
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea77f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea77f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aJ5BM", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $7cf275098e444ba8$export$ffb0004e005737fa, (v) => $7cf275098e444ba8$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $7cf275098e444ba8$export$34b9dba7ce09269b, (v) => $7cf275098e444ba8$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $7cf275098e444ba8$export$25062201e9e25d76, (v) => $7cf275098e444ba8$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7cf275098e444ba8$export$ffb0004e005737fa;
var $7cf275098e444ba8$export$34b9dba7ce09269b;
var $7cf275098e444ba8$export$25062201e9e25d76;
'use strict';

var $eeyUA = parcelRequire("eeyUA");
var $7cf275098e444ba8$var$k = Symbol.for("react.element"), $7cf275098e444ba8$var$l = Symbol.for("react.fragment"), $7cf275098e444ba8$var$m = Object.prototype.hasOwnProperty, $7cf275098e444ba8$var$n = $eeyUA.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7cf275098e444ba8$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7cf275098e444ba8$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7cf275098e444ba8$var$m.call(a, b) && !$7cf275098e444ba8$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7cf275098e444ba8$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7cf275098e444ba8$var$n.current
    };
}
$7cf275098e444ba8$export$ffb0004e005737fa = $7cf275098e444ba8$var$l;
$7cf275098e444ba8$export$34b9dba7ce09269b = $7cf275098e444ba8$var$q;
$7cf275098e444ba8$export$25062201e9e25d76 = $7cf275098e444ba8$var$q;

});
parcelRegister("eeyUA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3DQa4"));

});
parcelRegister("3DQa4", function(module, exports) {

$parcel$export(module.exports, "Children", () => $2a6d79c7eec5dc68$export$dca3b0875bd9a954, (v) => $2a6d79c7eec5dc68$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $2a6d79c7eec5dc68$export$16fa2f45be04daa8, (v) => $2a6d79c7eec5dc68$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $2a6d79c7eec5dc68$export$ffb0004e005737fa, (v) => $2a6d79c7eec5dc68$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $2a6d79c7eec5dc68$export$e2c29f18771995cb, (v) => $2a6d79c7eec5dc68$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $2a6d79c7eec5dc68$export$221d75b3f55bb0bd, (v) => $2a6d79c7eec5dc68$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $2a6d79c7eec5dc68$export$5f8d39834fd61797, (v) => $2a6d79c7eec5dc68$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2a6d79c7eec5dc68$export$74bf444e3cd11ea5, (v) => $2a6d79c7eec5dc68$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2a6d79c7eec5dc68$export$ae55be85d98224ed, (v) => $2a6d79c7eec5dc68$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $2a6d79c7eec5dc68$export$3ba232387fd5d6dd, (v) => $2a6d79c7eec5dc68$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $2a6d79c7eec5dc68$export$e530037191fcd5d7, (v) => $2a6d79c7eec5dc68$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $2a6d79c7eec5dc68$export$fd42f52fd3ae1109, (v) => $2a6d79c7eec5dc68$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $2a6d79c7eec5dc68$export$c8a8987d4410bf2d, (v) => $2a6d79c7eec5dc68$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $2a6d79c7eec5dc68$export$d38cd72104c1f0e9, (v) => $2a6d79c7eec5dc68$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $2a6d79c7eec5dc68$export$7d1e3a5e95ceca43, (v) => $2a6d79c7eec5dc68$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $2a6d79c7eec5dc68$export$257a8862b851cb5b, (v) => $2a6d79c7eec5dc68$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $2a6d79c7eec5dc68$export$a8257692ac88316c, (v) => $2a6d79c7eec5dc68$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $2a6d79c7eec5dc68$export$488013bae63b21da, (v) => $2a6d79c7eec5dc68$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $2a6d79c7eec5dc68$export$7c73462e0d25e514, (v) => $2a6d79c7eec5dc68$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $2a6d79c7eec5dc68$export$7568632d0d33d16d, (v) => $2a6d79c7eec5dc68$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $2a6d79c7eec5dc68$export$88948ce120ea2619, (v) => $2a6d79c7eec5dc68$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $2a6d79c7eec5dc68$export$35808ee640e87ca7, (v) => $2a6d79c7eec5dc68$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $2a6d79c7eec5dc68$export$fae74005e78b1a27, (v) => $2a6d79c7eec5dc68$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $2a6d79c7eec5dc68$export$dc8fbce3eb94dc1e, (v) => $2a6d79c7eec5dc68$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $2a6d79c7eec5dc68$export$6a7bc4e911dc01cf, (v) => $2a6d79c7eec5dc68$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $2a6d79c7eec5dc68$export$6d9c69b0de29b591, (v) => $2a6d79c7eec5dc68$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $2a6d79c7eec5dc68$export$f680877a34711e37, (v) => $2a6d79c7eec5dc68$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $2a6d79c7eec5dc68$export$d5a552a76deda3c2, (v) => $2a6d79c7eec5dc68$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $2a6d79c7eec5dc68$export$aaabe4eda9ed9969, (v) => $2a6d79c7eec5dc68$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $2a6d79c7eec5dc68$export$e5c5a5f917a5871c, (v) => $2a6d79c7eec5dc68$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $2a6d79c7eec5dc68$export$1538c33de8887b59, (v) => $2a6d79c7eec5dc68$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $2a6d79c7eec5dc68$export$13e3392192263954, (v) => $2a6d79c7eec5dc68$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $2a6d79c7eec5dc68$export$b8f5890fc79d6aca, (v) => $2a6d79c7eec5dc68$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $2a6d79c7eec5dc68$export$60241385465d0a34, (v) => $2a6d79c7eec5dc68$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $2a6d79c7eec5dc68$export$306c0aa65ff9ec16, (v) => $2a6d79c7eec5dc68$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $2a6d79c7eec5dc68$export$7b286972b8d8ccbf, (v) => $2a6d79c7eec5dc68$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $2a6d79c7eec5dc68$export$83d89fbfd8236492, (v) => $2a6d79c7eec5dc68$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2a6d79c7eec5dc68$export$dca3b0875bd9a954;
var $2a6d79c7eec5dc68$export$16fa2f45be04daa8;
var $2a6d79c7eec5dc68$export$ffb0004e005737fa;
var $2a6d79c7eec5dc68$export$e2c29f18771995cb;
var $2a6d79c7eec5dc68$export$221d75b3f55bb0bd;
var $2a6d79c7eec5dc68$export$5f8d39834fd61797;
var $2a6d79c7eec5dc68$export$74bf444e3cd11ea5;
var $2a6d79c7eec5dc68$export$ae55be85d98224ed;
var $2a6d79c7eec5dc68$export$3ba232387fd5d6dd;
var $2a6d79c7eec5dc68$export$e530037191fcd5d7;
var $2a6d79c7eec5dc68$export$fd42f52fd3ae1109;
var $2a6d79c7eec5dc68$export$c8a8987d4410bf2d;
var $2a6d79c7eec5dc68$export$d38cd72104c1f0e9;
var $2a6d79c7eec5dc68$export$7d1e3a5e95ceca43;
var $2a6d79c7eec5dc68$export$257a8862b851cb5b;
var $2a6d79c7eec5dc68$export$a8257692ac88316c;
var $2a6d79c7eec5dc68$export$488013bae63b21da;
var $2a6d79c7eec5dc68$export$7c73462e0d25e514;
var $2a6d79c7eec5dc68$export$7568632d0d33d16d;
var $2a6d79c7eec5dc68$export$88948ce120ea2619;
var $2a6d79c7eec5dc68$export$35808ee640e87ca7;
var $2a6d79c7eec5dc68$export$fae74005e78b1a27;
var $2a6d79c7eec5dc68$export$dc8fbce3eb94dc1e;
var $2a6d79c7eec5dc68$export$6a7bc4e911dc01cf;
var $2a6d79c7eec5dc68$export$6d9c69b0de29b591;
var $2a6d79c7eec5dc68$export$f680877a34711e37;
var $2a6d79c7eec5dc68$export$d5a552a76deda3c2;
var $2a6d79c7eec5dc68$export$aaabe4eda9ed9969;
var $2a6d79c7eec5dc68$export$e5c5a5f917a5871c;
var $2a6d79c7eec5dc68$export$1538c33de8887b59;
var $2a6d79c7eec5dc68$export$13e3392192263954;
var $2a6d79c7eec5dc68$export$b8f5890fc79d6aca;
var $2a6d79c7eec5dc68$export$60241385465d0a34;
var $2a6d79c7eec5dc68$export$306c0aa65ff9ec16;
var $2a6d79c7eec5dc68$export$7b286972b8d8ccbf;
var $2a6d79c7eec5dc68$export$83d89fbfd8236492;
'use strict';
var $2a6d79c7eec5dc68$var$l = Symbol.for("react.element"), $2a6d79c7eec5dc68$var$n = Symbol.for("react.portal"), $2a6d79c7eec5dc68$var$p = Symbol.for("react.fragment"), $2a6d79c7eec5dc68$var$q = Symbol.for("react.strict_mode"), $2a6d79c7eec5dc68$var$r = Symbol.for("react.profiler"), $2a6d79c7eec5dc68$var$t = Symbol.for("react.provider"), $2a6d79c7eec5dc68$var$u = Symbol.for("react.context"), $2a6d79c7eec5dc68$var$v = Symbol.for("react.forward_ref"), $2a6d79c7eec5dc68$var$w = Symbol.for("react.suspense"), $2a6d79c7eec5dc68$var$x = Symbol.for("react.memo"), $2a6d79c7eec5dc68$var$y = Symbol.for("react.lazy"), $2a6d79c7eec5dc68$var$z = Symbol.iterator;
function $2a6d79c7eec5dc68$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $2a6d79c7eec5dc68$var$z && a[$2a6d79c7eec5dc68$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $2a6d79c7eec5dc68$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $2a6d79c7eec5dc68$var$C = Object.assign, $2a6d79c7eec5dc68$var$D = {};
function $2a6d79c7eec5dc68$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $2a6d79c7eec5dc68$var$D;
    this.updater = e || $2a6d79c7eec5dc68$var$B;
}
$2a6d79c7eec5dc68$var$E.prototype.isReactComponent = {};
$2a6d79c7eec5dc68$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$2a6d79c7eec5dc68$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $2a6d79c7eec5dc68$var$F() {}
$2a6d79c7eec5dc68$var$F.prototype = $2a6d79c7eec5dc68$var$E.prototype;
function $2a6d79c7eec5dc68$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $2a6d79c7eec5dc68$var$D;
    this.updater = e || $2a6d79c7eec5dc68$var$B;
}
var $2a6d79c7eec5dc68$var$H = $2a6d79c7eec5dc68$var$G.prototype = new $2a6d79c7eec5dc68$var$F;
$2a6d79c7eec5dc68$var$H.constructor = $2a6d79c7eec5dc68$var$G;
$2a6d79c7eec5dc68$var$C($2a6d79c7eec5dc68$var$H, $2a6d79c7eec5dc68$var$E.prototype);
$2a6d79c7eec5dc68$var$H.isPureReactComponent = !0;
var $2a6d79c7eec5dc68$var$I = Array.isArray, $2a6d79c7eec5dc68$var$J = Object.prototype.hasOwnProperty, $2a6d79c7eec5dc68$var$K = {
    current: null
}, $2a6d79c7eec5dc68$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2a6d79c7eec5dc68$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$2a6d79c7eec5dc68$var$J.call(b, d) && !$2a6d79c7eec5dc68$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $2a6d79c7eec5dc68$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $2a6d79c7eec5dc68$var$K.current
    };
}
function $2a6d79c7eec5dc68$var$N(a, b) {
    return {
        $$typeof: $2a6d79c7eec5dc68$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $2a6d79c7eec5dc68$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2a6d79c7eec5dc68$var$l;
}
function $2a6d79c7eec5dc68$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $2a6d79c7eec5dc68$var$P = /\/+/g;
function $2a6d79c7eec5dc68$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $2a6d79c7eec5dc68$var$escape("" + a.key) : b.toString(36);
}
function $2a6d79c7eec5dc68$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $2a6d79c7eec5dc68$var$l:
                case $2a6d79c7eec5dc68$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $2a6d79c7eec5dc68$var$Q(h, 0) : d, $2a6d79c7eec5dc68$var$I(c) ? (e = "", null != a && (e = a.replace($2a6d79c7eec5dc68$var$P, "$&/") + "/"), $2a6d79c7eec5dc68$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($2a6d79c7eec5dc68$var$O(c) && (c = $2a6d79c7eec5dc68$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($2a6d79c7eec5dc68$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($2a6d79c7eec5dc68$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $2a6d79c7eec5dc68$var$Q(k, g);
        h += $2a6d79c7eec5dc68$var$R(k, b, e, f, c);
    }
    else if (f = $2a6d79c7eec5dc68$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $2a6d79c7eec5dc68$var$Q(k, g++), h += $2a6d79c7eec5dc68$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $2a6d79c7eec5dc68$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $2a6d79c7eec5dc68$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $2a6d79c7eec5dc68$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $2a6d79c7eec5dc68$var$U = {
    current: null
}, $2a6d79c7eec5dc68$var$V = {
    transition: null
}, $2a6d79c7eec5dc68$var$W = {
    ReactCurrentDispatcher: $2a6d79c7eec5dc68$var$U,
    ReactCurrentBatchConfig: $2a6d79c7eec5dc68$var$V,
    ReactCurrentOwner: $2a6d79c7eec5dc68$var$K
};
function $2a6d79c7eec5dc68$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$2a6d79c7eec5dc68$export$dca3b0875bd9a954 = {
    map: $2a6d79c7eec5dc68$var$S,
    forEach: function(a, b, e) {
        $2a6d79c7eec5dc68$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $2a6d79c7eec5dc68$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $2a6d79c7eec5dc68$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$2a6d79c7eec5dc68$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$2a6d79c7eec5dc68$export$16fa2f45be04daa8 = $2a6d79c7eec5dc68$var$E;
$2a6d79c7eec5dc68$export$ffb0004e005737fa = $2a6d79c7eec5dc68$var$p;
$2a6d79c7eec5dc68$export$e2c29f18771995cb = $2a6d79c7eec5dc68$var$r;
$2a6d79c7eec5dc68$export$221d75b3f55bb0bd = $2a6d79c7eec5dc68$var$G;
$2a6d79c7eec5dc68$export$5f8d39834fd61797 = $2a6d79c7eec5dc68$var$q;
$2a6d79c7eec5dc68$export$74bf444e3cd11ea5 = $2a6d79c7eec5dc68$var$w;
$2a6d79c7eec5dc68$export$ae55be85d98224ed = $2a6d79c7eec5dc68$var$W;
$2a6d79c7eec5dc68$export$3ba232387fd5d6dd = $2a6d79c7eec5dc68$var$X;
$2a6d79c7eec5dc68$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $2a6d79c7eec5dc68$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $2a6d79c7eec5dc68$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$2a6d79c7eec5dc68$var$J.call(b, f) && !$2a6d79c7eec5dc68$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $2a6d79c7eec5dc68$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$2a6d79c7eec5dc68$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $2a6d79c7eec5dc68$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $2a6d79c7eec5dc68$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$2a6d79c7eec5dc68$export$c8a8987d4410bf2d = $2a6d79c7eec5dc68$var$M;
$2a6d79c7eec5dc68$export$d38cd72104c1f0e9 = function(a) {
    var b = $2a6d79c7eec5dc68$var$M.bind(null, a);
    b.type = a;
    return b;
};
$2a6d79c7eec5dc68$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$2a6d79c7eec5dc68$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $2a6d79c7eec5dc68$var$v,
        render: a
    };
};
$2a6d79c7eec5dc68$export$a8257692ac88316c = $2a6d79c7eec5dc68$var$O;
$2a6d79c7eec5dc68$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $2a6d79c7eec5dc68$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $2a6d79c7eec5dc68$var$T
    };
};
$2a6d79c7eec5dc68$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $2a6d79c7eec5dc68$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$2a6d79c7eec5dc68$export$7568632d0d33d16d = function(a) {
    var b = $2a6d79c7eec5dc68$var$V.transition;
    $2a6d79c7eec5dc68$var$V.transition = {};
    try {
        a();
    } finally{
        $2a6d79c7eec5dc68$var$V.transition = b;
    }
};
$2a6d79c7eec5dc68$export$88948ce120ea2619 = $2a6d79c7eec5dc68$var$X;
$2a6d79c7eec5dc68$export$35808ee640e87ca7 = function(a, b) {
    return $2a6d79c7eec5dc68$var$U.current.useCallback(a, b);
};
$2a6d79c7eec5dc68$export$fae74005e78b1a27 = function(a) {
    return $2a6d79c7eec5dc68$var$U.current.useContext(a);
};
$2a6d79c7eec5dc68$export$dc8fbce3eb94dc1e = function() {};
$2a6d79c7eec5dc68$export$6a7bc4e911dc01cf = function(a) {
    return $2a6d79c7eec5dc68$var$U.current.useDeferredValue(a);
};
$2a6d79c7eec5dc68$export$6d9c69b0de29b591 = function(a, b) {
    return $2a6d79c7eec5dc68$var$U.current.useEffect(a, b);
};
$2a6d79c7eec5dc68$export$f680877a34711e37 = function() {
    return $2a6d79c7eec5dc68$var$U.current.useId();
};
$2a6d79c7eec5dc68$export$d5a552a76deda3c2 = function(a, b, e) {
    return $2a6d79c7eec5dc68$var$U.current.useImperativeHandle(a, b, e);
};
$2a6d79c7eec5dc68$export$aaabe4eda9ed9969 = function(a, b) {
    return $2a6d79c7eec5dc68$var$U.current.useInsertionEffect(a, b);
};
$2a6d79c7eec5dc68$export$e5c5a5f917a5871c = function(a, b) {
    return $2a6d79c7eec5dc68$var$U.current.useLayoutEffect(a, b);
};
$2a6d79c7eec5dc68$export$1538c33de8887b59 = function(a, b) {
    return $2a6d79c7eec5dc68$var$U.current.useMemo(a, b);
};
$2a6d79c7eec5dc68$export$13e3392192263954 = function(a, b, e) {
    return $2a6d79c7eec5dc68$var$U.current.useReducer(a, b, e);
};
$2a6d79c7eec5dc68$export$b8f5890fc79d6aca = function(a) {
    return $2a6d79c7eec5dc68$var$U.current.useRef(a);
};
$2a6d79c7eec5dc68$export$60241385465d0a34 = function(a) {
    return $2a6d79c7eec5dc68$var$U.current.useState(a);
};
$2a6d79c7eec5dc68$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $2a6d79c7eec5dc68$var$U.current.useSyncExternalStore(a, b, e);
};
$2a6d79c7eec5dc68$export$7b286972b8d8ccbf = function() {
    return $2a6d79c7eec5dc68$var$U.current.useTransition();
};
$2a6d79c7eec5dc68$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("3MgPz", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2c02e90631b0fc8a$export$ae55be85d98224ed, (v) => $2c02e90631b0fc8a$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $2c02e90631b0fc8a$export$d39a5bbd09211389, (v) => $2c02e90631b0fc8a$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $2c02e90631b0fc8a$export$882461b6382ed46c, (v) => $2c02e90631b0fc8a$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $2c02e90631b0fc8a$export$466bfc07425424d5, (v) => $2c02e90631b0fc8a$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $2c02e90631b0fc8a$export$cd75ccfd720a3cd4, (v) => $2c02e90631b0fc8a$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $2c02e90631b0fc8a$export$fa8d919ba61d84db, (v) => $2c02e90631b0fc8a$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $2c02e90631b0fc8a$export$757ceba2d55c277e, (v) => $2c02e90631b0fc8a$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $2c02e90631b0fc8a$export$b3890eb0ae9dca99, (v) => $2c02e90631b0fc8a$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $2c02e90631b0fc8a$export$502457920280e6be, (v) => $2c02e90631b0fc8a$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2c02e90631b0fc8a$export$c78a37762a8d58e1, (v) => $2c02e90631b0fc8a$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $2c02e90631b0fc8a$export$dc54d992c10e8a18, (v) => $2c02e90631b0fc8a$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $2c02e90631b0fc8a$export$83d89fbfd8236492, (v) => $2c02e90631b0fc8a$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $2c02e90631b0fc8a$export$ae55be85d98224ed;
var $2c02e90631b0fc8a$export$d39a5bbd09211389;
var $2c02e90631b0fc8a$export$882461b6382ed46c;
var $2c02e90631b0fc8a$export$466bfc07425424d5;
var $2c02e90631b0fc8a$export$cd75ccfd720a3cd4;
var $2c02e90631b0fc8a$export$fa8d919ba61d84db;
var $2c02e90631b0fc8a$export$757ceba2d55c277e;
var $2c02e90631b0fc8a$export$b3890eb0ae9dca99;
var $2c02e90631b0fc8a$export$502457920280e6be;
var $2c02e90631b0fc8a$export$c78a37762a8d58e1;
var $2c02e90631b0fc8a$export$dc54d992c10e8a18;
var $2c02e90631b0fc8a$export$83d89fbfd8236492;
'use strict';

var $eeyUA = parcelRequire("eeyUA");

var $heSjF = parcelRequire("heSjF");
function $2c02e90631b0fc8a$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $2c02e90631b0fc8a$var$da = new Set, $2c02e90631b0fc8a$var$ea = {};
function $2c02e90631b0fc8a$var$fa(a, b) {
    $2c02e90631b0fc8a$var$ha(a, b);
    $2c02e90631b0fc8a$var$ha(a + "Capture", b);
}
function $2c02e90631b0fc8a$var$ha(a, b) {
    $2c02e90631b0fc8a$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$2c02e90631b0fc8a$var$da.add(b[a]);
}
var $2c02e90631b0fc8a$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $2c02e90631b0fc8a$var$ja = Object.prototype.hasOwnProperty, $2c02e90631b0fc8a$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $2c02e90631b0fc8a$var$la = {}, $2c02e90631b0fc8a$var$ma = {};
function $2c02e90631b0fc8a$var$oa(a) {
    if ($2c02e90631b0fc8a$var$ja.call($2c02e90631b0fc8a$var$ma, a)) return !0;
    if ($2c02e90631b0fc8a$var$ja.call($2c02e90631b0fc8a$var$la, a)) return !1;
    if ($2c02e90631b0fc8a$var$ka.test(a)) return $2c02e90631b0fc8a$var$ma[a] = !0;
    $2c02e90631b0fc8a$var$la[a] = !0;
    return !1;
}
function $2c02e90631b0fc8a$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $2c02e90631b0fc8a$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $2c02e90631b0fc8a$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $2c02e90631b0fc8a$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $2c02e90631b0fc8a$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $2c02e90631b0fc8a$var$z[a] = new $2c02e90631b0fc8a$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $2c02e90631b0fc8a$var$z[b] = new $2c02e90631b0fc8a$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $2c02e90631b0fc8a$var$z[a] = new $2c02e90631b0fc8a$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $2c02e90631b0fc8a$var$z[a] = new $2c02e90631b0fc8a$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $2c02e90631b0fc8a$var$z[a] = new $2c02e90631b0fc8a$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $2c02e90631b0fc8a$var$z[a] = new $2c02e90631b0fc8a$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $2c02e90631b0fc8a$var$z[a] = new $2c02e90631b0fc8a$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $2c02e90631b0fc8a$var$z[a] = new $2c02e90631b0fc8a$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $2c02e90631b0fc8a$var$z[a] = new $2c02e90631b0fc8a$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $2c02e90631b0fc8a$var$ra = /[\-:]([a-z])/g;
function $2c02e90631b0fc8a$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($2c02e90631b0fc8a$var$ra, $2c02e90631b0fc8a$var$sa);
    $2c02e90631b0fc8a$var$z[b] = new $2c02e90631b0fc8a$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($2c02e90631b0fc8a$var$ra, $2c02e90631b0fc8a$var$sa);
    $2c02e90631b0fc8a$var$z[b] = new $2c02e90631b0fc8a$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($2c02e90631b0fc8a$var$ra, $2c02e90631b0fc8a$var$sa);
    $2c02e90631b0fc8a$var$z[b] = new $2c02e90631b0fc8a$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $2c02e90631b0fc8a$var$z[a] = new $2c02e90631b0fc8a$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$2c02e90631b0fc8a$var$z.xlinkHref = new $2c02e90631b0fc8a$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $2c02e90631b0fc8a$var$z[a] = new $2c02e90631b0fc8a$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $2c02e90631b0fc8a$var$ta(a, b, c, d) {
    var e = $2c02e90631b0fc8a$var$z.hasOwnProperty(b) ? $2c02e90631b0fc8a$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $2c02e90631b0fc8a$var$qa(b, c, e, d) && (c = null), d || null === e ? $2c02e90631b0fc8a$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $2c02e90631b0fc8a$var$ua = $eeyUA.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $2c02e90631b0fc8a$var$va = Symbol.for("react.element"), $2c02e90631b0fc8a$var$wa = Symbol.for("react.portal"), $2c02e90631b0fc8a$var$ya = Symbol.for("react.fragment"), $2c02e90631b0fc8a$var$za = Symbol.for("react.strict_mode"), $2c02e90631b0fc8a$var$Aa = Symbol.for("react.profiler"), $2c02e90631b0fc8a$var$Ba = Symbol.for("react.provider"), $2c02e90631b0fc8a$var$Ca = Symbol.for("react.context"), $2c02e90631b0fc8a$var$Da = Symbol.for("react.forward_ref"), $2c02e90631b0fc8a$var$Ea = Symbol.for("react.suspense"), $2c02e90631b0fc8a$var$Fa = Symbol.for("react.suspense_list"), $2c02e90631b0fc8a$var$Ga = Symbol.for("react.memo"), $2c02e90631b0fc8a$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $2c02e90631b0fc8a$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $2c02e90631b0fc8a$var$Ja = Symbol.iterator;
function $2c02e90631b0fc8a$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $2c02e90631b0fc8a$var$Ja && a[$2c02e90631b0fc8a$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $2c02e90631b0fc8a$var$A = Object.assign, $2c02e90631b0fc8a$var$La;
function $2c02e90631b0fc8a$var$Ma(a) {
    if (void 0 === $2c02e90631b0fc8a$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $2c02e90631b0fc8a$var$La = b && b[1] || "";
    }
    return "\n" + $2c02e90631b0fc8a$var$La + a;
}
var $2c02e90631b0fc8a$var$Na = !1;
function $2c02e90631b0fc8a$var$Oa(a, b) {
    if (!a || $2c02e90631b0fc8a$var$Na) return "";
    $2c02e90631b0fc8a$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $2c02e90631b0fc8a$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $2c02e90631b0fc8a$var$Ma(a) : "";
}
function $2c02e90631b0fc8a$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $2c02e90631b0fc8a$var$Ma(a.type);
        case 16:
            return $2c02e90631b0fc8a$var$Ma("Lazy");
        case 13:
            return $2c02e90631b0fc8a$var$Ma("Suspense");
        case 19:
            return $2c02e90631b0fc8a$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $2c02e90631b0fc8a$var$Oa(a.type, !1), a;
        case 11:
            return a = $2c02e90631b0fc8a$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $2c02e90631b0fc8a$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $2c02e90631b0fc8a$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $2c02e90631b0fc8a$var$ya:
            return "Fragment";
        case $2c02e90631b0fc8a$var$wa:
            return "Portal";
        case $2c02e90631b0fc8a$var$Aa:
            return "Profiler";
        case $2c02e90631b0fc8a$var$za:
            return "StrictMode";
        case $2c02e90631b0fc8a$var$Ea:
            return "Suspense";
        case $2c02e90631b0fc8a$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $2c02e90631b0fc8a$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $2c02e90631b0fc8a$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $2c02e90631b0fc8a$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $2c02e90631b0fc8a$var$Ga:
            return b = a.displayName || null, null !== b ? b : $2c02e90631b0fc8a$var$Qa(a.type) || "Memo";
        case $2c02e90631b0fc8a$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $2c02e90631b0fc8a$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $2c02e90631b0fc8a$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $2c02e90631b0fc8a$var$Qa(b);
        case 8:
            return b === $2c02e90631b0fc8a$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $2c02e90631b0fc8a$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $2c02e90631b0fc8a$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $2c02e90631b0fc8a$var$Ua(a) {
    var b = $2c02e90631b0fc8a$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $2c02e90631b0fc8a$var$Va(a) {
    a._valueTracker || (a._valueTracker = $2c02e90631b0fc8a$var$Ua(a));
}
function $2c02e90631b0fc8a$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $2c02e90631b0fc8a$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $2c02e90631b0fc8a$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $2c02e90631b0fc8a$var$Ya(a, b) {
    var c = b.checked;
    return $2c02e90631b0fc8a$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $2c02e90631b0fc8a$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $2c02e90631b0fc8a$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $2c02e90631b0fc8a$var$ab(a, b) {
    b = b.checked;
    null != b && $2c02e90631b0fc8a$var$ta(a, "checked", b, !1);
}
function $2c02e90631b0fc8a$var$bb(a, b) {
    $2c02e90631b0fc8a$var$ab(a, b);
    var c = $2c02e90631b0fc8a$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $2c02e90631b0fc8a$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $2c02e90631b0fc8a$var$cb(a, b.type, $2c02e90631b0fc8a$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $2c02e90631b0fc8a$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $2c02e90631b0fc8a$var$cb(a, b, c) {
    if ("number" !== b || $2c02e90631b0fc8a$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $2c02e90631b0fc8a$var$eb = Array.isArray;
function $2c02e90631b0fc8a$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $2c02e90631b0fc8a$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $2c02e90631b0fc8a$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($2c02e90631b0fc8a$var$p(91));
    return $2c02e90631b0fc8a$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $2c02e90631b0fc8a$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($2c02e90631b0fc8a$var$p(92));
            if ($2c02e90631b0fc8a$var$eb(c)) {
                if (1 < c.length) throw Error($2c02e90631b0fc8a$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $2c02e90631b0fc8a$var$Sa(c)
    };
}
function $2c02e90631b0fc8a$var$ib(a, b) {
    var c = $2c02e90631b0fc8a$var$Sa(b.value), d = $2c02e90631b0fc8a$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $2c02e90631b0fc8a$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $2c02e90631b0fc8a$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $2c02e90631b0fc8a$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $2c02e90631b0fc8a$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $2c02e90631b0fc8a$var$mb, $2c02e90631b0fc8a$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $2c02e90631b0fc8a$var$mb = $2c02e90631b0fc8a$var$mb || document.createElement("div");
        $2c02e90631b0fc8a$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $2c02e90631b0fc8a$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $2c02e90631b0fc8a$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $2c02e90631b0fc8a$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $2c02e90631b0fc8a$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($2c02e90631b0fc8a$var$pb).forEach(function(a) {
    $2c02e90631b0fc8a$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $2c02e90631b0fc8a$var$pb[b] = $2c02e90631b0fc8a$var$pb[a];
    });
});
function $2c02e90631b0fc8a$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $2c02e90631b0fc8a$var$pb.hasOwnProperty(a) && $2c02e90631b0fc8a$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $2c02e90631b0fc8a$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $2c02e90631b0fc8a$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $2c02e90631b0fc8a$var$tb = $2c02e90631b0fc8a$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $2c02e90631b0fc8a$var$ub(a, b) {
    if (b) {
        if ($2c02e90631b0fc8a$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($2c02e90631b0fc8a$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($2c02e90631b0fc8a$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($2c02e90631b0fc8a$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($2c02e90631b0fc8a$var$p(62));
    }
}
function $2c02e90631b0fc8a$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2c02e90631b0fc8a$var$wb = null;
function $2c02e90631b0fc8a$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $2c02e90631b0fc8a$var$yb = null, $2c02e90631b0fc8a$var$zb = null, $2c02e90631b0fc8a$var$Ab = null;
function $2c02e90631b0fc8a$var$Bb(a) {
    if (a = $2c02e90631b0fc8a$var$Cb(a)) {
        if ("function" !== typeof $2c02e90631b0fc8a$var$yb) throw Error($2c02e90631b0fc8a$var$p(280));
        var b = a.stateNode;
        b && (b = $2c02e90631b0fc8a$var$Db(b), $2c02e90631b0fc8a$var$yb(a.stateNode, a.type, b));
    }
}
function $2c02e90631b0fc8a$var$Eb(a) {
    $2c02e90631b0fc8a$var$zb ? $2c02e90631b0fc8a$var$Ab ? $2c02e90631b0fc8a$var$Ab.push(a) : $2c02e90631b0fc8a$var$Ab = [
        a
    ] : $2c02e90631b0fc8a$var$zb = a;
}
function $2c02e90631b0fc8a$var$Fb() {
    if ($2c02e90631b0fc8a$var$zb) {
        var a = $2c02e90631b0fc8a$var$zb, b = $2c02e90631b0fc8a$var$Ab;
        $2c02e90631b0fc8a$var$Ab = $2c02e90631b0fc8a$var$zb = null;
        $2c02e90631b0fc8a$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$2c02e90631b0fc8a$var$Bb(b[a]);
    }
}
function $2c02e90631b0fc8a$var$Gb(a, b) {
    return a(b);
}
function $2c02e90631b0fc8a$var$Hb() {}
var $2c02e90631b0fc8a$var$Ib = !1;
function $2c02e90631b0fc8a$var$Jb(a, b, c) {
    if ($2c02e90631b0fc8a$var$Ib) return a(b, c);
    $2c02e90631b0fc8a$var$Ib = !0;
    try {
        return $2c02e90631b0fc8a$var$Gb(a, b, c);
    } finally{
        if ($2c02e90631b0fc8a$var$Ib = !1, null !== $2c02e90631b0fc8a$var$zb || null !== $2c02e90631b0fc8a$var$Ab) $2c02e90631b0fc8a$var$Hb(), $2c02e90631b0fc8a$var$Fb();
    }
}
function $2c02e90631b0fc8a$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $2c02e90631b0fc8a$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($2c02e90631b0fc8a$var$p(231, b, typeof c));
    return c;
}
var $2c02e90631b0fc8a$var$Lb = !1;
if ($2c02e90631b0fc8a$var$ia) try {
    var $2c02e90631b0fc8a$var$Mb = {};
    Object.defineProperty($2c02e90631b0fc8a$var$Mb, "passive", {
        get: function() {
            $2c02e90631b0fc8a$var$Lb = !0;
        }
    });
    window.addEventListener("test", $2c02e90631b0fc8a$var$Mb, $2c02e90631b0fc8a$var$Mb);
    window.removeEventListener("test", $2c02e90631b0fc8a$var$Mb, $2c02e90631b0fc8a$var$Mb);
} catch (a) {
    $2c02e90631b0fc8a$var$Lb = !1;
}
function $2c02e90631b0fc8a$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $2c02e90631b0fc8a$var$Ob = !1, $2c02e90631b0fc8a$var$Pb = null, $2c02e90631b0fc8a$var$Qb = !1, $2c02e90631b0fc8a$var$Rb = null, $2c02e90631b0fc8a$var$Sb = {
    onError: function(a) {
        $2c02e90631b0fc8a$var$Ob = !0;
        $2c02e90631b0fc8a$var$Pb = a;
    }
};
function $2c02e90631b0fc8a$var$Tb(a, b, c, d, e, f, g, h, k) {
    $2c02e90631b0fc8a$var$Ob = !1;
    $2c02e90631b0fc8a$var$Pb = null;
    $2c02e90631b0fc8a$var$Nb.apply($2c02e90631b0fc8a$var$Sb, arguments);
}
function $2c02e90631b0fc8a$var$Ub(a, b, c, d, e, f, g, h, k) {
    $2c02e90631b0fc8a$var$Tb.apply(this, arguments);
    if ($2c02e90631b0fc8a$var$Ob) {
        if ($2c02e90631b0fc8a$var$Ob) {
            var l = $2c02e90631b0fc8a$var$Pb;
            $2c02e90631b0fc8a$var$Ob = !1;
            $2c02e90631b0fc8a$var$Pb = null;
        } else throw Error($2c02e90631b0fc8a$var$p(198));
        $2c02e90631b0fc8a$var$Qb || ($2c02e90631b0fc8a$var$Qb = !0, $2c02e90631b0fc8a$var$Rb = l);
    }
}
function $2c02e90631b0fc8a$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $2c02e90631b0fc8a$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $2c02e90631b0fc8a$var$Xb(a) {
    if ($2c02e90631b0fc8a$var$Vb(a) !== a) throw Error($2c02e90631b0fc8a$var$p(188));
}
function $2c02e90631b0fc8a$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $2c02e90631b0fc8a$var$Vb(a);
        if (null === b) throw Error($2c02e90631b0fc8a$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $2c02e90631b0fc8a$var$Xb(e), a;
                if (f === d) return $2c02e90631b0fc8a$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($2c02e90631b0fc8a$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($2c02e90631b0fc8a$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($2c02e90631b0fc8a$var$p(190));
    }
    if (3 !== c.tag) throw Error($2c02e90631b0fc8a$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $2c02e90631b0fc8a$var$Zb(a) {
    a = $2c02e90631b0fc8a$var$Yb(a);
    return null !== a ? $2c02e90631b0fc8a$var$$b(a) : null;
}
function $2c02e90631b0fc8a$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $2c02e90631b0fc8a$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $2c02e90631b0fc8a$var$ac = $heSjF.unstable_scheduleCallback, $2c02e90631b0fc8a$var$bc = $heSjF.unstable_cancelCallback, $2c02e90631b0fc8a$var$cc = $heSjF.unstable_shouldYield, $2c02e90631b0fc8a$var$dc = $heSjF.unstable_requestPaint, $2c02e90631b0fc8a$var$B = $heSjF.unstable_now, $2c02e90631b0fc8a$var$ec = $heSjF.unstable_getCurrentPriorityLevel, $2c02e90631b0fc8a$var$fc = $heSjF.unstable_ImmediatePriority, $2c02e90631b0fc8a$var$gc = $heSjF.unstable_UserBlockingPriority, $2c02e90631b0fc8a$var$hc = $heSjF.unstable_NormalPriority, $2c02e90631b0fc8a$var$ic = $heSjF.unstable_LowPriority, $2c02e90631b0fc8a$var$jc = $heSjF.unstable_IdlePriority, $2c02e90631b0fc8a$var$kc = null, $2c02e90631b0fc8a$var$lc = null;
function $2c02e90631b0fc8a$var$mc(a) {
    if ($2c02e90631b0fc8a$var$lc && "function" === typeof $2c02e90631b0fc8a$var$lc.onCommitFiberRoot) try {
        $2c02e90631b0fc8a$var$lc.onCommitFiberRoot($2c02e90631b0fc8a$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $2c02e90631b0fc8a$var$oc = Math.clz32 ? Math.clz32 : $2c02e90631b0fc8a$var$nc, $2c02e90631b0fc8a$var$pc = Math.log, $2c02e90631b0fc8a$var$qc = Math.LN2;
function $2c02e90631b0fc8a$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($2c02e90631b0fc8a$var$pc(a) / $2c02e90631b0fc8a$var$qc | 0) | 0;
}
var $2c02e90631b0fc8a$var$rc = 64, $2c02e90631b0fc8a$var$sc = 4194304;
function $2c02e90631b0fc8a$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $2c02e90631b0fc8a$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $2c02e90631b0fc8a$var$tc(h) : (f &= g, 0 !== f && (d = $2c02e90631b0fc8a$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $2c02e90631b0fc8a$var$tc(g) : 0 !== f && (d = $2c02e90631b0fc8a$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $2c02e90631b0fc8a$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $2c02e90631b0fc8a$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2c02e90631b0fc8a$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $2c02e90631b0fc8a$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $2c02e90631b0fc8a$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $2c02e90631b0fc8a$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $2c02e90631b0fc8a$var$yc() {
    var a = $2c02e90631b0fc8a$var$rc;
    $2c02e90631b0fc8a$var$rc <<= 1;
    0 === ($2c02e90631b0fc8a$var$rc & 4194240) && ($2c02e90631b0fc8a$var$rc = 64);
    return a;
}
function $2c02e90631b0fc8a$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $2c02e90631b0fc8a$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $2c02e90631b0fc8a$var$oc(b);
    a[b] = c;
}
function $2c02e90631b0fc8a$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $2c02e90631b0fc8a$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $2c02e90631b0fc8a$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $2c02e90631b0fc8a$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $2c02e90631b0fc8a$var$C = 0;
function $2c02e90631b0fc8a$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $2c02e90631b0fc8a$var$Ec, $2c02e90631b0fc8a$var$Fc, $2c02e90631b0fc8a$var$Gc, $2c02e90631b0fc8a$var$Hc, $2c02e90631b0fc8a$var$Ic, $2c02e90631b0fc8a$var$Jc = !1, $2c02e90631b0fc8a$var$Kc = [], $2c02e90631b0fc8a$var$Lc = null, $2c02e90631b0fc8a$var$Mc = null, $2c02e90631b0fc8a$var$Nc = null, $2c02e90631b0fc8a$var$Oc = new Map, $2c02e90631b0fc8a$var$Pc = new Map, $2c02e90631b0fc8a$var$Qc = [], $2c02e90631b0fc8a$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $2c02e90631b0fc8a$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $2c02e90631b0fc8a$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $2c02e90631b0fc8a$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $2c02e90631b0fc8a$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $2c02e90631b0fc8a$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2c02e90631b0fc8a$var$Pc.delete(b.pointerId);
    }
}
function $2c02e90631b0fc8a$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $2c02e90631b0fc8a$var$Cb(b), null !== b && $2c02e90631b0fc8a$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $2c02e90631b0fc8a$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $2c02e90631b0fc8a$var$Lc = $2c02e90631b0fc8a$var$Tc($2c02e90631b0fc8a$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $2c02e90631b0fc8a$var$Mc = $2c02e90631b0fc8a$var$Tc($2c02e90631b0fc8a$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $2c02e90631b0fc8a$var$Nc = $2c02e90631b0fc8a$var$Tc($2c02e90631b0fc8a$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $2c02e90631b0fc8a$var$Oc.set(f, $2c02e90631b0fc8a$var$Tc($2c02e90631b0fc8a$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $2c02e90631b0fc8a$var$Pc.set(f, $2c02e90631b0fc8a$var$Tc($2c02e90631b0fc8a$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $2c02e90631b0fc8a$var$Vc(a) {
    var b = $2c02e90631b0fc8a$var$Wc(a.target);
    if (null !== b) {
        var c = $2c02e90631b0fc8a$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $2c02e90631b0fc8a$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $2c02e90631b0fc8a$var$Ic(a.priority, function() {
                        $2c02e90631b0fc8a$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $2c02e90631b0fc8a$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $2c02e90631b0fc8a$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $2c02e90631b0fc8a$var$wb = d;
            c.target.dispatchEvent(d);
            $2c02e90631b0fc8a$var$wb = null;
        } else return b = $2c02e90631b0fc8a$var$Cb(c), null !== b && $2c02e90631b0fc8a$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $2c02e90631b0fc8a$var$Zc(a, b, c) {
    $2c02e90631b0fc8a$var$Xc(a) && c.delete(b);
}
function $2c02e90631b0fc8a$var$$c() {
    $2c02e90631b0fc8a$var$Jc = !1;
    null !== $2c02e90631b0fc8a$var$Lc && $2c02e90631b0fc8a$var$Xc($2c02e90631b0fc8a$var$Lc) && ($2c02e90631b0fc8a$var$Lc = null);
    null !== $2c02e90631b0fc8a$var$Mc && $2c02e90631b0fc8a$var$Xc($2c02e90631b0fc8a$var$Mc) && ($2c02e90631b0fc8a$var$Mc = null);
    null !== $2c02e90631b0fc8a$var$Nc && $2c02e90631b0fc8a$var$Xc($2c02e90631b0fc8a$var$Nc) && ($2c02e90631b0fc8a$var$Nc = null);
    $2c02e90631b0fc8a$var$Oc.forEach($2c02e90631b0fc8a$var$Zc);
    $2c02e90631b0fc8a$var$Pc.forEach($2c02e90631b0fc8a$var$Zc);
}
function $2c02e90631b0fc8a$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $2c02e90631b0fc8a$var$Jc || ($2c02e90631b0fc8a$var$Jc = !0, $heSjF.unstable_scheduleCallback($heSjF.unstable_NormalPriority, $2c02e90631b0fc8a$var$$c)));
}
function $2c02e90631b0fc8a$var$bd(a) {
    function b(b) {
        return $2c02e90631b0fc8a$var$ad(b, a);
    }
    if (0 < $2c02e90631b0fc8a$var$Kc.length) {
        $2c02e90631b0fc8a$var$ad($2c02e90631b0fc8a$var$Kc[0], a);
        for(var c = 1; c < $2c02e90631b0fc8a$var$Kc.length; c++){
            var d = $2c02e90631b0fc8a$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $2c02e90631b0fc8a$var$Lc && $2c02e90631b0fc8a$var$ad($2c02e90631b0fc8a$var$Lc, a);
    null !== $2c02e90631b0fc8a$var$Mc && $2c02e90631b0fc8a$var$ad($2c02e90631b0fc8a$var$Mc, a);
    null !== $2c02e90631b0fc8a$var$Nc && $2c02e90631b0fc8a$var$ad($2c02e90631b0fc8a$var$Nc, a);
    $2c02e90631b0fc8a$var$Oc.forEach(b);
    $2c02e90631b0fc8a$var$Pc.forEach(b);
    for(c = 0; c < $2c02e90631b0fc8a$var$Qc.length; c++)d = $2c02e90631b0fc8a$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $2c02e90631b0fc8a$var$Qc.length && (c = $2c02e90631b0fc8a$var$Qc[0], null === c.blockedOn);)$2c02e90631b0fc8a$var$Vc(c), null === c.blockedOn && $2c02e90631b0fc8a$var$Qc.shift();
}
var $2c02e90631b0fc8a$var$cd = $2c02e90631b0fc8a$var$ua.ReactCurrentBatchConfig, $2c02e90631b0fc8a$var$dd = !0;
function $2c02e90631b0fc8a$var$ed(a, b, c, d) {
    var e = $2c02e90631b0fc8a$var$C, f = $2c02e90631b0fc8a$var$cd.transition;
    $2c02e90631b0fc8a$var$cd.transition = null;
    try {
        $2c02e90631b0fc8a$var$C = 1, $2c02e90631b0fc8a$var$fd(a, b, c, d);
    } finally{
        $2c02e90631b0fc8a$var$C = e, $2c02e90631b0fc8a$var$cd.transition = f;
    }
}
function $2c02e90631b0fc8a$var$gd(a, b, c, d) {
    var e = $2c02e90631b0fc8a$var$C, f = $2c02e90631b0fc8a$var$cd.transition;
    $2c02e90631b0fc8a$var$cd.transition = null;
    try {
        $2c02e90631b0fc8a$var$C = 4, $2c02e90631b0fc8a$var$fd(a, b, c, d);
    } finally{
        $2c02e90631b0fc8a$var$C = e, $2c02e90631b0fc8a$var$cd.transition = f;
    }
}
function $2c02e90631b0fc8a$var$fd(a, b, c, d) {
    if ($2c02e90631b0fc8a$var$dd) {
        var e = $2c02e90631b0fc8a$var$Yc(a, b, c, d);
        if (null === e) $2c02e90631b0fc8a$var$hd(a, b, d, $2c02e90631b0fc8a$var$id, c), $2c02e90631b0fc8a$var$Sc(a, d);
        else if ($2c02e90631b0fc8a$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($2c02e90631b0fc8a$var$Sc(a, d), b & 4 && -1 < $2c02e90631b0fc8a$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $2c02e90631b0fc8a$var$Cb(e);
                null !== f && $2c02e90631b0fc8a$var$Ec(f);
                f = $2c02e90631b0fc8a$var$Yc(a, b, c, d);
                null === f && $2c02e90631b0fc8a$var$hd(a, b, d, $2c02e90631b0fc8a$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $2c02e90631b0fc8a$var$hd(a, b, d, null, c);
    }
}
var $2c02e90631b0fc8a$var$id = null;
function $2c02e90631b0fc8a$var$Yc(a, b, c, d) {
    $2c02e90631b0fc8a$var$id = null;
    a = $2c02e90631b0fc8a$var$xb(d);
    a = $2c02e90631b0fc8a$var$Wc(a);
    if (null !== a) {
        if (b = $2c02e90631b0fc8a$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $2c02e90631b0fc8a$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $2c02e90631b0fc8a$var$id = a;
    return null;
}
function $2c02e90631b0fc8a$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($2c02e90631b0fc8a$var$ec()){
                case $2c02e90631b0fc8a$var$fc:
                    return 1;
                case $2c02e90631b0fc8a$var$gc:
                    return 4;
                case $2c02e90631b0fc8a$var$hc:
                case $2c02e90631b0fc8a$var$ic:
                    return 16;
                case $2c02e90631b0fc8a$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $2c02e90631b0fc8a$var$kd = null, $2c02e90631b0fc8a$var$ld = null, $2c02e90631b0fc8a$var$md = null;
function $2c02e90631b0fc8a$var$nd() {
    if ($2c02e90631b0fc8a$var$md) return $2c02e90631b0fc8a$var$md;
    var a, b = $2c02e90631b0fc8a$var$ld, c = b.length, d, e = "value" in $2c02e90631b0fc8a$var$kd ? $2c02e90631b0fc8a$var$kd.value : $2c02e90631b0fc8a$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $2c02e90631b0fc8a$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $2c02e90631b0fc8a$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $2c02e90631b0fc8a$var$pd() {
    return !0;
}
function $2c02e90631b0fc8a$var$qd() {
    return !1;
}
function $2c02e90631b0fc8a$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $2c02e90631b0fc8a$var$pd : $2c02e90631b0fc8a$var$qd;
        this.isPropagationStopped = $2c02e90631b0fc8a$var$qd;
        return this;
    }
    $2c02e90631b0fc8a$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $2c02e90631b0fc8a$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $2c02e90631b0fc8a$var$pd);
        },
        persist: function() {},
        isPersistent: $2c02e90631b0fc8a$var$pd
    });
    return b;
}
var $2c02e90631b0fc8a$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2c02e90631b0fc8a$var$td = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$sd), $2c02e90631b0fc8a$var$ud = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$sd, {
    view: 0,
    detail: 0
}), $2c02e90631b0fc8a$var$vd = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$ud), $2c02e90631b0fc8a$var$wd, $2c02e90631b0fc8a$var$xd, $2c02e90631b0fc8a$var$yd, $2c02e90631b0fc8a$var$Ad = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2c02e90631b0fc8a$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $2c02e90631b0fc8a$var$yd && ($2c02e90631b0fc8a$var$yd && "mousemove" === a.type ? ($2c02e90631b0fc8a$var$wd = a.screenX - $2c02e90631b0fc8a$var$yd.screenX, $2c02e90631b0fc8a$var$xd = a.screenY - $2c02e90631b0fc8a$var$yd.screenY) : $2c02e90631b0fc8a$var$xd = $2c02e90631b0fc8a$var$wd = 0, $2c02e90631b0fc8a$var$yd = a);
        return $2c02e90631b0fc8a$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $2c02e90631b0fc8a$var$xd;
    }
}), $2c02e90631b0fc8a$var$Bd = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$Ad), $2c02e90631b0fc8a$var$Cd = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$Ad, {
    dataTransfer: 0
}), $2c02e90631b0fc8a$var$Dd = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$Cd), $2c02e90631b0fc8a$var$Ed = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$ud, {
    relatedTarget: 0
}), $2c02e90631b0fc8a$var$Fd = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$Ed), $2c02e90631b0fc8a$var$Gd = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2c02e90631b0fc8a$var$Hd = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$Gd), $2c02e90631b0fc8a$var$Id = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $2c02e90631b0fc8a$var$Jd = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$Id), $2c02e90631b0fc8a$var$Kd = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$sd, {
    data: 0
}), $2c02e90631b0fc8a$var$Ld = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$Kd), $2c02e90631b0fc8a$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2c02e90631b0fc8a$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2c02e90631b0fc8a$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2c02e90631b0fc8a$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $2c02e90631b0fc8a$var$Od[a]) ? !!b[a] : !1;
}
function $2c02e90631b0fc8a$var$zd() {
    return $2c02e90631b0fc8a$var$Pd;
}
var $2c02e90631b0fc8a$var$Qd = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $2c02e90631b0fc8a$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $2c02e90631b0fc8a$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $2c02e90631b0fc8a$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2c02e90631b0fc8a$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $2c02e90631b0fc8a$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $2c02e90631b0fc8a$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $2c02e90631b0fc8a$var$Rd = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$Qd), $2c02e90631b0fc8a$var$Sd = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2c02e90631b0fc8a$var$Td = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$Sd), $2c02e90631b0fc8a$var$Ud = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2c02e90631b0fc8a$var$zd
}), $2c02e90631b0fc8a$var$Vd = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$Ud), $2c02e90631b0fc8a$var$Wd = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2c02e90631b0fc8a$var$Xd = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$Wd), $2c02e90631b0fc8a$var$Yd = $2c02e90631b0fc8a$var$A({}, $2c02e90631b0fc8a$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2c02e90631b0fc8a$var$Zd = $2c02e90631b0fc8a$var$rd($2c02e90631b0fc8a$var$Yd), $2c02e90631b0fc8a$var$$d = [
    9,
    13,
    27,
    32
], $2c02e90631b0fc8a$var$ae = $2c02e90631b0fc8a$var$ia && "CompositionEvent" in window, $2c02e90631b0fc8a$var$be = null;
$2c02e90631b0fc8a$var$ia && "documentMode" in document && ($2c02e90631b0fc8a$var$be = document.documentMode);
var $2c02e90631b0fc8a$var$ce = $2c02e90631b0fc8a$var$ia && "TextEvent" in window && !$2c02e90631b0fc8a$var$be, $2c02e90631b0fc8a$var$de = $2c02e90631b0fc8a$var$ia && (!$2c02e90631b0fc8a$var$ae || $2c02e90631b0fc8a$var$be && 8 < $2c02e90631b0fc8a$var$be && 11 >= $2c02e90631b0fc8a$var$be), $2c02e90631b0fc8a$var$ee = String.fromCharCode(32), $2c02e90631b0fc8a$var$fe = !1;
function $2c02e90631b0fc8a$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $2c02e90631b0fc8a$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2c02e90631b0fc8a$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $2c02e90631b0fc8a$var$ie = !1;
function $2c02e90631b0fc8a$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $2c02e90631b0fc8a$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $2c02e90631b0fc8a$var$fe = !0;
            return $2c02e90631b0fc8a$var$ee;
        case "textInput":
            return a = b.data, a === $2c02e90631b0fc8a$var$ee && $2c02e90631b0fc8a$var$fe ? null : a;
        default:
            return null;
    }
}
function $2c02e90631b0fc8a$var$ke(a, b) {
    if ($2c02e90631b0fc8a$var$ie) return "compositionend" === a || !$2c02e90631b0fc8a$var$ae && $2c02e90631b0fc8a$var$ge(a, b) ? (a = $2c02e90631b0fc8a$var$nd(), $2c02e90631b0fc8a$var$md = $2c02e90631b0fc8a$var$ld = $2c02e90631b0fc8a$var$kd = null, $2c02e90631b0fc8a$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $2c02e90631b0fc8a$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $2c02e90631b0fc8a$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2c02e90631b0fc8a$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$2c02e90631b0fc8a$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $2c02e90631b0fc8a$var$ne(a, b, c, d) {
    $2c02e90631b0fc8a$var$Eb(d);
    b = $2c02e90631b0fc8a$var$oe(b, "onChange");
    0 < b.length && (c = new $2c02e90631b0fc8a$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $2c02e90631b0fc8a$var$pe = null, $2c02e90631b0fc8a$var$qe = null;
function $2c02e90631b0fc8a$var$re(a) {
    $2c02e90631b0fc8a$var$se(a, 0);
}
function $2c02e90631b0fc8a$var$te(a) {
    var b = $2c02e90631b0fc8a$var$ue(a);
    if ($2c02e90631b0fc8a$var$Wa(b)) return a;
}
function $2c02e90631b0fc8a$var$ve(a, b) {
    if ("change" === a) return b;
}
var $2c02e90631b0fc8a$var$we = !1;
if ($2c02e90631b0fc8a$var$ia) {
    var $2c02e90631b0fc8a$var$xe;
    if ($2c02e90631b0fc8a$var$ia) {
        var $2c02e90631b0fc8a$var$ye = "oninput" in document;
        if (!$2c02e90631b0fc8a$var$ye) {
            var $2c02e90631b0fc8a$var$ze = document.createElement("div");
            $2c02e90631b0fc8a$var$ze.setAttribute("oninput", "return;");
            $2c02e90631b0fc8a$var$ye = "function" === typeof $2c02e90631b0fc8a$var$ze.oninput;
        }
        $2c02e90631b0fc8a$var$xe = $2c02e90631b0fc8a$var$ye;
    } else $2c02e90631b0fc8a$var$xe = !1;
    $2c02e90631b0fc8a$var$we = $2c02e90631b0fc8a$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $2c02e90631b0fc8a$var$Ae() {
    $2c02e90631b0fc8a$var$pe && ($2c02e90631b0fc8a$var$pe.detachEvent("onpropertychange", $2c02e90631b0fc8a$var$Be), $2c02e90631b0fc8a$var$qe = $2c02e90631b0fc8a$var$pe = null);
}
function $2c02e90631b0fc8a$var$Be(a) {
    if ("value" === a.propertyName && $2c02e90631b0fc8a$var$te($2c02e90631b0fc8a$var$qe)) {
        var b = [];
        $2c02e90631b0fc8a$var$ne(b, $2c02e90631b0fc8a$var$qe, a, $2c02e90631b0fc8a$var$xb(a));
        $2c02e90631b0fc8a$var$Jb($2c02e90631b0fc8a$var$re, b);
    }
}
function $2c02e90631b0fc8a$var$Ce(a, b, c) {
    "focusin" === a ? ($2c02e90631b0fc8a$var$Ae(), $2c02e90631b0fc8a$var$pe = b, $2c02e90631b0fc8a$var$qe = c, $2c02e90631b0fc8a$var$pe.attachEvent("onpropertychange", $2c02e90631b0fc8a$var$Be)) : "focusout" === a && $2c02e90631b0fc8a$var$Ae();
}
function $2c02e90631b0fc8a$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $2c02e90631b0fc8a$var$te($2c02e90631b0fc8a$var$qe);
}
function $2c02e90631b0fc8a$var$Ee(a, b) {
    if ("click" === a) return $2c02e90631b0fc8a$var$te(b);
}
function $2c02e90631b0fc8a$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $2c02e90631b0fc8a$var$te(b);
}
function $2c02e90631b0fc8a$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2c02e90631b0fc8a$var$He = "function" === typeof Object.is ? Object.is : $2c02e90631b0fc8a$var$Ge;
function $2c02e90631b0fc8a$var$Ie(a, b) {
    if ($2c02e90631b0fc8a$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$2c02e90631b0fc8a$var$ja.call(b, e) || !$2c02e90631b0fc8a$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $2c02e90631b0fc8a$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $2c02e90631b0fc8a$var$Ke(a, b) {
    var c = $2c02e90631b0fc8a$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $2c02e90631b0fc8a$var$Je(c);
    }
}
function $2c02e90631b0fc8a$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $2c02e90631b0fc8a$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $2c02e90631b0fc8a$var$Me() {
    for(var a = window, b = $2c02e90631b0fc8a$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $2c02e90631b0fc8a$var$Xa(a.document);
    }
    return b;
}
function $2c02e90631b0fc8a$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $2c02e90631b0fc8a$var$Oe(a) {
    var b = $2c02e90631b0fc8a$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $2c02e90631b0fc8a$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $2c02e90631b0fc8a$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $2c02e90631b0fc8a$var$Ke(c, f);
                var g = $2c02e90631b0fc8a$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $2c02e90631b0fc8a$var$Pe = $2c02e90631b0fc8a$var$ia && "documentMode" in document && 11 >= document.documentMode, $2c02e90631b0fc8a$var$Qe = null, $2c02e90631b0fc8a$var$Re = null, $2c02e90631b0fc8a$var$Se = null, $2c02e90631b0fc8a$var$Te = !1;
function $2c02e90631b0fc8a$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $2c02e90631b0fc8a$var$Te || null == $2c02e90631b0fc8a$var$Qe || $2c02e90631b0fc8a$var$Qe !== $2c02e90631b0fc8a$var$Xa(d) || (d = $2c02e90631b0fc8a$var$Qe, "selectionStart" in d && $2c02e90631b0fc8a$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $2c02e90631b0fc8a$var$Se && $2c02e90631b0fc8a$var$Ie($2c02e90631b0fc8a$var$Se, d) || ($2c02e90631b0fc8a$var$Se = d, d = $2c02e90631b0fc8a$var$oe($2c02e90631b0fc8a$var$Re, "onSelect"), 0 < d.length && (b = new $2c02e90631b0fc8a$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $2c02e90631b0fc8a$var$Qe)));
}
function $2c02e90631b0fc8a$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $2c02e90631b0fc8a$var$We = {
    animationend: $2c02e90631b0fc8a$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $2c02e90631b0fc8a$var$Ve("Animation", "AnimationIteration"),
    animationstart: $2c02e90631b0fc8a$var$Ve("Animation", "AnimationStart"),
    transitionend: $2c02e90631b0fc8a$var$Ve("Transition", "TransitionEnd")
}, $2c02e90631b0fc8a$var$Xe = {}, $2c02e90631b0fc8a$var$Ye = {};
$2c02e90631b0fc8a$var$ia && ($2c02e90631b0fc8a$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $2c02e90631b0fc8a$var$We.animationend.animation, delete $2c02e90631b0fc8a$var$We.animationiteration.animation, delete $2c02e90631b0fc8a$var$We.animationstart.animation), "TransitionEvent" in window || delete $2c02e90631b0fc8a$var$We.transitionend.transition);
function $2c02e90631b0fc8a$var$Ze(a) {
    if ($2c02e90631b0fc8a$var$Xe[a]) return $2c02e90631b0fc8a$var$Xe[a];
    if (!$2c02e90631b0fc8a$var$We[a]) return a;
    var b = $2c02e90631b0fc8a$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $2c02e90631b0fc8a$var$Ye) return $2c02e90631b0fc8a$var$Xe[a] = b[c];
    return a;
}
var $2c02e90631b0fc8a$var$$e = $2c02e90631b0fc8a$var$Ze("animationend"), $2c02e90631b0fc8a$var$af = $2c02e90631b0fc8a$var$Ze("animationiteration"), $2c02e90631b0fc8a$var$bf = $2c02e90631b0fc8a$var$Ze("animationstart"), $2c02e90631b0fc8a$var$cf = $2c02e90631b0fc8a$var$Ze("transitionend"), $2c02e90631b0fc8a$var$df = new Map, $2c02e90631b0fc8a$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $2c02e90631b0fc8a$var$ff(a, b) {
    $2c02e90631b0fc8a$var$df.set(a, b);
    $2c02e90631b0fc8a$var$fa(b, [
        a
    ]);
}
for(var $2c02e90631b0fc8a$var$gf = 0; $2c02e90631b0fc8a$var$gf < $2c02e90631b0fc8a$var$ef.length; $2c02e90631b0fc8a$var$gf++){
    var $2c02e90631b0fc8a$var$hf = $2c02e90631b0fc8a$var$ef[$2c02e90631b0fc8a$var$gf], $2c02e90631b0fc8a$var$jf = $2c02e90631b0fc8a$var$hf.toLowerCase(), $2c02e90631b0fc8a$var$kf = $2c02e90631b0fc8a$var$hf[0].toUpperCase() + $2c02e90631b0fc8a$var$hf.slice(1);
    $2c02e90631b0fc8a$var$ff($2c02e90631b0fc8a$var$jf, "on" + $2c02e90631b0fc8a$var$kf);
}
$2c02e90631b0fc8a$var$ff($2c02e90631b0fc8a$var$$e, "onAnimationEnd");
$2c02e90631b0fc8a$var$ff($2c02e90631b0fc8a$var$af, "onAnimationIteration");
$2c02e90631b0fc8a$var$ff($2c02e90631b0fc8a$var$bf, "onAnimationStart");
$2c02e90631b0fc8a$var$ff("dblclick", "onDoubleClick");
$2c02e90631b0fc8a$var$ff("focusin", "onFocus");
$2c02e90631b0fc8a$var$ff("focusout", "onBlur");
$2c02e90631b0fc8a$var$ff($2c02e90631b0fc8a$var$cf, "onTransitionEnd");
$2c02e90631b0fc8a$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2c02e90631b0fc8a$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2c02e90631b0fc8a$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2c02e90631b0fc8a$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2c02e90631b0fc8a$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2c02e90631b0fc8a$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2c02e90631b0fc8a$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2c02e90631b0fc8a$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2c02e90631b0fc8a$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2c02e90631b0fc8a$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2c02e90631b0fc8a$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2c02e90631b0fc8a$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($2c02e90631b0fc8a$var$lf));
function $2c02e90631b0fc8a$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $2c02e90631b0fc8a$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $2c02e90631b0fc8a$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2c02e90631b0fc8a$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2c02e90631b0fc8a$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($2c02e90631b0fc8a$var$Qb) throw a = $2c02e90631b0fc8a$var$Rb, $2c02e90631b0fc8a$var$Qb = !1, $2c02e90631b0fc8a$var$Rb = null, a;
}
function $2c02e90631b0fc8a$var$D(a, b) {
    var c = b[$2c02e90631b0fc8a$var$of];
    void 0 === c && (c = b[$2c02e90631b0fc8a$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($2c02e90631b0fc8a$var$pf(b, a, 2, !1), c.add(d));
}
function $2c02e90631b0fc8a$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $2c02e90631b0fc8a$var$pf(c, a, d, b);
}
var $2c02e90631b0fc8a$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $2c02e90631b0fc8a$var$sf(a) {
    if (!a[$2c02e90631b0fc8a$var$rf]) {
        a[$2c02e90631b0fc8a$var$rf] = !0;
        $2c02e90631b0fc8a$var$da.forEach(function(b) {
            "selectionchange" !== b && ($2c02e90631b0fc8a$var$mf.has(b) || $2c02e90631b0fc8a$var$qf(b, !1, a), $2c02e90631b0fc8a$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$2c02e90631b0fc8a$var$rf] || (b[$2c02e90631b0fc8a$var$rf] = !0, $2c02e90631b0fc8a$var$qf("selectionchange", !1, b));
    }
}
function $2c02e90631b0fc8a$var$pf(a, b, c, d) {
    switch($2c02e90631b0fc8a$var$jd(b)){
        case 1:
            var e = $2c02e90631b0fc8a$var$ed;
            break;
        case 4:
            e = $2c02e90631b0fc8a$var$gd;
            break;
        default:
            e = $2c02e90631b0fc8a$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$2c02e90631b0fc8a$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $2c02e90631b0fc8a$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $2c02e90631b0fc8a$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $2c02e90631b0fc8a$var$Jb(function() {
        var d = f, e = $2c02e90631b0fc8a$var$xb(c), g = [];
        a: {
            var h = $2c02e90631b0fc8a$var$df.get(a);
            if (void 0 !== h) {
                var k = $2c02e90631b0fc8a$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $2c02e90631b0fc8a$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $2c02e90631b0fc8a$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $2c02e90631b0fc8a$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $2c02e90631b0fc8a$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $2c02e90631b0fc8a$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $2c02e90631b0fc8a$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $2c02e90631b0fc8a$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $2c02e90631b0fc8a$var$Vd;
                        break;
                    case $2c02e90631b0fc8a$var$$e:
                    case $2c02e90631b0fc8a$var$af:
                    case $2c02e90631b0fc8a$var$bf:
                        k = $2c02e90631b0fc8a$var$Hd;
                        break;
                    case $2c02e90631b0fc8a$var$cf:
                        k = $2c02e90631b0fc8a$var$Xd;
                        break;
                    case "scroll":
                        k = $2c02e90631b0fc8a$var$vd;
                        break;
                    case "wheel":
                        k = $2c02e90631b0fc8a$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $2c02e90631b0fc8a$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $2c02e90631b0fc8a$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $2c02e90631b0fc8a$var$Kb(w, x), null != F && t.push($2c02e90631b0fc8a$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $2c02e90631b0fc8a$var$wb && (n = c.relatedTarget || c.fromElement) && ($2c02e90631b0fc8a$var$Wc(n) || n[$2c02e90631b0fc8a$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $2c02e90631b0fc8a$var$Wc(n) : null, null !== n && (J = $2c02e90631b0fc8a$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $2c02e90631b0fc8a$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $2c02e90631b0fc8a$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $2c02e90631b0fc8a$var$ue(k);
                        u = null == n ? h : $2c02e90631b0fc8a$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $2c02e90631b0fc8a$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $2c02e90631b0fc8a$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $2c02e90631b0fc8a$var$vf(F))u++;
                            for(; 0 < w - u;)t = $2c02e90631b0fc8a$var$vf(t), w--;
                            for(; 0 < u - w;)x = $2c02e90631b0fc8a$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $2c02e90631b0fc8a$var$vf(t);
                                x = $2c02e90631b0fc8a$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $2c02e90631b0fc8a$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $2c02e90631b0fc8a$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $2c02e90631b0fc8a$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $2c02e90631b0fc8a$var$ve;
                else if ($2c02e90631b0fc8a$var$me(h)) {
                    if ($2c02e90631b0fc8a$var$we) na = $2c02e90631b0fc8a$var$Fe;
                    else {
                        na = $2c02e90631b0fc8a$var$De;
                        var xa = $2c02e90631b0fc8a$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $2c02e90631b0fc8a$var$Ee);
                if (na && (na = na(a, d))) {
                    $2c02e90631b0fc8a$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $2c02e90631b0fc8a$var$cb(h, "number", h.value);
            }
            xa = d ? $2c02e90631b0fc8a$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($2c02e90631b0fc8a$var$me(xa) || "true" === xa.contentEditable) $2c02e90631b0fc8a$var$Qe = xa, $2c02e90631b0fc8a$var$Re = d, $2c02e90631b0fc8a$var$Se = null;
                    break;
                case "focusout":
                    $2c02e90631b0fc8a$var$Se = $2c02e90631b0fc8a$var$Re = $2c02e90631b0fc8a$var$Qe = null;
                    break;
                case "mousedown":
                    $2c02e90631b0fc8a$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2c02e90631b0fc8a$var$Te = !1;
                    $2c02e90631b0fc8a$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($2c02e90631b0fc8a$var$Pe) break;
                case "keydown":
                case "keyup":
                    $2c02e90631b0fc8a$var$Ue(g, c, e);
            }
            var $a;
            if ($2c02e90631b0fc8a$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $2c02e90631b0fc8a$var$ie ? $2c02e90631b0fc8a$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($2c02e90631b0fc8a$var$de && "ko" !== c.locale && ($2c02e90631b0fc8a$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $2c02e90631b0fc8a$var$ie && ($a = $2c02e90631b0fc8a$var$nd()) : ($2c02e90631b0fc8a$var$kd = e, $2c02e90631b0fc8a$var$ld = "value" in $2c02e90631b0fc8a$var$kd ? $2c02e90631b0fc8a$var$kd.value : $2c02e90631b0fc8a$var$kd.textContent, $2c02e90631b0fc8a$var$ie = !0)), xa = $2c02e90631b0fc8a$var$oe(d, ba), 0 < xa.length && (ba = new $2c02e90631b0fc8a$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $2c02e90631b0fc8a$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $2c02e90631b0fc8a$var$ce ? $2c02e90631b0fc8a$var$je(a, c) : $2c02e90631b0fc8a$var$ke(a, c)) d = $2c02e90631b0fc8a$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $2c02e90631b0fc8a$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $2c02e90631b0fc8a$var$se(g, b);
    });
}
function $2c02e90631b0fc8a$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $2c02e90631b0fc8a$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $2c02e90631b0fc8a$var$Kb(a, c), null != f && d.unshift($2c02e90631b0fc8a$var$tf(a, f, e)), f = $2c02e90631b0fc8a$var$Kb(a, b), null != f && d.push($2c02e90631b0fc8a$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $2c02e90631b0fc8a$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $2c02e90631b0fc8a$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $2c02e90631b0fc8a$var$Kb(c, f), null != k && g.unshift($2c02e90631b0fc8a$var$tf(c, k, h))) : e || (k = $2c02e90631b0fc8a$var$Kb(c, f), null != k && g.push($2c02e90631b0fc8a$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $2c02e90631b0fc8a$var$xf = /\r\n?/g, $2c02e90631b0fc8a$var$yf = /\u0000|\uFFFD/g;
function $2c02e90631b0fc8a$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($2c02e90631b0fc8a$var$xf, "\n").replace($2c02e90631b0fc8a$var$yf, "");
}
function $2c02e90631b0fc8a$var$Af(a, b, c) {
    b = $2c02e90631b0fc8a$var$zf(b);
    if ($2c02e90631b0fc8a$var$zf(a) !== b && c) throw Error($2c02e90631b0fc8a$var$p(425));
}
function $2c02e90631b0fc8a$var$Bf() {}
var $2c02e90631b0fc8a$var$Cf = null, $2c02e90631b0fc8a$var$Df = null;
function $2c02e90631b0fc8a$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $2c02e90631b0fc8a$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $2c02e90631b0fc8a$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $2c02e90631b0fc8a$var$Hf = "function" === typeof Promise ? Promise : void 0, $2c02e90631b0fc8a$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $2c02e90631b0fc8a$var$Hf ? function(a) {
    return $2c02e90631b0fc8a$var$Hf.resolve(null).then(a).catch($2c02e90631b0fc8a$var$If);
} : $2c02e90631b0fc8a$var$Ff;
function $2c02e90631b0fc8a$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $2c02e90631b0fc8a$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $2c02e90631b0fc8a$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $2c02e90631b0fc8a$var$bd(b);
}
function $2c02e90631b0fc8a$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $2c02e90631b0fc8a$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $2c02e90631b0fc8a$var$Nf = Math.random().toString(36).slice(2), $2c02e90631b0fc8a$var$Of = "__reactFiber$" + $2c02e90631b0fc8a$var$Nf, $2c02e90631b0fc8a$var$Pf = "__reactProps$" + $2c02e90631b0fc8a$var$Nf, $2c02e90631b0fc8a$var$uf = "__reactContainer$" + $2c02e90631b0fc8a$var$Nf, $2c02e90631b0fc8a$var$of = "__reactEvents$" + $2c02e90631b0fc8a$var$Nf, $2c02e90631b0fc8a$var$Qf = "__reactListeners$" + $2c02e90631b0fc8a$var$Nf, $2c02e90631b0fc8a$var$Rf = "__reactHandles$" + $2c02e90631b0fc8a$var$Nf;
function $2c02e90631b0fc8a$var$Wc(a) {
    var b = a[$2c02e90631b0fc8a$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$2c02e90631b0fc8a$var$uf] || c[$2c02e90631b0fc8a$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $2c02e90631b0fc8a$var$Mf(a); null !== a;){
                if (c = a[$2c02e90631b0fc8a$var$Of]) return c;
                a = $2c02e90631b0fc8a$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $2c02e90631b0fc8a$var$Cb(a) {
    a = a[$2c02e90631b0fc8a$var$Of] || a[$2c02e90631b0fc8a$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $2c02e90631b0fc8a$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($2c02e90631b0fc8a$var$p(33));
}
function $2c02e90631b0fc8a$var$Db(a) {
    return a[$2c02e90631b0fc8a$var$Pf] || null;
}
var $2c02e90631b0fc8a$var$Sf = [], $2c02e90631b0fc8a$var$Tf = -1;
function $2c02e90631b0fc8a$var$Uf(a) {
    return {
        current: a
    };
}
function $2c02e90631b0fc8a$var$E(a) {
    0 > $2c02e90631b0fc8a$var$Tf || (a.current = $2c02e90631b0fc8a$var$Sf[$2c02e90631b0fc8a$var$Tf], $2c02e90631b0fc8a$var$Sf[$2c02e90631b0fc8a$var$Tf] = null, $2c02e90631b0fc8a$var$Tf--);
}
function $2c02e90631b0fc8a$var$G(a, b) {
    $2c02e90631b0fc8a$var$Tf++;
    $2c02e90631b0fc8a$var$Sf[$2c02e90631b0fc8a$var$Tf] = a.current;
    a.current = b;
}
var $2c02e90631b0fc8a$var$Vf = {}, $2c02e90631b0fc8a$var$H = $2c02e90631b0fc8a$var$Uf($2c02e90631b0fc8a$var$Vf), $2c02e90631b0fc8a$var$Wf = $2c02e90631b0fc8a$var$Uf(!1), $2c02e90631b0fc8a$var$Xf = $2c02e90631b0fc8a$var$Vf;
function $2c02e90631b0fc8a$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $2c02e90631b0fc8a$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $2c02e90631b0fc8a$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $2c02e90631b0fc8a$var$$f() {
    $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$Wf);
    $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$H);
}
function $2c02e90631b0fc8a$var$ag(a, b, c) {
    if ($2c02e90631b0fc8a$var$H.current !== $2c02e90631b0fc8a$var$Vf) throw Error($2c02e90631b0fc8a$var$p(168));
    $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$H, b);
    $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$Wf, c);
}
function $2c02e90631b0fc8a$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($2c02e90631b0fc8a$var$p(108, $2c02e90631b0fc8a$var$Ra(a) || "Unknown", e));
    return $2c02e90631b0fc8a$var$A({}, c, d);
}
function $2c02e90631b0fc8a$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $2c02e90631b0fc8a$var$Vf;
    $2c02e90631b0fc8a$var$Xf = $2c02e90631b0fc8a$var$H.current;
    $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$H, a);
    $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$Wf, $2c02e90631b0fc8a$var$Wf.current);
    return !0;
}
function $2c02e90631b0fc8a$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($2c02e90631b0fc8a$var$p(169));
    c ? (a = $2c02e90631b0fc8a$var$bg(a, b, $2c02e90631b0fc8a$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$Wf), $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$H), $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$H, a)) : $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$Wf);
    $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$Wf, c);
}
var $2c02e90631b0fc8a$var$eg = null, $2c02e90631b0fc8a$var$fg = !1, $2c02e90631b0fc8a$var$gg = !1;
function $2c02e90631b0fc8a$var$hg(a) {
    null === $2c02e90631b0fc8a$var$eg ? $2c02e90631b0fc8a$var$eg = [
        a
    ] : $2c02e90631b0fc8a$var$eg.push(a);
}
function $2c02e90631b0fc8a$var$ig(a) {
    $2c02e90631b0fc8a$var$fg = !0;
    $2c02e90631b0fc8a$var$hg(a);
}
function $2c02e90631b0fc8a$var$jg() {
    if (!$2c02e90631b0fc8a$var$gg && null !== $2c02e90631b0fc8a$var$eg) {
        $2c02e90631b0fc8a$var$gg = !0;
        var a = 0, b = $2c02e90631b0fc8a$var$C;
        try {
            var c = $2c02e90631b0fc8a$var$eg;
            for($2c02e90631b0fc8a$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $2c02e90631b0fc8a$var$eg = null;
            $2c02e90631b0fc8a$var$fg = !1;
        } catch (e) {
            throw null !== $2c02e90631b0fc8a$var$eg && ($2c02e90631b0fc8a$var$eg = $2c02e90631b0fc8a$var$eg.slice(a + 1)), $2c02e90631b0fc8a$var$ac($2c02e90631b0fc8a$var$fc, $2c02e90631b0fc8a$var$jg), e;
        } finally{
            $2c02e90631b0fc8a$var$C = b, $2c02e90631b0fc8a$var$gg = !1;
        }
    }
    return null;
}
var $2c02e90631b0fc8a$var$kg = [], $2c02e90631b0fc8a$var$lg = 0, $2c02e90631b0fc8a$var$mg = null, $2c02e90631b0fc8a$var$ng = 0, $2c02e90631b0fc8a$var$og = [], $2c02e90631b0fc8a$var$pg = 0, $2c02e90631b0fc8a$var$qg = null, $2c02e90631b0fc8a$var$rg = 1, $2c02e90631b0fc8a$var$sg = "";
function $2c02e90631b0fc8a$var$tg(a, b) {
    $2c02e90631b0fc8a$var$kg[$2c02e90631b0fc8a$var$lg++] = $2c02e90631b0fc8a$var$ng;
    $2c02e90631b0fc8a$var$kg[$2c02e90631b0fc8a$var$lg++] = $2c02e90631b0fc8a$var$mg;
    $2c02e90631b0fc8a$var$mg = a;
    $2c02e90631b0fc8a$var$ng = b;
}
function $2c02e90631b0fc8a$var$ug(a, b, c) {
    $2c02e90631b0fc8a$var$og[$2c02e90631b0fc8a$var$pg++] = $2c02e90631b0fc8a$var$rg;
    $2c02e90631b0fc8a$var$og[$2c02e90631b0fc8a$var$pg++] = $2c02e90631b0fc8a$var$sg;
    $2c02e90631b0fc8a$var$og[$2c02e90631b0fc8a$var$pg++] = $2c02e90631b0fc8a$var$qg;
    $2c02e90631b0fc8a$var$qg = a;
    var d = $2c02e90631b0fc8a$var$rg;
    a = $2c02e90631b0fc8a$var$sg;
    var e = 32 - $2c02e90631b0fc8a$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $2c02e90631b0fc8a$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $2c02e90631b0fc8a$var$rg = 1 << 32 - $2c02e90631b0fc8a$var$oc(b) + e | c << e | d;
        $2c02e90631b0fc8a$var$sg = f + a;
    } else $2c02e90631b0fc8a$var$rg = 1 << f | c << e | d, $2c02e90631b0fc8a$var$sg = a;
}
function $2c02e90631b0fc8a$var$vg(a) {
    null !== a.return && ($2c02e90631b0fc8a$var$tg(a, 1), $2c02e90631b0fc8a$var$ug(a, 1, 0));
}
function $2c02e90631b0fc8a$var$wg(a) {
    for(; a === $2c02e90631b0fc8a$var$mg;)$2c02e90631b0fc8a$var$mg = $2c02e90631b0fc8a$var$kg[--$2c02e90631b0fc8a$var$lg], $2c02e90631b0fc8a$var$kg[$2c02e90631b0fc8a$var$lg] = null, $2c02e90631b0fc8a$var$ng = $2c02e90631b0fc8a$var$kg[--$2c02e90631b0fc8a$var$lg], $2c02e90631b0fc8a$var$kg[$2c02e90631b0fc8a$var$lg] = null;
    for(; a === $2c02e90631b0fc8a$var$qg;)$2c02e90631b0fc8a$var$qg = $2c02e90631b0fc8a$var$og[--$2c02e90631b0fc8a$var$pg], $2c02e90631b0fc8a$var$og[$2c02e90631b0fc8a$var$pg] = null, $2c02e90631b0fc8a$var$sg = $2c02e90631b0fc8a$var$og[--$2c02e90631b0fc8a$var$pg], $2c02e90631b0fc8a$var$og[$2c02e90631b0fc8a$var$pg] = null, $2c02e90631b0fc8a$var$rg = $2c02e90631b0fc8a$var$og[--$2c02e90631b0fc8a$var$pg], $2c02e90631b0fc8a$var$og[$2c02e90631b0fc8a$var$pg] = null;
}
var $2c02e90631b0fc8a$var$xg = null, $2c02e90631b0fc8a$var$yg = null, $2c02e90631b0fc8a$var$I = !1, $2c02e90631b0fc8a$var$zg = null;
function $2c02e90631b0fc8a$var$Ag(a, b) {
    var c = $2c02e90631b0fc8a$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $2c02e90631b0fc8a$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $2c02e90631b0fc8a$var$xg = a, $2c02e90631b0fc8a$var$yg = $2c02e90631b0fc8a$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $2c02e90631b0fc8a$var$xg = a, $2c02e90631b0fc8a$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $2c02e90631b0fc8a$var$qg ? {
                id: $2c02e90631b0fc8a$var$rg,
                overflow: $2c02e90631b0fc8a$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $2c02e90631b0fc8a$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $2c02e90631b0fc8a$var$xg = a, $2c02e90631b0fc8a$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $2c02e90631b0fc8a$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $2c02e90631b0fc8a$var$Eg(a) {
    if ($2c02e90631b0fc8a$var$I) {
        var b = $2c02e90631b0fc8a$var$yg;
        if (b) {
            var c = b;
            if (!$2c02e90631b0fc8a$var$Cg(a, b)) {
                if ($2c02e90631b0fc8a$var$Dg(a)) throw Error($2c02e90631b0fc8a$var$p(418));
                b = $2c02e90631b0fc8a$var$Lf(c.nextSibling);
                var d = $2c02e90631b0fc8a$var$xg;
                b && $2c02e90631b0fc8a$var$Cg(a, b) ? $2c02e90631b0fc8a$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $2c02e90631b0fc8a$var$I = !1, $2c02e90631b0fc8a$var$xg = a);
            }
        } else {
            if ($2c02e90631b0fc8a$var$Dg(a)) throw Error($2c02e90631b0fc8a$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $2c02e90631b0fc8a$var$I = !1;
            $2c02e90631b0fc8a$var$xg = a;
        }
    }
}
function $2c02e90631b0fc8a$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $2c02e90631b0fc8a$var$xg = a;
}
function $2c02e90631b0fc8a$var$Gg(a) {
    if (a !== $2c02e90631b0fc8a$var$xg) return !1;
    if (!$2c02e90631b0fc8a$var$I) return $2c02e90631b0fc8a$var$Fg(a), $2c02e90631b0fc8a$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$2c02e90631b0fc8a$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $2c02e90631b0fc8a$var$yg)) {
        if ($2c02e90631b0fc8a$var$Dg(a)) throw $2c02e90631b0fc8a$var$Hg(), Error($2c02e90631b0fc8a$var$p(418));
        for(; b;)$2c02e90631b0fc8a$var$Ag(a, b), b = $2c02e90631b0fc8a$var$Lf(b.nextSibling);
    }
    $2c02e90631b0fc8a$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($2c02e90631b0fc8a$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $2c02e90631b0fc8a$var$yg = $2c02e90631b0fc8a$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $2c02e90631b0fc8a$var$yg = null;
        }
    } else $2c02e90631b0fc8a$var$yg = $2c02e90631b0fc8a$var$xg ? $2c02e90631b0fc8a$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $2c02e90631b0fc8a$var$Hg() {
    for(var a = $2c02e90631b0fc8a$var$yg; a;)a = $2c02e90631b0fc8a$var$Lf(a.nextSibling);
}
function $2c02e90631b0fc8a$var$Ig() {
    $2c02e90631b0fc8a$var$yg = $2c02e90631b0fc8a$var$xg = null;
    $2c02e90631b0fc8a$var$I = !1;
}
function $2c02e90631b0fc8a$var$Jg(a) {
    null === $2c02e90631b0fc8a$var$zg ? $2c02e90631b0fc8a$var$zg = [
        a
    ] : $2c02e90631b0fc8a$var$zg.push(a);
}
var $2c02e90631b0fc8a$var$Kg = $2c02e90631b0fc8a$var$ua.ReactCurrentBatchConfig;
function $2c02e90631b0fc8a$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($2c02e90631b0fc8a$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($2c02e90631b0fc8a$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($2c02e90631b0fc8a$var$p(284));
        if (!c._owner) throw Error($2c02e90631b0fc8a$var$p(290, a));
    }
    return a;
}
function $2c02e90631b0fc8a$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($2c02e90631b0fc8a$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $2c02e90631b0fc8a$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $2c02e90631b0fc8a$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $2c02e90631b0fc8a$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $2c02e90631b0fc8a$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $2c02e90631b0fc8a$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $2c02e90631b0fc8a$var$Ha && $2c02e90631b0fc8a$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $2c02e90631b0fc8a$var$Lg(a, b, c), d.return = a, d;
        d = $2c02e90631b0fc8a$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $2c02e90631b0fc8a$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $2c02e90631b0fc8a$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $2c02e90631b0fc8a$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $2c02e90631b0fc8a$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $2c02e90631b0fc8a$var$va:
                    return c = $2c02e90631b0fc8a$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $2c02e90631b0fc8a$var$Lg(a, null, b), c.return = a, c;
                case $2c02e90631b0fc8a$var$wa:
                    return b = $2c02e90631b0fc8a$var$Sg(b, a.mode, c), b.return = a, b;
                case $2c02e90631b0fc8a$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($2c02e90631b0fc8a$var$eb(b) || $2c02e90631b0fc8a$var$Ka(b)) return b = $2c02e90631b0fc8a$var$Tg(b, a.mode, c, null), b.return = a, b;
            $2c02e90631b0fc8a$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $2c02e90631b0fc8a$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $2c02e90631b0fc8a$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $2c02e90631b0fc8a$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($2c02e90631b0fc8a$var$eb(c) || $2c02e90631b0fc8a$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $2c02e90631b0fc8a$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $2c02e90631b0fc8a$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $2c02e90631b0fc8a$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $2c02e90631b0fc8a$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($2c02e90631b0fc8a$var$eb(d) || $2c02e90631b0fc8a$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $2c02e90631b0fc8a$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $2c02e90631b0fc8a$var$I && $2c02e90631b0fc8a$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $2c02e90631b0fc8a$var$I && $2c02e90631b0fc8a$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $2c02e90631b0fc8a$var$I && $2c02e90631b0fc8a$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $2c02e90631b0fc8a$var$Ka(h);
        if ("function" !== typeof l) throw Error($2c02e90631b0fc8a$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($2c02e90631b0fc8a$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $2c02e90631b0fc8a$var$I && $2c02e90631b0fc8a$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $2c02e90631b0fc8a$var$I && $2c02e90631b0fc8a$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $2c02e90631b0fc8a$var$I && $2c02e90631b0fc8a$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $2c02e90631b0fc8a$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $2c02e90631b0fc8a$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $2c02e90631b0fc8a$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $2c02e90631b0fc8a$var$Ha && $2c02e90631b0fc8a$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $2c02e90631b0fc8a$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $2c02e90631b0fc8a$var$ya ? (d = $2c02e90631b0fc8a$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $2c02e90631b0fc8a$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $2c02e90631b0fc8a$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $2c02e90631b0fc8a$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $2c02e90631b0fc8a$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $2c02e90631b0fc8a$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($2c02e90631b0fc8a$var$eb(f)) return n(a, d, f, h);
            if ($2c02e90631b0fc8a$var$Ka(f)) return t(a, d, f, h);
            $2c02e90631b0fc8a$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $2c02e90631b0fc8a$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $2c02e90631b0fc8a$var$Ug = $2c02e90631b0fc8a$var$Og(!0), $2c02e90631b0fc8a$var$Vg = $2c02e90631b0fc8a$var$Og(!1), $2c02e90631b0fc8a$var$Wg = $2c02e90631b0fc8a$var$Uf(null), $2c02e90631b0fc8a$var$Xg = null, $2c02e90631b0fc8a$var$Yg = null, $2c02e90631b0fc8a$var$Zg = null;
function $2c02e90631b0fc8a$var$$g() {
    $2c02e90631b0fc8a$var$Zg = $2c02e90631b0fc8a$var$Yg = $2c02e90631b0fc8a$var$Xg = null;
}
function $2c02e90631b0fc8a$var$ah(a) {
    var b = $2c02e90631b0fc8a$var$Wg.current;
    $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$Wg);
    a._currentValue = b;
}
function $2c02e90631b0fc8a$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $2c02e90631b0fc8a$var$ch(a, b) {
    $2c02e90631b0fc8a$var$Xg = a;
    $2c02e90631b0fc8a$var$Zg = $2c02e90631b0fc8a$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($2c02e90631b0fc8a$var$dh = !0), a.firstContext = null);
}
function $2c02e90631b0fc8a$var$eh(a) {
    var b = a._currentValue;
    if ($2c02e90631b0fc8a$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $2c02e90631b0fc8a$var$Yg) {
            if (null === $2c02e90631b0fc8a$var$Xg) throw Error($2c02e90631b0fc8a$var$p(308));
            $2c02e90631b0fc8a$var$Yg = a;
            $2c02e90631b0fc8a$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $2c02e90631b0fc8a$var$Yg = $2c02e90631b0fc8a$var$Yg.next = a;
    }
    return b;
}
var $2c02e90631b0fc8a$var$fh = null;
function $2c02e90631b0fc8a$var$gh(a) {
    null === $2c02e90631b0fc8a$var$fh ? $2c02e90631b0fc8a$var$fh = [
        a
    ] : $2c02e90631b0fc8a$var$fh.push(a);
}
function $2c02e90631b0fc8a$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $2c02e90631b0fc8a$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $2c02e90631b0fc8a$var$ih(a, d);
}
function $2c02e90631b0fc8a$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $2c02e90631b0fc8a$var$jh = !1;
function $2c02e90631b0fc8a$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $2c02e90631b0fc8a$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $2c02e90631b0fc8a$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2c02e90631b0fc8a$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($2c02e90631b0fc8a$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $2c02e90631b0fc8a$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $2c02e90631b0fc8a$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $2c02e90631b0fc8a$var$ih(a, c);
}
function $2c02e90631b0fc8a$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2c02e90631b0fc8a$var$Cc(a, c);
    }
}
function $2c02e90631b0fc8a$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $2c02e90631b0fc8a$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $2c02e90631b0fc8a$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $2c02e90631b0fc8a$var$A({}, q, r);
                            break a;
                        case 2:
                            $2c02e90631b0fc8a$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $2c02e90631b0fc8a$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $2c02e90631b0fc8a$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($2c02e90631b0fc8a$var$p(191, e));
            e.call(d);
        }
    }
}
var $2c02e90631b0fc8a$var$th = {}, $2c02e90631b0fc8a$var$uh = $2c02e90631b0fc8a$var$Uf($2c02e90631b0fc8a$var$th), $2c02e90631b0fc8a$var$vh = $2c02e90631b0fc8a$var$Uf($2c02e90631b0fc8a$var$th), $2c02e90631b0fc8a$var$wh = $2c02e90631b0fc8a$var$Uf($2c02e90631b0fc8a$var$th);
function $2c02e90631b0fc8a$var$xh(a) {
    if (a === $2c02e90631b0fc8a$var$th) throw Error($2c02e90631b0fc8a$var$p(174));
    return a;
}
function $2c02e90631b0fc8a$var$yh(a, b) {
    $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$wh, b);
    $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$vh, a);
    $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$uh, $2c02e90631b0fc8a$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $2c02e90631b0fc8a$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $2c02e90631b0fc8a$var$lb(b, a);
    }
    $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$uh);
    $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$uh, b);
}
function $2c02e90631b0fc8a$var$zh() {
    $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$uh);
    $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$vh);
    $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$wh);
}
function $2c02e90631b0fc8a$var$Ah(a) {
    $2c02e90631b0fc8a$var$xh($2c02e90631b0fc8a$var$wh.current);
    var b = $2c02e90631b0fc8a$var$xh($2c02e90631b0fc8a$var$uh.current);
    var c = $2c02e90631b0fc8a$var$lb(b, a.type);
    b !== c && ($2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$vh, a), $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$uh, c));
}
function $2c02e90631b0fc8a$var$Bh(a) {
    $2c02e90631b0fc8a$var$vh.current === a && ($2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$uh), $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$vh));
}
var $2c02e90631b0fc8a$var$L = $2c02e90631b0fc8a$var$Uf(0);
function $2c02e90631b0fc8a$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $2c02e90631b0fc8a$var$Dh = [];
function $2c02e90631b0fc8a$var$Eh() {
    for(var a = 0; a < $2c02e90631b0fc8a$var$Dh.length; a++)$2c02e90631b0fc8a$var$Dh[a]._workInProgressVersionPrimary = null;
    $2c02e90631b0fc8a$var$Dh.length = 0;
}
var $2c02e90631b0fc8a$var$Fh = $2c02e90631b0fc8a$var$ua.ReactCurrentDispatcher, $2c02e90631b0fc8a$var$Gh = $2c02e90631b0fc8a$var$ua.ReactCurrentBatchConfig, $2c02e90631b0fc8a$var$Hh = 0, $2c02e90631b0fc8a$var$M = null, $2c02e90631b0fc8a$var$N = null, $2c02e90631b0fc8a$var$O = null, $2c02e90631b0fc8a$var$Ih = !1, $2c02e90631b0fc8a$var$Jh = !1, $2c02e90631b0fc8a$var$Kh = 0, $2c02e90631b0fc8a$var$Lh = 0;
function $2c02e90631b0fc8a$var$P() {
    throw Error($2c02e90631b0fc8a$var$p(321));
}
function $2c02e90631b0fc8a$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$2c02e90631b0fc8a$var$He(a[c], b[c])) return !1;
    return !0;
}
function $2c02e90631b0fc8a$var$Nh(a, b, c, d, e, f) {
    $2c02e90631b0fc8a$var$Hh = f;
    $2c02e90631b0fc8a$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $2c02e90631b0fc8a$var$Fh.current = null === a || null === a.memoizedState ? $2c02e90631b0fc8a$var$Oh : $2c02e90631b0fc8a$var$Ph;
    a = c(d, e);
    if ($2c02e90631b0fc8a$var$Jh) {
        f = 0;
        do {
            $2c02e90631b0fc8a$var$Jh = !1;
            $2c02e90631b0fc8a$var$Kh = 0;
            if (25 <= f) throw Error($2c02e90631b0fc8a$var$p(301));
            f += 1;
            $2c02e90631b0fc8a$var$O = $2c02e90631b0fc8a$var$N = null;
            b.updateQueue = null;
            $2c02e90631b0fc8a$var$Fh.current = $2c02e90631b0fc8a$var$Qh;
            a = c(d, e);
        }while ($2c02e90631b0fc8a$var$Jh);
    }
    $2c02e90631b0fc8a$var$Fh.current = $2c02e90631b0fc8a$var$Rh;
    b = null !== $2c02e90631b0fc8a$var$N && null !== $2c02e90631b0fc8a$var$N.next;
    $2c02e90631b0fc8a$var$Hh = 0;
    $2c02e90631b0fc8a$var$O = $2c02e90631b0fc8a$var$N = $2c02e90631b0fc8a$var$M = null;
    $2c02e90631b0fc8a$var$Ih = !1;
    if (b) throw Error($2c02e90631b0fc8a$var$p(300));
    return a;
}
function $2c02e90631b0fc8a$var$Sh() {
    var a = 0 !== $2c02e90631b0fc8a$var$Kh;
    $2c02e90631b0fc8a$var$Kh = 0;
    return a;
}
function $2c02e90631b0fc8a$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $2c02e90631b0fc8a$var$O ? $2c02e90631b0fc8a$var$M.memoizedState = $2c02e90631b0fc8a$var$O = a : $2c02e90631b0fc8a$var$O = $2c02e90631b0fc8a$var$O.next = a;
    return $2c02e90631b0fc8a$var$O;
}
function $2c02e90631b0fc8a$var$Uh() {
    if (null === $2c02e90631b0fc8a$var$N) {
        var a = $2c02e90631b0fc8a$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $2c02e90631b0fc8a$var$N.next;
    var b = null === $2c02e90631b0fc8a$var$O ? $2c02e90631b0fc8a$var$M.memoizedState : $2c02e90631b0fc8a$var$O.next;
    if (null !== b) $2c02e90631b0fc8a$var$O = b, $2c02e90631b0fc8a$var$N = a;
    else {
        if (null === a) throw Error($2c02e90631b0fc8a$var$p(310));
        $2c02e90631b0fc8a$var$N = a;
        a = {
            memoizedState: $2c02e90631b0fc8a$var$N.memoizedState,
            baseState: $2c02e90631b0fc8a$var$N.baseState,
            baseQueue: $2c02e90631b0fc8a$var$N.baseQueue,
            queue: $2c02e90631b0fc8a$var$N.queue,
            next: null
        };
        null === $2c02e90631b0fc8a$var$O ? $2c02e90631b0fc8a$var$M.memoizedState = $2c02e90631b0fc8a$var$O = a : $2c02e90631b0fc8a$var$O = $2c02e90631b0fc8a$var$O.next = a;
    }
    return $2c02e90631b0fc8a$var$O;
}
function $2c02e90631b0fc8a$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $2c02e90631b0fc8a$var$Wh(a) {
    var b = $2c02e90631b0fc8a$var$Uh(), c = b.queue;
    if (null === c) throw Error($2c02e90631b0fc8a$var$p(311));
    c.lastRenderedReducer = a;
    var d = $2c02e90631b0fc8a$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($2c02e90631b0fc8a$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $2c02e90631b0fc8a$var$M.lanes |= m;
                $2c02e90631b0fc8a$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $2c02e90631b0fc8a$var$He(d, b.memoizedState) || ($2c02e90631b0fc8a$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $2c02e90631b0fc8a$var$M.lanes |= f, $2c02e90631b0fc8a$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $2c02e90631b0fc8a$var$Xh(a) {
    var b = $2c02e90631b0fc8a$var$Uh(), c = b.queue;
    if (null === c) throw Error($2c02e90631b0fc8a$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $2c02e90631b0fc8a$var$He(f, b.memoizedState) || ($2c02e90631b0fc8a$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $2c02e90631b0fc8a$var$Yh() {}
function $2c02e90631b0fc8a$var$Zh(a, b) {
    var c = $2c02e90631b0fc8a$var$M, d = $2c02e90631b0fc8a$var$Uh(), e = b(), f = !$2c02e90631b0fc8a$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $2c02e90631b0fc8a$var$dh = !0);
    d = d.queue;
    $2c02e90631b0fc8a$var$$h($2c02e90631b0fc8a$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $2c02e90631b0fc8a$var$O && $2c02e90631b0fc8a$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $2c02e90631b0fc8a$var$bi(9, $2c02e90631b0fc8a$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $2c02e90631b0fc8a$var$Q) throw Error($2c02e90631b0fc8a$var$p(349));
        0 !== ($2c02e90631b0fc8a$var$Hh & 30) || $2c02e90631b0fc8a$var$di(c, b, e);
    }
    return e;
}
function $2c02e90631b0fc8a$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $2c02e90631b0fc8a$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2c02e90631b0fc8a$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $2c02e90631b0fc8a$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $2c02e90631b0fc8a$var$ei(b) && $2c02e90631b0fc8a$var$fi(a);
}
function $2c02e90631b0fc8a$var$ai(a, b, c) {
    return c(function() {
        $2c02e90631b0fc8a$var$ei(b) && $2c02e90631b0fc8a$var$fi(a);
    });
}
function $2c02e90631b0fc8a$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$2c02e90631b0fc8a$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $2c02e90631b0fc8a$var$fi(a) {
    var b = $2c02e90631b0fc8a$var$ih(a, 1);
    null !== b && $2c02e90631b0fc8a$var$gi(b, a, 1, -1);
}
function $2c02e90631b0fc8a$var$hi(a) {
    var b = $2c02e90631b0fc8a$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2c02e90631b0fc8a$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $2c02e90631b0fc8a$var$ii.bind(null, $2c02e90631b0fc8a$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $2c02e90631b0fc8a$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $2c02e90631b0fc8a$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2c02e90631b0fc8a$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $2c02e90631b0fc8a$var$ji() {
    return $2c02e90631b0fc8a$var$Uh().memoizedState;
}
function $2c02e90631b0fc8a$var$ki(a, b, c, d) {
    var e = $2c02e90631b0fc8a$var$Th();
    $2c02e90631b0fc8a$var$M.flags |= a;
    e.memoizedState = $2c02e90631b0fc8a$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $2c02e90631b0fc8a$var$li(a, b, c, d) {
    var e = $2c02e90631b0fc8a$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $2c02e90631b0fc8a$var$N) {
        var g = $2c02e90631b0fc8a$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $2c02e90631b0fc8a$var$Mh(d, g.deps)) {
            e.memoizedState = $2c02e90631b0fc8a$var$bi(b, c, f, d);
            return;
        }
    }
    $2c02e90631b0fc8a$var$M.flags |= a;
    e.memoizedState = $2c02e90631b0fc8a$var$bi(1 | b, c, f, d);
}
function $2c02e90631b0fc8a$var$mi(a, b) {
    return $2c02e90631b0fc8a$var$ki(8390656, 8, a, b);
}
function $2c02e90631b0fc8a$var$$h(a, b) {
    return $2c02e90631b0fc8a$var$li(2048, 8, a, b);
}
function $2c02e90631b0fc8a$var$ni(a, b) {
    return $2c02e90631b0fc8a$var$li(4, 2, a, b);
}
function $2c02e90631b0fc8a$var$oi(a, b) {
    return $2c02e90631b0fc8a$var$li(4, 4, a, b);
}
function $2c02e90631b0fc8a$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $2c02e90631b0fc8a$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $2c02e90631b0fc8a$var$li(4, 4, $2c02e90631b0fc8a$var$pi.bind(null, b, a), c);
}
function $2c02e90631b0fc8a$var$ri() {}
function $2c02e90631b0fc8a$var$si(a, b) {
    var c = $2c02e90631b0fc8a$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2c02e90631b0fc8a$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2c02e90631b0fc8a$var$ti(a, b) {
    var c = $2c02e90631b0fc8a$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2c02e90631b0fc8a$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2c02e90631b0fc8a$var$ui(a, b, c) {
    if (0 === ($2c02e90631b0fc8a$var$Hh & 21)) return a.baseState && (a.baseState = !1, $2c02e90631b0fc8a$var$dh = !0), a.memoizedState = c;
    $2c02e90631b0fc8a$var$He(c, b) || (c = $2c02e90631b0fc8a$var$yc(), $2c02e90631b0fc8a$var$M.lanes |= c, $2c02e90631b0fc8a$var$rh |= c, a.baseState = !0);
    return b;
}
function $2c02e90631b0fc8a$var$vi(a, b) {
    var c = $2c02e90631b0fc8a$var$C;
    $2c02e90631b0fc8a$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $2c02e90631b0fc8a$var$Gh.transition;
    $2c02e90631b0fc8a$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $2c02e90631b0fc8a$var$C = c, $2c02e90631b0fc8a$var$Gh.transition = d;
    }
}
function $2c02e90631b0fc8a$var$wi() {
    return $2c02e90631b0fc8a$var$Uh().memoizedState;
}
function $2c02e90631b0fc8a$var$xi(a, b, c) {
    var d = $2c02e90631b0fc8a$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2c02e90631b0fc8a$var$zi(a)) $2c02e90631b0fc8a$var$Ai(b, c);
    else if (c = $2c02e90631b0fc8a$var$hh(a, b, c, d), null !== c) {
        var e = $2c02e90631b0fc8a$var$R();
        $2c02e90631b0fc8a$var$gi(c, a, d, e);
        $2c02e90631b0fc8a$var$Bi(c, b, d);
    }
}
function $2c02e90631b0fc8a$var$ii(a, b, c) {
    var d = $2c02e90631b0fc8a$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2c02e90631b0fc8a$var$zi(a)) $2c02e90631b0fc8a$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($2c02e90631b0fc8a$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $2c02e90631b0fc8a$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $2c02e90631b0fc8a$var$hh(a, b, e, d);
        null !== c && (e = $2c02e90631b0fc8a$var$R(), $2c02e90631b0fc8a$var$gi(c, a, d, e), $2c02e90631b0fc8a$var$Bi(c, b, d));
    }
}
function $2c02e90631b0fc8a$var$zi(a) {
    var b = a.alternate;
    return a === $2c02e90631b0fc8a$var$M || null !== b && b === $2c02e90631b0fc8a$var$M;
}
function $2c02e90631b0fc8a$var$Ai(a, b) {
    $2c02e90631b0fc8a$var$Jh = $2c02e90631b0fc8a$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $2c02e90631b0fc8a$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2c02e90631b0fc8a$var$Cc(a, c);
    }
}
var $2c02e90631b0fc8a$var$Rh = {
    readContext: $2c02e90631b0fc8a$var$eh,
    useCallback: $2c02e90631b0fc8a$var$P,
    useContext: $2c02e90631b0fc8a$var$P,
    useEffect: $2c02e90631b0fc8a$var$P,
    useImperativeHandle: $2c02e90631b0fc8a$var$P,
    useInsertionEffect: $2c02e90631b0fc8a$var$P,
    useLayoutEffect: $2c02e90631b0fc8a$var$P,
    useMemo: $2c02e90631b0fc8a$var$P,
    useReducer: $2c02e90631b0fc8a$var$P,
    useRef: $2c02e90631b0fc8a$var$P,
    useState: $2c02e90631b0fc8a$var$P,
    useDebugValue: $2c02e90631b0fc8a$var$P,
    useDeferredValue: $2c02e90631b0fc8a$var$P,
    useTransition: $2c02e90631b0fc8a$var$P,
    useMutableSource: $2c02e90631b0fc8a$var$P,
    useSyncExternalStore: $2c02e90631b0fc8a$var$P,
    useId: $2c02e90631b0fc8a$var$P,
    unstable_isNewReconciler: !1
}, $2c02e90631b0fc8a$var$Oh = {
    readContext: $2c02e90631b0fc8a$var$eh,
    useCallback: function(a, b) {
        $2c02e90631b0fc8a$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $2c02e90631b0fc8a$var$eh,
    useEffect: $2c02e90631b0fc8a$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $2c02e90631b0fc8a$var$ki(4194308, 4, $2c02e90631b0fc8a$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $2c02e90631b0fc8a$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $2c02e90631b0fc8a$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $2c02e90631b0fc8a$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $2c02e90631b0fc8a$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $2c02e90631b0fc8a$var$xi.bind(null, $2c02e90631b0fc8a$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $2c02e90631b0fc8a$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $2c02e90631b0fc8a$var$hi,
    useDebugValue: $2c02e90631b0fc8a$var$ri,
    useDeferredValue: function(a) {
        return $2c02e90631b0fc8a$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $2c02e90631b0fc8a$var$hi(!1), b = a[0];
        a = $2c02e90631b0fc8a$var$vi.bind(null, a[1]);
        $2c02e90631b0fc8a$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $2c02e90631b0fc8a$var$M, e = $2c02e90631b0fc8a$var$Th();
        if ($2c02e90631b0fc8a$var$I) {
            if (void 0 === c) throw Error($2c02e90631b0fc8a$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $2c02e90631b0fc8a$var$Q) throw Error($2c02e90631b0fc8a$var$p(349));
            0 !== ($2c02e90631b0fc8a$var$Hh & 30) || $2c02e90631b0fc8a$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $2c02e90631b0fc8a$var$mi($2c02e90631b0fc8a$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $2c02e90631b0fc8a$var$bi(9, $2c02e90631b0fc8a$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $2c02e90631b0fc8a$var$Th(), b = $2c02e90631b0fc8a$var$Q.identifierPrefix;
        if ($2c02e90631b0fc8a$var$I) {
            var c = $2c02e90631b0fc8a$var$sg;
            var d = $2c02e90631b0fc8a$var$rg;
            c = (d & ~(1 << 32 - $2c02e90631b0fc8a$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $2c02e90631b0fc8a$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $2c02e90631b0fc8a$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $2c02e90631b0fc8a$var$Ph = {
    readContext: $2c02e90631b0fc8a$var$eh,
    useCallback: $2c02e90631b0fc8a$var$si,
    useContext: $2c02e90631b0fc8a$var$eh,
    useEffect: $2c02e90631b0fc8a$var$$h,
    useImperativeHandle: $2c02e90631b0fc8a$var$qi,
    useInsertionEffect: $2c02e90631b0fc8a$var$ni,
    useLayoutEffect: $2c02e90631b0fc8a$var$oi,
    useMemo: $2c02e90631b0fc8a$var$ti,
    useReducer: $2c02e90631b0fc8a$var$Wh,
    useRef: $2c02e90631b0fc8a$var$ji,
    useState: function() {
        return $2c02e90631b0fc8a$var$Wh($2c02e90631b0fc8a$var$Vh);
    },
    useDebugValue: $2c02e90631b0fc8a$var$ri,
    useDeferredValue: function(a) {
        var b = $2c02e90631b0fc8a$var$Uh();
        return $2c02e90631b0fc8a$var$ui(b, $2c02e90631b0fc8a$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $2c02e90631b0fc8a$var$Wh($2c02e90631b0fc8a$var$Vh)[0], b = $2c02e90631b0fc8a$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2c02e90631b0fc8a$var$Yh,
    useSyncExternalStore: $2c02e90631b0fc8a$var$Zh,
    useId: $2c02e90631b0fc8a$var$wi,
    unstable_isNewReconciler: !1
}, $2c02e90631b0fc8a$var$Qh = {
    readContext: $2c02e90631b0fc8a$var$eh,
    useCallback: $2c02e90631b0fc8a$var$si,
    useContext: $2c02e90631b0fc8a$var$eh,
    useEffect: $2c02e90631b0fc8a$var$$h,
    useImperativeHandle: $2c02e90631b0fc8a$var$qi,
    useInsertionEffect: $2c02e90631b0fc8a$var$ni,
    useLayoutEffect: $2c02e90631b0fc8a$var$oi,
    useMemo: $2c02e90631b0fc8a$var$ti,
    useReducer: $2c02e90631b0fc8a$var$Xh,
    useRef: $2c02e90631b0fc8a$var$ji,
    useState: function() {
        return $2c02e90631b0fc8a$var$Xh($2c02e90631b0fc8a$var$Vh);
    },
    useDebugValue: $2c02e90631b0fc8a$var$ri,
    useDeferredValue: function(a) {
        var b = $2c02e90631b0fc8a$var$Uh();
        return null === $2c02e90631b0fc8a$var$N ? b.memoizedState = a : $2c02e90631b0fc8a$var$ui(b, $2c02e90631b0fc8a$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $2c02e90631b0fc8a$var$Xh($2c02e90631b0fc8a$var$Vh)[0], b = $2c02e90631b0fc8a$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2c02e90631b0fc8a$var$Yh,
    useSyncExternalStore: $2c02e90631b0fc8a$var$Zh,
    useId: $2c02e90631b0fc8a$var$wi,
    unstable_isNewReconciler: !1
};
function $2c02e90631b0fc8a$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $2c02e90631b0fc8a$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $2c02e90631b0fc8a$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $2c02e90631b0fc8a$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $2c02e90631b0fc8a$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $2c02e90631b0fc8a$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2c02e90631b0fc8a$var$R(), e = $2c02e90631b0fc8a$var$yi(a), f = $2c02e90631b0fc8a$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2c02e90631b0fc8a$var$nh(a, f, e);
        null !== b && ($2c02e90631b0fc8a$var$gi(b, a, e, d), $2c02e90631b0fc8a$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2c02e90631b0fc8a$var$R(), e = $2c02e90631b0fc8a$var$yi(a), f = $2c02e90631b0fc8a$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2c02e90631b0fc8a$var$nh(a, f, e);
        null !== b && ($2c02e90631b0fc8a$var$gi(b, a, e, d), $2c02e90631b0fc8a$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $2c02e90631b0fc8a$var$R(), d = $2c02e90631b0fc8a$var$yi(a), e = $2c02e90631b0fc8a$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $2c02e90631b0fc8a$var$nh(a, e, d);
        null !== b && ($2c02e90631b0fc8a$var$gi(b, a, d, c), $2c02e90631b0fc8a$var$oh(b, a, d));
    }
};
function $2c02e90631b0fc8a$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$2c02e90631b0fc8a$var$Ie(c, d) || !$2c02e90631b0fc8a$var$Ie(e, f) : !0;
}
function $2c02e90631b0fc8a$var$Gi(a, b, c) {
    var d = !1, e = $2c02e90631b0fc8a$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $2c02e90631b0fc8a$var$eh(f) : (e = $2c02e90631b0fc8a$var$Zf(b) ? $2c02e90631b0fc8a$var$Xf : $2c02e90631b0fc8a$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $2c02e90631b0fc8a$var$Yf(a, e) : $2c02e90631b0fc8a$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $2c02e90631b0fc8a$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $2c02e90631b0fc8a$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $2c02e90631b0fc8a$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $2c02e90631b0fc8a$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $2c02e90631b0fc8a$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $2c02e90631b0fc8a$var$eh(f) : (f = $2c02e90631b0fc8a$var$Zf(b) ? $2c02e90631b0fc8a$var$Xf : $2c02e90631b0fc8a$var$H.current, e.context = $2c02e90631b0fc8a$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($2c02e90631b0fc8a$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $2c02e90631b0fc8a$var$Ei.enqueueReplaceState(e, e.state, null), $2c02e90631b0fc8a$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $2c02e90631b0fc8a$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $2c02e90631b0fc8a$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $2c02e90631b0fc8a$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $2c02e90631b0fc8a$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $2c02e90631b0fc8a$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $2c02e90631b0fc8a$var$Ni(a, b, c) {
    c = $2c02e90631b0fc8a$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $2c02e90631b0fc8a$var$Oi || ($2c02e90631b0fc8a$var$Oi = !0, $2c02e90631b0fc8a$var$Pi = d);
        $2c02e90631b0fc8a$var$Li(a, b);
    };
    return c;
}
function $2c02e90631b0fc8a$var$Qi(a, b, c) {
    c = $2c02e90631b0fc8a$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $2c02e90631b0fc8a$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $2c02e90631b0fc8a$var$Li(a, b);
        "function" !== typeof d && (null === $2c02e90631b0fc8a$var$Ri ? $2c02e90631b0fc8a$var$Ri = new Set([
            this
        ]) : $2c02e90631b0fc8a$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $2c02e90631b0fc8a$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $2c02e90631b0fc8a$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $2c02e90631b0fc8a$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $2c02e90631b0fc8a$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $2c02e90631b0fc8a$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $2c02e90631b0fc8a$var$mh(-1, 1), b.tag = 2, $2c02e90631b0fc8a$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $2c02e90631b0fc8a$var$Wi = $2c02e90631b0fc8a$var$ua.ReactCurrentOwner, $2c02e90631b0fc8a$var$dh = !1;
function $2c02e90631b0fc8a$var$Xi(a, b, c, d) {
    b.child = null === a ? $2c02e90631b0fc8a$var$Vg(b, null, c, d) : $2c02e90631b0fc8a$var$Ug(b, a.child, c, d);
}
function $2c02e90631b0fc8a$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $2c02e90631b0fc8a$var$ch(b, e);
    d = $2c02e90631b0fc8a$var$Nh(a, b, c, d, f, e);
    c = $2c02e90631b0fc8a$var$Sh();
    if (null !== a && !$2c02e90631b0fc8a$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2c02e90631b0fc8a$var$Zi(a, b, e);
    $2c02e90631b0fc8a$var$I && c && $2c02e90631b0fc8a$var$vg(b);
    b.flags |= 1;
    $2c02e90631b0fc8a$var$Xi(a, b, d, e);
    return b.child;
}
function $2c02e90631b0fc8a$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$2c02e90631b0fc8a$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $2c02e90631b0fc8a$var$bj(a, b, f, d, e);
        a = $2c02e90631b0fc8a$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $2c02e90631b0fc8a$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $2c02e90631b0fc8a$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $2c02e90631b0fc8a$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $2c02e90631b0fc8a$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($2c02e90631b0fc8a$var$Ie(f, d) && a.ref === b.ref) {
            if ($2c02e90631b0fc8a$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($2c02e90631b0fc8a$var$dh = !0);
            else return b.lanes = a.lanes, $2c02e90631b0fc8a$var$Zi(a, b, e);
        }
    }
    return $2c02e90631b0fc8a$var$cj(a, b, c, d, e);
}
function $2c02e90631b0fc8a$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$ej, $2c02e90631b0fc8a$var$fj), $2c02e90631b0fc8a$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$ej, $2c02e90631b0fc8a$var$fj), $2c02e90631b0fc8a$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$ej, $2c02e90631b0fc8a$var$fj);
            $2c02e90631b0fc8a$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$ej, $2c02e90631b0fc8a$var$fj), $2c02e90631b0fc8a$var$fj |= d;
    $2c02e90631b0fc8a$var$Xi(a, b, e, c);
    return b.child;
}
function $2c02e90631b0fc8a$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $2c02e90631b0fc8a$var$cj(a, b, c, d, e) {
    var f = $2c02e90631b0fc8a$var$Zf(c) ? $2c02e90631b0fc8a$var$Xf : $2c02e90631b0fc8a$var$H.current;
    f = $2c02e90631b0fc8a$var$Yf(b, f);
    $2c02e90631b0fc8a$var$ch(b, e);
    c = $2c02e90631b0fc8a$var$Nh(a, b, c, d, f, e);
    d = $2c02e90631b0fc8a$var$Sh();
    if (null !== a && !$2c02e90631b0fc8a$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2c02e90631b0fc8a$var$Zi(a, b, e);
    $2c02e90631b0fc8a$var$I && d && $2c02e90631b0fc8a$var$vg(b);
    b.flags |= 1;
    $2c02e90631b0fc8a$var$Xi(a, b, c, e);
    return b.child;
}
function $2c02e90631b0fc8a$var$hj(a, b, c, d, e) {
    if ($2c02e90631b0fc8a$var$Zf(c)) {
        var f = !0;
        $2c02e90631b0fc8a$var$cg(b);
    } else f = !1;
    $2c02e90631b0fc8a$var$ch(b, e);
    if (null === b.stateNode) $2c02e90631b0fc8a$var$ij(a, b), $2c02e90631b0fc8a$var$Gi(b, c, d), $2c02e90631b0fc8a$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $2c02e90631b0fc8a$var$eh(l) : (l = $2c02e90631b0fc8a$var$Zf(c) ? $2c02e90631b0fc8a$var$Xf : $2c02e90631b0fc8a$var$H.current, l = $2c02e90631b0fc8a$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $2c02e90631b0fc8a$var$Hi(b, g, d, l);
        $2c02e90631b0fc8a$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $2c02e90631b0fc8a$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $2c02e90631b0fc8a$var$Wf.current || $2c02e90631b0fc8a$var$jh ? ("function" === typeof m && ($2c02e90631b0fc8a$var$Di(b, c, m, d), k = b.memoizedState), (h = $2c02e90631b0fc8a$var$jh || $2c02e90631b0fc8a$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $2c02e90631b0fc8a$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $2c02e90631b0fc8a$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $2c02e90631b0fc8a$var$eh(k) : (k = $2c02e90631b0fc8a$var$Zf(c) ? $2c02e90631b0fc8a$var$Xf : $2c02e90631b0fc8a$var$H.current, k = $2c02e90631b0fc8a$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $2c02e90631b0fc8a$var$Hi(b, g, d, k);
        $2c02e90631b0fc8a$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $2c02e90631b0fc8a$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $2c02e90631b0fc8a$var$Wf.current || $2c02e90631b0fc8a$var$jh ? ("function" === typeof y && ($2c02e90631b0fc8a$var$Di(b, c, y, d), n = b.memoizedState), (l = $2c02e90631b0fc8a$var$jh || $2c02e90631b0fc8a$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $2c02e90631b0fc8a$var$jj(a, b, c, d, f, e);
}
function $2c02e90631b0fc8a$var$jj(a, b, c, d, e, f) {
    $2c02e90631b0fc8a$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $2c02e90631b0fc8a$var$dg(b, c, !1), $2c02e90631b0fc8a$var$Zi(a, b, f);
    d = b.stateNode;
    $2c02e90631b0fc8a$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $2c02e90631b0fc8a$var$Ug(b, a.child, null, f), b.child = $2c02e90631b0fc8a$var$Ug(b, null, h, f)) : $2c02e90631b0fc8a$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $2c02e90631b0fc8a$var$dg(b, c, !0);
    return b.child;
}
function $2c02e90631b0fc8a$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $2c02e90631b0fc8a$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $2c02e90631b0fc8a$var$ag(a, b.context, !1);
    $2c02e90631b0fc8a$var$yh(a, b.containerInfo);
}
function $2c02e90631b0fc8a$var$lj(a, b, c, d, e) {
    $2c02e90631b0fc8a$var$Ig();
    $2c02e90631b0fc8a$var$Jg(e);
    b.flags |= 256;
    $2c02e90631b0fc8a$var$Xi(a, b, c, d);
    return b.child;
}
var $2c02e90631b0fc8a$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $2c02e90631b0fc8a$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $2c02e90631b0fc8a$var$oj(a, b, c) {
    var d = b.pendingProps, e = $2c02e90631b0fc8a$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$L, e & 1);
    if (null === a) {
        $2c02e90631b0fc8a$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $2c02e90631b0fc8a$var$pj(g, d, 0, null), a = $2c02e90631b0fc8a$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $2c02e90631b0fc8a$var$nj(c), b.memoizedState = $2c02e90631b0fc8a$var$mj, a) : $2c02e90631b0fc8a$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $2c02e90631b0fc8a$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $2c02e90631b0fc8a$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $2c02e90631b0fc8a$var$Pg(h, f) : (f = $2c02e90631b0fc8a$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $2c02e90631b0fc8a$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $2c02e90631b0fc8a$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $2c02e90631b0fc8a$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $2c02e90631b0fc8a$var$qj(a, b) {
    b = $2c02e90631b0fc8a$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $2c02e90631b0fc8a$var$sj(a, b, c, d) {
    null !== d && $2c02e90631b0fc8a$var$Jg(d);
    $2c02e90631b0fc8a$var$Ug(b, a.child, null, c);
    a = $2c02e90631b0fc8a$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $2c02e90631b0fc8a$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $2c02e90631b0fc8a$var$Ki(Error($2c02e90631b0fc8a$var$p(422))), $2c02e90631b0fc8a$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $2c02e90631b0fc8a$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $2c02e90631b0fc8a$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $2c02e90631b0fc8a$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $2c02e90631b0fc8a$var$nj(g);
        b.memoizedState = $2c02e90631b0fc8a$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $2c02e90631b0fc8a$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($2c02e90631b0fc8a$var$p(419));
        d = $2c02e90631b0fc8a$var$Ki(f, d, void 0);
        return $2c02e90631b0fc8a$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($2c02e90631b0fc8a$var$dh || h) {
        d = $2c02e90631b0fc8a$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $2c02e90631b0fc8a$var$ih(a, e), $2c02e90631b0fc8a$var$gi(d, a, e, -1));
        }
        $2c02e90631b0fc8a$var$tj();
        d = $2c02e90631b0fc8a$var$Ki(Error($2c02e90631b0fc8a$var$p(421)));
        return $2c02e90631b0fc8a$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $2c02e90631b0fc8a$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $2c02e90631b0fc8a$var$yg = $2c02e90631b0fc8a$var$Lf(e.nextSibling);
    $2c02e90631b0fc8a$var$xg = b;
    $2c02e90631b0fc8a$var$I = !0;
    $2c02e90631b0fc8a$var$zg = null;
    null !== a && ($2c02e90631b0fc8a$var$og[$2c02e90631b0fc8a$var$pg++] = $2c02e90631b0fc8a$var$rg, $2c02e90631b0fc8a$var$og[$2c02e90631b0fc8a$var$pg++] = $2c02e90631b0fc8a$var$sg, $2c02e90631b0fc8a$var$og[$2c02e90631b0fc8a$var$pg++] = $2c02e90631b0fc8a$var$qg, $2c02e90631b0fc8a$var$rg = a.id, $2c02e90631b0fc8a$var$sg = a.overflow, $2c02e90631b0fc8a$var$qg = b);
    b = $2c02e90631b0fc8a$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $2c02e90631b0fc8a$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $2c02e90631b0fc8a$var$bh(a.return, b, c);
}
function $2c02e90631b0fc8a$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $2c02e90631b0fc8a$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $2c02e90631b0fc8a$var$Xi(a, b, d.children, c);
    d = $2c02e90631b0fc8a$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $2c02e90631b0fc8a$var$vj(a, c, b);
            else if (19 === a.tag) $2c02e90631b0fc8a$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $2c02e90631b0fc8a$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $2c02e90631b0fc8a$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $2c02e90631b0fc8a$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $2c02e90631b0fc8a$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $2c02e90631b0fc8a$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $2c02e90631b0fc8a$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $2c02e90631b0fc8a$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $2c02e90631b0fc8a$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($2c02e90631b0fc8a$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $2c02e90631b0fc8a$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $2c02e90631b0fc8a$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $2c02e90631b0fc8a$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $2c02e90631b0fc8a$var$kj(b);
            $2c02e90631b0fc8a$var$Ig();
            break;
        case 5:
            $2c02e90631b0fc8a$var$Ah(b);
            break;
        case 1:
            $2c02e90631b0fc8a$var$Zf(b.type) && $2c02e90631b0fc8a$var$cg(b);
            break;
        case 4:
            $2c02e90631b0fc8a$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$L, $2c02e90631b0fc8a$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $2c02e90631b0fc8a$var$oj(a, b, c);
                $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$L, $2c02e90631b0fc8a$var$L.current & 1);
                a = $2c02e90631b0fc8a$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$L, $2c02e90631b0fc8a$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $2c02e90631b0fc8a$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$L, $2c02e90631b0fc8a$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $2c02e90631b0fc8a$var$dj(a, b, c);
    }
    return $2c02e90631b0fc8a$var$Zi(a, b, c);
}
var $2c02e90631b0fc8a$var$zj, $2c02e90631b0fc8a$var$Aj, $2c02e90631b0fc8a$var$Bj, $2c02e90631b0fc8a$var$Cj;
$2c02e90631b0fc8a$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$2c02e90631b0fc8a$var$Aj = function() {};
$2c02e90631b0fc8a$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $2c02e90631b0fc8a$var$xh($2c02e90631b0fc8a$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $2c02e90631b0fc8a$var$Ya(a, e);
                d = $2c02e90631b0fc8a$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $2c02e90631b0fc8a$var$A({}, e, {
                    value: void 0
                });
                d = $2c02e90631b0fc8a$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $2c02e90631b0fc8a$var$gb(a, e);
                d = $2c02e90631b0fc8a$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $2c02e90631b0fc8a$var$Bf);
        }
        $2c02e90631b0fc8a$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($2c02e90631b0fc8a$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($2c02e90631b0fc8a$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $2c02e90631b0fc8a$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$2c02e90631b0fc8a$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $2c02e90631b0fc8a$var$Dj(a, b) {
    if (!$2c02e90631b0fc8a$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $2c02e90631b0fc8a$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $2c02e90631b0fc8a$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $2c02e90631b0fc8a$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2c02e90631b0fc8a$var$S(b), null;
        case 1:
            return $2c02e90631b0fc8a$var$Zf(b.type) && $2c02e90631b0fc8a$var$$f(), $2c02e90631b0fc8a$var$S(b), null;
        case 3:
            d = b.stateNode;
            $2c02e90631b0fc8a$var$zh();
            $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$Wf);
            $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$H);
            $2c02e90631b0fc8a$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $2c02e90631b0fc8a$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $2c02e90631b0fc8a$var$zg && ($2c02e90631b0fc8a$var$Fj($2c02e90631b0fc8a$var$zg), $2c02e90631b0fc8a$var$zg = null));
            $2c02e90631b0fc8a$var$Aj(a, b);
            $2c02e90631b0fc8a$var$S(b);
            return null;
        case 5:
            $2c02e90631b0fc8a$var$Bh(b);
            var e = $2c02e90631b0fc8a$var$xh($2c02e90631b0fc8a$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $2c02e90631b0fc8a$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($2c02e90631b0fc8a$var$p(166));
                    $2c02e90631b0fc8a$var$S(b);
                    return null;
                }
                a = $2c02e90631b0fc8a$var$xh($2c02e90631b0fc8a$var$uh.current);
                if ($2c02e90631b0fc8a$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$2c02e90631b0fc8a$var$Of] = b;
                    d[$2c02e90631b0fc8a$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $2c02e90631b0fc8a$var$D("cancel", d);
                            $2c02e90631b0fc8a$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $2c02e90631b0fc8a$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $2c02e90631b0fc8a$var$lf.length; e++)$2c02e90631b0fc8a$var$D($2c02e90631b0fc8a$var$lf[e], d);
                            break;
                        case "source":
                            $2c02e90631b0fc8a$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $2c02e90631b0fc8a$var$D("error", d);
                            $2c02e90631b0fc8a$var$D("load", d);
                            break;
                        case "details":
                            $2c02e90631b0fc8a$var$D("toggle", d);
                            break;
                        case "input":
                            $2c02e90631b0fc8a$var$Za(d, f);
                            $2c02e90631b0fc8a$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $2c02e90631b0fc8a$var$D("invalid", d);
                            break;
                        case "textarea":
                            $2c02e90631b0fc8a$var$hb(d, f), $2c02e90631b0fc8a$var$D("invalid", d);
                    }
                    $2c02e90631b0fc8a$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $2c02e90631b0fc8a$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $2c02e90631b0fc8a$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $2c02e90631b0fc8a$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $2c02e90631b0fc8a$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $2c02e90631b0fc8a$var$Va(d);
                            $2c02e90631b0fc8a$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $2c02e90631b0fc8a$var$Va(d);
                            $2c02e90631b0fc8a$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $2c02e90631b0fc8a$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $2c02e90631b0fc8a$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$2c02e90631b0fc8a$var$Of] = b;
                    a[$2c02e90631b0fc8a$var$Pf] = d;
                    $2c02e90631b0fc8a$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $2c02e90631b0fc8a$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $2c02e90631b0fc8a$var$D("cancel", a);
                                $2c02e90631b0fc8a$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $2c02e90631b0fc8a$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $2c02e90631b0fc8a$var$lf.length; e++)$2c02e90631b0fc8a$var$D($2c02e90631b0fc8a$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $2c02e90631b0fc8a$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $2c02e90631b0fc8a$var$D("error", a);
                                $2c02e90631b0fc8a$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $2c02e90631b0fc8a$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $2c02e90631b0fc8a$var$Za(a, d);
                                e = $2c02e90631b0fc8a$var$Ya(a, d);
                                $2c02e90631b0fc8a$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $2c02e90631b0fc8a$var$A({}, d, {
                                    value: void 0
                                });
                                $2c02e90631b0fc8a$var$D("invalid", a);
                                break;
                            case "textarea":
                                $2c02e90631b0fc8a$var$hb(a, d);
                                e = $2c02e90631b0fc8a$var$gb(a, d);
                                $2c02e90631b0fc8a$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $2c02e90631b0fc8a$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $2c02e90631b0fc8a$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $2c02e90631b0fc8a$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $2c02e90631b0fc8a$var$ob(a, k) : "number" === typeof k && $2c02e90631b0fc8a$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($2c02e90631b0fc8a$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $2c02e90631b0fc8a$var$D("scroll", a) : null != k && $2c02e90631b0fc8a$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $2c02e90631b0fc8a$var$Va(a);
                                $2c02e90631b0fc8a$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $2c02e90631b0fc8a$var$Va(a);
                                $2c02e90631b0fc8a$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $2c02e90631b0fc8a$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $2c02e90631b0fc8a$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $2c02e90631b0fc8a$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $2c02e90631b0fc8a$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $2c02e90631b0fc8a$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $2c02e90631b0fc8a$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($2c02e90631b0fc8a$var$p(166));
                c = $2c02e90631b0fc8a$var$xh($2c02e90631b0fc8a$var$wh.current);
                $2c02e90631b0fc8a$var$xh($2c02e90631b0fc8a$var$uh.current);
                if ($2c02e90631b0fc8a$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$2c02e90631b0fc8a$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $2c02e90631b0fc8a$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $2c02e90631b0fc8a$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $2c02e90631b0fc8a$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$2c02e90631b0fc8a$var$Of] = b, b.stateNode = d;
            }
            $2c02e90631b0fc8a$var$S(b);
            return null;
        case 13:
            $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($2c02e90631b0fc8a$var$I && null !== $2c02e90631b0fc8a$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $2c02e90631b0fc8a$var$Hg(), $2c02e90631b0fc8a$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $2c02e90631b0fc8a$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($2c02e90631b0fc8a$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($2c02e90631b0fc8a$var$p(317));
                        f[$2c02e90631b0fc8a$var$Of] = b;
                    } else $2c02e90631b0fc8a$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $2c02e90631b0fc8a$var$S(b);
                    f = !1;
                } else null !== $2c02e90631b0fc8a$var$zg && ($2c02e90631b0fc8a$var$Fj($2c02e90631b0fc8a$var$zg), $2c02e90631b0fc8a$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($2c02e90631b0fc8a$var$L.current & 1) ? 0 === $2c02e90631b0fc8a$var$T && ($2c02e90631b0fc8a$var$T = 3) : $2c02e90631b0fc8a$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $2c02e90631b0fc8a$var$S(b);
            return null;
        case 4:
            return $2c02e90631b0fc8a$var$zh(), $2c02e90631b0fc8a$var$Aj(a, b), null === a && $2c02e90631b0fc8a$var$sf(b.stateNode.containerInfo), $2c02e90631b0fc8a$var$S(b), null;
        case 10:
            return $2c02e90631b0fc8a$var$ah(b.type._context), $2c02e90631b0fc8a$var$S(b), null;
        case 17:
            return $2c02e90631b0fc8a$var$Zf(b.type) && $2c02e90631b0fc8a$var$$f(), $2c02e90631b0fc8a$var$S(b), null;
        case 19:
            $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$L);
            f = b.memoizedState;
            if (null === f) return $2c02e90631b0fc8a$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $2c02e90631b0fc8a$var$Dj(f, !1);
                else {
                    if (0 !== $2c02e90631b0fc8a$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $2c02e90631b0fc8a$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $2c02e90631b0fc8a$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$L, $2c02e90631b0fc8a$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $2c02e90631b0fc8a$var$B() > $2c02e90631b0fc8a$var$Gj && (b.flags |= 128, d = !0, $2c02e90631b0fc8a$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $2c02e90631b0fc8a$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $2c02e90631b0fc8a$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$2c02e90631b0fc8a$var$I) return $2c02e90631b0fc8a$var$S(b), null;
                    } else 2 * $2c02e90631b0fc8a$var$B() - f.renderingStartTime > $2c02e90631b0fc8a$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $2c02e90631b0fc8a$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $2c02e90631b0fc8a$var$B(), b.sibling = null, c = $2c02e90631b0fc8a$var$L.current, $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$L, d ? c & 1 | 2 : c & 1), b;
            $2c02e90631b0fc8a$var$S(b);
            return null;
        case 22:
        case 23:
            return $2c02e90631b0fc8a$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($2c02e90631b0fc8a$var$fj & 1073741824) && ($2c02e90631b0fc8a$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $2c02e90631b0fc8a$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($2c02e90631b0fc8a$var$p(156, b.tag));
}
function $2c02e90631b0fc8a$var$Ij(a, b) {
    $2c02e90631b0fc8a$var$wg(b);
    switch(b.tag){
        case 1:
            return $2c02e90631b0fc8a$var$Zf(b.type) && $2c02e90631b0fc8a$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $2c02e90631b0fc8a$var$zh(), $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$Wf), $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$H), $2c02e90631b0fc8a$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $2c02e90631b0fc8a$var$Bh(b), null;
        case 13:
            $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($2c02e90631b0fc8a$var$p(340));
                $2c02e90631b0fc8a$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$L), null;
        case 4:
            return $2c02e90631b0fc8a$var$zh(), null;
        case 10:
            return $2c02e90631b0fc8a$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $2c02e90631b0fc8a$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $2c02e90631b0fc8a$var$Jj = !1, $2c02e90631b0fc8a$var$U = !1, $2c02e90631b0fc8a$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $2c02e90631b0fc8a$var$V = null;
function $2c02e90631b0fc8a$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $2c02e90631b0fc8a$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $2c02e90631b0fc8a$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $2c02e90631b0fc8a$var$W(a, b, d);
    }
}
var $2c02e90631b0fc8a$var$Nj = !1;
function $2c02e90631b0fc8a$var$Oj(a, b) {
    $2c02e90631b0fc8a$var$Cf = $2c02e90631b0fc8a$var$dd;
    a = $2c02e90631b0fc8a$var$Me();
    if ($2c02e90631b0fc8a$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $2c02e90631b0fc8a$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $2c02e90631b0fc8a$var$dd = !1;
    for($2c02e90631b0fc8a$var$V = b; null !== $2c02e90631b0fc8a$var$V;)if (b = $2c02e90631b0fc8a$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $2c02e90631b0fc8a$var$V = a;
    else for(; null !== $2c02e90631b0fc8a$var$V;){
        b = $2c02e90631b0fc8a$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $2c02e90631b0fc8a$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($2c02e90631b0fc8a$var$p(163));
            }
        } catch (F) {
            $2c02e90631b0fc8a$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $2c02e90631b0fc8a$var$V = a;
            break;
        }
        $2c02e90631b0fc8a$var$V = b.return;
    }
    n = $2c02e90631b0fc8a$var$Nj;
    $2c02e90631b0fc8a$var$Nj = !1;
    return n;
}
function $2c02e90631b0fc8a$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $2c02e90631b0fc8a$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $2c02e90631b0fc8a$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $2c02e90631b0fc8a$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $2c02e90631b0fc8a$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $2c02e90631b0fc8a$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$2c02e90631b0fc8a$var$Of], delete b[$2c02e90631b0fc8a$var$Pf], delete b[$2c02e90631b0fc8a$var$of], delete b[$2c02e90631b0fc8a$var$Qf], delete b[$2c02e90631b0fc8a$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $2c02e90631b0fc8a$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $2c02e90631b0fc8a$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $2c02e90631b0fc8a$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $2c02e90631b0fc8a$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $2c02e90631b0fc8a$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($2c02e90631b0fc8a$var$Vj(a, b, c), a = a.sibling; null !== a;)$2c02e90631b0fc8a$var$Vj(a, b, c), a = a.sibling;
}
function $2c02e90631b0fc8a$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($2c02e90631b0fc8a$var$Wj(a, b, c), a = a.sibling; null !== a;)$2c02e90631b0fc8a$var$Wj(a, b, c), a = a.sibling;
}
var $2c02e90631b0fc8a$var$X = null, $2c02e90631b0fc8a$var$Xj = !1;
function $2c02e90631b0fc8a$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$2c02e90631b0fc8a$var$Zj(a, b, c), c = c.sibling;
}
function $2c02e90631b0fc8a$var$Zj(a, b, c) {
    if ($2c02e90631b0fc8a$var$lc && "function" === typeof $2c02e90631b0fc8a$var$lc.onCommitFiberUnmount) try {
        $2c02e90631b0fc8a$var$lc.onCommitFiberUnmount($2c02e90631b0fc8a$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $2c02e90631b0fc8a$var$U || $2c02e90631b0fc8a$var$Lj(c, b);
        case 6:
            var d = $2c02e90631b0fc8a$var$X, e = $2c02e90631b0fc8a$var$Xj;
            $2c02e90631b0fc8a$var$X = null;
            $2c02e90631b0fc8a$var$Yj(a, b, c);
            $2c02e90631b0fc8a$var$X = d;
            $2c02e90631b0fc8a$var$Xj = e;
            null !== $2c02e90631b0fc8a$var$X && ($2c02e90631b0fc8a$var$Xj ? (a = $2c02e90631b0fc8a$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $2c02e90631b0fc8a$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $2c02e90631b0fc8a$var$X && ($2c02e90631b0fc8a$var$Xj ? (a = $2c02e90631b0fc8a$var$X, c = c.stateNode, 8 === a.nodeType ? $2c02e90631b0fc8a$var$Kf(a.parentNode, c) : 1 === a.nodeType && $2c02e90631b0fc8a$var$Kf(a, c), $2c02e90631b0fc8a$var$bd(a)) : $2c02e90631b0fc8a$var$Kf($2c02e90631b0fc8a$var$X, c.stateNode));
            break;
        case 4:
            d = $2c02e90631b0fc8a$var$X;
            e = $2c02e90631b0fc8a$var$Xj;
            $2c02e90631b0fc8a$var$X = c.stateNode.containerInfo;
            $2c02e90631b0fc8a$var$Xj = !0;
            $2c02e90631b0fc8a$var$Yj(a, b, c);
            $2c02e90631b0fc8a$var$X = d;
            $2c02e90631b0fc8a$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$2c02e90631b0fc8a$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $2c02e90631b0fc8a$var$Mj(c, b, g) : 0 !== (f & 4) && $2c02e90631b0fc8a$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $2c02e90631b0fc8a$var$Yj(a, b, c);
            break;
        case 1:
            if (!$2c02e90631b0fc8a$var$U && ($2c02e90631b0fc8a$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $2c02e90631b0fc8a$var$W(c, b, h);
            }
            $2c02e90631b0fc8a$var$Yj(a, b, c);
            break;
        case 21:
            $2c02e90631b0fc8a$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($2c02e90631b0fc8a$var$U = (d = $2c02e90631b0fc8a$var$U) || null !== c.memoizedState, $2c02e90631b0fc8a$var$Yj(a, b, c), $2c02e90631b0fc8a$var$U = d) : $2c02e90631b0fc8a$var$Yj(a, b, c);
            break;
        default:
            $2c02e90631b0fc8a$var$Yj(a, b, c);
    }
}
function $2c02e90631b0fc8a$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $2c02e90631b0fc8a$var$Kj);
        b.forEach(function(b) {
            var d = $2c02e90631b0fc8a$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $2c02e90631b0fc8a$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $2c02e90631b0fc8a$var$X = h.stateNode;
                        $2c02e90631b0fc8a$var$Xj = !1;
                        break a;
                    case 3:
                        $2c02e90631b0fc8a$var$X = h.stateNode.containerInfo;
                        $2c02e90631b0fc8a$var$Xj = !0;
                        break a;
                    case 4:
                        $2c02e90631b0fc8a$var$X = h.stateNode.containerInfo;
                        $2c02e90631b0fc8a$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $2c02e90631b0fc8a$var$X) throw Error($2c02e90631b0fc8a$var$p(160));
            $2c02e90631b0fc8a$var$Zj(f, g, e);
            $2c02e90631b0fc8a$var$X = null;
            $2c02e90631b0fc8a$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $2c02e90631b0fc8a$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$2c02e90631b0fc8a$var$dk(b, a), b = b.sibling;
}
function $2c02e90631b0fc8a$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $2c02e90631b0fc8a$var$ck(b, a);
            $2c02e90631b0fc8a$var$ek(a);
            if (d & 4) {
                try {
                    $2c02e90631b0fc8a$var$Pj(3, a, a.return), $2c02e90631b0fc8a$var$Qj(3, a);
                } catch (t) {
                    $2c02e90631b0fc8a$var$W(a, a.return, t);
                }
                try {
                    $2c02e90631b0fc8a$var$Pj(5, a, a.return);
                } catch (t) {
                    $2c02e90631b0fc8a$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $2c02e90631b0fc8a$var$ck(b, a);
            $2c02e90631b0fc8a$var$ek(a);
            d & 512 && null !== c && $2c02e90631b0fc8a$var$Lj(c, c.return);
            break;
        case 5:
            $2c02e90631b0fc8a$var$ck(b, a);
            $2c02e90631b0fc8a$var$ek(a);
            d & 512 && null !== c && $2c02e90631b0fc8a$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $2c02e90631b0fc8a$var$ob(e, "");
                } catch (t) {
                    $2c02e90631b0fc8a$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $2c02e90631b0fc8a$var$ab(e, f);
                    $2c02e90631b0fc8a$var$vb(h, g);
                    var l = $2c02e90631b0fc8a$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $2c02e90631b0fc8a$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $2c02e90631b0fc8a$var$nb(e, q) : "children" === m ? $2c02e90631b0fc8a$var$ob(e, q) : $2c02e90631b0fc8a$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $2c02e90631b0fc8a$var$bb(e, f);
                            break;
                        case "textarea":
                            $2c02e90631b0fc8a$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $2c02e90631b0fc8a$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $2c02e90631b0fc8a$var$fb(e, !!f.multiple, f.defaultValue, !0) : $2c02e90631b0fc8a$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$2c02e90631b0fc8a$var$Pf] = f;
                } catch (t) {
                    $2c02e90631b0fc8a$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $2c02e90631b0fc8a$var$ck(b, a);
            $2c02e90631b0fc8a$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($2c02e90631b0fc8a$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $2c02e90631b0fc8a$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $2c02e90631b0fc8a$var$ck(b, a);
            $2c02e90631b0fc8a$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $2c02e90631b0fc8a$var$bd(b.containerInfo);
            } catch (t) {
                $2c02e90631b0fc8a$var$W(a, a.return, t);
            }
            break;
        case 4:
            $2c02e90631b0fc8a$var$ck(b, a);
            $2c02e90631b0fc8a$var$ek(a);
            break;
        case 13:
            $2c02e90631b0fc8a$var$ck(b, a);
            $2c02e90631b0fc8a$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($2c02e90631b0fc8a$var$fk = $2c02e90631b0fc8a$var$B()));
            d & 4 && $2c02e90631b0fc8a$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($2c02e90631b0fc8a$var$U = (l = $2c02e90631b0fc8a$var$U) || m, $2c02e90631b0fc8a$var$ck(b, a), $2c02e90631b0fc8a$var$U = l) : $2c02e90631b0fc8a$var$ck(b, a);
            $2c02e90631b0fc8a$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($2c02e90631b0fc8a$var$V = a, m = a.child; null !== m;){
                    for(q = $2c02e90631b0fc8a$var$V = m; null !== $2c02e90631b0fc8a$var$V;){
                        r = $2c02e90631b0fc8a$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $2c02e90631b0fc8a$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $2c02e90631b0fc8a$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $2c02e90631b0fc8a$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $2c02e90631b0fc8a$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $2c02e90631b0fc8a$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $2c02e90631b0fc8a$var$V = y) : $2c02e90631b0fc8a$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $2c02e90631b0fc8a$var$rb("display", g));
                            } catch (t) {
                                $2c02e90631b0fc8a$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $2c02e90631b0fc8a$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $2c02e90631b0fc8a$var$ck(b, a);
            $2c02e90631b0fc8a$var$ek(a);
            d & 4 && $2c02e90631b0fc8a$var$ak(a);
            break;
        case 21:
            break;
        default:
            $2c02e90631b0fc8a$var$ck(b, a), $2c02e90631b0fc8a$var$ek(a);
    }
}
function $2c02e90631b0fc8a$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($2c02e90631b0fc8a$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($2c02e90631b0fc8a$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($2c02e90631b0fc8a$var$ob(e, ""), d.flags &= -33);
                    var f = $2c02e90631b0fc8a$var$Uj(a);
                    $2c02e90631b0fc8a$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $2c02e90631b0fc8a$var$Uj(a);
                    $2c02e90631b0fc8a$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($2c02e90631b0fc8a$var$p(161));
            }
        } catch (k) {
            $2c02e90631b0fc8a$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $2c02e90631b0fc8a$var$hk(a, b, c) {
    $2c02e90631b0fc8a$var$V = a;
    $2c02e90631b0fc8a$var$ik(a, b, c);
}
function $2c02e90631b0fc8a$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $2c02e90631b0fc8a$var$V;){
        var e = $2c02e90631b0fc8a$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $2c02e90631b0fc8a$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $2c02e90631b0fc8a$var$U;
                h = $2c02e90631b0fc8a$var$Jj;
                var l = $2c02e90631b0fc8a$var$U;
                $2c02e90631b0fc8a$var$Jj = g;
                if (($2c02e90631b0fc8a$var$U = k) && !l) for($2c02e90631b0fc8a$var$V = e; null !== $2c02e90631b0fc8a$var$V;)g = $2c02e90631b0fc8a$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $2c02e90631b0fc8a$var$jk(e) : null !== k ? (k.return = g, $2c02e90631b0fc8a$var$V = k) : $2c02e90631b0fc8a$var$jk(e);
                for(; null !== f;)$2c02e90631b0fc8a$var$V = f, $2c02e90631b0fc8a$var$ik(f, b, c), f = f.sibling;
                $2c02e90631b0fc8a$var$V = e;
                $2c02e90631b0fc8a$var$Jj = h;
                $2c02e90631b0fc8a$var$U = l;
            }
            $2c02e90631b0fc8a$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $2c02e90631b0fc8a$var$V = f) : $2c02e90631b0fc8a$var$kk(a, b, c);
    }
}
function $2c02e90631b0fc8a$var$kk(a) {
    for(; null !== $2c02e90631b0fc8a$var$V;){
        var b = $2c02e90631b0fc8a$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $2c02e90631b0fc8a$var$U || $2c02e90631b0fc8a$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$2c02e90631b0fc8a$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $2c02e90631b0fc8a$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $2c02e90631b0fc8a$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $2c02e90631b0fc8a$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $2c02e90631b0fc8a$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($2c02e90631b0fc8a$var$p(163));
                }
                $2c02e90631b0fc8a$var$U || b.flags & 512 && $2c02e90631b0fc8a$var$Rj(b);
            } catch (r) {
                $2c02e90631b0fc8a$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $2c02e90631b0fc8a$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $2c02e90631b0fc8a$var$V = c;
            break;
        }
        $2c02e90631b0fc8a$var$V = b.return;
    }
}
function $2c02e90631b0fc8a$var$gk(a) {
    for(; null !== $2c02e90631b0fc8a$var$V;){
        var b = $2c02e90631b0fc8a$var$V;
        if (b === a) {
            $2c02e90631b0fc8a$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $2c02e90631b0fc8a$var$V = c;
            break;
        }
        $2c02e90631b0fc8a$var$V = b.return;
    }
}
function $2c02e90631b0fc8a$var$jk(a) {
    for(; null !== $2c02e90631b0fc8a$var$V;){
        var b = $2c02e90631b0fc8a$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $2c02e90631b0fc8a$var$Qj(4, b);
                    } catch (k) {
                        $2c02e90631b0fc8a$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $2c02e90631b0fc8a$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $2c02e90631b0fc8a$var$Rj(b);
                    } catch (k) {
                        $2c02e90631b0fc8a$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $2c02e90631b0fc8a$var$Rj(b);
                    } catch (k) {
                        $2c02e90631b0fc8a$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $2c02e90631b0fc8a$var$W(b, b.return, k);
        }
        if (b === a) {
            $2c02e90631b0fc8a$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $2c02e90631b0fc8a$var$V = h;
            break;
        }
        $2c02e90631b0fc8a$var$V = b.return;
    }
}
var $2c02e90631b0fc8a$var$lk = Math.ceil, $2c02e90631b0fc8a$var$mk = $2c02e90631b0fc8a$var$ua.ReactCurrentDispatcher, $2c02e90631b0fc8a$var$nk = $2c02e90631b0fc8a$var$ua.ReactCurrentOwner, $2c02e90631b0fc8a$var$ok = $2c02e90631b0fc8a$var$ua.ReactCurrentBatchConfig, $2c02e90631b0fc8a$var$K = 0, $2c02e90631b0fc8a$var$Q = null, $2c02e90631b0fc8a$var$Y = null, $2c02e90631b0fc8a$var$Z = 0, $2c02e90631b0fc8a$var$fj = 0, $2c02e90631b0fc8a$var$ej = $2c02e90631b0fc8a$var$Uf(0), $2c02e90631b0fc8a$var$T = 0, $2c02e90631b0fc8a$var$pk = null, $2c02e90631b0fc8a$var$rh = 0, $2c02e90631b0fc8a$var$qk = 0, $2c02e90631b0fc8a$var$rk = 0, $2c02e90631b0fc8a$var$sk = null, $2c02e90631b0fc8a$var$tk = null, $2c02e90631b0fc8a$var$fk = 0, $2c02e90631b0fc8a$var$Gj = Infinity, $2c02e90631b0fc8a$var$uk = null, $2c02e90631b0fc8a$var$Oi = !1, $2c02e90631b0fc8a$var$Pi = null, $2c02e90631b0fc8a$var$Ri = null, $2c02e90631b0fc8a$var$vk = !1, $2c02e90631b0fc8a$var$wk = null, $2c02e90631b0fc8a$var$xk = 0, $2c02e90631b0fc8a$var$yk = 0, $2c02e90631b0fc8a$var$zk = null, $2c02e90631b0fc8a$var$Ak = -1, $2c02e90631b0fc8a$var$Bk = 0;
function $2c02e90631b0fc8a$var$R() {
    return 0 !== ($2c02e90631b0fc8a$var$K & 6) ? $2c02e90631b0fc8a$var$B() : -1 !== $2c02e90631b0fc8a$var$Ak ? $2c02e90631b0fc8a$var$Ak : $2c02e90631b0fc8a$var$Ak = $2c02e90631b0fc8a$var$B();
}
function $2c02e90631b0fc8a$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($2c02e90631b0fc8a$var$K & 2) && 0 !== $2c02e90631b0fc8a$var$Z) return $2c02e90631b0fc8a$var$Z & -$2c02e90631b0fc8a$var$Z;
    if (null !== $2c02e90631b0fc8a$var$Kg.transition) return 0 === $2c02e90631b0fc8a$var$Bk && ($2c02e90631b0fc8a$var$Bk = $2c02e90631b0fc8a$var$yc()), $2c02e90631b0fc8a$var$Bk;
    a = $2c02e90631b0fc8a$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $2c02e90631b0fc8a$var$jd(a.type);
    return a;
}
function $2c02e90631b0fc8a$var$gi(a, b, c, d) {
    if (50 < $2c02e90631b0fc8a$var$yk) throw $2c02e90631b0fc8a$var$yk = 0, $2c02e90631b0fc8a$var$zk = null, Error($2c02e90631b0fc8a$var$p(185));
    $2c02e90631b0fc8a$var$Ac(a, c, d);
    if (0 === ($2c02e90631b0fc8a$var$K & 2) || a !== $2c02e90631b0fc8a$var$Q) a === $2c02e90631b0fc8a$var$Q && (0 === ($2c02e90631b0fc8a$var$K & 2) && ($2c02e90631b0fc8a$var$qk |= c), 4 === $2c02e90631b0fc8a$var$T && $2c02e90631b0fc8a$var$Ck(a, $2c02e90631b0fc8a$var$Z)), $2c02e90631b0fc8a$var$Dk(a, d), 1 === c && 0 === $2c02e90631b0fc8a$var$K && 0 === (b.mode & 1) && ($2c02e90631b0fc8a$var$Gj = $2c02e90631b0fc8a$var$B() + 500, $2c02e90631b0fc8a$var$fg && $2c02e90631b0fc8a$var$jg());
}
function $2c02e90631b0fc8a$var$Dk(a, b) {
    var c = a.callbackNode;
    $2c02e90631b0fc8a$var$wc(a, b);
    var d = $2c02e90631b0fc8a$var$uc(a, a === $2c02e90631b0fc8a$var$Q ? $2c02e90631b0fc8a$var$Z : 0);
    if (0 === d) null !== c && $2c02e90631b0fc8a$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $2c02e90631b0fc8a$var$bc(c);
        if (1 === b) 0 === a.tag ? $2c02e90631b0fc8a$var$ig($2c02e90631b0fc8a$var$Ek.bind(null, a)) : $2c02e90631b0fc8a$var$hg($2c02e90631b0fc8a$var$Ek.bind(null, a)), $2c02e90631b0fc8a$var$Jf(function() {
            0 === ($2c02e90631b0fc8a$var$K & 6) && $2c02e90631b0fc8a$var$jg();
        }), c = null;
        else {
            switch($2c02e90631b0fc8a$var$Dc(d)){
                case 1:
                    c = $2c02e90631b0fc8a$var$fc;
                    break;
                case 4:
                    c = $2c02e90631b0fc8a$var$gc;
                    break;
                case 16:
                    c = $2c02e90631b0fc8a$var$hc;
                    break;
                case 536870912:
                    c = $2c02e90631b0fc8a$var$jc;
                    break;
                default:
                    c = $2c02e90631b0fc8a$var$hc;
            }
            c = $2c02e90631b0fc8a$var$Fk(c, $2c02e90631b0fc8a$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $2c02e90631b0fc8a$var$Gk(a, b) {
    $2c02e90631b0fc8a$var$Ak = -1;
    $2c02e90631b0fc8a$var$Bk = 0;
    if (0 !== ($2c02e90631b0fc8a$var$K & 6)) throw Error($2c02e90631b0fc8a$var$p(327));
    var c = a.callbackNode;
    if ($2c02e90631b0fc8a$var$Hk() && a.callbackNode !== c) return null;
    var d = $2c02e90631b0fc8a$var$uc(a, a === $2c02e90631b0fc8a$var$Q ? $2c02e90631b0fc8a$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $2c02e90631b0fc8a$var$Ik(a, d);
    else {
        b = d;
        var e = $2c02e90631b0fc8a$var$K;
        $2c02e90631b0fc8a$var$K |= 2;
        var f = $2c02e90631b0fc8a$var$Jk();
        if ($2c02e90631b0fc8a$var$Q !== a || $2c02e90631b0fc8a$var$Z !== b) $2c02e90631b0fc8a$var$uk = null, $2c02e90631b0fc8a$var$Gj = $2c02e90631b0fc8a$var$B() + 500, $2c02e90631b0fc8a$var$Kk(a, b);
        for(;;)try {
            $2c02e90631b0fc8a$var$Lk();
            break;
        } catch (h) {
            $2c02e90631b0fc8a$var$Mk(a, h);
        }
        $2c02e90631b0fc8a$var$$g();
        $2c02e90631b0fc8a$var$mk.current = f;
        $2c02e90631b0fc8a$var$K = e;
        null !== $2c02e90631b0fc8a$var$Y ? b = 0 : ($2c02e90631b0fc8a$var$Q = null, $2c02e90631b0fc8a$var$Z = 0, b = $2c02e90631b0fc8a$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $2c02e90631b0fc8a$var$xc(a), 0 !== e && (d = e, b = $2c02e90631b0fc8a$var$Nk(a, e)));
        if (1 === b) throw c = $2c02e90631b0fc8a$var$pk, $2c02e90631b0fc8a$var$Kk(a, 0), $2c02e90631b0fc8a$var$Ck(a, d), $2c02e90631b0fc8a$var$Dk(a, $2c02e90631b0fc8a$var$B()), c;
        if (6 === b) $2c02e90631b0fc8a$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$2c02e90631b0fc8a$var$Ok(e) && (b = $2c02e90631b0fc8a$var$Ik(a, d), 2 === b && (f = $2c02e90631b0fc8a$var$xc(a), 0 !== f && (d = f, b = $2c02e90631b0fc8a$var$Nk(a, f))), 1 === b)) throw c = $2c02e90631b0fc8a$var$pk, $2c02e90631b0fc8a$var$Kk(a, 0), $2c02e90631b0fc8a$var$Ck(a, d), $2c02e90631b0fc8a$var$Dk(a, $2c02e90631b0fc8a$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($2c02e90631b0fc8a$var$p(345));
                case 2:
                    $2c02e90631b0fc8a$var$Pk(a, $2c02e90631b0fc8a$var$tk, $2c02e90631b0fc8a$var$uk);
                    break;
                case 3:
                    $2c02e90631b0fc8a$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $2c02e90631b0fc8a$var$fk + 500 - $2c02e90631b0fc8a$var$B(), 10 < b)) {
                        if (0 !== $2c02e90631b0fc8a$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $2c02e90631b0fc8a$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $2c02e90631b0fc8a$var$Ff($2c02e90631b0fc8a$var$Pk.bind(null, a, $2c02e90631b0fc8a$var$tk, $2c02e90631b0fc8a$var$uk), b);
                        break;
                    }
                    $2c02e90631b0fc8a$var$Pk(a, $2c02e90631b0fc8a$var$tk, $2c02e90631b0fc8a$var$uk);
                    break;
                case 4:
                    $2c02e90631b0fc8a$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $2c02e90631b0fc8a$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $2c02e90631b0fc8a$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $2c02e90631b0fc8a$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $2c02e90631b0fc8a$var$Ff($2c02e90631b0fc8a$var$Pk.bind(null, a, $2c02e90631b0fc8a$var$tk, $2c02e90631b0fc8a$var$uk), d);
                        break;
                    }
                    $2c02e90631b0fc8a$var$Pk(a, $2c02e90631b0fc8a$var$tk, $2c02e90631b0fc8a$var$uk);
                    break;
                case 5:
                    $2c02e90631b0fc8a$var$Pk(a, $2c02e90631b0fc8a$var$tk, $2c02e90631b0fc8a$var$uk);
                    break;
                default:
                    throw Error($2c02e90631b0fc8a$var$p(329));
            }
        }
    }
    $2c02e90631b0fc8a$var$Dk(a, $2c02e90631b0fc8a$var$B());
    return a.callbackNode === c ? $2c02e90631b0fc8a$var$Gk.bind(null, a) : null;
}
function $2c02e90631b0fc8a$var$Nk(a, b) {
    var c = $2c02e90631b0fc8a$var$sk;
    a.current.memoizedState.isDehydrated && ($2c02e90631b0fc8a$var$Kk(a, b).flags |= 256);
    a = $2c02e90631b0fc8a$var$Ik(a, b);
    2 !== a && (b = $2c02e90631b0fc8a$var$tk, $2c02e90631b0fc8a$var$tk = c, null !== b && $2c02e90631b0fc8a$var$Fj(b));
    return a;
}
function $2c02e90631b0fc8a$var$Fj(a) {
    null === $2c02e90631b0fc8a$var$tk ? $2c02e90631b0fc8a$var$tk = a : $2c02e90631b0fc8a$var$tk.push.apply($2c02e90631b0fc8a$var$tk, a);
}
function $2c02e90631b0fc8a$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$2c02e90631b0fc8a$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $2c02e90631b0fc8a$var$Ck(a, b) {
    b &= ~$2c02e90631b0fc8a$var$rk;
    b &= ~$2c02e90631b0fc8a$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $2c02e90631b0fc8a$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $2c02e90631b0fc8a$var$Ek(a) {
    if (0 !== ($2c02e90631b0fc8a$var$K & 6)) throw Error($2c02e90631b0fc8a$var$p(327));
    $2c02e90631b0fc8a$var$Hk();
    var b = $2c02e90631b0fc8a$var$uc(a, 0);
    if (0 === (b & 1)) return $2c02e90631b0fc8a$var$Dk(a, $2c02e90631b0fc8a$var$B()), null;
    var c = $2c02e90631b0fc8a$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $2c02e90631b0fc8a$var$xc(a);
        0 !== d && (b = d, c = $2c02e90631b0fc8a$var$Nk(a, d));
    }
    if (1 === c) throw c = $2c02e90631b0fc8a$var$pk, $2c02e90631b0fc8a$var$Kk(a, 0), $2c02e90631b0fc8a$var$Ck(a, b), $2c02e90631b0fc8a$var$Dk(a, $2c02e90631b0fc8a$var$B()), c;
    if (6 === c) throw Error($2c02e90631b0fc8a$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $2c02e90631b0fc8a$var$Pk(a, $2c02e90631b0fc8a$var$tk, $2c02e90631b0fc8a$var$uk);
    $2c02e90631b0fc8a$var$Dk(a, $2c02e90631b0fc8a$var$B());
    return null;
}
function $2c02e90631b0fc8a$var$Qk(a, b) {
    var c = $2c02e90631b0fc8a$var$K;
    $2c02e90631b0fc8a$var$K |= 1;
    try {
        return a(b);
    } finally{
        $2c02e90631b0fc8a$var$K = c, 0 === $2c02e90631b0fc8a$var$K && ($2c02e90631b0fc8a$var$Gj = $2c02e90631b0fc8a$var$B() + 500, $2c02e90631b0fc8a$var$fg && $2c02e90631b0fc8a$var$jg());
    }
}
function $2c02e90631b0fc8a$var$Rk(a) {
    null !== $2c02e90631b0fc8a$var$wk && 0 === $2c02e90631b0fc8a$var$wk.tag && 0 === ($2c02e90631b0fc8a$var$K & 6) && $2c02e90631b0fc8a$var$Hk();
    var b = $2c02e90631b0fc8a$var$K;
    $2c02e90631b0fc8a$var$K |= 1;
    var c = $2c02e90631b0fc8a$var$ok.transition, d = $2c02e90631b0fc8a$var$C;
    try {
        if ($2c02e90631b0fc8a$var$ok.transition = null, $2c02e90631b0fc8a$var$C = 1, a) return a();
    } finally{
        $2c02e90631b0fc8a$var$C = d, $2c02e90631b0fc8a$var$ok.transition = c, $2c02e90631b0fc8a$var$K = b, 0 === ($2c02e90631b0fc8a$var$K & 6) && $2c02e90631b0fc8a$var$jg();
    }
}
function $2c02e90631b0fc8a$var$Hj() {
    $2c02e90631b0fc8a$var$fj = $2c02e90631b0fc8a$var$ej.current;
    $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$ej);
}
function $2c02e90631b0fc8a$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $2c02e90631b0fc8a$var$Gf(c));
    if (null !== $2c02e90631b0fc8a$var$Y) for(c = $2c02e90631b0fc8a$var$Y.return; null !== c;){
        var d = c;
        $2c02e90631b0fc8a$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $2c02e90631b0fc8a$var$$f();
                break;
            case 3:
                $2c02e90631b0fc8a$var$zh();
                $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$Wf);
                $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$H);
                $2c02e90631b0fc8a$var$Eh();
                break;
            case 5:
                $2c02e90631b0fc8a$var$Bh(d);
                break;
            case 4:
                $2c02e90631b0fc8a$var$zh();
                break;
            case 13:
                $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$L);
                break;
            case 19:
                $2c02e90631b0fc8a$var$E($2c02e90631b0fc8a$var$L);
                break;
            case 10:
                $2c02e90631b0fc8a$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $2c02e90631b0fc8a$var$Hj();
        }
        c = c.return;
    }
    $2c02e90631b0fc8a$var$Q = a;
    $2c02e90631b0fc8a$var$Y = a = $2c02e90631b0fc8a$var$Pg(a.current, null);
    $2c02e90631b0fc8a$var$Z = $2c02e90631b0fc8a$var$fj = b;
    $2c02e90631b0fc8a$var$T = 0;
    $2c02e90631b0fc8a$var$pk = null;
    $2c02e90631b0fc8a$var$rk = $2c02e90631b0fc8a$var$qk = $2c02e90631b0fc8a$var$rh = 0;
    $2c02e90631b0fc8a$var$tk = $2c02e90631b0fc8a$var$sk = null;
    if (null !== $2c02e90631b0fc8a$var$fh) {
        for(b = 0; b < $2c02e90631b0fc8a$var$fh.length; b++)if (c = $2c02e90631b0fc8a$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $2c02e90631b0fc8a$var$fh = null;
    }
    return a;
}
function $2c02e90631b0fc8a$var$Mk(a, b) {
    do {
        var c = $2c02e90631b0fc8a$var$Y;
        try {
            $2c02e90631b0fc8a$var$$g();
            $2c02e90631b0fc8a$var$Fh.current = $2c02e90631b0fc8a$var$Rh;
            if ($2c02e90631b0fc8a$var$Ih) {
                for(var d = $2c02e90631b0fc8a$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $2c02e90631b0fc8a$var$Ih = !1;
            }
            $2c02e90631b0fc8a$var$Hh = 0;
            $2c02e90631b0fc8a$var$O = $2c02e90631b0fc8a$var$N = $2c02e90631b0fc8a$var$M = null;
            $2c02e90631b0fc8a$var$Jh = !1;
            $2c02e90631b0fc8a$var$Kh = 0;
            $2c02e90631b0fc8a$var$nk.current = null;
            if (null === c || null === c.return) {
                $2c02e90631b0fc8a$var$T = 1;
                $2c02e90631b0fc8a$var$pk = b;
                $2c02e90631b0fc8a$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $2c02e90631b0fc8a$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $2c02e90631b0fc8a$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $2c02e90631b0fc8a$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $2c02e90631b0fc8a$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $2c02e90631b0fc8a$var$Si(f, l, b);
                            $2c02e90631b0fc8a$var$tj();
                            break a;
                        }
                        k = Error($2c02e90631b0fc8a$var$p(426));
                    }
                } else if ($2c02e90631b0fc8a$var$I && h.mode & 1) {
                    var J = $2c02e90631b0fc8a$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $2c02e90631b0fc8a$var$Vi(J, g, h, f, b);
                        $2c02e90631b0fc8a$var$Jg($2c02e90631b0fc8a$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $2c02e90631b0fc8a$var$Ji(k, h);
                4 !== $2c02e90631b0fc8a$var$T && ($2c02e90631b0fc8a$var$T = 2);
                null === $2c02e90631b0fc8a$var$sk ? $2c02e90631b0fc8a$var$sk = [
                    f
                ] : $2c02e90631b0fc8a$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $2c02e90631b0fc8a$var$Ni(f, k, b);
                            $2c02e90631b0fc8a$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $2c02e90631b0fc8a$var$Ri || !$2c02e90631b0fc8a$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $2c02e90631b0fc8a$var$Qi(f, h, b);
                                $2c02e90631b0fc8a$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $2c02e90631b0fc8a$var$Sk(c);
        } catch (na) {
            b = na;
            $2c02e90631b0fc8a$var$Y === c && null !== c && ($2c02e90631b0fc8a$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $2c02e90631b0fc8a$var$Jk() {
    var a = $2c02e90631b0fc8a$var$mk.current;
    $2c02e90631b0fc8a$var$mk.current = $2c02e90631b0fc8a$var$Rh;
    return null === a ? $2c02e90631b0fc8a$var$Rh : a;
}
function $2c02e90631b0fc8a$var$tj() {
    if (0 === $2c02e90631b0fc8a$var$T || 3 === $2c02e90631b0fc8a$var$T || 2 === $2c02e90631b0fc8a$var$T) $2c02e90631b0fc8a$var$T = 4;
    null === $2c02e90631b0fc8a$var$Q || 0 === ($2c02e90631b0fc8a$var$rh & 268435455) && 0 === ($2c02e90631b0fc8a$var$qk & 268435455) || $2c02e90631b0fc8a$var$Ck($2c02e90631b0fc8a$var$Q, $2c02e90631b0fc8a$var$Z);
}
function $2c02e90631b0fc8a$var$Ik(a, b) {
    var c = $2c02e90631b0fc8a$var$K;
    $2c02e90631b0fc8a$var$K |= 2;
    var d = $2c02e90631b0fc8a$var$Jk();
    if ($2c02e90631b0fc8a$var$Q !== a || $2c02e90631b0fc8a$var$Z !== b) $2c02e90631b0fc8a$var$uk = null, $2c02e90631b0fc8a$var$Kk(a, b);
    for(;;)try {
        $2c02e90631b0fc8a$var$Tk();
        break;
    } catch (e) {
        $2c02e90631b0fc8a$var$Mk(a, e);
    }
    $2c02e90631b0fc8a$var$$g();
    $2c02e90631b0fc8a$var$K = c;
    $2c02e90631b0fc8a$var$mk.current = d;
    if (null !== $2c02e90631b0fc8a$var$Y) throw Error($2c02e90631b0fc8a$var$p(261));
    $2c02e90631b0fc8a$var$Q = null;
    $2c02e90631b0fc8a$var$Z = 0;
    return $2c02e90631b0fc8a$var$T;
}
function $2c02e90631b0fc8a$var$Tk() {
    for(; null !== $2c02e90631b0fc8a$var$Y;)$2c02e90631b0fc8a$var$Uk($2c02e90631b0fc8a$var$Y);
}
function $2c02e90631b0fc8a$var$Lk() {
    for(; null !== $2c02e90631b0fc8a$var$Y && !$2c02e90631b0fc8a$var$cc();)$2c02e90631b0fc8a$var$Uk($2c02e90631b0fc8a$var$Y);
}
function $2c02e90631b0fc8a$var$Uk(a) {
    var b = $2c02e90631b0fc8a$var$Vk(a.alternate, a, $2c02e90631b0fc8a$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $2c02e90631b0fc8a$var$Sk(a) : $2c02e90631b0fc8a$var$Y = b;
    $2c02e90631b0fc8a$var$nk.current = null;
}
function $2c02e90631b0fc8a$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $2c02e90631b0fc8a$var$Ej(c, b, $2c02e90631b0fc8a$var$fj), null !== c) {
                $2c02e90631b0fc8a$var$Y = c;
                return;
            }
        } else {
            c = $2c02e90631b0fc8a$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $2c02e90631b0fc8a$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $2c02e90631b0fc8a$var$T = 6;
                $2c02e90631b0fc8a$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $2c02e90631b0fc8a$var$Y = b;
            return;
        }
        $2c02e90631b0fc8a$var$Y = b = a;
    }while (null !== b);
    0 === $2c02e90631b0fc8a$var$T && ($2c02e90631b0fc8a$var$T = 5);
}
function $2c02e90631b0fc8a$var$Pk(a, b, c) {
    var d = $2c02e90631b0fc8a$var$C, e = $2c02e90631b0fc8a$var$ok.transition;
    try {
        $2c02e90631b0fc8a$var$ok.transition = null, $2c02e90631b0fc8a$var$C = 1, $2c02e90631b0fc8a$var$Wk(a, b, c, d);
    } finally{
        $2c02e90631b0fc8a$var$ok.transition = e, $2c02e90631b0fc8a$var$C = d;
    }
    return null;
}
function $2c02e90631b0fc8a$var$Wk(a, b, c, d) {
    do $2c02e90631b0fc8a$var$Hk();
    while (null !== $2c02e90631b0fc8a$var$wk);
    if (0 !== ($2c02e90631b0fc8a$var$K & 6)) throw Error($2c02e90631b0fc8a$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($2c02e90631b0fc8a$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $2c02e90631b0fc8a$var$Bc(a, f);
    a === $2c02e90631b0fc8a$var$Q && ($2c02e90631b0fc8a$var$Y = $2c02e90631b0fc8a$var$Q = null, $2c02e90631b0fc8a$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $2c02e90631b0fc8a$var$vk || ($2c02e90631b0fc8a$var$vk = !0, $2c02e90631b0fc8a$var$Fk($2c02e90631b0fc8a$var$hc, function() {
        $2c02e90631b0fc8a$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $2c02e90631b0fc8a$var$ok.transition;
        $2c02e90631b0fc8a$var$ok.transition = null;
        var g = $2c02e90631b0fc8a$var$C;
        $2c02e90631b0fc8a$var$C = 1;
        var h = $2c02e90631b0fc8a$var$K;
        $2c02e90631b0fc8a$var$K |= 4;
        $2c02e90631b0fc8a$var$nk.current = null;
        $2c02e90631b0fc8a$var$Oj(a, c);
        $2c02e90631b0fc8a$var$dk(c, a);
        $2c02e90631b0fc8a$var$Oe($2c02e90631b0fc8a$var$Df);
        $2c02e90631b0fc8a$var$dd = !!$2c02e90631b0fc8a$var$Cf;
        $2c02e90631b0fc8a$var$Df = $2c02e90631b0fc8a$var$Cf = null;
        a.current = c;
        $2c02e90631b0fc8a$var$hk(c, a, e);
        $2c02e90631b0fc8a$var$dc();
        $2c02e90631b0fc8a$var$K = h;
        $2c02e90631b0fc8a$var$C = g;
        $2c02e90631b0fc8a$var$ok.transition = f;
    } else a.current = c;
    $2c02e90631b0fc8a$var$vk && ($2c02e90631b0fc8a$var$vk = !1, $2c02e90631b0fc8a$var$wk = a, $2c02e90631b0fc8a$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($2c02e90631b0fc8a$var$Ri = null);
    $2c02e90631b0fc8a$var$mc(c.stateNode, d);
    $2c02e90631b0fc8a$var$Dk(a, $2c02e90631b0fc8a$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($2c02e90631b0fc8a$var$Oi) throw $2c02e90631b0fc8a$var$Oi = !1, a = $2c02e90631b0fc8a$var$Pi, $2c02e90631b0fc8a$var$Pi = null, a;
    0 !== ($2c02e90631b0fc8a$var$xk & 1) && 0 !== a.tag && $2c02e90631b0fc8a$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $2c02e90631b0fc8a$var$zk ? $2c02e90631b0fc8a$var$yk++ : ($2c02e90631b0fc8a$var$yk = 0, $2c02e90631b0fc8a$var$zk = a) : $2c02e90631b0fc8a$var$yk = 0;
    $2c02e90631b0fc8a$var$jg();
    return null;
}
function $2c02e90631b0fc8a$var$Hk() {
    if (null !== $2c02e90631b0fc8a$var$wk) {
        var a = $2c02e90631b0fc8a$var$Dc($2c02e90631b0fc8a$var$xk), b = $2c02e90631b0fc8a$var$ok.transition, c = $2c02e90631b0fc8a$var$C;
        try {
            $2c02e90631b0fc8a$var$ok.transition = null;
            $2c02e90631b0fc8a$var$C = 16 > a ? 16 : a;
            if (null === $2c02e90631b0fc8a$var$wk) var d = !1;
            else {
                a = $2c02e90631b0fc8a$var$wk;
                $2c02e90631b0fc8a$var$wk = null;
                $2c02e90631b0fc8a$var$xk = 0;
                if (0 !== ($2c02e90631b0fc8a$var$K & 6)) throw Error($2c02e90631b0fc8a$var$p(331));
                var e = $2c02e90631b0fc8a$var$K;
                $2c02e90631b0fc8a$var$K |= 4;
                for($2c02e90631b0fc8a$var$V = a.current; null !== $2c02e90631b0fc8a$var$V;){
                    var f = $2c02e90631b0fc8a$var$V, g = f.child;
                    if (0 !== ($2c02e90631b0fc8a$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($2c02e90631b0fc8a$var$V = l; null !== $2c02e90631b0fc8a$var$V;){
                                    var m = $2c02e90631b0fc8a$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $2c02e90631b0fc8a$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $2c02e90631b0fc8a$var$V = q;
                                    else for(; null !== $2c02e90631b0fc8a$var$V;){
                                        m = $2c02e90631b0fc8a$var$V;
                                        var r = m.sibling, y = m.return;
                                        $2c02e90631b0fc8a$var$Sj(m);
                                        if (m === l) {
                                            $2c02e90631b0fc8a$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $2c02e90631b0fc8a$var$V = r;
                                            break;
                                        }
                                        $2c02e90631b0fc8a$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $2c02e90631b0fc8a$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $2c02e90631b0fc8a$var$V = g;
                    else b: for(; null !== $2c02e90631b0fc8a$var$V;){
                        f = $2c02e90631b0fc8a$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $2c02e90631b0fc8a$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $2c02e90631b0fc8a$var$V = x;
                            break b;
                        }
                        $2c02e90631b0fc8a$var$V = f.return;
                    }
                }
                var w = a.current;
                for($2c02e90631b0fc8a$var$V = w; null !== $2c02e90631b0fc8a$var$V;){
                    g = $2c02e90631b0fc8a$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $2c02e90631b0fc8a$var$V = u;
                    else b: for(g = w; null !== $2c02e90631b0fc8a$var$V;){
                        h = $2c02e90631b0fc8a$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $2c02e90631b0fc8a$var$Qj(9, h);
                            }
                        } catch (na) {
                            $2c02e90631b0fc8a$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $2c02e90631b0fc8a$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $2c02e90631b0fc8a$var$V = F;
                            break b;
                        }
                        $2c02e90631b0fc8a$var$V = h.return;
                    }
                }
                $2c02e90631b0fc8a$var$K = e;
                $2c02e90631b0fc8a$var$jg();
                if ($2c02e90631b0fc8a$var$lc && "function" === typeof $2c02e90631b0fc8a$var$lc.onPostCommitFiberRoot) try {
                    $2c02e90631b0fc8a$var$lc.onPostCommitFiberRoot($2c02e90631b0fc8a$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $2c02e90631b0fc8a$var$C = c, $2c02e90631b0fc8a$var$ok.transition = b;
        }
    }
    return !1;
}
function $2c02e90631b0fc8a$var$Xk(a, b, c) {
    b = $2c02e90631b0fc8a$var$Ji(c, b);
    b = $2c02e90631b0fc8a$var$Ni(a, b, 1);
    a = $2c02e90631b0fc8a$var$nh(a, b, 1);
    b = $2c02e90631b0fc8a$var$R();
    null !== a && ($2c02e90631b0fc8a$var$Ac(a, 1, b), $2c02e90631b0fc8a$var$Dk(a, b));
}
function $2c02e90631b0fc8a$var$W(a, b, c) {
    if (3 === a.tag) $2c02e90631b0fc8a$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $2c02e90631b0fc8a$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $2c02e90631b0fc8a$var$Ri || !$2c02e90631b0fc8a$var$Ri.has(d))) {
                a = $2c02e90631b0fc8a$var$Ji(c, a);
                a = $2c02e90631b0fc8a$var$Qi(b, a, 1);
                b = $2c02e90631b0fc8a$var$nh(b, a, 1);
                a = $2c02e90631b0fc8a$var$R();
                null !== b && ($2c02e90631b0fc8a$var$Ac(b, 1, a), $2c02e90631b0fc8a$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $2c02e90631b0fc8a$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $2c02e90631b0fc8a$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $2c02e90631b0fc8a$var$Q === a && ($2c02e90631b0fc8a$var$Z & c) === c && (4 === $2c02e90631b0fc8a$var$T || 3 === $2c02e90631b0fc8a$var$T && ($2c02e90631b0fc8a$var$Z & 130023424) === $2c02e90631b0fc8a$var$Z && 500 > $2c02e90631b0fc8a$var$B() - $2c02e90631b0fc8a$var$fk ? $2c02e90631b0fc8a$var$Kk(a, 0) : $2c02e90631b0fc8a$var$rk |= c);
    $2c02e90631b0fc8a$var$Dk(a, b);
}
function $2c02e90631b0fc8a$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $2c02e90631b0fc8a$var$sc, $2c02e90631b0fc8a$var$sc <<= 1, 0 === ($2c02e90631b0fc8a$var$sc & 130023424) && ($2c02e90631b0fc8a$var$sc = 4194304)));
    var c = $2c02e90631b0fc8a$var$R();
    a = $2c02e90631b0fc8a$var$ih(a, b);
    null !== a && ($2c02e90631b0fc8a$var$Ac(a, b, c), $2c02e90631b0fc8a$var$Dk(a, c));
}
function $2c02e90631b0fc8a$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $2c02e90631b0fc8a$var$Yk(a, c);
}
function $2c02e90631b0fc8a$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($2c02e90631b0fc8a$var$p(314));
    }
    null !== d && d.delete(b);
    $2c02e90631b0fc8a$var$Yk(a, c);
}
var $2c02e90631b0fc8a$var$Vk;
$2c02e90631b0fc8a$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $2c02e90631b0fc8a$var$Wf.current) $2c02e90631b0fc8a$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $2c02e90631b0fc8a$var$dh = !1, $2c02e90631b0fc8a$var$yj(a, b, c);
            $2c02e90631b0fc8a$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $2c02e90631b0fc8a$var$dh = !1, $2c02e90631b0fc8a$var$I && 0 !== (b.flags & 1048576) && $2c02e90631b0fc8a$var$ug(b, $2c02e90631b0fc8a$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $2c02e90631b0fc8a$var$ij(a, b);
            a = b.pendingProps;
            var e = $2c02e90631b0fc8a$var$Yf(b, $2c02e90631b0fc8a$var$H.current);
            $2c02e90631b0fc8a$var$ch(b, c);
            e = $2c02e90631b0fc8a$var$Nh(null, b, d, a, e, c);
            var f = $2c02e90631b0fc8a$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $2c02e90631b0fc8a$var$Zf(d) ? (f = !0, $2c02e90631b0fc8a$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $2c02e90631b0fc8a$var$kh(b), e.updater = $2c02e90631b0fc8a$var$Ei, b.stateNode = e, e._reactInternals = b, $2c02e90631b0fc8a$var$Ii(b, d, a, c), b = $2c02e90631b0fc8a$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $2c02e90631b0fc8a$var$I && f && $2c02e90631b0fc8a$var$vg(b), $2c02e90631b0fc8a$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $2c02e90631b0fc8a$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $2c02e90631b0fc8a$var$Zk(d);
                a = $2c02e90631b0fc8a$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $2c02e90631b0fc8a$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $2c02e90631b0fc8a$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $2c02e90631b0fc8a$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $2c02e90631b0fc8a$var$$i(null, b, d, $2c02e90631b0fc8a$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($2c02e90631b0fc8a$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2c02e90631b0fc8a$var$Ci(d, e), $2c02e90631b0fc8a$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2c02e90631b0fc8a$var$Ci(d, e), $2c02e90631b0fc8a$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $2c02e90631b0fc8a$var$kj(b);
                if (null === a) throw Error($2c02e90631b0fc8a$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $2c02e90631b0fc8a$var$lh(a, b);
                $2c02e90631b0fc8a$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $2c02e90631b0fc8a$var$Ji(Error($2c02e90631b0fc8a$var$p(423)), b);
                        b = $2c02e90631b0fc8a$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $2c02e90631b0fc8a$var$Ji(Error($2c02e90631b0fc8a$var$p(424)), b);
                        b = $2c02e90631b0fc8a$var$lj(a, b, d, c, e);
                        break a;
                    } else for($2c02e90631b0fc8a$var$yg = $2c02e90631b0fc8a$var$Lf(b.stateNode.containerInfo.firstChild), $2c02e90631b0fc8a$var$xg = b, $2c02e90631b0fc8a$var$I = !0, $2c02e90631b0fc8a$var$zg = null, c = $2c02e90631b0fc8a$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $2c02e90631b0fc8a$var$Ig();
                    if (d === e) {
                        b = $2c02e90631b0fc8a$var$Zi(a, b, c);
                        break a;
                    }
                    $2c02e90631b0fc8a$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $2c02e90631b0fc8a$var$Ah(b), null === a && $2c02e90631b0fc8a$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $2c02e90631b0fc8a$var$Ef(d, e) ? g = null : null !== f && $2c02e90631b0fc8a$var$Ef(d, f) && (b.flags |= 32), $2c02e90631b0fc8a$var$gj(a, b), $2c02e90631b0fc8a$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $2c02e90631b0fc8a$var$Eg(b), null;
        case 13:
            return $2c02e90631b0fc8a$var$oj(a, b, c);
        case 4:
            return $2c02e90631b0fc8a$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $2c02e90631b0fc8a$var$Ug(b, null, d, c) : $2c02e90631b0fc8a$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2c02e90631b0fc8a$var$Ci(d, e), $2c02e90631b0fc8a$var$Yi(a, b, d, e, c);
        case 7:
            return $2c02e90631b0fc8a$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $2c02e90631b0fc8a$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $2c02e90631b0fc8a$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $2c02e90631b0fc8a$var$G($2c02e90631b0fc8a$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($2c02e90631b0fc8a$var$He(f.value, g)) {
                        if (f.children === e.children && !$2c02e90631b0fc8a$var$Wf.current) {
                            b = $2c02e90631b0fc8a$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $2c02e90631b0fc8a$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $2c02e90631b0fc8a$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($2c02e90631b0fc8a$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $2c02e90631b0fc8a$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $2c02e90631b0fc8a$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $2c02e90631b0fc8a$var$ch(b, c), e = $2c02e90631b0fc8a$var$eh(e), d = d(e), b.flags |= 1, $2c02e90631b0fc8a$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $2c02e90631b0fc8a$var$Ci(d, b.pendingProps), e = $2c02e90631b0fc8a$var$Ci(d.type, e), $2c02e90631b0fc8a$var$$i(a, b, d, e, c);
        case 15:
            return $2c02e90631b0fc8a$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2c02e90631b0fc8a$var$Ci(d, e), $2c02e90631b0fc8a$var$ij(a, b), b.tag = 1, $2c02e90631b0fc8a$var$Zf(d) ? (a = !0, $2c02e90631b0fc8a$var$cg(b)) : a = !1, $2c02e90631b0fc8a$var$ch(b, c), $2c02e90631b0fc8a$var$Gi(b, d, e), $2c02e90631b0fc8a$var$Ii(b, d, e, c), $2c02e90631b0fc8a$var$jj(null, b, d, !0, a, c);
        case 19:
            return $2c02e90631b0fc8a$var$xj(a, b, c);
        case 22:
            return $2c02e90631b0fc8a$var$dj(a, b, c);
    }
    throw Error($2c02e90631b0fc8a$var$p(156, b.tag));
};
function $2c02e90631b0fc8a$var$Fk(a, b) {
    return $2c02e90631b0fc8a$var$ac(a, b);
}
function $2c02e90631b0fc8a$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $2c02e90631b0fc8a$var$Bg(a, b, c, d) {
    return new $2c02e90631b0fc8a$var$$k(a, b, c, d);
}
function $2c02e90631b0fc8a$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $2c02e90631b0fc8a$var$Zk(a) {
    if ("function" === typeof a) return $2c02e90631b0fc8a$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $2c02e90631b0fc8a$var$Da) return 11;
        if (a === $2c02e90631b0fc8a$var$Ga) return 14;
    }
    return 2;
}
function $2c02e90631b0fc8a$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $2c02e90631b0fc8a$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $2c02e90631b0fc8a$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $2c02e90631b0fc8a$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $2c02e90631b0fc8a$var$ya:
            return $2c02e90631b0fc8a$var$Tg(c.children, e, f, b);
        case $2c02e90631b0fc8a$var$za:
            g = 8;
            e |= 8;
            break;
        case $2c02e90631b0fc8a$var$Aa:
            return a = $2c02e90631b0fc8a$var$Bg(12, c, b, e | 2), a.elementType = $2c02e90631b0fc8a$var$Aa, a.lanes = f, a;
        case $2c02e90631b0fc8a$var$Ea:
            return a = $2c02e90631b0fc8a$var$Bg(13, c, b, e), a.elementType = $2c02e90631b0fc8a$var$Ea, a.lanes = f, a;
        case $2c02e90631b0fc8a$var$Fa:
            return a = $2c02e90631b0fc8a$var$Bg(19, c, b, e), a.elementType = $2c02e90631b0fc8a$var$Fa, a.lanes = f, a;
        case $2c02e90631b0fc8a$var$Ia:
            return $2c02e90631b0fc8a$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $2c02e90631b0fc8a$var$Ba:
                    g = 10;
                    break a;
                case $2c02e90631b0fc8a$var$Ca:
                    g = 9;
                    break a;
                case $2c02e90631b0fc8a$var$Da:
                    g = 11;
                    break a;
                case $2c02e90631b0fc8a$var$Ga:
                    g = 14;
                    break a;
                case $2c02e90631b0fc8a$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($2c02e90631b0fc8a$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $2c02e90631b0fc8a$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $2c02e90631b0fc8a$var$Tg(a, b, c, d) {
    a = $2c02e90631b0fc8a$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $2c02e90631b0fc8a$var$pj(a, b, c, d) {
    a = $2c02e90631b0fc8a$var$Bg(22, a, d, b);
    a.elementType = $2c02e90631b0fc8a$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $2c02e90631b0fc8a$var$Qg(a, b, c) {
    a = $2c02e90631b0fc8a$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $2c02e90631b0fc8a$var$Sg(a, b, c) {
    b = $2c02e90631b0fc8a$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $2c02e90631b0fc8a$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $2c02e90631b0fc8a$var$zc(0);
    this.expirationTimes = $2c02e90631b0fc8a$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $2c02e90631b0fc8a$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $2c02e90631b0fc8a$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $2c02e90631b0fc8a$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $2c02e90631b0fc8a$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $2c02e90631b0fc8a$var$kh(f);
    return a;
}
function $2c02e90631b0fc8a$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $2c02e90631b0fc8a$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $2c02e90631b0fc8a$var$dl(a) {
    if (!a) return $2c02e90631b0fc8a$var$Vf;
    a = a._reactInternals;
    a: {
        if ($2c02e90631b0fc8a$var$Vb(a) !== a || 1 !== a.tag) throw Error($2c02e90631b0fc8a$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($2c02e90631b0fc8a$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($2c02e90631b0fc8a$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($2c02e90631b0fc8a$var$Zf(c)) return $2c02e90631b0fc8a$var$bg(a, c, b);
    }
    return b;
}
function $2c02e90631b0fc8a$var$el(a, b, c, d, e, f, g, h, k) {
    a = $2c02e90631b0fc8a$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $2c02e90631b0fc8a$var$dl(null);
    c = a.current;
    d = $2c02e90631b0fc8a$var$R();
    e = $2c02e90631b0fc8a$var$yi(c);
    f = $2c02e90631b0fc8a$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $2c02e90631b0fc8a$var$nh(c, f, e);
    a.current.lanes = e;
    $2c02e90631b0fc8a$var$Ac(a, e, d);
    $2c02e90631b0fc8a$var$Dk(a, d);
    return a;
}
function $2c02e90631b0fc8a$var$fl(a, b, c, d) {
    var e = b.current, f = $2c02e90631b0fc8a$var$R(), g = $2c02e90631b0fc8a$var$yi(e);
    c = $2c02e90631b0fc8a$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $2c02e90631b0fc8a$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $2c02e90631b0fc8a$var$nh(e, b, g);
    null !== a && ($2c02e90631b0fc8a$var$gi(a, e, g, f), $2c02e90631b0fc8a$var$oh(a, e, g));
    return g;
}
function $2c02e90631b0fc8a$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $2c02e90631b0fc8a$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $2c02e90631b0fc8a$var$il(a, b) {
    $2c02e90631b0fc8a$var$hl(a, b);
    (a = a.alternate) && $2c02e90631b0fc8a$var$hl(a, b);
}
function $2c02e90631b0fc8a$var$jl() {
    return null;
}
var $2c02e90631b0fc8a$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $2c02e90631b0fc8a$var$ll(a) {
    this._internalRoot = a;
}
$2c02e90631b0fc8a$var$ml.prototype.render = $2c02e90631b0fc8a$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($2c02e90631b0fc8a$var$p(409));
    $2c02e90631b0fc8a$var$fl(a, b, null, null);
};
$2c02e90631b0fc8a$var$ml.prototype.unmount = $2c02e90631b0fc8a$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $2c02e90631b0fc8a$var$Rk(function() {
            $2c02e90631b0fc8a$var$fl(null, a, null, null);
        });
        b[$2c02e90631b0fc8a$var$uf] = null;
    }
};
function $2c02e90631b0fc8a$var$ml(a) {
    this._internalRoot = a;
}
$2c02e90631b0fc8a$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $2c02e90631b0fc8a$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $2c02e90631b0fc8a$var$Qc.length && 0 !== b && b < $2c02e90631b0fc8a$var$Qc[c].priority; c++);
        $2c02e90631b0fc8a$var$Qc.splice(c, 0, a);
        0 === c && $2c02e90631b0fc8a$var$Vc(a);
    }
};
function $2c02e90631b0fc8a$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $2c02e90631b0fc8a$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $2c02e90631b0fc8a$var$pl() {}
function $2c02e90631b0fc8a$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $2c02e90631b0fc8a$var$gl(g);
                f.call(a);
            };
        }
        var g = $2c02e90631b0fc8a$var$el(b, d, a, 0, null, !1, !1, "", $2c02e90631b0fc8a$var$pl);
        a._reactRootContainer = g;
        a[$2c02e90631b0fc8a$var$uf] = g.current;
        $2c02e90631b0fc8a$var$sf(8 === a.nodeType ? a.parentNode : a);
        $2c02e90631b0fc8a$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $2c02e90631b0fc8a$var$gl(k);
            h.call(a);
        };
    }
    var k = $2c02e90631b0fc8a$var$bl(a, 0, !1, null, null, !1, !1, "", $2c02e90631b0fc8a$var$pl);
    a._reactRootContainer = k;
    a[$2c02e90631b0fc8a$var$uf] = k.current;
    $2c02e90631b0fc8a$var$sf(8 === a.nodeType ? a.parentNode : a);
    $2c02e90631b0fc8a$var$Rk(function() {
        $2c02e90631b0fc8a$var$fl(b, k, c, d);
    });
    return k;
}
function $2c02e90631b0fc8a$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $2c02e90631b0fc8a$var$gl(g);
                h.call(a);
            };
        }
        $2c02e90631b0fc8a$var$fl(b, g, a, e);
    } else g = $2c02e90631b0fc8a$var$ql(c, b, a, e, d);
    return $2c02e90631b0fc8a$var$gl(g);
}
$2c02e90631b0fc8a$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $2c02e90631b0fc8a$var$tc(b.pendingLanes);
                0 !== c && ($2c02e90631b0fc8a$var$Cc(b, c | 1), $2c02e90631b0fc8a$var$Dk(b, $2c02e90631b0fc8a$var$B()), 0 === ($2c02e90631b0fc8a$var$K & 6) && ($2c02e90631b0fc8a$var$Gj = $2c02e90631b0fc8a$var$B() + 500, $2c02e90631b0fc8a$var$jg()));
            }
            break;
        case 13:
            $2c02e90631b0fc8a$var$Rk(function() {
                var b = $2c02e90631b0fc8a$var$ih(a, 1);
                if (null !== b) {
                    var c = $2c02e90631b0fc8a$var$R();
                    $2c02e90631b0fc8a$var$gi(b, a, 1, c);
                }
            }), $2c02e90631b0fc8a$var$il(a, 1);
    }
};
$2c02e90631b0fc8a$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $2c02e90631b0fc8a$var$ih(a, 134217728);
        if (null !== b) {
            var c = $2c02e90631b0fc8a$var$R();
            $2c02e90631b0fc8a$var$gi(b, a, 134217728, c);
        }
        $2c02e90631b0fc8a$var$il(a, 134217728);
    }
};
$2c02e90631b0fc8a$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $2c02e90631b0fc8a$var$yi(a), c = $2c02e90631b0fc8a$var$ih(a, b);
        if (null !== c) {
            var d = $2c02e90631b0fc8a$var$R();
            $2c02e90631b0fc8a$var$gi(c, a, b, d);
        }
        $2c02e90631b0fc8a$var$il(a, b);
    }
};
$2c02e90631b0fc8a$var$Hc = function() {
    return $2c02e90631b0fc8a$var$C;
};
$2c02e90631b0fc8a$var$Ic = function(a, b) {
    var c = $2c02e90631b0fc8a$var$C;
    try {
        return $2c02e90631b0fc8a$var$C = a, b();
    } finally{
        $2c02e90631b0fc8a$var$C = c;
    }
};
$2c02e90631b0fc8a$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $2c02e90631b0fc8a$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $2c02e90631b0fc8a$var$Db(d);
                        if (!e) throw Error($2c02e90631b0fc8a$var$p(90));
                        $2c02e90631b0fc8a$var$Wa(d);
                        $2c02e90631b0fc8a$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $2c02e90631b0fc8a$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $2c02e90631b0fc8a$var$fb(a, !!c.multiple, b, !1);
    }
};
$2c02e90631b0fc8a$var$Gb = $2c02e90631b0fc8a$var$Qk;
$2c02e90631b0fc8a$var$Hb = $2c02e90631b0fc8a$var$Rk;
var $2c02e90631b0fc8a$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $2c02e90631b0fc8a$var$Cb,
        $2c02e90631b0fc8a$var$ue,
        $2c02e90631b0fc8a$var$Db,
        $2c02e90631b0fc8a$var$Eb,
        $2c02e90631b0fc8a$var$Fb,
        $2c02e90631b0fc8a$var$Qk
    ]
}, $2c02e90631b0fc8a$var$tl = {
    findFiberByHostInstance: $2c02e90631b0fc8a$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $2c02e90631b0fc8a$var$ul = {
    bundleType: $2c02e90631b0fc8a$var$tl.bundleType,
    version: $2c02e90631b0fc8a$var$tl.version,
    rendererPackageName: $2c02e90631b0fc8a$var$tl.rendererPackageName,
    rendererConfig: $2c02e90631b0fc8a$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $2c02e90631b0fc8a$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $2c02e90631b0fc8a$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $2c02e90631b0fc8a$var$tl.findFiberByHostInstance || $2c02e90631b0fc8a$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $2c02e90631b0fc8a$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$2c02e90631b0fc8a$var$vl.isDisabled && $2c02e90631b0fc8a$var$vl.supportsFiber) try {
        $2c02e90631b0fc8a$var$kc = $2c02e90631b0fc8a$var$vl.inject($2c02e90631b0fc8a$var$ul), $2c02e90631b0fc8a$var$lc = $2c02e90631b0fc8a$var$vl;
    } catch (a) {}
}
$2c02e90631b0fc8a$export$ae55be85d98224ed = $2c02e90631b0fc8a$var$sl;
$2c02e90631b0fc8a$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$2c02e90631b0fc8a$var$nl(b)) throw Error($2c02e90631b0fc8a$var$p(200));
    return $2c02e90631b0fc8a$var$cl(a, b, null, c);
};
$2c02e90631b0fc8a$export$882461b6382ed46c = function(a, b) {
    if (!$2c02e90631b0fc8a$var$nl(a)) throw Error($2c02e90631b0fc8a$var$p(299));
    var c = !1, d = "", e = $2c02e90631b0fc8a$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $2c02e90631b0fc8a$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$2c02e90631b0fc8a$var$uf] = b.current;
    $2c02e90631b0fc8a$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $2c02e90631b0fc8a$var$ll(b);
};
$2c02e90631b0fc8a$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($2c02e90631b0fc8a$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($2c02e90631b0fc8a$var$p(268, a));
    }
    a = $2c02e90631b0fc8a$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$2c02e90631b0fc8a$export$cd75ccfd720a3cd4 = function(a) {
    return $2c02e90631b0fc8a$var$Rk(a);
};
$2c02e90631b0fc8a$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$2c02e90631b0fc8a$var$ol(b)) throw Error($2c02e90631b0fc8a$var$p(200));
    return $2c02e90631b0fc8a$var$rl(null, a, b, !0, c);
};
$2c02e90631b0fc8a$export$757ceba2d55c277e = function(a, b, c) {
    if (!$2c02e90631b0fc8a$var$nl(a)) throw Error($2c02e90631b0fc8a$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $2c02e90631b0fc8a$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $2c02e90631b0fc8a$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$2c02e90631b0fc8a$var$uf] = b.current;
    $2c02e90631b0fc8a$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $2c02e90631b0fc8a$var$ml(b);
};
$2c02e90631b0fc8a$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$2c02e90631b0fc8a$var$ol(b)) throw Error($2c02e90631b0fc8a$var$p(200));
    return $2c02e90631b0fc8a$var$rl(null, a, b, !1, c);
};
$2c02e90631b0fc8a$export$502457920280e6be = function(a) {
    if (!$2c02e90631b0fc8a$var$ol(a)) throw Error($2c02e90631b0fc8a$var$p(40));
    return a._reactRootContainer ? ($2c02e90631b0fc8a$var$Rk(function() {
        $2c02e90631b0fc8a$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$2c02e90631b0fc8a$var$uf] = null;
        });
    }), !0) : !1;
};
$2c02e90631b0fc8a$export$c78a37762a8d58e1 = $2c02e90631b0fc8a$var$Qk;
$2c02e90631b0fc8a$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$2c02e90631b0fc8a$var$ol(c)) throw Error($2c02e90631b0fc8a$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($2c02e90631b0fc8a$var$p(38));
    return $2c02e90631b0fc8a$var$rl(a, b, c, !1, d);
};
$2c02e90631b0fc8a$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("heSjF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lSXQo"));

});
parcelRegister("lSXQo", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $feed0fe2fad907b3$export$c4744153514ff05d, (v) => $feed0fe2fad907b3$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $feed0fe2fad907b3$export$3e506c1ccc9cc1a7, (v) => $feed0fe2fad907b3$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $feed0fe2fad907b3$export$e26fe2ed2fa76875, (v) => $feed0fe2fad907b3$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $feed0fe2fad907b3$export$502329bbf4b505b1, (v) => $feed0fe2fad907b3$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $feed0fe2fad907b3$export$6e3807111c4874c4, (v) => $feed0fe2fad907b3$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $feed0fe2fad907b3$export$c27134553091fb3a, (v) => $feed0fe2fad907b3$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $feed0fe2fad907b3$export$33ee1acdc04fd2a2, (v) => $feed0fe2fad907b3$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $feed0fe2fad907b3$export$b00a404bbd5edef2, (v) => $feed0fe2fad907b3$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $feed0fe2fad907b3$export$8352ce38b91d0c62, (v) => $feed0fe2fad907b3$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $feed0fe2fad907b3$export$d66a1c1c77bd778b, (v) => $feed0fe2fad907b3$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $feed0fe2fad907b3$export$d3dfb8e4810cb555, (v) => $feed0fe2fad907b3$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $feed0fe2fad907b3$export$839f9183b0465a69, (v) => $feed0fe2fad907b3$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $feed0fe2fad907b3$export$72fdf0e06517287b, (v) => $feed0fe2fad907b3$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $feed0fe2fad907b3$export$4b844e58a3e414b4, (v) => $feed0fe2fad907b3$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $feed0fe2fad907b3$export$816d2913ae6b83b1, (v) => $feed0fe2fad907b3$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $feed0fe2fad907b3$export$61bcfe829111a1d0, (v) => $feed0fe2fad907b3$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $feed0fe2fad907b3$export$7ee8c9beb337bc3f, (v) => $feed0fe2fad907b3$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $feed0fe2fad907b3$export$b5836b71941fa3ed, (v) => $feed0fe2fad907b3$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $feed0fe2fad907b3$export$cf845f2c119da08a, (v) => $feed0fe2fad907b3$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $feed0fe2fad907b3$export$c4744153514ff05d;
var $feed0fe2fad907b3$export$3e506c1ccc9cc1a7;
var $feed0fe2fad907b3$export$e26fe2ed2fa76875;
var $feed0fe2fad907b3$export$502329bbf4b505b1;
var $feed0fe2fad907b3$export$6e3807111c4874c4;
var $feed0fe2fad907b3$export$c27134553091fb3a;
var $feed0fe2fad907b3$export$33ee1acdc04fd2a2;
var $feed0fe2fad907b3$export$b00a404bbd5edef2;
var $feed0fe2fad907b3$export$8352ce38b91d0c62;
var $feed0fe2fad907b3$export$d66a1c1c77bd778b;
var $feed0fe2fad907b3$export$d3dfb8e4810cb555;
var $feed0fe2fad907b3$export$839f9183b0465a69;
var $feed0fe2fad907b3$export$72fdf0e06517287b;
var $feed0fe2fad907b3$export$4b844e58a3e414b4;
var $feed0fe2fad907b3$export$816d2913ae6b83b1;
var $feed0fe2fad907b3$export$61bcfe829111a1d0;
var $feed0fe2fad907b3$export$7ee8c9beb337bc3f;
var $feed0fe2fad907b3$export$b5836b71941fa3ed;
var $feed0fe2fad907b3$export$cf845f2c119da08a;
'use strict';
function $feed0fe2fad907b3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $feed0fe2fad907b3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $feed0fe2fad907b3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $feed0fe2fad907b3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $feed0fe2fad907b3$var$g(C, c)) n < e && 0 > $feed0fe2fad907b3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $feed0fe2fad907b3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $feed0fe2fad907b3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $feed0fe2fad907b3$var$l = performance;
    $feed0fe2fad907b3$export$c4744153514ff05d = function() {
        return $feed0fe2fad907b3$var$l.now();
    };
} else {
    var $feed0fe2fad907b3$var$p = Date, $feed0fe2fad907b3$var$q = $feed0fe2fad907b3$var$p.now();
    $feed0fe2fad907b3$export$c4744153514ff05d = function() {
        return $feed0fe2fad907b3$var$p.now() - $feed0fe2fad907b3$var$q;
    };
}
var $feed0fe2fad907b3$var$r = [], $feed0fe2fad907b3$var$t = [], $feed0fe2fad907b3$var$u = 1, $feed0fe2fad907b3$var$v = null, $feed0fe2fad907b3$var$y = 3, $feed0fe2fad907b3$var$z = !1, $feed0fe2fad907b3$var$A = !1, $feed0fe2fad907b3$var$B = !1, $feed0fe2fad907b3$var$D = "function" === typeof setTimeout ? setTimeout : null, $feed0fe2fad907b3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $feed0fe2fad907b3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $feed0fe2fad907b3$var$G(a) {
    for(var b = $feed0fe2fad907b3$var$h($feed0fe2fad907b3$var$t); null !== b;){
        if (null === b.callback) $feed0fe2fad907b3$var$k($feed0fe2fad907b3$var$t);
        else if (b.startTime <= a) $feed0fe2fad907b3$var$k($feed0fe2fad907b3$var$t), b.sortIndex = b.expirationTime, $feed0fe2fad907b3$var$f($feed0fe2fad907b3$var$r, b);
        else break;
        b = $feed0fe2fad907b3$var$h($feed0fe2fad907b3$var$t);
    }
}
function $feed0fe2fad907b3$var$H(a) {
    $feed0fe2fad907b3$var$B = !1;
    $feed0fe2fad907b3$var$G(a);
    if (!$feed0fe2fad907b3$var$A) {
        if (null !== $feed0fe2fad907b3$var$h($feed0fe2fad907b3$var$r)) $feed0fe2fad907b3$var$A = !0, $feed0fe2fad907b3$var$I($feed0fe2fad907b3$var$J);
        else {
            var b = $feed0fe2fad907b3$var$h($feed0fe2fad907b3$var$t);
            null !== b && $feed0fe2fad907b3$var$K($feed0fe2fad907b3$var$H, b.startTime - a);
        }
    }
}
function $feed0fe2fad907b3$var$J(a, b) {
    $feed0fe2fad907b3$var$A = !1;
    $feed0fe2fad907b3$var$B && ($feed0fe2fad907b3$var$B = !1, $feed0fe2fad907b3$var$E($feed0fe2fad907b3$var$L), $feed0fe2fad907b3$var$L = -1);
    $feed0fe2fad907b3$var$z = !0;
    var c = $feed0fe2fad907b3$var$y;
    try {
        $feed0fe2fad907b3$var$G(b);
        for($feed0fe2fad907b3$var$v = $feed0fe2fad907b3$var$h($feed0fe2fad907b3$var$r); null !== $feed0fe2fad907b3$var$v && (!($feed0fe2fad907b3$var$v.expirationTime > b) || a && !$feed0fe2fad907b3$var$M());){
            var d = $feed0fe2fad907b3$var$v.callback;
            if ("function" === typeof d) {
                $feed0fe2fad907b3$var$v.callback = null;
                $feed0fe2fad907b3$var$y = $feed0fe2fad907b3$var$v.priorityLevel;
                var e = d($feed0fe2fad907b3$var$v.expirationTime <= b);
                b = $feed0fe2fad907b3$export$c4744153514ff05d();
                "function" === typeof e ? $feed0fe2fad907b3$var$v.callback = e : $feed0fe2fad907b3$var$v === $feed0fe2fad907b3$var$h($feed0fe2fad907b3$var$r) && $feed0fe2fad907b3$var$k($feed0fe2fad907b3$var$r);
                $feed0fe2fad907b3$var$G(b);
            } else $feed0fe2fad907b3$var$k($feed0fe2fad907b3$var$r);
            $feed0fe2fad907b3$var$v = $feed0fe2fad907b3$var$h($feed0fe2fad907b3$var$r);
        }
        if (null !== $feed0fe2fad907b3$var$v) var w = !0;
        else {
            var m = $feed0fe2fad907b3$var$h($feed0fe2fad907b3$var$t);
            null !== m && $feed0fe2fad907b3$var$K($feed0fe2fad907b3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $feed0fe2fad907b3$var$v = null, $feed0fe2fad907b3$var$y = c, $feed0fe2fad907b3$var$z = !1;
    }
}
var $feed0fe2fad907b3$var$N = !1, $feed0fe2fad907b3$var$O = null, $feed0fe2fad907b3$var$L = -1, $feed0fe2fad907b3$var$P = 5, $feed0fe2fad907b3$var$Q = -1;
function $feed0fe2fad907b3$var$M() {
    return $feed0fe2fad907b3$export$c4744153514ff05d() - $feed0fe2fad907b3$var$Q < $feed0fe2fad907b3$var$P ? !1 : !0;
}
function $feed0fe2fad907b3$var$R() {
    if (null !== $feed0fe2fad907b3$var$O) {
        var a = $feed0fe2fad907b3$export$c4744153514ff05d();
        $feed0fe2fad907b3$var$Q = a;
        var b = !0;
        try {
            b = $feed0fe2fad907b3$var$O(!0, a);
        } finally{
            b ? $feed0fe2fad907b3$var$S() : ($feed0fe2fad907b3$var$N = !1, $feed0fe2fad907b3$var$O = null);
        }
    } else $feed0fe2fad907b3$var$N = !1;
}
var $feed0fe2fad907b3$var$S;
if ("function" === typeof $feed0fe2fad907b3$var$F) $feed0fe2fad907b3$var$S = function() {
    $feed0fe2fad907b3$var$F($feed0fe2fad907b3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $feed0fe2fad907b3$var$T = new MessageChannel, $feed0fe2fad907b3$var$U = $feed0fe2fad907b3$var$T.port2;
    $feed0fe2fad907b3$var$T.port1.onmessage = $feed0fe2fad907b3$var$R;
    $feed0fe2fad907b3$var$S = function() {
        $feed0fe2fad907b3$var$U.postMessage(null);
    };
} else $feed0fe2fad907b3$var$S = function() {
    $feed0fe2fad907b3$var$D($feed0fe2fad907b3$var$R, 0);
};
function $feed0fe2fad907b3$var$I(a) {
    $feed0fe2fad907b3$var$O = a;
    $feed0fe2fad907b3$var$N || ($feed0fe2fad907b3$var$N = !0, $feed0fe2fad907b3$var$S());
}
function $feed0fe2fad907b3$var$K(a, b) {
    $feed0fe2fad907b3$var$L = $feed0fe2fad907b3$var$D(function() {
        a($feed0fe2fad907b3$export$c4744153514ff05d());
    }, b);
}
$feed0fe2fad907b3$export$3e506c1ccc9cc1a7 = 5;
$feed0fe2fad907b3$export$e26fe2ed2fa76875 = 1;
$feed0fe2fad907b3$export$502329bbf4b505b1 = 4;
$feed0fe2fad907b3$export$6e3807111c4874c4 = 3;
$feed0fe2fad907b3$export$c27134553091fb3a = null;
$feed0fe2fad907b3$export$33ee1acdc04fd2a2 = 2;
$feed0fe2fad907b3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$feed0fe2fad907b3$export$8352ce38b91d0c62 = function() {
    $feed0fe2fad907b3$var$A || $feed0fe2fad907b3$var$z || ($feed0fe2fad907b3$var$A = !0, $feed0fe2fad907b3$var$I($feed0fe2fad907b3$var$J));
};
$feed0fe2fad907b3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $feed0fe2fad907b3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$feed0fe2fad907b3$export$d3dfb8e4810cb555 = function() {
    return $feed0fe2fad907b3$var$y;
};
$feed0fe2fad907b3$export$839f9183b0465a69 = function() {
    return $feed0fe2fad907b3$var$h($feed0fe2fad907b3$var$r);
};
$feed0fe2fad907b3$export$72fdf0e06517287b = function(a) {
    switch($feed0fe2fad907b3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $feed0fe2fad907b3$var$y;
    }
    var c = $feed0fe2fad907b3$var$y;
    $feed0fe2fad907b3$var$y = b;
    try {
        return a();
    } finally{
        $feed0fe2fad907b3$var$y = c;
    }
};
$feed0fe2fad907b3$export$4b844e58a3e414b4 = function() {};
$feed0fe2fad907b3$export$816d2913ae6b83b1 = function() {};
$feed0fe2fad907b3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $feed0fe2fad907b3$var$y;
    $feed0fe2fad907b3$var$y = a;
    try {
        return b();
    } finally{
        $feed0fe2fad907b3$var$y = c;
    }
};
$feed0fe2fad907b3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $feed0fe2fad907b3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $feed0fe2fad907b3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $feed0fe2fad907b3$var$f($feed0fe2fad907b3$var$t, a), null === $feed0fe2fad907b3$var$h($feed0fe2fad907b3$var$r) && a === $feed0fe2fad907b3$var$h($feed0fe2fad907b3$var$t) && ($feed0fe2fad907b3$var$B ? ($feed0fe2fad907b3$var$E($feed0fe2fad907b3$var$L), $feed0fe2fad907b3$var$L = -1) : $feed0fe2fad907b3$var$B = !0, $feed0fe2fad907b3$var$K($feed0fe2fad907b3$var$H, c - d))) : (a.sortIndex = e, $feed0fe2fad907b3$var$f($feed0fe2fad907b3$var$r, a), $feed0fe2fad907b3$var$A || $feed0fe2fad907b3$var$z || ($feed0fe2fad907b3$var$A = !0, $feed0fe2fad907b3$var$I($feed0fe2fad907b3$var$J)));
    return a;
};
$feed0fe2fad907b3$export$b5836b71941fa3ed = $feed0fe2fad907b3$var$M;
$feed0fe2fad907b3$export$cf845f2c119da08a = function(a) {
    var b = $feed0fe2fad907b3$var$y;
    return function() {
        var c = $feed0fe2fad907b3$var$y;
        $feed0fe2fad907b3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $feed0fe2fad907b3$var$y = c;
        }
    };
};

});



parcelRegister("43V45", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ip5if.default;
    }
});

var $ip5if = parcelRequire("ip5if");

});
parcelRegister("ip5if", function(module, exports) {

$parcel$export(module.exports, "default", () => $d65eaaf020815f0f$export$2e2bcd8739ae039);

var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");

var $8GcPv = parcelRequire("8GcPv");

var $e9nev = parcelRequire("e9nev");
'use client';
function $d65eaaf020815f0f$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $e9nev.jsx)((0, $8GcPv.default), (0, $7Nobb.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $8GcPv.default).muiName;
    return /*#__PURE__*/ $eeyUA.memo(/*#__PURE__*/ $eeyUA.forwardRef(Component));
}

});
parcelRegister("7Nobb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5acfdd8d5e83c648$export$2e2bcd8739ae039);
function $5acfdd8d5e83c648$export$2e2bcd8739ae039() {
    return $5acfdd8d5e83c648$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5acfdd8d5e83c648$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("8GcPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $651c32b08a6a5c8f$export$2e2bcd8739ae039);

var $7Nobb = parcelRequire("7Nobb");

var $8T8Yq = parcelRequire("8T8Yq");

var $eeyUA = parcelRequire("eeyUA");


var $2e7Qq = parcelRequire("2e7Qq");

var $bW94t = parcelRequire("bW94t");

var $i6gkh = parcelRequire("i6gkh");

var $5TnQM = parcelRequire("5TnQM");

var $fRobA = parcelRequire("fRobA");

var $cHMPl = parcelRequire("cHMPl");

var $e9nev = parcelRequire("e9nev");
'use client';
const $651c32b08a6a5c8f$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $651c32b08a6a5c8f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $i6gkh.default)(color)}`,
            `fontSize${(0, $i6gkh.default)(fontSize)}`
        ]
    };
    return (0, $bW94t.default)(slots, (0, $cHMPl.getSvgIconUtilityClass), classes);
};
const $651c32b08a6a5c8f$var$SvgIconRoot = (0, $fRobA.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $i6gkh.default)(ownerState.color)}`],
            styles[`fontSize${(0, $i6gkh.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $651c32b08a6a5c8f$var$SvgIcon = /*#__PURE__*/ $eeyUA.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $5TnQM.default)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $8T8Yq.default)(props, $651c32b08a6a5c8f$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $eeyUA.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $7Nobb.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $651c32b08a6a5c8f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $e9nev.jsxs)($651c32b08a6a5c8f$var$SvgIconRoot, (0, $7Nobb.default)({
        as: component,
        className: (0, $2e7Qq.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $e9nev.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$651c32b08a6a5c8f$var$SvgIcon.muiName = 'SvgIcon';
var $651c32b08a6a5c8f$export$2e2bcd8739ae039 = $651c32b08a6a5c8f$var$SvgIcon;

});
parcelRegister("8T8Yq", function(module, exports) {

$parcel$export(module.exports, "default", () => $678a6bc30d6d2d82$export$2e2bcd8739ae039);
function $678a6bc30d6d2d82$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("2e7Qq", function(module, exports) {

$parcel$export(module.exports, "clsx", () => $ba4c9e44a6540bc1$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $ba4c9e44a6540bc1$export$2e2bcd8739ae039);
function $ba4c9e44a6540bc1$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ba4c9e44a6540bc1$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ba4c9e44a6540bc1$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ba4c9e44a6540bc1$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ba4c9e44a6540bc1$export$2e2bcd8739ae039 = $ba4c9e44a6540bc1$export$4f5d2d50c9deca37;

});

parcelRegister("bW94t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b0c25d84fea91cd$export$2e2bcd8739ae039);
function $8b0c25d84fea91cd$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("i6gkh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d5739167d6e5f3$export$2e2bcd8739ae039);

var $3wBkp = parcelRequire("3wBkp");
var $d2d5739167d6e5f3$export$2e2bcd8739ae039 = (0, $3wBkp.default);

});
parcelRegister("3wBkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $291150e04632c18c$export$2e2bcd8739ae039);

var $l4W6n = parcelRequire("l4W6n");
function $291150e04632c18c$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $l4W6n.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("l4W6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5870a864c221100$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $f5870a864c221100$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});



parcelRegister("5TnQM", function(module, exports) {

$parcel$export(module.exports, "default", () => $44a496f85b86897d$export$2e2bcd8739ae039);

var $7UH3u = parcelRequire("7UH3u");

var $fQUvq = parcelRequire("fQUvq");

var $jLld0 = parcelRequire("jLld0");
'use client';
function $44a496f85b86897d$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $7UH3u.default)({
        props: props,
        name: name,
        defaultTheme: $fQUvq.default,
        themeId: (0, $jLld0.default)
    });
}

});
parcelRegister("7UH3u", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c2f293a805d3f98$export$2e2bcd8739ae039);

var $5nSjx = parcelRequire("5nSjx");

var $8O0Iu = parcelRequire("8O0Iu");
'use client';
function $5c2f293a805d3f98$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $8O0Iu.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $5nSjx.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("5nSjx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb93b63a011eada$export$2e2bcd8739ae039);

var $aNPRO = parcelRequire("aNPRO");
function $3eb93b63a011eada$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $aNPRO.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("aNPRO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dd6b6acf7b74e98$export$2e2bcd8739ae039);

var $7Nobb = parcelRequire("7Nobb");
function $7dd6b6acf7b74e98$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $7Nobb.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $7Nobb.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $7Nobb.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $7dd6b6acf7b74e98$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("8O0Iu", function(module, exports) {

$parcel$export(module.exports, "default", () => $66938c8ac6f920f4$export$2e2bcd8739ae039);

var $kBzHD = parcelRequire("kBzHD");

var $zqgc6 = parcelRequire("zqgc6");
'use client';
const $66938c8ac6f920f4$export$35e57303dbd8a66 = (0, $kBzHD.default)();
function $66938c8ac6f920f4$var$useTheme(defaultTheme = $66938c8ac6f920f4$export$35e57303dbd8a66) {
    return (0, $zqgc6.default)(defaultTheme);
}
var $66938c8ac6f920f4$export$2e2bcd8739ae039 = $66938c8ac6f920f4$var$useTheme;

});
parcelRegister("kBzHD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f002f5304647997f$export$2e2bcd8739ae039);

var $7Nobb = parcelRequire("7Nobb");

var $8T8Yq = parcelRequire("8T8Yq");

var $f41I8 = parcelRequire("f41I8");

var $3fllQ = parcelRequire("3fllQ");

var $ik085 = parcelRequire("ik085");

var $4XYFl = parcelRequire("4XYFl");

var $aF1tN = parcelRequire("aF1tN");

var $euq5j = parcelRequire("euq5j");

var $i16H0 = parcelRequire("i16H0");
const $f002f5304647997f$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $f002f5304647997f$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $8T8Yq.default)(options, $f002f5304647997f$var$_excluded);
    const breakpoints = (0, $3fllQ.default)(breakpointsInput);
    const spacing = (0, $4XYFl.default)(spacingInput);
    let muiTheme = (0, $f41I8.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $7Nobb.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $7Nobb.default)({}, (0, $ik085.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $i16H0.default);
    muiTheme = args.reduce((acc, argument)=>(0, $f41I8.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $7Nobb.default)({}, (0, $euq5j.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $aF1tN.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $f002f5304647997f$export$2e2bcd8739ae039 = $f002f5304647997f$var$createTheme;

});
parcelRegister("f41I8", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $af788e7f6e1eeb8f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $af788e7f6e1eeb8f$export$2e2bcd8739ae039);

var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
function $af788e7f6e1eeb8f$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $af788e7f6e1eeb8f$var$deepClone(source) {
    if (/*#__PURE__*/ $eeyUA.isValidElement(source) || !$af788e7f6e1eeb8f$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $af788e7f6e1eeb8f$var$deepClone(source[key]);
    });
    return output;
}
function $af788e7f6e1eeb8f$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $7Nobb.default)({}, target) : target;
    if ($af788e7f6e1eeb8f$export$53b83ca8eaab0383(target) && $af788e7f6e1eeb8f$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $eeyUA.isValidElement(source[key])) output[key] = source[key];
        else if ($af788e7f6e1eeb8f$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $af788e7f6e1eeb8f$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $af788e7f6e1eeb8f$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $af788e7f6e1eeb8f$export$53b83ca8eaab0383(source[key]) ? $af788e7f6e1eeb8f$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("3fllQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $25d355bbd2b4cd79$export$2e2bcd8739ae039);

var $8T8Yq = parcelRequire("8T8Yq");

var $7Nobb = parcelRequire("7Nobb");
const $25d355bbd2b4cd79$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $25d355bbd2b4cd79$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $25d355bbd2b4cd79$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $7Nobb.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $25d355bbd2b4cd79$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $8T8Yq.default)(breakpoints, $25d355bbd2b4cd79$var$_excluded);
    const sortedValues = $25d355bbd2b4cd79$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $7Nobb.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("ik085", function(module, exports) {

$parcel$export(module.exports, "default", () => $d56a31f234829792$export$2e2bcd8739ae039);
const $d56a31f234829792$var$shape = {
    borderRadius: 4
};
var $d56a31f234829792$export$2e2bcd8739ae039 = $d56a31f234829792$var$shape;

});

parcelRegister("4XYFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $39dbbb0ffcb3d2d1$export$2e2bcd8739ae039);

var $bhdQC = parcelRequire("bhdQC");
function $39dbbb0ffcb3d2d1$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $bhdQC.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("bhdQC", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $835c061e028b0d8b$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $835c061e028b0d8b$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $835c061e028b0d8b$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $835c061e028b0d8b$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $835c061e028b0d8b$export$6f98e8eaf0be1996);


var $bQVdy = parcelRequire("bQVdy");

var $aghI8 = parcelRequire("aghI8");

var $eHfx1 = parcelRequire("eHfx1");

var $hGdXH = parcelRequire("hGdXH");
const $835c061e028b0d8b$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $835c061e028b0d8b$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $835c061e028b0d8b$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $835c061e028b0d8b$var$getCssProperties = (0, $hGdXH.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($835c061e028b0d8b$var$aliases[prop]) prop = $835c061e028b0d8b$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $835c061e028b0d8b$var$properties[a];
    const direction = $835c061e028b0d8b$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $835c061e028b0d8b$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $835c061e028b0d8b$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $835c061e028b0d8b$var$spacingKeys = [
    ...$835c061e028b0d8b$export$aab52a0dde05ad8a,
    ...$835c061e028b0d8b$export$f8397d44f03ab6ad
];
function $835c061e028b0d8b$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $aghI8.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $835c061e028b0d8b$export$1def6f833384e3d1(theme) {
    return $835c061e028b0d8b$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $835c061e028b0d8b$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $835c061e028b0d8b$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $835c061e028b0d8b$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $835c061e028b0d8b$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $835c061e028b0d8b$var$getCssProperties(prop);
    const styleFromPropValue = $835c061e028b0d8b$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $bQVdy.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $835c061e028b0d8b$var$style(props, keys) {
    const transformer = $835c061e028b0d8b$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$835c061e028b0d8b$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $eHfx1.default), {});
}
function $835c061e028b0d8b$export$7ede87f9b603dd3c(props) {
    return $835c061e028b0d8b$var$style(props, $835c061e028b0d8b$export$aab52a0dde05ad8a);
}
$835c061e028b0d8b$export$7ede87f9b603dd3c.propTypes = {};
$835c061e028b0d8b$export$7ede87f9b603dd3c.filterProps = $835c061e028b0d8b$export$aab52a0dde05ad8a;
function $835c061e028b0d8b$export$6f98e8eaf0be1996(props) {
    return $835c061e028b0d8b$var$style(props, $835c061e028b0d8b$export$f8397d44f03ab6ad);
}
$835c061e028b0d8b$export$6f98e8eaf0be1996.propTypes = {};
$835c061e028b0d8b$export$6f98e8eaf0be1996.filterProps = $835c061e028b0d8b$export$f8397d44f03ab6ad;
function $835c061e028b0d8b$var$spacing(props) {
    return $835c061e028b0d8b$var$style(props, $835c061e028b0d8b$var$spacingKeys);
}
$835c061e028b0d8b$var$spacing.propTypes = {};
$835c061e028b0d8b$var$spacing.filterProps = $835c061e028b0d8b$var$spacingKeys;
var $835c061e028b0d8b$export$2e2bcd8739ae039 = $835c061e028b0d8b$var$spacing;

});
parcelRegister("bQVdy", function(module, exports) {

$parcel$export(module.exports, "values", () => $8a10ef4618108420$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $8a10ef4618108420$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $8a10ef4618108420$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $8a10ef4618108420$export$8922c90b6e020726);

var $7Nobb = parcelRequire("7Nobb");


var $f41I8 = parcelRequire("f41I8");

var $eHfx1 = parcelRequire("eHfx1");
const $8a10ef4618108420$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $8a10ef4618108420$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$8a10ef4618108420$export$68c286be0e7e55b7[key]}px)`
};
function $8a10ef4618108420$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $8a10ef4618108420$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $8a10ef4618108420$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $8a10ef4618108420$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $8a10ef4618108420$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $8a10ef4618108420$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $7Nobb.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $eHfx1.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $8a10ef4618108420$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $8a10ef4618108420$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $8a10ef4618108420$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $8a10ef4618108420$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $f41I8.default)(prev, next), {});
    return $8a10ef4618108420$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $8a10ef4618108420$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $8a10ef4618108420$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $8a10ef4618108420$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $8a10ef4618108420$export$2e2bcd8739ae039 = $8a10ef4618108420$var$breakpoints;

});
parcelRegister("eHfx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab31211ad8f67cd3$export$2e2bcd8739ae039);

var $f41I8 = parcelRequire("f41I8");
function $ab31211ad8f67cd3$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $f41I8.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $ab31211ad8f67cd3$export$2e2bcd8739ae039 = $ab31211ad8f67cd3$var$merge;

});


parcelRegister("aghI8", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $7789230249bd1e50$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $7789230249bd1e50$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $7789230249bd1e50$export$2e2bcd8739ae039);

var $3wBkp = parcelRequire("3wBkp");


var $bQVdy = parcelRequire("bQVdy");
function $7789230249bd1e50$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $7789230249bd1e50$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $7789230249bd1e50$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $7789230249bd1e50$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $7789230249bd1e50$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $7789230249bd1e50$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $7789230249bd1e50$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $3wBkp.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $bQVdy.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $7789230249bd1e50$export$2e2bcd8739ae039 = $7789230249bd1e50$var$style;

});

parcelRegister("hGdXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdf1307241b33c35$export$2e2bcd8739ae039);
function $cdf1307241b33c35$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("aF1tN", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $7c2ee18e3dcdf408$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $7c2ee18e3dcdf408$export$2e2bcd8739ae039);

var $3wBkp = parcelRequire("3wBkp");

var $eHfx1 = parcelRequire("eHfx1");

var $aghI8 = parcelRequire("aghI8");

var $bQVdy = parcelRequire("bQVdy");

var $euq5j = parcelRequire("euq5j");
function $7c2ee18e3dcdf408$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $7c2ee18e3dcdf408$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $7c2ee18e3dcdf408$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $aghI8.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $aghI8.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $aghI8.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $3wBkp.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $bQVdy.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $euq5j.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $bQVdy.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $7c2ee18e3dcdf408$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $eHfx1.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $bQVdy.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($7c2ee18e3dcdf408$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $eHfx1.default)(css, breakpointsValues);
                        }
                    } else css = (0, $eHfx1.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $bQVdy.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $bQVdy.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $7c2ee18e3dcdf408$var$styleFunctionSx = $7c2ee18e3dcdf408$export$7d53d8bf2911e013();
$7c2ee18e3dcdf408$var$styleFunctionSx.filterProps = [
    'sx'
];
var $7c2ee18e3dcdf408$export$2e2bcd8739ae039 = $7c2ee18e3dcdf408$var$styleFunctionSx;

});
parcelRegister("euq5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8c819edd585aaa4$export$2e2bcd8739ae039);

var $bhdQC = parcelRequire("bhdQC");

var $gfkLN = parcelRequire("gfkLN");

var $gtGMi = parcelRequire("gtGMi");

var $ljlSB = parcelRequire("ljlSB");

var $4GXCJ = parcelRequire("4GXCJ");
const $a8c819edd585aaa4$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $gfkLN.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $gfkLN.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $gfkLN.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $gfkLN.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $gfkLN.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $gfkLN.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $gfkLN.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $ljlSB.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $ljlSB.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $ljlSB.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $bhdQC.padding)
    },
    pt: {
        style: (0, $bhdQC.padding)
    },
    pr: {
        style: (0, $bhdQC.padding)
    },
    pb: {
        style: (0, $bhdQC.padding)
    },
    pl: {
        style: (0, $bhdQC.padding)
    },
    px: {
        style: (0, $bhdQC.padding)
    },
    py: {
        style: (0, $bhdQC.padding)
    },
    padding: {
        style: (0, $bhdQC.padding)
    },
    paddingTop: {
        style: (0, $bhdQC.padding)
    },
    paddingRight: {
        style: (0, $bhdQC.padding)
    },
    paddingBottom: {
        style: (0, $bhdQC.padding)
    },
    paddingLeft: {
        style: (0, $bhdQC.padding)
    },
    paddingX: {
        style: (0, $bhdQC.padding)
    },
    paddingY: {
        style: (0, $bhdQC.padding)
    },
    paddingInline: {
        style: (0, $bhdQC.padding)
    },
    paddingInlineStart: {
        style: (0, $bhdQC.padding)
    },
    paddingInlineEnd: {
        style: (0, $bhdQC.padding)
    },
    paddingBlock: {
        style: (0, $bhdQC.padding)
    },
    paddingBlockStart: {
        style: (0, $bhdQC.padding)
    },
    paddingBlockEnd: {
        style: (0, $bhdQC.padding)
    },
    m: {
        style: (0, $bhdQC.margin)
    },
    mt: {
        style: (0, $bhdQC.margin)
    },
    mr: {
        style: (0, $bhdQC.margin)
    },
    mb: {
        style: (0, $bhdQC.margin)
    },
    ml: {
        style: (0, $bhdQC.margin)
    },
    mx: {
        style: (0, $bhdQC.margin)
    },
    my: {
        style: (0, $bhdQC.margin)
    },
    margin: {
        style: (0, $bhdQC.margin)
    },
    marginTop: {
        style: (0, $bhdQC.margin)
    },
    marginRight: {
        style: (0, $bhdQC.margin)
    },
    marginBottom: {
        style: (0, $bhdQC.margin)
    },
    marginLeft: {
        style: (0, $bhdQC.margin)
    },
    marginX: {
        style: (0, $bhdQC.margin)
    },
    marginY: {
        style: (0, $bhdQC.margin)
    },
    marginInline: {
        style: (0, $bhdQC.margin)
    },
    marginInlineStart: {
        style: (0, $bhdQC.margin)
    },
    marginInlineEnd: {
        style: (0, $bhdQC.margin)
    },
    marginBlock: {
        style: (0, $bhdQC.margin)
    },
    marginBlockStart: {
        style: (0, $bhdQC.margin)
    },
    marginBlockEnd: {
        style: (0, $bhdQC.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $gtGMi.gap)
    },
    rowGap: {
        style: (0, $gtGMi.rowGap)
    },
    columnGap: {
        style: (0, $gtGMi.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $4GXCJ.sizingTransform)
    },
    maxWidth: {
        style: (0, $4GXCJ.maxWidth)
    },
    minWidth: {
        transform: (0, $4GXCJ.sizingTransform)
    },
    height: {
        transform: (0, $4GXCJ.sizingTransform)
    },
    maxHeight: {
        transform: (0, $4GXCJ.sizingTransform)
    },
    minHeight: {
        transform: (0, $4GXCJ.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $a8c819edd585aaa4$export$2e2bcd8739ae039 = $a8c819edd585aaa4$var$defaultSxConfig;

});
parcelRegister("gfkLN", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $bd3e28828d2da2d9$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $bd3e28828d2da2d9$export$7a57f79000377ca2);


var $aghI8 = parcelRequire("aghI8");

var $4Qcke = parcelRequire("4Qcke");

var $bhdQC = parcelRequire("bhdQC");

var $bQVdy = parcelRequire("bQVdy");
function $bd3e28828d2da2d9$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $bd3e28828d2da2d9$var$createBorderStyle(prop, transform) {
    return (0, $aghI8.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $bd3e28828d2da2d9$export$1edee58a52776cd9 = $bd3e28828d2da2d9$var$createBorderStyle('border', $bd3e28828d2da2d9$export$34e2febe53ae29cc);
const $bd3e28828d2da2d9$export$f9a7b6bd24892946 = $bd3e28828d2da2d9$var$createBorderStyle('borderTop', $bd3e28828d2da2d9$export$34e2febe53ae29cc);
const $bd3e28828d2da2d9$export$5abca33e6be905d2 = $bd3e28828d2da2d9$var$createBorderStyle('borderRight', $bd3e28828d2da2d9$export$34e2febe53ae29cc);
const $bd3e28828d2da2d9$export$e2ce9f12a980a822 = $bd3e28828d2da2d9$var$createBorderStyle('borderBottom', $bd3e28828d2da2d9$export$34e2febe53ae29cc);
const $bd3e28828d2da2d9$export$47658cca1a909427 = $bd3e28828d2da2d9$var$createBorderStyle('borderLeft', $bd3e28828d2da2d9$export$34e2febe53ae29cc);
const $bd3e28828d2da2d9$export$e7fb0694ba2404fc = $bd3e28828d2da2d9$var$createBorderStyle('borderColor');
const $bd3e28828d2da2d9$export$126a92c968acdb85 = $bd3e28828d2da2d9$var$createBorderStyle('borderTopColor');
const $bd3e28828d2da2d9$export$85cc51cb8fbb8c0e = $bd3e28828d2da2d9$var$createBorderStyle('borderRightColor');
const $bd3e28828d2da2d9$export$340b0327727f6d1a = $bd3e28828d2da2d9$var$createBorderStyle('borderBottomColor');
const $bd3e28828d2da2d9$export$60beef91a985b4bf = $bd3e28828d2da2d9$var$createBorderStyle('borderLeftColor');
const $bd3e28828d2da2d9$export$f9258c55612cbed7 = $bd3e28828d2da2d9$var$createBorderStyle('outline', $bd3e28828d2da2d9$export$34e2febe53ae29cc);
const $bd3e28828d2da2d9$export$621fe586efeb64b9 = $bd3e28828d2da2d9$var$createBorderStyle('outlineColor');
const $bd3e28828d2da2d9$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $bhdQC.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $bhdQC.getValue)(transformer, propValue)
            });
        return (0, $bQVdy.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$bd3e28828d2da2d9$export$7a57f79000377ca2.propTypes = {};
$bd3e28828d2da2d9$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $bd3e28828d2da2d9$var$borders = (0, $4Qcke.default)($bd3e28828d2da2d9$export$1edee58a52776cd9, $bd3e28828d2da2d9$export$f9a7b6bd24892946, $bd3e28828d2da2d9$export$5abca33e6be905d2, $bd3e28828d2da2d9$export$e2ce9f12a980a822, $bd3e28828d2da2d9$export$47658cca1a909427, $bd3e28828d2da2d9$export$e7fb0694ba2404fc, $bd3e28828d2da2d9$export$126a92c968acdb85, $bd3e28828d2da2d9$export$85cc51cb8fbb8c0e, $bd3e28828d2da2d9$export$340b0327727f6d1a, $bd3e28828d2da2d9$export$60beef91a985b4bf, $bd3e28828d2da2d9$export$7a57f79000377ca2, $bd3e28828d2da2d9$export$f9258c55612cbed7, $bd3e28828d2da2d9$export$621fe586efeb64b9);
var $bd3e28828d2da2d9$export$2e2bcd8739ae039 = $bd3e28828d2da2d9$var$borders;

});
parcelRegister("4Qcke", function(module, exports) {

$parcel$export(module.exports, "default", () => $3865944eb2fed590$export$2e2bcd8739ae039);

var $eHfx1 = parcelRequire("eHfx1");
function $3865944eb2fed590$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $eHfx1.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $3865944eb2fed590$export$2e2bcd8739ae039 = $3865944eb2fed590$var$compose;

});


parcelRegister("gtGMi", function(module, exports) {

$parcel$export(module.exports, "gap", () => $bff089964ea28f33$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $bff089964ea28f33$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $bff089964ea28f33$export$8a833ffa5f5dbeda);

var $aghI8 = parcelRequire("aghI8");

var $4Qcke = parcelRequire("4Qcke");

var $bhdQC = parcelRequire("bhdQC");

var $bQVdy = parcelRequire("bQVdy");

const $bff089964ea28f33$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $bhdQC.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $bhdQC.getValue)(transformer, propValue)
            });
        return (0, $bQVdy.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$bff089964ea28f33$export$5df9adcb0db95e1e.propTypes = {};
$bff089964ea28f33$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $bff089964ea28f33$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $bhdQC.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $bhdQC.getValue)(transformer, propValue)
            });
        return (0, $bQVdy.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$bff089964ea28f33$export$ec60d70ff941a580.propTypes = {};
$bff089964ea28f33$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $bff089964ea28f33$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $bhdQC.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $bhdQC.getValue)(transformer, propValue)
            });
        return (0, $bQVdy.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$bff089964ea28f33$export$8a833ffa5f5dbeda.propTypes = {};
$bff089964ea28f33$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $bff089964ea28f33$export$baf44164ca3a34e8 = (0, $aghI8.default)({
    prop: 'gridColumn'
});
const $bff089964ea28f33$export$8f7213a1cd01e832 = (0, $aghI8.default)({
    prop: 'gridRow'
});
const $bff089964ea28f33$export$b0e0abbc49ba668 = (0, $aghI8.default)({
    prop: 'gridAutoFlow'
});
const $bff089964ea28f33$export$bcd8b929d4b4142 = (0, $aghI8.default)({
    prop: 'gridAutoColumns'
});
const $bff089964ea28f33$export$e5039a674e14c828 = (0, $aghI8.default)({
    prop: 'gridAutoRows'
});
const $bff089964ea28f33$export$42bd9088661ffb03 = (0, $aghI8.default)({
    prop: 'gridTemplateColumns'
});
const $bff089964ea28f33$export$920682ae05b999bc = (0, $aghI8.default)({
    prop: 'gridTemplateRows'
});
const $bff089964ea28f33$export$1b88fbdd482fd33a = (0, $aghI8.default)({
    prop: 'gridTemplateAreas'
});
const $bff089964ea28f33$export$bdb486e40d52d26f = (0, $aghI8.default)({
    prop: 'gridArea'
});
const $bff089964ea28f33$var$grid = (0, $4Qcke.default)($bff089964ea28f33$export$5df9adcb0db95e1e, $bff089964ea28f33$export$ec60d70ff941a580, $bff089964ea28f33$export$8a833ffa5f5dbeda, $bff089964ea28f33$export$baf44164ca3a34e8, $bff089964ea28f33$export$8f7213a1cd01e832, $bff089964ea28f33$export$b0e0abbc49ba668, $bff089964ea28f33$export$bcd8b929d4b4142, $bff089964ea28f33$export$e5039a674e14c828, $bff089964ea28f33$export$42bd9088661ffb03, $bff089964ea28f33$export$920682ae05b999bc, $bff089964ea28f33$export$1b88fbdd482fd33a, $bff089964ea28f33$export$bdb486e40d52d26f);
var $bff089964ea28f33$export$2e2bcd8739ae039 = $bff089964ea28f33$var$grid;

});

parcelRegister("ljlSB", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $f83c582f4f3d61ec$export$dbaffd4420ea0ac6);

var $aghI8 = parcelRequire("aghI8");

var $4Qcke = parcelRequire("4Qcke");
function $f83c582f4f3d61ec$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $f83c582f4f3d61ec$export$35e9368ef982300f = (0, $aghI8.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $f83c582f4f3d61ec$export$dbaffd4420ea0ac6
});
const $f83c582f4f3d61ec$export$2506f56c10355b33 = (0, $aghI8.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $f83c582f4f3d61ec$export$dbaffd4420ea0ac6
});
const $f83c582f4f3d61ec$export$8c5a050822fd698c = (0, $aghI8.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $f83c582f4f3d61ec$export$dbaffd4420ea0ac6
});
const $f83c582f4f3d61ec$var$palette = (0, $4Qcke.default)($f83c582f4f3d61ec$export$35e9368ef982300f, $f83c582f4f3d61ec$export$2506f56c10355b33, $f83c582f4f3d61ec$export$8c5a050822fd698c);
var $f83c582f4f3d61ec$export$2e2bcd8739ae039 = $f83c582f4f3d61ec$var$palette;

});

parcelRegister("4GXCJ", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $36a955b399b6c2f5$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $36a955b399b6c2f5$export$488fda99655ff65a);

var $aghI8 = parcelRequire("aghI8");

var $4Qcke = parcelRequire("4Qcke");

var $bQVdy = parcelRequire("bQVdy");
function $36a955b399b6c2f5$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $36a955b399b6c2f5$export$7e3df82ee760448c = (0, $aghI8.default)({
    prop: 'width',
    transform: $36a955b399b6c2f5$export$8afece71750ec241
});
const $36a955b399b6c2f5$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $bQVdy.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $36a955b399b6c2f5$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $bQVdy.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$36a955b399b6c2f5$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $36a955b399b6c2f5$export$ee148fbbe8357dd2 = (0, $aghI8.default)({
    prop: 'minWidth',
    transform: $36a955b399b6c2f5$export$8afece71750ec241
});
const $36a955b399b6c2f5$export$ac607276a8fe9f0a = (0, $aghI8.default)({
    prop: 'height',
    transform: $36a955b399b6c2f5$export$8afece71750ec241
});
const $36a955b399b6c2f5$export$dc0d8bd0b94f8570 = (0, $aghI8.default)({
    prop: 'maxHeight',
    transform: $36a955b399b6c2f5$export$8afece71750ec241
});
const $36a955b399b6c2f5$export$a43cf604e12f3b17 = (0, $aghI8.default)({
    prop: 'minHeight',
    transform: $36a955b399b6c2f5$export$8afece71750ec241
});
const $36a955b399b6c2f5$export$ffed9f14fb65e276 = (0, $aghI8.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $36a955b399b6c2f5$export$8afece71750ec241
});
const $36a955b399b6c2f5$export$905076ed6620e671 = (0, $aghI8.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $36a955b399b6c2f5$export$8afece71750ec241
});
const $36a955b399b6c2f5$export$6ccc93f785106a58 = (0, $aghI8.default)({
    prop: 'boxSizing'
});
const $36a955b399b6c2f5$var$sizing = (0, $4Qcke.default)($36a955b399b6c2f5$export$7e3df82ee760448c, $36a955b399b6c2f5$export$488fda99655ff65a, $36a955b399b6c2f5$export$ee148fbbe8357dd2, $36a955b399b6c2f5$export$ac607276a8fe9f0a, $36a955b399b6c2f5$export$dc0d8bd0b94f8570, $36a955b399b6c2f5$export$a43cf604e12f3b17, $36a955b399b6c2f5$export$6ccc93f785106a58);
var $36a955b399b6c2f5$export$2e2bcd8739ae039 = $36a955b399b6c2f5$var$sizing;

});



parcelRegister("i16H0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1dd83005de7753b$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $d1dd83005de7753b$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("zqgc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $06a7a3ba0f4a3527$export$2e2bcd8739ae039);

var $eeyUA = parcelRequire("eeyUA");
parcelRequire("evqAe");
var $3M4a6 = parcelRequire("3M4a6");
'use client';
function $06a7a3ba0f4a3527$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $06a7a3ba0f4a3527$var$useTheme(defaultTheme = null) {
    const contextTheme = $eeyUA.useContext((0, $3M4a6.T));
    return !contextTheme || $06a7a3ba0f4a3527$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $06a7a3ba0f4a3527$export$2e2bcd8739ae039 = $06a7a3ba0f4a3527$var$useTheme;

});
parcelRegister("evqAe", function(module, exports) {

$parcel$export(module.exports, "Global", () => $a8f894d8439a670c$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $a8f894d8439a670c$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $a8f894d8439a670c$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("3M4a6")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("3M4a6")).w);

var $3M4a6 = parcelRequire("3M4a6");

var $eeyUA = parcelRequire("eeyUA");

var $cfloP = parcelRequire("cfloP");

var $4PcT3 = parcelRequire("4PcT3");

var $2WE2O = parcelRequire("2WE2O");
parcelRequire("9qOEN");
parcelRequire("9nayj");
parcelRequire("b4xGC");

parcelRequire("90hus");
var $a8f894d8439a670c$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $a8f894d8439a670c$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $3M4a6.h).call(props, 'css')) // $FlowFixMe
    return $eeyUA.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $3M4a6.E);
    createElementArgArray[1] = (0, $3M4a6.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $eeyUA.createElement.apply(null, createElementArgArray);
};
var $a8f894d8439a670c$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $a8f894d8439a670c$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $3M4a6.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $2WE2O.serializeStyles)([
        styles
    ], undefined, $eeyUA.useContext((0, $3M4a6.T)));
    if (!(0, $3M4a6.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $eeyUA.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $eeyUA.useRef();
    (0, $4PcT3.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $4PcT3.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $cfloP.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $a8f894d8439a670c$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $2WE2O.serializeStyles)(args);
}
var $a8f894d8439a670c$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $a8f894d8439a670c$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $a8f894d8439a670c$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $a8f894d8439a670c$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $cfloP.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $a8f894d8439a670c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $4PcT3.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $cfloP.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $a8f894d8439a670c$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $3M4a6.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $2WE2O.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $cfloP.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $a8f894d8439a670c$var$merge(cache.registered, css, $a8f894d8439a670c$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $eeyUA.useContext((0, $3M4a6.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, /*#__PURE__*/ $eeyUA.createElement($a8f894d8439a670c$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $a8f894d8439a670c$var$isBrowser, $a8f894d8439a670c$var$isTestEnv, $a8f894d8439a670c$var$globalContext, $a8f894d8439a670c$var$globalKey;

});
parcelRegister("3M4a6", function(module, exports) {

$parcel$export(module.exports, "i", () => $2bf91545e7a248e8$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $2bf91545e7a248e8$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "C", () => $2bf91545e7a248e8$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $2bf91545e7a248e8$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $2bf91545e7a248e8$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $2bf91545e7a248e8$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $2bf91545e7a248e8$export$a9c23c6ac3fc3eca);

var $eeyUA = parcelRequire("eeyUA");

var $9qOEN = parcelRequire("9qOEN");

var $7Nobb = parcelRequire("7Nobb");

var $b4xGC = parcelRequire("b4xGC");

var $2JovX = parcelRequire("2JovX");

var $cfloP = parcelRequire("cfloP");

var $2WE2O = parcelRequire("2WE2O");

var $4PcT3 = parcelRequire("4PcT3");
var $2bf91545e7a248e8$export$23f2a1d2818174ef = true;
var $2bf91545e7a248e8$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $2bf91545e7a248e8$var$EmotionCacheContext = /* #__PURE__ */ $eeyUA.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $9qOEN.default)({
    key: 'css'
}) : null);
var $2bf91545e7a248e8$export$e7094788287c5e9b = $2bf91545e7a248e8$var$EmotionCacheContext.Provider;
var $2bf91545e7a248e8$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $eeyUA.useContext)($2bf91545e7a248e8$var$EmotionCacheContext);
};
var $2bf91545e7a248e8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $eeyUA.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $eeyUA.useContext)($2bf91545e7a248e8$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$2bf91545e7a248e8$export$23f2a1d2818174ef) $2bf91545e7a248e8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $eeyUA.useContext)($2bf91545e7a248e8$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $9qOEN.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $eeyUA.createElement($2bf91545e7a248e8$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $2bf91545e7a248e8$export$971d5caa766a69d7 = /* #__PURE__ */ $eeyUA.createContext({});
var $2bf91545e7a248e8$export$3b14a55fb2447963 = function useTheme() {
    return $eeyUA.useContext($2bf91545e7a248e8$export$971d5caa766a69d7);
};
var $2bf91545e7a248e8$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $7Nobb.default)({}, outerTheme, theme);
};
var $2bf91545e7a248e8$var$createCacheWithTheme = /* #__PURE__ */ (0, $b4xGC.default)(function(outerTheme) {
    return (0, $b4xGC.default)(function(theme) {
        return $2bf91545e7a248e8$var$getTheme(outerTheme, theme);
    });
});
var $2bf91545e7a248e8$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $eeyUA.useContext($2bf91545e7a248e8$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $2bf91545e7a248e8$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $eeyUA.createElement($2bf91545e7a248e8$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $2bf91545e7a248e8$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $eeyUA.useContext($2bf91545e7a248e8$export$971d5caa766a69d7);
        return /*#__PURE__*/ $eeyUA.createElement(Component, (0, $7Nobb.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $eeyUA.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $2JovX.default)(WithTheme, Component);
}
var $2bf91545e7a248e8$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $2bf91545e7a248e8$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $2bf91545e7a248e8$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $2bf91545e7a248e8$var$getLastPart(match[1]);
    return undefined;
};
var $2bf91545e7a248e8$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $2bf91545e7a248e8$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $2bf91545e7a248e8$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $2bf91545e7a248e8$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($2bf91545e7a248e8$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $2bf91545e7a248e8$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $2bf91545e7a248e8$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $2bf91545e7a248e8$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $2bf91545e7a248e8$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($2bf91545e7a248e8$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$2bf91545e7a248e8$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $2bf91545e7a248e8$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $cfloP.registerStyles)(cache, serialized, isStringTag);
    (0, $4PcT3.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $cfloP.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $2bf91545e7a248e8$var$Emotion = /* #__PURE__ */ $2bf91545e7a248e8$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$2bf91545e7a248e8$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $cfloP.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $2WE2O.serializeStyles)(registeredStyles, undefined, $eeyUA.useContext($2bf91545e7a248e8$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($2bf91545e7a248e8$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $2bf91545e7a248e8$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, /*#__PURE__*/ $eeyUA.createElement($2bf91545e7a248e8$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $eeyUA.createElement(WrappedComponent, newProps));
});
var $2bf91545e7a248e8$export$a9c23c6ac3fc3eca = $2bf91545e7a248e8$var$Emotion;

});
parcelRegister("9qOEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dddd63355c7afd9$export$2e2bcd8739ae039);

var $6uhHJ = parcelRequire("6uhHJ");

var $bXPBv = parcelRequire("bXPBv");

var $jMVaa = parcelRequire("jMVaa");

var $6xwrb = parcelRequire("6xwrb");
var $6dddd63355c7afd9$var$isBrowser = typeof document !== 'undefined';
var $6dddd63355c7afd9$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $bXPBv.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $bXPBv.token)(character)) break;
        (0, $bXPBv.next)();
    }
    return (0, $bXPBv.slice)(begin, (0, $bXPBv.position));
};
var $6dddd63355c7afd9$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $bXPBv.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $bXPBv.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $6dddd63355c7afd9$var$identifierWithPointTracking((0, $bXPBv.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $bXPBv.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $bXPBv.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $bXPBv.from)(character);
    }
    while (character = (0, $bXPBv.next)());
    return parsed;
};
var $6dddd63355c7afd9$var$getRules = function getRules(value, points) {
    return (0, $bXPBv.dealloc)($6dddd63355c7afd9$var$toRules((0, $bXPBv.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $6dddd63355c7afd9$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $6dddd63355c7afd9$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$6dddd63355c7afd9$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $6dddd63355c7afd9$var$fixedElements.set(element, true);
    var points = [];
    var rules = $6dddd63355c7afd9$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $6dddd63355c7afd9$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $6dddd63355c7afd9$var$prefix(value, length) {
    switch((0, $bXPBv.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $bXPBv.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $bXPBv.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MOZ) + value + (0, $bXPBv.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MS) + value + value;
        // order
        case 6165:
            return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.replace)(value, /(\w+).+(:[^]+)/, (0, $bXPBv.WEBKIT) + 'box-$1$2' + (0, $bXPBv.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MS) + 'flex-item-' + (0, $bXPBv.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MS) + 'flex-line-pack' + (0, $bXPBv.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MS) + (0, $bXPBv.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MS) + (0, $bXPBv.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $bXPBv.WEBKIT) + 'box-' + (0, $bXPBv.replace)(value, '-grow', '') + (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MS) + (0, $bXPBv.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $bXPBv.WEBKIT) + (0, $bXPBv.replace)(value, /([^-])(transform)/g, '$1' + (0, $bXPBv.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $bXPBv.replace)((0, $bXPBv.replace)((0, $bXPBv.replace)(value, /(zoom-|grab)/, (0, $bXPBv.WEBKIT) + '$1'), /(image-set)/, (0, $bXPBv.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $bXPBv.replace)(value, /(image-set\([^]*)/, (0, $bXPBv.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $bXPBv.replace)((0, $bXPBv.replace)(value, /(.+:)(flex-)?(.*)/, (0, $bXPBv.WEBKIT) + 'box-pack:$3' + (0, $bXPBv.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $bXPBv.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $bXPBv.replace)(value, /(.+)-inline(.+)/, (0, $bXPBv.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $bXPBv.strlen)(value) - 1 - length > 6) switch((0, $bXPBv.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $bXPBv.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $bXPBv.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $bXPBv.WEBKIT) + '$2-$3' + '$1' + (0, $bXPBv.MOZ) + ((0, $bXPBv.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $bXPBv.indexof)(value, 'stretch') ? $6dddd63355c7afd9$var$prefix((0, $bXPBv.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $bXPBv.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $bXPBv.charat)(value, (0, $bXPBv.strlen)(value) - 3 - (~(0, $bXPBv.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $bXPBv.replace)(value, ':', ':' + (0, $bXPBv.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $bXPBv.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $bXPBv.WEBKIT) + ((0, $bXPBv.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $bXPBv.WEBKIT) + '$2$3' + '$1' + (0, $bXPBv.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $bXPBv.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MS) + (0, $bXPBv.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MS) + (0, $bXPBv.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MS) + (0, $bXPBv.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $bXPBv.WEBKIT) + value + (0, $bXPBv.MS) + value + value;
    }
    return value;
}
var $6dddd63355c7afd9$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $bXPBv.DECLARATION:
                element["return"] = $6dddd63355c7afd9$var$prefix(element.value, element.length);
                break;
            case 0, $bXPBv.KEYFRAMES:
                return (0, $bXPBv.serialize)([
                    (0, $bXPBv.copy)(element, {
                        value: (0, $bXPBv.replace)(element.value, '@', '@' + (0, $bXPBv.WEBKIT))
                    })
                ], callback);
            case 0, $bXPBv.RULESET:
                if (element.length) return (0, $bXPBv.combine)(element.props, function(value) {
                    switch((0, $bXPBv.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $bXPBv.serialize)([
                                (0, $bXPBv.copy)(element, {
                                    props: [
                                        (0, $bXPBv.replace)(value, /:(read-\w+)/, ':' + (0, $bXPBv.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $bXPBv.serialize)([
                                (0, $bXPBv.copy)(element, {
                                    props: [
                                        (0, $bXPBv.replace)(value, /:(plac\w+)/, ':' + (0, $bXPBv.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $bXPBv.copy)(element, {
                                    props: [
                                        (0, $bXPBv.replace)(value, /:(plac\w+)/, ':' + (0, $bXPBv.MOZ) + '$1')
                                    ]
                                }),
                                (0, $bXPBv.copy)(element, {
                                    props: [
                                        (0, $bXPBv.replace)(value, /:(plac\w+)/, (0, $bXPBv.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $6dddd63355c7afd9$var$getServerStylisCache = $6dddd63355c7afd9$var$isBrowser ? undefined : (0, $jMVaa.default)(function() {
    return (0, $6xwrb.default)(function() {
        return {};
    });
});
var $6dddd63355c7afd9$var$defaultStylisPlugins = [
    $6dddd63355c7afd9$var$prefixer
];
var $6dddd63355c7afd9$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($6dddd63355c7afd9$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $6dddd63355c7afd9$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($6dddd63355c7afd9$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $6dddd63355c7afd9$var$compat,
        $6dddd63355c7afd9$var$removeLabel
    ];
    if (!$6dddd63355c7afd9$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $bXPBv.stringify),
            (0, $bXPBv.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $bXPBv.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $bXPBv.serialize)((0, $bXPBv.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $bXPBv.stringify)
        ];
        var _serializer = (0, $bXPBv.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $bXPBv.serialize)((0, $bXPBv.compile)(styles), _serializer);
        };
        var serverStylisCache = $6dddd63355c7afd9$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $6uhHJ.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("6uhHJ", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $4b93471c78e7965d$export$9d753cd7ae895cce);
var $4b93471c78e7965d$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $4b93471c78e7965d$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $4b93471c78e7965d$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $4b93471c78e7965d$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$4b93471c78e7965d$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($4b93471c78e7965d$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $4b93471c78e7965d$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("bXPBv", function(module, exports) {

$parcel$export(module.exports, "MS", () => $84a8eb74fa06a152$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $84a8eb74fa06a152$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $84a8eb74fa06a152$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $84a8eb74fa06a152$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $84a8eb74fa06a152$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $84a8eb74fa06a152$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $84a8eb74fa06a152$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $84a8eb74fa06a152$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $84a8eb74fa06a152$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $84a8eb74fa06a152$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $84a8eb74fa06a152$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $84a8eb74fa06a152$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $84a8eb74fa06a152$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $84a8eb74fa06a152$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $84a8eb74fa06a152$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $84a8eb74fa06a152$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $84a8eb74fa06a152$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $84a8eb74fa06a152$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $84a8eb74fa06a152$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $84a8eb74fa06a152$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $84a8eb74fa06a152$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $84a8eb74fa06a152$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $84a8eb74fa06a152$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $84a8eb74fa06a152$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $84a8eb74fa06a152$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $84a8eb74fa06a152$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $84a8eb74fa06a152$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $84a8eb74fa06a152$export$38bcb760f1d4871c);
var $84a8eb74fa06a152$export$71ad59f2e432cfe8 = "-ms-";
var $84a8eb74fa06a152$export$2c0f367103c8d01c = "-moz-";
var $84a8eb74fa06a152$export$39dfd62a25e0fe93 = "-webkit-";
var $84a8eb74fa06a152$export$a29989082612d0d9 = "comm";
var $84a8eb74fa06a152$export$aa3a2e812ca8570d = "rule";
var $84a8eb74fa06a152$export$527d108ccf083c2b = "decl";
var $84a8eb74fa06a152$export$d3d35020fa5b54f0 = "@page";
var $84a8eb74fa06a152$export$500415a86c544f73 = "@media";
var $84a8eb74fa06a152$export$a763edbf796b780a = "@import";
var $84a8eb74fa06a152$export$2790aeb8b4e5c826 = "@charset";
var $84a8eb74fa06a152$export$1cc683e23b84b133 = "@viewport";
var $84a8eb74fa06a152$export$9447a5efea57e862 = "@supports";
var $84a8eb74fa06a152$export$ef011b4e114b1fba = "@document";
var $84a8eb74fa06a152$export$6aad947bda0f3f46 = "@namespace";
var $84a8eb74fa06a152$export$b44a8529a35fcb60 = "@keyframes";
var $84a8eb74fa06a152$export$2c16de31893252e6 = "@font-face";
var $84a8eb74fa06a152$export$3d846dd52e150c6f = "@counter-style";
var $84a8eb74fa06a152$export$22314bfbb57653fe = "@font-feature-values";
var $84a8eb74fa06a152$export$d773506282b3cfe6 = "@layer";
var $84a8eb74fa06a152$export$2335f513bbd82c6d = Math.abs;
var $84a8eb74fa06a152$export$6788812c4e6611e6 = String.fromCharCode;
var $84a8eb74fa06a152$export$e6e34fd1f2686227 = Object.assign;
function $84a8eb74fa06a152$export$d6af199866bfb566(e, r) {
    return $84a8eb74fa06a152$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $84a8eb74fa06a152$export$a9db5e087081082d(e, 0)) << 2 ^ $84a8eb74fa06a152$export$a9db5e087081082d(e, 1)) << 2 ^ $84a8eb74fa06a152$export$a9db5e087081082d(e, 2)) << 2 ^ $84a8eb74fa06a152$export$a9db5e087081082d(e, 3) : 0;
}
function $84a8eb74fa06a152$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $84a8eb74fa06a152$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $84a8eb74fa06a152$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $84a8eb74fa06a152$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $84a8eb74fa06a152$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $84a8eb74fa06a152$export$36776f635604f274(e) {
    return e.length;
}
function $84a8eb74fa06a152$export$f9084667e487ed46(e) {
    return e.length;
}
function $84a8eb74fa06a152$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $84a8eb74fa06a152$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $84a8eb74fa06a152$export$53f1d5ea8de3d7c = 1;
var $84a8eb74fa06a152$export$4e0c71f277ca26b3 = 1;
var $84a8eb74fa06a152$export$f24224f1c91d8156 = 0;
var $84a8eb74fa06a152$export$5880b8b5730aff45 = 0;
var $84a8eb74fa06a152$export$c0306caf338ac095 = 0;
var $84a8eb74fa06a152$export$30a86d91af8ff6e6 = "";
function $84a8eb74fa06a152$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $84a8eb74fa06a152$export$53f1d5ea8de3d7c,
        column: $84a8eb74fa06a152$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $84a8eb74fa06a152$export$784d13d8ee351f07(e, r) {
    return $84a8eb74fa06a152$export$e6e34fd1f2686227($84a8eb74fa06a152$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $84a8eb74fa06a152$export$eba6f6f03b0a92e7() {
    return $84a8eb74fa06a152$export$c0306caf338ac095;
}
function $84a8eb74fa06a152$export$232faf9add678146() {
    $84a8eb74fa06a152$export$c0306caf338ac095 = $84a8eb74fa06a152$export$5880b8b5730aff45 > 0 ? $84a8eb74fa06a152$export$a9db5e087081082d($84a8eb74fa06a152$export$30a86d91af8ff6e6, --$84a8eb74fa06a152$export$5880b8b5730aff45) : 0;
    if ($84a8eb74fa06a152$export$4e0c71f277ca26b3--, $84a8eb74fa06a152$export$c0306caf338ac095 === 10) $84a8eb74fa06a152$export$4e0c71f277ca26b3 = 1, $84a8eb74fa06a152$export$53f1d5ea8de3d7c--;
    return $84a8eb74fa06a152$export$c0306caf338ac095;
}
function $84a8eb74fa06a152$export$48cfd1e771a65c4f() {
    $84a8eb74fa06a152$export$c0306caf338ac095 = $84a8eb74fa06a152$export$5880b8b5730aff45 < $84a8eb74fa06a152$export$f24224f1c91d8156 ? $84a8eb74fa06a152$export$a9db5e087081082d($84a8eb74fa06a152$export$30a86d91af8ff6e6, $84a8eb74fa06a152$export$5880b8b5730aff45++) : 0;
    if ($84a8eb74fa06a152$export$4e0c71f277ca26b3++, $84a8eb74fa06a152$export$c0306caf338ac095 === 10) $84a8eb74fa06a152$export$4e0c71f277ca26b3 = 1, $84a8eb74fa06a152$export$53f1d5ea8de3d7c++;
    return $84a8eb74fa06a152$export$c0306caf338ac095;
}
function $84a8eb74fa06a152$export$4d3fb11e950abb9e() {
    return $84a8eb74fa06a152$export$a9db5e087081082d($84a8eb74fa06a152$export$30a86d91af8ff6e6, $84a8eb74fa06a152$export$5880b8b5730aff45);
}
function $84a8eb74fa06a152$export$e88cb2efb12ae807() {
    return $84a8eb74fa06a152$export$5880b8b5730aff45;
}
function $84a8eb74fa06a152$export$58adb3bec8346d0f(e, r) {
    return $84a8eb74fa06a152$export$2f35ab04d2335697($84a8eb74fa06a152$export$30a86d91af8ff6e6, e, r);
}
function $84a8eb74fa06a152$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $84a8eb74fa06a152$export$2de70f21292aac9e(e) {
    return $84a8eb74fa06a152$export$53f1d5ea8de3d7c = $84a8eb74fa06a152$export$4e0c71f277ca26b3 = 1, $84a8eb74fa06a152$export$f24224f1c91d8156 = $84a8eb74fa06a152$export$36776f635604f274($84a8eb74fa06a152$export$30a86d91af8ff6e6 = e), $84a8eb74fa06a152$export$5880b8b5730aff45 = 0, [];
}
function $84a8eb74fa06a152$export$45918ac1574455b1(e) {
    return $84a8eb74fa06a152$export$30a86d91af8ff6e6 = "", e;
}
function $84a8eb74fa06a152$export$410ac95b9ec204b8(e) {
    return $84a8eb74fa06a152$export$87c2784dc9fc4ab($84a8eb74fa06a152$export$58adb3bec8346d0f($84a8eb74fa06a152$export$5880b8b5730aff45 - 1, $84a8eb74fa06a152$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $84a8eb74fa06a152$export$660b2ee2d4fb4eff(e) {
    return $84a8eb74fa06a152$export$45918ac1574455b1($84a8eb74fa06a152$export$5f8c09e3ae6f64e1($84a8eb74fa06a152$export$2de70f21292aac9e(e)));
}
function $84a8eb74fa06a152$export$7af1228ff777d175(e) {
    while($84a8eb74fa06a152$export$c0306caf338ac095 = $84a8eb74fa06a152$export$4d3fb11e950abb9e())if ($84a8eb74fa06a152$export$c0306caf338ac095 < 33) $84a8eb74fa06a152$export$48cfd1e771a65c4f();
    else break;
    return $84a8eb74fa06a152$export$9e1725a4cfeada27(e) > 2 || $84a8eb74fa06a152$export$9e1725a4cfeada27($84a8eb74fa06a152$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $84a8eb74fa06a152$export$5f8c09e3ae6f64e1(e) {
    while($84a8eb74fa06a152$export$48cfd1e771a65c4f())switch($84a8eb74fa06a152$export$9e1725a4cfeada27($84a8eb74fa06a152$export$c0306caf338ac095)){
        case 0:
            $84a8eb74fa06a152$export$10d8903dec122b9d($84a8eb74fa06a152$export$c2ab62c7bf24634($84a8eb74fa06a152$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $84a8eb74fa06a152$export$10d8903dec122b9d($84a8eb74fa06a152$export$410ac95b9ec204b8($84a8eb74fa06a152$export$c0306caf338ac095), e);
            break;
        default:
            $84a8eb74fa06a152$export$10d8903dec122b9d($84a8eb74fa06a152$export$6788812c4e6611e6($84a8eb74fa06a152$export$c0306caf338ac095), e);
    }
    return e;
}
function $84a8eb74fa06a152$export$955ba06d119e085e(e, r) {
    while(--r && $84a8eb74fa06a152$export$48cfd1e771a65c4f())if ($84a8eb74fa06a152$export$c0306caf338ac095 < 48 || $84a8eb74fa06a152$export$c0306caf338ac095 > 102 || $84a8eb74fa06a152$export$c0306caf338ac095 > 57 && $84a8eb74fa06a152$export$c0306caf338ac095 < 65 || $84a8eb74fa06a152$export$c0306caf338ac095 > 70 && $84a8eb74fa06a152$export$c0306caf338ac095 < 97) break;
    return $84a8eb74fa06a152$export$58adb3bec8346d0f(e, $84a8eb74fa06a152$export$e88cb2efb12ae807() + (r < 6 && $84a8eb74fa06a152$export$4d3fb11e950abb9e() == 32 && $84a8eb74fa06a152$export$48cfd1e771a65c4f() == 32));
}
function $84a8eb74fa06a152$export$c889f2fcc19dbf12(e) {
    while($84a8eb74fa06a152$export$48cfd1e771a65c4f())switch($84a8eb74fa06a152$export$c0306caf338ac095){
        case e:
            return $84a8eb74fa06a152$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $84a8eb74fa06a152$export$c889f2fcc19dbf12($84a8eb74fa06a152$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $84a8eb74fa06a152$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $84a8eb74fa06a152$export$48cfd1e771a65c4f();
            break;
    }
    return $84a8eb74fa06a152$export$5880b8b5730aff45;
}
function $84a8eb74fa06a152$export$4254d4e2b3745c4c(e, r) {
    while($84a8eb74fa06a152$export$48cfd1e771a65c4f())if (e + $84a8eb74fa06a152$export$c0306caf338ac095 === 57) break;
    else if (e + $84a8eb74fa06a152$export$c0306caf338ac095 === 84 && $84a8eb74fa06a152$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $84a8eb74fa06a152$export$58adb3bec8346d0f(r, $84a8eb74fa06a152$export$5880b8b5730aff45 - 1) + "*" + $84a8eb74fa06a152$export$6788812c4e6611e6(e === 47 ? e : $84a8eb74fa06a152$export$48cfd1e771a65c4f());
}
function $84a8eb74fa06a152$export$c2ab62c7bf24634(e) {
    while(!$84a8eb74fa06a152$export$9e1725a4cfeada27($84a8eb74fa06a152$export$4d3fb11e950abb9e()))$84a8eb74fa06a152$export$48cfd1e771a65c4f();
    return $84a8eb74fa06a152$export$58adb3bec8346d0f(e, $84a8eb74fa06a152$export$5880b8b5730aff45);
}
function $84a8eb74fa06a152$export$ef7acd7185315e22(e) {
    return $84a8eb74fa06a152$export$45918ac1574455b1($84a8eb74fa06a152$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $84a8eb74fa06a152$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $84a8eb74fa06a152$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $84a8eb74fa06a152$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $84a8eb74fa06a152$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($84a8eb74fa06a152$export$f8e21b1e77979a08(j += $84a8eb74fa06a152$export$77ad94ebf1c2b9ed($84a8eb74fa06a152$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $84a8eb74fa06a152$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $84a8eb74fa06a152$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $84a8eb74fa06a152$export$955ba06d119e085e($84a8eb74fa06a152$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($84a8eb74fa06a152$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $84a8eb74fa06a152$export$10d8903dec122b9d($84a8eb74fa06a152$export$4a34f930e789283c($84a8eb74fa06a152$export$4254d4e2b3745c4c($84a8eb74fa06a152$export$48cfd1e771a65c4f(), $84a8eb74fa06a152$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $84a8eb74fa06a152$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $84a8eb74fa06a152$export$36776f635604f274(j) - l) $84a8eb74fa06a152$export$10d8903dec122b9d(p > 32 ? $84a8eb74fa06a152$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $84a8eb74fa06a152$export$f8483753829ec8f3($84a8eb74fa06a152$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $84a8eb74fa06a152$export$10d8903dec122b9d(y = $84a8eb74fa06a152$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $84a8eb74fa06a152$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $84a8eb74fa06a152$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $84a8eb74fa06a152$export$98e6a39c04603d36(e, y, y, n && $84a8eb74fa06a152$export$10d8903dec122b9d($84a8eb74fa06a152$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $84a8eb74fa06a152$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $84a8eb74fa06a152$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $84a8eb74fa06a152$export$232faf9add678146() == 125) continue;
            }
            switch(j += $84a8eb74fa06a152$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($84a8eb74fa06a152$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($84a8eb74fa06a152$export$4d3fb11e950abb9e() === 45) j += $84a8eb74fa06a152$export$410ac95b9ec204b8($84a8eb74fa06a152$export$48cfd1e771a65c4f());
                    v = $84a8eb74fa06a152$export$4d3fb11e950abb9e(), o = l = $84a8eb74fa06a152$export$36776f635604f274(g = j += $84a8eb74fa06a152$export$c2ab62c7bf24634($84a8eb74fa06a152$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $84a8eb74fa06a152$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $84a8eb74fa06a152$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $84a8eb74fa06a152$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $84a8eb74fa06a152$export$2f35ab04d2335697(e, v + 1, v = $84a8eb74fa06a152$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $84a8eb74fa06a152$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $84a8eb74fa06a152$export$35059013cd4a06db(e, r, a, s === 0 ? $84a8eb74fa06a152$export$aa3a2e812ca8570d : i, f, o, l);
}
function $84a8eb74fa06a152$export$4a34f930e789283c(e, r, a) {
    return $84a8eb74fa06a152$export$35059013cd4a06db(e, r, a, $84a8eb74fa06a152$export$a29989082612d0d9, $84a8eb74fa06a152$export$6788812c4e6611e6($84a8eb74fa06a152$export$eba6f6f03b0a92e7()), $84a8eb74fa06a152$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $84a8eb74fa06a152$export$f8483753829ec8f3(e, r, a, n) {
    return $84a8eb74fa06a152$export$35059013cd4a06db(e, r, a, $84a8eb74fa06a152$export$527d108ccf083c2b, $84a8eb74fa06a152$export$2f35ab04d2335697(e, 0, n), $84a8eb74fa06a152$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $84a8eb74fa06a152$export$82e9f45cca5ba907(n, c, s) {
    switch($84a8eb74fa06a152$export$d6af199866bfb566(n, c)){
        case 5103:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $84a8eb74fa06a152$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$2c0f367103c8d01c + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($84a8eb74fa06a152$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "box-$1$2" + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + "flex-item-" + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$84a8eb74fa06a152$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $84a8eb74fa06a152$export$71ad59f2e432cfe8 + "grid-row-" + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + "flex-line-pack" + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "box-" + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, "-grow", "") + $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $84a8eb74fa06a152$export$39dfd62a25e0fe93 + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $84a8eb74fa06a152$export$77ad94ebf1c2b9ed($84a8eb74fa06a152$export$77ad94ebf1c2b9ed($84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $84a8eb74fa06a152$export$77ad94ebf1c2b9ed($84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "box-pack:$3" + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $84a8eb74fa06a152$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$84a8eb74fa06a152$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $84a8eb74fa06a152$export$71ad59f2e432cfe8 + "grid-column-align" + $84a8eb74fa06a152$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $84a8eb74fa06a152$export$71ad59f2e432cfe8 + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $84a8eb74fa06a152$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$84a8eb74fa06a152$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $84a8eb74fa06a152$export$71ad59f2e432cfe8 + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$84a8eb74fa06a152$export$f8e21b1e77979a08(s, "span") ? $84a8eb74fa06a152$export$4659b591c19bdf3d(s, /\d+/) : +$84a8eb74fa06a152$export$4659b591c19bdf3d(s, /\d+/) - +$84a8eb74fa06a152$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $84a8eb74fa06a152$export$71ad59f2e432cfe8 + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $84a8eb74fa06a152$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $84a8eb74fa06a152$export$71ad59f2e432cfe8 + $84a8eb74fa06a152$export$77ad94ebf1c2b9ed($84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($84a8eb74fa06a152$export$36776f635604f274(n) - 1 - c > 6) switch($84a8eb74fa06a152$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($84a8eb74fa06a152$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $84a8eb74fa06a152$export$2c0f367103c8d01c + ($84a8eb74fa06a152$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$84a8eb74fa06a152$export$f8e21b1e77979a08(n, "stretch") ? $84a8eb74fa06a152$export$82e9f45cca5ba907($84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $84a8eb74fa06a152$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $84a8eb74fa06a152$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($84a8eb74fa06a152$export$a9db5e087081082d(n, c + 6) === 121) return $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, ":", ":" + $84a8eb74fa06a152$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($84a8eb74fa06a152$export$a9db5e087081082d(n, $84a8eb74fa06a152$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $84a8eb74fa06a152$export$39dfd62a25e0fe93 + ($84a8eb74fa06a152$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $84a8eb74fa06a152$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, ":", ":" + $84a8eb74fa06a152$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $84a8eb74fa06a152$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $84a8eb74fa06a152$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $84a8eb74fa06a152$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $84a8eb74fa06a152$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $84a8eb74fa06a152$export$a763edbf796b780a:
        case $84a8eb74fa06a152$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $84a8eb74fa06a152$export$a29989082612d0d9:
            return "";
        case $84a8eb74fa06a152$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $84a8eb74fa06a152$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $84a8eb74fa06a152$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $84a8eb74fa06a152$export$36776f635604f274(a = $84a8eb74fa06a152$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $84a8eb74fa06a152$export$5a7767152ae0305f(e) {
    var r = $84a8eb74fa06a152$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $84a8eb74fa06a152$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $84a8eb74fa06a152$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $84a8eb74fa06a152$export$527d108ccf083c2b:
                n.return = $84a8eb74fa06a152$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $84a8eb74fa06a152$export$b44a8529a35fcb60:
                return $84a8eb74fa06a152$export$dfdc1655ccc5b9cb([
                    $84a8eb74fa06a152$export$784d13d8ee351f07(n, {
                        value: $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $84a8eb74fa06a152$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $84a8eb74fa06a152$export$aa3a2e812ca8570d:
                if (n.length) return $84a8eb74fa06a152$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($84a8eb74fa06a152$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $84a8eb74fa06a152$export$dfdc1655ccc5b9cb([
                                $84a8eb74fa06a152$export$784d13d8ee351f07(n, {
                                    props: [
                                        $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $84a8eb74fa06a152$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $84a8eb74fa06a152$export$dfdc1655ccc5b9cb([
                                $84a8eb74fa06a152$export$784d13d8ee351f07(n, {
                                    props: [
                                        $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $84a8eb74fa06a152$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $84a8eb74fa06a152$export$784d13d8ee351f07(n, {
                                    props: [
                                        $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $84a8eb74fa06a152$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $84a8eb74fa06a152$export$784d13d8ee351f07(n, {
                                    props: [
                                        $84a8eb74fa06a152$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $84a8eb74fa06a152$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $84a8eb74fa06a152$export$76a88f7de6507443(e) {
    switch(e.type){
        case $84a8eb74fa06a152$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $84a8eb74fa06a152$export$1be1fc439b849fdf($84a8eb74fa06a152$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($84a8eb74fa06a152$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $84a8eb74fa06a152$export$2f35ab04d2335697(r, 1, $84a8eb74fa06a152$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $84a8eb74fa06a152$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $84a8eb74fa06a152$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $84a8eb74fa06a152$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("jMVaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e67ed769a984b671$export$2e2bcd8739ae039);
var $e67ed769a984b671$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("6xwrb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c2efc91a435176f$export$2e2bcd8739ae039);
function $4c2efc91a435176f$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("b4xGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $80fa32d28c717c76$export$2e2bcd8739ae039);
var $80fa32d28c717c76$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("2JovX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fd2cccc08b94f2c$export$2e2bcd8739ae039);

var $90hus = parcelRequire("90hus");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $1fd2cccc08b94f2c$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($90hus)))(targetComponent, sourceComponent);
};

});
parcelRegister("90hus", function(module, exports) {
'use strict';

var $k4h6F = parcelRequire("k4h6F");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $68e1ae5e328f6000$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $68e1ae5e328f6000$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $68e1ae5e328f6000$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $68e1ae5e328f6000$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $68e1ae5e328f6000$var$TYPE_STATICS = {};
$68e1ae5e328f6000$var$TYPE_STATICS[$k4h6F.ForwardRef] = $68e1ae5e328f6000$var$FORWARD_REF_STATICS;
$68e1ae5e328f6000$var$TYPE_STATICS[$k4h6F.Memo] = $68e1ae5e328f6000$var$MEMO_STATICS;
function $68e1ae5e328f6000$var$getStatics(component) {
    // React v16.11 and below
    if ($k4h6F.isMemo(component)) return $68e1ae5e328f6000$var$MEMO_STATICS;
     // React v16.12 and above
    return $68e1ae5e328f6000$var$TYPE_STATICS[component['$$typeof']] || $68e1ae5e328f6000$var$REACT_STATICS;
}
var $68e1ae5e328f6000$var$defineProperty = Object.defineProperty;
var $68e1ae5e328f6000$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $68e1ae5e328f6000$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $68e1ae5e328f6000$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $68e1ae5e328f6000$var$getPrototypeOf = Object.getPrototypeOf;
var $68e1ae5e328f6000$var$objectPrototype = Object.prototype;
function $68e1ae5e328f6000$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($68e1ae5e328f6000$var$objectPrototype) {
            var inheritedComponent = $68e1ae5e328f6000$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $68e1ae5e328f6000$var$objectPrototype) $68e1ae5e328f6000$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $68e1ae5e328f6000$var$getOwnPropertyNames(sourceComponent);
        if ($68e1ae5e328f6000$var$getOwnPropertySymbols) keys = keys.concat($68e1ae5e328f6000$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $68e1ae5e328f6000$var$getStatics(targetComponent);
        var sourceStatics = $68e1ae5e328f6000$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$68e1ae5e328f6000$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $68e1ae5e328f6000$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $68e1ae5e328f6000$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $68e1ae5e328f6000$var$hoistNonReactStatics;

});
parcelRegister("k4h6F", function(module, exports) {
'use strict';

module.exports = (parcelRequire("17yUm"));

});
parcelRegister("17yUm", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $0d1185e9738ec001$export$2b8d127b894957b9, (v) => $0d1185e9738ec001$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $0d1185e9738ec001$export$cea3a54a6425200c, (v) => $0d1185e9738ec001$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $0d1185e9738ec001$export$a7c73072b1a182ae, (v) => $0d1185e9738ec001$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $0d1185e9738ec001$export$9f27bc3417b4524d, (v) => $0d1185e9738ec001$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $0d1185e9738ec001$export$db77ccec0bb4ccac, (v) => $0d1185e9738ec001$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $0d1185e9738ec001$export$8392c0c9d3dcbd35, (v) => $0d1185e9738ec001$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $0d1185e9738ec001$export$ffb0004e005737fa, (v) => $0d1185e9738ec001$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $0d1185e9738ec001$export$b624eff549462981, (v) => $0d1185e9738ec001$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $0d1185e9738ec001$export$7897aa7841a5380c, (v) => $0d1185e9738ec001$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $0d1185e9738ec001$export$602eac185826482c, (v) => $0d1185e9738ec001$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $0d1185e9738ec001$export$e2c29f18771995cb, (v) => $0d1185e9738ec001$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $0d1185e9738ec001$export$5f8d39834fd61797, (v) => $0d1185e9738ec001$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0d1185e9738ec001$export$74bf444e3cd11ea5, (v) => $0d1185e9738ec001$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $0d1185e9738ec001$export$92387174baf9b227, (v) => $0d1185e9738ec001$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $0d1185e9738ec001$export$ec112efeb987d9c6, (v) => $0d1185e9738ec001$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $0d1185e9738ec001$export$b706b080d889d2c9, (v) => $0d1185e9738ec001$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $0d1185e9738ec001$export$5be5a87408f70ddc, (v) => $0d1185e9738ec001$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $0d1185e9738ec001$export$45a5e7f76e0caa8d, (v) => $0d1185e9738ec001$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $0d1185e9738ec001$export$455c2e768291efa6, (v) => $0d1185e9738ec001$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $0d1185e9738ec001$export$9522e17588c12572, (v) => $0d1185e9738ec001$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $0d1185e9738ec001$export$2110ac352bb060b9, (v) => $0d1185e9738ec001$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $0d1185e9738ec001$export$56885ab8b9c456ab, (v) => $0d1185e9738ec001$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $0d1185e9738ec001$export$d927fcb6adf8f9de, (v) => $0d1185e9738ec001$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $0d1185e9738ec001$export$b82d16f27459e05a, (v) => $0d1185e9738ec001$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $0d1185e9738ec001$export$522c17b4f5e123e8, (v) => $0d1185e9738ec001$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $0d1185e9738ec001$export$1aabd8a0274ecfd6, (v) => $0d1185e9738ec001$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $0d1185e9738ec001$export$9b621391a187a31a, (v) => $0d1185e9738ec001$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $0d1185e9738ec001$export$f5bbd400c2f4426f, (v) => $0d1185e9738ec001$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0d1185e9738ec001$export$2b8d127b894957b9;
var $0d1185e9738ec001$export$cea3a54a6425200c;
var $0d1185e9738ec001$export$a7c73072b1a182ae;
var $0d1185e9738ec001$export$9f27bc3417b4524d;
var $0d1185e9738ec001$export$db77ccec0bb4ccac;
var $0d1185e9738ec001$export$8392c0c9d3dcbd35;
var $0d1185e9738ec001$export$ffb0004e005737fa;
var $0d1185e9738ec001$export$b624eff549462981;
var $0d1185e9738ec001$export$7897aa7841a5380c;
var $0d1185e9738ec001$export$602eac185826482c;
var $0d1185e9738ec001$export$e2c29f18771995cb;
var $0d1185e9738ec001$export$5f8d39834fd61797;
var $0d1185e9738ec001$export$74bf444e3cd11ea5;
var $0d1185e9738ec001$export$92387174baf9b227;
var $0d1185e9738ec001$export$ec112efeb987d9c6;
var $0d1185e9738ec001$export$b706b080d889d2c9;
var $0d1185e9738ec001$export$5be5a87408f70ddc;
var $0d1185e9738ec001$export$45a5e7f76e0caa8d;
var $0d1185e9738ec001$export$455c2e768291efa6;
var $0d1185e9738ec001$export$9522e17588c12572;
var $0d1185e9738ec001$export$2110ac352bb060b9;
var $0d1185e9738ec001$export$56885ab8b9c456ab;
var $0d1185e9738ec001$export$d927fcb6adf8f9de;
var $0d1185e9738ec001$export$b82d16f27459e05a;
var $0d1185e9738ec001$export$522c17b4f5e123e8;
var $0d1185e9738ec001$export$1aabd8a0274ecfd6;
var $0d1185e9738ec001$export$9b621391a187a31a;
var $0d1185e9738ec001$export$f5bbd400c2f4426f;
'use strict';
var $0d1185e9738ec001$var$b = "function" === typeof Symbol && Symbol.for, $0d1185e9738ec001$var$c = $0d1185e9738ec001$var$b ? Symbol.for("react.element") : 60103, $0d1185e9738ec001$var$d = $0d1185e9738ec001$var$b ? Symbol.for("react.portal") : 60106, $0d1185e9738ec001$var$e = $0d1185e9738ec001$var$b ? Symbol.for("react.fragment") : 60107, $0d1185e9738ec001$var$f = $0d1185e9738ec001$var$b ? Symbol.for("react.strict_mode") : 60108, $0d1185e9738ec001$var$g = $0d1185e9738ec001$var$b ? Symbol.for("react.profiler") : 60114, $0d1185e9738ec001$var$h = $0d1185e9738ec001$var$b ? Symbol.for("react.provider") : 60109, $0d1185e9738ec001$var$k = $0d1185e9738ec001$var$b ? Symbol.for("react.context") : 60110, $0d1185e9738ec001$var$l = $0d1185e9738ec001$var$b ? Symbol.for("react.async_mode") : 60111, $0d1185e9738ec001$var$m = $0d1185e9738ec001$var$b ? Symbol.for("react.concurrent_mode") : 60111, $0d1185e9738ec001$var$n = $0d1185e9738ec001$var$b ? Symbol.for("react.forward_ref") : 60112, $0d1185e9738ec001$var$p = $0d1185e9738ec001$var$b ? Symbol.for("react.suspense") : 60113, $0d1185e9738ec001$var$q = $0d1185e9738ec001$var$b ? Symbol.for("react.suspense_list") : 60120, $0d1185e9738ec001$var$r = $0d1185e9738ec001$var$b ? Symbol.for("react.memo") : 60115, $0d1185e9738ec001$var$t = $0d1185e9738ec001$var$b ? Symbol.for("react.lazy") : 60116, $0d1185e9738ec001$var$v = $0d1185e9738ec001$var$b ? Symbol.for("react.block") : 60121, $0d1185e9738ec001$var$w = $0d1185e9738ec001$var$b ? Symbol.for("react.fundamental") : 60117, $0d1185e9738ec001$var$x = $0d1185e9738ec001$var$b ? Symbol.for("react.responder") : 60118, $0d1185e9738ec001$var$y = $0d1185e9738ec001$var$b ? Symbol.for("react.scope") : 60119;
function $0d1185e9738ec001$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $0d1185e9738ec001$var$c:
                switch(a = a.type, a){
                    case $0d1185e9738ec001$var$l:
                    case $0d1185e9738ec001$var$m:
                    case $0d1185e9738ec001$var$e:
                    case $0d1185e9738ec001$var$g:
                    case $0d1185e9738ec001$var$f:
                    case $0d1185e9738ec001$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $0d1185e9738ec001$var$k:
                            case $0d1185e9738ec001$var$n:
                            case $0d1185e9738ec001$var$t:
                            case $0d1185e9738ec001$var$r:
                            case $0d1185e9738ec001$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $0d1185e9738ec001$var$d:
                return u;
        }
    }
}
function $0d1185e9738ec001$var$A(a) {
    return $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$m;
}
$0d1185e9738ec001$export$2b8d127b894957b9 = $0d1185e9738ec001$var$l;
$0d1185e9738ec001$export$cea3a54a6425200c = $0d1185e9738ec001$var$m;
$0d1185e9738ec001$export$a7c73072b1a182ae = $0d1185e9738ec001$var$k;
$0d1185e9738ec001$export$9f27bc3417b4524d = $0d1185e9738ec001$var$h;
$0d1185e9738ec001$export$db77ccec0bb4ccac = $0d1185e9738ec001$var$c;
$0d1185e9738ec001$export$8392c0c9d3dcbd35 = $0d1185e9738ec001$var$n;
$0d1185e9738ec001$export$ffb0004e005737fa = $0d1185e9738ec001$var$e;
$0d1185e9738ec001$export$b624eff549462981 = $0d1185e9738ec001$var$t;
$0d1185e9738ec001$export$7897aa7841a5380c = $0d1185e9738ec001$var$r;
$0d1185e9738ec001$export$602eac185826482c = $0d1185e9738ec001$var$d;
$0d1185e9738ec001$export$e2c29f18771995cb = $0d1185e9738ec001$var$g;
$0d1185e9738ec001$export$5f8d39834fd61797 = $0d1185e9738ec001$var$f;
$0d1185e9738ec001$export$74bf444e3cd11ea5 = $0d1185e9738ec001$var$p;
$0d1185e9738ec001$export$92387174baf9b227 = function(a) {
    return $0d1185e9738ec001$var$A(a) || $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$l;
};
$0d1185e9738ec001$export$ec112efeb987d9c6 = $0d1185e9738ec001$var$A;
$0d1185e9738ec001$export$b706b080d889d2c9 = function(a) {
    return $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$k;
};
$0d1185e9738ec001$export$5be5a87408f70ddc = function(a) {
    return $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$h;
};
$0d1185e9738ec001$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0d1185e9738ec001$var$c;
};
$0d1185e9738ec001$export$455c2e768291efa6 = function(a) {
    return $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$n;
};
$0d1185e9738ec001$export$9522e17588c12572 = function(a) {
    return $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$e;
};
$0d1185e9738ec001$export$2110ac352bb060b9 = function(a) {
    return $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$t;
};
$0d1185e9738ec001$export$56885ab8b9c456ab = function(a) {
    return $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$r;
};
$0d1185e9738ec001$export$d927fcb6adf8f9de = function(a) {
    return $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$d;
};
$0d1185e9738ec001$export$b82d16f27459e05a = function(a) {
    return $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$g;
};
$0d1185e9738ec001$export$522c17b4f5e123e8 = function(a) {
    return $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$f;
};
$0d1185e9738ec001$export$1aabd8a0274ecfd6 = function(a) {
    return $0d1185e9738ec001$var$z(a) === $0d1185e9738ec001$var$p;
};
$0d1185e9738ec001$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $0d1185e9738ec001$var$e || a === $0d1185e9738ec001$var$m || a === $0d1185e9738ec001$var$g || a === $0d1185e9738ec001$var$f || a === $0d1185e9738ec001$var$p || a === $0d1185e9738ec001$var$q || "object" === typeof a && null !== a && (a.$$typeof === $0d1185e9738ec001$var$t || a.$$typeof === $0d1185e9738ec001$var$r || a.$$typeof === $0d1185e9738ec001$var$h || a.$$typeof === $0d1185e9738ec001$var$k || a.$$typeof === $0d1185e9738ec001$var$n || a.$$typeof === $0d1185e9738ec001$var$w || a.$$typeof === $0d1185e9738ec001$var$x || a.$$typeof === $0d1185e9738ec001$var$y || a.$$typeof === $0d1185e9738ec001$var$v);
};
$0d1185e9738ec001$export$f5bbd400c2f4426f = $0d1185e9738ec001$var$z;

});




parcelRegister("cfloP", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $8ea77c3fe4f7a240$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $8ea77c3fe4f7a240$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $8ea77c3fe4f7a240$export$6f077d94b33a01aa);
var $8ea77c3fe4f7a240$var$isBrowser = typeof document !== 'undefined';
function $8ea77c3fe4f7a240$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $8ea77c3fe4f7a240$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $8ea77c3fe4f7a240$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $8ea77c3fe4f7a240$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $8ea77c3fe4f7a240$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$8ea77c3fe4f7a240$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$8ea77c3fe4f7a240$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("2WE2O", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $22500f84310e4a37$export$6321afa313b251b5);

var $2r9p1 = parcelRequire("2r9p1");

var $hf6BA = parcelRequire("hf6BA");

var $6xwrb = parcelRequire("6xwrb");
var $22500f84310e4a37$var$isDevelopment = false;
var $22500f84310e4a37$var$hyphenateRegex = /[A-Z]|^ms/g;
var $22500f84310e4a37$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $22500f84310e4a37$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $22500f84310e4a37$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $22500f84310e4a37$var$processStyleName = /* #__PURE__ */ (0, $6xwrb.default)(function(styleName) {
    return $22500f84310e4a37$var$isCustomProperty(styleName) ? styleName : styleName.replace($22500f84310e4a37$var$hyphenateRegex, '-$&').toLowerCase();
});
var $22500f84310e4a37$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($22500f84310e4a37$var$animationRegex, function(match, p1, p2) {
                $22500f84310e4a37$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $22500f84310e4a37$var$cursor
                };
                return p1;
            });
    }
    if ((0, $hf6BA.default)[key] !== 1 && !$22500f84310e4a37$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $22500f84310e4a37$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $22500f84310e4a37$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $22500f84310e4a37$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $22500f84310e4a37$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $22500f84310e4a37$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $22500f84310e4a37$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $22500f84310e4a37$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $22500f84310e4a37$var$cursor;
                var result = interpolation(mergedProps);
                $22500f84310e4a37$var$cursor = previousCursor;
                return $22500f84310e4a37$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $22500f84310e4a37$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $22500f84310e4a37$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($22500f84310e4a37$var$isProcessableValue(asString)) string += $22500f84310e4a37$var$processStyleName(key) + ":" + $22500f84310e4a37$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $22500f84310e4a37$var$isDevelopment) throw new Error($22500f84310e4a37$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($22500f84310e4a37$var$isProcessableValue(value[_i])) string += $22500f84310e4a37$var$processStyleName(key) + ":" + $22500f84310e4a37$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $22500f84310e4a37$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $22500f84310e4a37$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $22500f84310e4a37$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $22500f84310e4a37$var$cursor;
function $22500f84310e4a37$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $22500f84310e4a37$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $22500f84310e4a37$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $22500f84310e4a37$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $22500f84310e4a37$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $22500f84310e4a37$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $2r9p1.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $22500f84310e4a37$var$cursor
    };
}

});
parcelRegister("2r9p1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c656586d747aa39$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1c656586d747aa39$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("hf6BA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d8f6107df43c52$export$2e2bcd8739ae039);
var $c8d8f6107df43c52$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("4PcT3", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $3835ebe75eadb2b6$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $3835ebe75eadb2b6$export$811a713a7276cb9d);

var $eeyUA = parcelRequire("eeyUA");
var $3835ebe75eadb2b6$var$isBrowser = typeof document !== 'undefined';
var $3835ebe75eadb2b6$var$syncFallback = function syncFallback(create) {
    return create();
};
var $3835ebe75eadb2b6$var$useInsertionEffect = $eeyUA.useInsertionEffect ? $eeyUA.useInsertionEffect : false;
var $3835ebe75eadb2b6$export$db21c7ffa21794e7 = !$3835ebe75eadb2b6$var$isBrowser ? $3835ebe75eadb2b6$var$syncFallback : $3835ebe75eadb2b6$var$useInsertionEffect || $3835ebe75eadb2b6$var$syncFallback;
var $3835ebe75eadb2b6$export$811a713a7276cb9d = $3835ebe75eadb2b6$var$useInsertionEffect || $eeyUA.useLayoutEffect;

});


parcelRegister("9nayj", function(module, exports) {
function $6d2e728a872d87b7$var$_extends() {
    return module.exports = $6d2e728a872d87b7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6d2e728a872d87b7$var$_extends.apply(null, arguments);
}
module.exports = $6d2e728a872d87b7$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("fQUvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8a78b410ecbd2f2$export$2e2bcd8739ae039);

var $eA6mq = parcelRequire("eA6mq");
'use client';
const $b8a78b410ecbd2f2$var$defaultTheme = (0, $eA6mq.default)();
var $b8a78b410ecbd2f2$export$2e2bcd8739ae039 = $b8a78b410ecbd2f2$var$defaultTheme;

});
parcelRegister("eA6mq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d95c985f6fecb1$export$2e2bcd8739ae039);

var $7Nobb = parcelRequire("7Nobb");

var $8T8Yq = parcelRequire("8T8Yq");

var $l4W6n = parcelRequire("l4W6n");

var $f41I8 = parcelRequire("f41I8");

var $aF1tN = parcelRequire("aF1tN");
var $euq5j = parcelRequire("euq5j");

var $kBzHD = parcelRequire("kBzHD");


var $1ggtw = parcelRequire("1ggtw");

var $aLVOE = parcelRequire("aLVOE");

var $gePrR = parcelRequire("gePrR");

var $ihfFG = parcelRequire("ihfFG");

var $jUdkD = parcelRequire("jUdkD");

var $6P4l5 = parcelRequire("6P4l5");
const $a9d95c985f6fecb1$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $a9d95c985f6fecb1$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $8T8Yq.default)(options, $a9d95c985f6fecb1$var$_excluded);
    if (options.vars) throw new Error((0, $l4W6n.default)(18));
    const palette = (0, $aLVOE.default)(paletteInput);
    const systemTheme = (0, $kBzHD.default)(options);
    let muiTheme = (0, $f41I8.default)(systemTheme, {
        mixins: (0, $1ggtw.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $ihfFG.default).slice(),
        typography: (0, $gePrR.default)(palette, typographyInput),
        transitions: (0, $jUdkD.default)(transitionsInput),
        zIndex: (0, $7Nobb.default)({}, (0, $6P4l5.default))
    });
    muiTheme = (0, $f41I8.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $f41I8.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $7Nobb.default)({}, (0, $euq5j.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $aF1tN.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $a9d95c985f6fecb1$var$warnedOnce = false;
function $a9d95c985f6fecb1$export$c469355549431d9b(...args) {
    return $a9d95c985f6fecb1$var$createTheme(...args);
}
var $a9d95c985f6fecb1$export$2e2bcd8739ae039 = $a9d95c985f6fecb1$var$createTheme;

});
parcelRegister("1ggtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb410b6f3363ced$export$2e2bcd8739ae039);

var $7Nobb = parcelRequire("7Nobb");
function $0eb410b6f3363ced$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $7Nobb.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("aLVOE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7b24365b344b3f$export$2e2bcd8739ae039);

var $7Nobb = parcelRequire("7Nobb");

var $8T8Yq = parcelRequire("8T8Yq");

var $l4W6n = parcelRequire("l4W6n");

var $f41I8 = parcelRequire("f41I8");

var $ajq9C = parcelRequire("ajq9C");

var $14YhP = parcelRequire("14YhP");

var $6hMHh = parcelRequire("6hMHh");

var $9MW8V = parcelRequire("9MW8V");

var $2RBd6 = parcelRequire("2RBd6");

var $fJOCs = parcelRequire("fJOCs");

var $8r7Mf = parcelRequire("8r7Mf");

var $ge9Sn = parcelRequire("ge9Sn");

var $aAYZz = parcelRequire("aAYZz");
const $7d7b24365b344b3f$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $7d7b24365b344b3f$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $14YhP.default).white,
        default: (0, $14YhP.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $7d7b24365b344b3f$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $14YhP.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $14YhP.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $7d7b24365b344b3f$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $ajq9C.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $ajq9C.darken)(intent.main, tonalOffsetDark);
    }
}
function $7d7b24365b344b3f$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $8r7Mf.default)[200],
        light: (0, $8r7Mf.default)[50],
        dark: (0, $8r7Mf.default)[400]
    };
    return {
        main: (0, $8r7Mf.default)[700],
        light: (0, $8r7Mf.default)[400],
        dark: (0, $8r7Mf.default)[800]
    };
}
function $7d7b24365b344b3f$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9MW8V.default)[200],
        light: (0, $9MW8V.default)[50],
        dark: (0, $9MW8V.default)[400]
    };
    return {
        main: (0, $9MW8V.default)[500],
        light: (0, $9MW8V.default)[300],
        dark: (0, $9MW8V.default)[700]
    };
}
function $7d7b24365b344b3f$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $2RBd6.default)[500],
        light: (0, $2RBd6.default)[300],
        dark: (0, $2RBd6.default)[700]
    };
    return {
        main: (0, $2RBd6.default)[700],
        light: (0, $2RBd6.default)[400],
        dark: (0, $2RBd6.default)[800]
    };
}
function $7d7b24365b344b3f$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ge9Sn.default)[400],
        light: (0, $ge9Sn.default)[300],
        dark: (0, $ge9Sn.default)[700]
    };
    return {
        main: (0, $ge9Sn.default)[700],
        light: (0, $ge9Sn.default)[500],
        dark: (0, $ge9Sn.default)[900]
    };
}
function $7d7b24365b344b3f$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $aAYZz.default)[400],
        light: (0, $aAYZz.default)[300],
        dark: (0, $aAYZz.default)[700]
    };
    return {
        main: (0, $aAYZz.default)[800],
        light: (0, $aAYZz.default)[500],
        dark: (0, $aAYZz.default)[900]
    };
}
function $7d7b24365b344b3f$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $fJOCs.default)[400],
        light: (0, $fJOCs.default)[300],
        dark: (0, $fJOCs.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $fJOCs.default)[500],
        dark: (0, $fJOCs.default)[900]
    };
}
function $7d7b24365b344b3f$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $8T8Yq.default)(palette, $7d7b24365b344b3f$var$_excluded);
    const primary = palette.primary || $7d7b24365b344b3f$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $7d7b24365b344b3f$var$getDefaultSecondary(mode);
    const error = palette.error || $7d7b24365b344b3f$var$getDefaultError(mode);
    const info = palette.info || $7d7b24365b344b3f$var$getDefaultInfo(mode);
    const success = palette.success || $7d7b24365b344b3f$var$getDefaultSuccess(mode);
    const warning = palette.warning || $7d7b24365b344b3f$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $ajq9C.getContrastRatio)(background, $7d7b24365b344b3f$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $7d7b24365b344b3f$export$55ce6f3a06c59543.text.primary : $7d7b24365b344b3f$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $7Nobb.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $l4W6n.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $l4W6n.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $7d7b24365b344b3f$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $7d7b24365b344b3f$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $7d7b24365b344b3f$export$55ce6f3a06c59543,
        light: $7d7b24365b344b3f$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $f41I8.default)((0, $7Nobb.default)({
        // A collection of common colors.
        common: (0, $7Nobb.default)({}, (0, $14YhP.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $6hMHh.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("ajq9C", function(module, exports) {
"use strict";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $781ff769e57096c3$var$alpha;
module.exports.blend = $781ff769e57096c3$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $781ff769e57096c3$var$darken;
module.exports.decomposeColor = $781ff769e57096c3$var$decomposeColor;
module.exports.emphasize = $781ff769e57096c3$var$emphasize;
module.exports.getContrastRatio = $781ff769e57096c3$var$getContrastRatio;
module.exports.getLuminance = $781ff769e57096c3$var$getLuminance;
module.exports.hexToRgb = $781ff769e57096c3$var$hexToRgb;
module.exports.hslToRgb = $781ff769e57096c3$var$hslToRgb;
module.exports.lighten = $781ff769e57096c3$var$lighten;
module.exports.private_safeAlpha = $781ff769e57096c3$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $781ff769e57096c3$var$private_safeDarken;
module.exports.private_safeEmphasize = $781ff769e57096c3$var$private_safeEmphasize;
module.exports.private_safeLighten = $781ff769e57096c3$var$private_safeLighten;
module.exports.recomposeColor = $781ff769e57096c3$var$recomposeColor;
module.exports.rgbToHex = $781ff769e57096c3$var$rgbToHex;

var $781ff769e57096c3$var$_formatMuiErrorMessage2 = $bl52K((parcelRequire("dVqDZ")));

var $781ff769e57096c3$var$_clamp = $bl52K((parcelRequire("cbCmp")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $781ff769e57096c3$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $781ff769e57096c3$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $781ff769e57096c3$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $781ff769e57096c3$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $781ff769e57096c3$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $781ff769e57096c3$var$decomposeColor($781ff769e57096c3$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $781ff769e57096c3$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $781ff769e57096c3$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $781ff769e57096c3$var$colorChannel = (color)=>{
    const decomposedColor = $781ff769e57096c3$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $781ff769e57096c3$var$colorChannel;
const $781ff769e57096c3$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $781ff769e57096c3$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $781ff769e57096c3$var$private_safeColorChannel;
function $781ff769e57096c3$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $781ff769e57096c3$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $781ff769e57096c3$var$decomposeColor(color);
    return `#${values.map((n, i)=>$781ff769e57096c3$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $781ff769e57096c3$var$hslToRgb(color) {
    color = $781ff769e57096c3$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $781ff769e57096c3$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $781ff769e57096c3$var$getLuminance(color) {
    color = $781ff769e57096c3$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $781ff769e57096c3$var$decomposeColor($781ff769e57096c3$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $781ff769e57096c3$var$getContrastRatio(foreground, background) {
    const lumA = $781ff769e57096c3$var$getLuminance(foreground);
    const lumB = $781ff769e57096c3$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $781ff769e57096c3$var$alpha(color, value) {
    color = $781ff769e57096c3$var$decomposeColor(color);
    value = $781ff769e57096c3$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $781ff769e57096c3$var$recomposeColor(color);
}
function $781ff769e57096c3$var$private_safeAlpha(color, value, warning) {
    try {
        return $781ff769e57096c3$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $781ff769e57096c3$var$darken(color, coefficient) {
    color = $781ff769e57096c3$var$decomposeColor(color);
    coefficient = $781ff769e57096c3$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $781ff769e57096c3$var$recomposeColor(color);
}
function $781ff769e57096c3$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $781ff769e57096c3$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $781ff769e57096c3$var$lighten(color, coefficient) {
    color = $781ff769e57096c3$var$decomposeColor(color);
    coefficient = $781ff769e57096c3$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $781ff769e57096c3$var$recomposeColor(color);
}
function $781ff769e57096c3$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $781ff769e57096c3$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $781ff769e57096c3$var$emphasize(color, coefficient = 0.15) {
    return $781ff769e57096c3$var$getLuminance(color) > 0.5 ? $781ff769e57096c3$var$darken(color, coefficient) : $781ff769e57096c3$var$lighten(color, coefficient);
}
function $781ff769e57096c3$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $781ff769e57096c3$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $781ff769e57096c3$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $781ff769e57096c3$var$decomposeColor(background);
    const overlayColor = $781ff769e57096c3$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $781ff769e57096c3$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("bl52K", function(module, exports) {
function $841591597e746a3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $841591597e746a3b$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dVqDZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("l4W6n")).default);

var $l4W6n = parcelRequire("l4W6n");

});

parcelRegister("cbCmp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("du4YY")).default);

var $du4YY = parcelRequire("du4YY");

});
parcelRegister("du4YY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d11f122e1a2aa13$export$2e2bcd8739ae039);
function $9d11f122e1a2aa13$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $9d11f122e1a2aa13$export$2e2bcd8739ae039 = $9d11f122e1a2aa13$var$clamp;

});



parcelRegister("14YhP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c94edd040066f3f$export$2e2bcd8739ae039);
const $0c94edd040066f3f$var$common = {
    black: '#000',
    white: '#fff'
};
var $0c94edd040066f3f$export$2e2bcd8739ae039 = $0c94edd040066f3f$var$common;

});

parcelRegister("6hMHh", function(module, exports) {

$parcel$export(module.exports, "default", () => $493a1adac44be457$export$2e2bcd8739ae039);
const $493a1adac44be457$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $493a1adac44be457$export$2e2bcd8739ae039 = $493a1adac44be457$var$grey;

});

parcelRegister("9MW8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $7205b2bcdbb62f9b$export$2e2bcd8739ae039);
const $7205b2bcdbb62f9b$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $7205b2bcdbb62f9b$export$2e2bcd8739ae039 = $7205b2bcdbb62f9b$var$purple;

});

parcelRegister("2RBd6", function(module, exports) {

$parcel$export(module.exports, "default", () => $215d652ea2ebcad0$export$2e2bcd8739ae039);
const $215d652ea2ebcad0$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $215d652ea2ebcad0$export$2e2bcd8739ae039 = $215d652ea2ebcad0$var$red;

});

parcelRegister("fJOCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b75252ef566ad25d$export$2e2bcd8739ae039);
const $b75252ef566ad25d$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $b75252ef566ad25d$export$2e2bcd8739ae039 = $b75252ef566ad25d$var$orange;

});

parcelRegister("8r7Mf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6246e0bba7363a9b$export$2e2bcd8739ae039);
const $6246e0bba7363a9b$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $6246e0bba7363a9b$export$2e2bcd8739ae039 = $6246e0bba7363a9b$var$blue;

});

parcelRegister("ge9Sn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd059d508c38d993$export$2e2bcd8739ae039);
const $bd059d508c38d993$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $bd059d508c38d993$export$2e2bcd8739ae039 = $bd059d508c38d993$var$lightBlue;

});

parcelRegister("aAYZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b6c93f139a96cb7$export$2e2bcd8739ae039);
const $7b6c93f139a96cb7$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $7b6c93f139a96cb7$export$2e2bcd8739ae039 = $7b6c93f139a96cb7$var$green;

});


parcelRegister("gePrR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd25dcb47bb5f327$export$2e2bcd8739ae039);

var $7Nobb = parcelRequire("7Nobb");

var $8T8Yq = parcelRequire("8T8Yq");

var $f41I8 = parcelRequire("f41I8");
const $bd25dcb47bb5f327$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $bd25dcb47bb5f327$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $bd25dcb47bb5f327$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $bd25dcb47bb5f327$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $bd25dcb47bb5f327$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $bd25dcb47bb5f327$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $8T8Yq.default)(_ref, $bd25dcb47bb5f327$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $7Nobb.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $bd25dcb47bb5f327$var$defaultFontFamily ? {
            letterSpacing: `${$bd25dcb47bb5f327$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $bd25dcb47bb5f327$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $bd25dcb47bb5f327$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $f41I8.default)((0, $7Nobb.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("ihfFG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4e5f88b5a70ea6b$export$2e2bcd8739ae039);
const $d4e5f88b5a70ea6b$var$shadowKeyUmbraOpacity = 0.2;
const $d4e5f88b5a70ea6b$var$shadowKeyPenumbraOpacity = 0.14;
const $d4e5f88b5a70ea6b$var$shadowAmbientShadowOpacity = 0.12;
function $d4e5f88b5a70ea6b$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$d4e5f88b5a70ea6b$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$d4e5f88b5a70ea6b$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$d4e5f88b5a70ea6b$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $d4e5f88b5a70ea6b$var$shadows = [
    'none',
    $d4e5f88b5a70ea6b$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $d4e5f88b5a70ea6b$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $d4e5f88b5a70ea6b$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $d4e5f88b5a70ea6b$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $d4e5f88b5a70ea6b$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $d4e5f88b5a70ea6b$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $d4e5f88b5a70ea6b$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $d4e5f88b5a70ea6b$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $d4e5f88b5a70ea6b$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $d4e5f88b5a70ea6b$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $d4e5f88b5a70ea6b$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $d4e5f88b5a70ea6b$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $d4e5f88b5a70ea6b$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $d4e5f88b5a70ea6b$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $d4e5f88b5a70ea6b$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $d4e5f88b5a70ea6b$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $d4e5f88b5a70ea6b$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $d4e5f88b5a70ea6b$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $d4e5f88b5a70ea6b$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $d4e5f88b5a70ea6b$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $d4e5f88b5a70ea6b$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $d4e5f88b5a70ea6b$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $d4e5f88b5a70ea6b$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $d4e5f88b5a70ea6b$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $d4e5f88b5a70ea6b$export$2e2bcd8739ae039 = $d4e5f88b5a70ea6b$var$shadows;

});

parcelRegister("jUdkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7dd96b94562642f$export$2e2bcd8739ae039);

var $8T8Yq = parcelRequire("8T8Yq");

var $7Nobb = parcelRequire("7Nobb");
const $e7dd96b94562642f$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $e7dd96b94562642f$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $e7dd96b94562642f$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $e7dd96b94562642f$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $e7dd96b94562642f$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $e7dd96b94562642f$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $7Nobb.default)({}, $e7dd96b94562642f$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $7Nobb.default)({}, $e7dd96b94562642f$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $8T8Yq.default)(options, $e7dd96b94562642f$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $e7dd96b94562642f$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $e7dd96b94562642f$var$formatMs(delay)}`).join(',');
    };
    return (0, $7Nobb.default)({
        getAutoHeightDuration: $e7dd96b94562642f$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("6P4l5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f7adf2505942039$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $4f7adf2505942039$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $4f7adf2505942039$export$2e2bcd8739ae039 = $4f7adf2505942039$var$zIndex;

});



parcelRegister("jLld0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e632dbbd122b63fb$export$2e2bcd8739ae039);
var $e632dbbd122b63fb$export$2e2bcd8739ae039 = '$$material';

});


parcelRegister("fRobA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8be910e2fbd0230$export$2e2bcd8739ae039);

var $1hcAw = parcelRequire("1hcAw");

var $fQUvq = parcelRequire("fQUvq");

var $jLld0 = parcelRequire("jLld0");

var $fJeA4 = parcelRequire("fJeA4");

'use client';
const $b8be910e2fbd0230$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($1hcAw)))({
    themeId: (0, $jLld0.default),
    defaultTheme: $fQUvq.default,
    rootShouldForwardProp: $fJeA4.default
});
var $b8be910e2fbd0230$export$2e2bcd8739ae039 = $b8be910e2fbd0230$var$styled;

});
parcelRegister("1hcAw", function(module, exports) {
"use strict";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0ee124b390e9280b$var$createStyled;
module.exports.shouldForwardProp = $0ee124b390e9280b$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $0ee124b390e9280b$var$_extends2 = $bl52K((parcelRequire("9nayj")));

var $0ee124b390e9280b$var$_objectWithoutPropertiesLoose2 = $bl52K((parcelRequire("h7coc")));

var $0ee124b390e9280b$var$_styledEngine = $0ee124b390e9280b$var$_interopRequireWildcard((parcelRequire("fnr4D")));

var $f41I8 = parcelRequire("f41I8");

var $0ee124b390e9280b$var$_capitalize = $bl52K((parcelRequire("havsf")));

var $0ee124b390e9280b$var$_getDisplayName = $bl52K((parcelRequire("3Ispu")));

var $0ee124b390e9280b$var$_createTheme = $bl52K((parcelRequire("juBCB")));

var $0ee124b390e9280b$var$_styleFunctionSx = $bl52K((parcelRequire("asMfg")));
const $0ee124b390e9280b$var$_excluded = [
    "ownerState"
], $0ee124b390e9280b$var$_excluded2 = [
    "variants"
], $0ee124b390e9280b$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $0ee124b390e9280b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0ee124b390e9280b$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $0ee124b390e9280b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $0ee124b390e9280b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $0ee124b390e9280b$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $0ee124b390e9280b$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $0ee124b390e9280b$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $0ee124b390e9280b$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $0ee124b390e9280b$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $0ee124b390e9280b$var$_createTheme.default)();
const $0ee124b390e9280b$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $0ee124b390e9280b$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $0ee124b390e9280b$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $0ee124b390e9280b$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $0ee124b390e9280b$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $0ee124b390e9280b$var$_objectWithoutPropertiesLoose2.default)(_ref, $0ee124b390e9280b$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $0ee124b390e9280b$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$0ee124b390e9280b$var$processStyleArg(resolvedStyle, (0, $0ee124b390e9280b$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $0ee124b390e9280b$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $0ee124b390e9280b$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $0ee124b390e9280b$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $0ee124b390e9280b$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $0ee124b390e9280b$var$shallowLayer((0, $0ee124b390e9280b$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $0ee124b390e9280b$var$shallowLayer((0, $0ee124b390e9280b$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $0ee124b390e9280b$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $0ee124b390e9280b$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $0ee124b390e9280b$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $0ee124b390e9280b$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $0ee124b390e9280b$var$_styleFunctionSx.default)((0, $0ee124b390e9280b$var$_extends2.default)({}, props, {
            theme: $0ee124b390e9280b$var$resolveTheme((0, $0ee124b390e9280b$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $0ee124b390e9280b$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $0ee124b390e9280b$var$defaultOverridesResolver($0ee124b390e9280b$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $0ee124b390e9280b$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $0ee124b390e9280b$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $0ee124b390e9280b$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($0ee124b390e9280b$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $0ee124b390e9280b$var$_styledEngine.default)(tag, (0, $0ee124b390e9280b$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $f41I8.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $0ee124b390e9280b$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $0ee124b390e9280b$var$processStyleArg(stylesArg, (0, $0ee124b390e9280b$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0ee124b390e9280b$var$resolveTheme((0, $0ee124b390e9280b$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $0ee124b390e9280b$var$processStyleArg(slotStyle, (0, $0ee124b390e9280b$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $0ee124b390e9280b$var$resolveTheme((0, $0ee124b390e9280b$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $0ee124b390e9280b$var$processStyleArg({
                    variants: themeVariants
                }, (0, $0ee124b390e9280b$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("h7coc", function(module, exports) {
function $c75cb3633e279c1d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $c75cb3633e279c1d$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fnr4D", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b31e014af19aeb66$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $b31e014af19aeb66$export$e00380445f2b9e0c);
$parcel$export(module.exports, "internal_serializeStyles", () => $b31e014af19aeb66$export$13a2d3ef13012b32);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("3M4a6")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("evqAe")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("evqAe")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("js0BJ")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("fWq5h")).default);
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $6nZhc = parcelRequire("6nZhc");

var $2WE2O = parcelRequire("2WE2O");

var $evqAe = parcelRequire("evqAe");
var $3M4a6 = parcelRequire("3M4a6");

var $js0BJ = parcelRequire("js0BJ");

var $fWq5h = parcelRequire("fWq5h");
'use client';
function $b31e014af19aeb66$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $6nZhc.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $b31e014af19aeb66$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $b31e014af19aeb66$var$wrapper = [];
function $b31e014af19aeb66$export$13a2d3ef13012b32(styles) {
    $b31e014af19aeb66$var$wrapper[0] = styles;
    return (0, $2WE2O.serializeStyles)($b31e014af19aeb66$var$wrapper);
}

});
parcelRegister("6nZhc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a646c4d40b356f1$export$2e2bcd8739ae039);

var $3bCyl = parcelRequire("3bCyl");
parcelRequire("9nayj");
parcelRequire("eeyUA");
parcelRequire("k3T3I");

parcelRequire("cfloP");
parcelRequire("2WE2O");
parcelRequire("4PcT3");
var $4a646c4d40b356f1$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $4a646c4d40b356f1$export$2e2bcd8739ae039 = (0, $3bCyl.default).bind();
$4a646c4d40b356f1$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $4a646c4d40b356f1$export$2e2bcd8739ae039[tagName] = $4a646c4d40b356f1$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("3bCyl", function(module, exports) {

$parcel$export(module.exports, "default", () => $25204df774cbfb64$export$2e2bcd8739ae039);

var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");

var $k3T3I = parcelRequire("k3T3I");
parcelRequire("evqAe");
var $3M4a6 = parcelRequire("3M4a6");

var $cfloP = parcelRequire("cfloP");

var $2WE2O = parcelRequire("2WE2O");

var $4PcT3 = parcelRequire("4PcT3");
var $25204df774cbfb64$var$testOmitPropsOnStringTag = (0, $k3T3I.default);
var $25204df774cbfb64$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $25204df774cbfb64$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $25204df774cbfb64$var$testOmitPropsOnStringTag : $25204df774cbfb64$var$testOmitPropsOnComponent;
};
var $25204df774cbfb64$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $25204df774cbfb64$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $25204df774cbfb64$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $cfloP.registerStyles)(cache, serialized, isStringTag);
    (0, $4PcT3.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $cfloP.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $25204df774cbfb64$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $25204df774cbfb64$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $25204df774cbfb64$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $3M4a6.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $eeyUA.useContext((0, $3M4a6.T));
            }
            if (typeof props.className === 'string') className = (0, $cfloP.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $2WE2O.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $25204df774cbfb64$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, /*#__PURE__*/ $eeyUA.createElement($25204df774cbfb64$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $eeyUA.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $7Nobb.default)({}, options, nextOptions, {
                shouldForwardProp: $25204df774cbfb64$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("k3T3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9aecc0228727f5a$export$2e2bcd8739ae039);

var $6xwrb = parcelRequire("6xwrb");
// eslint-disable-next-line no-undef
var $e9aecc0228727f5a$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $e9aecc0228727f5a$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6xwrb.default)(function(prop) {
    return $e9aecc0228727f5a$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("js0BJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2911a7d8e585b92$export$2e2bcd8739ae039);

var $eeyUA = parcelRequire("eeyUA");


var $3M4a6 = parcelRequire("3M4a6");

var $9qOEN = parcelRequire("9qOEN");

var $e9nev = parcelRequire("e9nev");
'use client';
function $e2911a7d8e585b92$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $9qOEN.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $e2911a7d8e585b92$var$cacheMap = new Map();
function $e2911a7d8e585b92$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $eeyUA.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $e2911a7d8e585b92$var$cacheMap.has(cacheKey)) return $e2911a7d8e585b92$var$cacheMap.get(cacheKey);
        const fresh = $e2911a7d8e585b92$var$getCache(injectFirst, enableCssLayer);
        $e2911a7d8e585b92$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $e9nev.jsx)((0, $3M4a6.C), {
        value: cache,
        children: children
    });
    return children;
}

});
parcelRegister("e9nev", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aJ5BM"));

});


parcelRegister("fWq5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9b0818d74a55406$export$2e2bcd8739ae039);
parcelRequire("eeyUA");


var $evqAe = parcelRequire("evqAe");

var $e9nev = parcelRequire("e9nev");
'use client';
function $b9b0818d74a55406$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $b9b0818d74a55406$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($b9b0818d74a55406$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $e9nev.jsx)((0, $evqAe.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("havsf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("3wBkp")).default);

var $3wBkp = parcelRequire("3wBkp");

});

parcelRegister("3Ispu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("4xWNq")).default);

var $4xWNq = parcelRequire("4xWNq");
$parcel$exportWildcard(module.exports, $4xWNq);

});
parcelRegister("4xWNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $34f7da2cb24110cd$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $34f7da2cb24110cd$export$2e2bcd8739ae039);

var $jKogB = parcelRequire("jKogB");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $34f7da2cb24110cd$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $34f7da2cb24110cd$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($34f7da2cb24110cd$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $34f7da2cb24110cd$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $34f7da2cb24110cd$export$aad197c7121a6651(Component) || fallback;
}
function $34f7da2cb24110cd$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $34f7da2cb24110cd$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $34f7da2cb24110cd$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $34f7da2cb24110cd$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $jKogB.ForwardRef:
            return $34f7da2cb24110cd$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $jKogB.Memo:
            return $34f7da2cb24110cd$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("jKogB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ehoK4"));

});
parcelRegister("ehoK4", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $a655d87bf90a6b19$export$a7c73072b1a182ae, (v) => $a655d87bf90a6b19$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a655d87bf90a6b19$export$9f27bc3417b4524d, (v) => $a655d87bf90a6b19$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a655d87bf90a6b19$export$db77ccec0bb4ccac, (v) => $a655d87bf90a6b19$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a655d87bf90a6b19$export$8392c0c9d3dcbd35, (v) => $a655d87bf90a6b19$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a655d87bf90a6b19$export$ffb0004e005737fa, (v) => $a655d87bf90a6b19$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a655d87bf90a6b19$export$b624eff549462981, (v) => $a655d87bf90a6b19$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a655d87bf90a6b19$export$7897aa7841a5380c, (v) => $a655d87bf90a6b19$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a655d87bf90a6b19$export$602eac185826482c, (v) => $a655d87bf90a6b19$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a655d87bf90a6b19$export$e2c29f18771995cb, (v) => $a655d87bf90a6b19$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a655d87bf90a6b19$export$5f8d39834fd61797, (v) => $a655d87bf90a6b19$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a655d87bf90a6b19$export$74bf444e3cd11ea5, (v) => $a655d87bf90a6b19$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $a655d87bf90a6b19$export$998bcd577473dd93, (v) => $a655d87bf90a6b19$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a655d87bf90a6b19$export$b706b080d889d2c9, (v) => $a655d87bf90a6b19$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a655d87bf90a6b19$export$5be5a87408f70ddc, (v) => $a655d87bf90a6b19$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a655d87bf90a6b19$export$45a5e7f76e0caa8d, (v) => $a655d87bf90a6b19$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a655d87bf90a6b19$export$455c2e768291efa6, (v) => $a655d87bf90a6b19$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a655d87bf90a6b19$export$9522e17588c12572, (v) => $a655d87bf90a6b19$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a655d87bf90a6b19$export$2110ac352bb060b9, (v) => $a655d87bf90a6b19$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a655d87bf90a6b19$export$56885ab8b9c456ab, (v) => $a655d87bf90a6b19$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a655d87bf90a6b19$export$d927fcb6adf8f9de, (v) => $a655d87bf90a6b19$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a655d87bf90a6b19$export$b82d16f27459e05a, (v) => $a655d87bf90a6b19$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a655d87bf90a6b19$export$522c17b4f5e123e8, (v) => $a655d87bf90a6b19$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a655d87bf90a6b19$export$1aabd8a0274ecfd6, (v) => $a655d87bf90a6b19$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $a655d87bf90a6b19$export$3d6c20d97e46b957, (v) => $a655d87bf90a6b19$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $a655d87bf90a6b19$export$9b621391a187a31a, (v) => $a655d87bf90a6b19$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a655d87bf90a6b19$export$f5bbd400c2f4426f, (v) => $a655d87bf90a6b19$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a655d87bf90a6b19$export$a7c73072b1a182ae;
var $a655d87bf90a6b19$export$9f27bc3417b4524d;
var $a655d87bf90a6b19$export$db77ccec0bb4ccac;
var $a655d87bf90a6b19$export$8392c0c9d3dcbd35;
var $a655d87bf90a6b19$export$ffb0004e005737fa;
var $a655d87bf90a6b19$export$b624eff549462981;
var $a655d87bf90a6b19$export$7897aa7841a5380c;
var $a655d87bf90a6b19$export$602eac185826482c;
var $a655d87bf90a6b19$export$e2c29f18771995cb;
var $a655d87bf90a6b19$export$5f8d39834fd61797;
var $a655d87bf90a6b19$export$74bf444e3cd11ea5;
var $a655d87bf90a6b19$export$998bcd577473dd93;
var $a655d87bf90a6b19$export$b706b080d889d2c9;
var $a655d87bf90a6b19$export$5be5a87408f70ddc;
var $a655d87bf90a6b19$export$45a5e7f76e0caa8d;
var $a655d87bf90a6b19$export$455c2e768291efa6;
var $a655d87bf90a6b19$export$9522e17588c12572;
var $a655d87bf90a6b19$export$2110ac352bb060b9;
var $a655d87bf90a6b19$export$56885ab8b9c456ab;
var $a655d87bf90a6b19$export$d927fcb6adf8f9de;
var $a655d87bf90a6b19$export$b82d16f27459e05a;
var $a655d87bf90a6b19$export$522c17b4f5e123e8;
var $a655d87bf90a6b19$export$1aabd8a0274ecfd6;
var $a655d87bf90a6b19$export$3d6c20d97e46b957;
var $a655d87bf90a6b19$export$9b621391a187a31a;
var $a655d87bf90a6b19$export$f5bbd400c2f4426f;
"use strict";
var $a655d87bf90a6b19$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a655d87bf90a6b19$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $a655d87bf90a6b19$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $a655d87bf90a6b19$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $a655d87bf90a6b19$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $a655d87bf90a6b19$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $a655d87bf90a6b19$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $a655d87bf90a6b19$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $a655d87bf90a6b19$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $a655d87bf90a6b19$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $a655d87bf90a6b19$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $a655d87bf90a6b19$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $a655d87bf90a6b19$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $a655d87bf90a6b19$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $a655d87bf90a6b19$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $a655d87bf90a6b19$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $a655d87bf90a6b19$var$REACT_FRAGMENT_TYPE:
                    case $a655d87bf90a6b19$var$REACT_PROFILER_TYPE:
                    case $a655d87bf90a6b19$var$REACT_STRICT_MODE_TYPE:
                    case $a655d87bf90a6b19$var$REACT_SUSPENSE_TYPE:
                    case $a655d87bf90a6b19$var$REACT_SUSPENSE_LIST_TYPE:
                    case $a655d87bf90a6b19$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $a655d87bf90a6b19$var$REACT_CONTEXT_TYPE:
                            case $a655d87bf90a6b19$var$REACT_FORWARD_REF_TYPE:
                            case $a655d87bf90a6b19$var$REACT_LAZY_TYPE:
                            case $a655d87bf90a6b19$var$REACT_MEMO_TYPE:
                                return object;
                            case $a655d87bf90a6b19$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $a655d87bf90a6b19$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$a655d87bf90a6b19$export$a7c73072b1a182ae = $a655d87bf90a6b19$var$REACT_CONSUMER_TYPE;
$a655d87bf90a6b19$export$9f27bc3417b4524d = $a655d87bf90a6b19$var$REACT_CONTEXT_TYPE;
$a655d87bf90a6b19$export$db77ccec0bb4ccac = $a655d87bf90a6b19$var$REACT_ELEMENT_TYPE;
$a655d87bf90a6b19$export$8392c0c9d3dcbd35 = $a655d87bf90a6b19$var$REACT_FORWARD_REF_TYPE;
$a655d87bf90a6b19$export$ffb0004e005737fa = $a655d87bf90a6b19$var$REACT_FRAGMENT_TYPE;
$a655d87bf90a6b19$export$b624eff549462981 = $a655d87bf90a6b19$var$REACT_LAZY_TYPE;
$a655d87bf90a6b19$export$7897aa7841a5380c = $a655d87bf90a6b19$var$REACT_MEMO_TYPE;
$a655d87bf90a6b19$export$602eac185826482c = $a655d87bf90a6b19$var$REACT_PORTAL_TYPE;
$a655d87bf90a6b19$export$e2c29f18771995cb = $a655d87bf90a6b19$var$REACT_PROFILER_TYPE;
$a655d87bf90a6b19$export$5f8d39834fd61797 = $a655d87bf90a6b19$var$REACT_STRICT_MODE_TYPE;
$a655d87bf90a6b19$export$74bf444e3cd11ea5 = $a655d87bf90a6b19$var$REACT_SUSPENSE_TYPE;
$a655d87bf90a6b19$export$998bcd577473dd93 = $a655d87bf90a6b19$var$REACT_SUSPENSE_LIST_TYPE;
$a655d87bf90a6b19$export$b706b080d889d2c9 = function(object) {
    return $a655d87bf90a6b19$var$typeOf(object) === $a655d87bf90a6b19$var$REACT_CONSUMER_TYPE;
};
$a655d87bf90a6b19$export$5be5a87408f70ddc = function(object) {
    return $a655d87bf90a6b19$var$typeOf(object) === $a655d87bf90a6b19$var$REACT_CONTEXT_TYPE;
};
$a655d87bf90a6b19$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $a655d87bf90a6b19$var$REACT_ELEMENT_TYPE;
};
$a655d87bf90a6b19$export$455c2e768291efa6 = function(object) {
    return $a655d87bf90a6b19$var$typeOf(object) === $a655d87bf90a6b19$var$REACT_FORWARD_REF_TYPE;
};
$a655d87bf90a6b19$export$9522e17588c12572 = function(object) {
    return $a655d87bf90a6b19$var$typeOf(object) === $a655d87bf90a6b19$var$REACT_FRAGMENT_TYPE;
};
$a655d87bf90a6b19$export$2110ac352bb060b9 = function(object) {
    return $a655d87bf90a6b19$var$typeOf(object) === $a655d87bf90a6b19$var$REACT_LAZY_TYPE;
};
$a655d87bf90a6b19$export$56885ab8b9c456ab = function(object) {
    return $a655d87bf90a6b19$var$typeOf(object) === $a655d87bf90a6b19$var$REACT_MEMO_TYPE;
};
$a655d87bf90a6b19$export$d927fcb6adf8f9de = function(object) {
    return $a655d87bf90a6b19$var$typeOf(object) === $a655d87bf90a6b19$var$REACT_PORTAL_TYPE;
};
$a655d87bf90a6b19$export$b82d16f27459e05a = function(object) {
    return $a655d87bf90a6b19$var$typeOf(object) === $a655d87bf90a6b19$var$REACT_PROFILER_TYPE;
};
$a655d87bf90a6b19$export$522c17b4f5e123e8 = function(object) {
    return $a655d87bf90a6b19$var$typeOf(object) === $a655d87bf90a6b19$var$REACT_STRICT_MODE_TYPE;
};
$a655d87bf90a6b19$export$1aabd8a0274ecfd6 = function(object) {
    return $a655d87bf90a6b19$var$typeOf(object) === $a655d87bf90a6b19$var$REACT_SUSPENSE_TYPE;
};
$a655d87bf90a6b19$export$3d6c20d97e46b957 = function(object) {
    return $a655d87bf90a6b19$var$typeOf(object) === $a655d87bf90a6b19$var$REACT_SUSPENSE_LIST_TYPE;
};
$a655d87bf90a6b19$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $a655d87bf90a6b19$var$REACT_FRAGMENT_TYPE || type === $a655d87bf90a6b19$var$REACT_PROFILER_TYPE || type === $a655d87bf90a6b19$var$REACT_STRICT_MODE_TYPE || type === $a655d87bf90a6b19$var$REACT_SUSPENSE_TYPE || type === $a655d87bf90a6b19$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $a655d87bf90a6b19$var$REACT_LAZY_TYPE || type.$$typeof === $a655d87bf90a6b19$var$REACT_MEMO_TYPE || type.$$typeof === $a655d87bf90a6b19$var$REACT_CONTEXT_TYPE || type.$$typeof === $a655d87bf90a6b19$var$REACT_CONSUMER_TYPE || type.$$typeof === $a655d87bf90a6b19$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $a655d87bf90a6b19$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$a655d87bf90a6b19$export$f5bbd400c2f4426f = $a655d87bf90a6b19$var$typeOf;

});




parcelRegister("juBCB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("kBzHD")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("3fllQ")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("i16H0")).default);

var $kBzHD = parcelRequire("kBzHD");

var $3fllQ = parcelRequire("3fllQ");

var $i16H0 = parcelRequire("i16H0");

});

parcelRegister("asMfg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("aF1tN")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("aF1tN")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("gR6ti")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("euq5j")).default);

var $aF1tN = parcelRequire("aF1tN");

var $gR6ti = parcelRequire("gR6ti");

var $euq5j = parcelRequire("euq5j");

});
parcelRegister("gR6ti", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4569dab745a551b$export$2e2bcd8739ae039);

var $7Nobb = parcelRequire("7Nobb");

var $8T8Yq = parcelRequire("8T8Yq");

var $f41I8 = parcelRequire("f41I8");

var $euq5j = parcelRequire("euq5j");
const $c4569dab745a551b$var$_excluded = [
    "sx"
];
const $c4569dab745a551b$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $euq5j.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c4569dab745a551b$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $8T8Yq.default)(props, $c4569dab745a551b$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $c4569dab745a551b$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $f41I8.isPlainObject)(result)) return systemProps;
        return (0, $7Nobb.default)({}, systemProps, result);
    };
    else finalSx = (0, $7Nobb.default)({}, systemProps, inSx);
    return (0, $7Nobb.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("fJeA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7365e68deffb987$export$2e2bcd8739ae039);

var $7xLJq = parcelRequire("7xLJq");
const $b7365e68deffb987$var$rootShouldForwardProp = (prop)=>(0, $7xLJq.default)(prop) && prop !== 'classes';
var $b7365e68deffb987$export$2e2bcd8739ae039 = $b7365e68deffb987$var$rootShouldForwardProp;

});
parcelRegister("7xLJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $57e0a400b9bb2490$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $57e0a400b9bb2490$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $57e0a400b9bb2490$export$2e2bcd8739ae039 = $57e0a400b9bb2490$var$slotShouldForwardProp;

});



parcelRegister("cHMPl", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $93ff603df863adb0$export$c7c50641356bdfa5);

var $dPRnY = parcelRequire("dPRnY");

var $jBOtT = parcelRequire("jBOtT");
function $93ff603df863adb0$export$c7c50641356bdfa5(slot) {
    return (0, $jBOtT.default)('MuiSvgIcon', slot);
}
const $93ff603df863adb0$var$svgIconClasses = (0, $dPRnY.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $93ff603df863adb0$export$2e2bcd8739ae039 = $93ff603df863adb0$var$svgIconClasses;

});
parcelRegister("dPRnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a129730eb0c07134$export$2e2bcd8739ae039);

var $jBOtT = parcelRequire("jBOtT");
function $a129730eb0c07134$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $jBOtT.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("jBOtT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e468a187940d459c$export$2e2bcd8739ae039);

var $l5Bff = parcelRequire("l5Bff");
const $e468a187940d459c$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $e468a187940d459c$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $e468a187940d459c$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $l5Bff.default).generate(componentName)}-${slot}`;
}
function $e468a187940d459c$export$34c0130b1f3e8ae3(slot) {
    return $e468a187940d459c$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("l5Bff", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a6f4aa94524b59$export$2e2bcd8739ae039);
const $f5a6f4aa94524b59$var$defaultGenerator = (componentName)=>componentName;
const $f5a6f4aa94524b59$var$createClassNameGenerator = ()=>{
    let generate = $f5a6f4aa94524b59$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $f5a6f4aa94524b59$var$defaultGenerator;
        }
    };
};
const $f5a6f4aa94524b59$var$ClassNameGenerator = $f5a6f4aa94524b59$var$createClassNameGenerator();
var $f5a6f4aa94524b59$export$2e2bcd8739ae039 = $f5a6f4aa94524b59$var$ClassNameGenerator;

});







parcelRegister("hpnsu", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cac6f7d512e9cb9e$var$ReactIs, $cac6f7d512e9cb9e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("4dIrL"))();

});
parcelRegister("4dIrL", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $gnCXp = parcelRequire("gnCXp");
function $312ada839a1716b5$var$emptyFunction() {}
function $312ada839a1716b5$var$emptyFunctionWithReset() {}
$312ada839a1716b5$var$emptyFunctionWithReset.resetWarningCache = $312ada839a1716b5$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $gnCXp) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $312ada839a1716b5$var$emptyFunctionWithReset,
        resetWarningCache: $312ada839a1716b5$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("gnCXp", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $becd0363e3d2b790$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $becd0363e3d2b790$var$ReactPropTypesSecret;

});



parcelRegister("kY3tI", function(module, exports) {
'use strict';

var $f43c1bfbfbfecfcc$require$assign = (parcelRequire("bQwNq")).assign;

var $74PTr = parcelRequire("74PTr");

var $h2xiW = parcelRequire("h2xiW");

var $pE4pY = parcelRequire("pE4pY");

var $f62O3 = parcelRequire("f62O3");

var $iJCC3 = parcelRequire("iJCC3");



/**
 * Preset configs
 */ var $f43c1bfbfbfecfcc$var$config = {
    'default': (parcelRequire("de00F")),
    'full': (parcelRequire("58FAn")),
    'commonmark': (parcelRequire("53QEF"))
};
/**
 * The `StateCore` class manages state.
 *
 * @param {Object} `instance` Remarkable instance
 * @param {String} `str` Markdown string
 * @param {Object} `env`
 */ function $f43c1bfbfbfecfcc$var$StateCore(instance, str, env) {
    this.src = str;
    this.env = env;
    this.options = instance.options;
    this.tokens = [];
    this.inlineMode = false;
    this.inline = instance.inline;
    this.block = instance.block;
    this.renderer = instance.renderer;
    this.typographer = instance.typographer;
}
/**
 * The main `Remarkable` class. Create an instance of
 * `Remarkable` with a `preset` and/or `options`.
 *
 * @param {String} `preset` If no preset is given, `default` is used.
 * @param {Object} `options`
 */ function $f43c1bfbfbfecfcc$var$Remarkable(preset, options) {
    if (typeof preset !== 'string') {
        options = preset;
        preset = 'default';
    }
    this.inline = new $f62O3();
    this.block = new $pE4pY();
    this.core = new $h2xiW();
    this.renderer = new $74PTr();
    this.ruler = new $iJCC3();
    this.options = {};
    this.configure($f43c1bfbfbfecfcc$var$config[preset]);
    this.set(options || {});
}
/**
 * Set options as an alternative to passing them
 * to the constructor.
 *
 * ```js
 * md.set({typographer: true});
 * ```
 * @param {Object} `options`
 * @api public
 */ $f43c1bfbfbfecfcc$var$Remarkable.prototype.set = function(options) {
    $f43c1bfbfbfecfcc$require$assign(this.options, options);
};
/**
 * Batch loader for components rules states, and options
 *
 * @param  {Object} `presets`
 */ $f43c1bfbfbfecfcc$var$Remarkable.prototype.configure = function(presets) {
    var self = this;
    if (!presets) throw new Error('Wrong `remarkable` preset, check name/content');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enable(presets.components[name].rules, true);
    });
};
/**
 * Use a plugin.
 *
 * ```js
 * var md = new Remarkable();
 *
 * md.use(plugin1)
 *   .use(plugin2, opts)
 *   .use(plugin3);
 * ```
 *
 * @param  {Function} `plugin`
 * @param  {Object} `options`
 * @return {Object} `Remarkable` for chaining
 */ $f43c1bfbfbfecfcc$var$Remarkable.prototype.use = function(plugin, options) {
    plugin(this, options);
    return this;
};
/**
 * Parse the input `string` and return a tokens array.
 * Modifies `env` with definitions data.
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {Array} Array of tokens
 */ $f43c1bfbfbfecfcc$var$Remarkable.prototype.parse = function(str, env) {
    var state = new $f43c1bfbfbfecfcc$var$StateCore(this, str, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * The main `.render()` method that does all the magic :)
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {String} Rendered HTML.
 */ $f43c1bfbfbfecfcc$var$Remarkable.prototype.render = function(str, env) {
    env = env || {};
    return this.renderer.render(this.parse(str, env), this.options, env);
};
/**
 * Parse the given content `string` as a single string.
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {Array} Array of tokens
 */ $f43c1bfbfbfecfcc$var$Remarkable.prototype.parseInline = function(str, env) {
    var state = new $f43c1bfbfbfecfcc$var$StateCore(this, str, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * Render a single content `string`, without wrapping it
 * to paragraphs
 *
 * @param  {String} `str`
 * @param  {Object} `env`
 * @return {String}
 */ $f43c1bfbfbfecfcc$var$Remarkable.prototype.renderInline = function(str, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(str, env), this.options, env);
};
/**
 * Expose `Remarkable`
 */ module.exports = $f43c1bfbfbfecfcc$var$Remarkable;

/**
 * Expose `utils`, Useful helper functions for custom
 * rendering.
 */ module.exports.utils = (parcelRequire("bQwNq"));

});
parcelRegister("bQwNq", function(module, exports) {

$parcel$export(module.exports, "assign", () => $0239c62800d50c5d$export$e6e34fd1f2686227, (v) => $0239c62800d50c5d$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $0239c62800d50c5d$export$844ec244b1367d54, (v) => $0239c62800d50c5d$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $0239c62800d50c5d$export$a4f4bb6b1453fff5, (v) => $0239c62800d50c5d$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $0239c62800d50c5d$export$5ccde1ea0c14bb03, (v) => $0239c62800d50c5d$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "isValidEntityCode", () => $0239c62800d50c5d$export$644a8f5b13b2a36d, (v) => $0239c62800d50c5d$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $0239c62800d50c5d$export$73bfc63873071f74, (v) => $0239c62800d50c5d$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "replaceEntities", () => $0239c62800d50c5d$export$92752f49babf4588, (v) => $0239c62800d50c5d$export$92752f49babf4588 = v);
$parcel$export(module.exports, "escapeHtml", () => $0239c62800d50c5d$export$4cf11838cdc2a8a8, (v) => $0239c62800d50c5d$export$4cf11838cdc2a8a8 = v);
////////////////////////////////////////////////////////////////////////////////
var $0239c62800d50c5d$export$e6e34fd1f2686227;
var $0239c62800d50c5d$export$844ec244b1367d54;
var $0239c62800d50c5d$export$a4f4bb6b1453fff5;
var $0239c62800d50c5d$export$5ccde1ea0c14bb03;
var $0239c62800d50c5d$export$644a8f5b13b2a36d;
var $0239c62800d50c5d$export$73bfc63873071f74;
var $0239c62800d50c5d$export$92752f49babf4588;
var $0239c62800d50c5d$export$4cf11838cdc2a8a8;
'use strict';
/**
 * Utility functions
 */ function $0239c62800d50c5d$var$typeOf(obj) {
    return Object.prototype.toString.call(obj);
}
function $0239c62800d50c5d$var$isString(obj) {
    return $0239c62800d50c5d$var$typeOf(obj) === '[object String]';
}
var $0239c62800d50c5d$var$hasOwn = Object.prototype.hasOwnProperty;
function $0239c62800d50c5d$var$has(object, key) {
    return object ? $0239c62800d50c5d$var$hasOwn.call(object, key) : false;
}
// Extend objects
//
function $0239c62800d50c5d$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = [].slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
////////////////////////////////////////////////////////////////////////////////
var $0239c62800d50c5d$var$UNESCAPE_MD_RE = /\\([\\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
function $0239c62800d50c5d$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($0239c62800d50c5d$var$UNESCAPE_MD_RE, '$1');
}
////////////////////////////////////////////////////////////////////////////////
function $0239c62800d50c5d$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $0239c62800d50c5d$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $0239c62800d50c5d$var$NAMED_ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $0239c62800d50c5d$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

var $7jmp5 = parcelRequire("7jmp5");
function $0239c62800d50c5d$var$replaceEntityPattern(match, name) {
    var code = 0;
    if ($0239c62800d50c5d$var$has($7jmp5, name)) return $7jmp5[name];
    else if (name.charCodeAt(0) === 0x23 /* # */  && $0239c62800d50c5d$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($0239c62800d50c5d$var$isValidEntityCode(code)) return $0239c62800d50c5d$var$fromCodePoint(code);
    }
    return match;
}
function $0239c62800d50c5d$var$replaceEntities(str) {
    if (str.indexOf('&') < 0) return str;
    return str.replace($0239c62800d50c5d$var$NAMED_ENTITY_RE, $0239c62800d50c5d$var$replaceEntityPattern);
}
////////////////////////////////////////////////////////////////////////////////
var $0239c62800d50c5d$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $0239c62800d50c5d$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $0239c62800d50c5d$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $0239c62800d50c5d$var$replaceUnsafeChar(ch) {
    return $0239c62800d50c5d$var$HTML_REPLACEMENTS[ch];
}
function $0239c62800d50c5d$var$escapeHtml(str) {
    if ($0239c62800d50c5d$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($0239c62800d50c5d$var$HTML_ESCAPE_REPLACE_RE, $0239c62800d50c5d$var$replaceUnsafeChar);
    return str;
}
$0239c62800d50c5d$export$e6e34fd1f2686227 = $0239c62800d50c5d$var$assign;
$0239c62800d50c5d$export$844ec244b1367d54 = $0239c62800d50c5d$var$isString;
$0239c62800d50c5d$export$a4f4bb6b1453fff5 = $0239c62800d50c5d$var$has;
$0239c62800d50c5d$export$5ccde1ea0c14bb03 = $0239c62800d50c5d$var$unescapeMd;
$0239c62800d50c5d$export$644a8f5b13b2a36d = $0239c62800d50c5d$var$isValidEntityCode;
$0239c62800d50c5d$export$73bfc63873071f74 = $0239c62800d50c5d$var$fromCodePoint;
$0239c62800d50c5d$export$92752f49babf4588 = $0239c62800d50c5d$var$replaceEntities;
$0239c62800d50c5d$export$4cf11838cdc2a8a8 = $0239c62800d50c5d$var$escapeHtml;

});
parcelRegister("7jmp5", function(module, exports) {
// List of valid entities
//
// Generate with ./support/entities.js script
//
'use strict';
/*eslint quotes:0*/ module.exports = {
    "Aacute": "\u00C1",
    "aacute": "\u00E1",
    "Abreve": "\u0102",
    "abreve": "\u0103",
    "ac": "\u223E",
    "acd": "\u223F",
    "acE": "\u223E\u0333",
    "Acirc": "\u00C2",
    "acirc": "\u00E2",
    "acute": "\u00B4",
    "Acy": "\u0410",
    "acy": "\u0430",
    "AElig": "\u00C6",
    "aelig": "\u00E6",
    "af": "\u2061",
    "Afr": "\uD835\uDD04",
    "afr": "\uD835\uDD1E",
    "Agrave": "\u00C0",
    "agrave": "\u00E0",
    "alefsym": "\u2135",
    "aleph": "\u2135",
    "Alpha": "\u0391",
    "alpha": "\u03B1",
    "Amacr": "\u0100",
    "amacr": "\u0101",
    "amalg": "\u2A3F",
    "AMP": "\u0026",
    "amp": "\u0026",
    "And": "\u2A53",
    "and": "\u2227",
    "andand": "\u2A55",
    "andd": "\u2A5C",
    "andslope": "\u2A58",
    "andv": "\u2A5A",
    "ang": "\u2220",
    "ange": "\u29A4",
    "angle": "\u2220",
    "angmsd": "\u2221",
    "angmsdaa": "\u29A8",
    "angmsdab": "\u29A9",
    "angmsdac": "\u29AA",
    "angmsdad": "\u29AB",
    "angmsdae": "\u29AC",
    "angmsdaf": "\u29AD",
    "angmsdag": "\u29AE",
    "angmsdah": "\u29AF",
    "angrt": "\u221F",
    "angrtvb": "\u22BE",
    "angrtvbd": "\u299D",
    "angsph": "\u2222",
    "angst": "\u00C5",
    "angzarr": "\u237C",
    "Aogon": "\u0104",
    "aogon": "\u0105",
    "Aopf": "\uD835\uDD38",
    "aopf": "\uD835\uDD52",
    "ap": "\u2248",
    "apacir": "\u2A6F",
    "apE": "\u2A70",
    "ape": "\u224A",
    "apid": "\u224B",
    "apos": "\u0027",
    "ApplyFunction": "\u2061",
    "approx": "\u2248",
    "approxeq": "\u224A",
    "Aring": "\u00C5",
    "aring": "\u00E5",
    "Ascr": "\uD835\uDC9C",
    "ascr": "\uD835\uDCB6",
    "Assign": "\u2254",
    "ast": "\u002A",
    "asymp": "\u2248",
    "asympeq": "\u224D",
    "Atilde": "\u00C3",
    "atilde": "\u00E3",
    "Auml": "\u00C4",
    "auml": "\u00E4",
    "awconint": "\u2233",
    "awint": "\u2A11",
    "backcong": "\u224C",
    "backepsilon": "\u03F6",
    "backprime": "\u2035",
    "backsim": "\u223D",
    "backsimeq": "\u22CD",
    "Backslash": "\u2216",
    "Barv": "\u2AE7",
    "barvee": "\u22BD",
    "Barwed": "\u2306",
    "barwed": "\u2305",
    "barwedge": "\u2305",
    "bbrk": "\u23B5",
    "bbrktbrk": "\u23B6",
    "bcong": "\u224C",
    "Bcy": "\u0411",
    "bcy": "\u0431",
    "bdquo": "\u201E",
    "becaus": "\u2235",
    "Because": "\u2235",
    "because": "\u2235",
    "bemptyv": "\u29B0",
    "bepsi": "\u03F6",
    "bernou": "\u212C",
    "Bernoullis": "\u212C",
    "Beta": "\u0392",
    "beta": "\u03B2",
    "beth": "\u2136",
    "between": "\u226C",
    "Bfr": "\uD835\uDD05",
    "bfr": "\uD835\uDD1F",
    "bigcap": "\u22C2",
    "bigcirc": "\u25EF",
    "bigcup": "\u22C3",
    "bigodot": "\u2A00",
    "bigoplus": "\u2A01",
    "bigotimes": "\u2A02",
    "bigsqcup": "\u2A06",
    "bigstar": "\u2605",
    "bigtriangledown": "\u25BD",
    "bigtriangleup": "\u25B3",
    "biguplus": "\u2A04",
    "bigvee": "\u22C1",
    "bigwedge": "\u22C0",
    "bkarow": "\u290D",
    "blacklozenge": "\u29EB",
    "blacksquare": "\u25AA",
    "blacktriangle": "\u25B4",
    "blacktriangledown": "\u25BE",
    "blacktriangleleft": "\u25C2",
    "blacktriangleright": "\u25B8",
    "blank": "\u2423",
    "blk12": "\u2592",
    "blk14": "\u2591",
    "blk34": "\u2593",
    "block": "\u2588",
    "bne": "\u003D\u20E5",
    "bnequiv": "\u2261\u20E5",
    "bNot": "\u2AED",
    "bnot": "\u2310",
    "Bopf": "\uD835\uDD39",
    "bopf": "\uD835\uDD53",
    "bot": "\u22A5",
    "bottom": "\u22A5",
    "bowtie": "\u22C8",
    "boxbox": "\u29C9",
    "boxDL": "\u2557",
    "boxDl": "\u2556",
    "boxdL": "\u2555",
    "boxdl": "\u2510",
    "boxDR": "\u2554",
    "boxDr": "\u2553",
    "boxdR": "\u2552",
    "boxdr": "\u250C",
    "boxH": "\u2550",
    "boxh": "\u2500",
    "boxHD": "\u2566",
    "boxHd": "\u2564",
    "boxhD": "\u2565",
    "boxhd": "\u252C",
    "boxHU": "\u2569",
    "boxHu": "\u2567",
    "boxhU": "\u2568",
    "boxhu": "\u2534",
    "boxminus": "\u229F",
    "boxplus": "\u229E",
    "boxtimes": "\u22A0",
    "boxUL": "\u255D",
    "boxUl": "\u255C",
    "boxuL": "\u255B",
    "boxul": "\u2518",
    "boxUR": "\u255A",
    "boxUr": "\u2559",
    "boxuR": "\u2558",
    "boxur": "\u2514",
    "boxV": "\u2551",
    "boxv": "\u2502",
    "boxVH": "\u256C",
    "boxVh": "\u256B",
    "boxvH": "\u256A",
    "boxvh": "\u253C",
    "boxVL": "\u2563",
    "boxVl": "\u2562",
    "boxvL": "\u2561",
    "boxvl": "\u2524",
    "boxVR": "\u2560",
    "boxVr": "\u255F",
    "boxvR": "\u255E",
    "boxvr": "\u251C",
    "bprime": "\u2035",
    "Breve": "\u02D8",
    "breve": "\u02D8",
    "brvbar": "\u00A6",
    "Bscr": "\u212C",
    "bscr": "\uD835\uDCB7",
    "bsemi": "\u204F",
    "bsim": "\u223D",
    "bsime": "\u22CD",
    "bsol": "\u005C",
    "bsolb": "\u29C5",
    "bsolhsub": "\u27C8",
    "bull": "\u2022",
    "bullet": "\u2022",
    "bump": "\u224E",
    "bumpE": "\u2AAE",
    "bumpe": "\u224F",
    "Bumpeq": "\u224E",
    "bumpeq": "\u224F",
    "Cacute": "\u0106",
    "cacute": "\u0107",
    "Cap": "\u22D2",
    "cap": "\u2229",
    "capand": "\u2A44",
    "capbrcup": "\u2A49",
    "capcap": "\u2A4B",
    "capcup": "\u2A47",
    "capdot": "\u2A40",
    "CapitalDifferentialD": "\u2145",
    "caps": "\u2229\uFE00",
    "caret": "\u2041",
    "caron": "\u02C7",
    "Cayleys": "\u212D",
    "ccaps": "\u2A4D",
    "Ccaron": "\u010C",
    "ccaron": "\u010D",
    "Ccedil": "\u00C7",
    "ccedil": "\u00E7",
    "Ccirc": "\u0108",
    "ccirc": "\u0109",
    "Cconint": "\u2230",
    "ccups": "\u2A4C",
    "ccupssm": "\u2A50",
    "Cdot": "\u010A",
    "cdot": "\u010B",
    "cedil": "\u00B8",
    "Cedilla": "\u00B8",
    "cemptyv": "\u29B2",
    "cent": "\u00A2",
    "CenterDot": "\u00B7",
    "centerdot": "\u00B7",
    "Cfr": "\u212D",
    "cfr": "\uD835\uDD20",
    "CHcy": "\u0427",
    "chcy": "\u0447",
    "check": "\u2713",
    "checkmark": "\u2713",
    "Chi": "\u03A7",
    "chi": "\u03C7",
    "cir": "\u25CB",
    "circ": "\u02C6",
    "circeq": "\u2257",
    "circlearrowleft": "\u21BA",
    "circlearrowright": "\u21BB",
    "circledast": "\u229B",
    "circledcirc": "\u229A",
    "circleddash": "\u229D",
    "CircleDot": "\u2299",
    "circledR": "\u00AE",
    "circledS": "\u24C8",
    "CircleMinus": "\u2296",
    "CirclePlus": "\u2295",
    "CircleTimes": "\u2297",
    "cirE": "\u29C3",
    "cire": "\u2257",
    "cirfnint": "\u2A10",
    "cirmid": "\u2AEF",
    "cirscir": "\u29C2",
    "ClockwiseContourIntegral": "\u2232",
    "CloseCurlyDoubleQuote": "\u201D",
    "CloseCurlyQuote": "\u2019",
    "clubs": "\u2663",
    "clubsuit": "\u2663",
    "Colon": "\u2237",
    "colon": "\u003A",
    "Colone": "\u2A74",
    "colone": "\u2254",
    "coloneq": "\u2254",
    "comma": "\u002C",
    "commat": "\u0040",
    "comp": "\u2201",
    "compfn": "\u2218",
    "complement": "\u2201",
    "complexes": "\u2102",
    "cong": "\u2245",
    "congdot": "\u2A6D",
    "Congruent": "\u2261",
    "Conint": "\u222F",
    "conint": "\u222E",
    "ContourIntegral": "\u222E",
    "Copf": "\u2102",
    "copf": "\uD835\uDD54",
    "coprod": "\u2210",
    "Coproduct": "\u2210",
    "COPY": "\u00A9",
    "copy": "\u00A9",
    "copysr": "\u2117",
    "CounterClockwiseContourIntegral": "\u2233",
    "crarr": "\u21B5",
    "Cross": "\u2A2F",
    "cross": "\u2717",
    "Cscr": "\uD835\uDC9E",
    "cscr": "\uD835\uDCB8",
    "csub": "\u2ACF",
    "csube": "\u2AD1",
    "csup": "\u2AD0",
    "csupe": "\u2AD2",
    "ctdot": "\u22EF",
    "cudarrl": "\u2938",
    "cudarrr": "\u2935",
    "cuepr": "\u22DE",
    "cuesc": "\u22DF",
    "cularr": "\u21B6",
    "cularrp": "\u293D",
    "Cup": "\u22D3",
    "cup": "\u222A",
    "cupbrcap": "\u2A48",
    "CupCap": "\u224D",
    "cupcap": "\u2A46",
    "cupcup": "\u2A4A",
    "cupdot": "\u228D",
    "cupor": "\u2A45",
    "cups": "\u222A\uFE00",
    "curarr": "\u21B7",
    "curarrm": "\u293C",
    "curlyeqprec": "\u22DE",
    "curlyeqsucc": "\u22DF",
    "curlyvee": "\u22CE",
    "curlywedge": "\u22CF",
    "curren": "\u00A4",
    "curvearrowleft": "\u21B6",
    "curvearrowright": "\u21B7",
    "cuvee": "\u22CE",
    "cuwed": "\u22CF",
    "cwconint": "\u2232",
    "cwint": "\u2231",
    "cylcty": "\u232D",
    "Dagger": "\u2021",
    "dagger": "\u2020",
    "daleth": "\u2138",
    "Darr": "\u21A1",
    "dArr": "\u21D3",
    "darr": "\u2193",
    "dash": "\u2010",
    "Dashv": "\u2AE4",
    "dashv": "\u22A3",
    "dbkarow": "\u290F",
    "dblac": "\u02DD",
    "Dcaron": "\u010E",
    "dcaron": "\u010F",
    "Dcy": "\u0414",
    "dcy": "\u0434",
    "DD": "\u2145",
    "dd": "\u2146",
    "ddagger": "\u2021",
    "ddarr": "\u21CA",
    "DDotrahd": "\u2911",
    "ddotseq": "\u2A77",
    "deg": "\u00B0",
    "Del": "\u2207",
    "Delta": "\u0394",
    "delta": "\u03B4",
    "demptyv": "\u29B1",
    "dfisht": "\u297F",
    "Dfr": "\uD835\uDD07",
    "dfr": "\uD835\uDD21",
    "dHar": "\u2965",
    "dharl": "\u21C3",
    "dharr": "\u21C2",
    "DiacriticalAcute": "\u00B4",
    "DiacriticalDot": "\u02D9",
    "DiacriticalDoubleAcute": "\u02DD",
    "DiacriticalGrave": "\u0060",
    "DiacriticalTilde": "\u02DC",
    "diam": "\u22C4",
    "Diamond": "\u22C4",
    "diamond": "\u22C4",
    "diamondsuit": "\u2666",
    "diams": "\u2666",
    "die": "\u00A8",
    "DifferentialD": "\u2146",
    "digamma": "\u03DD",
    "disin": "\u22F2",
    "div": "\u00F7",
    "divide": "\u00F7",
    "divideontimes": "\u22C7",
    "divonx": "\u22C7",
    "DJcy": "\u0402",
    "djcy": "\u0452",
    "dlcorn": "\u231E",
    "dlcrop": "\u230D",
    "dollar": "\u0024",
    "Dopf": "\uD835\uDD3B",
    "dopf": "\uD835\uDD55",
    "Dot": "\u00A8",
    "dot": "\u02D9",
    "DotDot": "\u20DC",
    "doteq": "\u2250",
    "doteqdot": "\u2251",
    "DotEqual": "\u2250",
    "dotminus": "\u2238",
    "dotplus": "\u2214",
    "dotsquare": "\u22A1",
    "doublebarwedge": "\u2306",
    "DoubleContourIntegral": "\u222F",
    "DoubleDot": "\u00A8",
    "DoubleDownArrow": "\u21D3",
    "DoubleLeftArrow": "\u21D0",
    "DoubleLeftRightArrow": "\u21D4",
    "DoubleLeftTee": "\u2AE4",
    "DoubleLongLeftArrow": "\u27F8",
    "DoubleLongLeftRightArrow": "\u27FA",
    "DoubleLongRightArrow": "\u27F9",
    "DoubleRightArrow": "\u21D2",
    "DoubleRightTee": "\u22A8",
    "DoubleUpArrow": "\u21D1",
    "DoubleUpDownArrow": "\u21D5",
    "DoubleVerticalBar": "\u2225",
    "DownArrow": "\u2193",
    "Downarrow": "\u21D3",
    "downarrow": "\u2193",
    "DownArrowBar": "\u2913",
    "DownArrowUpArrow": "\u21F5",
    "DownBreve": "\u0311",
    "downdownarrows": "\u21CA",
    "downharpoonleft": "\u21C3",
    "downharpoonright": "\u21C2",
    "DownLeftRightVector": "\u2950",
    "DownLeftTeeVector": "\u295E",
    "DownLeftVector": "\u21BD",
    "DownLeftVectorBar": "\u2956",
    "DownRightTeeVector": "\u295F",
    "DownRightVector": "\u21C1",
    "DownRightVectorBar": "\u2957",
    "DownTee": "\u22A4",
    "DownTeeArrow": "\u21A7",
    "drbkarow": "\u2910",
    "drcorn": "\u231F",
    "drcrop": "\u230C",
    "Dscr": "\uD835\uDC9F",
    "dscr": "\uD835\uDCB9",
    "DScy": "\u0405",
    "dscy": "\u0455",
    "dsol": "\u29F6",
    "Dstrok": "\u0110",
    "dstrok": "\u0111",
    "dtdot": "\u22F1",
    "dtri": "\u25BF",
    "dtrif": "\u25BE",
    "duarr": "\u21F5",
    "duhar": "\u296F",
    "dwangle": "\u29A6",
    "DZcy": "\u040F",
    "dzcy": "\u045F",
    "dzigrarr": "\u27FF",
    "Eacute": "\u00C9",
    "eacute": "\u00E9",
    "easter": "\u2A6E",
    "Ecaron": "\u011A",
    "ecaron": "\u011B",
    "ecir": "\u2256",
    "Ecirc": "\u00CA",
    "ecirc": "\u00EA",
    "ecolon": "\u2255",
    "Ecy": "\u042D",
    "ecy": "\u044D",
    "eDDot": "\u2A77",
    "Edot": "\u0116",
    "eDot": "\u2251",
    "edot": "\u0117",
    "ee": "\u2147",
    "efDot": "\u2252",
    "Efr": "\uD835\uDD08",
    "efr": "\uD835\uDD22",
    "eg": "\u2A9A",
    "Egrave": "\u00C8",
    "egrave": "\u00E8",
    "egs": "\u2A96",
    "egsdot": "\u2A98",
    "el": "\u2A99",
    "Element": "\u2208",
    "elinters": "\u23E7",
    "ell": "\u2113",
    "els": "\u2A95",
    "elsdot": "\u2A97",
    "Emacr": "\u0112",
    "emacr": "\u0113",
    "empty": "\u2205",
    "emptyset": "\u2205",
    "EmptySmallSquare": "\u25FB",
    "emptyv": "\u2205",
    "EmptyVerySmallSquare": "\u25AB",
    "emsp": "\u2003",
    "emsp13": "\u2004",
    "emsp14": "\u2005",
    "ENG": "\u014A",
    "eng": "\u014B",
    "ensp": "\u2002",
    "Eogon": "\u0118",
    "eogon": "\u0119",
    "Eopf": "\uD835\uDD3C",
    "eopf": "\uD835\uDD56",
    "epar": "\u22D5",
    "eparsl": "\u29E3",
    "eplus": "\u2A71",
    "epsi": "\u03B5",
    "Epsilon": "\u0395",
    "epsilon": "\u03B5",
    "epsiv": "\u03F5",
    "eqcirc": "\u2256",
    "eqcolon": "\u2255",
    "eqsim": "\u2242",
    "eqslantgtr": "\u2A96",
    "eqslantless": "\u2A95",
    "Equal": "\u2A75",
    "equals": "\u003D",
    "EqualTilde": "\u2242",
    "equest": "\u225F",
    "Equilibrium": "\u21CC",
    "equiv": "\u2261",
    "equivDD": "\u2A78",
    "eqvparsl": "\u29E5",
    "erarr": "\u2971",
    "erDot": "\u2253",
    "Escr": "\u2130",
    "escr": "\u212F",
    "esdot": "\u2250",
    "Esim": "\u2A73",
    "esim": "\u2242",
    "Eta": "\u0397",
    "eta": "\u03B7",
    "ETH": "\u00D0",
    "eth": "\u00F0",
    "Euml": "\u00CB",
    "euml": "\u00EB",
    "euro": "\u20AC",
    "excl": "\u0021",
    "exist": "\u2203",
    "Exists": "\u2203",
    "expectation": "\u2130",
    "ExponentialE": "\u2147",
    "exponentiale": "\u2147",
    "fallingdotseq": "\u2252",
    "Fcy": "\u0424",
    "fcy": "\u0444",
    "female": "\u2640",
    "ffilig": "\uFB03",
    "fflig": "\uFB00",
    "ffllig": "\uFB04",
    "Ffr": "\uD835\uDD09",
    "ffr": "\uD835\uDD23",
    "filig": "\uFB01",
    "FilledSmallSquare": "\u25FC",
    "FilledVerySmallSquare": "\u25AA",
    "fjlig": "\u0066\u006A",
    "flat": "\u266D",
    "fllig": "\uFB02",
    "fltns": "\u25B1",
    "fnof": "\u0192",
    "Fopf": "\uD835\uDD3D",
    "fopf": "\uD835\uDD57",
    "ForAll": "\u2200",
    "forall": "\u2200",
    "fork": "\u22D4",
    "forkv": "\u2AD9",
    "Fouriertrf": "\u2131",
    "fpartint": "\u2A0D",
    "frac12": "\u00BD",
    "frac13": "\u2153",
    "frac14": "\u00BC",
    "frac15": "\u2155",
    "frac16": "\u2159",
    "frac18": "\u215B",
    "frac23": "\u2154",
    "frac25": "\u2156",
    "frac34": "\u00BE",
    "frac35": "\u2157",
    "frac38": "\u215C",
    "frac45": "\u2158",
    "frac56": "\u215A",
    "frac58": "\u215D",
    "frac78": "\u215E",
    "frasl": "\u2044",
    "frown": "\u2322",
    "Fscr": "\u2131",
    "fscr": "\uD835\uDCBB",
    "gacute": "\u01F5",
    "Gamma": "\u0393",
    "gamma": "\u03B3",
    "Gammad": "\u03DC",
    "gammad": "\u03DD",
    "gap": "\u2A86",
    "Gbreve": "\u011E",
    "gbreve": "\u011F",
    "Gcedil": "\u0122",
    "Gcirc": "\u011C",
    "gcirc": "\u011D",
    "Gcy": "\u0413",
    "gcy": "\u0433",
    "Gdot": "\u0120",
    "gdot": "\u0121",
    "gE": "\u2267",
    "ge": "\u2265",
    "gEl": "\u2A8C",
    "gel": "\u22DB",
    "geq": "\u2265",
    "geqq": "\u2267",
    "geqslant": "\u2A7E",
    "ges": "\u2A7E",
    "gescc": "\u2AA9",
    "gesdot": "\u2A80",
    "gesdoto": "\u2A82",
    "gesdotol": "\u2A84",
    "gesl": "\u22DB\uFE00",
    "gesles": "\u2A94",
    "Gfr": "\uD835\uDD0A",
    "gfr": "\uD835\uDD24",
    "Gg": "\u22D9",
    "gg": "\u226B",
    "ggg": "\u22D9",
    "gimel": "\u2137",
    "GJcy": "\u0403",
    "gjcy": "\u0453",
    "gl": "\u2277",
    "gla": "\u2AA5",
    "glE": "\u2A92",
    "glj": "\u2AA4",
    "gnap": "\u2A8A",
    "gnapprox": "\u2A8A",
    "gnE": "\u2269",
    "gne": "\u2A88",
    "gneq": "\u2A88",
    "gneqq": "\u2269",
    "gnsim": "\u22E7",
    "Gopf": "\uD835\uDD3E",
    "gopf": "\uD835\uDD58",
    "grave": "\u0060",
    "GreaterEqual": "\u2265",
    "GreaterEqualLess": "\u22DB",
    "GreaterFullEqual": "\u2267",
    "GreaterGreater": "\u2AA2",
    "GreaterLess": "\u2277",
    "GreaterSlantEqual": "\u2A7E",
    "GreaterTilde": "\u2273",
    "Gscr": "\uD835\uDCA2",
    "gscr": "\u210A",
    "gsim": "\u2273",
    "gsime": "\u2A8E",
    "gsiml": "\u2A90",
    "GT": "\u003E",
    "Gt": "\u226B",
    "gt": "\u003E",
    "gtcc": "\u2AA7",
    "gtcir": "\u2A7A",
    "gtdot": "\u22D7",
    "gtlPar": "\u2995",
    "gtquest": "\u2A7C",
    "gtrapprox": "\u2A86",
    "gtrarr": "\u2978",
    "gtrdot": "\u22D7",
    "gtreqless": "\u22DB",
    "gtreqqless": "\u2A8C",
    "gtrless": "\u2277",
    "gtrsim": "\u2273",
    "gvertneqq": "\u2269\uFE00",
    "gvnE": "\u2269\uFE00",
    "Hacek": "\u02C7",
    "hairsp": "\u200A",
    "half": "\u00BD",
    "hamilt": "\u210B",
    "HARDcy": "\u042A",
    "hardcy": "\u044A",
    "hArr": "\u21D4",
    "harr": "\u2194",
    "harrcir": "\u2948",
    "harrw": "\u21AD",
    "Hat": "\u005E",
    "hbar": "\u210F",
    "Hcirc": "\u0124",
    "hcirc": "\u0125",
    "hearts": "\u2665",
    "heartsuit": "\u2665",
    "hellip": "\u2026",
    "hercon": "\u22B9",
    "Hfr": "\u210C",
    "hfr": "\uD835\uDD25",
    "HilbertSpace": "\u210B",
    "hksearow": "\u2925",
    "hkswarow": "\u2926",
    "hoarr": "\u21FF",
    "homtht": "\u223B",
    "hookleftarrow": "\u21A9",
    "hookrightarrow": "\u21AA",
    "Hopf": "\u210D",
    "hopf": "\uD835\uDD59",
    "horbar": "\u2015",
    "HorizontalLine": "\u2500",
    "Hscr": "\u210B",
    "hscr": "\uD835\uDCBD",
    "hslash": "\u210F",
    "Hstrok": "\u0126",
    "hstrok": "\u0127",
    "HumpDownHump": "\u224E",
    "HumpEqual": "\u224F",
    "hybull": "\u2043",
    "hyphen": "\u2010",
    "Iacute": "\u00CD",
    "iacute": "\u00ED",
    "ic": "\u2063",
    "Icirc": "\u00CE",
    "icirc": "\u00EE",
    "Icy": "\u0418",
    "icy": "\u0438",
    "Idot": "\u0130",
    "IEcy": "\u0415",
    "iecy": "\u0435",
    "iexcl": "\u00A1",
    "iff": "\u21D4",
    "Ifr": "\u2111",
    "ifr": "\uD835\uDD26",
    "Igrave": "\u00CC",
    "igrave": "\u00EC",
    "ii": "\u2148",
    "iiiint": "\u2A0C",
    "iiint": "\u222D",
    "iinfin": "\u29DC",
    "iiota": "\u2129",
    "IJlig": "\u0132",
    "ijlig": "\u0133",
    "Im": "\u2111",
    "Imacr": "\u012A",
    "imacr": "\u012B",
    "image": "\u2111",
    "ImaginaryI": "\u2148",
    "imagline": "\u2110",
    "imagpart": "\u2111",
    "imath": "\u0131",
    "imof": "\u22B7",
    "imped": "\u01B5",
    "Implies": "\u21D2",
    "in": "\u2208",
    "incare": "\u2105",
    "infin": "\u221E",
    "infintie": "\u29DD",
    "inodot": "\u0131",
    "Int": "\u222C",
    "int": "\u222B",
    "intcal": "\u22BA",
    "integers": "\u2124",
    "Integral": "\u222B",
    "intercal": "\u22BA",
    "Intersection": "\u22C2",
    "intlarhk": "\u2A17",
    "intprod": "\u2A3C",
    "InvisibleComma": "\u2063",
    "InvisibleTimes": "\u2062",
    "IOcy": "\u0401",
    "iocy": "\u0451",
    "Iogon": "\u012E",
    "iogon": "\u012F",
    "Iopf": "\uD835\uDD40",
    "iopf": "\uD835\uDD5A",
    "Iota": "\u0399",
    "iota": "\u03B9",
    "iprod": "\u2A3C",
    "iquest": "\u00BF",
    "Iscr": "\u2110",
    "iscr": "\uD835\uDCBE",
    "isin": "\u2208",
    "isindot": "\u22F5",
    "isinE": "\u22F9",
    "isins": "\u22F4",
    "isinsv": "\u22F3",
    "isinv": "\u2208",
    "it": "\u2062",
    "Itilde": "\u0128",
    "itilde": "\u0129",
    "Iukcy": "\u0406",
    "iukcy": "\u0456",
    "Iuml": "\u00CF",
    "iuml": "\u00EF",
    "Jcirc": "\u0134",
    "jcirc": "\u0135",
    "Jcy": "\u0419",
    "jcy": "\u0439",
    "Jfr": "\uD835\uDD0D",
    "jfr": "\uD835\uDD27",
    "jmath": "\u0237",
    "Jopf": "\uD835\uDD41",
    "jopf": "\uD835\uDD5B",
    "Jscr": "\uD835\uDCA5",
    "jscr": "\uD835\uDCBF",
    "Jsercy": "\u0408",
    "jsercy": "\u0458",
    "Jukcy": "\u0404",
    "jukcy": "\u0454",
    "Kappa": "\u039A",
    "kappa": "\u03BA",
    "kappav": "\u03F0",
    "Kcedil": "\u0136",
    "kcedil": "\u0137",
    "Kcy": "\u041A",
    "kcy": "\u043A",
    "Kfr": "\uD835\uDD0E",
    "kfr": "\uD835\uDD28",
    "kgreen": "\u0138",
    "KHcy": "\u0425",
    "khcy": "\u0445",
    "KJcy": "\u040C",
    "kjcy": "\u045C",
    "Kopf": "\uD835\uDD42",
    "kopf": "\uD835\uDD5C",
    "Kscr": "\uD835\uDCA6",
    "kscr": "\uD835\uDCC0",
    "lAarr": "\u21DA",
    "Lacute": "\u0139",
    "lacute": "\u013A",
    "laemptyv": "\u29B4",
    "lagran": "\u2112",
    "Lambda": "\u039B",
    "lambda": "\u03BB",
    "Lang": "\u27EA",
    "lang": "\u27E8",
    "langd": "\u2991",
    "langle": "\u27E8",
    "lap": "\u2A85",
    "Laplacetrf": "\u2112",
    "laquo": "\u00AB",
    "Larr": "\u219E",
    "lArr": "\u21D0",
    "larr": "\u2190",
    "larrb": "\u21E4",
    "larrbfs": "\u291F",
    "larrfs": "\u291D",
    "larrhk": "\u21A9",
    "larrlp": "\u21AB",
    "larrpl": "\u2939",
    "larrsim": "\u2973",
    "larrtl": "\u21A2",
    "lat": "\u2AAB",
    "lAtail": "\u291B",
    "latail": "\u2919",
    "late": "\u2AAD",
    "lates": "\u2AAD\uFE00",
    "lBarr": "\u290E",
    "lbarr": "\u290C",
    "lbbrk": "\u2772",
    "lbrace": "\u007B",
    "lbrack": "\u005B",
    "lbrke": "\u298B",
    "lbrksld": "\u298F",
    "lbrkslu": "\u298D",
    "Lcaron": "\u013D",
    "lcaron": "\u013E",
    "Lcedil": "\u013B",
    "lcedil": "\u013C",
    "lceil": "\u2308",
    "lcub": "\u007B",
    "Lcy": "\u041B",
    "lcy": "\u043B",
    "ldca": "\u2936",
    "ldquo": "\u201C",
    "ldquor": "\u201E",
    "ldrdhar": "\u2967",
    "ldrushar": "\u294B",
    "ldsh": "\u21B2",
    "lE": "\u2266",
    "le": "\u2264",
    "LeftAngleBracket": "\u27E8",
    "LeftArrow": "\u2190",
    "Leftarrow": "\u21D0",
    "leftarrow": "\u2190",
    "LeftArrowBar": "\u21E4",
    "LeftArrowRightArrow": "\u21C6",
    "leftarrowtail": "\u21A2",
    "LeftCeiling": "\u2308",
    "LeftDoubleBracket": "\u27E6",
    "LeftDownTeeVector": "\u2961",
    "LeftDownVector": "\u21C3",
    "LeftDownVectorBar": "\u2959",
    "LeftFloor": "\u230A",
    "leftharpoondown": "\u21BD",
    "leftharpoonup": "\u21BC",
    "leftleftarrows": "\u21C7",
    "LeftRightArrow": "\u2194",
    "Leftrightarrow": "\u21D4",
    "leftrightarrow": "\u2194",
    "leftrightarrows": "\u21C6",
    "leftrightharpoons": "\u21CB",
    "leftrightsquigarrow": "\u21AD",
    "LeftRightVector": "\u294E",
    "LeftTee": "\u22A3",
    "LeftTeeArrow": "\u21A4",
    "LeftTeeVector": "\u295A",
    "leftthreetimes": "\u22CB",
    "LeftTriangle": "\u22B2",
    "LeftTriangleBar": "\u29CF",
    "LeftTriangleEqual": "\u22B4",
    "LeftUpDownVector": "\u2951",
    "LeftUpTeeVector": "\u2960",
    "LeftUpVector": "\u21BF",
    "LeftUpVectorBar": "\u2958",
    "LeftVector": "\u21BC",
    "LeftVectorBar": "\u2952",
    "lEg": "\u2A8B",
    "leg": "\u22DA",
    "leq": "\u2264",
    "leqq": "\u2266",
    "leqslant": "\u2A7D",
    "les": "\u2A7D",
    "lescc": "\u2AA8",
    "lesdot": "\u2A7F",
    "lesdoto": "\u2A81",
    "lesdotor": "\u2A83",
    "lesg": "\u22DA\uFE00",
    "lesges": "\u2A93",
    "lessapprox": "\u2A85",
    "lessdot": "\u22D6",
    "lesseqgtr": "\u22DA",
    "lesseqqgtr": "\u2A8B",
    "LessEqualGreater": "\u22DA",
    "LessFullEqual": "\u2266",
    "LessGreater": "\u2276",
    "lessgtr": "\u2276",
    "LessLess": "\u2AA1",
    "lesssim": "\u2272",
    "LessSlantEqual": "\u2A7D",
    "LessTilde": "\u2272",
    "lfisht": "\u297C",
    "lfloor": "\u230A",
    "Lfr": "\uD835\uDD0F",
    "lfr": "\uD835\uDD29",
    "lg": "\u2276",
    "lgE": "\u2A91",
    "lHar": "\u2962",
    "lhard": "\u21BD",
    "lharu": "\u21BC",
    "lharul": "\u296A",
    "lhblk": "\u2584",
    "LJcy": "\u0409",
    "ljcy": "\u0459",
    "Ll": "\u22D8",
    "ll": "\u226A",
    "llarr": "\u21C7",
    "llcorner": "\u231E",
    "Lleftarrow": "\u21DA",
    "llhard": "\u296B",
    "lltri": "\u25FA",
    "Lmidot": "\u013F",
    "lmidot": "\u0140",
    "lmoust": "\u23B0",
    "lmoustache": "\u23B0",
    "lnap": "\u2A89",
    "lnapprox": "\u2A89",
    "lnE": "\u2268",
    "lne": "\u2A87",
    "lneq": "\u2A87",
    "lneqq": "\u2268",
    "lnsim": "\u22E6",
    "loang": "\u27EC",
    "loarr": "\u21FD",
    "lobrk": "\u27E6",
    "LongLeftArrow": "\u27F5",
    "Longleftarrow": "\u27F8",
    "longleftarrow": "\u27F5",
    "LongLeftRightArrow": "\u27F7",
    "Longleftrightarrow": "\u27FA",
    "longleftrightarrow": "\u27F7",
    "longmapsto": "\u27FC",
    "LongRightArrow": "\u27F6",
    "Longrightarrow": "\u27F9",
    "longrightarrow": "\u27F6",
    "looparrowleft": "\u21AB",
    "looparrowright": "\u21AC",
    "lopar": "\u2985",
    "Lopf": "\uD835\uDD43",
    "lopf": "\uD835\uDD5D",
    "loplus": "\u2A2D",
    "lotimes": "\u2A34",
    "lowast": "\u2217",
    "lowbar": "\u005F",
    "LowerLeftArrow": "\u2199",
    "LowerRightArrow": "\u2198",
    "loz": "\u25CA",
    "lozenge": "\u25CA",
    "lozf": "\u29EB",
    "lpar": "\u0028",
    "lparlt": "\u2993",
    "lrarr": "\u21C6",
    "lrcorner": "\u231F",
    "lrhar": "\u21CB",
    "lrhard": "\u296D",
    "lrm": "\u200E",
    "lrtri": "\u22BF",
    "lsaquo": "\u2039",
    "Lscr": "\u2112",
    "lscr": "\uD835\uDCC1",
    "Lsh": "\u21B0",
    "lsh": "\u21B0",
    "lsim": "\u2272",
    "lsime": "\u2A8D",
    "lsimg": "\u2A8F",
    "lsqb": "\u005B",
    "lsquo": "\u2018",
    "lsquor": "\u201A",
    "Lstrok": "\u0141",
    "lstrok": "\u0142",
    "LT": "\u003C",
    "Lt": "\u226A",
    "lt": "\u003C",
    "ltcc": "\u2AA6",
    "ltcir": "\u2A79",
    "ltdot": "\u22D6",
    "lthree": "\u22CB",
    "ltimes": "\u22C9",
    "ltlarr": "\u2976",
    "ltquest": "\u2A7B",
    "ltri": "\u25C3",
    "ltrie": "\u22B4",
    "ltrif": "\u25C2",
    "ltrPar": "\u2996",
    "lurdshar": "\u294A",
    "luruhar": "\u2966",
    "lvertneqq": "\u2268\uFE00",
    "lvnE": "\u2268\uFE00",
    "macr": "\u00AF",
    "male": "\u2642",
    "malt": "\u2720",
    "maltese": "\u2720",
    "Map": "\u2905",
    "map": "\u21A6",
    "mapsto": "\u21A6",
    "mapstodown": "\u21A7",
    "mapstoleft": "\u21A4",
    "mapstoup": "\u21A5",
    "marker": "\u25AE",
    "mcomma": "\u2A29",
    "Mcy": "\u041C",
    "mcy": "\u043C",
    "mdash": "\u2014",
    "mDDot": "\u223A",
    "measuredangle": "\u2221",
    "MediumSpace": "\u205F",
    "Mellintrf": "\u2133",
    "Mfr": "\uD835\uDD10",
    "mfr": "\uD835\uDD2A",
    "mho": "\u2127",
    "micro": "\u00B5",
    "mid": "\u2223",
    "midast": "\u002A",
    "midcir": "\u2AF0",
    "middot": "\u00B7",
    "minus": "\u2212",
    "minusb": "\u229F",
    "minusd": "\u2238",
    "minusdu": "\u2A2A",
    "MinusPlus": "\u2213",
    "mlcp": "\u2ADB",
    "mldr": "\u2026",
    "mnplus": "\u2213",
    "models": "\u22A7",
    "Mopf": "\uD835\uDD44",
    "mopf": "\uD835\uDD5E",
    "mp": "\u2213",
    "Mscr": "\u2133",
    "mscr": "\uD835\uDCC2",
    "mstpos": "\u223E",
    "Mu": "\u039C",
    "mu": "\u03BC",
    "multimap": "\u22B8",
    "mumap": "\u22B8",
    "nabla": "\u2207",
    "Nacute": "\u0143",
    "nacute": "\u0144",
    "nang": "\u2220\u20D2",
    "nap": "\u2249",
    "napE": "\u2A70\u0338",
    "napid": "\u224B\u0338",
    "napos": "\u0149",
    "napprox": "\u2249",
    "natur": "\u266E",
    "natural": "\u266E",
    "naturals": "\u2115",
    "nbsp": "\u00A0",
    "nbump": "\u224E\u0338",
    "nbumpe": "\u224F\u0338",
    "ncap": "\u2A43",
    "Ncaron": "\u0147",
    "ncaron": "\u0148",
    "Ncedil": "\u0145",
    "ncedil": "\u0146",
    "ncong": "\u2247",
    "ncongdot": "\u2A6D\u0338",
    "ncup": "\u2A42",
    "Ncy": "\u041D",
    "ncy": "\u043D",
    "ndash": "\u2013",
    "ne": "\u2260",
    "nearhk": "\u2924",
    "neArr": "\u21D7",
    "nearr": "\u2197",
    "nearrow": "\u2197",
    "nedot": "\u2250\u0338",
    "NegativeMediumSpace": "\u200B",
    "NegativeThickSpace": "\u200B",
    "NegativeThinSpace": "\u200B",
    "NegativeVeryThinSpace": "\u200B",
    "nequiv": "\u2262",
    "nesear": "\u2928",
    "nesim": "\u2242\u0338",
    "NestedGreaterGreater": "\u226B",
    "NestedLessLess": "\u226A",
    "NewLine": "\u000A",
    "nexist": "\u2204",
    "nexists": "\u2204",
    "Nfr": "\uD835\uDD11",
    "nfr": "\uD835\uDD2B",
    "ngE": "\u2267\u0338",
    "nge": "\u2271",
    "ngeq": "\u2271",
    "ngeqq": "\u2267\u0338",
    "ngeqslant": "\u2A7E\u0338",
    "nges": "\u2A7E\u0338",
    "nGg": "\u22D9\u0338",
    "ngsim": "\u2275",
    "nGt": "\u226B\u20D2",
    "ngt": "\u226F",
    "ngtr": "\u226F",
    "nGtv": "\u226B\u0338",
    "nhArr": "\u21CE",
    "nharr": "\u21AE",
    "nhpar": "\u2AF2",
    "ni": "\u220B",
    "nis": "\u22FC",
    "nisd": "\u22FA",
    "niv": "\u220B",
    "NJcy": "\u040A",
    "njcy": "\u045A",
    "nlArr": "\u21CD",
    "nlarr": "\u219A",
    "nldr": "\u2025",
    "nlE": "\u2266\u0338",
    "nle": "\u2270",
    "nLeftarrow": "\u21CD",
    "nleftarrow": "\u219A",
    "nLeftrightarrow": "\u21CE",
    "nleftrightarrow": "\u21AE",
    "nleq": "\u2270",
    "nleqq": "\u2266\u0338",
    "nleqslant": "\u2A7D\u0338",
    "nles": "\u2A7D\u0338",
    "nless": "\u226E",
    "nLl": "\u22D8\u0338",
    "nlsim": "\u2274",
    "nLt": "\u226A\u20D2",
    "nlt": "\u226E",
    "nltri": "\u22EA",
    "nltrie": "\u22EC",
    "nLtv": "\u226A\u0338",
    "nmid": "\u2224",
    "NoBreak": "\u2060",
    "NonBreakingSpace": "\u00A0",
    "Nopf": "\u2115",
    "nopf": "\uD835\uDD5F",
    "Not": "\u2AEC",
    "not": "\u00AC",
    "NotCongruent": "\u2262",
    "NotCupCap": "\u226D",
    "NotDoubleVerticalBar": "\u2226",
    "NotElement": "\u2209",
    "NotEqual": "\u2260",
    "NotEqualTilde": "\u2242\u0338",
    "NotExists": "\u2204",
    "NotGreater": "\u226F",
    "NotGreaterEqual": "\u2271",
    "NotGreaterFullEqual": "\u2267\u0338",
    "NotGreaterGreater": "\u226B\u0338",
    "NotGreaterLess": "\u2279",
    "NotGreaterSlantEqual": "\u2A7E\u0338",
    "NotGreaterTilde": "\u2275",
    "NotHumpDownHump": "\u224E\u0338",
    "NotHumpEqual": "\u224F\u0338",
    "notin": "\u2209",
    "notindot": "\u22F5\u0338",
    "notinE": "\u22F9\u0338",
    "notinva": "\u2209",
    "notinvb": "\u22F7",
    "notinvc": "\u22F6",
    "NotLeftTriangle": "\u22EA",
    "NotLeftTriangleBar": "\u29CF\u0338",
    "NotLeftTriangleEqual": "\u22EC",
    "NotLess": "\u226E",
    "NotLessEqual": "\u2270",
    "NotLessGreater": "\u2278",
    "NotLessLess": "\u226A\u0338",
    "NotLessSlantEqual": "\u2A7D\u0338",
    "NotLessTilde": "\u2274",
    "NotNestedGreaterGreater": "\u2AA2\u0338",
    "NotNestedLessLess": "\u2AA1\u0338",
    "notni": "\u220C",
    "notniva": "\u220C",
    "notnivb": "\u22FE",
    "notnivc": "\u22FD",
    "NotPrecedes": "\u2280",
    "NotPrecedesEqual": "\u2AAF\u0338",
    "NotPrecedesSlantEqual": "\u22E0",
    "NotReverseElement": "\u220C",
    "NotRightTriangle": "\u22EB",
    "NotRightTriangleBar": "\u29D0\u0338",
    "NotRightTriangleEqual": "\u22ED",
    "NotSquareSubset": "\u228F\u0338",
    "NotSquareSubsetEqual": "\u22E2",
    "NotSquareSuperset": "\u2290\u0338",
    "NotSquareSupersetEqual": "\u22E3",
    "NotSubset": "\u2282\u20D2",
    "NotSubsetEqual": "\u2288",
    "NotSucceeds": "\u2281",
    "NotSucceedsEqual": "\u2AB0\u0338",
    "NotSucceedsSlantEqual": "\u22E1",
    "NotSucceedsTilde": "\u227F\u0338",
    "NotSuperset": "\u2283\u20D2",
    "NotSupersetEqual": "\u2289",
    "NotTilde": "\u2241",
    "NotTildeEqual": "\u2244",
    "NotTildeFullEqual": "\u2247",
    "NotTildeTilde": "\u2249",
    "NotVerticalBar": "\u2224",
    "npar": "\u2226",
    "nparallel": "\u2226",
    "nparsl": "\u2AFD\u20E5",
    "npart": "\u2202\u0338",
    "npolint": "\u2A14",
    "npr": "\u2280",
    "nprcue": "\u22E0",
    "npre": "\u2AAF\u0338",
    "nprec": "\u2280",
    "npreceq": "\u2AAF\u0338",
    "nrArr": "\u21CF",
    "nrarr": "\u219B",
    "nrarrc": "\u2933\u0338",
    "nrarrw": "\u219D\u0338",
    "nRightarrow": "\u21CF",
    "nrightarrow": "\u219B",
    "nrtri": "\u22EB",
    "nrtrie": "\u22ED",
    "nsc": "\u2281",
    "nsccue": "\u22E1",
    "nsce": "\u2AB0\u0338",
    "Nscr": "\uD835\uDCA9",
    "nscr": "\uD835\uDCC3",
    "nshortmid": "\u2224",
    "nshortparallel": "\u2226",
    "nsim": "\u2241",
    "nsime": "\u2244",
    "nsimeq": "\u2244",
    "nsmid": "\u2224",
    "nspar": "\u2226",
    "nsqsube": "\u22E2",
    "nsqsupe": "\u22E3",
    "nsub": "\u2284",
    "nsubE": "\u2AC5\u0338",
    "nsube": "\u2288",
    "nsubset": "\u2282\u20D2",
    "nsubseteq": "\u2288",
    "nsubseteqq": "\u2AC5\u0338",
    "nsucc": "\u2281",
    "nsucceq": "\u2AB0\u0338",
    "nsup": "\u2285",
    "nsupE": "\u2AC6\u0338",
    "nsupe": "\u2289",
    "nsupset": "\u2283\u20D2",
    "nsupseteq": "\u2289",
    "nsupseteqq": "\u2AC6\u0338",
    "ntgl": "\u2279",
    "Ntilde": "\u00D1",
    "ntilde": "\u00F1",
    "ntlg": "\u2278",
    "ntriangleleft": "\u22EA",
    "ntrianglelefteq": "\u22EC",
    "ntriangleright": "\u22EB",
    "ntrianglerighteq": "\u22ED",
    "Nu": "\u039D",
    "nu": "\u03BD",
    "num": "\u0023",
    "numero": "\u2116",
    "numsp": "\u2007",
    "nvap": "\u224D\u20D2",
    "nVDash": "\u22AF",
    "nVdash": "\u22AE",
    "nvDash": "\u22AD",
    "nvdash": "\u22AC",
    "nvge": "\u2265\u20D2",
    "nvgt": "\u003E\u20D2",
    "nvHarr": "\u2904",
    "nvinfin": "\u29DE",
    "nvlArr": "\u2902",
    "nvle": "\u2264\u20D2",
    "nvlt": "\u003C\u20D2",
    "nvltrie": "\u22B4\u20D2",
    "nvrArr": "\u2903",
    "nvrtrie": "\u22B5\u20D2",
    "nvsim": "\u223C\u20D2",
    "nwarhk": "\u2923",
    "nwArr": "\u21D6",
    "nwarr": "\u2196",
    "nwarrow": "\u2196",
    "nwnear": "\u2927",
    "Oacute": "\u00D3",
    "oacute": "\u00F3",
    "oast": "\u229B",
    "ocir": "\u229A",
    "Ocirc": "\u00D4",
    "ocirc": "\u00F4",
    "Ocy": "\u041E",
    "ocy": "\u043E",
    "odash": "\u229D",
    "Odblac": "\u0150",
    "odblac": "\u0151",
    "odiv": "\u2A38",
    "odot": "\u2299",
    "odsold": "\u29BC",
    "OElig": "\u0152",
    "oelig": "\u0153",
    "ofcir": "\u29BF",
    "Ofr": "\uD835\uDD12",
    "ofr": "\uD835\uDD2C",
    "ogon": "\u02DB",
    "Ograve": "\u00D2",
    "ograve": "\u00F2",
    "ogt": "\u29C1",
    "ohbar": "\u29B5",
    "ohm": "\u03A9",
    "oint": "\u222E",
    "olarr": "\u21BA",
    "olcir": "\u29BE",
    "olcross": "\u29BB",
    "oline": "\u203E",
    "olt": "\u29C0",
    "Omacr": "\u014C",
    "omacr": "\u014D",
    "Omega": "\u03A9",
    "omega": "\u03C9",
    "Omicron": "\u039F",
    "omicron": "\u03BF",
    "omid": "\u29B6",
    "ominus": "\u2296",
    "Oopf": "\uD835\uDD46",
    "oopf": "\uD835\uDD60",
    "opar": "\u29B7",
    "OpenCurlyDoubleQuote": "\u201C",
    "OpenCurlyQuote": "\u2018",
    "operp": "\u29B9",
    "oplus": "\u2295",
    "Or": "\u2A54",
    "or": "\u2228",
    "orarr": "\u21BB",
    "ord": "\u2A5D",
    "order": "\u2134",
    "orderof": "\u2134",
    "ordf": "\u00AA",
    "ordm": "\u00BA",
    "origof": "\u22B6",
    "oror": "\u2A56",
    "orslope": "\u2A57",
    "orv": "\u2A5B",
    "oS": "\u24C8",
    "Oscr": "\uD835\uDCAA",
    "oscr": "\u2134",
    "Oslash": "\u00D8",
    "oslash": "\u00F8",
    "osol": "\u2298",
    "Otilde": "\u00D5",
    "otilde": "\u00F5",
    "Otimes": "\u2A37",
    "otimes": "\u2297",
    "otimesas": "\u2A36",
    "Ouml": "\u00D6",
    "ouml": "\u00F6",
    "ovbar": "\u233D",
    "OverBar": "\u203E",
    "OverBrace": "\u23DE",
    "OverBracket": "\u23B4",
    "OverParenthesis": "\u23DC",
    "par": "\u2225",
    "para": "\u00B6",
    "parallel": "\u2225",
    "parsim": "\u2AF3",
    "parsl": "\u2AFD",
    "part": "\u2202",
    "PartialD": "\u2202",
    "Pcy": "\u041F",
    "pcy": "\u043F",
    "percnt": "\u0025",
    "period": "\u002E",
    "permil": "\u2030",
    "perp": "\u22A5",
    "pertenk": "\u2031",
    "Pfr": "\uD835\uDD13",
    "pfr": "\uD835\uDD2D",
    "Phi": "\u03A6",
    "phi": "\u03C6",
    "phiv": "\u03D5",
    "phmmat": "\u2133",
    "phone": "\u260E",
    "Pi": "\u03A0",
    "pi": "\u03C0",
    "pitchfork": "\u22D4",
    "piv": "\u03D6",
    "planck": "\u210F",
    "planckh": "\u210E",
    "plankv": "\u210F",
    "plus": "\u002B",
    "plusacir": "\u2A23",
    "plusb": "\u229E",
    "pluscir": "\u2A22",
    "plusdo": "\u2214",
    "plusdu": "\u2A25",
    "pluse": "\u2A72",
    "PlusMinus": "\u00B1",
    "plusmn": "\u00B1",
    "plussim": "\u2A26",
    "plustwo": "\u2A27",
    "pm": "\u00B1",
    "Poincareplane": "\u210C",
    "pointint": "\u2A15",
    "Popf": "\u2119",
    "popf": "\uD835\uDD61",
    "pound": "\u00A3",
    "Pr": "\u2ABB",
    "pr": "\u227A",
    "prap": "\u2AB7",
    "prcue": "\u227C",
    "prE": "\u2AB3",
    "pre": "\u2AAF",
    "prec": "\u227A",
    "precapprox": "\u2AB7",
    "preccurlyeq": "\u227C",
    "Precedes": "\u227A",
    "PrecedesEqual": "\u2AAF",
    "PrecedesSlantEqual": "\u227C",
    "PrecedesTilde": "\u227E",
    "preceq": "\u2AAF",
    "precnapprox": "\u2AB9",
    "precneqq": "\u2AB5",
    "precnsim": "\u22E8",
    "precsim": "\u227E",
    "Prime": "\u2033",
    "prime": "\u2032",
    "primes": "\u2119",
    "prnap": "\u2AB9",
    "prnE": "\u2AB5",
    "prnsim": "\u22E8",
    "prod": "\u220F",
    "Product": "\u220F",
    "profalar": "\u232E",
    "profline": "\u2312",
    "profsurf": "\u2313",
    "prop": "\u221D",
    "Proportion": "\u2237",
    "Proportional": "\u221D",
    "propto": "\u221D",
    "prsim": "\u227E",
    "prurel": "\u22B0",
    "Pscr": "\uD835\uDCAB",
    "pscr": "\uD835\uDCC5",
    "Psi": "\u03A8",
    "psi": "\u03C8",
    "puncsp": "\u2008",
    "Qfr": "\uD835\uDD14",
    "qfr": "\uD835\uDD2E",
    "qint": "\u2A0C",
    "Qopf": "\u211A",
    "qopf": "\uD835\uDD62",
    "qprime": "\u2057",
    "Qscr": "\uD835\uDCAC",
    "qscr": "\uD835\uDCC6",
    "quaternions": "\u210D",
    "quatint": "\u2A16",
    "quest": "\u003F",
    "questeq": "\u225F",
    "QUOT": "\u0022",
    "quot": "\u0022",
    "rAarr": "\u21DB",
    "race": "\u223D\u0331",
    "Racute": "\u0154",
    "racute": "\u0155",
    "radic": "\u221A",
    "raemptyv": "\u29B3",
    "Rang": "\u27EB",
    "rang": "\u27E9",
    "rangd": "\u2992",
    "range": "\u29A5",
    "rangle": "\u27E9",
    "raquo": "\u00BB",
    "Rarr": "\u21A0",
    "rArr": "\u21D2",
    "rarr": "\u2192",
    "rarrap": "\u2975",
    "rarrb": "\u21E5",
    "rarrbfs": "\u2920",
    "rarrc": "\u2933",
    "rarrfs": "\u291E",
    "rarrhk": "\u21AA",
    "rarrlp": "\u21AC",
    "rarrpl": "\u2945",
    "rarrsim": "\u2974",
    "Rarrtl": "\u2916",
    "rarrtl": "\u21A3",
    "rarrw": "\u219D",
    "rAtail": "\u291C",
    "ratail": "\u291A",
    "ratio": "\u2236",
    "rationals": "\u211A",
    "RBarr": "\u2910",
    "rBarr": "\u290F",
    "rbarr": "\u290D",
    "rbbrk": "\u2773",
    "rbrace": "\u007D",
    "rbrack": "\u005D",
    "rbrke": "\u298C",
    "rbrksld": "\u298E",
    "rbrkslu": "\u2990",
    "Rcaron": "\u0158",
    "rcaron": "\u0159",
    "Rcedil": "\u0156",
    "rcedil": "\u0157",
    "rceil": "\u2309",
    "rcub": "\u007D",
    "Rcy": "\u0420",
    "rcy": "\u0440",
    "rdca": "\u2937",
    "rdldhar": "\u2969",
    "rdquo": "\u201D",
    "rdquor": "\u201D",
    "rdsh": "\u21B3",
    "Re": "\u211C",
    "real": "\u211C",
    "realine": "\u211B",
    "realpart": "\u211C",
    "reals": "\u211D",
    "rect": "\u25AD",
    "REG": "\u00AE",
    "reg": "\u00AE",
    "ReverseElement": "\u220B",
    "ReverseEquilibrium": "\u21CB",
    "ReverseUpEquilibrium": "\u296F",
    "rfisht": "\u297D",
    "rfloor": "\u230B",
    "Rfr": "\u211C",
    "rfr": "\uD835\uDD2F",
    "rHar": "\u2964",
    "rhard": "\u21C1",
    "rharu": "\u21C0",
    "rharul": "\u296C",
    "Rho": "\u03A1",
    "rho": "\u03C1",
    "rhov": "\u03F1",
    "RightAngleBracket": "\u27E9",
    "RightArrow": "\u2192",
    "Rightarrow": "\u21D2",
    "rightarrow": "\u2192",
    "RightArrowBar": "\u21E5",
    "RightArrowLeftArrow": "\u21C4",
    "rightarrowtail": "\u21A3",
    "RightCeiling": "\u2309",
    "RightDoubleBracket": "\u27E7",
    "RightDownTeeVector": "\u295D",
    "RightDownVector": "\u21C2",
    "RightDownVectorBar": "\u2955",
    "RightFloor": "\u230B",
    "rightharpoondown": "\u21C1",
    "rightharpoonup": "\u21C0",
    "rightleftarrows": "\u21C4",
    "rightleftharpoons": "\u21CC",
    "rightrightarrows": "\u21C9",
    "rightsquigarrow": "\u219D",
    "RightTee": "\u22A2",
    "RightTeeArrow": "\u21A6",
    "RightTeeVector": "\u295B",
    "rightthreetimes": "\u22CC",
    "RightTriangle": "\u22B3",
    "RightTriangleBar": "\u29D0",
    "RightTriangleEqual": "\u22B5",
    "RightUpDownVector": "\u294F",
    "RightUpTeeVector": "\u295C",
    "RightUpVector": "\u21BE",
    "RightUpVectorBar": "\u2954",
    "RightVector": "\u21C0",
    "RightVectorBar": "\u2953",
    "ring": "\u02DA",
    "risingdotseq": "\u2253",
    "rlarr": "\u21C4",
    "rlhar": "\u21CC",
    "rlm": "\u200F",
    "rmoust": "\u23B1",
    "rmoustache": "\u23B1",
    "rnmid": "\u2AEE",
    "roang": "\u27ED",
    "roarr": "\u21FE",
    "robrk": "\u27E7",
    "ropar": "\u2986",
    "Ropf": "\u211D",
    "ropf": "\uD835\uDD63",
    "roplus": "\u2A2E",
    "rotimes": "\u2A35",
    "RoundImplies": "\u2970",
    "rpar": "\u0029",
    "rpargt": "\u2994",
    "rppolint": "\u2A12",
    "rrarr": "\u21C9",
    "Rrightarrow": "\u21DB",
    "rsaquo": "\u203A",
    "Rscr": "\u211B",
    "rscr": "\uD835\uDCC7",
    "Rsh": "\u21B1",
    "rsh": "\u21B1",
    "rsqb": "\u005D",
    "rsquo": "\u2019",
    "rsquor": "\u2019",
    "rthree": "\u22CC",
    "rtimes": "\u22CA",
    "rtri": "\u25B9",
    "rtrie": "\u22B5",
    "rtrif": "\u25B8",
    "rtriltri": "\u29CE",
    "RuleDelayed": "\u29F4",
    "ruluhar": "\u2968",
    "rx": "\u211E",
    "Sacute": "\u015A",
    "sacute": "\u015B",
    "sbquo": "\u201A",
    "Sc": "\u2ABC",
    "sc": "\u227B",
    "scap": "\u2AB8",
    "Scaron": "\u0160",
    "scaron": "\u0161",
    "sccue": "\u227D",
    "scE": "\u2AB4",
    "sce": "\u2AB0",
    "Scedil": "\u015E",
    "scedil": "\u015F",
    "Scirc": "\u015C",
    "scirc": "\u015D",
    "scnap": "\u2ABA",
    "scnE": "\u2AB6",
    "scnsim": "\u22E9",
    "scpolint": "\u2A13",
    "scsim": "\u227F",
    "Scy": "\u0421",
    "scy": "\u0441",
    "sdot": "\u22C5",
    "sdotb": "\u22A1",
    "sdote": "\u2A66",
    "searhk": "\u2925",
    "seArr": "\u21D8",
    "searr": "\u2198",
    "searrow": "\u2198",
    "sect": "\u00A7",
    "semi": "\u003B",
    "seswar": "\u2929",
    "setminus": "\u2216",
    "setmn": "\u2216",
    "sext": "\u2736",
    "Sfr": "\uD835\uDD16",
    "sfr": "\uD835\uDD30",
    "sfrown": "\u2322",
    "sharp": "\u266F",
    "SHCHcy": "\u0429",
    "shchcy": "\u0449",
    "SHcy": "\u0428",
    "shcy": "\u0448",
    "ShortDownArrow": "\u2193",
    "ShortLeftArrow": "\u2190",
    "shortmid": "\u2223",
    "shortparallel": "\u2225",
    "ShortRightArrow": "\u2192",
    "ShortUpArrow": "\u2191",
    "shy": "\u00AD",
    "Sigma": "\u03A3",
    "sigma": "\u03C3",
    "sigmaf": "\u03C2",
    "sigmav": "\u03C2",
    "sim": "\u223C",
    "simdot": "\u2A6A",
    "sime": "\u2243",
    "simeq": "\u2243",
    "simg": "\u2A9E",
    "simgE": "\u2AA0",
    "siml": "\u2A9D",
    "simlE": "\u2A9F",
    "simne": "\u2246",
    "simplus": "\u2A24",
    "simrarr": "\u2972",
    "slarr": "\u2190",
    "SmallCircle": "\u2218",
    "smallsetminus": "\u2216",
    "smashp": "\u2A33",
    "smeparsl": "\u29E4",
    "smid": "\u2223",
    "smile": "\u2323",
    "smt": "\u2AAA",
    "smte": "\u2AAC",
    "smtes": "\u2AAC\uFE00",
    "SOFTcy": "\u042C",
    "softcy": "\u044C",
    "sol": "\u002F",
    "solb": "\u29C4",
    "solbar": "\u233F",
    "Sopf": "\uD835\uDD4A",
    "sopf": "\uD835\uDD64",
    "spades": "\u2660",
    "spadesuit": "\u2660",
    "spar": "\u2225",
    "sqcap": "\u2293",
    "sqcaps": "\u2293\uFE00",
    "sqcup": "\u2294",
    "sqcups": "\u2294\uFE00",
    "Sqrt": "\u221A",
    "sqsub": "\u228F",
    "sqsube": "\u2291",
    "sqsubset": "\u228F",
    "sqsubseteq": "\u2291",
    "sqsup": "\u2290",
    "sqsupe": "\u2292",
    "sqsupset": "\u2290",
    "sqsupseteq": "\u2292",
    "squ": "\u25A1",
    "Square": "\u25A1",
    "square": "\u25A1",
    "SquareIntersection": "\u2293",
    "SquareSubset": "\u228F",
    "SquareSubsetEqual": "\u2291",
    "SquareSuperset": "\u2290",
    "SquareSupersetEqual": "\u2292",
    "SquareUnion": "\u2294",
    "squarf": "\u25AA",
    "squf": "\u25AA",
    "srarr": "\u2192",
    "Sscr": "\uD835\uDCAE",
    "sscr": "\uD835\uDCC8",
    "ssetmn": "\u2216",
    "ssmile": "\u2323",
    "sstarf": "\u22C6",
    "Star": "\u22C6",
    "star": "\u2606",
    "starf": "\u2605",
    "straightepsilon": "\u03F5",
    "straightphi": "\u03D5",
    "strns": "\u00AF",
    "Sub": "\u22D0",
    "sub": "\u2282",
    "subdot": "\u2ABD",
    "subE": "\u2AC5",
    "sube": "\u2286",
    "subedot": "\u2AC3",
    "submult": "\u2AC1",
    "subnE": "\u2ACB",
    "subne": "\u228A",
    "subplus": "\u2ABF",
    "subrarr": "\u2979",
    "Subset": "\u22D0",
    "subset": "\u2282",
    "subseteq": "\u2286",
    "subseteqq": "\u2AC5",
    "SubsetEqual": "\u2286",
    "subsetneq": "\u228A",
    "subsetneqq": "\u2ACB",
    "subsim": "\u2AC7",
    "subsub": "\u2AD5",
    "subsup": "\u2AD3",
    "succ": "\u227B",
    "succapprox": "\u2AB8",
    "succcurlyeq": "\u227D",
    "Succeeds": "\u227B",
    "SucceedsEqual": "\u2AB0",
    "SucceedsSlantEqual": "\u227D",
    "SucceedsTilde": "\u227F",
    "succeq": "\u2AB0",
    "succnapprox": "\u2ABA",
    "succneqq": "\u2AB6",
    "succnsim": "\u22E9",
    "succsim": "\u227F",
    "SuchThat": "\u220B",
    "Sum": "\u2211",
    "sum": "\u2211",
    "sung": "\u266A",
    "Sup": "\u22D1",
    "sup": "\u2283",
    "sup1": "\u00B9",
    "sup2": "\u00B2",
    "sup3": "\u00B3",
    "supdot": "\u2ABE",
    "supdsub": "\u2AD8",
    "supE": "\u2AC6",
    "supe": "\u2287",
    "supedot": "\u2AC4",
    "Superset": "\u2283",
    "SupersetEqual": "\u2287",
    "suphsol": "\u27C9",
    "suphsub": "\u2AD7",
    "suplarr": "\u297B",
    "supmult": "\u2AC2",
    "supnE": "\u2ACC",
    "supne": "\u228B",
    "supplus": "\u2AC0",
    "Supset": "\u22D1",
    "supset": "\u2283",
    "supseteq": "\u2287",
    "supseteqq": "\u2AC6",
    "supsetneq": "\u228B",
    "supsetneqq": "\u2ACC",
    "supsim": "\u2AC8",
    "supsub": "\u2AD4",
    "supsup": "\u2AD6",
    "swarhk": "\u2926",
    "swArr": "\u21D9",
    "swarr": "\u2199",
    "swarrow": "\u2199",
    "swnwar": "\u292A",
    "szlig": "\u00DF",
    "Tab": "\u0009",
    "target": "\u2316",
    "Tau": "\u03A4",
    "tau": "\u03C4",
    "tbrk": "\u23B4",
    "Tcaron": "\u0164",
    "tcaron": "\u0165",
    "Tcedil": "\u0162",
    "tcedil": "\u0163",
    "Tcy": "\u0422",
    "tcy": "\u0442",
    "tdot": "\u20DB",
    "telrec": "\u2315",
    "Tfr": "\uD835\uDD17",
    "tfr": "\uD835\uDD31",
    "there4": "\u2234",
    "Therefore": "\u2234",
    "therefore": "\u2234",
    "Theta": "\u0398",
    "theta": "\u03B8",
    "thetasym": "\u03D1",
    "thetav": "\u03D1",
    "thickapprox": "\u2248",
    "thicksim": "\u223C",
    "ThickSpace": "\u205F\u200A",
    "thinsp": "\u2009",
    "ThinSpace": "\u2009",
    "thkap": "\u2248",
    "thksim": "\u223C",
    "THORN": "\u00DE",
    "thorn": "\u00FE",
    "Tilde": "\u223C",
    "tilde": "\u02DC",
    "TildeEqual": "\u2243",
    "TildeFullEqual": "\u2245",
    "TildeTilde": "\u2248",
    "times": "\u00D7",
    "timesb": "\u22A0",
    "timesbar": "\u2A31",
    "timesd": "\u2A30",
    "tint": "\u222D",
    "toea": "\u2928",
    "top": "\u22A4",
    "topbot": "\u2336",
    "topcir": "\u2AF1",
    "Topf": "\uD835\uDD4B",
    "topf": "\uD835\uDD65",
    "topfork": "\u2ADA",
    "tosa": "\u2929",
    "tprime": "\u2034",
    "TRADE": "\u2122",
    "trade": "\u2122",
    "triangle": "\u25B5",
    "triangledown": "\u25BF",
    "triangleleft": "\u25C3",
    "trianglelefteq": "\u22B4",
    "triangleq": "\u225C",
    "triangleright": "\u25B9",
    "trianglerighteq": "\u22B5",
    "tridot": "\u25EC",
    "trie": "\u225C",
    "triminus": "\u2A3A",
    "TripleDot": "\u20DB",
    "triplus": "\u2A39",
    "trisb": "\u29CD",
    "tritime": "\u2A3B",
    "trpezium": "\u23E2",
    "Tscr": "\uD835\uDCAF",
    "tscr": "\uD835\uDCC9",
    "TScy": "\u0426",
    "tscy": "\u0446",
    "TSHcy": "\u040B",
    "tshcy": "\u045B",
    "Tstrok": "\u0166",
    "tstrok": "\u0167",
    "twixt": "\u226C",
    "twoheadleftarrow": "\u219E",
    "twoheadrightarrow": "\u21A0",
    "Uacute": "\u00DA",
    "uacute": "\u00FA",
    "Uarr": "\u219F",
    "uArr": "\u21D1",
    "uarr": "\u2191",
    "Uarrocir": "\u2949",
    "Ubrcy": "\u040E",
    "ubrcy": "\u045E",
    "Ubreve": "\u016C",
    "ubreve": "\u016D",
    "Ucirc": "\u00DB",
    "ucirc": "\u00FB",
    "Ucy": "\u0423",
    "ucy": "\u0443",
    "udarr": "\u21C5",
    "Udblac": "\u0170",
    "udblac": "\u0171",
    "udhar": "\u296E",
    "ufisht": "\u297E",
    "Ufr": "\uD835\uDD18",
    "ufr": "\uD835\uDD32",
    "Ugrave": "\u00D9",
    "ugrave": "\u00F9",
    "uHar": "\u2963",
    "uharl": "\u21BF",
    "uharr": "\u21BE",
    "uhblk": "\u2580",
    "ulcorn": "\u231C",
    "ulcorner": "\u231C",
    "ulcrop": "\u230F",
    "ultri": "\u25F8",
    "Umacr": "\u016A",
    "umacr": "\u016B",
    "uml": "\u00A8",
    "UnderBar": "\u005F",
    "UnderBrace": "\u23DF",
    "UnderBracket": "\u23B5",
    "UnderParenthesis": "\u23DD",
    "Union": "\u22C3",
    "UnionPlus": "\u228E",
    "Uogon": "\u0172",
    "uogon": "\u0173",
    "Uopf": "\uD835\uDD4C",
    "uopf": "\uD835\uDD66",
    "UpArrow": "\u2191",
    "Uparrow": "\u21D1",
    "uparrow": "\u2191",
    "UpArrowBar": "\u2912",
    "UpArrowDownArrow": "\u21C5",
    "UpDownArrow": "\u2195",
    "Updownarrow": "\u21D5",
    "updownarrow": "\u2195",
    "UpEquilibrium": "\u296E",
    "upharpoonleft": "\u21BF",
    "upharpoonright": "\u21BE",
    "uplus": "\u228E",
    "UpperLeftArrow": "\u2196",
    "UpperRightArrow": "\u2197",
    "Upsi": "\u03D2",
    "upsi": "\u03C5",
    "upsih": "\u03D2",
    "Upsilon": "\u03A5",
    "upsilon": "\u03C5",
    "UpTee": "\u22A5",
    "UpTeeArrow": "\u21A5",
    "upuparrows": "\u21C8",
    "urcorn": "\u231D",
    "urcorner": "\u231D",
    "urcrop": "\u230E",
    "Uring": "\u016E",
    "uring": "\u016F",
    "urtri": "\u25F9",
    "Uscr": "\uD835\uDCB0",
    "uscr": "\uD835\uDCCA",
    "utdot": "\u22F0",
    "Utilde": "\u0168",
    "utilde": "\u0169",
    "utri": "\u25B5",
    "utrif": "\u25B4",
    "uuarr": "\u21C8",
    "Uuml": "\u00DC",
    "uuml": "\u00FC",
    "uwangle": "\u29A7",
    "vangrt": "\u299C",
    "varepsilon": "\u03F5",
    "varkappa": "\u03F0",
    "varnothing": "\u2205",
    "varphi": "\u03D5",
    "varpi": "\u03D6",
    "varpropto": "\u221D",
    "vArr": "\u21D5",
    "varr": "\u2195",
    "varrho": "\u03F1",
    "varsigma": "\u03C2",
    "varsubsetneq": "\u228A\uFE00",
    "varsubsetneqq": "\u2ACB\uFE00",
    "varsupsetneq": "\u228B\uFE00",
    "varsupsetneqq": "\u2ACC\uFE00",
    "vartheta": "\u03D1",
    "vartriangleleft": "\u22B2",
    "vartriangleright": "\u22B3",
    "Vbar": "\u2AEB",
    "vBar": "\u2AE8",
    "vBarv": "\u2AE9",
    "Vcy": "\u0412",
    "vcy": "\u0432",
    "VDash": "\u22AB",
    "Vdash": "\u22A9",
    "vDash": "\u22A8",
    "vdash": "\u22A2",
    "Vdashl": "\u2AE6",
    "Vee": "\u22C1",
    "vee": "\u2228",
    "veebar": "\u22BB",
    "veeeq": "\u225A",
    "vellip": "\u22EE",
    "Verbar": "\u2016",
    "verbar": "\u007C",
    "Vert": "\u2016",
    "vert": "\u007C",
    "VerticalBar": "\u2223",
    "VerticalLine": "\u007C",
    "VerticalSeparator": "\u2758",
    "VerticalTilde": "\u2240",
    "VeryThinSpace": "\u200A",
    "Vfr": "\uD835\uDD19",
    "vfr": "\uD835\uDD33",
    "vltri": "\u22B2",
    "vnsub": "\u2282\u20D2",
    "vnsup": "\u2283\u20D2",
    "Vopf": "\uD835\uDD4D",
    "vopf": "\uD835\uDD67",
    "vprop": "\u221D",
    "vrtri": "\u22B3",
    "Vscr": "\uD835\uDCB1",
    "vscr": "\uD835\uDCCB",
    "vsubnE": "\u2ACB\uFE00",
    "vsubne": "\u228A\uFE00",
    "vsupnE": "\u2ACC\uFE00",
    "vsupne": "\u228B\uFE00",
    "Vvdash": "\u22AA",
    "vzigzag": "\u299A",
    "Wcirc": "\u0174",
    "wcirc": "\u0175",
    "wedbar": "\u2A5F",
    "Wedge": "\u22C0",
    "wedge": "\u2227",
    "wedgeq": "\u2259",
    "weierp": "\u2118",
    "Wfr": "\uD835\uDD1A",
    "wfr": "\uD835\uDD34",
    "Wopf": "\uD835\uDD4E",
    "wopf": "\uD835\uDD68",
    "wp": "\u2118",
    "wr": "\u2240",
    "wreath": "\u2240",
    "Wscr": "\uD835\uDCB2",
    "wscr": "\uD835\uDCCC",
    "xcap": "\u22C2",
    "xcirc": "\u25EF",
    "xcup": "\u22C3",
    "xdtri": "\u25BD",
    "Xfr": "\uD835\uDD1B",
    "xfr": "\uD835\uDD35",
    "xhArr": "\u27FA",
    "xharr": "\u27F7",
    "Xi": "\u039E",
    "xi": "\u03BE",
    "xlArr": "\u27F8",
    "xlarr": "\u27F5",
    "xmap": "\u27FC",
    "xnis": "\u22FB",
    "xodot": "\u2A00",
    "Xopf": "\uD835\uDD4F",
    "xopf": "\uD835\uDD69",
    "xoplus": "\u2A01",
    "xotime": "\u2A02",
    "xrArr": "\u27F9",
    "xrarr": "\u27F6",
    "Xscr": "\uD835\uDCB3",
    "xscr": "\uD835\uDCCD",
    "xsqcup": "\u2A06",
    "xuplus": "\u2A04",
    "xutri": "\u25B3",
    "xvee": "\u22C1",
    "xwedge": "\u22C0",
    "Yacute": "\u00DD",
    "yacute": "\u00FD",
    "YAcy": "\u042F",
    "yacy": "\u044F",
    "Ycirc": "\u0176",
    "ycirc": "\u0177",
    "Ycy": "\u042B",
    "ycy": "\u044B",
    "yen": "\u00A5",
    "Yfr": "\uD835\uDD1C",
    "yfr": "\uD835\uDD36",
    "YIcy": "\u0407",
    "yicy": "\u0457",
    "Yopf": "\uD835\uDD50",
    "yopf": "\uD835\uDD6A",
    "Yscr": "\uD835\uDCB4",
    "yscr": "\uD835\uDCCE",
    "YUcy": "\u042E",
    "yucy": "\u044E",
    "Yuml": "\u0178",
    "yuml": "\u00FF",
    "Zacute": "\u0179",
    "zacute": "\u017A",
    "Zcaron": "\u017D",
    "zcaron": "\u017E",
    "Zcy": "\u0417",
    "zcy": "\u0437",
    "Zdot": "\u017B",
    "zdot": "\u017C",
    "zeetrf": "\u2128",
    "ZeroWidthSpace": "\u200B",
    "Zeta": "\u0396",
    "zeta": "\u03B6",
    "Zfr": "\u2128",
    "zfr": "\uD835\uDD37",
    "ZHcy": "\u0416",
    "zhcy": "\u0436",
    "zigrarr": "\u21DD",
    "Zopf": "\u2124",
    "zopf": "\uD835\uDD6B",
    "Zscr": "\uD835\uDCB5",
    "zscr": "\uD835\uDCCF",
    "zwj": "\u200D",
    "zwnj": "\u200C"
};

});


parcelRegister("74PTr", function(module, exports) {
'use strict';

var $bQwNq = parcelRequire("bQwNq");

var $57wrL = parcelRequire("57wrL");
/**
 * Expose `Renderer`
 */ module.exports = $5271290c51060972$var$Renderer;
/**
 * Renderer class. Renders HTML and exposes `rules` to allow
 * local modifications.
 */ function $5271290c51060972$var$Renderer() {
    this.rules = $bQwNq.assign({}, $57wrL);
    // exported helper, for custom rules only
    this.getBreak = $57wrL.getBreak;
}
/**
 * Render a string of inline HTML with the given `tokens` and
 * `options`.
 *
 * @param  {Array} `tokens`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @return {String}
 * @api public
 */ $5271290c51060972$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var _rules = this.rules;
    var len = tokens.length, i = 0;
    var result = '';
    while(len--)result += _rules[tokens[i].type](tokens, i++, options, env, this);
    return result;
};
/**
 * Render a string of HTML with the given `tokens` and
 * `options`.
 *
 * @param  {Array} `tokens`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @return {String}
 * @api public
 */ $5271290c51060972$var$Renderer.prototype.render = function(tokens, options, env) {
    var _rules = this.rules;
    var len = tokens.length, i = -1;
    var result = '';
    while(++i < len)if (tokens[i].type === 'inline') result += this.renderInline(tokens[i].children, options, env);
    else result += _rules[tokens[i].type](tokens, i, options, env, this);
    return result;
};

});
parcelRegister("57wrL", function(module, exports) {
'use strict';

var $bQwNq = parcelRequire("bQwNq");
var $3ba6c67676bf137e$require$has = $bQwNq.has;

var $bQwNq = parcelRequire("bQwNq");
var $3ba6c67676bf137e$require$unescapeMd = $bQwNq.unescapeMd;

var $bQwNq = parcelRequire("bQwNq");
var $3ba6c67676bf137e$require$replaceEntities = $bQwNq.replaceEntities;

var $bQwNq = parcelRequire("bQwNq");
var $3ba6c67676bf137e$require$escapeHtml = $bQwNq.escapeHtml;
/**
 * Renderer rules cache
 */ var $3ba6c67676bf137e$var$rules = {};
/**
 * Blockquotes
 */ $3ba6c67676bf137e$var$rules.blockquote_open = function() {
    return '<blockquote>\n';
};
$3ba6c67676bf137e$var$rules.blockquote_close = function(tokens, idx /*, options, env */ ) {
    return '</blockquote>' + $3ba6c67676bf137e$var$getBreak(tokens, idx);
};
/**
 * Code
 */ $3ba6c67676bf137e$var$rules.code = function(tokens, idx /*, options, env */ ) {
    if (tokens[idx].block) return '<pre><code>' + $3ba6c67676bf137e$require$escapeHtml(tokens[idx].content) + '</code></pre>' + $3ba6c67676bf137e$var$getBreak(tokens, idx);
    return '<code>' + $3ba6c67676bf137e$require$escapeHtml(tokens[idx].content) + '</code>';
};
/**
 * Fenced code blocks
 */ $3ba6c67676bf137e$var$rules.fence = function(tokens, idx, options, env, instance) {
    var token = tokens[idx];
    var langClass = '';
    var langPrefix = options.langPrefix;
    var langName = '', fences, fenceName;
    var highlighted;
    if (token.params) {
        //
        // ```foo bar
        //
        // Try custom renderer "foo" first. That will simplify overwrite
        // for diagrams, latex, and any other fenced block with custom look
        //
        fences = token.params.split(/\s+/g);
        fenceName = fences.join(' ');
        if ($3ba6c67676bf137e$require$has(instance.rules.fence_custom, fences[0])) return instance.rules.fence_custom[fences[0]](tokens, idx, options, env, instance);
        langName = $3ba6c67676bf137e$require$escapeHtml($3ba6c67676bf137e$require$replaceEntities($3ba6c67676bf137e$require$unescapeMd(fenceName)));
        langClass = ' class="' + langPrefix + langName + '"';
    }
    if (options.highlight) highlighted = options.highlight.apply(options.highlight, [
        token.content
    ].concat(fences)) || $3ba6c67676bf137e$require$escapeHtml(token.content);
    else highlighted = $3ba6c67676bf137e$require$escapeHtml(token.content);
    return '<pre><code' + langClass + '>' + highlighted + '</code></pre>' + $3ba6c67676bf137e$var$getBreak(tokens, idx);
};
$3ba6c67676bf137e$var$rules.fence_custom = {};
/**
 * Headings
 */ $3ba6c67676bf137e$var$rules.heading_open = function(tokens, idx /*, options, env */ ) {
    return '<h' + tokens[idx].hLevel + '>';
};
$3ba6c67676bf137e$var$rules.heading_close = function(tokens, idx /*, options, env */ ) {
    return '</h' + tokens[idx].hLevel + '>\n';
};
/**
 * Horizontal rules
 */ $3ba6c67676bf137e$var$rules.hr = function(tokens, idx, options /*, env */ ) {
    return (options.xhtmlOut ? '<hr />' : '<hr>') + $3ba6c67676bf137e$var$getBreak(tokens, idx);
};
/**
 * Bullets
 */ $3ba6c67676bf137e$var$rules.bullet_list_open = function() {
    return '<ul>\n';
};
$3ba6c67676bf137e$var$rules.bullet_list_close = function(tokens, idx /*, options, env */ ) {
    return '</ul>' + $3ba6c67676bf137e$var$getBreak(tokens, idx);
};
/**
 * List items
 */ $3ba6c67676bf137e$var$rules.list_item_open = function() {
    return '<li>';
};
$3ba6c67676bf137e$var$rules.list_item_close = function() {
    return '</li>\n';
};
/**
 * Ordered list items
 */ $3ba6c67676bf137e$var$rules.ordered_list_open = function(tokens, idx /*, options, env */ ) {
    var token = tokens[idx];
    var order = token.order > 1 ? ' start="' + token.order + '"' : '';
    return '<ol' + order + '>\n';
};
$3ba6c67676bf137e$var$rules.ordered_list_close = function(tokens, idx /*, options, env */ ) {
    return '</ol>' + $3ba6c67676bf137e$var$getBreak(tokens, idx);
};
/**
 * Paragraphs
 */ $3ba6c67676bf137e$var$rules.paragraph_open = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].tight ? '' : '<p>';
};
$3ba6c67676bf137e$var$rules.paragraph_close = function(tokens, idx /*, options, env */ ) {
    var addBreak = !(tokens[idx].tight && idx && tokens[idx - 1].type === 'inline' && !tokens[idx - 1].content);
    return (tokens[idx].tight ? '' : '</p>') + (addBreak ? $3ba6c67676bf137e$var$getBreak(tokens, idx) : '');
};
/**
 * Links
 */ $3ba6c67676bf137e$var$rules.link_open = function(tokens, idx, options /* env */ ) {
    var title = tokens[idx].title ? ' title="' + $3ba6c67676bf137e$require$escapeHtml($3ba6c67676bf137e$require$replaceEntities(tokens[idx].title)) + '"' : '';
    var target = options.linkTarget ? ' target="' + options.linkTarget + '"' : '';
    return '<a href="' + $3ba6c67676bf137e$require$escapeHtml(tokens[idx].href) + '"' + title + target + '>';
};
$3ba6c67676bf137e$var$rules.link_close = function() {
    return '</a>';
};
/**
 * Images
 */ $3ba6c67676bf137e$var$rules.image = function(tokens, idx, options /*, env */ ) {
    var src = ' src="' + $3ba6c67676bf137e$require$escapeHtml(tokens[idx].src) + '"';
    var title = tokens[idx].title ? ' title="' + $3ba6c67676bf137e$require$escapeHtml($3ba6c67676bf137e$require$replaceEntities(tokens[idx].title)) + '"' : '';
    var alt = ' alt="' + (tokens[idx].alt ? $3ba6c67676bf137e$require$escapeHtml($3ba6c67676bf137e$require$replaceEntities($3ba6c67676bf137e$require$unescapeMd(tokens[idx].alt))) : '') + '"';
    var suffix = options.xhtmlOut ? ' /' : '';
    return '<img' + src + alt + title + suffix + '>';
};
/**
 * Tables
 */ $3ba6c67676bf137e$var$rules.table_open = function() {
    return '<table>\n';
};
$3ba6c67676bf137e$var$rules.table_close = function() {
    return '</table>\n';
};
$3ba6c67676bf137e$var$rules.thead_open = function() {
    return '<thead>\n';
};
$3ba6c67676bf137e$var$rules.thead_close = function() {
    return '</thead>\n';
};
$3ba6c67676bf137e$var$rules.tbody_open = function() {
    return '<tbody>\n';
};
$3ba6c67676bf137e$var$rules.tbody_close = function() {
    return '</tbody>\n';
};
$3ba6c67676bf137e$var$rules.tr_open = function() {
    return '<tr>';
};
$3ba6c67676bf137e$var$rules.tr_close = function() {
    return '</tr>\n';
};
$3ba6c67676bf137e$var$rules.th_open = function(tokens, idx /*, options, env */ ) {
    var token = tokens[idx];
    return '<th' + (token.align ? ' style="text-align:' + token.align + '"' : '') + '>';
};
$3ba6c67676bf137e$var$rules.th_close = function() {
    return '</th>';
};
$3ba6c67676bf137e$var$rules.td_open = function(tokens, idx /*, options, env */ ) {
    var token = tokens[idx];
    return '<td' + (token.align ? ' style="text-align:' + token.align + '"' : '') + '>';
};
$3ba6c67676bf137e$var$rules.td_close = function() {
    return '</td>';
};
/**
 * Bold
 */ $3ba6c67676bf137e$var$rules.strong_open = function() {
    return '<strong>';
};
$3ba6c67676bf137e$var$rules.strong_close = function() {
    return '</strong>';
};
/**
 * Italicize
 */ $3ba6c67676bf137e$var$rules.em_open = function() {
    return '<em>';
};
$3ba6c67676bf137e$var$rules.em_close = function() {
    return '</em>';
};
/**
 * Strikethrough
 */ $3ba6c67676bf137e$var$rules.del_open = function() {
    return '<del>';
};
$3ba6c67676bf137e$var$rules.del_close = function() {
    return '</del>';
};
/**
 * Insert
 */ $3ba6c67676bf137e$var$rules.ins_open = function() {
    return '<ins>';
};
$3ba6c67676bf137e$var$rules.ins_close = function() {
    return '</ins>';
};
/**
 * Highlight
 */ $3ba6c67676bf137e$var$rules.mark_open = function() {
    return '<mark>';
};
$3ba6c67676bf137e$var$rules.mark_close = function() {
    return '</mark>';
};
/**
 * Super- and sub-script
 */ $3ba6c67676bf137e$var$rules.sub = function(tokens, idx /*, options, env */ ) {
    return '<sub>' + $3ba6c67676bf137e$require$escapeHtml(tokens[idx].content) + '</sub>';
};
$3ba6c67676bf137e$var$rules.sup = function(tokens, idx /*, options, env */ ) {
    return '<sup>' + $3ba6c67676bf137e$require$escapeHtml(tokens[idx].content) + '</sup>';
};
/**
 * Breaks
 */ $3ba6c67676bf137e$var$rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$3ba6c67676bf137e$var$rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
/**
 * Text
 */ $3ba6c67676bf137e$var$rules.text = function(tokens, idx /*, options, env */ ) {
    return $3ba6c67676bf137e$require$escapeHtml(tokens[idx].content);
};
/**
 * Content
 */ $3ba6c67676bf137e$var$rules.htmlblock = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$3ba6c67676bf137e$var$rules.htmltag = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * Abbreviations, initialism
 */ $3ba6c67676bf137e$var$rules.abbr_open = function(tokens, idx /*, options, env */ ) {
    return '<abbr title="' + $3ba6c67676bf137e$require$escapeHtml($3ba6c67676bf137e$require$replaceEntities(tokens[idx].title)) + '">';
};
$3ba6c67676bf137e$var$rules.abbr_close = function() {
    return '</abbr>';
};
/**
 * Footnotes
 */ $3ba6c67676bf137e$var$rules.footnote_ref = function(tokens, idx) {
    var n = Number(tokens[idx].id + 1).toString();
    var id = 'fnref' + n;
    if (tokens[idx].subId > 0) id += ':' + tokens[idx].subId;
    return '<sup class="footnote-ref"><a href="#fn' + n + '" id="' + id + '">[' + n + ']</a></sup>';
};
$3ba6c67676bf137e$var$rules.footnote_block_open = function(tokens, idx, options) {
    var hr = options.xhtmlOut ? '<hr class="footnotes-sep" />\n' : '<hr class="footnotes-sep">\n';
    return hr + '<section class="footnotes">\n<ol class="footnotes-list">\n';
};
$3ba6c67676bf137e$var$rules.footnote_block_close = function() {
    return '</ol>\n</section>\n';
};
$3ba6c67676bf137e$var$rules.footnote_open = function(tokens, idx) {
    var id = Number(tokens[idx].id + 1).toString();
    return '<li id="fn' + id + '"  class="footnote-item">';
};
$3ba6c67676bf137e$var$rules.footnote_close = function() {
    return '</li>\n';
};
$3ba6c67676bf137e$var$rules.footnote_anchor = function(tokens, idx) {
    var n = Number(tokens[idx].id + 1).toString();
    var id = 'fnref' + n;
    if (tokens[idx].subId > 0) id += ':' + tokens[idx].subId;
    return ' <a href="#' + id + '" class="footnote-backref">\u21A9</a>';
};
/**
 * Definition lists
 */ $3ba6c67676bf137e$var$rules.dl_open = function() {
    return '<dl>\n';
};
$3ba6c67676bf137e$var$rules.dt_open = function() {
    return '<dt>';
};
$3ba6c67676bf137e$var$rules.dd_open = function() {
    return '<dd>';
};
$3ba6c67676bf137e$var$rules.dl_close = function() {
    return '</dl>\n';
};
$3ba6c67676bf137e$var$rules.dt_close = function() {
    return '</dt>\n';
};
$3ba6c67676bf137e$var$rules.dd_close = function() {
    return '</dd>\n';
};
/**
 * Helper functions
 */ function $3ba6c67676bf137e$var$nextToken(tokens, idx) {
    if (++idx >= tokens.length - 2) return idx;
    if (tokens[idx].type === 'paragraph_open' && tokens[idx].tight && tokens[idx + 1].type === 'inline' && tokens[idx + 1].content.length === 0 && tokens[idx + 2].type === 'paragraph_close' && tokens[idx + 2].tight) return $3ba6c67676bf137e$var$nextToken(tokens, idx + 2);
    return idx;
}
/**
 * Check to see if `\n` is needed before the next token.
 *
 * @param  {Array} `tokens`
 * @param  {Number} `idx`
 * @return {String} Empty string or newline
 * @api private
 */ var $3ba6c67676bf137e$var$getBreak = $3ba6c67676bf137e$var$rules.getBreak = function getBreak(tokens, idx) {
    idx = $3ba6c67676bf137e$var$nextToken(tokens, idx);
    if (idx < tokens.length && tokens[idx].type === 'list_item_close') return '';
    return '\n';
};
/**
 * Expose `rules`
 */ module.exports = $3ba6c67676bf137e$var$rules;

});


parcelRegister("h2xiW", function(module, exports) {
'use strict';

var $iJCC3 = parcelRequire("iJCC3");









/**
 * Core parser `rules`
 */ var $c67c752554a2f63d$var$_rules = [
    [
        'block',
        (parcelRequire("iJ85o"))
    ],
    [
        'abbr',
        (parcelRequire("cb51a"))
    ],
    [
        'references',
        (parcelRequire("k6h0b"))
    ],
    [
        'inline',
        (parcelRequire("dPAh0"))
    ],
    [
        'footnote_tail',
        (parcelRequire("b0kfp"))
    ],
    [
        'abbr2',
        (parcelRequire("biu4A"))
    ],
    [
        'replacements',
        (parcelRequire("f7Goi"))
    ],
    [
        'smartquotes',
        (parcelRequire("h3LhU"))
    ],
    [
        'linkify',
        (parcelRequire("fSq8e"))
    ]
];
/**
 * Class for top level (`core`) parser rules
 *
 * @api private
 */ function $c67c752554a2f63d$var$Core() {
    this.options = {};
    this.ruler = new $iJCC3();
    for(var i = 0; i < $c67c752554a2f63d$var$_rules.length; i++)this.ruler.push($c67c752554a2f63d$var$_rules[i][0], $c67c752554a2f63d$var$_rules[i][1]);
}
/**
 * Process rules with the given `state`
 *
 * @param  {Object} `state`
 * @api private
 */ $c67c752554a2f63d$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};
/**
 * Expose `Core`
 */ module.exports = $c67c752554a2f63d$var$Core;

});
parcelRegister("iJCC3", function(module, exports) {
'use strict';
/**
 * Ruler is a helper class for building responsibility chains from
 * parse rules. It allows:
 *
 *   - easy stack rules chains
 *   - getting main chain and named chains content (as arrays of functions)
 *
 * Helper methods, should not be used directly.
 * @api private
 */ function $da3a61a411c391b5$var$Ruler() {
    // List of added rules. Each element is:
    //
    // { name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ] }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - digital anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
/**
 * Find the index of a rule by `name`.
 *
 * @param  {String} `name`
 * @return {Number} Index of the given `name`
 * @api private
 */ $da3a61a411c391b5$var$Ruler.prototype.__find__ = function(name) {
    var len = this.__rules__.length;
    var i = -1;
    while(len--){
        if (this.__rules__[++i].name === name) return i;
    }
    return -1;
};
/**
 * Build the rules lookup cache
 *
 * @api private
 */ $da3a61a411c391b5$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler public methods
 * ------------------------------------------------
 */ /**
 * Replace rule function
 *
 * @param  {String} `name` Rule name
 * @param  {Function `fn`
 * @param  {Object} `options`
 * @api private
 */ $da3a61a411c391b5$var$Ruler.prototype.at = function(name, fn, options) {
    var idx = this.__find__(name);
    var opt = options || {};
    if (idx === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[idx].fn = fn;
    this.__rules__[idx].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Add a rule to the chain before given the `ruleName`.
 *
 * @param  {String}   `beforeName`
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @api private
 */ $da3a61a411c391b5$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var idx = this.__find__(beforeName);
    var opt = options || {};
    if (idx === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(idx, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Add a rule to the chain after the given `ruleName`.
 *
 * @param  {String}   `afterName`
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @api private
 */ $da3a61a411c391b5$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var idx = this.__find__(afterName);
    var opt = options || {};
    if (idx === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(idx + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Add a rule to the end of chain.
 *
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @return {String}
 */ $da3a61a411c391b5$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Enable a rule or list of rules.
 *
 * @param  {String|Array} `list` Name or array of rule names to enable
 * @param  {Boolean} `strict` If `true`, all non listed rules will be disabled.
 * @api private
 */ $da3a61a411c391b5$var$Ruler.prototype.enable = function(list, strict) {
    list = !Array.isArray(list) ? [
        list
    ] : list;
    // In strict mode disable all existing rules first
    if (strict) this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) throw new Error('Rules manager: invalid rule name ' + name);
        this.__rules__[idx].enabled = true;
    }, this);
    this.__cache__ = null;
};
/**
 * Disable a rule or list of rules.
 *
 * @param  {String|Array} `list` Name or array of rule names to disable
 * @api private
 */ $da3a61a411c391b5$var$Ruler.prototype.disable = function(list) {
    list = !Array.isArray(list) ? [
        list
    ] : list;
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) throw new Error('Rules manager: invalid rule name ' + name);
        this.__rules__[idx].enabled = false;
    }, this);
    this.__cache__ = null;
};
/**
 * Get a rules list as an array of functions.
 *
 * @param  {String} `chainName`
 * @return {Object}
 * @api private
 */ $da3a61a411c391b5$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    return this.__cache__[chainName] || [];
};
/**
 * Expose `Ruler`
 */ module.exports = $da3a61a411c391b5$var$Ruler;

});

parcelRegister("iJ85o", function(module, exports) {
'use strict';
module.exports = function block(state) {
    if (state.inlineMode) state.tokens.push({
        type: 'inline',
        content: state.src.replace(/\n/g, ' ').trim(),
        level: 0,
        lines: [
            0,
            1
        ],
        children: []
    });
    else state.block.parse(state.src, state.options, state.env, state.tokens);
};

});

parcelRegister("cb51a", function(module, exports) {
// Parse abbreviation definitions, i.e. `*[abbr]: description`
//
'use strict';

var $6oHIf = parcelRequire("6oHIf");

var $dQ9Wb = parcelRequire("dQ9Wb");
function $8dda6786db54b8d9$var$parseAbbr(str, parserInline, options, env) {
    var state, labelEnd, pos, max, label, title;
    if (str.charCodeAt(0) !== 0x2A /* * */ ) return -1;
    if (str.charCodeAt(1) !== 0x5B /* [ */ ) return -1;
    if (str.indexOf(']:') === -1) return -1;
    state = new $6oHIf(str, parserInline, options, env, []);
    labelEnd = $dQ9Wb(state, 1);
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return -1;
    max = state.posMax;
    // abbr title is always one line, so looking for ending "\n" here
    for(pos = labelEnd + 2; pos < max; pos++){
        if (state.src.charCodeAt(pos) === 0x0A) break;
    }
    label = str.slice(2, labelEnd);
    title = str.slice(labelEnd + 2, pos).trim();
    if (title.length === 0) return -1;
    if (!env.abbreviations) env.abbreviations = {};
    // prepend ':' to avoid conflict with Object.prototype members
    if (typeof env.abbreviations[':' + label] === 'undefined') env.abbreviations[':' + label] = title;
    return pos;
}
module.exports = function abbr(state) {
    var tokens = state.tokens, i, l, content, pos;
    if (state.inlineMode) return;
    // Parse inlines
    for(i = 1, l = tokens.length - 1; i < l; i++)if (tokens[i - 1].type === 'paragraph_open' && tokens[i].type === 'inline' && tokens[i + 1].type === 'paragraph_close') {
        content = tokens[i].content;
        while(content.length){
            pos = $8dda6786db54b8d9$var$parseAbbr(content, state.inline, state.options, state.env);
            if (pos < 0) break;
            content = content.slice(pos).trim();
        }
        tokens[i].content = content;
        if (!content.length) {
            tokens[i - 1].tight = true;
            tokens[i + 1].tight = true;
        }
    }
};

});
parcelRegister("6oHIf", function(module, exports) {
// Inline parser state
'use strict';
function $4a86e461cdd3cbce$var$StateInline(src, parserInline, options, env, outTokens) {
    this.src = src;
    this.env = env;
    this.options = options;
    this.parser = parserInline;
    this.tokens = outTokens;
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    this.cache = []; // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    // Link parser state vars
    this.isInLabel = false; // Set true when seek link label - we should disable
    // "paired" rules (emphasis, strikes) to not skip
    // tailing `]`
    this.linkLevel = 0; // Increment for each nesting link. Used to prevent
    // nesting in definitions
    this.linkContent = ''; // Temporary storage for link url
    this.labelUnmatchedScopes = 0; // Track unpaired `[` for link labels
// (backtrack optimization)
}
// Flush pending text
//
$4a86e461cdd3cbce$var$StateInline.prototype.pushPending = function() {
    this.tokens.push({
        type: 'text',
        content: this.pending,
        level: this.pendingLevel
    });
    this.pending = '';
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$4a86e461cdd3cbce$var$StateInline.prototype.push = function(token) {
    if (this.pending) this.pushPending();
    this.tokens.push(token);
    this.pendingLevel = this.level;
};
// Store value to cache.
// !!! Implementation has parser-specific optimizations
// !!! keys MUST be integer, >= 0; values MUST be integer, > 0
//
$4a86e461cdd3cbce$var$StateInline.prototype.cacheSet = function(key, val) {
    for(var i = this.cache.length; i <= key; i++)this.cache.push(0);
    this.cache[key] = val;
};
// Get cache value
//
$4a86e461cdd3cbce$var$StateInline.prototype.cacheGet = function(key) {
    return key < this.cache.length ? this.cache[key] : 0;
};
module.exports = $4a86e461cdd3cbce$var$StateInline;

});

parcelRegister("dQ9Wb", function(module, exports) {
'use strict';
/**
 * Parse link labels
 *
 * This function assumes that first character (`[`) already matches;
 * returns the end of the label.
 *
 * @param  {Object} state
 * @param  {Number} start
 * @api private
 */ module.exports = function parseLinkLabel(state, start) {
    var level, found, marker, labelEnd = -1, max = state.posMax, oldPos = state.pos, oldFlag = state.isInLabel;
    if (state.isInLabel) return -1;
    if (state.labelUnmatchedScopes) {
        state.labelUnmatchedScopes--;
        return -1;
    }
    state.pos = start + 1;
    state.isInLabel = true;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5B /* [ */ ) level++;
        else if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        state.parser.skipToken(state);
    }
    if (found) {
        labelEnd = state.pos;
        state.labelUnmatchedScopes = 0;
    } else state.labelUnmatchedScopes = level - 1;
    // restore old state
    state.pos = oldPos;
    state.isInLabel = oldFlag;
    return labelEnd;
};

});


parcelRegister("k6h0b", function(module, exports) {
'use strict';

var $6oHIf = parcelRequire("6oHIf");

var $dQ9Wb = parcelRequire("dQ9Wb");

var $010td = parcelRequire("010td");

var $2F3aO = parcelRequire("2F3aO");

var $fPktW = parcelRequire("fPktW");
function $ea218e683f400ad7$var$parseReference(str, parser, options, env) {
    var state, labelEnd, pos, max, code, start, href, title, label;
    if (str.charCodeAt(0) !== 0x5B /* [ */ ) return -1;
    if (str.indexOf(']:') === -1) return -1;
    state = new $6oHIf(str, parser, options, env, []);
    labelEnd = $dQ9Wb(state, 0);
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return -1;
    max = state.posMax;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        code = state.src.charCodeAt(pos);
        if (code !== 0x20 && code !== 0x0A) break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    if (!$010td(state, pos)) return -1;
    href = state.linkContent;
    pos = state.pos;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(pos = pos + 1; pos < max; pos++){
        code = state.src.charCodeAt(pos);
        if (code !== 0x20 && code !== 0x0A) break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    if (pos < max && start !== pos && $2F3aO(state, pos)) {
        title = state.linkContent;
        pos = state.pos;
    } else {
        title = '';
        pos = start;
    }
    // ensure that the end of the line is empty
    while(pos < max && state.src.charCodeAt(pos) === 0x20 /* space */ )pos++;
    if (pos < max && state.src.charCodeAt(pos) !== 0x0A) return -1;
    label = $fPktW(str.slice(1, labelEnd));
    if (typeof env.references[label] === 'undefined') env.references[label] = {
        title: title,
        href: href
    };
    return pos;
}
module.exports = function references(state) {
    var tokens = state.tokens, i, l, content, pos;
    state.env.references = state.env.references || {};
    if (state.inlineMode) return;
    // Scan definitions in paragraph inlines
    for(i = 1, l = tokens.length - 1; i < l; i++)if (tokens[i].type === 'inline' && tokens[i - 1].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') {
        content = tokens[i].content;
        while(content.length){
            pos = $ea218e683f400ad7$var$parseReference(content, state.inline, state.options, state.env);
            if (pos < 0) break;
            content = content.slice(pos).trim();
        }
        tokens[i].content = content;
        if (!content.length) {
            tokens[i - 1].tight = true;
            tokens[i + 1].tight = true;
        }
    }
};

});
parcelRegister("010td", function(module, exports) {
'use strict';

var $FCAyg = parcelRequire("FCAyg");

var $bQwNq = parcelRequire("bQwNq");
var $00307583c2107d74$require$unescapeMd = $bQwNq.unescapeMd;
/**
 * Parse link destination
 *
 *   - on success it returns a string and updates state.pos;
 *   - on failure it returns null
 *
 * @param  {Object} state
 * @param  {Number} pos
 * @api private
 */ module.exports = function parseLinkDestination(state, pos) {
    var code, level, link, start = pos, max = state.posMax;
    if (state.src.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = state.src.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return false;
            if (code === 0x3E /* > */ ) {
                link = $FCAyg($00307583c2107d74$require$unescapeMd(state.src.slice(start + 1, pos)));
                if (!state.parser.validateLink(link)) return false;
                state.pos = pos + 1;
                state.linkContent = link;
                return true;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return false;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = state.src.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control chars
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 1) break;
        }
        if (code === 0x29 /* ) */ ) {
            level--;
            if (level < 0) break;
        }
        pos++;
    }
    if (start === pos) return false;
    link = $00307583c2107d74$require$unescapeMd(state.src.slice(start, pos));
    if (!state.parser.validateLink(link)) return false;
    state.linkContent = link;
    state.pos = pos;
    return true;
};

});
parcelRegister("FCAyg", function(module, exports) {
'use strict';

var $bQwNq = parcelRequire("bQwNq");
var $07d1c354c2761752$require$replaceEntities = $bQwNq.replaceEntities;
module.exports = function normalizeLink(url) {
    var normalized = $07d1c354c2761752$require$replaceEntities(url);
    // We shouldn't care about the result of malformed URIs,
    // and should not throw an exception.
    try {
        normalized = decodeURI(normalized);
    } catch (err) {}
    return encodeURI(normalized);
};

});


parcelRegister("2F3aO", function(module, exports) {
'use strict';

var $bQwNq = parcelRequire("bQwNq");
var $1f01df4409c16fd1$require$unescapeMd = $bQwNq.unescapeMd;
/**
 * Parse link title
 *
 *   - on success it returns a string and updates state.pos;
 *   - on failure it returns null
 *
 * @param  {Object} state
 * @param  {Number} pos
 * @api private
 */ module.exports = function parseLinkTitle(state, pos) {
    var code, start = pos, max = state.posMax, marker = state.src.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return false;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = state.src.charCodeAt(pos);
        if (code === marker) {
            state.pos = pos + 1;
            state.linkContent = $1f01df4409c16fd1$require$unescapeMd(state.src.slice(start + 1, pos));
            return true;
        }
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos += 2;
            continue;
        }
        pos++;
    }
    return false;
};

});

parcelRegister("fPktW", function(module, exports) {
'use strict';
module.exports = function normalizeReference(str) {
    // use .toUpperCase() instead of .toLowerCase()
    // here to avoid a conflict with Object.prototype
    // members (most notably, `__proto__`)
    return str.trim().replace(/\s+/g, ' ').toUpperCase();
};

});


parcelRegister("dPAh0", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.inline.parse(tok.content, state.options, state.env, tok.children);
    }
};

});

parcelRegister("b0kfp", function(module, exports) {
'use strict';
module.exports = function footnote_block(state) {
    var i, l, j, t, lastParagraph, list, tokens, current, currentLabel, level = 0, insideRef = false, refTokens = {};
    if (!state.env.footnotes) return;
    state.tokens = state.tokens.filter(function(tok) {
        if (tok.type === 'footnote_reference_open') {
            insideRef = true;
            current = [];
            currentLabel = tok.label;
            return false;
        }
        if (tok.type === 'footnote_reference_close') {
            insideRef = false;
            // prepend ':' to avoid conflict with Object.prototype members
            refTokens[':' + currentLabel] = current;
            return false;
        }
        if (insideRef) current.push(tok);
        return !insideRef;
    });
    if (!state.env.footnotes.list) return;
    list = state.env.footnotes.list;
    state.tokens.push({
        type: 'footnote_block_open',
        level: level++
    });
    for(i = 0, l = list.length; i < l; i++){
        state.tokens.push({
            type: 'footnote_open',
            id: i,
            level: level++
        });
        if (list[i].tokens) {
            tokens = [];
            tokens.push({
                type: 'paragraph_open',
                tight: false,
                level: level++
            });
            tokens.push({
                type: 'inline',
                content: '',
                level: level,
                children: list[i].tokens
            });
            tokens.push({
                type: 'paragraph_close',
                tight: false,
                level: --level
            });
        } else if (list[i].label) tokens = refTokens[':' + list[i].label];
        state.tokens = state.tokens.concat(tokens);
        if (state.tokens[state.tokens.length - 1].type === 'paragraph_close') lastParagraph = state.tokens.pop();
        else lastParagraph = null;
        t = list[i].count > 0 ? list[i].count : 1;
        for(j = 0; j < t; j++)state.tokens.push({
            type: 'footnote_anchor',
            id: i,
            subId: j,
            level: level
        });
        if (lastParagraph) state.tokens.push(lastParagraph);
        state.tokens.push({
            type: 'footnote_close',
            level: --level
        });
    }
    state.tokens.push({
        type: 'footnote_block_close',
        level: --level
    });
};

});

parcelRegister("biu4A", function(module, exports) {
// Enclose abbreviations in <abbr> tags
//
'use strict';
var $8398b40831f1c683$var$PUNCT_CHARS = ' \n()[]\'".,!?-';
// from Google closure library
// http://closure-library.googlecode.com/git-history/docs/local_closure_goog_string_string.js.source.html#line1021
function $8398b40831f1c683$var$regEscape(s) {
    return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1');
}
module.exports = function abbr2(state) {
    var i, j, l, tokens, token, text, nodes, pos, level, reg, m, regText, blockTokens = state.tokens;
    if (!state.env.abbreviations) return;
    if (!state.env.abbrRegExp) {
        regText = '(^|[' + $8398b40831f1c683$var$PUNCT_CHARS.split('').map($8398b40831f1c683$var$regEscape).join('') + '])' + '(' + Object.keys(state.env.abbreviations).map(function(x) {
            return x.substr(1);
        }).sort(function(a, b) {
            return b.length - a.length;
        }).map($8398b40831f1c683$var$regEscape).join('|') + ')' + '($|[' + $8398b40831f1c683$var$PUNCT_CHARS.split('').map($8398b40831f1c683$var$regEscape).join('') + '])';
        state.env.abbrRegExp = new RegExp(regText, 'g');
    }
    reg = state.env.abbrRegExp;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        // We scan from the end, to keep position when new tags added.
        for(i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            if (token.type !== 'text') continue;
            pos = 0;
            text = token.content;
            reg.lastIndex = 0;
            level = token.level;
            nodes = [];
            while(m = reg.exec(text)){
                if (reg.lastIndex > pos) nodes.push({
                    type: 'text',
                    content: text.slice(pos, m.index + m[1].length),
                    level: level
                });
                nodes.push({
                    type: 'abbr_open',
                    title: state.env.abbreviations[':' + m[2]],
                    level: level++
                });
                nodes.push({
                    type: 'text',
                    content: m[2],
                    level: level
                });
                nodes.push({
                    type: 'abbr_close',
                    level: --level
                });
                pos = reg.lastIndex - m[3].length;
            }
            if (!nodes.length) continue;
            if (pos < text.length) nodes.push({
                type: 'text',
                content: text.slice(pos),
                level: level
            });
            // replace current node
            blockTokens[j].children = tokens = [].concat(tokens.slice(0, i), nodes, tokens.slice(i + 1));
        }
    }
};

});

parcelRegister("f7Goi", function(module, exports) {
// Simple typographical replacements
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - miltiplication 2 x 4 -> 2 × 4
var $b028646d644ba042$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
var $b028646d644ba042$var$SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
var $b028646d644ba042$var$SCOPED_ABBR = {
    'c': "\xa9",
    'r': "\xae",
    'p': "\xa7",
    'tm': "\u2122"
};
function $b028646d644ba042$var$replaceScopedAbbr(str) {
    if (str.indexOf('(') < 0) return str;
    return str.replace($b028646d644ba042$var$SCOPED_ABBR_RE, function(match, name) {
        return $b028646d644ba042$var$SCOPED_ABBR[name.toLowerCase()];
    });
}
module.exports = function replace(state) {
    var i, token, text, inlineTokens, blkIdx;
    if (!state.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        inlineTokens = state.tokens[blkIdx].children;
        for(i = inlineTokens.length - 1; i >= 0; i--){
            token = inlineTokens[i];
            if (token.type === 'text') {
                text = token.content;
                text = $b028646d644ba042$var$replaceScopedAbbr(text);
                if ($b028646d644ba042$var$RARE_RE.test(text)) text = text.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
                // but ?..... & !..... -> ?.. & !..
                .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
                .replace(/(^|[^-])---([^-]|$)/mg, '$1\u2014$2')// en-dash
                .replace(/(^|\s)--(\s|$)/mg, '$1\u2013$2').replace(/(^|[^-\s])--([^-\s]|$)/mg, '$1\u2013$2');
                token.content = text;
            }
        }
    }
};

});

parcelRegister("h3LhU", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';
var $c6b765d71e5f73b1$var$QUOTE_TEST_RE = /['"]/;
var $c6b765d71e5f73b1$var$QUOTE_RE = /['"]/g;
var $c6b765d71e5f73b1$var$PUNCT_RE = /[-\s()\[\]]/;
var $c6b765d71e5f73b1$var$APOSTROPHE = "\u2019";
// This function returns true if the character at `pos`
// could be inside a word.
function $c6b765d71e5f73b1$var$isLetter(str, pos) {
    if (pos < 0 || pos >= str.length) return false;
    return !$c6b765d71e5f73b1$var$PUNCT_RE.test(str[pos]);
}
function $c6b765d71e5f73b1$var$replaceAt(str, index, ch) {
    return str.substr(0, index) + ch + str.substr(index + 1);
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var i, token, text, t, pos, max, thisLevel, lastSpace, nextSpace, item, canOpen, canClose, j, isSingle, blkIdx, tokens, stack;
    if (!state.options.typographer) return;
    stack = [];
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        tokens = state.tokens[blkIdx].children;
        stack.length = 0;
        for(i = 0; i < tokens.length; i++){
            token = tokens[i];
            if (token.type !== 'text' || $c6b765d71e5f73b1$var$QUOTE_TEST_RE.test(token.text)) continue;
            thisLevel = tokens[i].level;
            for(j = stack.length - 1; j >= 0; j--){
                if (stack[j].level <= thisLevel) break;
            }
            stack.length = j + 1;
            text = token.content;
            pos = 0;
            max = text.length;
            /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
                $c6b765d71e5f73b1$var$QUOTE_RE.lastIndex = pos;
                t = $c6b765d71e5f73b1$var$QUOTE_RE.exec(text);
                if (!t) break;
                lastSpace = !$c6b765d71e5f73b1$var$isLetter(text, t.index - 1);
                pos = t.index + 1;
                isSingle = t[0] === "'";
                nextSpace = !$c6b765d71e5f73b1$var$isLetter(text, pos);
                if (!nextSpace && !lastSpace) {
                    // middle of word
                    if (isSingle) token.content = $c6b765d71e5f73b1$var$replaceAt(token.content, t.index, $c6b765d71e5f73b1$var$APOSTROPHE);
                    continue;
                }
                canOpen = !nextSpace;
                canClose = !lastSpace;
                if (canClose) // this could be a closing quote, rewind the stack to get a match
                for(j = stack.length - 1; j >= 0; j--){
                    item = stack[j];
                    if (stack[j].level < thisLevel) break;
                    if (item.single === isSingle && stack[j].level === thisLevel) {
                        item = stack[j];
                        if (isSingle) {
                            tokens[item.token].content = $c6b765d71e5f73b1$var$replaceAt(tokens[item.token].content, item.pos, state.options.quotes[2]);
                            token.content = $c6b765d71e5f73b1$var$replaceAt(token.content, t.index, state.options.quotes[3]);
                        } else {
                            tokens[item.token].content = $c6b765d71e5f73b1$var$replaceAt(tokens[item.token].content, item.pos, state.options.quotes[0]);
                            token.content = $c6b765d71e5f73b1$var$replaceAt(token.content, t.index, state.options.quotes[1]);
                        }
                        stack.length = j;
                        continue OUTER;
                    }
                }
                if (canOpen) stack.push({
                    token: i,
                    pos: t.index,
                    single: isSingle,
                    level: thisLevel
                });
                else if (canClose && isSingle) token.content = $c6b765d71e5f73b1$var$replaceAt(token.content, t.index, $c6b765d71e5f73b1$var$APOSTROPHE);
            }
        }
    }
};

});

parcelRegister("fSq8e", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `inline.validateLink()` to http/https/ftp
//
'use strict';

var $32KGk = parcelRequire("32KGk");
var $b8f02b62d7119f1d$var$LINK_SCAN_RE = /www|@|\:\/\//;
function $b8f02b62d7119f1d$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $b8f02b62d7119f1d$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
// Stupid fabric to avoid singletons, for thread safety.
// Required for engines like Nashorn.
//
function $b8f02b62d7119f1d$var$createLinkifier() {
    var links = [];
    var autolinker = new $32KGk({
        stripPrefix: false,
        url: true,
        email: true,
        twitter: false,
        replaceFn: function(linker, match) {
            // Only collect matched strings but don't change anything.
            switch(match.getType()){
                /*eslint default-case:0*/ case 'url':
                    links.push({
                        text: match.matchedText,
                        url: match.getUrl()
                    });
                    break;
                case 'email':
                    links.push({
                        text: match.matchedText,
                        // normalize email protocol
                        url: 'mailto:' + match.getEmail().replace(/^mailto:/i, '')
                    });
                    break;
            }
            return false;
        }
    });
    return {
        links: links,
        autolinker: autolinker
    };
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, text, nodes, ln, pos, level, htmlLinkLevel, blockTokens = state.tokens, linkifier = null, links, autolinker;
    if (!state.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            // Skip content of markdown links
            if (token.type === 'link_close') {
                i--;
                while(tokens[i].level !== token.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (token.type === 'htmltag') {
                if ($b8f02b62d7119f1d$var$isLinkOpen(token.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($b8f02b62d7119f1d$var$isLinkClose(token.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (token.type === 'text' && $b8f02b62d7119f1d$var$LINK_SCAN_RE.test(token.content)) {
                // Init linkifier in lazy manner, only if required.
                if (!linkifier) {
                    linkifier = $b8f02b62d7119f1d$var$createLinkifier();
                    links = linkifier.links;
                    autolinker = linkifier.autolinker;
                }
                text = token.content;
                links.length = 0;
                autolinker.link(text);
                if (!links.length) continue;
                // Now split string to nodes
                nodes = [];
                level = token.level;
                for(ln = 0; ln < links.length; ln++){
                    if (!state.inline.validateLink(links[ln].url)) continue;
                    pos = text.indexOf(links[ln].text);
                    if (pos) {
                        level;
                        nodes.push({
                            type: 'text',
                            content: text.slice(0, pos),
                            level: level
                        });
                    }
                    nodes.push({
                        type: 'link_open',
                        href: links[ln].url,
                        title: '',
                        level: level++
                    });
                    nodes.push({
                        type: 'text',
                        content: links[ln].text,
                        level: level
                    });
                    nodes.push({
                        type: 'link_close',
                        level: --level
                    });
                    text = text.slice(pos + links[ln].text.length);
                }
                if (text.length) nodes.push({
                    type: 'text',
                    content: text,
                    level: level
                });
                // replace current node
                blockTokens[j].children = tokens = [].concat(tokens.slice(0, i), nodes, tokens.slice(i + 1));
            }
        }
    }
};

});
parcelRegister("32KGk", function(module, exports) {
/*!
 * Autolinker.js
 * 0.28.1
 *
 * Copyright(c) 2016 Gregory Jacobs <greg@greg-jacobs.com>
 * MIT License
 *
 * https://github.com/gregjacobs/Autolinker.js
 */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define([], factory);
    else module.exports = factory();
})(module.exports, function() {
    /**
 * @class Autolinker
 * @extends Object
 *
 * Utility class used to process a given string of text, and wrap the matches in
 * the appropriate anchor (&lt;a&gt;) tags to turn them into links.
 *
 * Any of the configuration options may be provided in an Object (map) provided
 * to the Autolinker constructor, which will configure how the {@link #link link()}
 * method will process the links.
 *
 * For example:
 *
 *     var autolinker = new Autolinker( {
 *         newWindow : false,
 *         truncate  : 30
 *     } );
 *
 *     var html = autolinker.link( "Joe went to www.yahoo.com" );
 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
 *
 *
 * The {@link #static-link static link()} method may also be used to inline
 * options into a single call, which may be more convenient for one-off uses.
 * For example:
 *
 *     var html = Autolinker.link( "Joe went to www.yahoo.com", {
 *         newWindow : false,
 *         truncate  : 30
 *     } );
 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
 *
 *
 * ## Custom Replacements of Links
 *
 * If the configuration options do not provide enough flexibility, a {@link #replaceFn}
 * may be provided to fully customize the output of Autolinker. This function is
 * called once for each URL/Email/Phone#/Twitter Handle/Hashtag match that is
 * encountered.
 *
 * For example:
 *
 *     var input = "...";  // string with URLs, Email Addresses, Phone #s, Twitter Handles, and Hashtags
 *
 *     var linkedText = Autolinker.link( input, {
 *         replaceFn : function( autolinker, match ) {
 *             console.log( "href = ", match.getAnchorHref() );
 *             console.log( "text = ", match.getAnchorText() );
 *
 *             switch( match.getType() ) {
 *                 case 'url' :
 *                     console.log( "url: ", match.getUrl() );
 *
 *                     if( match.getUrl().indexOf( 'mysite.com' ) === -1 ) {
 *                         var tag = autolinker.getTagBuilder().build( match );  // returns an `Autolinker.HtmlTag` instance, which provides mutator methods for easy changes
 *                         tag.setAttr( 'rel', 'nofollow' );
 *                         tag.addClass( 'external-link' );
 *
 *                         return tag;
 *
 *                     } else {
 *                         return true;  // let Autolinker perform its normal anchor tag replacement
 *                     }
 *
 *                 case 'email' :
 *                     var email = match.getEmail();
 *                     console.log( "email: ", email );
 *
 *                     if( email === "my@own.address" ) {
 *                         return false;  // don't auto-link this particular email address; leave as-is
 *                     } else {
 *                         return;  // no return value will have Autolinker perform its normal anchor tag replacement (same as returning `true`)
 *                     }
 *
 *                 case 'phone' :
 *                     var phoneNumber = match.getPhoneNumber();
 *                     console.log( phoneNumber );
 *
 *                     return '<a href="http://newplace.to.link.phone.numbers.to/">' + phoneNumber + '</a>';
 *
 *                 case 'twitter' :
 *                     var twitterHandle = match.getTwitterHandle();
 *                     console.log( twitterHandle );
 *
 *                     return '<a href="http://newplace.to.link.twitter.handles.to/">' + twitterHandle + '</a>';
 *
 *                 case 'hashtag' :
 *                     var hashtag = match.getHashtag();
 *                     console.log( hashtag );
 *
 *                     return '<a href="http://newplace.to.link.hashtag.handles.to/">' + hashtag + '</a>';
 *             }
 *         }
 *     } );
 *
 *
 * The function may return the following values:
 *
 * - `true` (Boolean): Allow Autolinker to replace the match as it normally
 *   would.
 * - `false` (Boolean): Do not replace the current match at all - leave as-is.
 * - Any String: If a string is returned from the function, the string will be
 *   used directly as the replacement HTML for the match.
 * - An {@link Autolinker.HtmlTag} instance, which can be used to build/modify
 *   an HTML tag before writing out its HTML text.
 *
 * @constructor
 * @param {Object} [cfg] The configuration options for the Autolinker instance,
 *   specified in an Object (map).
 */ var Autolinker = function(cfg) {
        cfg = cfg || {};
        this.version = Autolinker.version;
        this.urls = this.normalizeUrlsCfg(cfg.urls);
        this.email = typeof cfg.email === 'boolean' ? cfg.email : true;
        this.twitter = typeof cfg.twitter === 'boolean' ? cfg.twitter : true;
        this.phone = typeof cfg.phone === 'boolean' ? cfg.phone : true;
        this.hashtag = cfg.hashtag || false;
        this.newWindow = typeof cfg.newWindow === 'boolean' ? cfg.newWindow : true;
        this.stripPrefix = typeof cfg.stripPrefix === 'boolean' ? cfg.stripPrefix : true;
        // Validate the value of the `hashtag` cfg.
        var hashtag = this.hashtag;
        if (hashtag !== false && hashtag !== 'twitter' && hashtag !== 'facebook' && hashtag !== 'instagram') throw new Error("invalid `hashtag` cfg - see docs");
        this.truncate = this.normalizeTruncateCfg(cfg.truncate);
        this.className = cfg.className || '';
        this.replaceFn = cfg.replaceFn || null;
        this.htmlParser = null;
        this.matchers = null;
        this.tagBuilder = null;
    };
    /**
 * Automatically links URLs, Email addresses, Phone Numbers, Twitter handles,
 * and Hashtags found in the given chunk of HTML. Does not link URLs found
 * within HTML tags.
 *
 * For instance, if given the text: `You should go to http://www.yahoo.com`,
 * then the result will be `You should go to &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
 *
 * Example:
 *
 *     var linkedText = Autolinker.link( "Go to google.com", { newWindow: false } );
 *     // Produces: "Go to <a href="http://google.com">google.com</a>"
 *
 * @static
 * @param {String} textOrHtml The HTML or text to find matches within (depending
 *   on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #twitter},
 *   and {@link #hashtag} options are enabled).
 * @param {Object} [options] Any of the configuration options for the Autolinker
 *   class, specified in an Object (map). See the class description for an
 *   example call.
 * @return {String} The HTML text, with matches automatically linked.
 */ Autolinker.link = function(textOrHtml, options) {
        var autolinker = new Autolinker(options);
        return autolinker.link(textOrHtml);
    };
    /**
 * @static
 * @property {String} version (readonly)
 *
 * The Autolinker version number in the form major.minor.patch
 *
 * Ex: 0.25.1
 */ Autolinker.version = '0.28.1';
    Autolinker.prototype = {
        constructor: Autolinker,
        /**
	 * @cfg {Boolean/Object} [urls=true]
	 *
	 * `true` if URLs should be automatically linked, `false` if they should not
	 * be.
	 *
	 * This option also accepts an Object form with 3 properties, to allow for
	 * more customization of what exactly gets linked. All default to `true`:
	 *
	 * @param {Boolean} schemeMatches `true` to match URLs found prefixed with a
	 *   scheme, i.e. `http://google.com`, or `other+scheme://google.com`,
	 *   `false` to prevent these types of matches.
	 * @param {Boolean} wwwMatches `true` to match urls found prefixed with
	 *   `'www.'`, i.e. `www.google.com`. `false` to prevent these types of
	 *   matches. Note that if the URL had a prefixed scheme, and
	 *   `schemeMatches` is true, it will still be linked.
	 * @param {Boolean} tldMatches `true` to match URLs with known top level
	 *   domains (.com, .net, etc.) that are not prefixed with a scheme or
	 *   `'www.'`. This option attempts to match anything that looks like a URL
	 *   in the given text. Ex: `google.com`, `asdf.org/?page=1`, etc. `false`
	 *   to prevent these types of matches.
	 */ /**
	 * @cfg {Boolean} [email=true]
	 *
	 * `true` if email addresses should be automatically linked, `false` if they
	 * should not be.
	 */ /**
	 * @cfg {Boolean} [twitter=true]
	 *
	 * `true` if Twitter handles ("@example") should be automatically linked,
	 * `false` if they should not be.
	 */ /**
	 * @cfg {Boolean} [phone=true]
	 *
	 * `true` if Phone numbers ("(555)555-5555") should be automatically linked,
	 * `false` if they should not be.
	 */ /**
	 * @cfg {Boolean/String} [hashtag=false]
	 *
	 * A string for the service name to have hashtags (ex: "#myHashtag")
	 * auto-linked to. The currently-supported values are:
	 *
	 * - 'twitter'
	 * - 'facebook'
	 * - 'instagram'
	 *
	 * Pass `false` to skip auto-linking of hashtags.
	 */ /**
	 * @cfg {Boolean} [newWindow=true]
	 *
	 * `true` if the links should open in a new window, `false` otherwise.
	 */ /**
	 * @cfg {Boolean} [stripPrefix=true]
	 *
	 * `true` if 'http://' or 'https://' and/or the 'www.' should be stripped
	 * from the beginning of URL links' text, `false` otherwise.
	 */ /**
	 * @cfg {Number/Object} [truncate=0]
	 *
	 * ## Number Form
	 *
	 * A number for how many characters matched text should be truncated to
	 * inside the text of a link. If the matched text is over this number of
	 * characters, it will be truncated to this length by adding a two period
	 * ellipsis ('..') to the end of the string.
	 *
	 * For example: A url like 'http://www.yahoo.com/some/long/path/to/a/file'
	 * truncated to 25 characters might look something like this:
	 * 'yahoo.com/some/long/pat..'
	 *
	 * Example Usage:
	 *
	 *     truncate: 25
	 *
	 *
	 *  Defaults to `0` for "no truncation."
	 *
	 *
	 * ## Object Form
	 *
	 * An Object may also be provided with two properties: `length` (Number) and
	 * `location` (String). `location` may be one of the following: 'end'
	 * (default), 'middle', or 'smart'.
	 *
	 * Example Usage:
	 *
	 *     truncate: { length: 25, location: 'middle' }
	 *
	 * @cfg {Number} [truncate.length=0] How many characters to allow before
	 *   truncation will occur. Defaults to `0` for "no truncation."
	 * @cfg {"end"/"middle"/"smart"} [truncate.location="end"]
	 *
	 * - 'end' (default): will truncate up to the number of characters, and then
	 *   add an ellipsis at the end. Ex: 'yahoo.com/some/long/pat..'
	 * - 'middle': will truncate and add the ellipsis in the middle. Ex:
	 *   'yahoo.com/s..th/to/a/file'
	 * - 'smart': for URLs where the algorithm attempts to strip out unnecessary
	 *   parts first (such as the 'www.', then URL scheme, hash, etc.),
	 *   attempting to make the URL human-readable before looking for a good
	 *   point to insert the ellipsis if it is still too long. Ex:
	 *   'yahoo.com/some..to/a/file'. For more details, see
	 *   {@link Autolinker.truncate.TruncateSmart}.
	 */ /**
	 * @cfg {String} className
	 *
	 * A CSS class name to add to the generated links. This class will be added
	 * to all links, as well as this class plus match suffixes for styling
	 * url/email/phone/twitter/hashtag links differently.
	 *
	 * For example, if this config is provided as "myLink", then:
	 *
	 * - URL links will have the CSS classes: "myLink myLink-url"
	 * - Email links will have the CSS classes: "myLink myLink-email", and
	 * - Twitter links will have the CSS classes: "myLink myLink-twitter"
	 * - Phone links will have the CSS classes: "myLink myLink-phone"
	 * - Hashtag links will have the CSS classes: "myLink myLink-hashtag"
	 */ /**
	 * @cfg {Function} replaceFn
	 *
	 * A function to individually process each match found in the input string.
	 *
	 * See the class's description for usage.
	 *
	 * This function is called with the following parameters:
	 *
	 * @cfg {Autolinker} replaceFn.autolinker The Autolinker instance, which may
	 *   be used to retrieve child objects from (such as the instance's
	 *   {@link #getTagBuilder tag builder}).
	 * @cfg {Autolinker.match.Match} replaceFn.match The Match instance which
	 *   can be used to retrieve information about the match that the `replaceFn`
	 *   is currently processing. See {@link Autolinker.match.Match} subclasses
	 *   for details.
	 */ /**
	 * @property {String} version (readonly)
	 *
	 * The Autolinker version number in the form major.minor.patch
	 *
	 * Ex: 0.25.1
	 */ /**
	 * @private
	 * @property {Autolinker.htmlParser.HtmlParser} htmlParser
	 *
	 * The HtmlParser instance used to skip over HTML tags, while finding text
	 * nodes to process. This is lazily instantiated in the {@link #getHtmlParser}
	 * method.
	 */ /**
	 * @private
	 * @property {Autolinker.matcher.Matcher[]} matchers
	 *
	 * The {@link Autolinker.matcher.Matcher} instances for this Autolinker
	 * instance.
	 *
	 * This is lazily created in {@link #getMatchers}.
	 */ /**
	 * @private
	 * @property {Autolinker.AnchorTagBuilder} tagBuilder
	 *
	 * The AnchorTagBuilder instance used to build match replacement anchor tags.
	 * Note: this is lazily instantiated in the {@link #getTagBuilder} method.
	 */ /**
	 * Normalizes the {@link #urls} config into an Object with 3 properties:
	 * `schemeMatches`, `wwwMatches`, and `tldMatches`, all Booleans.
	 *
	 * See {@link #urls} config for details.
	 *
	 * @private
	 * @param {Boolean/Object} urls
	 * @return {Object}
	 */ normalizeUrlsCfg: function(urls) {
            if (urls == null) urls = true; // default to `true`
            if (typeof urls === 'boolean') return {
                schemeMatches: urls,
                wwwMatches: urls,
                tldMatches: urls
            };
            else return {
                schemeMatches: typeof urls.schemeMatches === 'boolean' ? urls.schemeMatches : true,
                wwwMatches: typeof urls.wwwMatches === 'boolean' ? urls.wwwMatches : true,
                tldMatches: typeof urls.tldMatches === 'boolean' ? urls.tldMatches : true
            };
        },
        /**
	 * Normalizes the {@link #truncate} config into an Object with 2 properties:
	 * `length` (Number), and `location` (String).
	 *
	 * See {@link #truncate} config for details.
	 *
	 * @private
	 * @param {Number/Object} truncate
	 * @return {Object}
	 */ normalizeTruncateCfg: function(truncate) {
            if (typeof truncate === 'number') return {
                length: truncate,
                location: 'end'
            };
            else return Autolinker.Util.defaults(truncate || {}, {
                length: Number.POSITIVE_INFINITY,
                location: 'end'
            });
        },
        /**
	 * Parses the input `textOrHtml` looking for URLs, email addresses, phone
	 * numbers, username handles, and hashtags (depending on the configuration
	 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
	 * objects describing those matches.
	 *
	 * This method is used by the {@link #link} method, but can also be used to
	 * simply do parsing of the input in order to discover what kinds of links
	 * there are and how many.
	 *
	 * @param {String} textOrHtml The HTML or text to find matches within
	 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
	 *   {@link #twitter}, and {@link #hashtag} options are enabled).
	 * @return {Autolinker.match.Match[]} The array of Matches found in the
	 *   given input `textOrHtml`.
	 */ parse: function(textOrHtml) {
            var htmlParser = this.getHtmlParser(), htmlNodes = htmlParser.parse(textOrHtml), anchorTagStackCount = 0, matches = [];
            // Find all matches within the `textOrHtml` (but not matches that are
            // already nested within <a> tags)
            for(var i = 0, len = htmlNodes.length; i < len; i++){
                var node = htmlNodes[i], nodeType = node.getType();
                if (nodeType === 'element' && node.getTagName() === 'a') {
                    if (!node.isClosing()) anchorTagStackCount++;
                    else anchorTagStackCount = Math.max(anchorTagStackCount - 1, 0); // attempt to handle extraneous </a> tags by making sure the stack count never goes below 0
                } else if (nodeType === 'text' && anchorTagStackCount === 0) {
                    var textNodeMatches = this.parseText(node.getText(), node.getOffset());
                    matches.push.apply(matches, textNodeMatches);
                }
            }
            // After we have found all matches, remove subsequent matches that
            // overlap with a previous match. This can happen for instance with URLs,
            // where the url 'google.com/#link' would match '#link' as a hashtag.
            matches = this.compactMatches(matches);
            // And finally, remove matches for match types that have been turned
            // off. We needed to have all match types turned on initially so that
            // things like hashtags could be filtered out if they were really just
            // part of a URL match (for instance, as a named anchor).
            matches = this.removeUnwantedMatches(matches);
            return matches;
        },
        /**
	 * After we have found all matches, we need to remove subsequent matches
	 * that overlap with a previous match. This can happen for instance with
	 * URLs, where the url 'google.com/#link' would match '#link' as a hashtag.
	 *
	 * @private
	 * @param {Autolinker.match.Match[]} matches
	 * @return {Autolinker.match.Match[]}
	 */ compactMatches: function(matches) {
            // First, the matches need to be sorted in order of offset
            matches.sort(function(a, b) {
                return a.getOffset() - b.getOffset();
            });
            for(var i = 0; i < matches.length - 1; i++){
                var match = matches[i], endIdx = match.getOffset() + match.getMatchedText().length;
                // Remove subsequent matches that overlap with the current match
                while(i + 1 < matches.length && matches[i + 1].getOffset() <= endIdx)matches.splice(i + 1, 1);
            }
            return matches;
        },
        /**
	 * Removes matches for matchers that were turned off in the options. For
	 * example, if {@link #hashtag hashtags} were not to be matched, we'll
	 * remove them from the `matches` array here.
	 *
	 * @private
	 * @param {Autolinker.match.Match[]} matches The array of matches to remove
	 *   the unwanted matches from. Note: this array is mutated for the
	 *   removals.
	 * @return {Autolinker.match.Match[]} The mutated input `matches` array.
	 */ removeUnwantedMatches: function(matches) {
            var remove = Autolinker.Util.remove;
            if (!this.hashtag) remove(matches, function(match) {
                return match.getType() === 'hashtag';
            });
            if (!this.email) remove(matches, function(match) {
                return match.getType() === 'email';
            });
            if (!this.phone) remove(matches, function(match) {
                return match.getType() === 'phone';
            });
            if (!this.twitter) remove(matches, function(match) {
                return match.getType() === 'twitter';
            });
            if (!this.urls.schemeMatches) remove(matches, function(m) {
                return m.getType() === 'url' && m.getUrlMatchType() === 'scheme';
            });
            if (!this.urls.wwwMatches) remove(matches, function(m) {
                return m.getType() === 'url' && m.getUrlMatchType() === 'www';
            });
            if (!this.urls.tldMatches) remove(matches, function(m) {
                return m.getType() === 'url' && m.getUrlMatchType() === 'tld';
            });
            return matches;
        },
        /**
	 * Parses the input `text` looking for URLs, email addresses, phone
	 * numbers, username handles, and hashtags (depending on the configuration
	 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
	 * objects describing those matches.
	 *
	 * This method processes a **non-HTML string**, and is used to parse and
	 * match within the text nodes of an HTML string. This method is used
	 * internally by {@link #parse}.
	 *
	 * @private
	 * @param {String} text The text to find matches within (depending on if the
	 *   {@link #urls}, {@link #email}, {@link #phone}, {@link #twitter}, and
	 *   {@link #hashtag} options are enabled). This must be a non-HTML string.
	 * @param {Number} [offset=0] The offset of the text node within the
	 *   original string. This is used when parsing with the {@link #parse}
	 *   method to generate correct offsets within the {@link Autolinker.match.Match}
	 *   instances, but may be omitted if calling this method publicly.
	 * @return {Autolinker.match.Match[]} The array of Matches found in the
	 *   given input `text`.
	 */ parseText: function(text, offset) {
            offset = offset || 0;
            var matchers = this.getMatchers(), matches = [];
            for(var i = 0, numMatchers = matchers.length; i < numMatchers; i++){
                var textMatches = matchers[i].parseMatches(text);
                // Correct the offset of each of the matches. They are originally
                // the offset of the match within the provided text node, but we
                // need to correct them to be relative to the original HTML input
                // string (i.e. the one provided to #parse).
                for(var j = 0, numTextMatches = textMatches.length; j < numTextMatches; j++)textMatches[j].setOffset(offset + textMatches[j].getOffset());
                matches.push.apply(matches, textMatches);
            }
            return matches;
        },
        /**
	 * Automatically links URLs, Email addresses, Phone numbers, Twitter
	 * handles, and Hashtags found in the given chunk of HTML. Does not link
	 * URLs found within HTML tags.
	 *
	 * For instance, if given the text: `You should go to http://www.yahoo.com`,
	 * then the result will be `You should go to
	 * &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
	 *
	 * This method finds the text around any HTML elements in the input
	 * `textOrHtml`, which will be the text that is processed. Any original HTML
	 * elements will be left as-is, as well as the text that is already wrapped
	 * in anchor (&lt;a&gt;) tags.
	 *
	 * @param {String} textOrHtml The HTML or text to autolink matches within
	 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
	 *   {@link #twitter}, and {@link #hashtag} options are enabled).
	 * @return {String} The HTML, with matches automatically linked.
	 */ link: function(textOrHtml) {
            if (!textOrHtml) return "";
             // handle `null` and `undefined`
            var matches = this.parse(textOrHtml), newHtml = [], lastIndex = 0;
            for(var i = 0, len = matches.length; i < len; i++){
                var match = matches[i];
                newHtml.push(textOrHtml.substring(lastIndex, match.getOffset()));
                newHtml.push(this.createMatchReturnVal(match));
                lastIndex = match.getOffset() + match.getMatchedText().length;
            }
            newHtml.push(textOrHtml.substring(lastIndex)); // handle the text after the last match
            return newHtml.join('');
        },
        /**
	 * Creates the return string value for a given match in the input string.
	 *
	 * This method handles the {@link #replaceFn}, if one was provided.
	 *
	 * @private
	 * @param {Autolinker.match.Match} match The Match object that represents
	 *   the match.
	 * @return {String} The string that the `match` should be replaced with.
	 *   This is usually the anchor tag string, but may be the `matchStr` itself
	 *   if the match is not to be replaced.
	 */ createMatchReturnVal: function(match) {
            // Handle a custom `replaceFn` being provided
            var replaceFnResult;
            if (this.replaceFn) replaceFnResult = this.replaceFn.call(this, this, match); // Autolinker instance is the context, and the first arg
            if (typeof replaceFnResult === 'string') return replaceFnResult; // `replaceFn` returned a string, use that
            else if (replaceFnResult === false) return match.getMatchedText(); // no replacement for the match
            else if (replaceFnResult instanceof Autolinker.HtmlTag) return replaceFnResult.toAnchorString();
            else {
                // Perform Autolinker's default anchor tag generation
                var anchorTag = match.buildTag(); // returns an Autolinker.HtmlTag instance
                return anchorTag.toAnchorString();
            }
        },
        /**
	 * Lazily instantiates and returns the {@link #htmlParser} instance for this
	 * Autolinker instance.
	 *
	 * @protected
	 * @return {Autolinker.htmlParser.HtmlParser}
	 */ getHtmlParser: function() {
            var htmlParser = this.htmlParser;
            if (!htmlParser) htmlParser = this.htmlParser = new Autolinker.htmlParser.HtmlParser();
            return htmlParser;
        },
        /**
	 * Lazily instantiates and returns the {@link Autolinker.matcher.Matcher}
	 * instances for this Autolinker instance.
	 *
	 * @protected
	 * @return {Autolinker.matcher.Matcher[]}
	 */ getMatchers: function() {
            if (!this.matchers) {
                var matchersNs = Autolinker.matcher, tagBuilder = this.getTagBuilder();
                var matchers = [
                    new matchersNs.Hashtag({
                        tagBuilder: tagBuilder,
                        serviceName: this.hashtag
                    }),
                    new matchersNs.Email({
                        tagBuilder: tagBuilder
                    }),
                    new matchersNs.Phone({
                        tagBuilder: tagBuilder
                    }),
                    new matchersNs.Twitter({
                        tagBuilder: tagBuilder
                    }),
                    new matchersNs.Url({
                        tagBuilder: tagBuilder,
                        stripPrefix: this.stripPrefix
                    })
                ];
                return this.matchers = matchers;
            } else return this.matchers;
        },
        /**
	 * Returns the {@link #tagBuilder} instance for this Autolinker instance, lazily instantiating it
	 * if it does not yet exist.
	 *
	 * This method may be used in a {@link #replaceFn} to generate the {@link Autolinker.HtmlTag HtmlTag} instance that
	 * Autolinker would normally generate, and then allow for modifications before returning it. For example:
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 *
	 * @return {Autolinker.AnchorTagBuilder}
	 */ getTagBuilder: function() {
            var tagBuilder = this.tagBuilder;
            if (!tagBuilder) tagBuilder = this.tagBuilder = new Autolinker.AnchorTagBuilder({
                newWindow: this.newWindow,
                truncate: this.truncate,
                className: this.className
            });
            return tagBuilder;
        }
    };
    // Autolinker Namespaces
    Autolinker.match = {};
    Autolinker.matcher = {};
    Autolinker.htmlParser = {};
    Autolinker.truncate = {};
    /*global Autolinker */ /*jshint eqnull:true, boss:true */ /**
 * @class Autolinker.Util
 * @singleton
 *
 * A few utility methods for Autolinker.
 */ Autolinker.Util = {
        /**
	 * @property {Function} abstractMethod
	 *
	 * A function object which represents an abstract method.
	 */ abstractMethod: function() {
            throw "abstract";
        },
        /**
	 * @private
	 * @property {RegExp} trimRegex
	 *
	 * The regular expression used to trim the leading and trailing whitespace
	 * from a string.
	 */ trimRegex: /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        /**
	 * Assigns (shallow copies) the properties of `src` onto `dest`.
	 *
	 * @param {Object} dest The destination object.
	 * @param {Object} src The source object.
	 * @return {Object} The destination object (`dest`)
	 */ assign: function(dest, src) {
            for(var prop in src)if (src.hasOwnProperty(prop)) dest[prop] = src[prop];
            return dest;
        },
        /**
	 * Assigns (shallow copies) the properties of `src` onto `dest`, if the
	 * corresponding property on `dest` === `undefined`.
	 *
	 * @param {Object} dest The destination object.
	 * @param {Object} src The source object.
	 * @return {Object} The destination object (`dest`)
	 */ defaults: function(dest, src) {
            for(var prop in src)if (src.hasOwnProperty(prop) && dest[prop] === undefined) dest[prop] = src[prop];
            return dest;
        },
        /**
	 * Extends `superclass` to create a new subclass, adding the `protoProps` to the new subclass's prototype.
	 *
	 * @param {Function} superclass The constructor function for the superclass.
	 * @param {Object} protoProps The methods/properties to add to the subclass's prototype. This may contain the
	 *   special property `constructor`, which will be used as the new subclass's constructor function.
	 * @return {Function} The new subclass function.
	 */ extend: function(superclass, protoProps) {
            var superclassProto = superclass.prototype;
            var F = function() {};
            F.prototype = superclassProto;
            var subclass;
            if (protoProps.hasOwnProperty('constructor')) subclass = protoProps.constructor;
            else subclass = function() {
                superclassProto.constructor.apply(this, arguments);
            };
            var subclassProto = subclass.prototype = new F(); // set up prototype chain
            subclassProto.constructor = subclass; // fix constructor property
            subclassProto.superclass = superclassProto;
            delete protoProps.constructor; // don't re-assign constructor property to the prototype, since a new function may have been created (`subclass`), which is now already there
            Autolinker.Util.assign(subclassProto, protoProps);
            return subclass;
        },
        /**
	 * Truncates the `str` at `len - ellipsisChars.length`, and adds the `ellipsisChars` to the
	 * end of the string (by default, two periods: '..'). If the `str` length does not exceed
	 * `len`, the string will be returned unchanged.
	 *
	 * @param {String} str The string to truncate and add an ellipsis to.
	 * @param {Number} truncateLen The length to truncate the string at.
	 * @param {String} [ellipsisChars=..] The ellipsis character(s) to add to the end of `str`
	 *   when truncated. Defaults to '..'
	 */ ellipsis: function(str, truncateLen, ellipsisChars) {
            if (str.length > truncateLen) {
                ellipsisChars = ellipsisChars == null ? '..' : ellipsisChars;
                str = str.substring(0, truncateLen - ellipsisChars.length) + ellipsisChars;
            }
            return str;
        },
        /**
	 * Supports `Array.prototype.indexOf()` functionality for old IE (IE8 and below).
	 *
	 * @param {Array} arr The array to find an element of.
	 * @param {*} element The element to find in the array, and return the index of.
	 * @return {Number} The index of the `element`, or -1 if it was not found.
	 */ indexOf: function(arr, element) {
            if (Array.prototype.indexOf) return arr.indexOf(element);
            else {
                for(var i = 0, len = arr.length; i < len; i++){
                    if (arr[i] === element) return i;
                }
                return -1;
            }
        },
        /**
	 * Removes array elements based on a filtering function. Mutates the input
	 * array.
	 *
	 * Using this instead of the ES5 Array.prototype.filter() function, to allow
	 * Autolinker compatibility with IE8, and also to prevent creating many new
	 * arrays in memory for filtering.
	 *
	 * @param {Array} arr The array to remove elements from. This array is
	 *   mutated.
	 * @param {Function} fn A function which should return `true` to
	 *   remove an element.
	 * @return {Array} The mutated input `arr`.
	 */ remove: function(arr, fn) {
            for(var i = arr.length - 1; i >= 0; i--)if (fn(arr[i]) === true) arr.splice(i, 1);
        },
        /**
	 * Performs the functionality of what modern browsers do when `String.prototype.split()` is called
	 * with a regular expression that contains capturing parenthesis.
	 *
	 * For example:
	 *
	 *     // Modern browsers:
	 *     "a,b,c".split( /(,)/ );  // --> [ 'a', ',', 'b', ',', 'c' ]
	 *
	 *     // Old IE (including IE8):
	 *     "a,b,c".split( /(,)/ );  // --> [ 'a', 'b', 'c' ]
	 *
	 * This method emulates the functionality of modern browsers for the old IE case.
	 *
	 * @param {String} str The string to split.
	 * @param {RegExp} splitRegex The regular expression to split the input `str` on. The splitting
	 *   character(s) will be spliced into the array, as in the "modern browsers" example in the
	 *   description of this method.
	 *   Note #1: the supplied regular expression **must** have the 'g' flag specified.
	 *   Note #2: for simplicity's sake, the regular expression does not need
	 *   to contain capturing parenthesis - it will be assumed that any match has them.
	 * @return {String[]} The split array of strings, with the splitting character(s) included.
	 */ splitAndCapture: function(str, splitRegex) {
            if (!splitRegex.global) throw new Error("`splitRegex` must have the 'g' flag set");
            var result = [], lastIdx = 0, match;
            while(match = splitRegex.exec(str)){
                result.push(str.substring(lastIdx, match.index));
                result.push(match[0]); // push the splitting char(s)
                lastIdx = match.index + match[0].length;
            }
            result.push(str.substring(lastIdx));
            return result;
        },
        /**
	 * Trims the leading and trailing whitespace from a string.
	 *
	 * @param {String} str The string to trim.
	 * @return {String}
	 */ trim: function(str) {
            return str.replace(this.trimRegex, '');
        }
    };
    /*global Autolinker */ /*jshint boss:true */ /**
 * @class Autolinker.HtmlTag
 * @extends Object
 *
 * Represents an HTML tag, which can be used to easily build/modify HTML tags programmatically.
 *
 * Autolinker uses this abstraction to create HTML tags, and then write them out as strings. You may also use
 * this class in your code, especially within a {@link Autolinker#replaceFn replaceFn}.
 *
 * ## Examples
 *
 * Example instantiation:
 *
 *     var tag = new Autolinker.HtmlTag( {
 *         tagName : 'a',
 *         attrs   : { 'href': 'http://google.com', 'class': 'external-link' },
 *         innerHtml : 'Google'
 *     } );
 *
 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
 *
 *     // Individual accessor methods
 *     tag.getTagName();                 // 'a'
 *     tag.getAttr( 'href' );            // 'http://google.com'
 *     tag.hasClass( 'external-link' );  // true
 *
 *
 * Using mutator methods (which may be used in combination with instantiation config properties):
 *
 *     var tag = new Autolinker.HtmlTag();
 *     tag.setTagName( 'a' );
 *     tag.setAttr( 'href', 'http://google.com' );
 *     tag.addClass( 'external-link' );
 *     tag.setInnerHtml( 'Google' );
 *
 *     tag.getTagName();                 // 'a'
 *     tag.getAttr( 'href' );            // 'http://google.com'
 *     tag.hasClass( 'external-link' );  // true
 *
 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
 *
 *
 * ## Example use within a {@link Autolinker#replaceFn replaceFn}
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( autolinker, match ) {
 *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance, configured with the Match's href and anchor text
 *             tag.setAttr( 'rel', 'nofollow' );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
 *
 *
 * ## Example use with a new tag for the replacement
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( autolinker, match ) {
 *             var tag = new Autolinker.HtmlTag( {
 *                 tagName : 'button',
 *                 attrs   : { 'title': 'Load URL: ' + match.getAnchorHref() },
 *                 innerHtml : 'Load URL: ' + match.getAnchorText()
 *             } );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <button title="Load URL: http://google.com">Load URL: google.com</button>
 */ Autolinker.HtmlTag = Autolinker.Util.extend(Object, {
        /**
	 * @cfg {String} tagName
	 *
	 * The tag name. Ex: 'a', 'button', etc.
	 *
	 * Not required at instantiation time, but should be set using {@link #setTagName} before {@link #toAnchorString}
	 * is executed.
	 */ /**
	 * @cfg {Object.<String, String>} attrs
	 *
	 * An key/value Object (map) of attributes to create the tag with. The keys are the attribute names, and the
	 * values are the attribute values.
	 */ /**
	 * @cfg {String} innerHtml
	 *
	 * The inner HTML for the tag.
	 *
	 * Note the camel case name on `innerHtml`. Acronyms are camelCased in this utility (such as not to run into the acronym
	 * naming inconsistency that the DOM developers created with `XMLHttpRequest`). You may alternatively use {@link #innerHTML}
	 * if you prefer, but this one is recommended.
	 */ /**
	 * @cfg {String} innerHTML
	 *
	 * Alias of {@link #innerHtml}, accepted for consistency with the browser DOM api, but prefer the camelCased version
	 * for acronym names.
	 */ /**
	 * @protected
	 * @property {RegExp} whitespaceRegex
	 *
	 * Regular expression used to match whitespace in a string of CSS classes.
	 */ whitespaceRegex: /\s+/,
        /**
	 * @constructor
	 * @param {Object} [cfg] The configuration properties for this class, in an Object (map)
	 */ constructor: function(cfg) {
            Autolinker.Util.assign(this, cfg);
            this.innerHtml = this.innerHtml || this.innerHTML; // accept either the camelCased form or the fully capitalized acronym
        },
        /**
	 * Sets the tag name that will be used to generate the tag with.
	 *
	 * @param {String} tagName
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ setTagName: function(tagName) {
            this.tagName = tagName;
            return this;
        },
        /**
	 * Retrieves the tag name.
	 *
	 * @return {String}
	 */ getTagName: function() {
            return this.tagName || "";
        },
        /**
	 * Sets an attribute on the HtmlTag.
	 *
	 * @param {String} attrName The attribute name to set.
	 * @param {String} attrValue The attribute value to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ setAttr: function(attrName, attrValue) {
            var tagAttrs = this.getAttrs();
            tagAttrs[attrName] = attrValue;
            return this;
        },
        /**
	 * Retrieves an attribute from the HtmlTag. If the attribute does not exist, returns `undefined`.
	 *
	 * @param {String} attrName The attribute name to retrieve.
	 * @return {String} The attribute's value, or `undefined` if it does not exist on the HtmlTag.
	 */ getAttr: function(attrName) {
            return this.getAttrs()[attrName];
        },
        /**
	 * Sets one or more attributes on the HtmlTag.
	 *
	 * @param {Object.<String, String>} attrs A key/value Object (map) of the attributes to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ setAttrs: function(attrs) {
            var tagAttrs = this.getAttrs();
            Autolinker.Util.assign(tagAttrs, attrs);
            return this;
        },
        /**
	 * Retrieves the attributes Object (map) for the HtmlTag.
	 *
	 * @return {Object.<String, String>} A key/value object of the attributes for the HtmlTag.
	 */ getAttrs: function() {
            return this.attrs || (this.attrs = {});
        },
        /**
	 * Sets the provided `cssClass`, overwriting any current CSS classes on the HtmlTag.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to set (overwrite).
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ setClass: function(cssClass) {
            return this.setAttr('class', cssClass);
        },
        /**
	 * Convenience method to add one or more CSS classes to the HtmlTag. Will not add duplicate CSS classes.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to add.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ addClass: function(cssClass) {
            var classAttr = this.getClass(), whitespaceRegex = this.whitespaceRegex, indexOf = Autolinker.Util.indexOf, classes = !classAttr ? [] : classAttr.split(whitespaceRegex), newClasses = cssClass.split(whitespaceRegex), newClass;
            while(newClass = newClasses.shift())if (indexOf(classes, newClass) === -1) classes.push(newClass);
            this.getAttrs()['class'] = classes.join(" ");
            return this;
        },
        /**
	 * Convenience method to remove one or more CSS classes from the HtmlTag.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to remove.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ removeClass: function(cssClass) {
            var classAttr = this.getClass(), whitespaceRegex = this.whitespaceRegex, indexOf = Autolinker.Util.indexOf, classes = !classAttr ? [] : classAttr.split(whitespaceRegex), removeClasses = cssClass.split(whitespaceRegex), removeClass;
            while(classes.length && (removeClass = removeClasses.shift())){
                var idx = indexOf(classes, removeClass);
                if (idx !== -1) classes.splice(idx, 1);
            }
            this.getAttrs()['class'] = classes.join(" ");
            return this;
        },
        /**
	 * Convenience method to retrieve the CSS class(es) for the HtmlTag, which will each be separated by spaces when
	 * there are multiple.
	 *
	 * @return {String}
	 */ getClass: function() {
            return this.getAttrs()['class'] || "";
        },
        /**
	 * Convenience method to check if the tag has a CSS class or not.
	 *
	 * @param {String} cssClass The CSS class to check for.
	 * @return {Boolean} `true` if the HtmlTag has the CSS class, `false` otherwise.
	 */ hasClass: function(cssClass) {
            return (' ' + this.getClass() + ' ').indexOf(' ' + cssClass + ' ') !== -1;
        },
        /**
	 * Sets the inner HTML for the tag.
	 *
	 * @param {String} html The inner HTML to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ setInnerHtml: function(html) {
            this.innerHtml = html;
            return this;
        },
        /**
	 * Retrieves the inner HTML for the tag.
	 *
	 * @return {String}
	 */ getInnerHtml: function() {
            return this.innerHtml || "";
        },
        /**
	 * Override of superclass method used to generate the HTML string for the tag.
	 *
	 * @return {String}
	 */ toAnchorString: function() {
            var tagName = this.getTagName(), attrsStr = this.buildAttrsStr();
            attrsStr = attrsStr ? ' ' + attrsStr : ''; // prepend a space if there are actually attributes
            return [
                '<',
                tagName,
                attrsStr,
                '>',
                this.getInnerHtml(),
                '</',
                tagName,
                '>'
            ].join("");
        },
        /**
	 * Support method for {@link #toAnchorString}, returns the string space-separated key="value" pairs, used to populate
	 * the stringified HtmlTag.
	 *
	 * @protected
	 * @return {String} Example return: `attr1="value1" attr2="value2"`
	 */ buildAttrsStr: function() {
            if (!this.attrs) return ""; // no `attrs` Object (map) has been set, return empty string
            var attrs = this.getAttrs(), attrsArr = [];
            for(var prop in attrs)if (attrs.hasOwnProperty(prop)) attrsArr.push(prop + '="' + attrs[prop] + '"');
            return attrsArr.join(" ");
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.RegexLib
 * @singleton
 *
 * Builds and stores a library of the common regular expressions used by the
 * Autolinker utility.
 *
 * Other regular expressions may exist ad-hoc, but these are generally the
 * regular expressions that are shared between source files.
 */ Autolinker.RegexLib = function() {
        /**
	 * The string form of a regular expression that would match all of the
	 * alphabetic ("letter") chars in the unicode character set when placed in a
	 * RegExp character class (`[]`). This includes all international alphabetic
	 * characters.
	 *
	 * These would be the characters matched by unicode regex engines `\p{L}`
	 * escape ("all letters").
	 *
	 * Taken from the XRegExp library: http://xregexp.com/
	 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
	 *
	 * @private
	 * @type {String}
	 */ var alphaCharsStr = 'A-Za-z\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC';
        /**
	 * The string form of a regular expression that would match all of the
	 * decimal number chars in the unicode character set when placed in a RegExp
	 * character class (`[]`).
	 *
	 * These would be the characters matched by unicode regex engines `\p{Nd}`
	 * escape ("all decimal numbers")
	 *
	 * Taken from the XRegExp library: http://xregexp.com/
	 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
	 *
	 * @private
	 * @type {String}
	 */ var decimalNumbersStr = '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19';
        // See documentation below
        var alphaNumericCharsStr = alphaCharsStr + decimalNumbersStr;
        // See documentation below
        var domainNameRegex = new RegExp('[' + alphaNumericCharsStr + '.\\-]*[' + alphaNumericCharsStr + '\\-]');
        // See documentation below
        var tldRegex = /(?:travelersinsurance|sandvikcoromant|kerryproperties|cancerresearch|weatherchannel|kerrylogistics|spreadbetting|international|wolterskluwer|lifeinsurance|construction|pamperedchef|scholarships|versicherung|bridgestone|creditunion|kerryhotels|investments|productions|blackfriday|enterprises|lamborghini|photography|motorcycles|williamhill|playstation|contractors|barclaycard|accountants|redumbrella|engineering|management|telefonica|protection|consulting|tatamotors|creditcard|vlaanderen|schaeffler|associates|properties|foundation|republican|bnpparibas|boehringer|eurovision|extraspace|industries|immobilien|university|technology|volkswagen|healthcare|restaurant|cuisinella|vistaprint|apartments|accountant|travelers|homedepot|institute|vacations|furniture|fresenius|insurance|christmas|bloomberg|solutions|barcelona|firestone|financial|kuokgroup|fairwinds|community|passagens|goldpoint|equipment|lifestyle|yodobashi|aquarelle|marketing|analytics|education|amsterdam|statefarm|melbourne|allfinanz|directory|microsoft|stockholm|montblanc|accenture|lancaster|landrover|everbank|istanbul|graphics|grainger|ipiranga|softbank|attorney|pharmacy|saarland|catering|airforce|yokohama|mortgage|frontier|mutuelle|stcgroup|memorial|pictures|football|symantec|cipriani|ventures|telecity|cityeats|verisign|flsmidth|boutique|cleaning|firmdale|clinique|clothing|redstone|infiniti|deloitte|feedback|services|broadway|plumbing|commbank|training|barclays|exchange|computer|brussels|software|delivery|barefoot|builders|business|bargains|engineer|holdings|download|security|helsinki|lighting|movistar|discount|hdfcbank|supplies|marriott|property|diamonds|capetown|partners|democrat|jpmorgan|bradesco|budapest|rexroth|zuerich|shriram|academy|science|support|youtube|singles|surgery|alibaba|statoil|dentist|schwarz|android|cruises|cricket|digital|markets|starhub|systems|courses|coupons|netbank|country|domains|corsica|network|neustar|realtor|lincoln|limited|schmidt|yamaxun|cooking|contact|auction|spiegel|liaison|leclerc|latrobe|lasalle|abogado|compare|lanxess|exposed|express|company|cologne|college|avianca|lacaixa|fashion|recipes|ferrero|komatsu|storage|wanggou|clubmed|sandvik|fishing|fitness|bauhaus|kitchen|flights|florist|flowers|watches|weather|temasek|samsung|bentley|forsale|channel|theater|frogans|theatre|okinawa|website|tickets|jewelry|gallery|tiffany|iselect|shiksha|brother|organic|wedding|genting|toshiba|origins|philips|hyundai|hotmail|hoteles|hosting|rentals|windows|cartier|bugatti|holiday|careers|whoswho|hitachi|panerai|caravan|reviews|guitars|capital|trading|hamburg|hangout|finance|stream|family|abbott|health|review|travel|report|hermes|hiphop|gratis|career|toyota|hockey|dating|repair|google|social|soccer|reisen|global|otsuka|giving|unicom|casino|photos|center|broker|rocher|orange|bostik|garden|insure|ryukyu|bharti|safety|physio|sakura|oracle|online|jaguar|gallup|piaget|tienda|futbol|pictet|joburg|webcam|berlin|office|juegos|kaufen|chanel|chrome|xihuan|church|tennis|circle|kinder|flickr|bayern|claims|clinic|viajes|nowruz|xperia|norton|yachts|studio|coffee|camera|sanofi|nissan|author|expert|events|comsec|lawyer|tattoo|viking|estate|villas|condos|realty|yandex|energy|emerck|virgin|vision|durban|living|school|coupon|london|taobao|natura|taipei|nagoya|luxury|walter|aramco|sydney|madrid|credit|maison|makeup|schule|market|anquan|direct|design|swatch|suzuki|alsace|vuelos|dental|alipay|voyage|shouji|voting|airtel|mutual|degree|supply|agency|museum|mobily|dealer|monash|select|mormon|active|moscow|racing|datsun|quebec|nissay|rodeo|email|gifts|works|photo|chloe|edeka|cheap|earth|vista|tushu|koeln|glass|shoes|globo|tunes|gmail|nokia|space|kyoto|black|ricoh|seven|lamer|sener|epson|cisco|praxi|trust|citic|crown|shell|lease|green|legal|lexus|ninja|tatar|gripe|nikon|group|video|wales|autos|gucci|party|nexus|guide|linde|adult|parts|amica|lixil|boats|azure|loans|locus|cymru|lotte|lotto|stada|click|poker|quest|dabur|lupin|nadex|paris|faith|dance|canon|place|gives|trade|skype|rocks|mango|cloud|boots|smile|final|swiss|homes|honda|media|horse|cards|deals|watch|bosch|house|pizza|miami|osaka|tours|total|xerox|coach|sucks|style|delta|toray|iinet|tools|money|codes|beats|tokyo|salon|archi|movie|baidu|study|actor|yahoo|store|apple|world|forex|today|bible|tmall|tirol|irish|tires|forum|reise|vegas|vodka|sharp|omega|weber|jetzt|audio|promo|build|bingo|chase|gallo|drive|dubai|rehab|press|solar|sale|beer|bbva|bank|band|auto|sapo|sarl|saxo|audi|asia|arte|arpa|army|yoga|ally|zara|scor|scot|sexy|seat|zero|seek|aero|adac|zone|aarp|maif|meet|meme|menu|surf|mini|mobi|mtpc|porn|desi|star|ltda|name|talk|navy|love|loan|live|link|news|limo|like|spot|life|nico|lidl|lgbt|land|taxi|team|tech|kred|kpmg|sony|song|kiwi|kddi|jprs|jobs|sohu|java|itau|tips|info|immo|icbc|hsbc|town|host|page|toys|here|help|pars|haus|guru|guge|tube|goog|golf|gold|sncf|gmbh|gift|ggee|gent|gbiz|game|vana|pics|fund|ford|ping|pink|fish|film|fast|farm|play|fans|fail|plus|skin|pohl|fage|moda|post|erni|dvag|prod|doha|prof|docs|viva|diet|luxe|site|dell|sina|dclk|show|qpon|date|vote|cyou|voto|read|coop|cool|wang|club|city|chat|cern|cash|reit|rent|casa|cars|care|camp|rest|call|cafe|weir|wien|rich|wiki|buzz|wine|book|bond|room|work|rsvp|shia|ruhr|blue|bing|shaw|bike|safe|xbox|best|pwc|mtn|lds|aig|boo|fyi|nra|nrw|ntt|car|gal|obi|zip|aeg|vin|how|one|ong|onl|dad|ooo|bet|esq|org|htc|bar|uol|ibm|ovh|gdn|ice|icu|uno|gea|ifm|bot|top|wtf|lol|day|pet|eus|wtc|ubs|tvs|aco|ing|ltd|ink|tab|abb|afl|cat|int|pid|pin|bid|cba|gle|com|cbn|ads|man|wed|ceb|gmo|sky|ist|gmx|tui|mba|fan|ski|iwc|app|pro|med|ceo|jcb|jcp|goo|dev|men|aaa|meo|pub|jlc|bom|jll|gop|jmp|mil|got|gov|win|jot|mma|joy|trv|red|cfa|cfd|bio|moe|moi|mom|ren|biz|aws|xin|bbc|dnp|buy|kfh|mov|thd|xyz|fit|kia|rio|rip|kim|dog|vet|nyc|bcg|mtr|bcn|bms|bmw|run|bzh|rwe|tel|stc|axa|kpn|fly|krd|cab|bnl|foo|crs|eat|tci|sap|srl|nec|sas|net|cal|sbs|sfr|sca|scb|csc|edu|new|xxx|hiv|fox|wme|ngo|nhk|vip|sex|frl|lat|yun|law|you|tax|soy|sew|om|ac|hu|se|sc|sg|sh|sb|sa|rw|ru|rs|ro|re|qa|py|si|pw|pt|ps|sj|sk|pr|pn|pm|pl|sl|sm|pk|sn|ph|so|pg|pf|pe|pa|zw|nz|nu|nr|np|no|nl|ni|ng|nf|sr|ne|st|nc|na|mz|my|mx|mw|mv|mu|mt|ms|mr|mq|mp|mo|su|mn|mm|ml|mk|mh|mg|me|sv|md|mc|sx|sy|ma|ly|lv|sz|lu|lt|ls|lr|lk|li|lc|lb|la|tc|kz|td|ky|kw|kr|kp|kn|km|ki|kh|tf|tg|th|kg|ke|jp|jo|jm|je|it|is|ir|tj|tk|tl|tm|iq|tn|to|io|in|im|il|ie|ad|sd|ht|hr|hn|hm|tr|hk|gy|gw|gu|gt|gs|gr|gq|tt|gp|gn|gm|gl|tv|gi|tw|tz|ua|gh|ug|uk|gg|gf|ge|gd|us|uy|uz|va|gb|ga|vc|ve|fr|fo|fm|fk|fj|vg|vi|fi|eu|et|es|er|eg|ee|ec|dz|do|dm|dk|vn|dj|de|cz|cy|cx|cw|vu|cv|cu|cr|co|cn|cm|cl|ck|ci|ch|cg|cf|cd|cc|ca|wf|bz|by|bw|bv|bt|bs|br|bo|bn|bm|bj|bi|ws|bh|bg|bf|be|bd|bb|ba|az|ax|aw|au|at|as|ye|ar|aq|ao|am|al|yt|ai|za|ag|af|ae|zm|id)\b/;
        return {
            /**
		 * The string form of a regular expression that would match all of the
		 * letters and decimal number chars in the unicode character set when placed
		 * in a RegExp character class (`[]`).
		 *
		 * These would be the characters matched by unicode regex engines `[\p{L}\p{Nd}]`
		 * escape ("all letters and decimal numbers")
		 *
		 * @property {String} alphaNumericCharsStr
		 */ alphaNumericCharsStr: alphaNumericCharsStr,
            /**
		 * A regular expression to match domain names of a URL or email address.
		 * Ex: 'google', 'yahoo', 'some-other-company', etc.
		 *
		 * @property {RegExp} domainNameRegex
		 */ domainNameRegex: domainNameRegex,
            /**
		 * A regular expression to match top level domains (TLDs) for a URL or
		 * email address. Ex: 'com', 'org', 'net', etc.
		 *
		 * @property {RegExp} tldRegex
		 */ tldRegex: tldRegex
        };
    }();
    /*global Autolinker */ /*jshint sub:true */ /**
 * @protected
 * @class Autolinker.AnchorTagBuilder
 * @extends Object
 *
 * Builds anchor (&lt;a&gt;) tags for the Autolinker utility when a match is
 * found.
 *
 * Normally this class is instantiated, configured, and used internally by an
 * {@link Autolinker} instance, but may actually be retrieved in a {@link Autolinker#replaceFn replaceFn}
 * to create {@link Autolinker.HtmlTag HtmlTag} instances which may be modified
 * before returning from the {@link Autolinker#replaceFn replaceFn}. For
 * example:
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( autolinker, match ) {
 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
 *             tag.setAttr( 'rel', 'nofollow' );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
 */ Autolinker.AnchorTagBuilder = Autolinker.Util.extend(Object, {
        /**
	 * @cfg {Boolean} newWindow
	 * @inheritdoc Autolinker#newWindow
	 */ /**
	 * @cfg {Object} truncate
	 * @inheritdoc Autolinker#truncate
	 */ /**
	 * @cfg {String} className
	 * @inheritdoc Autolinker#className
	 */ /**
	 * @constructor
	 * @param {Object} [cfg] The configuration options for the AnchorTagBuilder instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.Util.assign(this, cfg);
        },
        /**
	 * Generates the actual anchor (&lt;a&gt;) tag to use in place of the
	 * matched text, via its `match` object.
	 *
	 * @param {Autolinker.match.Match} match The Match instance to generate an
	 *   anchor tag from.
	 * @return {Autolinker.HtmlTag} The HtmlTag instance for the anchor tag.
	 */ build: function(match) {
            return new Autolinker.HtmlTag({
                tagName: 'a',
                attrs: this.createAttrs(match.getType(), match.getAnchorHref()),
                innerHtml: this.processAnchorText(match.getAnchorText())
            });
        },
        /**
	 * Creates the Object (map) of the HTML attributes for the anchor (&lt;a&gt;)
	 *   tag being generated.
	 *
	 * @protected
	 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
	 *   match that an anchor tag is being generated for.
	 * @param {String} anchorHref The href for the anchor tag.
	 * @return {Object} A key/value Object (map) of the anchor tag's attributes.
	 */ createAttrs: function(matchType, anchorHref) {
            var attrs = {
                'href': anchorHref // we'll always have the `href` attribute
            };
            var cssClass = this.createCssClass(matchType);
            if (cssClass) attrs['class'] = cssClass;
            if (this.newWindow) {
                attrs['target'] = "_blank";
                attrs['rel'] = "noopener noreferrer";
            }
            return attrs;
        },
        /**
	 * Creates the CSS class that will be used for a given anchor tag, based on
	 * the `matchType` and the {@link #className} config.
	 *
	 * @private
	 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
	 *   match that an anchor tag is being generated for.
	 * @return {String} The CSS class string for the link. Example return:
	 *   "myLink myLink-url". If no {@link #className} was configured, returns
	 *   an empty string.
	 */ createCssClass: function(matchType) {
            var className = this.className;
            if (!className) return "";
            else return className + " " + className + "-" + matchType; // ex: "myLink myLink-url", "myLink myLink-email", "myLink myLink-phone", "myLink myLink-twitter", or "myLink myLink-hashtag"
        },
        /**
	 * Processes the `anchorText` by truncating the text according to the
	 * {@link #truncate} config.
	 *
	 * @private
	 * @param {String} anchorText The anchor tag's text (i.e. what will be
	 *   displayed).
	 * @return {String} The processed `anchorText`.
	 */ processAnchorText: function(anchorText) {
            anchorText = this.doTruncate(anchorText);
            return anchorText;
        },
        /**
	 * Performs the truncation of the `anchorText` based on the {@link #truncate}
	 * option. If the `anchorText` is longer than the length specified by the
	 * {@link #truncate} option, the truncation is performed based on the
	 * `location` property. See {@link #truncate} for details.
	 *
	 * @private
	 * @param {String} anchorText The anchor tag's text (i.e. what will be
	 *   displayed).
	 * @return {String} The truncated anchor text.
	 */ doTruncate: function(anchorText) {
            var truncate = this.truncate;
            if (!truncate || !truncate.length) return anchorText;
            var truncateLength = truncate.length, truncateLocation = truncate.location;
            if (truncateLocation === 'smart') return Autolinker.truncate.TruncateSmart(anchorText, truncateLength, '..');
            else if (truncateLocation === 'middle') return Autolinker.truncate.TruncateMiddle(anchorText, truncateLength, '..');
            else return Autolinker.truncate.TruncateEnd(anchorText, truncateLength, '..');
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.htmlParser.HtmlParser
 * @extends Object
 *
 * An HTML parser implementation which simply walks an HTML string and returns an array of
 * {@link Autolinker.htmlParser.HtmlNode HtmlNodes} that represent the basic HTML structure of the input string.
 *
 * Autolinker uses this to only link URLs/emails/Twitter handles within text nodes, effectively ignoring / "walking
 * around" HTML tags.
 */ Autolinker.htmlParser.HtmlParser = Autolinker.Util.extend(Object, {
        /**
	 * @private
	 * @property {RegExp} htmlRegex
	 *
	 * The regular expression used to pull out HTML tags from a string. Handles namespaced HTML tags and
	 * attribute names, as specified by http://www.w3.org/TR/html-markup/syntax.html.
	 *
	 * Capturing groups:
	 *
	 * 1. The "!DOCTYPE" tag name, if a tag is a &lt;!DOCTYPE&gt; tag.
	 * 2. If it is an end tag, this group will have the '/'.
	 * 3. If it is a comment tag, this group will hold the comment text (i.e.
	 *    the text inside the `&lt;!--` and `--&gt;`.
	 * 4. The tag name for all tags (other than the &lt;!DOCTYPE&gt; tag)
	 */ htmlRegex: function() {
            var commentTagRegex = /!--([\s\S]+?)--/, tagNameRegex = /[0-9a-zA-Z][0-9a-zA-Z:]*/, attrNameRegex = /[^\s"'>\/=\x00-\x1F\x7F]+/, attrValueRegex = /(?:"[^"]*?"|'[^']*?'|[^'"=<>`\s]+)/, nameEqualsValueRegex = attrNameRegex.source + '(?:\\s*=\\s*' + attrValueRegex.source + ')?'; // optional '=[value]'
            return new RegExp([
                // for <!DOCTYPE> tag. Ex: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
                '(?:',
                '<(!DOCTYPE)',
                // Zero or more attributes following the tag name
                '(?:',
                '\\s+',
                // Either:
                // A. attr="value", or
                // B. "value" alone (To cover example doctype tag: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
                '(?:',
                nameEqualsValueRegex,
                '|',
                attrValueRegex.source + ')',
                ')*',
                '>',
                ')',
                '|',
                // All other HTML tags (i.e. tags that are not <!DOCTYPE>)
                '(?:',
                '<(/)?',
                // *** Capturing Group 2: The slash or an empty string. Slash ('/') for end tag, empty string for start or self-closing tag.
                '(?:',
                commentTagRegex.source,
                '|',
                '(?:',
                // *** Capturing Group 4 - The tag name
                '(' + tagNameRegex.source + ')',
                // Zero or more attributes following the tag name
                '(?:',
                '(?:\\s+|\\b)',
                nameEqualsValueRegex,
                ')*',
                '\\s*/?',
                ')',
                ')',
                '>',
                ')'
            ].join(""), 'gi');
        }(),
        /**
	 * @private
	 * @property {RegExp} htmlCharacterEntitiesRegex
	 *
	 * The regular expression that matches common HTML character entities.
	 *
	 * Ignoring &amp; as it could be part of a query string -- handling it separately.
	 */ htmlCharacterEntitiesRegex: /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi,
        /**
	 * Parses an HTML string and returns a simple array of {@link Autolinker.htmlParser.HtmlNode HtmlNodes}
	 * to represent the HTML structure of the input string.
	 *
	 * @param {String} html The HTML to parse.
	 * @return {Autolinker.htmlParser.HtmlNode[]}
	 */ parse: function(html) {
            var htmlRegex = this.htmlRegex, currentResult, lastIndex = 0, textAndEntityNodes, nodes = []; // will be the result of the method
            while((currentResult = htmlRegex.exec(html)) !== null){
                var tagText = currentResult[0], commentText = currentResult[3], tagName = currentResult[1] || currentResult[4], isClosingTag = !!currentResult[2], offset = currentResult.index, inBetweenTagsText = html.substring(lastIndex, offset);
                // Push TextNodes and EntityNodes for any text found between tags
                if (inBetweenTagsText) {
                    textAndEntityNodes = this.parseTextAndEntityNodes(lastIndex, inBetweenTagsText);
                    nodes.push.apply(nodes, textAndEntityNodes);
                }
                // Push the CommentNode or ElementNode
                if (commentText) nodes.push(this.createCommentNode(offset, tagText, commentText));
                else nodes.push(this.createElementNode(offset, tagText, tagName, isClosingTag));
                lastIndex = offset + tagText.length;
            }
            // Process any remaining text after the last HTML element. Will process all of the text if there were no HTML elements.
            if (lastIndex < html.length) {
                var text = html.substring(lastIndex);
                // Push TextNodes and EntityNodes for any text found between tags
                if (text) {
                    textAndEntityNodes = this.parseTextAndEntityNodes(lastIndex, text);
                    nodes.push.apply(nodes, textAndEntityNodes);
                }
            }
            return nodes;
        },
        /**
	 * Parses text and HTML entity nodes from a given string. The input string
	 * should not have any HTML tags (elements) within it.
	 *
	 * @private
	 * @param {Number} offset The offset of the text node match within the
	 *   original HTML string.
	 * @param {String} text The string of text to parse. This is from an HTML
	 *   text node.
	 * @return {Autolinker.htmlParser.HtmlNode[]} An array of HtmlNodes to
	 *   represent the {@link Autolinker.htmlParser.TextNode TextNodes} and
	 *   {@link Autolinker.htmlParser.EntityNode EntityNodes} found.
	 */ parseTextAndEntityNodes: function(offset, text) {
            var nodes = [], textAndEntityTokens = Autolinker.Util.splitAndCapture(text, this.htmlCharacterEntitiesRegex); // split at HTML entities, but include the HTML entities in the results array
            // Every even numbered token is a TextNode, and every odd numbered token is an EntityNode
            // For example: an input `text` of "Test &quot;this&quot; today" would turn into the
            //   `textAndEntityTokens`: [ 'Test ', '&quot;', 'this', '&quot;', ' today' ]
            for(var i = 0, len = textAndEntityTokens.length; i < len; i += 2){
                var textToken = textAndEntityTokens[i], entityToken = textAndEntityTokens[i + 1];
                if (textToken) {
                    nodes.push(this.createTextNode(offset, textToken));
                    offset += textToken.length;
                }
                if (entityToken) {
                    nodes.push(this.createEntityNode(offset, entityToken));
                    offset += entityToken.length;
                }
            }
            return nodes;
        },
        /**
	 * Factory method to create an {@link Autolinker.htmlParser.CommentNode CommentNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} tagText The full text of the tag (comment) that was
	 *   matched, including its &lt;!-- and --&gt;.
	 * @param {String} commentText The full text of the comment that was matched.
	 */ createCommentNode: function(offset, tagText, commentText) {
            return new Autolinker.htmlParser.CommentNode({
                offset: offset,
                text: tagText,
                comment: Autolinker.Util.trim(commentText)
            });
        },
        /**
	 * Factory method to create an {@link Autolinker.htmlParser.ElementNode ElementNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} tagText The full text of the tag (element) that was
	 *   matched, including its attributes.
	 * @param {String} tagName The name of the tag. Ex: An &lt;img&gt; tag would
	 *   be passed to this method as "img".
	 * @param {Boolean} isClosingTag `true` if it's a closing tag, false
	 *   otherwise.
	 * @return {Autolinker.htmlParser.ElementNode}
	 */ createElementNode: function(offset, tagText, tagName, isClosingTag) {
            return new Autolinker.htmlParser.ElementNode({
                offset: offset,
                text: tagText,
                tagName: tagName.toLowerCase(),
                closing: isClosingTag
            });
        },
        /**
	 * Factory method to create a {@link Autolinker.htmlParser.EntityNode EntityNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} text The text that was matched for the HTML entity (such
	 *   as '&amp;nbsp;').
	 * @return {Autolinker.htmlParser.EntityNode}
	 */ createEntityNode: function(offset, text) {
            return new Autolinker.htmlParser.EntityNode({
                offset: offset,
                text: text
            });
        },
        /**
	 * Factory method to create a {@link Autolinker.htmlParser.TextNode TextNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} text The text that was matched.
	 * @return {Autolinker.htmlParser.TextNode}
	 */ createTextNode: function(offset, text) {
            return new Autolinker.htmlParser.TextNode({
                offset: offset,
                text: text
            });
        }
    });
    /*global Autolinker */ /**
 * @abstract
 * @class Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML node found in an input string. An HTML node is one of the
 * following:
 *
 * 1. An {@link Autolinker.htmlParser.ElementNode ElementNode}, which represents
 *    HTML tags.
 * 2. A {@link Autolinker.htmlParser.CommentNode CommentNode}, which represents
 *    HTML comments.
 * 3. A {@link Autolinker.htmlParser.TextNode TextNode}, which represents text
 *    outside or within HTML tags.
 * 4. A {@link Autolinker.htmlParser.EntityNode EntityNode}, which represents
 *    one of the known HTML entities that Autolinker looks for. This includes
 *    common ones such as &amp;quot; and &amp;nbsp;
 */ Autolinker.htmlParser.HtmlNode = Autolinker.Util.extend(Object, {
        /**
	 * @cfg {Number} offset (required)
	 *
	 * The offset of the HTML node in the original text that was parsed.
	 */ offset: undefined,
        /**
	 * @cfg {String} text (required)
	 *
	 * The text that was matched for the HtmlNode.
	 *
	 * - In the case of an {@link Autolinker.htmlParser.ElementNode ElementNode},
	 *   this will be the tag's text.
	 * - In the case of an {@link Autolinker.htmlParser.CommentNode CommentNode},
	 *   this will be the comment's text.
	 * - In the case of a {@link Autolinker.htmlParser.TextNode TextNode}, this
	 *   will be the text itself.
	 * - In the case of a {@link Autolinker.htmlParser.EntityNode EntityNode},
	 *   this will be the text of the HTML entity.
	 */ text: undefined,
        /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 * specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.Util.assign(this, cfg);
            if (this.offset == null) throw new Error('`offset` cfg required');
            if (this.text == null) throw new Error('`text` cfg required');
        },
        /**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @abstract
	 * @return {String}
	 */ getType: Autolinker.Util.abstractMethod,
        /**
	 * Retrieves the {@link #offset} of the HtmlNode. This is the offset of the
	 * HTML node in the original string that was parsed.
	 *
	 * @return {Number}
	 */ getOffset: function() {
            return this.offset;
        },
        /**
	 * Retrieves the {@link #text} for the HtmlNode.
	 *
	 * @return {String}
	 */ getText: function() {
            return this.text;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.htmlParser.CommentNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML comment node that has been parsed by the
 * {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */ Autolinker.htmlParser.CommentNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
        /**
	 * @cfg {String} comment (required)
	 *
	 * The text inside the comment tag. This text is stripped of any leading or
	 * trailing whitespace.
	 */ comment: '',
        /**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return 'comment';
        },
        /**
	 * Returns the comment inside the comment tag.
	 *
	 * @return {String}
	 */ getComment: function() {
            return this.comment;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.htmlParser.ElementNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML element node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */ Autolinker.htmlParser.ElementNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
        /**
	 * @cfg {String} tagName (required)
	 *
	 * The name of the tag that was matched.
	 */ tagName: '',
        /**
	 * @cfg {Boolean} closing (required)
	 *
	 * `true` if the element (tag) is a closing tag, `false` if its an opening
	 * tag.
	 */ closing: false,
        /**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return 'element';
        },
        /**
	 * Returns the HTML element's (tag's) name. Ex: for an &lt;img&gt; tag,
	 * returns "img".
	 *
	 * @return {String}
	 */ getTagName: function() {
            return this.tagName;
        },
        /**
	 * Determines if the HTML element (tag) is a closing tag. Ex: &lt;div&gt;
	 * returns `false`, while &lt;/div&gt; returns `true`.
	 *
	 * @return {Boolean}
	 */ isClosing: function() {
            return this.closing;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.htmlParser.EntityNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents a known HTML entity node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 * Ex: '&amp;nbsp;', or '&amp#160;' (which will be retrievable from the {@link #getText}
 * method.
 *
 * Note that this class will only be returned from the HtmlParser for the set of
 * checked HTML entity nodes  defined by the {@link Autolinker.htmlParser.HtmlParser#htmlCharacterEntitiesRegex}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */ Autolinker.htmlParser.EntityNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
        /**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return 'entity';
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.htmlParser.TextNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents a text node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */ Autolinker.htmlParser.TextNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
        /**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return 'text';
        }
    });
    /*global Autolinker */ /**
 * @abstract
 * @class Autolinker.match.Match
 *
 * Represents a match found in an input string which should be Autolinked. A Match object is what is provided in a
 * {@link Autolinker#replaceFn replaceFn}, and may be used to query for details about the match.
 *
 * For example:
 *
 *     var input = "...";  // string with URLs, Email Addresses, and Twitter Handles
 *
 *     var linkedText = Autolinker.link( input, {
 *         replaceFn : function( autolinker, match ) {
 *             console.log( "href = ", match.getAnchorHref() );
 *             console.log( "text = ", match.getAnchorText() );
 *
 *             switch( match.getType() ) {
 *                 case 'url' :
 *                     console.log( "url: ", match.getUrl() );
 *
 *                 case 'email' :
 *                     console.log( "email: ", match.getEmail() );
 *
 *                 case 'twitter' :
 *                     console.log( "twitter: ", match.getTwitterHandle() );
 *             }
 *         }
 *     } );
 *
 * See the {@link Autolinker} class for more details on using the {@link Autolinker#replaceFn replaceFn}.
 */ Autolinker.match.Match = Autolinker.Util.extend(Object, {
        /**
	 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
	 *
	 * Reference to the AnchorTagBuilder instance to use to generate an anchor
	 * tag for the Match.
	 */ /**
	 * @cfg {String} matchedText (required)
	 *
	 * The original text that was matched by the {@link Autolinker.matcher.Matcher}.
	 */ /**
	 * @cfg {Number} offset (required)
	 *
	 * The offset of where the match was made in the input string.
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            if (cfg.tagBuilder == null) throw new Error('`tagBuilder` cfg required');
            if (cfg.matchedText == null) throw new Error('`matchedText` cfg required');
            if (cfg.offset == null) throw new Error('`offset` cfg required');
            this.tagBuilder = cfg.tagBuilder;
            this.matchedText = cfg.matchedText;
            this.offset = cfg.offset;
        },
        /**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @abstract
	 * @return {String}
	 */ getType: Autolinker.Util.abstractMethod,
        /**
	 * Returns the original text that was matched.
	 *
	 * @return {String}
	 */ getMatchedText: function() {
            return this.matchedText;
        },
        /**
	 * Sets the {@link #offset} of where the match was made in the input string.
	 *
	 * A {@link Autolinker.matcher.Matcher} will be fed only HTML text nodes,
	 * and will therefore set an original offset that is relative to the HTML
	 * text node itself. However, we want this offset to be relative to the full
	 * HTML input string, and thus if using {@link Autolinker#parse} (rather
	 * than calling a {@link Autolinker.matcher.Matcher} directly), then this
	 * offset is corrected after the Matcher itself has done its job.
	 *
	 * @param {Number} offset
	 */ setOffset: function(offset) {
            this.offset = offset;
        },
        /**
	 * Returns the offset of where the match was made in the input string. This
	 * is the 0-based index of the match.
	 *
	 * @return {Number}
	 */ getOffset: function() {
            return this.offset;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @abstract
	 * @return {String}
	 */ getAnchorHref: Autolinker.Util.abstractMethod,
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @abstract
	 * @return {String}
	 */ getAnchorText: Autolinker.Util.abstractMethod,
        /**
	 * Builds and returns an {@link Autolinker.HtmlTag} instance based on the
	 * Match.
	 *
	 * This can be used to easily generate anchor tags from matches, and either
	 * return their HTML string, or modify them before doing so.
	 *
	 * Example Usage:
	 *
	 *     var tag = match.buildTag();
	 *     tag.addClass( 'cordova-link' );
	 *     tag.setAttr( 'target', '_system' );
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="cordova-link" target="_system">Google</a>
	 */ buildTag: function() {
            return this.tagBuilder.build(this);
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.match.Email
 * @extends Autolinker.match.Match
 *
 * Represents a Email match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */ Autolinker.match.Email = Autolinker.Util.extend(Autolinker.match.Match, {
        /**
	 * @cfg {String} email (required)
	 *
	 * The email address that was matched.
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.match.Match.prototype.constructor.call(this, cfg);
            if (!cfg.email) throw new Error('`email` cfg required');
            this.email = cfg.email;
        },
        /**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return 'email';
        },
        /**
	 * Returns the email address that was matched.
	 *
	 * @return {String}
	 */ getEmail: function() {
            return this.email;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorHref: function() {
            return 'mailto:' + this.email;
        },
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorText: function() {
            return this.email;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.match.Hashtag
 * @extends Autolinker.match.Match
 *
 * Represents a Hashtag match found in an input string which should be
 * Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more
 * details.
 */ Autolinker.match.Hashtag = Autolinker.Util.extend(Autolinker.match.Match, {
        /**
	 * @cfg {String} serviceName
	 *
	 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
	 * for available values.
	 */ /**
	 * @cfg {String} hashtag (required)
	 *
	 * The Hashtag that was matched, without the '#'.
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.match.Match.prototype.constructor.call(this, cfg);
            // TODO: if( !serviceName ) throw new Error( '`serviceName` cfg required' );
            if (!cfg.hashtag) throw new Error('`hashtag` cfg required');
            this.serviceName = cfg.serviceName;
            this.hashtag = cfg.hashtag;
        },
        /**
	 * Returns the type of match that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return 'hashtag';
        },
        /**
	 * Returns the configured {@link #serviceName} to point the Hashtag to.
	 * Ex: 'facebook', 'twitter'.
	 *
	 * @return {String}
	 */ getServiceName: function() {
            return this.serviceName;
        },
        /**
	 * Returns the matched hashtag, without the '#' character.
	 *
	 * @return {String}
	 */ getHashtag: function() {
            return this.hashtag;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorHref: function() {
            var serviceName = this.serviceName, hashtag = this.hashtag;
            switch(serviceName){
                case 'twitter':
                    return 'https://twitter.com/hashtag/' + hashtag;
                case 'facebook':
                    return 'https://www.facebook.com/hashtag/' + hashtag;
                case 'instagram':
                    return 'https://instagram.com/explore/tags/' + hashtag;
                default:
                    throw new Error('Unknown service name to point hashtag to: ', serviceName);
            }
        },
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorText: function() {
            return '#' + this.hashtag;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.match.Phone
 * @extends Autolinker.match.Match
 *
 * Represents a Phone number match found in an input string which should be
 * Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more
 * details.
 */ Autolinker.match.Phone = Autolinker.Util.extend(Autolinker.match.Match, {
        /**
	 * @protected
	 * @property {String} number (required)
	 *
	 * The phone number that was matched, without any delimiter characters.
	 *
	 * Note: This is a string to allow for prefixed 0's.
	 */ /**
	 * @protected
	 * @property  {Boolean} plusSign (required)
	 *
	 * `true` if the matched phone number started with a '+' sign. We'll include
	 * it in the `tel:` URL if so, as this is needed for international numbers.
	 *
	 * Ex: '+1 (123) 456 7879'
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.match.Match.prototype.constructor.call(this, cfg);
            if (!cfg.number) throw new Error('`number` cfg required');
            if (cfg.plusSign == null) throw new Error('`plusSign` cfg required');
            this.number = cfg.number;
            this.plusSign = cfg.plusSign;
        },
        /**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return 'phone';
        },
        /**
	 * Returns the phone number that was matched as a string, without any
	 * delimiter characters.
	 *
	 * Note: This is a string to allow for prefixed 0's.
	 *
	 * @return {String}
	 */ getNumber: function() {
            return this.number;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorHref: function() {
            return 'tel:' + (this.plusSign ? '+' : '') + this.number;
        },
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorText: function() {
            return this.matchedText;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.match.Twitter
 * @extends Autolinker.match.Match
 *
 * Represents a Twitter match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */ Autolinker.match.Twitter = Autolinker.Util.extend(Autolinker.match.Match, {
        /**
	 * @cfg {String} twitterHandle (required)
	 *
	 * The Twitter handle that was matched, without the '@' character.
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.match.Match.prototype.constructor.call(this, cfg);
            if (!cfg.twitterHandle) throw new Error('`twitterHandle` cfg required');
            this.twitterHandle = cfg.twitterHandle;
        },
        /**
	 * Returns the type of match that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return 'twitter';
        },
        /**
	 * Returns the twitter handle, without the '@' character.
	 *
	 * @return {String}
	 */ getTwitterHandle: function() {
            return this.twitterHandle;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorHref: function() {
            return 'https://twitter.com/' + this.twitterHandle;
        },
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorText: function() {
            return '@' + this.twitterHandle;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.match.Url
 * @extends Autolinker.match.Match
 *
 * Represents a Url match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */ Autolinker.match.Url = Autolinker.Util.extend(Autolinker.match.Match, {
        /**
	 * @cfg {String} url (required)
	 *
	 * The url that was matched.
	 */ /**
	 * @cfg {"scheme"/"www"/"tld"} urlMatchType (required)
	 *
	 * The type of URL match that this class represents. This helps to determine
	 * if the match was made in the original text with a prefixed scheme (ex:
	 * 'http://www.google.com'), a prefixed 'www' (ex: 'www.google.com'), or
	 * was matched by a known top-level domain (ex: 'google.com').
	 */ /**
	 * @cfg {Boolean} protocolUrlMatch (required)
	 *
	 * `true` if the URL is a match which already has a protocol (i.e.
	 * 'http://'), `false` if the match was from a 'www' or known TLD match.
	 */ /**
	 * @cfg {Boolean} protocolRelativeMatch (required)
	 *
	 * `true` if the URL is a protocol-relative match. A protocol-relative match
	 * is a URL that starts with '//', and will be either http:// or https://
	 * based on the protocol that the site is loaded under.
	 */ /**
	 * @cfg {Boolean} stripPrefix (required)
	 * @inheritdoc Autolinker#cfg-stripPrefix
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.match.Match.prototype.constructor.call(this, cfg);
            if (cfg.urlMatchType !== 'scheme' && cfg.urlMatchType !== 'www' && cfg.urlMatchType !== 'tld') throw new Error('`urlMatchType` cfg must be one of: "scheme", "www", or "tld"');
            if (!cfg.url) throw new Error('`url` cfg required');
            if (cfg.protocolUrlMatch == null) throw new Error('`protocolUrlMatch` cfg required');
            if (cfg.protocolRelativeMatch == null) throw new Error('`protocolRelativeMatch` cfg required');
            if (cfg.stripPrefix == null) throw new Error('`stripPrefix` cfg required');
            this.urlMatchType = cfg.urlMatchType;
            this.url = cfg.url;
            this.protocolUrlMatch = cfg.protocolUrlMatch;
            this.protocolRelativeMatch = cfg.protocolRelativeMatch;
            this.stripPrefix = cfg.stripPrefix;
        },
        /**
	 * @private
	 * @property {RegExp} urlPrefixRegex
	 *
	 * A regular expression used to remove the 'http://' or 'https://' and/or the 'www.' from URLs.
	 */ urlPrefixRegex: /^(https?:\/\/)?(www\.)?/i,
        /**
	 * @private
	 * @property {RegExp} protocolRelativeRegex
	 *
	 * The regular expression used to remove the protocol-relative '//' from the {@link #url} string, for purposes
	 * of {@link #getAnchorText}. A protocol-relative URL is, for example, "//yahoo.com"
	 */ protocolRelativeRegex: /^\/\//,
        /**
	 * @private
	 * @property {Boolean} protocolPrepended
	 *
	 * Will be set to `true` if the 'http://' protocol has been prepended to the {@link #url} (because the
	 * {@link #url} did not have a protocol)
	 */ protocolPrepended: false,
        /**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return 'url';
        },
        /**
	 * Returns a string name for the type of URL match that this class
	 * represents.
	 *
	 * This helps to determine if the match was made in the original text with a
	 * prefixed scheme (ex: 'http://www.google.com'), a prefixed 'www' (ex:
	 * 'www.google.com'), or was matched by a known top-level domain (ex:
	 * 'google.com').
	 *
	 * @return {"scheme"/"www"/"tld"}
	 */ getUrlMatchType: function() {
            return this.urlMatchType;
        },
        /**
	 * Returns the url that was matched, assuming the protocol to be 'http://' if the original
	 * match was missing a protocol.
	 *
	 * @return {String}
	 */ getUrl: function() {
            var url = this.url;
            // if the url string doesn't begin with a protocol, assume 'http://'
            if (!this.protocolRelativeMatch && !this.protocolUrlMatch && !this.protocolPrepended) {
                url = this.url = 'http://' + url;
                this.protocolPrepended = true;
            }
            return url;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorHref: function() {
            var url = this.getUrl();
            return url.replace(/&amp;/g, '&'); // any &amp;'s in the URL should be converted back to '&' if they were displayed as &amp; in the source html
        },
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorText: function() {
            var anchorText = this.getMatchedText();
            if (this.protocolRelativeMatch) // Strip off any protocol-relative '//' from the anchor text
            anchorText = this.stripProtocolRelativePrefix(anchorText);
            if (this.stripPrefix) anchorText = this.stripUrlPrefix(anchorText);
            anchorText = this.removeTrailingSlash(anchorText); // remove trailing slash, if there is one
            return anchorText;
        },
        // ---------------------------------------
        // Utility Functionality
        /**
	 * Strips the URL prefix (such as "http://" or "https://") from the given text.
	 *
	 * @private
	 * @param {String} text The text of the anchor that is being generated, for which to strip off the
	 *   url prefix (such as stripping off "http://")
	 * @return {String} The `anchorText`, with the prefix stripped.
	 */ stripUrlPrefix: function(text) {
            return text.replace(this.urlPrefixRegex, '');
        },
        /**
	 * Strips any protocol-relative '//' from the anchor text.
	 *
	 * @private
	 * @param {String} text The text of the anchor that is being generated, for which to strip off the
	 *   protocol-relative prefix (such as stripping off "//")
	 * @return {String} The `anchorText`, with the protocol-relative prefix stripped.
	 */ stripProtocolRelativePrefix: function(text) {
            return text.replace(this.protocolRelativeRegex, '');
        },
        /**
	 * Removes any trailing slash from the given `anchorText`, in preparation for the text to be displayed.
	 *
	 * @private
	 * @param {String} anchorText The text of the anchor that is being generated, for which to remove any trailing
	 *   slash ('/') that may exist.
	 * @return {String} The `anchorText`, with the trailing slash removed.
	 */ removeTrailingSlash: function(anchorText) {
            if (anchorText.charAt(anchorText.length - 1) === '/') anchorText = anchorText.slice(0, -1);
            return anchorText;
        }
    });
    /*global Autolinker */ /**
 * @abstract
 * @class Autolinker.matcher.Matcher
 *
 * An abstract class and interface for individual matchers to find matches in
 * an input string with linkified versions of them.
 *
 * Note that Matchers do not take HTML into account - they must be fed the text
 * nodes of any HTML string, which is handled by {@link Autolinker#parse}.
 */ Autolinker.matcher.Matcher = Autolinker.Util.extend(Object, {
        /**
	 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
	 *
	 * Reference to the AnchorTagBuilder instance to use to generate HTML tags
	 * for {@link Autolinker.match.Match Matches}.
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Matcher
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            if (!cfg.tagBuilder) throw new Error('`tagBuilder` cfg required');
            this.tagBuilder = cfg.tagBuilder;
        },
        /**
	 * Parses the input `text` and returns the array of {@link Autolinker.match.Match Matches}
	 * for the matcher.
	 *
	 * @abstract
	 * @param {String} text The text to scan and replace matches in.
	 * @return {Autolinker.match.Match[]}
	 */ parseMatches: Autolinker.Util.abstractMethod
    });
    /*global Autolinker */ /**
 * @class Autolinker.matcher.Email
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find email matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
 */ Autolinker.matcher.Email = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
        /**
	 * The regular expression to match email addresses. Example match:
	 *
	 *     person@place.com
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */ matcherRegex: function() {
            var alphaNumericChars = Autolinker.RegexLib.alphaNumericCharsStr, emailRegex = new RegExp('[' + alphaNumericChars + '\\-_\';:&=+$.,]+@'), domainNameRegex = Autolinker.RegexLib.domainNameRegex, tldRegex = Autolinker.RegexLib.tldRegex; // match our known top level domains (TLDs)
            return new RegExp([
                emailRegex.source,
                domainNameRegex.source,
                '\\.',
                tldRegex.source // '.com', '.net', etc
            ].join(""), 'gi');
        }(),
        /**
	 * @inheritdoc
	 */ parseMatches: function(text) {
            var matcherRegex = this.matcherRegex, tagBuilder = this.tagBuilder, matches = [], match;
            while((match = matcherRegex.exec(text)) !== null){
                var matchedText = match[0];
                matches.push(new Autolinker.match.Email({
                    tagBuilder: tagBuilder,
                    matchedText: matchedText,
                    offset: match.index,
                    email: matchedText
                }));
            }
            return matches;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.matcher.Hashtag
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find Hashtag matches in an input string.
 */ Autolinker.matcher.Hashtag = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
        /**
	 * @cfg {String} serviceName
	 *
	 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
	 * for available values.
	 */ /**
	 * The regular expression to match Hashtags. Example match:
	 *
	 *     #asdf
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */ matcherRegex: new RegExp('#[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,139}', 'g'),
        /**
	 * The regular expression to use to check the character before a username match to
	 * make sure we didn't accidentally match an email address.
	 *
	 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
	 *
	 * @private
	 * @property {RegExp} nonWordCharRegex
	 */ nonWordCharRegex: new RegExp('[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']'),
        /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 *   specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.matcher.Matcher.prototype.constructor.call(this, cfg);
            this.serviceName = cfg.serviceName;
        },
        /**
	 * @inheritdoc
	 */ parseMatches: function(text) {
            var matcherRegex = this.matcherRegex, nonWordCharRegex = this.nonWordCharRegex, serviceName = this.serviceName, tagBuilder = this.tagBuilder, matches = [], match;
            while((match = matcherRegex.exec(text)) !== null){
                var offset = match.index, prevChar = text.charAt(offset - 1);
                // If we found the match at the beginning of the string, or we found the match
                // and there is a whitespace char in front of it (meaning it is not a '#' char
                // in the middle of a word), then it is a hashtag match.
                if (offset === 0 || nonWordCharRegex.test(prevChar)) {
                    var matchedText = match[0], hashtag = match[0].slice(1); // strip off the '#' character at the beginning
                    matches.push(new Autolinker.match.Hashtag({
                        tagBuilder: tagBuilder,
                        matchedText: matchedText,
                        offset: offset,
                        serviceName: serviceName,
                        hashtag: hashtag
                    }));
                }
            }
            return matches;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.matcher.Phone
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find Phone number matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more
 * details.
 */ Autolinker.matcher.Phone = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
        /**
	 * The regular expression to match Phone numbers. Example match:
	 *
	 *     (123) 456-7890
	 *
	 * This regular expression has the following capturing groups:
	 *
	 * 1. The prefixed '+' sign, if there is one.
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */ matcherRegex: /(?:(\+)?\d{1,3}[-\040.])?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]\d{4}/g,
        /**
	 * @inheritdoc
	 */ parseMatches: function(text) {
            var matcherRegex = this.matcherRegex, tagBuilder = this.tagBuilder, matches = [], match;
            while((match = matcherRegex.exec(text)) !== null){
                // Remove non-numeric values from phone number string
                var matchedText = match[0], cleanNumber = matchedText.replace(/\D/g, ''), plusSign = !!match[1]; // match[ 1 ] is the prefixed plus sign, if there is one
                matches.push(new Autolinker.match.Phone({
                    tagBuilder: tagBuilder,
                    matchedText: matchedText,
                    offset: match.index,
                    number: cleanNumber,
                    plusSign: plusSign
                }));
            }
            return matches;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.matcher.Twitter
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find/replace username matches in an input string.
 */ Autolinker.matcher.Twitter = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
        /**
	 * The regular expression to match username handles. Example match:
	 *
	 *     @asdf
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */ matcherRegex: new RegExp('@[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,20}', 'g'),
        /**
	 * The regular expression to use to check the character before a username match to
	 * make sure we didn't accidentally match an email address.
	 *
	 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
	 *
	 * @private
	 * @property {RegExp} nonWordCharRegex
	 */ nonWordCharRegex: new RegExp('[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']'),
        /**
	 * @inheritdoc
	 */ parseMatches: function(text) {
            var matcherRegex = this.matcherRegex, nonWordCharRegex = this.nonWordCharRegex, tagBuilder = this.tagBuilder, matches = [], match;
            while((match = matcherRegex.exec(text)) !== null){
                var offset = match.index, prevChar = text.charAt(offset - 1);
                // If we found the match at the beginning of the string, or we found the match
                // and there is a whitespace char in front of it (meaning it is not an email
                // address), then it is a username match.
                if (offset === 0 || nonWordCharRegex.test(prevChar)) {
                    var matchedText = match[0], twitterHandle = match[0].slice(1); // strip off the '@' character at the beginning
                    matches.push(new Autolinker.match.Twitter({
                        tagBuilder: tagBuilder,
                        matchedText: matchedText,
                        offset: offset,
                        twitterHandle: twitterHandle
                    }));
                }
            }
            return matches;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.matcher.Url
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find URL matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
 */ Autolinker.matcher.Url = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
        /**
	 * @cfg {Boolean} stripPrefix (required)
	 * @inheritdoc Autolinker#stripPrefix
	 */ /**
	 * @private
	 * @property {RegExp} matcherRegex
	 *
	 * The regular expression to match URLs with an optional scheme, port
	 * number, path, query string, and hash anchor.
	 *
	 * Example matches:
	 *
	 *     http://google.com
	 *     www.google.com
	 *     google.com/path/to/file?q1=1&q2=2#myAnchor
	 *
	 *
	 * This regular expression will have the following capturing groups:
	 *
	 * 1.  Group that matches a scheme-prefixed URL (i.e. 'http://google.com').
	 *     This is used to match scheme URLs with just a single word, such as
	 *     'http://localhost', where we won't double check that the domain name
	 *     has at least one dot ('.') in it.
	 * 2.  Group that matches a 'www.' prefixed URL. This is only matched if the
	 *     'www.' text was not prefixed by a scheme (i.e.: not prefixed by
	 *     'http://', 'ftp:', etc.)
	 * 3.  A protocol-relative ('//') match for the case of a 'www.' prefixed
	 *     URL. Will be an empty string if it is not a protocol-relative match.
	 *     We need to know the character before the '//' in order to determine
	 *     if it is a valid match or the // was in a string we don't want to
	 *     auto-link.
	 * 4.  Group that matches a known TLD (top level domain), when a scheme
	 *     or 'www.'-prefixed domain is not matched.
	 * 5.  A protocol-relative ('//') match for the case of a known TLD prefixed
	 *     URL. Will be an empty string if it is not a protocol-relative match.
	 *     See #3 for more info.
	 */ matcherRegex: function() {
            var schemeRegex = /(?:[A-Za-z][-.+A-Za-z0-9]*:(?![A-Za-z][-.+A-Za-z0-9]*:\/\/)(?!\d+\/?)(?:\/\/)?)/, wwwRegex = /(?:www\.)/, domainNameRegex = Autolinker.RegexLib.domainNameRegex, tldRegex = Autolinker.RegexLib.tldRegex, alphaNumericCharsStr = Autolinker.RegexLib.alphaNumericCharsStr, // Allow optional path, query string, and hash anchor, not ending in the following characters: "?!:,.;"
            // http://blog.codinghorror.com/the-problem-with-urls/
            urlSuffixRegex = new RegExp('[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]?!:,.;]*[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]]');
            return new RegExp([
                '(?:',
                '(',
                schemeRegex.source,
                domainNameRegex.source,
                ')',
                '|',
                '(',
                '(//)?',
                wwwRegex.source,
                domainNameRegex.source,
                ')',
                '|',
                '(',
                '(//)?',
                domainNameRegex.source + '\\.',
                tldRegex.source,
                ')',
                ')',
                '(?:' + urlSuffixRegex.source + ')?' // match for path, query string, and/or hash anchor - optional
            ].join(""), 'gi');
        }(),
        /**
	 * A regular expression to use to check the character before a protocol-relative
	 * URL match. We don't want to match a protocol-relative URL if it is part
	 * of another word.
	 *
	 * For example, we want to match something like "Go to: //google.com",
	 * but we don't want to match something like "abc//google.com"
	 *
	 * This regular expression is used to test the character before the '//'.
	 *
	 * @private
	 * @type {RegExp} wordCharRegExp
	 */ wordCharRegExp: /\w/,
        /**
	 * The regular expression to match opening parenthesis in a URL match.
	 *
	 * This is to determine if we have unbalanced parenthesis in the URL, and to
	 * drop the final parenthesis that was matched if so.
	 *
	 * Ex: The text "(check out: wikipedia.com/something_(disambiguation))"
	 * should only autolink the inner "wikipedia.com/something_(disambiguation)"
	 * part, so if we find that we have unbalanced parenthesis, we will drop the
	 * last one for the match.
	 *
	 * @private
	 * @property {RegExp}
	 */ openParensRe: /\(/g,
        /**
	 * The regular expression to match closing parenthesis in a URL match. See
	 * {@link #openParensRe} for more information.
	 *
	 * @private
	 * @property {RegExp}
	 */ closeParensRe: /\)/g,
        /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 *   specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.matcher.Matcher.prototype.constructor.call(this, cfg);
            this.stripPrefix = cfg.stripPrefix;
            if (this.stripPrefix == null) throw new Error('`stripPrefix` cfg required');
        },
        /**
	 * @inheritdoc
	 */ parseMatches: function(text) {
            var matcherRegex = this.matcherRegex, stripPrefix = this.stripPrefix, tagBuilder = this.tagBuilder, matches = [], match;
            while((match = matcherRegex.exec(text)) !== null){
                var matchStr = match[0], schemeUrlMatch = match[1], wwwUrlMatch = match[2], wwwProtocolRelativeMatch = match[3], //tldUrlMatch = match[ 4 ],  -- not needed at the moment
                tldProtocolRelativeMatch = match[5], offset = match.index, protocolRelativeMatch = wwwProtocolRelativeMatch || tldProtocolRelativeMatch, prevChar = text.charAt(offset - 1);
                if (!Autolinker.matcher.UrlMatchValidator.isValid(matchStr, schemeUrlMatch)) continue;
                // If the match is preceded by an '@' character, then it is either
                // an email address or a username. Skip these types of matches.
                if (offset > 0 && prevChar === '@') continue;
                // If it's a protocol-relative '//' match, but the character before the '//'
                // was a word character (i.e. a letter/number), then we found the '//' in the
                // middle of another word (such as "asdf//asdf.com"). In this case, skip the
                // match.
                if (offset > 0 && protocolRelativeMatch && this.wordCharRegExp.test(prevChar)) continue;
                // Handle a closing parenthesis at the end of the match, and exclude
                // it if there is not a matching open parenthesis in the match
                // itself.
                if (this.matchHasUnbalancedClosingParen(matchStr)) matchStr = matchStr.substr(0, matchStr.length - 1); // remove the trailing ")"
                else {
                    // Handle an invalid character after the TLD
                    var pos = this.matchHasInvalidCharAfterTld(matchStr, schemeUrlMatch);
                    if (pos > -1) matchStr = matchStr.substr(0, pos); // remove the trailing invalid chars
                }
                var urlMatchType = schemeUrlMatch ? 'scheme' : wwwUrlMatch ? 'www' : 'tld', protocolUrlMatch = !!schemeUrlMatch;
                matches.push(new Autolinker.match.Url({
                    tagBuilder: tagBuilder,
                    matchedText: matchStr,
                    offset: offset,
                    urlMatchType: urlMatchType,
                    url: matchStr,
                    protocolUrlMatch: protocolUrlMatch,
                    protocolRelativeMatch: !!protocolRelativeMatch,
                    stripPrefix: stripPrefix
                }));
            }
            return matches;
        },
        /**
	 * Determines if a match found has an unmatched closing parenthesis. If so,
	 * this parenthesis will be removed from the match itself, and appended
	 * after the generated anchor tag.
	 *
	 * A match may have an extra closing parenthesis at the end of the match
	 * because the regular expression must include parenthesis for URLs such as
	 * "wikipedia.com/something_(disambiguation)", which should be auto-linked.
	 *
	 * However, an extra parenthesis *will* be included when the URL itself is
	 * wrapped in parenthesis, such as in the case of "(wikipedia.com/something_(disambiguation))".
	 * In this case, the last closing parenthesis should *not* be part of the
	 * URL itself, and this method will return `true`.
	 *
	 * @private
	 * @param {String} matchStr The full match string from the {@link #matcherRegex}.
	 * @return {Boolean} `true` if there is an unbalanced closing parenthesis at
	 *   the end of the `matchStr`, `false` otherwise.
	 */ matchHasUnbalancedClosingParen: function(matchStr) {
            var lastChar = matchStr.charAt(matchStr.length - 1);
            if (lastChar === ')') {
                var openParensMatch = matchStr.match(this.openParensRe), closeParensMatch = matchStr.match(this.closeParensRe), numOpenParens = openParensMatch && openParensMatch.length || 0, numCloseParens = closeParensMatch && closeParensMatch.length || 0;
                if (numOpenParens < numCloseParens) return true;
            }
            return false;
        },
        /**
	 * Determine if there's an invalid character after the TLD in a URL. Valid
	 * characters after TLD are ':/?#'. Exclude scheme matched URLs from this
	 * check.
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} schemeUrlMatch The match URL string for a scheme
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Number} the position where the invalid character was found. If
	 *   no such character was found, returns -1
	 */ matchHasInvalidCharAfterTld: function(urlMatch, schemeUrlMatch) {
            if (!urlMatch) return -1;
            var offset = 0;
            if (schemeUrlMatch) {
                offset = urlMatch.indexOf(':');
                urlMatch = urlMatch.slice(offset);
            }
            var re = /^((.?\/\/)?[A-Za-z0-9\u00C0-\u017F\.\-]*[A-Za-z0-9\u00C0-\u017F\-]\.[A-Za-z]+)/;
            var res = re.exec(urlMatch);
            if (res === null) return -1;
            offset += res[1].length;
            urlMatch = urlMatch.slice(res[1].length);
            if (/^[^.A-Za-z:\/?#]/.test(urlMatch)) return offset;
            return -1;
        }
    });
    /*global Autolinker */ /*jshint scripturl:true */ /**
 * @private
 * @class Autolinker.matcher.UrlMatchValidator
 * @singleton
 *
 * Used by Autolinker to filter out false URL positives from the
 * {@link Autolinker.matcher.Url UrlMatcher}.
 *
 * Due to the limitations of regular expressions (including the missing feature
 * of look-behinds in JS regular expressions), we cannot always determine the
 * validity of a given match. This class applies a bit of additional logic to
 * filter out any false positives that have been matched by the
 * {@link Autolinker.matcher.Url UrlMatcher}.
 */ Autolinker.matcher.UrlMatchValidator = {
        /**
	 * Regex to test for a full protocol, with the two trailing slashes. Ex: 'http://'
	 *
	 * @private
	 * @property {RegExp} hasFullProtocolRegex
	 */ hasFullProtocolRegex: /^[A-Za-z][-.+A-Za-z0-9]*:\/\//,
        /**
	 * Regex to find the URI scheme, such as 'mailto:'.
	 *
	 * This is used to filter out 'javascript:' and 'vbscript:' schemes.
	 *
	 * @private
	 * @property {RegExp} uriSchemeRegex
	 */ uriSchemeRegex: /^[A-Za-z][-.+A-Za-z0-9]*:/,
        /**
	 * Regex to determine if at least one word char exists after the protocol (i.e. after the ':')
	 *
	 * @private
	 * @property {RegExp} hasWordCharAfterProtocolRegex
	 */ hasWordCharAfterProtocolRegex: /:[^\s]*?[A-Za-z\u00C0-\u017F]/,
        /**
	 * Regex to determine if the string is a valid IP address
	 *
	 * @private
	 * @property {RegExp} ipRegex
	 */ ipRegex: /[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?(:[0-9]*)?\/?$/,
        /**
	 * Determines if a given URL match found by the {@link Autolinker.matcher.Url UrlMatcher}
	 * is valid. Will return `false` for:
	 *
	 * 1) URL matches which do not have at least have one period ('.') in the
	 *    domain name (effectively skipping over matches like "abc:def").
	 *    However, URL matches with a protocol will be allowed (ex: 'http://localhost')
	 * 2) URL matches which do not have at least one word character in the
	 *    domain name (effectively skipping over matches like "git:1.0").
	 * 3) A protocol-relative url match (a URL beginning with '//') whose
	 *    previous character is a word character (effectively skipping over
	 *    strings like "abc//google.com")
	 *
	 * Otherwise, returns `true`.
	 *
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Boolean} `true` if the match given is valid and should be
	 *   processed, or `false` if the match is invalid and/or should just not be
	 *   processed.
	 */ isValid: function(urlMatch, protocolUrlMatch) {
            if (protocolUrlMatch && !this.isValidUriScheme(protocolUrlMatch) || this.urlMatchDoesNotHaveProtocolOrDot(urlMatch, protocolUrlMatch) || // At least one period ('.') must exist in the URL match for us to consider it an actual URL, *unless* it was a full protocol match (like 'http://localhost')
            this.urlMatchDoesNotHaveAtLeastOneWordChar(urlMatch, protocolUrlMatch) && // At least one letter character must exist in the domain name after a protocol match. Ex: skip over something like "git:1.0"
            !this.isValidIpAddress(urlMatch) // Except if it's an IP address
            ) return false;
            return true;
        },
        isValidIpAddress: function(uriSchemeMatch) {
            var newRegex = new RegExp(this.hasFullProtocolRegex.source + this.ipRegex.source);
            var uriScheme = uriSchemeMatch.match(newRegex);
            return uriScheme !== null;
        },
        /**
	 * Determines if the URI scheme is a valid scheme to be autolinked. Returns
	 * `false` if the scheme is 'javascript:' or 'vbscript:'
	 *
	 * @private
	 * @param {String} uriSchemeMatch The match URL string for a full URI scheme
	 *   match. Ex: 'http://yahoo.com' or 'mailto:a@a.com'.
	 * @return {Boolean} `true` if the scheme is a valid one, `false` otherwise.
	 */ isValidUriScheme: function(uriSchemeMatch) {
            var uriScheme = uriSchemeMatch.match(this.uriSchemeRegex)[0].toLowerCase();
            return uriScheme !== 'javascript:' && uriScheme !== 'vbscript:';
        },
        /**
	 * Determines if a URL match does not have either:
	 *
	 * a) a full protocol (i.e. 'http://'), or
	 * b) at least one dot ('.') in the domain name (for a non-full-protocol
	 *    match).
	 *
	 * Either situation is considered an invalid URL (ex: 'git:d' does not have
	 * either the '://' part, or at least one dot in the domain name. If the
	 * match was 'git:abc.com', we would consider this valid.)
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Boolean} `true` if the URL match does not have a full protocol,
	 *   or at least one dot ('.') in a non-full-protocol match.
	 */ urlMatchDoesNotHaveProtocolOrDot: function(urlMatch, protocolUrlMatch) {
            return !!urlMatch && (!protocolUrlMatch || !this.hasFullProtocolRegex.test(protocolUrlMatch)) && urlMatch.indexOf('.') === -1;
        },
        /**
	 * Determines if a URL match does not have at least one word character after
	 * the protocol (i.e. in the domain name).
	 *
	 * At least one letter character must exist in the domain name after a
	 * protocol match. Ex: skip over something like "git:1.0"
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to know whether or not we
	 *   have a protocol in the URL string, in order to check for a word
	 *   character after the protocol separator (':').
	 * @return {Boolean} `true` if the URL match does not have at least one word
	 *   character in it after the protocol, `false` otherwise.
	 */ urlMatchDoesNotHaveAtLeastOneWordChar: function(urlMatch, protocolUrlMatch) {
            if (urlMatch && protocolUrlMatch) return !this.hasWordCharAfterProtocolRegex.test(urlMatch);
            else return false;
        }
    };
    /*global Autolinker */ /**
 * A truncation feature where the ellipsis will be placed at the end of the URL.
 *
 * @param {String} anchorText
 * @param {Number} truncateLen The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */ Autolinker.truncate.TruncateEnd = function(anchorText, truncateLen, ellipsisChars) {
        return Autolinker.Util.ellipsis(anchorText, truncateLen, ellipsisChars);
    };
    /*global Autolinker */ /**
 * Date: 2015-10-05
 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
 *
 * A truncation feature, where the ellipsis will be placed in the dead-center of the URL.
 *
 * @param {String} url             A URL.
 * @param {Number} truncateLen     The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars   The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */ Autolinker.truncate.TruncateMiddle = function(url, truncateLen, ellipsisChars) {
        if (url.length <= truncateLen) return url;
        var availableLength = truncateLen - ellipsisChars.length;
        var end = "";
        if (availableLength > 0) end = url.substr(-1 * Math.floor(availableLength / 2));
        return (url.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, truncateLen);
    };
    /*global Autolinker */ /**
 * Date: 2015-10-05
 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
 *
 * A truncation feature, where the ellipsis will be placed at a section within
 * the URL making it still somewhat human readable.
 *
 * @param {String} url						 A URL.
 * @param {Number} truncateLen		 The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars	 The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */ Autolinker.truncate.TruncateSmart = function(url, truncateLen, ellipsisChars) {
        var parse_url = function(url) {
            var urlObj = {};
            var urlSub = url;
            var match = urlSub.match(/^([a-z]+):\/\//i);
            if (match) {
                urlObj.scheme = match[1];
                urlSub = urlSub.substr(match[0].length);
            }
            match = urlSub.match(/^(.*?)(?=(\?|#|\/|$))/i);
            if (match) {
                urlObj.host = match[1];
                urlSub = urlSub.substr(match[0].length);
            }
            match = urlSub.match(/^\/(.*?)(?=(\?|#|$))/i);
            if (match) {
                urlObj.path = match[1];
                urlSub = urlSub.substr(match[0].length);
            }
            match = urlSub.match(/^\?(.*?)(?=(#|$))/i);
            if (match) {
                urlObj.query = match[1];
                urlSub = urlSub.substr(match[0].length);
            }
            match = urlSub.match(/^#(.*?)$/i);
            if (match) urlObj.fragment = match[1];
            return urlObj;
        };
        var buildUrl = function(urlObj) {
            var url = "";
            if (urlObj.scheme && urlObj.host) url += urlObj.scheme + "://";
            if (urlObj.host) url += urlObj.host;
            if (urlObj.path) url += "/" + urlObj.path;
            if (urlObj.query) url += "?" + urlObj.query;
            if (urlObj.fragment) url += "#" + urlObj.fragment;
            return url;
        };
        var buildSegment = function(segment, remainingAvailableLength) {
            var remainingAvailableLengthHalf = remainingAvailableLength / 2, startOffset = Math.ceil(remainingAvailableLengthHalf), endOffset = -1 * Math.floor(remainingAvailableLengthHalf), end = "";
            if (endOffset < 0) end = segment.substr(endOffset);
            return segment.substr(0, startOffset) + ellipsisChars + end;
        };
        if (url.length <= truncateLen) return url;
        var availableLength = truncateLen - ellipsisChars.length;
        var urlObj = parse_url(url);
        // Clean up the URL
        if (urlObj.query) {
            var matchQuery = urlObj.query.match(/^(.*?)(?=(\?|\#))(.*?)$/i);
            if (matchQuery) {
                // Malformed URL; two or more "?". Removed any content behind the 2nd.
                urlObj.query = urlObj.query.substr(0, matchQuery[1].length);
                url = buildUrl(urlObj);
            }
        }
        if (url.length <= truncateLen) return url;
        if (urlObj.host) {
            urlObj.host = urlObj.host.replace(/^www\./, "");
            url = buildUrl(urlObj);
        }
        if (url.length <= truncateLen) return url;
        // Process and build the URL
        var str = "";
        if (urlObj.host) str += urlObj.host;
        if (str.length >= availableLength) {
            if (urlObj.host.length == truncateLen) return (urlObj.host.substr(0, truncateLen - ellipsisChars.length) + ellipsisChars).substr(0, truncateLen);
            return buildSegment(str, availableLength).substr(0, truncateLen);
        }
        var pathAndQuery = "";
        if (urlObj.path) pathAndQuery += "/" + urlObj.path;
        if (urlObj.query) pathAndQuery += "?" + urlObj.query;
        if (pathAndQuery) {
            if ((str + pathAndQuery).length >= availableLength) {
                if ((str + pathAndQuery).length == truncateLen) return (str + pathAndQuery).substr(0, truncateLen);
                var remainingAvailableLength = availableLength - str.length;
                return (str + buildSegment(pathAndQuery, remainingAvailableLength)).substr(0, truncateLen);
            } else str += pathAndQuery;
        }
        if (urlObj.fragment) {
            var fragment = "#" + urlObj.fragment;
            if ((str + fragment).length >= availableLength) {
                if ((str + fragment).length == truncateLen) return (str + fragment).substr(0, truncateLen);
                var remainingAvailableLength2 = availableLength - str.length;
                return (str + buildSegment(fragment, remainingAvailableLength2)).substr(0, truncateLen);
            } else str += fragment;
        }
        if (urlObj.scheme && urlObj.host) {
            var scheme = urlObj.scheme + "://";
            if ((str + scheme).length < availableLength) return (scheme + str).substr(0, truncateLen);
        }
        if (str.length <= truncateLen) return str;
        var end = "";
        if (availableLength > 0) end = str.substr(-1 * Math.floor(availableLength / 2));
        return (str.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, truncateLen);
    };
    return Autolinker;
});

});



parcelRegister("pE4pY", function(module, exports) {
'use strict';

var $iJCC3 = parcelRequire("iJCC3");

var $ai6Lp = parcelRequire("ai6Lp");












/**
 * Parser rules
 */ var $04d16b084f2465d1$var$_rules = [
    [
        'code',
        (parcelRequire("d9gyC"))
    ],
    [
        'fences',
        (parcelRequire("fgNNv")),
        [
            'paragraph',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("4UZbS")),
        [
            'paragraph',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("5Wm7v")),
        [
            'paragraph',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("2A5d4")),
        [
            'paragraph',
            'blockquote'
        ]
    ],
    [
        'footnote',
        (parcelRequire("99i6i")),
        [
            'paragraph'
        ]
    ],
    [
        'heading',
        (parcelRequire("46TtU")),
        [
            'paragraph',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("2fLYx"))
    ],
    [
        'htmlblock',
        (parcelRequire("a8rqe")),
        [
            'paragraph',
            'blockquote'
        ]
    ],
    [
        'table',
        (parcelRequire("cGIIx")),
        [
            'paragraph'
        ]
    ],
    [
        'deflist',
        (parcelRequire("1VPGO")),
        [
            'paragraph'
        ]
    ],
    [
        'paragraph',
        (parcelRequire("7Y9Xm"))
    ]
];
/**
 * Block Parser class
 *
 * @api private
 */ function $04d16b084f2465d1$var$ParserBlock() {
    this.ruler = new $iJCC3();
    for(var i = 0; i < $04d16b084f2465d1$var$_rules.length; i++)this.ruler.push($04d16b084f2465d1$var$_rules[i][0], $04d16b084f2465d1$var$_rules[i][1], {
        alt: ($04d16b084f2465d1$var$_rules[i][2] || []).slice()
    });
}
/**
 * Generate tokens for the given input range.
 *
 * @param  {Object} `state` Has properties like `src`, `parser`, `options` etc
 * @param  {Number} `startLine`
 * @param  {Number} `endLine`
 * @api private
 */ $04d16b084f2465d1$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var rules = this.ruler.getRules('');
    var len = rules.length;
    var line = startLine;
    var hasEmptyLines = false;
    var ok, i;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.tShift[line] < state.blkIndent) break;
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) break;
        }
        // set state.tight iff we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            // two empty lines should stop the parser in list mode
            if (line < endLine && state.parentType === 'list' && state.isEmpty(line)) break;
            state.line = line;
        }
    }
};
var $04d16b084f2465d1$var$TABS_SCAN_RE = /[\n\t]/g;
var $04d16b084f2465d1$var$NEWLINES_RE = /\r[\n\u0085]|[\u2424\u2028\u0085]/g;
var $04d16b084f2465d1$var$SPACES_RE = /\u00a0/g;
/**
 * Tokenize the given `str`.
 *
 * @param  {String} `str` Source string
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @param  {Array} `outTokens`
 * @api private
 */ $04d16b084f2465d1$var$ParserBlock.prototype.parse = function(str, options, env, outTokens) {
    var state, lineStart = 0, lastTabPos = 0;
    if (!str) return [];
    // Normalize spaces
    str = str.replace($04d16b084f2465d1$var$SPACES_RE, ' ');
    // Normalize newlines
    str = str.replace($04d16b084f2465d1$var$NEWLINES_RE, '\n');
    // Replace tabs with proper number of spaces (1..4)
    if (str.indexOf('\t') >= 0) str = str.replace($04d16b084f2465d1$var$TABS_SCAN_RE, function(match, offset) {
        var result;
        if (str.charCodeAt(offset) === 0x0A) {
            lineStart = offset + 1;
            lastTabPos = 0;
            return match;
        }
        result = '    '.slice((offset - lineStart - lastTabPos) % 4);
        lastTabPos = offset - lineStart + 1;
        return result;
    });
    state = new $ai6Lp(str, this, options, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
/**
 * Expose `ParserBlock`
 */ module.exports = $04d16b084f2465d1$var$ParserBlock;

});
parcelRegister("ai6Lp", function(module, exports) {
// Parser state class
'use strict';
function $77e0d4f338ba63a3$var$StateBlock(src, parser, options, env, tokens) {
    var ch, s, start, pos, len, indent, indent_found;
    this.src = src;
    // Shortcuts to simplify nested calls
    this.parser = parser;
    this.options = options;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // indent for each line
    // block parser variables
    this.blkIndent = 0; // required block content indent
    // (for example, if we are in list)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.parentType = 'root'; // if `list`, block parser stops on two newlines
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent = 0;
    indent_found = false;
    for(start = pos = indent = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if (ch === 0x20 /* space */ ) {
                indent++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            indent_found = false;
            indent = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
$77e0d4f338ba63a3$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$77e0d4f338ba63a3$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$77e0d4f338ba63a3$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== 0x20 /* space */ ) break;
    }
    return pos;
};
// Skip char codes from given position
$77e0d4f338ba63a3$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$77e0d4f338ba63a3$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$77e0d4f338ba63a3$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, first, last, queue, shift, line = begin;
    if (begin >= end) return '';
    // Opt: don't use push queue for single line;
    if (line + 1 === end) {
        first = this.bMarks[line] + Math.min(this.tShift[line], indent);
        last = keepLastLF ? this.eMarks[line] + 1 : this.eMarks[line];
        return this.src.slice(first, last);
    }
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        shift = this.tShift[line];
        if (shift > indent) shift = indent;
        if (shift < 0) shift = 0;
        first = this.bMarks[line] + shift;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
module.exports = $77e0d4f338ba63a3$var$StateBlock;

});

parcelRegister("d9gyC", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last;
    if (state.tShift[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.tShift[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = nextLine;
    state.tokens.push({
        type: 'code',
        content: state.getLines(startLine, last, 4 + state.blkIndent, true),
        block: true,
        lines: [
            startLine,
            state.line
        ],
        level: state.level
    });
    return true;
};

});

parcelRegister("fgNNv", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fences(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    params = state.src.slice(pos, max).trim();
    if (params.indexOf('`') >= 0) return false;
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.tShift[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.tShift[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.tShift[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    state.tokens.push({
        type: 'fence',
        params: params,
        content: state.getLines(startLine + 1, nextLine, len, true),
        lines: [
            startLine,
            state.line
        ],
        level: state.level
    });
    return true;
};

});

parcelRegister("4UZbS", function(module, exports) {
// Block quotes
'use strict';
module.exports = function blockquote(state, startLine, endLine, silent) {
    var nextLine, lastLineEmpty, oldTShift, oldBMarks, oldIndent, oldParentType, lines, terminatorRules, i, l, terminate, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    if (pos > max) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos++) !== 0x3E /* > */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    // skip one optional space after '>'
    if (state.src.charCodeAt(pos) === 0x20) pos++;
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    oldBMarks = [
        state.bMarks[startLine]
    ];
    state.bMarks[startLine] = pos;
    // check if we have an empty blockquote
    pos = pos < max ? state.skipSpaces(pos) : pos;
    lastLineEmpty = pos >= max;
    oldTShift = [
        state.tShift[startLine]
    ];
    state.tShift[startLine] = pos - state.bMarks[startLine];
    terminatorRules = state.parser.ruler.getRules('blockquote');
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine + 1; nextLine < endLine; nextLine++){
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */ ) {
            // This line is inside the blockquote.
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20) pos++;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            pos = pos < max ? state.skipSpaces(pos) : pos;
            lastLineEmpty = pos >= max;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        oldBMarks.push(state.bMarks[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        // A negative number means that this is a paragraph continuation;
        //
        // Any negative number will do the job here, but it's better for it
        // to be large enough to make any bugs obvious.
        state.tShift[nextLine] = -1337;
    }
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    state.tokens.push({
        type: 'blockquote_open',
        lines: lines = [
            startLine,
            0
        ],
        level: state.level++
    });
    state.parser.tokenize(state, startLine, nextLine);
    state.tokens.push({
        type: 'blockquote_close',
        level: --state.level
    });
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("5Wm7v", function(module, exports) {
// Horizontal rule
'use strict';
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, pos = state.bMarks[startLine], max = state.eMarks[startLine];
    pos += state.tShift[startLine];
    if (pos > max) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 one
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && ch !== 0x20 /* space */ ) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    state.tokens.push({
        type: 'hr',
        lines: [
            startLine,
            state.line
        ],
        level: state.level
    });
    return true;
};

});

parcelRegister("2A5d4", function(module, exports) {
// Lists
'use strict';
// Search `[-+*][\n ]`, returns next pos arter marker on success
// or -1 on fail.
function $1e12fc1f4d73081c$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    if (pos >= max) return -1;
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max && state.src.charCodeAt(pos) !== 0x20) // " 1.test " - is not a list item
    return -1;
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos arter marker on success
// or -1 on fail.
function $1e12fc1f4d73081c$var$skipOrderedListMarker(state, startLine) {
    var ch, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) continue;
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max && state.src.charCodeAt(pos) !== 0x20 /* space */ ) // " 1.test " - is not a list item
    return -1;
    return pos;
}
function $1e12fc1f4d73081c$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].tight = true;
        state.tokens[i].tight = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var nextLine, indent, oldTShift, oldIndent, oldTight, oldParentType, start, posAfterMarker, max, indentAfterMarker, markerValue, markerCharCode, isOrdered, contentStart, listTokIdx, prevEmptyEnd, listLines, itemLines, tight = true, terminatorRules, i, l, terminate;
    // Detect list type and position after marker
    if ((posAfterMarker = $1e12fc1f4d73081c$var$skipOrderedListMarker(state, startLine)) >= 0) isOrdered = true;
    else if ((posAfterMarker = $1e12fc1f4d73081c$var$skipBulletListMarker(state, startLine)) >= 0) isOrdered = false;
    else return false;
    if (state.level >= state.options.maxNesting) return false;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // For validation mode we can terminate immediately
    if (silent) return true;
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        start = state.bMarks[startLine] + state.tShift[startLine];
        markerValue = Number(state.src.substr(start, posAfterMarker - start - 1));
        state.tokens.push({
            type: 'ordered_list_open',
            order: markerValue,
            lines: listLines = [
                startLine,
                0
            ],
            level: state.level++
        });
    } else state.tokens.push({
        type: 'bullet_list_open',
        lines: listLines = [
            startLine,
            0
        ],
        level: state.level++
    });
    //
    // Iterate list items
    //
    nextLine = startLine;
    prevEmptyEnd = false;
    terminatorRules = state.parser.ruler.getRules('list');
    while(nextLine < endLine){
        contentStart = state.skipSpaces(posAfterMarker);
        max = state.eMarks[nextLine];
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = contentStart - posAfterMarker;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // If indent is less than 1, assume that it's one, example:
        //  "-\n  test"
        if (indentAfterMarker < 1) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = posAfterMarker - state.bMarks[nextLine] + indentAfterMarker;
        // Run subparser & write tokens
        state.tokens.push({
            type: 'list_item_open',
            lines: itemLines = [
                startLine,
                0
            ],
            level: state.level++
        });
        oldIndent = state.blkIndent;
        oldTight = state.tight;
        oldTShift = state.tShift[startLine];
        oldParentType = state.parentType;
        state.tShift[startLine] = contentStart - state.bMarks[startLine];
        state.blkIndent = indent;
        state.tight = true;
        state.parentType = 'list';
        state.parser.tokenize(state, startLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - startLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = oldIndent;
        state.tShift[startLine] = oldTShift;
        state.tight = oldTight;
        state.parentType = oldParentType;
        state.tokens.push({
            type: 'list_item_close',
            level: --state.level
        });
        nextLine = startLine = state.line;
        itemLines[1] = nextLine;
        contentStart = state.bMarks[startLine];
        if (nextLine >= endLine) break;
        if (state.isEmpty(nextLine)) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.tShift[nextLine] < state.blkIndent) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $1e12fc1f4d73081c$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        } else {
            posAfterMarker = $1e12fc1f4d73081c$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finilize list
    state.tokens.push({
        type: isOrdered ? 'ordered_list_close' : 'bullet_list_close',
        level: --state.level
    });
    listLines[1] = nextLine;
    state.line = nextLine;
    // mark paragraphs tight if needed
    if (tight) $1e12fc1f4d73081c$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("99i6i", function(module, exports) {
// Process footnote reference list
'use strict';
module.exports = function footnote(state, startLine, endLine, silent) {
    var oldBMark, oldTShift, oldParentType, pos, label, start = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // line should be at least 5 chars - "[^x]:"
    if (start + 4 > max) return false;
    if (state.src.charCodeAt(start) !== 0x5B /* [ */ ) return false;
    if (state.src.charCodeAt(start + 1) !== 0x5E /* ^ */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    for(pos = start + 2; pos < max; pos++){
        if (state.src.charCodeAt(pos) === 0x20) return false;
        if (state.src.charCodeAt(pos) === 0x5D /* ] */ ) break;
    }
    if (pos === start + 2) return false;
     // no empty footnote labels
    if (pos + 1 >= max || state.src.charCodeAt(++pos) !== 0x3A /* : */ ) return false;
    if (silent) return true;
    pos++;
    if (!state.env.footnotes) state.env.footnotes = {};
    if (!state.env.footnotes.refs) state.env.footnotes.refs = {};
    label = state.src.slice(start + 2, pos - 2);
    state.env.footnotes.refs[':' + label] = -1;
    state.tokens.push({
        type: 'footnote_reference_open',
        label: label,
        level: state.level++
    });
    oldBMark = state.bMarks[startLine];
    oldTShift = state.tShift[startLine];
    oldParentType = state.parentType;
    state.tShift[startLine] = state.skipSpaces(pos) - pos;
    state.bMarks[startLine] = pos;
    state.blkIndent += 4;
    state.parentType = 'footnote';
    if (state.tShift[startLine] < state.blkIndent) {
        state.tShift[startLine] += state.blkIndent;
        state.bMarks[startLine] -= state.blkIndent;
    }
    state.parser.tokenize(state, startLine, endLine, true);
    state.parentType = oldParentType;
    state.blkIndent -= 4;
    state.tShift[startLine] = oldTShift;
    state.bMarks[startLine] = oldBMark;
    state.tokens.push({
        type: 'footnote_reference_close',
        level: --state.level
    });
    return true;
};

});

parcelRegister("46TtU", function(module, exports) {
// heading (#, ##, ...)
'use strict';
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    if (pos >= max) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && ch !== 0x20 /* space */ ) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipCharsBack(max, 0x20, pos); // space
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && state.src.charCodeAt(tmp - 1) === 0x20 /* space */ ) max = tmp;
    state.line = startLine + 1;
    state.tokens.push({
        type: 'heading_open',
        hLevel: level,
        lines: [
            startLine,
            state.line
        ],
        level: state.level
    });
    // only if header is not empty
    if (pos < max) state.tokens.push({
        type: 'inline',
        content: state.src.slice(pos, max).trim(),
        level: state.level + 1,
        lines: [
            startLine,
            state.line
        ],
        children: []
    });
    state.tokens.push({
        type: 'heading_close',
        hLevel: level,
        level: state.level
    });
    return true;
};

});

parcelRegister("2fLYx", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var marker, pos, max, next = startLine + 1;
    if (next >= endLine) return false;
    if (state.tShift[next] < state.blkIndent) return false;
    // Scan next line
    if (state.tShift[next] - state.blkIndent > 3) return false;
    pos = state.bMarks[next] + state.tShift[next];
    max = state.eMarks[next];
    if (pos >= max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x2D /* - */  && marker !== 0x3D /* = */ ) return false;
    pos = state.skipChars(pos, marker);
    pos = state.skipSpaces(pos);
    if (pos < max) return false;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    state.line = next + 1;
    state.tokens.push({
        type: 'heading_open',
        hLevel: marker === 0x3D /* = */  ? 1 : 2,
        lines: [
            startLine,
            state.line
        ],
        level: state.level
    });
    state.tokens.push({
        type: 'inline',
        content: state.src.slice(pos, state.eMarks[startLine]).trim(),
        level: state.level + 1,
        lines: [
            startLine,
            state.line - 1
        ],
        children: []
    });
    state.tokens.push({
        type: 'heading_close',
        hLevel: marker === 0x3D /* = */  ? 1 : 2,
        level: state.level
    });
    return true;
};

});

parcelRegister("a8rqe", function(module, exports) {
// HTML block
'use strict';

var $2aZUj = parcelRequire("2aZUj");
var $760fec3529f5b660$var$HTML_TAG_OPEN_RE = /^<([a-zA-Z]{1,15})[\s\/>]/;
var $760fec3529f5b660$var$HTML_TAG_CLOSE_RE = /^<\/([a-zA-Z]{1,15})[\s>]/;
function $760fec3529f5b660$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function htmlblock(state, startLine, endLine, silent) {
    var ch, match, nextLine, pos = state.bMarks[startLine], max = state.eMarks[startLine], shift = state.tShift[startLine];
    pos += shift;
    if (!state.options.html) return false;
    if (shift > 3 || pos + 2 >= max) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x21 /* ! */  || ch === 0x3F /* ? */ ) {
        // Directive start / comment start / processing instruction start
        if (silent) return true;
    } else if (ch === 0x2F /* / */  || $760fec3529f5b660$var$isLetter(ch)) {
        // Probably start or end of tag
        if (ch === 0x2F /* \ */ ) {
            // closing tag
            match = state.src.slice(pos, max).match($760fec3529f5b660$var$HTML_TAG_CLOSE_RE);
            if (!match) return false;
        } else {
            // opening tag
            match = state.src.slice(pos, max).match($760fec3529f5b660$var$HTML_TAG_OPEN_RE);
            if (!match) return false;
        }
        // Make sure tag name is valid
        if ($2aZUj[match[1].toLowerCase()] !== true) return false;
        if (silent) return true;
    } else return false;
    // If we are here - we detected HTML block.
    // Let's roll down till empty line (block end).
    nextLine = startLine + 1;
    while(nextLine < state.lineMax && !state.isEmpty(nextLine))nextLine++;
    state.line = nextLine;
    state.tokens.push({
        type: 'htmlblock',
        level: state.level,
        lines: [
            startLine,
            state.line
        ],
        content: state.getLines(startLine, nextLine, 0, true)
    });
    return true;
};

});
parcelRegister("2aZUj", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
var $195c89706de242d3$var$html_blocks = {};
[
    'article',
    'aside',
    'button',
    'blockquote',
    'body',
    'canvas',
    'caption',
    'col',
    'colgroup',
    'dd',
    'div',
    'dl',
    'dt',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hgroup',
    'hr',
    'iframe',
    'li',
    'map',
    'object',
    'ol',
    'output',
    'p',
    'pre',
    'progress',
    'script',
    'section',
    'style',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'tr',
    'thead',
    'ul',
    'video'
].forEach(function(name) {
    $195c89706de242d3$var$html_blocks[name] = true;
});
module.exports = $195c89706de242d3$var$html_blocks;

});


parcelRegister("cGIIx", function(module, exports) {
// GFM table, non-standard
'use strict';
function $93cc18342011c4fc$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, rows, cell, aligns, t, tableLines, tbodyLines;
    // should have at least three lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.tShift[nextLine] < state.blkIndent) return false;
    // first character of the second line should be '|' or '-'
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */ ) return false;
    lineText = $93cc18342011c4fc$var$getLine(state, startLine + 1);
    if (!/^[-:| ]+$/.test(lineText)) return false;
    rows = lineText.split('|');
    if (rows <= 2) return false;
    aligns = [];
    for(i = 0; i < rows.length; i++){
        t = rows[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === rows.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $93cc18342011c4fc$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    rows = lineText.replace(/^\||\|$/g, '').split('|');
    if (aligns.length !== rows.length) return false;
    if (silent) return true;
    state.tokens.push({
        type: 'table_open',
        lines: tableLines = [
            startLine,
            0
        ],
        level: state.level++
    });
    state.tokens.push({
        type: 'thead_open',
        lines: [
            startLine,
            startLine + 1
        ],
        level: state.level++
    });
    state.tokens.push({
        type: 'tr_open',
        lines: [
            startLine,
            startLine + 1
        ],
        level: state.level++
    });
    for(i = 0; i < rows.length; i++){
        state.tokens.push({
            type: 'th_open',
            align: aligns[i],
            lines: [
                startLine,
                startLine + 1
            ],
            level: state.level++
        });
        state.tokens.push({
            type: 'inline',
            content: rows[i].trim(),
            lines: [
                startLine,
                startLine + 1
            ],
            level: state.level,
            children: []
        });
        state.tokens.push({
            type: 'th_close',
            level: --state.level
        });
    }
    state.tokens.push({
        type: 'tr_close',
        level: --state.level
    });
    state.tokens.push({
        type: 'thead_close',
        level: --state.level
    });
    state.tokens.push({
        type: 'tbody_open',
        lines: tbodyLines = [
            startLine + 2,
            0
        ],
        level: state.level++
    });
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.tShift[nextLine] < state.blkIndent) break;
        lineText = $93cc18342011c4fc$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        rows = lineText.replace(/^\||\|$/g, '').split('|');
        state.tokens.push({
            type: 'tr_open',
            level: state.level++
        });
        for(i = 0; i < rows.length; i++){
            state.tokens.push({
                type: 'td_open',
                align: aligns[i],
                level: state.level++
            });
            // 0x7c === '|'
            cell = rows[i].substring(rows[i].charCodeAt(0) === 0x7c ? 1 : 0, rows[i].charCodeAt(rows[i].length - 1) === 0x7c ? rows[i].length - 1 : rows[i].length).trim();
            state.tokens.push({
                type: 'inline',
                content: cell,
                level: state.level,
                children: []
            });
            state.tokens.push({
                type: 'td_close',
                level: --state.level
            });
        }
        state.tokens.push({
            type: 'tr_close',
            level: --state.level
        });
    }
    state.tokens.push({
        type: 'tbody_close',
        level: --state.level
    });
    state.tokens.push({
        type: 'table_close',
        level: --state.level
    });
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});

parcelRegister("1VPGO", function(module, exports) {
// Definition lists
'use strict';
// Search `[:~][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $168335c5d9e2e921$var$skipMarker(state, line) {
    var pos, marker, start = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    if (start >= max) return -1;
    // Check bullet
    marker = state.src.charCodeAt(start++);
    if (marker !== 0x7E /* ~ */  && marker !== 0x3A /* : */ ) return -1;
    pos = state.skipSpaces(start);
    // require space after ":"
    if (start === pos) return -1;
    // no empty definitions, e.g. "  : "
    if (pos >= max) return -1;
    return pos;
}
function $168335c5d9e2e921$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].tight = true;
        state.tokens[i].tight = true;
        i += 2;
    }
}
module.exports = function deflist(state, startLine, endLine, silent) {
    var contentStart, ddLine, dtLine, itemLines, listLines, listTokIdx, nextLine, oldIndent, oldDDIndent, oldParentType, oldTShift, oldTight, prevEmptyEnd, tight;
    if (silent) {
        // quirk: validation mode validates a dd block only, not a whole deflist
        if (state.ddIndent < 0) return false;
        return $168335c5d9e2e921$var$skipMarker(state, startLine) >= 0;
    }
    nextLine = startLine + 1;
    if (state.isEmpty(nextLine)) {
        if (++nextLine > endLine) return false;
    }
    if (state.tShift[nextLine] < state.blkIndent) return false;
    contentStart = $168335c5d9e2e921$var$skipMarker(state, nextLine);
    if (contentStart < 0) return false;
    if (state.level >= state.options.maxNesting) return false;
    // Start list
    listTokIdx = state.tokens.length;
    state.tokens.push({
        type: 'dl_open',
        lines: listLines = [
            startLine,
            0
        ],
        level: state.level++
    });
    //
    // Iterate list items
    //
    dtLine = startLine;
    ddLine = nextLine;
    // One definition list can contain multiple DTs,
    // and one DT can be followed by multiple DDs.
    //
    // Thus, there is two loops here, and label is
    // needed to break out of the second one
    //
    /*eslint no-labels:0,block-scoped-var:0*/ OUTER: for(;;){
        tight = true;
        prevEmptyEnd = false;
        state.tokens.push({
            type: 'dt_open',
            lines: [
                dtLine,
                dtLine
            ],
            level: state.level++
        });
        state.tokens.push({
            type: 'inline',
            content: state.getLines(dtLine, dtLine + 1, state.blkIndent, false).trim(),
            level: state.level + 1,
            lines: [
                dtLine,
                dtLine
            ],
            children: []
        });
        state.tokens.push({
            type: 'dt_close',
            level: --state.level
        });
        for(;;){
            state.tokens.push({
                type: 'dd_open',
                lines: itemLines = [
                    nextLine,
                    0
                ],
                level: state.level++
            });
            oldTight = state.tight;
            oldDDIndent = state.ddIndent;
            oldIndent = state.blkIndent;
            oldTShift = state.tShift[ddLine];
            oldParentType = state.parentType;
            state.blkIndent = state.ddIndent = state.tShift[ddLine] + 2;
            state.tShift[ddLine] = contentStart - state.bMarks[ddLine];
            state.tight = true;
            state.parentType = 'deflist';
            state.parser.tokenize(state, ddLine, endLine, true);
            // If any of list item is tight, mark list as tight
            if (!state.tight || prevEmptyEnd) tight = false;
            // Item become loose if finish with empty line,
            // but we should filter last element, because it means list finish
            prevEmptyEnd = state.line - ddLine > 1 && state.isEmpty(state.line - 1);
            state.tShift[ddLine] = oldTShift;
            state.tight = oldTight;
            state.parentType = oldParentType;
            state.blkIndent = oldIndent;
            state.ddIndent = oldDDIndent;
            state.tokens.push({
                type: 'dd_close',
                level: --state.level
            });
            itemLines[1] = nextLine = state.line;
            if (nextLine >= endLine) break OUTER;
            if (state.tShift[nextLine] < state.blkIndent) break OUTER;
            contentStart = $168335c5d9e2e921$var$skipMarker(state, nextLine);
            if (contentStart < 0) break;
            ddLine = nextLine;
        // go to the next loop iteration:
        // insert DD tag and repeat checking
        }
        if (nextLine >= endLine) break;
        dtLine = nextLine;
        if (state.isEmpty(dtLine)) break;
        if (state.tShift[dtLine] < state.blkIndent) break;
        ddLine = dtLine + 1;
        if (ddLine >= endLine) break;
        if (state.isEmpty(ddLine)) ddLine++;
        if (ddLine >= endLine) break;
        if (state.tShift[ddLine] < state.blkIndent) break;
        contentStart = $168335c5d9e2e921$var$skipMarker(state, ddLine);
        if (contentStart < 0) break;
    // go to the next loop iteration:
    // insert DT and DD tags and repeat checking
    }
    // Finilize list
    state.tokens.push({
        type: 'dl_close',
        level: --state.level
    });
    listLines[1] = nextLine;
    state.line = nextLine;
    // mark paragraphs tight if needed
    if (tight) $168335c5d9e2e921$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("7Y9Xm", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine /*, endLine*/ ) {
    var endLine, content, terminate, i, l, nextLine = startLine + 1, terminatorRules;
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    if (nextLine < endLine && !state.isEmpty(nextLine)) {
        terminatorRules = state.parser.ruler.getRules('paragraph');
        for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
            // this would be a code block normally, but after paragraph
            // it's considered a lazy continuation regardless of what's there
            if (state.tShift[nextLine] - state.blkIndent > 3) continue;
            // Some tags can terminate paragraph without empty line.
            terminate = false;
            for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            if (terminate) break;
        }
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    if (content.length) {
        state.tokens.push({
            type: 'paragraph_open',
            tight: false,
            lines: [
                startLine,
                state.line
            ],
            level: state.level
        });
        state.tokens.push({
            type: 'inline',
            content: content,
            level: state.level + 1,
            lines: [
                startLine,
                state.line
            ],
            children: []
        });
        state.tokens.push({
            type: 'paragraph_close',
            tight: false,
            level: state.level
        });
    }
    return true;
};

});


parcelRegister("f62O3", function(module, exports) {
'use strict';

var $iJCC3 = parcelRequire("iJCC3");

var $6oHIf = parcelRequire("6oHIf");

var $bQwNq = parcelRequire("bQwNq");
















/**
 * Inline Parser `rules`
 */ var $afd997cee1b23c4f$var$_rules = [
    [
        'text',
        (parcelRequire("8HjDr"))
    ],
    [
        'newline',
        (parcelRequire("c0jMa"))
    ],
    [
        'escape',
        (parcelRequire("1nRri"))
    ],
    [
        'backticks',
        (parcelRequire("5ssWE"))
    ],
    [
        'del',
        (parcelRequire("5DK6v"))
    ],
    [
        'ins',
        (parcelRequire("5zRfp"))
    ],
    [
        'mark',
        (parcelRequire("9GZuR"))
    ],
    [
        'emphasis',
        (parcelRequire("joT5R"))
    ],
    [
        'sub',
        (parcelRequire("lAOqa"))
    ],
    [
        'sup',
        (parcelRequire("6z6Bg"))
    ],
    [
        'links',
        (parcelRequire("lhNTW"))
    ],
    [
        'footnote_inline',
        (parcelRequire("gvKFY"))
    ],
    [
        'footnote_ref',
        (parcelRequire("17EBv"))
    ],
    [
        'autolink',
        (parcelRequire("aLVUh"))
    ],
    [
        'htmltag',
        (parcelRequire("7zXy1"))
    ],
    [
        'entity',
        (parcelRequire("Yjb6v"))
    ]
];
/**
 * Inline Parser class. Note that link validation is stricter
 * in Remarkable than what is specified by CommonMark. If you
 * want to change this you can use a custom validator.
 *
 * @api private
 */ function $afd997cee1b23c4f$var$ParserInline() {
    this.ruler = new $iJCC3();
    for(var i = 0; i < $afd997cee1b23c4f$var$_rules.length; i++)this.ruler.push($afd997cee1b23c4f$var$_rules[i][0], $afd997cee1b23c4f$var$_rules[i][1]);
    // Can be overridden with a custom validator
    this.validateLink = $afd997cee1b23c4f$var$validateLink;
}
/**
 * Skip a single token by running all rules in validation mode.
 * Returns `true` if any rule reports success.
 *
 * @param  {Object} `state`
 * @api privage
 */ $afd997cee1b23c4f$var$ParserInline.prototype.skipToken = function(state) {
    var rules = this.ruler.getRules('');
    var len = rules.length;
    var pos = state.pos;
    var i, cached_pos;
    if ((cached_pos = state.cacheGet(pos)) > 0) {
        state.pos = cached_pos;
        return;
    }
    for(i = 0; i < len; i++)if (rules[i](state, true)) {
        state.cacheSet(pos, state.pos);
        return;
    }
    state.pos++;
    state.cacheSet(pos, state.pos);
};
/**
 * Generate tokens for the given input range.
 *
 * @param  {Object} `state`
 * @api private
 */ $afd997cee1b23c4f$var$ParserInline.prototype.tokenize = function(state) {
    var rules = this.ruler.getRules('');
    var len = rules.length;
    var end = state.posMax;
    var ok, i;
    while(state.pos < end){
        // Try all possible rules.
        // On success, the rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) break;
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * Parse the given input string.
 *
 * @param  {String} `str`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @param  {Array} `outTokens`
 * @api private
 */ $afd997cee1b23c4f$var$ParserInline.prototype.parse = function(str, options, env, outTokens) {
    var state = new $6oHIf(str, this, options, env, outTokens);
    this.tokenize(state);
};
/**
 * Validate the given `url` by checking for bad protocols.
 *
 * @param  {String} `url`
 * @return {Boolean}
 */ function $afd997cee1b23c4f$var$validateLink(url) {
    var BAD_PROTOCOLS = [
        'vbscript',
        'javascript',
        'file',
        'data'
    ];
    var str = url.trim().toLowerCase();
    // Care about digital entities "javascript&#x3A;alert(1)"
    str = $bQwNq.replaceEntities(str);
    if (str.indexOf(':') !== -1 && BAD_PROTOCOLS.indexOf(str.split(':')[0]) !== -1) return false;
    return true;
}
/**
 * Expose `ParserInline`
 */ module.exports = $afd997cee1b23c4f$var$ParserInline;

});
parcelRegister("8HjDr", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
function $655192093182ad89$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x5C /* \ */ :
        case 0x60 /* ` */ :
        case 0x2A /* * */ :
        case 0x5F /* _ */ :
        case 0x5E /* ^ */ :
        case 0x5B /* [ */ :
        case 0x5D /* ] */ :
        case 0x21 /* ! */ :
        case 0x26 /* & */ :
        case 0x3C /* < */ :
        case 0x3E /* > */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x40 /* @ */ :
        case 0x7E /* ~ */ :
        case 0x2B /* + */ :
        case 0x3D /* = */ :
        case 0x3A /* : */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$655192093182ad89$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
};

});

parcelRegister("c0jMa", function(module, exports) {
// Proceess '\n'
'use strict';
module.exports = function newline(state, silent) {
    var pmax, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Strip out all trailing spaces on this line.
                for(var i = pmax - 2; i >= 0; i--)if (state.pending.charCodeAt(i) !== 0x20) {
                    state.pending = state.pending.substring(0, i + 1);
                    break;
                }
                state.push({
                    type: 'hardbreak',
                    level: state.level
                });
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push({
                    type: 'softbreak',
                    level: state.level
                });
            }
        } else state.push({
            type: 'softbreak',
            level: state.level
        });
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && state.src.charCodeAt(pos) === 0x20)pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("1nRri", function(module, exports) {
// Proceess escaped chars and hardbreaks
'use strict';
var $102164604589d1d6$var$ESCAPED = [];
for(var $102164604589d1d6$var$i = 0; $102164604589d1d6$var$i < 256; $102164604589d1d6$var$i++)$102164604589d1d6$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $102164604589d1d6$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (ch < 256 && $102164604589d1d6$var$ESCAPED[ch] !== 0) {
            if (!silent) state.pending += state.src[pos];
            state.pos += 2;
            return true;
        }
        if (ch === 0x0A) {
            if (!silent) state.push({
                type: 'hardbreak',
                level: state.level
            });
            pos++;
            // skip leading whitespaces from next line
            while(pos < max && state.src.charCodeAt(pos) === 0x20)pos++;
            state.pos = pos;
            return true;
        }
    }
    if (!silent) state.pending += '\\';
    state.pos++;
    return true;
};

});

parcelRegister("5ssWE", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backticks(state, silent) {
    var start, max, marker, matchStart, matchEnd, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    matchStart = matchEnd = pos;
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        if (matchEnd - matchStart === marker.length) {
            if (!silent) state.push({
                type: 'code',
                content: state.src.slice(pos, matchStart).replace(/[ \n]+/g, ' ').trim(),
                block: false,
                level: state.level
            });
            state.pos = matchEnd;
            return true;
        }
    }
    if (!silent) state.pending += marker;
    state.pos += marker.length;
    return true;
};

});

parcelRegister("5DK6v", function(module, exports) {
// Process ~~deleted text~~
'use strict';
module.exports = function del(state, silent) {
    var found, pos, stack, max = state.posMax, start = state.pos, lastChar, nextChar;
    if (state.src.charCodeAt(start) !== 0x7E /* ~ */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    if (start + 4 >= max) return false;
    if (state.src.charCodeAt(start + 1) !== 0x7E /* ~ */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
    nextChar = state.src.charCodeAt(start + 2);
    if (lastChar === 0x7E /* ~ */ ) return false;
    if (nextChar === 0x7E /* ~ */ ) return false;
    if (nextChar === 0x20 || nextChar === 0x0A) return false;
    pos = start + 2;
    while(pos < max && state.src.charCodeAt(pos) === 0x7E /* ~ */ )pos++;
    if (pos > start + 3) {
        // sequence of 4+ markers taking as literal, same as in a emphasis
        state.pos += pos - start;
        if (!silent) state.pending += state.src.slice(start, pos);
        return true;
    }
    state.pos = start + 2;
    stack = 1;
    while(state.pos + 1 < max){
        if (state.src.charCodeAt(state.pos) === 0x7E /* ~ */ ) {
            if (state.src.charCodeAt(state.pos + 1) === 0x7E /* ~ */ ) {
                lastChar = state.src.charCodeAt(state.pos - 1);
                nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
                if (nextChar !== 0x7E /* ~ */  && lastChar !== 0x7E /* ~ */ ) {
                    if (lastChar !== 0x20 && lastChar !== 0x0A) // closing '~~'
                    stack--;
                    else if (nextChar !== 0x20 && nextChar !== 0x0A) // opening '~~'
                    stack++;
                     // else {
                    //  // standalone ' ~~ ' indented with spaces
                    // }
                    if (stack <= 0) {
                        found = true;
                        break;
                    }
                }
            }
        }
        state.parser.skipToken(state);
    }
    if (!found) {
        // parser failed to find ending tag, so it's not valid emphasis
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + 2;
    if (!silent) {
        state.push({
            type: 'del_open',
            level: state.level++
        });
        state.parser.tokenize(state);
        state.push({
            type: 'del_close',
            level: --state.level
        });
    }
    state.pos = state.posMax + 2;
    state.posMax = max;
    return true;
};

});

parcelRegister("5zRfp", function(module, exports) {
// Process ++inserted text++
'use strict';
module.exports = function ins(state, silent) {
    var found, pos, stack, max = state.posMax, start = state.pos, lastChar, nextChar;
    if (state.src.charCodeAt(start) !== 0x2B /* + */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    if (start + 4 >= max) return false;
    if (state.src.charCodeAt(start + 1) !== 0x2B /* + */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
    nextChar = state.src.charCodeAt(start + 2);
    if (lastChar === 0x2B /* + */ ) return false;
    if (nextChar === 0x2B /* + */ ) return false;
    if (nextChar === 0x20 || nextChar === 0x0A) return false;
    pos = start + 2;
    while(pos < max && state.src.charCodeAt(pos) === 0x2B /* + */ )pos++;
    if (pos !== start + 2) {
        // sequence of 3+ markers taking as literal, same as in a emphasis
        state.pos += pos - start;
        if (!silent) state.pending += state.src.slice(start, pos);
        return true;
    }
    state.pos = start + 2;
    stack = 1;
    while(state.pos + 1 < max){
        if (state.src.charCodeAt(state.pos) === 0x2B /* + */ ) {
            if (state.src.charCodeAt(state.pos + 1) === 0x2B /* + */ ) {
                lastChar = state.src.charCodeAt(state.pos - 1);
                nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
                if (nextChar !== 0x2B /* + */  && lastChar !== 0x2B /* + */ ) {
                    if (lastChar !== 0x20 && lastChar !== 0x0A) // closing '++'
                    stack--;
                    else if (nextChar !== 0x20 && nextChar !== 0x0A) // opening '++'
                    stack++;
                     // else {
                    //  // standalone ' ++ ' indented with spaces
                    // }
                    if (stack <= 0) {
                        found = true;
                        break;
                    }
                }
            }
        }
        state.parser.skipToken(state);
    }
    if (!found) {
        // parser failed to find ending tag, so it's not valid emphasis
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + 2;
    if (!silent) {
        state.push({
            type: 'ins_open',
            level: state.level++
        });
        state.parser.tokenize(state);
        state.push({
            type: 'ins_close',
            level: --state.level
        });
    }
    state.pos = state.posMax + 2;
    state.posMax = max;
    return true;
};

});

parcelRegister("9GZuR", function(module, exports) {
// Process ==highlighted text==
'use strict';
module.exports = function del(state, silent) {
    var found, pos, stack, max = state.posMax, start = state.pos, lastChar, nextChar;
    if (state.src.charCodeAt(start) !== 0x3D /* = */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    if (start + 4 >= max) return false;
    if (state.src.charCodeAt(start + 1) !== 0x3D /* = */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
    nextChar = state.src.charCodeAt(start + 2);
    if (lastChar === 0x3D /* = */ ) return false;
    if (nextChar === 0x3D /* = */ ) return false;
    if (nextChar === 0x20 || nextChar === 0x0A) return false;
    pos = start + 2;
    while(pos < max && state.src.charCodeAt(pos) === 0x3D /* = */ )pos++;
    if (pos !== start + 2) {
        // sequence of 3+ markers taking as literal, same as in a emphasis
        state.pos += pos - start;
        if (!silent) state.pending += state.src.slice(start, pos);
        return true;
    }
    state.pos = start + 2;
    stack = 1;
    while(state.pos + 1 < max){
        if (state.src.charCodeAt(state.pos) === 0x3D /* = */ ) {
            if (state.src.charCodeAt(state.pos + 1) === 0x3D /* = */ ) {
                lastChar = state.src.charCodeAt(state.pos - 1);
                nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
                if (nextChar !== 0x3D /* = */  && lastChar !== 0x3D /* = */ ) {
                    if (lastChar !== 0x20 && lastChar !== 0x0A) // closing '=='
                    stack--;
                    else if (nextChar !== 0x20 && nextChar !== 0x0A) // opening '=='
                    stack++;
                     // else {
                    //  // standalone ' == ' indented with spaces
                    // }
                    if (stack <= 0) {
                        found = true;
                        break;
                    }
                }
            }
        }
        state.parser.skipToken(state);
    }
    if (!found) {
        // parser failed to find ending tag, so it's not valid emphasis
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + 2;
    if (!silent) {
        state.push({
            type: 'mark_open',
            level: state.level++
        });
        state.parser.tokenize(state);
        state.push({
            type: 'mark_close',
            level: --state.level
        });
    }
    state.pos = state.posMax + 2;
    state.posMax = max;
    return true;
};

});

parcelRegister("joT5R", function(module, exports) {
// Process *this* and _that_
'use strict';
function $e1fafea1df371351$var$isAlphaNum(code) {
    return code >= 0x30 /* 0 */  && code <= 0x39 /* 9 */  || code >= 0x41 /* A */  && code <= 0x5A /* Z */  || code >= 0x61 /* a */  && code <= 0x7A /* z */ ;
}
// parse sequence of emphasis markers,
// "start" should point at a valid marker
function $e1fafea1df371351$var$scanDelims(state, start) {
    var pos = start, lastChar, nextChar, count, can_open = true, can_close = true, max = state.posMax, marker = state.src.charCodeAt(start);
    lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
    while(pos < max && state.src.charCodeAt(pos) === marker)pos++;
    if (pos >= max) can_open = false;
    count = pos - start;
    if (count >= 4) // sequence of four or more unescaped markers can't start/end an emphasis
    can_open = can_close = false;
    else {
        nextChar = pos < max ? state.src.charCodeAt(pos) : -1;
        // check whitespace conditions
        if (nextChar === 0x20 || nextChar === 0x0A) can_open = false;
        if (lastChar === 0x20 || lastChar === 0x0A) can_close = false;
        if (marker === 0x5F /* _ */ ) {
            // check if we aren't inside the word
            if ($e1fafea1df371351$var$isAlphaNum(lastChar)) can_open = false;
            if ($e1fafea1df371351$var$isAlphaNum(nextChar)) can_close = false;
        }
    }
    return {
        can_open: can_open,
        can_close: can_close,
        delims: count
    };
}
module.exports = function emphasis(state, silent) {
    var startCount, count, found, oldCount, newCount, stack, res, max = state.posMax, start = state.pos, marker = state.src.charCodeAt(start);
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    res = $e1fafea1df371351$var$scanDelims(state, start);
    startCount = res.delims;
    if (!res.can_open) {
        state.pos += startCount;
        if (!silent) state.pending += state.src.slice(start, state.pos);
        return true;
    }
    if (state.level >= state.options.maxNesting) return false;
    state.pos = start + startCount;
    stack = [
        startCount
    ];
    while(state.pos < max){
        if (state.src.charCodeAt(state.pos) === marker) {
            res = $e1fafea1df371351$var$scanDelims(state, state.pos);
            count = res.delims;
            if (res.can_close) {
                oldCount = stack.pop();
                newCount = count;
                while(oldCount !== newCount){
                    if (newCount < oldCount) {
                        stack.push(oldCount - newCount);
                        break;
                    }
                    // assert(newCount > oldCount)
                    newCount -= oldCount;
                    if (stack.length === 0) break;
                    state.pos += oldCount;
                    oldCount = stack.pop();
                }
                if (stack.length === 0) {
                    startCount = oldCount;
                    found = true;
                    break;
                }
                state.pos += count;
                continue;
            }
            if (res.can_open) stack.push(count);
            state.pos += count;
            continue;
        }
        state.parser.skipToken(state);
    }
    if (!found) {
        // parser failed to find ending tag, so it's not valid emphasis
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + startCount;
    if (!silent) {
        if (startCount === 2 || startCount === 3) state.push({
            type: 'strong_open',
            level: state.level++
        });
        if (startCount === 1 || startCount === 3) state.push({
            type: 'em_open',
            level: state.level++
        });
        state.parser.tokenize(state);
        if (startCount === 1 || startCount === 3) state.push({
            type: 'em_close',
            level: --state.level
        });
        if (startCount === 2 || startCount === 3) state.push({
            type: 'strong_close',
            level: --state.level
        });
    }
    state.pos = state.posMax + startCount;
    state.posMax = max;
    return true;
};

});

parcelRegister("lAOqa", function(module, exports) {
// Process ~subscript~
'use strict';
// same as UNESCAPE_MD_RE plus a space
var $fb8412509d26801b$var$UNESCAPE_RE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
module.exports = function sub(state, silent) {
    var found, content, max = state.posMax, start = state.pos;
    if (state.src.charCodeAt(start) !== 0x7E /* ~ */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    if (start + 2 >= max) return false;
    if (state.level >= state.options.maxNesting) return false;
    state.pos = start + 1;
    while(state.pos < max){
        if (state.src.charCodeAt(state.pos) === 0x7E /* ~ */ ) {
            found = true;
            break;
        }
        state.parser.skipToken(state);
    }
    if (!found || start + 1 === state.pos) {
        state.pos = start;
        return false;
    }
    content = state.src.slice(start + 1, state.pos);
    // don't allow unescaped spaces/newlines inside
    if (content.match(/(^|[^\\])(\\\\)*\s/)) {
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + 1;
    if (!silent) state.push({
        type: 'sub',
        level: state.level,
        content: content.replace($fb8412509d26801b$var$UNESCAPE_RE, '$1')
    });
    state.pos = state.posMax + 1;
    state.posMax = max;
    return true;
};

});

parcelRegister("6z6Bg", function(module, exports) {
// Process ^superscript^
'use strict';
// same as UNESCAPE_MD_RE plus a space
var $4c7b2190b06eb6bf$var$UNESCAPE_RE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
module.exports = function sup(state, silent) {
    var found, content, max = state.posMax, start = state.pos;
    if (state.src.charCodeAt(start) !== 0x5E /* ^ */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    if (start + 2 >= max) return false;
    if (state.level >= state.options.maxNesting) return false;
    state.pos = start + 1;
    while(state.pos < max){
        if (state.src.charCodeAt(state.pos) === 0x5E /* ^ */ ) {
            found = true;
            break;
        }
        state.parser.skipToken(state);
    }
    if (!found || start + 1 === state.pos) {
        state.pos = start;
        return false;
    }
    content = state.src.slice(start + 1, state.pos);
    // don't allow unescaped spaces/newlines inside
    if (content.match(/(^|[^\\])(\\\\)*\s/)) {
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + 1;
    if (!silent) state.push({
        type: 'sup',
        level: state.level,
        content: content.replace($4c7b2190b06eb6bf$var$UNESCAPE_RE, '$1')
    });
    state.pos = state.posMax + 1;
    state.posMax = max;
    return true;
};

});

parcelRegister("lhNTW", function(module, exports) {
// Process [links](<to> "stuff")
'use strict';

var $dQ9Wb = parcelRequire("dQ9Wb");

var $010td = parcelRequire("010td");

var $2F3aO = parcelRequire("2F3aO");

var $fPktW = parcelRequire("fPktW");
module.exports = function links(state, silent) {
    var labelStart, labelEnd, label, href, title, pos, ref, code, isImage = false, oldPos = state.pos, max = state.posMax, start = state.pos, marker = state.src.charCodeAt(start);
    if (marker === 0x21 /* ! */ ) {
        isImage = true;
        marker = state.src.charCodeAt(++start);
    }
    if (marker !== 0x5B /* [ */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    labelStart = start + 1;
    labelEnd = $dQ9Wb(state, start);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (code !== 0x20 && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        if ($010td(state, pos)) {
            href = state.linkContent;
            pos = state.pos;
        } else href = '';
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (code !== 0x20 && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        if (pos < max && start !== pos && $2F3aO(state, pos)) {
            title = state.linkContent;
            pos = state.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (code !== 0x20 && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        // do not allow nested reference links
        if (state.linkLevel > 0) return false;
        // [foo]  [bar]
        //      ^^ optional whitespace (can include newlines)
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (code !== 0x20 && code !== 0x0A) break;
        }
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = $dQ9Wb(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = start - 1;
        }
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) {
            if (typeof label === 'undefined') pos = labelEnd + 1;
            label = state.src.slice(labelStart, labelEnd);
        }
        ref = state.env.references[$fPktW(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        if (isImage) state.push({
            type: 'image',
            src: href,
            title: title,
            alt: state.src.substr(labelStart, labelEnd - labelStart),
            level: state.level
        });
        else {
            state.push({
                type: 'link_open',
                href: href,
                title: title,
                level: state.level++
            });
            state.linkLevel++;
            state.parser.tokenize(state);
            state.linkLevel--;
            state.push({
                type: 'link_close',
                level: --state.level
            });
        }
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("gvKFY", function(module, exports) {
// Process inline footnotes (^[...])
'use strict';

var $dQ9Wb = parcelRequire("dQ9Wb");
module.exports = function footnote_inline(state, silent) {
    var labelStart, labelEnd, footnoteId, oldLength, max = state.posMax, start = state.pos;
    if (start + 2 >= max) return false;
    if (state.src.charCodeAt(start) !== 0x5E /* ^ */ ) return false;
    if (state.src.charCodeAt(start + 1) !== 0x5B /* [ */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    labelStart = start + 2;
    labelEnd = $dQ9Wb(state, start + 1);
    // parser failed to find ']', so it's not a valid note
    if (labelEnd < 0) return false;
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        if (!state.env.footnotes) state.env.footnotes = {};
        if (!state.env.footnotes.list) state.env.footnotes.list = [];
        footnoteId = state.env.footnotes.list.length;
        state.pos = labelStart;
        state.posMax = labelEnd;
        state.push({
            type: 'footnote_ref',
            id: footnoteId,
            level: state.level
        });
        state.linkLevel++;
        oldLength = state.tokens.length;
        state.parser.tokenize(state);
        state.env.footnotes.list[footnoteId] = {
            tokens: state.tokens.splice(oldLength)
        };
        state.linkLevel--;
    }
    state.pos = labelEnd + 1;
    state.posMax = max;
    return true;
};

});

parcelRegister("17EBv", function(module, exports) {
// Process footnote references ([^...])
'use strict';
module.exports = function footnote_ref(state, silent) {
    var label, pos, footnoteId, footnoteSubId, max = state.posMax, start = state.pos;
    // should be at least 4 chars - "[^x]"
    if (start + 3 > max) return false;
    if (!state.env.footnotes || !state.env.footnotes.refs) return false;
    if (state.src.charCodeAt(start) !== 0x5B /* [ */ ) return false;
    if (state.src.charCodeAt(start + 1) !== 0x5E /* ^ */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    for(pos = start + 2; pos < max; pos++){
        if (state.src.charCodeAt(pos) === 0x20) return false;
        if (state.src.charCodeAt(pos) === 0x0A) return false;
        if (state.src.charCodeAt(pos) === 0x5D /* ] */ ) break;
    }
    if (pos === start + 2) return false;
     // no empty footnote labels
    if (pos >= max) return false;
    pos++;
    label = state.src.slice(start + 2, pos - 1);
    if (typeof state.env.footnotes.refs[':' + label] === 'undefined') return false;
    if (!silent) {
        if (!state.env.footnotes.list) state.env.footnotes.list = [];
        if (state.env.footnotes.refs[':' + label] < 0) {
            footnoteId = state.env.footnotes.list.length;
            state.env.footnotes.list[footnoteId] = {
                label: label,
                count: 0
            };
            state.env.footnotes.refs[':' + label] = footnoteId;
        } else footnoteId = state.env.footnotes.refs[':' + label];
        footnoteSubId = state.env.footnotes.list[footnoteId].count;
        state.env.footnotes.list[footnoteId].count++;
        state.push({
            type: 'footnote_ref',
            id: footnoteId,
            subId: footnoteSubId,
            level: state.level
        });
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("aLVUh", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';

var $ko6qG = parcelRequire("ko6qG");

var $FCAyg = parcelRequire("FCAyg");
/*eslint max-len:0*/ var $7d7b363c22e11ac7$var$EMAIL_RE = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
var $7d7b363c22e11ac7$var$AUTOLINK_RE = /^<([a-zA-Z.\-]{1,25}):([^<>\x00-\x20]*)>/;
module.exports = function autolink(state, silent) {
    var tail, linkMatch, emailMatch, url, fullUrl, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    tail = state.src.slice(pos);
    if (tail.indexOf('>') < 0) return false;
    linkMatch = tail.match($7d7b363c22e11ac7$var$AUTOLINK_RE);
    if (linkMatch) {
        if ($ko6qG.indexOf(linkMatch[1].toLowerCase()) < 0) return false;
        url = linkMatch[0].slice(1, -1);
        fullUrl = $FCAyg(url);
        if (!state.parser.validateLink(url)) return false;
        if (!silent) {
            state.push({
                type: 'link_open',
                href: fullUrl,
                level: state.level
            });
            state.push({
                type: 'text',
                content: url,
                level: state.level + 1
            });
            state.push({
                type: 'link_close',
                level: state.level
            });
        }
        state.pos += linkMatch[0].length;
        return true;
    }
    emailMatch = tail.match($7d7b363c22e11ac7$var$EMAIL_RE);
    if (emailMatch) {
        url = emailMatch[0].slice(1, -1);
        fullUrl = $FCAyg('mailto:' + url);
        if (!state.parser.validateLink(fullUrl)) return false;
        if (!silent) {
            state.push({
                type: 'link_open',
                href: fullUrl,
                level: state.level
            });
            state.push({
                type: 'text',
                content: url,
                level: state.level + 1
            });
            state.push({
                type: 'link_close',
                level: state.level
            });
        }
        state.pos += emailMatch[0].length;
        return true;
    }
    return false;
};

});
parcelRegister("ko6qG", function(module, exports) {
// List of valid url schemas, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#autolinks
'use strict';
module.exports = [
    'coap',
    'doi',
    'javascript',
    'aaa',
    'aaas',
    'about',
    'acap',
    'cap',
    'cid',
    'crid',
    'data',
    'dav',
    'dict',
    'dns',
    'file',
    'ftp',
    'geo',
    'go',
    'gopher',
    'h323',
    'http',
    'https',
    'iax',
    'icap',
    'im',
    'imap',
    'info',
    'ipp',
    'iris',
    'iris.beep',
    'iris.xpc',
    'iris.xpcs',
    'iris.lwz',
    'ldap',
    'mailto',
    'mid',
    'msrp',
    'msrps',
    'mtqp',
    'mupdate',
    'news',
    'nfs',
    'ni',
    'nih',
    'nntp',
    'opaquelocktoken',
    'pop',
    'pres',
    'rtsp',
    'service',
    'session',
    'shttp',
    'sieve',
    'sip',
    'sips',
    'sms',
    'snmp',
    'soap.beep',
    'soap.beeps',
    'tag',
    'tel',
    'telnet',
    'tftp',
    'thismessage',
    'tn3270',
    'tip',
    'tv',
    'urn',
    'vemmi',
    'ws',
    'wss',
    'xcon',
    'xcon-userid',
    'xmlrpc.beep',
    'xmlrpc.beeps',
    'xmpp',
    'z39.50r',
    'z39.50s',
    'adiumxtra',
    'afp',
    'afs',
    'aim',
    'apt',
    'attachment',
    'aw',
    'beshare',
    'bitcoin',
    'bolo',
    'callto',
    'chrome',
    'chrome-extension',
    'com-eventbrite-attendee',
    'content',
    'cvs',
    'dlna-playsingle',
    'dlna-playcontainer',
    'dtn',
    'dvb',
    'ed2k',
    'facetime',
    'feed',
    'finger',
    'fish',
    'gg',
    'git',
    'gizmoproject',
    'gtalk',
    'hcp',
    'icon',
    'ipn',
    'irc',
    'irc6',
    'ircs',
    'itms',
    'jar',
    'jms',
    'keyparc',
    'lastfm',
    'ldaps',
    'magnet',
    'maps',
    'market',
    'message',
    'mms',
    'ms-help',
    'msnim',
    'mumble',
    'mvn',
    'notes',
    'oid',
    'palm',
    'paparazzi',
    'platform',
    'proxy',
    'psyc',
    'query',
    'res',
    'resource',
    'rmi',
    'rsync',
    'rtmp',
    'secondlife',
    'sftp',
    'sgn',
    'skype',
    'smb',
    'soldat',
    'spotify',
    'ssh',
    'steam',
    'svn',
    'teamspeak',
    'things',
    'udp',
    'unreal',
    'ut2004',
    'ventrilo',
    'view-source',
    'webcal',
    'wtai',
    'wyciwyg',
    'xfire',
    'xri',
    'ymsgr'
];

});


parcelRegister("7zXy1", function(module, exports) {
// Process html tags
'use strict';

var $aSY05 = parcelRequire("aSY05");
var $5849fe3f9d51da88$require$HTML_TAG_RE = $aSY05.HTML_TAG_RE;
function $5849fe3f9d51da88$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function htmltag(state, silent) {
    var ch, match, max, pos = state.pos;
    if (!state.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$5849fe3f9d51da88$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($5849fe3f9d51da88$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) state.push({
        type: 'htmltag',
        content: state.src.slice(pos, pos + match[0].length),
        level: state.level
    });
    state.pos += match[0].length;
    return true;
};

});
parcelRegister("aSY05", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $7ecd7d5680057c54$export$6db61d2c3a16e419, (v) => $7ecd7d5680057c54$export$6db61d2c3a16e419 = v);
// Regexps to match html elements
var $7ecd7d5680057c54$export$6db61d2c3a16e419;
'use strict';
function $7ecd7d5680057c54$var$replace(regex, options) {
    regex = regex.source;
    options = options || '';
    return function self(name, val) {
        if (!name) return new RegExp(regex, options);
        val = val.source || val;
        regex = regex.replace(name, val);
        return self;
    };
}
var $7ecd7d5680057c54$var$attr_name = /[a-zA-Z_:][a-zA-Z0-9:._-]*/;
var $7ecd7d5680057c54$var$unquoted = /[^"'=<>`\x00-\x20]+/;
var $7ecd7d5680057c54$var$single_quoted = /'[^']*'/;
var $7ecd7d5680057c54$var$double_quoted = /"[^"]*"/;
/*eslint no-spaced-func:0*/ var $7ecd7d5680057c54$var$attr_value = $7ecd7d5680057c54$var$replace(/(?:unquoted|single_quoted|double_quoted)/)('unquoted', $7ecd7d5680057c54$var$unquoted)('single_quoted', $7ecd7d5680057c54$var$single_quoted)('double_quoted', $7ecd7d5680057c54$var$double_quoted)();
var $7ecd7d5680057c54$var$attribute = $7ecd7d5680057c54$var$replace(/(?:\s+attr_name(?:\s*=\s*attr_value)?)/)('attr_name', $7ecd7d5680057c54$var$attr_name)('attr_value', $7ecd7d5680057c54$var$attr_value)();
var $7ecd7d5680057c54$var$open_tag = $7ecd7d5680057c54$var$replace(/<[A-Za-z][A-Za-z0-9]*attribute*\s*\/?>/)('attribute', $7ecd7d5680057c54$var$attribute)();
var $7ecd7d5680057c54$var$close_tag = /<\/[A-Za-z][A-Za-z0-9]*\s*>/;
var $7ecd7d5680057c54$var$comment = /<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->/;
var $7ecd7d5680057c54$var$processing = /<[?].*?[?]>/;
var $7ecd7d5680057c54$var$declaration = /<![A-Z]+\s+[^>]*>/;
var $7ecd7d5680057c54$var$cdata = /<!\[CDATA\[[\s\S]*?\]\]>/;
var $7ecd7d5680057c54$var$HTML_TAG_RE = $7ecd7d5680057c54$var$replace(/^(?:open_tag|close_tag|comment|processing|declaration|cdata)/)('open_tag', $7ecd7d5680057c54$var$open_tag)('close_tag', $7ecd7d5680057c54$var$close_tag)('comment', $7ecd7d5680057c54$var$comment)('processing', $7ecd7d5680057c54$var$processing)('declaration', $7ecd7d5680057c54$var$declaration)('cdata', $7ecd7d5680057c54$var$cdata)();
$7ecd7d5680057c54$export$6db61d2c3a16e419 = $7ecd7d5680057c54$var$HTML_TAG_RE;

});


parcelRegister("Yjb6v", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $7jmp5 = parcelRequire("7jmp5");

var $bQwNq = parcelRequire("bQwNq");
var $0b547b14e2dec0aa$require$has = $bQwNq.has;

var $bQwNq = parcelRequire("bQwNq");
var $0b547b14e2dec0aa$require$isValidEntityCode = $bQwNq.isValidEntityCode;

var $bQwNq = parcelRequire("bQwNq");
var $0b547b14e2dec0aa$require$fromCodePoint = $bQwNq.fromCodePoint;
var $0b547b14e2dec0aa$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i;
var $0b547b14e2dec0aa$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 < max) {
        ch = state.src.charCodeAt(pos + 1);
        if (ch === 0x23 /* # */ ) {
            match = state.src.slice(pos).match($0b547b14e2dec0aa$var$DIGITAL_RE);
            if (match) {
                if (!silent) {
                    code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                    state.pending += $0b547b14e2dec0aa$require$isValidEntityCode(code) ? $0b547b14e2dec0aa$require$fromCodePoint(code) : $0b547b14e2dec0aa$require$fromCodePoint(0xFFFD);
                }
                state.pos += match[0].length;
                return true;
            }
        } else {
            match = state.src.slice(pos).match($0b547b14e2dec0aa$var$NAMED_RE);
            if (match) {
                if ($0b547b14e2dec0aa$require$has($7jmp5, match[1])) {
                    if (!silent) state.pending += $7jmp5[match[1]];
                    state.pos += match[0].length;
                    return true;
                }
            }
        }
    }
    if (!silent) state.pending += '&';
    state.pos++;
    return true;
};

});


parcelRegister("de00F", function(module, exports) {
// Remarkable default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        linkTarget: '',
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
        quotes: "\u201C\u201D\u2018\u2019",
        // Highlighter function. Should return escaped HTML,
        // or '' if input not changed
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'block',
                'inline',
                'references',
                'replacements',
                'linkify',
                'smartquotes',
                'references',
                'abbr2',
                'footnote_tail'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fences',
                'footnote',
                'heading',
                'hr',
                'htmlblock',
                'lheading',
                'list',
                'paragraph',
                'table'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'del',
                'emphasis',
                'entity',
                'escape',
                'footnote_ref',
                'htmltag',
                'links',
                'newline',
                'text'
            ]
        }
    }
};

});

parcelRegister("58FAn", function(module, exports) {
// Remarkable default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        linkTarget: '',
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
        quotes: "\u201C\u201D\u2018\u2019",
        // Highlighter function. Should return escaped HTML,
        // or '' if input not changed
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        // Don't restrict core/block/inline rules
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("53QEF", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        linkTarget: '',
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
        quotes: "\u201C\u201D\u2018\u2019",
        // Highlighter function. Should return escaped HTML,
        // or '' if input not changed
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'block',
                'inline',
                'references',
                'abbr2'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fences',
                'heading',
                'hr',
                'htmlblock',
                'lheading',
                'list',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'htmltag',
                'links',
                'newline',
                'text'
            ]
        }
    }
};

});


parcelRegister("aFVta", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $7c5a4ff0f4df248b$export$a7c73072b1a182ae, (v) => $7c5a4ff0f4df248b$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $7c5a4ff0f4df248b$export$9f27bc3417b4524d, (v) => $7c5a4ff0f4df248b$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $7c5a4ff0f4df248b$export$db77ccec0bb4ccac, (v) => $7c5a4ff0f4df248b$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $7c5a4ff0f4df248b$export$8392c0c9d3dcbd35, (v) => $7c5a4ff0f4df248b$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $7c5a4ff0f4df248b$export$ffb0004e005737fa, (v) => $7c5a4ff0f4df248b$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $7c5a4ff0f4df248b$export$b624eff549462981, (v) => $7c5a4ff0f4df248b$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $7c5a4ff0f4df248b$export$7897aa7841a5380c, (v) => $7c5a4ff0f4df248b$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $7c5a4ff0f4df248b$export$602eac185826482c, (v) => $7c5a4ff0f4df248b$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $7c5a4ff0f4df248b$export$e2c29f18771995cb, (v) => $7c5a4ff0f4df248b$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $7c5a4ff0f4df248b$export$5f8d39834fd61797, (v) => $7c5a4ff0f4df248b$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7c5a4ff0f4df248b$export$74bf444e3cd11ea5, (v) => $7c5a4ff0f4df248b$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $7c5a4ff0f4df248b$export$998bcd577473dd93, (v) => $7c5a4ff0f4df248b$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $7c5a4ff0f4df248b$export$92387174baf9b227, (v) => $7c5a4ff0f4df248b$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $7c5a4ff0f4df248b$export$ec112efeb987d9c6, (v) => $7c5a4ff0f4df248b$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $7c5a4ff0f4df248b$export$b706b080d889d2c9, (v) => $7c5a4ff0f4df248b$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $7c5a4ff0f4df248b$export$5be5a87408f70ddc, (v) => $7c5a4ff0f4df248b$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $7c5a4ff0f4df248b$export$45a5e7f76e0caa8d, (v) => $7c5a4ff0f4df248b$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $7c5a4ff0f4df248b$export$455c2e768291efa6, (v) => $7c5a4ff0f4df248b$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $7c5a4ff0f4df248b$export$9522e17588c12572, (v) => $7c5a4ff0f4df248b$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $7c5a4ff0f4df248b$export$2110ac352bb060b9, (v) => $7c5a4ff0f4df248b$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $7c5a4ff0f4df248b$export$56885ab8b9c456ab, (v) => $7c5a4ff0f4df248b$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $7c5a4ff0f4df248b$export$d927fcb6adf8f9de, (v) => $7c5a4ff0f4df248b$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $7c5a4ff0f4df248b$export$b82d16f27459e05a, (v) => $7c5a4ff0f4df248b$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $7c5a4ff0f4df248b$export$522c17b4f5e123e8, (v) => $7c5a4ff0f4df248b$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $7c5a4ff0f4df248b$export$1aabd8a0274ecfd6, (v) => $7c5a4ff0f4df248b$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $7c5a4ff0f4df248b$export$3d6c20d97e46b957, (v) => $7c5a4ff0f4df248b$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $7c5a4ff0f4df248b$export$9b621391a187a31a, (v) => $7c5a4ff0f4df248b$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $7c5a4ff0f4df248b$export$f5bbd400c2f4426f, (v) => $7c5a4ff0f4df248b$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7c5a4ff0f4df248b$export$a7c73072b1a182ae;
var $7c5a4ff0f4df248b$export$9f27bc3417b4524d;
var $7c5a4ff0f4df248b$export$db77ccec0bb4ccac;
var $7c5a4ff0f4df248b$export$8392c0c9d3dcbd35;
var $7c5a4ff0f4df248b$export$ffb0004e005737fa;
var $7c5a4ff0f4df248b$export$b624eff549462981;
var $7c5a4ff0f4df248b$export$7897aa7841a5380c;
var $7c5a4ff0f4df248b$export$602eac185826482c;
var $7c5a4ff0f4df248b$export$e2c29f18771995cb;
var $7c5a4ff0f4df248b$export$5f8d39834fd61797;
var $7c5a4ff0f4df248b$export$74bf444e3cd11ea5;
var $7c5a4ff0f4df248b$export$998bcd577473dd93;
var $7c5a4ff0f4df248b$export$92387174baf9b227;
var $7c5a4ff0f4df248b$export$ec112efeb987d9c6;
var $7c5a4ff0f4df248b$export$b706b080d889d2c9;
var $7c5a4ff0f4df248b$export$5be5a87408f70ddc;
var $7c5a4ff0f4df248b$export$45a5e7f76e0caa8d;
var $7c5a4ff0f4df248b$export$455c2e768291efa6;
var $7c5a4ff0f4df248b$export$9522e17588c12572;
var $7c5a4ff0f4df248b$export$2110ac352bb060b9;
var $7c5a4ff0f4df248b$export$56885ab8b9c456ab;
var $7c5a4ff0f4df248b$export$d927fcb6adf8f9de;
var $7c5a4ff0f4df248b$export$b82d16f27459e05a;
var $7c5a4ff0f4df248b$export$522c17b4f5e123e8;
var $7c5a4ff0f4df248b$export$1aabd8a0274ecfd6;
var $7c5a4ff0f4df248b$export$3d6c20d97e46b957;
var $7c5a4ff0f4df248b$export$9b621391a187a31a;
var $7c5a4ff0f4df248b$export$f5bbd400c2f4426f;
'use strict';
var $7c5a4ff0f4df248b$var$b = Symbol.for("react.element"), $7c5a4ff0f4df248b$var$c = Symbol.for("react.portal"), $7c5a4ff0f4df248b$var$d = Symbol.for("react.fragment"), $7c5a4ff0f4df248b$var$e = Symbol.for("react.strict_mode"), $7c5a4ff0f4df248b$var$f = Symbol.for("react.profiler"), $7c5a4ff0f4df248b$var$g = Symbol.for("react.provider"), $7c5a4ff0f4df248b$var$h = Symbol.for("react.context"), $7c5a4ff0f4df248b$var$k = Symbol.for("react.server_context"), $7c5a4ff0f4df248b$var$l = Symbol.for("react.forward_ref"), $7c5a4ff0f4df248b$var$m = Symbol.for("react.suspense"), $7c5a4ff0f4df248b$var$n = Symbol.for("react.suspense_list"), $7c5a4ff0f4df248b$var$p = Symbol.for("react.memo"), $7c5a4ff0f4df248b$var$q = Symbol.for("react.lazy"), $7c5a4ff0f4df248b$var$t = Symbol.for("react.offscreen"), $7c5a4ff0f4df248b$var$u;
$7c5a4ff0f4df248b$var$u = Symbol.for("react.module.reference");
function $7c5a4ff0f4df248b$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $7c5a4ff0f4df248b$var$b:
                switch(a = a.type, a){
                    case $7c5a4ff0f4df248b$var$d:
                    case $7c5a4ff0f4df248b$var$f:
                    case $7c5a4ff0f4df248b$var$e:
                    case $7c5a4ff0f4df248b$var$m:
                    case $7c5a4ff0f4df248b$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $7c5a4ff0f4df248b$var$k:
                            case $7c5a4ff0f4df248b$var$h:
                            case $7c5a4ff0f4df248b$var$l:
                            case $7c5a4ff0f4df248b$var$q:
                            case $7c5a4ff0f4df248b$var$p:
                            case $7c5a4ff0f4df248b$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $7c5a4ff0f4df248b$var$c:
                return r;
        }
    }
}
$7c5a4ff0f4df248b$export$a7c73072b1a182ae = $7c5a4ff0f4df248b$var$h;
$7c5a4ff0f4df248b$export$9f27bc3417b4524d = $7c5a4ff0f4df248b$var$g;
$7c5a4ff0f4df248b$export$db77ccec0bb4ccac = $7c5a4ff0f4df248b$var$b;
$7c5a4ff0f4df248b$export$8392c0c9d3dcbd35 = $7c5a4ff0f4df248b$var$l;
$7c5a4ff0f4df248b$export$ffb0004e005737fa = $7c5a4ff0f4df248b$var$d;
$7c5a4ff0f4df248b$export$b624eff549462981 = $7c5a4ff0f4df248b$var$q;
$7c5a4ff0f4df248b$export$7897aa7841a5380c = $7c5a4ff0f4df248b$var$p;
$7c5a4ff0f4df248b$export$602eac185826482c = $7c5a4ff0f4df248b$var$c;
$7c5a4ff0f4df248b$export$e2c29f18771995cb = $7c5a4ff0f4df248b$var$f;
$7c5a4ff0f4df248b$export$5f8d39834fd61797 = $7c5a4ff0f4df248b$var$e;
$7c5a4ff0f4df248b$export$74bf444e3cd11ea5 = $7c5a4ff0f4df248b$var$m;
$7c5a4ff0f4df248b$export$998bcd577473dd93 = $7c5a4ff0f4df248b$var$n;
$7c5a4ff0f4df248b$export$92387174baf9b227 = function() {
    return !1;
};
$7c5a4ff0f4df248b$export$ec112efeb987d9c6 = function() {
    return !1;
};
$7c5a4ff0f4df248b$export$b706b080d889d2c9 = function(a) {
    return $7c5a4ff0f4df248b$var$v(a) === $7c5a4ff0f4df248b$var$h;
};
$7c5a4ff0f4df248b$export$5be5a87408f70ddc = function(a) {
    return $7c5a4ff0f4df248b$var$v(a) === $7c5a4ff0f4df248b$var$g;
};
$7c5a4ff0f4df248b$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7c5a4ff0f4df248b$var$b;
};
$7c5a4ff0f4df248b$export$455c2e768291efa6 = function(a) {
    return $7c5a4ff0f4df248b$var$v(a) === $7c5a4ff0f4df248b$var$l;
};
$7c5a4ff0f4df248b$export$9522e17588c12572 = function(a) {
    return $7c5a4ff0f4df248b$var$v(a) === $7c5a4ff0f4df248b$var$d;
};
$7c5a4ff0f4df248b$export$2110ac352bb060b9 = function(a) {
    return $7c5a4ff0f4df248b$var$v(a) === $7c5a4ff0f4df248b$var$q;
};
$7c5a4ff0f4df248b$export$56885ab8b9c456ab = function(a) {
    return $7c5a4ff0f4df248b$var$v(a) === $7c5a4ff0f4df248b$var$p;
};
$7c5a4ff0f4df248b$export$d927fcb6adf8f9de = function(a) {
    return $7c5a4ff0f4df248b$var$v(a) === $7c5a4ff0f4df248b$var$c;
};
$7c5a4ff0f4df248b$export$b82d16f27459e05a = function(a) {
    return $7c5a4ff0f4df248b$var$v(a) === $7c5a4ff0f4df248b$var$f;
};
$7c5a4ff0f4df248b$export$522c17b4f5e123e8 = function(a) {
    return $7c5a4ff0f4df248b$var$v(a) === $7c5a4ff0f4df248b$var$e;
};
$7c5a4ff0f4df248b$export$1aabd8a0274ecfd6 = function(a) {
    return $7c5a4ff0f4df248b$var$v(a) === $7c5a4ff0f4df248b$var$m;
};
$7c5a4ff0f4df248b$export$3d6c20d97e46b957 = function(a) {
    return $7c5a4ff0f4df248b$var$v(a) === $7c5a4ff0f4df248b$var$n;
};
$7c5a4ff0f4df248b$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $7c5a4ff0f4df248b$var$d || a === $7c5a4ff0f4df248b$var$f || a === $7c5a4ff0f4df248b$var$e || a === $7c5a4ff0f4df248b$var$m || a === $7c5a4ff0f4df248b$var$n || a === $7c5a4ff0f4df248b$var$t || "object" === typeof a && null !== a && (a.$$typeof === $7c5a4ff0f4df248b$var$q || a.$$typeof === $7c5a4ff0f4df248b$var$p || a.$$typeof === $7c5a4ff0f4df248b$var$g || a.$$typeof === $7c5a4ff0f4df248b$var$h || a.$$typeof === $7c5a4ff0f4df248b$var$l || a.$$typeof === $7c5a4ff0f4df248b$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$7c5a4ff0f4df248b$export$f5bbd400c2f4426f = $7c5a4ff0f4df248b$var$v;

});


var $e9nev = parcelRequire("e9nev");

var $eeyUA = parcelRequire("eeyUA");
var $4d1551fcd46eb2de$export$882461b6382ed46c;
var $4d1551fcd46eb2de$export$757ceba2d55c277e;
'use strict';
var $6568ab17ba5c963b$exports = {};
'use strict';
function $6568ab17ba5c963b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6568ab17ba5c963b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6568ab17ba5c963b$var$checkDCE();

$6568ab17ba5c963b$exports = (parcelRequire("3MgPz"));


var $4d1551fcd46eb2de$var$i;
$4d1551fcd46eb2de$export$882461b6382ed46c = $6568ab17ba5c963b$exports.createRoot;
$4d1551fcd46eb2de$export$757ceba2d55c277e = $6568ab17ba5c963b$exports.hydrateRoot;



var $e9nev = parcelRequire("e9nev");

var $eeyUA = parcelRequire("eeyUA");

var $e9nev = parcelRequire("e9nev");

var $eeyUA = parcelRequire("eeyUA");

var $e9nev = parcelRequire("e9nev");

var $e9nev = parcelRequire("e9nev");

var $eeyUA = parcelRequire("eeyUA");


var $e9nev = parcelRequire("e9nev");
var $1e4f652a989dd07e$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($1e4f652a989dd07e$exports) {
        classNames.default = classNames;
        $1e4f652a989dd07e$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $eeyUA = parcelRequire("eeyUA");
var $06446c21cdc1ce48$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($06446c21cdc1ce48$exports, "__esModule", {
    value: true
});
$06446c21cdc1ce48$exports.default = void 0;

var $06446c21cdc1ce48$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $06446c21cdc1ce48$var$_default = $06446c21cdc1ce48$exports.default = (0, $06446c21cdc1ce48$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M11.07 12.85c.77-1.39 2.25-2.21 3.11-3.44.91-1.29.4-3.7-2.18-3.7-1.69 0-2.52 1.28-2.87 2.34L6.54 6.96C7.25 4.83 9.18 3 11.99 3c2.35 0 3.96 1.07 4.78 2.41.7 1.15 1.11 3.3.03 4.9-1.2 1.77-2.35 2.31-2.97 3.45-.25.46-.35.76-.35 2.24h-2.89c-.01-.78-.13-2.05.48-3.15M14 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2"
}), 'QuestionMarkOutlined');


var $7f2ee74f503c9795$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($7f2ee74f503c9795$exports, "__esModule", {
    value: true
});
$7f2ee74f503c9795$exports.default = void 0;

var $7f2ee74f503c9795$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $7f2ee74f503c9795$var$_default = $7f2ee74f503c9795$exports.default = (0, $7f2ee74f503c9795$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'AddOutlined');


var $2ef7d9eb657d3479$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($2ef7d9eb657d3479$exports, "__esModule", {
    value: true
});
$2ef7d9eb657d3479$exports.default = void 0;

var $2ef7d9eb657d3479$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $2ef7d9eb657d3479$var$_default = $2ef7d9eb657d3479$exports.default = (0, $2ef7d9eb657d3479$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreVertOutlined');


var $dcdf0ea9d5409019$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($dcdf0ea9d5409019$exports, "__esModule", {
    value: true
});
$dcdf0ea9d5409019$exports.default = void 0;

var $dcdf0ea9d5409019$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $dcdf0ea9d5409019$var$_default = $dcdf0ea9d5409019$exports.default = (0, $dcdf0ea9d5409019$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), 'ArrowBackIos');


var $810478c9643d836d$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($810478c9643d836d$exports, "__esModule", {
    value: true
});
$810478c9643d836d$exports.default = void 0;

var $810478c9643d836d$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $810478c9643d836d$var$_default = $810478c9643d836d$exports.default = (0, $810478c9643d836d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), 'ArrowDropDownOutlined');


var $1e24849621093dad$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($1e24849621093dad$exports, "__esModule", {
    value: true
});
$1e24849621093dad$exports.default = void 0;

var $1e24849621093dad$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $1e24849621093dad$var$_default = $1e24849621093dad$exports.default = (0, $1e24849621093dad$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "m17 8-1.41 1.41L17.17 11H9v2h8.17l-1.58 1.58L17 16l4-4zM5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5z"
}), 'LogoutOutlined');


var $b5d9f5c772f9ea7d$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($b5d9f5c772f9ea7d$exports, "__esModule", {
    value: true
});
$b5d9f5c772f9ea7d$exports.default = void 0;

var $b5d9f5c772f9ea7d$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $b5d9f5c772f9ea7d$var$_default = $b5d9f5c772f9ea7d$exports.default = (0, $b5d9f5c772f9ea7d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMoreOutlined');


var $21fe327746c07d2a$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($21fe327746c07d2a$exports, "__esModule", {
    value: true
});
$21fe327746c07d2a$exports.default = void 0;

var $21fe327746c07d2a$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $21fe327746c07d2a$var$_default = $21fe327746c07d2a$exports.default = (0, $21fe327746c07d2a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRightOutlined');


var $a6e1be9a13393d4d$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($a6e1be9a13393d4d$exports, "__esModule", {
    value: true
});
$a6e1be9a13393d4d$exports.default = void 0;

var $a6e1be9a13393d4d$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $a6e1be9a13393d4d$var$_default = $a6e1be9a13393d4d$exports.default = (0, $a6e1be9a13393d4d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'CloseOutlined');


var $ccb050a05964f360$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($ccb050a05964f360$exports, "__esModule", {
    value: true
});
$ccb050a05964f360$exports.default = void 0;

var $ccb050a05964f360$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $ccb050a05964f360$var$_default = $ccb050a05964f360$exports.default = (0, $ccb050a05964f360$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z"
}), 'ReportProblemOutlined');


var $cb4f278685e0adca$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($cb4f278685e0adca$exports, "__esModule", {
    value: true
});
$cb4f278685e0adca$exports.default = void 0;

var $cb4f278685e0adca$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $cb4f278685e0adca$var$_default = $cb4f278685e0adca$exports.default = (0, $cb4f278685e0adca$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');


var $545e1cb44bde939f$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($545e1cb44bde939f$exports, "__esModule", {
    value: true
});
$545e1cb44bde939f$exports.default = void 0;

var $545e1cb44bde939f$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $545e1cb44bde939f$var$_default = $545e1cb44bde939f$exports.default = (0, $545e1cb44bde939f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
}), 'CheckCircleOutlineOutlined');


var $aabebb6a6420d9b8$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($aabebb6a6420d9b8$exports, "__esModule", {
    value: true
});
$aabebb6a6420d9b8$exports.default = void 0;

var $aabebb6a6420d9b8$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $aabebb6a6420d9b8$var$_default = $aabebb6a6420d9b8$exports.default = (0, $aabebb6a6420d9b8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'ErrorOutlineOutlined');


var $509c8e9093c5cb2e$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($509c8e9093c5cb2e$exports, "__esModule", {
    value: true
});
$509c8e9093c5cb2e$exports.default = void 0;

var $509c8e9093c5cb2e$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $509c8e9093c5cb2e$var$_default = $509c8e9093c5cb2e$exports.default = (0, $509c8e9093c5cb2e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5z"
}), 'FileDownloadOutlined');


var $01803bbb9b3e6422$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($01803bbb9b3e6422$exports, "__esModule", {
    value: true
});
$01803bbb9b3e6422$exports.default = void 0;

var $01803bbb9b3e6422$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $01803bbb9b3e6422$var$_default = $01803bbb9b3e6422$exports.default = (0, $01803bbb9b3e6422$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2m0 15-5-2.18L7 18V5h10z"
}), 'BookmarkBorderOutlined');


var $7a36cab96895fa25$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($7a36cab96895fa25$exports, "__esModule", {
    value: true
});
$7a36cab96895fa25$exports.default = void 0;

var $7a36cab96895fa25$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $7a36cab96895fa25$var$_default = $7a36cab96895fa25$exports.default = (0, $7a36cab96895fa25$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2"
}), 'BookmarkOutlined');


var $300e5b040f49d1f2$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($300e5b040f49d1f2$exports, "__esModule", {
    value: true
});
$300e5b040f49d1f2$exports.default = void 0;

var $300e5b040f49d1f2$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $300e5b040f49d1f2$var$_default = $300e5b040f49d1f2$exports.default = (0, $300e5b040f49d1f2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4zm-2 13.17L18.83 16H4V4h16zM13 5h-2v4H7v2h4v4h2v-4h4V9h-4z"
}), 'AddCommentOutlined');


var $955a8c969d9872b2$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($955a8c969d9872b2$exports, "__esModule", {
    value: true
});
$955a8c969d9872b2$exports.default = void 0;

var $955a8c969d9872b2$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $955a8c969d9872b2$var$_default = $955a8c969d9872b2$exports.default = (0, $955a8c969d9872b2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6z"
}), 'AttachFileOutlined');


var $400e6b83aa6fa057$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($400e6b83aa6fa057$exports, "__esModule", {
    value: true
});
$400e6b83aa6fa057$exports.default = void 0;

var $400e6b83aa6fa057$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $400e6b83aa6fa057$var$_default = $400e6b83aa6fa057$exports.default = (0, $400e6b83aa6fa057$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6m6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26"
}), 'AutorenewOutlined');


var $f0e1fb68ac0b427d$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($f0e1fb68ac0b427d$exports, "__esModule", {
    value: true
});
$f0e1fb68ac0b427d$exports.default = void 0;

var $f0e1fb68ac0b427d$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $f0e1fb68ac0b427d$var$_default = $f0e1fb68ac0b427d$exports.default = (0, $f0e1fb68ac0b427d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12m8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8"
}), 'Block');


var $2f4d04b0406e11aa$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($2f4d04b0406e11aa$exports, "__esModule", {
    value: true
});
$2f4d04b0406e11aa$exports.default = void 0;

var $2f4d04b0406e11aa$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $2f4d04b0406e11aa$var$_default = $2f4d04b0406e11aa$exports.default = (0, $2f4d04b0406e11aa$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 7V3H2v18h20V7zM6 19H4v-2h2zm0-4H4v-2h2zm0-4H4V9h2zm0-4H4V5h2zm4 12H8v-2h2zm0-4H8v-2h2zm0-4H8V9h2zm0-4H8V5h2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8zm-2-8h-2v2h2zm0 4h-2v2h2z"
}), 'BusinessOutlined');


var $db2f69698bc83b0e$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($db2f69698bc83b0e$exports, "__esModule", {
    value: true
});
$db2f69698bc83b0e$exports.default = void 0;

var $db2f69698bc83b0e$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $db2f69698bc83b0e$var$_default = $db2f69698bc83b0e$exports.default = (0, $db2f69698bc83b0e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Cancel');


var $94b32c327852d14c$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($94b32c327852d14c$exports, "__esModule", {
    value: true
});
$94b32c327852d14c$exports.default = void 0;

var $94b32c327852d14c$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $94b32c327852d14c$var$_default = $94b32c327852d14c$exports.default = (0, $94b32c327852d14c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
}), 'CheckCircleOutlined');


var $49b5653e0d58589e$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($49b5653e0d58589e$exports, "__esModule", {
    value: true
});
$49b5653e0d58589e$exports.default = void 0;

var $49b5653e0d58589e$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $49b5653e0d58589e$var$_default = $49b5653e0d58589e$exports.default = (0, $49b5653e0d58589e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'ChevronLeftOutlined');


var $1af765e430b892bd$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($1af765e430b892bd$exports, "__esModule", {
    value: true
});
$1af765e430b892bd$exports.default = void 0;

var $1af765e430b892bd$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $1af765e430b892bd$var$_default = $1af765e430b892bd$exports.default = (0, $1af765e430b892bd$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M11 14H9c0-4.97 4.03-9 9-9v2c-3.87 0-7 3.13-7 7m7-3V9c-2.76 0-5 2.24-5 5h2c0-1.66 1.34-3 3-3M7 4c0-1.11-.89-2-2-2s-2 .89-2 2 .89 2 2 2 2-.89 2-2m4.45.5h-2C9.21 5.92 7.99 7 6.5 7h-3C2.67 7 2 7.67 2 8.5V11h6V8.74c1.86-.59 3.25-2.23 3.45-4.24M19 17c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2m1.5 1h-3c-1.49 0-2.71-1.08-2.95-2.5h-2c.2 2.01 1.59 3.65 3.45 4.24V22h6v-2.5c0-.83-.67-1.5-1.5-1.5"
}), 'ConnectWithoutContactOutlined');


var $ede66ffb82ed42b4$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($ede66ffb82ed42b4$exports, "__esModule", {
    value: true
});
$ede66ffb82ed42b4$exports.default = void 0;

var $ede66ffb82ed42b4$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $ede66ffb82ed42b4$var$_default = $ede66ffb82ed42b4$exports.default = (0, $ede66ffb82ed42b4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopyOutlined');


var $b1cab0fc6c5cc2c8$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($b1cab0fc6c5cc2c8$exports, "__esModule", {
    value: true
});
$b1cab0fc6c5cc2c8$exports.default = void 0;

var $b1cab0fc6c5cc2c8$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $b1cab0fc6c5cc2c8$var$_default = $b1cab0fc6c5cc2c8$exports.default = (0, $b1cab0fc6c5cc2c8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'ControlPoint');


var $1d56f5eeb165ab36$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($1d56f5eeb165ab36$exports, "__esModule", {
    value: true
});
$1d56f5eeb165ab36$exports.default = void 0;

var $1d56f5eeb165ab36$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $1d56f5eeb165ab36$var$_default = $1d56f5eeb165ab36$exports.default = (0, $1d56f5eeb165ab36$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M16 9v10H8V9zm-1.5-6h-5l-1 1H5v2h14V4h-3.5zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2z"
}), 'DeleteOutlined');


var $d73705fda6e157c0$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($d73705fda6e157c0$exports, "__esModule", {
    value: true
});
$d73705fda6e157c0$exports.default = void 0;

var $d73705fda6e157c0$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $d73705fda6e157c0$var$_default = $d73705fda6e157c0$exports.default = (0, $d73705fda6e157c0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "m14.06 9.02.92.92L5.92 19H5v-.92zM17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z"
}), 'EditOutlined');


var $226ea876a0710e3b$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($226ea876a0710e3b$exports, "__esModule", {
    value: true
});
$226ea876a0710e3b$exports.default = void 0;

var $226ea876a0710e3b$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $226ea876a0710e3b$var$_default = $226ea876a0710e3b$exports.default = (0, $226ea876a0710e3b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), 'ExitToAppOutlined');


var $febe4610c781402e$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($febe4610c781402e$exports, "__esModule", {
    value: true
});
$febe4610c781402e$exports.default = void 0;

var $febe4610c781402e$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $febe4610c781402e$var$_default = $febe4610c781402e$exports.default = (0, $febe4610c781402e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLessOutlined');


var $4d8bd3ab3b13c2a0$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($4d8bd3ab3b13c2a0$exports, "__esModule", {
    value: true
});
$4d8bd3ab3b13c2a0$exports.default = void 0;

var $4d8bd3ab3b13c2a0$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $4d8bd3ab3b13c2a0$var$_default = $4d8bd3ab3b13c2a0$exports.default = (0, $4d8bd3ab3b13c2a0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3zM7 9l1.41 1.41L11 7.83V16h2V7.83l2.59 2.58L17 9l-5-5z"
}), 'FileUploadOutlined');


var $afacc32d44032dcb$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($afacc32d44032dcb$exports, "__esModule", {
    value: true
});
$afacc32d44032dcb$exports.default = void 0;

var $afacc32d44032dcb$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $afacc32d44032dcb$var$_default = $afacc32d44032dcb$exports.default = (0, $afacc32d44032dcb$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $e9nev.jsx)("path", {
        d: "m12 12.9-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07z"
    }, "0"),
    /*#__PURE__*/ (0, $e9nev.jsx)("path", {
        d: "m16 6-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52"
    }, "1")
], 'LocalFireDepartment');


var $ecd0a3d80d5e6881$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($ecd0a3d80d5e6881$exports, "__esModule", {
    value: true
});
$ecd0a3d80d5e6881$exports.default = void 0;

var $ecd0a3d80d5e6881$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $ecd0a3d80d5e6881$var$_default = $ecd0a3d80d5e6881$exports.default = (0, $ecd0a3d80d5e6881$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7"
}), 'MyLocationOutlined');


var $c621450c2c75bc75$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($c621450c2c75bc75$exports, "__esModule", {
    value: true
});
$c621450c2c75bc75$exports.default = void 0;

var $c621450c2c75bc75$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $c621450c2c75bc75$var$_default = $c621450c2c75bc75$exports.default = (0, $c621450c2c75bc75$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4m-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2M1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4m2 0c.2-.71 3.3-2 6-2 2.69 0 5.78 1.28 6 2zm17-3v-3h3v-2h-3V7h-2v3h-3v2h3v3z"
}), 'PersonAddAlt1Outlined');


var $4a24cb17e3ce50b6$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($4a24cb17e3ce50b6$exports, "__esModule", {
    value: true
});
$4a24cb17e3ce50b6$exports.default = void 0;

var $4a24cb17e3ce50b6$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $4a24cb17e3ce50b6$var$_default = $4a24cb17e3ce50b6$exports.default = (0, $4a24cb17e3ce50b6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "m17.34 14.54-1.43-1.43c.56-.73 1.05-1.5 1.47-2.32l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1 0 3.98-1.37 7.64-3.66 10.54m-2.82 2.81C11.63 19.64 7.97 21 4 21c-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.35-.12.75-.03 1.02.24l2.2 2.2c.81-.42 1.58-.9 2.3-1.46L1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41z"
}), 'PhoneDisabled');


var $d7bc21fd768eafd4$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($d7bc21fd768eafd4$exports, "__esModule", {
    value: true
});
$d7bc21fd768eafd4$exports.default = void 0;

var $d7bc21fd768eafd4$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $d7bc21fd768eafd4$var$_default = $d7bc21fd768eafd4$exports.default = (0, $d7bc21fd768eafd4$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $e9nev.jsx)("path", {
        d: "M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2z"
    }, "0"),
    /*#__PURE__*/ (0, $e9nev.jsx)("path", {
        d: "M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3zM7 9h8v2H7zm0 3v2h8v-2h-3zm0 3h8v2H7z"
    }, "1")
], 'PostAddOutlined');


var $fdc42263a9383738$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($fdc42263a9383738$exports, "__esModule", {
    value: true
});
$fdc42263a9383738$exports.default = void 0;

var $fdc42263a9383738$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $fdc42263a9383738$var$_default = $fdc42263a9383738$exports.default = (0, $fdc42263a9383738$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $e9nev.jsx)("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
    }, "0"),
    /*#__PURE__*/ (0, $e9nev.jsx)("circle", {
        cx: "12",
        cy: "12",
        r: "5"
    }, "1")
], 'RadioButtonCheckedOutlined');


var $6211ea94e29790c9$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($6211ea94e29790c9$exports, "__esModule", {
    value: true
});
$6211ea94e29790c9$exports.default = void 0;

var $6211ea94e29790c9$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $6211ea94e29790c9$var$_default = $6211ea94e29790c9$exports.default = (0, $6211ea94e29790c9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'RadioButtonUncheckedOutlined');


var $e15844660322e7aa$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($e15844660322e7aa$exports, "__esModule", {
    value: true
});
$e15844660322e7aa$exports.default = void 0;

var $e15844660322e7aa$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $e15844660322e7aa$var$_default = $e15844660322e7aa$exports.default = (0, $e15844660322e7aa$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8"
}), 'Replay');


var $04a42b3dfaaf7244$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($04a42b3dfaaf7244$exports, "__esModule", {
    value: true
});
$04a42b3dfaaf7244$exports.default = void 0;

var $04a42b3dfaaf7244$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $04a42b3dfaaf7244$var$_default = $04a42b3dfaaf7244$exports.default = (0, $04a42b3dfaaf7244$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');


var $539627582d94ad84$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($539627582d94ad84$exports, "__esModule", {
    value: true
});
$539627582d94ad84$exports.default = void 0;

var $539627582d94ad84$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $539627582d94ad84$var$_default = $539627582d94ad84$exports.default = (0, $539627582d94ad84$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M20 4v12h-1.34l1.91 1.91C21.39 17.66 22 16.9 22 16V4c0-1.1-.9-2-2-2H4.66l2 2zM6 12h2v2H6zm12-3h-6.34l2 2H18zm0-3h-8v1.34l.66.66H18zM1.41 1.59 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73 1.41-1.41zM5.17 16 4 17.17V7l2 2v2h2l5 5z"
}), 'SpeakerNotesOffOutlined');


var $cf0101973b13c144$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($cf0101973b13c144$exports, "__esModule", {
    value: true
});
$cf0101973b13c144$exports.default = void 0;

var $cf0101973b13c144$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $cf0101973b13c144$var$_default = $cf0101973b13c144$exports.default = (0, $cf0101973b13c144$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28z"
}), 'StarBorderOutlined');


var $bbdb1aa2207cefa9$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($bbdb1aa2207cefa9$exports, "__esModule", {
    value: true
});
$bbdb1aa2207cefa9$exports.default = void 0;

var $bbdb1aa2207cefa9$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $bbdb1aa2207cefa9$var$_default = $bbdb1aa2207cefa9$exports.default = (0, $bbdb1aa2207cefa9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');


var $a630d7191614c622$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($a630d7191614c622$exports, "__esModule", {
    value: true
});
$a630d7191614c622$exports.default = void 0;

var $a630d7191614c622$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $a630d7191614c622$var$_default = $a630d7191614c622$exports.default = (0, $a630d7191614c622$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "m18.36 9 .6 3H5.04l.6-3zM20 4H4v2h16zm0 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2zM6 18v-4h6v4z"
}), 'StoreOutlined');


var $cf827279adbfdf3b$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($cf827279adbfdf3b$exports, "__esModule", {
    value: true
});
$cf827279adbfdf3b$exports.default = void 0;

var $cf827279adbfdf3b$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $cf827279adbfdf3b$var$_default = $cf827279adbfdf3b$exports.default = (0, $cf827279adbfdf3b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4z"
}), 'Sync');


var $c5b6ae9406003622$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($c5b6ae9406003622$exports, "__esModule", {
    value: true
});
$c5b6ae9406003622$exports.default = void 0;

var $c5b6ae9406003622$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $c5b6ae9406003622$var$_default = $c5b6ae9406003622$exports.default = (0, $c5b6ae9406003622$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M20 2H4.01c-1.1 0-2 .9-2 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.17L4 17.17V4h16zm-8-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m4 3.43c0-.81-.48-1.53-1.22-1.85-.85-.37-1.79-.58-2.78-.58-.99 0-1.93.21-2.78.58C8.48 11.9 8 12.62 8 13.43V14h8z"
}), 'ThreePOutlined');


var $35acfd64c7c20203$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($35acfd64c7c20203$exports, "__esModule", {
    value: true
});
$35acfd64c7c20203$exports.default = void 0;

var $35acfd64c7c20203$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $35acfd64c7c20203$var$_default = $35acfd64c7c20203$exports.default = (0, $35acfd64c7c20203$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M16 13h-3V3h-2v10H8l4 4zM4 19v2h16v-2z"
}), 'VerticalAlignBottom');


var $b20636cdb53c17ff$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($b20636cdb53c17ff$exports, "__esModule", {
    value: true
});
$b20636cdb53c17ff$exports.default = void 0;

var $b20636cdb53c17ff$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $b20636cdb53c17ff$var$_default = $b20636cdb53c17ff$exports.default = (0, $b20636cdb53c17ff$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7"
}), 'VisibilityOutlined');


var $4ab2c8cfffdca58b$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($4ab2c8cfffdca58b$exports, "__esModule", {
    value: true
});
$4ab2c8cfffdca58b$exports.default = void 0;

var $4ab2c8cfffdca58b$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $4ab2c8cfffdca58b$var$_default = $4ab2c8cfffdca58b$exports.default = (0, $4ab2c8cfffdca58b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 5.99 19.53 19H4.47zM2.74 18c-.77 1.33.19 3 1.73 3h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0zM11 11v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1m0 5h2v2h-2z"
}), 'WarningAmberRounded');


var $c5b92a0f0a8da945$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($c5b92a0f0a8da945$exports, "__esModule", {
    value: true
});
$c5b92a0f0a8da945$exports.default = void 0;

var $c5b92a0f0a8da945$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $c5b92a0f0a8da945$var$_default = $c5b92a0f0a8da945$exports.default = (0, $c5b92a0f0a8da945$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M14 6V4h-4v2zM4 8v11h16V8zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2z"
}), 'WorkOutlineOutlined');


var $fe3d85cf51706def$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($fe3d85cf51706def$exports, "__esModule", {
    value: true
});
$fe3d85cf51706def$exports.default = void 0;

var $fe3d85cf51706def$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $fe3d85cf51706def$var$_default = $fe3d85cf51706def$exports.default = (0, $fe3d85cf51706def$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75M19 19H5V5h14z"
}), 'AssignmentOutlined');


var $f26661024ff3452a$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($f26661024ff3452a$exports, "__esModule", {
    value: true
});
$f26661024ff3452a$exports.default = void 0;

var $f26661024ff3452a$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $f26661024ff3452a$var$_default = $f26661024ff3452a$exports.default = (0, $f26661024ff3452a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5M4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12m0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7m7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44M15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35"
}), 'PeopleOutlined');


var $7cea090517ff863a$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($7cea090517ff863a$exports, "__esModule", {
    value: true
});
$7cea090517ff863a$exports.default = void 0;

var $7cea090517ff863a$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $7cea090517ff863a$var$_default = $7cea090517ff863a$exports.default = (0, $7cea090517ff863a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2"
}), 'Circle');


var $98528ab5b56443e3$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($98528ab5b56443e3$exports, "__esModule", {
    value: true
});
$98528ab5b56443e3$exports.default = void 0;

var $98528ab5b56443e3$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $98528ab5b56443e3$var$_default = $98528ab5b56443e3$exports.default = (0, $98528ab5b56443e3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "m16.95 6-3.57 4.55 1.43 1.43c1.03-1.31 4.98-6.37 4.98-6.37C20.3 4.95 19.83 4 19 4H6.83l2 2zM2.81 2.81 1.39 4.22 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.17l5.78 5.78 1.41-1.41z"
}), 'FilterAltOffOutlined');


var $cbfc0163fdf3fa76$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($cbfc0163fdf3fa76$exports, "__esModule", {
    value: true
});
$cbfc0163fdf3fa76$exports.default = void 0;

var $cbfc0163fdf3fa76$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $cbfc0163fdf3fa76$var$_default = $cbfc0163fdf3fa76$exports.default = (0, $cbfc0163fdf3fa76$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M7 6h10l-5.01 6.3zm-2.75-.39C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61"
}), 'FilterAltOutlined');



var $36c92e7fbb27c050$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($36c92e7fbb27c050$exports, "__esModule", {
    value: true
});
$36c92e7fbb27c050$exports.default = void 0;

var $36c92e7fbb27c050$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $36c92e7fbb27c050$var$_default = $36c92e7fbb27c050$exports.default = (0, $36c92e7fbb27c050$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'CheckOutlined');


function $0e73c95013f1ef2d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0e73c95013f1ef2d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0e73c95013f1ef2d$export$2e2bcd8739ae039(o);
}



function $ae64a96c64ad24f1$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $cfcc8bf67e2ae284$export$2e2bcd8739ae039(t) {
    var i = (0, $ae64a96c64ad24f1$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $8ac9efdfad2454a3$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $cfcc8bf67e2ae284$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $9d79fabd39cd20fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d79fabd39cd20fa$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d79fabd39cd20fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d79fabd39cd20fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}



var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");

var $9qOEN = parcelRequire("9qOEN");

var $7Nobb = parcelRequire("7Nobb");

var $jMVaa = parcelRequire("jMVaa");

var $90hus = parcelRequire("90hus");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $40c869e622fca082$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($90hus)))(targetComponent, sourceComponent);
};



var $cfloP = parcelRequire("cfloP");

var $2WE2O = parcelRequire("2WE2O");

var $4PcT3 = parcelRequire("4PcT3");
var $2d12a1c9df581eb7$export$23f2a1d2818174ef = true;
var $2d12a1c9df581eb7$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
/* import { type EmotionCache } from '@emotion/utils' */ var $2d12a1c9df581eb7$var$EmotionCacheContext = /* #__PURE__ */ $eeyUA.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $9qOEN.default)({
    key: 'css'
}) : null);
var $2d12a1c9df581eb7$export$e7094788287c5e9b = $2d12a1c9df581eb7$var$EmotionCacheContext.Provider;
var $2d12a1c9df581eb7$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $eeyUA.useContext)($2d12a1c9df581eb7$var$EmotionCacheContext);
};
var $2d12a1c9df581eb7$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $eeyUA.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $eeyUA.useContext)($2d12a1c9df581eb7$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$2d12a1c9df581eb7$export$23f2a1d2818174ef) $2d12a1c9df581eb7$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $eeyUA.useContext)($2d12a1c9df581eb7$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $9qOEN.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $eeyUA.createElement($2d12a1c9df581eb7$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $2d12a1c9df581eb7$export$971d5caa766a69d7 = /* #__PURE__ */ $eeyUA.createContext({});
var $2d12a1c9df581eb7$export$3b14a55fb2447963 = function useTheme() {
    return $eeyUA.useContext($2d12a1c9df581eb7$export$971d5caa766a69d7);
};
var $2d12a1c9df581eb7$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $7Nobb.default)({}, outerTheme, theme);
};
var $2d12a1c9df581eb7$var$createCacheWithTheme = /* #__PURE__ */ (0, $jMVaa.default)(function(outerTheme) {
    return (0, $jMVaa.default)(function(theme) {
        return $2d12a1c9df581eb7$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $2d12a1c9df581eb7$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $eeyUA.useContext($2d12a1c9df581eb7$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $2d12a1c9df581eb7$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $eeyUA.createElement($2d12a1c9df581eb7$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $2d12a1c9df581eb7$export$8b22cf2602fb60ce(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $eeyUA.useContext($2d12a1c9df581eb7$export$971d5caa766a69d7);
        return /*#__PURE__*/ $eeyUA.createElement(Component, (0, $7Nobb.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $eeyUA.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $40c869e622fca082$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $2d12a1c9df581eb7$var$getLastPart = function /* : string */ getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $2d12a1c9df581eb7$var$getFunctionNameFromStackTraceLine = function /*: ?string*/ getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $2d12a1c9df581eb7$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $2d12a1c9df581eb7$var$getLastPart(match[1]);
    return undefined;
};
var $2d12a1c9df581eb7$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $2d12a1c9df581eb7$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $2d12a1c9df581eb7$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $2d12a1c9df581eb7$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($2d12a1c9df581eb7$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $2d12a1c9df581eb7$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $2d12a1c9df581eb7$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $2d12a1c9df581eb7$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $2d12a1c9df581eb7$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($2d12a1c9df581eb7$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$2d12a1c9df581eb7$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    var label;
    return newProps;
};
var $2d12a1c9df581eb7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $cfloP.registerStyles)(cache, serialized, isStringTag);
    (0, $4PcT3.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $cfloP.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $2d12a1c9df581eb7$var$Emotion = /* #__PURE__ */ $2d12a1c9df581eb7$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$2d12a1c9df581eb7$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $cfloP.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $2WE2O.serializeStyles)(registeredStyles, undefined, $eeyUA.useContext($2d12a1c9df581eb7$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($2d12a1c9df581eb7$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $2d12a1c9df581eb7$var$typePropName && true) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, /*#__PURE__*/ $eeyUA.createElement($2d12a1c9df581eb7$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $eeyUA.createElement(WrappedComponent, newProps));
});
var $2d12a1c9df581eb7$export$a9c23c6ac3fc3eca = $2d12a1c9df581eb7$var$Emotion;



var $eeyUA = parcelRequire("eeyUA");

var $cfloP = parcelRequire("cfloP");

var $4PcT3 = parcelRequire("4PcT3");

var $2WE2O = parcelRequire("2WE2O");
parcelRequire("9qOEN");
parcelRequire("9nayj");
parcelRequire("jMVaa");

parcelRequire("90hus");
var $f13d66bc12cdf03d$var$pkg = {
    name: "@emotion/react",
    version: "11.12.0",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.12.0",
        "@emotion/cache": "^11.12.0",
        "@emotion/serialize": "^1.2.0",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.3.0",
        "@emotion/weak-memoize": "^0.4.0",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.12.0",
        "@emotion/css-prettifier": "1.1.4",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.12.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^5.4.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $f13d66bc12cdf03d$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $2d12a1c9df581eb7$export$dda1d9f60106f0e9).call(props, 'css')) return $eeyUA.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $2d12a1c9df581eb7$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $2d12a1c9df581eb7$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $eeyUA.createElement.apply(null, createElementArgArray);
};
/*
type Styles = Object | Array<Object>

type GlobalProps = {
  +styles: Styles | (Object => Styles)
}
*/ var $f13d66bc12cdf03d$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $f13d66bc12cdf03d$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $2d12a1c9df581eb7$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $2WE2O.serializeStyles)([
        styles
    ], undefined, $eeyUA.useContext((0, $2d12a1c9df581eb7$export$971d5caa766a69d7)));
    if (!(0, $2d12a1c9df581eb7$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $eeyUA.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $eeyUA.useRef();
    (0, $4PcT3.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $4PcT3.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $cfloP.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $f13d66bc12cdf03d$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $2WE2O.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $f13d66bc12cdf03d$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $f13d66bc12cdf03d$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $f13d66bc12cdf03d$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $f13d66bc12cdf03d$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $cfloP.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f13d66bc12cdf03d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $4PcT3.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $cfloP.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $f13d66bc12cdf03d$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $2d12a1c9df581eb7$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $2WE2O.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $cfloP.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $f13d66bc12cdf03d$var$merge(cache.registered, css, $f13d66bc12cdf03d$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $eeyUA.useContext((0, $2d12a1c9df581eb7$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, /*#__PURE__*/ $eeyUA.createElement($f13d66bc12cdf03d$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $f13d66bc12cdf03d$var$isBrowser, $f13d66bc12cdf03d$var$isTestEnv, $f13d66bc12cdf03d$var$globalContext, $f13d66bc12cdf03d$var$globalKey;


function $6f7c37c69e4e8741$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $6be395f7e6ae1977$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $a7cfad0be490bfd9$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $31afbef354c99f62$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $a7cfad0be490bfd9$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $a7cfad0be490bfd9$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $78429f9f1196ab95$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $99519ca24d40826a$export$2e2bcd8739ae039(r, e) {
    return (0, $6f7c37c69e4e8741$export$2e2bcd8739ae039)(r) || (0, $6be395f7e6ae1977$export$2e2bcd8739ae039)(r, e) || (0, $31afbef354c99f62$export$2e2bcd8739ae039)(r, e) || (0, $78429f9f1196ab95$export$2e2bcd8739ae039)();
}



var $8T8Yq = parcelRequire("8T8Yq");
function $5a329839a83d6c12$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $8T8Yq.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



function $6fbe9f16bfdd9d95$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}




var $eeyUA = parcelRequire("eeyUA");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $999c052b5a43ad0f$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $999c052b5a43ad0f$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $999c052b5a43ad0f$export$803cd8101b6c182b = /*#__PURE__*/ $999c052b5a43ad0f$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $999c052b5a43ad0f$export$27b07d8a310ed8b5[0], side + "-" + $999c052b5a43ad0f$export$27b07d8a310ed8b5[1]), []);
const $999c052b5a43ad0f$export$96ec731ed4dcb222 = Math.min;
const $999c052b5a43ad0f$export$8960430cfd85939f = Math.max;
const $999c052b5a43ad0f$export$2077e0241d6afd3c = Math.round;
const $999c052b5a43ad0f$export$a3fe094919f356fd = Math.floor;
const $999c052b5a43ad0f$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $999c052b5a43ad0f$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $999c052b5a43ad0f$export$7d15b64cf5a3a4c4(start, value, end) {
    return $999c052b5a43ad0f$export$8960430cfd85939f(start, $999c052b5a43ad0f$export$96ec731ed4dcb222(value, end));
}
function $999c052b5a43ad0f$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $999c052b5a43ad0f$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $999c052b5a43ad0f$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $999c052b5a43ad0f$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $999c052b5a43ad0f$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $999c052b5a43ad0f$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $999c052b5a43ad0f$export$2b57e0052a6d6d4c(placement) {
    return $999c052b5a43ad0f$export$8a000a963141ac32($999c052b5a43ad0f$export$f28e8f882010718a(placement));
}
function $999c052b5a43ad0f$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $999c052b5a43ad0f$export$f0989780f32bfcda(placement);
    const alignmentAxis = $999c052b5a43ad0f$export$2b57e0052a6d6d4c(placement);
    const length = $999c052b5a43ad0f$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $999c052b5a43ad0f$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $999c052b5a43ad0f$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $999c052b5a43ad0f$export$496432a3699e50b1(placement) {
    const oppositePlacement = $999c052b5a43ad0f$export$9c5e28bad23365fa(placement);
    return [
        $999c052b5a43ad0f$export$2b182c584985588b(placement),
        oppositePlacement,
        $999c052b5a43ad0f$export$2b182c584985588b(oppositePlacement)
    ];
}
function $999c052b5a43ad0f$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $999c052b5a43ad0f$var$lrPlacement = [
    'left',
    'right'
];
const $999c052b5a43ad0f$var$rlPlacement = [
    'right',
    'left'
];
const $999c052b5a43ad0f$var$tbPlacement = [
    'top',
    'bottom'
];
const $999c052b5a43ad0f$var$btPlacement = [
    'bottom',
    'top'
];
function $999c052b5a43ad0f$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $999c052b5a43ad0f$var$rlPlacement : $999c052b5a43ad0f$var$lrPlacement;
            return isStart ? $999c052b5a43ad0f$var$lrPlacement : $999c052b5a43ad0f$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $999c052b5a43ad0f$var$tbPlacement : $999c052b5a43ad0f$var$btPlacement;
        default:
            return [];
    }
}
function $999c052b5a43ad0f$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $999c052b5a43ad0f$export$f0989780f32bfcda(placement);
    let list = $999c052b5a43ad0f$var$getSideList($999c052b5a43ad0f$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($999c052b5a43ad0f$export$2b182c584985588b));
    }
    return list;
}
function $999c052b5a43ad0f$export$9c5e28bad23365fa(placement) {
    const side = $999c052b5a43ad0f$export$3c915306cb7fc97a(placement);
    return $999c052b5a43ad0f$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $999c052b5a43ad0f$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $999c052b5a43ad0f$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $999c052b5a43ad0f$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $999c052b5a43ad0f$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $b41dad99a64d5031$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $999c052b5a43ad0f$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $999c052b5a43ad0f$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $999c052b5a43ad0f$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $999c052b5a43ad0f$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $999c052b5a43ad0f$export$f0989780f32bfcda)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $b41dad99a64d5031$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $999c052b5a43ad0f$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $999c052b5a43ad0f$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $999c052b5a43ad0f$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $999c052b5a43ad0f$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $b41dad99a64d5031$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $b41dad99a64d5031$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $b41dad99a64d5031$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $b41dad99a64d5031$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $b41dad99a64d5031$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $b41dad99a64d5031$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $b41dad99a64d5031$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $999c052b5a43ad0f$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $999c052b5a43ad0f$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $999c052b5a43ad0f$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $999c052b5a43ad0f$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $999c052b5a43ad0f$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $999c052b5a43ad0f$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $999c052b5a43ad0f$export$7d15b64cf5a3a4c4)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $999c052b5a43ad0f$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $b41dad99a64d5031$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $999c052b5a43ad0f$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $999c052b5a43ad0f$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $999c052b5a43ad0f$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $999c052b5a43ad0f$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $999c052b5a43ad0f$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $b41dad99a64d5031$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $999c052b5a43ad0f$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $999c052b5a43ad0f$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $999c052b5a43ad0f$export$803cd8101b6c182b) ? $b41dad99a64d5031$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $999c052b5a43ad0f$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $999c052b5a43ad0f$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $999c052b5a43ad0f$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $999c052b5a43ad0f$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $b41dad99a64d5031$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $999c052b5a43ad0f$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $999c052b5a43ad0f$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $999c052b5a43ad0f$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $999c052b5a43ad0f$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $999c052b5a43ad0f$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $999c052b5a43ad0f$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $999c052b5a43ad0f$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $999c052b5a43ad0f$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $999c052b5a43ad0f$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $999c052b5a43ad0f$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $999c052b5a43ad0f$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $b41dad99a64d5031$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $b41dad99a64d5031$var$isAnySideFullyClipped(overflow) {
    return (0, $999c052b5a43ad0f$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $b41dad99a64d5031$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $999c052b5a43ad0f$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $b41dad99a64d5031$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $b41dad99a64d5031$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $b41dad99a64d5031$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $b41dad99a64d5031$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $b41dad99a64d5031$var$getBoundingRect(rects) {
    const minX = (0, $999c052b5a43ad0f$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $999c052b5a43ad0f$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $999c052b5a43ad0f$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $999c052b5a43ad0f$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $b41dad99a64d5031$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $999c052b5a43ad0f$export$ee05aea0aeecbad4)($b41dad99a64d5031$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $b41dad99a64d5031$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $999c052b5a43ad0f$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $b41dad99a64d5031$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $999c052b5a43ad0f$export$ee05aea0aeecbad4)($b41dad99a64d5031$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $999c052b5a43ad0f$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $999c052b5a43ad0f$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $999c052b5a43ad0f$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $999c052b5a43ad0f$export$ee05aea0aeecbad4)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $999c052b5a43ad0f$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $999c052b5a43ad0f$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $999c052b5a43ad0f$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $999c052b5a43ad0f$export$ee05aea0aeecbad4)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $b41dad99a64d5031$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $b41dad99a64d5031$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $999c052b5a43ad0f$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $999c052b5a43ad0f$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $999c052b5a43ad0f$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $b41dad99a64d5031$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $999c052b5a43ad0f$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $b41dad99a64d5031$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $b41dad99a64d5031$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $b41dad99a64d5031$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $999c052b5a43ad0f$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $999c052b5a43ad0f$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $999c052b5a43ad0f$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $999c052b5a43ad0f$export$7d15b64cf5a3a4c4)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $b41dad99a64d5031$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $999c052b5a43ad0f$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $999c052b5a43ad0f$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $999c052b5a43ad0f$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $999c052b5a43ad0f$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $b41dad99a64d5031$var$originSides.has((0, $999c052b5a43ad0f$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $b41dad99a64d5031$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $999c052b5a43ad0f$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $999c052b5a43ad0f$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $999c052b5a43ad0f$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $999c052b5a43ad0f$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $999c052b5a43ad0f$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $999c052b5a43ad0f$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $999c052b5a43ad0f$export$8960430cfd85939f)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $999c052b5a43ad0f$export$8960430cfd85939f)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $9cafd3ff416294a1$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $9cafd3ff416294a1$export$651544f548703224(node) {
    if ($9cafd3ff416294a1$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $9cafd3ff416294a1$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $9cafd3ff416294a1$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($9cafd3ff416294a1$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $9cafd3ff416294a1$export$8ee0fc9ee280b4ee(value) {
    if (!$9cafd3ff416294a1$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $9cafd3ff416294a1$export$38b2d434cce3ea22(value).Node;
}
function $9cafd3ff416294a1$export$45a5e7f76e0caa8d(value) {
    if (!$9cafd3ff416294a1$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $9cafd3ff416294a1$export$38b2d434cce3ea22(value).Element;
}
function $9cafd3ff416294a1$export$1b3bfaa9684536aa(value) {
    if (!$9cafd3ff416294a1$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $9cafd3ff416294a1$export$38b2d434cce3ea22(value).HTMLElement;
}
function $9cafd3ff416294a1$export$af51f0f06c0f328a(value) {
    if (!$9cafd3ff416294a1$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $9cafd3ff416294a1$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $9cafd3ff416294a1$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $9cafd3ff416294a1$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $9cafd3ff416294a1$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($9cafd3ff416294a1$export$651544f548703224(element));
}
function $9cafd3ff416294a1$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $9cafd3ff416294a1$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $9cafd3ff416294a1$var$containRe = /paint|layout|strict|content/;
const $9cafd3ff416294a1$var$isNotNone = (value)=>!!value && value !== 'none';
let $9cafd3ff416294a1$var$isWebKitValue;
function $9cafd3ff416294a1$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $9cafd3ff416294a1$export$45a5e7f76e0caa8d(elementOrCss) ? $9cafd3ff416294a1$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $9cafd3ff416294a1$var$isNotNone(css.transform) || $9cafd3ff416294a1$var$isNotNone(css.translate) || $9cafd3ff416294a1$var$isNotNone(css.scale) || $9cafd3ff416294a1$var$isNotNone(css.rotate) || $9cafd3ff416294a1$var$isNotNone(css.perspective) || !$9cafd3ff416294a1$export$78551043582a6a98() && ($9cafd3ff416294a1$var$isNotNone(css.backdropFilter) || $9cafd3ff416294a1$var$isNotNone(css.filter)) || $9cafd3ff416294a1$var$willChangeRe.test(css.willChange || '') || $9cafd3ff416294a1$var$containRe.test(css.contain || '');
}
function $9cafd3ff416294a1$export$940d8225183e1404(element) {
    let currentNode = $9cafd3ff416294a1$export$4e12058fc4d51d56(element);
    while($9cafd3ff416294a1$export$1b3bfaa9684536aa(currentNode) && !$9cafd3ff416294a1$export$d1162fb0b6d4cd51(currentNode)){
        if ($9cafd3ff416294a1$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($9cafd3ff416294a1$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $9cafd3ff416294a1$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $9cafd3ff416294a1$export$78551043582a6a98() {
    if ($9cafd3ff416294a1$var$isWebKitValue == null) $9cafd3ff416294a1$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $9cafd3ff416294a1$var$isWebKitValue;
}
function $9cafd3ff416294a1$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($9cafd3ff416294a1$export$651544f548703224(node));
}
function $9cafd3ff416294a1$export$3735103072e4a80(element) {
    return $9cafd3ff416294a1$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $9cafd3ff416294a1$export$dc8fc79fa2800137(element) {
    if ($9cafd3ff416294a1$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $9cafd3ff416294a1$export$4e12058fc4d51d56(node) {
    if ($9cafd3ff416294a1$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $9cafd3ff416294a1$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $9cafd3ff416294a1$export$e495491855dc5418(node);
    return $9cafd3ff416294a1$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $9cafd3ff416294a1$export$7cd01a57c8ca906c(node) {
    const parentNode = $9cafd3ff416294a1$export$4e12058fc4d51d56(node);
    if ($9cafd3ff416294a1$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($9cafd3ff416294a1$export$1b3bfaa9684536aa(parentNode) && $9cafd3ff416294a1$export$989e911fa9af580a(parentNode)) return parentNode;
    return $9cafd3ff416294a1$export$7cd01a57c8ca906c(parentNode);
}
function $9cafd3ff416294a1$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $9cafd3ff416294a1$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $9cafd3ff416294a1$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $9cafd3ff416294a1$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $9cafd3ff416294a1$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $9cafd3ff416294a1$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $9cafd3ff416294a1$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $9cafd3ff416294a1$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $995799f803b32591$var$getCssDimensions(element) {
    const css = (0, $9cafd3ff416294a1$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $9cafd3ff416294a1$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $999c052b5a43ad0f$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $999c052b5a43ad0f$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $995799f803b32591$var$unwrapElement(element) {
    return !(0, $9cafd3ff416294a1$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $995799f803b32591$var$getScale(element) {
    const domElement = $995799f803b32591$var$unwrapElement(element);
    if (!(0, $9cafd3ff416294a1$export$1b3bfaa9684536aa)(domElement)) return (0, $999c052b5a43ad0f$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $995799f803b32591$var$getCssDimensions(domElement);
    let x = ($ ? (0, $999c052b5a43ad0f$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $999c052b5a43ad0f$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $995799f803b32591$var$noOffsets = /*#__PURE__*/ (0, $999c052b5a43ad0f$export$a397704b5e280835)(0);
function $995799f803b32591$var$getVisualOffsets(element) {
    const win = (0, $9cafd3ff416294a1$export$38b2d434cce3ea22)(element);
    if (!(0, $9cafd3ff416294a1$export$78551043582a6a98)() || !win.visualViewport) return $995799f803b32591$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $995799f803b32591$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $9cafd3ff416294a1$export$38b2d434cce3ea22)(element);
}
function $995799f803b32591$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $995799f803b32591$var$unwrapElement(element);
    let scale = (0, $999c052b5a43ad0f$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $9cafd3ff416294a1$export$45a5e7f76e0caa8d)(offsetParent)) scale = $995799f803b32591$var$getScale(offsetParent);
        } else scale = $995799f803b32591$var$getScale(element);
    }
    const visualOffsets = $995799f803b32591$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $995799f803b32591$var$getVisualOffsets(domElement) : (0, $999c052b5a43ad0f$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $9cafd3ff416294a1$export$38b2d434cce3ea22)(domElement);
        const offsetWin = (0, $9cafd3ff416294a1$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $9cafd3ff416294a1$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $9cafd3ff416294a1$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $995799f803b32591$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $9cafd3ff416294a1$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $9cafd3ff416294a1$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $9cafd3ff416294a1$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $999c052b5a43ad0f$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $995799f803b32591$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $9cafd3ff416294a1$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $995799f803b32591$var$getBoundingClientRect((0, $9cafd3ff416294a1$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $995799f803b32591$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $995799f803b32591$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $995799f803b32591$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $9cafd3ff416294a1$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $9cafd3ff416294a1$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $999c052b5a43ad0f$export$a397704b5e280835)(1);
    const offsets = (0, $999c052b5a43ad0f$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $9cafd3ff416294a1$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $9cafd3ff416294a1$export$651544f548703224)(offsetParent) !== 'body' || (0, $9cafd3ff416294a1$export$989e911fa9af580a)(documentElement)) scroll = (0, $9cafd3ff416294a1$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $995799f803b32591$var$getBoundingClientRect(offsetParent);
            scale = $995799f803b32591$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $995799f803b32591$var$getHTMLOffset(documentElement, scroll) : (0, $999c052b5a43ad0f$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $995799f803b32591$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $995799f803b32591$var$getDocumentRect(html) {
    const scroll = (0, $9cafd3ff416294a1$export$dc8fc79fa2800137)(html);
    const body = html.ownerDocument.body;
    const width = (0, $999c052b5a43ad0f$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $999c052b5a43ad0f$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $995799f803b32591$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $9cafd3ff416294a1$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $999c052b5a43ad0f$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $995799f803b32591$var$SCROLLBAR_MAX = 25;
function $995799f803b32591$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, $9cafd3ff416294a1$export$38b2d434cce3ea22)(element);
    const html = (0, $9cafd3ff416294a1$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $9cafd3ff416294a1$export$78551043582a6a98)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $995799f803b32591$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $995799f803b32591$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $995799f803b32591$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $995799f803b32591$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $995799f803b32591$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $995799f803b32591$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $995799f803b32591$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $995799f803b32591$var$getDocumentRect((0, $9cafd3ff416294a1$export$e495491855dc5418)(element));
    else if ((0, $9cafd3ff416294a1$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $995799f803b32591$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $995799f803b32591$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $999c052b5a43ad0f$export$ee05aea0aeecbad4)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $995799f803b32591$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $9cafd3ff416294a1$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $9cafd3ff416294a1$export$45a5e7f76e0caa8d)(el) && (0, $9cafd3ff416294a1$export$651544f548703224)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $9cafd3ff416294a1$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $9cafd3ff416294a1$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $9cafd3ff416294a1$export$45a5e7f76e0caa8d)(currentNode) && !(0, $9cafd3ff416294a1$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $9cafd3ff416294a1$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $9cafd3ff416294a1$export$d6c4e8150c35fed1)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $9cafd3ff416294a1$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $995799f803b32591$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $9cafd3ff416294a1$export$89e651af02346cd4)(element) ? [] : $995799f803b32591$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $995799f803b32591$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $995799f803b32591$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $999c052b5a43ad0f$export$8960430cfd85939f)(rect.top, top);
        right = (0, $999c052b5a43ad0f$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $999c052b5a43ad0f$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $999c052b5a43ad0f$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $995799f803b32591$var$getDimensions(element) {
    const { width: width, height: height } = $995799f803b32591$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $995799f803b32591$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $9cafd3ff416294a1$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $9cafd3ff416294a1$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $995799f803b32591$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $999c052b5a43ad0f$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $9cafd3ff416294a1$export$651544f548703224)(offsetParent) !== 'body' || (0, $9cafd3ff416294a1$export$989e911fa9af580a)(documentElement)) scroll = (0, $9cafd3ff416294a1$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $995799f803b32591$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $995799f803b32591$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $995799f803b32591$var$getHTMLOffset(documentElement, scroll) : (0, $999c052b5a43ad0f$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $995799f803b32591$var$isStaticPositioned(element) {
    return (0, $9cafd3ff416294a1$export$3735103072e4a80)(element).position === 'static';
}
function $995799f803b32591$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $9cafd3ff416294a1$export$1b3bfaa9684536aa)(element) || (0, $9cafd3ff416294a1$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $9cafd3ff416294a1$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $995799f803b32591$var$getOffsetParent(element, polyfill) {
    const win = (0, $9cafd3ff416294a1$export$38b2d434cce3ea22)(element);
    if ((0, $9cafd3ff416294a1$export$89e651af02346cd4)(element)) return win;
    if (!(0, $9cafd3ff416294a1$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $9cafd3ff416294a1$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $9cafd3ff416294a1$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $9cafd3ff416294a1$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$995799f803b32591$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $9cafd3ff416294a1$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $995799f803b32591$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $9cafd3ff416294a1$export$71535ffaa902797f)(offsetParent) && $995799f803b32591$var$isStaticPositioned(offsetParent))offsetParent = $995799f803b32591$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $9cafd3ff416294a1$export$d1162fb0b6d4cd51)(offsetParent) && $995799f803b32591$var$isStaticPositioned(offsetParent) && !(0, $9cafd3ff416294a1$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $9cafd3ff416294a1$export$940d8225183e1404)(element) || win;
}
const $995799f803b32591$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $995799f803b32591$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $995799f803b32591$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $995799f803b32591$var$isRTL(element) {
    return (0, $9cafd3ff416294a1$export$3735103072e4a80)(element).direction === 'rtl';
}
const $995799f803b32591$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $995799f803b32591$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $9cafd3ff416294a1$export$e495491855dc5418,
    getClippingRect: $995799f803b32591$var$getClippingRect,
    getOffsetParent: $995799f803b32591$var$getOffsetParent,
    getElementRects: $995799f803b32591$var$getElementRects,
    getClientRects: $995799f803b32591$var$getClientRects,
    getDimensions: $995799f803b32591$var$getDimensions,
    getScale: $995799f803b32591$var$getScale,
    isElement: $9cafd3ff416294a1$export$45a5e7f76e0caa8d,
    isRTL: $995799f803b32591$var$isRTL
};
function $995799f803b32591$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $995799f803b32591$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $9cafd3ff416294a1$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $999c052b5a43ad0f$export$a3fe094919f356fd)(top);
        const insetRight = (0, $999c052b5a43ad0f$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $999c052b5a43ad0f$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $999c052b5a43ad0f$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $999c052b5a43ad0f$export$8960430cfd85939f)(0, (0, $999c052b5a43ad0f$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$995799f803b32591$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $9cafd3ff416294a1$export$38b2d434cce3ea22)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $995799f803b32591$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $995799f803b32591$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $9cafd3ff416294a1$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $9cafd3ff416294a1$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $995799f803b32591$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $995799f803b32591$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $995799f803b32591$var$getBoundingClientRect(reference);
        if (prevRefRect && !$995799f803b32591$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $995799f803b32591$export$37b6bde19b108ecc = (0, $b41dad99a64d5031$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $995799f803b32591$export$cc800923e997bb8 = (0, $b41dad99a64d5031$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $995799f803b32591$export$91fb6ecbd551914 = (0, $b41dad99a64d5031$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $995799f803b32591$export$fba63a578e423eb = (0, $b41dad99a64d5031$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $995799f803b32591$export$8a83211c878a3f1f = (0, $b41dad99a64d5031$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $995799f803b32591$export$346677f925de839c = (0, $b41dad99a64d5031$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $995799f803b32591$export$fe8985bb6374093c = (0, $b41dad99a64d5031$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $995799f803b32591$export$f2120bbfa5450bd2 = (0, $b41dad99a64d5031$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $995799f803b32591$export$18c8ad048e32c7d5 = (0, $b41dad99a64d5031$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $995799f803b32591$export$7bf07e38f3dc4b69 = (0, $b41dad99a64d5031$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $995799f803b32591$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$995799f803b32591$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $b41dad99a64d5031$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $eeyUA = parcelRequire("eeyUA");
var $b945da23e06ac9fc$export$2e2bcd8739ae039 = (0, $eeyUA.useLayoutEffect);


var $ff70ed66f0d56426$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $ff70ed66f0d56426$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $ff70ed66f0d56426$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $ff70ed66f0d56426$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($ff70ed66f0d56426$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $ff70ed66f0d56426$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($ff70ed66f0d56426$var$isArray(value)) return value.filter(Boolean);
    if ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $ff70ed66f0d56426$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(props, $ff70ed66f0d56426$var$_excluded$4);
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $ff70ed66f0d56426$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $ff70ed66f0d56426$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $ff70ed66f0d56426$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $ff70ed66f0d56426$var$normalizedHeight(el) {
    if ($ff70ed66f0d56426$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $ff70ed66f0d56426$var$getScrollTop(el) {
    if ($ff70ed66f0d56426$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $ff70ed66f0d56426$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($ff70ed66f0d56426$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $ff70ed66f0d56426$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $ff70ed66f0d56426$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $ff70ed66f0d56426$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $ff70ed66f0d56426$export$b4171a6734a65d42;
    var start = $ff70ed66f0d56426$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $ff70ed66f0d56426$var$easeOutCubic(currentTime, start, change, duration);
        $ff70ed66f0d56426$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $ff70ed66f0d56426$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $ff70ed66f0d56426$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $ff70ed66f0d56426$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $ff70ed66f0d56426$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $ff70ed66f0d56426$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $ff70ed66f0d56426$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $ff70ed66f0d56426$var$passiveOptionAccessed = false;
var $ff70ed66f0d56426$var$options = {
    get passive () {
        return $ff70ed66f0d56426$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $ff70ed66f0d56426$var$w = typeof window !== 'undefined' ? window : {};
if ($ff70ed66f0d56426$var$w.addEventListener && $ff70ed66f0d56426$var$w.removeEventListener) {
    $ff70ed66f0d56426$var$w.addEventListener('p', $ff70ed66f0d56426$export$b4171a6734a65d42, $ff70ed66f0d56426$var$options);
    $ff70ed66f0d56426$var$w.removeEventListener('p', $ff70ed66f0d56426$export$b4171a6734a65d42, false);
}
var $ff70ed66f0d56426$export$2408f22a0fab9ae5 = $ff70ed66f0d56426$var$passiveOptionAccessed;
function $ff70ed66f0d56426$export$3466f893ebf79586(item) {
    return item != null;
}
function $ff70ed66f0d56426$var$isArray(arg) {
    return Array.isArray(arg);
}
function $ff70ed66f0d56426$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $ff70ed66f0d56426$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $ff70ed66f0d56426$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $ff70ed66f0d56426$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $ff70ed66f0d56426$var$_excluded$3 = [
    "children",
    "innerProps"
], $ff70ed66f0d56426$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $ff70ed66f0d56426$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $ff70ed66f0d56426$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $ff70ed66f0d56426$var$normalizedHeight(scrollParent);
    var scrollTop = $ff70ed66f0d56426$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $ff70ed66f0d56426$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $ff70ed66f0d56426$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $ff70ed66f0d56426$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $ff70ed66f0d56426$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $ff70ed66f0d56426$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $ff70ed66f0d56426$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $ff70ed66f0d56426$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $ff70ed66f0d56426$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(_objectSpread2, $ff70ed66f0d56426$var$alignToControl(placement), '100%'), (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $ff70ed66f0d56426$var$PortalPlacementContext = /*#__PURE__*/ (0, $eeyUA.createContext)(null);
// NOTE: internal only
var $ff70ed66f0d56426$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eeyUA.useContext)($ff70ed66f0d56426$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eeyUA.useRef)(null);
    var _useState = (0, $eeyUA.useState)(maxMenuHeight), _useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eeyUA.useState)(null), _useState4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $b945da23e06ac9fc$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $ff70ed66f0d56426$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $ff70ed66f0d56426$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $ff70ed66f0d56426$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $ff70ed66f0d56426$var$Menu$1 = $ff70ed66f0d56426$var$Menu;
// ==============================
// Menu List
// ==============================
var $ff70ed66f0d56426$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $ff70ed66f0d56426$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $ff70ed66f0d56426$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $ff70ed66f0d56426$export$3b14a55fb2447963 = $ff70ed66f0d56426$var$noticeCSS;
var $ff70ed66f0d56426$export$342063e11d6c3cad = $ff70ed66f0d56426$var$noticeCSS;
var $ff70ed66f0d56426$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_ref6, $ff70ed66f0d56426$var$_excluded$3);
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $ff70ed66f0d56426$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_ref7, $ff70ed66f0d56426$var$_excluded2$1);
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $ff70ed66f0d56426$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $ff70ed66f0d56426$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eeyUA.useRef)(null);
    var cleanupRef = (0, $eeyUA.useRef)(null);
    var _useState5 = (0, $eeyUA.useState)($ff70ed66f0d56426$var$coercePlacement(menuPlacement)), _useState6 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eeyUA.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eeyUA.useState)(null), _useState8 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eeyUA.useCallback)(function() {
        if (!controlElement) return;
        var rect = $ff70ed66f0d56426$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $b945da23e06ac9fc$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eeyUA.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $995799f803b32591$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $b945da23e06ac9fc$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eeyUA.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({
        ref: setMenuPortalElement
    }, $ff70ed66f0d56426$var$getStyleProps((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)($ff70ed66f0d56426$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $6568ab17ba5c963b$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $ff70ed66f0d56426$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $ff70ed66f0d56426$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $ff70ed66f0d56426$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $ff70ed66f0d56426$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $ff70ed66f0d56426$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $ff70ed66f0d56426$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $ff70ed66f0d56426$var$_templateObject;
var $ff70ed66f0d56426$var$_excluded$2 = [
    "size"
], $ff70ed66f0d56426$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $ff70ed66f0d56426$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $ff70ed66f0d56426$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $ff70ed66f0d56426$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_ref, $ff70ed66f0d56426$var$_excluded$2);
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("svg", (0, $7Nobb.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $ff70ed66f0d56426$var$_ref2
    }, props));
};
var $ff70ed66f0d56426$var$CrossIcon = function CrossIcon(props) {
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)($ff70ed66f0d56426$var$Svg, (0, $7Nobb.default)({
        size: 20
    }, props), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $ff70ed66f0d56426$var$DownChevron = function DownChevron(props) {
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)($ff70ed66f0d56426$var$Svg, (0, $7Nobb.default)({
        size: 20
    }, props), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $ff70ed66f0d56426$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $ff70ed66f0d56426$export$f1e1789686576879 = $ff70ed66f0d56426$var$baseCSS;
var $ff70ed66f0d56426$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)($ff70ed66f0d56426$var$DownChevron, null));
};
var $ff70ed66f0d56426$export$407448d2b89b1813 = $ff70ed66f0d56426$var$baseCSS;
var $ff70ed66f0d56426$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)($ff70ed66f0d56426$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $ff70ed66f0d56426$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $ff70ed66f0d56426$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("span", (0, $7Nobb.default)({}, innerProps, $ff70ed66f0d56426$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $ff70ed66f0d56426$var$loadingDotAnimations = (0, $f13d66bc12cdf03d$export$d25ddfdf17c3ad3e)($ff70ed66f0d56426$var$_templateObject || ($ff70ed66f0d56426$var$_templateObject = (0, $6fbe9f16bfdd9d95$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $ff70ed66f0d56426$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $ff70ed66f0d56426$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $f13d66bc12cdf03d$export$dbf350e5966cf602)({
            animation: "".concat($ff70ed66f0d56426$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $ff70ed66f0d56426$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_ref7, $ff70ed66f0d56426$var$_excluded2);
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)($ff70ed66f0d56426$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)($ff70ed66f0d56426$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)($ff70ed66f0d56426$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $ff70ed66f0d56426$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $ff70ed66f0d56426$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({
        ref: innerRef
    }, $ff70ed66f0d56426$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $ff70ed66f0d56426$var$Control$1 = $ff70ed66f0d56426$var$Control;
var $ff70ed66f0d56426$var$_excluded$1 = [
    "data"
];
var $ff70ed66f0d56426$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $ff70ed66f0d56426$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)(Heading, (0, $7Nobb.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", null, children));
};
var $ff70ed66f0d56426$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $ff70ed66f0d56426$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $ff70ed66f0d56426$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_cleanCommonProps, $ff70ed66f0d56426$var$_excluded$1);
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $ff70ed66f0d56426$var$Group$1 = $ff70ed66f0d56426$var$Group;
var $ff70ed66f0d56426$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $ff70ed66f0d56426$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $ff70ed66f0d56426$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $ff70ed66f0d56426$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $ff70ed66f0d56426$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $ff70ed66f0d56426$var$spacingStyle)
};
var $ff70ed66f0d56426$var$inputStyle = function inputStyle(isHidden) {
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $ff70ed66f0d56426$var$spacingStyle);
};
var $ff70ed66f0d56426$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $ff70ed66f0d56426$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_cleanCommonProps, $ff70ed66f0d56426$var$_excluded);
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("input", (0, $7Nobb.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $ff70ed66f0d56426$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $ff70ed66f0d56426$var$Input$1 = $ff70ed66f0d56426$var$Input;
var $ff70ed66f0d56426$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $ff70ed66f0d56426$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $ff70ed66f0d56426$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $ff70ed66f0d56426$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $ff70ed66f0d56426$var$MultiValueContainer = $ff70ed66f0d56426$var$MultiValueGeneric;
var $ff70ed66f0d56426$var$MultiValueLabel = $ff70ed66f0d56426$var$MultiValueGeneric;
function $ff70ed66f0d56426$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({
        role: "button"
    }, innerProps), children || (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)($ff70ed66f0d56426$var$CrossIcon, {
        size: 14
    }));
}
var $ff70ed66f0d56426$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $ff70ed66f0d56426$var$MultiValue$1 = $ff70ed66f0d56426$var$MultiValue;
var $ff70ed66f0d56426$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $ff70ed66f0d56426$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $ff70ed66f0d56426$var$Option$1 = $ff70ed66f0d56426$var$Option;
var $ff70ed66f0d56426$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $ff70ed66f0d56426$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $ff70ed66f0d56426$var$Placeholder$1 = $ff70ed66f0d56426$var$Placeholder;
var $ff70ed66f0d56426$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $ff70ed66f0d56426$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", (0, $7Nobb.default)({}, $ff70ed66f0d56426$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $ff70ed66f0d56426$var$SingleValue$1 = $ff70ed66f0d56426$var$SingleValue;
var $ff70ed66f0d56426$export$db3b6bfb95261072 = {
    ClearIndicator: $ff70ed66f0d56426$var$ClearIndicator,
    Control: $ff70ed66f0d56426$var$Control$1,
    DropdownIndicator: $ff70ed66f0d56426$var$DropdownIndicator,
    DownChevron: $ff70ed66f0d56426$var$DownChevron,
    CrossIcon: $ff70ed66f0d56426$var$CrossIcon,
    Group: $ff70ed66f0d56426$var$Group$1,
    GroupHeading: $ff70ed66f0d56426$var$GroupHeading,
    IndicatorsContainer: $ff70ed66f0d56426$var$IndicatorsContainer,
    IndicatorSeparator: $ff70ed66f0d56426$var$IndicatorSeparator,
    Input: $ff70ed66f0d56426$var$Input$1,
    LoadingIndicator: $ff70ed66f0d56426$var$LoadingIndicator,
    Menu: $ff70ed66f0d56426$var$Menu$1,
    MenuList: $ff70ed66f0d56426$var$MenuList,
    MenuPortal: $ff70ed66f0d56426$var$MenuPortal,
    LoadingMessage: $ff70ed66f0d56426$var$LoadingMessage,
    NoOptionsMessage: $ff70ed66f0d56426$var$NoOptionsMessage,
    MultiValue: $ff70ed66f0d56426$var$MultiValue$1,
    MultiValueContainer: $ff70ed66f0d56426$var$MultiValueContainer,
    MultiValueLabel: $ff70ed66f0d56426$var$MultiValueLabel,
    MultiValueRemove: $ff70ed66f0d56426$var$MultiValueRemove,
    Option: $ff70ed66f0d56426$var$Option$1,
    Placeholder: $ff70ed66f0d56426$var$Placeholder$1,
    SelectContainer: $ff70ed66f0d56426$var$SelectContainer,
    SingleValue: $ff70ed66f0d56426$var$SingleValue$1,
    ValueContainer: $ff70ed66f0d56426$var$ValueContainer
};
var $ff70ed66f0d56426$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, $ff70ed66f0d56426$export$db3b6bfb95261072), props.components);
};





var $eeyUA = parcelRequire("eeyUA");
var $fee7922a71d63233$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $fee7922a71d63233$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_ref, $fee7922a71d63233$var$_excluded);
    var _useState = (0, $eeyUA.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eeyUA.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eeyUA.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eeyUA.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eeyUA.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eeyUA.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eeyUA.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}



var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");

var $7Nobb = parcelRequire("7Nobb");

function $827123db267e1039$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $055f1aac98d71283$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $cfcc8bf67e2ae284$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $055f1aac98d71283$export$2e2bcd8739ae039(e, r, t) {
    return r && $055f1aac98d71283$var$_defineProperties(e.prototype, r), t && $055f1aac98d71283$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $f165bc1d5e47b973$export$2e2bcd8739ae039(t, e) {
    return $f165bc1d5e47b973$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $f165bc1d5e47b973$export$2e2bcd8739ae039(t, e);
}


function $6a4c2bdb64108a28$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $f165bc1d5e47b973$export$2e2bcd8739ae039)(t, e);
}


function $e20481fbceebf07e$export$2e2bcd8739ae039(t) {
    return $e20481fbceebf07e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e20481fbceebf07e$export$2e2bcd8739ae039(t);
}


function $e6710e827d4afd27$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e6710e827d4afd27$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $7e5561df6a152bb7$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $1b10256a60f0250e$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(t);
}


function $7104bbef2c357751$export$2e2bcd8739ae039(t) {
    var r = (0, $e6710e827d4afd27$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $e20481fbceebf07e$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $e20481fbceebf07e$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $1b10256a60f0250e$export$2e2bcd8739ae039)(this, e);
    };
}



function $838ff134510ff4d8$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $a7cfad0be490bfd9$export$2e2bcd8739ae039)(r);
}


function $cea7bea6a572eabb$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $166adba453ee2d50$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $3440102357566473$export$2e2bcd8739ae039(r) {
    return (0, $838ff134510ff4d8$export$2e2bcd8739ae039)(r) || (0, $cea7bea6a572eabb$export$2e2bcd8739ae039)(r) || (0, $31afbef354c99f62$export$2e2bcd8739ae039)(r) || (0, $166adba453ee2d50$export$2e2bcd8739ae039)();
}



var $eeyUA = parcelRequire("eeyUA");


var $144e27fd8686da5e$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $144e27fd8686da5e$var$isEqual(first, second) {
    if (first === second) return true;
    if ($144e27fd8686da5e$var$safeIsNaN(first) && $144e27fd8686da5e$var$safeIsNaN(second)) return true;
    return false;
}
function $144e27fd8686da5e$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$144e27fd8686da5e$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $144e27fd8686da5e$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $144e27fd8686da5e$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $0ad943b26790f691$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $0ad943b26790f691$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $0ad943b26790f691$var$A11yText = function A11yText(props) {
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("span", (0, $7Nobb.default)({
        css: $0ad943b26790f691$var$_ref
    }, props));
};
var $0ad943b26790f691$var$A11yText$1 = $0ad943b26790f691$var$A11yText;
var $0ad943b26790f691$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $0ad943b26790f691$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eeyUA.useMemo)(function() {
        return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, $0ad943b26790f691$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eeyUA.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eeyUA.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $eeyUA.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $eeyUA.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)((0, $eeyUA.Fragment), null, (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)((0, $eeyUA.Fragment), null, (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)($0ad943b26790f691$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)($0ad943b26790f691$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $0ad943b26790f691$var$LiveRegion$1 = $0ad943b26790f691$var$LiveRegion;
var $0ad943b26790f691$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $0ad943b26790f691$var$anyDiacritic = new RegExp('[' + $0ad943b26790f691$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $0ad943b26790f691$var$diacriticToBase = {};
for(var $0ad943b26790f691$var$i = 0; $0ad943b26790f691$var$i < $0ad943b26790f691$var$diacritics.length; $0ad943b26790f691$var$i++){
    var $0ad943b26790f691$var$diacritic = $0ad943b26790f691$var$diacritics[$0ad943b26790f691$var$i];
    for(var $0ad943b26790f691$var$j = 0; $0ad943b26790f691$var$j < $0ad943b26790f691$var$diacritic.letters.length; $0ad943b26790f691$var$j++)$0ad943b26790f691$var$diacriticToBase[$0ad943b26790f691$var$diacritic.letters[$0ad943b26790f691$var$j]] = $0ad943b26790f691$var$diacritic.base;
}
var $0ad943b26790f691$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($0ad943b26790f691$var$anyDiacritic, function(match) {
        return $0ad943b26790f691$var$diacriticToBase[match];
    });
};
var $0ad943b26790f691$var$memoizedStripDiacriticsForInput = (0, $144e27fd8686da5e$export$2e2bcd8739ae039)($0ad943b26790f691$var$stripDiacritics);
var $0ad943b26790f691$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $0ad943b26790f691$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $0ad943b26790f691$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $0ad943b26790f691$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $0ad943b26790f691$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $0ad943b26790f691$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $0ad943b26790f691$var$memoizedStripDiacriticsForInput(input);
            candidate = $0ad943b26790f691$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $0ad943b26790f691$var$_excluded = [
    "innerRef"
];
function $0ad943b26790f691$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_ref, $0ad943b26790f691$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $ff70ed66f0d56426$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("input", (0, $7Nobb.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $f13d66bc12cdf03d$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $0ad943b26790f691$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $0ad943b26790f691$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eeyUA.useRef)(false);
    var isTop = (0, $eeyUA.useRef)(false);
    var touchStart = (0, $eeyUA.useRef)(0);
    var scrollTarget = (0, $eeyUA.useRef)(null);
    var handleEventDelta = (0, $eeyUA.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $0ad943b26790f691$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eeyUA.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eeyUA.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eeyUA.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eeyUA.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $ff70ed66f0d56426$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eeyUA.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eeyUA.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $0ad943b26790f691$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $0ad943b26790f691$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $0ad943b26790f691$var$preventTouchMove(e) {
    e.preventDefault();
}
function $0ad943b26790f691$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $0ad943b26790f691$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $0ad943b26790f691$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $0ad943b26790f691$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $0ad943b26790f691$var$activeScrollLocks = 0;
var $0ad943b26790f691$var$listenerOptions = {
    capture: false,
    passive: false
};
function $0ad943b26790f691$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eeyUA.useRef)({});
    var scrollTarget = (0, $eeyUA.useRef)(null);
    var addScrollLock = (0, $eeyUA.useCallback)(function(touchScrollTarget) {
        if (!$0ad943b26790f691$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $0ad943b26790f691$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $0ad943b26790f691$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($0ad943b26790f691$var$LOCK_STYLES).forEach(function(key) {
                var val = $0ad943b26790f691$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $0ad943b26790f691$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $0ad943b26790f691$var$preventTouchMove, $0ad943b26790f691$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $0ad943b26790f691$var$preventInertiaScroll, $0ad943b26790f691$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $0ad943b26790f691$var$allowTouchMove, $0ad943b26790f691$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $0ad943b26790f691$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eeyUA.useCallback)(function(touchScrollTarget) {
        if (!$0ad943b26790f691$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $0ad943b26790f691$var$activeScrollLocks = Math.max($0ad943b26790f691$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $0ad943b26790f691$var$activeScrollLocks < 1) $0ad943b26790f691$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $0ad943b26790f691$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $0ad943b26790f691$var$preventTouchMove, $0ad943b26790f691$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $0ad943b26790f691$var$preventInertiaScroll, $0ad943b26790f691$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $0ad943b26790f691$var$allowTouchMove, $0ad943b26790f691$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eeyUA.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $0ad943b26790f691$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0ad943b26790f691$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $0ad943b26790f691$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $0ad943b26790f691$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $0ad943b26790f691$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $0ad943b26790f691$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)((0, $eeyUA.Fragment), null, lockEnabled && (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("div", {
        onClick: $0ad943b26790f691$var$blurSelectInput,
        css: $0ad943b26790f691$var$_ref2$1
    }), children(targetRef));
}
function $0ad943b26790f691$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0ad943b26790f691$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $0ad943b26790f691$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $f13d66bc12cdf03d$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $0ad943b26790f691$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $0ad943b26790f691$var$RequiredInput$1 = $0ad943b26790f691$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $0ad943b26790f691$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $0ad943b26790f691$var$isIPhone() {
    return $0ad943b26790f691$var$testPlatform(/^iPhone/i);
}
function $0ad943b26790f691$var$isMac() {
    return $0ad943b26790f691$var$testPlatform(/^Mac/i);
}
function $0ad943b26790f691$var$isIPad() {
    return $0ad943b26790f691$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $0ad943b26790f691$var$isMac() && navigator.maxTouchPoints > 1;
}
function $0ad943b26790f691$var$isIOS() {
    return $0ad943b26790f691$var$isIPhone() || $0ad943b26790f691$var$isIPad();
}
function $0ad943b26790f691$var$isAppleDevice() {
    return $0ad943b26790f691$var$isMac() || $0ad943b26790f691$var$isIOS();
}
var $0ad943b26790f691$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $0ad943b26790f691$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $0ad943b26790f691$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $0ad943b26790f691$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $0ad943b26790f691$var$defaultStyles = {
    clearIndicator: (0, $ff70ed66f0d56426$export$407448d2b89b1813),
    container: (0, $ff70ed66f0d56426$export$8b22cf2602fb60ce),
    control: (0, $ff70ed66f0d56426$export$4368d992c4eafac0),
    dropdownIndicator: (0, $ff70ed66f0d56426$export$f1e1789686576879),
    group: (0, $ff70ed66f0d56426$export$39b482c5e57630a8),
    groupHeading: (0, $ff70ed66f0d56426$export$2d1720544b23b823),
    indicatorsContainer: (0, $ff70ed66f0d56426$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $ff70ed66f0d56426$export$dda1d9f60106f0e9),
    input: (0, $ff70ed66f0d56426$export$35e795649ee09318),
    loadingIndicator: (0, $ff70ed66f0d56426$export$882b5998b3b9117c),
    loadingMessage: (0, $ff70ed66f0d56426$export$342063e11d6c3cad),
    menu: (0, $ff70ed66f0d56426$export$953cecd6e717a553),
    menuList: (0, $ff70ed66f0d56426$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $ff70ed66f0d56426$export$ae1af26003f05816),
    multiValue: (0, $ff70ed66f0d56426$export$ffb5f4729a158638),
    multiValueLabel: (0, $ff70ed66f0d56426$export$9e5f44173e64f162),
    multiValueRemove: (0, $ff70ed66f0d56426$export$625550452a3fa3ec),
    noOptionsMessage: (0, $ff70ed66f0d56426$export$3b14a55fb2447963),
    option: (0, $ff70ed66f0d56426$export$90a7f3efeed30595),
    placeholder: (0, $ff70ed66f0d56426$export$efccba1c4a2ef57b),
    singleValue: (0, $ff70ed66f0d56426$export$d141bba7fdc215a3),
    valueContainer: (0, $ff70ed66f0d56426$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $0ad943b26790f691$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $0ad943b26790f691$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $0ad943b26790f691$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $0ad943b26790f691$var$baseUnit = 4;
// The minimum height of the control
var $0ad943b26790f691$var$controlHeight = 38;
// The amount of space between the control and menu */
var $0ad943b26790f691$var$menuGutter = $0ad943b26790f691$var$baseUnit * 2;
var $0ad943b26790f691$var$spacing = {
    baseUnit: $0ad943b26790f691$var$baseUnit,
    controlHeight: $0ad943b26790f691$var$controlHeight,
    menuGutter: $0ad943b26790f691$var$menuGutter
};
var $0ad943b26790f691$export$4368d992c4eafac0 = {
    borderRadius: $0ad943b26790f691$var$borderRadius,
    colors: $0ad943b26790f691$var$colors,
    spacing: $0ad943b26790f691$var$spacing
};
var $0ad943b26790f691$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $ff70ed66f0d56426$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $ff70ed66f0d56426$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $0ad943b26790f691$export$db3b6bfb95261072(),
    formatGroupLabel: $0ad943b26790f691$var$formatGroupLabel,
    getOptionLabel: $0ad943b26790f691$export$8b22cf2602fb60ce,
    getOptionValue: $0ad943b26790f691$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $0ad943b26790f691$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $ff70ed66f0d56426$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $0ad943b26790f691$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $0ad943b26790f691$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $0ad943b26790f691$var$_isOptionSelected(props, option, selectValue);
    var label = $0ad943b26790f691$var$getOptionLabel(props, option);
    var value = $0ad943b26790f691$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $0ad943b26790f691$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $0ad943b26790f691$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $0ad943b26790f691$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $0ad943b26790f691$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $0ad943b26790f691$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $ff70ed66f0d56426$export$3466f893ebf79586));
}
function $0ad943b26790f691$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $3440102357566473$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $0ad943b26790f691$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $3440102357566473$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $0ad943b26790f691$var$buildFocusableOptions(props, selectValue) {
    return $0ad943b26790f691$var$buildFocusableOptionsFromCategorizedOptions($0ad943b26790f691$var$buildCategorizedOptions(props, selectValue));
}
function $0ad943b26790f691$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$0ad943b26790f691$var$shouldHideSelectedOptions(props) || !isSelected) && $0ad943b26790f691$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $0ad943b26790f691$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $0ad943b26790f691$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $0ad943b26790f691$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $0ad943b26790f691$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $0ad943b26790f691$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $0ad943b26790f691$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $0ad943b26790f691$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $0ad943b26790f691$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $0ad943b26790f691$var$getOptionValue(props, i) === candidate;
    });
}
function $0ad943b26790f691$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $0ad943b26790f691$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $0ad943b26790f691$var$instanceId = 1;
var $0ad943b26790f691$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $6a4c2bdb64108a28$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $7104bbef2c357751$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $0ad943b26790f691$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $ff70ed66f0d56426$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $ff70ed66f0d56426$export$ef35774e6d314e91)([].concat((0, $3440102357566473$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $ff70ed66f0d56426$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $ff70ed66f0d56426$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $ff70ed66f0d56426$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $ff70ed66f0d56426$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $ff70ed66f0d56426$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $0ad943b26790f691$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $0ad943b26790f691$var$buildFocusableOptionsWithIds($0ad943b26790f691$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $ff70ed66f0d56426$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $0ad943b26790f691$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $0ad943b26790f691$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $0ad943b26790f691$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $ff70ed66f0d56426$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $0ad943b26790f691$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $0ad943b26790f691$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $ff70ed66f0d56426$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $0ad943b26790f691$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$0ad943b26790f691$var$instanceId);
        _this.state.selectValue = (0, $ff70ed66f0d56426$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $0ad943b26790f691$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $ff70ed66f0d56426$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $ff70ed66f0d56426$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $0ad943b26790f691$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($0ad943b26790f691$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, $0ad943b26790f691$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $0ad943b26790f691$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $0ad943b26790f691$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $0ad943b26790f691$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eeyUA.createElement($0ad943b26790f691$var$DummyInput, (0, $7Nobb.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $ff70ed66f0d56426$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eeyUA.createElement(Input, (0, $7Nobb.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eeyUA.createElement(Placeholder, (0, $7Nobb.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eeyUA.createElement(MultiValue, (0, $7Nobb.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eeyUA.createElement(SingleValue, (0, $7Nobb.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eeyUA.createElement(ClearIndicator, (0, $7Nobb.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eeyUA.createElement(LoadingIndicator, (0, $7Nobb.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eeyUA.createElement(IndicatorSeparator, (0, $7Nobb.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eeyUA.createElement(DropdownIndicator, (0, $7Nobb.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $eeyUA.createElement(Option, (0, $7Nobb.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eeyUA.createElement(Group, (0, $7Nobb.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eeyUA.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eeyUA.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eeyUA.createElement((0, $ff70ed66f0d56426$export$3a1a48c8f6ef640e), (0, $7Nobb.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eeyUA.createElement(Menu, (0, $7Nobb.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eeyUA.createElement($0ad943b26790f691$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eeyUA.createElement(MenuList, (0, $7Nobb.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eeyUA.createElement(MenuPortal, (0, $7Nobb.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eeyUA.createElement($0ad943b26790f691$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eeyUA.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eeyUA.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eeyUA.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eeyUA.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eeyUA.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eeyUA.createElement($0ad943b26790f691$var$LiveRegion$1, (0, $7Nobb.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eeyUA.createElement(SelectContainer, (0, $7Nobb.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eeyUA.createElement(Control, (0, $7Nobb.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eeyUA.createElement(ValueContainer, (0, $7Nobb.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eeyUA.createElement(IndicatorsContainer, (0, $7Nobb.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $ff70ed66f0d56426$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $0ad943b26790f691$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $0ad943b26790f691$var$buildFocusableOptionsWithIds($0ad943b26790f691$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $0ad943b26790f691$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $0ad943b26790f691$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $0ad943b26790f691$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $ff70ed66f0d56426$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eeyUA.Component));
$0ad943b26790f691$export$25ce5a424b770e84.defaultProps = $0ad943b26790f691$export$407448d2b89b1813;




var $9qOEN = parcelRequire("9qOEN");

var $7084ff01a146cbb3$exports = {};
var $a151e2675be457a0$exports = {};
var $0362930e446e8dd8$exports = {};
var $46b6ad43d1e0dbf9$exports = {};
function $46b6ad43d1e0dbf9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $46b6ad43d1e0dbf9$exports = $46b6ad43d1e0dbf9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $46b6ad43d1e0dbf9$exports.__esModule = true, $46b6ad43d1e0dbf9$exports["default"] = $46b6ad43d1e0dbf9$exports, $46b6ad43d1e0dbf9$var$_typeof(o);
}
$46b6ad43d1e0dbf9$exports = $46b6ad43d1e0dbf9$var$_typeof, $46b6ad43d1e0dbf9$exports.__esModule = true, $46b6ad43d1e0dbf9$exports["default"] = $46b6ad43d1e0dbf9$exports;


var $0362930e446e8dd8$var$_typeof = $46b6ad43d1e0dbf9$exports.default;
var $879158a7b90a5b25$exports = {};

var $879158a7b90a5b25$var$_typeof = $46b6ad43d1e0dbf9$exports.default;
function $879158a7b90a5b25$var$toPrimitive(t, r) {
    if ("object" != $879158a7b90a5b25$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $879158a7b90a5b25$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$879158a7b90a5b25$exports = $879158a7b90a5b25$var$toPrimitive, $879158a7b90a5b25$exports.__esModule = true, $879158a7b90a5b25$exports["default"] = $879158a7b90a5b25$exports;


function $0362930e446e8dd8$var$toPropertyKey(t) {
    var i = $879158a7b90a5b25$exports(t, "string");
    return "symbol" == $0362930e446e8dd8$var$_typeof(i) ? i : i + "";
}
$0362930e446e8dd8$exports = $0362930e446e8dd8$var$toPropertyKey, $0362930e446e8dd8$exports.__esModule = true, $0362930e446e8dd8$exports["default"] = $0362930e446e8dd8$exports;


function $a151e2675be457a0$var$_defineProperty(e, r, t) {
    return (r = $0362930e446e8dd8$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$a151e2675be457a0$exports = $a151e2675be457a0$var$_defineProperty, $a151e2675be457a0$exports.__esModule = true, $a151e2675be457a0$exports["default"] = $a151e2675be457a0$exports;


function $7084ff01a146cbb3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7084ff01a146cbb3$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7084ff01a146cbb3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a151e2675be457a0$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7084ff01a146cbb3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$7084ff01a146cbb3$exports = $7084ff01a146cbb3$var$_objectSpread2, $7084ff01a146cbb3$exports.__esModule = true, $7084ff01a146cbb3$exports["default"] = $7084ff01a146cbb3$exports;


var $8c59e81fbdc580e3$exports = {};
var $0c420e1bdd712d25$exports = {};
function $0c420e1bdd712d25$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$0c420e1bdd712d25$exports = $0c420e1bdd712d25$var$_arrayWithHoles, $0c420e1bdd712d25$exports.__esModule = true, $0c420e1bdd712d25$exports["default"] = $0c420e1bdd712d25$exports;


var $9ac3444a24ab310b$exports = {};
function $9ac3444a24ab310b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$9ac3444a24ab310b$exports = $9ac3444a24ab310b$var$_iterableToArrayLimit, $9ac3444a24ab310b$exports.__esModule = true, $9ac3444a24ab310b$exports["default"] = $9ac3444a24ab310b$exports;


var $8561d5f571458fa0$exports = {};
var $90170c982c11d78f$exports = {};
function $90170c982c11d78f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$90170c982c11d78f$exports = $90170c982c11d78f$var$_arrayLikeToArray, $90170c982c11d78f$exports.__esModule = true, $90170c982c11d78f$exports["default"] = $90170c982c11d78f$exports;


function $8561d5f571458fa0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $90170c982c11d78f$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $90170c982c11d78f$exports(r, a) : void 0;
    }
}
$8561d5f571458fa0$exports = $8561d5f571458fa0$var$_unsupportedIterableToArray, $8561d5f571458fa0$exports.__esModule = true, $8561d5f571458fa0$exports["default"] = $8561d5f571458fa0$exports;


var $0d3a984499fe8a69$exports = {};
function $0d3a984499fe8a69$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$0d3a984499fe8a69$exports = $0d3a984499fe8a69$var$_nonIterableRest, $0d3a984499fe8a69$exports.__esModule = true, $0d3a984499fe8a69$exports["default"] = $0d3a984499fe8a69$exports;


function $8c59e81fbdc580e3$var$_slicedToArray(r, e) {
    return $0c420e1bdd712d25$exports(r) || $9ac3444a24ab310b$exports(r, e) || $8561d5f571458fa0$exports(r, e) || $0d3a984499fe8a69$exports();
}
$8c59e81fbdc580e3$exports = $8c59e81fbdc580e3$var$_slicedToArray, $8c59e81fbdc580e3$exports.__esModule = true, $8c59e81fbdc580e3$exports["default"] = $8c59e81fbdc580e3$exports;


var $1cd9adc72b89889f$exports = {};

var $h7coc = parcelRequire("h7coc");
function $1cd9adc72b89889f$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $h7coc(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$1cd9adc72b89889f$exports = $1cd9adc72b89889f$var$_objectWithoutProperties, $1cd9adc72b89889f$exports.__esModule = true, $1cd9adc72b89889f$exports["default"] = $1cd9adc72b89889f$exports;


var $c9f7e32026fd1f30$exports = {};
function $c9f7e32026fd1f30$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$c9f7e32026fd1f30$exports = $c9f7e32026fd1f30$var$_classCallCheck, $c9f7e32026fd1f30$exports.__esModule = true, $c9f7e32026fd1f30$exports["default"] = $c9f7e32026fd1f30$exports;


var $d3ae8be14a408633$exports = {};

function $d3ae8be14a408633$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $0362930e446e8dd8$exports(o.key), o);
    }
}
function $d3ae8be14a408633$var$_createClass(e, r, t) {
    return r && $d3ae8be14a408633$var$_defineProperties(e.prototype, r), t && $d3ae8be14a408633$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$d3ae8be14a408633$exports = $d3ae8be14a408633$var$_createClass, $d3ae8be14a408633$exports.__esModule = true, $d3ae8be14a408633$exports["default"] = $d3ae8be14a408633$exports;


var $1b8babc1525ded3a$exports = {};
var $4ae42a1c4101b000$exports = {};
function $4ae42a1c4101b000$var$_setPrototypeOf(t, e) {
    return $4ae42a1c4101b000$exports = $4ae42a1c4101b000$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $4ae42a1c4101b000$exports.__esModule = true, $4ae42a1c4101b000$exports["default"] = $4ae42a1c4101b000$exports, $4ae42a1c4101b000$var$_setPrototypeOf(t, e);
}
$4ae42a1c4101b000$exports = $4ae42a1c4101b000$var$_setPrototypeOf, $4ae42a1c4101b000$exports.__esModule = true, $4ae42a1c4101b000$exports["default"] = $4ae42a1c4101b000$exports;


function $1b8babc1525ded3a$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $4ae42a1c4101b000$exports(t, e);
}
$1b8babc1525ded3a$exports = $1b8babc1525ded3a$var$_inherits, $1b8babc1525ded3a$exports.__esModule = true, $1b8babc1525ded3a$exports["default"] = $1b8babc1525ded3a$exports;


var $9f94fd6568b3844e$exports = {};
var $5b1a6e44ca5125f4$exports = {};
function $5b1a6e44ca5125f4$var$_getPrototypeOf(t) {
    return $5b1a6e44ca5125f4$exports = $5b1a6e44ca5125f4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $5b1a6e44ca5125f4$exports.__esModule = true, $5b1a6e44ca5125f4$exports["default"] = $5b1a6e44ca5125f4$exports, $5b1a6e44ca5125f4$var$_getPrototypeOf(t);
}
$5b1a6e44ca5125f4$exports = $5b1a6e44ca5125f4$var$_getPrototypeOf, $5b1a6e44ca5125f4$exports.__esModule = true, $5b1a6e44ca5125f4$exports["default"] = $5b1a6e44ca5125f4$exports;


var $797f82d6fedc78ca$exports = {};
function $797f82d6fedc78ca$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($797f82d6fedc78ca$exports = $797f82d6fedc78ca$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, $797f82d6fedc78ca$exports.__esModule = true, $797f82d6fedc78ca$exports["default"] = $797f82d6fedc78ca$exports)();
}
$797f82d6fedc78ca$exports = $797f82d6fedc78ca$var$_isNativeReflectConstruct, $797f82d6fedc78ca$exports.__esModule = true, $797f82d6fedc78ca$exports["default"] = $797f82d6fedc78ca$exports;


var $4900c25d16e5e817$exports = {};

var $4900c25d16e5e817$var$_typeof = $46b6ad43d1e0dbf9$exports.default;
var $aa59959c9c58b61c$exports = {};
function $aa59959c9c58b61c$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$aa59959c9c58b61c$exports = $aa59959c9c58b61c$var$_assertThisInitialized, $aa59959c9c58b61c$exports.__esModule = true, $aa59959c9c58b61c$exports["default"] = $aa59959c9c58b61c$exports;


function $4900c25d16e5e817$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $4900c25d16e5e817$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $aa59959c9c58b61c$exports(t);
}
$4900c25d16e5e817$exports = $4900c25d16e5e817$var$_possibleConstructorReturn, $4900c25d16e5e817$exports.__esModule = true, $4900c25d16e5e817$exports["default"] = $4900c25d16e5e817$exports;


function $9f94fd6568b3844e$var$_createSuper(t) {
    var r = $797f82d6fedc78ca$exports();
    return function() {
        var e, o = $5b1a6e44ca5125f4$exports(t);
        if (r) {
            var s = $5b1a6e44ca5125f4$exports(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $4900c25d16e5e817$exports(this, e);
    };
}
$9f94fd6568b3844e$exports = $9f94fd6568b3844e$var$_createSuper, $9f94fd6568b3844e$exports.__esModule = true, $9f94fd6568b3844e$exports["default"] = $9f94fd6568b3844e$exports;


var $d795981720828bf5$exports = {};
var $d71eaefc8a73ce61$exports = {};

function $d71eaefc8a73ce61$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $90170c982c11d78f$exports(r);
}
$d71eaefc8a73ce61$exports = $d71eaefc8a73ce61$var$_arrayWithoutHoles, $d71eaefc8a73ce61$exports.__esModule = true, $d71eaefc8a73ce61$exports["default"] = $d71eaefc8a73ce61$exports;


var $58098692a3f5f223$exports = {};
function $58098692a3f5f223$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$58098692a3f5f223$exports = $58098692a3f5f223$var$_iterableToArray, $58098692a3f5f223$exports.__esModule = true, $58098692a3f5f223$exports["default"] = $58098692a3f5f223$exports;



var $8e3dff1931b8e811$exports = {};
function $8e3dff1931b8e811$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$8e3dff1931b8e811$exports = $8e3dff1931b8e811$var$_nonIterableSpread, $8e3dff1931b8e811$exports.__esModule = true, $8e3dff1931b8e811$exports["default"] = $8e3dff1931b8e811$exports;


function $d795981720828bf5$var$_toConsumableArray(r) {
    return $d71eaefc8a73ce61$exports(r) || $58098692a3f5f223$exports(r) || $8561d5f571458fa0$exports(r) || $8e3dff1931b8e811$exports();
}
$d795981720828bf5$exports = $d795981720828bf5$var$_toConsumableArray, $d795981720828bf5$exports.__esModule = true, $d795981720828bf5$exports["default"] = $d795981720828bf5$exports;




var $cb61ba54b6c1c56b$exports = {};
function $cb61ba54b6c1c56b$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
$cb61ba54b6c1c56b$exports = $cb61ba54b6c1c56b$var$_taggedTemplateLiteral, $cb61ba54b6c1c56b$exports.__esModule = true, $cb61ba54b6c1c56b$exports["default"] = $cb61ba54b6c1c56b$exports;






var $f7b5817f67dac20a$var$StateManagedSelect = /*#__PURE__*/ (0, $eeyUA.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $fee7922a71d63233$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $eeyUA.createElement((0, $0ad943b26790f691$export$25ce5a424b770e84), (0, $7Nobb.default)({
        ref: ref
    }, baseSelectProps));
});
var $f7b5817f67dac20a$export$2e2bcd8739ae039 = $f7b5817f67dac20a$var$StateManagedSelect;
var $f7b5817f67dac20a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eeyUA.useMemo)(function() {
        return (0, $9qOEN.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eeyUA.createElement((0, $2d12a1c9df581eb7$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};



var $7Nobb = parcelRequire("7Nobb");


function $7f5f83c736661bf2$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $f165bc1d5e47b973$export$2e2bcd8739ae039)(t, o);
}


var $dcd599196b00c1ed$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $dcd599196b00c1ed$var$isEqual(first, second) {
    if (first === second) return true;
    if ($dcd599196b00c1ed$var$safeIsNaN(first) && $dcd599196b00c1ed$var$safeIsNaN(second)) return true;
    return false;
}
function $dcd599196b00c1ed$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$dcd599196b00c1ed$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $dcd599196b00c1ed$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $dcd599196b00c1ed$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $dcd599196b00c1ed$export$2e2bcd8739ae039 = $dcd599196b00c1ed$var$memoizeOne;



var $eeyUA = parcelRequire("eeyUA");

var $8T8Yq = parcelRequire("8T8Yq");
// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $749f6ec63f6eddee$var$hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var $749f6ec63f6eddee$var$now = $749f6ec63f6eddee$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $749f6ec63f6eddee$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $749f6ec63f6eddee$var$requestTimeout(callback, delay) {
    var start = $749f6ec63f6eddee$var$now();
    function tick() {
        if ($749f6ec63f6eddee$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $749f6ec63f6eddee$var$size = -1; // This utility copied from "dom-helpers" package.
function $749f6ec63f6eddee$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($749f6ec63f6eddee$var$size === -1 || recalculate) {
        var div = document.createElement('div');
        var style = div.style;
        style.width = '50px';
        style.height = '50px';
        style.overflow = 'scroll';
        document.body.appendChild(div);
        $749f6ec63f6eddee$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $749f6ec63f6eddee$var$size;
}
var $749f6ec63f6eddee$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $749f6ec63f6eddee$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($749f6ec63f6eddee$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement('div');
        var outerStyle = outerDiv.style;
        outerStyle.width = '50px';
        outerStyle.height = '50px';
        outerStyle.overflow = 'scroll';
        outerStyle.direction = 'rtl';
        var innerDiv = document.createElement('div');
        var innerStyle = innerDiv.style;
        innerStyle.width = '100px';
        innerStyle.height = '100px';
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $749f6ec63f6eddee$var$cachedRTLResult = 'positive-descending';
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $749f6ec63f6eddee$var$cachedRTLResult = 'negative';
            else $749f6ec63f6eddee$var$cachedRTLResult = 'positive-ascending';
        }
        document.body.removeChild(outerDiv);
        return $749f6ec63f6eddee$var$cachedRTLResult;
    }
    return $749f6ec63f6eddee$var$cachedRTLResult;
}
var $749f6ec63f6eddee$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $749f6ec63f6eddee$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $749f6ec63f6eddee$var$devWarningsOverscanCount = null;
var $749f6ec63f6eddee$var$devWarningsOverscanRowsColumnsCount = null;
var $749f6ec63f6eddee$var$devWarningsTagName = null;
function $749f6ec63f6eddee$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $7f5f83c736661bf2$export$2e2bcd8739ae039)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                horizontalScrollDirection: 'forward',
                scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: 'forward'
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $dcd599196b00c1ed$export$2e2bcd8739ae039)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $dcd599196b00c1ed$export$2e2bcd8739ae039)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === 'rtl';
                    itemStyleCache[key] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $dcd599196b00c1ed$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === 'rtl') switch($749f6ec63f6eddee$var$getRTLOffsetType()){
                        case 'negative':
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case 'positive-descending':
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $749f6ec63f6eddee$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $749f6ec63f6eddee$var$requestTimeout(_this._resetIsScrolling, $749f6ec63f6eddee$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $749f6ec63f6eddee$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? 'auto' : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $749f6ec63f6eddee$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === 'number') outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === 'number') outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === 'rtl') switch($749f6ec63f6eddee$var$getRTLOffsetType()){
                    case 'negative':
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case 'positive-ascending':
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $749f6ec63f6eddee$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $749f6ec63f6eddee$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $eeyUA.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $eeyUA.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $7Nobb.default)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $eeyUA.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === 'function') {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === 'function') {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $eeyUA.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $749f6ec63f6eddee$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $749f6ec63f6eddee$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $749f6ec63f6eddee$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $749f6ec63f6eddee$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $749f6ec63f6eddee$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === 'column') instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $749f6ec63f6eddee$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $749f6ec63f6eddee$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $749f6ec63f6eddee$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $749f6ec63f6eddee$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $749f6ec63f6eddee$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $749f6ec63f6eddee$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $749f6ec63f6eddee$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $749f6ec63f6eddee$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $749f6ec63f6eddee$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === 'column' ? props.width : props.height;
    var itemMetadata = $749f6ec63f6eddee$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === 'column' ? $749f6ec63f6eddee$var$getEstimatedTotalWidth(props, instanceProps) : $749f6ec63f6eddee$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === 'smart') {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
        else align = 'center';
    }
    switch(align){
        case 'start':
            return maxOffset;
        case 'end':
            return minOffset;
        case 'center':
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case 'auto':
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $749f6ec63f6eddee$export$32c206c84102e73c = /*#__PURE__*/ $749f6ec63f6eddee$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $749f6ec63f6eddee$var$getItemMetadata('column', props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $749f6ec63f6eddee$var$findNearestItem('column', props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $749f6ec63f6eddee$var$getItemMetadata('column', props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $749f6ec63f6eddee$var$getItemMetadata('column', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $749f6ec63f6eddee$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $749f6ec63f6eddee$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $749f6ec63f6eddee$var$getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $749f6ec63f6eddee$var$getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $749f6ec63f6eddee$var$getItemMetadata('row', props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $749f6ec63f6eddee$var$findNearestItem('row', props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $749f6ec63f6eddee$var$getItemMetadata('row', props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $749f6ec63f6eddee$var$getItemMetadata('row', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $749f6ec63f6eddee$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $749f6ec63f6eddee$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === 'number') instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === 'number') instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $749f6ec63f6eddee$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $749f6ec63f6eddee$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $749f6ec63f6eddee$var$devWarningsDirection = null;
var $749f6ec63f6eddee$var$devWarningsTagName$1 = null;
function $749f6ec63f6eddee$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $7f5f83c736661bf2$export$2e2bcd8739ae039)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                scrollDirection: 'forward',
                scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $dcd599196b00c1ed$export$2e2bcd8739ae039)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $dcd599196b00c1ed$export$2e2bcd8739ae039)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
                    var isRtl = direction === 'rtl';
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : '100%',
                        width: isHorizontal ? size : '100%'
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $dcd599196b00c1ed$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($749f6ec63f6eddee$var$getRTLOffsetType()){
                        case 'negative':
                            scrollOffset = -scrollLeft;
                            break;
                        case 'positive-descending':
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $749f6ec63f6eddee$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $749f6ec63f6eddee$var$requestTimeout(_this._resetIsScrolling, $749f6ec63f6eddee$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $749f6ec63f6eddee$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = 'auto';
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === 'vertical') scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $749f6ec63f6eddee$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $749f6ec63f6eddee$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') {
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($749f6ec63f6eddee$var$getRTLOffsetType()){
                        case 'negative':
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case 'positive-ascending':
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $749f6ec63f6eddee$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $749f6ec63f6eddee$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $eeyUA.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $eeyUA.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $7Nobb.default)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $eeyUA.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? '100%' : estimatedTotalSize,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: isHorizontal ? estimatedTotalSize : '100%'
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === 'function') {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === 'function') {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $eeyUA.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        layout: 'vertical',
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $749f6ec63f6eddee$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $749f6ec63f6eddee$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $749f6ec63f6eddee$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $749f6ec63f6eddee$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $749f6ec63f6eddee$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $749f6ec63f6eddee$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $749f6ec63f6eddee$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $749f6ec63f6eddee$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $749f6ec63f6eddee$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $749f6ec63f6eddee$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $749f6ec63f6eddee$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $749f6ec63f6eddee$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $749f6ec63f6eddee$export$d8ac3b6b20be856e = /*#__PURE__*/ $749f6ec63f6eddee$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $749f6ec63f6eddee$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $749f6ec63f6eddee$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $749f6ec63f6eddee$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $749f6ec63f6eddee$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $749f6ec63f6eddee$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $749f6ec63f6eddee$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $749f6ec63f6eddee$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $749f6ec63f6eddee$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $749f6ec63f6eddee$export$f331158cccad7361 = /*#__PURE__*/ $749f6ec63f6eddee$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === 'smart') {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === 'smart') {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $749f6ec63f6eddee$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $749f6ec63f6eddee$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $749f6ec63f6eddee$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $749f6ec63f6eddee$var$_excluded = [
    "style"
], $749f6ec63f6eddee$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $749f6ec63f6eddee$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $8T8Yq.default)(prevProps, $749f6ec63f6eddee$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $8T8Yq.default)(nextProps, $749f6ec63f6eddee$var$_excluded2);
    return !$749f6ec63f6eddee$var$shallowDiffers(prevStyle, nextStyle) && !$749f6ec63f6eddee$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $749f6ec63f6eddee$export$aa365c903ed149ff(nextProps, nextState) {
    return !$749f6ec63f6eddee$export$b141efd0b0fb9174(this.props, nextProps) || $749f6ec63f6eddee$var$shallowDiffers(this.state, nextState);
}


var $f30739845add69b8$exports = {};
"use strict";
"use client";

var $bl52K = parcelRequire("bl52K");
Object.defineProperty($f30739845add69b8$exports, "__esModule", {
    value: true
});
$f30739845add69b8$exports.default = void 0;

var $f30739845add69b8$var$_createSvgIcon = $bl52K((parcelRequire("43V45")));

var $e9nev = parcelRequire("e9nev");
var $f30739845add69b8$var$_default = $f30739845add69b8$exports.default = (0, $f30739845add69b8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $e9nev.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-2 16H7v-.24C8.42 17.62 10.16 17 12 17s3.58.62 5 1.76zm2-1.14C17.2 16.09 14.73 15 12 15s-5.2 1.09-7 2.86V5h14zM12 13c1.93 0 3.5-1.57 3.5-3.5S13.93 6 12 6 8.5 7.57 8.5 9.5 10.07 13 12 13m0-5c.83 0 1.5.67 1.5 1.5S12.83 11 12 11s-1.5-.67-1.5-1.5S11.17 8 12 8"
}), 'AccountBoxOutlined');



var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $44a3ffde95d34834$var$ApartmentOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z"
                }
            }
        ]
    },
    "name": "apartment",
    "theme": "outlined"
};
var $44a3ffde95d34834$export$2e2bcd8739ae039 = $44a3ffde95d34834$var$ApartmentOutlined;



var $7Nobb = parcelRequire("7Nobb");




var $eeyUA = parcelRequire("eeyUA");


const $20bbc8b28143e9d1$var$round = Math.round;
/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */ function $20bbc8b28143e9d1$var$splitColorStr(str, parseNum) {
    const match = str// Remove str before `(`
    .replace(/^[^(]*\((.*)/, '$1')// Remove str after `)`
    .replace(/\).*/, '').match(/\d*\.?\d+%?/g) || [];
    const numList = match.map((item)=>parseFloat(item));
    for(let i = 0; i < 3; i += 1)numList[i] = parseNum(numList[i] || 0, match[i] || '', i);
    // For alpha. 50% should be 0.5
    if (match[3]) numList[3] = match[3].includes('%') ? numList[3] / 100 : numList[3];
    else // By default, alpha is 1
    numList[3] = 1;
    return numList;
}
const $20bbc8b28143e9d1$var$parseHSVorHSL = (num, _, index)=>index === 0 ? num : num / 100;
/** round and limit number to integer between 0-255 */ function $20bbc8b28143e9d1$var$limitRange(value, max) {
    const mergedMax = max || 255;
    if (value > mergedMax) return mergedMax;
    if (value < 0) return 0;
    return value;
}
class $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a {
    constructor(input){
        /**
     * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
     */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "isValid", true);
        /**
     * Red, R in RGB
     */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "r", 0);
        /**
     * Green, G in RGB
     */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "g", 0);
        /**
     * Blue, B in RGB
     */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "b", 0);
        /**
     * Alpha/Opacity, A in RGBA/HSLA
     */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "a", 1);
        // HSV privates
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "_h", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "_s", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "_l", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "_v", void 0);
        // intermediate variables to calculate HSL/HSV
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "_max", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "_min", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "_brightness", void 0);
        /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */ function matchFormat(str) {
            return str[0] in input && str[1] in input && str[2] in input;
        }
        if (!input) ;
        else if (typeof input === 'string') {
            const trimStr = input.trim();
            function matchPrefix(prefix) {
                return trimStr.startsWith(prefix);
            }
            if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) this.fromHexString(trimStr);
            else if (matchPrefix('rgb')) this.fromRgbString(trimStr);
            else if (matchPrefix('hsl')) this.fromHslString(trimStr);
            else if (matchPrefix('hsv') || matchPrefix('hsb')) this.fromHsvString(trimStr);
        } else if (input instanceof $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a) {
            this.r = input.r;
            this.g = input.g;
            this.b = input.b;
            this.a = input.a;
            this._h = input._h;
            this._s = input._s;
            this._l = input._l;
            this._v = input._v;
        } else if (matchFormat('rgb')) {
            this.r = $20bbc8b28143e9d1$var$limitRange(input.r);
            this.g = $20bbc8b28143e9d1$var$limitRange(input.g);
            this.b = $20bbc8b28143e9d1$var$limitRange(input.b);
            this.a = typeof input.a === 'number' ? $20bbc8b28143e9d1$var$limitRange(input.a, 1) : 1;
        } else if (matchFormat('hsl')) this.fromHsl(input);
        else if (matchFormat('hsv')) this.fromHsv(input);
        else throw new Error('@ant-design/fast-color: unsupported input ' + JSON.stringify(input));
    }
    // ======================= Setter =======================
    setR(value) {
        return this._sc('r', value);
    }
    setG(value) {
        return this._sc('g', value);
    }
    setB(value) {
        return this._sc('b', value);
    }
    setA(value) {
        return this._sc('a', value, 1);
    }
    setHue(value) {
        const hsv = this.toHsv();
        hsv.h = value;
        return this._c(hsv);
    }
    // ======================= Getter =======================
    /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */ getLuminance() {
        function adjustGamma(raw) {
            const val = raw / 255;
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        }
        const R = adjustGamma(this.r);
        const G = adjustGamma(this.g);
        const B = adjustGamma(this.b);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    getHue() {
        if (typeof this._h === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._h = 0;
            else this._h = $20bbc8b28143e9d1$var$round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
        }
        return this._h;
    }
    getSaturation() {
        if (typeof this._s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._s = 0;
            else this._s = delta / this.getMax();
        }
        return this._s;
    }
    getLightness() {
        if (typeof this._l === 'undefined') this._l = (this.getMax() + this.getMin()) / 510;
        return this._l;
    }
    getValue() {
        if (typeof this._v === 'undefined') this._v = this.getMax() / 255;
        return this._v;
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */ getBrightness() {
        if (typeof this._brightness === 'undefined') this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        return this._brightness;
    }
    // ======================== Func ========================
    darken(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() - amount / 100;
        if (l < 0) l = 0;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    lighten(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() + amount / 100;
        if (l > 1) l = 1;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(input, amount = 50) {
        const color = this._c(input);
        const p = amount / 100;
        const calc = (key)=>(color[key] - this[key]) * p + this[key];
        const rgba = {
            r: $20bbc8b28143e9d1$var$round(calc('r')),
            g: $20bbc8b28143e9d1$var$round(calc('g')),
            b: $20bbc8b28143e9d1$var$round(calc('b')),
            a: $20bbc8b28143e9d1$var$round(calc('a') * 100) / 100
        };
        return this._c(rgba);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */ tint(amount = 10) {
        return this.mix({
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }, amount);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */ shade(amount = 10) {
        return this.mix({
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, amount);
    }
    onBackground(background) {
        const bg = this._c(background);
        const alpha = this.a + bg.a * (1 - this.a);
        const calc = (key)=>{
            return $20bbc8b28143e9d1$var$round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
        };
        return this._c({
            r: calc('r'),
            g: calc('g'),
            b: calc('b'),
            a: alpha
        });
    }
    // ======================= Status =======================
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return this.getBrightness() >= 128;
    }
    // ======================== MISC ========================
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    clone() {
        return this._c(this);
    }
    // ======================= Format =======================
    toHexString() {
        let hex = '#';
        const rHex = (this.r || 0).toString(16);
        hex += rHex.length === 2 ? rHex : '0' + rHex;
        const gHex = (this.g || 0).toString(16);
        hex += gHex.length === 2 ? gHex : '0' + gHex;
        const bHex = (this.b || 0).toString(16);
        hex += bHex.length === 2 ? bHex : '0' + bHex;
        if (typeof this.a === 'number' && this.a >= 0 && this.a < 1) {
            const aHex = $20bbc8b28143e9d1$var$round(this.a * 255).toString(16);
            hex += aHex.length === 2 ? aHex : '0' + aHex;
        }
        return hex;
    }
    /** CSS support color pattern */ toHsl() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            l: this.getLightness(),
            a: this.a
        };
    }
    /** CSS support color pattern */ toHslString() {
        const h = this.getHue();
        const s = $20bbc8b28143e9d1$var$round(this.getSaturation() * 100);
        const l = $20bbc8b28143e9d1$var$round(this.getLightness() * 100);
        return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
    }
    /** Same as toHsb */ toHsv() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            v: this.getValue(),
            a: this.a
        };
    }
    toRgb() {
        return {
            r: this.r,
            g: this.g,
            b: this.b,
            a: this.a
        };
    }
    toRgbString() {
        return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
    }
    toString() {
        return this.toRgbString();
    }
    // ====================== Privates ======================
    /** Return a new FastColor object with one channel changed */ _sc(rgb, value, max) {
        const clone = this.clone();
        clone[rgb] = $20bbc8b28143e9d1$var$limitRange(value, max);
        return clone;
    }
    _c(input) {
        return new this.constructor(input);
    }
    getMax() {
        if (typeof this._max === 'undefined') this._max = Math.max(this.r, this.g, this.b);
        return this._max;
    }
    getMin() {
        if (typeof this._min === 'undefined') this._min = Math.min(this.r, this.g, this.b);
        return this._min;
    }
    fromHexString(trimStr) {
        const withoutPrefix = trimStr.replace('#', '');
        function connectNum(index1, index2) {
            return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
        }
        if (withoutPrefix.length < 6) {
            // #rgb or #rgba
            this.r = connectNum(0);
            this.g = connectNum(1);
            this.b = connectNum(2);
            this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
        } else {
            // #rrggbb or #rrggbbaa
            this.r = connectNum(0, 1);
            this.g = connectNum(2, 3);
            this.b = connectNum(4, 5);
            this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
        }
    }
    fromHsl({ h: h, s: s, l: l, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._l = l;
        this.a = typeof a === 'number' ? a : 1;
        if (s <= 0) {
            const rgb = $20bbc8b28143e9d1$var$round(l * 255);
            this.r = rgb;
            this.g = rgb;
            this.b = rgb;
        }
        let r = 0, g = 0, b = 0;
        const huePrime = h / 60;
        const chroma = (1 - Math.abs(2 * l - 1)) * s;
        const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
        if (huePrime >= 0 && huePrime < 1) {
            r = chroma;
            g = secondComponent;
        } else if (huePrime >= 1 && huePrime < 2) {
            r = secondComponent;
            g = chroma;
        } else if (huePrime >= 2 && huePrime < 3) {
            g = chroma;
            b = secondComponent;
        } else if (huePrime >= 3 && huePrime < 4) {
            g = secondComponent;
            b = chroma;
        } else if (huePrime >= 4 && huePrime < 5) {
            r = secondComponent;
            b = chroma;
        } else if (huePrime >= 5 && huePrime < 6) {
            r = chroma;
            b = secondComponent;
        }
        const lightnessModification = l - chroma / 2;
        this.r = $20bbc8b28143e9d1$var$round((r + lightnessModification) * 255);
        this.g = $20bbc8b28143e9d1$var$round((g + lightnessModification) * 255);
        this.b = $20bbc8b28143e9d1$var$round((b + lightnessModification) * 255);
    }
    fromHsv({ h: h, s: s, v: v, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._v = v;
        this.a = typeof a === 'number' ? a : 1;
        const vv = $20bbc8b28143e9d1$var$round(v * 255);
        this.r = vv;
        this.g = vv;
        this.b = vv;
        if (s <= 0) return;
        const hh = h / 60;
        const i = Math.floor(hh);
        const ff = hh - i;
        const p = $20bbc8b28143e9d1$var$round(v * (1.0 - s) * 255);
        const q = $20bbc8b28143e9d1$var$round(v * (1.0 - s * ff) * 255);
        const t = $20bbc8b28143e9d1$var$round(v * (1.0 - s * (1.0 - ff)) * 255);
        switch(i){
            case 0:
                this.g = t;
                this.b = p;
                break;
            case 1:
                this.r = q;
                this.b = p;
                break;
            case 2:
                this.r = p;
                this.b = t;
                break;
            case 3:
                this.r = p;
                this.g = q;
                break;
            case 4:
                this.r = t;
                this.g = p;
                break;
            case 5:
            default:
                this.g = p;
                this.b = q;
                break;
        }
    }
    fromHsvString(trimStr) {
        const cells = $20bbc8b28143e9d1$var$splitColorStr(trimStr, $20bbc8b28143e9d1$var$parseHSVorHSL);
        this.fromHsv({
            h: cells[0],
            s: cells[1],
            v: cells[2],
            a: cells[3]
        });
    }
    fromHslString(trimStr) {
        const cells = $20bbc8b28143e9d1$var$splitColorStr(trimStr, $20bbc8b28143e9d1$var$parseHSVorHSL);
        this.fromHsl({
            h: cells[0],
            s: cells[1],
            l: cells[2],
            a: cells[3]
        });
    }
    fromRgbString(trimStr) {
        const cells = $20bbc8b28143e9d1$var$splitColorStr(trimStr, (num, txt)=>// Convert percentage to number. e.g. 50% -> 128
            txt.includes('%') ? $20bbc8b28143e9d1$var$round(num / 100 * 255) : num);
        this.r = cells[0];
        this.g = cells[1];
        this.b = cells[2];
        this.a = cells[3];
    }
}






var $e53618f60b7980a8$var$hueStep = 2; // 色相阶梯
var $e53618f60b7980a8$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $e53618f60b7980a8$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $e53618f60b7980a8$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $e53618f60b7980a8$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $e53618f60b7980a8$var$lightColorCount = 5; // 浅色数量，主色上
var $e53618f60b7980a8$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $e53618f60b7980a8$var$darkColorMap = [
    {
        index: 7,
        amount: 15
    },
    {
        index: 6,
        amount: 25
    },
    {
        index: 5,
        amount: 30
    },
    {
        index: 5,
        amount: 45
    },
    {
        index: 5,
        amount: 65
    },
    {
        index: 5,
        amount: 85
    },
    {
        index: 4,
        amount: 90
    },
    {
        index: 3,
        amount: 95
    },
    {
        index: 2,
        amount: 97
    },
    {
        index: 1,
        amount: 98
    }
];
function $e53618f60b7980a8$var$getHue(hsv, i, light) {
    var hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $e53618f60b7980a8$var$hueStep * i : Math.round(hsv.h) + $e53618f60b7980a8$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $e53618f60b7980a8$var$hueStep * i : Math.round(hsv.h) - $e53618f60b7980a8$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $e53618f60b7980a8$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $e53618f60b7980a8$var$saturationStep * i;
    else if (i === $e53618f60b7980a8$var$darkColorCount) saturation = hsv.s + $e53618f60b7980a8$var$saturationStep;
    else saturation = hsv.s + $e53618f60b7980a8$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $e53618f60b7980a8$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Math.round(saturation * 100) / 100;
}
function $e53618f60b7980a8$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $e53618f60b7980a8$var$brightnessStep1 * i;
    else value = hsv.v - $e53618f60b7980a8$var$brightnessStep2 * i;
    // Clamp value between 0 and 1
    value = Math.max(0, Math.min(1, value));
    return Math.round(value * 100) / 100;
}
function $e53618f60b7980a8$export$2e2bcd8739ae039(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)(color);
    var hsv = pColor.toHsv();
    for(var i = $e53618f60b7980a8$var$lightColorCount; i > 0; i -= 1){
        var c = new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)({
            h: $e53618f60b7980a8$var$getHue(hsv, i, true),
            s: $e53618f60b7980a8$var$getSaturation(hsv, i, true),
            v: $e53618f60b7980a8$var$getValue(hsv, i, true)
        });
        patterns.push(c);
    }
    patterns.push(pColor);
    for(var _i = 1; _i <= $e53618f60b7980a8$var$darkColorCount; _i += 1){
        var _c = new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)({
            h: $e53618f60b7980a8$var$getHue(hsv, _i),
            s: $e53618f60b7980a8$var$getSaturation(hsv, _i),
            v: $e53618f60b7980a8$var$getValue(hsv, _i)
        });
        patterns.push(_c);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return $e53618f60b7980a8$var$darkColorMap.map(function(_ref) {
        var index = _ref.index, amount = _ref.amount;
        return new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)(opts.backgroundColor || '#141414').mix(patterns[index], amount).toHexString();
    });
    return patterns.map(function(c) {
        return c.toHexString();
    });
}


// Generated by script. Do NOT modify!
var $c009fb49b603f911$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
var $c009fb49b603f911$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$c009fb49b603f911$export$a90204d1394caf30.primary = $c009fb49b603f911$export$a90204d1394caf30[5];
var $c009fb49b603f911$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$c009fb49b603f911$export$e63a1643b2f79b16.primary = $c009fb49b603f911$export$e63a1643b2f79b16[5];
var $c009fb49b603f911$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$c009fb49b603f911$export$ad766f34ace1cafd.primary = $c009fb49b603f911$export$ad766f34ace1cafd[5];
var $c009fb49b603f911$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$c009fb49b603f911$export$c24201f7fe3571d8.primary = $c009fb49b603f911$export$c24201f7fe3571d8[5];
var $c009fb49b603f911$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$c009fb49b603f911$export$594c5a8758200c32.primary = $c009fb49b603f911$export$594c5a8758200c32[5];
var $c009fb49b603f911$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$c009fb49b603f911$export$221d31baf2636aad.primary = $c009fb49b603f911$export$221d31baf2636aad[5];
var $c009fb49b603f911$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$c009fb49b603f911$export$955a2ebd2fb142ae.primary = $c009fb49b603f911$export$955a2ebd2fb142ae[5];
var $c009fb49b603f911$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$c009fb49b603f911$export$7474046f446842ee.primary = $c009fb49b603f911$export$7474046f446842ee[5];
var $c009fb49b603f911$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$c009fb49b603f911$export$2aa0182783e7e9de.primary = $c009fb49b603f911$export$2aa0182783e7e9de[5];
var $c009fb49b603f911$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$c009fb49b603f911$export$4138d3aeddcbf415.primary = $c009fb49b603f911$export$4138d3aeddcbf415[5];
var $c009fb49b603f911$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$c009fb49b603f911$export$e13cce2a2d16a9d4.primary = $c009fb49b603f911$export$e13cce2a2d16a9d4[5];
var $c009fb49b603f911$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$c009fb49b603f911$export$2a9ca2e383622e18.primary = $c009fb49b603f911$export$2a9ca2e383622e18[5];
var $c009fb49b603f911$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$c009fb49b603f911$export$e4c89085febbc618.primary = $c009fb49b603f911$export$e4c89085febbc618[5];
var $c009fb49b603f911$export$3e2c219d3ab79d01 = $c009fb49b603f911$export$e4c89085febbc618;
var $c009fb49b603f911$export$36ad6df0f83f284d = {
    red: $c009fb49b603f911$export$a90204d1394caf30,
    volcano: $c009fb49b603f911$export$e63a1643b2f79b16,
    orange: $c009fb49b603f911$export$ad766f34ace1cafd,
    gold: $c009fb49b603f911$export$c24201f7fe3571d8,
    yellow: $c009fb49b603f911$export$594c5a8758200c32,
    lime: $c009fb49b603f911$export$221d31baf2636aad,
    green: $c009fb49b603f911$export$955a2ebd2fb142ae,
    cyan: $c009fb49b603f911$export$7474046f446842ee,
    blue: $c009fb49b603f911$export$2aa0182783e7e9de,
    geekblue: $c009fb49b603f911$export$4138d3aeddcbf415,
    purple: $c009fb49b603f911$export$e13cce2a2d16a9d4,
    magenta: $c009fb49b603f911$export$2a9ca2e383622e18,
    grey: $c009fb49b603f911$export$e4c89085febbc618
};
var $c009fb49b603f911$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$c009fb49b603f911$export$e984d34fc144caa1.primary = $c009fb49b603f911$export$e984d34fc144caa1[5];
var $c009fb49b603f911$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$c009fb49b603f911$export$360e10f78e17a865.primary = $c009fb49b603f911$export$360e10f78e17a865[5];
var $c009fb49b603f911$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$c009fb49b603f911$export$d5a12c698b31fa45.primary = $c009fb49b603f911$export$d5a12c698b31fa45[5];
var $c009fb49b603f911$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$c009fb49b603f911$export$2330427fb6a6af6f.primary = $c009fb49b603f911$export$2330427fb6a6af6f[5];
var $c009fb49b603f911$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$c009fb49b603f911$export$67d203119f0ecec.primary = $c009fb49b603f911$export$67d203119f0ecec[5];
var $c009fb49b603f911$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$c009fb49b603f911$export$51ed2a10d86576ed.primary = $c009fb49b603f911$export$51ed2a10d86576ed[5];
var $c009fb49b603f911$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$c009fb49b603f911$export$76a3d804058f9b5f.primary = $c009fb49b603f911$export$76a3d804058f9b5f[5];
var $c009fb49b603f911$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$c009fb49b603f911$export$dee6c7c6683c0d88.primary = $c009fb49b603f911$export$dee6c7c6683c0d88[5];
var $c009fb49b603f911$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$c009fb49b603f911$export$10e0fd027e632624.primary = $c009fb49b603f911$export$10e0fd027e632624[5];
var $c009fb49b603f911$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$c009fb49b603f911$export$abdd57ab473bba66.primary = $c009fb49b603f911$export$abdd57ab473bba66[5];
var $c009fb49b603f911$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$c009fb49b603f911$export$7a65e68792738764.primary = $c009fb49b603f911$export$7a65e68792738764[5];
var $c009fb49b603f911$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$c009fb49b603f911$export$d260a9321db4ab86.primary = $c009fb49b603f911$export$d260a9321db4ab86[5];
var $c009fb49b603f911$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$c009fb49b603f911$export$515283ba400ffa6c.primary = $c009fb49b603f911$export$515283ba400ffa6c[5];
var $c009fb49b603f911$export$24617255e4daf647 = {
    red: $c009fb49b603f911$export$e984d34fc144caa1,
    volcano: $c009fb49b603f911$export$360e10f78e17a865,
    orange: $c009fb49b603f911$export$d5a12c698b31fa45,
    gold: $c009fb49b603f911$export$2330427fb6a6af6f,
    yellow: $c009fb49b603f911$export$67d203119f0ecec,
    lime: $c009fb49b603f911$export$51ed2a10d86576ed,
    green: $c009fb49b603f911$export$76a3d804058f9b5f,
    cyan: $c009fb49b603f911$export$dee6c7c6683c0d88,
    blue: $c009fb49b603f911$export$10e0fd027e632624,
    geekblue: $c009fb49b603f911$export$abdd57ab473bba66,
    purple: $c009fb49b603f911$export$7a65e68792738764,
    magenta: $c009fb49b603f911$export$d260a9321db4ab86,
    grey: $c009fb49b603f911$export$515283ba400ffa6c
};





var $eeyUA = parcelRequire("eeyUA");
var $f1a22bf36ab8f6bd$var$IconContext = /*#__PURE__*/ (0, $eeyUA.createContext)({});
var $f1a22bf36ab8f6bd$export$2e2bcd8739ae039 = $f1a22bf36ab8f6bd$var$IconContext;





var $eeyUA = parcelRequire("eeyUA");




function $cfc14895ce0a1d11$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


function $9aac4e6cc0b0cad1$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


var $56d822aab7894329$var$APPEND_ORDER = 'data-rc-order';
var $56d822aab7894329$var$APPEND_PRIORITY = 'data-rc-priority';
var $56d822aab7894329$var$MARK_KEY = "rc-util-key";
var $56d822aab7894329$var$containerCache = new Map();
function $56d822aab7894329$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith('data-') ? mark : "data-".concat(mark);
    return $56d822aab7894329$var$MARK_KEY;
}
function $56d822aab7894329$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector('head');
    return head || document.body;
}
function $56d822aab7894329$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $56d822aab7894329$var$findStyles(container) {
    return Array.from(($56d822aab7894329$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === 'STYLE';
    });
}
function $56d822aab7894329$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $56d822aab7894329$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === 'prependQueue';
    var styleNode = document.createElement('style');
    styleNode.setAttribute($56d822aab7894329$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($56d822aab7894329$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $56d822aab7894329$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $56d822aab7894329$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($56d822aab7894329$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($56d822aab7894329$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $56d822aab7894329$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $56d822aab7894329$var$getContainer(option);
    return (option.styles || $56d822aab7894329$var$findStyles(container)).find(function(node) {
        return node.getAttribute($56d822aab7894329$var$getMark(option)) === key;
    });
}
function $56d822aab7894329$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $56d822aab7894329$var$findExistNode(key, option);
    if (existNode) {
        var container = $56d822aab7894329$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $56d822aab7894329$var$syncRealContainer(container, option) {
    var cachedRealContainer = $56d822aab7894329$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $9aac4e6cc0b0cad1$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        var placeholderStyle = $56d822aab7894329$export$1ab5838465dbd10a('', option);
        var parentNode = placeholderStyle.parentNode;
        $56d822aab7894329$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $56d822aab7894329$export$f80df667f2f5a272() {
    $56d822aab7894329$var$containerCache.clear();
}
function $56d822aab7894329$export$4d99a2890bb989f0(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $56d822aab7894329$var$getContainer(originOption);
    var styles = $56d822aab7894329$var$findStyles(container);
    var option = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $56d822aab7894329$var$syncRealContainer(container, option);
    var existNode = $56d822aab7894329$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $56d822aab7894329$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($56d822aab7894329$var$getMark(option), key);
    return newNode;
}


function $c0bfe74b4c42e630$var$getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function $c0bfe74b4c42e630$export$cca82218ea4431a(ele) {
    return $c0bfe74b4c42e630$var$getRoot(ele) instanceof ShadowRoot;
}
function $c0bfe74b4c42e630$export$70e8259662bb498b(ele) {
    return $c0bfe74b4c42e630$export$cca82218ea4431a(ele) ? $c0bfe74b4c42e630$var$getRoot(ele) : null;
}


/* eslint-disable no-console */ var $f29d0996356f1173$var$warned = {};
var $f29d0996356f1173$var$preWarningFns = [];
var $f29d0996356f1173$export$61616f168f0e5a05 = function preMessage(fn) {
    $f29d0996356f1173$var$preWarningFns.push(fn);
};
function $f29d0996356f1173$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $f29d0996356f1173$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $f29d0996356f1173$export$60eef1277fe463e4() {
    $f29d0996356f1173$var$warned = {};
}
function $f29d0996356f1173$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$f29d0996356f1173$var$warned[message]) {
        method(false, message);
        $f29d0996356f1173$var$warned[message] = true;
    }
}
function $f29d0996356f1173$export$82934adf09101657(valid, message) {
    $f29d0996356f1173$export$848feb93d8f32b9b($f29d0996356f1173$export$491112666e282270, valid, message);
}
function $f29d0996356f1173$export$89ff31684837bbbf(valid, message) {
    $f29d0996356f1173$export$848feb93d8f32b9b($f29d0996356f1173$export$a92e4c44d367d0af, valid, message);
}
$f29d0996356f1173$export$82934adf09101657.preMessage = $f29d0996356f1173$export$61616f168f0e5a05;
$f29d0996356f1173$export$82934adf09101657.resetWarned = $f29d0996356f1173$export$60eef1277fe463e4;
$f29d0996356f1173$export$82934adf09101657.noteOnce = $f29d0996356f1173$export$89ff31684837bbbf;
var $f29d0996356f1173$export$2e2bcd8739ae039 = $f29d0996356f1173$export$82934adf09101657;



var $eeyUA = parcelRequire("eeyUA");

function $3c4acffbe1215efe$var$camelCase(input) {
    return input.replace(/-(.)/g, function(match, g) {
        return g.toUpperCase();
    });
}
function $3c4acffbe1215efe$export$491112666e282270(valid, message) {
    (0, $f29d0996356f1173$export$2e2bcd8739ae039)(valid, "[@ant-design/icons] ".concat(message));
}
function $3c4acffbe1215efe$export$ab652842c37578f4(target) {
    return (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(target.icon) === 'object' || typeof target.icon === 'function');
}
function $3c4acffbe1215efe$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$3c4acffbe1215efe$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $3c4acffbe1215efe$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(node.tag, (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        key: key
    }, $3c4acffbe1215efe$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $3c4acffbe1215efe$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(node.tag, (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        key: key
    }, $3c4acffbe1215efe$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $3c4acffbe1215efe$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $3c4acffbe1215efe$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $e53618f60b7980a8$export$2e2bcd8739ae039)(primaryColor)[0];
}
function $3c4acffbe1215efe$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $3c4acffbe1215efe$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
var $3c4acffbe1215efe$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $3c4acffbe1215efe$export$938b1f86b61613d0 = function useInsertStyles(eleRef) {
    var _useContext = (0, $eeyUA.useContext)((0, $f1a22bf36ab8f6bd$export$2e2bcd8739ae039)), csp = _useContext.csp, prefixCls = _useContext.prefixCls, layer = _useContext.layer;
    var mergedStyleStr = $3c4acffbe1215efe$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = "@layer ".concat(layer, " {\n").concat(mergedStyleStr, "\n}");
    (0, $eeyUA.useEffect)(function() {
        var ele = eleRef.current;
        var shadowRoot = (0, $c0bfe74b4c42e630$export$70e8259662bb498b)(ele);
        (0, $56d822aab7894329$export$4d99a2890bb989f0)(mergedStyleStr, '@ant-design-icons', {
            prepend: !layer,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


var $89be0a5446f56c00$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $89be0a5446f56c00$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $89be0a5446f56c00$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $89be0a5446f56c00$var$twoToneColorPalette.primaryColor = primaryColor;
    $89be0a5446f56c00$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $3c4acffbe1215efe$export$b71c93f469694483)(primaryColor);
    $89be0a5446f56c00$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $89be0a5446f56c00$var$getTwoToneColors() {
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, $89be0a5446f56c00$var$twoToneColorPalette);
}
var $89be0a5446f56c00$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(props, $89be0a5446f56c00$var$_excluded);
    var svgRef = $eeyUA.useRef();
    var colors = $89be0a5446f56c00$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $3c4acffbe1215efe$export$b71c93f469694483)(primaryColor)
    };
    (0, $3c4acffbe1215efe$export$938b1f86b61613d0)(svgRef);
    (0, $3c4acffbe1215efe$export$491112666e282270)((0, $3c4acffbe1215efe$export$ab652842c37578f4)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $3c4acffbe1215efe$export$ab652842c37578f4)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === 'function') target = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $3c4acffbe1215efe$export$80d376111cc09ad7)(target.icon, "svg-".concat(target.name), (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true'
    }, restProps), {}, {
        ref: svgRef
    }));
};
$89be0a5446f56c00$var$IconBase.displayName = 'IconReact';
$89be0a5446f56c00$var$IconBase.getTwoToneColors = $89be0a5446f56c00$var$getTwoToneColors;
$89be0a5446f56c00$var$IconBase.setTwoToneColors = $89be0a5446f56c00$var$setTwoToneColors;
var $89be0a5446f56c00$export$2e2bcd8739ae039 = $89be0a5446f56c00$var$IconBase;





function $6e8cef0bd481fcf7$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $3c4acffbe1215efe$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $89be0a5446f56c00$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $6e8cef0bd481fcf7$export$abc7c554784cb4a7() {
    var colors = (0, $89be0a5446f56c00$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



'use client';
var $4ca0d5594d977ef2$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $6e8cef0bd481fcf7$export$8a145f34580ff02b)((0, $c009fb49b603f911$export$2aa0182783e7e9de).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
var $4ca0d5594d977ef2$var$Icon = /*#__PURE__*/ $eeyUA.forwardRef(function(props, ref) {
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(props, $4ca0d5594d977ef2$var$_excluded);
    var _React$useContext = $eeyUA.useContext((0, $f1a22bf36ab8f6bd$export$2e2bcd8739ae039)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(rootClassName, prefixCls, (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $3c4acffbe1215efe$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $eeyUA.createElement("span", (0, $7Nobb.default)({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $eeyUA.createElement((0, $89be0a5446f56c00$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$4ca0d5594d977ef2$var$Icon.displayName = 'AntdIcon';
$4ca0d5594d977ef2$var$Icon.getTwoToneColor = (0, $6e8cef0bd481fcf7$export$abc7c554784cb4a7);
$4ca0d5594d977ef2$var$Icon.setTwoToneColor = (0, $6e8cef0bd481fcf7$export$8a145f34580ff02b);
var $4ca0d5594d977ef2$export$2e2bcd8739ae039 = $4ca0d5594d977ef2$var$Icon;


var $7e8dd60fcd4e2bc9$var$ApartmentOutlined = function ApartmentOutlined(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $44a3ffde95d34834$export$2e2bcd8739ae039)
    }));
};
/**![apartment](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOCA2NDBIODA0VjQ4OGMwLTQuNC0zLjYtOC04LThINTQ4di05NmgxMDhjOC44IDAgMTYtNy4yIDE2LTE2VjgwYzAtOC44LTcuMi0xNi0xNi0xNkgzNjhjLTguOCAwLTE2IDcuMi0xNiAxNnYyODhjMCA4LjggNy4yIDE2IDE2IDE2aDEwOHY5NkgyMjhjLTQuNCAwLTggMy42LTggOHYxNTJIMTE2Yy04LjggMC0xNiA3LjItMTYgMTZ2Mjg4YzAgOC44IDcuMiAxNiAxNiAxNmgyODhjOC44IDAgMTYtNy4yIDE2LTE2VjY1NmMwLTguOC03LjItMTYtMTYtMTZIMjkydi04OGg0NDB2ODhINjIwYy04LjggMC0xNiA3LjItMTYgMTZ2Mjg4YzAgOC44IDcuMiAxNiAxNiAxNmgyODhjOC44IDAgMTYtNy4yIDE2LTE2VjY1NmMwLTguOC03LjItMTYtMTYtMTZ6bS01NjQgNzZ2MTY4SDE3NlY3MTZoMTY4em04NC00MDhWMTQwaDE2OHYxNjhINDI4em00MjAgNTc2SDY4MFY3MTZoMTY4djE2OHoiIC8+PC9zdmc+) */ var $7e8dd60fcd4e2bc9$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($7e8dd60fcd4e2bc9$var$ApartmentOutlined);
var $7e8dd60fcd4e2bc9$export$2e2bcd8739ae039 = $7e8dd60fcd4e2bc9$var$RefIcon;


var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $33735ae8ab6dceb2$var$BankOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z"
                }
            }
        ]
    },
    "name": "bank",
    "theme": "outlined"
};
var $33735ae8ab6dceb2$export$2e2bcd8739ae039 = $33735ae8ab6dceb2$var$BankOutlined;



var $b19fbf50a4bf375b$var$BankOutlined = function BankOutlined(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $33735ae8ab6dceb2$export$2e2bcd8739ae039)
    }));
};
/**![bank](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg5NCA0NjJjMzAuOSAwIDQzLjgtMzkuNyAxOC43LTU4TDUzMC44IDEyNi4yYTMxLjgxIDMxLjgxIDAgMDAtMzcuNiAwTDExMS4zIDQwNGMtMjUuMSAxOC4yLTEyLjIgNTggMTguOCA1OEgxOTJ2Mzc0aC03MmMtNC40IDAtOCAzLjYtOCA4djUyYzAgNC40IDMuNiA4IDggOGg3ODRjNC40IDAgOC0zLjYgOC04di01MmMwLTQuNC0zLjYtOC04LThoLTcyVjQ2Mmg2MnpNNTEyIDE5Ni43bDI3MS4xIDE5Ny4ySDI0MC45TDUxMiAxOTYuN3pNMjY0IDQ2MmgxMTd2Mzc0SDI2NFY0NjJ6bTE4OSAwaDExN3YzNzRINDUzVjQ2MnptMzA3IDM3NEg2NDJWNDYyaDExOHYzNzR6IiAvPjwvc3ZnPg==) */ var $b19fbf50a4bf375b$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($b19fbf50a4bf375b$var$BankOutlined);
var $b19fbf50a4bf375b$export$2e2bcd8739ae039 = $b19fbf50a4bf375b$var$RefIcon;


var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $1f8c4766069fae85$var$PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
var $1f8c4766069fae85$export$2e2bcd8739ae039 = $1f8c4766069fae85$var$PlusOutlined;



var $cb6da6362e791dd3$var$PlusOutlined = function PlusOutlined(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $1f8c4766069fae85$export$2e2bcd8739ae039)
    }));
};
/**![plus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MiAxNTJoNjBxOCAwIDggOHY3MDRxMCA4LTggOGgtNjBxLTggMC04LThWMTYwcTAtOCA4LTh6IiAvPjxwYXRoIGQ9Ik0xOTIgNDc0aDY3MnE4IDAgOCA4djYwcTAgOC04IDhIMTYwcS04IDAtOC04di02MHEwLTggOC04eiIgLz48L3N2Zz4=) */ var $cb6da6362e791dd3$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($cb6da6362e791dd3$var$PlusOutlined);
var $cb6da6362e791dd3$export$2e2bcd8739ae039 = $cb6da6362e791dd3$var$RefIcon;


var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $6c4196e7c9cf74d3$var$TagOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    },
    "name": "tag",
    "theme": "outlined"
};
var $6c4196e7c9cf74d3$export$2e2bcd8739ae039 = $6c4196e7c9cf74d3$var$TagOutlined;



var $07842ba6c5458c89$var$TagOutlined = function TagOutlined(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $6c4196e7c9cf74d3$export$2e2bcd8739ae039)
    }));
};
/**![tag](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkzOCA0NTguOGwtMjkuNi0zMTIuNmMtMS41LTE2LjItMTQuNC0yOS0zMC42LTMwLjZMNTY1LjIgODZoLS40Yy0zLjIgMC01LjcgMS03LjYgMi45TDg4LjkgNTU3LjJhOS45NiA5Ljk2IDAgMDAwIDE0LjFsMzYzLjggMzYzLjhjMS45IDEuOSA0LjQgMi45IDcuMSAyLjlzNS4yLTEgNy4xLTIuOWw0NjguMy00NjguM2MyLTIuMSAzLTUgMi44LTh6TTQ1OS43IDgzNC43TDE4OS4zIDU2NC4zIDU4OSAxNjQuNiA4MzYgMTg4bDIzLjQgMjQ3LTM5OS43IDM5OS43ek02ODAgMjU2Yy00OC41IDAtODggMzkuNS04OCA4OHMzOS41IDg4IDg4IDg4IDg4LTM5LjUgODgtODgtMzkuNS04OC04OC04OHptMCAxMjBjLTE3LjcgMC0zMi0xNC4zLTMyLTMyczE0LjMtMzIgMzItMzIgMzIgMTQuMyAzMiAzMi0xNC4zIDMyLTMyIDMyeiIgLz48L3N2Zz4=) */ var $07842ba6c5458c89$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($07842ba6c5458c89$var$TagOutlined);
var $07842ba6c5458c89$export$2e2bcd8739ae039 = $07842ba6c5458c89$var$RefIcon;


var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $8fa44961ffbb5343$var$UserAddOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 888.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "user-add",
    "theme": "outlined"
};
var $8fa44961ffbb5343$export$2e2bcd8739ae039 = $8fa44961ffbb5343$var$UserAddOutlined;



var $e19755f90d6d68a6$var$UserAddOutlined = function UserAddOutlined(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $8fa44961ffbb5343$export$2e2bcd8739ae039)
    }));
};
/**![user-add](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY3OC4zIDY0Mi40YzI0LjItMTMgNTEuOS0yMC40IDgxLjQtMjAuNGguMWMzIDAgNC40LTMuNiAyLjItNS42YTM3MS42NyAzNzEuNjcgMCAwMC0xMDMuNy02NS44Yy0uNC0uMi0uOC0uMy0xLjItLjVDNzE5LjIgNTA1IDc1OS42IDQzMS43IDc1OS42IDM0OWMwLTEzNy0xMTAuOC0yNDgtMjQ3LjUtMjQ4UzI2NC43IDIxMiAyNjQuNyAzNDljMCA4Mi43IDQwLjQgMTU2IDEwMi42IDIwMS4xLS40LjItLjguMy0xLjIuNS00NC43IDE4LjktODQuOCA0Ni0xMTkuMyA4MC42YTM3My40MiAzNzMuNDIgMCAwMC04MC40IDExOS41QTM3My42IDM3My42IDAgMDAxMzcgODg4LjhhOCA4IDAgMDA4IDguMmg1OS45YzQuMyAwIDcuOS0zLjUgOC03LjggMi03Ny4yIDMyLjktMTQ5LjUgODcuNi0yMDQuM0MzNTcgNjI4LjIgNDMyLjIgNTk3IDUxMi4yIDU5N2M1Ni43IDAgMTExLjEgMTUuNyAxNTggNDUuMWE4LjEgOC4xIDAgMDA4LjEuM3pNNTEyLjIgNTIxYy00NS44IDAtODguOS0xNy45LTEyMS40LTUwLjRBMTcxLjIgMTcxLjIgMCAwMTM0MC41IDM0OWMwLTQ1LjkgMTcuOS04OS4xIDUwLjMtMTIxLjZTNDY2LjMgMTc3IDUxMi4yIDE3N3M4OC45IDE3LjkgMTIxLjQgNTAuNEExNzEuMiAxNzEuMiAwIDAxNjgzLjkgMzQ5YzAgNDUuOS0xNy45IDg5LjEtNTAuMyAxMjEuNkM2MDEuMSA1MDMuMSA1NTggNTIxIDUxMi4yIDUyMXpNODgwIDc1OWgtODR2LTg0YzAtNC40LTMuNi04LTgtOGgtNTZjLTQuNCAwLTggMy42LTggOHY4NGgtODRjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoODR2ODRjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtODRoODRjNC40IDAgOC0zLjYgOC04di01NmMwLTQuNC0zLjYtOC04LTh6IiAvPjwvc3ZnPg==) */ var $e19755f90d6d68a6$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($e19755f90d6d68a6$var$UserAddOutlined);
var $e19755f90d6d68a6$export$2e2bcd8739ae039 = $e19755f90d6d68a6$var$RefIcon;


/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/ 
var $eeyUA = parcelRequire("eeyUA");


const $277fb56588fbddc4$var$h = "react-tooltip-core-styles", $277fb56588fbddc4$var$w = "react-tooltip-base-styles", $277fb56588fbddc4$var$b = {
    core: !1,
    base: !1
};
function $277fb56588fbddc4$var$S({ css: e, id: t = $277fb56588fbddc4$var$w, type: o = "base", ref: l }) {
    var r, n;
    if (!e || "undefined" == typeof document || $277fb56588fbddc4$var$b[o]) return;
    o;
    o;
    "core" === o && (t = $277fb56588fbddc4$var$h), l || (l = {});
    const { insertAt: i } = l;
    if (document.getElementById(t)) return;
    const c = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    s.id = t, s.type = "text/css", "top" === i && c.firstChild ? c.insertBefore(s, c.firstChild) : c.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e)), $277fb56588fbddc4$var$b[o] = !0;
}
function $277fb56588fbddc4$export$afe978aceb0adefd({ type: e = "base", id: t = $277fb56588fbddc4$var$w } = {}) {
    if (!$277fb56588fbddc4$var$b[e]) return;
    "core" === e && (t = $277fb56588fbddc4$var$h);
    const o = document.getElementById(t);
    "style" === (null == o ? void 0 : o.tagName) ? null == o || o.remove() : console.warn(`[react-tooltip] Failed to remove 'style' element with id '${t}'. Call \`injectStyle()\` first`), $277fb56588fbddc4$var$b[e] = !1;
}
const $277fb56588fbddc4$var$E = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: o = null, place: l = "top", offset: r = 10, strategy: n = "absolute", middlewares: i = [
    (0, $995799f803b32591$export$cc800923e997bb8)(Number(r)),
    (0, $995799f803b32591$export$8a83211c878a3f1f)({
        fallbackAxisSideDirection: "start"
    }),
    (0, $995799f803b32591$export$fba63a578e423eb)({
        padding: 5
    })
], border: c })=>{
    if (!e) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: l
    };
    if (null === t) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: l
    };
    const s = i;
    return o ? (s.push((0, $995799f803b32591$export$f2120bbfa5450bd2)({
        element: o,
        padding: 5
    })), (0, $995799f803b32591$export$48a53dcb22e581d0)(e, t, {
        placement: l,
        strategy: n,
        middleware: s
    }).then(({ x: e, y: t, placement: o, middlewareData: l })=>{
        var r, n;
        const i = {
            left: `${e}px`,
            top: `${t}px`,
            border: c
        }, { x: s, y: a } = null !== (r = l.arrow) && void 0 !== r ? r : {
            x: 0,
            y: 0
        }, u = null !== (n = ({
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        })[o.split("-")[0]]) && void 0 !== n ? n : "bottom", d = c && {
            borderBottom: c,
            borderRight: c
        };
        let p = 0;
        if (c) {
            const e = `${c}`.match(/(\d+)px/);
            p = (null == e ? void 0 : e[1]) ? Number(e[1]) : 1;
        }
        return {
            tooltipStyles: i,
            tooltipArrowStyles: {
                left: null != s ? `${s}px` : "",
                top: null != a ? `${a}px` : "",
                right: "",
                bottom: "",
                ...d,
                [u]: `-${4 + p}px`
            },
            place: o
        };
    })) : (0, $995799f803b32591$export$48a53dcb22e581d0)(e, t, {
        placement: "bottom",
        strategy: n,
        middleware: s
    }).then(({ x: e, y: t, placement: o })=>({
            tooltipStyles: {
                left: `${e}px`,
                top: `${t}px`
            },
            tooltipArrowStyles: {},
            place: o
        }));
}, $277fb56588fbddc4$var$A = (e, t)=>!("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), $277fb56588fbddc4$var$_ = (e, t, o)=>{
    let l = null;
    const r = function(...r) {
        const n = ()=>{
            l = null, o || e.apply(this, r);
        };
        o && !l && (e.apply(this, r), l = setTimeout(n, t)), o || (l && clearTimeout(l), l = setTimeout(n, t));
    };
    return r.cancel = ()=>{
        l && (clearTimeout(l), l = null);
    }, r;
}, $277fb56588fbddc4$var$O = (e)=>null !== e && !Array.isArray(e) && "object" == typeof e, $277fb56588fbddc4$var$k = (e, t)=>{
    if (e === t) return !0;
    if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((e, o)=>$277fb56588fbddc4$var$k(e, t[o]));
    if (Array.isArray(e) !== Array.isArray(t)) return !1;
    if (!$277fb56588fbddc4$var$O(e) || !$277fb56588fbddc4$var$O(t)) return e === t;
    const o = Object.keys(e), l = Object.keys(t);
    return o.length === l.length && o.every((o)=>$277fb56588fbddc4$var$k(e[o], t[o]));
}, $277fb56588fbddc4$var$T = (e)=>{
    if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
    const t = getComputedStyle(e);
    return [
        "overflow",
        "overflow-x",
        "overflow-y"
    ].some((e)=>{
        const o = t.getPropertyValue(e);
        return "auto" === o || "scroll" === o;
    });
}, $277fb56588fbddc4$var$L = (e)=>{
    if (!e) return null;
    let t = e.parentElement;
    for(; t;){
        if ($277fb56588fbddc4$var$T(t)) return t;
        t = t.parentElement;
    }
    return document.scrollingElement || document.documentElement;
}, $277fb56588fbddc4$var$C = "undefined" != typeof window ? (0, $eeyUA.useLayoutEffect) : (0, $eeyUA.useEffect), $277fb56588fbddc4$var$R = (e)=>{
    e.current && (clearTimeout(e.current), e.current = null);
}, $277fb56588fbddc4$var$x = "DEFAULT_TOOLTIP_ID", $277fb56588fbddc4$var$N = {
    anchorRefs: new Set,
    activeAnchor: {
        current: null
    },
    attach: ()=>{},
    detach: ()=>{},
    setActiveAnchor: ()=>{}
}, $277fb56588fbddc4$var$$ = (0, $eeyUA.createContext)({
    getTooltipData: ()=>$277fb56588fbddc4$var$N
}), $277fb56588fbddc4$export$f78649fb9ca566b8 = ({ children: t })=>{
    const [o, l] = (0, $eeyUA.useState)({
        [$277fb56588fbddc4$var$x]: new Set
    }), [c, s] = (0, $eeyUA.useState)({
        [$277fb56588fbddc4$var$x]: {
            current: null
        }
    }), a = (e, ...t)=>{
        l((o)=>{
            var l;
            const r = null !== (l = o[e]) && void 0 !== l ? l : new Set;
            return t.forEach((e)=>r.add(e)), {
                ...o,
                [e]: new Set(r)
            };
        });
    }, u = (e, ...t)=>{
        l((o)=>{
            const l = o[e];
            return l ? (t.forEach((e)=>l.delete(e)), {
                ...o
            }) : o;
        });
    }, d = (0, $eeyUA.useCallback)((e = $277fb56588fbddc4$var$x)=>{
        var t, l;
        return {
            anchorRefs: null !== (t = o[e]) && void 0 !== t ? t : new Set,
            activeAnchor: null !== (l = c[e]) && void 0 !== l ? l : {
                current: null
            },
            attach: (...t)=>a(e, ...t),
            detach: (...t)=>u(e, ...t),
            setActiveAnchor: (t)=>((e, t)=>{
                    s((o)=>{
                        var l;
                        return (null === (l = o[e]) || void 0 === l ? void 0 : l.current) === t.current ? o : {
                            ...o,
                            [e]: t
                        };
                    });
                })(e, t)
        };
    }, [
        o,
        c,
        a,
        u
    ]), p = (0, $eeyUA.useMemo)(()=>({
            getTooltipData: d
        }), [
        d
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement($277fb56588fbddc4$var$$.Provider, {
        value: p
    }, t);
};
function $277fb56588fbddc4$var$j(e = $277fb56588fbddc4$var$x) {
    return (0, $eeyUA.useContext)($277fb56588fbddc4$var$$).getTooltipData(e);
}
const $277fb56588fbddc4$export$57a09c4864b20b90 = ({ tooltipId: t, children: l, className: r, place: n, content: i, html: c, variant: a, offset: u, wrapper: d, events: p, positionStrategy: v, delayShow: m, delayHide: f })=>{
    const { attach: h, detach: w } = $277fb56588fbddc4$var$j(t), b = (0, $eeyUA.useRef)(null);
    return (0, $eeyUA.useEffect)(()=>(h(b), ()=>{
            w(b);
        }), []), (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("span", {
        ref: b,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("react-tooltip-wrapper", r),
        "data-tooltip-place": n,
        "data-tooltip-content": i,
        "data-tooltip-html": c,
        "data-tooltip-variant": a,
        "data-tooltip-offset": u,
        "data-tooltip-wrapper": d,
        "data-tooltip-events": p,
        "data-tooltip-position-strategy": v,
        "data-tooltip-delay-show": m,
        "data-tooltip-delay-hide": f
    }, l);
};
var $277fb56588fbddc4$var$z = {
    tooltip: "core-styles-module_tooltip__3vRRp",
    fixed: "core-styles-module_fixed__pcSol",
    arrow: "core-styles-module_arrow__cvMwQ",
    noArrow: "core-styles-module_noArrow__xock6",
    clickable: "core-styles-module_clickable__ZuTTB",
    show: "core-styles-module_show__Nt9eE",
    closing: "core-styles-module_closing__sGnxF"
}, $277fb56588fbddc4$var$D = {
    tooltip: "styles-module_tooltip__mnnfp",
    arrow: "styles-module_arrow__K0L3T",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
};
const $277fb56588fbddc4$var$q = ({ forwardRef: t, id: l, className: i, classNameArrow: c, variant: u = "dark", anchorId: d, anchorSelect: p, place: v = "top", offset: m = 10, events: h = [
    "hover"
], openOnClick: w = !1, positionStrategy: b = "absolute", middlewares: S, wrapper: g, delayShow: A = 0, delayHide: O = 0, float: T = !1, hidden: x = !1, noArrow: N = !1, clickable: $ = !1, closeOnEsc: I = !1, closeOnScroll: B = !1, closeOnResize: q = !1, openEvents: H, closeEvents: M, globalCloseEvents: W, imperativeModeOnly: P, style: V, position: F, afterShow: K, afterHide: U, disableTooltip: X, content: Y, contentWrapperRef: G, isOpen: Z, defaultIsOpen: J = !1, setIsOpen: Q, activeAnchor: ee, setActiveAnchor: te, border: oe, opacity: le, arrowColor: re, role: ne = "tooltip" })=>{
    var ie;
    const ce = (0, $eeyUA.useRef)(null), se = (0, $eeyUA.useRef)(null), ae = (0, $eeyUA.useRef)(null), ue = (0, $eeyUA.useRef)(null), de = (0, $eeyUA.useRef)(null), [pe, ve] = (0, $eeyUA.useState)({
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: v
    }), [me, fe] = (0, $eeyUA.useState)(!1), [ye, he] = (0, $eeyUA.useState)(!1), [we, be] = (0, $eeyUA.useState)(null), Se = (0, $eeyUA.useRef)(!1), ge = (0, $eeyUA.useRef)(null), { anchorRefs: Ee, setActiveAnchor: Ae } = $277fb56588fbddc4$var$j(l), _e = (0, $eeyUA.useRef)(!1), [Oe, ke] = (0, $eeyUA.useState)([]), Te = (0, $eeyUA.useRef)(!1), Le = w || h.includes("click"), Ce = Le || (null == H ? void 0 : H.click) || (null == H ? void 0 : H.dblclick) || (null == H ? void 0 : H.mousedown), Re = H ? {
        ...H
    } : {
        mouseover: !0,
        focus: !0,
        mouseenter: !1,
        click: !1,
        dblclick: !1,
        mousedown: !1
    };
    !H && Le && Object.assign(Re, {
        mouseenter: !1,
        focus: !1,
        mouseover: !1,
        click: !0
    });
    const xe = M ? {
        ...M
    } : {
        mouseout: !0,
        blur: !0,
        mouseleave: !1,
        click: !1,
        dblclick: !1,
        mouseup: !1
    };
    !M && Le && Object.assign(xe, {
        mouseleave: !1,
        blur: !1,
        mouseout: !1
    });
    const Ne = W ? {
        ...W
    } : {
        escape: I || !1,
        scroll: B || !1,
        resize: q || !1,
        clickOutsideAnchor: Ce || !1
    };
    P && (Object.assign(Re, {
        mouseenter: !1,
        focus: !1,
        click: !1,
        dblclick: !1,
        mousedown: !1
    }), Object.assign(xe, {
        mouseleave: !1,
        blur: !1,
        click: !1,
        dblclick: !1,
        mouseup: !1
    }), Object.assign(Ne, {
        escape: !1,
        scroll: !1,
        resize: !1,
        clickOutsideAnchor: !1
    })), $277fb56588fbddc4$var$C(()=>(Te.current = !0, ()=>{
            Te.current = !1;
        }), []);
    const $e = (e)=>{
        Te.current && (e && he(!0), setTimeout(()=>{
            Te.current && (null == Q || Q(e), void 0 === Z && fe(e));
        }, 10));
    };
    (0, $eeyUA.useEffect)(()=>{
        if (void 0 === Z) return ()=>null;
        Z && he(!0);
        const e = setTimeout(()=>{
            fe(Z);
        }, 10);
        return ()=>{
            clearTimeout(e);
        };
    }, [
        Z
    ]), (0, $eeyUA.useEffect)(()=>{
        if (me !== Se.current) {
            if ($277fb56588fbddc4$var$R(de), Se.current = me, me) null == K || K();
            else {
                const e = ((e)=>{
                    const t = e.match(/^([\d.]+)(ms|s)$/);
                    if (!t) return 0;
                    const [, o, l] = t;
                    return Number(o) * ("ms" === l ? 1 : 1e3);
                })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
                de.current = setTimeout(()=>{
                    he(!1), be(null), null == U || U();
                }, e + 25);
            }
        }
    }, [
        me
    ]);
    const Ie = (e)=>{
        ve((t)=>$277fb56588fbddc4$var$k(t, e) ? t : e);
    }, je = (e = A)=>{
        $277fb56588fbddc4$var$R(ae), ye ? $e(!0) : ae.current = setTimeout(()=>{
            $e(!0);
        }, e);
    }, Be = (e = O)=>{
        $277fb56588fbddc4$var$R(ue), ue.current = setTimeout(()=>{
            _e.current || $e(!1);
        }, e);
    }, ze = (e)=>{
        var t;
        if (!e) return;
        const o = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == o ? void 0 : o.isConnected)) return te(null), void Ae({
            current: null
        });
        A ? je() : $e(!0), te(o), Ae({
            current: o
        }), $277fb56588fbddc4$var$R(ue);
    }, De = ()=>{
        $ ? Be(O || 100) : O ? Be() : $e(!1), $277fb56588fbddc4$var$R(ae);
    }, qe = ({ x: e, y: t })=>{
        var o;
        const l = {
            getBoundingClientRect: ()=>({
                    x: e,
                    y: t,
                    width: 0,
                    height: 0,
                    top: t,
                    left: e,
                    right: e,
                    bottom: t
                })
        };
        $277fb56588fbddc4$var$E({
            place: null !== (o = null == we ? void 0 : we.place) && void 0 !== o ? o : v,
            offset: m,
            elementReference: l,
            tooltipReference: ce.current,
            tooltipArrowReference: se.current,
            strategy: b,
            middlewares: S,
            border: oe
        }).then((e)=>{
            Ie(e);
        });
    }, He = (e)=>{
        if (!e) return;
        const t = e, o = {
            x: t.clientX,
            y: t.clientY
        };
        qe(o), ge.current = o;
    }, Me = (e)=>{
        var t;
        if (!me) return;
        const o = e.target;
        if (!o.isConnected) return;
        if (null === (t = ce.current) || void 0 === t ? void 0 : t.contains(o)) return;
        [
            document.querySelector(`[id='${d}']`),
            ...Oe
        ].some((e)=>null == e ? void 0 : e.contains(o)) || ($e(!1), $277fb56588fbddc4$var$R(ae));
    }, We = $277fb56588fbddc4$var$_(ze, 50, !0), Pe = $277fb56588fbddc4$var$_(De, 50, !0), Ve = (e)=>{
        Pe.cancel(), We(e);
    }, Fe = ()=>{
        We.cancel(), Pe();
    }, Ke = (0, $eeyUA.useCallback)(()=>{
        var e, t;
        const o = null !== (e = null == we ? void 0 : we.position) && void 0 !== e ? e : F;
        o ? qe(o) : T ? ge.current && qe(ge.current) : (null == ee ? void 0 : ee.isConnected) && $277fb56588fbddc4$var$E({
            place: null !== (t = null == we ? void 0 : we.place) && void 0 !== t ? t : v,
            offset: m,
            elementReference: ee,
            tooltipReference: ce.current,
            tooltipArrowReference: se.current,
            strategy: b,
            middlewares: S,
            border: oe
        }).then((e)=>{
            Te.current && Ie(e);
        });
    }, [
        me,
        ee,
        Y,
        V,
        v,
        null == we ? void 0 : we.place,
        m,
        b,
        F,
        null == we ? void 0 : we.position,
        T
    ]);
    (0, $eeyUA.useEffect)(()=>{
        var e, t;
        const o = new Set(Ee);
        Oe.forEach((e)=>{
            (null == X ? void 0 : X(e)) || o.add({
                current: e
            });
        });
        const l = document.querySelector(`[id='${d}']`);
        l && !(null == X ? void 0 : X(l)) && o.add({
            current: l
        });
        const r = ()=>{
            $e(!1);
        }, n = $277fb56588fbddc4$var$L(ee), i = $277fb56588fbddc4$var$L(ce.current);
        Ne.scroll && (window.addEventListener("scroll", r), null == n || n.addEventListener("scroll", r), null == i || i.addEventListener("scroll", r));
        let c = null;
        Ne.resize ? window.addEventListener("resize", r) : ee && ce.current && (c = (0, $995799f803b32591$export$deee3a793edee05f)(ee, ce.current, Ke, {
            ancestorResize: !0,
            elementResize: !0,
            layoutShift: !0
        }));
        const s = (e)=>{
            "Escape" === e.key && $e(!1);
        };
        Ne.escape && window.addEventListener("keydown", s), Ne.clickOutsideAnchor && window.addEventListener("click", Me);
        const a = [], u = (e)=>{
            me && (null == e ? void 0 : e.target) === ee || ze(e);
        }, p = (e)=>{
            me && (null == e ? void 0 : e.target) === ee && De();
        }, v = [
            "mouseover",
            "mouseout",
            "mouseenter",
            "mouseleave",
            "focus",
            "blur"
        ], m = [
            "click",
            "dblclick",
            "mousedown",
            "mouseup"
        ];
        Object.entries(Re).forEach(([e, t])=>{
            t && (v.includes(e) ? a.push({
                event: e,
                listener: Ve
            }) : m.includes(e) && a.push({
                event: e,
                listener: u
            }));
        }), Object.entries(xe).forEach(([e, t])=>{
            t && (v.includes(e) ? a.push({
                event: e,
                listener: Fe
            }) : m.includes(e) && a.push({
                event: e,
                listener: p
            }));
        }), T && a.push({
            event: "pointermove",
            listener: He
        });
        const y = ()=>{
            _e.current = !0;
        }, h = ()=>{
            _e.current = !1, De();
        };
        return $ && !Ce && (null === (e = ce.current) || void 0 === e || e.addEventListener("mouseenter", y), null === (t = ce.current) || void 0 === t || t.addEventListener("mouseleave", h)), a.forEach(({ event: e, listener: t })=>{
            o.forEach((o)=>{
                var l;
                null === (l = o.current) || void 0 === l || l.addEventListener(e, t);
            });
        }), ()=>{
            var e, t;
            Ne.scroll && (window.removeEventListener("scroll", r), null == n || n.removeEventListener("scroll", r), null == i || i.removeEventListener("scroll", r)), Ne.resize ? window.removeEventListener("resize", r) : null == c || c(), Ne.clickOutsideAnchor && window.removeEventListener("click", Me), Ne.escape && window.removeEventListener("keydown", s), $ && !Ce && (null === (e = ce.current) || void 0 === e || e.removeEventListener("mouseenter", y), null === (t = ce.current) || void 0 === t || t.removeEventListener("mouseleave", h)), a.forEach(({ event: e, listener: t })=>{
                o.forEach((o)=>{
                    var l;
                    null === (l = o.current) || void 0 === l || l.removeEventListener(e, t);
                });
            });
        };
    }, [
        ee,
        Ke,
        ye,
        Ee,
        Oe,
        H,
        M,
        W,
        Le,
        A,
        O
    ]), (0, $eeyUA.useEffect)(()=>{
        var e, t;
        let o = null !== (t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p) && void 0 !== t ? t : "";
        !o && l && (o = `[data-tooltip-id='${l.replace(/'/g, "\\'")}']`);
        const r = new MutationObserver((e)=>{
            const t = [], r = [];
            e.forEach((e)=>{
                if ("attributes" === e.type && "data-tooltip-id" === e.attributeName) e.target.getAttribute("data-tooltip-id") === l ? t.push(e.target) : e.oldValue === l && r.push(e.target);
                if ("childList" === e.type) {
                    if (ee) {
                        const t = [
                            ...e.removedNodes
                        ].filter((e)=>1 === e.nodeType);
                        if (o) try {
                            r.push(...t.filter((e)=>e.matches(o))), r.push(...t.flatMap((e)=>[
                                    ...e.querySelectorAll(o)
                                ]));
                        } catch (e) {}
                        t.some((e)=>{
                            var t;
                            return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, ee)) && (he(!1), $e(!1), te(null), $277fb56588fbddc4$var$R(ae), $277fb56588fbddc4$var$R(ue), !0);
                        });
                    }
                    if (o) try {
                        const l = [
                            ...e.addedNodes
                        ].filter((e)=>1 === e.nodeType);
                        t.push(...l.filter((e)=>e.matches(o))), t.push(...l.flatMap((e)=>[
                                ...e.querySelectorAll(o)
                            ]));
                    } catch (e) {}
                }
            }), (t.length || r.length) && ke((e)=>[
                    ...e.filter((e)=>!r.includes(e)),
                    ...t
                ]);
        });
        return r.observe(document.body, {
            childList: !0,
            subtree: !0,
            attributes: !0,
            attributeFilter: [
                "data-tooltip-id"
            ],
            attributeOldValue: !0
        }), ()=>{
            r.disconnect();
        };
    }, [
        l,
        p,
        null == we ? void 0 : we.anchorSelect,
        ee
    ]), (0, $eeyUA.useEffect)(()=>{
        Ke();
    }, [
        Ke
    ]), (0, $eeyUA.useEffect)(()=>{
        if (!(null == G ? void 0 : G.current)) return ()=>null;
        const e = new ResizeObserver(()=>{
            setTimeout(()=>Ke());
        });
        return e.observe(G.current), ()=>{
            e.disconnect();
        };
    }, [
        Y,
        null == G ? void 0 : G.current
    ]), (0, $eeyUA.useEffect)(()=>{
        var e;
        const t = document.querySelector(`[id='${d}']`), o = [
            ...Oe,
            t
        ];
        ee && o.includes(ee) || te(null !== (e = Oe[0]) && void 0 !== e ? e : t);
    }, [
        d,
        Oe,
        ee
    ]), (0, $eeyUA.useEffect)(()=>(J && $e(!0), ()=>{
            $277fb56588fbddc4$var$R(ae), $277fb56588fbddc4$var$R(ue);
        }), []), (0, $eeyUA.useEffect)(()=>{
        var e;
        let t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p;
        if (!t && l && (t = `[data-tooltip-id='${l.replace(/'/g, "\\'")}']`), t) try {
            const e = Array.from(document.querySelectorAll(t));
            ke(e);
        } catch (e) {
            ke([]);
        }
    }, [
        l,
        p,
        null == we ? void 0 : we.anchorSelect
    ]), (0, $eeyUA.useEffect)(()=>{
        ae.current && ($277fb56588fbddc4$var$R(ae), je(A));
    }, [
        A
    ]);
    const Ue = null !== (ie = null == we ? void 0 : we.content) && void 0 !== ie ? ie : Y, Xe = me && Object.keys(pe.tooltipStyles).length > 0;
    return (0, $eeyUA.useImperativeHandle)(t, ()=>({
            open: (e)=>{
                if (null == e ? void 0 : e.anchorSelect) try {
                    document.querySelector(e.anchorSelect);
                } catch (t) {
                    return void console.warn(`[react-tooltip] "${e.anchorSelect}" is not a valid CSS selector`);
                }
                be(null != e ? e : null), (null == e ? void 0 : e.delay) ? je(e.delay) : $e(!0);
            },
            close: (e)=>{
                (null == e ? void 0 : e.delay) ? Be(e.delay) : $e(!1);
            },
            activeAnchor: ee,
            place: pe.place,
            isOpen: Boolean(ye && !x && Ue && Xe)
        })), ye && !x && Ue ? (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(g, {
        id: l,
        role: ne,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("react-tooltip", $277fb56588fbddc4$var$z.tooltip, $277fb56588fbddc4$var$D.tooltip, $277fb56588fbddc4$var$D[u], i, `react-tooltip__place-${pe.place}`, $277fb56588fbddc4$var$z[Xe ? "show" : "closing"], Xe ? "react-tooltip__show" : "react-tooltip__closing", "fixed" === b && $277fb56588fbddc4$var$z.fixed, $ && $277fb56588fbddc4$var$z.clickable),
        onTransitionEnd: (e)=>{
            $277fb56588fbddc4$var$R(de), me || "opacity" !== e.propertyName || (he(!1), be(null), null == U || U());
        },
        style: {
            ...V,
            ...pe.tooltipStyles,
            opacity: void 0 !== le && Xe ? le : void 0
        },
        ref: ce
    }, Ue, (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(g, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("react-tooltip-arrow", $277fb56588fbddc4$var$z.arrow, $277fb56588fbddc4$var$D.arrow, c, N && $277fb56588fbddc4$var$z.noArrow),
        style: {
            ...pe.tooltipArrowStyles,
            background: re ? `linear-gradient(to right bottom, transparent 50%, ${re} 50%)` : void 0
        },
        ref: se
    })) : null;
}, $277fb56588fbddc4$var$H = ({ content: t })=>(0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: t
        }
    }), $277fb56588fbddc4$export$28c660c63b792dea = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).forwardRef(({ id: t, anchorId: l, anchorSelect: n, content: i, html: c, render: a, className: u, classNameArrow: d, variant: p = "dark", place: v = "top", offset: m = 10, wrapper: f = "div", children: h = null, events: w = [
    "hover"
], openOnClick: b = !1, positionStrategy: S = "absolute", middlewares: g, delayShow: E = 0, delayHide: _ = 0, float: O = !1, hidden: k = !1, noArrow: T = !1, clickable: L = !1, closeOnEsc: C = !1, closeOnScroll: R = !1, closeOnResize: x = !1, openEvents: N, closeEvents: $, globalCloseEvents: I, imperativeModeOnly: B = !1, style: z, position: D, isOpen: M, defaultIsOpen: W = !1, disableStyleInjection: P = !1, border: V, opacity: F, arrowColor: K, setIsOpen: U, afterShow: X, afterHide: Y, disableTooltip: G, role: Z = "tooltip" }, J)=>{
    const [Q, ee] = (0, $eeyUA.useState)(i), [te, oe] = (0, $eeyUA.useState)(c), [le, re] = (0, $eeyUA.useState)(v), [ne, ie] = (0, $eeyUA.useState)(p), [ce, se] = (0, $eeyUA.useState)(m), [ae, ue] = (0, $eeyUA.useState)(E), [de, pe] = (0, $eeyUA.useState)(_), [ve, me] = (0, $eeyUA.useState)(O), [fe, ye] = (0, $eeyUA.useState)(k), [he, we] = (0, $eeyUA.useState)(f), [be, Se] = (0, $eeyUA.useState)(w), [ge, Ee] = (0, $eeyUA.useState)(S), [Ae, _e] = (0, $eeyUA.useState)(null), [Oe, ke] = (0, $eeyUA.useState)(null), Te = (0, $eeyUA.useRef)(P), { anchorRefs: Le, activeAnchor: Ce } = $277fb56588fbddc4$var$j(t), Re = (e)=>null == e ? void 0 : e.getAttributeNames().reduce((t, o)=>{
            var l;
            if (o.startsWith("data-tooltip-")) t[o.replace(/^data-tooltip-/, "")] = null !== (l = null == e ? void 0 : e.getAttribute(o)) && void 0 !== l ? l : null;
            return t;
        }, {}), xe = (e)=>{
        const t = {
            place: (e)=>{
                var t;
                re(null !== (t = e) && void 0 !== t ? t : v);
            },
            content: (e)=>{
                ee(null != e ? e : i);
            },
            html: (e)=>{
                oe(null != e ? e : c);
            },
            variant: (e)=>{
                var t;
                ie(null !== (t = e) && void 0 !== t ? t : p);
            },
            offset: (e)=>{
                se(null === e ? m : Number(e));
            },
            wrapper: (e)=>{
                var t;
                we(null !== (t = e) && void 0 !== t ? t : f);
            },
            events: (e)=>{
                const t = null == e ? void 0 : e.split(" ");
                Se(null != t ? t : w);
            },
            "position-strategy": (e)=>{
                var t;
                Ee(null !== (t = e) && void 0 !== t ? t : S);
            },
            "delay-show": (e)=>{
                ue(null === e ? E : Number(e));
            },
            "delay-hide": (e)=>{
                pe(null === e ? _ : Number(e));
            },
            float: (e)=>{
                me(null === e ? O : "true" === e);
            },
            hidden: (e)=>{
                ye(null === e ? k : "true" === e);
            },
            "class-name": (e)=>{
                _e(e);
            }
        };
        Object.values(t).forEach((e)=>e(null)), Object.entries(e).forEach(([e, o])=>{
            var l;
            null === (l = t[e]) || void 0 === l || l.call(t, o);
        });
    };
    (0, $eeyUA.useEffect)(()=>{
        ee(i);
    }, [
        i
    ]), (0, $eeyUA.useEffect)(()=>{
        oe(c);
    }, [
        c
    ]), (0, $eeyUA.useEffect)(()=>{
        re(v);
    }, [
        v
    ]), (0, $eeyUA.useEffect)(()=>{
        ie(p);
    }, [
        p
    ]), (0, $eeyUA.useEffect)(()=>{
        se(m);
    }, [
        m
    ]), (0, $eeyUA.useEffect)(()=>{
        ue(E);
    }, [
        E
    ]), (0, $eeyUA.useEffect)(()=>{
        pe(_);
    }, [
        _
    ]), (0, $eeyUA.useEffect)(()=>{
        me(O);
    }, [
        O
    ]), (0, $eeyUA.useEffect)(()=>{
        ye(k);
    }, [
        k
    ]), (0, $eeyUA.useEffect)(()=>{
        Ee(S);
    }, [
        S
    ]), (0, $eeyUA.useEffect)(()=>{
        Te.current !== P && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
    }, [
        P
    ]), (0, $eeyUA.useEffect)(()=>{
        "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", {
            detail: {
                disableCore: "core" === P,
                disableBase: P
            }
        }));
    }, []), (0, $eeyUA.useEffect)(()=>{
        var e;
        const o = new Set(Le);
        let r = n;
        if (!r && t && (r = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), r) try {
            document.querySelectorAll(r).forEach((e)=>{
                o.add({
                    current: e
                });
            });
        } catch (e) {
            console.warn(`[react-tooltip] "${r}" is not a valid CSS selector`);
        }
        const i = document.querySelector(`[id='${l}']`);
        if (i && o.add({
            current: i
        }), !o.size) return ()=>null;
        const c = null !== (e = null != Oe ? Oe : i) && void 0 !== e ? e : Ce.current, s = new MutationObserver((e)=>{
            e.forEach((e)=>{
                var t;
                if (!c || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
                const o = Re(c);
                xe(o);
            });
        }), a = {
            attributes: !0,
            childList: !1,
            subtree: !1
        };
        if (c) {
            const e = Re(c);
            xe(e), s.observe(c, a);
        }
        return ()=>{
            s.disconnect();
        };
    }, [
        Le,
        Ce,
        Oe,
        l,
        n
    ]), (0, $eeyUA.useEffect)(()=>{
        (null == z ? void 0 : z.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), V && !$277fb56588fbddc4$var$A("border", `${V}`) && console.warn(`[react-tooltip] "${V}" is not a valid \`border\`.`), (null == z ? void 0 : z.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), F && !$277fb56588fbddc4$var$A("opacity", `${F}`) && console.warn(`[react-tooltip] "${F}" is not a valid \`opacity\`.`);
    }, []);
    let Ne = h;
    const $e = (0, $eeyUA.useRef)(null);
    if (a) {
        const t = a({
            content: (null == Oe ? void 0 : Oe.getAttribute("data-tooltip-content")) || Q || null,
            activeAnchor: Oe
        });
        Ne = t ? (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
            ref: $e,
            className: "react-tooltip-content-wrapper"
        }, t) : null;
    } else Q && (Ne = Q);
    te && (Ne = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement($277fb56588fbddc4$var$H, {
        content: te
    }));
    const Ie = {
        forwardRef: J,
        id: t,
        anchorId: l,
        anchorSelect: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(u, Ae),
        classNameArrow: d,
        content: Ne,
        contentWrapperRef: $e,
        place: le,
        variant: ne,
        offset: ce,
        wrapper: he,
        events: be,
        openOnClick: b,
        positionStrategy: ge,
        middlewares: g,
        delayShow: ae,
        delayHide: de,
        float: ve,
        hidden: fe,
        noArrow: T,
        clickable: L,
        closeOnEsc: C,
        closeOnScroll: R,
        closeOnResize: x,
        openEvents: N,
        closeEvents: $,
        globalCloseEvents: I,
        imperativeModeOnly: B,
        style: z,
        position: D,
        isOpen: M,
        defaultIsOpen: W,
        border: V,
        opacity: F,
        arrowColor: K,
        setIsOpen: U,
        afterShow: X,
        afterHide: Y,
        disableTooltip: G,
        activeAnchor: Oe,
        setActiveAnchor: (e)=>ke(e),
        role: Z
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement($277fb56588fbddc4$var$q, {
        ...Ie
    });
});
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", (e)=>{
    e.detail.disableCore || $277fb56588fbddc4$var$S({
        css: `:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}`,
        type: "core"
    }), e.detail.disableBase || $277fb56588fbddc4$var$S({
        css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,
        type: "base"
    });
});


function $0eb8c2f4491c20a6$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $0eb8c2f4491c20a6$var$$parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $0eb8c2f4491c20a6$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
// Help @parcel/transformer-typescript-types find css module type
/// <reference types="./css.d.ts" />
var $0eb8c2f4491c20a6$var$$88e256115d638a8a$exports = {};
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$88e256115d638a8a$exports, "alert", function() {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$5ea928c9faf85bd3;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$5ea928c9faf85bd3 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$88e256115d638a8a$exports, "container", function() {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$34e0f9847d4c02dd;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$34e0f9847d4c02dd = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$88e256115d638a8a$exports, "content", function() {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a7db06668cad9adb;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a7db06668cad9adb = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$88e256115d638a8a$exports, "error", function() {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a3bc9b8ed74fc;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a3bc9b8ed74fc = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$88e256115d638a8a$exports, "info", function() {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a80b3bd66acc52ff;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a80b3bd66acc52ff = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$88e256115d638a8a$exports, "md", function() {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$f4de1c043ce6927;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$f4de1c043ce6927 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$88e256115d638a8a$exports, "sm", function() {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$92d98d0701d4531a;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$92d98d0701d4531a = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$88e256115d638a8a$exports, "success", function() {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$fe7c49d056ea1d88;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$fe7c49d056ea1d88 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$88e256115d638a8a$exports, "text", function() {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$6f093cfa640b7166;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$6f093cfa640b7166 = v;
});
var $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$5ea928c9faf85bd3;
var $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$34e0f9847d4c02dd;
var $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a7db06668cad9adb;
var $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a3bc9b8ed74fc;
var $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a80b3bd66acc52ff;
var $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$f4de1c043ce6927;
var $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$92d98d0701d4531a;
var $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$fe7c49d056ea1d88;
var $0eb8c2f4491c20a6$var$$88e256115d638a8a$export$6f093cfa640b7166;
$0eb8c2f4491c20a6$var$$88e256115d638a8a$export$5ea928c9faf85bd3 = `I4s30a_alert`;
$0eb8c2f4491c20a6$var$$88e256115d638a8a$export$34e0f9847d4c02dd = `I4s30a_container`;
$0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a7db06668cad9adb = `I4s30a_content`;
$0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a3bc9b8ed74fc = `I4s30a_error`;
$0eb8c2f4491c20a6$var$$88e256115d638a8a$export$a80b3bd66acc52ff = `I4s30a_info`;
$0eb8c2f4491c20a6$var$$88e256115d638a8a$export$f4de1c043ce6927 = `I4s30a_md`;
$0eb8c2f4491c20a6$var$$88e256115d638a8a$export$92d98d0701d4531a = `I4s30a_sm`;
$0eb8c2f4491c20a6$var$$88e256115d638a8a$export$fe7c49d056ea1d88 = `I4s30a_success`;
$0eb8c2f4491c20a6$var$$88e256115d638a8a$export$6f093cfa640b7166 = `I4s30a_text`;
var $0eb8c2f4491c20a6$export$5b4a8869eb24d061;
(function(AlertType) {
    AlertType["Info"] = "info";
    AlertType["Alert"] = "alert";
    AlertType["Success"] = "success";
    AlertType["Error"] = "error";
})($0eb8c2f4491c20a6$export$5b4a8869eb24d061 || ($0eb8c2f4491c20a6$export$5b4a8869eb24d061 = {}));
var $0eb8c2f4491c20a6$var$$dbea61467c089a69$export$14faa19a0f3bbeb2;
(function(Theme) {
    Theme["Default"] = "default";
    Theme["Info"] = "info";
    Theme["Alert"] = "alert";
    Theme["Success"] = "success";
    Theme["Error"] = "error";
})($0eb8c2f4491c20a6$var$$dbea61467c089a69$export$14faa19a0f3bbeb2 || ($0eb8c2f4491c20a6$var$$dbea61467c089a69$export$14faa19a0f3bbeb2 = {}));
const $0eb8c2f4491c20a6$var$$dbea61467c089a69$export$9d64ff89b6869900 = {
    ["alert"]: {
        icon: "ReportProblemOutlinedIcon",
        color: "icon-warn"
    },
    ["error"]: {
        icon: "ErrorOutlineOutlinedIcon",
        color: "alku-brand-primary"
    },
    ["info"]: {
        icon: "InfoOutlinedIcon",
        color: "icon-info"
    },
    ["success"]: {
        icon: "CheckCircleOutlineOutlinedIcon",
        color: "icon-success"
    },
    ["default"]: {
        icon: undefined,
        color: "icon-info"
    }
};
const $0eb8c2f4491c20a6$export$caec2af78bcc877f = ({ children: children, type: type = $0eb8c2f4491c20a6$export$5b4a8869eb24d061.Error, dismissible: dismissible = false, id: id, size: size = "md", onClick: onClick })=>{
    const { icon: icon, color: color } = $0eb8c2f4491c20a6$var$$dbea61467c089a69$export$9d64ff89b6869900[type];
    return (0, $e9nev.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$88e256115d638a8a$exports.container, $0eb8c2f4491c20a6$var$$88e256115d638a8a$exports[type], $0eb8c2f4491c20a6$var$$88e256115d638a8a$exports[size]),
        children: [
            (0, $e9nev.jsxs)("div", {
                className: $0eb8c2f4491c20a6$var$$88e256115d638a8a$exports.content,
                children: [
                    (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                        symbol: icon,
                        color: color,
                        size: size === "sm" ? "md" : "xl"
                    }),
                    (0, $e9nev.jsx)("div", {
                        className: $0eb8c2f4491c20a6$var$$88e256115d638a8a$exports.text,
                        children: children
                    })
                ]
            }),
            dismissible && (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$353f5b6fc5456de1, {
                as: "button",
                type: "button",
                id: id,
                style: "icon-only",
                ariaLabel: "close",
                onClick: onClick,
                children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                    symbol: "CloseOutlinedIcon",
                    color: color,
                    size: "lg"
                })
            })
        ]
    });
};
var $0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$exports = {};
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$exports, "avatar", function() {
    return $0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$345c5736c8054f22;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$345c5736c8054f22 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$exports, "md", function() {
    return $0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$f4de1c043ce6927;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$f4de1c043ce6927 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$exports, "sm", function() {
    return $0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$92d98d0701d4531a;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$92d98d0701d4531a = v;
});
var $0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$345c5736c8054f22;
var $0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$f4de1c043ce6927;
var $0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$92d98d0701d4531a;
$0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$345c5736c8054f22 = `MZwSAW_avatar`;
$0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$f4de1c043ce6927 = `MZwSAW_md`;
$0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$export$92d98d0701d4531a = `MZwSAW_sm`;
const $0eb8c2f4491c20a6$export$e2255cf6045e8d47 = ({ initials: initials, size: size })=>{
    return (0, $e9nev.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$exports.avatar, $0eb8c2f4491c20a6$var$$a4cd2e5379ae3619$exports[size]),
        children: initials
    });
};
var $0eb8c2f4491c20a6$var$$f1e10137373c17b6$exports = {};
$0eb8c2f4491c20a6$var$$f1e10137373c17b6$exports["function"] = `_0RedaG_function`;
$0eb8c2f4491c20a6$var$$f1e10137373c17b6$exports["icon-only"] = `_0RedaG_icon-only`;
$0eb8c2f4491c20a6$var$$f1e10137373c17b6$exports["link"] = `_0RedaG_link`;
$0eb8c2f4491c20a6$var$$f1e10137373c17b6$exports["primary-default"] = `_0RedaG_primary-default`;
$0eb8c2f4491c20a6$var$$f1e10137373c17b6$exports["primary-impact"] = `_0RedaG_primary-impact`;
$0eb8c2f4491c20a6$var$$f1e10137373c17b6$exports["secondary"] = `_0RedaG_secondary`;
for(let key in {})if (key in $0eb8c2f4491c20a6$var$$f1e10137373c17b6$exports) $0eb8c2f4491c20a6$var$$f1e10137373c17b6$exports[key] += " " + ({})[key];
else $0eb8c2f4491c20a6$var$$f1e10137373c17b6$exports[key] = ({})[key];
/**
 * Helper function to open links in new tab and eliminate window.opener vulnerabilities
 */ const $0eb8c2f4491c20a6$var$$917b1540128ca986$export$705f2bd319df8782 = (href)=>{
    if (typeof href === "string") {
        const newWindow = window.open(href, "_blank");
        if (newWindow !== null) newWindow.opener = null;
    }
};
const $0eb8c2f4491c20a6$export$353f5b6fc5456de1 = (0, $eeyUA.forwardRef)(function Button(props, ref) {
    const { children: children, style: style, type: type, as: as, href: href, linkNewTab: linkNewTab = false, ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, disabled: disabled, onClick: onClick, className: className, id: id, title: title, dataTestId: dataTestId } = props;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(`${$0eb8c2f4491c20a6$var$$f1e10137373c17b6$exports[style]}`, className);
    const externalLinkProps = {};
    if (linkNewTab) {
        externalLinkProps.onClick = (event)=>{
            event.preventDefault();
            $0eb8c2f4491c20a6$var$$917b1540128ca986$export$705f2bd319df8782(href);
        };
        externalLinkProps.rel = "external nofollow nooopener";
    }
    if (as === "a") return (0, $e9nev.jsx)("a", {
        href: href,
        "aria-label": ariaLabel ?? "",
        "aria-describedby": ariaDescribedBy ?? "",
        className: classes,
        onClick: onClick,
        ...externalLinkProps,
        id: id,
        "data-testid": dataTestId ?? "",
        ref: ref,
        children: children
    });
    else return (0, $e9nev.jsx)("button", {
        type: type,
        disabled: disabled,
        className: classes,
        "aria-label": ariaLabel ?? "",
        "aria-describedby": ariaDescribedBy ?? "",
        "data-testid": dataTestId ?? "",
        ...disabled ? {
            "aria-disabled": true
        } : {},
        onClick: disabled ? undefined : onClick,
        id: id,
        ref: ref,
        title: title,
        children: children
    });
});
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports = {};
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "center", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$3481c78889e8fbe8;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$3481c78889e8fbe8 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "icon", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$1ca1ec8b29a4ce27;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$1ca1ec8b29a4ce27 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "left", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$eabcd2c8791e7bf4;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$eabcd2c8791e7bf4 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "lg", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$27ac7b32bf0e709e;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$27ac7b32bf0e709e = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "md", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f4de1c043ce6927;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f4de1c043ce6927 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "no-shrink", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$dc042d0574ad144a;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$dc042d0574ad144a = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "none", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f883a24d5edde77c;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f883a24d5edde77c = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "right", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$79ffe56a765070d2;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$79ffe56a765070d2 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "rotate", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$bb628a54ab399bc9;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$bb628a54ab399bc9 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "sm", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$92d98d0701d4531a;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$92d98d0701d4531a = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "xl", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$abb3878d4b973569;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$abb3878d4b973569 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "xs", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f005493441391ad1;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f005493441391ad1 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports, "xxxl", function() {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$649fac613cc4a5;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$649fac613cc4a5 = v;
});
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$3481c78889e8fbe8;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$1ca1ec8b29a4ce27;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$eabcd2c8791e7bf4;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$27ac7b32bf0e709e;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f4de1c043ce6927;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$dc042d0574ad144a;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f883a24d5edde77c;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$79ffe56a765070d2;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$bb628a54ab399bc9;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$92d98d0701d4531a;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$abb3878d4b973569;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f005493441391ad1;
var $0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$649fac613cc4a5;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$3481c78889e8fbe8 = `_80CRQq_center`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$1ca1ec8b29a4ce27 = `_80CRQq_icon`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$eabcd2c8791e7bf4 = `_80CRQq_left`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$27ac7b32bf0e709e = `_80CRQq_lg`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f4de1c043ce6927 = `_80CRQq_md`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$dc042d0574ad144a = `_80CRQq_no-shrink`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f883a24d5edde77c = `_80CRQq_none`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$79ffe56a765070d2 = `_80CRQq_right`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$bb628a54ab399bc9 = `_80CRQq_rotate`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$92d98d0701d4531a = `_80CRQq_sm`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$abb3878d4b973569 = `_80CRQq_xl`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$f005493441391ad1 = `_80CRQq_xs`;
$0eb8c2f4491c20a6$var$$9e852ed4413296f9$export$649fac613cc4a5 = `_80CRQq_xxxl`;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports = {};
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "align-center", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$103da05444fe0664;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$103da05444fe0664 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "alku-black", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$b999fe50cb24a908;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$b999fe50cb24a908 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "alku-brand-primary", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1c1de8c1257ce12e;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1c1de8c1257ce12e = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "alku-icon-default", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$c314c8fdf8d15eb3;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$c314c8fdf8d15eb3 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "alku-white", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$ba48749b8f0985a7;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$ba48749b8f0985a7 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "alku-white-inactive", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$9ac66a0adf77937c;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$9ac66a0adf77937c = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "bold", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$73ba5813cda80a49;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$73ba5813cda80a49 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "bright-blue", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$30f8ae6ed9beb37c;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$30f8ae6ed9beb37c = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "cactus-dark-grey", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$74edff0cd2e642bf;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$74edff0cd2e642bf = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "cactus-green", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$10e3613adfc6ba88;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$10e3613adfc6ba88 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "cactus-green-light", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$2e948d8fa3f2c568;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$2e948d8fa3f2c568 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "cactus-light-grey", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$8884c32e2073d106;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$8884c32e2073d106 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "cactus-off-white", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$e5e96f9b884263be;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$e5e96f9b884263be = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "column", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4e0c71f277ca26b3;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4e0c71f277ca26b3 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "dark-blue", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$67c8ccd9d2cbb760;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$67c8ccd9d2cbb760 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "dark-grey", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$8bb03424abe908c9;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$8bb03424abe908c9 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "flex", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$97691fbb80847c19;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$97691fbb80847c19 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "flex-start", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$fb04de77fa42ac56;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$fb04de77fa42ac56 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "flex-wrap", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1f4cea2e27b57b02;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1f4cea2e27b57b02 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "flyout-overlay", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7aecf4a8d47d14ff;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7aecf4a8d47d14ff = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "header", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$38e42c68cf43b5d4;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$38e42c68cf43b5d4 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "header-account-wrapper", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4dd6232dd12b948a;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4dd6232dd12b948a = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "header-avatar", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$dc04afc4075173d6;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$dc04afc4075173d6 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "header-logo", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$f59d5279c2d040a8;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$f59d5279c2d040a8 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "header-nav-wrapper", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$232368ef6df1fa9;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$232368ef6df1fa9 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "header-profile", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$e766cfad7bbd8569;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$e766cfad7bbd8569 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "hyperlink", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$aaf0e9785a4e9240;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$aaf0e9785a4e9240 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "icon-favorite", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$18c9ab8f852dd70d;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$18c9ab8f852dd70d = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "icon-info", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7fdab38ec047cfcb;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7fdab38ec047cfcb = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "icon-red", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$fee7b90faa24e81f;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$fee7b90faa24e81f = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "icon-success", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$be7f98134691b9c8;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$be7f98134691b9c8 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "icon-warn", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7045e4723eb45ed0;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7045e4723eb45ed0 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "mb-1", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$81d1839eabae5078;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$81d1839eabae5078 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "overflow-hidden", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$15ee5781b96cbd33;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$15ee5781b96cbd33 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "regular", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$28a535dd448ffda4;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$28a535dd448ffda4 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "relative", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$f0e7d1106eeabbe6;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$f0e7d1106eeabbe6 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "row", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$120ff0929b202a6d;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$120ff0929b202a6d = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "semibold", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$ee40a85ed9c2d535;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$ee40a85ed9c2d535 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "space-between", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$72b535cced3bbc2a;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$72b535cced3bbc2a = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "text-disabled", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$da35ef826e167b82;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$da35ef826e167b82 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "text-green", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$609b24421289fe73;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$609b24421289fe73 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "text-purple", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1e7ea32ff0942faa;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1e7ea32ff0942faa = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "text-red", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4ff79f5b8deab660;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4ff79f5b8deab660 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports, "u-sr-only", function() {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$a52403d6f9e45688;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$a52403d6f9e45688 = v;
});
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$103da05444fe0664;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$b999fe50cb24a908;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1c1de8c1257ce12e;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$c314c8fdf8d15eb3;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$ba48749b8f0985a7;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$9ac66a0adf77937c;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$73ba5813cda80a49;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$30f8ae6ed9beb37c;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$74edff0cd2e642bf;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$10e3613adfc6ba88;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$2e948d8fa3f2c568;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$8884c32e2073d106;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$e5e96f9b884263be;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4e0c71f277ca26b3;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$67c8ccd9d2cbb760;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$8bb03424abe908c9;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$97691fbb80847c19;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$fb04de77fa42ac56;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1f4cea2e27b57b02;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7aecf4a8d47d14ff;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$38e42c68cf43b5d4;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4dd6232dd12b948a;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$dc04afc4075173d6;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$f59d5279c2d040a8;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$232368ef6df1fa9;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$e766cfad7bbd8569;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$aaf0e9785a4e9240;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$18c9ab8f852dd70d;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7fdab38ec047cfcb;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$fee7b90faa24e81f;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$be7f98134691b9c8;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7045e4723eb45ed0;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$81d1839eabae5078;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$15ee5781b96cbd33;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$28a535dd448ffda4;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$f0e7d1106eeabbe6;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$120ff0929b202a6d;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$ee40a85ed9c2d535;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$72b535cced3bbc2a;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$da35ef826e167b82;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$609b24421289fe73;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1e7ea32ff0942faa;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4ff79f5b8deab660;
var $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$a52403d6f9e45688;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$103da05444fe0664 = `TQ6Uua_align-center`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$b999fe50cb24a908 = `TQ6Uua_alku-black`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1c1de8c1257ce12e = `TQ6Uua_alku-brand-primary`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$c314c8fdf8d15eb3 = `TQ6Uua_alku-icon-default`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$ba48749b8f0985a7 = `TQ6Uua_alku-white`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$9ac66a0adf77937c = `TQ6Uua_alku-white-inactive`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$73ba5813cda80a49 = `TQ6Uua_bold`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$30f8ae6ed9beb37c = `TQ6Uua_bright-blue`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$74edff0cd2e642bf = `TQ6Uua_cactus-dark-grey`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$10e3613adfc6ba88 = `TQ6Uua_cactus-green`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$2e948d8fa3f2c568 = `TQ6Uua_cactus-green-light`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$8884c32e2073d106 = `TQ6Uua_cactus-light-grey`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$e5e96f9b884263be = `TQ6Uua_cactus-off-white`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4e0c71f277ca26b3 = `TQ6Uua_column`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$67c8ccd9d2cbb760 = `TQ6Uua_dark-blue`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$8bb03424abe908c9 = `TQ6Uua_dark-grey`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$97691fbb80847c19 = `TQ6Uua_flex`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$fb04de77fa42ac56 = `TQ6Uua_flex-start`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1f4cea2e27b57b02 = `TQ6Uua_flex-wrap`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7aecf4a8d47d14ff = `TQ6Uua_flyout-overlay`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$38e42c68cf43b5d4 = `TQ6Uua_header`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4dd6232dd12b948a = `TQ6Uua_header-account-wrapper`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$dc04afc4075173d6 = `TQ6Uua_header-avatar`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$f59d5279c2d040a8 = `TQ6Uua_header-logo`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$232368ef6df1fa9 = `TQ6Uua_header-nav-wrapper`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$e766cfad7bbd8569 = `TQ6Uua_header-profile`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$aaf0e9785a4e9240 = `TQ6Uua_hyperlink`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$18c9ab8f852dd70d = `TQ6Uua_icon-favorite`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7fdab38ec047cfcb = `TQ6Uua_icon-info`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$fee7b90faa24e81f = `TQ6Uua_icon-red`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$be7f98134691b9c8 = `TQ6Uua_icon-success`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$7045e4723eb45ed0 = `TQ6Uua_icon-warn`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$81d1839eabae5078 = `TQ6Uua_mb-1`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$15ee5781b96cbd33 = `TQ6Uua_overflow-hidden`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$28a535dd448ffda4 = `TQ6Uua_regular`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$f0e7d1106eeabbe6 = `TQ6Uua_relative`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$120ff0929b202a6d = `TQ6Uua_row`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$ee40a85ed9c2d535 = `TQ6Uua_semibold`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$72b535cced3bbc2a = `TQ6Uua_space-between`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$da35ef826e167b82 = `TQ6Uua_text-disabled`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$609b24421289fe73 = `TQ6Uua_text-green`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$1e7ea32ff0942faa = `TQ6Uua_text-purple`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$4ff79f5b8deab660 = `TQ6Uua_text-red`;
$0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$export$a52403d6f9e45688 = `TQ6Uua_u-sr-only`;
const $0eb8c2f4491c20a6$var$$a7a7876988c6a28d$export$c82760de046b5a30 = {
    QuestionMarkOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($06446c21cdc1ce48$exports))),
    AddOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7f2ee74f503c9795$exports))),
    MoreVertOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2ef7d9eb657d3479$exports))),
    ArrowBackIosIcon: (0, (/*@__PURE__*/$parcel$interopDefault($dcdf0ea9d5409019$exports))),
    ArrowDropDownOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($810478c9643d836d$exports))),
    LogoutOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1e24849621093dad$exports))),
    ExpandMoreOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($b5d9f5c772f9ea7d$exports))),
    ChevronRightOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($21fe327746c07d2a$exports))),
    CloseOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($a6e1be9a13393d4d$exports))),
    ReportProblemOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ccb050a05964f360$exports))),
    InfoOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cb4f278685e0adca$exports))),
    CheckCircleOutlineOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($545e1cb44bde939f$exports))),
    ErrorOutlineOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($aabebb6a6420d9b8$exports))),
    FileDownloadOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($509c8e9093c5cb2e$exports))),
    BookmarkOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7a36cab96895fa25$exports))),
    BookmarkBorderOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($01803bbb9b3e6422$exports))),
    CancelIcon: (0, (/*@__PURE__*/$parcel$interopDefault($db2f69698bc83b0e$exports))),
    BusinessOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2f4d04b0406e11aa$exports))),
    WorkOutlineOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c5b92a0f0a8da945$exports))),
    ExitToAppOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($226ea876a0710e3b$exports))),
    DeleteOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1d56f5eeb165ab36$exports))),
    EditOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d73705fda6e157c0$exports))),
    ChevronLeftOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($49b5653e0d58589e$exports))),
    ExpandLessOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($febe4610c781402e$exports))),
    PersonAddAlt1OutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c621450c2c75bc75$exports))),
    AutorenewOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($400e6b83aa6fa057$exports))),
    CheckCircleOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($94b32c327852d14c$exports))),
    WarningAmberRoundedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4ab2c8cfffdca58b$exports))),
    VisibilityOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($b20636cdb53c17ff$exports))),
    VerticalAlignBottomIcon: (0, (/*@__PURE__*/$parcel$interopDefault($35acfd64c7c20203$exports))),
    BlockIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f0e1fb68ac0b427d$exports))),
    RadioButtonCheckedOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdc42263a9383738$exports))),
    RadioButtonUncheckedOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6211ea94e29790c9$exports))),
    ReplayIcon: (0, (/*@__PURE__*/$parcel$interopDefault($e15844660322e7aa$exports))),
    ThreePOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c5b6ae9406003622$exports))),
    PostAddOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d7bc21fd768eafd4$exports))),
    ContentCopyOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ede66ffb82ed42b4$exports))),
    StarBorderOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cf0101973b13c144$exports))),
    StarIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bbdb1aa2207cefa9$exports))),
    SearchIcon: (0, (/*@__PURE__*/$parcel$interopDefault($04a42b3dfaaf7244$exports))),
    FileUploadOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4d8bd3ab3b13c2a0$exports))),
    AttachFileOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($955a8c969d9872b2$exports))),
    PhoneDisabledIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4a24cb17e3ce50b6$exports))),
    AddCommentOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($300e5b040f49d1f2$exports))),
    SpeakerNotesOffOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($539627582d94ad84$exports))),
    ControlPointIcon: (0, (/*@__PURE__*/$parcel$interopDefault($b1cab0fc6c5cc2c8$exports))),
    SyncIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cf827279adbfdf3b$exports))),
    LocalFireDepartmentIcon: (0, (/*@__PURE__*/$parcel$interopDefault($afacc32d44032dcb$exports))),
    MyLocationOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ecd0a3d80d5e6881$exports))),
    StoreOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($a630d7191614c622$exports))),
    ConnectWithoutContactOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1af765e430b892bd$exports))),
    AssignmentOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fe3d85cf51706def$exports))),
    CircleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7cea090517ff863a$exports))),
    PeopleOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f26661024ff3452a$exports))),
    FilterAltOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cbfc0163fdf3fa76$exports))),
    FilterAltOffOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($98528ab5b56443e3$exports)))
};
/**
 * Icons
 * @param {ReactNode} [children] - typically an mui icon component
 * @param {IconOptions} symbol - string of available icon options
 * @param {string} size - icon size, currently supports xs, sm, md and lg (see if we can manage w/o custom rems)
 * @param {string} color - icon color from global colors defined in root css
 * @param {string} [space] - add default spacing to left or right or both ("center") sides of icon
 * @param {boolean} [rotate] - rotate 180 when true
 */ const $0eb8c2f4491c20a6$var$$54b3890db507985c$var$IconSymbol = (props)=>{
    const Symbol = $0eb8c2f4491c20a6$var$$a7a7876988c6a28d$export$c82760de046b5a30[props.symbol];
    return (0, $e9nev.jsx)(Symbol, {
        ...props
    });
};
const $0eb8c2f4491c20a6$export$f04a61298a47a40f = (props)=>{
    const { children: children, symbol: symbol, color: color = "alku-icon-default", size: size, space: space = "none", rotate: rotate = false } = props;
    return (0, $e9nev.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports.icon, $0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports[size], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[color], $0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports[space], rotate ? $0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports.rotate : "", $0eb8c2f4491c20a6$var$$9e852ed4413296f9$exports["no-shrink"]),
        "aria-hidden": true,
        children: children ?? (0, $e9nev.jsx)($0eb8c2f4491c20a6$var$$54b3890db507985c$var$IconSymbol, {
            fontSize: "inherit",
            color: "inherit",
            symbol: symbol ?? "QuestionMarkOutlinedIcon",
            style: {
                height: "1.5em",
                width: "1.5em"
            }
        })
    });
};
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports = {};
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "detail", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$13a2d28b88853ef2;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$13a2d28b88853ef2 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "four", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$75086f8fac82c4cf;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$75086f8fac82c4cf = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "link", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$9c30223ca0a664fb;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$9c30223ca0a664fb = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "menu-item", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$9aa3f5850e4e7780;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$9aa3f5850e4e7780 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "metadata", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$dbb5e893e736e4ee;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$dbb5e893e736e4ee = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "nav-text", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$8fa00096d2f15ccf;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$8fa00096d2f15ccf = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "normal", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$411e9a7b4316b872;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$411e9a7b4316b872 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "note", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$a92e4c44d367d0af;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$a92e4c44d367d0af = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "one", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$80bf7733f1207381;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$80bf7733f1207381 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "small", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$3c17b0e969a90510;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$3c17b0e969a90510 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "subheading", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$eeb03afd9378c335;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$eeb03afd9378c335 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "subheading-small", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$34b935c76b893dbf;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$34b935c76b893dbf = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "three", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$c93cff18cf760708;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$c93cff18cf760708 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "title", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$fb184b623420d9be;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$fb184b623420d9be = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports, "two", function() {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$7dfe6c2e21a8ba69;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$7dfe6c2e21a8ba69 = v;
});
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$13a2d28b88853ef2;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$75086f8fac82c4cf;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$9c30223ca0a664fb;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$9aa3f5850e4e7780;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$dbb5e893e736e4ee;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$8fa00096d2f15ccf;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$411e9a7b4316b872;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$a92e4c44d367d0af;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$80bf7733f1207381;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$3c17b0e969a90510;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$eeb03afd9378c335;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$34b935c76b893dbf;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$c93cff18cf760708;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$fb184b623420d9be;
var $0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$7dfe6c2e21a8ba69;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$13a2d28b88853ef2 = `tt8iCq_detail`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$75086f8fac82c4cf = `tt8iCq_four`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$9c30223ca0a664fb = `tt8iCq_link`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$9aa3f5850e4e7780 = `tt8iCq_menu-item`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$dbb5e893e736e4ee = `tt8iCq_metadata`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$8fa00096d2f15ccf = `tt8iCq_nav-text`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$411e9a7b4316b872 = `tt8iCq_normal`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$a92e4c44d367d0af = `tt8iCq_note`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$80bf7733f1207381 = `tt8iCq_one`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$3c17b0e969a90510 = `tt8iCq_small`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$eeb03afd9378c335 = `tt8iCq_subheading`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$34b935c76b893dbf = `tt8iCq_subheading-small`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$c93cff18cf760708 = `tt8iCq_three`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$fb184b623420d9be = `tt8iCq_title`;
$0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$export$7dfe6c2e21a8ba69 = `tt8iCq_two`;
const $0eb8c2f4491c20a6$export$a8a3e93435678ff9 = ({ children: children, style: style, as: as = "div", color: color = "alku-black" })=>{
    const Component = as;
    return (0, $e9nev.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports[style], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[color]),
        children: children
    });
};
const $0eb8c2f4491c20a6$export$5f1af8db9871e1d6 = ({ children: children, style: style, as: as, color: color = "alku-black", weight: weight = "regular", href: href, linkNewTab: linkNewTab = false, className: className })=>{
    const optionalLinkProps = {};
    if (linkNewTab && as === "a") {
        optionalLinkProps.onClick = (event)=>{
            event.preventDefault();
            $0eb8c2f4491c20a6$var$$917b1540128ca986$export$705f2bd319df8782(href);
        };
        optionalLinkProps.rel = "external nofollow nooopener";
    }
    switch(as){
        case "p":
            return (0, $e9nev.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports[style], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[weight], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[color], className),
                children: children
            });
        case "span":
            return (0, $e9nev.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports[style], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[weight], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[color], className),
                children: children
            });
        case "strong":
            return (0, $e9nev.jsx)("strong", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports[style], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[weight], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[color]),
                children: children
            });
        case "a":
            return (0, $e9nev.jsx)("a", {
                href: href,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports[style], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[weight], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[color]),
                ...optionalLinkProps,
                children: children
            });
        default:
            return (0, $e9nev.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$10e2b9e52a693fdf$exports[style], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[weight], $0eb8c2f4491c20a6$var$$a6d82f8a0e5bcabb$exports[color]),
                children: children
            });
    }
};
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$exports = {};
$0eb8c2f4491c20a6$var$$parcel$defineInteropFlag($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports);
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "account", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$6b501c78a3684162;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$6b501c78a3684162 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "account-wrapper", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$50b1df6aa49d0846;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$50b1df6aa49d0846 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "closed", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$15ff61f90f7efc74;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$15ff61f90f7efc74 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "default", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$2e2bcd8739ae039;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$2e2bcd8739ae039 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "default-wrapper", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$2c25cd47e5687053;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$2c25cd47e5687053 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "flyout", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$ec4922be16378791;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$ec4922be16378791 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "flyout-item", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$16a014f920f26dab;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$16a014f920f26dab = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "flyout-list-item-btn", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$8a2f27b9e1738769;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$8a2f27b9e1738769 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "left", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$eabcd2c8791e7bf4;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$eabcd2c8791e7bf4 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "lg", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$27ac7b32bf0e709e;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$27ac7b32bf0e709e = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "md", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$f4de1c043ce6927;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$f4de1c043ce6927 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "open", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$3ce6949f20cea765;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$3ce6949f20cea765 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "position-right", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$80a9b1256f183cca;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$80a9b1256f183cca = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports, "right", function() {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$79ffe56a765070d2;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$79ffe56a765070d2 = v;
});
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$6b501c78a3684162;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$50b1df6aa49d0846;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$15ff61f90f7efc74;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$2e2bcd8739ae039;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$2c25cd47e5687053;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$ec4922be16378791;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$16a014f920f26dab;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$8a2f27b9e1738769;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$eabcd2c8791e7bf4;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$27ac7b32bf0e709e;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$f4de1c043ce6927;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$3ce6949f20cea765;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$80a9b1256f183cca;
var $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$79ffe56a765070d2;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$6b501c78a3684162 = `_7t1vbW_account`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$50b1df6aa49d0846 = `_7t1vbW_account-wrapper`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$15ff61f90f7efc74 = `_7t1vbW_closed`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$2e2bcd8739ae039 = `_7t1vbW_default`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$2c25cd47e5687053 = `_7t1vbW_default-wrapper`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$ec4922be16378791 = `_7t1vbW_flyout`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$16a014f920f26dab = `_7t1vbW_flyout-item`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$8a2f27b9e1738769 = `_7t1vbW_flyout-list-item-btn`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$eabcd2c8791e7bf4 = `_7t1vbW_left`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$27ac7b32bf0e709e = `_7t1vbW_lg`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$f4de1c043ce6927 = `_7t1vbW_md`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$3ce6949f20cea765 = `_7t1vbW_open`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$80a9b1256f183cca = `_7t1vbW_position-right`;
$0eb8c2f4491c20a6$var$$14def1888e8888b0$export$79ffe56a765070d2 = `_7t1vbW_right`;
const $0eb8c2f4491c20a6$export$924d1752b27abfc8 = (props)=>{
    const { type: type = "default", children: children, isOpen: isOpen, setIsOpen: setIsOpen, width: width } = props;
    const ref = (0, $eeyUA.useRef)(null);
    (0, $eeyUA.useLayoutEffect)(()=>{
        if (isOpen) setTimeout(()=>{
            document.addEventListener("click", handleClickAway);
        });
        else document.removeEventListener("click", handleClickAway);
        return ()=>{
            document.removeEventListener("click", handleClickAway);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen
    ]);
    const handleClickAway = (e)=>{
        const target = e.target;
        if (ref?.current === document.activeElement && ref?.current?.contains(target)) return;
        setIsOpen(false);
    };
    return (0, $e9nev.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$14def1888e8888b0$exports.flyout, $0eb8c2f4491c20a6$var$$14def1888e8888b0$exports[type], isOpen ? $0eb8c2f4491c20a6$var$$14def1888e8888b0$exports.open : $0eb8c2f4491c20a6$var$$14def1888e8888b0$exports.closed, width === "md" ? $0eb8c2f4491c20a6$var$$14def1888e8888b0$exports.md : $0eb8c2f4491c20a6$var$$14def1888e8888b0$exports.lg),
        "aria-expanded": isOpen,
        ref: ref,
        children: children
    });
};
const $0eb8c2f4491c20a6$export$cce593c893bdcfd0 = (props)=>{
    const { onClick: onClick, buttonProps: buttonProps, iconSymbol: iconSymbol, iconProps: iconProps, buttonText: buttonText, afterButton: afterButton, isDisabled: isDisabled = false } = props;
    return (0, $e9nev.jsxs)("li", {
        className: $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$16a014f920f26dab,
        children: [
            (0, $e9nev.jsxs)($0eb8c2f4491c20a6$export$353f5b6fc5456de1, {
                as: buttonProps?.as ?? "button",
                style: "icon-only",
                onClick: onClick,
                ...buttonProps,
                disabled: isDisabled,
                className: $0eb8c2f4491c20a6$var$$14def1888e8888b0$export$8a2f27b9e1738769,
                children: [
                    (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                        space: "right",
                        color: isDisabled ? "disabled-check" : "alku-brand-primary",
                        size: "sm",
                        symbol: iconSymbol,
                        ...iconProps
                    }),
                    (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$5f1af8db9871e1d6, {
                        as: "span",
                        style: "detail",
                        color: isDisabled ? "disabled-check" : "alku-black",
                        weight: "semibold",
                        children: buttonText
                    })
                ]
            }),
            afterButton
        ]
    });
};
const $0eb8c2f4491c20a6$export$f4188c4fe84d69c1 = (props)=>{
    const { label: label, id: id, iconProps: iconProps, flyoutChildren: flyoutChildren, buttonProps: buttonProps, position: position = "right", flyoutWidth: flyoutWidth, type: type = "default" } = props;
    const [isFlyoutOpen, setIsFlyoutOpen] = (0, $eeyUA.useState)(false);
    const toggleFlyoutVisibility = (0, $eeyUA.useCallback)(()=>{
        setIsFlyoutOpen((bool)=>!bool);
    }, []);
    return (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
        children: [
            (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$353f5b6fc5456de1, {
                as: "button",
                type: "button",
                style: "function",
                ariaLabel: label,
                id: id,
                onClick: toggleFlyoutVisibility,
                ...buttonProps,
                children: type === "account" ? (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
                    children: [
                        buttonProps?.children ?? "",
                        iconProps && (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                            color: "black",
                            size: "lg",
                            ...iconProps,
                            rotate: isFlyoutOpen
                        })
                    ]
                }) : (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
                    children: [
                        iconProps && (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                            color: "black",
                            size: "lg",
                            ...iconProps,
                            rotate: isFlyoutOpen
                        }),
                        buttonProps?.children ?? ""
                    ]
                })
            }),
            (0, $e9nev.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(type === "account" ? $0eb8c2f4491c20a6$var$$14def1888e8888b0$exports["account-wrapper"] : $0eb8c2f4491c20a6$var$$14def1888e8888b0$exports["default-wrapper"], $0eb8c2f4491c20a6$var$$14def1888e8888b0$exports[`position-${position}`]),
                children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$924d1752b27abfc8, {
                    type: type,
                    isOpen: isFlyoutOpen,
                    width: flyoutWidth ?? "lg",
                    setIsOpen: setIsFlyoutOpen,
                    children: (0, $e9nev.jsx)("ul", {
                        children: flyoutChildren
                    })
                })
            })
        ]
    });
};
var $0eb8c2f4491c20a6$var$$8f3896e6ad19250c$export$89da14300d534261;
var $0eb8c2f4491c20a6$var$$8f3896e6ad19250c$export$9c30223ca0a664fb;
var $0eb8c2f4491c20a6$var$$8f3896e6ad19250c$export$80e4b313e5e6b30d;
$0eb8c2f4491c20a6$var$$8f3896e6ad19250c$export$89da14300d534261 = `bh3Kaq_active`;
$0eb8c2f4491c20a6$var$$8f3896e6ad19250c$export$9c30223ca0a664fb = `bh3Kaq_link`;
$0eb8c2f4491c20a6$var$$8f3896e6ad19250c$export$80e4b313e5e6b30d = `bh3Kaq_nav`;
const $0eb8c2f4491c20a6$export$e3925dbaeffcc83f = (props)=>{
    const { children: children, isActive: isActive } = props;
    return (0, $e9nev.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$8f3896e6ad19250c$export$9c30223ca0a664fb, isActive ? $0eb8c2f4491c20a6$var$$8f3896e6ad19250c$export$89da14300d534261 : ""),
        children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$5f1af8db9871e1d6, {
            as: "div",
            style: "nav-text",
            color: "alku-black",
            weight: isActive ? "bold" : "semibold",
            children: children
        })
    });
};
var $0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports = {};
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports, "lg", function() {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$27ac7b32bf0e709e;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$27ac7b32bf0e709e = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports, "md", function() {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$f4de1c043ce6927;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$f4de1c043ce6927 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports, "modal", function() {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$96e4b36520c26a2c;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$96e4b36520c26a2c = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports, "modal-close", function() {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$5f4794bfaafb4f26;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$5f4794bfaafb4f26 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports, "modal-container", function() {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$a7facc7e2bc2d2b4;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$a7facc7e2bc2d2b4 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports, "modal-title", function() {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$5834f0b85cf53b19;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$5834f0b85cf53b19 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports, "sm", function() {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$92d98d0701d4531a;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$92d98d0701d4531a = v;
});
var $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$27ac7b32bf0e709e;
var $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$f4de1c043ce6927;
var $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$96e4b36520c26a2c;
var $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$5f4794bfaafb4f26;
var $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$a7facc7e2bc2d2b4;
var $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$5834f0b85cf53b19;
var $0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$92d98d0701d4531a;
$0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$27ac7b32bf0e709e = `_8mrmkq_lg`;
$0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$f4de1c043ce6927 = `_8mrmkq_md`;
$0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$96e4b36520c26a2c = `_8mrmkq_modal`;
$0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$5f4794bfaafb4f26 = `_8mrmkq_modal-close`;
$0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$a7facc7e2bc2d2b4 = `_8mrmkq_modal-container`;
$0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$5834f0b85cf53b19 = `_8mrmkq_modal-title`;
$0eb8c2f4491c20a6$var$$c3273e8c502b4291$export$92d98d0701d4531a = `_8mrmkq_sm`;
const $0eb8c2f4491c20a6$export$2b77a92f1a5ad772 = ({ children: children, open: open, onRequestClose: onRequestClose, closeOnOutsideClick: closeOnOutsideClick, title: title, theme: theme = "default", className: className = "", size: size = "md" })=>{
    const dialogRef = (0, $eeyUA.useRef)(null);
    const lastActiveElement = (0, $eeyUA.useRef)(null);
    const { icon: icon, color: color } = $0eb8c2f4491c20a6$var$$dbea61467c089a69$export$9d64ff89b6869900[theme];
    (0, $eeyUA.useEffect)(()=>{
        if (!dialogRef?.current) return;
        const dialogNode = dialogRef.current;
        if (open) {
            lastActiveElement.current = document.activeElement;
            dialogNode.showModal();
            dialogNode.focus();
        } else if (dialogNode.open) {
            dialogNode.close();
            if (lastActiveElement.current instanceof HTMLElement) lastActiveElement.current.focus();
        }
    }, [
        open
    ]);
    // add cancel handling
    const handleCancel = (0, $eeyUA.useCallback)((event)=>{
        event.preventDefault();
        if (event.target === dialogRef.current) onRequestClose();
    }, [
        onRequestClose
    ]);
    (0, $eeyUA.useEffect)(()=>{
        if (!dialogRef?.current) return;
        const dialogNode = dialogRef.current;
        dialogNode.addEventListener("cancel", handleCancel);
        return ()=>{
            dialogNode.removeEventListener("cancel", handleCancel);
        };
    }, [
        dialogRef,
        handleCancel
    ]);
    const handleOutsideClick = (event)=>{
        const dialogNode = dialogRef.current;
        if (closeOnOutsideClick && event.target === dialogNode) onRequestClose();
    };
    return (0, $6568ab17ba5c963b$exports.createPortal)((0, $e9nev.jsxs)("dialog", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports.modal, $0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports[size]),
        ref: dialogRef,
        onClick: handleOutsideClick,
        children: [
            (0, $e9nev.jsx)("div", {
                className: `${$0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports["modal-close"]}`,
                children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$353f5b6fc5456de1, {
                    as: "button",
                    id: "close-modal",
                    type: "button",
                    style: "icon-only",
                    ariaLabel: "close",
                    onClick: onRequestClose,
                    children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                        symbol: "CloseOutlinedIcon",
                        color: "alku-brand-primary",
                        size: "lg"
                    })
                })
            }),
            (0, $e9nev.jsxs)("div", {
                className: `${$0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports["modal-container"]} ${className}`,
                children: [
                    typeof title === "string" && (0, $e9nev.jsxs)("div", {
                        className: $0eb8c2f4491c20a6$var$$c3273e8c502b4291$exports["modal-title"],
                        children: [
                            theme !== "default" && (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                                symbol: icon,
                                color: color,
                                size: "lg",
                                space: "right"
                            }),
                            (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$a8a3e93435678ff9, {
                                as: "h3",
                                style: "three",
                                children: title
                            })
                        ]
                    }),
                    open ? children : null
                ]
            })
        ]
    }), document.body);
};
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$48e875d2d67d1ea6;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$b07e517d22efa1ca;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$9039ae56a700b4b4;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$dc2fd8f11acad4f6;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$10e528d0b71c3da2;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$b7f2353d94324f0d;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$376f46f0872b00ac;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$df4b052846ef414;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$fcc987631b73b72;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$e70786014ab58dbc;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$c0ff24c33853225;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$ec411651e2bad632;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$baaf81764c3fc10d;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$4935553e21c7c02b;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$60b1d8487debf9b7;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$4845725ffcd90c16;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$8e3fa857a77da761;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$2a95a8e98e57f7ab;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$2d8174d282f74895;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$c465dacf40ab9d21;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$305be758c69471f9;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$58bc64e42728b362;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$f8959486d01db527;
var $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$7c2b73235716e641;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$48e875d2d67d1ea6 = `FLSXqq_check-icon`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$b07e517d22efa1ca = `FLSXqq_checkbox`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$9039ae56a700b4b4 = `FLSXqq_checkbox-container`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$dc2fd8f11acad4f6 = `FLSXqq_checkbox-label`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$10e528d0b71c3da2 = `FLSXqq_custom-checkbox`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$b7f2353d94324f0d = `FLSXqq_custom-radio`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$376f46f0872b00ac = `FLSXqq_custom-radio__checkmark`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$df4b052846ef414 = `FLSXqq_custom-radio__label`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$fcc987631b73b72 = `FLSXqq_error-label`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$e70786014ab58dbc = `FLSXqq_filled`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$c0ff24c33853225 = `FLSXqq_lg-checkbox`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$ec411651e2bad632 = `FLSXqq_select-input-container`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$baaf81764c3fc10d = `FLSXqq_select-input-field`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$4935553e21c7c02b = `FLSXqq_select-input-label`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$60b1d8487debf9b7 = `FLSXqq_text-input-container`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$4845725ffcd90c16 = `FLSXqq_text-input-container-no-label`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$8e3fa857a77da761 = `FLSXqq_text-input-field`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$2a95a8e98e57f7ab = `FLSXqq_text-input-label`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$2d8174d282f74895 = `FLSXqq_text-input-required`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$c465dacf40ab9d21 = `FLSXqq_textarea-field`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$305be758c69471f9 = `FLSXqq_toggle-switch`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$58bc64e42728b362 = `FLSXqq_toggle-switch-checkbox`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$f8959486d01db527 = `FLSXqq_toggle-switch-label`;
$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$7c2b73235716e641 = `FLSXqq_toggle-switch-slider`;
const $0eb8c2f4491c20a6$export$c86715117507e8e5 = (0, $eeyUA.forwardRef)(({ id: id, label: label, value: value, onChange: onChange, required: required = false, errorMessage: errorMessage, multiline: multiline = false, rows: rows = 3, noLabel: noLabel = false, showHighPriorityIcon: showHighPriorityIcon = false, ...inputProps }, ref)=>{
    const ariaLabel = noLabel ? label : undefined;
    const handleChange = (event)=>{
        if (onChange) onChange(event);
    };
    return (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
        children: [
            (0, $e9nev.jsxs)("div", {
                className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$60b1d8487debf9b7,
                children: [
                    !noLabel ? (0, $e9nev.jsxs)("label", {
                        htmlFor: id,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$2a95a8e98e57f7ab, errorMessage && $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$fcc987631b73b72),
                        children: [
                            showHighPriorityIcon && (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                                symbol: "ReportProblemOutlinedIcon",
                                color: "alku-brand-primary",
                                size: "sm",
                                space: "right"
                            }),
                            label,
                            required && (0, $e9nev.jsx)("span", {
                                className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$2d8174d282f74895,
                                children: "*"
                            })
                        ]
                    }) : (0, $e9nev.jsx)("div", {
                        className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$4845725ffcd90c16
                    }),
                    multiline ? (0, $e9nev.jsx)("textarea", {
                        ref: ref,
                        id: id,
                        className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$c465dacf40ab9d21,
                        value: value,
                        onChange: handleChange,
                        rows: rows,
                        "aria-label": ariaLabel,
                        ...inputProps
                    }) : (0, $e9nev.jsx)("input", {
                        ref: ref,
                        id: id,
                        className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$8e3fa857a77da761,
                        value: value,
                        onChange: handleChange,
                        "aria-label": ariaLabel,
                        ...inputProps
                    })
                ]
            }),
            errorMessage && (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$5f1af8db9871e1d6, {
                style: "small",
                color: "alku-brand-primary",
                weight: "semibold",
                children: errorMessage
            })
        ]
    });
});
$0eb8c2f4491c20a6$export$c86715117507e8e5.displayName = "TextInput";
const $0eb8c2f4491c20a6$export$58f903f55606e69d = (0, $eeyUA.forwardRef)(({ id: id, label: label, value: value = "", onChange: onChange, required: required, options: options, errorMessage: errorMessage, noLabel: noLabel = false, showHighPriorityIcon: showHighPriorityIcon = false, ...rest }, ref)=>{
    const [selectedValue, setSelectedValue] = (0, $eeyUA.useState)(value);
    const internalRef = (0, $eeyUA.useRef)(null);
    (0, $eeyUA.useEffect)(()=>{
        if (internalRef.current) internalRef.current.value = selectedValue;
    }, [
        selectedValue
    ]);
    const handleChange = (event)=>{
        const newValue = event.target.value;
        setSelectedValue(newValue);
        if (onChange) onChange(event);
    };
    (0, $eeyUA.useEffect)(()=>{
        if (typeof ref === "function") ref(internalRef.current);
        else if (ref) ref.current = internalRef.current;
    }, [
        ref
    ]);
    const ariaLabel = noLabel ? label : undefined;
    return (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
        children: [
            (0, $e9nev.jsxs)("div", {
                className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$ec411651e2bad632,
                children: [
                    !noLabel ? (0, $e9nev.jsxs)("label", {
                        htmlFor: id,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$4935553e21c7c02b, errorMessage && $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$fcc987631b73b72),
                        children: [
                            showHighPriorityIcon && (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                                symbol: "ReportProblemOutlinedIcon",
                                color: "alku-brand-primary",
                                size: "sm",
                                space: "right"
                            }),
                            label,
                            required && (0, $e9nev.jsx)("span", {
                                className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$2d8174d282f74895,
                                children: "*"
                            })
                        ]
                    }) : (0, $e9nev.jsx)("div", {
                        className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$4845725ffcd90c16
                    }),
                    (0, $e9nev.jsx)("select", {
                        id: id,
                        ref: internalRef,
                        className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$baaf81764c3fc10d,
                        required: required,
                        onChange: handleChange,
                        "aria-label": ariaLabel,
                        value: selectedValue,
                        ...rest,
                        children: options.map((option)=>(0, $e9nev.jsx)("option", {
                                value: option.value,
                                children: option.label
                            }, option.value))
                    })
                ]
            }),
            errorMessage && (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$5f1af8db9871e1d6, {
                style: "small",
                color: "alku-brand-primary",
                weight: "semibold",
                children: errorMessage
            })
        ]
    });
});
$0eb8c2f4491c20a6$export$58f903f55606e69d.displayName = "SingleSelect";
const $0eb8c2f4491c20a6$export$ea5f704b89d806f6 = (0, $eeyUA.forwardRef)(({ checked: checked, onChange: onChange, label: label, ariaLabel: ariaLabel, className: className = "", ...rest }, ref)=>{
    return (0, $e9nev.jsx)("div", {
        className: `${$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$9039ae56a700b4b4} ${className}`,
        children: (0, $e9nev.jsxs)("label", {
            className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$dc2fd8f11acad4f6,
            children: [
                (0, $e9nev.jsx)("input", {
                    type: "checkbox",
                    checked: checked,
                    onChange: onChange,
                    "aria-checked": checked,
                    className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$b07e517d22efa1ca,
                    "aria-label": ariaLabel,
                    ref: ref,
                    ...rest
                }),
                (0, $e9nev.jsx)("span", {
                    className: `${$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$10e528d0b71c3da2} ${checked ? $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$e70786014ab58dbc : ""}`,
                    children: checked && (0, $e9nev.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($36c92e7fbb27c050$exports))), {
                        className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$48e875d2d67d1ea6
                    })
                }),
                label
            ]
        })
    });
});
$0eb8c2f4491c20a6$export$ea5f704b89d806f6.displayName = "CheckBox";
const $0eb8c2f4491c20a6$export$f4422ae58352e179 = (0, $eeyUA.forwardRef)(({ checked: checked, onChange: onChange, name: name, value: value, label: label, ariaLabel: ariaLabel, ...rest }, ref)=>{
    return (0, $e9nev.jsxs)("label", {
        className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$b7f2353d94324f0d,
        children: [
            (0, $e9nev.jsx)("input", {
                type: "radio",
                "aria-label": ariaLabel,
                "aria-checked": checked,
                checked: checked,
                onChange: onChange,
                name: name,
                value: value,
                ref: ref,
                ...rest
            }),
            (0, $e9nev.jsx)("span", {
                className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$376f46f0872b00ac
            }),
            (0, $e9nev.jsx)("span", {
                className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$df4b052846ef414,
                children: label
            })
        ]
    });
});
$0eb8c2f4491c20a6$export$f4422ae58352e179.displayName = "RadioButton";
// https://react-select.com/home
var $0eb8c2f4491c20a6$var$$884e730d81512b24$export$d76128d007d19019;
var $0eb8c2f4491c20a6$var$$884e730d81512b24$export$2e6c959c16ff56b8;
$0eb8c2f4491c20a6$var$$884e730d81512b24$export$d76128d007d19019 = `MZGFPW_search`;
$0eb8c2f4491c20a6$var$$884e730d81512b24$export$2e6c959c16ff56b8 = `MZGFPW_select`;
const $0eb8c2f4491c20a6$var$$4bae63beb61c725b$var$Label = ({ noLabel: noLabel, id: id, error: error, showHighPriorityIcon: showHighPriorityIcon, required: required, label: label })=>!noLabel ? (0, $e9nev.jsxs)("label", {
        htmlFor: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$2a95a8e98e57f7ab, error && $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$fcc987631b73b72),
        children: [
            showHighPriorityIcon && (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                symbol: "ReportProblemOutlinedIcon",
                color: "alku-brand-primary",
                size: "sm",
                space: "right"
            }),
            label,
            required && (0, $e9nev.jsx)("span", {
                className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$2d8174d282f74895,
                children: "*"
            })
        ]
    }) : (0, $e9nev.jsx)("div", {
        className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$4845725ffcd90c16
    });
var $0eb8c2f4491c20a6$var$$4bae63beb61c725b$export$2e2bcd8739ae039 = $0eb8c2f4491c20a6$var$$4bae63beb61c725b$var$Label;
const $0eb8c2f4491c20a6$var$$1e2adfe7ae6fe9a8$export$d52e1ba4a0ca7715 = (props)=>{
    const { children: children } = props;
    if (Array.isArray(children)) return (0, $e9nev.jsx)((0, $749f6ec63f6eddee$export$ae9e55e1d8a2f4b7), {
        width: "100%",
        itemSize: 45,
        height: 320,
        itemCount: children.length,
        children: ({ style: style, index: index })=>(0, $e9nev.jsx)("div", {
                style: style,
                children: children[index]
            })
    });
    return (0, $e9nev.jsx)((0, $e9nev.Fragment), {
        children: children
    });
};
const $0eb8c2f4491c20a6$var$$f763746754f5c2fe$export$c78cbf1c0339c149 = function ClearIndicatorWrapper({ name: name, isSearchable: isSearchable }) {
    const ClearIndicator = ({ innerProps: innerProps, ...props })=>{
        return (0, $e9nev.jsx)((0, $ff70ed66f0d56426$export$db3b6bfb95261072).ClearIndicator, {
            innerProps: {
                "aria-label": `Clear ${name ?? ""}`,
                ...innerProps
            },
            ...props,
            children: isSearchable && (0, $e9nev.jsx)($0eb8c2f4491c20a6$var$$f763746754f5c2fe$export$cefbac224a47f32, {})
        });
    };
    return ClearIndicator;
};
const $0eb8c2f4491c20a6$var$$f763746754f5c2fe$export$cefbac224a47f32 = ()=>{
    return (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
        symbol: "CancelIcon",
        color: "grey-8",
        size: "sm"
    });
};
const $0eb8c2f4491c20a6$var$$24d96fe60f4ba9df$export$51e02a53767a99fc = function DropdownIndicatorWrapper({ isSearchable: isSearchable }) {
    const DropdownIndicator = (props)=>{
        return (0, $e9nev.jsx)((0, $ff70ed66f0d56426$export$db3b6bfb95261072).DropdownIndicator, {
            ...props,
            children: isSearchable ? (0, $e9nev.jsx)($0eb8c2f4491c20a6$var$$24d96fe60f4ba9df$var$SearchIcon, {}) : (0, $e9nev.jsx)($0eb8c2f4491c20a6$var$$24d96fe60f4ba9df$var$CaretDownIcon, {})
        });
    };
    return DropdownIndicator;
};
const $0eb8c2f4491c20a6$var$$24d96fe60f4ba9df$var$CaretDownIcon = ()=>{
    return (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
        symbol: "ArrowDropDownOutlinedIcon",
        color: "grey-8",
        size: "lg"
    });
};
const $0eb8c2f4491c20a6$var$$24d96fe60f4ba9df$var$SearchIcon = ()=>{
    return (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
        symbol: "SearchIcon",
        color: "grey-8",
        size: "sm"
    });
};
const $0eb8c2f4491c20a6$var$$c70182d1b26dd267$export$8d6a14a0f231b3a3 = ()=>{
    const Option = ({ children: children, innerProps: innerProps, ...props })=>{
        const data = props.data;
        return (0, $e9nev.jsx)((0, $ff70ed66f0d56426$export$db3b6bfb95261072).Option, {
            innerProps: {
                ...innerProps,
                role: "option"
            },
            ...props,
            children: data.phones ? (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
                children: [
                    (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$5f1af8db9871e1d6, {
                        style: "detail",
                        weight: "semibold",
                        as: "div",
                        children: children
                    }),
                    data.phones.direct && (0, $e9nev.jsxs)($0eb8c2f4491c20a6$export$5f1af8db9871e1d6, {
                        style: "note",
                        weight: "regular",
                        as: "div",
                        children: [
                            "D: ",
                            data.phones.direct
                        ]
                    }),
                    data.phones.mobile && (0, $e9nev.jsxs)($0eb8c2f4491c20a6$export$5f1af8db9871e1d6, {
                        style: "note",
                        weight: "regular",
                        as: "div",
                        children: [
                            "M: ",
                            data.phones.mobile
                        ]
                    }),
                    data.phones.other && (0, $e9nev.jsxs)($0eb8c2f4491c20a6$export$5f1af8db9871e1d6, {
                        style: "note",
                        weight: "regular",
                        as: "div",
                        children: [
                            "O: ",
                            data.phones.other
                        ]
                    })
                ]
            }) : (0, $e9nev.jsx)((0, $e9nev.Fragment), {
                children: children
            })
        });
    };
    return Option;
};
const $0eb8c2f4491c20a6$var$$df952df053cb9a1a$export$2f431b47f660f2b = function NoOptionsMessageWrapper({ noOptionsText: noOptionsText }) {
    const NoOptionsMessage = (props)=>{
        return (0, $e9nev.jsx)((0, $ff70ed66f0d56426$export$db3b6bfb95261072).NoOptionsMessage, {
            ...props,
            children: noOptionsText
        });
    };
    return NoOptionsMessage;
};
const $0eb8c2f4491c20a6$var$$119b6213618bab0a$export$6e30bf8cb1347b56 = function SingleValueWrapper({ inputLabelPrefix: inputLabelPrefix }) {
    if (!inputLabelPrefix) return (0, $ff70ed66f0d56426$export$db3b6bfb95261072).SingleValue;
    const SingleValue = ({ children: children, ...props })=>{
        return (0, $e9nev.jsxs)((0, $ff70ed66f0d56426$export$db3b6bfb95261072).SingleValue, {
            ...props,
            children: [
                inputLabelPrefix,
                " ",
                children
            ]
        });
    };
    return SingleValue;
};
const $0eb8c2f4491c20a6$export$124e49603add0284 = ({ defaultOptionSelected: defaultOptionSelected = false, isSearchable: isSearchable = false, required: required = false, name: name = "", readOnly: readOnly = false, value: value, label: label, ariaLabel: ariaLabel, className: className, onChange: onChange, inputLabelPrefix: inputLabelPrefix, screenReaderOnlyLabel: screenReaderOnlyLabel = false, virtualize: virtualize = false, maxMenuHeight: maxMenuHeight = 250, noOptionsText: noOptionsText = "No Options", error: error, onClear: onClear, isMulti: isMulti = false, isClearable: isClearable = false, ...restProps })=>{
    const DropdownIndicator = (0, $eeyUA.useMemo)(()=>$0eb8c2f4491c20a6$var$$24d96fe60f4ba9df$export$51e02a53767a99fc({
            isSearchable: isSearchable
        }), [
        isSearchable
    ]);
    const ClearIndicator = (0, $eeyUA.useMemo)(()=>$0eb8c2f4491c20a6$var$$f763746754f5c2fe$export$c78cbf1c0339c149({
            name: name,
            isSearchable: isSearchable
        }), [
        isSearchable,
        name
    ]);
    const NoOptionsMessage = (0, $eeyUA.useMemo)(()=>$0eb8c2f4491c20a6$var$$df952df053cb9a1a$export$2f431b47f660f2b({
            noOptionsText: noOptionsText
        }), [
        noOptionsText
    ]);
    const SingleValue = (0, $eeyUA.useMemo)(()=>$0eb8c2f4491c20a6$var$$119b6213618bab0a$export$6e30bf8cb1347b56({
            inputLabelPrefix: inputLabelPrefix
        }), [
        inputLabelPrefix
    ]);
    const Option = (0, $eeyUA.useMemo)(()=>$0eb8c2f4491c20a6$var$$c70182d1b26dd267$export$8d6a14a0f231b3a3(), []);
    const handleChange = (selection)=>{
        if (onChange) {
            if (Array.isArray(selection)) {
                const values = selection?.map((s)=>s.value);
                onChange(values);
            } else onChange(selection?.value ?? null);
        }
        if (onClear && selection === null) onClear();
    };
    return (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
        children: [
            label && (0, $e9nev.jsx)($0eb8c2f4491c20a6$var$$4bae63beb61c725b$export$2e2bcd8739ae039, {
                id: name,
                label: label,
                required: required,
                error: error
            }),
            (0, $e9nev.jsx)((0, $f7b5817f67dac20a$export$2e2bcd8739ae039), {
                ...restProps,
                components: {
                    DropdownIndicator: DropdownIndicator,
                    ClearIndicator: ClearIndicator,
                    NoOptionsMessage: NoOptionsMessage,
                    SingleValue: SingleValue,
                    Option: Option,
                    MenuList: virtualize ? $0eb8c2f4491c20a6$var$$1e2adfe7ae6fe9a8$export$d52e1ba4a0ca7715 : (0, $ff70ed66f0d56426$export$db3b6bfb95261072).MenuList
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$884e730d81512b24$export$2e6c959c16ff56b8, isSearchable ? $0eb8c2f4491c20a6$var$$884e730d81512b24$export$d76128d007d19019 : "", className),
                "aria-label": ariaLabel,
                unstyled: true,
                styles: {
                    control: (base, state)=>({
                            ...base,
                            outline: "inherit",
                            "&:focus-within": {
                                outline: "-webkit-focus-ring-color auto 1px",
                                "box-shadow": "0 0 1rem 0 rgba(9, 55, 124, 0.5)"
                            }
                        }),
                    option: (base, props)=>({
                            ...base,
                            ...props.isFocused && {
                                outline: "-webkit-focus-ring-color auto 1px"
                            }
                        })
                },
                onChange: (v)=>{
                    handleChange(v);
                },
                isSearchable: isSearchable,
                classNamePrefix: "react-select",
                isClearable: isClearable || isSearchable,
                name: name,
                isDisabled: readOnly || restProps.isDisabled,
                maxMenuHeight: maxMenuHeight,
                isMulti: isMulti,
                value: value
            }),
            error && (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$5f1af8db9871e1d6, {
                style: "small",
                color: "alku-brand-primary",
                weight: "semibold",
                children: error
            })
        ]
    });
};
const $0eb8c2f4491c20a6$export$ea72a81534ebdad5 = ({ name: name = "", value: value, touched: touched = false, onChange: onChange, maxMenuHeight: maxMenuHeight = 250, noOptionsText: noOptionsText = "No Options", setValue: setValue, ...restProps })=>{
    (0, $eeyUA.useEffect)(()=>{
        if (value != null && setValue) {
            if (Array.isArray(value)) value.forEach((val)=>setValue(name, val.value));
            else setValue(name, value.value);
        }
    }, [
        setValue,
        value
    ]);
    const handleChange = (e)=>{
        if (e != null && setValue) setValue(name, e);
        if (typeof onChange === "function" && e !== null) onChange(e);
    };
    return (0, $e9nev.jsx)((0, $e9nev.Fragment), {
        children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$124e49603add0284, {
            ...restProps,
            value: value,
            touched: touched,
            onChange: handleChange,
            name: name,
            maxMenuHeight: maxMenuHeight,
            noOptionsText: noOptionsText
        })
    });
};
const $0eb8c2f4491c20a6$export$bea8ebba691c5813 = ({ checked: checked, onChange: onChange, label: label, ariaLabel: ariaLabel, className: className = "" })=>{
    return (0, $e9nev.jsxs)("label", {
        className: `${$0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$305be758c69471f9} ${className}`,
        children: [
            (0, $e9nev.jsx)("input", {
                type: "checkbox",
                checked: checked,
                onChange: onChange,
                "aria-checked": checked,
                "aria-label": ariaLabel,
                className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$58bc64e42728b362
            }),
            (0, $e9nev.jsx)("span", {
                className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$7c2b73235716e641
            }),
            label && (0, $e9nev.jsx)("span", {
                className: $0eb8c2f4491c20a6$var$$c2c2e7355ab24337$export$f8959486d01db527,
                children: label
            })
        ]
    });
};
var $0eb8c2f4491c20a6$var$$6b2a4da568ddee1d$export$46919bad18fb2f76;
(function(Role) {
    Role["ACCOUNT_MANAGER"] = "ACCOUNT_MANAGER";
    Role["NON_PRODUCER"] = "NON_PRODUCER";
    Role["RECRUITER"] = "RECRUITER";
    Role["NA"] = "N/A";
})($0eb8c2f4491c20a6$var$$6b2a4da568ddee1d$export$46919bad18fb2f76 || ($0eb8c2f4491c20a6$var$$6b2a4da568ddee1d$export$46919bad18fb2f76 = {}));
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports = {};
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "add-button", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$3193c42f8963eae6;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$3193c42f8963eae6 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "add-button-selected", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$5408d0cb424011ce;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$5408d0cb424011ce = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "add-flyout-item", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$1cd6cbff4c7027b3;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$1cd6cbff4c7027b3 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "add-flyout-menu", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$b4446be4c43cd49;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$b4446be4c43cd49 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "app-link-with-flyout", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$2704a37f8f853e90;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$2704a37f8f853e90 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "app-link-with-flyout-selected", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$c265117a5dc6822d;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$c265117a5dc6822d = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "app-links", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$9e362d663690f73d;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$9e362d663690f73d = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "app-selected", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$d560979766e523ce;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$d560979766e523ce = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "arrow-up", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$43897744d4b4c564;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$43897744d4b4c564 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "border-left", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$4b55cc737c4985b9;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$4b55cc737c4985b9 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "column", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$4e0c71f277ca26b3;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$4e0c71f277ca26b3 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "flyout-item", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$16a014f920f26dab;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$16a014f920f26dab = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "flyout-item-selected", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$da204b82030280b1;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$da204b82030280b1 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "flyout-menu", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$dc00fa1c30d03c72;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$dc00fa1c30d03c72 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "flyout-submenu", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$9ac8a7a58a68ea55;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$9ac8a7a58a68ea55 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "flyout-toggle", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$e9abe73d9145f91c;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$e9abe73d9145f91c = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "header-hidden", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$82a73d8d230cecc1;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$82a73d8d230cecc1 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "header-nav", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$b14562835e565eed;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$b14562835e565eed = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "icon-color", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$8c5868fc86120256;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$8c5868fc86120256 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "icon-container", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$a9c197b05f9cff86;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$a9c197b05f9cff86 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "logo", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$db3c28d99448dcff;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$db3c28d99448dcff = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "row", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$120ff0929b202a6d;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$120ff0929b202a6d = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "sticky-header", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$64993cce6e6922d6;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$64993cce6e6922d6 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "user-icon", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$cafc46a9962c7699;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$cafc46a9962c7699 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "user-initials", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$db900bc4c2c2386;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$db900bc4c2c2386 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports, "user-name", function() {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$31bb46544937dfa;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$31bb46544937dfa = v;
});
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$3193c42f8963eae6;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$5408d0cb424011ce;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$1cd6cbff4c7027b3;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$b4446be4c43cd49;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$2704a37f8f853e90;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$c265117a5dc6822d;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$9e362d663690f73d;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$d560979766e523ce;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$43897744d4b4c564;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$4b55cc737c4985b9;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$4e0c71f277ca26b3;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$16a014f920f26dab;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$da204b82030280b1;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$dc00fa1c30d03c72;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$9ac8a7a58a68ea55;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$e9abe73d9145f91c;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$82a73d8d230cecc1;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$b14562835e565eed;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$8c5868fc86120256;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$a9c197b05f9cff86;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$db3c28d99448dcff;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$120ff0929b202a6d;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$64993cce6e6922d6;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$cafc46a9962c7699;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$db900bc4c2c2386;
var $0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$31bb46544937dfa;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$3193c42f8963eae6 = `QyKJgW_add-button`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$5408d0cb424011ce = `QyKJgW_add-button-selected`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$1cd6cbff4c7027b3 = `QyKJgW_add-flyout-item`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$b4446be4c43cd49 = `QyKJgW_add-flyout-menu`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$2704a37f8f853e90 = `QyKJgW_app-link-with-flyout`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$c265117a5dc6822d = `QyKJgW_app-link-with-flyout-selected`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$9e362d663690f73d = `QyKJgW_app-links`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$d560979766e523ce = `QyKJgW_app-selected`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$43897744d4b4c564 = `QyKJgW_arrow-up`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$4b55cc737c4985b9 = `QyKJgW_border-left`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$4e0c71f277ca26b3 = `QyKJgW_column`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$16a014f920f26dab = `QyKJgW_flyout-item`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$da204b82030280b1 = `QyKJgW_flyout-item-selected`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$dc00fa1c30d03c72 = `QyKJgW_flyout-menu`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$9ac8a7a58a68ea55 = `QyKJgW_flyout-submenu`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$e9abe73d9145f91c = `QyKJgW_flyout-toggle`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$82a73d8d230cecc1 = `QyKJgW_header-hidden`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$b14562835e565eed = `QyKJgW_header-nav`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$8c5868fc86120256 = `QyKJgW_icon-color`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$a9c197b05f9cff86 = `QyKJgW_icon-container`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$db3c28d99448dcff = `QyKJgW_logo`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$120ff0929b202a6d = `QyKJgW_row`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$64993cce6e6922d6 = `QyKJgW_sticky-header`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$cafc46a9962c7699 = `QyKJgW_user-icon`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$db900bc4c2c2386 = `QyKJgW_user-initials`;
$0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$export$31bb46544937dfa = `QyKJgW_user-name`;
/**
 * Helper function to pull initials from first and last name strings
 */ const $0eb8c2f4491c20a6$var$$b040407228e93fd2$export$de9bdbce6502b027 = (first_name, last_name)=>{
    return first_name.substring(0, 1).toUpperCase() + last_name.substring(0, 1).toUpperCase();
};
var $dea65142fef47b01$exports = {};
$dea65142fef47b01$exports = import.meta.resolve("1y73l");


const $0eb8c2f4491c20a6$export$78990388006fc58f = ({ userName: userName, userRole: userRole, handleSignout: handleSignout, links: links, addFlyoutItems: addFlyoutItems })=>{
    const imageUrl = new URL($dea65142fef47b01$exports);
    const [flyoutVisible, setFlyoutVisible] = (0, $eeyUA.useState)(false);
    const [flyoutAppLinkVisible, setFlyoutAppLinkVisible] = (0, $eeyUA.useState)(false);
    const [userInitials, setUserInitials] = (0, $eeyUA.useState)("");
    const firstName = userName.split(" ")[0];
    const lastName = userName.split(" ")[1];
    const sessionRole = localStorage.getItem("userRole");
    const [currentRole, setCurrentRole] = (0, $eeyUA.useState)(sessionRole ? sessionRole : userRole === $0eb8c2f4491c20a6$var$$6b2a4da568ddee1d$export$46919bad18fb2f76.NON_PRODUCER ? $0eb8c2f4491c20a6$var$$6b2a4da568ddee1d$export$46919bad18fb2f76.ACCOUNT_MANAGER : userRole);
    const [currentPath, setCurrentPath] = (0, $eeyUA.useState)(window.location.pathname);
    const [addFlyoutVisible, setAddFlyoutVisible] = (0, $eeyUA.useState)(false);
    const lastScrollY = (0, $eeyUA.useRef)(0);
    const stickyHeaderRef = (0, $eeyUA.useRef)(null);
    const threshold = 200;
    // Create an object where the key is the role and the value is the list of routes
    const routesByRole = links.map((link)=>({
            role: link.role,
            routes: link.apps.map((app)=>app.route)
        }));
    const userRoleData = links.find((role)=>role.role === currentRole);
    (0, $eeyUA.useEffect)(()=>{
        const handlePathChange = ()=>{
            setCurrentPath(window.location.pathname);
        };
        window.addEventListener("popstate", handlePathChange);
        return ()=>{
            window.removeEventListener("popstate", handlePathChange);
        };
    }, []);
    (0, $eeyUA.useEffect)(()=>{
        const roleRoutes = routesByRole.find((role)=>role.role === currentRole)?.routes || [];
        const isPipelinesRoute = currentPath.startsWith("/pipelines");
        if (!isPipelinesRoute && !roleRoutes.some((route)=>currentPath.startsWith(route))) {
            const defaultRoute = roleRoutes[0];
            if (defaultRoute) {
                window.history.pushState({}, "", defaultRoute);
                setCurrentPath(defaultRoute); // Ensure navbar re-renders
            }
        }
    }, [
        currentRole,
        routesByRole,
        currentPath
    ]);
    (0, $eeyUA.useEffect)(()=>{
        const stickyHeader = stickyHeaderRef.current;
        if (!stickyHeader) return;
        const handleScroll = ()=>{
            const currentScrollY = window.scrollY;
            // Always show navbar if scrolled near the top
            if (currentScrollY < threshold) {
                stickyHeader.classList.remove(/*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["header-hidden"]);
                return;
            }
            // Hide on scroll down, show on scroll up
            if (currentScrollY > lastScrollY.current) stickyHeader.classList.add(/*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["header-hidden"]);
            else stickyHeader.classList.remove(/*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["header-hidden"]);
            lastScrollY.current = currentScrollY;
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0, $eeyUA.useEffect)(()=>{
        const initials = $0eb8c2f4491c20a6$var$$b040407228e93fd2$export$de9bdbce6502b027(firstName, lastName);
        setUserInitials(initials);
    }, []);
    const toggleFlyout = ()=>{
        setFlyoutVisible(!flyoutVisible);
    };
    const toggleAddFlyout = ()=>{
        setFlyoutVisible(false);
        setAddFlyoutVisible(!addFlyoutVisible);
    };
    const toggleFlyoutAppLink = ()=>{
        setFlyoutAppLinkVisible(!flyoutAppLinkVisible);
    };
    const handleRoleChange = (role)=>{
        localStorage.setItem("userRole", role);
        setCurrentRole(role); // This will trigger the useEffect that handles the URL update and app name change
        setFlyoutVisible(false);
    };
    const iconMap = {
        UserAddOutlined: (0, $e19755f90d6d68a6$export$2e2bcd8739ae039),
        ApartmentOutlined: (0, $7e8dd60fcd4e2bc9$export$2e2bcd8739ae039),
        TagOutlined: (0, $07842ba6c5458c89$export$2e2bcd8739ae039),
        BankOutlined: (0, $b19fbf50a4bf375b$export$2e2bcd8739ae039)
    };
    function getIconComponent(name) {
        const Icon = iconMap[name];
        return Icon ? (0, $e9nev.jsx)(Icon, {}) : null;
    }
    return (0, $e9nev.jsxs)("header", {
        className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["sticky-header"],
        id: "stickyHeader",
        ref: stickyHeaderRef,
        children: [
            (0, $e9nev.jsx)("div", {
                className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["logo"],
                children: (0, $e9nev.jsx)("img", {
                    src: imageUrl.toString(),
                    alt: "Cactus Logo"
                })
            }),
            (0, $e9nev.jsx)("nav", {
                className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["header-nav"],
                children: (0, $e9nev.jsxs)("div", {
                    className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["row"],
                    children: [
                        (0, $e9nev.jsx)("div", {
                            className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["column"],
                            children: (0, $e9nev.jsx)("div", {
                                className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["app-links"],
                                children: userRoleData?.apps.filter((app)=>app.isVisible !== false).map((app)=>(0, $e9nev.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Fragment, {
                                        children: app.children ? (0, $e9nev.jsxs)("div", {
                                            className: currentPath.startsWith(app.route) ? /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["app-link-with-flyout-selected"] : /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["app-link-with-flyout"],
                                            children: [
                                                (0, $e9nev.jsxs)("button", {
                                                    className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["flyout-toggle"],
                                                    onClick: toggleFlyoutAppLink,
                                                    "aria-haspopup": "true",
                                                    "aria-expanded": flyoutAppLinkVisible,
                                                    children: [
                                                        app.name,
                                                        (0, $e9nev.jsx)("div", {
                                                            className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["icon-container"],
                                                            children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                                                                symbol: "ExpandMoreOutlinedIcon",
                                                                color: "cactus-off-white",
                                                                size: "md",
                                                                rotate: flyoutAppLinkVisible
                                                            })
                                                        })
                                                    ]
                                                }),
                                                flyoutAppLinkVisible && (0, $e9nev.jsx)("div", {
                                                    className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["flyout-submenu"],
                                                    children: app.children.map((child)=>(0, $e9nev.jsx)("a", {
                                                            className: currentPath.startsWith(child.route) ? /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["app-selected"] : undefined,
                                                            href: child.route,
                                                            target: child.newTab ? "_blank" : "_self",
                                                            rel: child.newTab ? "noopener noreferrer" : undefined,
                                                            children: child.name
                                                        }, child.name))
                                                })
                                            ]
                                        }) : (0, $e9nev.jsx)("a", {
                                            className: `${currentPath.startsWith(app.route) ? /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["app-selected"] : ""}`,
                                            href: app.route,
                                            target: app.newTab ? "_blank" : "_self",
                                            rel: app.newTab ? "noopener noreferrer" : undefined,
                                            children: app.name
                                        })
                                    }, app.name))
                            })
                        }),
                        addFlyoutItems && (0, $e9nev.jsx)("div", {
                            className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["column"],
                            style: {
                                flex: "none",
                                marginRight: "1rem"
                            },
                            children: (0, $e9nev.jsxs)("button", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(/*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["add-button"], addFlyoutVisible ? /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["add-button-selected"] : ""),
                                onClick: toggleAddFlyout,
                                "aria-haspopup": "menu",
                                "aria-expanded": addFlyoutVisible,
                                type: "button",
                                children: [
                                    (0, $e9nev.jsx)("div", {
                                        className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["user-initials"],
                                        children: (0, $e9nev.jsx)((0, $cb6da6362e791dd3$export$2e2bcd8739ae039), {})
                                    }),
                                    (0, $e9nev.jsx)("div", {
                                        className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["user-name"],
                                        children: "Add"
                                    })
                                ]
                            })
                        }),
                        addFlyoutVisible && addFlyoutItems && (0, $e9nev.jsx)("div", {
                            className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["add-flyout-menu"],
                            role: "menu",
                            "aria-label": "Add menu",
                            children: addFlyoutItems.map(({ label: label, icon: icon, path: path })=>(0, $e9nev.jsxs)("a", {
                                    href: path,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["add-flyout-item"],
                                    onClick: ()=>setAddFlyoutVisible(false),
                                    children: [
                                        (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).cloneElement(getIconComponent(icon), {
                                            className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["icon-color"]
                                        }),
                                        label
                                    ]
                                }, label))
                        }),
                        (0, $e9nev.jsxs)("div", {
                            className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["column"],
                            style: {
                                flex: "none"
                            },
                            children: [
                                (0, $e9nev.jsxs)("button", {
                                    className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["user-icon"],
                                    onClick: toggleFlyout,
                                    "aria-haspopup": "menu",
                                    "aria-expanded": flyoutVisible,
                                    type: "button",
                                    children: [
                                        (0, $e9nev.jsx)("div", {
                                            className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["user-initials"],
                                            children: userInitials
                                        }),
                                        (0, $e9nev.jsx)("div", {
                                            className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["user-name"],
                                            children: userName
                                        }),
                                        (0, $e9nev.jsx)("div", {
                                            children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                                                symbol: "ExpandMoreOutlinedIcon",
                                                color: "cactus-off-white",
                                                size: "md",
                                                rotate: flyoutVisible
                                            })
                                        })
                                    ]
                                }),
                                flyoutVisible && (0, $e9nev.jsxs)("div", {
                                    className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["flyout-menu"],
                                    role: "menu",
                                    "aria-label": "User menu",
                                    children: [
                                        (0, $e9nev.jsx)("div", {
                                            className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["arrow-up"]
                                        }),
                                        userRole === $0eb8c2f4491c20a6$var$$6b2a4da568ddee1d$export$46919bad18fb2f76.NON_PRODUCER && (0, $e9nev.jsxs)("div", {
                                            children: [
                                                (0, $e9nev.jsxs)("button", {
                                                    className: `${/*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["flyout-item"]} ${currentRole === $0eb8c2f4491c20a6$var$$6b2a4da568ddee1d$export$46919bad18fb2f76.ACCOUNT_MANAGER ? /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["flyout-item-selected"] : ""}`,
                                                    onClick: ()=>handleRoleChange($0eb8c2f4491c20a6$var$$6b2a4da568ddee1d$export$46919bad18fb2f76.ACCOUNT_MANAGER),
                                                    type: "button",
                                                    role: "menuitem",
                                                    children: [
                                                        (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                                                            color: "cactus-off-white",
                                                            size: "md",
                                                            space: "right",
                                                            children: (0, $e9nev.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2f4d04b0406e11aa$exports))), {
                                                                fontSize: "large"
                                                            })
                                                        }),
                                                        "Account Management View"
                                                    ]
                                                }),
                                                (0, $e9nev.jsxs)("button", {
                                                    className: `${/*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["flyout-item"]} ${currentRole === $0eb8c2f4491c20a6$var$$6b2a4da568ddee1d$export$46919bad18fb2f76.RECRUITER ? /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["flyout-item-selected"] : ""}`,
                                                    onClick: ()=>handleRoleChange($0eb8c2f4491c20a6$var$$6b2a4da568ddee1d$export$46919bad18fb2f76.RECRUITER),
                                                    type: "button",
                                                    role: "menuitem",
                                                    children: [
                                                        (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                                                            color: "cactus-off-white",
                                                            size: "md",
                                                            space: "right",
                                                            children: (0, $e9nev.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f30739845add69b8$exports))), {
                                                                fontSize: "large"
                                                            })
                                                        }),
                                                        "Recruiter View"
                                                    ]
                                                })
                                            ]
                                        }),
                                        (0, $e9nev.jsxs)("button", {
                                            onClick: handleSignout,
                                            className: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$aaaee9b8c6313e4a$exports)["flyout-item"],
                                            type: "button",
                                            role: "menuitem",
                                            children: [
                                                (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                                                    symbol: "LogoutOutlinedIcon",
                                                    color: "cactus-off-white",
                                                    size: "md",
                                                    space: "right"
                                                }),
                                                "Sign Out"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $0eb8c2f4491c20a6$export$f52d00af2ce92343;
(function(TooltipPropDirection) {
    TooltipPropDirection["Top"] = "top";
    TooltipPropDirection["Bottom"] = "bottom";
    TooltipPropDirection["Left"] = "left";
    TooltipPropDirection["Right"] = "right";
    TooltipPropDirection["TopStart"] = "top-start";
    TooltipPropDirection["TopEnd"] = "top-end";
    TooltipPropDirection["RightStart"] = "right-start";
    TooltipPropDirection["RightEnd"] = "right-end";
    TooltipPropDirection["BottomStart"] = "bottom-start";
    TooltipPropDirection["BottomEnd"] = "bottom-end";
    TooltipPropDirection["LeftStart"] = "left-start";
    TooltipPropDirection["LeftEnd"] = "left-end";
})($0eb8c2f4491c20a6$export$f52d00af2ce92343 || ($0eb8c2f4491c20a6$export$f52d00af2ce92343 = {}));
var $0eb8c2f4491c20a6$var$$fdd8a4499c56c654$export$443696b1e393d770;
$0eb8c2f4491c20a6$var$$fdd8a4499c56c654$export$443696b1e393d770 = `S203dW_tooltip-container`;
const $0eb8c2f4491c20a6$export$28c660c63b792dea = ({ children: children, content: content, id: id, direction: direction = $0eb8c2f4491c20a6$export$f52d00af2ce92343.Top, delay: delay = 400, tooltipId: tooltipId })=>{
    return (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
        children: [
            (0, $e9nev.jsx)("a", {
                id: id,
                "data-tooltip-delay-show": delay,
                className: $0eb8c2f4491c20a6$var$$fdd8a4499c56c654$export$443696b1e393d770,
                children: children
            }),
            (0, $e9nev.jsx)((0, $277fb56588fbddc4$export$28c660c63b792dea), {
                anchorSelect: "#" + id,
                id: tooltipId,
                place: direction,
                border: "1px solid #D0D0D0",
                style: {
                    color: "black",
                    backgroundColor: "white",
                    fontSize: "14px",
                    fontFamily: "sans-serif",
                    lineHeight: 1,
                    zIndex: 1,
                    padding: "14px"
                },
                children: content
            }, direction)
        ]
    });
};
var $0eb8c2f4491c20a6$var$$4ad41d316c77dd5d$exports = {};
var $1ad018f1acb5837e$exports = {};
$1ad018f1acb5837e$exports = import.meta.resolve("8UMLg");


$0eb8c2f4491c20a6$var$$4ad41d316c77dd5d$exports = new URL($1ad018f1acb5837e$exports).toString();
var $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$exports = {};
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a724e4f554bd1f99$exports, "lg", function() {
    return $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$27ac7b32bf0e709e;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$27ac7b32bf0e709e = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a724e4f554bd1f99$exports, "loader", function() {
    return $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$f4c5de44377d2946;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$f4c5de44377d2946 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a724e4f554bd1f99$exports, "md", function() {
    return $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$f4de1c043ce6927;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$f4de1c043ce6927 = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a724e4f554bd1f99$exports, "sm", function() {
    return $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$92d98d0701d4531a;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$92d98d0701d4531a = v;
});
$0eb8c2f4491c20a6$var$$parcel$export($0eb8c2f4491c20a6$var$$a724e4f554bd1f99$exports, "xl", function() {
    return $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$abb3878d4b973569;
}, function(v) {
    return $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$abb3878d4b973569 = v;
});
var $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$27ac7b32bf0e709e;
var $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$f4c5de44377d2946;
var $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$f4de1c043ce6927;
var $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$92d98d0701d4531a;
var $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$abb3878d4b973569;
$0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$27ac7b32bf0e709e = `PlQZza_lg`;
$0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$f4c5de44377d2946 = `PlQZza_loader`;
$0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$f4de1c043ce6927 = `PlQZza_md`;
$0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$92d98d0701d4531a = `PlQZza_sm`;
$0eb8c2f4491c20a6$var$$a724e4f554bd1f99$export$abb3878d4b973569 = `PlQZza_xl`;
const $0eb8c2f4491c20a6$export$fac4de5e29191aa5 = ({ size: size = "lg" })=>{
    return (0, $e9nev.jsx)("div", {
        children: (0, $e9nev.jsx)("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))($0eb8c2f4491c20a6$var$$a724e4f554bd1f99$exports["loader"], $0eb8c2f4491c20a6$var$$a724e4f554bd1f99$exports[size]),
            src: /*@__PURE__*/ $0eb8c2f4491c20a6$var$$parcel$interopDefault($0eb8c2f4491c20a6$var$$4ad41d316c77dd5d$exports),
            alt: "Cactus Loading..."
        })
    });
};
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$571b02044ddb2ab3;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$6b087f52b8619213;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$616f2a8c4250fea0;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$b9310d795a5e43df;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$8892ae56d66dabb5;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$94132a0e348806d4;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$6fb7477f69d63352;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$62eab295986e7997;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$bac8ed84887f90b2;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$6382049c3febff1b;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$94b6ea4eda710e68;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$38e42c68cf43b5d4;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$1237798dc640739a;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$2da9be4cfdb689b1;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$fc00ee57782020aa;
var $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$237a47f808482848;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$571b02044ddb2ab3 = `oUkLTW_author`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$6b087f52b8619213 = `oUkLTW_commentText`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$616f2a8c4250fea0 = `oUkLTW_comments`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$b9310d795a5e43df = `oUkLTW_currentContainer`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$8892ae56d66dabb5 = `oUkLTW_currentLabel`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$94132a0e348806d4 = `oUkLTW_dot`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$6fb7477f69d63352 = `oUkLTW_draftIcon`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$62eab295986e7997 = `oUkLTW_draftInfo`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$bac8ed84887f90b2 = `oUkLTW_draftItem`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$6382049c3febff1b = `oUkLTW_draftSubtitle`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$94b6ea4eda710e68 = `oUkLTW_draftTitle`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$38e42c68cf43b5d4 = `oUkLTW_header`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$1237798dc640739a = `oUkLTW_label`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$2da9be4cfdb689b1 = `oUkLTW_time`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$fc00ee57782020aa = `oUkLTW_timestamp`;
$0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$237a47f808482848 = `oUkLTW_timestamps`;
const $0eb8c2f4491c20a6$var$$d01836862329400b$var$formatISOToCustom = (dateISO)=>{
    const date = new Date(dateISO);
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yy = String(date.getFullYear()).slice(-2);
    return `${mm}/${dd}/${yy} ${hours}:${minutes} ${ampm}`;
};
const $0eb8c2f4491c20a6$export$cbc94960dbffa143 = ({ id: id, createdAt: createdAt, updatedAt: updatedAt, current: current, handleSelect: handleSelect, handleDelete: handleDelete, notes: notes, title: title, subtitle: subtitle })=>{
    const formattedCreatedAt = (0, $eeyUA.useMemo)(()=>$0eb8c2f4491c20a6$var$$d01836862329400b$var$formatISOToCustom(createdAt), [
        createdAt
    ]);
    const formattedUpdatedAt = (0, $eeyUA.useMemo)(()=>$0eb8c2f4491c20a6$var$$d01836862329400b$var$formatISOToCustom(updatedAt), [
        updatedAt
    ]);
    const draftLabel = (0, $eeyUA.useMemo)(()=>{
        if (title || subtitle) return (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
            children: [
                title ? title : subtitle ? null : "Load Draft",
                (0, $e9nev.jsx)("br", {}),
                (0, $e9nev.jsx)("span", {
                    className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$6382049c3febff1b,
                    children: subtitle
                })
            ]
        });
        return (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
            children: [
                "Draft ",
                formattedCreatedAt
            ]
        });
    }, [
        title,
        subtitle,
        formattedCreatedAt
    ]);
    return (0, $e9nev.jsxs)("div", {
        className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$bac8ed84887f90b2,
        children: [
            (0, $e9nev.jsx)("div", {
                className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$38e42c68cf43b5d4,
                children: (0, $e9nev.jsxs)("div", {
                    className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$62eab295986e7997,
                    children: [
                        (0, $e9nev.jsx)("span", {
                            className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$6fb7477f69d63352,
                            children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                                symbol: "PostAddOutlinedIcon",
                                color: "icon-white",
                                size: "md"
                            })
                        }),
                        (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$28c660c63b792dea, {
                            content: "Click to load draft",
                            id: `draft-tooltip-${id}`,
                            children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$353f5b6fc5456de1, {
                                onClick: ()=>{
                                    handleSelect();
                                },
                                as: "button",
                                style: "icon-only",
                                children: (0, $e9nev.jsx)("span", {
                                    className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$94b6ea4eda710e68,
                                    children: draftLabel
                                })
                            })
                        }),
                        (0, $e9nev.jsx)("span", {
                            children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$353f5b6fc5456de1, {
                                onClick: ()=>{
                                    handleDelete();
                                },
                                as: "button",
                                style: "icon-only",
                                children: (0, $e9nev.jsx)($0eb8c2f4491c20a6$export$f04a61298a47a40f, {
                                    symbol: "DeleteOutlinedIcon",
                                    color: "icon-white",
                                    size: "sm"
                                })
                            })
                        })
                    ]
                })
            }),
            (0, $e9nev.jsxs)("div", {
                className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$237a47f808482848,
                children: [
                    (0, $e9nev.jsxs)("div", {
                        className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$fc00ee57782020aa,
                        children: [
                            (0, $e9nev.jsx)("span", {
                                className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$1237798dc640739a,
                                children: "CREATED"
                            }),
                            (0, $e9nev.jsx)("span", {
                                className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$2da9be4cfdb689b1,
                                children: formattedCreatedAt
                            })
                        ]
                    }),
                    (0, $e9nev.jsxs)("div", {
                        className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$fc00ee57782020aa,
                        children: [
                            (0, $e9nev.jsx)("span", {
                                className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$1237798dc640739a,
                                children: "LAST SAVED"
                            }),
                            (0, $e9nev.jsx)("span", {
                                className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$2da9be4cfdb689b1,
                                children: formattedUpdatedAt
                            })
                        ]
                    })
                ]
            }),
            notes && (0, $e9nev.jsxs)("div", {
                className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$616f2a8c4250fea0,
                children: [
                    (0, $e9nev.jsx)("span", {
                        className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$1237798dc640739a,
                        children: "COMMENTS"
                    }),
                    (0, $e9nev.jsx)("span", {
                        className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$6b087f52b8619213,
                        children: notes
                    })
                ]
            }),
            current === id && (0, $e9nev.jsx)("div", {
                className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$b9310d795a5e43df,
                children: (0, $e9nev.jsx)("span", {
                    className: $0eb8c2f4491c20a6$var$$7d1ce244d1a23bc9$export$8892ae56d66dabb5,
                    children: "CURRENT"
                })
            })
        ]
    });
};


/// <reference path="../types/react-markdown-renderer.d.ts" />
var $27b53b48eebea962$exports = {};
'use strict';
Object.defineProperty($27b53b48eebea962$exports, "__esModule", {
    value: true
});
var $27b53b48eebea962$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eeyUA = parcelRequire("eeyUA");
var $27b53b48eebea962$var$_react2 = $27b53b48eebea962$var$_interopRequireDefault($eeyUA);
var $95c311278f3b6d76$exports = {};
'use strict';

$95c311278f3b6d76$exports = (parcelRequire("kY3tI"));


var $27b53b48eebea962$var$_remarkable2 = $27b53b48eebea962$var$_interopRequireDefault($95c311278f3b6d76$exports);
function $27b53b48eebea962$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $27b53b48eebea962$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $27b53b48eebea962$var$MarkdownRenderer = function MarkdownRenderer(_ref) {
    var markdown = _ref.markdown, _ref$options = _ref.options;
    _ref$options = _ref$options === undefined ? {} : _ref$options;
    var preset = _ref$options.preset, options = $27b53b48eebea962$var$_objectWithoutProperties(_ref$options, [
        'preset'
    ]), props = $27b53b48eebea962$var$_objectWithoutProperties(_ref, [
        'markdown',
        'options'
    ]);
    var remarkable = new $27b53b48eebea962$var$_remarkable2.default(preset || 'default', options);
    var html = remarkable.render(markdown);
    return $27b53b48eebea962$var$_react2.default.createElement('div', $27b53b48eebea962$var$_extends({}, props, {
        dangerouslySetInnerHTML: {
            __html: html
        }
    }));
};











$27b53b48eebea962$var$MarkdownRenderer.propTypes = {
    markdown: (parcelRequire("hpnsu")).string.isRequired,
    options: (parcelRequire("hpnsu")).shape({
        preset: (parcelRequire("hpnsu")).oneOf([
            'default',
            'commonmark',
            'full'
        ]),
        html: (parcelRequire("hpnsu")).bool,
        xhtmlOut: (parcelRequire("hpnsu")).bool,
        breaks: (parcelRequire("hpnsu")).bool,
        langPrefix: (parcelRequire("hpnsu")).string,
        linkify: (parcelRequire("hpnsu")).bool,
        typographer: (parcelRequire("hpnsu")).bool,
        quotes: (parcelRequire("hpnsu")).string,
        highlight: (parcelRequire("hpnsu")).func
    })
};
$27b53b48eebea962$exports.default = $27b53b48eebea962$var$MarkdownRenderer;


/**
 * CJS package with `exports.__esModule` + `exports.default`.
 * Under Parcel/ESM the default import may be the module namespace
 * `{ default: Component }` instead of the component itself.
 */ const $d252d04b8be55307$var$MarkdownRenderer = typeof (0, (/*@__PURE__*/$parcel$interopDefault($27b53b48eebea962$exports))) === "function" ? (0, (/*@__PURE__*/$parcel$interopDefault($27b53b48eebea962$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($27b53b48eebea962$exports))).default;
var $d252d04b8be55307$export$2e2bcd8739ae039 = $d252d04b8be55307$var$MarkdownRenderer;


function $878c53339ed7cfc8$export$35c832f048303b4a(value) {
    if (value == null) return "";
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit"
    });
}
function $878c53339ed7cfc8$export$fca7975d61bd3fc6(content) {
    return {
        id: crypto.randomUUID(),
        role: "user",
        content: content,
        createdAt: new Date(),
        status: "sent"
    };
}
function $878c53339ed7cfc8$export$ed9cacc6cac33058(content, partial) {
    const id = partial?.id || partial?.messageID || crypto.randomUUID();
    return {
        role: "assistant",
        content: content,
        createdAt: new Date(),
        status: "sent",
        ...partial,
        id: id
    };
}
const $878c53339ed7cfc8$var$TABLE_SEPARATOR = /^\s*\|?\s*:?-{1,}:?\s*(\|\s*:?-{1,}:?\s*)*\|?\s*$/;
function $878c53339ed7cfc8$var$splitTableRow(line) {
    let row = line.trim();
    if (row.startsWith("|")) row = row.slice(1);
    if (row.endsWith("|") && !row.endsWith("\\|")) row = row.slice(0, -1);
    return row.split(/(?<!\\)\|/).map((cell)=>cell.replace(/\\\|/g, "|").replace(/<br\s*\/?>/gi, " ").trim());
}
function $878c53339ed7cfc8$var$parseBlocks(markdown) {
    const lines = markdown.split("\n");
    const blocks = [];
    let i = 0;
    while(i < lines.length){
        const isTableStart = lines[i].includes("|") && i + 1 < lines.length && lines[i + 1].includes("-") && $878c53339ed7cfc8$var$TABLE_SEPARATOR.test(lines[i + 1]);
        if (!isTableStart) {
            blocks.push({
                type: "text",
                line: lines[i++]
            });
            continue;
        }
        const start = i;
        const rows = [
            $878c53339ed7cfc8$var$splitTableRow(lines[i])
        ];
        i += 2;
        while(i < lines.length && lines[i].trim() !== "" && lines[i].includes("|")){
            rows.push($878c53339ed7cfc8$var$splitTableRow(lines[i]));
            i++;
        }
        blocks.push({
            type: "table",
            rows: rows,
            raw: lines.slice(start, i).join("\n")
        });
    }
    return blocks;
}
function $878c53339ed7cfc8$export$d8961ad1f47673e5(markdown) {
    const segments = [];
    let textLines = [];
    const flushText = ()=>{
        if (textLines.length) segments.push({
            type: "text",
            markdown: textLines.join("\n")
        });
        textLines = [];
    };
    for (const b of $878c53339ed7cfc8$var$parseBlocks(markdown)){
        if (b.type === "text") {
            textLines.push(b.line);
            continue;
        }
        flushText();
        segments.push({
            type: "table",
            markdown: b.raw
        });
    }
    flushText();
    return segments;
}
function $878c53339ed7cfc8$var$escapeHtml(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $878c53339ed7cfc8$export$375c3393e80d519c(markdown, tablesOnly = false) {
    const blocks = $878c53339ed7cfc8$var$parseBlocks(markdown);
    if (tablesOnly) return blocks.filter((b)=>b.type === "table").map((b)=>b.rows.map((r)=>r.join("\t")).join("\n")).join("\n\n");
    return blocks.flatMap((b)=>b.type === "text" ? [
            b.line
        ] : b.rows.map((r)=>r.join("\t"))).join("\n");
}
function $878c53339ed7cfc8$export$893ba1c6b5035ee0(markdown, tablesOnly = false) {
    const parts = [];
    for (const b of $878c53339ed7cfc8$var$parseBlocks(markdown)){
        if (b.type === "text") {
            if (!tablesOnly) parts.push(`<p>${$878c53339ed7cfc8$var$escapeHtml(b.line)}</p>`);
            continue;
        }
        const [header, ...body] = b.rows;
        const th = header.map((c)=>`<th>${$878c53339ed7cfc8$var$escapeHtml(c)}</th>`).join("");
        const trs = body.map((r)=>`<tr>${r.map((c)=>`<td>${$878c53339ed7cfc8$var$escapeHtml(c)}</td>`).join("")}</tr>`).join("");
        parts.push(`<table border="1" cellspacing="0" cellpadding="4"><thead><tr>${th}</tr></thead><tbody>${trs}</tbody></table>`);
    }
    return parts.join("");
}
async function $878c53339ed7cfc8$export$315a3a78b7712fad(markdown) {
    const tsv = $878c53339ed7cfc8$export$375c3393e80d519c(markdown, true);
    if (!tsv) {
        await $878c53339ed7cfc8$export$b2d21ae88f9b2aa6(markdown);
        return;
    }
    if (typeof ClipboardItem === "undefined" || !navigator.clipboard.write) {
        await navigator.clipboard.writeText(tsv);
        return;
    }
    await navigator.clipboard.write([
        new ClipboardItem({
            "text/plain": new Blob([
                tsv
            ], {
                type: "text/plain"
            }),
            "text/html": new Blob([
                $878c53339ed7cfc8$export$893ba1c6b5035ee0(markdown, true)
            ], {
                type: "text/html"
            })
        })
    ]);
}
async function $878c53339ed7cfc8$export$b2d21ae88f9b2aa6(markdown) {
    const tsv = $878c53339ed7cfc8$export$375c3393e80d519c(markdown);
    if (typeof ClipboardItem === "undefined" || !navigator.clipboard.write) {
        await navigator.clipboard.writeText(tsv);
        return;
    }
    await navigator.clipboard.write([
        new ClipboardItem({
            "text/plain": new Blob([
                tsv
            ], {
                type: "text/plain"
            }),
            "text/html": new Blob([
                $878c53339ed7cfc8$export$893ba1c6b5035ee0(markdown)
            ], {
                type: "text/html"
            })
        })
    ]);
}


var $dd2c652a409911c6$exports = {};
$dd2c652a409911c6$exports = import.meta.resolve("8Fsqq");



var $eeyUA = parcelRequire("eeyUA");
var $1821040c4e06c0ec$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($1821040c4e06c0ec$exports, "__esModule", {
    value: true
});
var $1821040c4e06c0ec$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
$1821040c4e06c0ec$exports.default = $1821040c4e06c0ec$var$CheckOutlined;



var $eeyUA = parcelRequire("eeyUA");

var $2e7Qq = parcelRequire("2e7Qq");

var $eeyUA = parcelRequire("eeyUA");
const $e5515b656c8ca768$var$IconContext = /*#__PURE__*/ (0, $eeyUA.createContext)({});
var $e5515b656c8ca768$export$2e2bcd8739ae039 = $e5515b656c8ca768$var$IconContext;



var $eeyUA = parcelRequire("eeyUA");

var $eeyUA = parcelRequire("eeyUA");

const $b0b48dacdb1a9abc$var$APPEND_ORDER = 'data-rc-order';
const $b0b48dacdb1a9abc$var$APPEND_PRIORITY = 'data-rc-priority';
const $b0b48dacdb1a9abc$var$MARK_KEY = 'rc-util-key';
const $b0b48dacdb1a9abc$var$containerCache = new Map();
function $b0b48dacdb1a9abc$var$canUseDom() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function $b0b48dacdb1a9abc$var$contains(root, node) {
    if (!root || !node) return false;
    if (root.contains) return root.contains(node);
    let current = node;
    while(current){
        if (current === root) return true;
        current = current.parentNode;
    }
    return false;
}
function $b0b48dacdb1a9abc$var$getMark({ mark: mark } = {}) {
    if (mark) return mark.startsWith('data-') ? mark : `data-${mark}`;
    return $b0b48dacdb1a9abc$var$MARK_KEY;
}
function $b0b48dacdb1a9abc$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    const head = document.querySelector('head');
    return head || document.body;
}
function $b0b48dacdb1a9abc$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
function $b0b48dacdb1a9abc$var$findStyles(container) {
    return Array.from(($b0b48dacdb1a9abc$var$containerCache.get(container) || container).children).filter((node)=>node.tagName === 'STYLE');
}
function $b0b48dacdb1a9abc$var$injectCSS(css, option = {}) {
    if (!$b0b48dacdb1a9abc$var$canUseDom()) return null;
    const { csp: csp, prepend: prepend, priority: priority = 0 } = option;
    const mergedOrder = $b0b48dacdb1a9abc$var$getOrder(prepend);
    const isPrependQueue = mergedOrder === 'prependQueue';
    const styleNode = document.createElement('style');
    styleNode.setAttribute($b0b48dacdb1a9abc$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($b0b48dacdb1a9abc$var$APPEND_PRIORITY, `${priority}`);
    if (csp?.nonce) styleNode.nonce = csp.nonce;
    styleNode.innerHTML = css;
    const container = $b0b48dacdb1a9abc$var$getContainer(option);
    const { firstChild: firstChild } = container;
    if (prepend) {
        if (isPrependQueue) {
            const existStyle = (option.styles || $b0b48dacdb1a9abc$var$findStyles(container)).filter((node)=>{
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($b0b48dacdb1a9abc$var$APPEND_ORDER))) return false;
                const nodePriority = Number(node.getAttribute($b0b48dacdb1a9abc$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $b0b48dacdb1a9abc$var$findExistNode(key, option = {}) {
    let { styles: styles } = option;
    styles ||= $b0b48dacdb1a9abc$var$findStyles($b0b48dacdb1a9abc$var$getContainer(option));
    return styles.find((node)=>node.getAttribute($b0b48dacdb1a9abc$var$getMark(option)) === key);
}
function $b0b48dacdb1a9abc$var$syncRealContainer(container, option) {
    const cachedRealContainer = $b0b48dacdb1a9abc$var$containerCache.get(container);
    if (!cachedRealContainer || !$b0b48dacdb1a9abc$var$contains(document, cachedRealContainer)) {
        const placeholderStyle = $b0b48dacdb1a9abc$var$injectCSS('', option);
        if (!placeholderStyle) return;
        const { parentNode: parentNode } = placeholderStyle;
        $b0b48dacdb1a9abc$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $b0b48dacdb1a9abc$export$4d99a2890bb989f0(css, key, originOption = {}) {
    if (!$b0b48dacdb1a9abc$var$canUseDom()) return null;
    const container = $b0b48dacdb1a9abc$var$getContainer(originOption);
    const styles = $b0b48dacdb1a9abc$var$findStyles(container);
    const option = {
        ...originOption,
        styles: styles
    };
    $b0b48dacdb1a9abc$var$syncRealContainer(container, option);
    const existNode = $b0b48dacdb1a9abc$var$findExistNode(key, option);
    if (existNode) {
        if (option.csp?.nonce && existNode.nonce !== option.csp.nonce) existNode.nonce = option.csp.nonce;
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    const newNode = $b0b48dacdb1a9abc$var$injectCSS(css, option);
    newNode?.setAttribute($b0b48dacdb1a9abc$var$getMark(option), key);
    return newNode;
}
function $b0b48dacdb1a9abc$var$getRoot(ele) {
    return ele?.getRootNode?.();
}
function $b0b48dacdb1a9abc$export$70e8259662bb498b(ele) {
    const root = $b0b48dacdb1a9abc$var$getRoot(ele);
    return typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot ? root : null;
}
const $b0b48dacdb1a9abc$var$warned = {};
function $b0b48dacdb1a9abc$export$82934adf09101657(valid, message) {
    if (valid || $b0b48dacdb1a9abc$var$warned[message]) return;
    $b0b48dacdb1a9abc$var$warned[message] = true;
}


function $16c1a08e7adfddd6$var$camelCase(input) {
    return input.replace(/-(.)/g, (match, g)=>g.toUpperCase());
}
function $16c1a08e7adfddd6$export$491112666e282270(valid, message) {
    (0, $b0b48dacdb1a9abc$export$82934adf09101657)(valid, `[@ant-design/icons] ${message}`);
}
function $16c1a08e7adfddd6$export$ab652842c37578f4(target) {
    return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
function $16c1a08e7adfddd6$export$9f5073e7201cc21c(attrs = {}) {
    return Object.keys(attrs).reduce((acc, key)=>{
        const val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$16c1a08e7adfddd6$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $16c1a08e7adfddd6$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(node.tag, {
        key: key,
        ...$16c1a08e7adfddd6$export$9f5073e7201cc21c(node.attrs)
    }, (node.children || []).map((child, index)=>$16c1a08e7adfddd6$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(node.tag, {
        key: key,
        ...$16c1a08e7adfddd6$export$9f5073e7201cc21c(node.attrs),
        ...rootProps
    }, (node.children || []).map((child, index)=>$16c1a08e7adfddd6$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
}
const $16c1a08e7adfddd6$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
const $16c1a08e7adfddd6$export$2c99b98b77550cb4 = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
  vertical-align: inherit;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin {
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
const $16c1a08e7adfddd6$export$938b1f86b61613d0 = (eleRef)=>{
    const { csp: csp, prefixCls: prefixCls, layer: layer, zeroRuntime: zeroRuntime } = (0, $eeyUA.useContext)((0, $e5515b656c8ca768$export$2e2bcd8739ae039));
    let mergedStyleStr = $16c1a08e7adfddd6$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = `@layer ${layer} {\n${mergedStyleStr}\n}`;
    (0, $eeyUA.useEffect)(()=>{
        if (zeroRuntime) return;
        const ele = eleRef.current;
        const shadowRoot = (0, $b0b48dacdb1a9abc$export$70e8259662bb498b)(ele);
        (0, $b0b48dacdb1a9abc$export$4d99a2890bb989f0)(mergedStyleStr, '@ant-design-icons', {
            prepend: !layer,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


const $c6c405b79eeccef1$var$IconBase = (props)=>{
    const { icon: icon, className: className, onClick: onClick, style: style, primaryColor: _primaryColor, secondaryColor: _secondaryColor, ...restProps } = props;
    const svgRef = $eeyUA.useRef(null);
    (0, $16c1a08e7adfddd6$export$938b1f86b61613d0)(svgRef);
    (0, $16c1a08e7adfddd6$export$491112666e282270)((0, $16c1a08e7adfddd6$export$ab652842c37578f4)(icon), `icon should be icon definiton, but got ${icon}`);
    if (!(0, $16c1a08e7adfddd6$export$ab652842c37578f4)(icon)) return null;
    const target = icon;
    return (0, $16c1a08e7adfddd6$export$80d376111cc09ad7)(target.icon, `svg-${target.name}`, {
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true',
        ...restProps,
        ref: svgRef
    });
};
$c6c405b79eeccef1$var$IconBase.displayName = 'IconReact';
var $c6c405b79eeccef1$export$2e2bcd8739ae039 = $c6c405b79eeccef1$var$IconBase;


'use client';
function $1df11896f514c369$var$_extends() {
    $1df11896f514c369$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1df11896f514c369$var$_extends.apply(this, arguments);
}
const $1df11896f514c369$var$Icon = /*#__PURE__*/ $eeyUA.forwardRef((props, ref)=>{
    const { className: // affect outter <i>...</i>
    className, icon: // affect inner <svg>...</svg>
    icon, spin: spin, rotate: rotate, tabIndex: tabIndex, onClick: onClick, twoToneColor: _twoToneColor, // other
    ...restProps } = props;
    const { prefixCls: prefixCls = 'anticon', rootClassName: rootClassName } = $eeyUA.useContext((0, $e5515b656c8ca768$export$2e2bcd8739ae039));
    const classString = (0, $2e7Qq.clsx)(rootClassName, prefixCls, {
        [`${prefixCls}-${icon.name}`]: !!icon.name,
        [`${prefixCls}-spin`]: !!spin || icon.name === 'loading'
    }, className);
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    const svgStyle = rotate ? {
        msTransform: `rotate(${rotate}deg)`,
        transform: `rotate(${rotate}deg)`
    } : undefined;
    return /*#__PURE__*/ $eeyUA.createElement("span", $1df11896f514c369$var$_extends({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $eeyUA.createElement((0, $c6c405b79eeccef1$export$2e2bcd8739ae039), {
        icon: icon,
        style: svgStyle
    }));
});
var $1df11896f514c369$export$2e2bcd8739ae039 = $1df11896f514c369$var$Icon;


function $0efd1207bcc6e53c$var$_extends() {
    $0efd1207bcc6e53c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0efd1207bcc6e53c$var$_extends.apply(this, arguments);
}
const $0efd1207bcc6e53c$var$CheckOutlined = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $0efd1207bcc6e53c$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1821040c4e06c0ec$exports)))
    }));
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ const $0efd1207bcc6e53c$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($0efd1207bcc6e53c$var$CheckOutlined);
var $0efd1207bcc6e53c$export$2e2bcd8739ae039 = $0efd1207bcc6e53c$var$RefIcon;


var $eeyUA = parcelRequire("eeyUA");
var $74959a8b24a6e9e8$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($74959a8b24a6e9e8$exports, "__esModule", {
    value: true
});
var $74959a8b24a6e9e8$var$CopyOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    },
    "name": "copy",
    "theme": "outlined"
};
$74959a8b24a6e9e8$exports.default = $74959a8b24a6e9e8$var$CopyOutlined;



function $e8ac5e4ccda16020$var$_extends() {
    $e8ac5e4ccda16020$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8ac5e4ccda16020$var$_extends.apply(this, arguments);
}
const $e8ac5e4ccda16020$var$CopyOutlined = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $e8ac5e4ccda16020$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($74959a8b24a6e9e8$exports)))
    }));
/**![copy](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgyOTZjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNDk2djY4OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04Vjk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MDQgMTkySDE5MmMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NTMwLjdjMCA4LjUgMy40IDE2LjYgOS40IDIyLjZsMTczLjMgMTczLjNjMi4yIDIuMiA0LjcgNCA3LjQgNS41djEuOWg0LjJjMy41IDEuMyA3LjIgMiAxMSAySDcwNGMxNy43IDAgMzItMTQuMyAzMi0zMlYyMjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTM1MCA4NTYuMkwyNjMuOSA3NzBIMzUwdjg2LjJ6TTY2NCA4ODhINDE0Vjc0NmMwLTIyLjEtMTcuOS00MC00MC00MEgyMzJWMjY0aDQzMnY2MjR6IiAvPjwvc3ZnPg==) */ const $e8ac5e4ccda16020$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($e8ac5e4ccda16020$var$CopyOutlined);
var $e8ac5e4ccda16020$export$2e2bcd8739ae039 = $e8ac5e4ccda16020$var$RefIcon;


var $eeyUA = parcelRequire("eeyUA");
var $5158187afdc280fc$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($5158187afdc280fc$exports, "__esModule", {
    value: true
});
var $5158187afdc280fc$var$DislikeFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    },
    "name": "dislike",
    "theme": "filled"
};
$5158187afdc280fc$exports.default = $5158187afdc280fc$var$DislikeFilled;



function $22111ae4a55e74a0$var$_extends() {
    $22111ae4a55e74a0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $22111ae4a55e74a0$var$_extends.apply(this, arguments);
}
const $22111ae4a55e74a0$var$DislikeFilled = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $22111ae4a55e74a0$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5158187afdc280fc$exports)))
    }));
/**![dislike](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NS45IDQ5MC4zYzMuNi0xMiA1LjQtMjQuNCA1LjQtMzcgMC0yOC4zLTkuMy01NS41LTI2LjEtNzcuNyAzLjYtMTIgNS40LTI0LjQgNS40LTM3IDAtMjguMy05LjMtNTUuNS0yNi4xLTc3LjcgMy42LTEyIDUuNC0yNC40IDUuNC0zNyAwLTUxLjYtMzAuNy05OC4xLTc4LjMtMTE4LjRhNjYuMSA2Ni4xIDAgMDAtMjYuNS01LjRIMjczdjQyOGguM2w4NS44IDMxMC44QzM3Mi45IDg4OSA0MTguOSA5MjQgNDcwLjkgOTI0YzI5LjcgMCA1Ny40LTExLjggNzcuOS0zMy40IDIwLjUtMjEuNSAzMS00OS43IDI5LjUtNzkuNGwtNi0xMjIuOWgyMzkuOWMxMi4xIDAgMjMuOS0zLjIgMzQuMy05LjMgNDAuNC0yMy41IDY1LjUtNjYuMSA2NS41LTExMSAwLTI4LjMtOS4zLTU1LjUtMjYuMS03Ny43ek0xMTIgMTMydjM2NGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NVYxMDBoLTY1Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnoiIC8+PC9zdmc+) */ const $22111ae4a55e74a0$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($22111ae4a55e74a0$var$DislikeFilled);
var $22111ae4a55e74a0$export$2e2bcd8739ae039 = $22111ae4a55e74a0$var$RefIcon;


var $eeyUA = parcelRequire("eeyUA");
var $5e6b149565757c94$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($5e6b149565757c94$exports, "__esModule", {
    value: true
});
var $5e6b149565757c94$var$DislikeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 01-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0133.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0119.6 43c0 19.1-11 37.5-28.8 48.4z"
                }
            }
        ]
    },
    "name": "dislike",
    "theme": "outlined"
};
$5e6b149565757c94$exports.default = $5e6b149565757c94$var$DislikeOutlined;



function $9d58283a9fc35d22$var$_extends() {
    $9d58283a9fc35d22$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9d58283a9fc35d22$var$_extends.apply(this, arguments);
}
const $9d58283a9fc35d22$var$DislikeOutlined = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $9d58283a9fc35d22$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5e6b149565757c94$exports)))
    }));
/**![dislike](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NS45IDQ5MC4zYzMuNi0xMiA1LjQtMjQuNCA1LjQtMzcgMC0yOC4zLTkuMy01NS41LTI2LjEtNzcuNyAzLjYtMTIgNS40LTI0LjQgNS40LTM3IDAtMjguMy05LjMtNTUuNS0yNi4xLTc3LjcgMy42LTEyIDUuNC0yNC40IDUuNC0zNyAwLTUxLjYtMzAuNy05OC4xLTc4LjMtMTE4LjRhNjYuMSA2Ni4xIDAgMDAtMjYuNS01LjRIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnYzNjRjMCAxNy43IDE0LjMgMzIgMzIgMzJoMTI5LjNsODUuOCAzMTAuOEMzNzIuOSA4ODkgNDE4LjkgOTI0IDQ3MC45IDkyNGMyOS43IDAgNTcuNC0xMS44IDc3LjktMzMuNCAyMC41LTIxLjUgMzEtNDkuNyAyOS41LTc5LjRsLTYtMTIyLjloMjM5LjljMTIuMSAwIDIzLjktMy4yIDM0LjMtOS4zIDQwLjQtMjMuNSA2NS41LTY2LjEgNjUuNS0xMTEgMC0yOC4zLTkuMy01NS41LTI2LjEtNzcuN3pNMTg0IDQ1NlYxNzJoODF2Mjg0aC04MXptNjI3LjIgMTYwLjRINDk2LjhsOS42IDE5OC40Yy42IDExLjktNC43IDIzLjEtMTQuNiAzMC41LTYuMSA0LjUtMTMuNiA2LjgtMjEuMSA2LjdhNDQuMjggNDQuMjggMCAwMS00Mi4yLTMyLjNMMzI5IDQ1OS4yVjE3Mmg0MTUuNGE1Ni44NSA1Ni44NSAwIDAxMzMuNiA1MS44YzAgOS43LTIuMyAxOC45LTYuOSAyNy4zbC0xMy45IDI1LjQgMjEuOSAxOWE1Ni43NiA1Ni43NiAwIDAxMTkuNiA0M2MwIDkuNy0yLjMgMTguOS02LjkgMjcuM2wtMTMuOSAyNS40IDIxLjkgMTlhNTYuNzYgNTYuNzYgMCAwMTE5LjYgNDNjMCA5LjctMi4zIDE4LjktNi45IDI3LjNsLTE0IDI1LjUgMjEuOSAxOWE1Ni43NiA1Ni43NiAwIDAxMTkuNiA0M2MwIDE5LjEtMTEgMzcuNS0yOC44IDQ4LjR6IiAvPjwvc3ZnPg==) */ const $9d58283a9fc35d22$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($9d58283a9fc35d22$var$DislikeOutlined);
var $9d58283a9fc35d22$export$2e2bcd8739ae039 = $9d58283a9fc35d22$var$RefIcon;


var $eeyUA = parcelRequire("eeyUA");
var $00f384d4a67fc5fb$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($00f384d4a67fc5fb$exports, "__esModule", {
    value: true
});
var $00f384d4a67fc5fb$var$LikeFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    },
    "name": "like",
    "theme": "filled"
};
$00f384d4a67fc5fb$exports.default = $00f384d4a67fc5fb$var$LikeFilled;



function $f5ad5adf626e2b8a$var$_extends() {
    $f5ad5adf626e2b8a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f5ad5adf626e2b8a$var$_extends.apply(this, arguments);
}
const $f5ad5adf626e2b8a$var$LikeFilled = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $f5ad5adf626e2b8a$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($00f384d4a67fc5fb$exports)))
    }));
/**![like](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NS45IDUzMy43YzE2LjgtMjIuMiAyNi4xLTQ5LjQgMjYuMS03Ny43IDAtNDQuOS0yNS4xLTg3LjQtNjUuNS0xMTEuMWE2Ny42NyA2Ny42NyAwIDAwLTM0LjMtOS4zSDU3Mi40bDYtMTIyLjljMS40LTI5LjctOS4xLTU3LjktMjkuNS03OS40QTEwNi42MiAxMDYuNjIgMCAwMDQ3MSA5OS45Yy01MiAwLTk4IDM1LTExMS44IDg1LjFsLTg1LjkgMzExaC0uM3Y0MjhoNDcyLjNjOS4yIDAgMTguMi0xLjggMjYuNS01LjQgNDcuNi0yMC4zIDc4LjMtNjYuOCA3OC4zLTExOC40IDAtMTIuNi0xLjgtMjUtNS40LTM3IDE2LjgtMjIuMiAyNi4xLTQ5LjQgMjYuMS03Ny43IDAtMTIuNi0xLjgtMjUtNS40LTM3IDE2LjgtMjIuMiAyNi4xLTQ5LjQgMjYuMS03Ny43LS4yLTEyLjYtMi0yNS4xLTUuNi0zNy4xek0xMTIgNTI4djM2NGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NVY0OTZoLTY1Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnoiIC8+PC9zdmc+) */ const $f5ad5adf626e2b8a$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($f5ad5adf626e2b8a$var$LikeFilled);
var $f5ad5adf626e2b8a$export$2e2bcd8739ae039 = $f5ad5adf626e2b8a$var$RefIcon;


var $eeyUA = parcelRequire("eeyUA");
var $a3441e0df23621ca$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($a3441e0df23621ca$exports, "__esModule", {
    value: true
});
var $a3441e0df23621ca$var$LikeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0142.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z"
                }
            }
        ]
    },
    "name": "like",
    "theme": "outlined"
};
$a3441e0df23621ca$exports.default = $a3441e0df23621ca$var$LikeOutlined;



function $7d3b7c83a889513b$var$_extends() {
    $7d3b7c83a889513b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d3b7c83a889513b$var$_extends.apply(this, arguments);
}
const $7d3b7c83a889513b$var$LikeOutlined = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $7d3b7c83a889513b$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a3441e0df23621ca$exports)))
    }));
/**![like](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NS45IDUzMy43YzE2LjgtMjIuMiAyNi4xLTQ5LjQgMjYuMS03Ny43IDAtNDQuOS0yNS4xLTg3LjQtNjUuNS0xMTEuMWE2Ny42NyA2Ny42NyAwIDAwLTM0LjMtOS4zSDU3Mi40bDYtMTIyLjljMS40LTI5LjctOS4xLTU3LjktMjkuNS03OS40QTEwNi42MiAxMDYuNjIgMCAwMDQ3MSA5OS45Yy01MiAwLTk4IDM1LTExMS44IDg1LjFsLTg1LjkgMzExSDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MzY0YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDYwMS4zYzkuMiAwIDE4LjItMS44IDI2LjUtNS40IDQ3LjYtMjAuMyA3OC4zLTY2LjggNzguMy0xMTguNCAwLTEyLjYtMS44LTI1LTUuNC0zNyAxNi44LTIyLjIgMjYuMS00OS40IDI2LjEtNzcuNyAwLTEyLjYtMS44LTI1LTUuNC0zNyAxNi44LTIyLjIgMjYuMS00OS40IDI2LjEtNzcuNy0uMi0xMi42LTItMjUuMS01LjYtMzcuMXpNMTg0IDg1MlY1NjhoODF2Mjg0aC04MXptNjM2LjQtMzUzbC0yMS45IDE5IDEzLjkgMjUuNGE1Ni4yIDU2LjIgMCAwMTYuOSAyNy4zYzAgMTYuNS03LjIgMzIuMi0xOS42IDQzbC0yMS45IDE5IDEzLjkgMjUuNGE1Ni4yIDU2LjIgMCAwMTYuOSAyNy4zYzAgMTYuNS03LjIgMzIuMi0xOS42IDQzbC0yMS45IDE5IDEzLjkgMjUuNGE1Ni4yIDU2LjIgMCAwMTYuOSAyNy4zYzAgMjIuNC0xMy4yIDQyLjYtMzMuNiA1MS44SDMyOVY1NjQuOGw5OS41LTM2MC41YTQ0LjEgNDQuMSAwIDAxNDIuMi0zMi4zYzcuNiAwIDE1LjEgMi4yIDIxLjEgNi43IDkuOSA3LjQgMTUuMiAxOC42IDE0LjYgMzAuNWwtOS42IDE5OC40aDMxNC40QzgyOSA0MTguNSA4NDAgNDM2LjkgODQwIDQ1NmMwIDE2LjUtNy4yIDMyLjEtMTkuNiA0M3oiIC8+PC9zdmc+) */ const $7d3b7c83a889513b$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($7d3b7c83a889513b$var$LikeOutlined);
var $7d3b7c83a889513b$export$2e2bcd8739ae039 = $7d3b7c83a889513b$var$RefIcon;


var $eeyUA = parcelRequire("eeyUA");
var $243f2400baa5bcc2$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($243f2400baa5bcc2$exports, "__esModule", {
    value: true
});
var $243f2400baa5bcc2$var$SendOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2a15.99 15.99 0 00-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-.9 3.7-.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 .7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-.8 4.2-2.6 5-5 1.4-4.2-.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z"
                }
            }
        ]
    },
    "name": "send",
    "theme": "outlined"
};
$243f2400baa5bcc2$exports.default = $243f2400baa5bcc2$var$SendOutlined;



function $bdfc75442d6c78bf$var$_extends() {
    $bdfc75442d6c78bf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bdfc75442d6c78bf$var$_extends.apply(this, arguments);
}
const $bdfc75442d6c78bf$var$SendOutlined = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $bdfc75442d6c78bf$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($243f2400baa5bcc2$exports)))
    }));
/**![send](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkzMS40IDQ5OC45TDk0LjkgNzkuNWMtMy40LTEuNy03LjMtMi4xLTExLTEuMmExNS45OSAxNS45OSAwIDAwLTExLjcgMTkuM2w4Ni4yIDM1Mi4yYzEuMyA1LjMgNS4yIDkuNiAxMC40IDExLjNsMTQ3LjcgNTAuNy0xNDcuNiA1MC43Yy01LjIgMS44LTkuMSA2LTEwLjMgMTEuM0w3Mi4yIDkyNi41Yy0uOSAzLjctLjUgNy42IDEuMiAxMC45IDMuOSA3LjkgMTMuNSAxMS4xIDIxLjUgNy4ybDgzNi41LTQxN2MzLjEtMS41IDUuNi00LjEgNy4yLTcuMSAzLjktOCAuNy0xNy42LTcuMi0yMS42ek0xNzAuOCA4MjYuM2w1MC4zLTIwNS42IDI5NS4yLTEwMS4zYzIuMy0uOCA0LjItMi42IDUtNSAxLjQtNC4yLS44LTguNy01LTEwLjJMMjIxLjEgNDAzIDE3MSAxOTguMmw2MjggMzE0LjktNjI4LjIgMzEzLjJ6IiAvPjwvc3ZnPg==) */ const $bdfc75442d6c78bf$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($bdfc75442d6c78bf$var$SendOutlined);
var $bdfc75442d6c78bf$export$2e2bcd8739ae039 = $bdfc75442d6c78bf$var$RefIcon;


var $eeyUA = parcelRequire("eeyUA");
var $b02798f12a296462$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($b02798f12a296462$exports, "__esModule", {
    value: true
});
var $b02798f12a296462$var$StopOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z"
                }
            }
        ]
    },
    "name": "stop",
    "theme": "outlined"
};
$b02798f12a296462$exports.default = $b02798f12a296462$var$StopOutlined;



function $421890d9d088a5ce$var$_extends() {
    $421890d9d088a5ce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $421890d9d088a5ce$var$_extends.apply(this, arguments);
}
const $421890d9d088a5ce$var$StopOutlined = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $421890d9d088a5ce$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b02798f12a296462$exports)))
    }));
/**![stop](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MiAwLTg5IDMxLjMtMTcwLjggODMuNS0yMzQuOGw1MjMuMyA1MjMuM0M2ODIuOCA4NTIuNyA2MDEgODg0IDUxMiA4ODR6bTI4OC41LTEzNy4yTDI3Ny4yIDIyMy41QzM0MS4yIDE3MS4zIDQyMyAxNDAgNTEyIDE0MGMyMDUuNCAwIDM3MiAxNjYuNiAzNzIgMzcyIDAgODktMzEuMyAxNzAuOC04My41IDIzNC44eiIgLz48L3N2Zz4=) */ const $421890d9d088a5ce$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($421890d9d088a5ce$var$StopOutlined);
var $421890d9d088a5ce$export$2e2bcd8739ae039 = $421890d9d088a5ce$var$RefIcon;


var $eeyUA = parcelRequire("eeyUA");
var $8eca1d3a952c5ac6$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($8eca1d3a952c5ac6$exports, "__esModule", {
    value: true
});
var $8eca1d3a952c5ac6$var$TableOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z"
                }
            }
        ]
    },
    "name": "table",
    "theme": "outlined"
};
$8eca1d3a952c5ac6$exports.default = $8eca1d3a952c5ac6$var$TableOutlined;



function $156ac749b3e8f144$var$_extends() {
    $156ac749b3e8f144$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $156ac749b3e8f144$var$_extends.apply(this, arguments);
}
const $156ac749b3e8f144$var$TableOutlined = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $156ac749b3e8f144$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8eca1d3a952c5ac6$exports)))
    }));
/**![table](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgMjA4SDY3NlYyMzJoMjEydjEzNnptMCAyMjRINjc2VjQzMmgyMTJ2MTYwek00MTIgNDMyaDIwMHYxNjBINDEyVjQzMnptMjAwLTY0SDQxMlYyMzJoMjAwdjEzNnptLTQ3NiA2NGgyMTJ2MTYwSDEzNlY0MzJ6bTAtMjAwaDIxMnYxMzZIMTM2VjIzMnptMCA0MjRoMjEydjEzNkgxMzZWNjU2em0yNzYgMGgyMDB2MTM2SDQxMlY2NTZ6bTQ3NiAxMzZINjc2VjY1NmgyMTJ2MTM2eiIgLz48L3N2Zz4=) */ const $156ac749b3e8f144$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($156ac749b3e8f144$var$TableOutlined);
var $156ac749b3e8f144$export$2e2bcd8739ae039 = $156ac749b3e8f144$var$RefIcon;


'use strict';
function $1d74f52613010282$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $833e317ce43259cd$var$toString } = Object.prototype;
const { getPrototypeOf: $833e317ce43259cd$var$getPrototypeOf } = Object;
const { iterator: $833e317ce43259cd$var$iterator, toStringTag: $833e317ce43259cd$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $833e317ce43259cd$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $833e317ce43259cd$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($833e317ce43259cd$var$hasOwnProperty(obj, prop)) return true;
        obj = $833e317ce43259cd$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $833e317ce43259cd$var$getSafeProp = (obj, prop)=>obj != null && $833e317ce43259cd$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $833e317ce43259cd$var$kindOf = ((cache)=>(thing)=>{
        const str = $833e317ce43259cd$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $833e317ce43259cd$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$833e317ce43259cd$var$kindOf(thing) === type;
};
const $833e317ce43259cd$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $833e317ce43259cd$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $833e317ce43259cd$var$isUndefined = $833e317ce43259cd$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $833e317ce43259cd$var$isBuffer(val) {
    return val !== null && !$833e317ce43259cd$var$isUndefined(val) && val.constructor !== null && !$833e317ce43259cd$var$isUndefined(val.constructor) && $833e317ce43259cd$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $833e317ce43259cd$var$isArrayBuffer = $833e317ce43259cd$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $833e317ce43259cd$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $833e317ce43259cd$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $833e317ce43259cd$var$isString = $833e317ce43259cd$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $833e317ce43259cd$var$isFunction = $833e317ce43259cd$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $833e317ce43259cd$var$isNumber = $833e317ce43259cd$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $833e317ce43259cd$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $833e317ce43259cd$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $833e317ce43259cd$var$isPlainObject = (val)=>{
    if (!$833e317ce43259cd$var$isObject(val)) return false;
    const prototype = $833e317ce43259cd$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $833e317ce43259cd$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$833e317ce43259cd$var$hasOwnInPrototypeChain(val, $833e317ce43259cd$var$toStringTag) && !$833e317ce43259cd$var$hasOwnInPrototypeChain(val, $833e317ce43259cd$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $833e317ce43259cd$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$833e317ce43259cd$var$isObject(val) || $833e317ce43259cd$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $833e317ce43259cd$var$isDate = $833e317ce43259cd$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $833e317ce43259cd$var$isFile = $833e317ce43259cd$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $833e317ce43259cd$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $833e317ce43259cd$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $833e317ce43259cd$var$isBlob = $833e317ce43259cd$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $833e317ce43259cd$var$isFileList = $833e317ce43259cd$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $833e317ce43259cd$var$isStream = (val)=>$833e317ce43259cd$var$isObject(val) && $833e317ce43259cd$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $833e317ce43259cd$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $833e317ce43259cd$var$G = $833e317ce43259cd$var$getGlobal();
const $833e317ce43259cd$var$FormDataCtor = typeof $833e317ce43259cd$var$G.FormData !== 'undefined' ? $833e317ce43259cd$var$G.FormData : undefined;
const $833e317ce43259cd$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($833e317ce43259cd$var$FormDataCtor && thing instanceof $833e317ce43259cd$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $833e317ce43259cd$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$833e317ce43259cd$var$isFunction(thing.append)) return false;
    const kind = $833e317ce43259cd$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $833e317ce43259cd$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $833e317ce43259cd$var$isURLSearchParams = $833e317ce43259cd$var$kindOfTest('URLSearchParams');
const [$833e317ce43259cd$var$isReadableStream, $833e317ce43259cd$var$isRequest, $833e317ce43259cd$var$isResponse, $833e317ce43259cd$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($833e317ce43259cd$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $833e317ce43259cd$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $833e317ce43259cd$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($833e317ce43259cd$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($833e317ce43259cd$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $833e317ce43259cd$var$findKey(obj, key) {
    if ($833e317ce43259cd$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $833e317ce43259cd$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $833e317ce43259cd$var$isContextDefined = (context)=>!$833e317ce43259cd$var$isUndefined(context) && context !== $833e317ce43259cd$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $833e317ce43259cd$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $833e317ce43259cd$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $833e317ce43259cd$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $833e317ce43259cd$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($833e317ce43259cd$var$isPlainObject(existing) && $833e317ce43259cd$var$isPlainObject(val)) result[targetKey] = $833e317ce43259cd$var$merge(existing, val);
        else if ($833e317ce43259cd$var$isPlainObject(val)) result[targetKey] = $833e317ce43259cd$var$merge({}, val);
        else if ($833e317ce43259cd$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$833e317ce43259cd$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $833e317ce43259cd$var$isBuffer(source)) continue;
        $833e317ce43259cd$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $833e317ce43259cd$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($833e317ce43259cd$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $833e317ce43259cd$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $833e317ce43259cd$var$forEach(b, (val, key)=>{
        if (thisArg && $833e317ce43259cd$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $1d74f52613010282$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $833e317ce43259cd$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $833e317ce43259cd$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $833e317ce43259cd$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $833e317ce43259cd$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $833e317ce43259cd$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $833e317ce43259cd$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($833e317ce43259cd$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$833e317ce43259cd$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $833e317ce43259cd$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $833e317ce43259cd$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $833e317ce43259cd$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$833e317ce43259cd$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $833e317ce43259cd$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $833e317ce43259cd$var$isHTMLForm = $833e317ce43259cd$var$kindOfTest('HTMLFormElement');
const $833e317ce43259cd$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $833e317ce43259cd$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $833e317ce43259cd$var$isRegExp = $833e317ce43259cd$var$kindOfTest('RegExp');
const $833e317ce43259cd$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $833e317ce43259cd$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $833e317ce43259cd$var$freezeMethods = (obj)=>{
    $833e317ce43259cd$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($833e317ce43259cd$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$833e317ce43259cd$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $833e317ce43259cd$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $833e317ce43259cd$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $833e317ce43259cd$var$noop = ()=>{};
const $833e317ce43259cd$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $833e317ce43259cd$var$isSpecCompliantForm(thing) {
    return !!(thing && $833e317ce43259cd$var$isFunction(thing.append) && thing[$833e317ce43259cd$var$toStringTag] === 'FormData' && thing[$833e317ce43259cd$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $833e317ce43259cd$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($833e317ce43259cd$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($833e317ce43259cd$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $833e317ce43259cd$var$isArray(source) ? [] : {};
                $833e317ce43259cd$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$833e317ce43259cd$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $833e317ce43259cd$var$isAsyncFn = $833e317ce43259cd$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $833e317ce43259cd$var$isThenable = (thing)=>thing && ($833e317ce43259cd$var$isObject(thing) || $833e317ce43259cd$var$isFunction(thing)) && $833e317ce43259cd$var$isFunction(thing.then) && $833e317ce43259cd$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $833e317ce43259cd$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $833e317ce43259cd$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $833e317ce43259cd$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $833e317ce43259cd$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $833e317ce43259cd$var$isFunction($833e317ce43259cd$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $833e317ce43259cd$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($833e317ce43259cd$var$_global) : $833e317ce43259cd$var$_setImmediate;
// *********************
const $833e317ce43259cd$var$isIterable = (thing)=>thing != null && $833e317ce43259cd$var$isFunction(thing[$833e317ce43259cd$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $833e317ce43259cd$var$isSafeIterable = (thing)=>thing != null && $833e317ce43259cd$var$hasOwnInPrototypeChain(thing, $833e317ce43259cd$var$iterator) && $833e317ce43259cd$var$isIterable(thing);
var $833e317ce43259cd$export$2e2bcd8739ae039 = {
    isArray: $833e317ce43259cd$var$isArray,
    isArrayBuffer: $833e317ce43259cd$var$isArrayBuffer,
    isBuffer: $833e317ce43259cd$var$isBuffer,
    isFormData: $833e317ce43259cd$var$isFormData,
    isArrayBufferView: $833e317ce43259cd$var$isArrayBufferView,
    isString: $833e317ce43259cd$var$isString,
    isNumber: $833e317ce43259cd$var$isNumber,
    isBoolean: $833e317ce43259cd$var$isBoolean,
    isObject: $833e317ce43259cd$var$isObject,
    isPlainObject: $833e317ce43259cd$var$isPlainObject,
    isEmptyObject: $833e317ce43259cd$var$isEmptyObject,
    isReadableStream: $833e317ce43259cd$var$isReadableStream,
    isRequest: $833e317ce43259cd$var$isRequest,
    isResponse: $833e317ce43259cd$var$isResponse,
    isHeaders: $833e317ce43259cd$var$isHeaders,
    isUndefined: $833e317ce43259cd$var$isUndefined,
    isDate: $833e317ce43259cd$var$isDate,
    isFile: $833e317ce43259cd$var$isFile,
    isReactNativeBlob: $833e317ce43259cd$var$isReactNativeBlob,
    isReactNative: $833e317ce43259cd$var$isReactNative,
    isBlob: $833e317ce43259cd$var$isBlob,
    isRegExp: $833e317ce43259cd$var$isRegExp,
    isFunction: $833e317ce43259cd$var$isFunction,
    isStream: $833e317ce43259cd$var$isStream,
    isURLSearchParams: $833e317ce43259cd$var$isURLSearchParams,
    isTypedArray: $833e317ce43259cd$var$isTypedArray,
    isFileList: $833e317ce43259cd$var$isFileList,
    forEach: $833e317ce43259cd$var$forEach,
    merge: $833e317ce43259cd$var$merge,
    extend: $833e317ce43259cd$var$extend,
    trim: $833e317ce43259cd$var$trim,
    stripBOM: $833e317ce43259cd$var$stripBOM,
    inherits: $833e317ce43259cd$var$inherits,
    toFlatObject: $833e317ce43259cd$var$toFlatObject,
    kindOf: $833e317ce43259cd$var$kindOf,
    kindOfTest: $833e317ce43259cd$var$kindOfTest,
    endsWith: $833e317ce43259cd$var$endsWith,
    toArray: $833e317ce43259cd$var$toArray,
    forEachEntry: $833e317ce43259cd$var$forEachEntry,
    matchAll: $833e317ce43259cd$var$matchAll,
    isHTMLForm: $833e317ce43259cd$var$isHTMLForm,
    hasOwnProperty: $833e317ce43259cd$var$hasOwnProperty,
    hasOwnProp: $833e317ce43259cd$var$hasOwnProperty,
    hasOwnInPrototypeChain: $833e317ce43259cd$var$hasOwnInPrototypeChain,
    getSafeProp: $833e317ce43259cd$var$getSafeProp,
    reduceDescriptors: $833e317ce43259cd$var$reduceDescriptors,
    freezeMethods: $833e317ce43259cd$var$freezeMethods,
    toObjectSet: $833e317ce43259cd$var$toObjectSet,
    toCamelCase: $833e317ce43259cd$var$toCamelCase,
    noop: $833e317ce43259cd$var$noop,
    toFiniteNumber: $833e317ce43259cd$var$toFiniteNumber,
    findKey: $833e317ce43259cd$var$findKey,
    global: $833e317ce43259cd$var$_global,
    isContextDefined: $833e317ce43259cd$var$isContextDefined,
    isSpecCompliantForm: $833e317ce43259cd$var$isSpecCompliantForm,
    toJSONObject: $833e317ce43259cd$var$toJSONObject,
    isAsyncFn: $833e317ce43259cd$var$isAsyncFn,
    isThenable: $833e317ce43259cd$var$isThenable,
    setImmediate: $833e317ce43259cd$var$_setImmediate,
    asap: $833e317ce43259cd$var$asap,
    isIterable: $833e317ce43259cd$var$isIterable,
    isSafeIterable: $833e317ce43259cd$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $e3712df562f61160$var$ignoreDuplicateOf = (0, $833e317ce43259cd$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $e3712df562f61160$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $e3712df562f61160$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $a36e789e89183a5b$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $a36e789e89183a5b$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $a36e789e89183a5b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $a36e789e89183a5b$var$sanitizeValue(value, invalidChars) {
    if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$a36e789e89183a5b$var$sanitizeValue(item, invalidChars));
    return $a36e789e89183a5b$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $a36e789e89183a5b$export$9e344cffce061a22 = (value)=>$a36e789e89183a5b$var$sanitizeValue(value, $a36e789e89183a5b$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $a36e789e89183a5b$export$59dd66c2a12d8f62 = (value)=>$a36e789e89183a5b$var$sanitizeValue(value, $a36e789e89183a5b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $a36e789e89183a5b$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $a36e789e89183a5b$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $e79457842ad79ca6$var$$internals = Symbol('internals');
function $e79457842ad79ca6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $e79457842ad79ca6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(value) ? value.map($e79457842ad79ca6$var$normalizeValue) : (0, $a36e789e89183a5b$export$9e344cffce061a22)(String(value));
}
function $e79457842ad79ca6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $e79457842ad79ca6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $e79457842ad79ca6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $e79457842ad79ca6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $e79457842ad79ca6$var$buildAccessors(obj, header) {
    const accessorName = (0, $833e317ce43259cd$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $e79457842ad79ca6$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $e79457842ad79ca6$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $833e317ce43259cd$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $e79457842ad79ca6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$e79457842ad79ca6$var$isValidHeaderName(header)) setHeaders((0, $e3712df562f61160$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isObject(header) && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $e79457842ad79ca6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $833e317ce43259cd$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $e79457842ad79ca6$var$parseTokens(value);
                if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $e79457842ad79ca6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $833e317ce43259cd$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $e79457842ad79ca6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $e79457842ad79ca6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $833e317ce43259cd$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $e79457842ad79ca6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $e79457842ad79ca6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $833e317ce43259cd$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $e79457842ad79ca6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $e79457842ad79ca6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $e79457842ad79ca6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$e79457842ad79ca6$var$$internals] = this[$e79457842ad79ca6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $e79457842ad79ca6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $e79457842ad79ca6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$e79457842ad79ca6$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $833e317ce43259cd$export$2e2bcd8739ae039).reduceDescriptors($e79457842ad79ca6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $833e317ce43259cd$export$2e2bcd8739ae039).freezeMethods($e79457842ad79ca6$var$AxiosHeaders);
var $e79457842ad79ca6$export$2e2bcd8739ae039 = $e79457842ad79ca6$var$AxiosHeaders;


'use strict';
const $05b25dfd89956b35$var$REDACTED = '[REDACTED ****]';
function $05b25dfd89956b35$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $05b25dfd89956b35$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $e79457842ad79ca6$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isPlainObject(source) && $05b25dfd89956b35$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $05b25dfd89956b35$var$REDACTED : visit(value);
                if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $05b25dfd89956b35$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $05b25dfd89956b35$var$AxiosError(error.message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $05b25dfd89956b35$var$redactConfig(config, redactKeys) : (0, $833e317ce43259cd$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$05b25dfd89956b35$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$05b25dfd89956b35$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$05b25dfd89956b35$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$05b25dfd89956b35$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$05b25dfd89956b35$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$05b25dfd89956b35$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$05b25dfd89956b35$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$05b25dfd89956b35$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$05b25dfd89956b35$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$05b25dfd89956b35$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$05b25dfd89956b35$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$05b25dfd89956b35$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$05b25dfd89956b35$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$05b25dfd89956b35$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $05b25dfd89956b35$export$2e2bcd8739ae039 = $05b25dfd89956b35$var$AxiosError;


// eslint-disable-next-line strict
var $bae03b29c94fb213$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $54421a260ad1d536$export$a143d493d941bafc;
var $54421a260ad1d536$export$e4cf37d7f6fb9e0a;
var $54421a260ad1d536$export$f99ded8fe4b79145;
var $54421a260ad1d536$export$599f31c3813fae4d;
'use strict';
var $e6ecf950cc60aeca$export$a48f0734ac7c2329;
var $e6ecf950cc60aeca$export$d622b2ad8d90c771;
var $e6ecf950cc60aeca$export$6100ba28696e12de;
'use strict';
$e6ecf950cc60aeca$export$a48f0734ac7c2329 = $e6ecf950cc60aeca$var$byteLength;
$e6ecf950cc60aeca$export$d622b2ad8d90c771 = $e6ecf950cc60aeca$var$toByteArray;
$e6ecf950cc60aeca$export$6100ba28696e12de = $e6ecf950cc60aeca$var$fromByteArray;
var $e6ecf950cc60aeca$var$lookup = [];
var $e6ecf950cc60aeca$var$revLookup = [];
var $e6ecf950cc60aeca$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e6ecf950cc60aeca$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e6ecf950cc60aeca$var$i = 0, $e6ecf950cc60aeca$var$len = $e6ecf950cc60aeca$var$code.length; $e6ecf950cc60aeca$var$i < $e6ecf950cc60aeca$var$len; ++$e6ecf950cc60aeca$var$i){
    $e6ecf950cc60aeca$var$lookup[$e6ecf950cc60aeca$var$i] = $e6ecf950cc60aeca$var$code[$e6ecf950cc60aeca$var$i];
    $e6ecf950cc60aeca$var$revLookup[$e6ecf950cc60aeca$var$code.charCodeAt($e6ecf950cc60aeca$var$i)] = $e6ecf950cc60aeca$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e6ecf950cc60aeca$var$revLookup['-'.charCodeAt(0)] = 62;
$e6ecf950cc60aeca$var$revLookup['_'.charCodeAt(0)] = 63;
function $e6ecf950cc60aeca$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e6ecf950cc60aeca$var$byteLength(b64) {
    var lens = $e6ecf950cc60aeca$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e6ecf950cc60aeca$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e6ecf950cc60aeca$var$toByteArray(b64) {
    var tmp;
    var lens = $e6ecf950cc60aeca$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e6ecf950cc60aeca$var$Arr($e6ecf950cc60aeca$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e6ecf950cc60aeca$var$revLookup[b64.charCodeAt(i)] << 18 | $e6ecf950cc60aeca$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e6ecf950cc60aeca$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e6ecf950cc60aeca$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e6ecf950cc60aeca$var$revLookup[b64.charCodeAt(i)] << 2 | $e6ecf950cc60aeca$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e6ecf950cc60aeca$var$revLookup[b64.charCodeAt(i)] << 10 | $e6ecf950cc60aeca$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e6ecf950cc60aeca$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e6ecf950cc60aeca$var$tripletToBase64(num) {
    return $e6ecf950cc60aeca$var$lookup[num >> 18 & 0x3F] + $e6ecf950cc60aeca$var$lookup[num >> 12 & 0x3F] + $e6ecf950cc60aeca$var$lookup[num >> 6 & 0x3F] + $e6ecf950cc60aeca$var$lookup[num & 0x3F];
}
function $e6ecf950cc60aeca$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e6ecf950cc60aeca$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e6ecf950cc60aeca$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e6ecf950cc60aeca$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e6ecf950cc60aeca$var$lookup[tmp >> 2] + $e6ecf950cc60aeca$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e6ecf950cc60aeca$var$lookup[tmp >> 10] + $e6ecf950cc60aeca$var$lookup[tmp >> 4 & 0x3F] + $e6ecf950cc60aeca$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $1677b07a82136f4c$export$aafa59e2e03f2942;
var $1677b07a82136f4c$export$68d8715fc104d294;
$1677b07a82136f4c$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$1677b07a82136f4c$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $54421a260ad1d536$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$54421a260ad1d536$export$a143d493d941bafc = $54421a260ad1d536$var$Buffer;
$54421a260ad1d536$export$e4cf37d7f6fb9e0a = $54421a260ad1d536$var$SlowBuffer;
$54421a260ad1d536$export$f99ded8fe4b79145 = 50;
const $54421a260ad1d536$var$K_MAX_LENGTH = 0x7fffffff;
$54421a260ad1d536$export$599f31c3813fae4d = $54421a260ad1d536$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $54421a260ad1d536$var$Buffer.TYPED_ARRAY_SUPPORT = $54421a260ad1d536$var$typedArraySupport();
if (!$54421a260ad1d536$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $54421a260ad1d536$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($54421a260ad1d536$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$54421a260ad1d536$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($54421a260ad1d536$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$54421a260ad1d536$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $54421a260ad1d536$var$createBuffer(length) {
    if (length > $54421a260ad1d536$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $54421a260ad1d536$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $54421a260ad1d536$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $54421a260ad1d536$var$allocUnsafe(arg);
    }
    return $54421a260ad1d536$var$from(arg, encodingOrOffset, length);
}
$54421a260ad1d536$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $54421a260ad1d536$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $54421a260ad1d536$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $54421a260ad1d536$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($54421a260ad1d536$var$isInstance(value, ArrayBuffer) || value && $54421a260ad1d536$var$isInstance(value.buffer, ArrayBuffer)) return $54421a260ad1d536$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($54421a260ad1d536$var$isInstance(value, SharedArrayBuffer) || value && $54421a260ad1d536$var$isInstance(value.buffer, SharedArrayBuffer))) return $54421a260ad1d536$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $54421a260ad1d536$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $54421a260ad1d536$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $54421a260ad1d536$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $54421a260ad1d536$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $54421a260ad1d536$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($54421a260ad1d536$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($54421a260ad1d536$var$Buffer, Uint8Array);
function $54421a260ad1d536$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $54421a260ad1d536$var$alloc(size, fill, encoding) {
    $54421a260ad1d536$var$assertSize(size);
    if (size <= 0) return $54421a260ad1d536$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $54421a260ad1d536$var$createBuffer(size).fill(fill, encoding) : $54421a260ad1d536$var$createBuffer(size).fill(fill);
    return $54421a260ad1d536$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $54421a260ad1d536$var$Buffer.alloc = function(size, fill, encoding) {
    return $54421a260ad1d536$var$alloc(size, fill, encoding);
};
function $54421a260ad1d536$var$allocUnsafe(size) {
    $54421a260ad1d536$var$assertSize(size);
    return $54421a260ad1d536$var$createBuffer(size < 0 ? 0 : $54421a260ad1d536$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $54421a260ad1d536$var$Buffer.allocUnsafe = function(size) {
    return $54421a260ad1d536$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $54421a260ad1d536$var$Buffer.allocUnsafeSlow = function(size) {
    return $54421a260ad1d536$var$allocUnsafe(size);
};
function $54421a260ad1d536$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$54421a260ad1d536$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $54421a260ad1d536$var$byteLength(string, encoding) | 0;
    let buf = $54421a260ad1d536$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $54421a260ad1d536$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $54421a260ad1d536$var$checked(array.length) | 0;
    const buf = $54421a260ad1d536$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $54421a260ad1d536$var$fromArrayView(arrayView) {
    if ($54421a260ad1d536$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $54421a260ad1d536$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $54421a260ad1d536$var$fromArrayLike(arrayView);
}
function $54421a260ad1d536$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $54421a260ad1d536$var$Buffer.prototype);
    return buf;
}
function $54421a260ad1d536$var$fromObject(obj) {
    if ($54421a260ad1d536$var$Buffer.isBuffer(obj)) {
        const len = $54421a260ad1d536$var$checked(obj.length) | 0;
        const buf = $54421a260ad1d536$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $54421a260ad1d536$var$numberIsNaN(obj.length)) return $54421a260ad1d536$var$createBuffer(0);
        return $54421a260ad1d536$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $54421a260ad1d536$var$fromArrayLike(obj.data);
}
function $54421a260ad1d536$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $54421a260ad1d536$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $54421a260ad1d536$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $54421a260ad1d536$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $54421a260ad1d536$var$Buffer.alloc(+length);
}
$54421a260ad1d536$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $54421a260ad1d536$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$54421a260ad1d536$var$Buffer.compare = function compare(a, b) {
    if ($54421a260ad1d536$var$isInstance(a, Uint8Array)) a = $54421a260ad1d536$var$Buffer.from(a, a.offset, a.byteLength);
    if ($54421a260ad1d536$var$isInstance(b, Uint8Array)) b = $54421a260ad1d536$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$54421a260ad1d536$var$Buffer.isBuffer(a) || !$54421a260ad1d536$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$54421a260ad1d536$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$54421a260ad1d536$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $54421a260ad1d536$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $54421a260ad1d536$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($54421a260ad1d536$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$54421a260ad1d536$var$Buffer.isBuffer(buf)) buf = $54421a260ad1d536$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$54421a260ad1d536$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $54421a260ad1d536$var$byteLength(string, encoding) {
    if ($54421a260ad1d536$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $54421a260ad1d536$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $54421a260ad1d536$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $54421a260ad1d536$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $54421a260ad1d536$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$54421a260ad1d536$var$Buffer.byteLength = $54421a260ad1d536$var$byteLength;
function $54421a260ad1d536$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $54421a260ad1d536$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $54421a260ad1d536$var$utf8Slice(this, start, end);
        case 'ascii':
            return $54421a260ad1d536$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $54421a260ad1d536$var$latin1Slice(this, start, end);
        case 'base64':
            return $54421a260ad1d536$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $54421a260ad1d536$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$54421a260ad1d536$var$Buffer.prototype._isBuffer = true;
function $54421a260ad1d536$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$54421a260ad1d536$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$54421a260ad1d536$var$swap(this, i, i + 1);
    return this;
};
$54421a260ad1d536$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $54421a260ad1d536$var$swap(this, i, i + 3);
        $54421a260ad1d536$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$54421a260ad1d536$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $54421a260ad1d536$var$swap(this, i, i + 7);
        $54421a260ad1d536$var$swap(this, i + 1, i + 6);
        $54421a260ad1d536$var$swap(this, i + 2, i + 5);
        $54421a260ad1d536$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$54421a260ad1d536$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $54421a260ad1d536$var$utf8Slice(this, 0, length);
    return $54421a260ad1d536$var$slowToString.apply(this, arguments);
};
$54421a260ad1d536$var$Buffer.prototype.toLocaleString = $54421a260ad1d536$var$Buffer.prototype.toString;
$54421a260ad1d536$var$Buffer.prototype.equals = function equals(b) {
    if (!$54421a260ad1d536$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $54421a260ad1d536$var$Buffer.compare(this, b) === 0;
};
$54421a260ad1d536$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $54421a260ad1d536$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($54421a260ad1d536$var$customInspectSymbol) $54421a260ad1d536$var$Buffer.prototype[$54421a260ad1d536$var$customInspectSymbol] = $54421a260ad1d536$var$Buffer.prototype.inspect;
$54421a260ad1d536$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($54421a260ad1d536$var$isInstance(target, Uint8Array)) target = $54421a260ad1d536$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$54421a260ad1d536$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $54421a260ad1d536$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($54421a260ad1d536$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $54421a260ad1d536$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($54421a260ad1d536$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $54421a260ad1d536$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $54421a260ad1d536$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $54421a260ad1d536$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$54421a260ad1d536$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$54421a260ad1d536$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $54421a260ad1d536$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$54421a260ad1d536$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $54421a260ad1d536$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $54421a260ad1d536$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($54421a260ad1d536$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $54421a260ad1d536$var$utf8Write(buf, string, offset, length) {
    return $54421a260ad1d536$var$blitBuffer($54421a260ad1d536$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $54421a260ad1d536$var$asciiWrite(buf, string, offset, length) {
    return $54421a260ad1d536$var$blitBuffer($54421a260ad1d536$var$asciiToBytes(string), buf, offset, length);
}
function $54421a260ad1d536$var$base64Write(buf, string, offset, length) {
    return $54421a260ad1d536$var$blitBuffer($54421a260ad1d536$var$base64ToBytes(string), buf, offset, length);
}
function $54421a260ad1d536$var$ucs2Write(buf, string, offset, length) {
    return $54421a260ad1d536$var$blitBuffer($54421a260ad1d536$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$54421a260ad1d536$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $54421a260ad1d536$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $54421a260ad1d536$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $54421a260ad1d536$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $54421a260ad1d536$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $54421a260ad1d536$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$54421a260ad1d536$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $54421a260ad1d536$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $e6ecf950cc60aeca$export$6100ba28696e12de(buf);
    else return $e6ecf950cc60aeca$export$6100ba28696e12de(buf.slice(start, end));
}
function $54421a260ad1d536$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $54421a260ad1d536$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $54421a260ad1d536$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $54421a260ad1d536$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $54421a260ad1d536$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $54421a260ad1d536$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $54421a260ad1d536$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $54421a260ad1d536$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $54421a260ad1d536$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $54421a260ad1d536$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $54421a260ad1d536$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$54421a260ad1d536$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $54421a260ad1d536$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $54421a260ad1d536$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$54421a260ad1d536$var$Buffer.prototype.readUintLE = $54421a260ad1d536$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$54421a260ad1d536$var$Buffer.prototype.readUintBE = $54421a260ad1d536$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$54421a260ad1d536$var$Buffer.prototype.readUint8 = $54421a260ad1d536$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$54421a260ad1d536$var$Buffer.prototype.readUint16LE = $54421a260ad1d536$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$54421a260ad1d536$var$Buffer.prototype.readUint16BE = $54421a260ad1d536$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$54421a260ad1d536$var$Buffer.prototype.readUint32LE = $54421a260ad1d536$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$54421a260ad1d536$var$Buffer.prototype.readUint32BE = $54421a260ad1d536$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$54421a260ad1d536$var$Buffer.prototype.readBigUInt64LE = $54421a260ad1d536$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $54421a260ad1d536$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $54421a260ad1d536$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$54421a260ad1d536$var$Buffer.prototype.readBigUInt64BE = $54421a260ad1d536$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $54421a260ad1d536$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $54421a260ad1d536$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$54421a260ad1d536$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$54421a260ad1d536$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$54421a260ad1d536$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$54421a260ad1d536$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$54421a260ad1d536$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$54421a260ad1d536$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$54421a260ad1d536$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$54421a260ad1d536$var$Buffer.prototype.readBigInt64LE = $54421a260ad1d536$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $54421a260ad1d536$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $54421a260ad1d536$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$54421a260ad1d536$var$Buffer.prototype.readBigInt64BE = $54421a260ad1d536$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $54421a260ad1d536$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $54421a260ad1d536$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$54421a260ad1d536$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 4, this.length);
    return $1677b07a82136f4c$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$54421a260ad1d536$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 4, this.length);
    return $1677b07a82136f4c$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$54421a260ad1d536$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 8, this.length);
    return $1677b07a82136f4c$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$54421a260ad1d536$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkOffset(offset, 8, this.length);
    return $1677b07a82136f4c$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $54421a260ad1d536$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$54421a260ad1d536$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$54421a260ad1d536$var$Buffer.prototype.writeUintLE = $54421a260ad1d536$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $54421a260ad1d536$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$54421a260ad1d536$var$Buffer.prototype.writeUintBE = $54421a260ad1d536$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $54421a260ad1d536$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$54421a260ad1d536$var$Buffer.prototype.writeUint8 = $54421a260ad1d536$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$54421a260ad1d536$var$Buffer.prototype.writeUint16LE = $54421a260ad1d536$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$54421a260ad1d536$var$Buffer.prototype.writeUint16BE = $54421a260ad1d536$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$54421a260ad1d536$var$Buffer.prototype.writeUint32LE = $54421a260ad1d536$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$54421a260ad1d536$var$Buffer.prototype.writeUint32BE = $54421a260ad1d536$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $54421a260ad1d536$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $54421a260ad1d536$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $54421a260ad1d536$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $54421a260ad1d536$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$54421a260ad1d536$var$Buffer.prototype.writeBigUInt64LE = $54421a260ad1d536$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $54421a260ad1d536$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$54421a260ad1d536$var$Buffer.prototype.writeBigUInt64BE = $54421a260ad1d536$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $54421a260ad1d536$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$54421a260ad1d536$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $54421a260ad1d536$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$54421a260ad1d536$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $54421a260ad1d536$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$54421a260ad1d536$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$54421a260ad1d536$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$54421a260ad1d536$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$54421a260ad1d536$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$54421a260ad1d536$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$54421a260ad1d536$var$Buffer.prototype.writeBigInt64LE = $54421a260ad1d536$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $54421a260ad1d536$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$54421a260ad1d536$var$Buffer.prototype.writeBigInt64BE = $54421a260ad1d536$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $54421a260ad1d536$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $54421a260ad1d536$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $54421a260ad1d536$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1677b07a82136f4c$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$54421a260ad1d536$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $54421a260ad1d536$var$writeFloat(this, value, offset, true, noAssert);
};
$54421a260ad1d536$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $54421a260ad1d536$var$writeFloat(this, value, offset, false, noAssert);
};
function $54421a260ad1d536$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54421a260ad1d536$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1677b07a82136f4c$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$54421a260ad1d536$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $54421a260ad1d536$var$writeDouble(this, value, offset, true, noAssert);
};
$54421a260ad1d536$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $54421a260ad1d536$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$54421a260ad1d536$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$54421a260ad1d536$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$54421a260ad1d536$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$54421a260ad1d536$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $54421a260ad1d536$var$Buffer.isBuffer(val) ? val : $54421a260ad1d536$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $54421a260ad1d536$var$errors = {};
function $54421a260ad1d536$var$E(sym, getMessage, Base) {
    $54421a260ad1d536$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$54421a260ad1d536$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$54421a260ad1d536$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$54421a260ad1d536$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $54421a260ad1d536$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $54421a260ad1d536$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $54421a260ad1d536$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $54421a260ad1d536$var$checkBounds(buf, offset, byteLength) {
    $54421a260ad1d536$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $54421a260ad1d536$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $54421a260ad1d536$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $54421a260ad1d536$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $54421a260ad1d536$var$checkBounds(buf, offset, byteLength);
}
function $54421a260ad1d536$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $54421a260ad1d536$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $54421a260ad1d536$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $54421a260ad1d536$var$validateNumber(value, type);
        throw new $54421a260ad1d536$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $54421a260ad1d536$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $54421a260ad1d536$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $54421a260ad1d536$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $54421a260ad1d536$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($54421a260ad1d536$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $54421a260ad1d536$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $54421a260ad1d536$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $54421a260ad1d536$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $54421a260ad1d536$var$base64ToBytes(str) {
    return $e6ecf950cc60aeca$export$d622b2ad8d90c771($54421a260ad1d536$var$base64clean(str));
}
function $54421a260ad1d536$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $54421a260ad1d536$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $54421a260ad1d536$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $54421a260ad1d536$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $54421a260ad1d536$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $54421a260ad1d536$var$BufferBigIntNotDefined : fn;
}
function $54421a260ad1d536$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $63712c0ff1698dd8$require$Buffer = $54421a260ad1d536$export$a143d493d941bafc;
'use strict';
const $63712c0ff1698dd8$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $63712c0ff1698dd8$var$isVisitable(thing) {
    return (0, $833e317ce43259cd$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $63712c0ff1698dd8$var$removeBrackets(key) {
    return (0, $833e317ce43259cd$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $63712c0ff1698dd8$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $63712c0ff1698dd8$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $63712c0ff1698dd8$var$isFlatArray(arr) {
    return (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(arr) && !arr.some($63712c0ff1698dd8$var$isVisitable);
}
const $63712c0ff1698dd8$var$predicates = (0, $833e317ce43259cd$export$2e2bcd8739ae039).toFlatObject((0, $833e317ce43259cd$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $63712c0ff1698dd8$var$toFormData(obj, formData, options) {
    if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $bae03b29c94fb213$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $833e317ce43259cd$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? $63712c0ff1698dd8$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $833e317ce43259cd$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if (typeof $63712c0ff1698dd8$require$Buffer !== 'undefined') return $63712c0ff1698dd8$require$Buffer.from(value);
            throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isReactNative(formData) && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($63712c0ff1698dd8$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(value) && $63712c0ff1698dd8$var$isFlatArray(value) || ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isFileList(value) || (0, $833e317ce43259cd$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $833e317ce43259cd$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $63712c0ff1698dd8$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $63712c0ff1698dd8$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($63712c0ff1698dd8$var$isVisitable(value)) return true;
        formData.append($63712c0ff1698dd8$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($63712c0ff1698dd8$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $63712c0ff1698dd8$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $63712c0ff1698dd8$export$2e2bcd8739ae039 = $63712c0ff1698dd8$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $e51c7bcf4b65f869$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $e51c7bcf4b65f869$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $63712c0ff1698dd8$export$2e2bcd8739ae039)(params, this, options);
}
const $e51c7bcf4b65f869$var$prototype = $e51c7bcf4b65f869$var$AxiosURLSearchParams.prototype;
$e51c7bcf4b65f869$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$e51c7bcf4b65f869$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $e51c7bcf4b65f869$var$encode) : $e51c7bcf4b65f869$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $e51c7bcf4b65f869$export$2e2bcd8739ae039 = $e51c7bcf4b65f869$var$AxiosURLSearchParams;


'use strict';
function $413c4110c050d132$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $413c4110c050d132$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $833e317ce43259cd$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $833e317ce43259cd$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $413c4110c050d132$export$c564cdbbe6da493;
    const serializeFn = (0, $833e317ce43259cd$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $833e317ce43259cd$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $e51c7bcf4b65f869$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $b138b667a00818c2$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $b138b667a00818c2$export$2e2bcd8739ae039 = $b138b667a00818c2$var$InterceptorManager;





'use strict';
var $c7701c9f6b2f4fe2$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $ebdd3e8cb3be1338$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $e51c7bcf4b65f869$export$2e2bcd8739ae039);


'use strict';
var $eec3ed3db5ec4094$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $02ca577fefe5d2e0$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $fbbed0a65e58de62$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $ebdd3e8cb3be1338$export$2e2bcd8739ae039,
        FormData: $eec3ed3db5ec4094$export$2e2bcd8739ae039,
        Blob: $02ca577fefe5d2e0$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $7338f753a65b00c1$exports = {};

$parcel$export($7338f753a65b00c1$exports, "hasBrowserEnv", () => $7338f753a65b00c1$export$c4996c4b7b93b0bf);
$parcel$export($7338f753a65b00c1$exports, "navigator", () => $7338f753a65b00c1$export$ec7c8efa7f5790ae);
$parcel$export($7338f753a65b00c1$exports, "hasStandardBrowserEnv", () => $7338f753a65b00c1$export$c0bcc9250309d66);
$parcel$export($7338f753a65b00c1$exports, "hasStandardBrowserWebWorkerEnv", () => $7338f753a65b00c1$export$c81692cf5af97dac);
$parcel$export($7338f753a65b00c1$exports, "origin", () => $7338f753a65b00c1$export$f710a83a91838a36);
const $7338f753a65b00c1$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $7338f753a65b00c1$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $7338f753a65b00c1$export$c0bcc9250309d66 = $7338f753a65b00c1$export$c4996c4b7b93b0bf && (!$7338f753a65b00c1$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($7338f753a65b00c1$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $7338f753a65b00c1$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $7338f753a65b00c1$export$f710a83a91838a36 = $7338f753a65b00c1$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $54256614a159fb46$export$2e2bcd8739ae039 = {
    ...$7338f753a65b00c1$exports,
    ...(0, $fbbed0a65e58de62$export$2e2bcd8739ae039)
};


'use strict';
function $8d90945f7485048f$export$2e2bcd8739ae039(data, options) {
    return (0, $63712c0ff1698dd8$export$2e2bcd8739ae039)(data, new (0, $54256614a159fb46$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $54256614a159fb46$export$2e2bcd8739ae039).isNode && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $e9281399ef5fb36a$var$MAX_DEPTH = (0, $63712c0ff1698dd8$export$659081b45d03227d);
function $e9281399ef5fb36a$var$throwIfDepthExceeded(index) {
    if (index > $e9281399ef5fb36a$var$MAX_DEPTH) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $e9281399ef5fb36a$var$MAX_DEPTH, (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $e9281399ef5fb36a$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    const path = [];
    const pattern = /\w+|\[(\w*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $e9281399ef5fb36a$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $e9281399ef5fb36a$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $e9281399ef5fb36a$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $e9281399ef5fb36a$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $833e317ce43259cd$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $e9281399ef5fb36a$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isFormData(formData) && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $833e317ce43259cd$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($e9281399ef5fb36a$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $e9281399ef5fb36a$export$2e2bcd8739ae039 = $e9281399ef5fb36a$var$formDataToJSON;


'use strict';
const $cf1e503df83d8e4c$var$own = (obj, key)=>obj != null && (0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $cf1e503df83d8e4c$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $833e317ce43259cd$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $cf1e503df83d8e4c$var$defaults = {
    transitional: (0, $c7701c9f6b2f4fe2$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $833e317ce43259cd$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $833e317ce43259cd$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $e9281399ef5fb36a$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $833e317ce43259cd$export$2e2bcd8739ae039).isBuffer(data) || (0, $833e317ce43259cd$export$2e2bcd8739ae039).isStream(data) || (0, $833e317ce43259cd$export$2e2bcd8739ae039).isFile(data) || (0, $833e317ce43259cd$export$2e2bcd8739ae039).isBlob(data) || (0, $833e317ce43259cd$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $cf1e503df83d8e4c$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $8d90945f7485048f$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $833e317ce43259cd$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $cf1e503df83d8e4c$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $63712c0ff1698dd8$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $cf1e503df83d8e4c$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $cf1e503df83d8e4c$var$own(this, 'transitional') || $cf1e503df83d8e4c$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $cf1e503df83d8e4c$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isResponse(data) || (0, $833e317ce43259cd$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $cf1e503df83d8e4c$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $05b25dfd89956b35$export$2e2bcd8739ae039).from(e, (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $cf1e503df83d8e4c$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $54256614a159fb46$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $54256614a159fb46$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $cf1e503df83d8e4c$var$defaults.headers[method] = {};
});
var $cf1e503df83d8e4c$export$2e2bcd8739ae039 = $cf1e503df83d8e4c$var$defaults;



'use strict';
function $21ab53ebbbeab0af$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $cf1e503df83d8e4c$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $e79457842ad79ca6$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $96305cad85dccce7$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $89005ebe752795cc$var$CanceledError extends (0, $05b25dfd89956b35$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $89005ebe752795cc$export$2e2bcd8739ae039 = $89005ebe752795cc$var$CanceledError;







'use strict';
function $643da3905b1306a3$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $da28beaa61a20346$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $0b1cfa8cdc84e8ac$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $0b1cfa8cdc84e8ac$export$2e2bcd8739ae039 = $0b1cfa8cdc84e8ac$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $5d3eb082ef4a93ad$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $5d3eb082ef4a93ad$export$2e2bcd8739ae039 = $5d3eb082ef4a93ad$var$throttle;



const $3975343f02c50245$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $0b1cfa8cdc84e8ac$export$2e2bcd8739ae039)(50, 250);
    return (0, $5d3eb082ef4a93ad$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $3975343f02c50245$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $3975343f02c50245$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $833e317ce43259cd$export$2e2bcd8739ae039).asap(()=>fn(...args));






var $6ee659d52c211100$export$2e2bcd8739ae039 = (0, $54256614a159fb46$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $54256614a159fb46$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $54256614a159fb46$export$2e2bcd8739ae039).origin), (0, $54256614a159fb46$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $54256614a159fb46$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $f5928780eeb44d7d$export$2e2bcd8739ae039 = (0, $54256614a159fb46$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $0df6d45cc9355b69$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $0a32b924c940f429$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
const $5042b5a788d1e06e$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $5042b5a788d1e06e$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $5042b5a788d1e06e$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $5042b5a788d1e06e$var$normalizeURLForProtocolCheck(url) {
    return $5042b5a788d1e06e$var$stripLeadingC0ControlOrSpace(url).replace($5042b5a788d1e06e$var$httpProtocolControlCharacters, '');
}
function $5042b5a788d1e06e$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string' && $5042b5a788d1e06e$var$malformedHttpProtocol.test($5042b5a788d1e06e$var$normalizeURLForProtocolCheck(url))) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('Invalid URL: missing "//" after protocol', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
}
function $5042b5a788d1e06e$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $5042b5a788d1e06e$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $0df6d45cc9355b69$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $5042b5a788d1e06e$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $0a32b924c940f429$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $bb89b9125afb4ec2$var$headersToObject = (thing)=>thing instanceof (0, $e79457842ad79ca6$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $bb89b9125afb4ec2$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isPlainObject(target) && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $833e317ce43259cd$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $833e317ce43259cd$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($bb89b9125afb4ec2$var$headersToObject(a), $bb89b9125afb4ec2$var$headersToObject(b), prop, true)
    };
    (0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}




const $109888ecdec6abd8$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $109888ecdec6abd8$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($109888ecdec6abd8$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $109888ecdec6abd8$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $109888ecdec6abd8$var$resolveConfig(config) {
    const newConfig = (0, $bb89b9125afb4ec2$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $e79457842ad79ca6$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $413c4110c050d132$export$2e2bcd8739ae039)((0, $5042b5a788d1e06e$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $833e317ce43259cd$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $833e317ce43259cd$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $109888ecdec6abd8$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $05b25dfd89956b35$export$2e2bcd8739ae039).from(e, (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $54256614a159fb46$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $54256614a159fb46$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $833e317ce43259cd$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $109888ecdec6abd8$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $54256614a159fb46$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $6ee659d52c211100$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $f5928780eeb44d7d$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $109888ecdec6abd8$export$2e2bcd8739ae039 = $109888ecdec6abd8$var$resolveConfig;



const $b2c6270ba02a580d$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $b2c6270ba02a580d$export$2e2bcd8739ae039 = $b2c6270ba02a580d$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $109888ecdec6abd8$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $e79457842ad79ca6$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $e79457842ad79ca6$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $643da3905b1306a3$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('Request aborted', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)(msg, (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $c7701c9f6b2f4fe2$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ETIMEDOUT : (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach((0, $a36e789e89183a5b$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $3975343f02c50245$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $3975343f02c50245$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $89005ebe752795cc$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $da28beaa61a20346$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $54256614a159fb46$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $ae5a547aa0981c96$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $05b25dfd89956b35$export$2e2bcd8739ae039) ? err : new (0, $89005ebe752795cc$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort, {
            once: true
        }));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $833e317ce43259cd$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $ae5a547aa0981c96$export$2e2bcd8739ae039 = $ae5a547aa0981c96$var$composeSignals;


const $08903e218d4f61b5$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $08903e218d4f61b5$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $08903e218d4f61b5$var$readStream(iterable))yield* $08903e218d4f61b5$export$71b051935044bd5d(chunk, chunkSize);
};
const $08903e218d4f61b5$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $08903e218d4f61b5$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $08903e218d4f61b5$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: compute the exact percent-decoded UTF-8 byte length.
 *
 * @param {string} url
 * @returns {number}
 */ const $1402240a113249db$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $1402240a113249db$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $1402240a113249db$var$isHexDigit(str.charCodeAt(i + 1)) && $1402240a113249db$var$isHexDigit(str.charCodeAt(i + 2));
function $1402240a113249db$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = $1402240a113249db$var$isHexDigit(a) && $1402240a113249db$var$isHexDigit(b);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $1402240a113249db$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $ac57d70ca2886fd0$export$a4ad2735b021c132 = "1.18.1";



const $683957d66ad383ce$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $683957d66ad383ce$var$isFunction } = (0, $833e317ce43259cd$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $683957d66ad383ce$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $683957d66ad383ce$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $683957d66ad383ce$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $683957d66ad383ce$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $683957d66ad383ce$var$factory = (env)=>{
    const globalObject = (0, $833e317ce43259cd$export$2e2bcd8739ae039).global !== undefined && (0, $833e317ce43259cd$export$2e2bcd8739ae039).global !== null ? (0, $833e317ce43259cd$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $833e317ce43259cd$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $683957d66ad383ce$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $683957d66ad383ce$var$isFunction(Request);
    const isResponseSupported = $683957d66ad383ce$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $683957d66ad383ce$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $683957d66ad383ce$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $54256614a159fb46$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $683957d66ad383ce$var$test(()=>(0, $833e317ce43259cd$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $54256614a159fb46$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $833e317ce43259cd$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $109888ecdec6abd8$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $833e317ce43259cd$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $833e317ce43259cd$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $ae5a547aa0981c96$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $833e317ce43259cd$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $833e317ce43259cd$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($683957d66ad383ce$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $54256614a159fb46$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $683957d66ad383ce$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $683957d66ad383ce$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($683957d66ad383ce$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $1402240a113249db$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isReadableStream(data) || (0, $833e317ce43259cd$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $08903e218d4f61b5$export$b0119225647bd83)(stream, $683957d66ad383ce$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $3975343f02c50245$export$d9fadd12586c18d6)(requestContentLength, (0, $3975343f02c50245$export$c1b28109d46c3592)((0, $3975343f02c50245$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $833e317ce43259cd$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $ac57d70ca2886fd0$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $a36e789e89183a5b$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $e79457842ad79ca6$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $833e317ce43259cd$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $833e317ce43259cd$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $3975343f02c50245$export$d9fadd12586c18d6)(responseContentLength, (0, $3975343f02c50245$export$c1b28109d46c3592)((0, $3975343f02c50245$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $08903e218d4f61b5$export$b0119225647bd83)(response.body, $683957d66ad383ce$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $833e317ce43259cd$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $643da3905b1306a3$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $e79457842ad79ca6$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $05b25dfd89956b35$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $05b25dfd89956b35$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('Network Error', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $05b25dfd89956b35$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $683957d66ad383ce$var$seedCache = new Map();
const $683957d66ad383ce$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $683957d66ad383ce$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $683957d66ad383ce$var$factory(env));
        map = target;
    }
    return target;
};
const $683957d66ad383ce$var$adapter = $683957d66ad383ce$export$3105c6651375d4fa();
var $683957d66ad383ce$export$2e2bcd8739ae039 = $683957d66ad383ce$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $ca8a3e1ee3d92331$var$knownAdapters = {
    http: (0, $bae03b29c94fb213$export$2e2bcd8739ae039),
    xhr: (0, $b2c6270ba02a580d$export$2e2bcd8739ae039),
    fetch: {
        get: $683957d66ad383ce$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach($ca8a3e1ee3d92331$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $ca8a3e1ee3d92331$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $ca8a3e1ee3d92331$var$isResolvedHandle = (adapter)=>(0, $833e317ce43259cd$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $ca8a3e1ee3d92331$var$getAdapter(adapters, config) {
    adapters = (0, $833e317ce43259cd$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$ca8a3e1ee3d92331$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $ca8a3e1ee3d92331$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($ca8a3e1ee3d92331$var$renderReason).join('\n') : ' ' + $ca8a3e1ee3d92331$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $ca8a3e1ee3d92331$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $ca8a3e1ee3d92331$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $ca8a3e1ee3d92331$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $71ca460e9cae92f9$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $89005ebe752795cc$export$2e2bcd8739ae039)(null, config);
}
function $71ca460e9cae92f9$export$2e2bcd8739ae039(config) {
    $71ca460e9cae92f9$var$throwIfCancellationRequested(config);
    config.headers = (0, $e79457842ad79ca6$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $21ab53ebbbeab0af$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $ca8a3e1ee3d92331$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $cf1e503df83d8e4c$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $71ca460e9cae92f9$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $21ab53ebbbeab0af$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $e79457842ad79ca6$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $96305cad85dccce7$export$2e2bcd8739ae039)(reason)) {
            $71ca460e9cae92f9$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $21ab53ebbbeab0af$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $e79457842ad79ca6$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $1348e76a0f731471$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $1348e76a0f731471$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $1348e76a0f731471$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1348e76a0f731471$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $ac57d70ca2886fd0$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$1348e76a0f731471$var$deprecatedWarnings[opt]) {
            $1348e76a0f731471$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1348e76a0f731471$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1348e76a0f731471$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('options must be an object', (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $05b25dfd89956b35$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $05b25dfd89956b35$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $1348e76a0f731471$export$2e2bcd8739ae039 = {
    assertOptions: $1348e76a0f731471$var$assertOptions,
    validators: $1348e76a0f731471$var$validators
};




'use strict';
const $131c64f59a250474$var$validators = (0, $1348e76a0f731471$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $131c64f59a250474$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $b138b667a00818c2$export$2e2bcd8739ae039)(),
            response: new (0, $b138b667a00818c2$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $bb89b9125afb4ec2$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $1348e76a0f731471$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $131c64f59a250474$var$validators.transitional($131c64f59a250474$var$validators.boolean),
            forcedJSONParsing: $131c64f59a250474$var$validators.transitional($131c64f59a250474$var$validators.boolean),
            clarifyTimeoutError: $131c64f59a250474$var$validators.transitional($131c64f59a250474$var$validators.boolean),
            legacyInterceptorReqResOrdering: $131c64f59a250474$var$validators.transitional($131c64f59a250474$var$validators.boolean),
            advertiseZstdAcceptEncoding: $131c64f59a250474$var$validators.transitional($131c64f59a250474$var$validators.boolean),
            validateStatusUndefinedResolves: $131c64f59a250474$var$validators.transitional($131c64f59a250474$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $833e317ce43259cd$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $1348e76a0f731471$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $131c64f59a250474$var$validators.function,
                serialize: $131c64f59a250474$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $1348e76a0f731471$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $131c64f59a250474$var$validators.spelling('baseURL'),
            withXsrfToken: $131c64f59a250474$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $833e317ce43259cd$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $e79457842ad79ca6$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $c7701c9f6b2f4fe2$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $71ca460e9cae92f9$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $71ca460e9cae92f9$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $bb89b9125afb4ec2$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $5042b5a788d1e06e$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $413c4110c050d132$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $131c64f59a250474$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $bb89b9125afb4ec2$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $833e317ce43259cd$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $833e317ce43259cd$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $bb89b9125afb4ec2$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $131c64f59a250474$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $131c64f59a250474$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $131c64f59a250474$export$2e2bcd8739ae039 = $131c64f59a250474$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $4460269ffd74898d$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $89005ebe752795cc$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $4460269ffd74898d$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $4460269ffd74898d$export$2e2bcd8739ae039 = $4460269ffd74898d$var$CancelToken;






'use strict';
function $e6a368dde484cc87$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $6b03b8e522d30035$export$2e2bcd8739ae039(payload) {
    return (0, $833e317ce43259cd$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $4fdbc93022dd13ae$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($4fdbc93022dd13ae$var$HttpStatusCode).forEach(([key, value])=>{
    $4fdbc93022dd13ae$var$HttpStatusCode[value] = key;
});
var $4fdbc93022dd13ae$export$2e2bcd8739ae039 = $4fdbc93022dd13ae$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $9b1678a8d2ae1e0f$var$createInstance(defaultConfig) {
    const context = new (0, $131c64f59a250474$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $1d74f52613010282$export$2e2bcd8739ae039)((0, $131c64f59a250474$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $833e317ce43259cd$export$2e2bcd8739ae039).extend(instance, (0, $131c64f59a250474$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $833e317ce43259cd$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $9b1678a8d2ae1e0f$var$createInstance((0, $bb89b9125afb4ec2$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $9b1678a8d2ae1e0f$var$axios = $9b1678a8d2ae1e0f$var$createInstance((0, $cf1e503df83d8e4c$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$9b1678a8d2ae1e0f$var$axios.Axios = (0, $131c64f59a250474$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$9b1678a8d2ae1e0f$var$axios.CanceledError = (0, $89005ebe752795cc$export$2e2bcd8739ae039);
$9b1678a8d2ae1e0f$var$axios.CancelToken = (0, $4460269ffd74898d$export$2e2bcd8739ae039);
$9b1678a8d2ae1e0f$var$axios.isCancel = (0, $96305cad85dccce7$export$2e2bcd8739ae039);
$9b1678a8d2ae1e0f$var$axios.VERSION = (0, $ac57d70ca2886fd0$export$a4ad2735b021c132);
$9b1678a8d2ae1e0f$var$axios.toFormData = (0, $63712c0ff1698dd8$export$2e2bcd8739ae039);
// Expose AxiosError class
$9b1678a8d2ae1e0f$var$axios.AxiosError = (0, $05b25dfd89956b35$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$9b1678a8d2ae1e0f$var$axios.Cancel = $9b1678a8d2ae1e0f$var$axios.CanceledError;
// Expose all/spread
$9b1678a8d2ae1e0f$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$9b1678a8d2ae1e0f$var$axios.spread = (0, $e6a368dde484cc87$export$2e2bcd8739ae039);
// Expose isAxiosError
$9b1678a8d2ae1e0f$var$axios.isAxiosError = (0, $6b03b8e522d30035$export$2e2bcd8739ae039);
// Expose mergeConfig
$9b1678a8d2ae1e0f$var$axios.mergeConfig = (0, $bb89b9125afb4ec2$export$2e2bcd8739ae039);
$9b1678a8d2ae1e0f$var$axios.AxiosHeaders = (0, $e79457842ad79ca6$export$2e2bcd8739ae039);
$9b1678a8d2ae1e0f$var$axios.formToJSON = (thing)=>(0, $e9281399ef5fb36a$export$2e2bcd8739ae039)((0, $833e317ce43259cd$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$9b1678a8d2ae1e0f$var$axios.getAdapter = (0, $ca8a3e1ee3d92331$export$2e2bcd8739ae039).getAdapter;
$9b1678a8d2ae1e0f$var$axios.HttpStatusCode = (0, $4fdbc93022dd13ae$export$2e2bcd8739ae039);
$9b1678a8d2ae1e0f$var$axios.default = $9b1678a8d2ae1e0f$var$axios;
var // this module should only have a default export
$9b1678a8d2ae1e0f$export$2e2bcd8739ae039 = $9b1678a8d2ae1e0f$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $5327a861ef8fd960$export$1c00760e9e5a4e95, AxiosError: $5327a861ef8fd960$export$c1fbed17c2f6a328, CanceledError: $5327a861ef8fd960$export$1ab0c6b20d94fa14, isCancel: $5327a861ef8fd960$export$3b22524397b493c6, CancelToken: $5327a861ef8fd960$export$fd08e3cb425f0d61, VERSION: $5327a861ef8fd960$export$a4ad2735b021c132, all: $5327a861ef8fd960$export$84bf76cd7afc7469, Cancel: $5327a861ef8fd960$export$848c9b7ead0df967, isAxiosError: $5327a861ef8fd960$export$fbafdbe06a5b5a9a, spread: $5327a861ef8fd960$export$3ae0fd4797ed47c8, toFormData: $5327a861ef8fd960$export$10ae0d317ea97f8b, AxiosHeaders: $5327a861ef8fd960$export$4e7d6ff0f3e6520, HttpStatusCode: $5327a861ef8fd960$export$a972f69c851492b3, formToJSON: $5327a861ef8fd960$export$86d7c59254d6a2c9, getAdapter: $5327a861ef8fd960$export$17ddc20a97d669e2, mergeConfig: $5327a861ef8fd960$export$7ec1ebcfa9d8bd6a, create: $5327a861ef8fd960$export$185802fd694ee1f5 } = (0, $9b1678a8d2ae1e0f$export$2e2bcd8739ae039);


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $2f7b58c8e76d4457$export$3d7865934588d77e = {
    INITIALIZE_START: "msal:initializeStart",
    INITIALIZE_END: "msal:initializeEnd",
    ACTIVE_ACCOUNT_CHANGED: "msal:activeAccountChanged",
    LOGIN_SUCCESS: "msal:loginSuccess",
    ACQUIRE_TOKEN_START: "msal:acquireTokenStart",
    BROKERED_REQUEST_START: "msal:brokeredRequestStart",
    ACQUIRE_TOKEN_SUCCESS: "msal:acquireTokenSuccess",
    BROKERED_REQUEST_SUCCESS: "msal:brokeredRequestSuccess",
    ACQUIRE_TOKEN_FAILURE: "msal:acquireTokenFailure",
    BROKERED_REQUEST_FAILURE: "msal:brokeredRequestFailure",
    ACQUIRE_TOKEN_NETWORK_START: "msal:acquireTokenFromNetworkStart",
    HANDLE_REDIRECT_START: "msal:handleRedirectStart",
    HANDLE_REDIRECT_END: "msal:handleRedirectEnd",
    POPUP_OPENED: "msal:popupOpened",
    LOGOUT_START: "msal:logoutStart",
    LOGOUT_SUCCESS: "msal:logoutSuccess",
    LOGOUT_FAILURE: "msal:logoutFailure",
    LOGOUT_END: "msal:logoutEnd",
    RESTORE_FROM_BFCACHE: "msal:restoreFromBFCache",
    BROKER_CONNECTION_ESTABLISHED: "msal:brokerConnectionEstablished"
};

/*! @azure/msal-browser v5.16.0 2026-06-30 */ /*! @azure/msal-browser v5.16.0 2026-06-30 */ /*! @azure/msal-browser v5.16.0 2026-06-30 */ var $11e3a50b38764cc5$exports = {};

$parcel$export($11e3a50b38764cc5$exports, "clientInfoDecodingError", () => $11e3a50b38764cc5$export$ccdf48c387c47b82);
$parcel$export($11e3a50b38764cc5$exports, "clientInfoEmptyError", () => $11e3a50b38764cc5$export$12315251e24e0181);
$parcel$export($11e3a50b38764cc5$exports, "tokenParsingError", () => $11e3a50b38764cc5$export$ad362b2e3a260143);
$parcel$export($11e3a50b38764cc5$exports, "nullOrEmptyToken", () => $11e3a50b38764cc5$export$78d01e29cb494be2);
$parcel$export($11e3a50b38764cc5$exports, "endpointResolutionError", () => $11e3a50b38764cc5$export$c9fcc93738cc2bc3);
$parcel$export($11e3a50b38764cc5$exports, "networkError", () => $11e3a50b38764cc5$export$4358cbadf08aa73);
$parcel$export($11e3a50b38764cc5$exports, "openIdConfigError", () => $11e3a50b38764cc5$export$73566da29bc073eb);
$parcel$export($11e3a50b38764cc5$exports, "hashNotDeserialized", () => $11e3a50b38764cc5$export$14c4d54a8414667f);
$parcel$export($11e3a50b38764cc5$exports, "invalidState", () => $11e3a50b38764cc5$export$72a77317632c052b);
$parcel$export($11e3a50b38764cc5$exports, "stateMismatch", () => $11e3a50b38764cc5$export$6a56d8f882843cd8);
$parcel$export($11e3a50b38764cc5$exports, "stateNotFound", () => $11e3a50b38764cc5$export$ef9214cfa5960fc);
$parcel$export($11e3a50b38764cc5$exports, "nonceMismatch", () => $11e3a50b38764cc5$export$edd0491c2c280be7);
$parcel$export($11e3a50b38764cc5$exports, "multipleMatchingTokens", () => $11e3a50b38764cc5$export$47c50a2451614107);
$parcel$export($11e3a50b38764cc5$exports, "multipleMatchingAppMetadata", () => $11e3a50b38764cc5$export$575bb2924bcd0084);
$parcel$export($11e3a50b38764cc5$exports, "requestCannotBeMade", () => $11e3a50b38764cc5$export$4ac9fb1f531eded7);
$parcel$export($11e3a50b38764cc5$exports, "cannotRemoveEmptyScope", () => $11e3a50b38764cc5$export$f7a276c01beb068a);
$parcel$export($11e3a50b38764cc5$exports, "cannotAppendScopeSet", () => $11e3a50b38764cc5$export$93883786cf4a4a27);
$parcel$export($11e3a50b38764cc5$exports, "emptyInputScopeSet", () => $11e3a50b38764cc5$export$41e2ce5958c42c83);
$parcel$export($11e3a50b38764cc5$exports, "noAccountInSilentRequest", () => $11e3a50b38764cc5$export$5a3c7d1c90ac9220);
$parcel$export($11e3a50b38764cc5$exports, "invalidCacheRecord", () => $11e3a50b38764cc5$export$d396103576f879cc);
$parcel$export($11e3a50b38764cc5$exports, "invalidCacheEnvironment", () => $11e3a50b38764cc5$export$dedc648643245fa1);
$parcel$export($11e3a50b38764cc5$exports, "noAccountFound", () => $11e3a50b38764cc5$export$b98ebfe073f0162f);
$parcel$export($11e3a50b38764cc5$exports, "noCryptoObject", () => $11e3a50b38764cc5$export$c39e501a22cba395);
$parcel$export($11e3a50b38764cc5$exports, "unexpectedCredentialType", () => $11e3a50b38764cc5$export$21fdd1f95350cd6d);
$parcel$export($11e3a50b38764cc5$exports, "tokenRefreshRequired", () => $11e3a50b38764cc5$export$e23b692cce0c7779);
$parcel$export($11e3a50b38764cc5$exports, "tokenClaimsCnfRequiredForSignedJwt", () => $11e3a50b38764cc5$export$6f89b8a7d491b526);
$parcel$export($11e3a50b38764cc5$exports, "authorizationCodeMissingFromServerResponse", () => $11e3a50b38764cc5$export$93625fc864d26bba);
$parcel$export($11e3a50b38764cc5$exports, "bindingKeyNotRemoved", () => $11e3a50b38764cc5$export$5765db5d84418d29);
$parcel$export($11e3a50b38764cc5$exports, "endSessionEndpointNotSupported", () => $11e3a50b38764cc5$export$c3bd741c16a889f3);
$parcel$export($11e3a50b38764cc5$exports, "keyIdMissing", () => $11e3a50b38764cc5$export$3c9338a50e294d1);
$parcel$export($11e3a50b38764cc5$exports, "noNetworkConnectivity", () => $11e3a50b38764cc5$export$31ae862f18c3b2b7);
$parcel$export($11e3a50b38764cc5$exports, "userCanceled", () => $11e3a50b38764cc5$export$8ee329e65a880ec7);
$parcel$export($11e3a50b38764cc5$exports, "methodNotImplemented", () => $11e3a50b38764cc5$export$24176fc1f15eea22);
$parcel$export($11e3a50b38764cc5$exports, "nestedAppAuthBridgeDisabled", () => $11e3a50b38764cc5$export$3078b0202fe7eea3);
$parcel$export($11e3a50b38764cc5$exports, "platformBrokerError", () => $11e3a50b38764cc5$export$3642667d172bf3ce);
$parcel$export($11e3a50b38764cc5$exports, "resourceParameterRequired", () => $11e3a50b38764cc5$export$17a59a33a4e9e5f7);
$parcel$export($11e3a50b38764cc5$exports, "misplacedResourceParam", () => $11e3a50b38764cc5$export$b4ecff4fd4f67ea0);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $11e3a50b38764cc5$export$ccdf48c387c47b82 = "client_info_decoding_error";
const $11e3a50b38764cc5$export$12315251e24e0181 = "client_info_empty_error";
const $11e3a50b38764cc5$export$ad362b2e3a260143 = "token_parsing_error";
const $11e3a50b38764cc5$export$78d01e29cb494be2 = "null_or_empty_token";
const $11e3a50b38764cc5$export$c9fcc93738cc2bc3 = "endpoints_resolution_error";
const $11e3a50b38764cc5$export$4358cbadf08aa73 = "network_error";
const $11e3a50b38764cc5$export$73566da29bc073eb = "openid_config_error";
const $11e3a50b38764cc5$export$14c4d54a8414667f = "hash_not_deserialized";
const $11e3a50b38764cc5$export$72a77317632c052b = "invalid_state";
const $11e3a50b38764cc5$export$6a56d8f882843cd8 = "state_mismatch";
const $11e3a50b38764cc5$export$ef9214cfa5960fc = "state_not_found";
const $11e3a50b38764cc5$export$edd0491c2c280be7 = "nonce_mismatch";
const $11e3a50b38764cc5$export$47c50a2451614107 = "multiple_matching_tokens";
const $11e3a50b38764cc5$export$575bb2924bcd0084 = "multiple_matching_appMetadata";
const $11e3a50b38764cc5$export$4ac9fb1f531eded7 = "request_cannot_be_made";
const $11e3a50b38764cc5$export$f7a276c01beb068a = "cannot_remove_empty_scope";
const $11e3a50b38764cc5$export$93883786cf4a4a27 = "cannot_append_scopeset";
const $11e3a50b38764cc5$export$41e2ce5958c42c83 = "empty_input_scopeset";
const $11e3a50b38764cc5$export$5a3c7d1c90ac9220 = "no_account_in_silent_request";
const $11e3a50b38764cc5$export$d396103576f879cc = "invalid_cache_record";
const $11e3a50b38764cc5$export$dedc648643245fa1 = "invalid_cache_environment";
const $11e3a50b38764cc5$export$b98ebfe073f0162f = "no_account_found";
const $11e3a50b38764cc5$export$c39e501a22cba395 = "no_crypto_object";
const $11e3a50b38764cc5$export$21fdd1f95350cd6d = "unexpected_credential_type";
const $11e3a50b38764cc5$export$e23b692cce0c7779 = "token_refresh_required";
const $11e3a50b38764cc5$export$6f89b8a7d491b526 = "token_claims_cnf_required_for_signedjwt";
const $11e3a50b38764cc5$export$93625fc864d26bba = "authorization_code_missing_from_server_response";
const $11e3a50b38764cc5$export$5765db5d84418d29 = "binding_key_not_removed";
const $11e3a50b38764cc5$export$c3bd741c16a889f3 = "end_session_endpoint_not_supported";
const $11e3a50b38764cc5$export$3c9338a50e294d1 = "key_id_missing";
const $11e3a50b38764cc5$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $11e3a50b38764cc5$export$8ee329e65a880ec7 = "user_canceled";
const $11e3a50b38764cc5$export$24176fc1f15eea22 = "method_not_implemented";
const $11e3a50b38764cc5$export$3078b0202fe7eea3 = "nested_app_auth_bridge_disabled";
const $11e3a50b38764cc5$export$3642667d172bf3ce = "platform_broker_error";
const $11e3a50b38764cc5$export$17a59a33a4e9e5f7 = "resource_parameter_required";
const $11e3a50b38764cc5$export$b4ecff4fd4f67ea0 = "misplaced_resource_parameter";

/*! @azure/msal-common v16.11.0 2026-06-30 */ /*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $8d1fc9917b2c0dac$export$714f3eb4b9ca37c5(code) {
    return `See https://aka.ms/msal.js.errors#${code} for details`;
}
/**
 * General error class thrown by the MSAL.js library.
 */ class $8d1fc9917b2c0dac$export$145273558d58e0ac extends Error {
    constructor(errorCode, correlationId, errorMessage, suberror){
        const message = errorMessage || (errorCode ? $8d1fc9917b2c0dac$export$714f3eb4b9ca37c5(errorCode) : "");
        const errorString = message ? `${errorCode}: ${message}` : errorCode;
        super(errorString);
        Object.setPrototypeOf(this, $8d1fc9917b2c0dac$export$145273558d58e0ac.prototype);
        this.errorCode = errorCode || "";
        this.errorMessage = message || "";
        this.subError = suberror || "";
        this.correlationId = correlationId;
        this.name = "AuthError";
    }
}
function $8d1fc9917b2c0dac$export$eb157f7636c79bd2(code, correlationId, additionalMessage) {
    return new $8d1fc9917b2c0dac$export$145273558d58e0ac(code, correlationId, additionalMessage || $8d1fc9917b2c0dac$export$714f3eb4b9ca37c5(code));
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ /**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $b5b2cf5eef944c90$export$a839ff85a7957561 extends (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) {
    constructor(errorCode, correlationId, additionalMessage){
        super(errorCode, correlationId, additionalMessage);
        this.name = "ClientAuthError";
        Object.setPrototypeOf(this, $b5b2cf5eef944c90$export$a839ff85a7957561.prototype);
    }
}
function $b5b2cf5eef944c90$export$ea892ce48f5bb4f3(errorCode, correlationId, additionalMessage) {
    return new $b5b2cf5eef944c90$export$a839ff85a7957561(errorCode, correlationId, additionalMessage);
}

/*! @azure/msal-common v16.11.0 2026-06-30 */ /*! @azure/msal-common v16.11.0 2026-06-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $545bc4a68e40c43a$export$980ad46b7a115fad extends (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        this.name = "JoseHeaderError";
        Object.setPrototypeOf(this, $545bc4a68e40c43a$export$980ad46b7a115fad.prototype);
    }
}
/** Returns JoseHeaderError object */ function $545bc4a68e40c43a$export$3ef463ea134172ed(code, correlationId) {
    return new $545bc4a68e40c43a$export$980ad46b7a115fad(code, correlationId);
}


var $8994aeee5e01080d$exports = {};

$parcel$export($8994aeee5e01080d$exports, "SKU", () => $8994aeee5e01080d$export$45c909820884b9ec);
$parcel$export($8994aeee5e01080d$exports, "DEFAULT_AUTHORITY", () => $8994aeee5e01080d$export$405127a8c597bdfe);
$parcel$export($8994aeee5e01080d$exports, "DEFAULT_AUTHORITY_HOST", () => $8994aeee5e01080d$export$ff29228a41d88890);
$parcel$export($8994aeee5e01080d$exports, "DEFAULT_COMMON_TENANT", () => $8994aeee5e01080d$export$cf84b28865aad146);
$parcel$export($8994aeee5e01080d$exports, "ADFS", () => $8994aeee5e01080d$export$d67d0b9d84b9fa64);
$parcel$export($8994aeee5e01080d$exports, "DSTS", () => $8994aeee5e01080d$export$ed356007bd76ccea);
$parcel$export($8994aeee5e01080d$exports, "AAD_INSTANCE_DISCOVERY_ENDPT", () => $8994aeee5e01080d$export$e56648d3c1473424);
$parcel$export($8994aeee5e01080d$exports, "CIAM_AUTH_URL", () => $8994aeee5e01080d$export$ecbbba19d57055cd);
$parcel$export($8994aeee5e01080d$exports, "AAD_TENANT_DOMAIN_SUFFIX", () => $8994aeee5e01080d$export$8a15b376f6b2940);
$parcel$export($8994aeee5e01080d$exports, "RESOURCE_DELIM", () => $8994aeee5e01080d$export$c49b7e87df554b81);
$parcel$export($8994aeee5e01080d$exports, "CONSUMER_UTID", () => $8994aeee5e01080d$export$90fa201058ba044f);
$parcel$export($8994aeee5e01080d$exports, "OPENID_SCOPE", () => $8994aeee5e01080d$export$74fa595b48c8c01e);
$parcel$export($8994aeee5e01080d$exports, "PROFILE_SCOPE", () => $8994aeee5e01080d$export$76ff9ac69ea41312);
$parcel$export($8994aeee5e01080d$exports, "OFFLINE_ACCESS_SCOPE", () => $8994aeee5e01080d$export$b281676656f67eb4);
$parcel$export($8994aeee5e01080d$exports, "EMAIL_SCOPE", () => $8994aeee5e01080d$export$a69a793fa9a71a6f);
$parcel$export($8994aeee5e01080d$exports, "CODE_GRANT_TYPE", () => $8994aeee5e01080d$export$69cccd63344f058d);
$parcel$export($8994aeee5e01080d$exports, "S256_CODE_CHALLENGE_METHOD", () => $8994aeee5e01080d$export$c12418ff35a420f6);
$parcel$export($8994aeee5e01080d$exports, "URL_FORM_CONTENT_TYPE", () => $8994aeee5e01080d$export$7558dcec6f2048d);
$parcel$export($8994aeee5e01080d$exports, "AUTHORIZATION_PENDING", () => $8994aeee5e01080d$export$b18f0664a2d39502);
$parcel$export($8994aeee5e01080d$exports, "NOT_APPLICABLE", () => $8994aeee5e01080d$export$e8958a6508ec5b71);
$parcel$export($8994aeee5e01080d$exports, "NOT_AVAILABLE", () => $8994aeee5e01080d$export$d5f291b4be36f605);
$parcel$export($8994aeee5e01080d$exports, "FORWARD_SLASH", () => $8994aeee5e01080d$export$933cdf3ebd8cc149);
$parcel$export($8994aeee5e01080d$exports, "IMDS_ENDPOINT", () => $8994aeee5e01080d$export$5eeea8c9d02ceb62);
$parcel$export($8994aeee5e01080d$exports, "IMDS_VERSION", () => $8994aeee5e01080d$export$69aaeb41e2826c48);
$parcel$export($8994aeee5e01080d$exports, "IMDS_TIMEOUT", () => $8994aeee5e01080d$export$7c61cea10ff91469);
$parcel$export($8994aeee5e01080d$exports, "AZURE_REGION_AUTO_DISCOVER_FLAG", () => $8994aeee5e01080d$export$243dfbda037eb091);
$parcel$export($8994aeee5e01080d$exports, "REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX", () => $8994aeee5e01080d$export$b85ac6323a66047);
$parcel$export($8994aeee5e01080d$exports, "KNOWN_PUBLIC_CLOUDS", () => $8994aeee5e01080d$export$afcb83a97360adbc);
$parcel$export($8994aeee5e01080d$exports, "SHR_NONCE_VALIDITY", () => $8994aeee5e01080d$export$20eec6ef8175441);
$parcel$export($8994aeee5e01080d$exports, "INVALID_INSTANCE", () => $8994aeee5e01080d$export$1d8570e3a324589e);
$parcel$export($8994aeee5e01080d$exports, "HTTP_SUCCESS", () => $8994aeee5e01080d$export$f7faf416d920fff3);
$parcel$export($8994aeee5e01080d$exports, "HTTP_SUCCESS_RANGE_START", () => $8994aeee5e01080d$export$bf64241e0c309627);
$parcel$export($8994aeee5e01080d$exports, "HTTP_SUCCESS_RANGE_END", () => $8994aeee5e01080d$export$bb61c9fb50e57838);
$parcel$export($8994aeee5e01080d$exports, "HTTP_REDIRECT", () => $8994aeee5e01080d$export$a704168478db6ad0);
$parcel$export($8994aeee5e01080d$exports, "HTTP_CLIENT_ERROR", () => $8994aeee5e01080d$export$365529322ade2a43);
$parcel$export($8994aeee5e01080d$exports, "HTTP_CLIENT_ERROR_RANGE_START", () => $8994aeee5e01080d$export$6f402514545f3f58);
$parcel$export($8994aeee5e01080d$exports, "HTTP_BAD_REQUEST", () => $8994aeee5e01080d$export$9a0aba463f6ac337);
$parcel$export($8994aeee5e01080d$exports, "HTTP_UNAUTHORIZED", () => $8994aeee5e01080d$export$adbf103f5d371692);
$parcel$export($8994aeee5e01080d$exports, "HTTP_NOT_FOUND", () => $8994aeee5e01080d$export$6226897062245741);
$parcel$export($8994aeee5e01080d$exports, "HTTP_REQUEST_TIMEOUT", () => $8994aeee5e01080d$export$304f7f334b3888b0);
$parcel$export($8994aeee5e01080d$exports, "HTTP_GONE", () => $8994aeee5e01080d$export$73cba17c10a00d41);
$parcel$export($8994aeee5e01080d$exports, "HTTP_TOO_MANY_REQUESTS", () => $8994aeee5e01080d$export$bc275033437a2e03);
$parcel$export($8994aeee5e01080d$exports, "HTTP_CLIENT_ERROR_RANGE_END", () => $8994aeee5e01080d$export$80be1ba03533fcfc);
$parcel$export($8994aeee5e01080d$exports, "HTTP_SERVER_ERROR", () => $8994aeee5e01080d$export$ec31e119ef282c60);
$parcel$export($8994aeee5e01080d$exports, "HTTP_SERVER_ERROR_RANGE_START", () => $8994aeee5e01080d$export$310d0488bddd36e1);
$parcel$export($8994aeee5e01080d$exports, "HTTP_SERVICE_UNAVAILABLE", () => $8994aeee5e01080d$export$b18794ec8d78bd2f);
$parcel$export($8994aeee5e01080d$exports, "HTTP_GATEWAY_TIMEOUT", () => $8994aeee5e01080d$export$d53e5bd3ec9a0f2a);
$parcel$export($8994aeee5e01080d$exports, "HTTP_SERVER_ERROR_RANGE_END", () => $8994aeee5e01080d$export$cabebb7af2e4f2f0);
$parcel$export($8994aeee5e01080d$exports, "HTTP_MULTI_SIDED_ERROR", () => $8994aeee5e01080d$export$910bb73d987bdc9);
$parcel$export($8994aeee5e01080d$exports, "HttpMethod", () => $8994aeee5e01080d$export$8343e6f32f5246de);
$parcel$export($8994aeee5e01080d$exports, "OIDC_DEFAULT_SCOPES", () => $8994aeee5e01080d$export$893b1b5b686d84ef);
$parcel$export($8994aeee5e01080d$exports, "OIDC_SCOPES", () => $8994aeee5e01080d$export$268e88275f5afab2);
$parcel$export($8994aeee5e01080d$exports, "HeaderNames", () => $8994aeee5e01080d$export$28d77f87efed1d88);
$parcel$export($8994aeee5e01080d$exports, "PersistentCacheKeys", () => $8994aeee5e01080d$export$81ab9ba9bd28255c);
$parcel$export($8994aeee5e01080d$exports, "AADAuthority", () => $8994aeee5e01080d$export$3fd50d6e6941567f);
$parcel$export($8994aeee5e01080d$exports, "ClaimsRequestKeys", () => $8994aeee5e01080d$export$c125cda26c71ef54);
$parcel$export($8994aeee5e01080d$exports, "PromptValue", () => $8994aeee5e01080d$export$49a06cbda5acaa5);
$parcel$export($8994aeee5e01080d$exports, "CodeChallengeMethodValues", () => $8994aeee5e01080d$export$a1fe36237c1cc863);
$parcel$export($8994aeee5e01080d$exports, "OAuthResponseType", () => $8994aeee5e01080d$export$5ef2b2ebd3da3e04);
$parcel$export($8994aeee5e01080d$exports, "ResponseMode", () => $8994aeee5e01080d$export$f990a5bae1260b8c);
$parcel$export($8994aeee5e01080d$exports, "GrantType", () => $8994aeee5e01080d$export$ce68f19b50b39c0b);
$parcel$export($8994aeee5e01080d$exports, "CACHE_ACCOUNT_TYPE_MSSTS", () => $8994aeee5e01080d$export$5a1fc3a8d23f6b21);
$parcel$export($8994aeee5e01080d$exports, "CACHE_ACCOUNT_TYPE_ADFS", () => $8994aeee5e01080d$export$8fb8b1752739f076);
$parcel$export($8994aeee5e01080d$exports, "CACHE_ACCOUNT_TYPE_MSAV1", () => $8994aeee5e01080d$export$9e5e568c23c195ce);
$parcel$export($8994aeee5e01080d$exports, "CACHE_ACCOUNT_TYPE_GENERIC", () => $8994aeee5e01080d$export$2825edabe103d5);
$parcel$export($8994aeee5e01080d$exports, "CACHE_KEY_SEPARATOR", () => $8994aeee5e01080d$export$9e9532f57bbb139e);
$parcel$export($8994aeee5e01080d$exports, "CLIENT_INFO_SEPARATOR", () => $8994aeee5e01080d$export$2e94b6c6dd44699e);
$parcel$export($8994aeee5e01080d$exports, "CredentialType", () => $8994aeee5e01080d$export$eca2dc7e6e608a68);
$parcel$export($8994aeee5e01080d$exports, "CacheType", () => $8994aeee5e01080d$export$ba193b555633db78);
$parcel$export($8994aeee5e01080d$exports, "APP_METADATA", () => $8994aeee5e01080d$export$7e1bea6dc1b6b32e);
$parcel$export($8994aeee5e01080d$exports, "CLIENT_INFO", () => $8994aeee5e01080d$export$476989d62bcb4c85);
$parcel$export($8994aeee5e01080d$exports, "THE_FAMILY_ID", () => $8994aeee5e01080d$export$978fe7ab5e74b539);
$parcel$export($8994aeee5e01080d$exports, "AUTHORITY_METADATA_CACHE_KEY", () => $8994aeee5e01080d$export$1137b2d06fad26eb);
$parcel$export($8994aeee5e01080d$exports, "AUTHORITY_METADATA_REFRESH_TIME_SECONDS", () => $8994aeee5e01080d$export$eea04158dccf5d70);
$parcel$export($8994aeee5e01080d$exports, "AuthorityMetadataSource", () => $8994aeee5e01080d$export$5d365d77acfcb55d);
$parcel$export($8994aeee5e01080d$exports, "SERVER_TELEM_SCHEMA_VERSION", () => $8994aeee5e01080d$export$ada8c967fb9297cd);
$parcel$export($8994aeee5e01080d$exports, "SERVER_TELEM_MAX_CUR_HEADER_BYTES", () => $8994aeee5e01080d$export$3ab7d699ccf481db);
$parcel$export($8994aeee5e01080d$exports, "SERVER_TELEM_MAX_LAST_HEADER_BYTES", () => $8994aeee5e01080d$export$166696a6bac48dc5);
$parcel$export($8994aeee5e01080d$exports, "SERVER_TELEM_MAX_CACHED_ERRORS", () => $8994aeee5e01080d$export$6fa374559f78ca9f);
$parcel$export($8994aeee5e01080d$exports, "SERVER_TELEM_CACHE_KEY", () => $8994aeee5e01080d$export$788940e4cd6c0eba);
$parcel$export($8994aeee5e01080d$exports, "SERVER_TELEM_CATEGORY_SEPARATOR", () => $8994aeee5e01080d$export$f51f7d493a85471e);
$parcel$export($8994aeee5e01080d$exports, "SERVER_TELEM_VALUE_SEPARATOR", () => $8994aeee5e01080d$export$b0781166f23da624);
$parcel$export($8994aeee5e01080d$exports, "SERVER_TELEM_OVERFLOW_TRUE", () => $8994aeee5e01080d$export$1ee554efbc503c65);
$parcel$export($8994aeee5e01080d$exports, "SERVER_TELEM_OVERFLOW_FALSE", () => $8994aeee5e01080d$export$aad3ca432a8e0485);
$parcel$export($8994aeee5e01080d$exports, "SERVER_TELEM_UNKNOWN_ERROR", () => $8994aeee5e01080d$export$b3ede2149169f35e);
$parcel$export($8994aeee5e01080d$exports, "AuthenticationScheme", () => $8994aeee5e01080d$export$901491a717da2ba5);
$parcel$export($8994aeee5e01080d$exports, "DEFAULT_THROTTLE_TIME_SECONDS", () => $8994aeee5e01080d$export$c79860cd1fb326bc);
$parcel$export($8994aeee5e01080d$exports, "DEFAULT_MAX_THROTTLE_TIME_SECONDS", () => $8994aeee5e01080d$export$ed50f84f656b8a71);
$parcel$export($8994aeee5e01080d$exports, "THROTTLING_PREFIX", () => $8994aeee5e01080d$export$2c4d2738c7e2e621);
$parcel$export($8994aeee5e01080d$exports, "X_MS_LIB_CAPABILITY_VALUE", () => $8994aeee5e01080d$export$796cc5ec53357060);
$parcel$export($8994aeee5e01080d$exports, "INVALID_GRANT_ERROR", () => $8994aeee5e01080d$export$885686d5cda1602e);
$parcel$export($8994aeee5e01080d$exports, "CLIENT_MISMATCH_ERROR", () => $8994aeee5e01080d$export$5c3e811110c23b4b);
$parcel$export($8994aeee5e01080d$exports, "PasswordGrantConstants", () => $8994aeee5e01080d$export$fa8b29062cab1da);
$parcel$export($8994aeee5e01080d$exports, "RegionDiscoverySources", () => $8994aeee5e01080d$export$3d4a3e11df589b40);
$parcel$export($8994aeee5e01080d$exports, "RegionDiscoveryOutcomes", () => $8994aeee5e01080d$export$92a685f9218422bd);
$parcel$export($8994aeee5e01080d$exports, "CacheOutcome", () => $8994aeee5e01080d$export$aa4af185ea049f6b);
$parcel$export($8994aeee5e01080d$exports, "JsonWebTokenTypes", () => $8994aeee5e01080d$export$fe5c42ed17efe603);
$parcel$export($8994aeee5e01080d$exports, "ONE_DAY_IN_MS", () => $8994aeee5e01080d$export$14c29d43b22a755f);
$parcel$export($8994aeee5e01080d$exports, "DEFAULT_TOKEN_RENEWAL_OFFSET_SEC", () => $8994aeee5e01080d$export$8d50f42618161d1a);
$parcel$export($8994aeee5e01080d$exports, "EncodingTypes", () => $8994aeee5e01080d$export$6592cb873eed5846);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $8994aeee5e01080d$export$45c909820884b9ec = "msal.js.common";
// default authority
const $8994aeee5e01080d$export$405127a8c597bdfe = "https://login.microsoftonline.com/common/";
const $8994aeee5e01080d$export$ff29228a41d88890 = "login.microsoftonline.com";
const $8994aeee5e01080d$export$cf84b28865aad146 = "common";
// ADFS String
const $8994aeee5e01080d$export$d67d0b9d84b9fa64 = "adfs";
const $8994aeee5e01080d$export$ed356007bd76ccea = "dstsv2";
// Default AAD Instance Discovery Endpoint
const $8994aeee5e01080d$export$e56648d3c1473424 = `${$8994aeee5e01080d$export$405127a8c597bdfe}discovery/instance?api-version=1.1&authorization_endpoint=`;
// CIAM URL
const $8994aeee5e01080d$export$ecbbba19d57055cd = ".ciamlogin.com";
const $8994aeee5e01080d$export$8a15b376f6b2940 = ".onmicrosoft.com";
// Resource delimiter - used for certain cache entries
const $8994aeee5e01080d$export$c49b7e87df554b81 = "|";
// Consumer UTID
const $8994aeee5e01080d$export$90fa201058ba044f = "9188040d-6c67-4c5b-b112-36a304b66dad";
// Default scopes
const $8994aeee5e01080d$export$74fa595b48c8c01e = "openid";
const $8994aeee5e01080d$export$76ff9ac69ea41312 = "profile";
const $8994aeee5e01080d$export$b281676656f67eb4 = "offline_access";
const $8994aeee5e01080d$export$a69a793fa9a71a6f = "email";
const $8994aeee5e01080d$export$69cccd63344f058d = "authorization_code";
const $8994aeee5e01080d$export$c12418ff35a420f6 = "S256";
const $8994aeee5e01080d$export$7558dcec6f2048d = "application/x-www-form-urlencoded;charset=utf-8";
const $8994aeee5e01080d$export$b18f0664a2d39502 = "authorization_pending";
const $8994aeee5e01080d$export$e8958a6508ec5b71 = "N/A";
const $8994aeee5e01080d$export$d5f291b4be36f605 = "Not Available";
const $8994aeee5e01080d$export$933cdf3ebd8cc149 = "/";
const $8994aeee5e01080d$export$5eeea8c9d02ceb62 = "http://169.254.169.254/metadata/instance/compute";
const $8994aeee5e01080d$export$69aaeb41e2826c48 = "2021-02-01";
const $8994aeee5e01080d$export$7c61cea10ff91469 = 2000;
const $8994aeee5e01080d$export$243dfbda037eb091 = "TryAutoDetect";
const $8994aeee5e01080d$export$b85ac6323a66047 = "login.microsoft.com";
const $8994aeee5e01080d$export$afcb83a97360adbc = [
    "login.microsoftonline.com",
    "login.windows.net",
    "login.microsoft.com",
    "sts.windows.net"
];
const $8994aeee5e01080d$export$20eec6ef8175441 = 240;
const $8994aeee5e01080d$export$1d8570e3a324589e = "invalid_instance";
const $8994aeee5e01080d$export$f7faf416d920fff3 = 200;
const $8994aeee5e01080d$export$bf64241e0c309627 = 200;
const $8994aeee5e01080d$export$bb61c9fb50e57838 = 299;
const $8994aeee5e01080d$export$a704168478db6ad0 = 302;
const $8994aeee5e01080d$export$365529322ade2a43 = 400;
const $8994aeee5e01080d$export$6f402514545f3f58 = 400;
const $8994aeee5e01080d$export$9a0aba463f6ac337 = 400;
const $8994aeee5e01080d$export$adbf103f5d371692 = 401;
const $8994aeee5e01080d$export$6226897062245741 = 404;
const $8994aeee5e01080d$export$304f7f334b3888b0 = 408;
const $8994aeee5e01080d$export$73cba17c10a00d41 = 410;
const $8994aeee5e01080d$export$bc275033437a2e03 = 429;
const $8994aeee5e01080d$export$80be1ba03533fcfc = 499;
const $8994aeee5e01080d$export$ec31e119ef282c60 = 500;
const $8994aeee5e01080d$export$310d0488bddd36e1 = 500;
const $8994aeee5e01080d$export$b18794ec8d78bd2f = 503;
const $8994aeee5e01080d$export$d53e5bd3ec9a0f2a = 504;
const $8994aeee5e01080d$export$cabebb7af2e4f2f0 = 599;
const $8994aeee5e01080d$export$910bb73d987bdc9 = 600;
const $8994aeee5e01080d$export$8343e6f32f5246de = {
    GET: "GET",
    POST: "POST"
};
const $8994aeee5e01080d$export$893b1b5b686d84ef = [
    $8994aeee5e01080d$export$74fa595b48c8c01e,
    $8994aeee5e01080d$export$76ff9ac69ea41312,
    $8994aeee5e01080d$export$b281676656f67eb4
];
const $8994aeee5e01080d$export$268e88275f5afab2 = [
    ...$8994aeee5e01080d$export$893b1b5b686d84ef,
    $8994aeee5e01080d$export$a69a793fa9a71a6f
];
/**
 * Request header names
 */ const $8994aeee5e01080d$export$28d77f87efed1d88 = {
    CONTENT_TYPE: "Content-Type",
    CONTENT_LENGTH: "Content-Length",
    RETRY_AFTER: "Retry-After",
    CCS_HEADER: "X-AnchorMailbox",
    WWWAuthenticate: "WWW-Authenticate",
    AuthenticationInfo: "Authentication-Info",
    X_MS_REQUEST_ID: "x-ms-request-id",
    X_MS_HTTP_VERSION: "x-ms-httpver"
};
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ const $8994aeee5e01080d$export$81ab9ba9bd28255c = {
    ACTIVE_ACCOUNT_FILTERS: "active-account-filters"
};
/**
 * String constants related to AAD Authority
 */ const $8994aeee5e01080d$export$3fd50d6e6941567f = {
    COMMON: "common",
    ORGANIZATIONS: "organizations",
    CONSUMERS: "consumers"
};
/**
 * Claims request keys
 */ const $8994aeee5e01080d$export$c125cda26c71ef54 = {
    ACCESS_TOKEN: "access_token",
    XMS_CC: "xms_cc",
    ID_TOKEN: "id_token",
    SIGNIN_STATE: "signin_state",
    LOGIN_HINT: "login_hint"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ const $8994aeee5e01080d$export$49a06cbda5acaa5 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * allowed values for codeVerifier
 */ const $8994aeee5e01080d$export$a1fe36237c1cc863 = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * Allowed values for response_type
 */ const $8994aeee5e01080d$export$5ef2b2ebd3da3e04 = {
    CODE: "code",
    IDTOKEN_TOKEN: "id_token token",
    IDTOKEN_TOKEN_REFRESHTOKEN: "id_token token refresh_token"
};
/**
 * allowed values for response_mode
 */ const $8994aeee5e01080d$export$f990a5bae1260b8c = {
    QUERY: "query",
    FRAGMENT: "fragment",
    FORM_POST: "form_post"
};
/**
 * allowed grant_type
 */ const $8994aeee5e01080d$export$ce68f19b50b39c0b = {
    IMPLICIT_GRANT: "implicit",
    AUTHORIZATION_CODE_GRANT: "authorization_code",
    CLIENT_CREDENTIALS_GRANT: "client_credentials",
    RESOURCE_OWNER_PASSWORD_GRANT: "password",
    REFRESH_TOKEN_GRANT: "refresh_token",
    DEVICE_CODE_GRANT: "device_code",
    JWT_BEARER: "urn:ietf:params:oauth:grant-type:jwt-bearer",
    USER_FIC: "user_fic"
};
/**
 * Account types in Cache
 */ const $8994aeee5e01080d$export$5a1fc3a8d23f6b21 = "MSSTS";
const $8994aeee5e01080d$export$8fb8b1752739f076 = "ADFS";
const $8994aeee5e01080d$export$9e5e568c23c195ce = "MSA";
const $8994aeee5e01080d$export$2825edabe103d5 = "Generic";
/**
 * Separators used in cache
 */ const $8994aeee5e01080d$export$9e9532f57bbb139e = "-";
const $8994aeee5e01080d$export$2e94b6c6dd44699e = ".";
/**
 * Credential Type stored in the cache
 */ const $8994aeee5e01080d$export$eca2dc7e6e608a68 = {
    ID_TOKEN: "IdToken",
    ACCESS_TOKEN: "AccessToken",
    ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
    REFRESH_TOKEN: "RefreshToken"
};
/**
 * Combine all cache types
 */ const $8994aeee5e01080d$export$ba193b555633db78 = {
    ADFS: 1001,
    MSA: 1002,
    MSSTS: 1003,
    GENERIC: 1004,
    ACCESS_TOKEN: 2001,
    REFRESH_TOKEN: 2002,
    ID_TOKEN: 2003,
    APP_METADATA: 3001,
    UNDEFINED: 9999
};
/**
 * More Cache related constants
 */ const $8994aeee5e01080d$export$7e1bea6dc1b6b32e = "appmetadata";
const $8994aeee5e01080d$export$476989d62bcb4c85 = "client_info";
const $8994aeee5e01080d$export$978fe7ab5e74b539 = "1";
const $8994aeee5e01080d$export$1137b2d06fad26eb = "authority-metadata";
const $8994aeee5e01080d$export$eea04158dccf5d70 = 86400; // 24 Hours
const $8994aeee5e01080d$export$5d365d77acfcb55d = {
    CONFIG: "config",
    CACHE: "cache",
    NETWORK: "network",
    HARDCODED_VALUES: "hardcoded_values"
};
const $8994aeee5e01080d$export$ada8c967fb9297cd = 5;
const $8994aeee5e01080d$export$3ab7d699ccf481db = 80; // ESTS limit is 100B, set to 80 to provide a 20B buffer
const $8994aeee5e01080d$export$166696a6bac48dc5 = 330; // ESTS limit is 350B, set to 330 to provide a 20B buffer,
const $8994aeee5e01080d$export$6fa374559f78ca9f = 50; // Limit the number of errors that can be stored to prevent uncontrolled size gains
const $8994aeee5e01080d$export$788940e4cd6c0eba = "server-telemetry";
const $8994aeee5e01080d$export$f51f7d493a85471e = "|";
const $8994aeee5e01080d$export$b0781166f23da624 = ",";
const $8994aeee5e01080d$export$1ee554efbc503c65 = "1";
const $8994aeee5e01080d$export$aad3ca432a8e0485 = "0";
const $8994aeee5e01080d$export$b3ede2149169f35e = "unknown_error";
/**
 * Type of the authentication request
 */ const $8994aeee5e01080d$export$901491a717da2ba5 = {
    BEARER: "Bearer",
    POP: "pop",
    SSH: "ssh-cert"
};
/**
 * Constants related to throttling
 */ const $8994aeee5e01080d$export$c79860cd1fb326bc = 60;
// Default maximum time to throttle in seconds, overrides what the server sends back
const $8994aeee5e01080d$export$ed50f84f656b8a71 = 3600;
// Prefix for storing throttling entries
const $8994aeee5e01080d$export$2c4d2738c7e2e621 = "throttling";
// Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
const $8994aeee5e01080d$export$796cc5ec53357060 = "retry-after, h429";
/**
 * Errors
 */ const $8994aeee5e01080d$export$885686d5cda1602e = "invalid_grant";
const $8994aeee5e01080d$export$5c3e811110c23b4b = "client_mismatch";
/**
 * Password grant parameters
 */ const $8994aeee5e01080d$export$fa8b29062cab1da = {
    username: "username",
    password: "password"
};
/**
 * Region Discovery Sources
 */ const $8994aeee5e01080d$export$3d4a3e11df589b40 = {
    FAILED_AUTO_DETECTION: "1",
    INTERNAL_CACHE: "2",
    ENVIRONMENT_VARIABLE: "3",
    IMDS: "4"
};
/**
 * Region Discovery Outcomes
 */ const $8994aeee5e01080d$export$92a685f9218422bd = {
    CONFIGURED_MATCHES_DETECTED: "1",
    CONFIGURED_NO_AUTO_DETECTION: "2",
    CONFIGURED_NOT_DETECTED: "3",
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
    AUTO_DETECTION_REQUESTED_FAILED: "5"
};
/**
 * Specifies the reason for fetching the access token from the identity provider
 */ const $8994aeee5e01080d$export$aa4af185ea049f6b = {
    // When a token is found in the cache or the cache is not supposed to be hit when making the request
    NOT_APPLICABLE: "0",
    // When the token request goes to the identity provider because force_refresh was set to true. Also occurs if claims were requested
    FORCE_REFRESH_OR_CLAIMS: "1",
    // When the token request goes to the identity provider because no cached access token exists
    NO_CACHED_ACCESS_TOKEN: "2",
    // When the token request goes to the identity provider because cached access token expired
    CACHED_ACCESS_TOKEN_EXPIRED: "3",
    // When the token request goes to the identity provider because refresh_in was used and the existing token needs to be refreshed
    PROACTIVELY_REFRESHED: "4"
};
const $8994aeee5e01080d$export$fe5c42ed17efe603 = {
    Jwt: "JWT",
    Jwk: "JWK",
    Pop: "pop"
};
const $8994aeee5e01080d$export$14c29d43b22a755f = 86400000;
// Token renewal offset default in seconds
const $8994aeee5e01080d$export$8d50f42618161d1a = 300;
const $8994aeee5e01080d$export$6592cb873eed5846 = {
    BASE64: "base64",
    HEX: "hex",
    UTF8: "utf-8"
};


/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $cad9f10ae11c6c7c$export$e2ac717a196f20ed = "missing_kid_error";
const $cad9f10ae11c6c7c$export$de67390d0a514010 = "missing_alg_error";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $11932bb33809c012$export$91748d132e6cb9b3 {
    constructor(options){
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object and returns
     * the stringified header object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @returns
     */ static getShrHeaderString(shrHeaderOptions) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw (0, $545bc4a68e40c43a$export$3ef463ea134172ed)((0, $cad9f10ae11c6c7c$export$e2ac717a196f20ed), "");
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw (0, $545bc4a68e40c43a$export$3ef463ea134172ed)((0, $cad9f10ae11c6c7c$export$de67390d0a514010), "");
        const shrHeader = new $11932bb33809c012$export$91748d132e6cb9b3({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || (0, $8994aeee5e01080d$export$fe5c42ed17efe603).Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        });
        return JSON.stringify(shrHeader);
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * acquireTokenFromCache (msal-browser).
 * Internal API for acquiring token from cache
 */ const $acc47f0f594e8d22$export$5ea798579d1036d1 = "acquireTokenFromCache";
/**
 * acquireTokenByRefreshToken API (msal-browser and msal-node).
 * Used to renew an access token using a refresh token against the token endpoint.
 */ const $acc47f0f594e8d22$export$76454c1307aa041e = "acquireTokenByRefreshToken";
/**
 * acquireTokenSilentAsync (msal-browser).
 * Internal API for acquireTokenSilent.
 */ const $acc47f0f594e8d22$export$234ca59652d54f20 = "acquireTokenSilentAsync";
/**
 * getPublicKeyThumbprint API in CryptoOpts class (msal-browser).
 * Used to generate a public/private keypair and generate a public key thumbprint for pop requests.
 */ const $acc47f0f594e8d22$export$ca484cac69c0554d = "cryptoOptsGetPublicKeyThumbprint";
/**
 * signJwt API in CryptoOpts class (msal-browser).
 * Used to signed a pop token.
 */ const $acc47f0f594e8d22$export$fbfd9e4c1c2461a4 = "cryptoOptsSignJwt";
/**
 * acquireToken API in the SilentCacheClient class (msal-browser).
 * Used to read access tokens from the cache.
 */ const $acc47f0f594e8d22$export$d17448fed671f254 = "silentCacheClientAcquireToken";
/**
 * acquireToken API in the SilentIframeClient class (msal-browser).
 * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
 */ const $acc47f0f594e8d22$export$cad3a91a6c9c24dc = "silentIframeClientAcquireToken";
const $acc47f0f594e8d22$export$4616f8f2f8e44472 = "awaitConcurrentIframe"; // Time spent waiting for a concurrent iframe to complete
/**
 * acquireToken API in SilentRereshClient (msal-browser).
 * Used to acquire a new set of tokens from the token endpoint using a refresh token.
 */ const $acc47f0f594e8d22$export$aa71423206472289 = "silentRefreshClientAcquireToken";
/**
 * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
 * Used to load authority metadata for a request.
 */ const $acc47f0f594e8d22$export$dad6c3127c773e76 = "standardInteractionClientGetDiscoveredAuthority";
/**
 * acquireToken API in NativeInteractionClient class (msal-browser).
 * Used to acquire a token from Native component when native brokering is enabled.
 */ const $acc47f0f594e8d22$export$6939ff7b9b362e6d = "nativeInteractionClientAcquireToken";
const $acc47f0f594e8d22$export$7b5471de971cecfc = "nativeInteractionClientAcquireToken";
/**
 * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
 */ const $acc47f0f594e8d22$export$f5534f1ba404e5a3 = "refreshTokenClientAcquireTokenByRefreshToken";
/**
 * acquireTokenBySilentIframe (msal-browser).
 * Internal API for acquiring token by silent Iframe
 */ const $acc47f0f594e8d22$export$1f97c40875a1f78c = "acquireTokenBySilentIframe";
/**
 * Internal API for initializing base request in BaseInteractionClient (msal-browser)
 */ const $acc47f0f594e8d22$export$e13dedc12c2c4f38 = "initializeBaseRequest";
/**
 * Internal API for initializing silent request in SilentCacheClient (msal-browser)
 */ const $acc47f0f594e8d22$export$c4741a5a0838f7c = "initializeSilentRequest";
const $acc47f0f594e8d22$export$c4d273a3eb6a2e87 = "initializeCache";
/**
 * Helper function in SilentIframeClient class (msal-browser).
 */ const $acc47f0f594e8d22$export$84c1ce19d7e23fb5 = "silentIframeClientTokenHelper";
/**
 * SilentHandler
 */ const $acc47f0f594e8d22$export$c9535608a7f36f5f = "silentHandlerInitiateAuthRequest";
const $acc47f0f594e8d22$export$a4bfaadf3c5aed38 = "silentHandlerMonitorIframeForHash";
/**
 * Helper functions in StandardInteractionClient class (msal-browser)
 */ const $acc47f0f594e8d22$export$2778b133ce149dc6 = "standardInteractionClientCreateAuthCodeClient";
const $acc47f0f594e8d22$export$8b2b453d4b5734d9 = "standardInteractionClientGetClientConfiguration";
const $acc47f0f594e8d22$export$ee6f0d99b40b747e = "standardInteractionClientInitializeAuthorizationRequest";
const $acc47f0f594e8d22$export$1760779da367f865 = "silentFlowClientAcquireCachedToken";
const $acc47f0f594e8d22$export$183789ea9e54834a = "getStandardParams";
const $acc47f0f594e8d22$export$4800d7aad979f214 = "handleCodeResponse";
const $acc47f0f594e8d22$export$680f3c7b33b3fdfd = "handleResponseEar";
const $acc47f0f594e8d22$export$4ba148c2708dd557 = "handleResponsePlatformBroker";
const $acc47f0f594e8d22$export$e5c1dfbe90037ee5 = "handleResponseCode";
const $acc47f0f594e8d22$export$ce1a395bb2077ffd = "authClientAcquireToken";
const $acc47f0f594e8d22$export$bd4551c9ff45ab85 = "deserializeResponse";
const $acc47f0f594e8d22$export$e7e182fcd29aaa7f = "authorityFactoryCreateDiscoveredInstance";
const $acc47f0f594e8d22$export$39ed3fafad4d8fb4 = "acquireTokenByCodeAsync";
const $acc47f0f594e8d22$export$67b57f4cae7558a0 = "handleRedirectPromise";
const $acc47f0f594e8d22$export$d3f7d57b3e4e2e35 = "handleNativeRedirectPromise";
const $acc47f0f594e8d22$export$12043b01baba5136 = "nativeMessageHandlerHandshake";
const $acc47f0f594e8d22$export$e84ca321454a8dc1 = "removeHiddenIframe";
const $acc47f0f594e8d22$export$8ad0cce1899a6e6b = "importExistingCache";
/**
 * Crypto Operations
 */ const $acc47f0f594e8d22$export$5a7b24ab3b501c09 = "generatePkceCodes";
const $acc47f0f594e8d22$export$924a2894e07f5df7 = "generateCodeVerifier";
const $acc47f0f594e8d22$export$eb0aa8a1e44ee69e = "generateCodeChallengeFromVerifier";
const $acc47f0f594e8d22$export$1000bc604c253d18 = "sha256Digest";
const $acc47f0f594e8d22$export$932b19829e8c5c9c = "getRandomValues";
const $acc47f0f594e8d22$export$f85f32203360ffb7 = "generateHKDF";
const $acc47f0f594e8d22$export$924f0b17a8155ca0 = "generateBaseKey";
const $acc47f0f594e8d22$export$fe555b2490ffa3fb = "base64Decode";
const $acc47f0f594e8d22$export$6486e7961fcba669 = "urlEncodeArr";
const $acc47f0f594e8d22$export$47fac120ab74ef02 = "encrypt";
const $acc47f0f594e8d22$export$753391c83cc4ba4d = "decrypt";
const $acc47f0f594e8d22$export$8f99489bc43f886e = "generateEarKey";
const $acc47f0f594e8d22$export$f57bcff988fe6ecb = "decryptEarResponse";
const $acc47f0f594e8d22$export$416229714bf50920 = "loadAccount";
const $acc47f0f594e8d22$export$b08d49c05f03b037 = "loadIdToken";
const $acc47f0f594e8d22$export$8a5d4e1e5f3a9a12 = "loadAccessToken";
const $acc47f0f594e8d22$export$4257376d62bdee2 = "loadRefreshToken";
/**
 * Background telemetry measurement that tracks whether a late bridge response
 * arrives after the iframe timeout has already fired.
 */ const $acc47f0f594e8d22$export$d9fd8b66da5a3a9a = "waitForBridgeLateResponse";


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ /**
 * Returns URL Safe b64 encoded string from a plaintext string.
 * @param input
 */ function $0349b3935d5ceef2$export$9ef804feabbcbaf1(input) {
    return encodeURIComponent($0349b3935d5ceef2$export$e510a73ee562749(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"));
}
/**
 * Returns URL Safe b64 encoded string from an int8Array.
 * @param inputArr
 */ function $0349b3935d5ceef2$export$84f5a428c7153a69(inputArr) {
    return $0349b3935d5ceef2$var$base64EncArr(inputArr).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * Returns b64 encoded string from plaintext string.
 * @param input
 */ function $0349b3935d5ceef2$export$e510a73ee562749(input) {
    return $0349b3935d5ceef2$var$base64EncArr(new TextEncoder().encode(input));
}
/**
 * Base64 encode byte array
 * @param aBytes
 */ function $0349b3935d5ceef2$var$base64EncArr(aBytes) {
    const binString = Array.from(aBytes, (x)=>String.fromCodePoint(x)).join("");
    return btoa(binString);
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ /*! @azure/msal-browser v5.16.0 2026-06-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e015633e658266f1$export$714f3eb4b9ca37c5(code) {
    return `See https://aka.ms/msal.js.errors#${code} for details`;
}
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $e015633e658266f1$export$f8eb6760ca13876a extends (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) {
    constructor(errorCode, correlationId, subError){
        super(errorCode, correlationId, $e015633e658266f1$export$714f3eb4b9ca37c5(errorCode), subError);
        Object.setPrototypeOf(this, $e015633e658266f1$export$f8eb6760ca13876a.prototype);
        this.name = "BrowserAuthError";
    }
}
function $e015633e658266f1$export$72f7b48f3bc1d4cb(errorCode, correlationId, subError) {
    return new $e015633e658266f1$export$f8eb6760ca13876a(errorCode, correlationId, subError);
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $8a281d620a4036a7$export$ee549107fa376fc1 = "pkce_not_created";
const $8a281d620a4036a7$export$2c031f99d3e081ff = "ear_jwk_empty";
const $8a281d620a4036a7$export$b9f7c47ac4054f3d = "ear_jwe_empty";
const $8a281d620a4036a7$export$6319761d10f0cc4c = "crypto_nonexistent";
const $8a281d620a4036a7$export$be9285c64f247822 = "empty_navigate_uri";
const $8a281d620a4036a7$export$a29c42a1dd414317 = "hash_empty_error";
const $8a281d620a4036a7$export$211c8e8843a8d278 = "no_state_in_hash";
const $8a281d620a4036a7$export$5743873a5ba5d124 = "hash_does_not_contain_known_properties";
const $8a281d620a4036a7$export$237bdd0b913cb30c = "unable_to_parse_state";
const $8a281d620a4036a7$export$499b1b95c97a1c75 = "state_interaction_type_mismatch";
const $8a281d620a4036a7$export$2700dc1c133d227e = "interaction_in_progress";
const $8a281d620a4036a7$export$87332f77d3f8befc = "interaction_in_progress_cancelled";
const $8a281d620a4036a7$export$f1b7091ee48d0b3e = "popup_window_error";
const $8a281d620a4036a7$export$5e827e513523a576 = "empty_window_error";
const $8a281d620a4036a7$export$6bae303c5e922702 = "user_cancelled";
const $8a281d620a4036a7$export$ef85f3d55419b6f4 = "redirect_bridge_empty_response";
const $8a281d620a4036a7$export$9cc12eb574ceee30 = "redirect_in_iframe";
const $8a281d620a4036a7$export$71bafc2814e56c09 = "block_iframe_reload";
const $8a281d620a4036a7$export$c4a80c97d7b48f72 = "block_nested_popups";
const $8a281d620a4036a7$export$6a76760db525f402 = "iframe_closed_prematurely";
const $8a281d620a4036a7$export$78523a40be105a03 = "silent_logout_unsupported";
const $8a281d620a4036a7$export$87933d7d4116cb12 = "no_account_error";
const $8a281d620a4036a7$export$24dae796d0958d3 = "silent_prompt_value_error";
const $8a281d620a4036a7$export$8b51939fb2aab3d7 = "no_token_request_cache_error";
const $8a281d620a4036a7$export$f3ae24cdfaab4488 = "unable_to_parse_token_request_cache_error";
const $8a281d620a4036a7$export$c47649cf6408c7b2 = "auth_request_not_set_error";
const $8a281d620a4036a7$export$ff7164a2aeeff392 = "invalid_cache_type";
const $8a281d620a4036a7$export$932e0f52d657f7fb = "non_browser_environment";
const $8a281d620a4036a7$export$4752ced1a1a262f = "database_not_open";
const $8a281d620a4036a7$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $8a281d620a4036a7$export$7a1e28a7b60ca602 = "post_request_failed";
const $8a281d620a4036a7$export$45e7eaaecd19d31e = "get_request_failed";
const $8a281d620a4036a7$export$96735047beea85a0 = "failed_to_parse_response";
const $8a281d620a4036a7$export$6acf650331eb5f5f = "unable_to_load_token";
const $8a281d620a4036a7$export$a416b0eceb5c15df = "crypto_key_not_found";
const $8a281d620a4036a7$export$e502d98cd8d2da43 = "auth_code_required";
const $8a281d620a4036a7$export$8bea68053103eaeb = "auth_code_or_nativeAccountId_required";
const $8a281d620a4036a7$export$1efb009e9d75bbe4 = "spa_code_and_nativeAccountId_present";
const $8a281d620a4036a7$export$c1110692d2978b8 = "database_unavailable";
const $8a281d620a4036a7$export$b897bbe2c683def2 = "unable_to_acquire_token_from_native_platform";
const $8a281d620a4036a7$export$4747c302ef0117fd = "native_handshake_timeout";
const $8a281d620a4036a7$export$59080ea2398ee306 = "native_extension_not_installed";
const $8a281d620a4036a7$export$7b7357e3538624aa = "native_connection_not_established";
const $8a281d620a4036a7$export$436657cdcd7fe2be = "uninitialized_public_client_application";
const $8a281d620a4036a7$export$62fdd8848aa75547 = "native_prompt_not_supported";
const $8a281d620a4036a7$export$fcc6790b5d12da63 = "invalid_base64_string";
const $8a281d620a4036a7$export$f6f43ae33ad04b91 = "invalid_pop_token_request";
const $8a281d620a4036a7$export$df9e6aae71bd84f = "failed_to_build_headers";
const $8a281d620a4036a7$export$487fe7232a90003c = "failed_to_parse_headers";
const $8a281d620a4036a7$export$6e3539c6f28cd91f = "failed_to_decrypt_ear_response";
const $8a281d620a4036a7$export$ce7eeda4eb1dd3c6 = "timed_out";
const $8a281d620a4036a7$export$b07b0d8dc0894ecf = "empty_response";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ /**
 * Returns a URL-safe plaintext decoded string from b64 encoded input.
 * @param input
 */ function $5949979cf1605326$export$c62426fdd000a97e(input) {
    return new TextDecoder().decode($5949979cf1605326$export$8f0c237d3e8188bc(input));
}
/**
 * Decodes base64 into Uint8Array
 * @param base64String
 */ function $5949979cf1605326$export$8f0c237d3e8188bc(base64String) {
    let encodedString = base64String.replace(/-/g, "+").replace(/_/g, "/");
    switch(encodedString.length % 4){
        case 0:
            break;
        case 2:
            encodedString += "==";
            break;
        case 3:
            encodedString += "=";
            break;
        default:
            throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$fcc6790b5d12da63), "");
    }
    const binString = atob(encodedString);
    return Uint8Array.from(binString, (m)=>m.codePointAt(0) || 0);
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ const $7101cc4ee26a17a4$export$a0a689e4294b9880 = {
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
const $7101cc4ee26a17a4$export$3ebdf53424883b5f = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS",
    MICROSOFT_ENTRA_BROKERID: "MicrosoftEntra",
    DOM_API_NAME: "DOM API",
    PLATFORM_DOM_APIS: "get-token-and-sign-out",
    PLATFORM_DOM_PROVIDER: "PlatformAuthDOMHandler",
    PLATFORM_EXTENSION_PROVIDER: "PlatformAuthExtensionHandler"
};
const $7101cc4ee26a17a4$export$3536098be6c7dadb = {
    HandshakeRequest: "Handshake",
    HandshakeResponse: "HandshakeResponse",
    GetToken: "GetToken",
    Response: "Response"
};
const $7101cc4ee26a17a4$export$573384e47a12d835 = {
    LocalStorage: "localStorage",
    SessionStorage: "sessionStorage",
    MemoryStorage: "memoryStorage"
};
/**
 * HTTP Request types supported by MSAL.
 */ const $7101cc4ee26a17a4$export$c774c31b4c31da8 = {
    GET: "GET",
    POST: "POST"
};
const $7101cc4ee26a17a4$export$dc1d3aa5f3837765 = {
    SIGNIN: "signin",
    SIGNOUT: "signout"
};
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ const $7101cc4ee26a17a4$export$21d55bedf0d269fb = {
    ORIGIN_URI: "request.origin",
    URL_HASH: "urlHash",
    REQUEST_PARAMS: "request.params",
    VERIFIER: "code.verifier",
    INTERACTION_STATUS_KEY: "interaction.status",
    NATIVE_REQUEST: "request.native"
};
/**
 * Cache keys stored in-memory
 */ const $7101cc4ee26a17a4$export$8f546f90896bcfa9 = {
    WRAPPER_SKU: "wrapper.sku",
    WRAPPER_VER: "wrapper.version"
};
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 * 900-999 Misc
 */ const $7101cc4ee26a17a4$export$192d74ad69b40705 = {
    acquireTokenRedirect: 861,
    acquireTokenPopup: 862,
    ssoSilent: 863,
    acquireTokenSilent_authCode: 864,
    handleRedirectPromise: 865,
    acquireTokenByCode: 866,
    acquireTokenSilent_silentFlow: 61,
    logout: 961,
    logoutPopup: 962,
    hydrateCache: 963,
    loadExternalTokens: 964
};
/**
 * API Names for Telemetry purposes.
 */ const $7101cc4ee26a17a4$export$7ee4637d1247e747 = {
    861: "acquireTokenRedirect",
    862: "acquireTokenPopup",
    863: "ssoSilent",
    864: "acquireTokenSilent_authCode",
    865: "handleRedirectPromise",
    866: "acquireTokenByCode",
    61: "acquireTokenSilent_silentFlow",
    961: "logout",
    962: "logoutPopup",
    963: "hydrateCache",
    964: "loadExternalTokens"
};
const $7101cc4ee26a17a4$export$970e8382081b483f = (id)=>{
    if (typeof id === "number" && id in $7101cc4ee26a17a4$export$7ee4637d1247e747) return $7101cc4ee26a17a4$export$7ee4637d1247e747[id];
    return "unknown";
};
/*
 * Interaction type of the API - used for state and telemetry
 */ var $7101cc4ee26a17a4$export$4ec29255e7e7f68f;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})($7101cc4ee26a17a4$export$4ec29255e7e7f68f || ($7101cc4ee26a17a4$export$4ec29255e7e7f68f = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ const $7101cc4ee26a17a4$export$bec20eda0179362b = {
    /**
     * Initial status before interaction occurs
     */ Startup: "startup",
    /**
     * Status set when logout call occuring
     */ Logout: "logout",
    /**
     * Status set for acquireToken calls
     */ AcquireToken: "acquireToken",
    /**
     * Status set when handleRedirect in progress
     */ HandleRedirect: "handleRedirect",
    /**
     * Status set when interaction is complete
     */ None: "none"
};
const $7101cc4ee26a17a4$export$7e12949cd6884193 = {
    scopes: (0, $8994aeee5e01080d$exports).OIDC_DEFAULT_SCOPES
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ const $7101cc4ee26a17a4$export$1294c3e3f84694cd = "jwk";
// Supported wrapper SKUs
const $7101cc4ee26a17a4$export$8abb9de997bb4e44 = {
    React: "@azure/msal-react",
    Angular: "@azure/msal-angular"
};
// DatabaseStorage Constants
const $7101cc4ee26a17a4$export$3c22ff8b64b8f565 = "msal.db";
const $7101cc4ee26a17a4$export$6a9022b4c5fcea02 = 1;
const $7101cc4ee26a17a4$export$9d785db034fb436f = `${$7101cc4ee26a17a4$export$3c22ff8b64b8f565}.keys`;
const $7101cc4ee26a17a4$export$4394baa7e922d42d = {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ Default: 0,
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ AccessToken: 1,
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ AccessTokenAndRefreshToken: 2,
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ RefreshToken: 3,
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ RefreshTokenAndNetwork: 4,
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ Skip: 5
};
const $7101cc4ee26a17a4$export$736180706fb122ee = [
    $7101cc4ee26a17a4$export$4394baa7e922d42d.Default,
    $7101cc4ee26a17a4$export$4394baa7e922d42d.Skip,
    $7101cc4ee26a17a4$export$4394baa7e922d42d.RefreshTokenAndNetwork
];





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This file defines functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // Algorithms
const $f0e13da7356d30ac$var$PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
const $f0e13da7356d30ac$var$AES_GCM = "AES-GCM";
const $f0e13da7356d30ac$var$HKDF = "HKDF";
// SHA-256 hashing algorithm
const $f0e13da7356d30ac$var$S256_HASH_ALG = "SHA-256";
// MOD length for PoP tokens
const $f0e13da7356d30ac$var$MODULUS_LENGTH = 2048;
// Public Exponent
const $f0e13da7356d30ac$var$PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
// UUID hex digits
const $f0e13da7356d30ac$var$UUID_CHARS = "0123456789abcdef";
// Array to store UINT32 random value
const $f0e13da7356d30ac$var$UINT32_ARR = new Uint32Array(1);
// Key Format
const $f0e13da7356d30ac$var$RAW = "raw";
// Key Usages
const $f0e13da7356d30ac$var$ENCRYPT = "encrypt";
const $f0e13da7356d30ac$var$DECRYPT = "decrypt";
const $f0e13da7356d30ac$var$DERIVE_KEY = "deriveKey";
// Suberror
const $f0e13da7356d30ac$var$SUBTLE_SUBERROR = "crypto_subtle_undefined";
const $f0e13da7356d30ac$var$keygenAlgorithmOptions = {
    name: $f0e13da7356d30ac$var$PKCS1_V15_KEYGEN_ALG,
    hash: $f0e13da7356d30ac$var$S256_HASH_ALG,
    modulusLength: $f0e13da7356d30ac$var$MODULUS_LENGTH,
    publicExponent: $f0e13da7356d30ac$var$PUBLIC_EXPONENT
};
/**
 * Check whether browser crypto is available.
 */ function $f0e13da7356d30ac$export$1ddcc6bab2bf2314(skipValidateSubtleCrypto) {
    if (!window) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$932e0f52d657f7fb), "");
    if (!window.crypto) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$6319761d10f0cc4c), "");
    if (!skipValidateSubtleCrypto && !window.crypto.subtle) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$6319761d10f0cc4c), "", $f0e13da7356d30ac$var$SUBTLE_SUBERROR);
}
/**
 * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
 * @param dataString {string} data string
 * @param performanceClient {?IPerformanceClient}
 * @param correlationId {?string} correlation id
 */ async function $f0e13da7356d30ac$export$52caff7bddbaf316(dataString) {
    const encoder = new TextEncoder();
    const data = encoder.encode(dataString);
    return window.crypto.subtle.digest($f0e13da7356d30ac$var$S256_HASH_ALG, data);
}
/**
 * Populates buffer with cryptographically random values.
 * @param dataBuffer
 */ function $f0e13da7356d30ac$export$960b9ff25e7d4257(dataBuffer) {
    return window.crypto.getRandomValues(dataBuffer);
}
/**
 * Returns random Uint32 value.
 * @returns {number}
 */ function $f0e13da7356d30ac$var$getRandomUint32() {
    window.crypto.getRandomValues($f0e13da7356d30ac$var$UINT32_ARR);
    return $f0e13da7356d30ac$var$UINT32_ARR[0];
}
/**
 * Creates a UUID v7 from the current timestamp.
 * Implementation relies on the system clock to guarantee increasing order of generated identifiers.
 * @returns {number}
 */ function $f0e13da7356d30ac$export$6ef0355fa80a5278() {
    const currentTimestamp = Date.now();
    const baseRand = $f0e13da7356d30ac$var$getRandomUint32() * 0x400 + ($f0e13da7356d30ac$var$getRandomUint32() & 0x3ff);
    // Result byte array
    const bytes = new Uint8Array(16);
    // A 12-bit `rand_a` field value
    const randA = Math.trunc(baseRand / 2 ** 30);
    // The higher 30 bits of 62-bit `rand_b` field value
    const randBHi = baseRand & 2 ** 30 - 1;
    // The lower 32 bits of 62-bit `rand_b` field value
    const randBLo = $f0e13da7356d30ac$var$getRandomUint32();
    bytes[0] = currentTimestamp / 2 ** 40;
    bytes[1] = currentTimestamp / 2 ** 32;
    bytes[2] = currentTimestamp / 2 ** 24;
    bytes[3] = currentTimestamp / 2 ** 16;
    bytes[4] = currentTimestamp / 256;
    bytes[5] = currentTimestamp;
    bytes[6] = 0x70 | randA >>> 8;
    bytes[7] = randA;
    bytes[8] = 0x80 | randBHi >>> 24;
    bytes[9] = randBHi >>> 16;
    bytes[10] = randBHi >>> 8;
    bytes[11] = randBHi;
    bytes[12] = randBLo >>> 24;
    bytes[13] = randBLo >>> 16;
    bytes[14] = randBLo >>> 8;
    bytes[15] = randBLo;
    let text = "";
    for(let i = 0; i < bytes.length; i++){
        text += $f0e13da7356d30ac$var$UUID_CHARS.charAt(bytes[i] >>> 4);
        text += $f0e13da7356d30ac$var$UUID_CHARS.charAt(bytes[i] & 0xf);
        if (i === 3 || i === 5 || i === 7 || i === 9) text += "-";
    }
    return text;
}
/**
 * Generates a keypair based on current keygen algorithm config.
 * @param extractable
 * @param usages
 */ async function $f0e13da7356d30ac$export$a949d36eab55b41f(extractable, usages) {
    return window.crypto.subtle.generateKey($f0e13da7356d30ac$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Export key as Json Web Key (JWK)
 * @param key
 */ async function $f0e13da7356d30ac$export$88781b8595a7d2ff(key) {
    return window.crypto.subtle.exportKey((0, $7101cc4ee26a17a4$export$1294c3e3f84694cd), key);
}
/**
 * Imports key as Json Web Key (JWK), can set extractable and usages.
 * @param key
 * @param extractable
 * @param usages
 */ async function $f0e13da7356d30ac$export$8bdea4e2e3f593c9(key, extractable, usages) {
    return window.crypto.subtle.importKey((0, $7101cc4ee26a17a4$export$1294c3e3f84694cd), key, $f0e13da7356d30ac$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Signs given data with given key
 * @param key
 * @param data
 */ async function $f0e13da7356d30ac$export$c5552dfdbc7cec71(key, data) {
    return window.crypto.subtle.sign($f0e13da7356d30ac$var$keygenAlgorithmOptions, key, data);
}
/**
 * Generates Base64 encoded jwk used in the Encrypted Authorize Response (EAR) flow
 */ async function $f0e13da7356d30ac$export$95528b8a314880d1() {
    const key = await $f0e13da7356d30ac$export$1222fa1cada87c76();
    const keyStr = (0, $0349b3935d5ceef2$export$84f5a428c7153a69)(new Uint8Array(key));
    const jwk = {
        alg: "dir",
        kty: "oct",
        k: keyStr
    };
    return (0, $0349b3935d5ceef2$export$e510a73ee562749)(JSON.stringify(jwk));
}
/**
 * Parses earJwk for encryption key and returns CryptoKey object
 * @param earJwk
 * @returns
 */ async function $f0e13da7356d30ac$export$cf6da4e13ceceed(earJwk) {
    const b64DecodedJwk = (0, $5949979cf1605326$export$c62426fdd000a97e)(earJwk);
    const jwkJson = JSON.parse(b64DecodedJwk);
    const rawKey = jwkJson.k;
    const keyBuffer = (0, $5949979cf1605326$export$8f0c237d3e8188bc)(rawKey);
    return window.crypto.subtle.importKey($f0e13da7356d30ac$var$RAW, keyBuffer, $f0e13da7356d30ac$var$AES_GCM, false, [
        $f0e13da7356d30ac$var$DECRYPT
    ]);
}
/**
 * Decrypt ear_jwe response returned in the Encrypted Authorize Response (EAR) flow
 * @param earJwk
 * @param earJwe
 * @returns
 */ async function $f0e13da7356d30ac$export$13b9c776ab498ef3(earJwk, earJwe) {
    const earJweParts = earJwe.split(".");
    if (earJweParts.length !== 5) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$6e3539c6f28cd91f), "", "jwe_length");
    const key = await $f0e13da7356d30ac$export$cf6da4e13ceceed(earJwk).catch(()=>{
        throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$6e3539c6f28cd91f), "", "import_key");
    });
    try {
        const header = new TextEncoder().encode(earJweParts[0]);
        const iv = (0, $5949979cf1605326$export$8f0c237d3e8188bc)(earJweParts[2]);
        const ciphertext = (0, $5949979cf1605326$export$8f0c237d3e8188bc)(earJweParts[3]);
        const tag = (0, $5949979cf1605326$export$8f0c237d3e8188bc)(earJweParts[4]);
        const tagLengthBits = tag.byteLength * 8;
        // Concat ciphertext and tag
        const encryptedData = new Uint8Array(ciphertext.length + tag.length);
        encryptedData.set(ciphertext);
        encryptedData.set(tag, ciphertext.length);
        const decryptedData = await window.crypto.subtle.decrypt({
            name: $f0e13da7356d30ac$var$AES_GCM,
            iv: iv,
            tagLength: tagLengthBits,
            additionalData: header
        }, key, encryptedData);
        return new TextDecoder().decode(decryptedData);
    } catch (e) {
        throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$6e3539c6f28cd91f), "", "decrypt");
    }
}
/**
 * Generates symmetric base encryption key. This may be stored as all encryption/decryption keys will be derived from this one.
 */ async function $f0e13da7356d30ac$export$1222fa1cada87c76() {
    const key = await window.crypto.subtle.generateKey({
        name: $f0e13da7356d30ac$var$AES_GCM,
        length: 256
    }, true, [
        $f0e13da7356d30ac$var$ENCRYPT,
        $f0e13da7356d30ac$var$DECRYPT
    ]);
    return window.crypto.subtle.exportKey($f0e13da7356d30ac$var$RAW, key);
}
/**
 * Returns the raw key to be passed into the key derivation function
 * @param baseKey
 * @returns
 */ async function $f0e13da7356d30ac$export$5a71d4e3178f19c4(baseKey) {
    return window.crypto.subtle.importKey($f0e13da7356d30ac$var$RAW, baseKey, $f0e13da7356d30ac$var$HKDF, false, [
        $f0e13da7356d30ac$var$DERIVE_KEY
    ]);
}
/**
 * Given a base key and a nonce generates a derived key to be used in encryption and decryption.
 * Note: every time we encrypt a new key is derived
 * @param baseKey
 * @param nonce
 * @returns
 */ async function $f0e13da7356d30ac$var$deriveKey(baseKey, nonce, context) {
    return window.crypto.subtle.deriveKey({
        name: $f0e13da7356d30ac$var$HKDF,
        salt: nonce,
        hash: $f0e13da7356d30ac$var$S256_HASH_ALG,
        info: new TextEncoder().encode(context)
    }, baseKey, {
        name: $f0e13da7356d30ac$var$AES_GCM,
        length: 256
    }, false, [
        $f0e13da7356d30ac$var$ENCRYPT,
        $f0e13da7356d30ac$var$DECRYPT
    ]);
}
/**
 * Encrypt the given data given a base key. Returns encrypted data and a nonce that must be provided during decryption
 * @param key
 * @param rawData
 */ async function $f0e13da7356d30ac$export$5b0f6292f11d1d18(baseKey, rawData, context) {
    const encodedData = new TextEncoder().encode(rawData);
    // The nonce must never be reused with a given key.
    const nonce = window.crypto.getRandomValues(new Uint8Array(16));
    const derivedKey = await $f0e13da7356d30ac$var$deriveKey(baseKey, nonce, context);
    const encryptedData = await window.crypto.subtle.encrypt({
        name: $f0e13da7356d30ac$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return {
        data: (0, $0349b3935d5ceef2$export$84f5a428c7153a69)(new Uint8Array(encryptedData)),
        nonce: (0, $0349b3935d5ceef2$export$84f5a428c7153a69)(nonce)
    };
}
/**
 * Decrypt data with the given key and nonce
 * @param key
 * @param nonce
 * @param encryptedData
 * @returns
 */ async function $f0e13da7356d30ac$export$e85a0c9a1067c5d3(baseKey, nonce, context, encryptedData) {
    const encodedData = (0, $5949979cf1605326$export$8f0c237d3e8188bc)(encryptedData);
    const derivedKey = await $f0e13da7356d30ac$var$deriveKey(baseKey, (0, $5949979cf1605326$export$8f0c237d3e8188bc)(nonce), context);
    const decryptedData = await window.crypto.subtle.decrypt({
        name: $f0e13da7356d30ac$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return new TextDecoder().decode(decryptedData);
}
/**
 * Returns the SHA-256 hash of an input string
 * @param plainText
 */ async function $f0e13da7356d30ac$export$9169be2e06c9c165(plainText) {
    const hashBuffer = await $f0e13da7356d30ac$export$52caff7bddbaf316(plainText);
    const hashBytes = new Uint8Array(hashBuffer);
    return (0, $0349b3935d5ceef2$export$84f5a428c7153a69)(hashBytes);
}



/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
/*! @azure/msal-browser v5.16.0 2026-06-30 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ class $ebfdb855ee1884d9$export$286b0f3b569e5f16 {
    constructor(){
        this.dbName = (0, $7101cc4ee26a17a4$export$3c22ff8b64b8f565);
        this.version = (0, $7101cc4ee26a17a4$export$6a9022b4c5fcea02);
        this.tableName = (0, $7101cc4ee26a17a4$export$9d785db034fb436f);
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ async open() {
        return new Promise((resolve, reject)=>{
            const openDB = window.indexedDB.open(this.dbName, this.version);
            openDB.addEventListener("upgradeneeded", (e)=>{
                const event = e;
                event.target.result.createObjectStore(this.tableName);
            });
            openDB.addEventListener("success", (e)=>{
                const event = e;
                this.db = event.target.result;
                this.dbOpen = true;
                resolve();
            });
            openDB.addEventListener("error", ()=>reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$c1110692d2978b8), "")));
        });
    }
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ closeConnection() {
        const db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    }
    /**
     * Opens database if it's not already open
     */ async validateDbIsOpen() {
        if (!this.dbOpen) return this.open();
    }
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ async getItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$4752ced1a1a262f), ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGet = objectStore.get(key);
            dbGet.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGet.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ async setItem(key, payload) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$4752ced1a1a262f), ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbPut = objectStore.put(payload, key);
            dbPut.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbPut.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ async removeItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$4752ced1a1a262f), ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbDelete = objectStore.delete(key);
            dbDelete.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbDelete.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ async getKeys() {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$4752ced1a1a262f), ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGetKeys = objectStore.getAllKeys();
            dbGetKeys.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGetKeys.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ async containsKey(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$4752ced1a1a262f), ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbContainsKey = objectStore.count(key);
            dbContainsKey.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result === 1);
            });
            dbContainsKey.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ async deleteDatabase() {
        // Check if database being deleted exists
        if (this.db && this.dbOpen) this.closeConnection();
        return new Promise((resolve, reject)=>{
            const deleteDbRequest = window.indexedDB.deleteDatabase((0, $7101cc4ee26a17a4$export$3c22ff8b64b8f565));
            const id = setTimeout(()=>reject(false), 200); // Reject if events aren't raised within 200ms
            deleteDbRequest.addEventListener("success", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("blocked", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("error", ()=>{
                clearTimeout(id);
                return reject(false);
            });
        });
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $14f17b15811f4641$export$d7392285c701ecf5 {
    constructor(){
        this.cache = new Map();
    }
    async initialize() {
    // Memory storage does not require initialization
    }
    getItem(key) {
        return this.cache.get(key) || null;
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        this.cache.set(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        this.cache.delete(key);
    }
    getKeys() {
        const cacheKeys = [];
        this.cache.forEach((value, key)=>{
            cacheKeys.push(key);
        });
        return cacheKeys;
    }
    containsKey(key) {
        return this.cache.has(key);
    }
    clear() {
        this.cache.clear();
    }
    decryptData() {
        // Memory storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ class $13a500180d3e0c33$export$b38f35aab37afcde {
    constructor(logger){
        this.inMemoryCache = new (0, $14f17b15811f4641$export$d7392285c701ecf5)();
        this.indexedDBCache = new (0, $ebfdb855ee1884d9$export$286b0f3b569e5f16)();
        this.logger = logger;
    }
    handleDatabaseAccessError(error, correlationId) {
        if (error instanceof (0, $e015633e658266f1$export$f8eb6760ca13876a) && error.errorCode === (0, $8a281d620a4036a7$export$c1110692d2978b8)) this.logger.error("1wx7zz", correlationId);
        else throw error;
    }
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     * @param correlationId
     */ async getItem(key, correlationId) {
        const item = this.inMemoryCache.getItem(key);
        if (!item) try {
            this.logger.verbose("0naxpl", correlationId);
            return await this.indexedDBCache.getItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
        return item;
    }
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     * @param correlationId
     */ async setItem(key, value, correlationId) {
        this.inMemoryCache.setItem(key, value);
        try {
            await this.indexedDBCache.setItem(key, value);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
    }
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     * @param correlationId
     */ async removeItem(key, correlationId) {
        this.inMemoryCache.removeItem(key);
        try {
            await this.indexedDBCache.removeItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
    }
    /**
     * Get all the keys from the in-memory cache as an iterable array of strings. If no keys are found, query the keys in the
     * asynchronous storage object.
     * @param correlationId
     */ async getKeys(correlationId) {
        const cacheKeys = this.inMemoryCache.getKeys();
        if (cacheKeys.length === 0) try {
            this.logger.verbose("1iqrbq", correlationId);
            return await this.indexedDBCache.getKeys();
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
        return cacheKeys;
    }
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     * @param correlationId
     */ async containsKey(key, correlationId) {
        const containsKey = this.inMemoryCache.containsKey(key);
        if (!containsKey) try {
            this.logger.verbose("03zl2j", correlationId);
            return await this.indexedDBCache.containsKey(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
        return containsKey;
    }
    /**
     * Clears in-memory Map
     * @param correlationId
     */ clearInMemory(correlationId) {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose("03r21p", correlationId);
        this.inMemoryCache.clear();
        this.logger.verbose("0uksk1", correlationId);
    }
    /**
     * Tries to delete the IndexedDB database
     * @param correlationId
     * @returns
     */ async clearPersistent(correlationId) {
        try {
            this.logger.verbose("0rdqut", correlationId);
            const dbDeleted = await this.indexedDBCache.deleteDatabase();
            if (dbDeleted) this.logger.verbose("149ouc", correlationId);
            return dbDeleted;
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
            return false;
        }
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ class $6b1f88068f54d1dd$export$c274a7f0ebd24b14 {
    constructor(logger, performanceClient, skipValidateSubtleCrypto){
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        (0, $f0e13da7356d30ac$export$1ddcc6bab2bf2314)(skipValidateSubtleCrypto ?? false);
        this.cache = new (0, $13a500180d3e0c33$export$b38f35aab37afcde)(this.logger);
        this.performanceClient = performanceClient;
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ createNewGuid() {
        return (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)();
    }
    /**
     * Encodes input string to base64.
     * @param input
     */ base64Encode(input) {
        return (0, $0349b3935d5ceef2$export$e510a73ee562749)(input);
    }
    /**
     * Decodes input string from base64.
     * @param input
     */ base64Decode(input) {
        return (0, $5949979cf1605326$export$c62426fdd000a97e)(input);
    }
    /**
     * Encodes input string to base64 URL safe string.
     * @param input
     */ base64UrlEncode(input) {
        return (0, $0349b3935d5ceef2$export$9ef804feabbcbaf1)(input);
    }
    /**
     * Stringifies and base64Url encodes input public key
     * @param inputKid
     * @returns Base64Url encoded public key
     */ encodeKid(inputKid) {
        return this.base64UrlEncode(JSON.stringify({
            kid: inputKid
        }));
    }
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */ async getPublicKeyThumbprint(request) {
        const publicKeyThumbMeasurement = this.performanceClient?.startMeasurement((0, $acc47f0f594e8d22$export$ca484cac69c0554d), request.correlationId);
        // Generate Keypair
        const keyPair = await (0, $f0e13da7356d30ac$export$a949d36eab55b41f)($6b1f88068f54d1dd$export$c274a7f0ebd24b14.EXTRACTABLE, $6b1f88068f54d1dd$export$c274a7f0ebd24b14.POP_KEY_USAGES);
        // Generate Thumbprint for Public Key
        const publicKeyJwk = await (0, $f0e13da7356d30ac$export$88781b8595a7d2ff)(keyPair.publicKey);
        const pubKeyThumprintObj = {
            e: publicKeyJwk.e,
            kty: publicKeyJwk.kty,
            n: publicKeyJwk.n
        };
        const publicJwkString = $6b1f88068f54d1dd$var$getSortedObjectString(pubKeyThumprintObj);
        const publicJwkHash = await this.hashString(publicJwkString);
        // Generate Thumbprint for Private Key
        const privateKeyJwk = await (0, $f0e13da7356d30ac$export$88781b8595a7d2ff)(keyPair.privateKey);
        // Re-import private key to make it unextractable
        const unextractablePrivateKey = await (0, $f0e13da7356d30ac$export$8bdea4e2e3f593c9)(privateKeyJwk, false, [
            "sign"
        ]);
        // Store Keypair data in keystore
        await this.cache.setItem(publicJwkHash, {
            privateKey: unextractablePrivateKey,
            publicKey: keyPair.publicKey,
            requestMethod: request.resourceRequestMethod,
            requestUri: request.resourceRequestUri
        }, request.correlationId);
        if (publicKeyThumbMeasurement) publicKeyThumbMeasurement.end({
            success: true
        });
        return publicJwkHash;
    }
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     * @param correlationId
     */ async removeTokenBindingKey(kid, correlationId) {
        await this.cache.removeItem(kid, correlationId);
        const keyFound = await this.cache.containsKey(kid, correlationId);
        if (keyFound) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).bindingKeyNotRemoved, correlationId);
    }
    /**
     * Removes all cryptographic keys from IndexedDB storage
     * @param correlationId
     */ async clearKeystore(correlationId) {
        // Delete in-memory keystores
        this.cache.clearInMemory(correlationId);
        /**
         * There is only one database, so calling clearPersistent on asymmetric keystore takes care of
         * every persistent keystore
         */ try {
            await this.cache.clearPersistent(correlationId);
            return true;
        } catch (e) {
            if (e instanceof Error) this.logger.error(`1owpn8 ${e.message}`, correlationId);
            else this.logger.error("0yrmwo", correlationId);
            return false;
        }
    }
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */ async signJwt(payload, kid, shrOptions, correlationId) {
        const signJwtMeasurement = this.performanceClient?.startMeasurement((0, $acc47f0f594e8d22$export$fbfd9e4c1c2461a4), correlationId);
        const cachedKeyPair = await this.cache.getItem(kid, correlationId || "");
        if (!cachedKeyPair) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$a416b0eceb5c15df), correlationId || "");
        // Get public key as JWK
        const publicKeyJwk = await (0, $f0e13da7356d30ac$export$88781b8595a7d2ff)(cachedKeyPair.publicKey);
        const publicKeyJwkString = $6b1f88068f54d1dd$var$getSortedObjectString(publicKeyJwk);
        // Base64URL encode public key thumbprint with keyId only: BASE64URL({ kid: "FULL_PUBLIC_KEY_HASH" })
        const encodedKeyIdThumbprint = (0, $0349b3935d5ceef2$export$9ef804feabbcbaf1)(JSON.stringify({
            kid: kid
        }));
        // Generate header
        const shrHeader = (0, $11932bb33809c012$export$91748d132e6cb9b3).getShrHeaderString({
            ...shrOptions?.header,
            alg: publicKeyJwk.alg,
            kid: encodedKeyIdThumbprint
        });
        const encodedShrHeader = (0, $0349b3935d5ceef2$export$9ef804feabbcbaf1)(shrHeader);
        // Generate payload
        payload.cnf = {
            jwk: JSON.parse(publicKeyJwkString)
        };
        const encodedPayload = (0, $0349b3935d5ceef2$export$9ef804feabbcbaf1)(JSON.stringify(payload));
        // Form token string
        const tokenString = `${encodedShrHeader}.${encodedPayload}`;
        // Sign token
        const encoder = new TextEncoder();
        const tokenBuffer = encoder.encode(tokenString);
        const signatureBuffer = await (0, $f0e13da7356d30ac$export$c5552dfdbc7cec71)(cachedKeyPair.privateKey, tokenBuffer);
        const encodedSignature = (0, $0349b3935d5ceef2$export$84f5a428c7153a69)(new Uint8Array(signatureBuffer));
        const signedJwt = `${tokenString}.${encodedSignature}`;
        if (signJwtMeasurement) signJwtMeasurement.end({
            success: true
        });
        return signedJwt;
    }
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ async hashString(plainText) {
        return (0, $f0e13da7356d30ac$export$9169be2e06c9c165)(plainText);
    }
}
$6b1f88068f54d1dd$export$c274a7f0ebd24b14.POP_KEY_USAGES = [
    "sign",
    "verify"
];
$6b1f88068f54d1dd$export$c274a7f0ebd24b14.EXTRACTABLE = true;
function $6b1f88068f54d1dd$var$getSortedObjectString(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}


var $f136bee61a3373e4$exports = {};

$parcel$export($f136bee61a3373e4$exports, "generateAccountId", () => $f136bee61a3373e4$export$27200f1de4935de2);
$parcel$export($f136bee61a3373e4$exports, "getAccountInfo", () => $f136bee61a3373e4$export$ec68416fe40418db);
$parcel$export($f136bee61a3373e4$exports, "isSingleTenant", () => $f136bee61a3373e4$export$e46c5db879535314);
$parcel$export($f136bee61a3373e4$exports, "createAccountEntity", () => $f136bee61a3373e4$export$104b1f92417fcaca);
$parcel$export($f136bee61a3373e4$exports, "createAccountEntityFromAccountInfo", () => $f136bee61a3373e4$export$258b94fce9daa9b0);
$parcel$export($f136bee61a3373e4$exports, "generateHomeAccountId", () => $f136bee61a3373e4$export$655e905bf6b8ee85);
$parcel$export($f136bee61a3373e4$exports, "isAccountEntity", () => $f136bee61a3373e4$export$644bdd16756dfb6b);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 
/*! @azure/msal-common v16.11.0 2026-06-30 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function $9c0d10744a3bd38b$export$575e1419cfbab7f8(rawClientInfo, base64Decode) {
    if (!rawClientInfo) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$12315251e24e0181), "");
    try {
        const decodedClientInfo = base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$ccdf48c387c47b82), "");
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function $9c0d10744a3bd38b$export$63508a6d6b7dbe07(homeAccountId) {
    if (!homeAccountId) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$ccdf48c387c47b82), "");
    const clientInfoParts = homeAccountId.split((0, $8994aeee5e01080d$export$2e94b6c6dd44699e), 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? "" : clientInfoParts[1]
    };
}


/*! @azure/msal-common v16.11.0 2026-06-30 */ var $4acd0486289e3b4f$exports = {};

$parcel$export($4acd0486289e3b4f$exports, "extractTokenClaims", () => $4acd0486289e3b4f$export$8a59e6f35fb00518);
$parcel$export($4acd0486289e3b4f$exports, "getJWSPayload", () => $4acd0486289e3b4f$export$b9f318d6daf53c97);
$parcel$export($4acd0486289e3b4f$exports, "isKmsi", () => $4acd0486289e3b4f$export$9475d607926d7a45);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extract token by decoding the rawToken
 *
 * @param encodedToken
 */ function $4acd0486289e3b4f$export$8a59e6f35fb00518(encodedToken, base64Decode, correlationId) {
    const jswPayload = $4acd0486289e3b4f$export$b9f318d6daf53c97(encodedToken, correlationId);
    // token will be decoded to get the username
    try {
        // base64Decode() should throw an error if there is an issue
        const base64Decoded = base64Decode(jswPayload);
        return JSON.parse(base64Decoded);
    } catch (err) {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$ad362b2e3a260143), correlationId);
    }
}
/**
 * Check if the signin_state claim contains "kmsi"
 * @param idTokenClaims
 * @returns
 */ function $4acd0486289e3b4f$export$9475d607926d7a45(idTokenClaims) {
    if (!idTokenClaims.signin_state) return false;
    /**
     * Signin_state claim known values:
     * dvc_mngd - device is managed
     * dvc_dmjd - device is domain joined
     * kmsi - user opted to "keep me signed in"
     * inknownntwk - Request made inside a known network. Don't use this, use CAE instead.
     */ const kmsiClaims = [
        "kmsi",
        "dvc_dmjd"
    ]; // There are some cases where kmsi may not be returned but persistent storage is still OK - allow dvc_dmjd as well
    return idTokenClaims.signin_state.some((value)=>kmsiClaims.includes(value.trim().toLowerCase()));
}
/**
 * decode a JWT
 *
 * @param authToken
 */ function $4acd0486289e3b4f$export$b9f318d6daf53c97(authToken, correlationId) {
    if (!authToken) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$78d01e29cb494be2), correlationId);
    const tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
    const matches = tokenPartsRegex.exec(authToken);
    if (!matches || matches.length < 4) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$ad362b2e3a260143), correlationId);
    /**
     * const crackedToken = {
     *  header: matches[1],
     *  JWSPayload: matches[2],
     *  JWSSig: matches[3],
     * };
     */ return matches[2];
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns true if tenantId matches the utid portion of homeAccountId
 * @param tenantId
 * @param homeAccountId
 * @returns
 */ function $7beee762cc5bd6b9$export$bc62fd222eddc2d7(tenantId, homeAccountId) {
    return !!tenantId && !!homeAccountId && tenantId === homeAccountId.split(".")[1];
}
/**
 * Build tenant profile
 * @param homeAccountId - Home account identifier for this account object
 * @param localAccountId - Local account identifer for this account object
 * @param tenantId - Full tenant or organizational id that this account belongs to
 * @param nativeAccountId - Native account identifier for this tenant
 * @param idTokenClaims - Claims from the ID token
 * @returns
 */ function $7beee762cc5bd6b9$export$924857724cb21ba4(homeAccountId, localAccountId, tenantId, nativeAccountId, idTokenClaims) {
    if (idTokenClaims) {
        const { oid: oid, sub: sub, tid: tid, name: name, tfp: tfp, acr: acr, preferred_username: preferred_username, upn: upn, login_hint: login_hint } = idTokenClaims;
        /**
         * Since there is no way to determine if the authority is AAD or B2C, we exhaust all the possible claims that can serve as tenant ID with the following precedence:
         * tid - TenantID claim that identifies the tenant that issued the token in AAD. Expected in all AAD ID tokens, not present in B2C ID Tokens.
         * tfp - Trust Framework Policy claim that identifies the policy that was used to authenticate the user. Functions as tenant for B2C scenarios.
         * acr - Authentication Context Class Reference claim used only with older B2C policies. Fallback in case tfp is not present, but likely won't be present anyway.
         */ const tenantId = tid || tfp || acr || "";
        return {
            tenantId: tenantId,
            localAccountId: oid || sub || "",
            name: name,
            username: preferred_username || upn || "",
            loginHint: login_hint,
            isHomeTenant: $7beee762cc5bd6b9$export$bc62fd222eddc2d7(tenantId, homeAccountId),
            upn: upn,
            ...nativeAccountId && {
                nativeAccountId: nativeAccountId
            }
        };
    } else return {
        tenantId: tenantId,
        localAccountId: localAccountId,
        username: "",
        isHomeTenant: $7beee762cc5bd6b9$export$bc62fd222eddc2d7(tenantId, homeAccountId),
        ...nativeAccountId && {
            nativeAccountId: nativeAccountId
        }
    };
}
/**
 * Replaces account info that varies by tenant profile sourced from the ID token claims passed in with the tenant-specific account info
 * @param baseAccountInfo
 * @param idTokenClaims
 * @returns
 */ function $7beee762cc5bd6b9$export$452a054c78b83dad(baseAccountInfo, tenantProfile, idTokenClaims, idTokenSecret) {
    let updatedAccountInfo = baseAccountInfo;
    // Tenant Profile overrides passed in account info
    if (tenantProfile) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...tenantProfileOverride } = tenantProfile;
        updatedAccountInfo = {
            ...baseAccountInfo,
            ...tenantProfileOverride
        };
    }
    // ID token claims override passed in account info and tenant profile
    if (idTokenClaims) {
        // Ignore isHomeTenant which is a utility property of tenant profile but not required in base account info
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...claimsSourcedTenantProfile } = $7beee762cc5bd6b9$export$924857724cb21ba4(baseAccountInfo.homeAccountId, baseAccountInfo.localAccountId, baseAccountInfo.tenantId, updatedAccountInfo.nativeAccountId, idTokenClaims);
        updatedAccountInfo = {
            ...updatedAccountInfo,
            ...claimsSourcedTenantProfile,
            idTokenClaims: idTokenClaims,
            idToken: idTokenSecret,
            kmsi: (0, $4acd0486289e3b4f$export$9475d607926d7a45)(idTokenClaims)
        };
        return updatedAccountInfo;
    }
    return updatedAccountInfo;
}



/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ const $2ac5a806251697eb$export$cd82032b224a3839 = {
    Default: 0,
    Adfs: 1,
    Dsts: 2,
    Ciam: 3
};


/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Gets tenantId from available ID token claims to set as credential realm with the following precedence:
 * 1. tid - if the token is acquired from an Azure AD tenant tid will be present
 * 2. tfp - if the token is acquired from a modern B2C tenant tfp should be present
 * 3. acr - if the token is acquired from a legacy B2C tenant acr should be present
 * Downcased to match the realm case-insensitive comparison requirements
 * @param idTokenClaims
 * @returns
 */ function $616279607e3ed735$export$8e1decb9a5e2932(idTokenClaims) {
    if (idTokenClaims) {
        const tenantId = idTokenClaims.tid || idTokenClaims.tfp || idTokenClaims.acr;
        return tenantId || null;
    }
    return null;
}


/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ const $631489f43a9fbed6$export$73a3e3dedd37150d = {
    /**
     * Auth Code + PKCE with Entra ID (formerly AAD) specific optimizations and features
     */ AAD: "AAD",
    /**
     * Auth Code + PKCE without Entra ID specific optimizations and features. For use only with non-Microsoft owned authorities.
     * Support is limited for this mode.
     */ OIDC: "OIDC",
    /**
     * Encrypted Authorize Response (EAR) with Entra ID specific optimizations and features
     */ EAR: "EAR"
};



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Generate Account Id key component as per the schema: <home_account_id>-<environment>
 * @internal
 */ function $f136bee61a3373e4$export$27200f1de4935de2(accountEntity) {
    const accountId = [
        accountEntity.homeAccountId,
        accountEntity.environment
    ];
    return accountId.join((0, $8994aeee5e01080d$export$9e9532f57bbb139e)).toLowerCase();
}
/**
 * Returns the AccountInfo interface for this account.
 * @internal
 */ function $f136bee61a3373e4$export$ec68416fe40418db(accountEntity) {
    const tenantProfiles = accountEntity.tenantProfiles || [];
    // Ensure at least the home tenant profile exists
    if (tenantProfiles.length === 0 && accountEntity.realm && accountEntity.localAccountId) tenantProfiles.push((0, $7beee762cc5bd6b9$export$924857724cb21ba4)(accountEntity.homeAccountId, accountEntity.localAccountId, accountEntity.realm, accountEntity.nativeAccountId));
    // Resolve nativeAccountId from the home tenant profile first, fall back to top-level (deprecated) for old cache entries
    const homeTenantProfile = tenantProfiles.find((tp)=>tp.tenantId === accountEntity.realm);
    const nativeAccountId = homeTenantProfile?.nativeAccountId || accountEntity.nativeAccountId;
    return {
        homeAccountId: accountEntity.homeAccountId,
        environment: accountEntity.environment,
        tenantId: accountEntity.realm,
        username: accountEntity.username,
        localAccountId: accountEntity.localAccountId,
        loginHint: accountEntity.loginHint,
        name: accountEntity.name,
        nativeAccountId: nativeAccountId,
        authorityType: accountEntity.authorityType,
        // Deserialize tenant profiles array into a Map
        tenantProfiles: new Map(tenantProfiles.map((tenantProfile)=>{
            return [
                tenantProfile.tenantId,
                tenantProfile
            ];
        })),
        dataBoundary: accountEntity.dataBoundary
    };
}
/**
 * Returns true if the account entity is in single tenant format (outdated), false otherwise
 * @internal
 */ function $f136bee61a3373e4$export$e46c5db879535314(accountEntity) {
    return !accountEntity.tenantProfiles;
}
/**
 * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
 * @param accountDetails
 * @internal
 */ function $f136bee61a3373e4$export$104b1f92417fcaca(accountDetails, authority, correlationId, base64Decode) {
    let authorityType;
    if (authority.authorityType === (0, $2ac5a806251697eb$export$cd82032b224a3839).Adfs) authorityType = (0, $8994aeee5e01080d$export$8fb8b1752739f076);
    else if (authority.protocolMode === (0, $631489f43a9fbed6$export$73a3e3dedd37150d).OIDC) authorityType = (0, $8994aeee5e01080d$export$2825edabe103d5);
    else authorityType = (0, $8994aeee5e01080d$export$5a1fc3a8d23f6b21);
    let clientInfo;
    let dataBoundary;
    if (accountDetails.clientInfo && base64Decode) {
        clientInfo = (0, $9c0d10744a3bd38b$export$575e1419cfbab7f8)(accountDetails.clientInfo, base64Decode);
        if (clientInfo.xms_tdbr) dataBoundary = clientInfo.xms_tdbr === "EU" ? "EU" : "None";
    }
    const env = accountDetails.environment || authority && authority.getPreferredCache();
    if (!env) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$dedc648643245fa1), correlationId);
    /*
     * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
     * In most cases it will contain a single email. This field should not be relied upon if a custom
     * policy is configured to return more than 1 email.
     */ const preferredUsername = accountDetails.idTokenClaims?.preferred_username || accountDetails.idTokenClaims?.upn;
    const email = accountDetails.idTokenClaims?.emails ? accountDetails.idTokenClaims.emails[0] : null;
    const username = preferredUsername || email || "";
    const loginHint = accountDetails.idTokenClaims?.login_hint;
    const realm = clientInfo?.utid || (0, $616279607e3ed735$export$8e1decb9a5e2932)(accountDetails.idTokenClaims) || ""; // non-AAD scenarios can have empty realm
    // How do you account for MSA CID here?
    const localAccountId = clientInfo?.uid || accountDetails.idTokenClaims?.oid || accountDetails.idTokenClaims?.sub || "";
    let tenantProfiles;
    if (accountDetails.tenantProfiles) tenantProfiles = accountDetails.tenantProfiles;
    else {
        const tenantProfile = (0, $7beee762cc5bd6b9$export$924857724cb21ba4)(accountDetails.homeAccountId, localAccountId, realm, accountDetails.nativeAccountId, accountDetails.idTokenClaims);
        tenantProfiles = [
            tenantProfile
        ];
    }
    return {
        homeAccountId: accountDetails.homeAccountId,
        environment: env,
        realm: realm,
        localAccountId: localAccountId,
        username: username,
        authorityType: authorityType,
        loginHint: loginHint,
        clientInfo: accountDetails.clientInfo,
        name: accountDetails.idTokenClaims?.name || "",
        lastModificationTime: undefined,
        lastModificationApp: undefined,
        cloudGraphHostName: accountDetails.cloudGraphHostName,
        msGraphHost: accountDetails.msGraphHost,
        nativeAccountId: accountDetails.nativeAccountId,
        tenantProfiles: tenantProfiles,
        dataBoundary: dataBoundary
    };
}
/**
 * Creates an AccountEntity object from AccountInfo
 * @param accountInfo
 * @param cloudGraphHostName
 * @param msGraphHost
 * @returns
 * @internal
 */ function $f136bee61a3373e4$export$258b94fce9daa9b0(accountInfo, cloudGraphHostName, msGraphHost) {
    // Serialize tenant profiles map into an array
    const tenantProfiles = Array.from(accountInfo.tenantProfiles?.values() || []);
    // Ensure at least the home tenant profile exists
    if (tenantProfiles.length === 0 && accountInfo.tenantId && accountInfo.localAccountId) tenantProfiles.push((0, $7beee762cc5bd6b9$export$924857724cb21ba4)(accountInfo.homeAccountId, accountInfo.localAccountId, accountInfo.tenantId, accountInfo.nativeAccountId, accountInfo.idTokenClaims));
    else if (accountInfo.nativeAccountId) {
        // Ensure nativeAccountId is set on the matching tenant profile
        const matchingProfile = tenantProfiles.find((tp)=>tp.tenantId === accountInfo.tenantId);
        if (matchingProfile && !matchingProfile.nativeAccountId) matchingProfile.nativeAccountId = accountInfo.nativeAccountId;
    }
    return {
        authorityType: accountInfo.authorityType || (0, $8994aeee5e01080d$export$2825edabe103d5),
        homeAccountId: accountInfo.homeAccountId,
        localAccountId: accountInfo.localAccountId,
        nativeAccountId: accountInfo.nativeAccountId,
        realm: accountInfo.tenantId,
        environment: accountInfo.environment,
        username: accountInfo.username,
        loginHint: accountInfo.loginHint,
        name: accountInfo.name,
        cloudGraphHostName: cloudGraphHostName,
        msGraphHost: msGraphHost,
        tenantProfiles: tenantProfiles,
        dataBoundary: accountInfo.dataBoundary
    };
}
/**
 * Generate HomeAccountId from server response
 * @param serverClientInfo
 * @param authType
 */ function $f136bee61a3373e4$export$655e905bf6b8ee85(serverClientInfo, authType, logger, cryptoObj, correlationId, idTokenClaims) {
    // since ADFS/DSTS do not have tid and does not set client_info
    if (!(authType === (0, $2ac5a806251697eb$export$cd82032b224a3839).Adfs || authType === (0, $2ac5a806251697eb$export$cd82032b224a3839).Dsts)) {
        // for cases where there is clientInfo
        if (serverClientInfo) try {
            const clientInfo = (0, $9c0d10744a3bd38b$export$575e1419cfbab7f8)(serverClientInfo, cryptoObj.base64Decode);
            if (clientInfo.uid && clientInfo.utid) return `${clientInfo.uid}.${clientInfo.utid}`;
        } catch (e) {}
        logger.warning("No client info in response", correlationId);
    }
    // default to "sub" claim
    return idTokenClaims?.sub || "";
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 * @internal
 */ function $f136bee61a3373e4$export$644bdd16756dfb6b(entity) {
    if (!entity) return false;
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
}

/*! @azure/msal-common v16.11.0 2026-06-30 */ 
/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $81f6e199bf36d728$export$aab44dc88900a3b(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}


/*! @azure/msal-common v16.11.0 2026-06-30 */ /*! @azure/msal-common v16.11.0 2026-06-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ class $3573ab538aec4484$export$ac9d9d20c2327339 extends (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) {
    constructor(errorCode, correlationId){
        super(errorCode, correlationId);
        this.name = "ClientConfigurationError";
        Object.setPrototypeOf(this, $3573ab538aec4484$export$ac9d9d20c2327339.prototype);
    }
}
function $3573ab538aec4484$export$5d63d098f4f130a1(errorCode, correlationId) {
    return new $3573ab538aec4484$export$ac9d9d20c2327339(errorCode, correlationId);
}


/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ class $4204b6e4994e8227$export$ecc754f99843e759 {
    /**
     * Check if stringified object is empty
     * @param strObj
     */ static isEmptyObj(strObj) {
        if (strObj) try {
            const obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    }
    static startsWith(str, search) {
        return str.indexOf(search) === 0;
    }
    static endsWith(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    }
    /**
     * Parses string into an object.
     *
     * @param query
     */ static queryStringToObject(query) {
        const obj = {};
        const params = query.split("&");
        const decode = (s)=>decodeURIComponent(s.replace(/\+/g, " "));
        params.forEach((pair)=>{
            if (pair.trim()) {
                const [key, value] = pair.split(/=(.+)/g, 2); // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    }
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ static trimArrayEntries(arr) {
        return arr.map((entry)=>entry.trim());
    }
    /**
     * Removes empty strings from array
     * @param arr
     */ static removeEmptyStringsFromArray(arr) {
        return arr.filter((entry)=>{
            return !!entry;
        });
    }
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ static jsonParseHelper(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }
}



var $86a6e7782b3ad3eb$exports = {};

$parcel$export($86a6e7782b3ad3eb$exports, "redirectUriEmpty", () => $86a6e7782b3ad3eb$export$7a02f9bdce79dd4e);
$parcel$export($86a6e7782b3ad3eb$exports, "claimsRequestParsingError", () => $86a6e7782b3ad3eb$export$561c97672a478709);
$parcel$export($86a6e7782b3ad3eb$exports, "authorityUriInsecure", () => $86a6e7782b3ad3eb$export$f77c6af656c8444b);
$parcel$export($86a6e7782b3ad3eb$exports, "urlParseError", () => $86a6e7782b3ad3eb$export$ee2a1a3389f75508);
$parcel$export($86a6e7782b3ad3eb$exports, "urlEmptyError", () => $86a6e7782b3ad3eb$export$859df485a5e0f239);
$parcel$export($86a6e7782b3ad3eb$exports, "emptyInputScopesError", () => $86a6e7782b3ad3eb$export$6ac27379c42383f);
$parcel$export($86a6e7782b3ad3eb$exports, "invalidClaims", () => $86a6e7782b3ad3eb$export$96e755c70e0d0e34);
$parcel$export($86a6e7782b3ad3eb$exports, "tokenRequestEmpty", () => $86a6e7782b3ad3eb$export$eca67ff7a91fed9d);
$parcel$export($86a6e7782b3ad3eb$exports, "logoutRequestEmpty", () => $86a6e7782b3ad3eb$export$9eb2eeb401492d88);
$parcel$export($86a6e7782b3ad3eb$exports, "invalidCodeChallengeMethod", () => $86a6e7782b3ad3eb$export$b8d8b332f17376dc);
$parcel$export($86a6e7782b3ad3eb$exports, "pkceParamsMissing", () => $86a6e7782b3ad3eb$export$2da3866b327f1753);
$parcel$export($86a6e7782b3ad3eb$exports, "invalidCloudDiscoveryMetadata", () => $86a6e7782b3ad3eb$export$92a2985751150ca5);
$parcel$export($86a6e7782b3ad3eb$exports, "invalidAuthorityMetadata", () => $86a6e7782b3ad3eb$export$edb4d5942bc8ccff);
$parcel$export($86a6e7782b3ad3eb$exports, "untrustedAuthority", () => $86a6e7782b3ad3eb$export$50c3162fda5f57);
$parcel$export($86a6e7782b3ad3eb$exports, "missingSshJwk", () => $86a6e7782b3ad3eb$export$8fbed44b22d9136f);
$parcel$export($86a6e7782b3ad3eb$exports, "missingSshKid", () => $86a6e7782b3ad3eb$export$b728bd8a588956c);
$parcel$export($86a6e7782b3ad3eb$exports, "missingNonceAuthenticationHeader", () => $86a6e7782b3ad3eb$export$4f88b4462bcef15f);
$parcel$export($86a6e7782b3ad3eb$exports, "invalidAuthenticationHeader", () => $86a6e7782b3ad3eb$export$bea58e1a2e503b59);
$parcel$export($86a6e7782b3ad3eb$exports, "cannotSetOIDCOptions", () => $86a6e7782b3ad3eb$export$a5c9fbb90473dca2);
$parcel$export($86a6e7782b3ad3eb$exports, "cannotAllowPlatformBroker", () => $86a6e7782b3ad3eb$export$9a3a7609ff879ac7);
$parcel$export($86a6e7782b3ad3eb$exports, "authorityMismatch", () => $86a6e7782b3ad3eb$export$91415fb6baea5d09);
$parcel$export($86a6e7782b3ad3eb$exports, "invalidRequestMethodForEAR", () => $86a6e7782b3ad3eb$export$370f4bd236cb2302);
$parcel$export($86a6e7782b3ad3eb$exports, "invalidPlatformBrokerConfiguration", () => $86a6e7782b3ad3eb$export$771e0d8e79da4143);
$parcel$export($86a6e7782b3ad3eb$exports, "issuerValidationFailed", () => $86a6e7782b3ad3eb$export$50a9c7532a41288a);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $86a6e7782b3ad3eb$export$7a02f9bdce79dd4e = "redirect_uri_empty";
const $86a6e7782b3ad3eb$export$561c97672a478709 = "claims_request_parsing_error";
const $86a6e7782b3ad3eb$export$f77c6af656c8444b = "authority_uri_insecure";
const $86a6e7782b3ad3eb$export$ee2a1a3389f75508 = "url_parse_error";
const $86a6e7782b3ad3eb$export$859df485a5e0f239 = "empty_url_error";
const $86a6e7782b3ad3eb$export$6ac27379c42383f = "empty_input_scopes_error";
const $86a6e7782b3ad3eb$export$96e755c70e0d0e34 = "invalid_claims";
const $86a6e7782b3ad3eb$export$eca67ff7a91fed9d = "token_request_empty";
const $86a6e7782b3ad3eb$export$9eb2eeb401492d88 = "logout_request_empty";
const $86a6e7782b3ad3eb$export$b8d8b332f17376dc = "invalid_code_challenge_method";
const $86a6e7782b3ad3eb$export$2da3866b327f1753 = "pkce_params_missing";
const $86a6e7782b3ad3eb$export$92a2985751150ca5 = "invalid_cloud_discovery_metadata";
const $86a6e7782b3ad3eb$export$edb4d5942bc8ccff = "invalid_authority_metadata";
const $86a6e7782b3ad3eb$export$50c3162fda5f57 = "untrusted_authority";
const $86a6e7782b3ad3eb$export$8fbed44b22d9136f = "missing_ssh_jwk";
const $86a6e7782b3ad3eb$export$b728bd8a588956c = "missing_ssh_kid";
const $86a6e7782b3ad3eb$export$4f88b4462bcef15f = "missing_nonce_authentication_header";
const $86a6e7782b3ad3eb$export$bea58e1a2e503b59 = "invalid_authentication_header";
const $86a6e7782b3ad3eb$export$a5c9fbb90473dca2 = "cannot_set_OIDCOptions";
const $86a6e7782b3ad3eb$export$9a3a7609ff879ac7 = "cannot_allow_platform_broker";
const $86a6e7782b3ad3eb$export$91415fb6baea5d09 = "authority_mismatch";
const $86a6e7782b3ad3eb$export$370f4bd236cb2302 = "invalid_request_method_for_EAR";
const $86a6e7782b3ad3eb$export$771e0d8e79da4143 = "invalid_platform_broker_configuration";
const $86a6e7782b3ad3eb$export$50a9c7532a41288a = "issuer_validation_failed";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ class $9c756a14a1bed5db$export$3abcdca7229e54f2 {
    get urlString() {
        return this._urlString;
    }
    constructor(url, correlationId){
        this._urlString = url;
        this.correlationId = correlationId;
        if (!this._urlString) // Throws error if url is empty
        throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$859df485a5e0f239), correlationId);
        if (!url.includes("#")) this._urlString = $9c756a14a1bed5db$export$3abcdca7229e54f2.canonicalizeUri(url);
    }
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ static canonicalizeUri(url) {
        if (url) {
            let lowerCaseUrl = url.toLowerCase();
            if ((0, $4204b6e4994e8227$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ((0, $4204b6e4994e8227$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!(0, $4204b6e4994e8227$export$ecc754f99843e759).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    }
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ validateAsUri() {
        // Attempts to parse url for uri components
        let components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$ee2a1a3389f75508), this.correlationId);
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$ee2a1a3389f75508), this.correlationId);
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$f77c6af656c8444b), this.correlationId);
    }
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ static appendQueryString(url, queryString) {
        if (!queryString) return url;
        return url.indexOf("?") < 0 ? `${url}?${queryString}` : `${url}&${queryString}`;
    }
    /**
     * Returns a url with the hash removed
     * @param url
     */ static removeHashFromUrl(url) {
        return $9c756a14a1bed5db$export$3abcdca7229e54f2.canonicalizeUri(url.split("#")[0]);
    }
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ replaceTenantPath(tenantId) {
        const urlObject = this.getUrlComponents();
        const pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === (0, $8994aeee5e01080d$export$3fd50d6e6941567f).COMMON || pathArray[0] === (0, $8994aeee5e01080d$export$3fd50d6e6941567f).ORGANIZATIONS)) pathArray[0] = tenantId;
        return $9c756a14a1bed5db$export$3abcdca7229e54f2.constructAuthorityUriFromObject(urlObject, this.correlationId);
    }
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ getUrlComponents() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        const regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        const match = this.urlString.match(regEx);
        if (!match) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$ee2a1a3389f75508), this.correlationId);
        // Url component object
        const urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        let pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter((val)=>val && val.length > 0); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (urlComponents.QueryString && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    }
    static getDomainFromUrl(url, correlationId) {
        const regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        const match = url.match(regEx);
        if (!match) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$ee2a1a3389f75508), correlationId);
        return match[2];
    }
    static getAbsoluteUrl(relativeUrl, baseUrl, correlationId) {
        if (relativeUrl[0] === (0, $8994aeee5e01080d$export$933cdf3ebd8cc149)) {
            const url = new $9c756a14a1bed5db$export$3abcdca7229e54f2(baseUrl, correlationId);
            const baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    }
    static constructAuthorityUriFromObject(urlObject, correlationId) {
        return new $9c756a14a1bed5db$export$3abcdca7229e54f2(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"), correlationId);
    }
}




/*! @azure/msal-common v16.11.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Build endpoint metadata dynamically to avoid string duplication
const $e0b6bad51f2d7eeb$var$endpointHosts = [
    {
        host: "login.microsoftonline.com"
    },
    {
        host: "login.chinacloudapi.cn",
        issuerHost: "login.partner.microsoftonline.cn"
    },
    {
        host: "login.microsoftonline.us"
    },
    {
        host: "login.sovcloud-identity.fr"
    },
    {
        host: "login.sovcloud-identity.de"
    },
    {
        host: "login.sovcloud-identity.sg"
    }
];
function $e0b6bad51f2d7eeb$var$buildOpenIdConfig(host, issuerHost) {
    return {
        token_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/token`,
        jwks_uri: `https://${host}/{tenantid}/discovery/v2.0/keys`,
        issuer: `https://${issuerHost}/{tenantid}/v2.0`,
        authorization_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/authorize`,
        end_session_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/logout`
    };
}
const $e0b6bad51f2d7eeb$var$dynamicEndpointMetadata = $e0b6bad51f2d7eeb$var$endpointHosts.reduce((acc, { host: host, issuerHost: issuerHost })=>{
    acc[host] = $e0b6bad51f2d7eeb$var$buildOpenIdConfig(host, issuerHost || host);
    return acc;
}, {});
const $e0b6bad51f2d7eeb$export$223f43dfec89cb87 = {
    endpointMetadata: $e0b6bad51f2d7eeb$var$dynamicEndpointMetadata,
    instanceDiscoveryMetadata: {
        metadata: [
            {
                preferred_network: "login.microsoftonline.com",
                preferred_cache: "login.windows.net",
                aliases: [
                    "login.microsoftonline.com",
                    "login.windows.net",
                    "login.microsoft.com",
                    "sts.windows.net"
                ]
            },
            {
                preferred_network: "login.partner.microsoftonline.cn",
                preferred_cache: "login.partner.microsoftonline.cn",
                aliases: [
                    "login.partner.microsoftonline.cn",
                    "login.chinacloudapi.cn"
                ]
            },
            {
                preferred_network: "login.microsoftonline.de",
                preferred_cache: "login.microsoftonline.de",
                aliases: [
                    "login.microsoftonline.de"
                ]
            },
            {
                preferred_network: "login.microsoftonline.us",
                preferred_cache: "login.microsoftonline.us",
                aliases: [
                    "login.microsoftonline.us",
                    "login.usgovcloudapi.net"
                ]
            },
            {
                preferred_network: "login-us.microsoftonline.com",
                preferred_cache: "login-us.microsoftonline.com",
                aliases: [
                    "login-us.microsoftonline.com"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.fr",
                preferred_cache: "login.sovcloud-identity.fr",
                aliases: [
                    "login.sovcloud-identity.fr"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.de",
                preferred_cache: "login.sovcloud-identity.de",
                aliases: [
                    "login.sovcloud-identity.de"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.sg",
                preferred_cache: "login.sovcloud-identity.sg",
                aliases: [
                    "login.sovcloud-identity.sg"
                ]
            },
            {
                preferred_network: "login.windows-ppe.net",
                preferred_cache: "login.windows-ppe.net",
                aliases: [
                    "login.windows-ppe.net",
                    "sts.windows-ppe.net",
                    "login.microsoft-ppe.com"
                ]
            }
        ]
    }
};
const $e0b6bad51f2d7eeb$export$f612854287391207 = $e0b6bad51f2d7eeb$export$223f43dfec89cb87.endpointMetadata;
const $e0b6bad51f2d7eeb$export$a21acafc3b6f5582 = $e0b6bad51f2d7eeb$export$223f43dfec89cb87.instanceDiscoveryMetadata;
const $e0b6bad51f2d7eeb$export$7d026f079148cd31 = new Set();
$e0b6bad51f2d7eeb$export$a21acafc3b6f5582.metadata.forEach((metadataEntry)=>{
    metadataEntry.aliases.forEach((alias)=>{
        $e0b6bad51f2d7eeb$export$7d026f079148cd31.add(alias);
    });
});
/**
 * Attempts to get an aliases array from the static authority metadata sources based on the canonical authority host
 * @param staticAuthorityOptions
 * @param logger
 * @returns
 */ function $e0b6bad51f2d7eeb$export$2c21adf4b4d4efc0(staticAuthorityOptions, logger, correlationId) {
    let staticAliases;
    const canonicalAuthority = staticAuthorityOptions.canonicalAuthority;
    if (canonicalAuthority) {
        const authorityHost = new (0, $9c756a14a1bed5db$export$3abcdca7229e54f2)(canonicalAuthority, correlationId).getUrlComponents().HostNameAndPort;
        staticAliases = $e0b6bad51f2d7eeb$export$d195904946de56a1(logger, correlationId, authorityHost, staticAuthorityOptions.cloudDiscoveryMetadata?.metadata, (0, $8994aeee5e01080d$export$5d365d77acfcb55d).CONFIG) || $e0b6bad51f2d7eeb$export$d195904946de56a1(logger, correlationId, authorityHost, $e0b6bad51f2d7eeb$export$a21acafc3b6f5582.metadata, (0, $8994aeee5e01080d$export$5d365d77acfcb55d).HARDCODED_VALUES) || staticAuthorityOptions.knownAuthorities;
    }
    return staticAliases || [];
}
/**
 * Returns aliases for from the raw cloud discovery metadata passed in
 * @param authorityHost
 * @param rawCloudDiscoveryMetadata
 * @returns
 */ function $e0b6bad51f2d7eeb$export$d195904946de56a1(logger, correlationId, authorityHost, cloudDiscoveryMetadata, source) {
    logger.trace(`getAliasesFromMetadata called with source: '${source}'`, correlationId);
    if (authorityHost && cloudDiscoveryMetadata) {
        const metadata = $e0b6bad51f2d7eeb$export$6e21098ea6e60dc(cloudDiscoveryMetadata, authorityHost);
        if (metadata) {
            logger.trace(`getAliasesFromMetadata: found cloud discovery metadata in '${source}', returning aliases`, correlationId);
            return metadata.aliases;
        } else logger.trace(`getAliasesFromMetadata: did not find cloud discovery metadata in '${source}'`, correlationId);
    }
    return null;
}
/**
 * Get cloud discovery metadata for common authorities
 */ function $e0b6bad51f2d7eeb$export$1b1433f93c9873f(authorityHost) {
    const metadata = $e0b6bad51f2d7eeb$export$6e21098ea6e60dc($e0b6bad51f2d7eeb$export$a21acafc3b6f5582.metadata, authorityHost);
    return metadata;
}
/**
 * Searches instance discovery network response for the entry that contains the host in the aliases list
 * @param response
 * @param authority
 */ function $e0b6bad51f2d7eeb$export$6e21098ea6e60dc(response, authorityHost) {
    for(let i = 0; i < response.length; i++){
        const metadata = response[i];
        if (metadata.aliases.includes(authorityHost)) return metadata;
    }
    return null;
}




/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $1fba6bdc8b3011e3$export$4cda21933050d9ec = {
    // AzureCloudInstance is not specified.
    None: "none",
    // Microsoft Azure public cloud
    AzurePublic: "https://login.microsoftonline.com",
    // Microsoft PPE
    AzurePpe: "https://login.windows-ppe.net",
    // Microsoft Chinese national/regional cloud
    AzureChina: "https://login.chinacloudapi.cn",
    // Microsoft German national/regional cloud ("Black Forest")
    AzureGermany: "https://login.microsoftonline.de",
    // US Government cloud
    AzureUsGovernment: "https://login.microsoftonline.us"
};


/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $ae1eaf93c5b21a8b$export$b288ea4a1e969e42(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}


/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $090fd57925a19904$export$6716273459d383f8(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}


/*! @azure/msal-common v16.11.0 2026-06-30 */ 
var $0d9eb83114fc9425$exports = {};

$parcel$export($0d9eb83114fc9425$exports, "NetworkClientSendPostRequestAsync", () => $0d9eb83114fc9425$export$98fd4e414eb6f897);
$parcel$export($0d9eb83114fc9425$exports, "RefreshTokenClientExecutePostToTokenEndpoint", () => $0d9eb83114fc9425$export$8ea44153120d19e5);
$parcel$export($0d9eb83114fc9425$exports, "AuthorizationCodeClientExecutePostToTokenEndpoint", () => $0d9eb83114fc9425$export$2697a5f7f677322e);
$parcel$export($0d9eb83114fc9425$exports, "RefreshTokenClientExecuteTokenRequest", () => $0d9eb83114fc9425$export$ac2700eaa8fb0f70);
$parcel$export($0d9eb83114fc9425$exports, "RefreshTokenClientAcquireToken", () => $0d9eb83114fc9425$export$6f67f4b67fca51ad);
$parcel$export($0d9eb83114fc9425$exports, "RefreshTokenClientAcquireTokenWithCachedRefreshToken", () => $0d9eb83114fc9425$export$1501c7e462f7c477);
$parcel$export($0d9eb83114fc9425$exports, "RefreshTokenClientCreateTokenRequestBody", () => $0d9eb83114fc9425$export$7f5252ee9f8772ec);
$parcel$export($0d9eb83114fc9425$exports, "SilentFlowClientGenerateResultFromCacheRecord", () => $0d9eb83114fc9425$export$6765682c201079f6);
$parcel$export($0d9eb83114fc9425$exports, "GetAuthCodeUrl", () => $0d9eb83114fc9425$export$402a522b7d3dde7c);
$parcel$export($0d9eb83114fc9425$exports, "HandleCodeResponseFromServer", () => $0d9eb83114fc9425$export$dafb32af5d611764);
$parcel$export($0d9eb83114fc9425$exports, "AuthClientExecuteTokenRequest", () => $0d9eb83114fc9425$export$7fe8027afbec6ae);
$parcel$export($0d9eb83114fc9425$exports, "AuthClientCreateTokenRequestBody", () => $0d9eb83114fc9425$export$5f104c073ff8021d);
$parcel$export($0d9eb83114fc9425$exports, "UpdateTokenEndpointAuthority", () => $0d9eb83114fc9425$export$3cb25312cfbc6081);
$parcel$export($0d9eb83114fc9425$exports, "PopTokenGenerateCnf", () => $0d9eb83114fc9425$export$42d4b7447f09a8ea);
$parcel$export($0d9eb83114fc9425$exports, "HandleServerTokenResponse", () => $0d9eb83114fc9425$export$602d5889aed45852);
$parcel$export($0d9eb83114fc9425$exports, "AuthorityResolveEndpointsAsync", () => $0d9eb83114fc9425$export$931c11cf1c07ab89);
$parcel$export($0d9eb83114fc9425$exports, "AuthorityGetCloudDiscoveryMetadataFromNetwork", () => $0d9eb83114fc9425$export$efaa875fb2b18324);
$parcel$export($0d9eb83114fc9425$exports, "AuthorityUpdateCloudDiscoveryMetadata", () => $0d9eb83114fc9425$export$f4b055b49d01aa42);
$parcel$export($0d9eb83114fc9425$exports, "AuthorityGetEndpointMetadataFromNetwork", () => $0d9eb83114fc9425$export$b3c7ccc70b66f496);
$parcel$export($0d9eb83114fc9425$exports, "AuthorityUpdateEndpointMetadata", () => $0d9eb83114fc9425$export$931517f5ac8360d7);
$parcel$export($0d9eb83114fc9425$exports, "AuthorityUpdateMetadataWithRegionalInformation", () => $0d9eb83114fc9425$export$fc53860665c327bc);
$parcel$export($0d9eb83114fc9425$exports, "RegionDiscoveryDetectRegion", () => $0d9eb83114fc9425$export$e92f44766756a006);
$parcel$export($0d9eb83114fc9425$exports, "RegionDiscoveryGetRegionFromIMDS", () => $0d9eb83114fc9425$export$a13bdfce41f1e18b);
$parcel$export($0d9eb83114fc9425$exports, "RegionDiscoveryGetCurrentVersion", () => $0d9eb83114fc9425$export$4f30612ca980fa0);
$parcel$export($0d9eb83114fc9425$exports, "CacheManagerGetRefreshToken", () => $0d9eb83114fc9425$export$cc3335bdf0624641);
$parcel$export($0d9eb83114fc9425$exports, "SetUserData", () => $0d9eb83114fc9425$export$b78fa8752ad1fc7b);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Time spent sending/waiting for the response of a request to the token endpoint
 */ const $0d9eb83114fc9425$export$98fd4e414eb6f897 = "networkClientSendPostRequestAsync";
const $0d9eb83114fc9425$export$8ea44153120d19e5 = "refreshTokenClientExecutePostToTokenEndpoint";
const $0d9eb83114fc9425$export$2697a5f7f677322e = "authorizationCodeClientExecutePostToTokenEndpoint";
/**
 * Time spent on the network for refresh token acquisition
 */ const $0d9eb83114fc9425$export$ac2700eaa8fb0f70 = "refreshTokenClientExecuteTokenRequest";
/**
 * Time taken for acquiring refresh token , records RT size
 */ const $0d9eb83114fc9425$export$6f67f4b67fca51ad = "refreshTokenClientAcquireToken";
/**
 * Time taken for acquiring cached refresh token
 */ const $0d9eb83114fc9425$export$1501c7e462f7c477 = "refreshTokenClientAcquireTokenWithCachedRefreshToken";
/**
 * Helper function to create token request body in RefreshTokenClient (msal-common).
 */ const $0d9eb83114fc9425$export$7f5252ee9f8772ec = "refreshTokenClientCreateTokenRequestBody";
const $0d9eb83114fc9425$export$6765682c201079f6 = "silentFlowClientGenerateResultFromCacheRecord";
/**
 * getAuthCodeUrl API (msal-browser and msal-node).
 */ const $0d9eb83114fc9425$export$402a522b7d3dde7c = "getAuthCodeUrl";
/**
 * Functions from InteractionHandler (msal-browser)
 */ const $0d9eb83114fc9425$export$dafb32af5d611764 = "handleCodeResponseFromServer";
/**
 * APIs in Authorization Code Client (msal-common)
 */ const $0d9eb83114fc9425$export$7fe8027afbec6ae = "authClientExecuteTokenRequest";
const $0d9eb83114fc9425$export$5f104c073ff8021d = "authClientCreateTokenRequestBody";
const $0d9eb83114fc9425$export$3cb25312cfbc6081 = "updateTokenEndpointAuthority";
/**
 * Generate functions in PopTokenGenerator (msal-common)
 */ const $0d9eb83114fc9425$export$42d4b7447f09a8ea = "popTokenGenerateCnf";
/**
 * handleServerTokenResponse API in ResponseHandler (msal-common)
 */ const $0d9eb83114fc9425$export$602d5889aed45852 = "handleServerTokenResponse";
/**
 * Authority functions
 */ const $0d9eb83114fc9425$export$931c11cf1c07ab89 = "authorityResolveEndpointsAsync";
const $0d9eb83114fc9425$export$efaa875fb2b18324 = "authorityGetCloudDiscoveryMetadataFromNetwork";
const $0d9eb83114fc9425$export$f4b055b49d01aa42 = "authorityUpdateCloudDiscoveryMetadata";
const $0d9eb83114fc9425$export$b3c7ccc70b66f496 = "authorityGetEndpointMetadataFromNetwork";
const $0d9eb83114fc9425$export$931517f5ac8360d7 = "authorityUpdateEndpointMetadata";
const $0d9eb83114fc9425$export$fc53860665c327bc = "authorityUpdateMetadataWithRegionalInformation";
/**
 * Region Discovery functions
 */ const $0d9eb83114fc9425$export$e92f44766756a006 = "regionDiscoveryDetectRegion";
const $0d9eb83114fc9425$export$a13bdfce41f1e18b = "regionDiscoveryGetRegionFromIMDS";
const $0d9eb83114fc9425$export$4f30612ca980fa0 = "regionDiscoveryGetCurrentVersion";
/**
 * Cache operations
 */ const $0d9eb83114fc9425$export$cc3335bdf0624641 = "cacheManagerGetRefreshToken";
const $0d9eb83114fc9425$export$b78fa8752ad1fc7b = "setUserData";


/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Wraps a function with a performance measurement.
 * Usage: invoke(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $69bce03cfd571284$export$468cda29b159ee5d = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function '${eventName}'`, correlationId);
        const inProgressEvent = telemetryClient.startMeasurement(eventName, correlationId);
        if (correlationId) // Track number of times this API is called in a single request
        telemetryClient.incrementFields({
            [`ext.${eventName}CallCount`]: 1
        }, correlationId);
        try {
            const result = callback(...args);
            inProgressEvent.end({
                success: true
            });
            logger.trace(`Returning result from '${eventName}'`, correlationId);
            return result;
        } catch (e) {
            logger.trace(`Error occurred in '${eventName}'`, correlationId);
            try {
                logger.trace(JSON.stringify(e), correlationId);
            } catch (e) {
                logger.trace("Unable to print error message.", correlationId);
            }
            inProgressEvent.end({
                success: false
            }, e);
            throw e;
        }
    };
};
/**
 * Wraps an async function with a performance measurement.
 * Usage: invokeAsync(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 *
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $69bce03cfd571284$export$e4feded94d9adb18 = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function '${eventName}'`, correlationId);
        const inProgressEvent = telemetryClient.startMeasurement(eventName, correlationId);
        if (correlationId) // Track number of times this API is called in a single request
        telemetryClient.incrementFields({
            [`ext.${eventName}CallCount`]: 1
        }, correlationId);
        return callback(...args).then((response)=>{
            logger.trace(`Returning result from '${eventName}'`, correlationId);
            inProgressEvent.end({
                success: true
            });
            return response;
        }).catch((e)=>{
            logger.trace(`Error occurred in '${eventName}'`, correlationId);
            try {
                logger.trace(JSON.stringify(e), correlationId);
            } catch (e) {
                logger.trace("Unable to print error message.", correlationId);
            }
            inProgressEvent.end({
                success: false
            }, e);
            throw e;
        });
    };
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $6c7e3926c3c4a181$export$1afa9d0f261ebb47 {
    constructor(networkInterface, logger, performanceClient, correlationId){
        this.networkInterface = networkInterface;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ async detectRegion(environmentRegion, regionDiscoveryMetadata) {
        // Initialize auto detected region with the region from the envrionment
        let autodetectedRegionName = environmentRegion;
        // Check if a region was detected from the environment, if not, attempt to get the region from IMDS
        if (!autodetectedRegionName) {
            const options = $6c7e3926c3c4a181$export$1afa9d0f261ebb47.IMDS_OPTIONS;
            try {
                const localIMDSVersionResponse = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $0d9eb83114fc9425$export$a13bdfce41f1e18b), this.logger, this.performanceClient, this.correlationId)((0, $8994aeee5e01080d$export$69aaeb41e2826c48), options);
                if (localIMDSVersionResponse.status === (0, $8994aeee5e01080d$export$f7faf416d920fff3)) {
                    autodetectedRegionName = localIMDSVersionResponse.body?.location;
                    if (autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, $8994aeee5e01080d$export$3d4a3e11df589b40).IMDS;
                }
                // If the response using the local IMDS version failed, try to fetch the current version of IMDS and retry.
                if (localIMDSVersionResponse.status === (0, $8994aeee5e01080d$export$9a0aba463f6ac337)) {
                    const currentIMDSVersion = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.getCurrentVersion.bind(this), (0, $0d9eb83114fc9425$export$4f30612ca980fa0), this.logger, this.performanceClient, this.correlationId)(options);
                    if (!currentIMDSVersion) {
                        regionDiscoveryMetadata.region_source = (0, $8994aeee5e01080d$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                        return null;
                    }
                    const currentIMDSVersionResponse = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $0d9eb83114fc9425$export$a13bdfce41f1e18b), this.logger, this.performanceClient, this.correlationId)(currentIMDSVersion, options);
                    if (currentIMDSVersionResponse.status === (0, $8994aeee5e01080d$export$f7faf416d920fff3)) {
                        autodetectedRegionName = currentIMDSVersionResponse.body?.location;
                        if (autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, $8994aeee5e01080d$export$3d4a3e11df589b40).IMDS;
                    }
                }
            } catch (e) {
                regionDiscoveryMetadata.region_source = (0, $8994aeee5e01080d$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                return null;
            }
        } else regionDiscoveryMetadata.region_source = (0, $8994aeee5e01080d$export$3d4a3e11df589b40).ENVIRONMENT_VARIABLE;
        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, $8994aeee5e01080d$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
        return autodetectedRegionName || null;
    }
    /**
     * Make the call to the IMDS endpoint
     *
     * @param version
     * @param options
     * @returns Promise<NetworkResponse<ImdsComputeResponse>>
     */ async getRegionFromIMDS(version, options) {
        return this.networkInterface.sendGetRequestAsync(`${(0, $8994aeee5e01080d$export$5eeea8c9d02ceb62)}?api-version=${version}`, options, (0, $8994aeee5e01080d$export$7c61cea10ff91469));
    }
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ async getCurrentVersion(options) {
        try {
            const response = await this.networkInterface.sendGetRequestAsync(`${(0, $8994aeee5e01080d$export$5eeea8c9d02ceb62)}?format=json`, options);
            // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
            if (response.status === (0, $8994aeee5e01080d$export$9a0aba463f6ac337) && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return response.body["newest-versions"][0];
            return null;
        } catch (e) {
            return null;
        }
    }
}
// Options for the IMDS endpoint request
$6c7e3926c3c4a181$export$1afa9d0f261ebb47.IMDS_OPTIONS = {
    headers: {
        Metadata: "true"
    }
};





var $4cd4d8a6d71d39a8$exports = {};

$parcel$export($4cd4d8a6d71d39a8$exports, "createIdTokenEntity", () => $4cd4d8a6d71d39a8$export$d8a173a23f325769);
$parcel$export($4cd4d8a6d71d39a8$exports, "createAccessTokenEntity", () => $4cd4d8a6d71d39a8$export$fa005e75d915b6db);
$parcel$export($4cd4d8a6d71d39a8$exports, "createRefreshTokenEntity", () => $4cd4d8a6d71d39a8$export$9095b5885dfa55cc);
$parcel$export($4cd4d8a6d71d39a8$exports, "isCredentialEntity", () => $4cd4d8a6d71d39a8$export$b8fc93e8af17dc04);
$parcel$export($4cd4d8a6d71d39a8$exports, "isAccessTokenEntity", () => $4cd4d8a6d71d39a8$export$d7e6bcc84cf680df);
$parcel$export($4cd4d8a6d71d39a8$exports, "isIdTokenEntity", () => $4cd4d8a6d71d39a8$export$71eec93d11c94dfc);
$parcel$export($4cd4d8a6d71d39a8$exports, "isRefreshTokenEntity", () => $4cd4d8a6d71d39a8$export$f1bb3af43d5b8bc7);
$parcel$export($4cd4d8a6d71d39a8$exports, "isServerTelemetryEntity", () => $4cd4d8a6d71d39a8$export$7ad16989078344e5);
$parcel$export($4cd4d8a6d71d39a8$exports, "isThrottlingEntity", () => $4cd4d8a6d71d39a8$export$7e43cc7efaf4bec2);
$parcel$export($4cd4d8a6d71d39a8$exports, "generateAppMetadataKey", () => $4cd4d8a6d71d39a8$export$ddbc6773ab812685);
$parcel$export($4cd4d8a6d71d39a8$exports, "isAppMetadataEntity", () => $4cd4d8a6d71d39a8$export$bb2a01b66d0b3486);
$parcel$export($4cd4d8a6d71d39a8$exports, "isAuthorityMetadataEntity", () => $4cd4d8a6d71d39a8$export$6231cab310116b3c);
$parcel$export($4cd4d8a6d71d39a8$exports, "generateAuthorityMetadataExpiresAt", () => $4cd4d8a6d71d39a8$export$90f464c4238c27e5);
$parcel$export($4cd4d8a6d71d39a8$exports, "updateAuthorityEndpointMetadata", () => $4cd4d8a6d71d39a8$export$ef87e8fbd8af5f96);
$parcel$export($4cd4d8a6d71d39a8$exports, "updateCloudDiscoveryMetadata", () => $4cd4d8a6d71d39a8$export$6d4972e1d88c8518);
$parcel$export($4cd4d8a6d71d39a8$exports, "isAuthorityMetadataExpired", () => $4cd4d8a6d71d39a8$export$b96839cf63a15b0f);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 


var $e0616e53cd3f026f$exports = {};

$parcel$export($e0616e53cd3f026f$exports, "nowSeconds", () => $e0616e53cd3f026f$export$ae62599a119ac50a);
$parcel$export($e0616e53cd3f026f$exports, "toSecondsFromDate", () => $e0616e53cd3f026f$export$13bf6a15fb02e52d);
$parcel$export($e0616e53cd3f026f$exports, "toDateFromSeconds", () => $e0616e53cd3f026f$export$dcee164673849555);
$parcel$export($e0616e53cd3f026f$exports, "isTokenExpired", () => $e0616e53cd3f026f$export$b007d77a962aa175);
$parcel$export($e0616e53cd3f026f$exports, "isCacheExpired", () => $e0616e53cd3f026f$export$d812b641f1458de4);
$parcel$export($e0616e53cd3f026f$exports, "wasClockTurnedBack", () => $e0616e53cd3f026f$export$8961be72dcbc368e);
$parcel$export($e0616e53cd3f026f$exports, "delay", () => $e0616e53cd3f026f$export$1391212d75b2ee65);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for managing date and time operations.
 */ /**
 * return the current time in Unix time (seconds).
 */ function $e0616e53cd3f026f$export$ae62599a119ac50a() {
    // Date.getTime() returns in milliseconds.
    return Math.round(new Date().getTime() / 1000.0);
}
/**
 * Converts JS Date object to seconds
 * @param date Date
 */ function $e0616e53cd3f026f$export$13bf6a15fb02e52d(date) {
    // Convert date to seconds
    return date.getTime() / 1000;
}
/**
 * Convert seconds to JS Date object. Seconds can be in a number or string format or undefined (will still return a date).
 * @param seconds
 */ function $e0616e53cd3f026f$export$dcee164673849555(seconds) {
    if (seconds) return new Date(Number(seconds) * 1000);
    return new Date();
}
/**
 * check if a token is expired based on given UTC time in seconds.
 * @param expiresOn
 */ function $e0616e53cd3f026f$export$b007d77a962aa175(expiresOn, offset) {
    // check for access token expiry
    const expirationSec = Number(expiresOn) || 0;
    const offsetCurrentTimeSec = $e0616e53cd3f026f$export$ae62599a119ac50a() + offset;
    // If current time + offset is greater than token expiration time, then token is expired.
    return offsetCurrentTimeSec > expirationSec;
}
/**
 * Checks if a cache entry is expired based on the last updated time and cache retention days.
 * @param lastUpdatedAt
 * @param cacheRetentionDays
 * @returns
 */ function $e0616e53cd3f026f$export$d812b641f1458de4(lastUpdatedAt, cacheRetentionDays) {
    const cacheExpirationTimestamp = Number(lastUpdatedAt) + cacheRetentionDays * 86400000;
    return Date.now() > cacheExpirationTimestamp;
}
/**
 * If the current time is earlier than the time that a token was cached at, we must discard the token
 * i.e. The system clock was turned back after acquiring the cached token
 * @param cachedAt
 * @param offset
 */ function $e0616e53cd3f026f$export$8961be72dcbc368e(cachedAt) {
    const cachedAtSec = Number(cachedAt);
    return cachedAtSec > $e0616e53cd3f026f$export$ae62599a119ac50a();
}
/**
 * Waits for t number of milliseconds
 * @param t number
 * @param value T
 */ function $e0616e53cd3f026f$export$1391212d75b2ee65(t, value) {
    return new Promise((resolve)=>setTimeout(()=>resolve(value), t));
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create IdTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $4cd4d8a6d71d39a8$export$d8a173a23f325769(homeAccountId, environment, idToken, clientId, tenantId) {
    const idTokenEntity = {
        credentialType: (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ID_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: idToken,
        realm: tenantId,
        lastUpdatedAt: Date.now().toString()
    };
    return idTokenEntity;
}
/**
 * Create AccessTokenEntity
 * @param homeAccountId
 * @param environment
 * @param accessToken
 * @param clientId
 * @param tenantId
 * @param scopes
 * @param expiresOn
 * @param extExpiresOn
 */ function $4cd4d8a6d71d39a8$export$fa005e75d915b6db(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, base64Decode, correlationId, refreshOn, tokenType, userAssertionHash, keyId, additionalCacheKeyComponents) {
    const atEntity = {
        homeAccountId: homeAccountId,
        credentialType: (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ACCESS_TOKEN,
        secret: accessToken,
        cachedAt: (0, $e0616e53cd3f026f$export$ae62599a119ac50a)().toString(),
        expiresOn: expiresOn.toString(),
        extendedExpiresOn: extExpiresOn.toString(),
        environment: environment,
        clientId: clientId,
        realm: tenantId,
        target: scopes,
        tokenType: tokenType || (0, $8994aeee5e01080d$export$901491a717da2ba5).BEARER,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) atEntity.userAssertionHash = userAssertionHash;
    if (refreshOn) atEntity.refreshOn = refreshOn.toString();
    /*
     * Create Access Token With Auth Scheme instead of regular access token
     * Cast to lower to handle "bearer" from ADFS
     */ if (atEntity.tokenType?.toLowerCase() !== (0, $8994aeee5e01080d$export$901491a717da2ba5).BEARER.toLowerCase()) {
        atEntity.credentialType = (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        switch(atEntity.tokenType){
            case (0, $8994aeee5e01080d$export$901491a717da2ba5).POP:
                // Make sure keyId is present and add it to credential
                const tokenClaims = (0, $4acd0486289e3b4f$export$8a59e6f35fb00518)(accessToken, base64Decode, correlationId);
                if (!tokenClaims?.cnf?.kid) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$6f89b8a7d491b526), correlationId);
                atEntity.keyId = tokenClaims.cnf.kid;
                break;
            case (0, $8994aeee5e01080d$export$901491a717da2ba5).SSH:
                atEntity.keyId = keyId;
        }
    }
    /* Additional cache key components for cache isolation (e.g., FMI path) */ if (additionalCacheKeyComponents && Object.keys(additionalCacheKeyComponents).length > 0) atEntity.additionalCacheKeyComponents = additionalCacheKeyComponents;
    return atEntity;
}
/**
 * Create RefreshTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $4cd4d8a6d71d39a8$export$9095b5885dfa55cc(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash, expiresOn) {
    const rtEntity = {
        credentialType: (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).REFRESH_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: refreshToken,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) rtEntity.userAssertionHash = userAssertionHash;
    if (familyId) rtEntity.familyId = familyId;
    if (expiresOn) rtEntity.expiresOn = expiresOn.toString();
    return rtEntity;
}
function $4cd4d8a6d71d39a8$export$b8fc93e8af17dc04(entity) {
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $4cd4d8a6d71d39a8$export$d7e6bcc84cf680df(entity) {
    if (!entity) return false;
    return $4cd4d8a6d71d39a8$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity.hasOwnProperty("target") && (entity["credentialType"] === (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ACCESS_TOKEN || entity["credentialType"] === (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME);
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $4cd4d8a6d71d39a8$export$71eec93d11c94dfc(entity) {
    if (!entity) return false;
    return $4cd4d8a6d71d39a8$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity["credentialType"] === (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ID_TOKEN;
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $4cd4d8a6d71d39a8$export$f1bb3af43d5b8bc7(entity) {
    if (!entity) return false;
    return $4cd4d8a6d71d39a8$export$b8fc93e8af17dc04(entity) && entity["credentialType"] === (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).REFRESH_TOKEN;
}
/**
 * validates if a given cache entry is "Telemetry", parses <key,value>
 * @param key
 * @param entity
 */ function $4cd4d8a6d71d39a8$export$7ad16989078344e5(key, entity) {
    const validateKey = key.indexOf((0, $8994aeee5e01080d$export$788940e4cd6c0eba)) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
    return validateKey && validateEntity;
}
/**
 * validates if a given cache entry is "Throttling", parses <key,value>
 * @param key
 * @param entity
 */ function $4cd4d8a6d71d39a8$export$7e43cc7efaf4bec2(key, entity) {
    let validateKey = false;
    if (key) validateKey = key.indexOf((0, $8994aeee5e01080d$export$2c4d2738c7e2e621)) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
    return validateKey && validateEntity;
}
/**
 * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
 */ function $4cd4d8a6d71d39a8$export$ddbc6773ab812685({ environment: environment, clientId: clientId }) {
    const appMetaDataKeyArray = [
        (0, $8994aeee5e01080d$export$7e1bea6dc1b6b32e),
        environment,
        clientId
    ];
    return appMetaDataKeyArray.join((0, $8994aeee5e01080d$export$9e9532f57bbb139e)).toLowerCase();
}
/*
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $4cd4d8a6d71d39a8$export$bb2a01b66d0b3486(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $8994aeee5e01080d$export$7e1bea6dc1b6b32e)) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $4cd4d8a6d71d39a8$export$6231cab310116b3c(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $8994aeee5e01080d$export$1137b2d06fad26eb)) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
}
/**
 * Reset the exiresAt value
 */ function $4cd4d8a6d71d39a8$export$90f464c4238c27e5() {
    return (0, $e0616e53cd3f026f$export$ae62599a119ac50a)() + (0, $8994aeee5e01080d$export$eea04158dccf5d70);
}
/** @internal */ function $4cd4d8a6d71d39a8$export$ef87e8fbd8af5f96(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.authorization_endpoint = updatedValues.authorization_endpoint;
    authorityMetadata.token_endpoint = updatedValues.token_endpoint;
    authorityMetadata.end_session_endpoint = updatedValues.end_session_endpoint;
    authorityMetadata.issuer = updatedValues.issuer;
    authorityMetadata.endpointsFromNetwork = fromNetwork;
    authorityMetadata.jwks_uri = updatedValues.jwks_uri;
}
/** @internal */ function $4cd4d8a6d71d39a8$export$6d4972e1d88c8518(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.aliases = updatedValues.aliases;
    authorityMetadata.preferred_cache = updatedValues.preferred_cache;
    authorityMetadata.preferred_network = updatedValues.preferred_network;
    authorityMetadata.aliasesFromNetwork = fromNetwork;
}
/**
 * Returns whether or not the data needs to be refreshed
 * @internal
 */ function $4cd4d8a6d71d39a8$export$b96839cf63a15b0f(metadata) {
    return metadata.expiresAt <= (0, $e0616e53cd3f026f$export$ae62599a119ac50a)();
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 * @internal
 */ class $c05549f487bde715$export$f1c6ec2e6d68c49c {
    constructor(authority, networkInterface, cacheManager, authorityOptions, logger, correlationId, performanceClient, managedIdentity){
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.managedIdentity = managedIdentity || false;
        this.regionDiscovery = new (0, $6c7e3926c3c4a181$export$1afa9d0f261ebb47)(networkInterface, this.logger, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType:type}
     * @param authorityUri {@link IUri}
     * @private
     */ getAuthorityType(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith((0, $8994aeee5e01080d$export$ecbbba19d57055cd))) return (0, $2ac5a806251697eb$export$cd82032b224a3839).Ciam;
        const pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case 0, $8994aeee5e01080d$export$d67d0b9d84b9fa64:
                return (0, $2ac5a806251697eb$export$cd82032b224a3839).Adfs;
            case 0, $8994aeee5e01080d$export$ed356007bd76ccea:
                return (0, $2ac5a806251697eb$export$cd82032b224a3839).Dsts;
        }
        return (0, $2ac5a806251697eb$export$cd82032b224a3839).Default;
    }
    // See above for AuthorityType
    get authorityType() {
        return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
    }
    /**
     * ProtocolMode enum representing the way endpoints are constructed.
     */ get protocolMode() {
        return this.authorityOptions.protocolMode;
    }
    /**
     * Returns authorityOptions which can be used to reinstantiate a new authority instance
     */ get options() {
        return this.authorityOptions;
    }
    /**
     * A URL that is the authority set by the developer
     */ get canonicalAuthority() {
        return this._canonicalAuthority.urlString;
    }
    /**
     * Sets canonical authority.
     */ set canonicalAuthority(url) {
        this._canonicalAuthority = new (0, $9c756a14a1bed5db$export$3abcdca7229e54f2)(url, this.correlationId);
        this._canonicalAuthority.validateAsUri();
        this._canonicalAuthorityUrlComponents = null;
    }
    /**
     * Get authority components.
     */ get canonicalAuthorityUrlComponents() {
        if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
        return this._canonicalAuthorityUrlComponents;
    }
    /**
     * Get hostname and port i.e. login.microsoftonline.com
     */ get hostnameAndPort() {
        return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
    }
    /**
     * Get tenant for authority.
     */ get tenant() {
        return this.canonicalAuthorityUrlComponents.PathSegments[0];
    }
    /**
     * OAuth /authorize endpoint for requests
     */ get authorizationEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
        else throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$c9fcc93738cc2bc3), this.correlationId);
    }
    /**
     * OAuth /token endpoint for requests
     */ get tokenEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
        else throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$c9fcc93738cc2bc3), this.correlationId);
    }
    get deviceCodeEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
        else throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$c9fcc93738cc2bc3), this.correlationId);
    }
    /**
     * OAuth logout endpoint for requests
     */ get endSessionEndpoint() {
        if (this.discoveryComplete()) {
            // ROPC policies may not have end_session_endpoint set
            if (!this.metadata.end_session_endpoint) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$c3bd741c16a889f3), this.correlationId);
            return this.replacePath(this.metadata.end_session_endpoint);
        } else throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$c9fcc93738cc2bc3), this.correlationId);
    }
    /**
     * OAuth issuer for requests
     */ get selfSignedJwtAudience() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
        else throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$c9fcc93738cc2bc3), this.correlationId);
    }
    /**
     * Jwks_uri for token signing keys
     */ get jwksUri() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
        else throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$c9fcc93738cc2bc3), this.correlationId);
    }
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ canReplaceTenant(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !$c05549f487bde715$export$f1c6ec2e6d68c49c.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === (0, $2ac5a806251697eb$export$cd82032b224a3839).Default && this.protocolMode !== (0, $631489f43a9fbed6$export$73a3e3dedd37150d).OIDC;
    }
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ replaceTenant(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    }
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ replacePath(urlString) {
        let endpoint = urlString;
        const cachedAuthorityUrl = new (0, $9c756a14a1bed5db$export$3abcdca7229e54f2)(this.metadata.canonical_authority, this.correlationId);
        const cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        const cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        const currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach((currentPart, index)=>{
            let cachedPart = cachedAuthorityParts[index];
            if (index === 0 && this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                const tenantId = new (0, $9c756a14a1bed5db$export$3abcdca7229e54f2)(this.metadata.authorization_endpoint, this.correlationId).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    this.logger.verbose(`Replacing tenant domain name '${cachedPart}' with id '${tenantId}'`, this.correlationId);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace(`/${cachedPart}/`, `/${currentPart}/`);
        });
        return this.replaceTenant(endpoint);
    }
    /**
     * The default open id configuration endpoint for any canonical authority.
     */ get defaultOpenIdConfigurationEndpoint() {
        const canonicalAuthorityHost = this.hostnameAndPort;
        if (this.canonicalAuthority.endsWith("v2.0/") || this.authorityType === (0, $2ac5a806251697eb$export$cd82032b224a3839).Adfs || this.protocolMode === (0, $631489f43a9fbed6$export$73a3e3dedd37150d).OIDC && !this.isAliasOfKnownMicrosoftAuthority(canonicalAuthorityHost)) return `${this.canonicalAuthority}.well-known/openid-configuration`;
        return `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
    }
    /**
     * Boolean that returns whether or not tenant discovery has been completed.
     */ discoveryComplete() {
        return !!this.metadata;
    }
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ async resolveEndpointsAsync() {
        const metadataEntity = this.getCurrentMetadataEntity();
        const cloudDiscoverySource = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.updateCloudDiscoveryMetadata.bind(this), (0, $0d9eb83114fc9425$export$f4b055b49d01aa42), this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
        const endpointSource = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.updateEndpointMetadata.bind(this), (0, $0d9eb83114fc9425$export$931517f5ac8360d7), this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.updateCachedMetadata(metadataEntity, cloudDiscoverySource, {
            source: endpointSource
        });
        this.performanceClient?.addFields({
            cloudDiscoverySource: cloudDiscoverySource,
            authorityEndpointSource: endpointSource
        }, this.correlationId);
    }
    /**
     * Returns metadata entity from cache if it exists, otherwise returns a new metadata entity built
     * from the configured canonical authority
     * @returns
     */ getCurrentMetadataEntity() {
        let metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort, this.correlationId);
        if (!metadataEntity) metadataEntity = {
            aliases: [],
            preferred_cache: this.hostnameAndPort,
            preferred_network: this.hostnameAndPort,
            canonical_authority: this.canonicalAuthority,
            authorization_endpoint: "",
            token_endpoint: "",
            end_session_endpoint: "",
            issuer: "",
            aliasesFromNetwork: false,
            endpointsFromNetwork: false,
            expiresAt: (0, $4cd4d8a6d71d39a8$export$90f464c4238c27e5)(),
            jwks_uri: ""
        };
        return metadataEntity;
    }
    /**
     * Updates cached metadata based on metadata source and sets the instance's metadata
     * property to the same value
     * @param metadataEntity
     * @param cloudDiscoverySource
     * @param endpointMetadataResult
     */ updateCachedMetadata(metadataEntity, cloudDiscoverySource, endpointMetadataResult) {
        if (cloudDiscoverySource !== (0, $8994aeee5e01080d$export$5d365d77acfcb55d).CACHE && endpointMetadataResult?.source !== (0, $8994aeee5e01080d$export$5d365d77acfcb55d).CACHE) {
            // Reset the expiration time unless both values came from a successful cache lookup
            metadataEntity.expiresAt = (0, $4cd4d8a6d71d39a8$export$90f464c4238c27e5)();
            metadataEntity.canonical_authority = this.canonicalAuthority;
        }
        const cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache, this.correlationId);
        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity, this.correlationId);
        this.metadata = metadataEntity;
    }
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ async updateEndpointMetadata(metadataEntity) {
        const localMetadata = this.updateEndpointMetadataFromLocalSources(metadataEntity);
        // Further update may be required for hardcoded metadata if regional metadata is preferred
        if (localMetadata) {
            if (localMetadata.source === (0, $8994aeee5e01080d$export$5d365d77acfcb55d).HARDCODED_VALUES) {
                // If the user prefers to use an azure region replace the global endpoints with regional information.
                if (this.authorityOptions.azureRegionConfiguration?.azureRegion) {
                    if (localMetadata.metadata) {
                        const hardcodedMetadata = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $0d9eb83114fc9425$export$fc53860665c327bc), this.logger, this.performanceClient, this.correlationId)(localMetadata.metadata);
                        (0, $4cd4d8a6d71d39a8$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                        metadataEntity.canonical_authority = this.canonicalAuthority;
                    }
                }
            }
            return localMetadata.source;
        }
        // Get metadata from network if local sources aren't available
        let metadata = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.getEndpointMetadataFromNetwork.bind(this), (0, $0d9eb83114fc9425$export$b3c7ccc70b66f496), this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            // Validate the issuer returned by the OIDC discovery document.
            this.validateIssuer(metadata.issuer);
            // If the user prefers to use an azure region replace the global endpoints with regional information.
            if (this.authorityOptions.azureRegionConfiguration?.azureRegion) metadata = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $0d9eb83114fc9425$export$fc53860665c327bc), this.logger, this.performanceClient, this.correlationId)(metadata);
            (0, $4cd4d8a6d71d39a8$export$ef87e8fbd8af5f96)(metadataEntity, metadata, true);
            return (0, $8994aeee5e01080d$export$5d365d77acfcb55d).NETWORK;
        } else // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$73566da29bc073eb), this.defaultOpenIdConfigurationEndpoint, this.correlationId);
    }
    /**
     * Updates endpoint metadata from local sources and returns where the information was retrieved from and the metadata config
     * response if the source is hardcoded metadata
     * @param metadataEntity
     * @returns
     */ updateEndpointMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get endpoint metadata from authority configuration", this.correlationId);
        const configMetadata = this.getEndpointMetadataFromConfig();
        if (configMetadata) {
            this.logger.verbose("Found endpoint metadata in authority configuration", this.correlationId);
            (0, $4cd4d8a6d71d39a8$export$ef87e8fbd8af5f96)(metadataEntity, configMetadata, false);
            return {
                source: (0, $8994aeee5e01080d$export$5d365d77acfcb55d).CONFIG
            };
        }
        this.logger.verbose("Did not find endpoint metadata in the config... Attempting to get endpoint metadata from the hardcoded values.", this.correlationId);
        const hardcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
        if (hardcodedMetadata) {
            (0, $4cd4d8a6d71d39a8$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
            return {
                source: (0, $8994aeee5e01080d$export$5d365d77acfcb55d).HARDCODED_VALUES,
                metadata: hardcodedMetadata
            };
        } else this.logger.verbose("Did not find endpoint metadata in hardcoded values... Attempting to get endpoint metadata from the network metadata cache.", this.correlationId);
        // Check cached metadata entity expiration status
        const metadataEntityExpired = (0, $4cd4d8a6d71d39a8$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntityExpired) {
            // No need to update
            this.logger.verbose("Found endpoint metadata in the cache.", "");
            return {
                source: (0, $8994aeee5e01080d$export$5d365d77acfcb55d).CACHE
            };
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.", "");
        return null;
    }
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ isAuthoritySameType(metadataEntity) {
        const cachedAuthorityUrl = new (0, $9c756a14a1bed5db$export$3abcdca7229e54f2)(metadataEntity.canonical_authority, this.correlationId);
        const cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    }
    /**
     * Parse authorityMetadata config option
     */ getEndpointMetadataFromConfig() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$edb4d5942bc8ccff), this.correlationId);
        }
        return null;
    }
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ async getEndpointMetadataFromNetwork() {
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ const openIdConfigurationEndpoint = this.defaultOpenIdConfigurationEndpoint;
        this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: attempting to retrieve OAuth endpoints from '${openIdConfigurationEndpoint}'`, this.correlationId);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(openIdConfigurationEndpoint, options);
            const isValidResponse = (0, $81f6e199bf36d728$export$aab44dc88900a3b)(response.body);
            if (isValidResponse) return response.body;
            else {
                this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: could not parse response as OpenID configuration`, this.correlationId);
                return null;
            }
        } catch (e) {
            this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: '${e}'`, this.correlationId);
            return null;
        }
    }
    /**
     * Get OAuth endpoints for common authorities.
     */ getEndpointMetadataFromHardcodedValues() {
        if (this.hostnameAndPort in (0, $e0b6bad51f2d7eeb$export$f612854287391207)) return (0, $e0b6bad51f2d7eeb$export$f612854287391207)[this.hostnameAndPort];
        return null;
    }
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */ async updateMetadataWithRegionalInformation(metadata) {
        const userConfiguredAzureRegion = this.authorityOptions.azureRegionConfiguration?.azureRegion;
        if (userConfiguredAzureRegion) {
            if (userConfiguredAzureRegion !== (0, $8994aeee5e01080d$export$243dfbda037eb091)) {
                this.regionDiscoveryMetadata.region_outcome = (0, $8994aeee5e01080d$export$92a685f9218422bd).CONFIGURED_NO_AUTO_DETECTION;
                this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                return $c05549f487bde715$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion, this.correlationId);
            }
            const autodetectedRegionName = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), (0, $0d9eb83114fc9425$export$e92f44766756a006), this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
            if (autodetectedRegionName) {
                this.regionDiscoveryMetadata.region_outcome = (0, $8994aeee5e01080d$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                return $c05549f487bde715$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, autodetectedRegionName, this.correlationId);
            }
            this.regionDiscoveryMetadata.region_outcome = (0, $8994aeee5e01080d$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_FAILED;
        }
        return metadata;
    }
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ async updateCloudDiscoveryMetadata(metadataEntity) {
        const localMetadataSource = this.updateCloudDiscoveryMetadataFromLocalSources(metadataEntity);
        if (localMetadataSource) return localMetadataSource;
        // Fallback to network as metadata source
        const metadata = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.getCloudDiscoveryMetadataFromNetwork.bind(this), (0, $0d9eb83114fc9425$export$efaa875fb2b18324), this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            (0, $4cd4d8a6d71d39a8$export$6d4972e1d88c8518)(metadataEntity, metadata, true);
            return (0, $8994aeee5e01080d$export$5d365d77acfcb55d).NETWORK;
        }
        // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$50c3162fda5f57), this.correlationId);
    }
    updateCloudDiscoveryMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get cloud discovery metadata from authority configuration", this.correlationId);
        this.logger.verbosePii(`Known Authorities: '${this.authorityOptions.knownAuthorities || (0, $8994aeee5e01080d$export$e8958a6508ec5b71)}'`, this.correlationId);
        this.logger.verbosePii(`Authority Metadata: '${this.authorityOptions.authorityMetadata || (0, $8994aeee5e01080d$export$e8958a6508ec5b71)}'`, this.correlationId);
        this.logger.verbosePii(`Canonical Authority: '${metadataEntity.canonical_authority || (0, $8994aeee5e01080d$export$e8958a6508ec5b71)}'`, this.correlationId);
        const metadata = this.getCloudDiscoveryMetadataFromConfig();
        if (metadata) {
            this.logger.verbose("Found cloud discovery metadata in authority configuration", this.correlationId);
            (0, $4cd4d8a6d71d39a8$export$6d4972e1d88c8518)(metadataEntity, metadata, false);
            return (0, $8994aeee5e01080d$export$5d365d77acfcb55d).CONFIG;
        }
        // If the cached metadata came from config but that config was not passed to this instance, we must go to hardcoded values
        this.logger.verbose("Did not find cloud discovery metadata in the config... Attempting to get cloud discovery metadata from the hardcoded values.", this.correlationId);
        const hardcodedMetadata = (0, $e0b6bad51f2d7eeb$export$1b1433f93c9873f)(this.hostnameAndPort);
        if (hardcodedMetadata) {
            this.logger.verbose("Found cloud discovery metadata from hardcoded values.", this.correlationId);
            (0, $4cd4d8a6d71d39a8$export$6d4972e1d88c8518)(metadataEntity, hardcodedMetadata, false);
            return (0, $8994aeee5e01080d$export$5d365d77acfcb55d).HARDCODED_VALUES;
        }
        this.logger.verbose("Did not find cloud discovery metadata in hardcoded values... Attempting to get cloud discovery metadata from the network metadata cache.", this.correlationId);
        const metadataEntityExpired = (0, $4cd4d8a6d71d39a8$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
            this.logger.verbose("Found cloud discovery metadata in the cache.", "");
            // No need to update
            return (0, $8994aeee5e01080d$export$5d365d77acfcb55d).CACHE;
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.", "");
        return null;
    }
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ getCloudDiscoveryMetadataFromConfig() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === (0, $2ac5a806251697eb$export$cd82032b224a3839).Ciam) {
            this.logger.verbose("CIAM authorities do not support cloud discovery metadata, generate the aliases from authority host.", this.correlationId);
            return $c05549f487bde715$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("The cloud discovery metadata has been provided as a network response, in the config.", this.correlationId);
            try {
                this.logger.verbose("Attempting to parse the cloud discovery metadata.", this.correlationId);
                const parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                const metadata = (0, $e0b6bad51f2d7eeb$export$6e21098ea6e60dc)(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("Parsed the cloud discovery metadata.", "");
                if (metadata) {
                    this.logger.verbose("There is returnable metadata attached to the parsed cloud discovery metadata.", this.correlationId);
                    return metadata;
                } else this.logger.verbose("There is no metadata attached to the parsed cloud discovery metadata.", this.correlationId);
            } catch (e) {
                this.logger.verbose("Unable to parse the cloud discovery metadata. Throwing Invalid Cloud Discovery Metadata Error.", this.correlationId);
                throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$92a2985751150ca5), this.correlationId);
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities(this.hostnameAndPort)) {
            this.logger.verbose("The host is included in knownAuthorities. Creating new cloud discovery metadata from the host.", this.correlationId);
            return $c05549f487bde715$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    }
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ async getCloudDiscoveryMetadataFromNetwork() {
        const instanceDiscoveryEndpoint = `${(0, $8994aeee5e01080d$export$e56648d3c1473424)}${this.canonicalAuthority}oauth2/v2.0/authorize`;
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ let match = null;
        try {
            const response = await this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options);
            let typedResponseBody;
            let metadata;
            if ((0, $ae1eaf93c5b21a8b$export$b288ea4a1e969e42)(response.body)) {
                typedResponseBody = response.body;
                metadata = typedResponseBody.metadata;
                this.logger.verbosePii(`tenant_discovery_endpoint is: '${typedResponseBody.tenant_discovery_endpoint}'`, this.correlationId);
            } else if ((0, $090fd57925a19904$export$6716273459d383f8)(response.body)) {
                this.logger.warning(`A CloudInstanceDiscoveryErrorResponse was returned. The cloud instance discovery network request's status code is: '${response.status}'`, this.correlationId);
                typedResponseBody = response.body;
                if (typedResponseBody.error === (0, $8994aeee5e01080d$export$1d8570e3a324589e)) {
                    this.logger.error("The CloudInstanceDiscoveryErrorResponse error is invalid_instance.", this.correlationId);
                    return null;
                }
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error is '${typedResponseBody.error}'`, this.correlationId);
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error description is '${typedResponseBody.error_description}'`, this.correlationId);
                this.logger.warning("Setting the value of the CloudInstanceDiscoveryMetadata (returned from the network, correlationId) to []", this.correlationId);
                metadata = [];
            } else {
                this.logger.error("AAD did not return a CloudInstanceDiscoveryResponse or CloudInstanceDiscoveryErrorResponse", this.correlationId);
                return null;
            }
            this.logger.verbose("Attempting to find a match between the developer's authority and the CloudInstanceDiscoveryMetadata returned from the network request.", this.correlationId);
            match = (0, $e0b6bad51f2d7eeb$export$6e21098ea6e60dc)(metadata, this.hostnameAndPort);
        } catch (error) {
            if (error instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) this.logger.error(`There was a network error while attempting to get the cloud discovery instance metadata.\nError: '${error.errorCode}'\nError Description: '${error.errorMessage}'`, this.correlationId);
            else {
                const typedError = error;
                this.logger.error(`A non-MSALJS error was thrown while attempting to get the cloud instance discovery metadata.\nError: '${typedError.name}'\nError Description: '${typedError.message}'`, this.correlationId);
            }
            return null;
        }
        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
        if (!match) {
            this.logger.warning("The developer's authority was not found within the CloudInstanceDiscoveryMetadata returned from the network request.", this.correlationId);
            this.logger.verbose("Creating custom Authority for custom domain scenario.", this.correlationId);
            match = $c05549f487bde715$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return match;
    }
    /**
     * Helper function to determine if a host is included in the knownAuthorities config option.
     */ isInKnownAuthorities(host) {
        const normalizedHost = host.toLowerCase();
        const matches = this.authorityOptions.knownAuthorities.filter((authority)=>{
            return authority && (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).getDomainFromUrl(authority, this.correlationId).toLowerCase() === normalizedHost;
        });
        return matches.length > 0;
    }
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ static generateAuthority(authorityString, azureCloudOptions) {
        let authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== (0, $1fba6bdc8b3011e3$export$4cda21933050d9ec).None) {
            const tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : (0, $8994aeee5e01080d$export$cf84b28865aad146);
            authorityAzureCloudInstance = `${azureCloudOptions.azureCloudInstance}/${tenant}/`;
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    }
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ static createCloudDiscoveryMetadataFromHost(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    }
    /**
     * helper function to generate environment from authority object
     */ getPreferredCache() {
        if (this.managedIdentity) return 0, $8994aeee5e01080d$export$ff29228a41d88890;
        else if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$c9fcc93738cc2bc3), this.correlationId);
    }
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ isAlias(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    }
    /**
     * Returns whether or not the provided host is an alias of a known Microsoft authority for purposes of endpoint discovery
     * @param host
     */ isAliasOfKnownMicrosoftAuthority(host) {
        return (0, $e0b6bad51f2d7eeb$export$7d026f079148cd31).has(host);
    }
    /**
     * Validates the `issuer` returned by an OIDC discovery document against
     * this authority, per
     * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfigurationValidation
     *
     * The issuer is accepted when ANY of the following holds:
     *  1. The issuer scheme + host + port match the authority's (path may
     *     differ). Applies to all authorities.
     *  2. The authority is a Microsoft cloud authority (public, sovereign,
     *     or CIAM), the issuer is HTTPS, and the issuer host is in the known
     *     Microsoft authority host set.
     *  3. Same as (2), but the issuer host is a single-label regional variant
     *     of a known Microsoft host (e.g. `westus.login.microsoftonline.com`).
     *  4. Same as (2), but the issuer host matches the CIAM tenant pattern
     *     `{tenant}.ciamlogin.com` with an optional `/{tenant}[.onmicrosoft.com][/v2.0]`
     *     path.
     *  5. The issuer host is HTTPS and is explicitly listed in the
     *     developer-configured `knownAuthorities`. This covers scenarios where
     *     the OIDC discovery document returns an issuer host that differs from
     *     the authority (e.g., a GUID-based issuer for a name-based CIAM authority).
     *
     * @param issuer The `issuer` value returned in the OIDC discovery document.
     * @throws ClientConfigurationError("issuer_validation_failed") on failure.
     */ validateIssuer(issuer) {
        if (!issuer) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$50a9c7532a41288a), this.correlationId);
        // Parse with the WHATWG URL API. URL normalizes scheme + host to lowercase per RFC 3986.
        let issuerUrl;
        try {
            issuerUrl = new URL(issuer);
        } catch  {
            throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$50a9c7532a41288a), this.correlationId);
        }
        const issuerScheme = issuerUrl.protocol;
        const issuerHost = issuerUrl.host;
        const authorityScheme = (this.canonicalAuthorityUrlComponents.Protocol || "").toLowerCase();
        const authorityHost = (this.canonicalAuthorityUrlComponents.HostNameAndPort || "").toLowerCase();
        // Rule 1: Same scheme and host
        const matchesAuthorityOrigin = this.matchesAuthorityOrigin(issuerScheme, issuerHost, authorityScheme, authorityHost);
        // Rule 2: The issuer host is a well-known Microsoft authority host (HTTPS only)
        const matchesKnownMicrosoftHost = issuerScheme === "https:" && this.isAliasOfKnownMicrosoftAuthority(issuerHost);
        /*
         * Rule 3: The issuer host is a regional variant ({region}.{host}) of a well-known host
         * (HTTPS only). E.g. westus2.login.microsoft.com
         */ const matchesRegionalMicrosoftHost = issuerScheme === "https:" && this.matchesRegionalMicrosoftHost(issuerHost);
        /*
         * Rule 4: CIAM-specific validation. In a CIAM scenario the issuer is expected to
         * have "{tenant}.ciamlogin.com" as the host, even when using a custom domain.
         */ const matchesCiamTenantPattern = this.matchesCiamTenantPattern(issuerUrl, authorityHost, this.canonicalAuthorityUrlComponents.PathSegments);
        /*
         * Rule 5: The issuer host is explicitly listed in the developer-configured
         * knownAuthorities. This covers scenarios where the OIDC discovery document
         * returns an issuer with a different host than the authority
         * (e.g., a GUID-based issuer for a name-based authority).
         */ const matchesKnownAuthority = issuerScheme === "https:" && this.isInKnownAuthorities(issuerHost);
        // Each rule is an independent boolean; the issuer is valid if ANY rule matches.
        if (matchesAuthorityOrigin || matchesKnownMicrosoftHost || matchesRegionalMicrosoftHost || matchesCiamTenantPattern || matchesKnownAuthority) return;
        // issuer validation fails if none of the above rules are satisfied
        throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$50a9c7532a41288a), this.correlationId);
    }
    /**
     * Rule 1: The issuer scheme + host (and port) match the authority's. Path
     * may differ. Applies to all authorities.
     */ matchesAuthorityOrigin(issuerScheme, issuerHost, authorityScheme, authorityHost) {
        return issuerScheme === authorityScheme && issuerHost === authorityHost;
    }
    /**
     * Rule 3: The issuer host is a regional variant
     * (`{region}.{host}`) of a known Microsoft authority host.
     * E.g. `westus2.login.microsoft.com`.
     */ matchesRegionalMicrosoftHost(issuerHost) {
        const firstDot = issuerHost.indexOf(".");
        if (firstDot > 0 && firstDot < issuerHost.length - 1) {
            const hostWithoutRegion = issuerHost.substring(firstDot + 1);
            return this.isAliasOfKnownMicrosoftAuthority(hostWithoutRegion);
        }
        return false;
    }
    /**
     * Rule 4: The issuer matches one of the well-known CIAM tenant patterns
     * (`https://{tenant}.ciamlogin.com[/{tenant}[.onmicrosoft.com][/v2.0]]`).
     *
     * The bare tenant name is extracted from the authority's first path segment
     * when available (stripping the `.onmicrosoft.com` suffix that
     * `transformCIAMAuthority` adds), or otherwise from the leftmost label of
     * the authority host (to support CIAM custom domain scenarios).
     *
     * Both `/{tenant}` and `/{tenant}.onmicrosoft.com` path forms are accepted
     * because the OIDC issuer may use either form depending on the authority URL
     * that was used to trigger discovery.
     */ matchesCiamTenantPattern(issuerUrl, authorityHost, authorityPathSegments) {
        /*
         * authorityPathSegments[0] is the first path segment of the *authority
         * URL* after transformCIAMAuthority runs (e.g. "contoso.onmicrosoft.com").
         * Additional CIAM issuer path segments such as "/v2.0" are part of the
         * issuer string, not the authority URL's PathSegments.
         */ const pathSegment = authorityPathSegments[0];
        /*
         * Extract the bare tenant name: strip the .onmicrosoft.com suffix when
         * present (introduced by transformCIAMAuthority), or fall back to the
         * first label of the authority hostname for non-transformed/custom-domain
         * CIAM authorities.
         */ const tenantName = pathSegment ? pathSegment.endsWith((0, $8994aeee5e01080d$export$8a15b376f6b2940)) ? pathSegment.slice(0, -(0, $8994aeee5e01080d$export$8a15b376f6b2940).length) : pathSegment : authorityHost.split(".")[0];
        if (!tenantName) return false;
        const ciamBaseURL = `https://${tenantName}${(0, $8994aeee5e01080d$export$ecbbba19d57055cd)}`;
        const validCiamPatterns = [
            ciamBaseURL,
            `${ciamBaseURL}/${tenantName}`,
            `${ciamBaseURL}/${tenantName}/v2.0`,
            `${ciamBaseURL}/${tenantName}${(0, $8994aeee5e01080d$export$8a15b376f6b2940)}`,
            `${ciamBaseURL}/${tenantName}${(0, $8994aeee5e01080d$export$8a15b376f6b2940)}/v2.0`
        ];
        /*
         * Compose the canonical issuer string from URL components and strip any
         * trailing slashes from the path so it can be compared to the pattern set.
         */ const issuerPath = issuerUrl.pathname.replace(/\/+$/, "");
        const normalizedIssuer = `${issuerUrl.protocol}//${issuerUrl.host}${issuerPath}`;
        return validCiamPatterns.some((pattern)=>pattern === normalizedIssuer);
    }
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ static isPublicCloudAuthority(host) {
        return (0, $8994aeee5e01080d$export$afcb83a97360adbc).indexOf(host) >= 0;
    }
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ static buildRegionalAuthorityString(host, region, correlationId, queryString) {
        // Create and validate a Url string object with the initial authority string
        const authorityUrlInstance = new (0, $9c756a14a1bed5db$export$3abcdca7229e54f2)(host, correlationId);
        authorityUrlInstance.validateAsUri();
        const authorityUrlParts = authorityUrlInstance.getUrlComponents();
        let hostNameAndPort = `${region}.${authorityUrlParts.HostNameAndPort}`;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = `${region}.${0, $8994aeee5e01080d$export$b85ac6323a66047}`;
        // Include the query string portion of the url
        const url = (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).constructAuthorityUriFromObject({
            ...authorityUrlInstance.getUrlComponents(),
            HostNameAndPort: hostNameAndPort
        }, correlationId).urlString;
        // Add the query string if a query string was provided
        if (queryString) return `${url}?${queryString}`;
        return url;
    }
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ static replaceWithRegionalInformation(metadata, azureRegion, correlationId) {
        const regionalMetadata = {
            ...metadata
        };
        regionalMetadata.authorization_endpoint = $c05549f487bde715$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.authorization_endpoint, azureRegion, correlationId);
        regionalMetadata.token_endpoint = $c05549f487bde715$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.token_endpoint, azureRegion, correlationId);
        if (regionalMetadata.end_session_endpoint) regionalMetadata.end_session_endpoint = $c05549f487bde715$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.end_session_endpoint, azureRegion, correlationId);
        return regionalMetadata;
    }
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ static transformCIAMAuthority(authority, correlationId) {
        let ciamAuthority = authority;
        const authorityUrl = new (0, $9c756a14a1bed5db$export$3abcdca7229e54f2)(authority, correlationId);
        const authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith((0, $8994aeee5e01080d$export$ecbbba19d57055cd))) {
            const tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = `${ciamAuthority}${tenantIdOrDomain}${0, $8994aeee5e01080d$export$8a15b376f6b2940}`;
        }
        return ciamAuthority;
    }
}
// Reserved tenant domain names that will not be replaced with tenant id
$c05549f487bde715$export$f1c6ec2e6d68c49c.reservedTenantDomains = new Set([
    "{tenant}",
    "{tenantid}",
    (0, $8994aeee5e01080d$export$3fd50d6e6941567f).COMMON,
    (0, $8994aeee5e01080d$export$3fd50d6e6941567f).CONSUMERS,
    (0, $8994aeee5e01080d$export$3fd50d6e6941567f).ORGANIZATIONS
]);
/**
 * Extract tenantId from authority
 */ function $c05549f487bde715$export$6ed5af33d279fbc7(authority, correlationId) {
    const authorityUrl = new (0, $9c756a14a1bed5db$export$3abcdca7229e54f2)(authority, correlationId);
    const authorityUrlComponents = authorityUrl.getUrlComponents();
    /**
     * For credential matching purposes, tenantId is the last path segment of the authority URL:
     *  AAD Authority - domain/tenantId -> Credentials are cached with realm = tenantId
     *  B2C Authority - domain/{tenantId}?/.../policy -> Credentials are cached with realm = policy
     *  tenantId is downcased because B2C policies can have mixed case but tfp claim is downcased
     *
     * Note that we may not have any path segments in certain OIDC scenarios.
     */ const tenantId = authorityUrlComponents.PathSegments.slice(-1)[0]?.toLowerCase();
    switch(tenantId){
        case (0, $8994aeee5e01080d$export$3fd50d6e6941567f).COMMON:
        case (0, $8994aeee5e01080d$export$3fd50d6e6941567f).ORGANIZATIONS:
        case (0, $8994aeee5e01080d$export$3fd50d6e6941567f).CONSUMERS:
            return undefined;
        default:
            return tenantId;
    }
}
function $c05549f487bde715$export$4030f3538167cb9e(authorityUri) {
    return authorityUri.endsWith((0, $8994aeee5e01080d$export$933cdf3ebd8cc149)) ? authorityUri : `${authorityUri}${0, $8994aeee5e01080d$export$933cdf3ebd8cc149}`;
}
function $c05549f487bde715$export$2b9ebf6f25078cc0(authOptions) {
    const rawCloudDiscoveryMetadata = authOptions.cloudDiscoveryMetadata;
    let cloudDiscoveryMetadata = undefined;
    if (rawCloudDiscoveryMetadata) try {
        cloudDiscoveryMetadata = JSON.parse(rawCloudDiscoveryMetadata);
    } catch (e) {
        throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$92a2985751150ca5), "");
    }
    return {
        canonicalAuthority: authOptions.authority ? $c05549f487bde715$export$4030f3538167cb9e(authOptions.authority) : undefined,
        knownAuthorities: authOptions.knownAuthorities,
        cloudDiscoveryMetadata: cloudDiscoveryMetadata
    };
}

/*! @azure/msal-common v16.11.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $842f61e187fdf563$export$865f57d401606752 = {
    createNewGuid: ()=>{
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    },
    base64Decode: ()=>{
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    },
    base64Encode: ()=>{
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    },
    base64UrlEncode: ()=>{
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    },
    encodeKid: ()=>{
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    },
    async getPublicKeyThumbprint () {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    },
    async removeTokenBindingKey () {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    },
    async clearKeystore () {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    },
    async signJwt () {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    },
    async hashString () {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
};

/*! @azure/msal-common v16.11.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Helper to enforce resource parameter presence in token requests when isMcp is set in the configuration.
 * If resource parameter is set in both the request and in extraQueryParameters or extraParameters, an error will be thrown.
 * This is used for MCP flows.
 * @param isMcp - Flag indicating if application is an MCP app, from configuration
 * @param request - Auth request
 */ function $8451db0dd4949b5f$export$df47a28b08fa2370(isMcp, request) {
    if (!isMcp) return;
    if (request.resource && ($8451db0dd4949b5f$var$containsResourceParam(request.extraParameters) || $8451db0dd4949b5f$var$containsResourceParam(request.extraQueryParameters))) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$b4ecff4fd4f67ea0), request.correlationId || "");
    if (!request.resource) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$17a59a33a4e9e5f7), request.correlationId || "");
}
function $8451db0dd4949b5f$var$containsResourceParam(params) {
    if (!params) return false;
    return Object.prototype.hasOwnProperty.call(params, "resource");
}

/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $1a839cf816c84c9b$export$2daa8cfcf54c2b48(clientId, request, homeAccountId) {
    return {
        clientId: clientId,
        authority: request.authority,
        scopes: request.scopes,
        homeAccountIdentifier: homeAccountId,
        claims: request.claims,
        authenticationScheme: request.authenticationScheme,
        resourceRequestMethod: request.resourceRequestMethod,
        resourceRequestUri: request.resourceRequestUri,
        shrClaims: request.shrClaims,
        sshKid: request.sshKid,
        embeddedClientId: request.embeddedClientId || request.extraParameters?.clientId,
        resource: request.resource
    };
}

/*! @azure/msal-common v16.11.0 2026-06-30 */ 
var $65a17b77f45cb3f9$exports = {};

$parcel$export($65a17b77f45cb3f9$exports, "noTokensFound", () => $65a17b77f45cb3f9$export$e408b083cd212696);
$parcel$export($65a17b77f45cb3f9$exports, "nativeAccountUnavailable", () => $65a17b77f45cb3f9$export$3bf2eb3358f5f570);
$parcel$export($65a17b77f45cb3f9$exports, "refreshTokenExpired", () => $65a17b77f45cb3f9$export$a90e8b9c10991b49);
$parcel$export($65a17b77f45cb3f9$exports, "uiNotAllowed", () => $65a17b77f45cb3f9$export$9cf2978f6906b604);
$parcel$export($65a17b77f45cb3f9$exports, "interactionRequired", () => $65a17b77f45cb3f9$export$cdb77bf88e749c31);
$parcel$export($65a17b77f45cb3f9$exports, "consentRequired", () => $65a17b77f45cb3f9$export$ca4e8d96d12fe4c5);
$parcel$export($65a17b77f45cb3f9$exports, "loginRequired", () => $65a17b77f45cb3f9$export$402ebc0f96d7decb);
$parcel$export($65a17b77f45cb3f9$exports, "badToken", () => $65a17b77f45cb3f9$export$2e3666c77d45a4da);
$parcel$export($65a17b77f45cb3f9$exports, "interruptedUser", () => $65a17b77f45cb3f9$export$54dc2de0f2617e03);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * MSAL-defined interaction required error code indicating no tokens are found in cache.
 * @public
 */ const $65a17b77f45cb3f9$export$e408b083cd212696 = "no_tokens_found";
/**
 * MSAL-defined error code indicating a native account is unavailable on the platform.
 * @public
 */ const $65a17b77f45cb3f9$export$3bf2eb3358f5f570 = "native_account_unavailable";
/**
 * MSAL-defined error code indicating the refresh token has expired and user interaction is needed.
 * @public
 */ const $65a17b77f45cb3f9$export$a90e8b9c10991b49 = "refresh_token_expired";
/**
 * MSAL-defined error code indicating UI/UX is not allowed (e.g., blocked by policy), requiring alternate interaction.
 * @public
 */ const $65a17b77f45cb3f9$export$9cf2978f6906b604 = "ui_not_allowed";
/**
 * Server-originated error code indicating interaction is required to complete the request.
 * @public
 */ const $65a17b77f45cb3f9$export$cdb77bf88e749c31 = "interaction_required";
/**
 * Server-originated error code indicating user consent is required.
 * @public
 */ const $65a17b77f45cb3f9$export$ca4e8d96d12fe4c5 = "consent_required";
/**
 * Server-originated error code indicating user login is required.
 * @public
 */ const $65a17b77f45cb3f9$export$402ebc0f96d7decb = "login_required";
/**
 * Server-originated error code indicating the token is invalid or corrupted.
 * @public
 */ const $65a17b77f45cb3f9$export$2e3666c77d45a4da = "bad_token";
/**
 * Server-originated error code indicating the user is in an interrupted state and interaction is required.
 * @public
 */ const $65a17b77f45cb3f9$export$54dc2de0f2617e03 = "interrupted_user";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ const $e9bbb17645bd3149$export$e16d6a6c677acec5 = [
    (0, $65a17b77f45cb3f9$export$cdb77bf88e749c31),
    (0, $65a17b77f45cb3f9$export$ca4e8d96d12fe4c5),
    (0, $65a17b77f45cb3f9$export$402ebc0f96d7decb),
    (0, $65a17b77f45cb3f9$export$2e3666c77d45a4da),
    (0, $65a17b77f45cb3f9$export$9cf2978f6906b604),
    (0, $65a17b77f45cb3f9$export$54dc2de0f2617e03)
];
const $e9bbb17645bd3149$export$9689959ec6716811 = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required",
    "bad_token",
    "ui_not_allowed",
    "interrupted_user"
];
/**
 * Error thrown when user interaction is required.
 */ class $e9bbb17645bd3149$export$6ba3e818c6bc76ba extends (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) {
    constructor(errorCode, correlationId, errorMessage, subError, timestamp, traceId, claims, errorNo){
        super(errorCode, correlationId, errorMessage, subError);
        Object.setPrototypeOf(this, $e9bbb17645bd3149$export$6ba3e818c6bc76ba.prototype);
        this.timestamp = timestamp || "";
        this.traceId = traceId || "";
        this.claims = claims || "";
        this.name = "InteractionRequiredAuthError";
        this.errorNo = errorNo;
    }
}
/**
 * Helper function used to determine if an error thrown by the server requires interaction to resolve
 * @param errorCode
 * @param errorString
 * @param subError
 */ function $e9bbb17645bd3149$export$376c3c4c19cb933a(errorCode, errorString, subError) {
    const isInteractionRequiredErrorCode = !!errorCode && $e9bbb17645bd3149$export$e16d6a6c677acec5.indexOf(errorCode) > -1;
    const isInteractionRequiredSubError = !!subError && $e9bbb17645bd3149$export$9689959ec6716811.indexOf(subError) > -1;
    const isInteractionRequiredErrorDesc = !!errorString && $e9bbb17645bd3149$export$e16d6a6c677acec5.some((irErrorCode)=>{
        return errorString.indexOf(irErrorCode) > -1;
    });
    return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
}
/**
 * Creates an InteractionRequiredAuthError
 */ function $e9bbb17645bd3149$export$8f7a741750c16535(errorCode, correlationId, errorMessage) {
    return new $e9bbb17645bd3149$export$6ba3e818c6bc76ba(errorCode, correlationId, errorMessage);
}



/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * acquireTokenSilent API (msal-browser and msal-node).
 * Used to silently acquire a new access token (from the cache or the network).
 */ const $65145b346c45554a$export$ef5b8273b1c66495 = "acquireTokenSilent";
/**
 * acquireTokenByCode API (msal-browser and msal-node).
 * Used to acquire tokens by trading an authorization code against the token endpoint.
 */ const $65145b346c45554a$export$8535c832f2be2140 = "acquireTokenByCode";
/**
 * acquireTokenPopup (msal-browser).
 * Used to acquire a new access token interactively through pop ups
 */ const $65145b346c45554a$export$8eece1dda35ee9eb = "acquireTokenPopup";
/**
 * acquireTokenPreRedirect (msal-browser).
 * First part of the redirect flow.
 * Used to acquire a new access token interactively through redirects.
 */ const $65145b346c45554a$export$affbf361bd01dc11 = "acquireTokenPreRedirect";
/**
 * acquireTokenRedirect (msal-browser).
 * Second part of the redirect flow.
 * Used to acquire a new access token interactively through redirects.
 */ const $65145b346c45554a$export$8fbc8506f7dfc43c = "acquireTokenRedirect";
/**
 * ssoSilent API (msal-browser).
 * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
 */ const $65145b346c45554a$export$2da6f47a70635e40 = "ssoSilent";
// Initialize client application
const $65145b346c45554a$export$ebaff939a81dcf2b = "initializeClientApplication";
// Update cache storage
const $65145b346c45554a$export$cac8f5c791e30935 = "localStorageUpdated";
// Load external tokens
const $65145b346c45554a$export$b67c243106370b59 = "loadExternalTokens";
/**
 * SSO capability verification call (msal-browser).
 * Fire-and-forget SSO verification call made after interactive authentication completes.
 */ const $65145b346c45554a$export$7caf697918d46b97 = "ssoCapable";
// Wait for late response from bridge after timeout has already occurred
const $65145b346c45554a$export$d9fd8b66da5a3a9a = "waitForBridgeLateResponse";


/*! @azure/msal-browser v5.16.0 2026-06-30 */ /*! @azure/msal-common v16.11.0 2026-06-30 */ var $faceeef73c915a1b$exports = {};

$parcel$export($faceeef73c915a1b$exports, "cacheQuotaExceeded", () => $faceeef73c915a1b$export$e55c8be2f026d30a);
$parcel$export($faceeef73c915a1b$exports, "cacheErrorUnknown", () => $faceeef73c915a1b$export$6f650427f72a7890);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $faceeef73c915a1b$export$e55c8be2f026d30a = "cache_quota_exceeded";
const $faceeef73c915a1b$export$6f650427f72a7890 = "cache_error_unknown";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the cache
 */ class $7cf95cc28691dd17$export$78ff06e91c3de382 extends Error {
    constructor(errorCode, errorMessage){
        const message = errorMessage || (0, $8d1fc9917b2c0dac$export$714f3eb4b9ca37c5)(errorCode);
        super(message);
        Object.setPrototypeOf(this, $7cf95cc28691dd17$export$78ff06e91c3de382.prototype);
        this.name = "CacheError";
        this.errorCode = errorCode;
        this.errorMessage = message;
    }
}
/**
 * Helper function to wrap browser errors in a CacheError object
 * @param e
 * @returns
 */ function $7cf95cc28691dd17$export$2056718aee1b1d88(e) {
    if (!(e instanceof Error)) return new $7cf95cc28691dd17$export$78ff06e91c3de382((0, $faceeef73c915a1b$export$6f650427f72a7890));
    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.message.includes("exceeded the quota")) return new $7cf95cc28691dd17$export$78ff06e91c3de382((0, $faceeef73c915a1b$export$e55c8be2f026d30a));
    else return new $7cf95cc28691dd17$export$78ff06e91c3de382(e.name, e.message);
}

/*! @azure/msal-common v16.11.0 2026-06-30 */ 





/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/* eslint-disable header/header */ const $8da2d5e621fbe87e$export$a8ff84c12d48cfa6 = "@azure/msal-common";
const $8da2d5e621fbe87e$export$83d89fbfd8236492 = "16.11.0";


/*! @azure/msal-common v16.11.0 2026-06-30 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ class $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99 {
    constructor(inputScopes, correlationId){
        this.correlationId = correlationId;
        // Filter empty string and null/undefined array items
        const scopeArr = inputScopes ? (0, $4204b6e4994e8227$export$ecc754f99843e759).trimArrayEntries([
            ...inputScopes
        ]) : [];
        const filteredInput = scopeArr ? (0, $4204b6e4994e8227$export$ecc754f99843e759).removeEmptyStringsFromArray(scopeArr) : [];
        // Check if scopes array has at least one member
        if (!filteredInput || !filteredInput.length) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$6ac27379c42383f), correlationId);
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach((scope)=>this.scopes.add(scope));
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ static fromString(inputScopeString, correlationId) {
        const scopeString = inputScopeString || "";
        const inputScopes = scopeString.split(" ");
        return new $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99(inputScopes, correlationId);
    }
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ static createSearchScopes(inputScopeString, correlationId) {
        // Handle empty scopes by using default OIDC scopes for cache lookup
        const scopesToUse = inputScopeString && inputScopeString.length > 0 ? inputScopeString : [
            ...(0, $8994aeee5e01080d$export$893b1b5b686d84ef)
        ];
        const scopeSet = new $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99(scopesToUse, correlationId);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope((0, $8994aeee5e01080d$export$b281676656f67eb4));
        return scopeSet;
    }
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ containsScope(scope) {
        const lowerCaseScopes = this.printScopesLowerCase().split(" ");
        const lowerCaseScopesSet = new $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99(lowerCaseScopes, this.correlationId);
        // compare lowercase scopes
        return scope ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    }
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ containsScopeSet(scopeSet) {
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every((scope)=>this.containsScope(scope));
    }
    /**
     * Check if set of scopes contains only the defaults
     */ containsOnlyOIDCScopes() {
        let defaultScopeCount = 0;
        (0, $8994aeee5e01080d$export$268e88275f5afab2).forEach((defaultScope)=>{
            if (this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    }
    /**
     * Appends single scope if passed
     * @param newScope
     */ appendScope(newScope) {
        if (newScope) this.scopes.add(newScope.trim());
    }
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ appendScopes(newScopes) {
        try {
            newScopes.forEach((newScope)=>this.appendScope(newScope));
        } catch (e) {
            throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$93883786cf4a4a27), this.correlationId);
        }
    }
    /**
     * Removes element from set of scopes.
     * @param scope
     */ removeScope(scope) {
        if (!scope) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$f7a276c01beb068a), this.correlationId);
        this.scopes.delete(scope.trim());
    }
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ removeOIDCScopes() {
        (0, $8994aeee5e01080d$export$268e88275f5afab2).forEach((defaultScope)=>{
            this.scopes.delete(defaultScope);
        });
    }
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ unionScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$41e2ce5958c42c83), this.correlationId);
        const unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        this.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        return unionScopes;
    }
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ intersectingScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$41e2ce5958c42c83), this.correlationId);
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        const unionScopes = this.unionScopeSets(otherScopes);
        const sizeOtherScopes = otherScopes.getScopeCount();
        const sizeThisScopes = this.getScopeCount();
        const sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    }
    /**
     * Returns size of set of scopes.
     */ getScopeCount() {
        return this.scopes.size;
    }
    /**
     * Returns the scopes as an array of string values
     */ asArray() {
        const array = [];
        this.scopes.forEach((val)=>array.push(val));
        return array;
    }
    /**
     * Prints scopes into a space-delimited string
     */ printScopes() {
        if (this.scopes) {
            const scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return "";
    }
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ printScopesLowerCase() {
        return this.printScopes().toLowerCase();
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 * @internal
 */ class $a087c4e9d9c3e8cc$export$996e3ea69314b5c6 {
    constructor(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions){
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.commonLogger = logger.clone((0, $8da2d5e621fbe87e$export$a8ff84c12d48cfa6), (0, $8da2d5e621fbe87e$export$83d89fbfd8236492));
        this.staticAuthorityOptions = staticAuthorityOptions;
        this.performanceClient = performanceClient;
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter = {}, correlationId) {
        return this.buildTenantProfiles(this.getAccountsFilteredBy(accountFilter, correlationId), correlationId, accountFilter);
    }
    /**
     * Gets first tenanted AccountInfo object found based on provided filters
     */ getAccountInfoFilteredBy(accountFilter, correlationId) {
        if (Object.keys(accountFilter).length === 0 || Object.values(accountFilter).every((value)=>value === null || value === undefined || value === "")) {
            this.commonLogger.warning("getAccountInfoFilteredBy: Account filter is empty or invalid, returning null", correlationId);
            return null;
        }
        const allAccounts = this.getAllAccounts(accountFilter, correlationId);
        if (allAccounts.length > 1) {
            // If one or more accounts are found, prioritize accounts that have an ID token
            const sortedAccounts = allAccounts.sort((a, b)=>{
                const aHasClaims = a.idTokenClaims ? 1 : 0;
                const bHasClaims = b.idTokenClaims ? 1 : 0;
                return bHasClaims - aHasClaims;
            });
            return sortedAccounts[0];
        } else if (allAccounts.length === 1) // If only one account is found, return it regardless of whether a matching ID token was found
        return allAccounts[0];
        else return null;
    }
    /**
     * Returns a single matching
     * @param accountFilter
     * @returns
     */ getBaseAccountInfo(accountFilter, correlationId) {
        const accountEntities = this.getAccountsFilteredBy(accountFilter, correlationId);
        if (accountEntities.length > 0) return (0, $f136bee61a3373e4$export$ec68416fe40418db)(accountEntities[0]);
        else return null;
    }
    /**
     * Matches filtered account entities with cached ID tokens that match the tenant profile-specific account filters
     * and builds the account info objects from the matching ID token's claims
     * @param cachedAccounts
     * @param accountFilter
     * @returns Array of AccountInfo objects that match account and tenant profile filters
     */ buildTenantProfiles(cachedAccounts, correlationId, accountFilter) {
        return cachedAccounts.flatMap((accountEntity)=>{
            return this.getTenantProfilesFromAccountEntity(accountEntity, correlationId, accountFilter?.tenantId, accountFilter);
        });
    }
    getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter) {
        let tenantedAccountInfo = null;
        let idTokenClaims;
        if (tenantProfileFilter) {
            if (!this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter)) return null;
        }
        const idToken = this.getIdToken(accountInfo, correlationId, tokenKeys, tenantProfile.tenantId);
        if (idToken) {
            idTokenClaims = (0, $4acd0486289e3b4f$export$8a59e6f35fb00518)(idToken.secret, this.cryptoImpl.base64Decode, correlationId);
            if (!this.idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter)) // ID token sourced claims don't match so this tenant profile is not a match
            return null;
        }
        // Expand tenant profile into account info based on matching tenant profile and if available matching ID token claims
        tenantedAccountInfo = (0, $7beee762cc5bd6b9$export$452a054c78b83dad)(accountInfo, tenantProfile, idTokenClaims, idToken?.secret);
        return tenantedAccountInfo;
    }
    getTenantProfilesFromAccountEntity(accountEntity, correlationId, targetTenantId, tenantProfileFilter) {
        const accountInfo = (0, $f136bee61a3373e4$export$ec68416fe40418db)(accountEntity);
        let searchTenantProfiles = accountInfo.tenantProfiles || new Map();
        const tokenKeys = this.getTokenKeys();
        // If a tenant ID was provided, only return the tenant profile for that tenant ID if it exists
        if (targetTenantId) {
            const tenantProfile = searchTenantProfiles.get(targetTenantId);
            if (tenantProfile) // Reduce search field to just this tenant profile
            searchTenantProfiles = new Map([
                [
                    targetTenantId,
                    tenantProfile
                ]
            ]);
            else // No tenant profile for search tenant ID, return empty array
            return [];
        }
        const matchingTenantProfiles = [];
        searchTenantProfiles.forEach((tenantProfile)=>{
            const tenantedAccountInfo = this.getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter);
            if (tenantedAccountInfo) matchingTenantProfiles.push(tenantedAccountInfo);
        });
        return matchingTenantProfiles;
    }
    tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter) {
        if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTenantProfile(tenantProfile, tenantProfileFilter.localAccountId)) return false;
        if (!!tenantProfileFilter.name && !(tenantProfile.name === tenantProfileFilter.name)) return false;
        if (tenantProfileFilter.isHomeTenant !== undefined && !(tenantProfile.isHomeTenant === tenantProfileFilter.isHomeTenant)) return false;
        if (!!tenantProfileFilter.username && !this.matchUsername(tenantProfile.username, tenantProfileFilter.username) && !this.matchUsername(tenantProfile.upn, tenantProfileFilter.username)) return false;
        if (!!tenantProfileFilter.loginHint && !this.matchLoginHintWithTenantProfile(tenantProfile, tenantProfileFilter.loginHint)) return false;
        if (!!tenantProfileFilter.upn && !(tenantProfile.upn === tenantProfileFilter.upn)) return false;
        if (!!tenantProfileFilter.nativeAccountId && tenantProfile.nativeAccountId !== tenantProfileFilter.nativeAccountId) return false;
        return true;
    }
    idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter) {
        // Tenant Profile filtering
        if (tenantProfileFilter) {
            if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTokenClaims(idTokenClaims, tenantProfileFilter.localAccountId)) return false;
            if (!!tenantProfileFilter.loginHint && !this.matchLoginHintFromTokenClaims(idTokenClaims, tenantProfileFilter.loginHint)) return false;
            if (!!tenantProfileFilter.username && !this.matchUsername(idTokenClaims.preferred_username, tenantProfileFilter.username) && !this.matchUsername(idTokenClaims.upn, tenantProfileFilter.username)) return false;
            if (!!tenantProfileFilter.name && !this.matchName(idTokenClaims, tenantProfileFilter.name)) return false;
            if (!!tenantProfileFilter.sid && !this.matchSid(idTokenClaims, tenantProfileFilter.sid)) return false;
        }
        return true;
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache) {
        if (!cacheRecord) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$d396103576f879cc), correlationId);
        try {
            if (!!cacheRecord.account) await this.setAccount(cacheRecord.account, correlationId, kmsi, apiId);
            if (!!cacheRecord.idToken && storeInCache?.idToken !== false) await this.setIdTokenCredential(cacheRecord.idToken, correlationId, kmsi);
            if (!!cacheRecord.accessToken && storeInCache?.accessToken !== false) await this.saveAccessToken(cacheRecord.accessToken, correlationId, kmsi);
            if (!!cacheRecord.refreshToken && storeInCache?.refreshToken !== false) await this.setRefreshTokenCredential(cacheRecord.refreshToken, correlationId, kmsi);
            if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata, correlationId);
        } catch (e) {
            this.commonLogger?.error(`CacheManager.saveCacheRecord: failed`, correlationId);
            if (e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) throw e;
            else throw (0, $7cf95cc28691dd17$export$2056718aee1b1d88)(e);
        }
    }
    /**
     * saves access token credential
     * @param credential
     */ async saveAccessToken(credential, correlationId, kmsi) {
        const accessTokenFilter = {
            clientId: credential.clientId,
            credentialType: credential.credentialType,
            environment: credential.environment,
            homeAccountId: credential.homeAccountId,
            realm: credential.realm,
            tokenType: credential.tokenType
        };
        const tokenKeys = this.getTokenKeys();
        const currentScopes = (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99).fromString(credential.target, correlationId);
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
            const tokenEntity = this.getAccessTokenCredential(key, correlationId);
            if (tokenEntity && this.credentialMatchesFilter(tokenEntity, accessTokenFilter, correlationId)) {
                const tokenScopeSet = (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99).fromString(tokenEntity.target, correlationId);
                if (tokenScopeSet.intersectingScopeSets(currentScopes)) this.removeAccessToken(key, correlationId);
            }
        });
        await this.setAccessTokenCredential(credential, correlationId, kmsi);
    }
    /**
     * Retrieve account entities matching all provided tenant-agnostic filters; if no filter is set, get all account entities in the cache
     * Not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param accountFilter - An object containing Account properties to filter by
     */ getAccountsFilteredBy(accountFilter, correlationId) {
        const allAccountKeys = this.getAccountKeys();
        const matchingAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            const entity = this.getAccount(cacheKey, correlationId);
            // Match base account fields
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.environment && !this.matchEnvironment(entity, accountFilter.environment, correlationId)) return;
            if (!!accountFilter.realm && !this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.authorityType && !this.matchAuthorityType(entity, accountFilter.authorityType)) return;
            // If at least one tenant profile matches the tenant profile filter, add the account to the list of matching accounts
            const tenantProfileFilter = {
                localAccountId: accountFilter?.localAccountId,
                name: accountFilter?.name,
                username: accountFilter?.username,
                loginHint: accountFilter?.loginHint,
                upn: accountFilter?.upn,
                nativeAccountId: accountFilter?.nativeAccountId
            };
            const matchingTenantProfiles = entity.tenantProfiles?.filter((tenantProfile)=>{
                return this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter);
            });
            if (matchingTenantProfiles && matchingTenantProfiles.length === 0) // No tenant profile for this account matches filter, don't add to list of matching accounts
            return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    }
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @param correlationId
     * @returns
     */ credentialMatchesFilter(entity, filter, correlationId) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment, correlationId)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target, correlationId)) return false;
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
            // KeyId (sshKid) in request must match cached SSH certificate keyId because SSH cert is bound to a specific key
            if (filter.tokenType === (0, $8994aeee5e01080d$export$901491a717da2ba5).SSH) {
                if (filter.keyId && !this.matchKeyId(entity, filter.keyId)) return false;
            }
        }
        // Additional cache key components matching (bidirectional isolation)
        const entityComponents = entity.additionalCacheKeyComponents;
        const filterComponents = filter.additionalCacheKeyComponents;
        const entityHasComponents = !!entityComponents && Object.keys(entityComponents).length > 0;
        const filterHasComponents = !!filterComponents && Object.keys(filterComponents).length > 0;
        if (entityHasComponents !== filterHasComponents) return false;
        if (entityHasComponents && filterHasComponents) {
            const entityKeys = Object.keys(entityComponents).sort();
            const filterKeys = Object.keys(filterComponents).sort();
            if (entityKeys.length !== filterKeys.length) return false;
            for(let i = 0; i < entityKeys.length; i++){
                if (entityKeys[i] !== filterKeys[i] || entityComponents[entityKeys[i]] !== filterComponents[filterKeys[i]]) return false;
            }
        }
        return true;
    }
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     * @param correlationId
     */ getAppMetadataFilteredBy(filter, correlationId) {
        const allCacheKeys = this.getKeys();
        const matchingAppMetadata = {};
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-appMetadata type cache entities
            if (!this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            const entity = this.getAppMetadata(cacheKey, correlationId);
            if (!entity) return;
            if (!!filter.environment && !this.matchEnvironment(entity, filter.environment, correlationId)) return;
            if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    }
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param host
     * @param correlationId
     */ getAuthorityMetadataByAlias(host, correlationId) {
        const allCacheKeys = this.getAuthorityMetadataKeys();
        let matchedEntity = null;
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-authorityMetadata type cache entities
            if (!this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(this.clientId) === -1) return;
            // Attempt retrieval
            const entity = this.getAuthorityMetadata(cacheKey, correlationId);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    }
    /**
     * Removes all accounts and related tokens from cache.
     */ removeAllAccounts(correlationId) {
        const accounts = this.getAllAccounts({}, correlationId);
        accounts.forEach((account)=>{
            this.removeAccount(account, correlationId);
        });
    }
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ removeAccount(account, correlationId) {
        this.removeAccountContext(account, correlationId);
        const accountKeys = this.getAccountKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        accountKeys.filter(keyFilter).forEach((key)=>{
            this.removeItem(key, correlationId);
            this.performanceClient.incrementFields({
                accountsRemoved: 1
            }, correlationId);
        });
    }
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ removeAccountContext(account, correlationId) {
        const allTokenKeys = this.getTokenKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        allTokenKeys.idToken.filter(keyFilter).forEach((key)=>{
            this.removeIdToken(key, correlationId);
        });
        allTokenKeys.accessToken.filter(keyFilter).forEach((key)=>{
            this.removeAccessToken(key, correlationId);
        });
        allTokenKeys.refreshToken.filter(keyFilter).forEach((key)=>{
            this.removeRefreshToken(key, correlationId);
        });
    }
    /**
     * returns a boolean if the given credential is removed
     * @param key
     * @param correlationId
     */ removeAccessToken(key, correlationId) {
        const credential = this.getAccessTokenCredential(key, correlationId);
        if (!credential) return;
        this.removeItem(key, correlationId);
        this.performanceClient.incrementFields({
            accessTokensRemoved: 1
        }, correlationId);
        // Remove Token Binding Key from key store for PoP Tokens Credentials
        if (credential.credentialType.toLowerCase() === (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) {
            if (credential.tokenType === (0, $8994aeee5e01080d$export$901491a717da2ba5).POP) {
                const accessTokenWithAuthSchemeEntity = credential;
                const kid = accessTokenWithAuthSchemeEntity.keyId;
                if (kid) this.cryptoImpl.removeTokenBindingKey(kid, correlationId).catch(()=>{
                    this.commonLogger.error(`Failed to remove token binding key '${kid}'`, correlationId);
                    this.performanceClient?.incrementFields({
                        removeTokenBindingKeyFailure: 1
                    }, correlationId);
                });
            }
        }
    }
    /**
     * Removes all app metadata objects from cache.
     */ removeAppMetadata(correlationId) {
        const allCacheKeys = this.getKeys();
        allCacheKeys.forEach((cacheKey)=>{
            if (this.isAppMetadata(cacheKey)) this.removeItem(cacheKey, correlationId);
        });
        return true;
    }
    /**
     * Retrieve IdTokenEntity from cache
     * @param account {AccountInfo}
     * @param tokenKeys {?TokenKeys}
     * @param targetRealm {?string}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getIdToken(account, correlationId, tokenKeys, targetRealm) {
        this.commonLogger.trace("CacheManager - getIdToken called", correlationId);
        const idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ID_TOKEN,
            clientId: this.clientId,
            realm: targetRealm
        };
        const idTokenMap = this.getIdTokensByFilter(idTokenFilter, correlationId, tokenKeys);
        const numIdTokens = idTokenMap.size;
        if (numIdTokens < 1) {
            this.commonLogger.info("CacheManager:getIdToken - No token found", correlationId);
            return null;
        } else if (numIdTokens > 1) {
            let tokensToBeRemoved = idTokenMap;
            // Multiple tenant profiles and no tenant specified, pick home account
            if (!targetRealm) {
                const homeIdTokenMap = new Map();
                idTokenMap.forEach((idToken, key)=>{
                    if (idToken.realm === account.tenantId) homeIdTokenMap.set(key, idToken);
                });
                const numHomeIdTokens = homeIdTokenMap.size;
                if (numHomeIdTokens < 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account but none match account entity tenant id, returning first result", correlationId);
                    return idTokenMap.values().next().value ?? null;
                } else if (numHomeIdTokens === 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account, defaulting to home tenant profile", correlationId);
                    return homeIdTokenMap.values().next().value ?? null;
                } else // Multiple ID tokens for home tenant profile, remove all and return null
                tokensToBeRemoved = homeIdTokenMap;
            }
            // Multiple tokens for a single tenant profile, remove all and return null
            this.commonLogger.info("CacheManager:getIdToken - Multiple matching ID tokens found, clearing them", correlationId);
            tokensToBeRemoved.forEach((idToken, key)=>{
                this.removeIdToken(key, correlationId);
            });
            this.performanceClient.addFields({
                multiMatchedID: idTokenMap.size
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getIdToken - Returning ID token", correlationId);
        return idTokenMap.values().next().value ?? null;
    }
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ getIdTokensByFilter(filter, correlationId, tokenKeys) {
        const idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        const idTokens = new Map();
        idTokenKeys.forEach((key)=>{
            if (!this.idTokenKeyMatchesFilter(key, {
                clientId: this.clientId,
                ...filter
            })) return;
            const idToken = this.getIdTokenCredential(key, correlationId);
            if (idToken && this.credentialMatchesFilter(idToken, filter, correlationId)) idTokens.set(key, idToken);
        });
        return idTokens;
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ idTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Removes idToken from the cache
     * @param key
     */ removeIdToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Removes refresh token from the cache
     * @param key
     */ removeRefreshToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Retrieve AccessTokenEntity from cache
     * @param account {AccountInfo}
     * @param request {BaseAuthRequest}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     */ getAccessToken(account, request, tokenKeys, targetRealm) {
        const correlationId = request.correlationId;
        this.commonLogger.trace("CacheManager - getAccessToken called", correlationId);
        const scopes = (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99).createSearchScopes(request.scopes, correlationId);
        const authScheme = request.authenticationScheme || (0, $8994aeee5e01080d$export$901491a717da2ba5).BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ const credentialType = authScheme && authScheme.toLowerCase() !== (0, $8994aeee5e01080d$export$901491a717da2ba5).BEARER.toLowerCase() ? (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME : (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ACCESS_TOKEN;
        const accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: targetRealm || account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: request.sshKid
        };
        const accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        const accessTokens = [];
        accessTokenKeys.forEach((key)=>{
            // Validate key
            if (this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                const accessToken = this.getAccessTokenCredential(key, correlationId);
                // Validate value
                if (accessToken && this.credentialMatchesFilter(accessToken, accessTokenFilter, correlationId)) accessTokens.push(accessToken);
            }
        });
        const numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            this.commonLogger.info("CacheManager:getAccessToken - No token found", correlationId);
            return null;
        } else if (numAccessTokens > 1) {
            this.commonLogger.info("CacheManager:getAccessToken - Multiple access tokens found, clearing them", correlationId);
            accessTokens.forEach((accessToken)=>{
                this.removeAccessToken(this.generateCredentialKey(accessToken), correlationId);
            });
            this.performanceClient.addFields({
                multiMatchedAT: accessTokens.length
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getAccessToken - Returning access token", correlationId);
        return accessTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ accessTokenKeyMatchesFilter(inputKey, filter, keyMustContainAllScopes) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.target) {
            const scopes = filter.target.asArray();
            for(let i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    }
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ getAccessTokensByFilter(filter, correlationId) {
        const tokenKeys = this.getTokenKeys();
        const accessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            const accessToken = this.getAccessTokenCredential(key, correlationId);
            if (accessToken && this.credentialMatchesFilter(accessToken, filter, correlationId)) accessTokens.push(accessToken);
        });
        return accessTokens;
    }
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param account {AccountInfo}
     * @param familyRT {boolean}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getRefreshToken(account, familyRT, correlationId, tokenKeys) {
        this.commonLogger.trace("CacheManager - getRefreshToken called", correlationId);
        const id = familyRT ? (0, $8994aeee5e01080d$export$978fe7ab5e74b539) : undefined;
        const refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        const refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        const refreshTokens = [];
        refreshTokenKeys.forEach((key)=>{
            // Validate key
            if (this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                const refreshToken = this.getRefreshTokenCredential(key, correlationId);
                // Validate value
                if (refreshToken && this.credentialMatchesFilter(refreshToken, refreshTokenFilter, correlationId)) refreshTokens.push(refreshToken);
            }
        });
        const numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("CacheManager:getRefreshToken - No refresh token found.", correlationId);
            return null;
        }
        // address the else case after remove functions address environment aliases
        if (numRefreshTokens > 1) this.performanceClient.addFields({
            multiMatchedRT: numRefreshTokens
        }, correlationId);
        this.commonLogger.info("CacheManager:getRefreshToken - returning refresh token", correlationId);
        return refreshTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ refreshTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Retrieve AppMetadataEntity from cache
     */ readAppMetadataFromCache(environment, correlationId) {
        const appMetadataFilter = {
            environment: environment,
            clientId: this.clientId
        };
        const appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter, correlationId);
        const appMetadataEntries = Object.keys(appMetadata).map((key)=>appMetadata[key]);
        const numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$575bb2924bcd0084), correlationId);
        return appMetadataEntries[0];
    }
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ isAppMetadataFOCI(environment, correlationId) {
        const appMetadata = this.readAppMetadataFromCache(environment, correlationId);
        return !!(appMetadata && appMetadata.familyId === (0, $8994aeee5e01080d$export$978fe7ab5e74b539));
    }
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ matchHomeAccountId(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    }
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ matchLocalAccountIdFromTokenClaims(tokenClaims, localAccountId) {
        const idTokenLocalAccountId = tokenClaims.oid || tokenClaims.sub;
        return localAccountId === idTokenLocalAccountId;
    }
    matchLocalAccountIdFromTenantProfile(tenantProfile, localAccountId) {
        return tenantProfile.localAccountId === localAccountId;
    }
    /**
     * helper to match names
     * @param entity
     * @param name
     * @returns true if the downcased name properties are present and match in the filter and the entity
     */ matchName(claims, name) {
        return !!(name.toLowerCase() === claims.name?.toLowerCase());
    }
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ matchUsername(cachedUsername, filterUsername) {
        return !!(cachedUsername && typeof cachedUsername === "string" && filterUsername?.toLowerCase() === cachedUsername.toLowerCase());
    }
    /**
     * helper to match loginhints
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintWithTenantProfile(tenantProfile, loginHintFilter) {
        return tenantProfile.loginHint === loginHintFilter || tenantProfile.username === loginHintFilter || tenantProfile.upn === loginHintFilter;
    }
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ matchUserAssertionHash(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    }
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ matchEnvironment(entity, environment, correlationId) {
        // Check static authority options first for cases where authority metadata has not been resolved and cached yet
        if (this.staticAuthorityOptions) {
            const staticAliases = (0, $e0b6bad51f2d7eeb$export$2c21adf4b4d4efc0)(this.staticAuthorityOptions, this.commonLogger, correlationId);
            if (staticAliases.includes(environment) && staticAliases.includes(entity.environment)) return true;
        }
        // Query metadata cache if no static authority configuration has aliases that match enviroment
        const cloudMetadata = this.getAuthorityMetadataByAlias(environment, correlationId);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    }
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ matchCredentialType(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    }
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ matchClientId(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    }
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ matchFamilyId(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    }
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ matchRealm(entity, realm) {
        return !!(entity.realm?.toLowerCase() === realm.toLowerCase());
    }
    /**
     * helper to match loginHint which can be either:
     * 1. login_hint ID token claim
     * 2. username in cached account object
     * 3. upn in ID token claims
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintFromTokenClaims(tokenClaims, loginHint) {
        if (tokenClaims.login_hint === loginHint) return true;
        if (tokenClaims.preferred_username === loginHint) return true;
        if (tokenClaims.upn === loginHint) return true;
        // check login hint against list of emails in token claims
        if (tokenClaims.emails && tokenClaims.emails.includes(loginHint)) return true;
        return false;
    }
    /**
     * Helper to match sid
     * @param entity
     * @param sid
     * @returns true if the sid claim is present and matches the filter
     */ matchSid(idTokenClaims, sid) {
        return idTokenClaims.sid === sid;
    }
    matchAuthorityType(entity, authorityType) {
        return !!(entity.authorityType && authorityType.toLowerCase() === entity.authorityType.toLowerCase());
    }
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ matchTarget(entity, target, correlationId) {
        const isNotAccessTokenCredential = entity.credentialType !== (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ACCESS_TOKEN && entity.credentialType !== (0, $8994aeee5e01080d$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        const entityScopeSet = (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99).fromString(entity.target, correlationId);
        return entityScopeSet.containsScopeSet(target);
    }
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ matchTokenType(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType === tokenType);
    }
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param keyId
     */ matchKeyId(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    }
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ isAppMetadata(key) {
        return key.indexOf((0, $8994aeee5e01080d$export$7e1bea6dc1b6b32e)) !== -1;
    }
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ isAuthorityMetadata(key) {
        return key.indexOf((0, $8994aeee5e01080d$export$1137b2d06fad26eb)) !== -1;
    }
    /**
     * returns cache key used for cloud instance metadata
     */ generateAuthorityMetadataCacheKey(authority) {
        return `${0, $8994aeee5e01080d$export$1137b2d06fad26eb}-${this.clientId}-${authority}`;
    }
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ static toObject(obj, json) {
        for(const propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    }
}
/** @internal */ class $a087c4e9d9c3e8cc$export$b7254d304b3004b6 extends $a087c4e9d9c3e8cc$export$996e3ea69314b5c6 {
    async setAccount() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getAccount() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    async setIdTokenCredential() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getIdTokenCredential() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    async setAccessTokenCredential() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getAccessTokenCredential() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    async setRefreshTokenCredential() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getRefreshTokenCredential() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    setAppMetadata() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getAppMetadata() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    setServerTelemetry() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getServerTelemetry() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    setAuthorityMetadata() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getAuthorityMetadata() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getAuthorityMetadataKeys() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    setThrottlingCache() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getThrottlingCache() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    removeItem() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getKeys() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getAccountKeys() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    getTokenKeys() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    generateCredentialKey() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
    generateAccountKey() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
}




/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $6669d8f0f59e64dc$export$8a682ae47622dbb9 = "msal";
const $6669d8f0f59e64dc$var$BROWSER_PREFIX = "browser";
const $6669d8f0f59e64dc$export$9e9532f57bbb139e = "|";
const $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d = 3;
const $6669d8f0f59e64dc$export$4693794d1f911b27 = 3;
const $6669d8f0f59e64dc$export$b28668d53eb57e63 = `${$6669d8f0f59e64dc$export$8a682ae47622dbb9}.${$6669d8f0f59e64dc$var$BROWSER_PREFIX}.log.level`;
const $6669d8f0f59e64dc$export$d9bc1c202a3825f1 = `${$6669d8f0f59e64dc$export$8a682ae47622dbb9}.${$6669d8f0f59e64dc$var$BROWSER_PREFIX}.log.pii`;
const $6669d8f0f59e64dc$export$54408f0b0cf727d4 = `${$6669d8f0f59e64dc$export$8a682ae47622dbb9}.${$6669d8f0f59e64dc$var$BROWSER_PREFIX}.performance.enabled`;
const $6669d8f0f59e64dc$export$6825ebfedde34998 = `${$6669d8f0f59e64dc$export$8a682ae47622dbb9}.version`;
const $6669d8f0f59e64dc$export$55a9047ed9cd2b03 = "account.keys";
const $6669d8f0f59e64dc$export$332974f1fffb359a = "token.keys";
const $6669d8f0f59e64dc$export$4a19efda043b2ab6 = `${$6669d8f0f59e64dc$export$8a682ae47622dbb9}.${$6669d8f0f59e64dc$var$BROWSER_PREFIX}.sso.capable`;
function $6669d8f0f59e64dc$export$8cef587ddea5c5f6(schema = $6669d8f0f59e64dc$export$4693794d1f911b27) {
    if (schema < 1) return `${$6669d8f0f59e64dc$export$8a682ae47622dbb9}.${$6669d8f0f59e64dc$export$55a9047ed9cd2b03}`;
    return `${$6669d8f0f59e64dc$export$8a682ae47622dbb9}.${schema}.${$6669d8f0f59e64dc$export$55a9047ed9cd2b03}`;
}
function $6669d8f0f59e64dc$export$79944bbef1910535(clientId, schema = $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d) {
    if (schema < 1) return `${$6669d8f0f59e64dc$export$8a682ae47622dbb9}.${$6669d8f0f59e64dc$export$332974f1fffb359a}.${clientId}`;
    return `${$6669d8f0f59e64dc$export$8a682ae47622dbb9}.${schema}.${$6669d8f0f59e64dc$export$332974f1fffb359a}.${clientId}`;
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 






/*! @azure/msal-browser v5.16.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $179ed9ff4e1d3922$export$2eb7a1dfdc4c5fba extends (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(this, $179ed9ff4e1d3922$export$2eb7a1dfdc4c5fba.prototype);
    }
}
function $179ed9ff4e1d3922$export$176bd5050947ba0c(errorCode, correlationId) {
    return new $179ed9ff4e1d3922$export$2eb7a1dfdc4c5fba(errorCode, correlationId, (0, $e015633e658266f1$export$714f3eb4b9ca37c5)(errorCode));
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Cookie life calculation (hours * minutes * seconds * ms)
const $42298ec3717585a2$var$COOKIE_LIFE_MULTIPLIER = 86400000;
const $42298ec3717585a2$export$b18f4dec3e412d34 = {
    Lax: "Lax",
    None: "None"
};
class $42298ec3717585a2$export$dae7d845015939d5 {
    initialize() {
        return Promise.resolve();
    }
    getItem(key) {
        const name = encodeURIComponent(key);
        const cookieList = document.cookie.split(";");
        for(let i = 0; i < cookieList.length; i++){
            const cookie = cookieList[i].trim();
            const eqIndex = cookie.indexOf("=");
            const rawKey = eqIndex === -1 ? cookie : cookie.substring(0, eqIndex);
            if (rawKey === name) {
                const rawValue = eqIndex === -1 ? "" : cookie.substring(eqIndex + 1);
                try {
                    return decodeURIComponent(rawValue);
                } catch  {
                    return rawValue;
                }
            }
        }
        return "";
    }
    getUserData() {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).methodNotImplemented, "");
    }
    setItem(key, value, cookieLifeDays, secure = true, sameSite = $42298ec3717585a2$export$b18f4dec3e412d34.Lax) {
        let cookieStr = `${encodeURIComponent(key)}=${encodeURIComponent(value)};path=/;SameSite=${sameSite};`;
        if (cookieLifeDays) {
            const expireTime = $42298ec3717585a2$export$b720d871a37fa65(cookieLifeDays);
            cookieStr += `expires=${expireTime};`;
        }
        if (secure || sameSite === $42298ec3717585a2$export$b18f4dec3e412d34.None) // SameSite None requires Secure flag
        cookieStr += "Secure;";
        document.cookie = cookieStr;
    }
    async setUserData(_key, _value, correlationId) {
        return Promise.reject((0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).methodNotImplemented, correlationId));
    }
    removeItem(key) {
        // Setting expiration to -1 removes it
        this.setItem(key, "", -1);
    }
    getKeys() {
        const cookieList = document.cookie.split(";");
        const keys = [];
        cookieList.forEach((cookie)=>{
            const trimmed = cookie.trim();
            const eqIndex = trimmed.indexOf("=");
            const rawKey = eqIndex === -1 ? trimmed : trimmed.substring(0, eqIndex);
            try {
                keys.push(decodeURIComponent(rawKey));
            } catch  {
            // Skip cookies with malformed percent-encoded sequences in the key
            }
        });
        return keys;
    }
    containsKey(key) {
        return this.getKeys().includes(key);
    }
    decryptData() {
        // Cookie storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}
/**
 * Get cookie expiration time
 * @param cookieLifeDays
 */ function $42298ec3717585a2$export$b720d871a37fa65(cookieLifeDays) {
    const today = new Date();
    const expr = new Date(today.getTime() + cookieLifeDays * $42298ec3717585a2$var$COOKIE_LIFE_MULTIPLIER);
    return expr.toUTCString();
}



/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns a list of cache keys for all known accounts
 * @param storage
 * @returns
 */ function $3485a03b74b26dfd$export$beb6809f8bbb3df6(storage, schemaVersion) {
    const accountKeys = storage.getItem((0, $6669d8f0f59e64dc$export$8cef587ddea5c5f6)(schemaVersion));
    if (accountKeys) return JSON.parse(accountKeys);
    return [];
}
/**
 * Returns a list of cache keys for all known tokens
 * @param clientId
 * @param storage
 * @returns
 */ function $3485a03b74b26dfd$export$ee837b3b857e6cf8(clientId, storage, schemaVersion) {
    const item = storage.getItem((0, $6669d8f0f59e64dc$export$79944bbef1910535)(clientId, schemaVersion));
    if (item) {
        const tokenKeys = JSON.parse(item);
        if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
    }
    return {
        idToken: [],
        accessToken: [],
        refreshToken: []
    };
}



/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $4833b6d6d0ccb7ef$export$691b4523c5340423(data) {
    return data.hasOwnProperty("id") && data.hasOwnProperty("nonce") && data.hasOwnProperty("data");
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $3c757ef3817bc34f$export$41d7a3d4e14d6113 = "storage_not_supported";
const $3c757ef3817bc34f$export$1377ea690fa0b6d8 = "stubbed_public_client_application_called";
const $3c757ef3817bc34f$export$37486e3b6bed61c6 = "in_mem_redirect_unavailable";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d4a22c590a0a36fb$var$ENCRYPTION_KEY = "msal.cache.encryption";
const $d4a22c590a0a36fb$var$BROADCAST_CHANNEL_NAME = "msal.broadcast.cache";
class $d4a22c590a0a36fb$export$19fffca37ef3e106 {
    constructor(clientId, logger, performanceClient){
        if (!window.localStorage) throw (0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$41d7a3d4e14d6113), "");
        this.memoryStorage = new (0, $14f17b15811f4641$export$d7392285c701ecf5)();
        this.initialized = false;
        this.clientId = clientId;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.broadcast = new BroadcastChannel($d4a22c590a0a36fb$var$BROADCAST_CHANNEL_NAME);
    }
    async initialize(correlationId) {
        const cookies = new (0, $42298ec3717585a2$export$dae7d845015939d5)();
        const cookieString = cookies.getItem($d4a22c590a0a36fb$var$ENCRYPTION_KEY);
        let parsedCookie = {
            key: "",
            id: ""
        };
        if (cookieString) try {
            parsedCookie = JSON.parse(cookieString);
        } catch (e) {}
        if (parsedCookie.key && parsedCookie.id) {
            // Encryption key already exists, import
            const baseKey = (0, $69bce03cfd571284$export$468cda29b159ee5d)((0, $5949979cf1605326$export$8f0c237d3e8188bc), (0, $acc47f0f594e8d22$export$fe555b2490ffa3fb), this.logger, this.performanceClient, correlationId)(parsedCookie.key);
            this.encryptionCookie = {
                id: parsedCookie.id,
                key: await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $f0e13da7356d30ac$export$5a71d4e3178f19c4), (0, $acc47f0f594e8d22$export$f85f32203360ffb7), this.logger, this.performanceClient, correlationId)(baseKey)
            };
        } else {
            // Encryption key doesn't exist or is invalid, generate a new one
            const id = (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)();
            const baseKey = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $f0e13da7356d30ac$export$1222fa1cada87c76), (0, $acc47f0f594e8d22$export$924f0b17a8155ca0), this.logger, this.performanceClient, correlationId)();
            const keyStr = (0, $69bce03cfd571284$export$468cda29b159ee5d)((0, $0349b3935d5ceef2$export$84f5a428c7153a69), (0, $acc47f0f594e8d22$export$6486e7961fcba669), this.logger, this.performanceClient, correlationId)(new Uint8Array(baseKey));
            this.encryptionCookie = {
                id: id,
                key: await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $f0e13da7356d30ac$export$5a71d4e3178f19c4), (0, $acc47f0f594e8d22$export$f85f32203360ffb7), this.logger, this.performanceClient, correlationId)(baseKey)
            };
            const cookieData = {
                id: id,
                key: keyStr
            };
            cookies.setItem($d4a22c590a0a36fb$var$ENCRYPTION_KEY, JSON.stringify(cookieData), 0, true, (0, $42298ec3717585a2$export$b18f4dec3e412d34).None // SameSite must be None to support iframed apps
            );
        }
        await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.importExistingCache.bind(this), (0, $acc47f0f594e8d22$export$8ad0cce1899a6e6b), this.logger, this.performanceClient, correlationId)(correlationId);
        // Register listener for cache updates in other tabs
        this.broadcast.addEventListener("message", (event)=>{
            this.updateCache(event, correlationId);
        });
        this.initialized = true;
    }
    getItem(key) {
        return window.localStorage.getItem(key);
    }
    getUserData(key) {
        if (!this.initialized) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$436657cdcd7fe2be), "");
        return this.memoryStorage.getItem(key);
    }
    async decryptData(key, data, correlationId) {
        if (!this.initialized || !this.encryptionCookie) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$436657cdcd7fe2be), "");
        if (data.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        const decryptedData = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $f0e13da7356d30ac$export$e85a0c9a1067c5d3), (0, $acc47f0f594e8d22$export$753391c83cc4ba4d), this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, data.nonce, this.getContext(key), data.data);
        if (!decryptedData) return null;
        try {
            return {
                ...JSON.parse(decryptedData),
                lastUpdatedAt: data.lastUpdatedAt
            };
        } catch (e) {
            this.performanceClient.incrementFields({
                encryptedCacheCorruptionCount: 1
            }, correlationId);
            return null;
        }
    }
    setItem(key, value) {
        window.localStorage.setItem(key, value);
    }
    async setUserData(key, value, correlationId, timestamp, kmsi) {
        if (!this.initialized || !this.encryptionCookie) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$436657cdcd7fe2be), "");
        if (kmsi) this.setItem(key, value);
        else {
            const { data: data, nonce: nonce } = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $f0e13da7356d30ac$export$5b0f6292f11d1d18), (0, $acc47f0f594e8d22$export$47fac120ab74ef02), this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, value, this.getContext(key));
            const encryptedData = {
                id: this.encryptionCookie.id,
                nonce: nonce,
                data: data,
                lastUpdatedAt: timestamp
            };
            this.setItem(key, JSON.stringify(encryptedData));
        }
        this.memoryStorage.setItem(key, value);
        // Notify other frames to update their in-memory cache
        this.broadcast.postMessage({
            key: key,
            value: value,
            context: this.getContext(key)
        });
    }
    removeItem(key) {
        if (this.memoryStorage.containsKey(key)) {
            this.memoryStorage.removeItem(key);
            this.broadcast.postMessage({
                key: key,
                value: null,
                context: this.getContext(key)
            });
        }
        window.localStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.localStorage);
    }
    containsKey(key) {
        return window.localStorage.hasOwnProperty(key);
    }
    /**
     * Removes all known MSAL keys from the cache
     */ clear() {
        // Removes all remaining MSAL cache items
        this.memoryStorage.clear();
        const accountKeys = (0, $3485a03b74b26dfd$export$beb6809f8bbb3df6)(this);
        accountKeys.forEach((key)=>this.removeItem(key));
        const tokenKeys = (0, $3485a03b74b26dfd$export$ee837b3b857e6cf8)(this.clientId, this);
        tokenKeys.idToken.forEach((key)=>this.removeItem(key));
        tokenKeys.accessToken.forEach((key)=>this.removeItem(key));
        tokenKeys.refreshToken.forEach((key)=>this.removeItem(key));
        // Clean up anything left
        this.getKeys().forEach((cacheKey)=>{
            if (cacheKey.startsWith((0, $6669d8f0f59e64dc$export$8a682ae47622dbb9)) || cacheKey.indexOf(this.clientId) !== -1) this.removeItem(cacheKey);
        });
    }
    /**
     * Helper to decrypt all known MSAL keys in localStorage and save them to inMemory storage
     * @returns
     */ async importExistingCache(correlationId) {
        if (!this.encryptionCookie) return;
        let accountKeys = (0, $3485a03b74b26dfd$export$beb6809f8bbb3df6)(this);
        accountKeys = await this.importArray(accountKeys, correlationId);
        // Write valid account keys back to map
        if (accountKeys.length) this.setItem((0, $6669d8f0f59e64dc$export$8cef587ddea5c5f6)(), JSON.stringify(accountKeys));
        else this.removeItem((0, $6669d8f0f59e64dc$export$8cef587ddea5c5f6)());
        const tokenKeys = (0, $3485a03b74b26dfd$export$ee837b3b857e6cf8)(this.clientId, this);
        tokenKeys.idToken = await this.importArray(tokenKeys.idToken, correlationId);
        tokenKeys.accessToken = await this.importArray(tokenKeys.accessToken, correlationId);
        tokenKeys.refreshToken = await this.importArray(tokenKeys.refreshToken, correlationId);
        // Write valid token keys back to map
        if (tokenKeys.idToken.length || tokenKeys.accessToken.length || tokenKeys.refreshToken.length) this.setItem((0, $6669d8f0f59e64dc$export$79944bbef1910535)(this.clientId), JSON.stringify(tokenKeys));
        else this.removeItem((0, $6669d8f0f59e64dc$export$79944bbef1910535)(this.clientId));
    }
    /**
     * Helper to decrypt and save cache entries
     * @param key
     * @returns
     */ async getItemFromEncryptedCache(key, correlationId) {
        if (!this.encryptionCookie) return null;
        const rawCache = this.getItem(key);
        if (!rawCache) return null;
        let encObj;
        try {
            encObj = JSON.parse(rawCache);
        } catch (e) {
            // Not a valid encrypted object, remove
            return null;
        }
        if (!(0, $4833b6d6d0ccb7ef$export$691b4523c5340423)(encObj)) {
            // Data is not encrypted
            this.performanceClient.incrementFields({
                unencryptedCacheCount: 1
            }, correlationId);
            return rawCache;
        }
        if (encObj.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        this.performanceClient.incrementFields({
            encryptedCacheCount: 1
        }, correlationId);
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $f0e13da7356d30ac$export$e85a0c9a1067c5d3), (0, $acc47f0f594e8d22$export$753391c83cc4ba4d), this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, encObj.nonce, this.getContext(key), encObj.data);
    }
    /**
     * Helper to decrypt and save an array of cache keys
     * @param arr
     * @returns Array of keys successfully imported
     */ async importArray(arr, correlationId) {
        const importedArr = [];
        const promiseArr = [];
        arr.forEach((key)=>{
            const promise = this.getItemFromEncryptedCache(key, correlationId).then((value)=>{
                if (value) {
                    this.memoryStorage.setItem(key, value);
                    importedArr.push(key);
                } else // If value is empty, unencrypted or expired remove
                this.removeItem(key);
            });
            promiseArr.push(promise);
        });
        await Promise.all(promiseArr);
        return importedArr;
    }
    /**
     * Gets encryption context for a given cache entry. This is clientId for app specific entries, empty string for shared entries
     * @param key
     * @returns
     */ getContext(key) {
        let context = "";
        if (key.includes(this.clientId)) context = this.clientId; // Used to bind encryption key to this appId
        return context;
    }
    updateCache(event, correlationId) {
        this.logger.trace("17cxcm", correlationId);
        const perfMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$cac8f5c791e30935));
        perfMeasurement.add({
            isBackground: true
        });
        const { key: key, value: value, context: context } = event.data;
        if (!key) {
            this.logger.error("0e10qr", correlationId);
            perfMeasurement.end({
                success: false,
                errorCode: "noKey"
            });
            return;
        }
        if (context && context !== this.clientId) {
            this.logger.trace(`04rtdy ${context}`, correlationId);
            perfMeasurement.end({
                success: false,
                errorCode: "contextMismatch"
            });
            return;
        }
        if (!value) {
            this.memoryStorage.removeItem(key);
            this.logger.verbose("04ypih", correlationId);
        } else {
            this.memoryStorage.setItem(key, value);
            this.logger.verbose("1vzsgt", correlationId);
        }
        perfMeasurement.end({
            success: true
        });
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $980292a08ffc7409$export$2c4b17e1c2e0931 {
    constructor(){
        if (!window.sessionStorage) throw (0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$41d7a3d4e14d6113), "");
    }
    async initialize() {
    // Session storage does not require initialization
    }
    getItem(key) {
        return window.sessionStorage.getItem(key);
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        window.sessionStorage.setItem(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        window.sessionStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.sessionStorage);
    }
    containsKey(key) {
        return window.sessionStorage.hasOwnProperty(key);
    }
    decryptData() {
        // Session storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}








var $8e677587a7c978db$exports = {};

$parcel$export($8e677587a7c978db$exports, "parseAuthResponseFromUrl", () => $8e677587a7c978db$export$a143506230fae361);
$parcel$export($8e677587a7c978db$exports, "clearHash", () => $8e677587a7c978db$export$a20c3032ba81d6aa);
$parcel$export($8e677587a7c978db$exports, "clearAuthResponseFromUrl", () => $8e677587a7c978db$export$460894b9c7dcb1ac);
$parcel$export($8e677587a7c978db$exports, "replaceHash", () => $8e677587a7c978db$export$9bf2691bda54425c);
$parcel$export($8e677587a7c978db$exports, "isInIframe", () => $8e677587a7c978db$export$9f140ed41af5108c);
$parcel$export($8e677587a7c978db$exports, "isInPopup", () => $8e677587a7c978db$export$722fdce8786cc28b);
$parcel$export($8e677587a7c978db$exports, "cancelPendingBridgeResponse", () => $8e677587a7c978db$export$faedfb2c37a42b1d);
$parcel$export($8e677587a7c978db$exports, "waitForBridgeResponse", () => $8e677587a7c978db$export$f241abdbe4a81a03);
$parcel$export($8e677587a7c978db$exports, "getCurrentUri", () => $8e677587a7c978db$export$1204531fbbf6ecde);
$parcel$export($8e677587a7c978db$exports, "getHomepage", () => $8e677587a7c978db$export$60785768478b4ffc);
$parcel$export($8e677587a7c978db$exports, "blockReloadInHiddenIframes", () => $8e677587a7c978db$export$8fdba407d8e31f54);
$parcel$export($8e677587a7c978db$exports, "blockRedirectInIframe", () => $8e677587a7c978db$export$5ae6b09f947c8a9e);
$parcel$export($8e677587a7c978db$exports, "blockAcquireTokenInPopups", () => $8e677587a7c978db$export$dc99b653c8cd2cd7);
$parcel$export($8e677587a7c978db$exports, "blockNonBrowserEnvironment", () => $8e677587a7c978db$export$c7939bfe92ae2787);
$parcel$export($8e677587a7c978db$exports, "blockAPICallsBeforeInitialize", () => $8e677587a7c978db$export$630119c5db8b5529);
$parcel$export($8e677587a7c978db$exports, "preflightCheck", () => $8e677587a7c978db$export$4dd091cbdc98b52e);
$parcel$export($8e677587a7c978db$exports, "redirectPreflightCheck", () => $8e677587a7c978db$export$62c8f4fdca4df60f);
$parcel$export($8e677587a7c978db$exports, "preconnect", () => $8e677587a7c978db$export$a0816fa17a9e79be);
$parcel$export($8e677587a7c978db$exports, "createGuid", () => $8e677587a7c978db$export$7571c350ed9fec74);
$parcel$export($8e677587a7c978db$exports, "buildMergedClaims", () => $8e677587a7c978db$export$ffd234d2f4f3cfb1);
$parcel$export($8e677587a7c978db$exports, "invoke", () => $69bce03cfd571284$export$468cda29b159ee5d);
$parcel$export($8e677587a7c978db$exports, "invokeAsync", () => $69bce03cfd571284$export$e4feded94d9adb18);
/*! @azure/msal-browser v5.16.0 2026-06-30 */ var $de6be0b6a0939617$exports = {};

$parcel$export($de6be0b6a0939617$exports, "setRequestState", () => $de6be0b6a0939617$export$5590937a2c44af77);
$parcel$export($de6be0b6a0939617$exports, "generateLibraryState", () => $de6be0b6a0939617$export$4d657b11f5678790);
$parcel$export($de6be0b6a0939617$exports, "parseRequestState", () => $de6be0b6a0939617$export$803567147421ddac);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Appends user state with random guid, or returns random guid.
 * @param cryptoObj
 * @param userState
 * @param meta
 * @param correlationId
 */ function $de6be0b6a0939617$export$5590937a2c44af77(cryptoObj, userState, meta, correlationId) {
    const libraryState = $de6be0b6a0939617$export$4d657b11f5678790(cryptoObj, correlationId, meta);
    return userState ? `${libraryState}${0, $8994aeee5e01080d$export$c49b7e87df554b81}${userState}` : libraryState;
}
/**
 * Generates the state value used by the common library.
 * @param cryptoObj
 * @param correlationId
 * @param meta
 */ function $de6be0b6a0939617$export$4d657b11f5678790(cryptoObj, correlationId, meta) {
    if (!cryptoObj) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$c39e501a22cba395), correlationId);
    // Create a state object containing a unique id and the timestamp of the request creation
    const stateObj = {
        id: cryptoObj.createNewGuid()
    };
    if (meta) stateObj.meta = meta;
    const stateString = JSON.stringify(stateObj);
    return cryptoObj.base64Encode(stateString);
}
/**
 * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
 * @param base64Decode
 * @param state
 * @param correlationId
 */ function $de6be0b6a0939617$export$803567147421ddac(base64Decode, state, correlationId) {
    if (!base64Decode) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$c39e501a22cba395), correlationId);
    if (!state) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$72a77317632c052b), correlationId);
    try {
        // Split the state between library state and user passed state and decode them separately
        const splitState = state.split((0, $8994aeee5e01080d$export$c49b7e87df554b81));
        const libraryState = splitState[0];
        const userState = splitState.length > 1 ? splitState.slice(1).join((0, $8994aeee5e01080d$export$c49b7e87df554b81)) : "";
        const libraryStateString = base64Decode(libraryState);
        const libraryStateObj = JSON.parse(libraryStateString);
        return {
            userRequestState: userState || "",
            libraryState: libraryStateObj
        };
    } catch (e) {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$72a77317632c052b), correlationId);
    }
}

var $25d69fa430040087$exports = {};

$parcel$export($25d69fa430040087$exports, "instrumentBrokerParams", () => $25d69fa430040087$export$7153a1ee4346fa3b);
$parcel$export($25d69fa430040087$exports, "addResponseType", () => $25d69fa430040087$export$3e2fd8b32dd28470);
$parcel$export($25d69fa430040087$exports, "addResponseMode", () => $25d69fa430040087$export$f1c153626c2c2d91);
$parcel$export($25d69fa430040087$exports, "addNativeBroker", () => $25d69fa430040087$export$8c305b8d324c4edb);
$parcel$export($25d69fa430040087$exports, "addScopes", () => $25d69fa430040087$export$c213bf8f125826ba);
$parcel$export($25d69fa430040087$exports, "addClientId", () => $25d69fa430040087$export$8360c651f9cc692b);
$parcel$export($25d69fa430040087$exports, "addRedirectUri", () => $25d69fa430040087$export$6758d6264f4f06);
$parcel$export($25d69fa430040087$exports, "addPostLogoutRedirectUri", () => $25d69fa430040087$export$bb8081db67b059c0);
$parcel$export($25d69fa430040087$exports, "addIdTokenHint", () => $25d69fa430040087$export$c6f34f6f67740950);
$parcel$export($25d69fa430040087$exports, "addDomainHint", () => $25d69fa430040087$export$1bd007a9d7fec290);
$parcel$export($25d69fa430040087$exports, "addLoginHint", () => $25d69fa430040087$export$65f43fd4b28bba5f);
$parcel$export($25d69fa430040087$exports, "addCcsUpn", () => $25d69fa430040087$export$aa9cca16bcc29d2d);
$parcel$export($25d69fa430040087$exports, "addCcsOid", () => $25d69fa430040087$export$68a633ecf634a2ea);
$parcel$export($25d69fa430040087$exports, "addSid", () => $25d69fa430040087$export$9d8531b0fa366b30);
$parcel$export($25d69fa430040087$exports, "addClaims", () => $25d69fa430040087$export$b04c3bca9165ed02);
$parcel$export($25d69fa430040087$exports, "buildMergedClaims", () => $25d69fa430040087$export$ffd234d2f4f3cfb1);
$parcel$export($25d69fa430040087$exports, "addCorrelationId", () => $25d69fa430040087$export$8a224ff809946e9c);
$parcel$export($25d69fa430040087$exports, "addLibraryInfo", () => $25d69fa430040087$export$3ecac3764b147c3f);
$parcel$export($25d69fa430040087$exports, "addApplicationTelemetry", () => $25d69fa430040087$export$37ec1b76d865654a);
$parcel$export($25d69fa430040087$exports, "addPrompt", () => $25d69fa430040087$export$e982ccd37a61cde6);
$parcel$export($25d69fa430040087$exports, "addState", () => $25d69fa430040087$export$4a8b8c14090dd065);
$parcel$export($25d69fa430040087$exports, "addNonce", () => $25d69fa430040087$export$87b1d5d886e84b11);
$parcel$export($25d69fa430040087$exports, "addCodeChallengeParams", () => $25d69fa430040087$export$57a984e7ed784e16);
$parcel$export($25d69fa430040087$exports, "addAuthorizationCode", () => $25d69fa430040087$export$ff027aab2d77a49c);
$parcel$export($25d69fa430040087$exports, "addDeviceCode", () => $25d69fa430040087$export$8999dc4307159304);
$parcel$export($25d69fa430040087$exports, "addRefreshToken", () => $25d69fa430040087$export$b9e8ccbb425b80a3);
$parcel$export($25d69fa430040087$exports, "addCodeVerifier", () => $25d69fa430040087$export$dceb49e3b4703cbb);
$parcel$export($25d69fa430040087$exports, "addClientSecret", () => $25d69fa430040087$export$8df84bbb0e2465bc);
$parcel$export($25d69fa430040087$exports, "addClientAssertion", () => $25d69fa430040087$export$2d3d772920e2496e);
$parcel$export($25d69fa430040087$exports, "addClientAssertionType", () => $25d69fa430040087$export$55ad911d12112f00);
$parcel$export($25d69fa430040087$exports, "addOboAssertion", () => $25d69fa430040087$export$34b131001eea36b1);
$parcel$export($25d69fa430040087$exports, "addRequestTokenUse", () => $25d69fa430040087$export$b6d65fd125460167);
$parcel$export($25d69fa430040087$exports, "addGrantType", () => $25d69fa430040087$export$e5f700fdeb4022b2);
$parcel$export($25d69fa430040087$exports, "addClientInfo", () => $25d69fa430040087$export$86b85a101d45e918);
$parcel$export($25d69fa430040087$exports, "addCliData", () => $25d69fa430040087$export$5a0058be0b2fe3ea);
$parcel$export($25d69fa430040087$exports, "addInstanceAware", () => $25d69fa430040087$export$50b40dfb1d11b77a);
$parcel$export($25d69fa430040087$exports, "addExtraParameters", () => $25d69fa430040087$export$7f71daa83fb7c7e2);
$parcel$export($25d69fa430040087$exports, "addUsername", () => $25d69fa430040087$export$d38c772efe03a690);
$parcel$export($25d69fa430040087$exports, "addPassword", () => $25d69fa430040087$export$bfe833e59aa823e8);
$parcel$export($25d69fa430040087$exports, "addPopToken", () => $25d69fa430040087$export$6dfc34809d8c4096);
$parcel$export($25d69fa430040087$exports, "addSshJwk", () => $25d69fa430040087$export$f004de9a266b8070);
$parcel$export($25d69fa430040087$exports, "addServerTelemetry", () => $25d69fa430040087$export$79fb524b159705e9);
$parcel$export($25d69fa430040087$exports, "addThrottling", () => $25d69fa430040087$export$26592ae2037df9de);
$parcel$export($25d69fa430040087$exports, "addLogoutHint", () => $25d69fa430040087$export$e0d4676d7288bded);
$parcel$export($25d69fa430040087$exports, "addBrokerParameters", () => $25d69fa430040087$export$5ea4577e2a518c27);
$parcel$export($25d69fa430040087$exports, "addEARParameters", () => $25d69fa430040087$export$ec0b476da4a9fb0);
$parcel$export($25d69fa430040087$exports, "addResource", () => $25d69fa430040087$export$dd712f36c1a9cd08);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 
var $46f4c10c7ac0692f$exports = {};

$parcel$export($46f4c10c7ac0692f$exports, "CLIENT_ID", () => $46f4c10c7ac0692f$export$c7b1b63f5b60f8e);
$parcel$export($46f4c10c7ac0692f$exports, "REDIRECT_URI", () => $46f4c10c7ac0692f$export$89711068e98820c5);
$parcel$export($46f4c10c7ac0692f$exports, "RESPONSE_TYPE", () => $46f4c10c7ac0692f$export$af70b7209f1c7f6e);
$parcel$export($46f4c10c7ac0692f$exports, "RESPONSE_MODE", () => $46f4c10c7ac0692f$export$2ae8b352eb8edff7);
$parcel$export($46f4c10c7ac0692f$exports, "GRANT_TYPE", () => $46f4c10c7ac0692f$export$47f09697d0642170);
$parcel$export($46f4c10c7ac0692f$exports, "CLAIMS", () => $46f4c10c7ac0692f$export$c9b29cc9615296dd);
$parcel$export($46f4c10c7ac0692f$exports, "SCOPE", () => $46f4c10c7ac0692f$export$1c5a554c78c0cd12);
$parcel$export($46f4c10c7ac0692f$exports, "ERROR", () => $46f4c10c7ac0692f$export$103bedf43ba882db);
$parcel$export($46f4c10c7ac0692f$exports, "ERROR_DESCRIPTION", () => $46f4c10c7ac0692f$export$a9d2d02ea6b73527);
$parcel$export($46f4c10c7ac0692f$exports, "ACCESS_TOKEN", () => $46f4c10c7ac0692f$export$cdbdf26448f9da5b);
$parcel$export($46f4c10c7ac0692f$exports, "ID_TOKEN", () => $46f4c10c7ac0692f$export$9e690c458f1b1eda);
$parcel$export($46f4c10c7ac0692f$exports, "REFRESH_TOKEN", () => $46f4c10c7ac0692f$export$2a2261c5a58ac0);
$parcel$export($46f4c10c7ac0692f$exports, "EXPIRES_IN", () => $46f4c10c7ac0692f$export$a9f2539254087dfb);
$parcel$export($46f4c10c7ac0692f$exports, "REFRESH_TOKEN_EXPIRES_IN", () => $46f4c10c7ac0692f$export$97e3ac17371277);
$parcel$export($46f4c10c7ac0692f$exports, "STATE", () => $46f4c10c7ac0692f$export$63b4527a2777036f);
$parcel$export($46f4c10c7ac0692f$exports, "NONCE", () => $46f4c10c7ac0692f$export$8646168ae3eb91e1);
$parcel$export($46f4c10c7ac0692f$exports, "PROMPT", () => $46f4c10c7ac0692f$export$19855bb42e55939d);
$parcel$export($46f4c10c7ac0692f$exports, "SESSION_STATE", () => $46f4c10c7ac0692f$export$3edd0f3d0bfcddba);
$parcel$export($46f4c10c7ac0692f$exports, "CLIENT_INFO", () => $46f4c10c7ac0692f$export$476989d62bcb4c85);
$parcel$export($46f4c10c7ac0692f$exports, "CODE", () => $46f4c10c7ac0692f$export$ec5856072852bd7f);
$parcel$export($46f4c10c7ac0692f$exports, "CODE_CHALLENGE", () => $46f4c10c7ac0692f$export$58d2be3216991fee);
$parcel$export($46f4c10c7ac0692f$exports, "CODE_CHALLENGE_METHOD", () => $46f4c10c7ac0692f$export$129e6f0601e36303);
$parcel$export($46f4c10c7ac0692f$exports, "CODE_VERIFIER", () => $46f4c10c7ac0692f$export$a5a34ec10c757281);
$parcel$export($46f4c10c7ac0692f$exports, "CLIENT_REQUEST_ID", () => $46f4c10c7ac0692f$export$633c8d7cd18ad9a9);
$parcel$export($46f4c10c7ac0692f$exports, "X_CLIENT_SKU", () => $46f4c10c7ac0692f$export$fe2f04d04881f19d);
$parcel$export($46f4c10c7ac0692f$exports, "X_CLIENT_VER", () => $46f4c10c7ac0692f$export$d0d0201281a553c0);
$parcel$export($46f4c10c7ac0692f$exports, "X_CLIENT_OS", () => $46f4c10c7ac0692f$export$35497983a44f9406);
$parcel$export($46f4c10c7ac0692f$exports, "X_CLIENT_CPU", () => $46f4c10c7ac0692f$export$d14a6ca469cd1d2b);
$parcel$export($46f4c10c7ac0692f$exports, "X_CLIENT_CURR_TELEM", () => $46f4c10c7ac0692f$export$770dc090fda61e98);
$parcel$export($46f4c10c7ac0692f$exports, "X_CLIENT_LAST_TELEM", () => $46f4c10c7ac0692f$export$99d6087ff3bfb0d3);
$parcel$export($46f4c10c7ac0692f$exports, "X_MS_LIB_CAPABILITY", () => $46f4c10c7ac0692f$export$c5cd103a582a276);
$parcel$export($46f4c10c7ac0692f$exports, "X_APP_NAME", () => $46f4c10c7ac0692f$export$6101af169595a2ae);
$parcel$export($46f4c10c7ac0692f$exports, "X_APP_VER", () => $46f4c10c7ac0692f$export$a8707209cc4254a);
$parcel$export($46f4c10c7ac0692f$exports, "POST_LOGOUT_URI", () => $46f4c10c7ac0692f$export$965624bb436bcb2);
$parcel$export($46f4c10c7ac0692f$exports, "ID_TOKEN_HINT", () => $46f4c10c7ac0692f$export$8d6737236a319b56);
$parcel$export($46f4c10c7ac0692f$exports, "DEVICE_CODE", () => $46f4c10c7ac0692f$export$a575303545717aec);
$parcel$export($46f4c10c7ac0692f$exports, "CLIENT_SECRET", () => $46f4c10c7ac0692f$export$69f7aececf3ea5d7);
$parcel$export($46f4c10c7ac0692f$exports, "CLIENT_ASSERTION", () => $46f4c10c7ac0692f$export$cddd1d85c78cca51);
$parcel$export($46f4c10c7ac0692f$exports, "CLIENT_ASSERTION_TYPE", () => $46f4c10c7ac0692f$export$21aecb34d0e7d9c0);
$parcel$export($46f4c10c7ac0692f$exports, "TOKEN_TYPE", () => $46f4c10c7ac0692f$export$5706a68daf4f000a);
$parcel$export($46f4c10c7ac0692f$exports, "REQ_CNF", () => $46f4c10c7ac0692f$export$427afb3f9eefe31e);
$parcel$export($46f4c10c7ac0692f$exports, "OBO_ASSERTION", () => $46f4c10c7ac0692f$export$3529b31b0ae94ae0);
$parcel$export($46f4c10c7ac0692f$exports, "REQUESTED_TOKEN_USE", () => $46f4c10c7ac0692f$export$97bc1bf63f077c4a);
$parcel$export($46f4c10c7ac0692f$exports, "ON_BEHALF_OF", () => $46f4c10c7ac0692f$export$4aca5741d44e318e);
$parcel$export($46f4c10c7ac0692f$exports, "FOCI", () => $46f4c10c7ac0692f$export$a03331b9d99609d6);
$parcel$export($46f4c10c7ac0692f$exports, "CCS_HEADER", () => $46f4c10c7ac0692f$export$773357fabf610b1f);
$parcel$export($46f4c10c7ac0692f$exports, "RETURN_SPA_CODE", () => $46f4c10c7ac0692f$export$f58b98a40c1faa68);
$parcel$export($46f4c10c7ac0692f$exports, "NATIVE_BROKER", () => $46f4c10c7ac0692f$export$830ff7e6cf071f86);
$parcel$export($46f4c10c7ac0692f$exports, "LOGOUT_HINT", () => $46f4c10c7ac0692f$export$a96ff88ff08babe2);
$parcel$export($46f4c10c7ac0692f$exports, "SID", () => $46f4c10c7ac0692f$export$e9405f9e95799b52);
$parcel$export($46f4c10c7ac0692f$exports, "LOGIN_HINT", () => $46f4c10c7ac0692f$export$defd6be6e02aaeb3);
$parcel$export($46f4c10c7ac0692f$exports, "DOMAIN_HINT", () => $46f4c10c7ac0692f$export$41459bac1e74ba19);
$parcel$export($46f4c10c7ac0692f$exports, "X_CLIENT_EXTRA_SKU", () => $46f4c10c7ac0692f$export$493429868d5ba9bc);
$parcel$export($46f4c10c7ac0692f$exports, "BROKER_CLIENT_ID", () => $46f4c10c7ac0692f$export$3f910906fd5fe047);
$parcel$export($46f4c10c7ac0692f$exports, "BROKER_REDIRECT_URI", () => $46f4c10c7ac0692f$export$c3ecf58e7e228261);
$parcel$export($46f4c10c7ac0692f$exports, "INSTANCE_AWARE", () => $46f4c10c7ac0692f$export$d72b25d13120919d);
$parcel$export($46f4c10c7ac0692f$exports, "EAR_JWK", () => $46f4c10c7ac0692f$export$1e9ebf38b05380ef);
$parcel$export($46f4c10c7ac0692f$exports, "EAR_JWE_CRYPTO", () => $46f4c10c7ac0692f$export$79d2fd0e357f5119);
$parcel$export($46f4c10c7ac0692f$exports, "RESOURCE", () => $46f4c10c7ac0692f$export$84ba8fa7099b85b);
$parcel$export($46f4c10c7ac0692f$exports, "CLI_DATA", () => $46f4c10c7ac0692f$export$d1fd943f3801b39a);
$parcel$export($46f4c10c7ac0692f$exports, "USER_FEDERATED_IDENTITY_CREDENTIAL", () => $46f4c10c7ac0692f$export$7edcc0568bb2d7bc);
$parcel$export($46f4c10c7ac0692f$exports, "USERNAME", () => $46f4c10c7ac0692f$export$faea9a3ba60d21f2);
$parcel$export($46f4c10c7ac0692f$exports, "USER_ID", () => $46f4c10c7ac0692f$export$212a8f1ea37518bd);
$parcel$export($46f4c10c7ac0692f$exports, "FMI_PATH", () => $46f4c10c7ac0692f$export$68d570f77d6ac4ad);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $46f4c10c7ac0692f$export$c7b1b63f5b60f8e = "client_id";
const $46f4c10c7ac0692f$export$89711068e98820c5 = "redirect_uri";
const $46f4c10c7ac0692f$export$af70b7209f1c7f6e = "response_type";
const $46f4c10c7ac0692f$export$2ae8b352eb8edff7 = "response_mode";
const $46f4c10c7ac0692f$export$47f09697d0642170 = "grant_type";
const $46f4c10c7ac0692f$export$c9b29cc9615296dd = "claims";
const $46f4c10c7ac0692f$export$1c5a554c78c0cd12 = "scope";
const $46f4c10c7ac0692f$export$103bedf43ba882db = "error";
const $46f4c10c7ac0692f$export$a9d2d02ea6b73527 = "error_description";
const $46f4c10c7ac0692f$export$cdbdf26448f9da5b = "access_token";
const $46f4c10c7ac0692f$export$9e690c458f1b1eda = "id_token";
const $46f4c10c7ac0692f$export$2a2261c5a58ac0 = "refresh_token";
const $46f4c10c7ac0692f$export$a9f2539254087dfb = "expires_in";
const $46f4c10c7ac0692f$export$97e3ac17371277 = "refresh_token_expires_in";
const $46f4c10c7ac0692f$export$63b4527a2777036f = "state";
const $46f4c10c7ac0692f$export$8646168ae3eb91e1 = "nonce";
const $46f4c10c7ac0692f$export$19855bb42e55939d = "prompt";
const $46f4c10c7ac0692f$export$3edd0f3d0bfcddba = "session_state";
const $46f4c10c7ac0692f$export$476989d62bcb4c85 = "client_info";
const $46f4c10c7ac0692f$export$ec5856072852bd7f = "code";
const $46f4c10c7ac0692f$export$58d2be3216991fee = "code_challenge";
const $46f4c10c7ac0692f$export$129e6f0601e36303 = "code_challenge_method";
const $46f4c10c7ac0692f$export$a5a34ec10c757281 = "code_verifier";
const $46f4c10c7ac0692f$export$633c8d7cd18ad9a9 = "client-request-id";
const $46f4c10c7ac0692f$export$fe2f04d04881f19d = "x-client-SKU";
const $46f4c10c7ac0692f$export$d0d0201281a553c0 = "x-client-VER";
const $46f4c10c7ac0692f$export$35497983a44f9406 = "x-client-OS";
const $46f4c10c7ac0692f$export$d14a6ca469cd1d2b = "x-client-CPU";
const $46f4c10c7ac0692f$export$770dc090fda61e98 = "x-client-current-telemetry";
const $46f4c10c7ac0692f$export$99d6087ff3bfb0d3 = "x-client-last-telemetry";
const $46f4c10c7ac0692f$export$c5cd103a582a276 = "x-ms-lib-capability";
const $46f4c10c7ac0692f$export$6101af169595a2ae = "x-app-name";
const $46f4c10c7ac0692f$export$a8707209cc4254a = "x-app-ver";
const $46f4c10c7ac0692f$export$965624bb436bcb2 = "post_logout_redirect_uri";
const $46f4c10c7ac0692f$export$8d6737236a319b56 = "id_token_hint";
const $46f4c10c7ac0692f$export$a575303545717aec = "device_code";
const $46f4c10c7ac0692f$export$69f7aececf3ea5d7 = "client_secret";
const $46f4c10c7ac0692f$export$cddd1d85c78cca51 = "client_assertion";
const $46f4c10c7ac0692f$export$21aecb34d0e7d9c0 = "client_assertion_type";
const $46f4c10c7ac0692f$export$5706a68daf4f000a = "token_type";
const $46f4c10c7ac0692f$export$427afb3f9eefe31e = "req_cnf";
const $46f4c10c7ac0692f$export$3529b31b0ae94ae0 = "assertion";
const $46f4c10c7ac0692f$export$97bc1bf63f077c4a = "requested_token_use";
const $46f4c10c7ac0692f$export$4aca5741d44e318e = "on_behalf_of";
const $46f4c10c7ac0692f$export$a03331b9d99609d6 = "foci";
const $46f4c10c7ac0692f$export$773357fabf610b1f = "X-AnchorMailbox";
const $46f4c10c7ac0692f$export$f58b98a40c1faa68 = "return_spa_code";
const $46f4c10c7ac0692f$export$830ff7e6cf071f86 = "nativebroker";
const $46f4c10c7ac0692f$export$a96ff88ff08babe2 = "logout_hint";
const $46f4c10c7ac0692f$export$e9405f9e95799b52 = "sid";
const $46f4c10c7ac0692f$export$defd6be6e02aaeb3 = "login_hint";
const $46f4c10c7ac0692f$export$41459bac1e74ba19 = "domain_hint";
const $46f4c10c7ac0692f$export$493429868d5ba9bc = "x-client-xtra-sku";
const $46f4c10c7ac0692f$export$3f910906fd5fe047 = "brk_client_id";
const $46f4c10c7ac0692f$export$c3ecf58e7e228261 = "brk_redirect_uri";
const $46f4c10c7ac0692f$export$d72b25d13120919d = "instance_aware";
const $46f4c10c7ac0692f$export$1e9ebf38b05380ef = "ear_jwk";
const $46f4c10c7ac0692f$export$79d2fd0e357f5119 = "ear_jwe_crypto";
const $46f4c10c7ac0692f$export$84ba8fa7099b85b = "resource";
const $46f4c10c7ac0692f$export$d1fd943f3801b39a = "clidata";
const $46f4c10c7ac0692f$export$7edcc0568bb2d7bc = "user_federated_identity_credential";
const $46f4c10c7ac0692f$export$faea9a3ba60d21f2 = "username";
const $46f4c10c7ac0692f$export$212a8f1ea37518bd = "user_id";
const $46f4c10c7ac0692f$export$68d570f77d6ac4ad = "fmi_path";





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $25d69fa430040087$export$7153a1ee4346fa3b(parameters, correlationId, performanceClient) {
    if (!correlationId) return;
    const clientId = parameters.get((0, $46f4c10c7ac0692f$export$c7b1b63f5b60f8e));
    if (clientId && parameters.has((0, $46f4c10c7ac0692f$export$3f910906fd5fe047))) performanceClient?.addFields({
        embeddedClientId: clientId,
        embeddedRedirectUri: parameters.get((0, $46f4c10c7ac0692f$export$89711068e98820c5))
    }, correlationId);
}
/**
 * Add the given response_type
 * @param parameters
 * @param responseType
 */ function $25d69fa430040087$export$3e2fd8b32dd28470(parameters, responseType) {
    parameters.set((0, $46f4c10c7ac0692f$export$af70b7209f1c7f6e), responseType);
}
/**
 * add response_mode. defaults to query.
 * @param responseMode
 */ function $25d69fa430040087$export$f1c153626c2c2d91(parameters, responseMode) {
    parameters.set((0, $46f4c10c7ac0692f$export$2ae8b352eb8edff7), responseMode ? responseMode : (0, $8994aeee5e01080d$export$f990a5bae1260b8c).QUERY);
}
/**
 * Add flag to indicate STS should attempt to use WAM if available
 */ function $25d69fa430040087$export$8c305b8d324c4edb(parameters) {
    parameters.set((0, $46f4c10c7ac0692f$export$830ff7e6cf071f86), "1");
}
/**
 * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
 * @param scopeSet
 * @param addOidcScopes
 */ function $25d69fa430040087$export$c213bf8f125826ba(parameters, scopes, correlationId, addOidcScopes = true, defaultScopes = (0, $8994aeee5e01080d$export$893b1b5b686d84ef)) {
    // Always add openid to the scopes when adding OIDC scopes
    if (addOidcScopes && !defaultScopes.includes("openid") && !scopes.includes("openid")) defaultScopes.push("openid");
    const requestScopes = addOidcScopes ? [
        ...scopes || [],
        ...defaultScopes
    ] : scopes || [];
    const scopeSet = new (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99)(requestScopes, correlationId);
    parameters.set((0, $46f4c10c7ac0692f$export$1c5a554c78c0cd12), scopeSet.printScopes());
}
/**
 * add clientId
 * @param clientId
 */ function $25d69fa430040087$export$8360c651f9cc692b(parameters, clientId) {
    parameters.set((0, $46f4c10c7ac0692f$export$c7b1b63f5b60f8e), clientId);
}
/**
 * add redirect_uri
 * @param redirectUri
 */ function $25d69fa430040087$export$6758d6264f4f06(parameters, redirectUri) {
    parameters.set((0, $46f4c10c7ac0692f$export$89711068e98820c5), redirectUri);
}
/**
 * add post logout redirectUri
 * @param redirectUri
 */ function $25d69fa430040087$export$bb8081db67b059c0(parameters, redirectUri) {
    parameters.set((0, $46f4c10c7ac0692f$export$965624bb436bcb2), redirectUri);
}
/**
 * add id_token_hint to logout request
 * @param idTokenHint
 */ function $25d69fa430040087$export$c6f34f6f67740950(parameters, idTokenHint) {
    parameters.set((0, $46f4c10c7ac0692f$export$8d6737236a319b56), idTokenHint);
}
/**
 * add domain_hint
 * @param domainHint
 */ function $25d69fa430040087$export$1bd007a9d7fec290(parameters, domainHint) {
    parameters.set((0, $46f4c10c7ac0692f$export$41459bac1e74ba19), domainHint);
}
/**
 * add login_hint
 * @param loginHint
 */ function $25d69fa430040087$export$65f43fd4b28bba5f(parameters, loginHint) {
    parameters.set((0, $46f4c10c7ac0692f$export$defd6be6e02aaeb3), loginHint);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for login_hint
 * @param loginHint
 */ function $25d69fa430040087$export$aa9cca16bcc29d2d(parameters, loginHint) {
    parameters.set((0, $8994aeee5e01080d$export$28d77f87efed1d88).CCS_HEADER, `UPN:${loginHint}`);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for account object
 * @param loginHint
 */ function $25d69fa430040087$export$68a633ecf634a2ea(parameters, clientInfo) {
    parameters.set((0, $8994aeee5e01080d$export$28d77f87efed1d88).CCS_HEADER, `Oid:${clientInfo.uid}@${clientInfo.utid}`);
}
/**
 * add sid
 * @param sid
 */ function $25d69fa430040087$export$9d8531b0fa366b30(parameters, sid) {
    parameters.set((0, $46f4c10c7ac0692f$export$e9405f9e95799b52), sid);
}
/**
 * Adds claims to request parameters, conditionally excluding clientCapabilities
 * when skipBrokerClaims is true and a brokered flow is in effect.
 * @param parameters - The request parameters map
 * @param correlationId - The request correlation id
 * @param claims - The claims string from the request
 * @param clientCapabilities - The client capabilities from configuration
 * @param skipBrokerClaims - When true and BROKER_CLIENT_ID is present, excludes clientCapabilities from claims
 */ function $25d69fa430040087$export$b04c3bca9165ed02(parameters, correlationId, claims, clientCapabilities, skipBrokerClaims) {
    // Skip clientCapabilities if skipBrokerClaims is set to true and this is a brokered authentication flow
    const configClaims = skipBrokerClaims && parameters.has((0, $46f4c10c7ac0692f$export$3f910906fd5fe047)) ? undefined : clientCapabilities;
    const mergedClaims = $25d69fa430040087$export$ffd234d2f4f3cfb1(claims, configClaims, correlationId);
    parameters.set((0, $46f4c10c7ac0692f$export$c9b29cc9615296dd), mergedClaims);
}
/**
 * add correlationId
 * @param correlationId
 */ function $25d69fa430040087$export$8a224ff809946e9c(parameters, correlationId) {
    parameters.set((0, $46f4c10c7ac0692f$export$633c8d7cd18ad9a9), correlationId);
}
/**
 * add library info query params
 * @param libraryInfo
 */ function $25d69fa430040087$export$3ecac3764b147c3f(parameters, libraryInfo) {
    // Telemetry Info
    parameters.set((0, $46f4c10c7ac0692f$export$fe2f04d04881f19d), libraryInfo.sku);
    parameters.set((0, $46f4c10c7ac0692f$export$d0d0201281a553c0), libraryInfo.version);
    if (libraryInfo.os) parameters.set((0, $46f4c10c7ac0692f$export$35497983a44f9406), libraryInfo.os);
    if (libraryInfo.cpu) parameters.set((0, $46f4c10c7ac0692f$export$d14a6ca469cd1d2b), libraryInfo.cpu);
}
/**
 * Add client telemetry parameters
 * @param appTelemetry
 */ function $25d69fa430040087$export$37ec1b76d865654a(parameters, appTelemetry) {
    if (appTelemetry?.appName) parameters.set((0, $46f4c10c7ac0692f$export$6101af169595a2ae), appTelemetry.appName);
    if (appTelemetry?.appVersion) parameters.set((0, $46f4c10c7ac0692f$export$a8707209cc4254a), appTelemetry.appVersion);
}
/**
 * add prompt
 * @param prompt
 */ function $25d69fa430040087$export$e982ccd37a61cde6(parameters, prompt) {
    parameters.set((0, $46f4c10c7ac0692f$export$19855bb42e55939d), prompt);
}
/**
 * add state
 * @param state
 */ function $25d69fa430040087$export$4a8b8c14090dd065(parameters, state) {
    if (state) parameters.set((0, $46f4c10c7ac0692f$export$63b4527a2777036f), state);
}
/**
 * add nonce
 * @param nonce
 */ function $25d69fa430040087$export$87b1d5d886e84b11(parameters, nonce) {
    parameters.set((0, $46f4c10c7ac0692f$export$8646168ae3eb91e1), nonce);
}
/**
 * add code_challenge and code_challenge_method
 * - throw if either of them are not passed
 * @param codeChallenge
 * @param codeChallengeMethod
 */ function $25d69fa430040087$export$57a984e7ed784e16(parameters, codeChallenge, codeChallengeMethod) {
    if (codeChallenge && codeChallengeMethod) {
        parameters.set((0, $46f4c10c7ac0692f$export$58d2be3216991fee), codeChallenge);
        parameters.set((0, $46f4c10c7ac0692f$export$129e6f0601e36303), codeChallengeMethod);
    } else throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$2da3866b327f1753), "");
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function $25d69fa430040087$export$ff027aab2d77a49c(parameters, code) {
    parameters.set((0, $46f4c10c7ac0692f$export$ec5856072852bd7f), code);
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function $25d69fa430040087$export$8999dc4307159304(parameters, code) {
    parameters.set((0, $46f4c10c7ac0692f$export$a575303545717aec), code);
}
/**
 * add the `refreshToken` passed by the user
 * @param refreshToken
 */ function $25d69fa430040087$export$b9e8ccbb425b80a3(parameters, refreshToken) {
    parameters.set((0, $46f4c10c7ac0692f$export$2a2261c5a58ac0), refreshToken);
}
/**
 * add the `code_verifier` passed by the user to exchange for a token
 * @param codeVerifier
 */ function $25d69fa430040087$export$dceb49e3b4703cbb(parameters, codeVerifier) {
    parameters.set((0, $46f4c10c7ac0692f$export$a5a34ec10c757281), codeVerifier);
}
/**
 * add client_secret
 * @param clientSecret
 */ function $25d69fa430040087$export$8df84bbb0e2465bc(parameters, clientSecret) {
    parameters.set((0, $46f4c10c7ac0692f$export$69f7aececf3ea5d7), clientSecret);
}
/**
 * add clientAssertion for confidential client flows
 * @param clientAssertion
 */ function $25d69fa430040087$export$2d3d772920e2496e(parameters, clientAssertion) {
    if (clientAssertion) parameters.set((0, $46f4c10c7ac0692f$export$cddd1d85c78cca51), clientAssertion);
}
/**
 * add clientAssertionType for confidential client flows
 * @param clientAssertionType
 */ function $25d69fa430040087$export$55ad911d12112f00(parameters, clientAssertionType) {
    if (clientAssertionType) parameters.set((0, $46f4c10c7ac0692f$export$21aecb34d0e7d9c0), clientAssertionType);
}
/**
 * add OBO assertion for confidential client flows
 * @param clientAssertion
 */ function $25d69fa430040087$export$34b131001eea36b1(parameters, oboAssertion) {
    parameters.set((0, $46f4c10c7ac0692f$export$3529b31b0ae94ae0), oboAssertion);
}
/**
 * add grant type
 * @param grantType
 */ function $25d69fa430040087$export$b6d65fd125460167(parameters, tokenUse) {
    parameters.set((0, $46f4c10c7ac0692f$export$97bc1bf63f077c4a), tokenUse);
}
/**
 * add grant type
 * @param grantType
 */ function $25d69fa430040087$export$e5f700fdeb4022b2(parameters, grantType) {
    parameters.set((0, $46f4c10c7ac0692f$export$47f09697d0642170), grantType);
}
/**
 * add client info
 *
 */ function $25d69fa430040087$export$86b85a101d45e918(parameters) {
    parameters.set((0, $8994aeee5e01080d$export$476989d62bcb4c85), "1");
}
/**
 * add clidata=1 to request to indicate client data support
 */ function $25d69fa430040087$export$5a0058be0b2fe3ea(parameters) {
    parameters.set((0, $46f4c10c7ac0692f$export$d1fd943f3801b39a), "1");
}
function $25d69fa430040087$export$50b40dfb1d11b77a(parameters) {
    if (!parameters.has((0, $46f4c10c7ac0692f$export$d72b25d13120919d))) parameters.set((0, $46f4c10c7ac0692f$export$d72b25d13120919d), "true");
}
/**
 * Add extraParameters
 * @param extraParams - String dictionary containing extra parameters to be added.
 */ function $25d69fa430040087$export$7f71daa83fb7c7e2(parameters, extraParams) {
    Object.entries(extraParams).forEach(([key, value])=>{
        if (!parameters.has(key) && value) parameters.set(key, value);
    });
}
/**
 * Default optional idToken claims requested on all auth requests.
 * signin_state enables KMSI detection; login_hint enables login hint propagation.
 */ const $25d69fa430040087$var$DEFAULT_ID_TOKEN_CLAIMS = {
    [(0, $8994aeee5e01080d$export$c125cda26c71ef54).SIGNIN_STATE]: {
        essential: false
    },
    [(0, $8994aeee5e01080d$export$c125cda26c71ef54).LOGIN_HINT]: {
        essential: false
    }
};
/**
 * Parses claims JSON, merges default optional idToken claims (signin_state, login_hint),
 * and appends client capabilities (xms_cc) to the access_token section.
 * Does not overwrite idToken claims already specified by the caller.
 * @param claims - Existing claims JSON string from the request (may be undefined)
 * @param clientCapabilities - Client capabilities array from configuration
 * @returns Merged claims JSON string
 */ function $25d69fa430040087$export$ffd234d2f4f3cfb1(claims, clientCapabilities, correlationId = "") {
    let mergedClaims;
    // Parse provided claims into JSON object or initialize empty object
    if (!claims) mergedClaims = {};
    else try {
        const parsed = JSON.parse(claims);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) throw new Error("Claims must be a JSON object");
        mergedClaims = parsed;
    } catch (e) {
        throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$96e755c70e0d0e34), correlationId);
    }
    // Add default optional idToken claims
    if (!Object.prototype.hasOwnProperty.call(mergedClaims, (0, $8994aeee5e01080d$export$c125cda26c71ef54).ID_TOKEN)) mergedClaims[(0, $8994aeee5e01080d$export$c125cda26c71ef54).ID_TOKEN] = {};
    const idTokenClaims = mergedClaims[(0, $8994aeee5e01080d$export$c125cda26c71ef54).ID_TOKEN];
    for (const [key, value] of Object.entries($25d69fa430040087$var$DEFAULT_ID_TOKEN_CLAIMS))if (!(key in idTokenClaims)) idTokenClaims[key] = value;
    // Add client capabilities
    if (clientCapabilities && clientCapabilities.length > 0) {
        if (!Object.prototype.hasOwnProperty.call(mergedClaims, (0, $8994aeee5e01080d$export$c125cda26c71ef54).ACCESS_TOKEN)) // Add access_token key to claims object
        mergedClaims[(0, $8994aeee5e01080d$export$c125cda26c71ef54).ACCESS_TOKEN] = {};
        // Add xms_cc claim with provided clientCapabilities to access_token key
        mergedClaims[(0, $8994aeee5e01080d$export$c125cda26c71ef54).ACCESS_TOKEN][(0, $8994aeee5e01080d$export$c125cda26c71ef54).XMS_CC] = {
            values: clientCapabilities
        };
    }
    return JSON.stringify(mergedClaims);
}
/**
 * adds `username` for Password Grant flow
 * @param username
 */ function $25d69fa430040087$export$d38c772efe03a690(parameters, username) {
    parameters.set((0, $8994aeee5e01080d$export$fa8b29062cab1da).username, username);
}
/**
 * adds `password` for Password Grant flow
 * @param password
 */ function $25d69fa430040087$export$bfe833e59aa823e8(parameters, password) {
    parameters.set((0, $8994aeee5e01080d$export$fa8b29062cab1da).password, password);
}
/**
 * add pop_jwk to query params
 * @param cnfString
 */ function $25d69fa430040087$export$6dfc34809d8c4096(parameters, cnfString) {
    if (cnfString) {
        parameters.set((0, $46f4c10c7ac0692f$export$5706a68daf4f000a), (0, $8994aeee5e01080d$export$901491a717da2ba5).POP);
        parameters.set((0, $46f4c10c7ac0692f$export$427afb3f9eefe31e), cnfString);
    }
}
/**
 * add SSH JWK and key ID to query params
 */ function $25d69fa430040087$export$f004de9a266b8070(parameters, sshJwkString) {
    if (sshJwkString) {
        parameters.set((0, $46f4c10c7ac0692f$export$5706a68daf4f000a), (0, $8994aeee5e01080d$export$901491a717da2ba5).SSH);
        parameters.set((0, $46f4c10c7ac0692f$export$427afb3f9eefe31e), sshJwkString);
    }
}
/**
 * add server telemetry fields
 * @param serverTelemetryManager
 * @internal
 */ function $25d69fa430040087$export$79fb524b159705e9(parameters, serverTelemetryManager) {
    parameters.set((0, $46f4c10c7ac0692f$export$770dc090fda61e98), serverTelemetryManager.generateCurrentRequestHeaderValue());
    parameters.set((0, $46f4c10c7ac0692f$export$99d6087ff3bfb0d3), serverTelemetryManager.generateLastRequestHeaderValue());
}
/**
 * Adds parameter that indicates to the server that throttling is supported
 */ function $25d69fa430040087$export$26592ae2037df9de(parameters) {
    parameters.set((0, $46f4c10c7ac0692f$export$c5cd103a582a276), (0, $8994aeee5e01080d$export$796cc5ec53357060));
}
/**
 * Adds logout_hint parameter for "silent" logout which prevent server account picker
 */ function $25d69fa430040087$export$e0d4676d7288bded(parameters, logoutHint) {
    parameters.set((0, $46f4c10c7ac0692f$export$a96ff88ff08babe2), logoutHint);
}
function $25d69fa430040087$export$5ea4577e2a518c27(parameters, brokerClientId, brokerRedirectUri) {
    if (!parameters.has((0, $46f4c10c7ac0692f$export$3f910906fd5fe047))) parameters.set((0, $46f4c10c7ac0692f$export$3f910906fd5fe047), brokerClientId);
    if (!parameters.has((0, $46f4c10c7ac0692f$export$c3ecf58e7e228261))) parameters.set((0, $46f4c10c7ac0692f$export$c3ecf58e7e228261), brokerRedirectUri);
}
/**
 * Add EAR (Encrypted Authorize Response) request parameters
 * @param parameters
 * @param jwk
 */ function $25d69fa430040087$export$ec0b476da4a9fb0(parameters, jwk) {
    parameters.set((0, $46f4c10c7ac0692f$export$1e9ebf38b05380ef), encodeURIComponent(jwk));
    // ear_jwe_crypto will always have value: {"alg":"dir","enc":"A256GCM"} so we can hardcode this
    const jweCryptoB64Encoded = "eyJhbGciOiJkaXIiLCJlbmMiOiJBMjU2R0NNIn0";
    parameters.set((0, $46f4c10c7ac0692f$export$79d2fd0e357f5119), jweCryptoB64Encoded);
}
function $25d69fa430040087$export$dd712f36c1a9cd08(parameters, resource) {
    if (resource) parameters.set((0, $46f4c10c7ac0692f$export$84ba8fa7099b85b), resource);
}

var $d35bb33c1dc82f98$exports = {};

$parcel$export($d35bb33c1dc82f98$exports, "stripLeadingHashOrQuery", () => $d35bb33c1dc82f98$export$fe89dd256736a6b3);
$parcel$export($d35bb33c1dc82f98$exports, "getDeserializedResponse", () => $d35bb33c1dc82f98$export$f98e0976781b1204);
$parcel$export($d35bb33c1dc82f98$exports, "mapToQueryString", () => $d35bb33c1dc82f98$export$44d4663acf79cde2);
$parcel$export($d35bb33c1dc82f98$exports, "normalizeUrlForComparison", () => $d35bb33c1dc82f98$export$d87ce1a4b7c183c8);
$parcel$export($d35bb33c1dc82f98$exports, "validateUrl", () => $d35bb33c1dc82f98$export$52213319c01858f);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Parses hash string from given string. Returns empty string if no hash symbol is found.
 * @param hashString
 */ function $d35bb33c1dc82f98$export$fe89dd256736a6b3(responseString) {
    if (responseString.startsWith("#/")) return responseString.substring(2);
    else if (responseString.startsWith("#") || responseString.startsWith("?")) return responseString.substring(1);
    return responseString;
}
/**
 * Returns URL hash as server auth code response object.
 */ function $d35bb33c1dc82f98$export$f98e0976781b1204(responseString) {
    // Check if given hash is empty
    if (!responseString || responseString.indexOf("=") < 0) return null;
    try {
        // Strip the # or ? symbol if present
        const normalizedResponse = $d35bb33c1dc82f98$export$fe89dd256736a6b3(responseString);
        // If # symbol was not present, above will return empty string, so give original hash value
        const deserializedHash = Object.fromEntries(new URLSearchParams(normalizedResponse));
        // Check for known response properties
        if (deserializedHash.code || deserializedHash.ear_jwe || deserializedHash.error || deserializedHash.error_description || deserializedHash.state) return deserializedHash;
    } catch (e) {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$14c4d54a8414667f), "");
    }
    return null;
}
/**
 * Utility to create a URL from the params map
 */ function $d35bb33c1dc82f98$export$44d4663acf79cde2(parameters) {
    const queryParameterArray = new Array();
    parameters.forEach((value, key)=>{
        queryParameterArray.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParameterArray.join("&");
}
/**
 * Normalizes URLs for comparison per MDN & RFC 3986 standards:
 * - Hash/fragment is removed
 * - Scheme and host are lowercased (case-insensitive per spec)
 * - Path and query parameters preserve original casing (case-sensitive per spec)
 * - Percent-encoding in pathname is normalized (e.g., %27 and ' are treated equivalently)
 * - Ensures pathname ends with /
 * Throws a urlParseError if the provided URL is malformed and cannot be parsed.
 * @param url - URL to normalize
 * @param logger - Optional logger used to log parse failures
 * @param correlationId - Optional correlationId associated with the log entry
 * @returns Normalized URL string for comparison
 */ function $d35bb33c1dc82f98$export$d87ce1a4b7c183c8(url, logger, correlationId) {
    if (!url) return url;
    const urlWithoutHash = url.split("#")[0];
    if (!urlWithoutHash) return urlWithoutHash;
    try {
        const urlObj = new URL(urlWithoutHash);
        // Treat an empty query string (a bare trailing "?") as equivalent to no query
        if (!urlObj.search) urlObj.search = "";
        // Decode the pathname to normalize percent-encoding and ensure trailing slash
        let pathname;
        try {
            pathname = decodeURIComponent(urlObj.pathname);
        } catch (e) {
            pathname = urlObj.pathname;
        }
        if (!pathname.endsWith("/")) pathname += "/";
        urlObj.pathname = pathname;
        return urlObj.href;
    } catch (e) {
        logger?.error(`Failed to normalize URL for comparison: '${e}'`, correlationId || "");
        throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$ee2a1a3389f75508), correlationId || "");
    }
}
/**
 * Validates that the provided value is a well-formed, parseable absolute URL.
 * Throws a urlParseError if the value cannot be parsed by the URL API (e.g. the
 * literal string "null", an empty string, or any malformed/relative URL). Use this
 * to guard against persisting an invalid value (such as a redirect URL) to the cache.
 * @param url - URL to validate
 * @param logger - Optional logger used to log validation failures
 * @param correlationId - Optional correlationId associated with the log entry
 */ function $d35bb33c1dc82f98$export$52213319c01858f(url, logger, correlationId) {
    try {
        new URL(url);
    } catch (e) {
        logger?.error(`Failed to validate URL: '${e}'`, correlationId || "");
        throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$ee2a1a3389f75508), correlationId || "");
    }
}










'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts and parses the authentication response from URL (hash and/or query string).
 * This is a shared utility used across multiple components in msal-browser.
 *
 * @returns {Object} An object containing the parsed state information and URL parameters.
 * @returns {URLSearchParams} params - The parsed URL parameters from the payload.
 * @returns {string} payload - The combined query string and hash content.
 * @returns {string} urlHash - The original URL hash.
 * @returns {string} urlQuery - The original URL query string.
 * @returns {LibraryStateObject} libraryState - The decoded library state from the state parameter.
 *
 * @throws {AuthError} If no authentication payload is found in the URL.
 * @throws {AuthError} If the state parameter is missing.
 * @throws {AuthError} If the state is missing required 'id' or 'meta' attributes.
 */ function $8e677587a7c978db$export$a143506230fae361() {
    // Extract both hash and query string to support hybrid response format
    const urlHash = window.location.hash;
    const urlQuery = window.location.search;
    // Determine which part contains the auth response by checking for 'state' parameter
    let hasResponseInHash = false;
    let hasResponseInQuery = false;
    let payload = "";
    let params = undefined;
    if (urlHash && urlHash.length > 1) {
        const hashContent = urlHash.charAt(0) === "#" ? urlHash.substring(1) : urlHash;
        const hashParams = new URLSearchParams(hashContent);
        if (hashParams.has("state")) {
            hasResponseInHash = true;
            payload = hashContent;
            params = hashParams;
        }
    }
    if (urlQuery && urlQuery.length > 1) {
        const queryContent = urlQuery.charAt(0) === "?" ? urlQuery.substring(1) : urlQuery;
        const queryParams = new URLSearchParams(queryContent);
        if (queryParams.has("state")) {
            hasResponseInQuery = true;
            payload = queryContent;
            params = queryParams;
        }
    }
    // If response is in both, combine them (hybrid format)
    if (hasResponseInHash && hasResponseInQuery) {
        const queryContent = urlQuery.charAt(0) === "?" ? urlQuery.substring(1) : urlQuery;
        const hashContent = urlHash.charAt(0) === "#" ? urlHash.substring(1) : urlHash;
        payload = `${queryContent}${hashContent}`;
        params = new URLSearchParams(payload);
    }
    /*
     * Called by the redirect-bridge entry point before any request context exists,
     * so correlationId is intentionally empty for the throws below.
     */ if (!payload || !params) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$b07b0d8dc0894ecf), "");
    const state = params.get("state");
    if (!state) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$211c8e8843a8d278), "");
    const { libraryState: libraryState } = (0, $de6be0b6a0939617$exports).parseRequestState((0, $5949979cf1605326$export$c62426fdd000a97e), state, "");
    const { id: id, meta: meta } = libraryState;
    if (!id || !meta) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$237bdd0b913cb30c), "", "missing_library_state");
    return {
        params: params,
        payload: payload,
        urlHash: urlHash,
        urlQuery: urlQuery,
        hasResponseInHash: hasResponseInHash,
        hasResponseInQuery: hasResponseInQuery,
        libraryState: {
            id: id,
            meta: meta
        }
    };
}
/**
 * Clears hash from window url.
 */ function $8e677587a7c978db$export$a20c3032ba81d6aa(contentWindow) {
    // Office.js sets history.replaceState to null
    contentWindow.location.hash = "";
    if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
    contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}${contentWindow.location.search}`);
}
/**
 * Strips both hash and query string from the given window's URL by replacing
 * with origin + pathname only. Used to remove auth response parameters
 * (auth code, state, etc.) before the window is closed or navigated away.
 */ function $8e677587a7c978db$export$460894b9c7dcb1ac(contentWindow) {
    if (typeof contentWindow.history?.replaceState === "function") contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}`);
}
/**
 * Replaces current hash with hash from provided url
 */ function $8e677587a7c978db$export$9bf2691bda54425c(url) {
    const urlParts = url.split("#");
    urlParts.shift(); // Remove part before the hash
    window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
}
/**
 * Returns boolean of whether the current window is in an iframe or not.
 */ function $8e677587a7c978db$export$9f140ed41af5108c() {
    return window.parent !== window;
}
/**
 * Returns boolean of whether or not the current window is a popup opened by msal
 */ function $8e677587a7c978db$export$722fdce8786cc28b() {
    if ($8e677587a7c978db$export$9f140ed41af5108c()) return false;
    try {
        const { libraryState: libraryState } = $8e677587a7c978db$export$a143506230fae361();
        const { meta: meta } = libraryState;
        return meta["interactionType"] === (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup;
    } catch (e) {
        // If parsing fails (no state, invalid URL, etc.), we're not in a popup
        return false;
    }
}
/**
 * Await a response from a redirect bridge using BroadcastChannel.
 * This unified function works for both popup and iframe scenarios by listening on a
 * BroadcastChannel for the server payload.
 *
 * @param timeoutMs - Timeout in milliseconds.
 * @param logger - Logger instance for logging monitoring events.
 * @param browserCrypto - Browser crypto instance for decoding state.
 * @param request - The authorization or end session request.
 * @returns Promise<string> - Resolves with the response string (query or hash) from the window.
 */ // Track the active bridge monitor to allow cancellation when overriding interactions
let $8e677587a7c978db$var$activeBridgeMonitor = null;
/**
 * Cancels the pending bridge response monitor if one exists.
 * This is called when overrideInteractionInProgress is used to cancel
 * any pending popup interaction before starting a new one.
 */ function $8e677587a7c978db$export$faedfb2c37a42b1d(logger, correlationId) {
    if ($8e677587a7c978db$var$activeBridgeMonitor) {
        logger.verbose("18y01k", correlationId);
        clearTimeout($8e677587a7c978db$var$activeBridgeMonitor.timeoutId);
        $8e677587a7c978db$var$activeBridgeMonitor.channel.close();
        $8e677587a7c978db$var$activeBridgeMonitor.reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$87332f77d3f8befc), ""));
        $8e677587a7c978db$var$activeBridgeMonitor = null;
    }
}
/** @internal */ async function $8e677587a7c978db$export$f241abdbe4a81a03(timeoutMs, logger, request, performanceClient, experimentalConfig) {
    return new Promise((resolve, reject)=>{
        logger.verbose("1rf6em", request.correlationId);
        const correlationId = request.correlationId;
        performanceClient.addFields({
            redirectBridgeTimeoutMs: timeoutMs,
            lateResponseExperimentEnabled: experimentalConfig?.iframeTimeoutTelemetry || false
        }, correlationId);
        const { libraryState: libraryState } = (0, $de6be0b6a0939617$exports).parseRequestState((0, $5949979cf1605326$export$c62426fdd000a97e), request.state || "", request.correlationId);
        const channel = new BroadcastChannel(libraryState.id);
        let responseString = undefined;
        let timedOut$1 = false;
        let lateTimeoutId;
        let lateMeasurement;
        const timeoutId = window.setTimeout(()=>{
            // Clear the active monitor
            $8e677587a7c978db$var$activeBridgeMonitor = null;
            if (experimentalConfig?.iframeTimeoutTelemetry) {
                lateMeasurement = performanceClient.startMeasurement((0, $acc47f0f594e8d22$export$d9fd8b66da5a3a9a), correlationId);
                timedOut$1 = true;
                lateTimeoutId = window.setTimeout(()=>{
                    lateMeasurement?.end({
                        success: false
                    });
                    clearTimeout(lateTimeoutId);
                    channel.close();
                }, 60000); // 60s late response timeout to allow for telemetry of late responses
            } else channel.close();
            reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$ce7eeda4eb1dd3c6), "", "redirect_bridge_timeout"));
        }, timeoutMs);
        // Track this monitor so it can be cancelled if needed
        $8e677587a7c978db$var$activeBridgeMonitor = {
            timeoutId: timeoutId,
            channel: channel,
            reject: reject
        };
        channel.onmessage = (event)=>{
            responseString = event.data.payload;
            const messageVersion = event?.data && typeof event.data.v === "number" ? event.data.v : undefined;
            if (timedOut$1) {
                lateMeasurement?.end({
                    success: responseString ? true : false
                });
                clearTimeout(lateTimeoutId);
                channel.close();
                return;
            }
            performanceClient.addFields({
                redirectBridgeMessageVersion: messageVersion
            }, correlationId);
            // Clear the active monitor
            $8e677587a7c978db$var$activeBridgeMonitor = null;
            clearTimeout(timeoutId);
            channel.close();
            if (responseString) resolve(responseString);
            else reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$ef85f3d55419b6f4), correlationId));
        };
    });
}
// #endregion
/**
 * Returns current window URL as redirect uri
 */ function $8e677587a7c978db$export$1204531fbbf6ecde() {
    return typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "";
}
/**
 * Gets the homepage url for the current window location.
 */ function $8e677587a7c978db$export$60785768478b4ffc(correlationId) {
    const currentUrl = new (0, $9c756a14a1bed5db$export$3abcdca7229e54f2)(window.location.href, correlationId || "");
    const urlComponents = currentUrl.getUrlComponents();
    return `${urlComponents.Protocol}//${urlComponents.HostNameAndPort}/`;
}
/**
 * Throws error if we have completed an auth and are
 * attempting another auth request inside an iframe.
 */ function $8e677587a7c978db$export$8fdba407d8e31f54() {
    const isResponseHash = (0, $d35bb33c1dc82f98$exports).getDeserializedResponse(window.location.hash);
    // return an error if called from the hidden iframe created by the msal js silent calls
    if (isResponseHash && $8e677587a7c978db$export$9f140ed41af5108c()) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$71bafc2814e56c09), "");
}
/**
 * Block redirect operations in iframes unless explicitly allowed
 * @param interactionType Interaction type for the request
 * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
 */ function $8e677587a7c978db$export$5ae6b09f947c8a9e(allowRedirectInIframe) {
    if ($8e677587a7c978db$export$9f140ed41af5108c() && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
    throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$9cc12eb574ceee30), "");
}
/**
 * Block redirectUri loaded in popup from calling AcquireToken APIs
 */ function $8e677587a7c978db$export$dc99b653c8cd2cd7() {
    // Popups opened by msal popup APIs are given a name that starts with "msal."
    if ($8e677587a7c978db$export$722fdce8786cc28b()) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$c4a80c97d7b48f72), "");
}
/**
 * Throws error if token requests are made in non-browser environment
 * @param isBrowserEnvironment Flag indicating if environment is a browser.
 */ function $8e677587a7c978db$export$c7939bfe92ae2787() {
    if (typeof window === "undefined") throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$932e0f52d657f7fb), "");
}
/**
 * Throws error if initialize hasn't been called
 * @param initialized
 */ function $8e677587a7c978db$export$630119c5db8b5529(initialized) {
    if (!initialized) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$436657cdcd7fe2be), "");
}
/**
 * Helper to validate app environment before making an auth request
 * @param initialized
 */ function $8e677587a7c978db$export$4dd091cbdc98b52e(initialized) {
    // Block request if not in browser environment
    $8e677587a7c978db$export$c7939bfe92ae2787();
    // Block auth requests inside a hidden iframe
    $8e677587a7c978db$export$8fdba407d8e31f54();
    // Block redirectUri opened in a popup from calling MSAL APIs
    $8e677587a7c978db$export$dc99b653c8cd2cd7();
    // Block token acquisition before initialize has been called
    $8e677587a7c978db$export$630119c5db8b5529(initialized);
}
/**
 * Helper to validate app environment before making redirect request
 * @param initialized
 * @param config
 * @internal
 */ function $8e677587a7c978db$export$62c8f4fdca4df60f(initialized, config) {
    $8e677587a7c978db$export$4dd091cbdc98b52e(initialized);
    $8e677587a7c978db$export$5ae6b09f947c8a9e(config.system.allowRedirectInIframe);
    // Block redirects if memory storage is enabled
    if (config.cache.cacheLocation === (0, $7101cc4ee26a17a4$export$573384e47a12d835).MemoryStorage) throw (0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$37486e3b6bed61c6), "");
}
/**
 * Adds a preconnect link element to the header which begins DNS resolution and SSL connection in anticipation of the /token request
 * @param loginDomain Authority domain, including https protocol e.g. https://login.microsoftonline.com
 * @returns
 */ function $8e677587a7c978db$export$a0816fa17a9e79be(authority) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = new URL(authority).origin;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
    // The browser will close connection if not used within a few seconds, remove element from the header after 10s
    window.setTimeout(()=>{
        try {
            document.head.removeChild(link);
        } catch  {}
    }, 10000); // 10s Timeout
}
/**
 * Wrapper function that creates a UUID v7 from the current timestamp.
 * @returns {string}
 */ function $8e677587a7c978db$export$7571c350ed9fec74() {
    return (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)();
}
const $8e677587a7c978db$export$ffd234d2f4f3cfb1 = (0, $25d69fa430040087$exports).buildMergedClaims;


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/* eslint-disable header/header */ const $c8226bf52dd9a4ef$export$a8ff84c12d48cfa6 = "@azure/msal-browser";
const $c8226bf52dd9a4ef$export$83d89fbfd8236492 = "5.16.0";


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility function to remove an element from an array in place.
 * @param array - The array from which to remove the element.
 * @param element - The element to remove from the array.
 */ function $263fb32ebf848105$export$f6b67b4ecd4149d9(array, element) {
    const index = array.indexOf(element);
    if (index > -1) array.splice(index, 1);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Reason an old-schema cache entry was removed during migration.
 */ const $e624d8f74faf8e75$var$MigrationRemovalReason = {
    Invalid: "invalid",
    TtlExpired: "ttlExpired",
    DecryptFailed: "decryptFailed",
    Expired: "expired"
};
/**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 */ class $e624d8f74faf8e75$export$44d7291b5c8cc149 extends (0, $a087c4e9d9c3e8cc$export$996e3ea69314b5c6) {
    constructor(clientId, cacheConfig, cryptoImpl, logger, performanceClient, eventHandler, staticAuthorityOptions){
        super(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions);
        this.cacheConfig = cacheConfig;
        this.logger = logger;
        this.internalStorage = new (0, $14f17b15811f4641$export$d7392285c701ecf5)();
        this.browserStorage = $e624d8f74faf8e75$var$getStorageImplementation(clientId, cacheConfig.cacheLocation, logger, performanceClient);
        this.temporaryCacheStorage = $e624d8f74faf8e75$var$getStorageImplementation(clientId, (0, $7101cc4ee26a17a4$export$573384e47a12d835).SessionStorage, logger, performanceClient);
        this.cookieStorage = new (0, $42298ec3717585a2$export$dae7d845015939d5)();
        this.eventHandler = eventHandler;
    }
    async initialize(correlationId) {
        this.performanceClient.addFields({
            cacheLocation: this.cacheConfig.cacheLocation,
            cacheRetentionDays: this.cacheConfig.cacheRetentionDays
        }, correlationId);
        await this.browserStorage.initialize(correlationId);
        await this.migrateExistingCache(correlationId);
        this.trackVersionChanges(correlationId);
    }
    /**
     * Migrates any existing cache data from previous versions of MSAL.js into the current cache structure.
     */ async migrateExistingCache(correlationId) {
        let accountKeys = (0, $3485a03b74b26dfd$export$beb6809f8bbb3df6)(this.browserStorage);
        let tokenKeys = (0, $3485a03b74b26dfd$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            preMigrateAcntCount: accountKeys.length,
            preMigrateATCount: tokenKeys.accessToken.length,
            preMigrateITCount: tokenKeys.idToken.length,
            preMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
        for(let i = 0; i < (0, $6669d8f0f59e64dc$export$4693794d1f911b27); i++){
            const credentialSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.removeStaleAccounts(i, credentialSchema, correlationId);
        }
        // Must migrate idTokens first to ensure we have KMSI info for the rest
        for(let i = 0; i < (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d); i++){
            const accountSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.migrateIdTokens(i, accountSchema, correlationId);
        }
        const kmsiMap = this.getKMSIValues();
        for(let i = 0; i < (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d); i++){
            await this.migrateAccessTokens(i, kmsiMap, correlationId);
            await this.migrateRefreshTokens(i, kmsiMap, correlationId);
        }
        accountKeys = (0, $3485a03b74b26dfd$export$beb6809f8bbb3df6)(this.browserStorage);
        tokenKeys = (0, $3485a03b74b26dfd$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            postMigrateAcntCount: accountKeys.length,
            postMigrateATCount: tokenKeys.accessToken.length,
            postMigrateITCount: tokenKeys.idToken.length,
            postMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
    }
    /**
     * Parses entry, adds lastUpdatedAt if it doesn't exist, removes entry if expired or invalid
     * @param key
     * @param correlationId
     * @returns
     */ async updateOldEntry(key, correlationId) {
        const rawValue = this.browserStorage.getItem(key);
        const parsedValue = this.validateAndParseJson(rawValue || "");
        if (!parsedValue) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $e624d8f74faf8e75$var$MigrationRemovalReason.Invalid
            };
        }
        if (!parsedValue.lastUpdatedAt) {
            // Add lastUpdatedAt to the existing v0 entry if it doesnt exist so we know when it's safe to remove it
            parsedValue.lastUpdatedAt = Date.now().toString();
            this.setItem(key, JSON.stringify(parsedValue), correlationId);
        } else if ((0, $e0616e53cd3f026f$exports).isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $e624d8f74faf8e75$var$MigrationRemovalReason.TtlExpired
            };
        }
        const wasEncrypted = (0, $4833b6d6d0ccb7ef$export$691b4523c5340423)(parsedValue);
        const decryptedData = wasEncrypted ? await this.browserStorage.decryptData(key, parsedValue, correlationId) : parsedValue;
        if (!decryptedData) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: wasEncrypted ? $e624d8f74faf8e75$var$MigrationRemovalReason.DecryptFailed : $e624d8f74faf8e75$var$MigrationRemovalReason.Invalid
            };
        }
        if (!(0, $4cd4d8a6d71d39a8$exports).isCredentialEntity(decryptedData)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $e624d8f74faf8e75$var$MigrationRemovalReason.Invalid
            };
        }
        if (((0, $4cd4d8a6d71d39a8$exports).isAccessTokenEntity(decryptedData) || (0, $4cd4d8a6d71d39a8$exports).isRefreshTokenEntity(decryptedData)) && decryptedData.expiresOn && (0, $e0616e53cd3f026f$exports).isTokenExpired(decryptedData.expiresOn, (0, $8994aeee5e01080d$exports).DEFAULT_TOKEN_RENEWAL_OFFSET_SEC)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $e624d8f74faf8e75$var$MigrationRemovalReason.Expired
            };
        }
        return {
            entry: decryptedData
        };
    }
    /**
     * Remove accounts from the cache for older schema versions if they have not been updated in the last cacheRetentionDays
     * @param accountSchema
     * @param credentialSchema
     * @param correlationId
     * @returns
     */ async removeStaleAccounts(accountSchema, credentialSchema, correlationId) {
        const accountKeysToCheck = (0, $3485a03b74b26dfd$export$beb6809f8bbb3df6)(this.browserStorage, accountSchema);
        if (accountKeysToCheck.length === 0) return;
        for (const accountKey of [
            ...accountKeysToCheck
        ]){
            this.performanceClient.incrementFields({
                oldAcntCount: 1
            }, correlationId);
            const rawValue = this.browserStorage.getItem(accountKey);
            const parsedValue = this.validateAndParseJson(rawValue || "");
            if (!parsedValue) {
                this.browserStorage.removeItem(accountKey);
                this.performanceClient.incrementFields({
                    invalidAcntCount: 1
                }, correlationId);
                (0, $263fb32ebf848105$export$f6b67b4ecd4149d9)(accountKeysToCheck, accountKey);
                continue;
            }
            if (!parsedValue.lastUpdatedAt) {
                // Add lastUpdatedAt to the existing entry if it doesnt exist so we know when it's safe to remove it
                parsedValue.lastUpdatedAt = Date.now().toString();
                this.setItem(accountKey, JSON.stringify(parsedValue), correlationId);
                continue;
            } else if ((0, $e0616e53cd3f026f$exports).isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
                // Cache expired remove account and associated tokens
                await this.removeAccountOldSchema(accountKey, parsedValue, credentialSchema, correlationId);
                this.performanceClient.incrementFields({
                    ttlExpiredAcntCount: 1
                }, correlationId);
                (0, $263fb32ebf848105$export$f6b67b4ecd4149d9)(accountKeysToCheck, accountKey);
            } else if ((0, $4833b6d6d0ccb7ef$export$691b4523c5340423)(parsedValue)) {
                // Remove accounts encrypted with a different key (session cookie expired/changed)
                const decrypted = await this.browserStorage.decryptData(accountKey, parsedValue, correlationId);
                if (!decrypted) {
                    this.browserStorage.removeItem(accountKey);
                    this.performanceClient.incrementFields({
                        decryptFailedAcntCount: 1
                    }, correlationId);
                    (0, $263fb32ebf848105$export$f6b67b4ecd4149d9)(accountKeysToCheck, accountKey);
                }
            }
        }
        this.setAccountKeys(accountKeysToCheck, correlationId, accountSchema);
    }
    /**
     * Remove the given account and all associated tokens from the cache
     * @param accountKey
     * @param rawObject
     * @param credentialSchema
     * @param correlationId
     */ async removeAccountOldSchema(accountKey, rawObject, credentialSchema, correlationId) {
        const decryptedData = (0, $4833b6d6d0ccb7ef$export$691b4523c5340423)(rawObject) ? await this.browserStorage.decryptData(accountKey, rawObject, correlationId) : rawObject;
        const homeAccountId = decryptedData?.homeAccountId;
        if (homeAccountId) {
            const tokenKeys = this.getTokenKeys(credentialSchema);
            [
                ...tokenKeys.idToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, $263fb32ebf848105$export$f6b67b4ecd4149d9)(tokenKeys.idToken, key);
            });
            [
                ...tokenKeys.accessToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, $263fb32ebf848105$export$f6b67b4ecd4149d9)(tokenKeys.accessToken, key);
            });
            [
                ...tokenKeys.refreshToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, $263fb32ebf848105$export$f6b67b4ecd4149d9)(tokenKeys.refreshToken, key);
            });
            this.setTokenKeys(tokenKeys, correlationId, credentialSchema);
        }
        this.browserStorage.removeItem(accountKey);
    }
    /**
     * Gets key value pair mapping homeAccountId to KMSI value
     * @returns
     */ getKMSIValues() {
        const kmsiMap = {};
        const tokenKeys = this.getTokenKeys().idToken;
        for (const key of tokenKeys){
            const rawValue = this.browserStorage.getUserData(key);
            if (rawValue) {
                const idToken = JSON.parse(rawValue);
                const claims = (0, $4acd0486289e3b4f$exports).extractTokenClaims(idToken.secret, (0, $5949979cf1605326$export$c62426fdd000a97e), "");
                if (claims) kmsiMap[idToken.homeAccountId] = (0, $4acd0486289e3b4f$exports).isKmsi(claims);
            }
        }
        return kmsiMap;
    }
    /**
     * Migrates id tokens from the old schema to the new schema, also migrates associated account object if it doesn't already exist in the new schema
     * @param credentialSchema
     * @param accountSchema
     * @param correlationId
     * @returns
     */ async migrateIdTokens(credentialSchema, accountSchema, correlationId) {
        const credentialKeysToMigrate = (0, $3485a03b74b26dfd$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.idToken.length === 0) return;
        const currentCredentialKeys = (0, $3485a03b74b26dfd$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d));
        const currentAccountKeys = (0, $3485a03b74b26dfd$export$beb6809f8bbb3df6)(this.browserStorage);
        const previousAccountKeys = (0, $3485a03b74b26dfd$export$beb6809f8bbb3df6)(this.browserStorage, accountSchema);
        for (const idTokenKey of [
            ...credentialKeysToMigrate.idToken
        ]){
            this.performanceClient.incrementFields({
                oldITCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(idTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case $e624d8f74faf8e75$var$MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredITCount: 1
                        }, correlationId);
                        break;
                    case $e624d8f74faf8e75$var$MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedITCount: 1
                        }, correlationId);
                        break;
                    case $e624d8f74faf8e75$var$MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidITCount: 1
                        }, correlationId);
                        break;
                }
                (0, $263fb32ebf848105$export$f6b67b4ecd4149d9)(credentialKeysToMigrate.idToken, idTokenKey);
                continue;
            }
            const currentAccountKey = currentAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            const previousAccountKey = previousAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            let account = null;
            if (currentAccountKey) account = this.getAccount(currentAccountKey, correlationId);
            else if (previousAccountKey) {
                const rawValue = this.browserStorage.getItem(previousAccountKey);
                const parsedValue = this.validateAndParseJson(rawValue || "");
                account = parsedValue && (0, $4833b6d6d0ccb7ef$export$691b4523c5340423)(parsedValue) ? await this.browserStorage.decryptData(previousAccountKey, parsedValue, correlationId) : parsedValue;
            }
            if (!account) {
                // Don't migrate idToken if we don't have an account for it
                this.performanceClient.incrementFields({
                    skipITMigrateCount: 1
                }, correlationId);
                continue;
            }
            const claims = (0, $4acd0486289e3b4f$exports).extractTokenClaims(oldSchemaData.secret, (0, $5949979cf1605326$export$c62426fdd000a97e), correlationId);
            const newIdTokenKey = this.generateCredentialKey(oldSchemaData);
            const currentIdToken = this.getIdTokenCredential(newIdTokenKey, correlationId);
            const oldTokenHasSignInState = Object.keys(claims).includes("signin_state");
            const currentTokenHasSignInState = currentIdToken && Object.keys((0, $4acd0486289e3b4f$exports).extractTokenClaims(currentIdToken.secret, (0, $5949979cf1605326$export$c62426fdd000a97e), correlationId) || {}).includes("signin_state");
            /**
             * Only migrate if:
             * 1. Token doesn't yet exist in current schema
             * 2. Old schema token has been updated more recently than the current one AND migrating it won't result in loss of KMSI state
             */ if (!currentIdToken || oldSchemaData.lastUpdatedAt > currentIdToken.lastUpdatedAt && (oldTokenHasSignInState || !currentTokenHasSignInState)) {
                const tenantProfiles = account.tenantProfiles || [];
                const tenantId = (0, $616279607e3ed735$export$8e1decb9a5e2932)(claims) || account.realm;
                if (tenantId && !tenantProfiles.find((tenantProfile)=>{
                    return tenantProfile.tenantId === tenantId;
                })) {
                    const newTenantProfile = (0, $7beee762cc5bd6b9$export$924857724cb21ba4)(account.homeAccountId, account.localAccountId, tenantId, account.nativeAccountId, claims);
                    tenantProfiles.push(newTenantProfile);
                }
                account.tenantProfiles = tenantProfiles;
                const newAccountKey = this.generateAccountKey((0, $f136bee61a3373e4$exports).getAccountInfo(account));
                const kmsi = (0, $4acd0486289e3b4f$exports).isKmsi(claims);
                await this.setUserData(newAccountKey, JSON.stringify(account), correlationId, account.lastUpdatedAt, kmsi);
                if (!currentAccountKeys.includes(newAccountKey)) currentAccountKeys.push(newAccountKey);
                await this.setUserData(newIdTokenKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedITCount: 1
                }, correlationId);
                if (!currentCredentialKeys.idToken.includes(newIdTokenKey)) currentCredentialKeys.idToken.push(newIdTokenKey);
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
        this.setAccountKeys(currentAccountKeys, correlationId);
    }
    /**
     * Migrates access tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateAccessTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = (0, $3485a03b74b26dfd$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.accessToken.length === 0) return;
        const currentCredentialKeys = (0, $3485a03b74b26dfd$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d));
        for (const accessTokenKey of [
            ...credentialKeysToMigrate.accessToken
        ]){
            this.performanceClient.incrementFields({
                oldATCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(accessTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case $e624d8f74faf8e75$var$MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredATCount: 1
                        }, correlationId);
                        break;
                    case $e624d8f74faf8e75$var$MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedATCount: 1
                        }, correlationId);
                        break;
                    case $e624d8f74faf8e75$var$MigrationRemovalReason.Expired:
                        this.performanceClient.incrementFields({
                            expiredATCount: 1
                        }, correlationId);
                        break;
                    case $e624d8f74faf8e75$var$MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidATCount: 1
                        }, correlationId);
                        break;
                }
                (0, $263fb32ebf848105$export$f6b67b4ecd4149d9)(credentialKeysToMigrate.accessToken, accessTokenKey);
                continue;
            }
            if (!(oldSchemaData.homeAccountId in kmsiMap)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipATMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.accessToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedATCount: 1
                }, correlationId);
                currentCredentialKeys.accessToken.push(newKey);
            } else {
                const currentToken = this.getAccessTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedATCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Migrates refresh tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateRefreshTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = (0, $3485a03b74b26dfd$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.refreshToken.length === 0) return;
        const currentCredentialKeys = (0, $3485a03b74b26dfd$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d));
        for (const refreshTokenKey of [
            ...credentialKeysToMigrate.refreshToken
        ]){
            this.performanceClient.incrementFields({
                oldRTCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(refreshTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case $e624d8f74faf8e75$var$MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredRTCount: 1
                        }, correlationId);
                        break;
                    case $e624d8f74faf8e75$var$MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedRTCount: 1
                        }, correlationId);
                        break;
                    case $e624d8f74faf8e75$var$MigrationRemovalReason.Expired:
                        this.performanceClient.incrementFields({
                            expiredRTCount: 1
                        }, correlationId);
                        break;
                    case $e624d8f74faf8e75$var$MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidRTCount: 1
                        }, correlationId);
                        break;
                }
                (0, $263fb32ebf848105$export$f6b67b4ecd4149d9)(credentialKeysToMigrate.refreshToken, refreshTokenKey);
                continue;
            }
            if (!(oldSchemaData.homeAccountId in kmsiMap)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipRTMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.refreshToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedRTCount: 1
                }, correlationId);
                currentCredentialKeys.refreshToken.push(newKey);
            } else {
                const currentToken = this.getRefreshTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedRTCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Tracks upgrades and downgrades for telemetry and debugging purposes
     */ trackVersionChanges(correlationId) {
        const previousVersion = this.browserStorage.getItem((0, $6669d8f0f59e64dc$export$6825ebfedde34998));
        if (previousVersion) {
            this.logger.info(`1wuc87 ${previousVersion}`, correlationId);
            this.performanceClient.addGlobalFields({
                previousLibraryVersion: previousVersion
            });
        }
        if (previousVersion !== (0, $c8226bf52dd9a4ef$export$83d89fbfd8236492)) this.setItem((0, $6669d8f0f59e64dc$export$6825ebfedde34998), (0, $c8226bf52dd9a4ef$export$83d89fbfd8236492), correlationId);
    }
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ validateAndParseJson(jsonValue) {
        if (!jsonValue) return null;
        try {
            const parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    }
    /**
     * Helper to setItem in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     */ setItem(key, value, correlationId) {
        const tokenKeysCount = new Array((0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d) + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)// Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
        try {
            this.browserStorage.setItem(key, value);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d); schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = (0, $7cf95cc28691dd17$export$2056718aee1b1d88)(e);
            if (cacheError.errorCode === (0, $faceeef73c915a1b$exports).cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) {
                    // If we are currently trying to set the token keys, use the value we're trying to set
                    for(let i = 0; i <= (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d); i++)if (key === (0, $6669d8f0f59e64dc$export$79944bbef1910535)(this.clientId, i)) {
                        const tokenKeys = JSON.parse(value).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    } else {
                        const tokenKeys = this.getTokenKeys(i).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    }
                }
                if (accessTokenKeys.length <= i) // Nothing to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Helper to setUserData in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     * @param correlationId
     */ async setUserData(key, value, correlationId, timestamp, kmsi) {
        const tokenKeysCount = new Array((0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d) + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)try {
            // Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
            await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.browserStorage.setUserData.bind(this.browserStorage), (0, $0d9eb83114fc9425$exports).SetUserData, this.logger, this.performanceClient, correlationId)(key, value, correlationId, timestamp, kmsi);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d); schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = (0, $7cf95cc28691dd17$export$2056718aee1b1d88)(e);
            if (cacheError.errorCode === (0, $faceeef73c915a1b$exports).cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) // If we are currently trying to set the token keys, use the value we're trying to set
                for(let i = 0; i <= (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d); i++){
                    const tokenKeys = this.getTokenKeys(i).accessToken;
                    accessTokenKeys.push(...tokenKeys);
                    tokenKeysCount[i] = tokenKeys.length;
                }
                if (accessTokenKeys.length <= i) // Nothing left to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Reads account from cache, deserializes it into an account entity and returns it.
     * If account is not found from the key, returns null and removes key from map.
     * @param accountKey
     * @returns
     */ getAccount(accountKey, correlationId) {
        this.logger.trace("1lfvm6", correlationId);
        const serializedAccount = this.browserStorage.getUserData(accountKey);
        if (!serializedAccount) {
            this.removeAccountKeyFromMap(accountKey, correlationId);
            return null;
        }
        const parsedAccount = this.validateAndParseJson(serializedAccount);
        if (!parsedAccount || !(0, $f136bee61a3373e4$exports).isAccountEntity(parsedAccount)) return null;
        const account = (0, $a087c4e9d9c3e8cc$export$996e3ea69314b5c6).toObject({}, parsedAccount);
        this.performanceClient.addFields({
            accountCachedBy: (0, $7101cc4ee26a17a4$export$970e8382081b483f)(account.cachedByApiId)
        }, correlationId);
        return account;
    }
    /**
     * set account entity in the platform cache
     * @param account
     */ async setAccount(account, correlationId, kmsi, apiId) {
        this.logger.trace("1bz3wr", correlationId);
        const key = this.generateAccountKey((0, $f136bee61a3373e4$exports).getAccountInfo(account));
        const timestamp = Date.now().toString();
        account.lastUpdatedAt = timestamp;
        account.cachedByApiId = apiId;
        await this.setUserData(key, JSON.stringify(account), correlationId, timestamp, kmsi);
        this.addAccountKeyToMap(key, correlationId);
        this.performanceClient.addFields({
            kmsi: kmsi
        }, correlationId);
    }
    setAccountKeys(accountKeys, correlationId, schemaVersion = (0, $6669d8f0f59e64dc$export$4693794d1f911b27)) {
        if (accountKeys.length === 0) this.removeItem((0, $6669d8f0f59e64dc$export$8cef587ddea5c5f6)(schemaVersion));
        else this.setItem((0, $6669d8f0f59e64dc$export$8cef587ddea5c5f6)(schemaVersion), JSON.stringify(accountKeys), correlationId);
    }
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ getAccountKeys() {
        return (0, $3485a03b74b26dfd$export$beb6809f8bbb3df6)(this.browserStorage);
    }
    /**
     * Add a new account to the key map
     * @param key
     */ addAccountKeyToMap(key, correlationId) {
        this.logger.trace("0rb85k", correlationId);
        this.logger.tracePii(`1l9bdo ${key}`, correlationId);
        const accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem((0, $6669d8f0f59e64dc$export$8cef587ddea5c5f6)(), JSON.stringify(accountKeys), correlationId);
            this.logger.verbose("0xia39", correlationId);
            return true;
        } else {
            this.logger.verbose("0161kk", correlationId);
            return false;
        }
    }
    /**
     * Remove an account from the key map
     * @param key
     */ removeAccountKeyFromMap(key, correlationId) {
        this.logger.trace("1jpigu", correlationId);
        this.logger.tracePii(`1xzspl ${key}`, correlationId);
        const accountKeys = this.getAccountKeys();
        const removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            this.setAccountKeys(accountKeys, correlationId);
        } else this.logger.trace("1dytu2", correlationId);
    }
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ removeAccount(account, correlationId) {
        const activeAccount = this.getActiveAccount(correlationId);
        if (activeAccount?.homeAccountId === account.homeAccountId && activeAccount?.environment === account.environment) this.setActiveAccount(null, correlationId);
        super.removeAccount(account, correlationId);
        this.removeAccountKeyFromMap(this.generateAccountKey(account), correlationId);
        // Remove all other associated cache items
        this.browserStorage.getKeys().forEach((key)=>{
            if (key.includes(account.homeAccountId) && key.includes(account.environment)) this.browserStorage.removeItem(key);
        });
    }
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ removeIdToken(key, correlationId) {
        super.removeIdToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const idRemoval = tokenKeys.idToken.indexOf(key);
        if (idRemoval > -1) {
            this.logger.info("05udv9", correlationId);
            tokenKeys.idToken.splice(idRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ removeAccessToken(key, correlationId, updateTokenKeys = true) {
        super.removeAccessToken(key, correlationId);
        updateTokenKeys && this.removeAccessTokenKeys([
            key
        ], correlationId);
    }
    /**
     * Remove access token key from the key map
     * @param key
     * @param correlationId
     * @param tokenKeys
     */ removeAccessTokenKeys(keys, correlationId, schemaVersion = (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d)) {
        this.logger.trace("17o18n", correlationId);
        const tokenKeys = this.getTokenKeys(schemaVersion);
        let keysRemoved = 0;
        keys.forEach((key)=>{
            const accessRemoval = tokenKeys.accessToken.indexOf(key);
            if (accessRemoval > -1) {
                tokenKeys.accessToken.splice(accessRemoval, 1);
                keysRemoved++;
            }
        });
        if (keysRemoved > 0) {
            this.logger.info(`15i5d5 ${keysRemoved}`, correlationId);
            this.setTokenKeys(tokenKeys, correlationId, schemaVersion);
            return;
        }
    }
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ removeRefreshToken(key, correlationId) {
        super.removeRefreshToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const refreshRemoval = tokenKeys.refreshToken.indexOf(key);
        if (refreshRemoval > -1) {
            this.logger.info("1f4fq3", correlationId);
            tokenKeys.refreshToken.splice(refreshRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ getTokenKeys(schemaVersion = (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d)) {
        return (0, $3485a03b74b26dfd$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, schemaVersion);
    }
    /**
     * Sets the token keys in the cache
     * @param tokenKeys
     * @param correlationId
     * @returns
     */ setTokenKeys(tokenKeys, correlationId, schemaVersion = (0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d)) {
        if (tokenKeys.idToken.length === 0 && tokenKeys.accessToken.length === 0 && tokenKeys.refreshToken.length === 0) {
            // If no keys left, remove the map
            this.removeItem((0, $6669d8f0f59e64dc$export$79944bbef1910535)(this.clientId, schemaVersion));
            return;
        } else this.setItem((0, $6669d8f0f59e64dc$export$79944bbef1910535)(this.clientId, schemaVersion), JSON.stringify(tokenKeys), correlationId);
    }
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ getIdTokenCredential(idTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(idTokenKey);
        if (!value) {
            this.logger.trace("1jukz6", correlationId);
            this.removeIdToken(idTokenKey, correlationId);
            return null;
        }
        const parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !(0, $4cd4d8a6d71d39a8$exports).isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("1jukz6", correlationId);
            return null;
        }
        this.logger.trace("01ju66", correlationId);
        return parsedIdToken;
    }
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ async setIdTokenCredential(idToken, correlationId, kmsi) {
        this.logger.trace("13hjll", correlationId);
        const idTokenKey = this.generateCredentialKey(idToken);
        const timestamp = Date.now().toString();
        idToken.lastUpdatedAt = timestamp;
        await this.setUserData(idTokenKey, JSON.stringify(idToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.idToken.indexOf(idTokenKey) === -1) {
            this.logger.info("07jy92", correlationId);
            tokenKeys.idToken.push(idTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * generates accessToken entity from a string
     * @param key
     */ getAccessTokenCredential(accessTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(accessTokenKey);
        if (!value) {
            this.logger.trace("0bqvx8", correlationId);
            this.removeAccessTokenKeys([
                accessTokenKey
            ], correlationId);
            return null;
        }
        const parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !(0, $4cd4d8a6d71d39a8$exports).isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("0bqvx8", correlationId);
            return null;
        }
        this.logger.trace("1o81rl", correlationId);
        return parsedAccessToken;
    }
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */ async setAccessTokenCredential(accessToken, correlationId, kmsi) {
        this.logger.trace("1pondb", correlationId);
        const accessTokenKey = this.generateCredentialKey(accessToken);
        const timestamp = Date.now().toString();
        accessToken.lastUpdatedAt = timestamp;
        await this.setUserData(accessTokenKey, JSON.stringify(accessToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        const index = tokenKeys.accessToken.indexOf(accessTokenKey);
        if (index !== -1) tokenKeys.accessToken.splice(index, 1); // Remove existing key before pushing to the end
        this.logger.trace(`1onhey ${index === -1 ? "added to" : "updated in"}`, correlationId);
        tokenKeys.accessToken.push(accessTokenKey);
        this.setTokenKeys(tokenKeys, correlationId);
    }
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ getRefreshTokenCredential(refreshTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(refreshTokenKey);
        if (!value) {
            this.logger.trace("0jlizt", correlationId);
            this.removeRefreshToken(refreshTokenKey, correlationId);
            return null;
        }
        const parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !(0, $4cd4d8a6d71d39a8$exports).isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("0jlizt", correlationId);
            return null;
        }
        this.logger.trace("0nokxi", correlationId);
        return parsedRefreshToken;
    }
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ async setRefreshTokenCredential(refreshToken, correlationId, kmsi) {
        this.logger.trace("0tcg8d", correlationId);
        const refreshTokenKey = this.generateCredentialKey(refreshToken);
        const timestamp = Date.now().toString();
        refreshToken.lastUpdatedAt = timestamp;
        await this.setUserData(refreshTokenKey, JSON.stringify(refreshToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.refreshToken.indexOf(refreshTokenKey) === -1) {
            this.logger.info("0eckjs", correlationId);
            tokenKeys.refreshToken.push(refreshTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     * @param correlationId
     */ getAppMetadata(appMetadataKey, correlationId) {
        const value = this.browserStorage.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("1q101h", correlationId);
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, $4cd4d8a6d71d39a8$exports).isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("1q101h", correlationId);
            return null;
        }
        this.logger.trace("19pvg2", correlationId);
        return parsedMetadata;
    }
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     * @param correlationId
     */ setAppMetadata(appMetadata, correlationId) {
        this.logger.trace("0cyma6", correlationId);
        const appMetadataKey = (0, $4cd4d8a6d71d39a8$exports).generateAppMetadataKey(appMetadata);
        this.setItem(appMetadataKey, JSON.stringify(appMetadata), correlationId);
    }
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     * @param correlationId
     */ getServerTelemetry(serverTelemetryKey, correlationId) {
        const value = this.browserStorage.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("0jk19c", correlationId);
            return null;
        }
        const parsedEntity = this.validateAndParseJson(value);
        if (!parsedEntity || !(0, $4cd4d8a6d71d39a8$exports).isServerTelemetryEntity(serverTelemetryKey, parsedEntity)) {
            this.logger.trace("0jk19c", correlationId);
            return null;
        }
        this.logger.trace("12jguk", correlationId);
        return parsedEntity;
    }
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ setServerTelemetry(serverTelemetryKey, serverTelemetry, correlationId) {
        this.logger.trace("1poh61", correlationId);
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry), correlationId);
    }
    /**
     *
     */ getAuthorityMetadata(key, correlationId) {
        const value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("1r39oe", correlationId);
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && (0, $4cd4d8a6d71d39a8$exports).isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("1ohvk3", correlationId);
            return parsedMetadata;
        }
        return null;
    }
    /**
     *
     */ getAuthorityMetadataKeys() {
        const allKeys = this.internalStorage.getKeys();
        return allKeys.filter((key)=>{
            return this.isAuthorityMetadata(key);
        });
    }
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ setWrapperMetadata(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem((0, $7101cc4ee26a17a4$export$8f546f90896bcfa9).WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem((0, $7101cc4ee26a17a4$export$8f546f90896bcfa9).WRAPPER_VER, wrapperVersion);
    }
    /**
     * Returns wrapper metadata from in-memory storage
     */ getWrapperMetadata() {
        const sku = this.internalStorage.getItem((0, $7101cc4ee26a17a4$export$8f546f90896bcfa9).WRAPPER_SKU) || "";
        const version = this.internalStorage.getItem((0, $7101cc4ee26a17a4$export$8f546f90896bcfa9).WRAPPER_VER) || "";
        return [
            sku,
            version
        ];
    }
    /**
     *
     * @param key
     * @param entity
     * @param correlationId
     */ setAuthorityMetadata(key, entity, correlationId) {
        this.logger.trace("07w8n2", correlationId);
        this.internalStorage.setItem(key, JSON.stringify(entity));
    }
    /**
     * Gets the active account
     */ getActiveAccount(correlationId) {
        const activeAccountKeyFilters = this.generateCacheKey((0, $8994aeee5e01080d$exports).PersistentCacheKeys.ACTIVE_ACCOUNT_FILTERS);
        const activeAccountValueFilters = this.browserStorage.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            this.logger.trace("08gw0e", correlationId);
            return null;
        }
        const activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("1t3ch7", correlationId);
            return this.getAccountInfoFilteredBy({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId,
                tenantId: activeAccountValueObj.tenantId
            }, correlationId);
        }
        this.logger.trace("0me1up", correlationId);
        return null;
    }
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ setActiveAccount(account, correlationId) {
        const activeAccountKey = this.generateCacheKey((0, $8994aeee5e01080d$exports).PersistentCacheKeys.ACTIVE_ACCOUNT_FILTERS);
        if (account) {
            this.logger.verbose("0rsj80", correlationId);
            const activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId,
                tenantId: account.tenantId
            };
            this.setItem(activeAccountKey, JSON.stringify(activeAccountValue), correlationId);
        } else {
            this.logger.verbose("1bp5z5", correlationId);
            this.browserStorage.removeItem(activeAccountKey);
        }
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED, correlationId);
    }
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     * @param correlationId
     */ getThrottlingCache(throttlingCacheKey, correlationId) {
        const value = this.browserStorage.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("1h4wa6", correlationId);
            return null;
        }
        const parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !(0, $4cd4d8a6d71d39a8$exports).isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("1h4wa6", correlationId);
            return null;
        }
        this.logger.trace("0of6n8", correlationId);
        return parsedThrottlingCache;
    }
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ setThrottlingCache(throttlingCacheKey, throttlingCache, correlationId) {
        this.logger.trace("0wfgh6", correlationId);
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache), correlationId);
    }
    /**
     * Gets cache item with given key.
     * @param cacheKey
     * @param correlationId
     * @param generateKey
     */ getTemporaryCache(cacheKey, correlationId, generateKey) {
        this.logger.trace("1ordf8", correlationId);
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        return this.temporaryCacheStorage.getItem(key);
    }
    /**
     * Sets the cache item with the key and value given.
     * @param key
     * @param value
     */ setTemporaryCache(cacheKey, value, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
    }
    /**
     * Removes the cache item with the given key.
     * @param key
     */ removeItem(key) {
        this.browserStorage.removeItem(key);
    }
    /**
     * Removes the temporary cache item with the given key.
     * @param key
     */ removeTemporaryItem(key) {
        this.temporaryCacheStorage.removeItem(key);
    }
    /**
     * Gets all keys in window.
     */ getKeys() {
        return this.browserStorage.getKeys();
    }
    /**
     * Clears all cache entries created by MSAL.
     */ clear(correlationId) {
        // Removes all accounts and their credentials
        this.removeAllAccounts(correlationId);
        this.removeAppMetadata(correlationId);
        // Remove temp storage first to make sure any cookies are cleared
        this.temporaryCacheStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $6669d8f0f59e64dc$export$8a682ae47622dbb9)) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.removeTemporaryItem(cacheKey);
        });
        // Removes all remaining MSAL cache items
        this.browserStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $6669d8f0f59e64dc$export$8a682ae47622dbb9)) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.browserStorage.removeItem(cacheKey);
        });
        this.internalStorage.clear();
    }
    /**
     * Prepend msal.<client-id> to each key
     * @param key
     * @param addInstanceId
     */ generateCacheKey(key) {
        if ((0, $4204b6e4994e8227$export$ecc754f99843e759).startsWith(key, (0, $6669d8f0f59e64dc$export$8a682ae47622dbb9))) return key;
        return `${0, $6669d8f0f59e64dc$export$8a682ae47622dbb9}.${this.clientId}.${key}`;
    }
    /**
     * Generate Credential Key. All changes to the key REQUIRE a schema version update.
     * Cache Key: msal.<schema_version>|<home_account_id>|<environment>|<credential_type>|<client_id or familyId>|<realm>|<scopes>|<scheme>
     * @param credentialEntity
     * @returns
     */ generateCredentialKey(credential) {
        const familyId = credential.credentialType === (0, $8994aeee5e01080d$exports).CredentialType.REFRESH_TOKEN && credential.familyId || credential.clientId;
        const scheme = credential.tokenType && credential.tokenType.toLowerCase() !== (0, $8994aeee5e01080d$exports).AuthenticationScheme.BEARER.toLowerCase() ? credential.tokenType.toLowerCase() : "";
        const credentialKey = [
            `${(0, $6669d8f0f59e64dc$export$8a682ae47622dbb9)}.${(0, $6669d8f0f59e64dc$export$ec2ec5cd3d01f05d)}`,
            credential.homeAccountId,
            credential.environment,
            credential.credentialType,
            familyId,
            credential.realm || "",
            credential.target || "",
            scheme
        ];
        return credentialKey.join((0, $6669d8f0f59e64dc$export$9e9532f57bbb139e)).toLowerCase();
    }
    /**
     * Cache Key: msal.<schema_version>.<home_account_id>.<environment>.<tenant_id>
     * @param account
     * @returns
     */ generateAccountKey(account) {
        const homeTenantId = account.homeAccountId.split(".")[1];
        const accountKey = [
            `${(0, $6669d8f0f59e64dc$export$8a682ae47622dbb9)}.${(0, $6669d8f0f59e64dc$export$4693794d1f911b27)}`,
            account.homeAccountId,
            account.environment,
            homeTenantId || account.tenantId || ""
        ];
        return accountKey.join((0, $6669d8f0f59e64dc$export$9e9532f57bbb139e)).toLowerCase();
    }
    /**
     * Reset all temporary cache items
     * @param correlationId
     */ resetRequestCache(correlationId) {
        this.logger.trace("0h0ynu", correlationId);
        this.removeTemporaryItem(this.generateCacheKey((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).REQUEST_PARAMS));
        this.removeTemporaryItem(this.generateCacheKey((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).VERIFIER));
        this.removeTemporaryItem(this.generateCacheKey((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).ORIGIN_URI));
        this.removeTemporaryItem(this.generateCacheKey((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).URL_HASH));
        this.removeTemporaryItem(this.generateCacheKey((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).NATIVE_REQUEST));
        this.setInteractionInProgress(false, undefined);
    }
    cacheAuthorizeRequest(authCodeRequest, correlationId, codeVerifier) {
        this.logger.trace("1tzef5", correlationId);
        const encodedValue = (0, $0349b3935d5ceef2$export$e510a73ee562749)(JSON.stringify(authCodeRequest));
        this.setTemporaryCache((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).REQUEST_PARAMS, encodedValue, true);
        if (codeVerifier) {
            const encodedVerifier = (0, $0349b3935d5ceef2$export$e510a73ee562749)(codeVerifier);
            this.setTemporaryCache((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).VERIFIER, encodedVerifier, true);
        }
    }
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     * @param correlationId
     */ getCachedRequest(correlationId) {
        this.logger.trace("0uen20", correlationId);
        // Get token request from cache and parse as TokenExchangeParameters.
        const encodedTokenRequest = this.getTemporaryCache((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).REQUEST_PARAMS, correlationId, true);
        if (!encodedTokenRequest) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$8b51939fb2aab3d7), "");
        const encodedVerifier = this.getTemporaryCache((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).VERIFIER, correlationId, true);
        let parsedRequest;
        let verifier = "";
        try {
            parsedRequest = JSON.parse((0, $5949979cf1605326$export$c62426fdd000a97e)(encodedTokenRequest));
            if (encodedVerifier) verifier = (0, $5949979cf1605326$export$c62426fdd000a97e)(encodedVerifier);
        } catch (e) {
            this.logger.errorPii(`0ewsey ${encodedTokenRequest}`, correlationId);
            this.logger.error(`0tvdic ${e}`, correlationId);
            throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$f3ae24cdfaab4488), "");
        }
        return [
            parsedRequest,
            verifier
        ];
    }
    /**
     * Gets cached native request for redirect flows
     * @param correlationId
     */ getCachedNativeRequest() {
        this.logger.trace("1yxcdm", "");
        const cachedRequest = this.getTemporaryCache((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).NATIVE_REQUEST, "", true);
        if (!cachedRequest) {
            this.logger.trace("0mnxd4", "");
            return null;
        }
        const parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("0rrkip", "");
            return null;
        }
        return parsedRequest;
    }
    isInteractionInProgress(matchClientId) {
        const clientId = this.getInteractionInProgress()?.clientId;
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    }
    getInteractionInProgress() {
        const key = `${(0, $6669d8f0f59e64dc$export$8a682ae47622dbb9)}.${(0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        const value = this.getTemporaryCache(key, "", false);
        try {
            return value ? JSON.parse(value) : null;
        } catch (e) {
            // Remove interaction and other temp keys if interaction status can't be parsed
            this.logger.error("0jjyys", "");
            this.removeTemporaryItem(key);
            this.resetRequestCache("");
            (0, $8e677587a7c978db$export$a20c3032ba81d6aa)(window);
            return null;
        }
    }
    setInteractionInProgress(inProgress, type = (0, $7101cc4ee26a17a4$export$dc1d3aa5f3837765).SIGNIN, allowOverride = false, correlationId = "") {
        // Ensure we don't overwrite interaction in progress for a different clientId
        const key = `${(0, $6669d8f0f59e64dc$export$8a682ae47622dbb9)}.${(0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        if (inProgress) {
            const existingInteraction = this.getInteractionInProgress();
            if (existingInteraction) {
                if (allowOverride) {
                    this.logger.warning(`1pmscr ${existingInteraction.clientId} ${existingInteraction.type}`, correlationId);
                    // Cancel any active bridge monitor from the previous interaction
                    (0, $8e677587a7c978db$export$faedfb2c37a42b1d)(this.logger, correlationId);
                    // Clear existing interaction to allow new one
                    this.removeTemporaryItem(key);
                } else throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$2700dc1c133d227e), "");
            }
            // Set new interaction
            this.setTemporaryCache(key, JSON.stringify({
                clientId: this.clientId,
                type: type
            }), false);
        } else if (!inProgress && this.getInteractionInProgress()?.clientId === this.clientId) this.removeTemporaryItem(key);
    }
    /**
     * Builds credential entities from AuthenticationResult object and saves the resulting credentials to the cache
     * @param result
     * @param request
     */ async hydrateCache(result, request) {
        const idTokenEntity = (0, $4cd4d8a6d71d39a8$exports).createIdTokenEntity(result.account.homeAccountId, result.account.environment, result.idToken, this.clientId, result.tenantId);
        /**
         * meta data for cache stores time in seconds from epoch
         * AuthenticationResult returns expiresOn and extExpiresOn in milliseconds (as a Date object which is in ms)
         * We need to map these for the cache when building tokens from AuthenticationResult
         *
         * The next MSAL VFuture should map these both to same value if possible
         */ const accessTokenEntity = (0, $4cd4d8a6d71d39a8$exports).createAccessTokenEntity(result.account.homeAccountId, result.account.environment, result.accessToken, this.clientId, result.tenantId, result.scopes.join(" "), // Access token expiresOn stored in seconds, converting from AuthenticationResult expiresOn stored as Date
        result.expiresOn ? (0, $e0616e53cd3f026f$exports).toSecondsFromDate(result.expiresOn) : 0, result.extExpiresOn ? (0, $e0616e53cd3f026f$exports).toSecondsFromDate(result.extExpiresOn) : 0, (0, $5949979cf1605326$export$c62426fdd000a97e), request.correlationId || "", undefined, result.tokenType, undefined, request.sshKid);
        if (request.resource) accessTokenEntity.resource = request.resource;
        const cacheRecord = {
            idToken: idTokenEntity,
            accessToken: accessTokenEntity
        };
        return this.saveCacheRecord(cacheRecord, result.correlationId, (0, $4acd0486289e3b4f$exports).isKmsi((0, $4acd0486289e3b4f$exports).extractTokenClaims(result.idToken, (0, $5949979cf1605326$export$c62426fdd000a97e), result.correlationId)), (0, $7101cc4ee26a17a4$export$192d74ad69b40705).hydrateCache);
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache) {
        try {
            await super.saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache);
        } catch (e) {
            if (e instanceof (0, $7cf95cc28691dd17$export$78ff06e91c3de382) && this.performanceClient && correlationId) try {
                const tokenKeys = this.getTokenKeys();
                this.performanceClient.addFields({
                    cacheRtCount: tokenKeys.refreshToken.length,
                    cacheIdCount: tokenKeys.idToken.length,
                    cacheAtCount: tokenKeys.accessToken.length
                }, correlationId);
            } catch (e) {}
            throw e;
        }
    }
}
/**
 * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
 * @param cacheLocation
 */ function $e624d8f74faf8e75$var$getStorageImplementation(clientId, cacheLocation, logger, performanceClient) {
    try {
        switch(cacheLocation){
            case (0, $7101cc4ee26a17a4$export$573384e47a12d835).LocalStorage:
                return new (0, $d4a22c590a0a36fb$export$19fffca37ef3e106)(clientId, logger, performanceClient);
            case (0, $7101cc4ee26a17a4$export$573384e47a12d835).SessionStorage:
                return new (0, $980292a08ffc7409$export$2c4b17e1c2e0931)();
            case (0, $7101cc4ee26a17a4$export$573384e47a12d835).MemoryStorage:
            default:
                break;
        }
    } catch (e) {
        logger.error(e, "");
    }
    return new (0, $14f17b15811f4641$export$d7392285c701ecf5)();
}
const $e624d8f74faf8e75$export$8e2d54002f8f6e5d = (clientId, logger, performanceClient, eventHandler)=>{
    const cacheOptions = {
        cacheLocation: (0, $7101cc4ee26a17a4$export$573384e47a12d835).MemoryStorage,
        cacheRetentionDays: 5
    };
    return new $e624d8f74faf8e75$export$44d7291b5c8cc149(clientId, cacheOptions, (0, $842f61e187fdf563$export$865f57d401606752), logger, performanceClient, eventHandler);
};



/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
 * @param accountFilter - (Optional) filter to narrow down the accounts returned
 * @returns Array of AccountInfo objects in cache
 */ function $9e3c3c60dcb65490$export$a4fc43c2a99143cd(logger, browserStorage, isInBrowser, correlationId, accountFilter) {
    logger.verbose("1yd030", correlationId);
    return isInBrowser ? browserStorage.getAllAccounts(accountFilter, correlationId) : [];
}
/**
 * Returns the first account found in the cache that matches the account filter passed in.
 * @param accountFilter
 * @returns The first account found in the cache matching the provided filter or null if no account could be found.
 */ function $9e3c3c60dcb65490$export$4f9234baf34abd0(accountFilter, logger, browserStorage, correlationId) {
    logger.trace("0u7b90", correlationId);
    const account = browserStorage.getAccountInfoFilteredBy(accountFilter, correlationId);
    if (account) {
        logger.verbose("0btgll", correlationId);
        return account;
    } else {
        logger.verbose("0ltaj5", correlationId);
        return null;
    }
}
/**
 * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
 * @param account
 */ function $9e3c3c60dcb65490$export$c55c3d25cf1bcd99(account, browserStorage, correlationId) {
    browserStorage.setActiveAccount(account, correlationId);
}
/**
 * Gets the currently active account
 */ function $9e3c3c60dcb65490$export$13dd2e33a23839ad(browserStorage, correlationId) {
    return browserStorage.getActiveAccount(correlationId);
}





/*! @azure/msal-browser v5.16.0 2026-06-30 */ /*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var $0fd93c953107c2f4$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})($0fd93c953107c2f4$export$243e62d78d3b544d || ($0fd93c953107c2f4$export$243e62d78d3b544d = {}));
// Shared cache state for better minification - using Map's insertion order for LRU
const $0fd93c953107c2f4$var$CACHE_CAPACITY = 50;
const $0fd93c953107c2f4$var$MAX_LOGS_PER_CORRELATION = 500;
const $0fd93c953107c2f4$var$correlationCache = new Map();
/**
 * Mark correlation ID as recently used by moving it to end of Map
 * @param correlationId
 * @param {CorrelationLogData} data
 */ function $0fd93c953107c2f4$var$markAsRecentlyUsed(correlationId, data) {
    $0fd93c953107c2f4$var$correlationCache.delete(correlationId);
    $0fd93c953107c2f4$var$correlationCache.set(correlationId, data);
}
/**
 * Add log message to cache for specific correlation ID
 * @param correlationId
 * @param {LoggedMessage} loggedMessage
 */ function $0fd93c953107c2f4$var$addLogToCache(correlationId, loggedMessage) {
    const currentTime = Date.now();
    let data = $0fd93c953107c2f4$var$correlationCache.get(correlationId);
    if (data) // Mark as recently used
    $0fd93c953107c2f4$var$markAsRecentlyUsed(correlationId, data);
    else {
        // Create new entry
        data = {
            logs: [],
            firstEventTime: currentTime
        };
        $0fd93c953107c2f4$var$correlationCache.set(correlationId, data);
        // Remove LRU (first entry) if capacity exceeded
        if ($0fd93c953107c2f4$var$correlationCache.size > $0fd93c953107c2f4$var$CACHE_CAPACITY) {
            const firstKey = $0fd93c953107c2f4$var$correlationCache.keys().next().value;
            if (firstKey !== undefined) $0fd93c953107c2f4$var$correlationCache.delete(firstKey);
        }
    }
    // Add log to the data, maintaining max logs per correlation
    data.logs.push({
        ...loggedMessage,
        milliseconds: currentTime - data.firstEventTime
    });
    if (data.logs.length > $0fd93c953107c2f4$var$MAX_LOGS_PER_CORRELATION) data.logs.shift(); // Remove oldest log
}
/**
 * Get logs for correlation ID and flush them from cache
 * Attaches logs with empty correlation id to the requested correlation logs
 * @param correlationId
 */ function $0fd93c953107c2f4$export$8572009c2a983f45(correlationId) {
    const res = [];
    for (const id of [
        "",
        correlationId
    ]){
        const data = $0fd93c953107c2f4$var$correlationCache.get(id);
        res.push(...data?.logs ?? []);
        $0fd93c953107c2f4$var$correlationCache.delete(id); // Remove the correlation ID completely from cache
    }
    return res;
}
/**
 * Extracts the leading minification hash from a log message, if present.
 *
 * Minified messages are produced by the logger-minify rollup plugin and are
 * either a bare 6-character alphanumeric hash, or that hash followed by a space
 * and runtime variables appended for local (console) logging, e.g.
 * "abc123 user-1 popup". Only the leading hash is returned so that telemetry
 * never captures the appended variables. Returns null when the message is not
 * a minified message.
 */ function $0fd93c953107c2f4$var$getMessageHash(str) {
    if (str.length < 6) return null;
    /*
     * If the message is longer than the hash, the hash must be delimited by a
     * space (the separator the plugin inserts before appended variables).
     */ if (str.length > 6 && str[6] !== " ") return null;
    for(let i = 0; i < 6; i++){
        const char = str[i];
        const isAlphaNumeric = char >= "a" && char <= "z" || char >= "A" && char <= "Z" || char >= "0" && char <= "9";
        if (!isAlphaNumeric) return null;
    }
    return str.substring(0, 6);
}
/**
 * Class which facilitates logging of messages to a specific place.
 */ class $0fd93c953107c2f4$export$efa9a398d6368992 {
    constructor(loggerOptions, packageName, packageVersion){
        // Current log level, defaults to info.
        this.level = $0fd93c953107c2f4$export$243e62d78d3b544d.Info;
        const defaultLoggerCallback = ()=>{
            return;
        };
        const setLoggerOptions = loggerOptions || $0fd93c953107c2f4$export$efa9a398d6368992.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : $0fd93c953107c2f4$export$243e62d78d3b544d.Info;
        this.packageName = packageName || "";
        this.packageVersion = packageVersion || "";
    }
    static createDefaultLoggerOptions() {
        return {
            loggerCallback: ()=>{
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: $0fd93c953107c2f4$export$243e62d78d3b544d.Info
        };
    }
    /**
     * Create new Logger with existing configurations.
     */ clone(packageName, packageVersion) {
        return new $0fd93c953107c2f4$export$efa9a398d6368992({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level
        }, packageName, packageVersion);
    }
    /**
     * Log message with required options.
     */ logMessage(logMessage, options) {
        const correlationId = options.correlationId;
        const messageHash = $0fd93c953107c2f4$var$getMessageHash(logMessage);
        if (messageHash) {
            const loggedMessage = {
                hash: messageHash,
                level: options.logLevel,
                containsPii: options.containsPii || false,
                milliseconds: 0
            };
            $0fd93c953107c2f4$var$addLogToCache(correlationId, loggedMessage);
        }
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        const timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        const logHeader = `[${timestamp}] : [${correlationId}]`;
        const log = `${logHeader} : ${this.packageName}@${this.packageVersion} : ${$0fd93c953107c2f4$export$243e62d78d3b544d[options.logLevel]} - ${logMessage}`;
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    }
    /**
     * Execute callback with message.
     */ executeCallback(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    }
    /**
     * Logs error messages.
     */ error(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0fd93c953107c2f4$export$243e62d78d3b544d.Error,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs error messages with PII.
     */ errorPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0fd93c953107c2f4$export$243e62d78d3b544d.Error,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs warning messages.
     */ warning(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0fd93c953107c2f4$export$243e62d78d3b544d.Warning,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs warning messages with PII.
     */ warningPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0fd93c953107c2f4$export$243e62d78d3b544d.Warning,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs info messages.
     */ info(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0fd93c953107c2f4$export$243e62d78d3b544d.Info,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs info messages with PII.
     */ infoPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0fd93c953107c2f4$export$243e62d78d3b544d.Info,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs verbose messages.
     */ verbose(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0fd93c953107c2f4$export$243e62d78d3b544d.Verbose,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs verbose messages with PII.
     */ verbosePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0fd93c953107c2f4$export$243e62d78d3b544d.Verbose,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs trace messages.
     */ trace(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0fd93c953107c2f4$export$243e62d78d3b544d.Trace,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs trace messages with PII.
     */ tracePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0fd93c953107c2f4$export$243e62d78d3b544d.Trace,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Returns whether PII Logging is enabled or not.
     */ isPiiLoggingEnabled() {
        return this.piiLoggingEnabled || false;
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $0a29dd70327044d0$var$BROADCAST_CHANNEL_NAME = "msal.broadcast.event";
class $0a29dd70327044d0$export$ce0ba2422a1c7815 {
    constructor(logger){
        this.eventCallbacks = new Map();
        this.logger = logger || new (0, $0fd93c953107c2f4$export$efa9a398d6368992)({}, (0, $c8226bf52dd9a4ef$export$a8ff84c12d48cfa6), (0, $c8226bf52dd9a4ef$export$83d89fbfd8236492));
        if (typeof BroadcastChannel !== "undefined") this.broadcastChannel = new BroadcastChannel($0a29dd70327044d0$var$BROADCAST_CHANNEL_NAME);
        this.invokeCrossTabCallbacks = this.invokeCrossTabCallbacks.bind(this);
    }
    /**
     * Adds event callbacks to array
     * @param callback - callback to be invoked when an event is raised
     * @param eventTypes - list of events that this callback will be invoked for, if not provided callback will be invoked for all events
     * @param callbackId - Identifier for the callback, used to locate and remove the callback when no longer required
     */ addEventCallback(callback, eventTypes, callbackId) {
        if (typeof window !== "undefined") {
            const id = callbackId || (0, $8e677587a7c978db$export$7571c350ed9fec74)();
            if (this.eventCallbacks.has(id)) {
                this.logger.error(`1578i0 ${id}`, "");
                return null;
            }
            this.eventCallbacks.set(id, [
                callback,
                eventTypes || []
            ]);
            this.logger.verbose(`1cnec4 ${id}`, "");
            return id;
        }
        return null;
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose(`12zotd ${callbackId}`, "");
    }
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ emitEvent(eventType, correlationId, interactionType, payload, error) {
        const message = {
            eventType: eventType,
            interactionType: interactionType || null,
            payload: payload || null,
            error: error || null,
            correlationId: correlationId,
            timestamp: Date.now()
        };
        switch(eventType){
            case (0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGIN_SUCCESS:
            case (0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_SUCCESS:
            case (0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED:
                // Send event to other open tabs / MSAL instances on same domain
                this.broadcastChannel?.postMessage(message);
        }
        // Emit event to callbacks registered in this instance
        this.invokeCallbacks(message);
    }
    /**
     * Invoke registered callbacks
     * @param message
     */ invokeCallbacks(message) {
        this.eventCallbacks.forEach(([callback, eventTypes], callbackId)=>{
            if (eventTypes.length === 0 || eventTypes.includes(message.eventType)) {
                this.logger.verbose(`15jpwk ${callbackId} ${message.eventType}`, "");
                callback.apply(null, [
                    message
                ]);
            }
        });
    }
    /**
     * Wrapper around invokeCallbacks to handle broadcast events received from other tabs/instances
     * @param event
     */ invokeCrossTabCallbacks(event) {
        const message = event.data;
        this.invokeCallbacks(message);
    }
    /**
     * Listen for events broadcasted from other tabs/instances
     */ subscribeCrossTab() {
        this.broadcastChannel?.addEventListener("message", this.invokeCrossTabCallbacks);
    }
    /**
     * Unsubscribe from broadcast events
     */ unsubscribeCrossTab() {
        this.broadcastChannel?.removeEventListener("message", this.invokeCrossTabCallbacks);
    }
}



/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
/*! @azure/msal-browser v5.16.0 2026-06-30 */ /*! @azure/msal-common v16.11.0 2026-06-30 */ 



/*! @azure/msal-common v16.11.0 2026-06-30 */ 







/*! @azure/msal-common v16.11.0 2026-06-30 */ /*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ const $1ee010de329a60a2$export$bc3547c8ae7b1db = {
    NotStarted: 0,
    InProgress: 1,
    Completed: 2
};
/**
 * Prefix used to mark telemetry field names as dynamic.
 * Fields with this prefix in addFields/incrementFields calls will be routed
 * to the PerformanceEvent.ext sub-object.
 */ const $1ee010de329a60a2$export$79df1103383f4c32 = "ext.";
const $1ee010de329a60a2$export$f16d39729f4b7302 = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "startTimeMs",
    "status",
    "multiMatchedAT",
    "multiMatchedID",
    "multiMatchedRT",
    "unencryptedCacheCount",
    "encryptedCacheExpiredCount",
    "oldAccountCount",
    "oldAccessCount",
    "oldIdCount",
    "oldRefreshCount",
    "currAccountCount",
    "currAccessCount",
    "currIdCount",
    "currRefreshCount",
    "ttlExpiredAcntCount",
    "ttlExpiredITCount",
    "ttlExpiredATCount",
    "ttlExpiredRTCount",
    "decryptFailedAcntCount",
    "decryptFailedITCount",
    "decryptFailedATCount",
    "decryptFailedRTCount",
    "invalidAcntCount",
    "invalidITCount",
    "invalidATCount",
    "invalidRTCount",
    "expiredATCount",
    "expiredRTCount",
    "upgradedCacheCount",
    "cacheMatchedAccounts",
    "networkRtt",
    "redirectBridgeTimeoutMs",
    "redirectBridgeMessageVersion"
]);


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $d7391fb9e8152ad3$export$c70f2989a65fda3e {
    generateId() {
        return "callback-id";
    }
    startMeasurement(measureName, correlationId) {
        return {
            end: ()=>null,
            discard: ()=>{},
            add: ()=>{},
            increment: ()=>{},
            event: {
                eventId: this.generateId(),
                status: (0, $1ee010de329a60a2$export$bc3547c8ae7b1db).InProgress,
                authority: "",
                libraryName: "",
                libraryVersion: "",
                clientId: "",
                name: measureName,
                startTimeMs: Date.now(),
                correlationId: correlationId || ""
            }
        };
    }
    endMeasurement() {
        return null;
    }
    discardMeasurements() {
        return;
    }
    removePerformanceCallback() {
        return true;
    }
    addPerformanceCallback() {
        return "";
    }
    emitEvents() {
        return;
    }
    addFields() {
        return;
    }
    addGlobalFields() {
        return;
    }
    incrementFields() {
        return;
    }
    cacheEventByCorrelationId() {
        return;
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $8e787aed99ab54c6$export$f7a7dd6bfc156d75 = {
    tokenRenewalOffsetSeconds: (0, $8994aeee5e01080d$export$8d50f42618161d1a),
    preventCorsPreflight: false
};
const $8e787aed99ab54c6$var$DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: ()=>{
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Info,
    correlationId: ""
};
const $8e787aed99ab54c6$var$DEFAULT_NETWORK_IMPLEMENTATION = {
    async sendGetRequestAsync () {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    },
    async sendPostRequestAsync () {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), "");
    }
};
const $8e787aed99ab54c6$var$DEFAULT_LIBRARY_INFO = {
    sku: (0, $8994aeee5e01080d$export$45c909820884b9ec),
    version: (0, $8da2d5e621fbe87e$export$83d89fbfd8236492),
    cpu: "",
    os: ""
};
const $8e787aed99ab54c6$var$DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: "",
    clientAssertion: undefined
};
const $8e787aed99ab54c6$var$DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: (0, $1fba6bdc8b3011e3$export$4cda21933050d9ec).None,
    tenant: `${(0, $8994aeee5e01080d$export$cf84b28865aad146)}`
};
const $8e787aed99ab54c6$var$DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 * @internal
 */ function $8e787aed99ab54c6$export$57a091701dcdabb2({ authOptions: userAuthOptions, systemOptions: userSystemOptions, loggerOptions: userLoggerOption, storageInterface: storageImplementation, networkInterface: networkImplementation, cryptoInterface: cryptoImplementation, clientCredentials: clientCredentials, libraryInfo: libraryInfo, telemetry: telemetry, serverTelemetryManager: serverTelemetryManager, persistencePlugin: persistencePlugin, serializableCache: serializableCache }) {
    const loggerOptions = {
        ...$8e787aed99ab54c6$var$DEFAULT_LOGGER_IMPLEMENTATION,
        ...userLoggerOption
    };
    return {
        authOptions: $8e787aed99ab54c6$var$buildAuthOptions(userAuthOptions),
        systemOptions: {
            ...$8e787aed99ab54c6$export$f7a7dd6bfc156d75,
            ...userSystemOptions
        },
        loggerOptions: loggerOptions,
        storageInterface: storageImplementation || new (0, $a087c4e9d9c3e8cc$export$b7254d304b3004b6)(userAuthOptions.clientId, (0, $842f61e187fdf563$export$865f57d401606752), new (0, $0fd93c953107c2f4$export$efa9a398d6368992)(loggerOptions, (0, $8da2d5e621fbe87e$export$a8ff84c12d48cfa6), (0, $8da2d5e621fbe87e$export$83d89fbfd8236492)), new (0, $d7391fb9e8152ad3$export$c70f2989a65fda3e)()),
        networkInterface: networkImplementation || $8e787aed99ab54c6$var$DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || (0, $842f61e187fdf563$export$865f57d401606752),
        clientCredentials: clientCredentials || $8e787aed99ab54c6$var$DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: {
            ...$8e787aed99ab54c6$var$DEFAULT_LIBRARY_INFO,
            ...libraryInfo
        },
        telemetry: {
            ...$8e787aed99ab54c6$var$DEFAULT_TELEMETRY_OPTIONS,
            ...telemetry
        },
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function $8e787aed99ab54c6$var$buildAuthOptions(authOptions) {
    return {
        clientCapabilities: [],
        azureCloudOptions: $8e787aed99ab54c6$var$DEFAULT_AZURE_CLOUD_OPTIONS,
        instanceAware: false,
        isMcp: false,
        ...authOptions
    };
}
/**
 * Returns true if config has protocolMode set to ProtocolMode.OIDC, false otherwise
 * @param ClientConfiguration
 */ function $8e787aed99ab54c6$export$25afa7198c2ed9b9(config) {
    return config.authOptions.authority.options.protocolMode === (0, $631489f43a9fbed6$export$73a3e3dedd37150d).OIDC;
}


/*! @azure/msal-common v16.11.0 2026-06-30 */ 


/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ class $3284c8b847fbb4bc$export$500ab620f6bcc747 {
    constructor(tokenCache, hasChanged){
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    /**
     * boolean which indicates the changes in cache
     */ get cacheHasChanged() {
        return this.hasChanged;
    }
    /**
     * function to retrieve the token cache
     */ get tokenCache() {
        return this.cache;
    }
}




/*! @azure/msal-common v16.11.0 2026-06-30 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $7d2464f001dd27e8$var$KeyLocation = {
    SW: "sw"
};
/** @internal */ class $7d2464f001dd27e8$export$3dd8467151c83e3e {
    constructor(cryptoUtils, performanceClient){
        this.cryptoUtils = cryptoUtils;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ async generateCnf(request, logger) {
        const reqCnf = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.generateKid.bind(this), (0, $0d9eb83114fc9425$export$42d4b7447f09a8ea), logger, this.performanceClient, request.correlationId)(request);
        const reqCnfString = this.cryptoUtils.base64UrlEncode(JSON.stringify(reqCnf));
        return {
            kid: reqCnf.kid,
            reqCnfString: reqCnfString
        };
    }
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ async generateKid(request) {
        const kidThumbprint = await this.cryptoUtils.getPublicKeyThumbprint(request);
        return {
            kid: kidThumbprint,
            xms_ksl: $7d2464f001dd27e8$var$KeyLocation.SW
        };
    }
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ async signPopToken(accessToken, keyId, request) {
        return this.signPayload(accessToken, keyId, request);
    }
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ async signPayload(payload, keyId, request, claims) {
        // Deconstruct request to extract SHR parameters
        const { resourceRequestMethod: resourceRequestMethod, resourceRequestUri: resourceRequestUri, shrClaims: shrClaims, shrNonce: shrNonce, shrOptions: shrOptions } = request;
        const resourceUrlString = resourceRequestUri ? new (0, $9c756a14a1bed5db$export$3abcdca7229e54f2)(resourceRequestUri, request.correlationId) : undefined;
        const resourceUrlComponents = resourceUrlString?.getUrlComponents();
        return this.cryptoUtils.signJwt({
            at: payload,
            ts: (0, $e0616e53cd3f026f$export$ae62599a119ac50a)(),
            m: resourceRequestMethod?.toUpperCase(),
            u: resourceUrlComponents?.HostNameAndPort,
            nonce: shrNonce || this.cryptoUtils.createNewGuid(),
            p: resourceUrlComponents?.AbsolutePath,
            q: resourceUrlComponents?.QueryString ? [
                [],
                resourceUrlComponents.QueryString
            ] : undefined,
            client_claims: shrClaims || undefined,
            ...claims
        }, keyId, shrOptions, request.correlationId);
    }
}




/*! @azure/msal-common v16.11.0 2026-06-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ class $cf4c26be8c97417f$export$ea52035eac03daf0 extends (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) {
    constructor(errorCode, correlationId, errorMessage, subError, errorNo, status){
        super(errorCode, correlationId, errorMessage, subError);
        this.name = "ServerError";
        this.errorNo = errorNo;
        this.status = status;
        Object.setPrototypeOf(this, $cf4c26be8c97417f$export$ea52035eac03daf0.prototype);
    }
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class that handles response parsing.
 * @internal
 */ class $ef22af12cad4e1b3$export$f456c9835cc63582 {
    constructor(clientId, cacheStorage, cryptoObj, logger, performanceClient, serializableCache, persistencePlugin){
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
    }
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     * @param correlationId
     * @param refreshAccessToken
     */ validateTokenResponse(serverResponse, correlationId, refreshAccessToken) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const errString = `Error(s): ${serverResponse.error_codes || (0, $8994aeee5e01080d$export$d5f291b4be36f605)} - Timestamp: ${serverResponse.timestamp || (0, $8994aeee5e01080d$export$d5f291b4be36f605)} - Description: ${serverResponse.error_description || (0, $8994aeee5e01080d$export$d5f291b4be36f605)} - Correlation ID: ${serverResponse.correlation_id || (0, $8994aeee5e01080d$export$d5f291b4be36f605)} - Trace ID: ${serverResponse.trace_id || (0, $8994aeee5e01080d$export$d5f291b4be36f605)}`;
            const serverErrorNo = serverResponse.error_codes?.length ? serverResponse.error_codes[0] : undefined;
            const serverError = new (0, $cf4c26be8c97417f$export$ea52035eac03daf0)(serverResponse.error || "", serverResponse.correlation_id || "", errString, serverResponse.suberror, serverErrorNo, serverResponse.status);
            // check if 500 error
            if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $8994aeee5e01080d$export$310d0488bddd36e1) && serverResponse.status <= (0, $8994aeee5e01080d$export$cabebb7af2e4f2f0)) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently unavailable and the access token is unable to be refreshed.\n${serverError}`, correlationId);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            // check if 400 error
            } else if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $8994aeee5e01080d$export$6f402514545f3f58) && serverResponse.status <= (0, $8994aeee5e01080d$export$80be1ba03533fcfc)) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently available but is unable to refresh the access token.\n${serverError}`, correlationId);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            }
            if ((0, $e9bbb17645bd3149$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $e9bbb17645bd3149$export$6ba3e818c6bc76ba)(serverResponse.error || "", serverResponse.correlation_id || "", serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.claims || "", serverErrorNo);
            throw serverError;
        }
    }
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ async handleServerTokenResponse(serverTokenResponse, authority, reqTimestamp, request, apiId, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId, additionalCacheKeyComponents) {
        // create an idToken object (not entity)
        let idTokenClaims;
        if (serverTokenResponse.id_token) {
            idTokenClaims = (0, $4acd0486289e3b4f$export$8a59e6f35fb00518)(serverTokenResponse.id_token || "", this.cryptoObj.base64Decode, request.correlationId);
            // token nonce check (TODO: Add a warning if no nonce is given?)
            if (authCodePayload && authCodePayload.nonce) {
                if (idTokenClaims.nonce !== authCodePayload.nonce) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$edd0491c2c280be7), request.correlationId);
            }
        }
        // generate homeAccountId
        this.homeAccountIdentifier = (0, $f136bee61a3373e4$export$655e905bf6b8ee85)(serverTokenResponse.client_info || "", authority.authorityType, this.logger, this.cryptoObj, request.correlationId, idTokenClaims);
        // save the response tokens
        let requestStateObj;
        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = (0, $de6be0b6a0939617$export$803567147421ddac)(this.cryptoObj.base64Decode, authCodePayload.state, request.correlationId);
        // Add keyId from request to serverTokenResponse if defined
        serverTokenResponse.key_id = serverTokenResponse.key_id || request.sshKid || undefined;
        const cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload, additionalCacheKeyComponents);
        let cacheContext;
        try {
            if (this.persistencePlugin && this.serializableCache) {
                this.logger.verbose("Persistence enabled, calling beforeCacheAccess", request.correlationId);
                cacheContext = new (0, $3284c8b847fbb4bc$export$500ab620f6bcc747)(this.serializableCache, true);
                await this.persistencePlugin.beforeCacheAccess(cacheContext);
            }
            /*
             * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
             * If not present, we should return null, as it's the case that another application called removeAccount in between
             * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
             * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
             */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                const cachedAccounts = this.cacheStorage.getAllAccounts({
                    homeAccountId: cacheRecord.account.homeAccountId,
                    environment: cacheRecord.account.environment
                }, request.correlationId);
                if (cachedAccounts.length < 1) {
                    this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache", request.correlationId);
                    this.performanceClient?.addFields({
                        acntLoggedOut: true
                    }, request.correlationId);
                    return await $ef22af12cad4e1b3$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, this.performanceClient, idTokenClaims, requestStateObj, undefined, serverRequestId);
                }
            }
            await this.cacheStorage.saveCacheRecord(cacheRecord, request.correlationId, (0, $4acd0486289e3b4f$export$9475d607926d7a45)(idTokenClaims || {}), apiId, request.storeInCache);
        } finally{
            if (this.persistencePlugin && this.serializableCache && cacheContext) {
                this.logger.verbose("Persistence enabled, calling afterCacheAccess", request.correlationId);
                await this.persistencePlugin.afterCacheAccess(cacheContext);
            }
        }
        return $ef22af12cad4e1b3$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, this.performanceClient, idTokenClaims, requestStateObj, serverTokenResponse, serverRequestId);
    }
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload, additionalCacheKeyComponents) {
        const env = authority.getPreferredCache();
        if (!env) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$dedc648643245fa1), request.correlationId);
        const claimsTenantId = (0, $616279607e3ed735$export$8e1decb9a5e2932)(idTokenClaims);
        // IdToken: non AAD scenarios can have empty realm
        let cachedIdToken;
        let cachedAccount;
        if (serverTokenResponse.id_token && !!idTokenClaims) {
            cachedIdToken = (0, $4cd4d8a6d71d39a8$export$d8a173a23f325769)(this.homeAccountIdentifier, env, serverTokenResponse.id_token, this.clientId, claimsTenantId || "");
            cachedAccount = $ef22af12cad4e1b3$export$73b84062d58a1307(this.cacheStorage, authority, this.homeAccountIdentifier, this.cryptoObj.base64Decode, request.correlationId, idTokenClaims, serverTokenResponse.client_info, env, claimsTenantId, authCodePayload, undefined, this.logger, this.performanceClient);
        }
        // AccessToken
        let cachedAccessToken = null;
        if (serverTokenResponse.access_token) {
            // If scopes not returned in server response, use request scopes
            const responseScopes = serverTokenResponse.scope ? (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99).fromString(serverTokenResponse.scope, request.correlationId) : new (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99)(request.scopes || [], request.correlationId);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ const expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            const extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            const refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            const tokenExpirationSeconds = reqTimestamp + expiresIn;
            const extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            const refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = (0, $4cd4d8a6d71d39a8$export$fa005e75d915b6db)(this.homeAccountIdentifier, env, serverTokenResponse.access_token, this.clientId, claimsTenantId || authority.tenant || "", responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj.base64Decode, request.correlationId, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, additionalCacheKeyComponents);
            // Set resource (to be used for MCP scenarios)
            const resource = request.resource || null;
            if (resource) cachedAccessToken.resource = resource;
        }
        // refreshToken
        let cachedRefreshToken = null;
        if (serverTokenResponse.refresh_token) {
            let rtExpiresOn;
            if (serverTokenResponse.refresh_token_expires_in) {
                const rtExpiresIn = typeof serverTokenResponse.refresh_token_expires_in === "string" ? parseInt(serverTokenResponse.refresh_token_expires_in, 10) : serverTokenResponse.refresh_token_expires_in;
                rtExpiresOn = reqTimestamp + rtExpiresIn;
                this.performanceClient?.addFields({
                    ntwkRtExpiresOnSeconds: rtExpiresOn
                }, request.correlationId);
            }
            cachedRefreshToken = (0, $4cd4d8a6d71d39a8$export$9095b5885dfa55cc)(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token, this.clientId, serverTokenResponse.foci, userAssertionHash, rtExpiresOn);
        }
        // appMetadata
        let cachedAppMetadata = null;
        if (serverTokenResponse.foci) cachedAppMetadata = {
            clientId: this.clientId,
            environment: env,
            familyId: serverTokenResponse.foci
        };
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    }
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ static async generateAuthenticationResult(cryptoObj, authority, cacheRecord, fromTokenCache, request, performanceClient, idTokenClaims, requestState, serverTokenResponse, requestId) {
        let accessToken = "";
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        let refreshOn;
        let familyId = "";
        if (cacheRecord.accessToken) {
            /*
             * if the request object has `popKid` property, `signPopToken` will be set to false and
             * the token will be returned unsigned
             */ if (cacheRecord.accessToken.tokenType === (0, $8994aeee5e01080d$export$901491a717da2ba5).POP && !request.popKid) {
                const popTokenGenerator = new (0, $7d2464f001dd27e8$export$3dd8467151c83e3e)(cryptoObj, performanceClient);
                const { secret: secret, keyId: keyId } = cacheRecord.accessToken;
                if (!keyId) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$3c9338a50e294d1), request.correlationId);
                accessToken = await popTokenGenerator.signPopToken(secret, keyId, request);
            } else accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target, request.correlationId).asArray();
            // Access token expiresOn cached in seconds, converting to Date for AuthenticationResult
            expiresOn = (0, $e0616e53cd3f026f$export$dcee164673849555)(cacheRecord.accessToken.expiresOn);
            extExpiresOn = (0, $e0616e53cd3f026f$export$dcee164673849555)(cacheRecord.accessToken.extendedExpiresOn);
            if (cacheRecord.accessToken.refreshOn) refreshOn = (0, $e0616e53cd3f026f$export$dcee164673849555)(cacheRecord.accessToken.refreshOn);
        }
        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === (0, $8994aeee5e01080d$export$978fe7ab5e74b539) ? (0, $8994aeee5e01080d$export$978fe7ab5e74b539) : "";
        const uid = idTokenClaims?.oid || idTokenClaims?.sub || "";
        const tid = idTokenClaims?.tid || "";
        // for hybrid + native bridge enablement, send back the native account Id
        if (serverTokenResponse?.spa_accountid && !!cacheRecord.account) {
            // Set on deprecated top-level for downgrade compat
            cacheRecord.account.nativeAccountId = serverTokenResponse?.spa_accountid;
            // Set on the matching tenant profile (source of truth)
            const targetTenantId = tid || cacheRecord.account.realm;
            if (cacheRecord.account.tenantProfiles) {
                const matchingProfile = cacheRecord.account.tenantProfiles.find((tp)=>tp.tenantId === targetTenantId);
                if (matchingProfile) matchingProfile.nativeAccountId = serverTokenResponse.spa_accountid;
            }
        }
        const accountInfo = cacheRecord.account ? (0, $7beee762cc5bd6b9$export$452a054c78b83dad)((0, $f136bee61a3373e4$export$ec68416fe40418db)(cacheRecord.account), undefined, idTokenClaims, cacheRecord.idToken?.secret) : null;
        return {
            authority: authority.canonicalAuthority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: accountInfo,
            idToken: cacheRecord?.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: fromTokenCache,
            expiresOn: expiresOn,
            extExpiresOn: extExpiresOn,
            refreshOn: refreshOn,
            correlationId: request.correlationId,
            requestId: requestId || "",
            familyId: familyId,
            tokenType: cacheRecord.accessToken?.tokenType || "",
            state: requestState ? requestState.userRequestState : "",
            cloudGraphHostName: cacheRecord.account?.cloudGraphHostName || "",
            msGraphHost: cacheRecord.account?.msGraphHost || "",
            code: serverTokenResponse?.spa_code,
            fromPlatformBroker: false
        };
    }
}
/** @internal */ function $ef22af12cad4e1b3$export$73b84062d58a1307(cacheStorage, authority, homeAccountId, base64Decode, correlationId, idTokenClaims, clientInfo, environment, claimsTenantId, authCodePayload, nativeAccountId, logger, performanceClient) {
    logger?.verbose("setCachedAccount called", correlationId);
    /*
     * Check if base account is already cached. Filter by homeAccountId (identifies
     * the user's home identity) and environment (identifies the cloud) — the two
     * tenant-agnostic properties that uniquely locate a base AccountEntity.
     */ const accountEnvironment = environment || authority.getPreferredCache();
    const matchedAccounts = cacheStorage.getAccountsFilteredBy({
        homeAccountId: homeAccountId,
        environment: accountEnvironment
    }, correlationId);
    performanceClient?.addFields({
        cacheMatchedAccounts: matchedAccounts.length
    }, correlationId);
    if (matchedAccounts.length > 1) /*
         * Base accounts are expected to be unique for a given homeAccountId in normal cache usage.
         * If multiple matches exist, ignore the cache hit rather than arbitrarily choosing one.
         */ logger?.warning("Multiple base accounts matched homeAccountId. Ignoring cached account and creating a new base account.", correlationId);
    const cachedAccount = matchedAccounts.length === 1 ? matchedAccounts[0] : null;
    const baseAccount = cachedAccount || (0, $f136bee61a3373e4$export$104b1f92417fcaca)({
        homeAccountId: homeAccountId,
        idTokenClaims: idTokenClaims,
        clientInfo: clientInfo,
        environment: environment,
        cloudGraphHostName: authCodePayload?.cloud_graph_host_name,
        msGraphHost: authCodePayload?.msgraph_host,
        nativeAccountId: nativeAccountId
    }, authority, correlationId, base64Decode);
    const tenantProfiles = baseAccount.tenantProfiles || [];
    const tenantId = claimsTenantId || baseAccount.realm;
    if (tenantId && !tenantProfiles.find((tenantProfile)=>{
        return tenantProfile.tenantId === tenantId;
    })) {
        const newTenantProfile = (0, $7beee762cc5bd6b9$export$924857724cb21ba4)(homeAccountId, baseAccount.localAccountId, tenantId, nativeAccountId, idTokenClaims);
        tenantProfiles.push(newTenantProfile);
    }
    baseAccount.tenantProfiles = tenantProfiles;
    return baseAccount;
}







/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN"
};





/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $8e85ce4eede47db4$export$620d3a93bf8b59fb(clientAssertion, clientId, tokenEndpoint, fmiPath) {
    if (typeof clientAssertion === "string") return clientAssertion;
    else {
        const config = {
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            fmiPath: fmiPath
        };
        return clientAssertion(config);
    }
}



/*! @azure/msal-common v16.11.0 2026-06-30 */ 




/*! @azure/msal-common v16.11.0 2026-06-30 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $e230755462b27a9d$export$c060a619741dd765 {
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ static generateThrottlingStorageKey(thumbprint) {
        return `${0, $8994aeee5e01080d$export$2c4d2738c7e2e621}.${JSON.stringify(thumbprint)}`;
    }
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ static preProcess(cacheManager, thumbprint, correlationId) {
        const key = $e230755462b27a9d$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint);
        const value = cacheManager.getThrottlingCache(key, correlationId);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key, correlationId);
                return;
            }
            throw new (0, $cf4c26be8c97417f$export$ea52035eac03daf0)(value.errorCodes?.join(" ") || "", correlationId, value.errorMessage, value.subError);
        }
    }
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */ static postProcess(cacheManager, thumbprint, response, correlationId) {
        if ($e230755462b27a9d$export$c060a619741dd765.checkResponseStatus(response) || $e230755462b27a9d$export$c060a619741dd765.checkResponseForRetryAfter(response)) {
            const thumbprintValue = {
                throttleTime: $e230755462b27a9d$export$c060a619741dd765.calculateThrottleTime(parseInt(response.headers[(0, $8994aeee5e01080d$export$28d77f87efed1d88).RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache($e230755462b27a9d$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint), thumbprintValue, correlationId);
        }
    }
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ static checkResponseStatus(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    }
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */ static checkResponseForRetryAfter(response) {
        if (response.headers) return response.headers.hasOwnProperty((0, $8994aeee5e01080d$export$28d77f87efed1d88).RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        return false;
    }
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ static calculateThrottleTime(throttleTime) {
        const time = throttleTime <= 0 ? 0 : throttleTime;
        const currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || (0, $8994aeee5e01080d$export$c79860cd1fb326bc)), currentSeconds + (0, $8994aeee5e01080d$export$ed50f84f656b8a71)) * 1000);
    }
    static removeThrottle(cacheManager, clientId, request, homeAccountIdentifier) {
        const thumbprint = (0, $1a839cf816c84c9b$export$2daa8cfcf54c2b48)(clientId, request, homeAccountIdentifier);
        const key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key, request.correlationId);
    }
}


/*! @azure/msal-common v16.11.0 2026-06-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Represents network related errors
 */ class $bd3dc01dbb312431$export$bae979e68e4dc802 extends (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) {
    constructor(error, httpStatus, responseHeaders){
        super(error.errorCode, error.correlationId, error.errorMessage, error.subError);
        Object.setPrototypeOf(this, $bd3dc01dbb312431$export$bae979e68e4dc802.prototype);
        this.name = "NetworkError";
        this.error = error;
        this.httpStatus = httpStatus;
        this.responseHeaders = responseHeaders;
    }
}
/**
 * Creates NetworkError object for a failed network request
 * @param error - Error to be thrown back to the caller
 * @param httpStatus - Status code of the network request
 * @param responseHeaders - Response headers of the network request, when available
 * @returns NetworkError object
 */ function $bd3dc01dbb312431$export$262c4a35fb53be19(error, httpStatus, responseHeaders, additionalError) {
    error.errorMessage = `${error.errorMessage}, additionalErrorInfo: error.name:${additionalError?.name}, error.message:${additionalError?.message}`;
    return new $bd3dc01dbb312431$export$bae979e68e4dc802(error, httpStatus, responseHeaders);
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Creates default headers for requests to token endpoint
 */ function $ce0751562d3e57c4$export$74d4e61cf31cd8f9(logger, preventCorsPreflight, ccsCred) {
    const headers = {};
    headers[(0, $8994aeee5e01080d$export$28d77f87efed1d88).CONTENT_TYPE] = (0, $8994aeee5e01080d$export$7558dcec6f2048d);
    if (!preventCorsPreflight && ccsCred) switch(ccsCred.type){
        case (0, $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
            try {
                const clientInfo = (0, $9c0d10744a3bd38b$export$63508a6d6b7dbe07)(ccsCred.credential);
                headers[(0, $8994aeee5e01080d$export$28d77f87efed1d88).CCS_HEADER] = `Oid:${clientInfo.uid}@${clientInfo.utid}`;
            } catch (e) {
                logger.verbose(`Could not parse home account ID for CCS Header: '${e}'`, "");
            }
            break;
        case (0, $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f).UPN:
            headers[(0, $8994aeee5e01080d$export$28d77f87efed1d88).CCS_HEADER] = `UPN: ${ccsCred.credential}`;
            break;
    }
    return headers;
}
/**
 * Creates query string for the /token request
 * @param request
 */ function $ce0751562d3e57c4$export$c9cf064a62ceb675(request, clientId, redirectUri, performanceClient) {
    const parameters = new Map();
    if (request.embeddedClientId) (0, $25d69fa430040087$export$5ea4577e2a518c27)(parameters, clientId, redirectUri);
    if (request.extraQueryParameters) (0, $25d69fa430040087$export$7f71daa83fb7c7e2)(parameters, request.extraQueryParameters);
    (0, $25d69fa430040087$export$8a224ff809946e9c)(parameters, request.correlationId);
    (0, $25d69fa430040087$export$7153a1ee4346fa3b)(parameters, request.correlationId, performanceClient);
    return (0, $d35bb33c1dc82f98$export$44d4663acf79cde2)(parameters);
}
/**
 * Http post to token endpoint
 * @param tokenEndpoint
 * @param queryString
 * @param headers
 * @param thumbprint
 * @internal
 */ async function $ce0751562d3e57c4$export$2e39c706a1d34784(tokenEndpoint, queryString, headers, thumbprint, correlationId, cacheManager, networkClient, logger, performanceClient, serverTelemetryManager) {
    const response = await $ce0751562d3e57c4$export$c66c97cf7c2e5f90(thumbprint, tokenEndpoint, {
        body: queryString,
        headers: headers
    }, correlationId, cacheManager, networkClient, logger, performanceClient);
    if (serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
    serverTelemetryManager.clearTelemetryCache();
    return response;
}
/**
 * Wraps sendPostRequestAsync with necessary preflight and postflight logic
 * @param thumbprint - Request thumbprint for throttling
 * @param tokenEndpoint - Endpoint to make the POST to
 * @param options - Body and Headers to include on the POST request
 * @param correlationId - CorrelationId for telemetry
 * @param cacheManager - Cache manager instance
 * @param networkClient - Network module instance
 * @param logger - Logger instance
 * @param performanceClient - Performance client instance
 * @internal
 */ async function $ce0751562d3e57c4$export$c66c97cf7c2e5f90(thumbprint, tokenEndpoint, options, correlationId, cacheManager, networkClient, logger, performanceClient) {
    (0, $e230755462b27a9d$export$c060a619741dd765).preProcess(cacheManager, thumbprint, correlationId);
    let response;
    try {
        response = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(networkClient.sendPostRequestAsync.bind(networkClient), (0, $0d9eb83114fc9425$export$98fd4e414eb6f897), logger, performanceClient, correlationId)(tokenEndpoint, options);
        const responseHeaders = response.headers || {};
        performanceClient?.addFields({
            refreshTokenSize: response.body.refresh_token?.length || 0,
            httpVerToken: responseHeaders[(0, $8994aeee5e01080d$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
            requestId: responseHeaders[(0, $8994aeee5e01080d$export$28d77f87efed1d88).X_MS_REQUEST_ID] || ""
        }, correlationId);
    } catch (e) {
        if (e instanceof (0, $bd3dc01dbb312431$export$bae979e68e4dc802)) {
            const responseHeaders = e.responseHeaders;
            if (responseHeaders) performanceClient?.addFields({
                httpVerToken: responseHeaders[(0, $8994aeee5e01080d$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                requestId: responseHeaders[(0, $8994aeee5e01080d$export$28d77f87efed1d88).X_MS_REQUEST_ID] || "",
                contentTypeHeader: responseHeaders[(0, $8994aeee5e01080d$export$28d77f87efed1d88).CONTENT_TYPE] || undefined,
                contentLengthHeader: responseHeaders[(0, $8994aeee5e01080d$export$28d77f87efed1d88).CONTENT_LENGTH] || undefined,
                httpStatus: e.httpStatus
            }, correlationId);
            throw e.error;
        }
        if (e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) throw e;
        else throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$4358cbadf08aa73), correlationId);
    }
    (0, $e230755462b27a9d$export$c060a619741dd765).postProcess(cacheManager, thumbprint, response, correlationId);
    return response;
}


var $6e9164c377553ca6$exports = {};

$parcel$export($6e9164c377553ca6$exports, "createDiscoveredInstance", () => $6e9164c377553ca6$export$ab9db5e7e572e7da);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create an authority object of the correct type based on the url
 * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
 *
 * Also performs endpoint discovery.
 *
 * @param authorityUri
 * @param networkClient
 * @param cacheManager
 * @param authorityOptions
 * @param logger
 * @param correlationId
 * @param performanceClient
 * @internal
 */ async function $6e9164c377553ca6$export$ab9db5e7e572e7da(authorityUri, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient) {
    const authorityUriFinal = (0, $c05549f487bde715$export$f1c6ec2e6d68c49c).transformCIAMAuthority((0, $c05549f487bde715$export$4030f3538167cb9e)(authorityUri), correlationId);
    // Initialize authority and perform discovery endpoint check.
    const acquireTokenAuthority = new (0, $c05549f487bde715$export$f1c6ec2e6d68c49c)(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient);
    try {
        await (0, $69bce03cfd571284$export$e4feded94d9adb18)(acquireTokenAuthority.resolveEndpointsAsync.bind(acquireTokenAuthority), (0, $0d9eb83114fc9425$export$931c11cf1c07ab89), logger, performanceClient, correlationId)();
        return acquireTokenAuthority;
    } catch (e) {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$c9fcc93738cc2bc3), correlationId);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 * @internal
 */ class $5d04d7665f1ebf53$export$8538731fd397fb90 {
    constructor(configuration, performanceClient){
        // Flag to indicate if client is for hybrid spa auth code redemption
        this.includeRedirectUri = true;
        // Set the configuration
        this.config = (0, $8e787aed99ab54c6$export$57a091701dcdabb2)(configuration);
        // Initialize the logger
        this.logger = new (0, $0fd93c953107c2f4$export$efa9a398d6368992)(this.config.loggerOptions, (0, $8da2d5e621fbe87e$export$a8ff84c12d48cfa6), (0, $8da2d5e621fbe87e$export$83d89fbfd8236492));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
        this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
    }
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */ async acquireToken(request, apiId, authCodePayload) {
        if (!request.code) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$4ac9fb1f531eded7), request.correlationId);
        // Check for new cloud instance
        if (authCodePayload && authCodePayload.cloud_instance_host_name) await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.updateTokenEndpointAuthority.bind(this), (0, $0d9eb83114fc9425$export$3cb25312cfbc6081), this.logger, this.performanceClient, request.correlationId)(authCodePayload.cloud_instance_host_name, request.correlationId);
        const reqTimestamp = (0, $e0616e53cd3f026f$export$ae62599a119ac50a)();
        const response = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $0d9eb83114fc9425$export$7fe8027afbec6ae), this.logger, this.performanceClient, request.correlationId)(this.authority, request, this.serverTelemetryManager);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $8994aeee5e01080d$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $ef22af12cad4e1b3$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin);
        // Validate response. This function throws a server error if an error is returned by the server.
        responseHandler.validateTokenResponse(response.body, request.correlationId);
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $0d9eb83114fc9425$export$602d5889aed45852), this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, apiId, authCodePayload, undefined, undefined, undefined, requestId);
    }
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ getLogoutUri(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$9eb2eeb401492d88), "");
        const queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).appendQueryString(this.authority.endSessionEndpoint, queryString);
    }
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ async executeTokenRequest(authority, request, serverTelemetryManager) {
        const queryParametersString = (0, $ce0751562d3e57c4$export$c9cf064a62ceb675)(request, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient);
        const endpoint = (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $0d9eb83114fc9425$export$5f104c073ff8021d), this.logger, this.performanceClient, request.correlationId)(request);
        let ccsCredential = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $9c0d10744a3bd38b$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCredential = {
                credential: `${clientInfo.uid}${0, $8994aeee5e01080d$export$2e94b6c6dd44699e}${clientInfo.utid}`,
                type: (0, $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose(`Could not parse client info for CCS Header: '${e}'`, request.correlationId);
        }
        const headers = (0, $ce0751562d3e57c4$export$74d4e61cf31cd8f9)(this.logger, this.config.systemOptions.preventCorsPreflight, ccsCredential || request.ccsCredential);
        const thumbprint = (0, $1a839cf816c84c9b$export$2daa8cfcf54c2b48)(this.config.authOptions.clientId, request);
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $ce0751562d3e57c4$export$2e39c706a1d34784), (0, $0d9eb83114fc9425$export$2697a5f7f677322e), this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, serverTelemetryManager);
    }
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ async createTokenRequestBody(request) {
        const parameters = new Map();
        (0, $25d69fa430040087$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.extraParameters?.[0, $46f4c10c7ac0692f$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        /*
         * For hybrid spa flow, there will be a code but no verifier
         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
         */ if (!this.includeRedirectUri) {
            // Just validate
            if (!request.redirectUri) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$7a02f9bdce79dd4e), request.correlationId);
        } else // Validate and include redirect uri
        (0, $25d69fa430040087$export$6758d6264f4f06)(parameters, request.redirectUri);
        // Add scope array, parameter builder will add default scopes and dedupe
        (0, $25d69fa430040087$export$c213bf8f125826ba)(parameters, request.scopes, request.correlationId, true, this.oidcDefaultScopes);
        (0, $25d69fa430040087$export$dd712f36c1a9cd08)(parameters, request.resource);
        // add code: user set, not validated
        (0, $25d69fa430040087$export$ff027aab2d77a49c)(parameters, request.code);
        // Add library metadata
        (0, $25d69fa430040087$export$3ecac3764b147c3f)(parameters, this.config.libraryInfo);
        (0, $25d69fa430040087$export$37ec1b76d865654a)(parameters, this.config.telemetry.application);
        (0, $25d69fa430040087$export$26592ae2037df9de)(parameters);
        if (this.serverTelemetryManager && !(0, $8e787aed99ab54c6$export$25afa7198c2ed9b9)(this.config)) (0, $25d69fa430040087$export$79fb524b159705e9)(parameters, this.serverTelemetryManager);
        // add code_verifier if passed
        if (request.codeVerifier) (0, $25d69fa430040087$export$dceb49e3b4703cbb)(parameters, request.codeVerifier);
        if (this.config.clientCredentials.clientSecret) (0, $25d69fa430040087$export$8df84bbb0e2465bc)(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            (0, $25d69fa430040087$export$2d3d772920e2496e)(parameters, await (0, $8e85ce4eede47db4$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            (0, $25d69fa430040087$export$55ad911d12112f00)(parameters, clientAssertion.assertionType);
        }
        (0, $25d69fa430040087$export$e5f700fdeb4022b2)(parameters, (0, $8994aeee5e01080d$export$ce68f19b50b39c0b).AUTHORIZATION_CODE_GRANT);
        (0, $25d69fa430040087$export$86b85a101d45e918)(parameters);
        if (request.authenticationScheme === (0, $8994aeee5e01080d$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $7d2464f001dd27e8$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $0d9eb83114fc9425$export$42d4b7447f09a8ea), this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            (0, $25d69fa430040087$export$6dfc34809d8c4096)(parameters, reqCnfData);
        } else if (request.authenticationScheme === (0, $8994aeee5e01080d$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) (0, $25d69fa430040087$export$f004de9a266b8070)(parameters, request.sshJwk);
            else throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$8fbed44b22d9136f), request.correlationId);
        }
        let ccsCred = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $9c0d10744a3bd38b$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCred = {
                credential: `${clientInfo.uid}${0, $8994aeee5e01080d$export$2e94b6c6dd44699e}${clientInfo.utid}`,
                type: (0, $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose(`Could not parse client info for CCS Header: '${e}'`, request.correlationId);
        }
        else ccsCred = request.ccsCredential;
        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $9c0d10744a3bd38b$export$63508a6d6b7dbe07)(ccsCred.credential);
                    (0, $25d69fa430040087$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose(`Could not parse home account ID for CCS Header: '${e}'`, request.correlationId);
                }
                break;
            case (0, $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f).UPN:
                (0, $25d69fa430040087$export$aa9cca16bcc29d2d)(parameters, ccsCred.credential);
                break;
        }
        if (request.embeddedClientId) (0, $25d69fa430040087$export$5ea4577e2a518c27)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.extraParameters) (0, $25d69fa430040087$export$7f71daa83fb7c7e2)(parameters, request.extraParameters);
        // Add hybrid spa parameters if not already provided
        if (request.enableSpaAuthorizationCode && (!request.extraParameters || !request.extraParameters[0, $46f4c10c7ac0692f$export$f58b98a40c1faa68])) (0, $25d69fa430040087$export$7f71daa83fb7c7e2)(parameters, {
            [(0, $46f4c10c7ac0692f$export$f58b98a40c1faa68)]: "1"
        });
        (0, $25d69fa430040087$export$7153a1ee4346fa3b)(parameters, request.correlationId, this.performanceClient);
        (0, $25d69fa430040087$export$b04c3bca9165ed02)(parameters, request.correlationId, request.claims, this.config.authOptions.clientCapabilities, request.skipBrokerClaims);
        return (0, $d35bb33c1dc82f98$export$44d4663acf79cde2)(parameters);
    }
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ createLogoutUrlQueryString(request) {
        const parameters = new Map();
        if (request.postLogoutRedirectUri) (0, $25d69fa430040087$export$bb8081db67b059c0)(parameters, request.postLogoutRedirectUri);
        if (request.correlationId) (0, $25d69fa430040087$export$8a224ff809946e9c)(parameters, request.correlationId);
        if (request.idTokenHint) (0, $25d69fa430040087$export$c6f34f6f67740950)(parameters, request.idTokenHint);
        if (request.state) (0, $25d69fa430040087$export$4a8b8c14090dd065)(parameters, request.state);
        if (request.logoutHint) (0, $25d69fa430040087$export$e0d4676d7288bded)(parameters, request.logoutHint);
        if (request.extraQueryParameters) (0, $25d69fa430040087$export$7f71daa83fb7c7e2)(parameters, request.extraQueryParameters);
        if (this.config.authOptions.instanceAware) (0, $25d69fa430040087$export$50b40dfb1d11b77a)(parameters);
        return (0, $d35bb33c1dc82f98$export$44d4663acf79cde2)(parameters);
    }
    /**
     * Updates the authority to the cloud instance provided in the authorization response
     * @param cloudInstanceHostName - cloud instance host name from authorization code payload
     * @param correlationId - request correlation id
     */ async updateTokenEndpointAuthority(cloudInstanceHostName, correlationId) {
        const cloudInstanceAuthorityUri = `https://${cloudInstanceHostName}/${this.authority.tenant}/`;
        const cloudInstanceAuthority = await (0, $6e9164c377553ca6$export$ab9db5e7e572e7da)(cloudInstanceAuthorityUri, this.networkClient, this.cacheManager, this.authority.options, this.logger, correlationId, this.performanceClient);
        this.authority = cloudInstanceAuthority;
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ /*! @azure/msal-common v16.11.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $3c6f275c31235baf$var$skuGroupSeparator = ",";
const $3c6f275c31235baf$var$skuValueSeparator = "|";
function $3c6f275c31235baf$var$makeExtraSkuString(params) {
    const { skus: skus, libraryName: libraryName, libraryVersion: libraryVersion, extensionName: extensionName, extensionVersion: extensionVersion } = params;
    const skuMap = new Map([
        [
            0,
            [
                libraryName,
                libraryVersion
            ]
        ],
        [
            2,
            [
                extensionName,
                extensionVersion
            ]
        ]
    ]);
    let skuArr = [];
    if (skus?.length) {
        skuArr = skus.split($3c6f275c31235baf$var$skuGroupSeparator);
        // Ignore invalid input sku param
        if (skuArr.length < 4) return skus;
    } else skuArr = Array.from({
        length: 4
    }, ()=>$3c6f275c31235baf$var$skuValueSeparator);
    skuMap.forEach((value, key)=>{
        if (value.length === 2 && value[0]?.length && value[1]?.length) $3c6f275c31235baf$var$setSku({
            skuArr: skuArr,
            index: key,
            skuName: value[0],
            skuVersion: value[1]
        });
    });
    return skuArr.join($3c6f275c31235baf$var$skuGroupSeparator);
}
function $3c6f275c31235baf$var$setSku(params) {
    const { skuArr: skuArr, index: index, skuName: skuName, skuVersion: skuVersion } = params;
    if (index >= skuArr.length) return;
    skuArr[index] = [
        skuName,
        skuVersion
    ].join($3c6f275c31235baf$var$skuValueSeparator);
}
/** @internal */ class $3c6f275c31235baf$export$bddbbc43a3ca9c53 {
    constructor(telemetryRequest, cacheManager){
        this.cacheOutcome = (0, $8994aeee5e01080d$export$aa4af185ea049f6b).NOT_APPLICABLE;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || "";
        this.wrapperVer = telemetryRequest.wrapperVer || "";
        this.telemetryCacheKey = (0, $8994aeee5e01080d$export$788940e4cd6c0eba) + (0, $8994aeee5e01080d$export$9e9532f57bbb139e) + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ generateCurrentRequestHeaderValue() {
        const request = `${this.apiId}${(0, $8994aeee5e01080d$export$b0781166f23da624)}${this.cacheOutcome}`;
        const platformFieldsArr = [
            this.wrapperSKU,
            this.wrapperVer
        ];
        const nativeBrokerErrorCode = this.getNativeBrokerErrorCode();
        if (nativeBrokerErrorCode?.length) platformFieldsArr.push(`broker_error=${nativeBrokerErrorCode}`);
        const platformFields = platformFieldsArr.join((0, $8994aeee5e01080d$export$b0781166f23da624));
        const regionDiscoveryFields = this.getRegionDiscoveryFields();
        const requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join((0, $8994aeee5e01080d$export$b0781166f23da624));
        return [
            (0, $8994aeee5e01080d$export$ada8c967fb9297cd),
            requestWithRegionDiscoveryFields,
            platformFields
        ].join((0, $8994aeee5e01080d$export$f51f7d493a85471e));
    }
    /**
     * API to add MSER Telemetry for the last failed request
     */ generateLastRequestHeaderValue() {
        const lastRequests = this.getLastRequests();
        const maxErrors = $3c6f275c31235baf$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join((0, $8994aeee5e01080d$export$b0781166f23da624));
        const errors = lastRequests.errors.slice(0, maxErrors).join((0, $8994aeee5e01080d$export$b0781166f23da624));
        const errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        const overflow = maxErrors < errorCount ? (0, $8994aeee5e01080d$export$1ee554efbc503c65) : (0, $8994aeee5e01080d$export$aad3ca432a8e0485);
        const platformFields = [
            errorCount,
            overflow
        ].join((0, $8994aeee5e01080d$export$b0781166f23da624));
        return [
            (0, $8994aeee5e01080d$export$ada8c967fb9297cd),
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join((0, $8994aeee5e01080d$export$f51f7d493a85471e));
    }
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ cacheFailedRequest(error) {
        try {
            const lastRequests = this.getLastRequests();
            if (lastRequests.errors.length >= (0, $8994aeee5e01080d$export$6fa374559f78ca9f)) {
                // Remove a cached error to make room, first in first out
                lastRequests.failedRequests.shift(); // apiId
                lastRequests.failedRequests.shift(); // correlationId
                lastRequests.errors.shift();
            }
            lastRequests.failedRequests.push(this.apiId, this.correlationId);
            if (error instanceof Error && !!error && error.toString()) {
                if (error instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) {
                    if (error.subError) lastRequests.errors.push(error.subError);
                    else if (error.errorCode) lastRequests.errors.push(error.errorCode);
                    else lastRequests.errors.push(error.toString());
                } else lastRequests.errors.push(error.toString());
            } else lastRequests.errors.push((0, $8994aeee5e01080d$export$b3ede2149169f35e));
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        } catch  {
        // Ignore telemetry cache failures to avoid masking the original auth error path.
        }
        return;
    }
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ incrementCacheHits() {
        const lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return lastRequests.cacheHits;
    }
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ getLastRequests() {
        const initialValue = {
            failedRequests: [],
            errors: [],
            cacheHits: 0
        };
        const lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey, this.correlationId);
        return lastRequests || initialValue;
    }
    /**
     * Remove server telemetry cache entry
     */ clearTelemetryCache() {
        const lastRequests = this.getLastRequests();
        const numErrorsFlushed = $3c6f275c31235baf$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey, this.correlationId);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            const serverTelemEntity = {
                failedRequests: lastRequests.failedRequests.slice(numErrorsFlushed * 2),
                errors: lastRequests.errors.slice(numErrorsFlushed),
                cacheHits: 0
            };
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity, this.correlationId);
        }
    }
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ static maxErrorsToSend(serverTelemetryEntity) {
        let i;
        let maxErrors = 0;
        let dataSize = 0;
        const errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            const apiId = serverTelemetryEntity.failedRequests[2 * i] || "";
            const correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || "";
            const errorCode = serverTelemetryEntity.errors[i] || "";
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < (0, $8994aeee5e01080d$export$166696a6bac48dc5)) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    }
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ getRegionDiscoveryFields() {
        const regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || "");
        regionDiscoveryFields.push(this.regionSource || "");
        regionDiscoveryFields.push(this.regionOutcome || "");
        return regionDiscoveryFields.join(",");
    }
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ updateRegionDiscoveryMetadata(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    }
    /**
     * Set cache outcome
     */ setCacheOutcome(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    }
    setNativeBrokerErrorCode(errorCode) {
        const lastRequests = this.getLastRequests();
        lastRequests.nativeBrokerErrorCode = errorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    getNativeBrokerErrorCode() {
        return this.getLastRequests().nativeBrokerErrorCode;
    }
    clearNativeBrokerErrorCode() {
        const lastRequests = this.getLastRequests();
        delete lastRequests.nativeBrokerErrorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    static makeExtraSkuString(params) {
        return $3c6f275c31235baf$var$makeExtraSkuString(params);
    }
}
/** @internal */ class $3c6f275c31235baf$export$2738742abaa26ef7 extends $3c6f275c31235baf$export$bddbbc43a3ca9c53 {
    constructor(){
        super({
            clientId: "",
            apiId: 0,
            correlationId: "",
            forceRefresh: false
        }, {});
    }
    generateCurrentRequestHeaderValue() {
        return "";
    }
    generateLastRequestHeaderValue() {
        return "";
    }
    cacheFailedRequest() {}
    incrementCacheHits() {
        return 0;
    }
    clearTelemetryCache() {}
    getRegionDiscoveryFields() {
        return "";
    }
    updateRegionDiscoveryMetadata() {}
    setCacheOutcome() {}
    setNativeBrokerErrorCode() {}
    getNativeBrokerErrorCode() {
        return undefined;
    }
    clearNativeBrokerErrorCode() {}
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $956a2c583a756eea$export$d858565f81c03f1f {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider){
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.platformAuthProvider = platformAuthProvider;
        this.correlationId = correlationId;
        this.logger = logger.clone((0, $c8226bf52dd9a4ef$export$a8ff84c12d48cfa6), (0, $c8226bf52dd9a4ef$export$83d89fbfd8236492));
        this.performanceClient = performanceClient;
    }
}
/**
 * Use to get the redirect URI configured in MSAL or construct one from the current page.
 * @param requestRedirectUri - Redirect URI from the request or undefined if not configured
 * @param clientConfigRedirectUri - Redirect URI from the client configuration or undefined if not configured
 * @param logger - Logger instance from the calling client
 * @param correlationId
 * @returns Absolute redirect URL constructed from the provided URI, config, or current page
 */ function $956a2c583a756eea$export$e602b39e9004b45f(requestRedirectUri, clientConfigRedirectUri, logger, correlationId) {
    logger.verbose("0bd1la", correlationId);
    const redirectUri = requestRedirectUri || clientConfigRedirectUri || "";
    return (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).getAbsoluteUrl(redirectUri, (0, $8e677587a7c978db$export$1204531fbbf6ecde)(), correlationId);
}
/**
 * Initializes and returns a ServerTelemetryManager with the provided telemetry configuration.
 * @param apiId - The API identifier for telemetry tracking
 * @param clientId - The client application identifier
 * @param correlationId - Unique identifier for correlating requests
 * @param browserStorage - Browser cache manager instance for storing telemetry data
 * @param logger - Optional logger instance for verbose logging
 * @param forceRefresh - Optional flag to force refresh of telemetry data
 * @param enabled - Optional flag to enable or disable server telemetry (default: true for custom_auth flows, false for standard flows)
 * @returns Configured ServerTelemetryManager instance
 */ function $956a2c583a756eea$export$c0fa8985fac40b0c(apiId, clientId, correlationId, browserStorage, logger, forceRefresh, enabled = true) {
    logger.verbose("1p12tq", correlationId);
    if (!enabled) {
        logger.verbose("0tajnr", correlationId);
        return new (0, $3c6f275c31235baf$export$2738742abaa26ef7)();
    }
    const telemetryPayload = {
        clientId: clientId,
        correlationId: correlationId,
        apiId: apiId,
        forceRefresh: forceRefresh || false,
        wrapperSKU: browserStorage.getWrapperMetadata()[0],
        wrapperVer: browserStorage.getWrapperMetadata()[1]
    };
    return new (0, $3c6f275c31235baf$export$bddbbc43a3ca9c53)(telemetryPayload, browserStorage);
}
/**
 * Used to get a discovered version of the default authority.
 * @param params - Configuration object containing authority and cloud options
 * @param params.requestAuthority - Optional specific authority URL to use
 * @param params.requestAzureCloudOptions - Optional Azure cloud configuration options
 * @param params.requestExtraQueryParameters - Optional additional query parameters
 * @param params.account - Optional account info for instance-aware scenarios
 * @param config - Browser configuration containing auth settings
 * @param correlationId - Unique identifier for correlating requests
 * @param performanceClient - Performance monitoring client instance
 * @param browserStorage - Browser cache manager instance
 * @param logger - Logger instance for tracking operations
 * @returns Promise that resolves to a discovered Authority instance
 */ async function $956a2c583a756eea$export$e36d1ed7c9435e3e(config, correlationId, performanceClient, browserStorage, logger, requestAuthority, requestAzureCloudOptions, requestExtraQueryParameters, account) {
    const instanceAwareEQ = requestExtraQueryParameters && requestExtraQueryParameters.hasOwnProperty("instance_aware") ? requestExtraQueryParameters["instance_aware"] : undefined;
    const authorityOptions = {
        protocolMode: config.system.protocolMode,
        OIDCOptions: config.auth.OIDCOptions,
        knownAuthorities: config.auth.knownAuthorities,
        cloudDiscoveryMetadata: config.auth.cloudDiscoveryMetadata,
        authorityMetadata: config.auth.authorityMetadata
    };
    // build authority string based on auth params, precedence - azureCloudInstance + tenant >> authority
    const resolvedAuthority = requestAuthority || config.auth.authority;
    const resolvedInstanceAware = instanceAwareEQ?.length ? instanceAwareEQ === "true" : config.auth.instanceAware;
    const userAuthority = account && resolvedInstanceAware ? config.auth.authority.replace((0, $9c756a14a1bed5db$export$3abcdca7229e54f2).getDomainFromUrl(resolvedAuthority, correlationId), account.environment) : resolvedAuthority;
    // fall back to the authority from config
    const builtAuthority = (0, $c05549f487bde715$export$f1c6ec2e6d68c49c).generateAuthority(userAuthority, requestAzureCloudOptions || config.auth.azureCloudOptions);
    const discoveredAuthority = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $6e9164c377553ca6$exports).createDiscoveredInstance, (0, $acc47f0f594e8d22$export$e7e182fcd29aaa7f), logger, performanceClient, correlationId)(builtAuthority, config.system.networkClient, browserStorage, authorityOptions, logger, correlationId, performanceClient);
    if (account && !discoveredAuthority.isAlias(account.environment)) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$exports).authorityMismatch, correlationId);
    return discoveredAuthority;
}
/**
 * Clears cache and account information during logout.
 *
 * If an account is provided, removes the account from cache and, if it is the active account, sets the active account to null.
 * If no account is provided, clears all accounts and tokens from cache.
 *
 * @param browserStorage - The browser cache manager instance used to manage cache.
 * @param browserCrypto - The crypto interface for cache operations.
 * @param logger - Logger instance for logging operations.
 * @param correlationId - Correlation ID for the logout operation.
 * @param account - (Optional) The account to clear from cache. If not provided, all accounts are cleared.
 * @returns A promise that resolves when the cache has been cleared.
 */ async function $956a2c583a756eea$export$bcfc3ed6114b66f4(browserStorage, browserCrypto, logger, correlationId, account) {
    if (account) // Clear given account.
    try {
        browserStorage.removeAccount(account, correlationId);
        logger.verbose("0s4z6h", correlationId);
    } catch (error) {
        logger.error("0mgg1d", correlationId);
    }
    else try {
        logger.verbose("0zj631", correlationId);
        // Clear all accounts and tokens
        browserStorage.clear(correlationId);
        // Clear any stray keys from IndexedDB
        await browserCrypto.clearKeystore(correlationId);
    } catch (e) {
        logger.error("12ih0c", correlationId);
    }
}







/*! @azure/msal-browser v5.16.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Initializer function for all request APIs
 * @param request
 * @param config
 * @param performanceClient
 * @param logger
 * @param correlationId
 */ async function $e54e4b4a24079223$export$8e461fcf1fd6910b(request, config, performanceClient, logger, correlationId) {
    const authority = request.authority || config.auth.authority;
    const scopes = [
        ...request && request.scopes || []
    ];
    const validatedRequest = {
        ...request,
        correlationId: request.correlationId,
        authority: authority,
        scopes: scopes
    };
    // Set authenticationScheme to BEARER if not explicitly set in the request
    if (!validatedRequest.authenticationScheme) {
        validatedRequest.authenticationScheme = (0, $8994aeee5e01080d$exports).AuthenticationScheme.BEARER;
        logger.verbose("1l4fwv", correlationId);
    } else {
        if (validatedRequest.authenticationScheme === (0, $8994aeee5e01080d$exports).AuthenticationScheme.SSH) {
            if (!request.sshJwk) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$exports).missingSshJwk, "");
            if (!request.sshKid) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$exports).missingSshKid, "");
        }
        logger.verbose(`1ecmns ${validatedRequest.authenticationScheme}`, correlationId);
    }
    return validatedRequest;
}
async function $e54e4b4a24079223$export$4c8aa78c426811d4(request, account, config, performanceClient, logger) {
    const baseRequest = await (0, $69bce03cfd571284$export$e4feded94d9adb18)($e54e4b4a24079223$export$8e461fcf1fd6910b, (0, $acc47f0f594e8d22$export$e13dedc12c2c4f38), logger, performanceClient, request.correlationId)(request, config, performanceClient, logger, request.correlationId);
    return {
        ...request,
        ...baseRequest,
        account: account,
        forceRefresh: request.forceRefresh || false
    };
}
/**
 * Validates that the combination of request method, protocol mode and authorize body parameters is correct.
 * Returns the validated or defaulted HTTP method or throws if the configured combination is invalid.
 * @param interactionRequest
 * @param protocolMode
 * @returns
 */ function $e54e4b4a24079223$export$253b550f4555e4bf(interactionRequest, protocolMode) {
    let httpMethod;
    const requestMethod = interactionRequest.httpMethod;
    if (protocolMode === (0, $631489f43a9fbed6$export$73a3e3dedd37150d).EAR) {
        // Validate that method can only be POST when protocol mode is EAR
        if (requestMethod && requestMethod !== (0, $8994aeee5e01080d$exports).HttpMethod.POST) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$exports).invalidRequestMethodForEAR, "");
        else httpMethod = (0, $8994aeee5e01080d$exports).HttpMethod.POST;
    } else // For non-EAR protocol modes, default to GET if httpMethod is not set
    httpMethod = requestMethod || (0, $8994aeee5e01080d$exports).HttpMethod.GET;
    return httpMethod;
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ class $b86c5719a99dca61$export$fa9179cade3eb05a extends (0, $956a2c583a756eea$export$d858565f81c03f1f) {
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ initializeLogoutRequest(logoutRequest) {
        this.logger.verbose("0546u4", this.correlationId);
        const validLogoutRequest = {
            correlationId: this.correlationId,
            ...logoutRequest
        };
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from account loginHint or ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    const logoutHint = logoutRequest.account.loginHint || this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("0d7s8p", this.correlationId);
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("0pdtc3", this.correlationId);
            } else this.logger.verbose("12k4l4", this.correlationId);
        } else this.logger.verbose("07ndze", this.correlationId);
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("1vamm6", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, (0, $8e677587a7c978db$export$1204531fbbf6ecde)(), validLogoutRequest.correlationId);
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("15m5g7", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("1f4xlz", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, (0, $8e677587a7c978db$export$1204531fbbf6ecde)(), validLogoutRequest.correlationId);
            } else {
                this.logger.verbose("17s5rf", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).getAbsoluteUrl((0, $8e677587a7c978db$export$1204531fbbf6ecde)(), (0, $8e677587a7c978db$export$1204531fbbf6ecde)(), validLogoutRequest.correlationId);
            }
        } else this.logger.verbose("0ljv63", validLogoutRequest.correlationId);
        return validLogoutRequest;
    }
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ getLogoutHintFromIdTokenClaims(account) {
        const idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) {
                this.logger.verbose("0u5bmc", this.correlationId);
                return idTokenClaims.login_hint;
            } else this.logger.verbose("0mvp54", this.correlationId);
        } else this.logger.verbose("1e7bdp", this.correlationId);
        return null;
    }
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createAuthCodeClient(params) {
        // Create auth module.
        const clientConfig = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $acc47f0f594e8d22$export$8b2b453d4b5734d9), this.logger, this.performanceClient, this.correlationId)(params);
        return new (0, $5d04d7665f1ebf53$export$8538731fd397fb90)(clientConfig, this.performanceClient);
    }
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: boolean;
     *         account?: AccountInfo;
     *        }
     */ async getClientConfiguration(params) {
        const { serverTelemetryManager: serverTelemetryManager, requestAuthority: requestAuthority, requestAzureCloudOptions: requestAzureCloudOptions, requestExtraQueryParameters: requestExtraQueryParameters, account: account } = params;
        const discoveredAuthority = params.authority || await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $956a2c583a756eea$export$e36d1ed7c9435e3e), (0, $acc47f0f594e8d22$export$dad6c3127c773e76), this.logger, this.performanceClient, this.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, requestAuthority, requestAzureCloudOptions, requestExtraQueryParameters, account);
        const logger = this.config.system.loggerOptions;
        return {
            authOptions: {
                clientId: this.config.auth.clientId,
                authority: discoveredAuthority,
                clientCapabilities: this.config.auth.clientCapabilities,
                redirectUri: this.config.auth.redirectUri,
                isMcp: this.config.auth.isMcp
            },
            systemOptions: {
                tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                preventCorsPreflight: true
            },
            loggerOptions: {
                loggerCallback: logger.loggerCallback,
                piiLoggingEnabled: logger.piiLoggingEnabled,
                logLevel: logger.logLevel,
                correlationId: this.correlationId
            },
            cryptoInterface: this.browserCrypto,
            networkInterface: this.networkClient,
            storageInterface: this.browserStorage,
            serverTelemetryManager: serverTelemetryManager,
            libraryInfo: {
                sku: (0, $7101cc4ee26a17a4$export$a0a689e4294b9880).MSAL_SKU,
                version: (0, $c8226bf52dd9a4ef$export$83d89fbfd8236492),
                cpu: "",
                os: ""
            },
            telemetry: this.config.telemetry
        };
    }
}
/**
 * Helper to initialize required request parameters for interactive APIs and ssoSilent().
 *
 * @param request - The authentication request object (RedirectRequest, PopupRequest, or SsoSilentRequest).
 * @param interactionType - The type of interaction (e.g., redirect, popup, silent).
 * @param config - The browser configuration object.
 * @param browserCrypto - The cryptographic interface for browser operations.
 * @param browserStorage - The browser storage manager instance.
 * @param logger - The logger instance for logging messages.
 * @param performanceClient - The performance client for telemetry.
 * @param correlationId - The correlation ID for the request.
 * @returns A promise that resolves to a CommonAuthorizationUrlRequest object with initialized parameters.
 */ async function $b86c5719a99dca61$export$33189c9f1d196fb4(request, interactionType, config, browserCrypto, browserStorage, logger, performanceClient, correlationId) {
    const redirectUri = (0, $956a2c583a756eea$export$e602b39e9004b45f)(request.redirectUri, config.auth.redirectUri, logger, correlationId);
    if (new URL(redirectUri).origin !== new URL(window.location.href).origin) {
        logger.warning("08qbvw", correlationId);
        performanceClient.addFields({
            isRedirectUriCrossOrigin: true
        }, correlationId);
    }
    const browserState = {
        interactionType: interactionType
    };
    const state = (0, $de6be0b6a0939617$exports).setRequestState(browserCrypto, request && request.state || "", browserState, correlationId);
    const baseRequest = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $e54e4b4a24079223$export$8e461fcf1fd6910b), (0, $acc47f0f594e8d22$export$e13dedc12c2c4f38), logger, performanceClient, correlationId)({
        ...request,
        correlationId: correlationId
    }, config, performanceClient, logger, correlationId);
    const interactionRequest = {
        ...baseRequest,
        redirectUri: redirectUri,
        state: state,
        nonce: request.nonce || (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)(),
        responseMode: config.auth.OIDCOptions.responseMode
    };
    const validatedRequest = {
        ...interactionRequest,
        httpMethod: (0, $e54e4b4a24079223$export$253b550f4555e4bf)(interactionRequest, config.system.protocolMode)
    };
    // Skip active account lookup if either login hint or session id is set
    if (request.loginHint || request.sid) return validatedRequest;
    const account = request.account || browserStorage.getActiveAccount(correlationId);
    if (account) {
        logger.verbose("1eqlb3", correlationId);
        logger.verbosePii(`0tf99t ${account.homeAccountId}`, correlationId);
        validatedRequest.account = account;
    }
    return validatedRequest;
}







/*! @azure/msal-browser v5.16.0 2026-06-30 */ 

/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts the BrowserStateObject from the state string.
 * @param browserCrypto
 * @param state
 */ function $f98f3776dccd761b$export$68ec87f530f5f536(browserCrypto, state, correlationId) {
    if (!state) return null;
    try {
        const requestStateObj = (0, $de6be0b6a0939617$exports).parseRequestState(browserCrypto.base64Decode, state, correlationId);
        return requestStateObj.libraryState.meta;
    } catch (e) {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).invalidState, correlationId);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e54e6f1425de2c43$export$e64c1808ed72a7c(responseString, responseLocation, logger, correlationId) {
    // Deserialize hash fragment response parameters.
    const serverParams = (0, $d35bb33c1dc82f98$exports).getDeserializedResponse(responseString);
    if (!serverParams) {
        if (!(0, $d35bb33c1dc82f98$exports).stripLeadingHashOrQuery(responseString)) {
            // Hash or Query string is empty
            logger.error(`18h0l1 ${responseLocation} ${responseLocation}`, correlationId);
            throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$a29c42a1dd414317), correlationId);
        } else {
            logger.error(`13pl0s ${responseLocation} ${responseLocation}`, correlationId);
            logger.errorPii(`1097vx ${responseLocation} ${responseString}`, correlationId);
            throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$5743873a5ba5d124), correlationId);
        }
    }
    return serverParams;
}
/**
 * Returns the interaction type that the response object belongs to
 */ function $e54e6f1425de2c43$export$af0c72d18284aa0(response, browserCrypto, interactionType, correlationId) {
    if (!response.state) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$211c8e8843a8d278), correlationId);
    const platformStateObj = (0, $f98f3776dccd761b$export$68ec87f530f5f536)(browserCrypto, response.state, correlationId);
    if (!platformStateObj) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$237bdd0b913cb30c), correlationId);
    if (platformStateObj.interactionType !== interactionType) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$499b1b95c97a1c75), correlationId);
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ var $34778708f9a89dd9$exports = {};

$parcel$export($34778708f9a89dd9$exports, "getStandardAuthorizeRequestParameters", () => $34778708f9a89dd9$export$61cf790f71e46219);
$parcel$export($34778708f9a89dd9$exports, "getAuthorizeUrl", () => $34778708f9a89dd9$export$e397eb426c115a0a);
$parcel$export($34778708f9a89dd9$exports, "getAuthorizationCodePayload", () => $34778708f9a89dd9$export$36c64a7d10cf377b);
$parcel$export($34778708f9a89dd9$exports, "validateAuthorizationResponse", () => $34778708f9a89dd9$export$9979de10627480c5);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 * @internal
 */ function $34778708f9a89dd9$export$61cf790f71e46219(authOptions, request, logger, performanceClient) {
    // generate the correlationId if not set by the user and add
    const correlationId = request.correlationId;
    const parameters = new Map();
    (0, $25d69fa430040087$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.extraQueryParameters?.[0, $46f4c10c7ac0692f$export$c7b1b63f5b60f8e] || authOptions.clientId);
    const requestScopes = [
        ...request.scopes || [],
        ...request.extraScopesToConsent || []
    ];
    (0, $25d69fa430040087$export$c213bf8f125826ba)(parameters, requestScopes, request.correlationId, true, authOptions.authority.options.OIDCOptions?.defaultScopes);
    (0, $25d69fa430040087$export$dd712f36c1a9cd08)(parameters, request.resource);
    (0, $25d69fa430040087$export$6758d6264f4f06)(parameters, request.redirectUri);
    (0, $25d69fa430040087$export$8a224ff809946e9c)(parameters, correlationId);
    // add response_mode. If not passed in it defaults to query.
    (0, $25d69fa430040087$export$f1c153626c2c2d91)(parameters, request.responseMode);
    // add client_info=1
    (0, $25d69fa430040087$export$86b85a101d45e918)(parameters);
    // add clidata=1
    (0, $25d69fa430040087$export$5a0058be0b2fe3ea)(parameters);
    if (request.prompt) {
        (0, $25d69fa430040087$export$e982ccd37a61cde6)(parameters, request.prompt);
        performanceClient?.addFields({
            prompt: request.prompt
        }, correlationId);
    }
    if (request.domainHint) {
        (0, $25d69fa430040087$export$1bd007a9d7fec290)(parameters, request.domainHint);
        performanceClient?.addFields({
            domainHintFromRequest: true
        }, correlationId);
    }
    // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
    if (request.prompt !== (0, $8994aeee5e01080d$export$49a06cbda5acaa5).SELECT_ACCOUNT) {
        // AAD will throw if prompt=select_account is passed with an account hint
        if (request.sid && request.prompt === (0, $8994aeee5e01080d$export$49a06cbda5acaa5).NONE) {
            // SessionID is only used in silent calls
            logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request", request.correlationId);
            (0, $25d69fa430040087$export$9d8531b0fa366b30)(parameters, request.sid);
            performanceClient?.addFields({
                sidFromRequest: true
            }, correlationId);
        } else if (request.account) {
            const accountSid = $34778708f9a89dd9$var$extractAccountSid(request.account);
            let accountLoginHintClaim = $34778708f9a89dd9$var$extractLoginHint(request.account);
            if (accountLoginHintClaim && request.domainHint) {
                logger.warning(`AuthorizationCodeClient.createAuthCodeUrlQueryString: "domainHint" param is set, skipping opaque "login_hint" claim. Please consider not passing domainHint`, request.correlationId);
                accountLoginHintClaim = null;
            }
            // If login_hint claim is present, use it over sid/username
            if (accountLoginHintClaim) {
                logger.verbose("createAuthCodeUrlQueryString: login_hint claim present on account", request.correlationId);
                (0, $25d69fa430040087$export$65f43fd4b28bba5f)(parameters, accountLoginHintClaim);
                performanceClient?.addFields({
                    loginHintFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = (0, $9c0d10744a3bd38b$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $25d69fa430040087$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header", request.correlationId);
                }
            } else if (accountSid && request.prompt === (0, $8994aeee5e01080d$export$49a06cbda5acaa5).NONE) {
                /*
                 * If account and loginHint are provided, we will check account first for sid before adding loginHint
                 * SessionId is only used in silent calls
                 */ logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account", request.correlationId);
                (0, $25d69fa430040087$export$9d8531b0fa366b30)(parameters, accountSid);
                performanceClient?.addFields({
                    sidFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = (0, $9c0d10744a3bd38b$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $25d69fa430040087$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header", request.correlationId);
                }
            } else if (request.loginHint) {
                logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request", request.correlationId);
                (0, $25d69fa430040087$export$65f43fd4b28bba5f)(parameters, request.loginHint);
                (0, $25d69fa430040087$export$aa9cca16bcc29d2d)(parameters, request.loginHint);
                performanceClient?.addFields({
                    loginHintFromRequest: true
                }, correlationId);
            } else if (request.account.username) {
                // Fallback to account username if provided
                logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account", request.correlationId);
                (0, $25d69fa430040087$export$65f43fd4b28bba5f)(parameters, request.account.username);
                performanceClient?.addFields({
                    loginHintFromUpn: true
                }, correlationId);
                try {
                    const clientInfo = (0, $9c0d10744a3bd38b$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $25d69fa430040087$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header", request.correlationId);
                }
            }
        } else if (request.loginHint) {
            logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request", request.correlationId);
            (0, $25d69fa430040087$export$65f43fd4b28bba5f)(parameters, request.loginHint);
            (0, $25d69fa430040087$export$aa9cca16bcc29d2d)(parameters, request.loginHint);
            performanceClient?.addFields({
                loginHintFromRequest: true
            }, correlationId);
        }
    } else logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints", request.correlationId);
    if (request.nonce) (0, $25d69fa430040087$export$87b1d5d886e84b11)(parameters, request.nonce);
    if (request.state) (0, $25d69fa430040087$export$4a8b8c14090dd065)(parameters, request.state);
    if (request.embeddedClientId) (0, $25d69fa430040087$export$5ea4577e2a518c27)(parameters, authOptions.clientId, authOptions.redirectUri);
    (0, $25d69fa430040087$export$b04c3bca9165ed02)(parameters, request.correlationId, request.claims, authOptions.clientCapabilities, request.skipBrokerClaims);
    // If extraQueryParameters includes instance_aware its value will be added when extraQueryParameters are added
    if (authOptions.instanceAware && (!request.extraQueryParameters || !Object.keys(request.extraQueryParameters).includes((0, $46f4c10c7ac0692f$export$d72b25d13120919d)))) (0, $25d69fa430040087$export$50b40dfb1d11b77a)(parameters);
    return parameters;
}
/**
 * Returns authorize endpoint with given request parameters in the query string
 * @param authority
 * @param requestParameters
 * @returns
 * @internal
 */ function $34778708f9a89dd9$export$e397eb426c115a0a(authority, requestParameters) {
    const queryString = (0, $d35bb33c1dc82f98$export$44d4663acf79cde2)(requestParameters);
    return (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).appendQueryString(authority.authorizationEndpoint, queryString);
}
/**
 * Handles the hash fragment response from public client code request. Returns a code response used by
 * the client to exchange for a token in acquireToken.
 * @param serverParams
 * @param cachedState
 * @param correlationId
 */ function $34778708f9a89dd9$export$36c64a7d10cf377b(serverParams, cachedState, correlationId) {
    // Get code response
    $34778708f9a89dd9$export$9979de10627480c5(serverParams, cachedState, correlationId);
    // throw when there is no auth code in the response
    if (!serverParams.code) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$93625fc864d26bba), correlationId);
    return serverParams;
}
/**
 * Function which validates server authorization code response.
 * @param serverResponseHash
 * @param requestState
 * @param correlationId
 */ function $34778708f9a89dd9$export$9979de10627480c5(serverResponse, requestState, correlationId) {
    if (!serverResponse.state || !requestState) throw serverResponse.state ? (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$ef9214cfa5960fc), correlationId, "Cached State") : (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$ef9214cfa5960fc), correlationId, "Server State");
    let decodedServerResponseState;
    let decodedRequestState;
    try {
        decodedServerResponseState = decodeURIComponent(serverResponse.state);
    } catch (e) {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$72a77317632c052b), correlationId, serverResponse.state);
    }
    try {
        decodedRequestState = decodeURIComponent(requestState);
    } catch (e) {
        throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$72a77317632c052b), correlationId, serverResponse.state);
    }
    if (decodedServerResponseState !== decodedRequestState) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$6a56d8f882843cd8), correlationId);
    // Check for error
    if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
        const serverErrorNo = $34778708f9a89dd9$var$parseServerErrorNo(serverResponse);
        if ((0, $e9bbb17645bd3149$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $e9bbb17645bd3149$export$6ba3e818c6bc76ba)(serverResponse.error || "", serverResponse.correlation_id || correlationId, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.claims || "", serverErrorNo);
        throw new (0, $cf4c26be8c97417f$export$ea52035eac03daf0)(serverResponse.error || "", serverResponse.correlation_id || correlationId, serverResponse.error_description, serverResponse.suberror, serverErrorNo);
    }
}
/**
 * Get server error No from the error_uri
 * @param serverResponse
 * @returns
 */ function $34778708f9a89dd9$var$parseServerErrorNo(serverResponse) {
    const errorCodePrefix = "code=";
    const errorCodePrefixIndex = serverResponse.error_uri?.lastIndexOf(errorCodePrefix);
    return errorCodePrefixIndex && errorCodePrefixIndex >= 0 ? serverResponse.error_uri?.substring(errorCodePrefixIndex + errorCodePrefix.length) : undefined;
}
/**
 * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
 * @param account
 */ function $34778708f9a89dd9$var$extractAccountSid(account) {
    return account.idTokenClaims?.sid || null;
}
function $34778708f9a89dd9$var$extractLoginHint(account) {
    return account.loginHint || account.idTokenClaims?.login_hint || null;
}







/*! @azure/msal-browser v5.16.0 2026-06-30 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ class $d0174f0c495d01eb$export$a30cd982b4e89bdb {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ async handleCodeResponse(response, request, apiId) {
        let authCodeResponse;
        try {
            authCodeResponse = (0, $34778708f9a89dd9$exports).getAuthorizationCodePayload(response, request.state, request.correlationId);
        } catch (e) {
            if (e instanceof (0, $cf4c26be8c97417f$export$ea52035eac03daf0) && e.subError === (0, $8a281d620a4036a7$export$6bae303c5e922702)) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$6bae303c5e922702), request.correlationId);
            else throw e;
        }
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.handleCodeResponseFromServer.bind(this), (0, $0d9eb83114fc9425$exports).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)(authCodeResponse, request, apiId);
    }
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param request
     * @param validateNonce
     * @returns
     */ async handleCodeResponseFromServer(authCodeResponse, request, apiId, validateNonce = true) {
        this.logger.trace("0mf2hb", request.correlationId);
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
        if (validateNonce) // TODO: Assigning "response nonce" to "request nonce" is confusing. Refactor the function doing validation to accept request nonce directly
        authCodeResponse.nonce = request.nonce || undefined;
        authCodeResponse.state = request.state;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const ccsCred = this.createCcsCredentials(request);
            if (ccsCred) this.authCodeRequest.ccsCredential = ccsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.authModule.acquireToken.bind(this.authModule), (0, $acc47f0f594e8d22$export$ce1a395bb2077ffd), this.logger, this.performanceClient, request.correlationId)(this.authCodeRequest, apiId, authCodeResponse);
        return tokenResponse;
    }
    /**
     * Build ccs creds if available
     */ createCcsCredentials(request) {
        if (request.account) return {
            credential: request.account.homeAccountId,
            type: (0, $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
        };
        else if (request.loginHint) return {
            credential: request.loginHint,
            type: (0, $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f).UPN
        };
        return null;
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 

/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $54c057f8977f7ba9$export$fbe5ac8608048ea9 = "ContentError";
const $54c057f8977f7ba9$export$9da03c0dbf887a8 = "PageException";
const $54c057f8977f7ba9$export$966ec8558e4d7922 = "user_switch";
const $54c057f8977f7ba9$export$d2b39fdb388adfc8 = "unsupported_method";


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Status Codes that can be thrown by WAM
const $ee59bce363904ed6$export$e0aac30e542b316c = "USER_INTERACTION_REQUIRED";
const $ee59bce363904ed6$export$bec5e49cc27c5c10 = "USER_CANCEL";
const $ee59bce363904ed6$export$3c68b4973c91ba = "NO_NETWORK";
const $ee59bce363904ed6$export$8cd212c10b4124d2 = "DISABLED";
const $ee59bce363904ed6$export$f4c2bddc98c93ffc = "ACCOUNT_UNAVAILABLE";
const $ee59bce363904ed6$export$c3e51a265f1b751c = "UI_NOT_ALLOWED";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $8cc7862cecd95c0a$var$INVALID_METHOD_ERROR = -2147186943;
class $8cc7862cecd95c0a$export$4b8a4f6256e840ab extends (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) {
    constructor(errorCode, correlationId, description, ext){
        super(errorCode, correlationId, description || (0, $e015633e658266f1$export$714f3eb4b9ca37c5)(errorCode));
        Object.setPrototypeOf(this, $8cc7862cecd95c0a$export$4b8a4f6256e840ab.prototype);
        this.name = "NativeAuthError";
        this.ext = ext;
    }
}
/**
 * These errors should result in a fallback to the 'standard' browser based auth flow.
 */ function $8cc7862cecd95c0a$export$f21e42e365baeb50(error) {
    if (error.ext && error.ext.status && error.ext.status === (0, $ee59bce363904ed6$export$8cd212c10b4124d2)) return true;
    if (error.ext && error.ext.error && error.ext.error === $8cc7862cecd95c0a$var$INVALID_METHOD_ERROR) return true;
    switch(error.errorCode){
        case 0, $54c057f8977f7ba9$export$fbe5ac8608048ea9:
        case 0, $54c057f8977f7ba9$export$9da03c0dbf887a8:
            return true;
        default:
            return false;
    }
}
/**
 * Create the appropriate error object based on the WAM status code.
 * @param code
 * @param description
 * @param ext
 * @returns
 */ function $8cc7862cecd95c0a$export$9154414ec87d187b(code, correlationId, description, ext) {
    let error;
    if (ext && ext.status) {
        switch(ext.status){
            case 0, $ee59bce363904ed6$export$f4c2bddc98c93ffc:
                error = (0, $e9bbb17645bd3149$export$8f7a741750c16535)((0, $65a17b77f45cb3f9$exports).nativeAccountUnavailable, correlationId, (0, $e015633e658266f1$export$714f3eb4b9ca37c5)(code));
                break;
            case 0, $ee59bce363904ed6$export$e0aac30e542b316c:
                error = new (0, $e9bbb17645bd3149$export$6ba3e818c6bc76ba)(code, correlationId, description);
                break;
            case 0, $ee59bce363904ed6$export$bec5e49cc27c5c10:
                error = (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$6bae303c5e922702), correlationId);
                break;
            case 0, $ee59bce363904ed6$export$3c68b4973c91ba:
                error = (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$31ae862f18c3b2b7), correlationId);
                break;
            case 0, $ee59bce363904ed6$export$c3e51a265f1b751c:
                error = (0, $e9bbb17645bd3149$export$8f7a741750c16535)((0, $65a17b77f45cb3f9$exports).uiNotAllowed, correlationId);
                break;
            default:
                error = new $8cc7862cecd95c0a$export$4b8a4f6256e840ab(code, correlationId, description, ext);
        }
        return error;
    }
    error = new $8cc7862cecd95c0a$export$4b8a4f6256e840ab(code, correlationId, description, ext);
    return error;
}







/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
/*! @azure/msal-common v16.11.0 2026-06-30 */ 












'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $ee8746763ff7719b$export$e344f5b12c464597 {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = (0, $8e787aed99ab54c6$export$57a091701dcdabb2)(configuration);
        // Initialize the logger
        this.logger = new (0, $0fd93c953107c2f4$export$efa9a398d6368992)(this.config.loggerOptions, (0, $8da2d5e621fbe87e$export$a8ff84c12d48cfa6), (0, $8da2d5e621fbe87e$export$83d89fbfd8236492));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ async acquireCachedToken(request) {
        let lastCacheOutcome = (0, $8994aeee5e01080d$export$aa4af185ea049f6b).NOT_APPLICABLE;
        if (request.forceRefresh || !(0, $4204b6e4994e8227$export$ecc754f99843e759).isEmptyObj(request.claims)) {
            // Must refresh due to present force_refresh flag.
            this.setCacheOutcome((0, $8994aeee5e01080d$export$aa4af185ea049f6b).FORCE_REFRESH_OR_CLAIMS, request.correlationId);
            throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$e23b692cce0c7779), request.correlationId);
        }
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$5a3c7d1c90ac9220), request.correlationId);
        const requestTenantId = request.account.tenantId || (0, $c05549f487bde715$export$6ed5af33d279fbc7)(request.authority, request.correlationId);
        const tokenKeys = this.cacheManager.getTokenKeys();
        const cachedAccessToken = this.cacheManager.getAccessToken(request.account, request, tokenKeys, requestTenantId);
        if (!cachedAccessToken) {
            // must refresh due to non-existent access_token
            this.setCacheOutcome((0, $8994aeee5e01080d$export$aa4af185ea049f6b).NO_CACHED_ACCESS_TOKEN, request.correlationId);
            throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$e23b692cce0c7779), request.correlationId);
        } else if ((0, $e0616e53cd3f026f$export$8961be72dcbc368e)(cachedAccessToken.cachedAt) || (0, $e0616e53cd3f026f$export$b007d77a962aa175)(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
            // must refresh due to the expires_in value
            this.setCacheOutcome((0, $8994aeee5e01080d$export$aa4af185ea049f6b).CACHED_ACCESS_TOKEN_EXPIRED, request.correlationId);
            throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$e23b692cce0c7779), request.correlationId);
        } else if (request.resource) // cached access token must have a resource that matches the request resource for MCP scenarios
        {
            if (cachedAccessToken.resource !== request.resource) {
                this.setCacheOutcome((0, $8994aeee5e01080d$export$aa4af185ea049f6b).NO_CACHED_ACCESS_TOKEN, request.correlationId);
                throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$e23b692cce0c7779), request.correlationId);
            }
        } else if (cachedAccessToken.refreshOn && (0, $e0616e53cd3f026f$export$b007d77a962aa175)(cachedAccessToken.refreshOn, 0)) // must refresh (in the background) due to the refresh_in value
        lastCacheOutcome = (0, $8994aeee5e01080d$export$aa4af185ea049f6b).PROACTIVELY_REFRESHED;
        const environment = request.authority || this.authority.getPreferredCache();
        const cacheRecord = {
            account: this.cacheManager.getAccount(this.cacheManager.generateAccountKey(request.account), request.correlationId),
            accessToken: cachedAccessToken,
            idToken: this.cacheManager.getIdToken(request.account, request.correlationId, tokenKeys, requestTenantId),
            refreshToken: null,
            appMetadata: this.cacheManager.readAppMetadataFromCache(environment, request.correlationId)
        };
        this.setCacheOutcome(lastCacheOutcome, request.correlationId);
        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
        return [
            await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.generateResultFromCacheRecord.bind(this), (0, $0d9eb83114fc9425$export$6765682c201079f6), this.logger, this.performanceClient, request.correlationId)(cacheRecord, request),
            lastCacheOutcome
        ];
    }
    setCacheOutcome(cacheOutcome, correlationId) {
        this.serverTelemetryManager?.setCacheOutcome(cacheOutcome);
        this.performanceClient?.addFields({
            cacheOutcome: cacheOutcome
        }, correlationId);
        if (cacheOutcome !== (0, $8994aeee5e01080d$export$aa4af185ea049f6b).NOT_APPLICABLE) this.logger.info(`Token refresh is required due to cache outcome: '${cacheOutcome}'`, correlationId);
    }
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ async generateResultFromCacheRecord(cacheRecord, request) {
        let idTokenClaims;
        if (cacheRecord.idToken) idTokenClaims = (0, $4acd0486289e3b4f$export$8a59e6f35fb00518)(cacheRecord.idToken.secret, this.config.cryptoInterface.base64Decode, request.correlationId);
        return (0, $ef22af12cad4e1b3$export$f456c9835cc63582).generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, this.performanceClient, idTokenClaims);
    }
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $a376ef2f5068f2a9$export$59d4f873ee62d01e extends (0, $b86c5719a99dca61$export$fa9179cade3eb05a) {
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ async acquireToken(silentRequest) {
        // Telemetry manager only used to increment cacheHits here
        const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)((0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const clientConfig = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $acc47f0f594e8d22$export$8b2b453d4b5734d9), this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        const silentAuthClient = new (0, $ee8746763ff7719b$export$e344f5b12c464597)(clientConfig, this.performanceClient);
        this.logger.verbose("0wa871", this.correlationId);
        try {
            const response = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(silentAuthClient.acquireCachedToken.bind(silentAuthClient), (0, $acc47f0f594e8d22$export$1760779da367f865), this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
            const authResponse = response[0];
            this.performanceClient.addFields({
                fromCache: true
            }, silentRequest.correlationId);
            return authResponse;
        } catch (error) {
            if (error instanceof (0, $e015633e658266f1$export$f8eb6760ca13876a) && error.errorCode === (0, $8a281d620a4036a7$export$a416b0eceb5c15df)) this.logger.verbose("06wena", this.correlationId);
            throw error;
        }
    }
    /**
     * API to silenty clear the browser cache.
     * @param logoutRequest
     */ logout(logoutRequest) {
        this.logger.verbose("1rkurh", this.correlationId);
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        return (0, $956a2c583a756eea$export$bcfc3ed6114b66f4)(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validLogoutRequest.account);
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9a0ce6cc67a0db6b$export$3f89612b3fd8831f extends (0, $956a2c583a756eea$export$d858565f81c03f1f) {
    constructor(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId){
        super(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, provider);
        this.apiId = apiId;
        this.accountId = accountId;
        this.platformAuthProvider = provider;
        this.nativeStorageManager = nativeStorageImpl;
        this.silentCacheClient = new (0, $a376ef2f5068f2a9$export$59d4f873ee62d01e)(config, this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, provider);
        const extensionName = this.platformAuthProvider.getExtensionName();
        this.skus = (0, $3c6f275c31235baf$export$bddbbc43a3ca9c53).makeExtraSkuString({
            libraryName: (0, $7101cc4ee26a17a4$export$a0a689e4294b9880).MSAL_SKU,
            libraryVersion: (0, $c8226bf52dd9a4ef$export$83d89fbfd8236492),
            extensionName: extensionName,
            extensionVersion: this.platformAuthProvider.getExtensionVersion()
        });
    }
    /**
     * Adds SKUs to request extra query parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ addRequestSKUs(request) {
        request.extraParameters = {
            ...request.extraParameters,
            [(0, $46f4c10c7ac0692f$exports).X_CLIENT_EXTRA_SKU]: this.skus
        };
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ async acquireToken(request, cacheLookupPolicy) {
        this.logger.trace("03qeos", this.correlationId);
        // start the perf measurement
        const nativeATMeasurement = this.performanceClient.startMeasurement((0, $acc47f0f594e8d22$export$6939ff7b9b362e6d), this.correlationId);
        const reqTimestamp = (0, $e0616e53cd3f026f$exports).nowSeconds();
        const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // initialize native request
            const nativeRequest = await this.initializePlatformRequest(request);
            // check if the tokens can be retrieved from internal cache
            try {
                const result = await this.acquireTokensFromCache(this.accountId, nativeRequest);
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: false,
                    fromCache: true
                });
                return result;
            } catch (e) {
                if (cacheLookupPolicy === (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).AccessToken) {
                    this.logger.info("0eitbc", this.correlationId);
                    nativeATMeasurement.end({
                        success: false,
                        brokerErrorCode: "cache_request_failed"
                    });
                    throw e;
                }
                // continue with a native call for any and all errors
                this.logger.info("0957j1", this.correlationId);
            }
            const validatedResponse = await this.platformAuthProvider.sendMessage(nativeRequest);
            return await this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp).then((result)=>{
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: true,
                    requestId: result.requestId
                });
                serverTelemetryManager.clearNativeBrokerErrorCode();
                return result;
            }).catch((error)=>{
                nativeATMeasurement.end({
                    success: false,
                    errorCode: error.errorCode,
                    subErrorCode: error.subError
                });
                throw error;
            });
        } catch (e) {
            if (e instanceof (0, $8cc7862cecd95c0a$export$4b8a4f6256e840ab)) serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
            nativeATMeasurement.end({
                success: false
            });
            throw e;
        }
    }
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ createSilentCacheRequest(request, cachedAccount) {
        return {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99).fromString(request.scope, this.correlationId).asArray(),
            account: cachedAccount,
            forceRefresh: false
        };
    }
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ async acquireTokensFromCache(nativeAccountId, request) {
        if (!nativeAccountId) {
            this.logger.warning("1ndf3e", this.correlationId);
            throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).noAccountFound, this.correlationId);
        }
        // fetch the account from browser cache
        const account = this.browserStorage.getBaseAccountInfo({
            nativeAccountId: nativeAccountId
        }, this.correlationId);
        if (!account) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).noAccountFound, this.correlationId);
        // leverage silent flow for cached tokens retrieval
        try {
            const silentRequest = this.createSilentCacheRequest(request, account);
            const result = await this.silentCacheClient.acquireToken(silentRequest);
            const idToken = this.browserStorage.getIdToken(account, this.correlationId, this.browserStorage.getTokenKeys(), account.tenantId);
            const idTokenClaims = (0, $4acd0486289e3b4f$exports).extractTokenClaims(idToken?.secret || "", (0, $5949979cf1605326$export$c62426fdd000a97e), this.correlationId);
            const fullAccount = (0, $7beee762cc5bd6b9$export$452a054c78b83dad)(account, undefined, idTokenClaims, idToken?.secret);
            return {
                ...result,
                idToken: idToken?.secret || "",
                idTokenClaims: idTokenClaims,
                account: fullAccount
            };
        } catch (e) {
            throw e;
        }
    }
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param {RedirectRequest} request
     * @param {InProgressPerformanceEvent} rootMeasurement
     * @param {HandleRedirectPromiseOptions} options
     */ async acquireTokenRedirect(request, rootMeasurement, options) {
        this.logger.trace("0luikq", this.correlationId);
        const nativeRequest = await this.initializePlatformRequest(request);
        const navigateToLoginRequestUrl = options?.navigateToLoginRequestUrl ?? true;
        try {
            await this.platformAuthProvider.sendMessage(nativeRequest);
        } catch (e) {
            // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
            if (e instanceof (0, $8cc7862cecd95c0a$export$4b8a4f6256e840ab)) {
                const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
                serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
                if ((0, $8cc7862cecd95c0a$export$f21e42e365baeb50)(e)) throw e;
            }
        }
        this.browserStorage.setTemporaryCache((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).NATIVE_REQUEST, JSON.stringify(nativeRequest), true);
        const navigationOptions = {
            apiId: (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenRedirect,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: false
        };
        const redirectUri = navigateToLoginRequestUrl ? (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).getAbsoluteUrl(request.redirectStartPage || window.location.href, (0, $8e677587a7c978db$export$1204531fbbf6ecde)(), this.correlationId) : (0, $956a2c583a756eea$export$e602b39e9004b45f)(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId);
        rootMeasurement.end({
            success: true
        });
        await this.navigationClient.navigateExternal(redirectUri, navigationOptions); // Need to treat this as external to ensure handleRedirectPromise is run again
    }
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     * @param performanceClient {IPerformanceClient?}
     * @param correlationId {string?} correlation identifier
     */ async handleRedirectPromise() {
        this.logger.trace("1c5lhw", this.correlationId);
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("0le6uv", this.correlationId);
            return null;
        }
        // remove prompt from the request to prevent WAM from prompting twice
        const cachedRequest = this.browserStorage.getCachedNativeRequest();
        if (!cachedRequest) {
            this.logger.verbose("0a6zjb", this.correlationId);
            this.performanceClient?.addFields({
                errorCode: "no_cached_request"
            }, this.correlationId);
            return null;
        }
        const { prompt: prompt, ...request } = cachedRequest;
        if (prompt) this.logger.verbose("0ac34v", this.correlationId);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).NATIVE_REQUEST));
        const reqTimestamp = (0, $e0616e53cd3f026f$exports).nowSeconds();
        try {
            this.logger.verbose("003x5a", this.correlationId);
            const response = await this.platformAuthProvider.sendMessage(request);
            const authResult = await this.handleNativeResponse(response, request, reqTimestamp);
            const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
            serverTelemetryManager.clearNativeBrokerErrorCode();
            this.performanceClient?.addFields({
                isNativeBroker: true
            }, this.correlationId);
            return authResult;
        } catch (e) {
            throw e;
        }
    }
    /**
     * Logout from native platform via browser extension
     * @param request
     */ logout() {
        this.logger.trace("0u2sjm", this.correlationId);
        return Promise.reject("Logout not implemented yet");
    }
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ async handleNativeResponse(response, request, reqTimestamp) {
        this.logger.trace("1bojln", this.correlationId);
        // generate identifiers
        const idTokenClaims = (0, $4acd0486289e3b4f$exports).extractTokenClaims(response.id_token, (0, $5949979cf1605326$export$c62426fdd000a97e), this.correlationId);
        const homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenClaims);
        const cachedhomeAccountId = this.browserStorage.getAccountInfoFilteredBy({
            nativeAccountId: request.accountId
        }, this.correlationId)?.homeAccountId;
        // add exception for double brokering, please note this is temporary and will be fortified in future
        if (request.extraParameters?.child_client_id && response.account.id !== request.accountId) this.logger.info("1ub1in", this.correlationId);
        else if (homeAccountIdentifier !== cachedhomeAccountId && response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
        throw (0, $8cc7862cecd95c0a$export$9154414ec87d187b)((0, $54c057f8977f7ba9$export$966ec8558e4d7922), this.correlationId);
        // Get the preferred_cache domain for the given authority
        const authority = await (0, $956a2c583a756eea$export$e36d1ed7c9435e3e)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, request.authority);
        const baseAccount = (0, $ef22af12cad4e1b3$export$73b84062d58a1307)(this.browserStorage, authority, homeAccountIdentifier, (0, $5949979cf1605326$export$c62426fdd000a97e), this.correlationId, idTokenClaims, response.client_info, authority.getPreferredCache(), idTokenClaims.tid, undefined, response.account.id, this.logger, this.performanceClient);
        // Ensure expires_in is in number format
        response.expires_in = Number(response.expires_in);
        // generate authenticationResult
        const result = await this.generateAuthenticationResult(response, request, idTokenClaims, baseAccount, authority.canonicalAuthority, reqTimestamp);
        // cache accounts and tokens in the appropriate storage
        await this.cacheAccount(baseAccount, (0, $4acd0486289e3b4f$exports).isKmsi(idTokenClaims));
        await this.cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, result.tenantId, reqTimestamp, authority.getPreferredCache() // environment
        );
        return result;
    }
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ createHomeAccountIdentifier(response, idTokenClaims) {
        // Save account in browser storage
        const homeAccountIdentifier = (0, $f136bee61a3373e4$exports).generateHomeAccountId(response.client_info || "", (0, $2ac5a806251697eb$export$cd82032b224a3839).Default, this.logger, this.browserCrypto, this.correlationId, idTokenClaims);
        return homeAccountIdentifier;
    }
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ generateScopes(requestScopes, responseScopes) {
        return responseScopes ? (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99).fromString(responseScopes, this.correlationId) : (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99).fromString(requestScopes, this.correlationId);
    }
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ async generatePopAccessToken(response, request) {
        if (request.tokenType === (0, $8994aeee5e01080d$exports).AuthenticationScheme.POP && request.signPopToken) {
            /**
             * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
             * is still received, SHR is calculated locally
             */ // Check if native layer returned an SHR token
            if (response.shr) {
                this.logger.trace("0coqhu", this.correlationId);
                return response.shr;
            }
            // Generate SHR in msal js if WAM does not compute it when POP is enabled
            const popTokenGenerator = new (0, $7d2464f001dd27e8$export$3dd8467151c83e3e)(this.browserCrypto, this.performanceClient);
            const shrParameters = {
                resourceRequestMethod: request.resourceRequestMethod,
                resourceRequestUri: request.resourceRequestUri,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce,
                correlationId: this.correlationId
            };
            /**
             * KeyID must be present in the native request from when the PoP key was generated in order for
             * PopTokenGenerator to query the full key for signing
             */ if (!request.keyId) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).keyIdMissing, this.correlationId);
            return popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters);
        } else return response.access_token;
    }
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ async generateAuthenticationResult(response, request, idTokenClaims, accountEntity, authority, reqTimestamp) {
        // Add Native Broker fields to Telemetry
        const mats = this.addTelemetryFromNativeResponse(response.properties.MATS);
        // If scopes not returned in server response, use request scopes
        const responseScopes = this.generateScopes(request.scope, response.scope);
        const accountProperties = response.account.properties || {};
        const uid = accountProperties["UID"] || idTokenClaims.oid || idTokenClaims.sub || "";
        const tid = accountProperties["TenantId"] || idTokenClaims.tid || "";
        const accountInfo = (0, $7beee762cc5bd6b9$export$452a054c78b83dad)((0, $f136bee61a3373e4$exports).getAccountInfo(accountEntity), undefined, idTokenClaims, response.id_token);
        /**
         * In pairwise broker flows, this check prevents the broker's native account id
         * from being returned over the embedded app's account id.
         */ if (accountInfo.nativeAccountId !== response.account.id) {
            accountInfo.nativeAccountId = response.account.id;
            // Also update the matching tenant profile (source of truth)
            const targetTenantId = tid || accountInfo.tenantId;
            const tenantProfile = accountInfo.tenantProfiles?.get(targetTenantId);
            if (tenantProfile) tenantProfile.nativeAccountId = response.account.id;
        }
        // generate PoP token as needed
        const responseAccessToken = await this.generatePopAccessToken(response, request);
        const tokenType = request.tokenType === (0, $8994aeee5e01080d$exports).AuthenticationScheme.POP ? (0, $8994aeee5e01080d$exports).AuthenticationScheme.POP : (0, $8994aeee5e01080d$exports).AuthenticationScheme.BEARER;
        const result = {
            authority: authority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes.asArray(),
            account: accountInfo,
            idToken: response.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: responseAccessToken,
            fromCache: mats ? this.isResponseFromCache(mats) : false,
            // Request timestamp and NativeResponse expires_in are in seconds, converting to Date for AuthenticationResult
            expiresOn: (0, $e0616e53cd3f026f$exports).toDateFromSeconds(reqTimestamp + response.expires_in),
            tokenType: tokenType,
            correlationId: this.correlationId,
            state: response.state,
            fromPlatformBroker: true,
            ...request.resource && {
                resource: request.resource
            }
        };
        return result;
    }
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ async cacheAccount(accountEntity, kmsi) {
        // Store the account info and hence `nativeAccountId` in browser cache
        await this.browserStorage.setAccount(accountEntity, this.correlationId, kmsi, this.apiId);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext((0, $f136bee61a3373e4$exports).getAccountInfo(accountEntity), this.correlationId);
    }
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ async cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, tenantId, reqTimestamp, environment) {
        const cachedIdToken = (0, $4cd4d8a6d71d39a8$exports).createIdTokenEntity(homeAccountIdentifier, environment, response.id_token || "", request.clientId, idTokenClaims.tid || "");
        // cache accessToken in inmemory storage
        const expiresIn = request.tokenType === (0, $8994aeee5e01080d$exports).AuthenticationScheme.POP ? (0, $8994aeee5e01080d$exports).SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        const tokenExpirationSeconds = reqTimestamp + expiresIn;
        const responseScopes = this.generateScopes(response.scope, request.scope);
        const cachedAccessToken = (0, $4cd4d8a6d71d39a8$exports).createAccessTokenEntity(homeAccountIdentifier, environment, response.access_token, request.clientId, idTokenClaims.tid || tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, (0, $5949979cf1605326$export$c62426fdd000a97e), request.correlationId, undefined, request.tokenType, undefined, request.keyId);
        // save idtoken credential in configured browser storage
        if (!!cachedIdToken && request.storeInCache?.idToken !== false) await this.browserStorage.setIdTokenCredential(cachedIdToken, this.correlationId, (0, $4acd0486289e3b4f$exports).isKmsi(idTokenClaims));
        // save access token credential in memory storage
        const nativeCacheRecord = {
            accessToken: cachedAccessToken
        };
        return this.nativeStorageManager.saveCacheRecord(nativeCacheRecord, this.correlationId, (0, $4acd0486289e3b4f$exports).isKmsi(idTokenClaims), this.apiId, request.storeInCache);
    }
    getExpiresInValue(tokenType, expiresIn) {
        return tokenType === (0, $8994aeee5e01080d$exports).AuthenticationScheme.POP ? (0, $8994aeee5e01080d$exports).SHR_NONCE_VALIDITY : (typeof expiresIn === "string" ? parseInt(expiresIn, 10) : expiresIn) || 0;
    }
    addTelemetryFromNativeResponse(matsResponse) {
        const mats = this.getMATSFromResponse(matsResponse);
        if (!mats) return null;
        this.performanceClient.addFields({
            extensionId: this.platformAuthProvider.getExtensionId(),
            extensionVersion: this.platformAuthProvider.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    }
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ getMATSFromResponse(matsResponse) {
        if (matsResponse) try {
            return JSON.parse(matsResponse);
        } catch (e) {
            this.logger.error("0b3l57", this.correlationId);
        }
        return null;
    }
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ isResponseFromCache(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("1okqev", this.correlationId);
            return false;
        }
        return !!mats.is_cached;
    }
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ async initializePlatformRequest(request) {
        this.logger.trace("1xdm2a", this.correlationId);
        const canonicalAuthority = await this.getCanonicalAuthority(request);
        // ignore config claims if skipBrokerClaims is set to true and this is a brokered authentication flow
        const configClaims = request.skipBrokerClaims && !!request.embeddedClientId ? undefined : this.config.auth.clientCapabilities;
        // scopes are expected to be received by the native broker as "scope" and will be added to the request below. Other properties that should be dropped from the request to the native broker can be included in the object destructuring here.
        const { scopes: scopes, claims: claims, ...remainingProperties } = request;
        const scopeSet = new (0, $12ae8bb0ea11ce50$export$b9b82b0f94ae1f99)(scopes || [], this.correlationId);
        scopeSet.appendScopes((0, $8994aeee5e01080d$exports).OIDC_DEFAULT_SCOPES);
        const mergedClaims = (0, $25d69fa430040087$exports).buildMergedClaims(claims, configClaims?.length ? configClaims : undefined);
        const validatedRequest = {
            ...remainingProperties,
            claims: mergedClaims,
            accountId: this.accountId,
            clientId: this.config.auth.clientId,
            authority: canonicalAuthority.urlString,
            scope: scopeSet.printScopes(),
            redirectUri: (0, $956a2c583a756eea$export$e602b39e9004b45f)(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId),
            prompt: this.getPrompt(request.prompt),
            correlationId: this.correlationId,
            tokenType: request.authenticationScheme,
            windowTitleSubstring: document.title,
            extraParameters: {
                ...request.extraParameters
            },
            extendedExpiryToken: false,
            keyId: request.popKid
        };
        // Check for PoP token requests: signPopToken should only be set to true if popKid is not set
        if (validatedRequest.signPopToken && !!request.popKid) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$f6f43ae33ad04b91), this.correlationId);
        this.handleExtraBrokerParams(validatedRequest);
        validatedRequest.extraParameters = validatedRequest.extraParameters || {};
        validatedRequest.extraParameters.telemetry = (0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).MATS_TELEMETRY;
        if (request.authenticationScheme === (0, $8994aeee5e01080d$exports).AuthenticationScheme.POP) {
            // add POP request type
            const shrParameters = {
                resourceRequestUri: request.resourceRequestUri,
                resourceRequestMethod: request.resourceRequestMethod,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce,
                correlationId: this.correlationId
            };
            const popTokenGenerator = new (0, $7d2464f001dd27e8$export$3dd8467151c83e3e)(this.browserCrypto, this.performanceClient);
            // generate reqCnf if not provided in the request
            let reqCnfData;
            if (!validatedRequest.keyId) {
                const generatedReqCnfData = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $0d9eb83114fc9425$exports).PopTokenGenerateCnf, this.logger, this.performanceClient, this.correlationId)(shrParameters, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
                validatedRequest.keyId = generatedReqCnfData.kid;
                validatedRequest.signPopToken = true;
            } else {
                reqCnfData = this.browserCrypto.base64UrlEncode(JSON.stringify({
                    kid: validatedRequest.keyId
                }));
                validatedRequest.signPopToken = false;
            }
            // SPAs require whole string to be passed to broker
            validatedRequest.reqCnf = reqCnfData;
        }
        this.addRequestSKUs(validatedRequest);
        return validatedRequest;
    }
    async getCanonicalAuthority(request) {
        const requestAuthority = request.authority || this.config.auth.authority;
        const { azureCloudOptions: azureCloudOptions, account: account } = request;
        if (account) // validate authority
        await (0, $956a2c583a756eea$export$e36d1ed7c9435e3e)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, requestAuthority, azureCloudOptions, undefined, account);
        const canonicalAuthority = new (0, $9c756a14a1bed5db$export$3abcdca7229e54f2)(requestAuthority, this.correlationId);
        canonicalAuthority.validateAsUri();
        return canonicalAuthority;
    }
    getPrompt(prompt) {
        // If request is silent, prompt is always none
        switch(this.apiId){
            case (0, $7101cc4ee26a17a4$export$192d74ad69b40705).ssoSilent:
            case (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenSilent_silentFlow:
                this.logger.trace("12n1y2", this.correlationId);
                return (0, $8994aeee5e01080d$exports).PromptValue.NONE;
        }
        // Prompt not provided, request may proceed and native broker decides if it needs to prompt
        if (!prompt) {
            this.logger.trace("0uid1p", this.correlationId);
            return undefined;
        }
        // If request is interactive, check if prompt provided is allowed to go directly to native broker
        switch(prompt){
            case (0, $8994aeee5e01080d$exports).PromptValue.NONE:
            case (0, $8994aeee5e01080d$exports).PromptValue.CONSENT:
            case (0, $8994aeee5e01080d$exports).PromptValue.LOGIN:
                this.logger.trace("0i0hco", this.correlationId);
                return prompt;
            default:
                this.logger.trace(`0w3tpw ${prompt}`, this.correlationId);
                throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$62fdd8848aa75547), this.correlationId);
        }
    }
    /**
     * Handles extra broker request parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ handleExtraBrokerParams(request) {
        const hasExtraBrokerParams = request.extraParameters && request.extraParameters.hasOwnProperty((0, $46f4c10c7ac0692f$exports).BROKER_CLIENT_ID) && request.extraParameters.hasOwnProperty((0, $46f4c10c7ac0692f$exports).BROKER_REDIRECT_URI) && request.extraParameters.hasOwnProperty((0, $46f4c10c7ac0692f$exports).CLIENT_ID);
        if (!request.embeddedClientId && !hasExtraBrokerParams) return;
        let child_client_id = "";
        const child_redirect_uri = request.redirectUri;
        if (request.embeddedClientId) {
            request.redirectUri = this.config.auth.redirectUri;
            child_client_id = request.embeddedClientId;
        } else if (request.extraParameters) {
            request.redirectUri = request.extraParameters[(0, $46f4c10c7ac0692f$exports).BROKER_REDIRECT_URI];
            child_client_id = request.extraParameters[(0, $46f4c10c7ac0692f$exports).CLIENT_ID];
        }
        request.extraParameters = {
            child_client_id: child_client_id,
            child_redirect_uri: child_redirect_uri
        };
        this.performanceClient?.addFields({
            embeddedClientId: child_client_id,
            embeddedRedirectUri: child_redirect_uri
        }, this.correlationId);
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $aa09ca607db54806$var$clientDataAccountTypeMapping = new Map([
    [
        "e",
        "AAD"
    ],
    [
        "m",
        "MSA"
    ]
]);
/**
 * Parses the clientdata response parameter from the /authorize endpoint.
 *
 * Logically, the clientdata value is URL-encoded and pipe-delimited:
 *   urlencoded(account_type | error | sub_error | cloud_instance | caller_data_boundary)
 *
 * In normal browser flows, this value may already have been URL-decoded
 * (e.g. by URLSearchParams). This function will only apply decodeURIComponent
 * when the string appears to contain percent-encoded sequences to avoid
 * double-decoding.
 *
 * @param clientdata - The raw clientdata string from the authorize response
 * @returns Parsed ClientData object, or null if the input is empty/invalid
 */ function $aa09ca607db54806$export$a3b9de6fc1cadc0e(clientdata) {
    if (!clientdata) return null;
    try {
        // Only decode when the string appears to contain percent-encoded sequences
        const shouldDecode = /%(?:[0-9A-Fa-f]{2})/.test(clientdata);
        const decoded = shouldDecode ? decodeURIComponent(clientdata) : clientdata;
        const parts = decoded.split("|");
        if (parts.length < 5) return null;
        return {
            accountType: $aa09ca607db54806$var$clientDataAccountTypeMapping.get(parts[0]?.trim() || "") || "",
            error: parts[1]?.trim() || "",
            subError: parts[2]?.trim() || "",
            cloudInstance: parts[3]?.trim() || "",
            callerDataBoundary: parts[4]?.trim() || ""
        };
    } catch  {
        return null;
    }
}
/**
 * Instruments account type, error, and suberror from clientdata
 */ function $aa09ca607db54806$var$instrumentClientData(response, correlationId, performanceClient) {
    const parsed = $aa09ca607db54806$export$a3b9de6fc1cadc0e(response.clientdata);
    parsed?.accountType && performanceClient.addFields({
        accountType: parsed.accountType
    }, correlationId);
    parsed?.error && performanceClient.addFields({
        serverErrorNo: parsed.error
    }, correlationId);
    parsed?.subError && performanceClient.addFields({
        serverSubErrorNo: parsed.subError
    }, correlationId);
}
/**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $aa09ca607db54806$var$getStandardParameters(config, authority, request, logger, performanceClient) {
    const parameters = (0, $34778708f9a89dd9$exports).getStandardAuthorizeRequestParameters({
        ...config.auth,
        authority: authority
    }, request, logger, performanceClient);
    (0, $25d69fa430040087$exports).addLibraryInfo(parameters, {
        sku: (0, $7101cc4ee26a17a4$export$a0a689e4294b9880).MSAL_SKU,
        version: (0, $c8226bf52dd9a4ef$export$83d89fbfd8236492),
        os: "",
        cpu: ""
    });
    if (config.system.protocolMode !== (0, $631489f43a9fbed6$export$73a3e3dedd37150d).OIDC) (0, $25d69fa430040087$exports).addApplicationTelemetry(parameters, config.telemetry.application);
    if (request.platformBroker) {
        // signal ests that this is a WAM call
        (0, $25d69fa430040087$exports).addNativeBroker(parameters);
        // instrument JS-platform bridge specific fields
        performanceClient.addFields({
            isPlatformAuthorizeRequest: true
        }, request.correlationId);
        // pass the req_cnf for POP
        if (request.authenticationScheme === (0, $8994aeee5e01080d$exports).AuthenticationScheme.POP) {
            const cryptoOps = new (0, $6b1f88068f54d1dd$export$c274a7f0ebd24b14)(logger, performanceClient);
            const popTokenGenerator = new (0, $7d2464f001dd27e8$export$3dd8467151c83e3e)(cryptoOps, performanceClient);
            // req_cnf is always sent as a string for SPAs
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $0d9eb83114fc9425$exports).PopTokenGenerateCnf, logger, performanceClient, request.correlationId)(request, logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = cryptoOps.encodeKid(request.popKid);
            (0, $25d69fa430040087$exports).addPopToken(parameters, reqCnfData);
        }
    }
    (0, $25d69fa430040087$exports).instrumentBrokerParams(parameters, request.correlationId, performanceClient);
    return parameters;
}
/**
 * Gets the full /authorize URL with request parameters when using Auth Code + PKCE
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $aa09ca607db54806$export$a256231ce8625983(config, authority, request, logger, performanceClient) {
    if (!request.codeChallenge) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$exports).pkceParamsMissing, request.correlationId);
    const parameters = await (0, $69bce03cfd571284$export$e4feded94d9adb18)($aa09ca607db54806$var$getStandardParameters, (0, $acc47f0f594e8d22$export$183789ea9e54834a), logger, performanceClient, request.correlationId)(config, authority, request, logger, performanceClient);
    (0, $25d69fa430040087$exports).addResponseType(parameters, (0, $8994aeee5e01080d$exports).OAuthResponseType.CODE);
    (0, $25d69fa430040087$exports).addCodeChallengeParams(parameters, request.codeChallenge, (0, $8994aeee5e01080d$exports).S256_CODE_CHALLENGE_METHOD);
    // Merge extraQueryParameters and extraParameters to be appended to request URL
    (0, $25d69fa430040087$exports).addExtraParameters(parameters, {
        ...request.extraQueryParameters,
        ...request.extraParameters
    });
    return (0, $34778708f9a89dd9$exports).getAuthorizeUrl(authority, parameters);
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using EAR
 */ async function $aa09ca607db54806$export$3c140ef19fa8de34(frame, config, authority, request, logger, performanceClient) {
    if (!request.earJwk) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$2c031f99d3e081ff), request.correlationId);
    const parameters = await $aa09ca607db54806$var$getStandardParameters(config, authority, request, logger, performanceClient);
    (0, $25d69fa430040087$exports).addResponseType(parameters, (0, $8994aeee5e01080d$exports).OAuthResponseType.IDTOKEN_TOKEN_REFRESHTOKEN);
    (0, $25d69fa430040087$exports).addEARParameters(parameters, request.earJwk);
    // Also add codeChallenge as backup in case EAR is not supported
    (0, $25d69fa430040087$exports).addCodeChallengeParams(parameters, request.codeChallenge, (0, $8994aeee5e01080d$exports).S256_CODE_CHALLENGE_METHOD);
    (0, $25d69fa430040087$exports).addExtraParameters(parameters, {
        ...request.extraParameters
    });
    const queryParams = new Map();
    (0, $25d69fa430040087$exports).addExtraParameters(queryParams, request.extraQueryParameters || {});
    // Add correlationId to query params so gateway can propagate it to IDPs
    (0, $25d69fa430040087$exports).addCorrelationId(queryParams, request.correlationId);
    const url = (0, $34778708f9a89dd9$exports).getAuthorizeUrl(authority, queryParams);
    return $aa09ca607db54806$var$createForm(frame, url, parameters);
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using POST method
 */ async function $aa09ca607db54806$export$a76e1509233f1aec(frame, config, authority, request, logger, performanceClient) {
    const parameters = await $aa09ca607db54806$var$getStandardParameters(config, authority, request, logger, performanceClient);
    (0, $25d69fa430040087$exports).addResponseType(parameters, (0, $8994aeee5e01080d$exports).OAuthResponseType.CODE);
    (0, $25d69fa430040087$exports).addCodeChallengeParams(parameters, request.codeChallenge, request.codeChallengeMethod || (0, $8994aeee5e01080d$exports).S256_CODE_CHALLENGE_METHOD);
    // Add extraParameters to the request body
    (0, $25d69fa430040087$exports).addExtraParameters(parameters, {
        ...request.extraParameters
    });
    // Add extraQueryParameters to be appended to request URL
    const queryParams = new Map();
    (0, $25d69fa430040087$exports).addExtraParameters(queryParams, request.extraQueryParameters || {});
    // Add correlationId to query params so gateway can propagate it to IDPs
    (0, $25d69fa430040087$exports).addCorrelationId(queryParams, request.correlationId);
    const url = (0, $34778708f9a89dd9$exports).getAuthorizeUrl(authority, queryParams);
    return $aa09ca607db54806$var$createForm(frame, url, parameters);
}
/**
 * Creates form element in the provided document with auth parameters in the post body
 * @param frame
 * @param authorizeUrl
 * @param parameters
 * @returns
 */ function $aa09ca607db54806$var$createForm(frame, authorizeUrl, parameters) {
    const form = frame.createElement("form");
    form.method = "post";
    form.action = authorizeUrl;
    parameters.forEach((value, key)=>{
        const param = frame.createElement("input");
        param.hidden = true;
        param.name = key;
        param.value = value;
        form.appendChild(param);
    });
    frame.body.appendChild(form);
    return form;
}
/**
 * Response handler when server returns accountId on the /authorize request
 * @param request
 * @param accountId
 * @param apiId
 * @param config
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $aa09ca607db54806$export$51c4d8201b4a42eb(request, accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    logger.verbose("11qcow", request.correlationId);
    if (!platformAuthProvider) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$7b7357e3538624aa), request.correlationId);
    const browserCrypto = new (0, $6b1f88068f54d1dd$export$c274a7f0ebd24b14)(logger, performanceClient);
    const nativeInteractionClient = new (0, $9a0ce6cc67a0db6b$export$3f89612b3fd8831f)(config, browserStorage, browserCrypto, logger, eventHandler, config.system.navigationClient, apiId, performanceClient, platformAuthProvider, accountId, nativeStorage, request.correlationId);
    const { userRequestState: userRequestState } = (0, $de6be0b6a0939617$exports).parseRequestState(browserCrypto.base64Decode, request.state, request.correlationId);
    return (0, $69bce03cfd571284$export$e4feded94d9adb18)(nativeInteractionClient.acquireToken.bind(nativeInteractionClient), (0, $acc47f0f594e8d22$export$6939ff7b9b362e6d), logger, performanceClient, request.correlationId)({
        ...request,
        state: userRequestState,
        prompt: undefined
    });
}
/**
 * Response handler when server returns code on the /authorize request
 * @param request
 * @param response
 * @param codeVerifier
 * @param authClient
 * @param browserStorage
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $aa09ca607db54806$export$907304a743d3578a(request, response, codeVerifier, apiId, config, authClient, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    (0, $e230755462b27a9d$export$c060a619741dd765).removeThrottle(browserStorage, config.auth.clientId, request);
    // Instrument clientdata telemetry fields from the authorize response
    $aa09ca607db54806$var$instrumentClientData(response, request.correlationId, performanceClient);
    if (response.accountId) return (0, $69bce03cfd571284$export$e4feded94d9adb18)($aa09ca607db54806$export$51c4d8201b4a42eb, (0, $acc47f0f594e8d22$export$4ba148c2708dd557), logger, performanceClient, request.correlationId)(request, response.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const authCodeRequest = {
        ...request,
        code: response.code || "",
        codeVerifier: codeVerifier
    };
    // Create popup interaction handler.
    const interactionHandler = new (0, $d0174f0c495d01eb$export$a30cd982b4e89bdb)(authClient, browserStorage, authCodeRequest, logger, performanceClient);
    // Handle response from hash string.
    const result = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(interactionHandler.handleCodeResponse.bind(interactionHandler), (0, $acc47f0f594e8d22$export$4800d7aad979f214), logger, performanceClient, request.correlationId)(response, request, apiId);
    return result;
}
/**
 * Response handler when server returns ear_jwe on the /authorize request
 * @param request
 * @param response
 * @param apiId
 * @param config
 * @param authority
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $aa09ca607db54806$export$21aeb02dac823516(request, response, apiId, config, authority, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    (0, $e230755462b27a9d$export$c060a619741dd765).removeThrottle(browserStorage, config.auth.clientId, request);
    // Instrument clientdata telemetry fields from the authorize response
    $aa09ca607db54806$var$instrumentClientData(response, request.correlationId, performanceClient);
    // Validate state & check response for errors
    (0, $34778708f9a89dd9$exports).validateAuthorizationResponse(response, request.state, request.correlationId);
    if (!response.ear_jwe) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$b9f7c47ac4054f3d), request.correlationId);
    if (!request.earJwk) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$2c031f99d3e081ff), request.correlationId);
    const decryptedData = JSON.parse(await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $f0e13da7356d30ac$export$13b9c776ab498ef3), (0, $acc47f0f594e8d22$export$f57bcff988fe6ecb), logger, performanceClient, request.correlationId)(request.earJwk, response.ear_jwe));
    if (decryptedData.accountId) return (0, $69bce03cfd571284$export$e4feded94d9adb18)($aa09ca607db54806$export$51c4d8201b4a42eb, (0, $acc47f0f594e8d22$export$4ba148c2708dd557), logger, performanceClient, request.correlationId)(request, decryptedData.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const responseHandler = new (0, $ef22af12cad4e1b3$export$f456c9835cc63582)(config.auth.clientId, browserStorage, new (0, $6b1f88068f54d1dd$export$c274a7f0ebd24b14)(logger, performanceClient), logger, performanceClient, null, null);
    // Validate response. This function throws a server error if an error is returned by the server.
    responseHandler.validateTokenResponse(decryptedData, request.correlationId);
    // Temporary until response handler is refactored to be more flow agnostic.
    const additionalData = {
        code: "",
        state: request.state,
        nonce: request.nonce,
        client_info: decryptedData.client_info,
        cloud_graph_host_name: decryptedData.cloud_graph_host_name,
        cloud_instance_host_name: decryptedData.cloud_instance_host_name,
        cloud_instance_name: decryptedData.cloud_instance_name,
        msgraph_host: decryptedData.msgraph_host
    };
    return await (0, $69bce03cfd571284$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $0d9eb83114fc9425$exports).HandleServerTokenResponse, logger, performanceClient, request.correlationId)(decryptedData, authority, (0, $e0616e53cd3f026f$exports).nowSeconds(), request, apiId, additionalData, undefined, undefined, undefined, undefined);
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
const $d0efbde2aa549bff$var$RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * This file defines APIs to generate PKCE codes and code verifiers.
 */ /**
 * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
 */ async function $d0efbde2aa549bff$export$91d5e5a023803853(performanceClient, logger, correlationId) {
    const codeVerifier = (0, $69bce03cfd571284$export$468cda29b159ee5d)($d0efbde2aa549bff$var$generateCodeVerifier, (0, $acc47f0f594e8d22$export$924a2894e07f5df7), logger, performanceClient, correlationId)(performanceClient, logger, correlationId);
    const codeChallenge = await (0, $69bce03cfd571284$export$e4feded94d9adb18)($d0efbde2aa549bff$var$generateCodeChallengeFromVerifier, (0, $acc47f0f594e8d22$export$eb0aa8a1e44ee69e), logger, performanceClient, correlationId)(codeVerifier, performanceClient, logger, correlationId);
    return {
        verifier: codeVerifier,
        challenge: codeChallenge
    };
}
/**
 * Generates a random 32 byte buffer and returns the base64
 * encoded string to be used as a PKCE Code Verifier
 */ function $d0efbde2aa549bff$var$generateCodeVerifier(performanceClient, logger, correlationId) {
    try {
        // Generate random values as utf-8
        const buffer = new Uint8Array($d0efbde2aa549bff$var$RANDOM_BYTE_ARR_LENGTH);
        (0, $69bce03cfd571284$export$468cda29b159ee5d)((0, $f0e13da7356d30ac$export$960b9ff25e7d4257), (0, $acc47f0f594e8d22$export$932b19829e8c5c9c), logger, performanceClient, correlationId)(buffer);
        // encode verifier as base64
        const pkceCodeVerifierB64 = (0, $0349b3935d5ceef2$export$84f5a428c7153a69)(buffer);
        return pkceCodeVerifierB64;
    } catch (e) {
        throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$ee549107fa376fc1), correlationId);
    }
}
/**
 * Creates a base64 encoded PKCE Code Challenge string from the
 * hash created from the PKCE Code Verifier supplied
 */ async function $d0efbde2aa549bff$var$generateCodeChallengeFromVerifier(pkceCodeVerifier, performanceClient, logger, correlationId) {
    try {
        // hashed verifier
        const pkceHashedCodeVerifier = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $f0e13da7356d30ac$export$52caff7bddbaf316), (0, $acc47f0f594e8d22$export$1000bc604c253d18), logger, performanceClient, correlationId)(pkceCodeVerifier);
        // encode hash as base64
        return (0, $0349b3935d5ceef2$export$84f5a428c7153a69)(new Uint8Array(pkceHashedCodeVerifier));
    } catch (e) {
        throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$ee549107fa376fc1), correlationId);
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 

/*! @azure/msal-browser v5.16.0 2026-06-30 */ /*! @azure/msal-common v16.11.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $b79fc7ba4054046e$export$6d95060a8ed7155a = {
    // Module-level singleton: no per-request correlationId available
    sendGetRequestAsync: ()=>{
        return Promise.reject((0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), ""));
    },
    sendPostRequestAsync: ()=>{
        return Promise.reject((0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$24176fc1f15eea22), ""));
    }
};



/*! @azure/msal-browser v5.16.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $5dbbed21e942ce04$export$d0d362a73d466c9b {
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ navigateInternal(url, options) {
        return $5dbbed21e942ce04$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ navigateExternal(url, options) {
        return $5dbbed21e942ce04$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ static defaultNavigateWindow(url, options) {
        if (options.noHistory) window.location.replace(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        else window.location.assign(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$ce7eeda4eb1dd3c6), "", "failed_to_redirect"));
            }, options.timeout);
        });
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ class $43c1c8dd22874bcd$export$4c206ef5be879972 {
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ async sendGetRequestAsync(url, options) {
        let response;
        let responseHeaders = {};
        let responseStatus = 0;
        const reqHeaders = $43c1c8dd22874bcd$var$getFetchHeaders(options);
        try {
            response = await fetch(url, {
                method: (0, $7101cc4ee26a17a4$export$c774c31b4c31da8).GET,
                headers: reqHeaders
            });
        } catch (e) {
            throw (0, $bd3dc01dbb312431$export$262c4a35fb53be19)((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $8a281d620a4036a7$export$45e7eaaecd19d31e) : (0, $8a281d620a4036a7$export$31ae862f18c3b2b7), ""), undefined, undefined, e);
        }
        responseHeaders = $43c1c8dd22874bcd$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $bd3dc01dbb312431$export$262c4a35fb53be19)((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$96735047beea85a0), ""), responseStatus, responseHeaders, e);
        }
    }
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ async sendPostRequestAsync(url, options) {
        const reqBody = options && options.body || "";
        const reqHeaders = $43c1c8dd22874bcd$var$getFetchHeaders(options);
        let response;
        let responseStatus = 0;
        let responseHeaders = {};
        try {
            response = await fetch(url, {
                method: (0, $7101cc4ee26a17a4$export$c774c31b4c31da8).POST,
                headers: reqHeaders,
                body: reqBody
            });
        } catch (e) {
            throw (0, $bd3dc01dbb312431$export$262c4a35fb53be19)((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $8a281d620a4036a7$export$7a1e28a7b60ca602) : (0, $8a281d620a4036a7$export$31ae862f18c3b2b7), ""), undefined, undefined, e);
        }
        responseHeaders = $43c1c8dd22874bcd$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $bd3dc01dbb312431$export$262c4a35fb53be19)((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$96735047beea85a0), ""), responseStatus, responseHeaders, e);
        }
    }
}
/**
 * Get Fetch API Headers object from string map
 * @param inputHeaders
 */ function $43c1c8dd22874bcd$var$getFetchHeaders(options) {
    try {
        const headers = new Headers();
        if (!(options && options.headers)) return headers;
        const optionsHeaders = options.headers;
        Object.entries(optionsHeaders).forEach(([key, value])=>{
            headers.append(key, value);
        });
        return headers;
    } catch (e) {
        throw (0, $bd3dc01dbb312431$export$262c4a35fb53be19)((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$df9e6aae71bd84f), ""), undefined, undefined, e);
    }
}
/**
 * Returns object representing response headers
 * @param headers
 * @returns
 */ function $43c1c8dd22874bcd$var$getHeaderDict(headers) {
    try {
        const headerDict = {};
        headers.forEach((value, key)=>{
            headerDict[key] = value;
        });
        return headerDict;
    } catch (e) {
        throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$487fe7232a90003c), "");
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
const $6aa2fe410d14ea27$export$a5835ee54399d410 = 60000;
const $6aa2fe410d14ea27$export$f3ffe700be354b19 = 10000;
const $6aa2fe410d14ea27$export$293647e7865520c6 = 30000;
const $6aa2fe410d14ea27$export$73d1d87a8b7ddb57 = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function $6aa2fe410d14ea27$export$f8352245bee68086({ auth: userInputAuth, cache: userInputCache, system: userInputSystem, experimental: userInputExperimental, telemetry: userInputTelemetry }, isBrowserEnvironment) {
    // Default auth options for browser
    const DEFAULT_AUTH_OPTIONS = {
        clientId: "",
        authority: `${(0, $8994aeee5e01080d$exports).DEFAULT_AUTHORITY}`,
        knownAuthorities: [],
        cloudDiscoveryMetadata: "",
        authorityMetadata: "",
        redirectUri: typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "",
        postLogoutRedirectUri: "",
        clientCapabilities: [],
        OIDCOptions: {
            responseMode: (0, $8994aeee5e01080d$exports).ResponseMode.FRAGMENT,
            defaultScopes: [
                (0, $8994aeee5e01080d$exports).OPENID_SCOPE,
                (0, $8994aeee5e01080d$exports).PROFILE_SCOPE,
                (0, $8994aeee5e01080d$exports).OFFLINE_ACCESS_SCOPE
            ]
        },
        azureCloudOptions: {
            azureCloudInstance: (0, $1fba6bdc8b3011e3$export$4cda21933050d9ec).None,
            tenant: ""
        },
        instanceAware: false,
        isMcp: false,
        verifySSO: false
    };
    // Default cache options for browser
    const DEFAULT_CACHE_OPTIONS = {
        cacheLocation: (0, $7101cc4ee26a17a4$export$573384e47a12d835).SessionStorage,
        cacheRetentionDays: 5
    };
    // Default logger options for browser
    const DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: ()=>{
        // allow users to not set logger call back
        },
        logLevel: (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    const DEFAULT_BROWSER_SYSTEM_OPTIONS = {
        ...(0, $8e787aed99ab54c6$export$f7a7dd6bfc156d75),
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? new (0, $43c1c8dd22874bcd$export$4c206ef5be879972)() : (0, $b79fc7ba4054046e$export$6d95060a8ed7155a),
        navigationClient: new (0, $5dbbed21e942ce04$export$d0d362a73d466c9b)(),
        popupBridgeTimeout: userInputSystem?.popupBridgeTimeout || $6aa2fe410d14ea27$export$a5835ee54399d410,
        iframeBridgeTimeout: userInputSystem?.iframeBridgeTimeout || $6aa2fe410d14ea27$export$f3ffe700be354b19,
        redirectNavigationTimeout: $6aa2fe410d14ea27$export$293647e7865520c6,
        allowRedirectInIframe: false,
        navigatePopups: true,
        allowPlatformBroker: false,
        nativeBrokerHandshakeTimeout: userInputSystem?.nativeBrokerHandshakeTimeout || $6aa2fe410d14ea27$export$73d1d87a8b7ddb57,
        protocolMode: (0, $631489f43a9fbed6$export$73a3e3dedd37150d).AAD,
        serverTelemetryEnabled: false
    };
    const providedSystemOptions = {
        ...DEFAULT_BROWSER_SYSTEM_OPTIONS,
        ...userInputSystem,
        loggerOptions: userInputSystem?.loggerOptions || DEFAULT_LOGGER_OPTIONS
    };
    const DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: "",
            appVersion: ""
        },
        client: new (0, $d7391fb9e8152ad3$export$c70f2989a65fda3e)()
    };
    const DEFAULT_EXPERIMENTAL_OPTIONS = {
        iframeTimeoutTelemetry: false,
        allowPlatformBrokerWithDOM: false
    };
    // Throw an error if user has set OIDCOptions without being in OIDC protocol mode
    if (userInputSystem?.protocolMode !== (0, $631489f43a9fbed6$export$73a3e3dedd37150d).OIDC && userInputAuth?.OIDCOptions) {
        const logger = new (0, $0fd93c953107c2f4$export$efa9a398d6368992)(providedSystemOptions.loggerOptions, (0, $c8226bf52dd9a4ef$export$a8ff84c12d48cfa6), (0, $c8226bf52dd9a4ef$export$83d89fbfd8236492));
        logger.warning(JSON.stringify((0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$exports).cannotSetOIDCOptions, "")), "");
    }
    // Throw an error if user has set allowPlatformBroker to true with OIDC protocol mode
    if (userInputSystem?.protocolMode && userInputSystem.protocolMode === (0, $631489f43a9fbed6$export$73a3e3dedd37150d).OIDC && providedSystemOptions?.allowPlatformBroker) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$exports).cannotAllowPlatformBroker, "");
    const overlayedConfig = {
        auth: {
            ...DEFAULT_AUTH_OPTIONS,
            ...userInputAuth,
            OIDCOptions: {
                ...DEFAULT_AUTH_OPTIONS.OIDCOptions,
                ...userInputAuth?.OIDCOptions
            }
        },
        cache: {
            ...DEFAULT_CACHE_OPTIONS,
            ...userInputCache
        },
        system: providedSystemOptions,
        experimental: {
            ...DEFAULT_EXPERIMENTAL_OPTIONS,
            ...userInputExperimental
        },
        telemetry: {
            ...DEFAULT_TELEMETRY_OPTIONS,
            ...userInputTelemetry
        }
    };
    return overlayedConfig;
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
var $0159cd24dd549a61$exports = {};

$parcel$export($0159cd24dd549a61$exports, "unexpectedError", () => $0159cd24dd549a61$export$efbc88c27b0be04);
$parcel$export($0159cd24dd549a61$exports, "postRequestFailed", () => $0159cd24dd549a61$export$7a1e28a7b60ca602);
/*! @azure/msal-common v16.11.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ const $0159cd24dd549a61$export$efbc88c27b0be04 = "unexpected_error";
const $0159cd24dd549a61$export$7a1e28a7b60ca602 = "post_request_failed";








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $8ee799594ccc5014$export$de4c158ddf8b89f6 {
    constructor(logger, handshakeTimeoutMs, performanceClient, extensionId){
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = this.performanceClient.startMeasurement((0, $acc47f0f594e8d22$export$12043b01baba5136));
        this.platformAuthType = (0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).PLATFORM_EXTENSION_PROVIDER;
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param request
     */ async sendMessage(request) {
        this.logger.trace(`0on4p2 ${this.platformAuthType}`, request.correlationId);
        // fall back to native calls
        const messageBody = {
            method: (0, $7101cc4ee26a17a4$export$3536098be6c7dadb).GetToken,
            request: request
        };
        const req = {
            channel: (0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)(),
            body: messageBody
        };
        this.logger.trace(`1qadfi ${this.platformAuthType}`, request.correlationId);
        this.logger.tracePii(`1xm533 ${this.platformAuthType} ${JSON.stringify(req)}`, request.correlationId);
        this.messageChannel.port1.postMessage(req);
        const response = await new Promise((resolve, reject)=>{
            this.resolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
        });
        const validatedResponse = this.validatePlatformBrokerResponse(response);
        return validatedResponse;
    }
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     * @param {ICrypto} crypto
     */ static async createProvider(logger, handshakeTimeoutMs, performanceClient, correlationId) {
        logger.trace("15zfnw", correlationId);
        try {
            const preferredProvider = new $8ee799594ccc5014$export$de4c158ddf8b89f6(logger, handshakeTimeoutMs, performanceClient, (0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).PREFERRED_EXTENSION_ID);
            await preferredProvider.sendHandshakeRequest(correlationId);
            return preferredProvider;
        } catch (e) {
            // If preferred extension fails for whatever reason, fallback to using any installed extension
            const backupProvider = new $8ee799594ccc5014$export$de4c158ddf8b89f6(logger, handshakeTimeoutMs, performanceClient);
            await backupProvider.sendHandshakeRequest(correlationId);
            return backupProvider;
        }
    }
    /**
     * Send handshake request helper.
     */ async sendHandshakeRequest(correlationId) {
        this.logger.trace(`1dpg9o ${this.platformAuthType}`, correlationId);
        // Register this event listener before sending handshake
        window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
        const req = {
            channel: (0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)(),
            body: {
                method: (0, $7101cc4ee26a17a4$export$3536098be6c7dadb).HandshakeRequest
            }
        };
        this.handshakeEvent.add({
            extensionId: this.extensionId,
            extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
        });
        this.messageChannel.port1.onmessage = (event)=>{
            this.onChannelMessage(event);
        };
        window.postMessage(req, window.origin, [
            this.messageChannel.port2
        ]);
        return new Promise((resolve, reject)=>{
            this.handshakeResolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
            this.timeoutId = window.setTimeout(()=>{
                /*
                 * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                 * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                 */ window.removeEventListener("message", this.windowListener, false);
                this.messageChannel.port1.close();
                this.messageChannel.port2.close();
                this.handshakeEvent.end({
                    extensionHandshakeTimedOut: true,
                    success: false
                });
                reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$4747c302ef0117fd), ""));
                this.handshakeResolvers.delete(req.responseId);
            }, this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
        });
    }
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ onWindowMessage(event) {
        const correlationId = (0, $8e677587a7c978db$export$7571c350ed9fec74)();
        this.logger.trace(`0jpn5u ${this.platformAuthType}`, correlationId);
        // We only accept messages from ourselves
        if (event.source !== window) return;
        const request = event.data;
        if (!request.channel || request.channel !== (0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === (0, $7101cc4ee26a17a4$export$3536098be6c7dadb).HandshakeRequest) {
            const handshakeResolver = this.handshakeResolvers.get(request.responseId);
            /*
             * Filter out responses with no matched resolvers sooner to keep channel ports open while waiting for
             * the proper response.
             */ if (!handshakeResolver) {
                this.logger.trace(`07buhm ${this.platformAuthType} ${request.responseId}`, correlationId);
                return;
            }
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? `0xrkug ${request.extensionId}` : "No extension installed", correlationId);
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            this.handshakeEvent.end({
                success: false,
                extensionInstalled: false
            });
            handshakeResolver.reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$59080ea2398ee306), ""));
        }
    }
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ onChannelMessage(event) {
        const correlationId = (0, $8e677587a7c978db$export$7571c350ed9fec74)();
        this.logger.trace(`1py8yf ${this.platformAuthType}`, correlationId);
        const request = event.data;
        const resolver = this.resolvers.get(request.responseId);
        const handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            const method = request.body.method;
            if (method === (0, $7101cc4ee26a17a4$export$3536098be6c7dadb).Response) {
                if (!resolver) return;
                const response = request.body.response;
                this.logger.trace(`19hpgm ${this.platformAuthType}`, correlationId);
                this.logger.tracePii(`179a24 ${this.platformAuthType} ${JSON.stringify(response)}`, correlationId);
                if (response.status !== "Success") resolver.reject((0, $8cc7862cecd95c0a$export$9154414ec87d187b)(response.code, correlationId, response.description, response.ext));
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) resolver.reject((0, $8cc7862cecd95c0a$export$9154414ec87d187b)(response.result["code"], correlationId, response.result["description"], response.result["ext"]));
                    else resolver.resolve(response.result);
                } else throw (0, $8d1fc9917b2c0dac$export$eb157f7636c79bd2)((0, $0159cd24dd549a61$exports).unexpectedError, correlationId, "Event does not contain result.");
                this.resolvers.delete(request.responseId);
            } else if (method === (0, $7101cc4ee26a17a4$export$3536098be6c7dadb).HandshakeResponse) {
                if (!handshakeResolver) {
                    this.logger.trace(`082qnt ${this.platformAuthType} ${request.responseId}`, correlationId);
                    return;
                }
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose(`0yf5ib ${this.platformAuthType} ${this.extensionId}`, correlationId);
                this.handshakeEvent.end({
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
        // Do nothing if method is not Response or HandshakeResponse
        } catch (err) {
            this.logger.error("0xf978", correlationId);
            this.logger.errorPii(`04i99o ${err}`, correlationId);
            this.logger.errorPii(`0xdvsy ${event}`, correlationId);
            if (resolver) resolver.reject(err);
            else if (handshakeResolver) handshakeResolver.reject(err);
        }
    }
    /**
     * Validates native platform response before processing
     * @param response
     */ validatePlatformBrokerResponse(response) {
        if (response.hasOwnProperty("access_token") && response.hasOwnProperty("id_token") && response.hasOwnProperty("client_info") && response.hasOwnProperty("account") && response.hasOwnProperty("scope") && response.hasOwnProperty("expires_in")) return response;
        else throw (0, $8d1fc9917b2c0dac$export$eb157f7636c79bd2)((0, $0159cd24dd549a61$exports).unexpectedError, "", "Response missing expected properties.");
    }
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return this.extensionId;
    }
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ getExtensionVersion() {
        return this.extensionVersion;
    }
    getExtensionName() {
        return this.getExtensionId() === (0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).PREFERRED_EXTENSION_ID ? "chrome" : this.getExtensionId()?.length ? "unknown" : undefined;
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $c915b264ea145955$export$aa8591dfbb8a4c65 {
    constructor(logger, performanceClient, correlationId){
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.platformAuthType = (0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).PLATFORM_DOM_PROVIDER;
    }
    static async createProvider(logger, performanceClient, correlationId) {
        logger.trace("12mj4a", correlationId);
        // @ts-ignore
        if (window.navigator?.platformAuthentication) {
            const supportedContracts = // @ts-ignore
            await window.navigator.platformAuthentication.getSupportedContracts((0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).MICROSOFT_ENTRA_BROKERID);
            if (supportedContracts?.includes((0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).PLATFORM_DOM_APIS)) {
                logger.trace("1h5q1r", correlationId);
                return new $c915b264ea145955$export$aa8591dfbb8a4c65(logger, performanceClient, correlationId);
            }
        }
        return undefined;
    }
    /**
     * Returns the Id for the broker extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return (0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).MICROSOFT_ENTRA_BROKERID;
    }
    getExtensionVersion() {
        return "";
    }
    getExtensionName() {
        return (0, $7101cc4ee26a17a4$export$3ebdf53424883b5f).DOM_API_NAME;
    }
    /**
     * Send token request to platform broker via browser DOM API
     * @param request
     * @returns
     */ async sendMessage(request) {
        this.logger.trace(`02bcil ${this.platformAuthType}`, request.correlationId);
        try {
            const platformDOMRequest = this.initializePlatformDOMRequest(request);
            const response = // @ts-ignore
            await window.navigator.platformAuthentication.executeGetToken(platformDOMRequest);
            return this.validatePlatformBrokerResponse(response, request.correlationId);
        } catch (e) {
            this.logger.error(`11im7g ${this.platformAuthType}`, request.correlationId);
            throw e;
        }
    }
    initializePlatformDOMRequest(request) {
        this.logger.trace(`15d6yv ${this.platformAuthType}`, request.correlationId);
        const { accountId: accountId, clientId: clientId, authority: authority, scope: scope, redirectUri: redirectUri, correlationId: correlationId, state: state, storeInCache: storeInCache, embeddedClientId: embeddedClientId, extraParameters: extraParameters, ...remainingProperties } = request;
        const validExtraParameters = this.getDOMExtraParams(remainingProperties, correlationId);
        const platformDOMRequest = {
            accountId: accountId,
            brokerId: this.getExtensionId(),
            authority: authority,
            clientId: clientId,
            correlationId: correlationId || this.correlationId,
            extraParameters: {
                ...extraParameters,
                ...validExtraParameters
            },
            isSecurityTokenService: false,
            redirectUri: redirectUri,
            scope: scope,
            state: state,
            storeInCache: storeInCache,
            embeddedClientId: embeddedClientId
        };
        return platformDOMRequest;
    }
    validatePlatformBrokerResponse(response, correlationId) {
        if (response.hasOwnProperty("isSuccess")) {
            if (response.hasOwnProperty("accessToken") && response.hasOwnProperty("idToken") && response.hasOwnProperty("clientInfo") && response.hasOwnProperty("account") && response.hasOwnProperty("scopes") && response.hasOwnProperty("expiresIn")) {
                this.logger.trace(`0h4vei ${this.platformAuthType}`, correlationId);
                return this.convertToPlatformBrokerResponse(response, correlationId);
            } else if (response.hasOwnProperty("error")) {
                const errorResponse = response;
                if (errorResponse.isSuccess === false && errorResponse.error && errorResponse.error.code) {
                    this.logger.trace(`0g92vm ${this.platformAuthType}`, correlationId);
                    throw (0, $8cc7862cecd95c0a$export$9154414ec87d187b)(errorResponse.error.code, correlationId, errorResponse.error.description, {
                        error: parseInt(errorResponse.error.errorCode),
                        protocol_error: errorResponse.error.protocolError,
                        status: errorResponse.error.status,
                        properties: errorResponse.error.properties
                    });
                }
            }
        }
        throw (0, $8d1fc9917b2c0dac$export$eb157f7636c79bd2)((0, $0159cd24dd549a61$exports).unexpectedError, correlationId, "Response missing expected properties.");
    }
    convertToPlatformBrokerResponse(response, correlationId) {
        this.logger.trace(`14913t ${this.platformAuthType}`, correlationId);
        const nativeResponse = {
            access_token: response.accessToken,
            id_token: response.idToken,
            client_info: response.clientInfo,
            account: response.account,
            expires_in: response.expiresIn,
            scope: response.scopes,
            state: response.state || "",
            properties: response.properties || {},
            extendedLifetimeToken: response.extendedLifetimeToken ?? false,
            shr: response.proofOfPossessionPayload
        };
        return nativeResponse;
    }
    getDOMExtraParams(extraParameters, correlationId) {
        try {
            const stringifiedProperties = {};
            for (const [key, value] of Object.entries(extraParameters)){
                if (!value) continue;
                if (typeof value === "object") stringifiedProperties[key] = JSON.stringify(value);
                else stringifiedProperties[key] = String(value);
            }
            return stringifiedProperties;
        } catch (e) {
            this.logger.error(`0eu9o3 ${this.platformAuthType}`, correlationId);
            this.logger.errorPii(`17rpl5 ${this.platformAuthType} ${e}`, correlationId);
            return {};
        }
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Checks if the platform broker is available in the current environment.
 * @param domConfig - Whether to enable platform broker DOM API support (required)
 * @param loggerOptions - Optional logger options
 * @param perfClient - Optional performance client
 * @param correlationId - Optional correlation ID
 * @returns Promise<boolean> indicating if platform broker is available
 */ async function $0f1c35249bd71733$export$bce61db0d62ff8e2(domConfig, loggerOptions, perfClient, correlationId) {
    const logger = new (0, $0fd93c953107c2f4$export$efa9a398d6368992)(loggerOptions || {}, (0, $c8226bf52dd9a4ef$export$a8ff84c12d48cfa6), (0, $c8226bf52dd9a4ef$export$83d89fbfd8236492));
    const performanceClient = perfClient || new (0, $d7391fb9e8152ad3$export$c70f2989a65fda3e)();
    if (typeof window === "undefined") {
        logger.trace("082ed3", correlationId || (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)());
        return false;
    }
    return !!await $0f1c35249bd71733$export$b2c9df3607dc771a(logger, performanceClient, correlationId || (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)(), undefined, domConfig);
}
async function $0f1c35249bd71733$export$b2c9df3607dc771a(logger, performanceClient, correlationId, nativeBrokerHandshakeTimeout, enablePlatformBrokerDOMSupport) {
    logger.trace("134j0v", correlationId);
    logger.trace(`04c81g ${enablePlatformBrokerDOMSupport}`, correlationId);
    let platformAuthProvider;
    try {
        if (enablePlatformBrokerDOMSupport) // Check if DOM platform API is supported first
        platformAuthProvider = await (0, $c915b264ea145955$export$aa8591dfbb8a4c65).createProvider(logger, performanceClient, correlationId);
        if (!platformAuthProvider) {
            logger.trace("0l3na8", correlationId);
            /*
             * If DOM APIs are not available, check if browser extension is available.
             * Platform authentication via DOM APIs is preferred over extension APIs.
             */ platformAuthProvider = await (0, $8ee799594ccc5014$export$de4c158ddf8b89f6).createProvider(logger, nativeBrokerHandshakeTimeout || (0, $6aa2fe410d14ea27$export$73d1d87a8b7ddb57), performanceClient, correlationId);
        }
    } catch (e) {
        logger.trace("0icbd7", e);
    }
    return platformAuthProvider;
}
/**
 * Returns boolean indicating whether or not the request should attempt to use platform broker
 * @param logger
 * @param config
 * @param correlationId
 * @param platformAuthProvider
 * @param authenticationScheme
 */ function $0f1c35249bd71733$export$4815cc9f88d4f6a5(config, logger, correlationId, platformAuthProvider, authenticationScheme) {
    logger.trace("0uko3r", correlationId);
    // throw an error if allowPlatformBroker is not enabled and allowPlatformBrokerWithDOM is enabled
    if (!config.system.allowPlatformBroker && config.experimental.allowPlatformBrokerWithDOM) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$exports).invalidPlatformBrokerConfiguration, "");
    if (!config.system.allowPlatformBroker) {
        logger.trace("04hozs", correlationId);
        // Developer disabled WAM
        return false;
    }
    if (!platformAuthProvider) {
        logger.trace("0kvv1r", correlationId);
        // Platform broker auth providers are not available
        return false;
    }
    if (authenticationScheme) switch(authenticationScheme){
        case (0, $8994aeee5e01080d$exports).AuthenticationScheme.BEARER:
        case (0, $8994aeee5e01080d$exports).AuthenticationScheme.POP:
            logger.trace("18tev1", correlationId);
            return true;
        default:
            logger.trace("1dd2nh", correlationId);
            return false;
    }
    return true;
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $698b575715aaca34$export$43b0fce132d066f4 extends (0, $b86c5719a99dca61$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, correlationId, platformAuthHandler, waitForPopupResponseHook){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthHandler);
        this.nativeStorage = nativeStorageImpl;
        this.eventHandler = eventHandler;
        this.waitForPopupResponseHook = waitForPopupResponseHook;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     * @param pkceCodes
     */ acquireToken(request, pkceCodes) {
        let popupParams = undefined;
        try {
            const popupName = this.generatePopupName(request.scopes || (0, $8994aeee5e01080d$exports).OIDC_DEFAULT_SCOPES, request.authority || this.config.auth.authority);
            popupParams = {
                popupName: popupName,
                popupWindowAttributes: request.popupWindowAttributes || {},
                popupWindowParent: request.popupWindowParent ?? window
            };
            this.performanceClient.addFields({
                isAsyncPopup: !this.config.system.navigatePopups
            }, this.correlationId);
            // navigatePopups flag is false. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (!this.config.system.navigatePopups) {
                this.logger.verbose("162h4u", this.correlationId);
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupParams, pkceCodes);
            } else {
                // navigatePopups flag is set to true. Opens popup before acquiring token.
                // Pre-validate request method to avoid opening popup if the request is invalid
                const validatedRequest = {
                    ...request,
                    httpMethod: (0, $e54e4b4a24079223$export$253b550f4555e4bf)(request, this.config.system.protocolMode)
                };
                this.logger.verbose("1f9ok3", this.correlationId);
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.acquireTokenPopupAsync(validatedRequest, popupParams, pkceCodes);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logout(logoutRequest) {
        try {
            this.logger.verbose("068rup", this.correlationId);
            const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            const popupParams = {
                popupName: this.generateLogoutPopupName(validLogoutRequest),
                popupWindowAttributes: logoutRequest?.popupWindowAttributes || {},
                popupWindowParent: logoutRequest?.popupWindowParent ?? window
            };
            const authority = logoutRequest && logoutRequest.authority;
            const mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            // navigatePopups flag set to false. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (!this.config.system.navigatePopups) {
                this.logger.verbose("1phd8u", this.correlationId);
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            } else {
                // navigatePopups flag is set to true. Opens popup before logging out.
                this.logger.verbose("1a28da", this.correlationId);
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param request
     * @param popupParams
     * @param pkceCodes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopupAsync(request, popupParams, pkceCodes) {
        this.logger.verbose("1g77pg", this.correlationId);
        const validRequest = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $b86c5719a99dca61$export$33189c9f1d196fb4), (0, $acc47f0f594e8d22$export$ee6f0d99b40b747e), this.logger, this.performanceClient, this.correlationId)(request, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        /*
         * Skip pre-connect for async popups to reduce time between user interaction and popup window creation to avoid
         * popup from being blocked by browsers with shorter popup timers
         */ if (popupParams.popup) (0, $8e677587a7c978db$export$a0816fa17a9e79be)(validRequest.authority);
        const isPlatformBroker = (0, $0f1c35249bd71733$export$4815cc9f88d4f6a5)(this.config, this.logger, this.correlationId, this.platformAuthProvider, request.authenticationScheme);
        validRequest.platformBroker = isPlatformBroker;
        if (this.config.system.protocolMode === (0, $631489f43a9fbed6$export$73a3e3dedd37150d).EAR) return this.executeEarFlow(validRequest, popupParams, pkceCodes);
        else return this.executeCodeFlow(validRequest, popupParams, pkceCodes);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @param popupParams
     * @param pkceCodes
     * @returns
     */ async executeCodeFlow(request, popupParams, pkceCodes) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)((0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const pkce = pkceCodes || await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $d0efbde2aa549bff$export$91d5e5a023803853), (0, $acc47f0f594e8d22$export$5a7b24ab3b501c09), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const popupRequest = {
            ...request,
            codeChallenge: pkce.challenge
        };
        try {
            // Initialize the client
            const authClient = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $acc47f0f594e8d22$export$2778b133ce149dc6), this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: popupRequest.authority,
                requestAzureCloudOptions: popupRequest.azureCloudOptions,
                requestExtraQueryParameters: popupRequest.extraQueryParameters,
                account: popupRequest.account
            });
            if (popupRequest.httpMethod === (0, $8994aeee5e01080d$exports).HttpMethod.POST) return await this.executeCodeFlowWithPost(popupRequest, popupParams, authClient, pkce.verifier);
            else {
                // Create acquire token url.
                const navigateUrl = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$a256231ce8625983), (0, $0d9eb83114fc9425$exports).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, popupRequest, this.logger, this.performanceClient);
                // Show the UI once the url has been created. Get the window handle for the popup.
                const popupWindow = this.initiateAuthRequest(navigateUrl, popupParams);
                this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).POPUP_OPENED, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, {
                    popupWindow: popupWindow
                }, null);
                // Wait for the redirect bridge response
                const responseString = await this.waitForPopupResponse(request, popupWindow, popupParams.popupWindowParent);
                const serverParams = (0, $69bce03cfd571284$export$468cda29b159ee5d)((0, $e54e6f1425de2c43$export$e64c1808ed72a7c), (0, $acc47f0f594e8d22$export$bd4551c9ff45ab85), this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
                return await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$907304a743d3578a), (0, $acc47f0f594e8d22$export$e5c1dfbe90037ee5), this.logger, this.performanceClient, correlationId)(request, serverParams, pkce.verifier, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
            }
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request, popupParams, pkceCodes) {
        const { correlationId: correlationId, authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $956a2c583a756eea$export$e36d1ed7c9435e3e), (0, $acc47f0f594e8d22$export$dad6c3127c773e76), this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $f0e13da7356d30ac$export$95528b8a314880d1), (0, $acc47f0f594e8d22$export$8f99489bc43f886e), this.logger, this.performanceClient, correlationId)();
        const pkce = pkceCodes || await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $d0efbde2aa549bff$export$91d5e5a023803853), (0, $acc47f0f594e8d22$export$5a7b24ab3b501c09), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const popupRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkce.challenge
        };
        const popupWindow = popupParams.popup || this.openPopup("about:blank", popupParams);
        const form = await (0, $aa09ca607db54806$export$3c140ef19fa8de34)(popupWindow.document, this.config, discoveredAuthority, popupRequest, this.logger, this.performanceClient);
        form.submit();
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.waitForPopupResponse.bind(this), (0, $acc47f0f594e8d22$export$a4bfaadf3c5aed38), this.logger, this.performanceClient, correlationId)(popupRequest, popupWindow, popupParams.popupWindowParent);
        const serverParams = (0, $69bce03cfd571284$export$468cda29b159ee5d)((0, $e54e6f1425de2c43$export$e64c1808ed72a7c), (0, $acc47f0f594e8d22$export$bd4551c9ff45ab85), this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
        if (!serverParams.ear_jwe && serverParams.code) {
            const authClient = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $acc47f0f594e8d22$export$2778b133ce149dc6), this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: (0, $956a2c583a756eea$export$c0fa8985fac40b0c)((0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenPopup, this.config.auth.clientId, correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$907304a743d3578a), (0, $acc47f0f594e8d22$export$e5c1dfbe90037ee5), this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, pkce.verifier, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$21aeb02dac823516), (0, $acc47f0f594e8d22$export$680f3c7b33b3fdfd), this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenPopup, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    async executeCodeFlowWithPost(request, popupParams, authClient, pkceVerifier) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $956a2c583a756eea$export$e36d1ed7c9435e3e), (0, $acc47f0f594e8d22$export$dad6c3127c773e76), this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger);
        const popupWindow = popupParams.popup || this.openPopup("about:blank", popupParams);
        const form = await (0, $aa09ca607db54806$export$a76e1509233f1aec)(popupWindow.document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.waitForPopupResponse.bind(this), (0, $acc47f0f594e8d22$export$a4bfaadf3c5aed38), this.logger, this.performanceClient, correlationId)(request, popupWindow, popupParams.popupWindowParent);
        const serverParams = (0, $69bce03cfd571284$export$468cda29b159ee5d)((0, $e54e6f1425de2c43$export$e64c1808ed72a7c), (0, $acc47f0f594e8d22$export$bd4551c9ff45ab85), this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$907304a743d3578a), (0, $acc47f0f594e8d22$export$e5c1dfbe90037ee5), this.logger, this.performanceClient, correlationId)(request, serverParams, pkceVerifier, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ async logoutPopupAsync(validRequest, popupParams, requestAuthority, mainWindowRedirectUri) {
        this.logger.verbose("0b7yrk", this.correlationId);
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_START, this.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, validRequest);
        const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)((0, $7101cc4ee26a17a4$export$192d74ad69b40705).logoutPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // Clear cache on logout
            await (0, $956a2c583a756eea$export$bcfc3ed6114b66f4)(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validRequest.account);
            // Initialize the client
            const authClient = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $acc47f0f594e8d22$export$2778b133ce149dc6), this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: requestAuthority,
                account: validRequest.account || undefined
            });
            try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validRequest.account?.homeAccountId && validRequest.postLogoutRedirectUri && authClient.authority.protocolMode === (0, $631489f43a9fbed6$export$73a3e3dedd37150d).OIDC) {
                    this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_SUCCESS, validRequest.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, validRequest);
                    if (mainWindowRedirectUri) {
                        const navigationOptions = {
                            apiId: (0, $7101cc4ee26a17a4$export$192d74ad69b40705).logoutPopup,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        const absoluteUrl = (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $8e677587a7c978db$export$1204531fbbf6ecde)(), this.correlationId);
                        await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                    }
                    popupParams.popup?.close();
                    return;
                }
            }
            // Redirect bridge requires "state" param to work properly
            validRequest.state = (0, $de6be0b6a0939617$exports).setRequestState(this.browserCrypto, validRequest.state || "", {
                interactionType: (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup
            }, validRequest.correlationId);
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validRequest);
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_SUCCESS, validRequest.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, validRequest);
            // Open the popup window to requestUrl.
            const popupWindow = this.openPopup(logoutUri, popupParams);
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).POPUP_OPENED, validRequest.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, {
                popupWindow: popupWindow
            }, null);
            await this.waitForPopupResponse(validRequest, popupWindow, popupParams.popupWindowParent).catch(()=>{
            // Swallow any errors related to monitoring the window. Server logout is best effort
            });
            if (mainWindowRedirectUri) {
                const navigationOptions = {
                    apiId: (0, $7101cc4ee26a17a4$export$192d74ad69b40705).logoutPopup,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: false
                };
                const absoluteUrl = (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $8e677587a7c978db$export$1204531fbbf6ecde)(), this.correlationId);
                this.logger.verbose("0qcur2", this.correlationId);
                this.logger.verbosePii(`0oj7lk ${absoluteUrl}`, this.correlationId);
                await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
            } else this.logger.verbose("03zgcf", this.correlationId);
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_FAILURE, this.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, null, e);
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_END, this.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup);
            throw e;
        }
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_END, this.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup);
    }
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ initiateAuthRequest(requestUrl, params) {
        // Check that request url is not empty.
        if (requestUrl) {
            this.logger.infoPii(`1kcr9k ${requestUrl}`, this.correlationId);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("1l7hyp", this.correlationId);
            throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$be9285c64f247822), this.correlationId);
        }
    }
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ openPopup(urlNavigate, popupParams) {
        try {
            let popupWindow;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii(`0cgeo7 ${urlNavigate}`, this.correlationId);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii(`0c2awd ${urlNavigate}`, this.correlationId);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$5e827e513523a576), this.correlationId);
            try {
                popupWindow.document.title = "Microsoft Authentication";
            } catch (e) {
                if (typeof DOMException !== "undefined" && e instanceof DOMException && e.name === "SecurityError") ;
                else this.logger.verbose("1s1yfs", this.correlationId);
            }
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            return popupWindow;
        } catch (e) {
            this.logger.error(`0dxfb9 ${e.message}`, this.correlationId);
            throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$f1b7091ee48d0b3e), this.correlationId);
        }
    }
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ openSizedPopup(urlNavigate, { popupName: popupName, popupWindowAttributes: popupWindowAttributes, popupWindowParent: popupWindowParent }) {
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ const winLeft = popupWindowParent.screenLeft ? popupWindowParent.screenLeft : popupWindowParent.screenX;
        const winTop = popupWindowParent.screenTop ? popupWindowParent.screenTop : popupWindowParent.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ const winWidth = popupWindowParent.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const winHeight = popupWindowParent.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let width = popupWindowAttributes.popupSize?.width;
        let height = popupWindowAttributes.popupSize?.height;
        let top = popupWindowAttributes.popupPosition?.top;
        let left = popupWindowAttributes.popupPosition?.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("08vfmo", this.correlationId);
            width = (0, $7101cc4ee26a17a4$export$a0a689e4294b9880).POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("09cxa0", this.correlationId);
            height = (0, $7101cc4ee26a17a4$export$a0a689e4294b9880).POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("1qh4wo", this.correlationId);
            top = Math.max(0, winHeight / 2 - (0, $7101cc4ee26a17a4$export$a0a689e4294b9880).POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("1sz3en", this.correlationId);
            left = Math.max(0, winWidth / 2 - (0, $7101cc4ee26a17a4$export$a0a689e4294b9880).POPUP_WIDTH / 2 + winLeft);
        }
        return popupWindowParent.open(urlNavigate, popupName, `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes`);
    }
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ generatePopupName(scopes, authority) {
        return `${(0, $7101cc4ee26a17a4$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${scopes.join("-")}.${authority}.${this.correlationId}`;
    }
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ generateLogoutPopupName(request) {
        const homeAccountId = request.account && request.account.homeAccountId;
        return `${(0, $7101cc4ee26a17a4$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${homeAccountId}.${this.correlationId}`;
    }
    async waitForPopupResponse(request, popupWindow, popupWindowParent) {
        if (this.waitForPopupResponseHook) return this.waitForPopupResponseHook(request, popupWindow, popupWindowParent);
        return (0, $8e677587a7c978db$export$f241abdbe4a81a03)(this.config.system.popupBridgeTimeout, this.logger, request, this.performanceClient);
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 













'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $2ddf9de1d228c373$var$getNavigationType() {
    if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.getEntriesByType !== "function") return undefined;
    const navigationEntries = window.performance.getEntriesByType("navigation");
    const navigation = navigationEntries.length ? navigationEntries[0] : undefined;
    return navigation?.type;
}
class $2ddf9de1d228c373$export$a368977effbc1ed6 extends (0, $b86c5719a99dca61$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, correlationId, platformAuthHandler){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthHandler);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ async acquireToken(request) {
        const validRequest = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $b86c5719a99dca61$export$33189c9f1d196fb4), (0, $acc47f0f594e8d22$export$ee6f0d99b40b747e), this.logger, this.performanceClient, this.correlationId)(request, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        validRequest.platformBroker = (0, $0f1c35249bd71733$export$4815cc9f88d4f6a5)(this.config, this.logger, this.correlationId, this.platformAuthProvider, request.authenticationScheme);
        const handleBackButton = (event)=>{
            // Clear temporary cache if the back button is clicked during the redirect flow.
            if (event.persisted) {
                this.logger.verbose("0udvtt", this.correlationId);
                this.browserStorage.resetRequestCache(this.correlationId);
                this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).RESTORE_FROM_BFCACHE, this.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect);
            }
        };
        const redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
        this.logger.verbosePii(`0zao0a ${redirectStartPage}`, this.correlationId);
        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
        this.browserStorage.setTemporaryCache((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).ORIGIN_URI, redirectStartPage, true);
        // Clear temporary cache if the back button is clicked during the redirect flow.
        window.addEventListener("pageshow", handleBackButton);
        try {
            if (this.config.system.protocolMode === (0, $631489f43a9fbed6$export$73a3e3dedd37150d).EAR) await this.executeEarFlow(validRequest);
            else await this.executeCodeFlow(validRequest);
        } catch (e) {
            if (e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) e.correlationId = this.correlationId;
            window.removeEventListener("pageshow", handleBackButton);
            throw e;
        }
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)((0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenRedirect, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const pkceCodes = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $d0efbde2aa549bff$export$91d5e5a023803853), (0, $acc47f0f594e8d22$export$5a7b24ab3b501c09), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const redirectRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, this.correlationId, pkceCodes.verifier);
        try {
            if (redirectRequest.httpMethod === (0, $8994aeee5e01080d$exports).HttpMethod.POST) return await this.executeCodeFlowWithPost(redirectRequest);
            else {
                // Initialize the client
                const authClient = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $acc47f0f594e8d22$export$2778b133ce149dc6), this.logger, this.performanceClient, this.correlationId)({
                    serverTelemetryManager: serverTelemetryManager,
                    requestAuthority: redirectRequest.authority,
                    requestAzureCloudOptions: redirectRequest.azureCloudOptions,
                    requestExtraQueryParameters: redirectRequest.extraQueryParameters,
                    account: redirectRequest.account
                });
                // Create acquire token url.
                const navigateUrl = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$a256231ce8625983), (0, $0d9eb83114fc9425$exports).GetAuthCodeUrl, this.logger, this.performanceClient, request.correlationId)(this.config, authClient.authority, redirectRequest, this.logger, this.performanceClient);
                // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
                return await this.initiateAuthRequest(navigateUrl);
            }
        } catch (e) {
            if (e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const { correlationId: correlationId, authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $956a2c583a756eea$export$e36d1ed7c9435e3e), (0, $acc47f0f594e8d22$export$dad6c3127c773e76), this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $f0e13da7356d30ac$export$95528b8a314880d1), (0, $acc47f0f594e8d22$export$8f99489bc43f886e), this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $d0efbde2aa549bff$export$91d5e5a023803853), (0, $acc47f0f594e8d22$export$5a7b24ab3b501c09), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const redirectRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, this.correlationId, pkceCodes.verifier);
        const form = await (0, $aa09ca607db54806$export$3c140ef19fa8de34)(document, this.config, discoveredAuthority, redirectRequest, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$ce7eeda4eb1dd3c6), "", "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Executes classic Authorization Code flow with a POST request.
     * @param request
     */ async executeCodeFlowWithPost(request) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $956a2c583a756eea$export$e36d1ed7c9435e3e), (0, $acc47f0f594e8d22$export$dad6c3127c773e76), this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger);
        this.browserStorage.cacheAuthorizeRequest(request, this.correlationId);
        const form = await (0, $aa09ca607db54806$export$a76e1509233f1aec)(document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$ce7eeda4eb1dd3c6), "", "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash {string} url hash
     * @param parentMeasurement {InProgressPerformanceEvent} parent measurement
     * @param request {CommonAuthorizationUrlRequest} request object
     * @param pkceVerifier {string} PKCE verifier
     * @param options {HandleRedirectPromiseOptions} options for handling redirect promise
     */ async handleRedirectPromise(request, pkceVerifier, parentMeasurement, options) {
        const originalTitle = document.title;
        document.title = "Microsoft Authentication";
        const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)((0, $7101cc4ee26a17a4$export$192d74ad69b40705).handleRedirectPromise, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const navigateToLoginRequestUrl = options?.navigateToLoginRequestUrl ?? true;
        try {
            const [serverParams, responseString] = this.getRedirectResponse(options?.hash || "");
            if (!serverParams) {
                // Not a recognized server response hash or hash not associated with a redirect request
                this.logger.info("1qmv0q", this.correlationId);
                this.browserStorage.resetRequestCache(this.correlationId);
                // Do not instrument "no_server_response" if user clicked back button
                if ($2ddf9de1d228c373$var$getNavigationType() !== "back_forward") parentMeasurement.event.errorCode = "no_server_response";
                else this.logger.verbose("1eqegq", this.correlationId);
                return null;
            }
            // If navigateToLoginRequestUrl is true, get the url where the redirect request was initiated
            const loginRequestUrl = this.browserStorage.getTemporaryCache((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).ORIGIN_URI, this.correlationId, true) || "";
            const loginRequestUrlNormalized = (0, $d35bb33c1dc82f98$exports).normalizeUrlForComparison(loginRequestUrl, this.logger, this.correlationId);
            const currentUrlNormalized = (0, $d35bb33c1dc82f98$exports).normalizeUrlForComparison(window.location.href, this.logger, this.correlationId);
            if (loginRequestUrlNormalized === currentUrlNormalized && navigateToLoginRequestUrl) {
                // We are on the page we need to navigate to - handle hash
                this.logger.verbose("11yred", this.correlationId);
                if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                (0, $8e677587a7c978db$export$9bf2691bda54425c)(loginRequestUrl);
                const handleHashResult = await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
                return handleHashResult;
            } else if (!navigateToLoginRequestUrl) {
                this.logger.verbose("0v4sdv", this.correlationId);
                return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            } else if (!(0, $8e677587a7c978db$export$9f140ed41af5108c)() || this.config.system.allowRedirectInIframe) {
                /*
                 * Returned from authority using redirect - need to perform navigation before processing response
                 * Cache the hash to be retrieved after the next redirect
                 */ this.browserStorage.setTemporaryCache((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).URL_HASH, responseString, true);
                const navigationOptions = {
                    apiId: (0, $7101cc4ee26a17a4$export$192d74ad69b40705).handleRedirectPromise,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: true
                };
                /**
                 * Default behavior is to redirect to the start page and not process the hash now.
                 * The start page is expected to also call handleRedirectPromise which will process the hash in one of the checks above.
                 */ let processHashOnRedirect = true;
                if (!loginRequestUrl) {
                    // Redirect to home page if login request url is empty
                    const homepage = (0, $8e677587a7c978db$export$60785768478b4ffc)(this.correlationId);
                    // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                    this.browserStorage.setTemporaryCache((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).ORIGIN_URI, homepage, true);
                    this.logger.warning("1dutq1", this.correlationId);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(homepage, navigationOptions);
                } else {
                    // Navigate to page that initiated the redirect request
                    this.logger.verbose(`08jpy1 ${loginRequestUrl}`, this.correlationId);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions);
                }
                // If navigateInternal implementation returns false, handle the hash now
                if (!processHashOnRedirect) return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            }
            return null;
        } catch (e) {
            if (e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        } finally{
            document.title = originalTitle;
        }
    }
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ getRedirectResponse(userProvidedResponse) {
        this.logger.verbose("1c5i8m", this.correlationId);
        // Get current location hash from window or cache.
        let responseString = userProvidedResponse;
        if (!responseString) {
            if (this.config.auth.OIDCOptions.responseMode === (0, $8994aeee5e01080d$exports).ResponseMode.QUERY) responseString = window.location.search;
            else responseString = window.location.hash;
        }
        let response = (0, $d35bb33c1dc82f98$exports).getDeserializedResponse(responseString);
        if (response) {
            try {
                (0, $e54e6f1425de2c43$export$af0c72d18284aa0)(response, this.browserCrypto, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect, this.correlationId);
            } catch (e) {
                if (e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) this.logger.error(`0bkq6p ${e.errorCode} ${e.errorMessage}`, this.correlationId);
                return [
                    null,
                    ""
                ];
            }
            (0, $8e677587a7c978db$export$a20c3032ba81d6aa)(window);
            this.logger.verbose("00uvho", this.correlationId);
            return [
                response,
                responseString
            ];
        }
        const cachedHash = this.browserStorage.getTemporaryCache((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).URL_HASH, this.correlationId, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $7101cc4ee26a17a4$export$21d55bedf0d269fb).URL_HASH));
        if (cachedHash) {
            response = (0, $d35bb33c1dc82f98$exports).getDeserializedResponse(cachedHash);
            if (response) {
                this.logger.verbose("001671", this.correlationId);
                return [
                    response,
                    cachedHash
                ];
            }
        }
        return [
            null,
            ""
        ];
    }
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ async handleResponse(serverParams, request, codeVerifier, serverTelemetryManager) {
        const state = serverParams.state;
        if (!state) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$211c8e8843a8d278), request.correlationId);
        const { authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        if (serverParams.ear_jwe) {
            const discoveredAuthority = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $956a2c583a756eea$export$e36d1ed7c9435e3e), (0, $acc47f0f594e8d22$export$dad6c3127c773e76), this.logger, this.performanceClient, request.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
            return (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$21aeb02dac823516), (0, $acc47f0f594e8d22$export$680f3c7b33b3fdfd), this.logger, this.performanceClient, request.correlationId)(request, serverParams, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenRedirect, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        }
        const authClient = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $acc47f0f594e8d22$export$2778b133ce149dc6), this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: request.authority
        });
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$907304a743d3578a), (0, $acc47f0f594e8d22$export$e5c1dfbe90037ee5), this.logger, this.performanceClient, request.correlationId)(request, serverParams, codeVerifier, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenRedirect, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     * @param onRedirectNavigateRequest - onRedirectNavigate callback provided on the request
     */ async initiateAuthRequest(requestUrl) {
        this.logger.verbose("0yaw2e", this.correlationId);
        // Navigate if valid URL
        if (requestUrl) {
            this.logger.infoPii(`1luf83 ${requestUrl}`, this.correlationId);
            const navigationOptions = {
                apiId: (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenRedirect,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const onRedirectNavigate = this.config.auth.onRedirectNavigate;
            // If onRedirectNavigate is implemented, invoke it and provide requestUrl
            if (typeof onRedirectNavigate === "function") {
                this.logger.verbose("1nehvl", this.correlationId);
                const navigate = onRedirectNavigate(requestUrl);
                // Returning false from onRedirectNavigate will stop navigation
                if (navigate !== false) {
                    this.logger.verbose("1a0jxh", this.correlationId);
                    await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                    return;
                } else {
                    this.logger.verbose("09k5h5", this.correlationId);
                    return;
                }
            } else {
                // Navigate window to request URL
                this.logger.verbose("0klwf7", this.correlationId);
                await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                return;
            }
        } else {
            // Throw error if request URL is empty.
            this.logger.info("0rlh4e", this.correlationId);
            throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$be9285c64f247822), this.correlationId);
        }
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logout(logoutRequest) {
        this.logger.verbose("1rkurh", this.correlationId);
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)((0, $7101cc4ee26a17a4$export$192d74ad69b40705).logout, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_START, this.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect, logoutRequest);
            // Clear cache on logout
            await (0, $956a2c583a756eea$export$bcfc3ed6114b66f4)(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validLogoutRequest.account);
            const navigationOptions = {
                apiId: (0, $7101cc4ee26a17a4$export$192d74ad69b40705).logout,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const authClient = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $acc47f0f594e8d22$export$2778b133ce149dc6), this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: logoutRequest && logoutRequest.authority,
                requestExtraQueryParameters: logoutRequest?.extraQueryParameters,
                account: logoutRequest && logoutRequest.account || undefined
            });
            if (authClient.authority.protocolMode === (0, $631489f43a9fbed6$export$73a3e3dedd37150d).OIDC) try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validLogoutRequest.account?.homeAccountId) {
                    this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_SUCCESS, this.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
                    return;
                }
            }
            // Redirect bridge requires "state" param to work properly
            validLogoutRequest.state = (0, $de6be0b6a0939617$exports).setRequestState(this.browserCrypto, validLogoutRequest.state || "", {
                interactionType: (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect
            }, validLogoutRequest.correlationId);
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validLogoutRequest);
            if (validLogoutRequest.account?.homeAccountId) this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_SUCCESS, this.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
            // Check if onRedirectNavigate is implemented, and invoke it if so
            const onRedirectNavigate = this.config.auth.onRedirectNavigate;
            if (typeof onRedirectNavigate === "function") {
                const navigate = onRedirectNavigate(logoutUri);
                if (navigate !== false) {
                    this.logger.verbose("06v57e", this.correlationId);
                    // Ensure interaction is in progress
                    if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, (0, $7101cc4ee26a17a4$export$dc1d3aa5f3837765).SIGNOUT);
                    await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                    return;
                } else {
                    // Ensure interaction is not in progress
                    this.browserStorage.setInteractionInProgress(false);
                    this.logger.verbose("0xqes1", this.correlationId);
                }
            } else {
                // Ensure interaction is in progress
                if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, (0, $7101cc4ee26a17a4$export$dc1d3aa5f3837765).SIGNOUT);
                await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                return;
            }
        } catch (e) {
            if (e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_FAILURE, this.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect, null, e);
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_END, this.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect);
            throw e;
        }
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_END, this.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect);
    }
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ getRedirectStartPage(requestStartPage) {
        const redirectStartPage = requestStartPage || window.location.href;
        const absoluteRedirectStartPage = (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).getAbsoluteUrl(redirectStartPage, (0, $8e677587a7c978db$export$1204531fbbf6ecde)(), this.correlationId);
        // Sanity check the URL before it is cached so we never persist a malformed value (e.g. the literal string "null")
        (0, $d35bb33c1dc82f98$exports).validateUrl(absoluteRedirectStartPage, this.logger, this.correlationId);
        return absoluteRedirectStartPage;
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 




/*! @azure/msal-browser v5.16.0 2026-06-30 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Navigates the given hidden iframe to the provided URL.
 * @param frame
 * @param requestUrl
 */ async function $4b1acd649d15f5a8$export$b5cc8574c3c26d11(frame, requestUrl, logger, correlationId) {
    if (!requestUrl) {
        // Throw error if request URL is empty.
        logger.info("1l7hyp", correlationId);
        throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$be9285c64f247822), correlationId);
    }
    frame.src = requestUrl;
    return frame;
}
async function $4b1acd649d15f5a8$export$99ef719e5be9ef9(frame, config, authority, request, logger, performanceClient) {
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await (0, $aa09ca607db54806$export$a76e1509233f1aec)(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
async function $4b1acd649d15f5a8$export$dfeea08a8aa03859(frame, config, authority, request, logger, performanceClient) {
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await (0, $aa09ca607db54806$export$3c140ef19fa8de34)(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
/**
 * @hidden
 * Creates a new hidden iframe for silent token renewal. Callers navigate it
 * (set `src` or submit a form) after registering the response listener.
 * @ignore
 */ function $4b1acd649d15f5a8$export$2559d0efcd1e5517() {
    const authFrame = document.createElement("iframe");
    authFrame.className = "msalSilentIframe";
    authFrame.title = "Microsoft Authentication";
    authFrame.style.visibility = "hidden";
    authFrame.style.position = "absolute";
    authFrame.style.width = authFrame.style.height = "0";
    authFrame.style.border = "0";
    authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
    authFrame.setAttribute("allow", "local-network-access *");
    document.body.appendChild(authFrame);
    return authFrame;
}
/**
 * @hidden
 * Removes a hidden iframe from `document.body` if it is a direct child.
 * @param iframe - The iframe element to remove.
 */ function $4b1acd649d15f5a8$export$58f7b73180118e4e(iframe) {
    if (document.body === iframe.parentNode) document.body.removeChild(iframe);
}










'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $0956cbdf3eea11f6$export$e81c7938bccef977 extends (0, $b86c5719a99dca61$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, correlationId, platformAuthProvider, waitForIframeResponseHook){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider);
        this.apiId = apiId;
        this.nativeStorage = nativeStorageImpl;
        this.waitForIframeResponseHook = waitForIframeResponseHook;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ async acquireToken(request) {
        // Check that we have some SSO data
        if (!request.loginHint && !request.sid && (!request.account || !request.account.username)) this.logger.warning("1kl318", this.correlationId);
        // Check the prompt value
        const inputRequest = {
            ...request
        };
        if (inputRequest.prompt) {
            if (inputRequest.prompt !== (0, $8994aeee5e01080d$exports).PromptValue.NONE && inputRequest.prompt !== (0, $8994aeee5e01080d$exports).PromptValue.NO_SESSION) {
                this.logger.warning(`0bmctg ${inputRequest.prompt} ${(0, $8994aeee5e01080d$exports).PromptValue.NONE}`, this.correlationId);
                inputRequest.prompt = (0, $8994aeee5e01080d$exports).PromptValue.NONE;
            }
        } else inputRequest.prompt = (0, $8994aeee5e01080d$exports).PromptValue.NONE;
        // Create silent request
        const silentRequest = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $b86c5719a99dca61$export$33189c9f1d196fb4), (0, $acc47f0f594e8d22$export$ee6f0d99b40b747e), this.logger, this.performanceClient, this.correlationId)(inputRequest, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        silentRequest.platformBroker = (0, $0f1c35249bd71733$export$4815cc9f88d4f6a5)(this.config, this.logger, this.correlationId, this.platformAuthProvider, silentRequest.authenticationScheme);
        (0, $8e677587a7c978db$export$a0816fa17a9e79be)(silentRequest.authority);
        if (this.config.system.protocolMode === (0, $631489f43a9fbed6$export$73a3e3dedd37150d).EAR) return this.executeEarFlow(silentRequest);
        else return this.executeCodeFlow(silentRequest);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request) {
        let authClient;
        const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // Initialize the client
            authClient = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $acc47f0f594e8d22$export$2778b133ce149dc6), this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account
            });
            return await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $acc47f0f594e8d22$export$84c1ce19d7e23fb5), this.logger, this.performanceClient, request.correlationId)(authClient, request);
        } catch (e) {
            if (e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            if (!authClient || !(e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) || e.errorCode !== (0, $7101cc4ee26a17a4$export$a0a689e4294b9880).INVALID_GRANT_ERROR) throw e;
            this.performanceClient.addFields({
                retryError: e.errorCode
            }, this.correlationId);
            return await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $acc47f0f594e8d22$export$84c1ce19d7e23fb5), this.logger, this.performanceClient, this.correlationId)(authClient, request);
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const { correlationId: correlationId, authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        const discoveredAuthority = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $956a2c583a756eea$export$e36d1ed7c9435e3e), (0, $acc47f0f594e8d22$export$dad6c3127c773e76), this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $f0e13da7356d30ac$export$95528b8a314880d1), (0, $acc47f0f594e8d22$export$8f99489bc43f886e), this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $d0efbde2aa549bff$export$91d5e5a023803853), (0, $acc47f0f594e8d22$export$5a7b24ab3b501c09), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const silentRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge
        };
        // Create the iframe, register the response listener, then navigate, so the listener is active before the iframe can respond.
        const iframe = (0, $4b1acd649d15f5a8$export$2559d0efcd1e5517)();
        const responseType = this.config.auth.OIDCOptions.responseMode;
        let responseString;
        try {
            const responsePromise = (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.waitForIframeResponse.bind(this), (0, $acc47f0f594e8d22$export$a4bfaadf3c5aed38), this.logger, this.performanceClient, correlationId)(iframe, request);
            responsePromise.catch(()=>{
            /*
                 * If navigation below throws before responsePromise is awaited,
                 * the listener still rejects on timeout. Swallow it here so it
                 * does not surface as an unhandled rejection; the navigation
                 * error is propagated instead.
                 */ });
            await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $4b1acd649d15f5a8$export$dfeea08a8aa03859), (0, $acc47f0f594e8d22$export$c9535608a7f36f5f), this.logger, this.performanceClient, correlationId)(iframe, this.config, discoveredAuthority, silentRequest, this.logger, this.performanceClient);
            responseString = await responsePromise;
        } finally{
            (0, $69bce03cfd571284$export$468cda29b159ee5d)((0, $4b1acd649d15f5a8$export$58f7b73180118e4e), (0, $acc47f0f594e8d22$export$e84ca321454a8dc1), this.logger, this.performanceClient, correlationId)(iframe);
        }
        const serverParams = (0, $69bce03cfd571284$export$468cda29b159ee5d)((0, $e54e6f1425de2c43$export$e64c1808ed72a7c), (0, $acc47f0f594e8d22$export$bd4551c9ff45ab85), this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger, this.correlationId);
        if (!serverParams.ear_jwe && serverParams.code) {
            // If server doesn't support EAR, they may fallback to auth code flow instead
            const authClient = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $acc47f0f594e8d22$export$2778b133ce149dc6), this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: (0, $956a2c583a756eea$export$c0fa8985fac40b0c)(this.apiId, this.config.auth.clientId, correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$907304a743d3578a), (0, $acc47f0f594e8d22$export$e5c1dfbe90037ee5), this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$21aeb02dac823516), (0, $acc47f0f594e8d22$export$680f3c7b33b3fdfd), this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, this.apiId, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Verifies SSO capability by making an iframe request to /authorize without exchanging the code for tokens.
     * This is useful for verifying SSO capability in the background without the overhead of a full token exchange.
     * @param request - The SSO silent request
     * @returns true if SSO verification was successful with a valid authorization code, false otherwise
     */ async verifySso(request) {
        const inputRequest = {
            ...request
        };
        if (!inputRequest.prompt) inputRequest.prompt = (0, $8994aeee5e01080d$exports).PromptValue.NONE;
        // Create silent request
        const silentRequest = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $b86c5719a99dca61$export$33189c9f1d196fb4), (0, $acc47f0f594e8d22$export$ee6f0d99b40b747e), this.logger, this.performanceClient, this.correlationId)(inputRequest, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        const authClient = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $acc47f0f594e8d22$export$2778b133ce149dc6), this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: (0, $956a2c583a756eea$export$c0fa8985fac40b0c)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            requestExtraQueryParameters: silentRequest.extraQueryParameters,
            account: silentRequest.account
        });
        const { serverParams: serverParams } = await this.silentAuthorizeHelper(authClient, silentRequest);
        const correlationId = silentRequest.correlationId;
        // Validate the response - this checks for errors and validates state
        (0, $34778708f9a89dd9$exports).validateAuthorizationResponse(serverParams, silentRequest.state, correlationId);
        // Verify a valid authorization code is present
        if (!serverParams.code) {
            this.logger.warning("0y34ti", correlationId);
            return false;
        }
        this.logger.verbose("0kkkcj", correlationId);
        return true;
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$78523a40be105a03), ""));
    }
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ async silentTokenHelper(authClient, request) {
        const { serverParams: serverParams, pkceCodes: pkceCodes } = await this.silentAuthorizeHelper(authClient, request);
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$907304a743d3578a), (0, $acc47f0f594e8d22$export$e5c1dfbe90037ee5), this.logger, this.performanceClient, request.correlationId)(request, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Shared helper that generates PKCE codes, builds the /authorize URL,
     * loads it in a hidden iframe, waits for the redirect-bridge response,
     * and returns the deserialized server parameters along with the PKCE codes
     * and the request that was sent.
     */ async silentAuthorizeHelper(authClient, request) {
        const correlationId = request.correlationId;
        const pkceCodes = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $d0efbde2aa549bff$export$91d5e5a023803853), (0, $acc47f0f594e8d22$export$5a7b24ab3b501c09), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const silentRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge
        };
        // Create the iframe, register the response listener, then navigate, so the listener is active before the iframe can respond.
        const iframe = (0, $4b1acd649d15f5a8$export$2559d0efcd1e5517)();
        const responseType = this.config.auth.OIDCOptions.responseMode;
        // Wait for response from the redirect bridge.
        let responseString;
        try {
            const responsePromise = (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.waitForIframeResponse.bind(this), (0, $acc47f0f594e8d22$export$a4bfaadf3c5aed38), this.logger, this.performanceClient, correlationId)(iframe, request);
            responsePromise.catch(()=>{
            /*
                 * If URL creation or navigation below throws before
                 * responsePromise is awaited, the listener still rejects on
                 * timeout. Swallow it here so it does not surface as an
                 * unhandled rejection; the navigation error is propagated
                 * instead.
                 */ });
            if (request.httpMethod === (0, $8994aeee5e01080d$exports).HttpMethod.POST) await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $4b1acd649d15f5a8$export$99ef719e5be9ef9), (0, $acc47f0f594e8d22$export$c9535608a7f36f5f), this.logger, this.performanceClient, correlationId)(iframe, this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
            else {
                // Create authorize request url
                const navigateUrl = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $aa09ca607db54806$export$a256231ce8625983), (0, $0d9eb83114fc9425$exports).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
                // Navigate the iframe to the authorize request url
                await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $4b1acd649d15f5a8$export$b5cc8574c3c26d11), (0, $acc47f0f594e8d22$export$c9535608a7f36f5f), this.logger, this.performanceClient, correlationId)(iframe, navigateUrl, this.logger, correlationId);
            }
            responseString = await responsePromise;
        } finally{
            (0, $69bce03cfd571284$export$468cda29b159ee5d)((0, $4b1acd649d15f5a8$export$58f7b73180118e4e), (0, $acc47f0f594e8d22$export$e84ca321454a8dc1), this.logger, this.performanceClient, correlationId)(iframe);
        }
        const serverParams = (0, $69bce03cfd571284$export$468cda29b159ee5d)((0, $e54e6f1425de2c43$export$e64c1808ed72a7c), (0, $acc47f0f594e8d22$export$bd4551c9ff45ab85), this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger, this.correlationId);
        return {
            serverParams: serverParams,
            pkceCodes: pkceCodes,
            silentRequest: silentRequest
        };
    }
    async waitForIframeResponse(iframe, request) {
        if (this.waitForIframeResponseHook) return this.waitForIframeResponseHook(iframe, request);
        return (0, $8e677587a7c978db$export$f241abdbe4a81a03)(this.config.system.iframeBridgeTimeout, this.logger, request, this.performanceClient, this.config.experimental);
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
/*! @azure/msal-common v16.11.0 2026-06-30 */ 
























'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $5ee756e2263af840$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS = 300; // 5 Minutes
/**
 * OAuth2.0 refresh token client
 * @internal
 */ class $5ee756e2263af840$export$9cb096b89b92d8a8 {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = (0, $8e787aed99ab54c6$export$57a091701dcdabb2)(configuration);
        // Initialize the logger
        this.logger = new (0, $0fd93c953107c2f4$export$efa9a398d6368992)(this.config.loggerOptions, (0, $8da2d5e621fbe87e$export$a8ff84c12d48cfa6), (0, $8da2d5e621fbe87e$export$83d89fbfd8236492));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    async acquireToken(request, apiId) {
        const reqTimestamp = (0, $e0616e53cd3f026f$export$ae62599a119ac50a)();
        const response = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $0d9eb83114fc9425$export$ac2700eaa8fb0f70), this.logger, this.performanceClient, request.correlationId)(request, this.authority);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $8994aeee5e01080d$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $ef22af12cad4e1b3$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin);
        responseHandler.validateTokenResponse(response.body, request.correlationId);
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $0d9eb83114fc9425$export$602d5889aed45852), this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, apiId, undefined, undefined, true, request.forceCache, requestId);
    }
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ async acquireTokenByRefreshToken(request, apiId) {
        // Cannot renew token if no request object is given.
        if (!request) throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$eca67ff7a91fed9d), "");
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$export$5a3c7d1c90ac9220), request.correlationId);
        // try checking if FOCI is enabled for the given application
        const isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment, request.correlationId);
        // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
        if (isFOCI) try {
            return await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $0d9eb83114fc9425$export$1501c7e462f7c477), this.logger, this.performanceClient, request.correlationId)(request, true, apiId);
        } catch (e) {
            const noFamilyRTInCache = e instanceof (0, $e9bbb17645bd3149$export$6ba3e818c6bc76ba) && e.errorCode === (0, $65a17b77f45cb3f9$export$e408b083cd212696);
            const clientMismatchErrorWithFamilyRT = e instanceof (0, $cf4c26be8c97417f$export$ea52035eac03daf0) && e.errorCode === (0, $8994aeee5e01080d$export$885686d5cda1602e) && e.subError === (0, $8994aeee5e01080d$export$5c3e811110c23b4b);
            // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
            if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) return (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $0d9eb83114fc9425$export$1501c7e462f7c477), this.logger, this.performanceClient, request.correlationId)(request, false, apiId);
            else throw e;
        }
        // fall back to application refresh token acquisition
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $0d9eb83114fc9425$export$1501c7e462f7c477), this.logger, this.performanceClient, request.correlationId)(request, false, apiId);
    }
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ async acquireTokenWithCachedRefreshToken(request, foci, apiId) {
        // fetches family RT or application RT based on FOCI value
        const refreshToken = (0, $69bce03cfd571284$export$468cda29b159ee5d)(this.cacheManager.getRefreshToken.bind(this.cacheManager), (0, $0d9eb83114fc9425$export$cc3335bdf0624641), this.logger, this.performanceClient, request.correlationId)(request.account, foci, request.correlationId, undefined);
        if (!refreshToken) throw (0, $e9bbb17645bd3149$export$8f7a741750c16535)((0, $65a17b77f45cb3f9$export$e408b083cd212696), request.correlationId);
        if (refreshToken.expiresOn) {
            const offset = request.refreshTokenExpirationOffsetSeconds || $5ee756e2263af840$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS;
            this.performanceClient?.addFields({
                cacheRtExpiresOnSeconds: Number(refreshToken.expiresOn),
                rtOffsetSeconds: offset
            }, request.correlationId);
            if ((0, $e0616e53cd3f026f$export$b007d77a962aa175)(refreshToken.expiresOn, offset)) throw (0, $e9bbb17645bd3149$export$8f7a741750c16535)((0, $65a17b77f45cb3f9$export$a90e8b9c10991b49), request.correlationId);
        }
        // attach cached RT size to the current measurement
        const refreshTokenRequest = {
            ...request,
            refreshToken: refreshToken.secret,
            authenticationScheme: request.authenticationScheme || (0, $8994aeee5e01080d$export$901491a717da2ba5).BEARER,
            ccsCredential: {
                credential: request.account.homeAccountId,
                type: (0, $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            }
        };
        try {
            return await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.acquireToken.bind(this), (0, $0d9eb83114fc9425$export$6f67f4b67fca51ad), this.logger, this.performanceClient, request.correlationId)(refreshTokenRequest, apiId);
        } catch (e) {
            if (e instanceof (0, $e9bbb17645bd3149$export$6ba3e818c6bc76ba)) {
                if (e.subError === (0, $65a17b77f45cb3f9$export$2e3666c77d45a4da)) {
                    // Remove bad refresh token from cache
                    this.logger.verbose("acquireTokenWithRefreshToken: bad refresh token, removing from cache", request.correlationId);
                    const badRefreshTokenKey = this.cacheManager.generateCredentialKey(refreshToken);
                    this.cacheManager.removeRefreshToken(badRefreshTokenKey, request.correlationId);
                }
            }
            throw e;
        }
    }
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ async executeTokenRequest(request, authority) {
        const queryParametersString = (0, $ce0751562d3e57c4$export$c9cf064a62ceb675)(request, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient);
        const endpoint = (0, $9c756a14a1bed5db$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $0d9eb83114fc9425$export$7f5252ee9f8772ec), this.logger, this.performanceClient, request.correlationId)(request);
        const headers = (0, $ce0751562d3e57c4$export$74d4e61cf31cd8f9)(this.logger, this.config.systemOptions.preventCorsPreflight, request.ccsCredential);
        const thumbprint = (0, $1a839cf816c84c9b$export$2daa8cfcf54c2b48)(this.config.authOptions.clientId, request);
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $ce0751562d3e57c4$export$2e39c706a1d34784), (0, $0d9eb83114fc9425$export$8ea44153120d19e5), this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, this.serverTelemetryManager);
    }
    /**
     * Helper function to create the token request body
     * @param request
     */ async createTokenRequestBody(request) {
        const parameters = new Map();
        (0, $25d69fa430040087$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.extraParameters?.[0, $46f4c10c7ac0692f$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        if (request.redirectUri) (0, $25d69fa430040087$export$6758d6264f4f06)(parameters, request.redirectUri);
        (0, $25d69fa430040087$export$c213bf8f125826ba)(parameters, request.scopes, request.correlationId, true, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes);
        (0, $25d69fa430040087$export$e5f700fdeb4022b2)(parameters, (0, $8994aeee5e01080d$export$ce68f19b50b39c0b).REFRESH_TOKEN_GRANT);
        (0, $25d69fa430040087$export$86b85a101d45e918)(parameters);
        (0, $25d69fa430040087$export$3ecac3764b147c3f)(parameters, this.config.libraryInfo);
        (0, $25d69fa430040087$export$37ec1b76d865654a)(parameters, this.config.telemetry.application);
        (0, $25d69fa430040087$export$26592ae2037df9de)(parameters);
        if (this.serverTelemetryManager && !(0, $8e787aed99ab54c6$export$25afa7198c2ed9b9)(this.config)) (0, $25d69fa430040087$export$79fb524b159705e9)(parameters, this.serverTelemetryManager);
        (0, $25d69fa430040087$export$b9e8ccbb425b80a3)(parameters, request.refreshToken);
        if (this.config.clientCredentials.clientSecret) (0, $25d69fa430040087$export$8df84bbb0e2465bc)(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            (0, $25d69fa430040087$export$2d3d772920e2496e)(parameters, await (0, $8e85ce4eede47db4$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            (0, $25d69fa430040087$export$55ad911d12112f00)(parameters, clientAssertion.assertionType);
        }
        if (request.authenticationScheme === (0, $8994aeee5e01080d$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $7d2464f001dd27e8$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $0d9eb83114fc9425$export$42d4b7447f09a8ea), this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            (0, $25d69fa430040087$export$6dfc34809d8c4096)(parameters, reqCnfData);
        } else if (request.authenticationScheme === (0, $8994aeee5e01080d$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) (0, $25d69fa430040087$export$f004de9a266b8070)(parameters, request.sshJwk);
            else throw (0, $3573ab538aec4484$export$5d63d098f4f130a1)((0, $86a6e7782b3ad3eb$export$8fbed44b22d9136f), request.correlationId);
        }
        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
            case (0, $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $9c0d10744a3bd38b$export$63508a6d6b7dbe07)(request.ccsCredential.credential);
                    (0, $25d69fa430040087$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose(`Could not parse home account ID for CCS Header: '${e}'`, request.correlationId);
                }
                break;
            case (0, $dd8f3ff6f1410ceb$export$17b7b3ac1abef49f).UPN:
                (0, $25d69fa430040087$export$aa9cca16bcc29d2d)(parameters, request.ccsCredential.credential);
                break;
        }
        if (request.embeddedClientId) (0, $25d69fa430040087$export$5ea4577e2a518c27)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.extraParameters) (0, $25d69fa430040087$export$7f71daa83fb7c7e2)(parameters, {
            ...request.extraParameters
        });
        (0, $25d69fa430040087$export$7153a1ee4346fa3b)(parameters, request.correlationId, this.performanceClient);
        (0, $25d69fa430040087$export$b04c3bca9165ed02)(parameters, request.correlationId, request.claims, this.config.authOptions.clientCapabilities, request.skipBrokerClaims);
        return (0, $d35bb33c1dc82f98$export$44d4663acf79cde2)(parameters);
    }
}








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $36ade668a744777e$export$b4a36596822a5d2 extends (0, $b86c5719a99dca61$export$fa9179cade3eb05a) {
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ async acquireToken(request) {
        const baseRequest = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $e54e4b4a24079223$export$8e461fcf1fd6910b), (0, $acc47f0f594e8d22$export$e13dedc12c2c4f38), this.logger, this.performanceClient, request.correlationId)(request, this.config, this.performanceClient, this.logger, this.correlationId);
        const silentRequest = {
            ...request,
            ...baseRequest
        };
        if (request.redirectUri) // Make sure any passed redirectUri is converted to an absolute URL - redirectUri is not a required parameter for refresh token redemption so only include if explicitly provided
        silentRequest.redirectUri = (0, $956a2c583a756eea$export$e602b39e9004b45f)(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId);
        const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)((0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const refreshTokenClient = await this.createRefreshTokenClient({
            serverTelemetryManager: serverTelemetryManager,
            authorityUrl: silentRequest.authority,
            azureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)(refreshTokenClient.acquireTokenByRefreshToken.bind(refreshTokenClient), (0, $acc47f0f594e8d22$export$f5534f1ba404e5a3), this.logger, this.performanceClient, request.correlationId)(silentRequest, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenSilent_silentFlow).catch((e)=>{
            e.correlationId = this.correlationId;
            serverTelemetryManager.cacheFailedRequest(e);
            throw e;
        });
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$78523a40be105a03), ""));
    }
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         azureCloudOptions?: AzureCloudOptions;
     *         extraQueryParams?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createRefreshTokenClient(params) {
        // Create auth module.
        const clientConfig = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $acc47f0f594e8d22$export$8b2b453d4b5734d9), this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: params.serverTelemetryManager,
            requestAuthority: params.authorityUrl,
            requestAzureCloudOptions: params.azureCloudOptions,
            requestExtraQueryParameters: params.extraQueryParameters,
            account: params.account
        });
        return new (0, $5ee756e2263af840$export$9cb096b89b92d8a8)(clientConfig, this.performanceClient);
    }
}





/*! @azure/msal-browser v5.16.0 2026-06-30 */ 




/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $b21c0a54e14c82a7$export$a2dbbd28e9bce542 extends (0, $5d04d7665f1ebf53$export$8538731fd397fb90) {
    constructor(config, performanceClient){
        super(config, performanceClient);
        this.includeRedirectUri = false;
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $600fe559a2f36d9c$export$d7f5ef311b3e9fca extends (0, $b86c5719a99dca61$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, correlationId, platformAuthProvider){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider);
        this.apiId = apiId;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ async acquireToken(request) {
        // Auth code payload is required
        if (!request.code) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$e502d98cd8d2da43), this.correlationId);
        // Create silent request
        const silentRequest = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $b86c5719a99dca61$export$33189c9f1d196fb4), (0, $acc47f0f594e8d22$export$ee6f0d99b40b747e), this.logger, this.performanceClient, this.correlationId)(request, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, /*
         * correlationId is optional in request payload, while this.correlationId is always instantiated as request.correlationId || createGuid().
         * Each auth request creates a new instance of *Client so we can safely use this.correlationId.
         */ this.correlationId);
        const serverTelemetryManager = (0, $956a2c583a756eea$export$c0fa8985fac40b0c)(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // Create auth code request (PKCE not needed)
            const authCodeRequest = {
                ...silentRequest,
                code: request.code
            };
            // Initialize the client
            const clientConfig = await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $acc47f0f594e8d22$export$8b2b453d4b5734d9), this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            const authClient = new (0, $b21c0a54e14c82a7$export$a2dbbd28e9bce542)(clientConfig, this.performanceClient);
            this.logger.verbose("1uic5e", this.correlationId);
            // Create silent handler
            const interactionHandler = new (0, $d0174f0c495d01eb$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Handle auth code parameters from request
            return await (0, $69bce03cfd571284$export$e4feded94d9adb18)(interactionHandler.handleCodeResponseFromServer.bind(interactionHandler), (0, $0d9eb83114fc9425$exports).HandleCodeResponseFromServer, this.logger, this.performanceClient, this.correlationId)({
                code: request.code,
                msgraph_host: request.msGraphHost,
                cloud_graph_host_name: request.cloudGraphHostName,
                cloud_instance_host_name: request.cloudInstanceHostName
            }, silentRequest, this.apiId, false);
        } catch (e) {
            if (e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$78523a40be105a03), ""));
    }
}







/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Get network information for telemetry purposes. This is only supported in Chromium-based browsers.
 * @returns Network connection information, or an empty object if not available.
 */ function $e5e76794f907911a$export$79f13b4cfaaf0d09() {
    if (typeof window === "undefined" || !window.navigator) return {};
    const connection = "connection" in window.navigator ? window.navigator.connection : undefined;
    return {
        effectiveType: connection?.effectiveType,
        rtt: connection?.rtt
    };
}
function $e5e76794f907911a$export$fe0570c25bf19cec(currentClientId, performanceEvent, logger, correlationId) {
    const frameInstances = // @ts-ignore
    window.msal?.clientIds || [];
    const msalInstanceCount = frameInstances.length;
    const sameClientIdInstanceCount = frameInstances.filter((i)=>i === currentClientId).length;
    if (sameClientIdInstanceCount > 1) logger.warning("1e88vg", correlationId);
    performanceEvent.add({
        msalInstanceCount: msalInstanceCount,
        sameClientIdInstanceCount: sameClientIdInstanceCount
    });
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $52bd6e9c9be84db3$var$preflightCheck(initialized, performanceEvent, config, request) {
    try {
        (0, $8e677587a7c978db$export$4dd091cbdc98b52e)(initialized);
        (0, $8451db0dd4949b5f$export$df47a28b08fa2370)(config.auth.isMcp, request);
    } catch (e) {
        performanceEvent.end({
            success: false
        }, e, request.account);
        throw e;
    }
}
class $52bd6e9c9be84db3$export$e9d1ef1cb8705404 {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ constructor(operatingContext){
        this.operatingContext = operatingContext;
        this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment();
        // Set the configuration.
        this.config = operatingContext.getConfig();
        this.initialized = false;
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new (0, $6b1f88068f54d1dd$export$c274a7f0ebd24b14)(this.logger, this.performanceClient) : (0, $842f61e187fdf563$export$865f57d401606752);
        this.eventHandler = new (0, $0a29dd70327044d0$export$ce0ba2422a1c7815)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new (0, $e624d8f74faf8e75$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, (0, $c05549f487bde715$export$2b9ebf6f25078cc0)(this.config.auth)) : (0, $e624d8f74faf8e75$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler);
        // initialize in memory storage for native flows
        const nativeCacheOptions = {
            cacheLocation: (0, $7101cc4ee26a17a4$export$573384e47a12d835).MemoryStorage,
            cacheRetentionDays: 5
        };
        this.nativeInternalStorage = new (0, $e624d8f74faf8e75$export$44d7291b5c8cc149)(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler);
        this.activeSilentTokenRequests = new Map();
        // Register listener functions
        this.trackStateChange = this.trackStateChange.bind(this);
        // Register listener functions
        this.trackStateChangeWithMeasurement = this.trackStateChangeWithMeasurement.bind(this);
    }
    static async createController(operatingContext, request) {
        const controller = new $52bd6e9c9be84db3$export$e9d1ef1cb8705404(operatingContext);
        await controller.initialize(request);
        return controller;
    }
    trackStateChange(correlationId, event) {
        if (!correlationId) return;
        if (event.type === "visibilitychange") {
            this.logger.info("16v6hv", correlationId);
            this.performanceClient.incrementFields({
                visibilityChangeCount: 1
            }, correlationId);
        } else if (event.type === "online") {
            this.logger.info("0zirfd", correlationId);
            this.performanceClient.incrementFields({
                onlineStatusChangeCount: 1
            }, correlationId);
        } else if (event.type === "offline") {
            this.logger.info("1xk9ef", correlationId);
            this.performanceClient.incrementFields({
                onlineStatusChangeCount: 1
            }, correlationId);
        }
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest} correlation id
     */ async initialize(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("1f7joy", correlationId);
        if (this.initialized) {
            this.logger.info("061m5x", correlationId);
            return;
        }
        if (!this.isBrowserEnvironment) {
            this.logger.info("19fvpi", correlationId);
            this.initialized = true;
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).INITIALIZE_END, correlationId);
            return;
        }
        const allowPlatformBroker = this.config.system.allowPlatformBroker;
        const initMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$ebaff939a81dcf2b), correlationId);
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).INITIALIZE_START, correlationId);
        // Broker applications are initialized twice, so we avoid double-counting it
        this.logMultipleInstances(initMeasurement, correlationId);
        initMeasurement.add({
            isMcp: this.config.auth.isMcp
        });
        await (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.browserStorage.initialize.bind(this.browserStorage), (0, $acc47f0f594e8d22$export$c4d273a3eb6a2e87), this.logger, this.performanceClient, correlationId)(correlationId);
        if (allowPlatformBroker) try {
            // check if platform authentication is available via DOM or browser extension and create relevant handlers
            this.platformAuthProvider = await (0, $0f1c35249bd71733$export$b2c9df3607dc771a)(this.logger, this.performanceClient, correlationId, this.config.system.nativeBrokerHandshakeTimeout, this.config.experimental.allowPlatformBrokerWithDOM);
        } catch (e) {
            this.logger.verbose(e, correlationId);
        }
        if (this.config.cache.cacheLocation === (0, $7101cc4ee26a17a4$export$573384e47a12d835).LocalStorage) this.eventHandler.subscribeCrossTab();
        !this.config.system.navigatePopups && await this.preGeneratePkceCodes(correlationId);
        this.initialized = true;
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).INITIALIZE_END, correlationId);
        initMeasurement.end({
            allowPlatformBroker: allowPlatformBroker,
            success: true
        });
    }
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @param options Object containing optional configuration for redirect promise handling.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ async handleRedirectPromise(options) {
        this.logger.verbose("02l8bm", "");
        // Block token acquisition before initialize has been called
        (0, $8e677587a7c978db$export$630119c5db8b5529)(this.initialized);
        if (this.isBrowserEnvironment) {
            /**
             * Store the promise on the PublicClientApplication instance if this is the first invocation of handleRedirectPromise,
             * otherwise return the promise from the first invocation. Prevents race conditions when handleRedirectPromise is called
             * several times concurrently.
             */ const redirectResponseKey = options?.hash || "";
            let response = this.redirectResponse.get(redirectResponseKey);
            if (typeof response === "undefined") {
                response = this.handleRedirectPromiseInternal(options);
                this.redirectResponse.set(redirectResponseKey, response);
                this.logger.verbose("1wn9kp", "");
            } else this.logger.verbose("0w0gm3", "");
            return response;
        }
        this.logger.verbose("12xi63", "");
        return null;
    }
    /**
     * The internal details of handleRedirectPromise. This is separated out to a helper to allow handleRedirectPromise to memoize requests
     * @param hash
     * @returns
     */ async handleRedirectPromiseInternal(options) {
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("0le6uv", "");
            return null;
        }
        const interactionType = this.browserStorage.getInteractionInProgress()?.type;
        if (interactionType === (0, $7101cc4ee26a17a4$export$dc1d3aa5f3837765).SIGNOUT) {
            this.logger.verbose("1ywcv2", "");
            this.browserStorage.setInteractionInProgress(false);
            return Promise.resolve(null);
        }
        const loggedInAccounts = this.getAllAccounts();
        const platformBrokerRequest = this.browserStorage.getCachedNativeRequest();
        const useNative = platformBrokerRequest && !options?.hash;
        let rootMeasurement;
        let redirectResponse;
        let cachedRedirectRequest;
        try {
            if (useNative && this.platformAuthProvider) {
                const correlationId = platformBrokerRequest?.correlationId || "";
                this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).HANDLE_REDIRECT_START, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect);
                rootMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$8fbc8506f7dfc43c), correlationId);
                this.logger.trace("12v7is", correlationId);
                rootMeasurement.add({
                    isPlatformBrokerRequest: true
                });
                const nativeClient = new (0, $9a0ce6cc67a0db6b$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).handleRedirectPromise, this.performanceClient, this.platformAuthProvider, platformBrokerRequest.accountId, this.nativeInternalStorage, platformBrokerRequest.correlationId);
                redirectResponse = (0, $69bce03cfd571284$export$e4feded94d9adb18)(nativeClient.handleRedirectPromise.bind(nativeClient), (0, $acc47f0f594e8d22$export$d3f7d57b3e4e2e35), this.logger, this.performanceClient, rootMeasurement.event.correlationId)();
            } else {
                const [standardRequest, codeVerifier] = this.browserStorage.getCachedRequest("");
                cachedRedirectRequest = standardRequest;
                const correlationId = standardRequest.correlationId;
                this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).HANDLE_REDIRECT_START, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect);
                // Reset rootMeasurement now that we have correlationId
                rootMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$8fbc8506f7dfc43c), correlationId);
                this.logger.trace("0znzs5", correlationId);
                const redirectClient = this.createRedirectClient(correlationId);
                redirectResponse = (0, $69bce03cfd571284$export$e4feded94d9adb18)(redirectClient.handleRedirectPromise.bind(redirectClient), (0, $acc47f0f594e8d22$export$67b57f4cae7558a0), this.logger, this.performanceClient, rootMeasurement.event.correlationId)(standardRequest, codeVerifier, rootMeasurement, options);
            }
        } catch (e) {
            this.browserStorage.resetRequestCache("");
            throw e;
        }
        return redirectResponse.then((result)=>{
            if (result) {
                this.browserStorage.resetRequestCache(result.correlationId);
                this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, result.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect, result);
                this.logger.verbose("0ui8f5", result.correlationId);
                // Emit login event if number of accounts change
                const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
                if (isLoggingIn) {
                    this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGIN_SUCCESS, result.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect, result.account);
                    this.logger.verbose("16im3l", result.correlationId);
                }
                rootMeasurement.end({
                    success: true
                }, undefined, result.account);
                // Fire-and-forget SSO capability verification in background
                this.verifySsoCapability(cachedRedirectRequest, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect);
            } else /*
                 * Instrument an event only if an error code is set. Otherwise, discard it when the redirect response
                 * is empty and the error code is missing.
                 */ if (rootMeasurement.event.errorCode) rootMeasurement.end({
                success: false
            }, undefined);
            else rootMeasurement.discard();
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).HANDLE_REDIRECT_END, rootMeasurement.event.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect);
            return result;
        }).catch((e)=>{
            this.browserStorage.resetRequestCache(rootMeasurement.event.correlationId);
            const eventError = e;
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, rootMeasurement.event.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect, null, eventError);
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).HANDLE_REDIRECT_END, rootMeasurement.event.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect);
            rootMeasurement.end({
                success: false
            }, eventError);
            throw e;
        });
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async acquireTokenRedirect(request) {
        // Preflight request
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0os66p", correlationId);
        (0, $8e677587a7c978db$export$62c8f4fdca4df60f)(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true, (0, $7101cc4ee26a17a4$export$dc1d3aa5f3837765).SIGNIN);
        const atrMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$affbf361bd01dc11), correlationId);
        atrMeasurement.add({
            scenarioId: request.scenarioId
        });
        const configOnRedirectNavigateCb = this.config.auth.onRedirectNavigate;
        this.config.auth.onRedirectNavigate = (url)=>{
            const navigate = typeof configOnRedirectNavigateCb === "function" ? configOnRedirectNavigateCb(url) : undefined;
            atrMeasurement.add({
                navigateCallbackResult: navigate !== false
            });
            atrMeasurement.event = atrMeasurement.end({
                success: true
            }, undefined, request.account) || atrMeasurement.event;
            return navigate;
        };
        try {
            (0, $8451db0dd4949b5f$export$df47a28b08fa2370)(this.config.auth.isMcp, request);
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_START, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect, request);
            let result;
            if (this.platformAuthProvider && this.canUsePlatformBroker(request)) {
                const nativeClient = new (0, $9a0ce6cc67a0db6b$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenRedirect, this.performanceClient, this.platformAuthProvider, this.getNativeAccountId(request), this.nativeInternalStorage, correlationId);
                result = (0, $69bce03cfd571284$export$e4feded94d9adb18)(nativeClient.acquireTokenRedirect.bind(nativeClient), (0, $acc47f0f594e8d22$export$7b5471de971cecfc), this.logger, this.performanceClient, correlationId)(request, atrMeasurement).catch((e)=>{
                    atrMeasurement.add({
                        brokerErrorName: e.name,
                        brokerErrorCode: e.errorCode
                    });
                    if (e instanceof (0, $8cc7862cecd95c0a$export$4b8a4f6256e840ab) && (0, $8cc7862cecd95c0a$export$f21e42e365baeb50)(e)) {
                        this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    } else if (e instanceof (0, $e9bbb17645bd3149$export$6ba3e818c6bc76ba)) {
                        this.logger.verbose("1ipyz4", correlationId);
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    }
                    throw e;
                });
            } else {
                const redirectClient = this.createRedirectClient(correlationId);
                result = redirectClient.acquireToken(request);
            }
            return await result;
        } catch (e) {
            this.browserStorage.resetRequestCache(correlationId);
            /*
             * Pre-redirect event completes before navigation occurs.
             * Timed out navigation needs to be instrumented separately as a post-redirect event.
             */ if (atrMeasurement.event.status === 2) this.performanceClient.startMeasurement((0, $65145b346c45554a$export$8fbc8506f7dfc43c), correlationId).end({
                success: false
            }, e, request.account);
            else atrMeasurement.end({
                success: false
            }, e, request.account);
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect, null, e);
            throw e;
        }
    }
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$8eece1dda35ee9eb), correlationId);
        atPopupMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            this.logger.verbose("0ch87b", correlationId);
            $52bd6e9c9be84db3$var$preflightCheck(this.initialized, atPopupMeasurement, this.config, request);
            this.browserStorage.setInteractionInProgress(true, (0, $7101cc4ee26a17a4$export$dc1d3aa5f3837765).SIGNIN, request.overrideInteractionInProgress, correlationId);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        const loggedInAccounts = this.getAllAccounts();
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_START, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, request);
        let result;
        const pkce = this.getPreGeneratedPkceCodes(correlationId);
        if (this.canUsePlatformBroker(request)) {
            atPopupMeasurement.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative({
                ...request,
                correlationId: correlationId
            }, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenPopup).then((response)=>{
                atPopupMeasurement.end({
                    success: true,
                    isNativeBroker: true
                }, undefined, response.account);
                return response;
            }).catch((e)=>{
                atPopupMeasurement.add({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                });
                if (e instanceof (0, $8cc7862cecd95c0a$export$4b8a4f6256e840ab) && (0, $8cc7862cecd95c0a$export$f21e42e365baeb50)(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                } else if (e instanceof (0, $e9bbb17645bd3149$export$6ba3e818c6bc76ba)) {
                    this.logger.verbose("0yy5fw", correlationId);
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                }
                throw e;
            });
        } else {
            const popupClient = this.createPopupClient(correlationId);
            result = popupClient.acquireToken(request, pkce);
        }
        return result.then((result)=>{
            /*
             *  If logged in, emit acquire token events
             */ const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, result);
            if (isLoggingIn) this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGIN_SUCCESS, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, result.account);
            atPopupMeasurement.end({
                success: true,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            // SSO capability verification in background
            this.verifySsoCapability(request, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup);
            return result;
        }).catch((e)=>{
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }).finally(async ()=>{
            this.browserStorage.setInteractionInProgress(false);
            if (!this.config.system.navigatePopups) await this.preGeneratePkceCodes(correlationId);
        });
    }
    trackStateChangeWithMeasurement(event) {
        const measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        if (event.type === "visibilitychange") {
            this.logger.info(`0yzimq ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                visibilityChangeCount: 1
            });
        } else if (event.type === "online") {
            this.logger.info(`1caf53 ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                onlineStatusChangeCount: 1
            });
        } else if (event.type === "offline") {
            this.logger.info(`0fdyk7 ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                onlineStatusChangeCount: 1
            });
        }
    }
    addStateChangeListeners(listener) {
        document.addEventListener("visibilitychange", listener);
        window.addEventListener("online", listener);
        window.addEventListener("offline", listener);
    }
    removeStateChangeListeners(listener) {
        document.removeEventListener("visibilitychange", listener);
        window.removeEventListener("online", listener);
        window.removeEventListener("offline", listener);
    }
    /**
     * Reads the cached ssoCapable value from localStorage.
     * @returns The cached ssoCapable boolean value, or undefined if not cached or expired.
     */ getCachedSsoCapable() {
        try {
            const cachedValue = window.localStorage.getItem((0, $6669d8f0f59e64dc$export$4a19efda043b2ab6));
            if (cachedValue) {
                const parsed = JSON.parse(cachedValue);
                if (parsed && typeof parsed.ssoCapable === "boolean" && parsed.expiresOn && Date.now() < parsed.expiresOn) return parsed.ssoCapable;
            }
        } catch  {
        // If parsing fails, return undefined
        }
        return undefined;
    }
    /**
     * SSO capability verification in the background.
     * This method makes an iframe request to /authorize to verify SSO capability without calling /token.
     * This method does not block the caller and tracks telemetry for success/failure.
     * This method only executes if verifySSO is set to true in the auth configuration.
     * The result is cached in localStorage with a 24-hour TTL; the SSO verification call
     * is only attempted when the cached value is absent or expired.
     * @param request - The original request used for the authentication flow
     * @param interactionType - The interactionType of the AT operation for logging purposes
     */ verifySsoCapability(request, interactionType) {
        // Check if SSO capability verification is enabled
        if (!this.config.auth.verifySSO) return;
        // Check TTL: derive ssoCapable state from localStorage and skip if not expired
        const ssoCacheKey = (0, $6669d8f0f59e64dc$export$4a19efda043b2ab6);
        const SSO_CAPABLE_TTL_MS = 86400000; // 24 hours
        const cachedSsoCapable = this.getCachedSsoCapable();
        if (cachedSsoCapable !== undefined) {
            this.logger.verbose(`13poou ${interactionType}`, "");
            return;
        }
        const correlationId = (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)();
        const ssoCapableMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$7caf697918d46b97), correlationId);
        ssoCapableMeasurement.add({
            "ext.interactionType": interactionType
        });
        this.logger.verbose(`0pbr0i ${interactionType}`, correlationId);
        /*
         * Use setTimeout to ensure this runs in a separate macrotask after the current call stack completes
         * This ensures the result is returned to the caller before the SSO verification starts and doesn't affect performance
         */ setTimeout(()=>{
            const ssoVerificationRequest = {
                ...request,
                correlationId: correlationId
            };
            const silentIframeClient = this.createSilentIframeClient(correlationId);
            silentIframeClient.verifySso(ssoVerificationRequest).then((result)=>{
                this.logger.verbose(`1gd1iv ${interactionType} ${result}`, correlationId);
                // TBD to add profileTelemetry later in localStorage with 24h TTL
                try {
                    const cacheEntry = JSON.stringify({
                        ssoCapable: result,
                        expiresOn: Date.now() + SSO_CAPABLE_TTL_MS
                    });
                    window.localStorage.setItem(ssoCacheKey, cacheEntry);
                } catch  {
                    this.logger.warning(`18lmoj ${interactionType}`, correlationId);
                }
                ssoCapableMeasurement.end({
                    fromCache: false,
                    success: result
                }, undefined);
            }).catch((error)=>{
                this.logger.warning(`05g83w ${interactionType} ${error.message}`, correlationId);
                // reset the cache
                try {
                    window.localStorage.removeItem(ssoCacheKey);
                } catch  {
                    this.logger.warning(`0nlf9q ${interactionType}`, correlationId);
                }
                ssoCapableMeasurement.end({
                    fromCache: false,
                    success: false
                }, error);
            });
        }, 0);
    }
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async ssoSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const validRequest = {
            ...request,
            correlationId: correlationId
        };
        this.ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$2da6f47a70635e40), correlationId);
        this.ssoSilentMeasurement?.add({
            scenarioId: request.scenarioId,
            ssoCapable: this.getCachedSsoCapable()
        });
        $52bd6e9c9be84db3$var$preflightCheck(this.initialized, this.ssoSilentMeasurement, this.config, validRequest);
        this.ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        });
        this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
        const loggedInAccounts = this.getAllAccounts();
        this.logger.verbose("0w1b45", correlationId);
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_START, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, validRequest);
        let result;
        if (this.canUsePlatformBroker(validRequest)) {
            this.ssoSilentMeasurement?.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative(validRequest, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).ssoSilent).catch((e)=>{
                this.ssoSilentMeasurement?.add({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                });
                // If native token acquisition fails for availability reasons fallback to standard flow
                if (e instanceof (0, $8cc7862cecd95c0a$export$4b8a4f6256e840ab) && (0, $8cc7862cecd95c0a$export$f21e42e365baeb50)(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                    const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                    return silentIframeClient.acquireToken(validRequest);
                }
                throw e;
            });
        } else {
            const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
            result = silentIframeClient.acquireToken(validRequest);
        }
        return result.then((response)=>{
            const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, response);
            if (isLoggingIn) this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGIN_SUCCESS, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, response.account);
            this.ssoSilentMeasurement?.end({
                success: true,
                isNativeBroker: response.fromPlatformBroker,
                accessTokenSize: response.accessToken.length,
                idTokenSize: response.idToken.length
            }, undefined, response.account);
            return response;
        }).catch((e)=>{
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, null, e);
            this.ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw e;
        }).finally(()=>{
            this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
        });
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenByCode(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("0ch6ga", correlationId);
        const atbcMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$8535c832f2be2140), correlationId);
        $52bd6e9c9be84db3$var$preflightCheck(this.initialized, atbcMeasurement, this.config, request);
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_START, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, request);
        atbcMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
            throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$1efb009e9d75bbe4), correlationId);
            else if (request.code) {
                const hybridAuthCode = request.code;
                let response = this.hybridAuthCodeResponses.get(hybridAuthCode);
                if (!response) {
                    this.logger.verbose("06eh73", correlationId);
                    response = this.acquireTokenByCodeAsync({
                        ...request,
                        correlationId: correlationId
                    }).then((result)=>{
                        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, result);
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        atbcMeasurement.end({
                            success: true,
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length
                        }, undefined, result.account);
                        return result;
                    }).catch((error)=>{
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, null, error);
                        atbcMeasurement.end({
                            success: false
                        }, error);
                        throw error;
                    });
                    this.hybridAuthCodeResponses.set(hybridAuthCode, response);
                } else {
                    this.logger.verbose("0qgp28", correlationId);
                    atbcMeasurement.discard();
                }
                return await response;
            } else if (request.nativeAccountId) {
                if (this.canUsePlatformBroker(request, request.nativeAccountId)) {
                    atbcMeasurement.add({
                        isPlatformBrokerRequest: true
                    });
                    const result = await this.acquireTokenNative({
                        ...request,
                        correlationId: correlationId
                    }, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenByCode, request.nativeAccountId).catch((e)=>{
                        atbcMeasurement.add({
                            brokerErrorName: e.name,
                            brokerErrorCode: e.errorCode
                        });
                        // If native token acquisition fails for availability reasons fallback to standard flow
                        if (e instanceof (0, $8cc7862cecd95c0a$export$4b8a4f6256e840ab) && (0, $8cc7862cecd95c0a$export$f21e42e365baeb50)(e)) this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        throw e;
                    });
                    atbcMeasurement.end({
                        success: true
                    }, undefined, result.account);
                    return result;
                } else throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$b897bbe2c683def2), correlationId);
            } else throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$8bea68053103eaeb), correlationId);
        } catch (e) {
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, null, e);
            atbcMeasurement.end({
                success: false
            }, e);
            throw e;
        }
    }
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ async acquireTokenByCodeAsync(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("10d9hy", correlationId);
        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement((0, $acc47f0f594e8d22$export$39ed3fafad4d8fb4), correlationId);
        this.acquireTokenByCodeAsyncMeasurement?.increment({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        });
        this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
        const silentAuthCodeClient = this.createSilentAuthCodeClient(correlationId);
        const silentTokenResult = await silentAuthCodeClient.acquireToken(request).then((response)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: true,
                fromCache: response.fromCache
            });
            return response;
        }).catch((tokenRenewalError)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: false
            }, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
        });
        return silentTokenResult;
    }
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenFromCache(commonRequest, cacheLookupPolicy) {
        switch(cacheLookupPolicy){
            case (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).Default:
            case (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).AccessToken:
            case (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                const silentCacheClient = this.createSilentCacheClient(commonRequest.correlationId);
                return (0, $69bce03cfd571284$export$e4feded94d9adb18)(silentCacheClient.acquireToken.bind(silentCacheClient), (0, $acc47f0f594e8d22$export$d17448fed671f254), this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).tokenRefreshRequired, commonRequest.correlationId);
        }
    }
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param cacheLookupPolicy CacheLookupPolicy
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenByRefreshToken(commonRequest, cacheLookupPolicy) {
        switch(cacheLookupPolicy){
            case (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).Default:
            case (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
            case (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).RefreshToken:
            case (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).RefreshTokenAndNetwork:
                const silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                return (0, $69bce03cfd571284$export$e4feded94d9adb18)(silentRefreshClient.acquireToken.bind(silentRefreshClient), (0, $acc47f0f594e8d22$export$aa71423206472289), this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).tokenRefreshRequired, commonRequest.correlationId);
        }
    }
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenBySilentIframe(request) {
        const silentIframeClient = this.createSilentIframeClient(request.correlationId);
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)(silentIframeClient.acquireToken.bind(silentIframeClient), (0, $acc47f0f594e8d22$export$cad3a91a6c9c24dc), this.logger, this.performanceClient, request.correlationId)(request);
    }
    // #endregion
    // #region Logout
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logoutRedirect(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        (0, $8e677587a7c978db$export$62c8f4fdca4df60f)(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true, (0, $7101cc4ee26a17a4$export$dc1d3aa5f3837765).SIGNOUT);
        const redirectClient = this.createRedirectClient(correlationId);
        return redirectClient.logout(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        try {
            const correlationId = this.getRequestCorrelationId(logoutRequest);
            (0, $8e677587a7c978db$export$4dd091cbdc98b52e)(this.initialized);
            this.browserStorage.setInteractionInProgress(true, (0, $7101cc4ee26a17a4$export$dc1d3aa5f3837765).SIGNOUT);
            const popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest).finally(()=>{
                this.browserStorage.setInteractionInProgress(false);
            });
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Creates a cache interaction client to clear broswer cache.
     * @param logoutRequest
     */ async clearCache(logoutRequest) {
        if (!this.isBrowserEnvironment) return;
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        const cacheClient = this.createSilentCacheClient(correlationId);
        return cacheClient.logout(logoutRequest);
    }
    // #endregion
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return (0, $9e3c3c60dcb65490$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnvironment, this.getRequestCorrelationId(), accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return (0, $9e3c3c60dcb65490$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage, this.getRequestCorrelationId());
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        (0, $9e3c3c60dcb65490$export$c55c3d25cf1bcd99)(account, this.browserStorage, this.getRequestCorrelationId());
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return (0, $9e3c3c60dcb65490$export$13dd2e33a23839ad)(this.browserStorage, this.getRequestCorrelationId());
    }
    // #endregion
    /**
     * Hydrates the cache with the tokens from an AuthenticationResult
     * @param result
     * @param request
     * @returns
     */ async hydrateCache(result, request) {
        this.logger.verbose("16jycr", result.correlationId);
        // Account gets saved to browser storage regardless of native or not
        const accountEntity = (0, $f136bee61a3373e4$exports).createAccountEntityFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, (0, $4acd0486289e3b4f$exports).isKmsi(result.idTokenClaims), (0, $7101cc4ee26a17a4$export$192d74ad69b40705).hydrateCache);
        if (result.fromPlatformBroker) {
            this.logger.verbose("1i5atf", result.correlationId);
            // Create idToken entity and store in browser storage
            const idTokenEntity = (0, $4cd4d8a6d71d39a8$exports).createIdTokenEntity(result.account.homeAccountId, result.account.environment, result.idToken, this.config.auth.clientId, result.tenantId);
            // Create accessToken entity and store in native internal storage
            const accessTokenEntity = (0, $4cd4d8a6d71d39a8$exports).createAccessTokenEntity(result.account.homeAccountId, result.account.environment, result.accessToken, this.config.auth.clientId, result.tenantId, result.scopes.join(" "), result.expiresOn ? (0, $e0616e53cd3f026f$exports).toSecondsFromDate(result.expiresOn) : 0, result.extExpiresOn ? (0, $e0616e53cd3f026f$exports).toSecondsFromDate(result.extExpiresOn) : 0, (0, $5949979cf1605326$export$c62426fdd000a97e), request.correlationId || "", undefined, result.tokenType, undefined, request.sshKid);
            if (request.resource) accessTokenEntity.resource = request.resource;
            const kmsi = (0, $4acd0486289e3b4f$exports).isKmsi(result.idTokenClaims);
            // Store idToken in browser storage
            await this.browserStorage.setIdTokenCredential(idTokenEntity, result.correlationId, kmsi);
            // Store accessToken in native internal storage
            await this.nativeInternalStorage.setAccessTokenCredential(accessTokenEntity, result.correlationId, kmsi);
        } else return this.browserStorage.hydrateCache(result, request);
    }
    // #region Helpers
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     */ async acquireTokenNative(request, apiId, accountId, cacheLookupPolicy) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("0b9y3p", correlationId);
        if (!this.platformAuthProvider) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$7b7357e3538624aa), correlationId);
        const nativeClient = new (0, $9a0ce6cc67a0db6b$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.platformAuthProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, correlationId);
        return (0, $69bce03cfd571284$export$e4feded94d9adb18)(nativeClient.acquireToken.bind(nativeClient), (0, $acc47f0f594e8d22$export$6939ff7b9b362e6d), this.logger, this.performanceClient, correlationId)(request, cacheLookupPolicy);
    }
    /**
     * Returns boolean indicating if this request can use the platform broker
     * @param request
     */ canUsePlatformBroker(request, accountId) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("1n9lbl", correlationId);
        if (!this.platformAuthProvider) {
            this.logger.trace("0vnu11", correlationId);
            return false;
        }
        if (!(0, $0f1c35249bd71733$export$4815cc9f88d4f6a5)(this.config, this.logger, correlationId, this.platformAuthProvider, request.authenticationScheme)) {
            this.logger.trace("0yoy1g", correlationId);
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case (0, $8994aeee5e01080d$exports).PromptValue.NONE:
            case (0, $8994aeee5e01080d$exports).PromptValue.CONSENT:
            case (0, $8994aeee5e01080d$exports).PromptValue.LOGIN:
                this.logger.trace("0vdv8e", correlationId);
                break;
            default:
                this.logger.trace(`0pdzw6 ${request.prompt}`, correlationId);
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("16lbtk", correlationId);
            return false;
        }
        return true;
    }
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ getNativeAccountId(request) {
        const account = request.account || this.getAccount({
            loginHint: request.loginHint,
            sid: request.sid
        }) || (!request.loginHint && !request.sid ? this.getActiveAccount() : null);
        return account && account.nativeAccountId || "";
    }
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ createPopupClient(correlationId) {
        return new (0, $698b575715aaca34$export$43b0fce132d066f4)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider, this.operatingContext.getResponseHandlers()?.waitForPopupResponse);
    }
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ createRedirectClient(correlationId) {
        return new (0, $2ddf9de1d228c373$export$a368977effbc1ed6)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider);
    }
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ createSilentIframeClient(correlationId) {
        return new (0, $0956cbdf3eea11f6$export$e81c7938bccef977)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).ssoSilent, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider, this.operatingContext.getResponseHandlers()?.waitForIframeResponse);
    }
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ createSilentCacheClient(correlationId) {
        return new (0, $a376ef2f5068f2a9$export$59d4f873ee62d01e)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, correlationId, this.platformAuthProvider);
    }
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ createSilentRefreshClient(correlationId) {
        return new (0, $36ade668a744777e$export$b4a36596822a5d2)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, correlationId, this.platformAuthProvider);
    }
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ createSilentAuthCodeClient(correlationId) {
        return new (0, $600fe559a2f36d9c$export$d7f5ef311b3e9fca)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenByCode, this.performanceClient, correlationId, this.platformAuthProvider);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        (0, $8e677587a7c978db$export$c7939bfe92ae2787)();
        return this.performanceClient.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.navigationClient = navigationClient;
    }
    /**
     * Returns the configuration object
     */ getConfiguration() {
        return this.config;
    }
    /**
     * Returns the performance client
     */ getPerformanceClient() {
        return this.performanceClient;
    }
    /**
     * Returns the browser env indicator
     */ isBrowserEnv() {
        return this.isBrowserEnvironment;
    }
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ getRequestCorrelationId(request) {
        if (request?.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return "";
    }
    // #endregion
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async loginRedirect(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0lz9hf", correlationId);
        return this.acquireTokenRedirect({
            correlationId: correlationId,
            ...request || (0, $7101cc4ee26a17a4$export$7e12949cd6884193)
        });
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0qw7v5", correlationId);
        return this.acquireTokenPopup({
            correlationId: correlationId,
            ...request || (0, $7101cc4ee26a17a4$export$7e12949cd6884193)
        });
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ async acquireTokenSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atsMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$ef5b8273b1c66495), correlationId);
        atsMeasurement.add({
            cacheLookupPolicy: request.cacheLookupPolicy,
            scenarioId: request.scenarioId,
            ssoCapable: this.getCachedSsoCapable()
        });
        $52bd6e9c9be84db3$var$preflightCheck(this.initialized, atsMeasurement, this.config, request);
        this.logger.verbose("0x1c4s", correlationId);
        const account = request.account || this.getActiveAccount();
        if (!account) throw (0, $e015633e658266f1$export$72f7b48f3bc1d4cb)((0, $8a281d620a4036a7$export$87933d7d4116cb12), correlationId);
        return this.acquireTokenSilentDeduped(request, account, correlationId).then((result)=>{
            atsMeasurement.end({
                success: true,
                fromCache: result.fromCache,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            return {
                ...result,
                state: request.state,
                correlationId: correlationId
            };
        }).catch((error)=>{
            if (error instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)) // Ensures PWB scenarios can correctly match request to response
            error.correlationId = correlationId;
            atsMeasurement.end({
                success: false
            }, error, account);
            throw error;
        });
    }
    /**
     * Checks if identical request is already in flight and returns reference to the existing promise or fires off a new one if this is the first
     * @param request
     * @param account
     * @param correlationId
     * @returns
     */ async acquireTokenSilentDeduped(request, account, correlationId) {
        const thumbprint = (0, $1a839cf816c84c9b$export$2daa8cfcf54c2b48)(this.config.auth.clientId, {
            ...request,
            authority: request.authority || this.config.auth.authority,
            correlationId: correlationId
        }, account.homeAccountId);
        const silentRequestKey = JSON.stringify(thumbprint);
        const inProgressRequest = this.activeSilentTokenRequests.get(silentRequestKey);
        if (typeof inProgressRequest === "undefined") {
            this.logger.verbose("0fcjbk", correlationId);
            this.performanceClient.addFields({
                deduped: false
            }, correlationId);
            const activeRequest = (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.acquireTokenSilentAsync.bind(this), (0, $acc47f0f594e8d22$export$234ca59652d54f20), this.logger, this.performanceClient, correlationId)({
                ...request,
                correlationId: correlationId
            }, account);
            this.activeSilentTokenRequests.set(silentRequestKey, activeRequest);
            return activeRequest.finally(()=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
            });
        } else {
            this.logger.verbose("1yq7nb", correlationId);
            this.performanceClient.addFields({
                deduped: true
            }, correlationId);
            return inProgressRequest;
        }
    }
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ async acquireTokenSilentAsync(request, account) {
        const trackStateChange = (event)=>this.trackStateChange(request.correlationId, event);
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_START, request.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, request);
        if (request.correlationId) this.performanceClient.incrementFields({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        }, request.correlationId);
        this.addStateChangeListeners(trackStateChange);
        const silentRequest = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $e54e4b4a24079223$export$4c8aa78c426811d4), (0, $acc47f0f594e8d22$export$c4741a5a0838f7c), this.logger, this.performanceClient, request.correlationId)(request, account, this.config, this.performanceClient, this.logger);
        const cacheLookupPolicy = request.cacheLookupPolicy || (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).Default;
        const result = this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy).catch(async (refreshTokenError)=>{
            const shouldTryToResolveSilently = $52bd6e9c9be84db3$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy);
            if (shouldTryToResolveSilently) {
                const silentRefreshReason = `${refreshTokenError.errorCode}${refreshTokenError.subError ? `|${refreshTokenError.subError}` : ""}`;
                this.performanceClient.addFields({
                    silentRefreshReason: silentRefreshReason
                }, request.correlationId);
                if (!this.activeIframeRequest) {
                    let _resolve;
                    // Always set the active request tracker immediately after checking it to prevent races
                    this.activeIframeRequest = [
                        new Promise((resolve)=>{
                            _resolve = resolve;
                        }),
                        silentRequest.correlationId
                    ];
                    this.logger.verbose("0rh08z", silentRequest.correlationId);
                    return (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $acc47f0f594e8d22$export$1f97c40875a1f78c), this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest).then((iframeResult)=>{
                        _resolve(true);
                        return iframeResult;
                    }).catch((e)=>{
                        _resolve(false);
                        throw e;
                    }).finally(()=>{
                        this.activeIframeRequest = undefined;
                    });
                } else if (cacheLookupPolicy !== (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).Skip) {
                    const [activePromise, activeCorrelationId] = this.activeIframeRequest;
                    this.logger.verbose(`1w8fso ${activeCorrelationId}`, silentRequest.correlationId);
                    const awaitConcurrentIframeMeasure = this.performanceClient.startMeasurement((0, $acc47f0f594e8d22$export$4616f8f2f8e44472), silentRequest.correlationId);
                    awaitConcurrentIframeMeasure.add({
                        awaitIframeCorrelationId: activeCorrelationId
                    });
                    const activePromiseResult = await activePromise;
                    awaitConcurrentIframeMeasure.end({
                        success: activePromiseResult
                    });
                    if (activePromiseResult) {
                        this.logger.verbose(`0ywzzi ${activeCorrelationId}`, silentRequest.correlationId);
                        // Retry cache lookup and/or RT exchange after iframe completes
                        return this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy);
                    } else {
                        this.logger.info(`17y14q ${activeCorrelationId}`, silentRequest.correlationId);
                        // If previous iframe request failed, it's unlikely to succeed this time. Throw original error.
                        throw refreshTokenError;
                    }
                } else {
                    // Cache policy set to skip and another iframe request is already in progress
                    this.logger.warning("1bd4p8", silentRequest.correlationId);
                    return (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $acc47f0f594e8d22$export$1f97c40875a1f78c), this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
                }
            } else // Error cannot be silently resolved or iframe renewal is not allowed, interaction required
            throw refreshTokenError;
        });
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, request.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, response);
            if (request.correlationId) this.performanceClient.addFields({
                fromCache: response.fromCache,
                isNativeBroker: response.fromPlatformBroker
            }, request.correlationId);
            return response;
        }).catch((tokenRenewalError)=>{
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, request.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, null, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            this.removeStateChangeListeners(trackStateChange);
        });
    }
    /**
     * AcquireTokenSilent without the iframe fallback. This is used to enable the correct fallbacks in cases where there's a potential for multiple silent requests to be made in parallel and prevent those requests from making concurrent iframe requests.
     * @param silentRequest
     * @param cacheLookupPolicy
     * @returns
     */ async acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy) {
        // if the cache policy is set to access_token only, we should not be hitting the native layer yet
        if ((0, $0f1c35249bd71733$export$4815cc9f88d4f6a5)(this.config, this.logger, silentRequest.correlationId, this.platformAuthProvider, silentRequest.authenticationScheme) && silentRequest.account.nativeAccountId) {
            this.logger.verbose("0sczo4", silentRequest.correlationId);
            this.performanceClient.addFields({
                isPlatformBrokerRequest: true
            }, silentRequest.correlationId);
            return this.acquireTokenNative(silentRequest, (0, $7101cc4ee26a17a4$export$192d74ad69b40705).acquireTokenSilent_silentFlow, silentRequest.account.nativeAccountId, cacheLookupPolicy).catch(async (e)=>{
                this.performanceClient.addFields({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                }, silentRequest.correlationId);
                // If native token acquisition fails for availability reasons fallback to web flow
                if (e instanceof (0, $8cc7862cecd95c0a$export$4b8a4f6256e840ab) && (0, $8cc7862cecd95c0a$export$f21e42e365baeb50)(e)) {
                    this.logger.verbose("07rkmb", silentRequest.correlationId);
                    this.platformAuthProvider = undefined; // Prevent future requests from continuing to attempt
                    // Cache will not contain tokens, given that previous WAM requests succeeded. Skip cache and RT renewal and go straight to iframe renewal
                    throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).tokenRefreshRequired, silentRequest.correlationId);
                }
                throw e;
            });
        } else {
            this.logger.verbose("0ox81t", silentRequest.correlationId);
            // add logs to identify embedded cache retrieval
            if (cacheLookupPolicy === (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).AccessToken) this.logger.verbose("0fvwxe", silentRequest.correlationId);
            return (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.acquireTokenFromCache.bind(this), (0, $acc47f0f594e8d22$export$5ea798579d1036d1), this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy).catch((cacheError)=>{
                if (cacheLookupPolicy === (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).AccessToken) throw cacheError;
                this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_NETWORK_START, silentRequest.correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, silentRequest);
                return (0, $69bce03cfd571284$export$e4feded94d9adb18)(this.acquireTokenByRefreshToken.bind(this), (0, $acc47f0f594e8d22$export$76454c1307aa041e), this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy);
            });
        }
    }
    /**
     * Pre-generates PKCE codes and stores it in local variable
     * @param correlationId
     */ async preGeneratePkceCodes(correlationId) {
        this.logger.verbose("1x6uj6", correlationId);
        this.pkceCode = await (0, $69bce03cfd571284$export$e4feded94d9adb18)((0, $d0efbde2aa549bff$export$91d5e5a023803853), (0, $acc47f0f594e8d22$export$5a7b24ab3b501c09), this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        return Promise.resolve();
    }
    /**
     * Provides pre-generated PKCE codes, if any
     * @param correlationId
     */ getPreGeneratedPkceCodes(correlationId) {
        const res = this.pkceCode ? {
            ...this.pkceCode
        } : undefined;
        this.pkceCode = undefined;
        if (res) this.logger.verbose("12js1o", correlationId);
        else this.logger.verbose("1oe9ci", correlationId);
        this.performanceClient.addFields({
            usePreGeneratedPkce: !!res
        }, correlationId);
        return res;
    }
    logMultipleInstances(performanceEvent, correlationId) {
        const clientId = this.config.auth.clientId;
        if (!window) return;
        // @ts-ignore
        window.msal = window.msal || {};
        // @ts-ignore
        window.msal.clientIds = window.msal.clientIds || [];
        // @ts-ignore
        const clientIds = window.msal.clientIds;
        if (clientIds.length > 0) this.logger.verbose("1qtz3l", correlationId);
        // @ts-ignore
        window.msal.clientIds.push(clientId);
        (0, $e5e76794f907911a$export$fe0570c25bf19cec)(clientId, performanceEvent, this.logger, correlationId);
    }
}
/**
 * Determines whether an error thrown by the refresh token endpoint can be resolved without interaction
 * @param refreshTokenError
 * @param silentRequest
 * @param cacheLookupPolicy
 * @returns
 */ function $52bd6e9c9be84db3$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy) {
    const noInteractionRequired = !(refreshTokenError instanceof (0, $e9bbb17645bd3149$export$6ba3e818c6bc76ba) && // For refresh token errors, bad_token does not always require interaction (silently resolvable)
    refreshTokenError.subError !== (0, $65a17b77f45cb3f9$exports).badToken);
    // Errors that result when the refresh token needs to be replaced
    const refreshTokenRefreshRequired = refreshTokenError.errorCode === (0, $7101cc4ee26a17a4$export$a0a689e4294b9880).INVALID_GRANT_ERROR || refreshTokenError.errorCode === (0, $11e3a50b38764cc5$exports).tokenRefreshRequired;
    // Errors that may be resolved before falling back to interaction (through iframe renewal)
    const isSilentlyResolvable = noInteractionRequired && refreshTokenRefreshRequired || refreshTokenError.errorCode === (0, $65a17b77f45cb3f9$exports).noTokensFound || refreshTokenError.errorCode === (0, $65a17b77f45cb3f9$exports).refreshTokenExpired;
    // Only these policies allow for an iframe renewal attempt
    const tryIframeRenewal = (0, $7101cc4ee26a17a4$export$736180706fb122ee).includes(cacheLookupPolicy);
    return isSilentlyResolvable && tryIframeRenewal;
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ /*! @azure/msal-browser v5.16.0 2026-06-30 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base class for operating context
 * Operating contexts are contexts in which MSAL.js is being run
 * More than one operating context may be available at a time
 * It's important from a logging and telemetry point of view for us to be able to identify the operating context.
 * For example: Some operating contexts will pre-cache tokens impacting performance telemetry
 */ class $43f6bae731ff8d3a$export$3aea257f46651b2b {
    static loggerCallback(level, message) {
        switch(level){
            case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Error:
                // eslint-disable-next-line no-console
                console.error(message);
                return;
            case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Info:
                // eslint-disable-next-line no-console
                console.info(message);
                return;
            case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Verbose:
                // eslint-disable-next-line no-console
                console.debug(message);
                return;
            case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Warning:
                // eslint-disable-next-line no-console
                console.warn(message);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(message);
                return;
        }
    }
    constructor(config, responseHandlers){
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.browserEnvironment = typeof window !== "undefined";
        this.config = (0, $6aa2fe410d14ea27$export$f8352245bee68086)(config, this.browserEnvironment);
        this.responseHandlers = responseHandlers;
        let sessionStorage;
        try {
            sessionStorage = window[(0, $7101cc4ee26a17a4$export$573384e47a12d835).SessionStorage];
        // Mute errors if it's a non-browser environment or cookies are blocked.
        } catch (e) {}
        const logLevelKey = sessionStorage?.getItem((0, $6669d8f0f59e64dc$export$b28668d53eb57e63));
        const piiLoggingKey = sessionStorage?.getItem((0, $6669d8f0f59e64dc$export$d9bc1c202a3825f1))?.toLowerCase();
        const piiLoggingEnabled = piiLoggingKey === "true" ? true : piiLoggingKey === "false" ? false : undefined;
        const loggerOptions = {
            ...this.config.system.loggerOptions
        };
        const logLevel = logLevelKey && Object.keys((0, $0fd93c953107c2f4$export$243e62d78d3b544d)).includes(logLevelKey) ? (0, $0fd93c953107c2f4$export$243e62d78d3b544d)[logLevelKey] : undefined;
        if (logLevel) {
            loggerOptions.loggerCallback = $43f6bae731ff8d3a$export$3aea257f46651b2b.loggerCallback;
            loggerOptions.logLevel = logLevel;
        }
        if (piiLoggingEnabled !== undefined) loggerOptions.piiLoggingEnabled = piiLoggingEnabled;
        this.logger = new (0, $0fd93c953107c2f4$export$efa9a398d6368992)(loggerOptions, (0, $c8226bf52dd9a4ef$export$a8ff84c12d48cfa6), (0, $c8226bf52dd9a4ef$export$83d89fbfd8236492));
        this.available = false;
    }
    /**
     * Return the MSAL config
     * @returns BrowserConfiguration
     */ getConfig() {
        return this.config;
    }
    /**
     * Returns the internal response handlers supplied by PublicClientApplication, if any.
     * @returns AuthResponseHandlers | undefined
     */ getResponseHandlers() {
        return this.responseHandlers;
    }
    /**
     * Returns the MSAL Logger
     * @returns Logger
     */ getLogger() {
        return this.logger;
    }
    isAvailable() {
        return this.available;
    }
    isBrowserEnvironment() {
        return this.browserEnvironment;
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $ec80fcc8b6adfb3c$export$f39c23bbfed89e6e extends (0, $43f6bae731ff8d3a$export$3aea257f46651b2b) {
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $ec80fcc8b6adfb3c$export$f39c23bbfed89e6e.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $ec80fcc8b6adfb3c$export$f39c23bbfed89e6e.ID;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async initialize(correlationId) {
        this.available = typeof window !== "undefined";
        return this.available;
    /*
         * NOTE: The standard context is available as long as there is a window.  If/when we split out WAM from Browser
         * We can move the current contents of the initialize method to here and verify that the WAM extension is available
         */ }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $ec80fcc8b6adfb3c$export$f39c23bbfed89e6e.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $ec80fcc8b6adfb3c$export$f39c23bbfed89e6e.ID = "StandardOperatingContext";


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 



/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $25f8be65a9f10751$export$caa3bc10e51dd7ee(error) {
    return error.status !== undefined;
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $1a1c6a045f124f72$export$6d05f68c12a46a00 = {
    UserInteractionRequired: "USER_INTERACTION_REQUIRED",
    UserCancel: "USER_CANCEL",
    NoNetwork: "NO_NETWORK",
    TransientError: "TRANSIENT_ERROR",
    PersistentError: "PERSISTENT_ERROR",
    Disabled: "DISABLED",
    AccountUnavailable: "ACCOUNT_UNAVAILABLE",
    NestedAppAuthUnavailable: "NESTED_APP_AUTH_UNAVAILABLE"
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $cdcf5fb47cd16823$export$cee94b20506f02aa {
    constructor(clientId, clientCapabilities, crypto, logger){
        this.clientId = clientId;
        this.clientCapabilities = clientCapabilities;
        this.crypto = crypto;
        this.logger = logger;
    }
    toNaaTokenRequest(request) {
        let extraParams;
        if (request.extraQueryParameters === undefined) extraParams = new Map();
        else extraParams = new Map(Object.entries(request.extraQueryParameters));
        const correlationId = request.correlationId || this.crypto.createNewGuid();
        const claims = (0, $25d69fa430040087$exports).buildMergedClaims(request.claims, this.clientCapabilities);
        const scopes = request.scopes || (0, $8994aeee5e01080d$exports).OIDC_DEFAULT_SCOPES;
        const tokenRequest = {
            platformBrokerId: request.account?.homeAccountId,
            clientId: this.clientId,
            authority: request.authority,
            resource: request.resource,
            scope: scopes.join(" "),
            correlationId: correlationId,
            claims: !(0, $4204b6e4994e8227$export$ecc754f99843e759).isEmptyObj(claims) ? claims : undefined,
            state: request.state,
            authenticationScheme: request.authenticationScheme || (0, $8994aeee5e01080d$exports).AuthenticationScheme.BEARER,
            extraParameters: extraParams
        };
        return tokenRequest;
    }
    fromNaaTokenResponse(request, response, reqTimestamp) {
        if (!response.token.id_token || !response.token.access_token) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).nullOrEmptyToken, request.correlationId);
        // Request timestamp and AuthResult expires_in are in seconds, converting to Date for AuthenticationResult
        const expiresOn = (0, $e0616e53cd3f026f$exports).toDateFromSeconds(reqTimestamp + (response.token.expires_in || 0));
        const idTokenClaims = (0, $4acd0486289e3b4f$exports).extractTokenClaims(response.token.id_token, this.crypto.base64Decode, request.correlationId);
        const account = this.fromNaaAccountInfo(response.account, response.token.id_token, idTokenClaims);
        const scopes = response.token.scope || request.scope;
        const authenticationResult = {
            authority: response.token.authority || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: response.token.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: response.token.access_token,
            fromCache: false,
            expiresOn: expiresOn,
            tokenType: request.authenticationScheme || (0, $8994aeee5e01080d$exports).AuthenticationScheme.BEARER,
            correlationId: request.correlationId,
            extExpiresOn: expiresOn,
            state: request.state
        };
        return authenticationResult;
    }
    /*
     *  export type AccountInfo = {
     *     homeAccountId: string;
     *     environment: string;
     *     tenantId: string;
     *     username: string;
     *     localAccountId: string;
     *     name?: string;
     *     idToken?: string;
     *     idTokenClaims?: TokenClaims & {
     *         [key: string]:
     *             | string
     *             | number
     *             | string[]
     *             | object
     *             | undefined
     *             | unknown;
     *     };
     *     nativeAccountId?: string;
     *     authorityType?: string;
     * };
     */ fromNaaAccountInfo(fromAccount, idToken, idTokenClaims) {
        const effectiveIdTokenClaims = idTokenClaims || fromAccount.idTokenClaims;
        const localAccountId = fromAccount.localAccountId || effectiveIdTokenClaims?.oid || effectiveIdTokenClaims?.sub || "";
        /*
         * In B2C scenarios tid may not be present, use getTenantIdFromIdTokenClaims
         * which handles tid, tfp (modern B2C), and acr (legacy B2C) claims
         */ const tenantId = fromAccount.tenantId || (0, $616279607e3ed735$export$8e1decb9a5e2932)(effectiveIdTokenClaims) || "";
        const homeAccountId = fromAccount.homeAccountId || `${localAccountId}.${tenantId}`;
        // Validate environment - required field
        const environment = fromAccount.environment;
        if (!environment) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).invalidCacheEnvironment, "");
        /*
         * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
         * In most cases it will contain a single email. This field should not be relied upon if a custom
         * policy is configured to return more than 1 email.
         */ const preferredUsername = effectiveIdTokenClaims?.preferred_username || effectiveIdTokenClaims?.upn;
        const email = effectiveIdTokenClaims?.emails?.[0] || null;
        const username = fromAccount.username || preferredUsername || email || "";
        const name = fromAccount.name || effectiveIdTokenClaims?.name || "";
        const loginHint = fromAccount.loginHint || effectiveIdTokenClaims?.login_hint;
        const tenantProfiles = new Map();
        const tenantProfile = (0, $7beee762cc5bd6b9$export$924857724cb21ba4)(homeAccountId, localAccountId, tenantId, fromAccount.platformBrokerId, effectiveIdTokenClaims);
        tenantProfiles.set(tenantId, tenantProfile);
        const account = {
            homeAccountId: homeAccountId,
            environment: environment,
            tenantId: tenantId,
            username: username,
            localAccountId: localAccountId,
            name: name,
            loginHint: loginHint,
            idToken: idToken,
            idTokenClaims: effectiveIdTokenClaims,
            nativeAccountId: fromAccount.platformBrokerId,
            tenantProfiles: tenantProfiles
        };
        return account;
    }
    /**
     *
     * @param error BridgeError
     * @returns AuthError, ClientAuthError, ClientConfigurationError, ServerError, InteractionRequiredError
     */ fromBridgeError(error) {
        if ((0, $25f8be65a9f10751$export$caa3bc10e51dd7ee)(error)) switch(error.status){
            case (0, $1a1c6a045f124f72$export$6d05f68c12a46a00).UserCancel:
                return new (0, $b5b2cf5eef944c90$export$a839ff85a7957561)((0, $11e3a50b38764cc5$exports).userCanceled, "");
            case (0, $1a1c6a045f124f72$export$6d05f68c12a46a00).NoNetwork:
                return new (0, $b5b2cf5eef944c90$export$a839ff85a7957561)((0, $11e3a50b38764cc5$exports).noNetworkConnectivity, "");
            case (0, $1a1c6a045f124f72$export$6d05f68c12a46a00).AccountUnavailable:
                return new (0, $b5b2cf5eef944c90$export$a839ff85a7957561)((0, $11e3a50b38764cc5$exports).noAccountFound, "");
            case (0, $1a1c6a045f124f72$export$6d05f68c12a46a00).Disabled:
                return new (0, $b5b2cf5eef944c90$export$a839ff85a7957561)((0, $11e3a50b38764cc5$exports).nestedAppAuthBridgeDisabled, "");
            case (0, $1a1c6a045f124f72$export$6d05f68c12a46a00).NestedAppAuthUnavailable:
                return new (0, $b5b2cf5eef944c90$export$a839ff85a7957561)(error.code || (0, $11e3a50b38764cc5$exports).nestedAppAuthBridgeDisabled, "", error.description);
            case (0, $1a1c6a045f124f72$export$6d05f68c12a46a00).TransientError:
            case (0, $1a1c6a045f124f72$export$6d05f68c12a46a00).PersistentError:
                return new (0, $cf4c26be8c97417f$export$ea52035eac03daf0)(error.code || "", "", error.description);
            case (0, $1a1c6a045f124f72$export$6d05f68c12a46a00).UserInteractionRequired:
                return new (0, $e9bbb17645bd3149$export$6ba3e818c6bc76ba)(error.code || "", "", error.description);
            default:
                return new (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)(error.code || "", "", error.description);
        }
        else return new (0, $8d1fc9917b2c0dac$export$145273558d58e0ac)("unknown_error", "", "An unknown error occurred");
    }
    /**
     * Returns an AuthenticationResult from the given cache items
     *
     * @param account
     * @param idToken
     * @param accessToken
     * @param reqTimestamp
     * @returns
     */ toAuthenticationResultFromCache(account, idToken, accessToken, request, correlationId) {
        if (!idToken || !accessToken) throw (0, $b5b2cf5eef944c90$export$ea892ce48f5bb4f3)((0, $11e3a50b38764cc5$exports).nullOrEmptyToken, correlationId);
        const idTokenClaims = (0, $4acd0486289e3b4f$exports).extractTokenClaims(idToken.secret, this.crypto.base64Decode, correlationId);
        const scopes = accessToken.target || request.scopes.join(" ");
        const authenticationResult = {
            authority: accessToken.environment || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: idToken.secret,
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken.secret,
            fromCache: true,
            expiresOn: (0, $e0616e53cd3f026f$exports).toDateFromSeconds(accessToken.expiresOn),
            extExpiresOn: (0, $e0616e53cd3f026f$exports).toDateFromSeconds(accessToken.extendedExpiresOn),
            tokenType: request.authenticationScheme || (0, $8994aeee5e01080d$exports).AuthenticationScheme.BEARER,
            correlationId: correlationId,
            state: request.state
        };
        return authenticationResult;
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $2385c9def25e00ec$export$7c79ceb488783308 extends (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        Object.setPrototypeOf(this, $2385c9def25e00ec$export$7c79ceb488783308.prototype);
        this.name = "NestedAppAuthError";
    }
    static createUnsupportedError(correlationId) {
        /*
         * Some controller stubs (perf callbacks, getPerformanceClient, getRedirectResponse)
         * have no request param and thus no correlationId to forward
         */ return new $2385c9def25e00ec$export$7c79ceb488783308((0, $54c057f8977f7ba9$export$d2b39fdb388adfc8), correlationId || "");
    }
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $51b3c82fe5bdefea$export$2319deb182e38ab3 {
    constructor(operatingContext){
        this.operatingContext = operatingContext;
        const proxy = this.operatingContext.getBridgeProxy();
        if (proxy !== undefined) this.bridgeProxy = proxy;
        else throw new Error("unexpected: bridgeProxy is undefined");
        // Set the configuration.
        this.config = operatingContext.getConfig();
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = operatingContext.isBrowserEnvironment() ? new (0, $6b1f88068f54d1dd$export$c274a7f0ebd24b14)(this.logger, this.performanceClient, true) : (0, $842f61e187fdf563$export$865f57d401606752);
        this.eventHandler = new (0, $0a29dd70327044d0$export$ce0ba2422a1c7815)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.operatingContext.isBrowserEnvironment() ? new (0, $e624d8f74faf8e75$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, (0, $c05549f487bde715$export$2b9ebf6f25078cc0)(this.config.auth)) : (0, $e624d8f74faf8e75$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler);
        this.nestedAppAuthAdapter = new (0, $cdcf5fb47cd16823$export$cee94b20506f02aa)(this.config.auth.clientId, this.config.auth.clientCapabilities, this.browserCrypto, this.logger);
        // Set the active account if available
        const accountContext = this.bridgeProxy.getAccountContext();
        this.currentAccountContext = accountContext ? accountContext : null;
    }
    /**
     * Factory function to create a new instance of NestedAppAuthController
     * @param operatingContext
     * @returns Promise<IController>
     */ static async createController(operatingContext) {
        const controller = new $51b3c82fe5bdefea$export$2319deb182e38ab3(operatingContext);
        return Promise.resolve(controller);
    }
    /**
     * Specific implementation of initialize function for NestedAppAuthController
     * @returns
     */ async initialize(request, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isBroker) {
        const initCorrelationId = request?.correlationId || (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)();
        await this.browserStorage.initialize(initCorrelationId);
        return Promise.resolve();
    }
    /**
     * Validate the incoming request and add correlationId if not present
     * @param request
     * @returns
     */ ensureValidRequest(request) {
        if (request?.correlationId) return request;
        return {
            ...request,
            correlationId: this.browserCrypto.createNewGuid()
        };
    }
    /**
     * Internal implementation of acquireTokenInteractive flow
     * @param request
     * @returns
     */ async acquireTokenInteractive(request) {
        const validRequest = this.ensureValidRequest(request);
        const correlationId = validRequest.correlationId || (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)();
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_START, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, validRequest);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$8eece1dda35ee9eb), correlationId);
        atPopupMeasurement.add({
            nestedAppAuthRequest: true
        });
        try {
            (0, $8451db0dd4949b5f$export$df47a28b08fa2370)(this.config.auth.isMcp, validRequest);
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, $e0616e53cd3f026f$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenInteractive(naaRequest);
            const result = {
                ...this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp)
            };
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`1mwr91 ${error}`, correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * Internal implementation of acquireTokenSilent flow
     * @param request
     * @returns
     */ async acquireTokenSilentInternal(request) {
        const validRequest = this.ensureValidRequest(request);
        const correlationId = validRequest.correlationId || (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)();
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_START, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, validRequest);
        // Look for tokens in the cache first
        const result = await this.acquireTokenFromCache(validRequest);
        if (result) {
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, result);
            return result;
        }
        // proceed with acquiring tokens via the host
        const ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$2da6f47a70635e40), correlationId);
        ssoSilentMeasurement.increment({
            visibilityChangeCount: 0
        });
        ssoSilentMeasurement.add({
            nestedAppAuthRequest: true
        });
        try {
            (0, $8451db0dd4949b5f$export$df47a28b08fa2370)(this.config.auth.isMcp, validRequest);
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            naaRequest.forceRefresh = validRequest.forceRefresh;
            const reqTimestamp = (0, $e0616e53cd3f026f$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenSilent(naaRequest);
            const result = this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp);
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`1mwr91 ${error}`, correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, result);
            ssoSilentMeasurement?.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            ssoSilentMeasurement?.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, null, e);
            ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * acquires tokens from cache
     * @param request
     * @returns
     */ async acquireTokenFromCache(request) {
        const correlationId = request.correlationId || (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)();
        const atsMeasurement = this.performanceClient.startMeasurement((0, $65145b346c45554a$export$ef5b8273b1c66495), correlationId);
        atsMeasurement?.add({
            nestedAppAuthRequest: true
        });
        // if the request has claims, we cannot look up in the cache
        if (request.claims) {
            this.logger.verbose("11t57w", correlationId);
            return null;
        }
        // if the request has forceRefresh, we cannot look up in the cache
        if (request.forceRefresh) {
            this.logger.verbose("1ovnmo", correlationId);
            return null;
        }
        // respect cache lookup policy
        let result = null;
        if (!request.cacheLookupPolicy) request.cacheLookupPolicy = (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).Default;
        switch(request.cacheLookupPolicy){
            case (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).Default:
            case (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).AccessToken:
            case (0, $7101cc4ee26a17a4$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                result = await this.acquireTokenFromCacheInternal(request);
                break;
            default:
                return null;
        }
        if (result) {
            this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, result);
            atsMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atsMeasurement.end({
                success: true
            }, undefined, result.account);
            return result;
        }
        this.logger.warning("1yb4fi", correlationId);
        this.eventHandler.emitEvent((0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, correlationId, (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent, null);
        atsMeasurement.end({
            success: false
        }, undefined, request.account);
        return null;
    }
    /**
     *
     * @param request
     * @returns
     */ async acquireTokenFromCacheInternal(request) {
        // always prioritize the account context from the bridge
        const accountContext = this.bridgeProxy.getAccountContext() || this.currentAccountContext;
        const correlationId = request.correlationId || (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)();
        let currentAccount = null;
        if (accountContext) currentAccount = (0, $9e3c3c60dcb65490$export$4f9234baf34abd0)(accountContext, this.logger, this.browserStorage, correlationId);
        // fall back to brokering if no cached account is found
        if (!currentAccount) {
            this.logger.verbose("10qnr0", correlationId);
            return Promise.resolve(null);
        }
        this.logger.verbose("1u7hux", correlationId);
        const authRequest = {
            ...request,
            correlationId: correlationId,
            authority: request.authority || currentAccount.environment,
            scopes: request.scopes?.length ? request.scopes : [
                ...(0, $8994aeee5e01080d$exports).OIDC_DEFAULT_SCOPES
            ]
        };
        // fetch access token and check for expiry
        const tokenKeys = this.browserStorage.getTokenKeys();
        const cachedAccessToken = this.browserStorage.getAccessToken(currentAccount, authRequest, tokenKeys, currentAccount.tenantId);
        // If there is no access token, log it and return null
        if (!cachedAccessToken) {
            this.logger.verbose("03vm49", correlationId);
            return Promise.resolve(null);
        } else if ((0, $e0616e53cd3f026f$exports).wasClockTurnedBack(cachedAccessToken.cachedAt) || (0, $e0616e53cd3f026f$exports).isTokenExpired(cachedAccessToken.expiresOn, this.config.system.tokenRenewalOffsetSeconds)) {
            this.logger.verbose("18egye", correlationId);
            return Promise.resolve(null);
        } else if (authRequest.resource) {
            const requestedResource = authRequest.resource;
            const cachedResource = cachedAccessToken.resource;
            if (!cachedResource || cachedResource !== requestedResource) {
                this.logger.verbose("0qraxd", correlationId);
                return Promise.resolve(null);
            }
        }
        const cachedIdToken = this.browserStorage.getIdToken(currentAccount, authRequest.correlationId, tokenKeys, currentAccount.tenantId);
        if (!cachedIdToken) {
            this.logger.verbose("0d68kd", correlationId);
            return Promise.resolve(null);
        }
        return this.nestedAppAuthAdapter.toAuthenticationResultFromCache(currentAccount, cachedIdToken, cachedAccessToken, authRequest, authRequest.correlationId);
    }
    /**
     * acquireTokenPopup flow implementation
     * @param request
     * @returns
     */ async acquireTokenPopup(request) {
        return this.acquireTokenInteractive(request);
    }
    /**
     * acquireTokenRedirect flow is not supported in nested app auth
     * @param request
     */ acquireTokenRedirect(request) {
        throw (0, $2385c9def25e00ec$export$7c79ceb488783308).createUnsupportedError(request?.correlationId);
    }
    /**
     * acquireTokenSilent flow implementation
     * @param silentRequest
     * @returns
     */ async acquireTokenSilent(silentRequest) {
        return this.acquireTokenSilentInternal(silentRequest);
    }
    /**
     * Hybrid flow is not currently supported in nested app auth
     * @param request
     */ acquireTokenByCode(request) {
        throw (0, $2385c9def25e00ec$export$7c79ceb488783308).createUnsupportedError(request?.correlationId);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addPerformanceCallback(callback) {
        // No request context: callback registration is not per-request
        throw (0, $2385c9def25e00ec$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removePerformanceCallback(callbackId) {
        // No request context: callback registration is not per-request
        throw (0, $2385c9def25e00ec$export$7c79ceb488783308).createUnsupportedError();
    }
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return (0, $9e3c3c60dcb65490$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnv(), (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)(), accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return (0, $9e3c3c60dcb65490$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage, (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)());
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        /*
         * StandardController uses this to allow the developer to set the active account
         * in the nested app auth scenario the active account is controlled by the app hosting the nested app
         */ return (0, $9e3c3c60dcb65490$export$c55c3d25cf1bcd99)(account, this.browserStorage, (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)());
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return (0, $9e3c3c60dcb65490$export$13dd2e33a23839ad)(this.browserStorage, (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)());
    }
    // #endregion
    handleRedirectPromise(options // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return Promise.resolve(null);
    }
    loginPopup(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return this.acquireTokenInteractive(request || (0, $7101cc4ee26a17a4$export$7e12949cd6884193));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRedirect(request) {
        throw (0, $2385c9def25e00ec$export$7c79ceb488783308).createUnsupportedError(request?.correlationId);
    }
    logoutRedirect(logoutRequest) {
        throw (0, $2385c9def25e00ec$export$7c79ceb488783308).createUnsupportedError(logoutRequest?.correlationId);
    }
    logoutPopup(logoutRequest) {
        throw (0, $2385c9def25e00ec$export$7c79ceb488783308).createUnsupportedError(logoutRequest?.correlationId);
    }
    ssoSilent(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    request) {
        return this.acquireTokenSilentInternal(request);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initializeWrapperLibrary(sku, version) {
        /*
         * Standard controller uses this to set the sku and version of the wrapper library in the storage
         * we do nothing here
         */ return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setNavigationClient(navigationClient) {
        this.logger.warning("1k8729", "");
    }
    getConfiguration() {
        return this.config;
    }
    isBrowserEnv() {
        return this.operatingContext.isBrowserEnvironment();
    }
    getBrowserCrypto() {
        return this.browserCrypto;
    }
    getPerformanceClient() {
        // Accessor stub with no request context
        throw (0, $2385c9def25e00ec$export$7c79ceb488783308).createUnsupportedError();
    }
    getRedirectResponse() {
        // Accessor stub with no request context
        throw (0, $2385c9def25e00ec$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async clearCache(logoutRequest) {
        throw (0, $2385c9def25e00ec$export$7c79ceb488783308).createUnsupportedError(logoutRequest?.correlationId);
    }
    async hydrateCache(result, request) {
        this.logger.verbose("16jycr", result.correlationId);
        const accountEntity = (0, $f136bee61a3373e4$exports).createAccountEntityFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, (0, $4acd0486289e3b4f$exports).isKmsi(result.idTokenClaims), (0, $7101cc4ee26a17a4$export$192d74ad69b40705).hydrateCache);
        return this.browserStorage.hydrateCache(result, request);
    }
}


/*! @azure/msal-browser v5.16.0 2026-06-30 */ 
/*! @azure/msal-browser v5.16.0 2026-06-30 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BridgeProxy
 * Provides a proxy for accessing a bridge to a host app and/or
 * platform broker
 */ class $4c0928f57330a1cf$export$d974b2d5dad1979e {
    /**
     * initializeNestedAppAuthBridge - Initializes the bridge to the host app
     * @returns a promise that resolves to an InitializeBridgeResponse or rejects with an Error
     * @remarks This method will be called by the create factory method
     * @remarks If the bridge is not available, this method will throw an error
     */ static async initializeNestedAppAuthBridge() {
        if (window === undefined) throw new Error("window is undefined");
        if (window.nestedAppAuthBridge === undefined) throw new Error("window.nestedAppAuthBridge is undefined");
        try {
            window.nestedAppAuthBridge.addEventListener("message", (response)=>{
                const responsePayload = typeof response === "string" ? response : response.data;
                const responseEnvelope = JSON.parse(responsePayload);
                const request = $4c0928f57330a1cf$export$d974b2d5dad1979e.bridgeRequests.find((element)=>element.requestId === responseEnvelope.requestId);
                if (request !== undefined) {
                    $4c0928f57330a1cf$export$d974b2d5dad1979e.bridgeRequests.splice($4c0928f57330a1cf$export$d974b2d5dad1979e.bridgeRequests.indexOf(request), 1);
                    if (responseEnvelope.success) request.resolve(responseEnvelope);
                    else request.reject(responseEnvelope.error);
                }
            });
            const bridgeResponse = await new Promise((resolve, reject)=>{
                const message = $4c0928f57330a1cf$export$d974b2d5dad1979e.buildRequest("GetInitContext");
                const request = {
                    requestId: message.requestId,
                    method: message.method,
                    resolve: resolve,
                    reject: reject
                };
                $4c0928f57330a1cf$export$d974b2d5dad1979e.bridgeRequests.push(request);
                window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
            });
            return $4c0928f57330a1cf$export$d974b2d5dad1979e.validateBridgeResultOrThrow(bridgeResponse.initContext);
        } catch (error) {
            window.console.log(error);
            throw error;
        }
    }
    /**
     * getTokenInteractive - Attempts to get a token interactively from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenInteractive(request) {
        return this.getToken("GetTokenPopup", request);
    }
    /**
     * getTokenSilent Attempts to get a token silently from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenSilent(request) {
        return this.getToken("GetToken", request);
    }
    async getToken(requestType, request) {
        const result = await this.sendRequest(requestType, {
            tokenParams: request
        });
        return {
            token: $4c0928f57330a1cf$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.token),
            account: $4c0928f57330a1cf$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.account)
        };
    }
    getHostCapabilities() {
        return this.capabilities ?? null;
    }
    getAccountContext() {
        return this.accountContext ? this.accountContext : null;
    }
    static buildRequest(method, requestParams) {
        return {
            messageType: "NestedAppAuthRequest",
            method: method,
            requestId: (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)(),
            sendTime: Date.now(),
            clientLibrary: (0, $7101cc4ee26a17a4$export$a0a689e4294b9880).MSAL_SKU,
            clientLibraryVersion: (0, $c8226bf52dd9a4ef$export$83d89fbfd8236492),
            ...requestParams
        };
    }
    /**
     * A method used to send a request to the bridge
     * @param request A token request
     * @returns a promise that resolves to a response of provided type or rejects with a BridgeError
     */ sendRequest(method, requestParams) {
        const message = $4c0928f57330a1cf$export$d974b2d5dad1979e.buildRequest(method, requestParams);
        const promise = new Promise((resolve, reject)=>{
            const request = {
                requestId: message.requestId,
                method: message.method,
                resolve: resolve,
                reject: reject
            };
            $4c0928f57330a1cf$export$d974b2d5dad1979e.bridgeRequests.push(request);
            window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
        });
        return promise;
    }
    static validateBridgeResultOrThrow(input) {
        if (input === undefined) {
            const bridgeError = {
                status: (0, $1a1c6a045f124f72$export$6d05f68c12a46a00).NestedAppAuthUnavailable
            };
            throw bridgeError;
        }
        return input;
    }
    /**
     * Private constructor for BridgeProxy
     * @param sdkName The name of the SDK being used to make requests on behalf of the app
     * @param sdkVersion The version of the SDK being used to make requests on behalf of the app
     * @param capabilities The capabilities of the bridge / SDK / platform broker
     */ constructor(sdkName, sdkVersion, accountContext, capabilities){
        this.sdkName = sdkName;
        this.sdkVersion = sdkVersion;
        this.accountContext = accountContext;
        this.capabilities = capabilities;
    }
    /**
     * Factory method for creating an implementation of IBridgeProxy
     * @returns A promise that resolves to a BridgeProxy implementation
     */ static async create() {
        const response = await $4c0928f57330a1cf$export$d974b2d5dad1979e.initializeNestedAppAuthBridge();
        return new $4c0928f57330a1cf$export$d974b2d5dad1979e(response.sdkName, response.sdkVersion, response.accountContext, response.capabilities);
    }
}
$4c0928f57330a1cf$export$d974b2d5dad1979e.bridgeRequests = [];


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $4612bd0a631dbad6$export$a2170d4e3f010950 extends (0, $43f6bae731ff8d3a$export$3aea257f46651b2b) {
    constructor(){
        super(...arguments);
        this.bridgeProxy = undefined;
        this.accountContext = null;
    }
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $4612bd0a631dbad6$export$a2170d4e3f010950.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $4612bd0a631dbad6$export$a2170d4e3f010950.ID;
    }
    /**
     * Returns the current BridgeProxy
     * @returns IBridgeProxy | undefined
     */ getBridgeProxy() {
        return this.bridgeProxy;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @param correlationId
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize(correlationId) {
        const cid = correlationId || "";
        try {
            if (typeof window !== "undefined") {
                if (typeof window.__initializeNestedAppAuth === "function") await window.__initializeNestedAppAuth();
                const bridgeProxy = await (0, $4c0928f57330a1cf$export$d974b2d5dad1979e).create();
                /*
                 * Because we want single sign on we expect the host app to provide the account context
                 * with a min set of params that can be used to identify the account
                 * this.account = nestedApp.getAccountByFilter(bridgeProxy.getAccountContext());
                 */ this.accountContext = bridgeProxy.getAccountContext();
                this.bridgeProxy = bridgeProxy;
                this.available = bridgeProxy !== undefined;
            }
        } catch (ex) {
            this.logger.infoPii(`1mdxyj ${ex}`, cid);
        }
        this.logger.info(`12jy9a ${this.available}`, cid);
        return this.available;
    }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $4612bd0a631dbad6$export$a2170d4e3f010950.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $4612bd0a631dbad6$export$a2170d4e3f010950.ID = "NestedAppOperatingContext";




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ class $d4ca65a93729f924$export$89f4855ef88b7920 {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     * @param IController Optional parameter to explictly set the controller. (Will be removed when we remove public constructor)
     */ constructor(configuration, controller){
        this.controller = controller || new (0, $52bd6e9c9be84db3$export$e9d1ef1cb8705404)(new (0, $ec80fcc8b6adfb3c$export$f39c23bbfed89e6e)(configuration, {
            waitForPopupResponse: this.waitForPopupResponse.bind(this),
            waitForIframeResponse: this.waitForIframeResponse.bind(this)
        }));
    }
    /**
     * Waits for the auth response from a popup window opened by MSAL.
     *
     * The default implementation delegates to MSAL's `BroadcastChannel`-based bridge.
     * Subclasses must return the raw response string (hash/query/fragment), or reject
     * with an `AuthError` on failure.
     *
     * @internal
     * @param request The in-flight authorization or end-session request.
     * @param popupWindow The popup window opened by MSAL.
     * @param popupWindowParent The parent window that opened the popup.
     */ async waitForPopupResponse(request, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    popupWindow, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    popupWindowParent) {
        const controller = this.controller;
        return (0, $8e677587a7c978db$export$f241abdbe4a81a03)(controller.getConfiguration().system.popupBridgeTimeout, controller.getLogger(), request, controller.getPerformanceClient());
    }
    /**
     * Waits for the auth response from a hidden iframe used by MSAL silent flows.
     *
     * The default implementation delegates to MSAL's `BroadcastChannel`-based bridge.
     * Subclasses must return the raw response string (hash/query/fragment), or reject
     * with an `AuthError` on failure.
     *
     * @internal
     * @param iframe The hidden iframe MSAL attached to the document.
     * @param request The in-flight authorization request.
     */ async waitForIframeResponse(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    iframe, request) {
        const controller = this.controller;
        const config = controller.getConfiguration();
        return (0, $8e677587a7c978db$export$f241abdbe4a81a03)(config.system.iframeBridgeTimeout, controller.getLogger(), request, controller.getPerformanceClient(), config.experimental);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest}
     */ async initialize(request) {
        return this.controller.initialize(request);
    }
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopup(request) {
        return this.controller.acquireTokenPopup(request);
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ acquireTokenRedirect(request) {
        return this.controller.acquireTokenRedirect(request);
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthenticationResult} object
     */ acquireTokenSilent(silentRequest) {
        return this.controller.acquireTokenSilent(silentRequest);
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenByCode(request) {
        return this.controller.acquireTokenByCode(request);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.controller.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        return this.controller.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        return this.controller.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.controller.removePerformanceCallback(callbackId);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return this.controller.getAccount(accountFilter);
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.controller.getAllAccounts(accountFilter);
    }
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @param options Object containing optional configuration for redirect promise handling.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ handleRedirectPromise(options) {
        return this.controller.handleRedirectPromise(options);
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        return this.controller.loginPopup(request);
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ loginRedirect(request) {
        return this.controller.loginRedirect(request);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ logoutRedirect(logoutRequest) {
        return this.controller.logoutRedirect(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        return this.controller.logoutPopup(logoutRequest);
    }
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ssoSilent(request) {
        return this.controller.ssoSilent(request);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.controller.getLogger();
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.controller.setLogger(logger);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        this.controller.setActiveAccount(account);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return this.controller.getActiveAccount();
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        return this.controller.initializeWrapperLibrary(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.controller.setNavigationClient(navigationClient);
    }
    /**
     * Returns the configuration object
     * @internal
     */ getConfiguration() {
        return this.controller.getConfiguration();
    }
    /**
     * Hydrates cache with the tokens and account in the AuthenticationResult object
     * @param result
     * @param request - The request object that was used to obtain the AuthenticationResult
     * @returns
     */ async hydrateCache(result, request) {
        return this.controller.hydrateCache(result, request);
    }
    /**
     * Clears tokens and account from the browser cache.
     * @param logoutRequest
     */ clearCache(logoutRequest) {
        return this.controller.clearCache(logoutRequest);
    }
}
/**
 * creates NestedAppAuthController and passes it to the PublicClientApplication,
 * falls back to StandardController if NestedAppAuthController is not available
 *
 * @param configuration
 * @param correlationId
 * @param pcaFactory
 * @returns IPublicClientApplication
 *
 */ async function $d4ca65a93729f924$export$210078d2745a65ac(configuration, correlationId, pcaFactory) {
    const nestedAppAuth = new (0, $4612bd0a631dbad6$export$a2170d4e3f010950)(configuration);
    await nestedAppAuth.initialize(correlationId);
    if (nestedAppAuth.isAvailable()) {
        const cid = correlationId || (0, $f0e13da7356d30ac$export$6ef0355fa80a5278)();
        const controller = new (0, $51b3c82fe5bdefea$export$2319deb182e38ab3)(nestedAppAuth);
        const nestablePCA = pcaFactory ? pcaFactory(configuration, controller) : new $d4ca65a93729f924$export$89f4855ef88b7920(configuration, controller);
        await nestablePCA.initialize({
            correlationId: cid
        });
        return nestablePCA;
    }
    return $d4ca65a93729f924$export$f28b97cfb2f3098(configuration);
}
/**
 * creates PublicClientApplication using StandardController
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $d4ca65a93729f924$export$f28b97cfb2f3098(configuration) {
    const pca = new $d4ca65a93729f924$export$89f4855ef88b7920(configuration);
    await pca.initialize();
    return pca;
}


/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */ const $e97d00946814e15c$var$TENANT_ID = "740e0ba1-e4ed-4c5d-9a56-2559c8fb94a6";
const $e97d00946814e15c$var$CLIENT_ID = "da42c2c9-fec6-47df-8caa-24eaeddc4082";
const $e97d00946814e15c$var$redirectUri = `${window.location.origin}`;
const $e97d00946814e15c$export$f6d610d2730cbf1a = {
    auth: {
        clientId: `${$e97d00946814e15c$var$CLIENT_ID}`,
        authority: `https://login.microsoftonline.com/${$e97d00946814e15c$var$TENANT_ID}`,
        redirectUri: $e97d00946814e15c$var$redirectUri,
        postLogoutRedirectUri: $e97d00946814e15c$var$redirectUri
    },
    cache: {
        cacheLocation: "sessionStorage"
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii)=>{
                if (containsPii) return;
                switch(level){
                    case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Error:
                        break;
                    case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Info:
                        break;
                    case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Verbose:
                        break;
                    case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Warning:
                        break;
                }
            }
        }
    }
};
const $e97d00946814e15c$export$be6c432b2463c5eb = {
    scopes: [
        "User.Read"
    ]
};
const $e97d00946814e15c$export$4965d3e40bbf5ccb = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};


const $f8e271a6a8b7dd21$var$isSingleSpa = false;
const $f8e271a6a8b7dd21$var$CLIENT_ID = $f8e271a6a8b7dd21$var$isSingleSpa ? "" : "da42c2c9-fec6-47df-8caa-24eaeddc4082";
const $f8e271a6a8b7dd21$export$ca9e2d319cf1d00d = {
    scopes: [
        `${$f8e271a6a8b7dd21$var$CLIENT_ID}/.default`
    ]
};
const $f8e271a6a8b7dd21$export$a59c2286a7150b12 = new (0, $d4ca65a93729f924$export$89f4855ef88b7920)((0, $e97d00946814e15c$export$f6d610d2730cbf1a));
const $f8e271a6a8b7dd21$export$84773cc9bf7dbe87 = async ()=>{
    await $f8e271a6a8b7dd21$export$a59c2286a7150b12.initialize();
    const accounts = $f8e271a6a8b7dd21$export$a59c2286a7150b12.getAllAccounts();
    if (accounts.length > 0) try {
        const request = {
            ...$f8e271a6a8b7dd21$export$ca9e2d319cf1d00d,
            account: accounts[0],
            forceRefresh: false
        };
        const response = await $f8e271a6a8b7dd21$export$a59c2286a7150b12.acquireTokenSilent(request);
        return response.accessToken;
    } catch (error) {
        console.error("Silent token acquisition failed:", error);
        // If silent token acquisition fails, we might need to refresh
        // but we shouldn't do interactive auth here since it should be handled by the provider
        try {
            // Try one more time with forceRefresh
            const refreshRequest = {
                ...$f8e271a6a8b7dd21$export$ca9e2d319cf1d00d,
                account: accounts[0],
                forceRefresh: true
            };
            const refreshResponse = await $f8e271a6a8b7dd21$export$a59c2286a7150b12.acquireTokenSilent(refreshRequest);
            return refreshResponse.accessToken;
        } catch (refreshError) {
            console.error("Token refresh failed:", refreshError);
            return null;
        }
    }
    return null;
};
// Account selection logic is app dependent. Adjust as needed for different use cases.
$f8e271a6a8b7dd21$export$a59c2286a7150b12.addEventCallback((event)=>{
    if (event.eventType === (0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGIN_SUCCESS) {
        // @ts-expect-error: see above
        const account = event.payload.account;
        $f8e271a6a8b7dd21$export$a59c2286a7150b12.setActiveAccount(account);
    }
});


const $ecec1a02f082128c$var$api = (0, $9b1678a8d2ae1e0f$export$2e2bcd8739ae039).create({
    baseURL: "https://hxooiur815.execute-api.us-east-2.amazonaws.com/uat",
    headers: {
        "Content-Type": "application/json"
    }
});
const $ecec1a02f082128c$export$a65d69dd22caceda = async (messageID, feedback)=>{
    try {
        const token = await (0, $f8e271a6a8b7dd21$export$84773cc9bf7dbe87)();
        const response = await $ecec1a02f082128c$var$api.post(`/feedback`, {
            messageID: messageID,
            feedback: feedback
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.status === 200;
    } catch (error) {
        if ((0, $9b1678a8d2ae1e0f$export$2e2bcd8739ae039).isAxiosError(error)) console.log("Axios error:", error.response?.data);
        else console.log("General error:", error);
        throw error;
    }
};


const $929c4e147339edc0$var$defaultLabels = {
    inputPlaceholder: "Type a message\u2026",
    sendButton: "Send",
    emptyState: "Start the conversation",
    typingIndicator: "CactAI is thinking..."
};
const $929c4e147339edc0$var$CopyButton = ({ text: text })=>{
    const [copied, setCopyState] = (0, $eeyUA.useState)(false);
    async function Copy() {
        await navigator.clipboard.writeText(text);
        setCopyState(true);
        setTimeout(()=>{
            setCopyState(false);
        }, 3000);
    }
    return /*#__PURE__*/ (0, $e9nev.jsx)("div", {
        className: "copy-button-container",
        onClick: ()=>Copy(),
        children: copied ? /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$28c660c63b792dea), {
            id: "copy",
            content: "Copied",
            children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $0efd1207bcc6e53c$export$2e2bcd8739ae039), {
                className: "copy-icon"
            })
        }) : /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$28c660c63b792dea), {
            id: "copy",
            content: "Copy",
            children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $e8ac5e4ccda16020$export$2e2bcd8739ae039), {
                className: "copy-icon"
            })
        })
    });
};
const $929c4e147339edc0$var$TableCopyButton = ({ markdown: markdown })=>{
    const [copied, setCopied] = (0, $eeyUA.useState)(false);
    async function Copy() {
        await (0, $878c53339ed7cfc8$export$315a3a78b7712fad)(markdown);
        setCopied(true);
        setTimeout(()=>setCopied(false), 3000);
    }
    return /*#__PURE__*/ (0, $e9nev.jsx)("div", {
        className: "table-copy-button",
        onClick: ()=>Copy(),
        children: copied ? /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$28c660c63b792dea), {
            id: "copy-slack",
            content: "Copied",
            children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $0efd1207bcc6e53c$export$2e2bcd8739ae039), {
                className: "copy-icon"
            })
        }) : /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$28c660c63b792dea), {
            id: "copy-slack",
            content: "Copy table",
            children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $156ac749b3e8f144$export$2e2bcd8739ae039), {
                className: "copy-icon"
            })
        })
    });
};
const $929c4e147339edc0$var$MessageContent = ({ markdown: markdown })=>{
    const segments = (0, $878c53339ed7cfc8$export$d8961ad1f47673e5)(markdown);
    if (!segments.some((s)=>s.type === "table")) return /*#__PURE__*/ (0, $e9nev.jsx)((0, $d252d04b8be55307$export$2e2bcd8739ae039), {
        markdown: markdown
    });
    return /*#__PURE__*/ (0, $e9nev.jsx)((0, $e9nev.Fragment), {
        children: segments.map((segment, i)=>segment.type === "table" ? /*#__PURE__*/ (0, $e9nev.jsxs)("div", {
                className: "table-block",
                children: [
                    /*#__PURE__*/ (0, $e9nev.jsx)((0, $d252d04b8be55307$export$2e2bcd8739ae039), {
                        markdown: segment.markdown
                    }),
                    /*#__PURE__*/ (0, $e9nev.jsx)($929c4e147339edc0$var$TableCopyButton, {
                        markdown: segment.markdown
                    })
                ]
            }, i) : /*#__PURE__*/ (0, $e9nev.jsx)((0, $d252d04b8be55307$export$2e2bcd8739ae039), {
                markdown: segment.markdown
            }, i))
    });
};
const $929c4e147339edc0$var$FeedbackContainer = ({ messageID: messageID })=>{
    const [feedback, setFeedback] = (0, $eeyUA.useState)(null);
    const updateFeedback = function(feedback) {
        setFeedback(feedback);
        (0, $ecec1a02f082128c$export$a65d69dd22caceda)(messageID, feedback);
    };
    return /*#__PURE__*/ (0, $e9nev.jsxs)("div", {
        className: "feedback-container",
        children: [
            feedback === 'disliked' ? /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$28c660c63b792dea), {
                id: "dislike",
                content: "Dislike",
                children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $22111ae4a55e74a0$export$2e2bcd8739ae039), {
                    onClick: ()=>updateFeedback(null)
                })
            }) : /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$28c660c63b792dea), {
                id: "dislike",
                content: "Dislike",
                children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $9d58283a9fc35d22$export$2e2bcd8739ae039), {
                    onClick: ()=>updateFeedback('disliked')
                })
            }),
            feedback === 'liked' ? /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$28c660c63b792dea), {
                id: "like",
                content: "Like",
                children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $f5ad5adf626e2b8a$export$2e2bcd8739ae039), {
                    onClick: ()=>updateFeedback(null)
                })
            }) : /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$28c660c63b792dea), {
                id: "like",
                content: "Like",
                children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $7d3b7c83a889513b$export$2e2bcd8739ae039), {
                    onClick: ()=>updateFeedback('liked')
                })
            })
        ]
    });
};
function $929c4e147339edc0$export$89085c7857c3f940({ messages: messages, emptyLabel: emptyLabel, renderMessage: renderMessage, isLoading: isLoading }) {
    const bottomRef = (0, $eeyUA.useRef)(null);
    const messagesContainerRef = (0, $eeyUA.useRef)(null);
    const [typingLabel, setTypingLabel] = (0, $eeyUA.useState)("CactAI is thinking...");
    const lastScrollKeyRef = (0, $eeyUA.useRef)("");
    (0, $eeyUA.useEffect)(()=>{
        const last = messages[messages.length - 1];
        const scrollKey = `${messages.length}:${last?.id ?? ""}:${isLoading}`;
        if (scrollKey === lastScrollKeyRef.current) return;
        lastScrollKeyRef.current = scrollKey;
        const container = messagesContainerRef.current;
        if (!container) return;
        requestAnimationFrame(()=>{
            container.scrollTop = container.scrollHeight;
        });
    }, [
        messages,
        isLoading
    ]);
    (0, $eeyUA.useEffect)(()=>{
        if (!isLoading) {
            setTypingLabel("CactAI is thinking...");
            return;
        }
        const id = window.setInterval(()=>{
            setTypingLabel((label)=>{
                if (label.endsWith("...")) return "CactAI is thinking.";
                if (label.endsWith("..")) return "CactAI is thinking...";
                if (label.endsWith(".")) return "CactAI is thinking..";
                return "CactAI is thinking...";
            });
        }, 1000);
        return ()=>window.clearInterval(id);
    }, [
        isLoading
    ]);
    if (messages.length === 0 && !isLoading) return /*#__PURE__*/ (0, $e9nev.jsx)("div", {
        className: "chat-empty",
        role: "status",
        children: emptyLabel
    });
    return /*#__PURE__*/ (0, $e9nev.jsxs)("div", {
        ref: messagesContainerRef,
        className: "chat-messages",
        role: "log",
        "aria-live": "polite",
        "aria-relevant": "additions",
        children: [
            messages.map((message)=>/*#__PURE__*/ (0, $e9nev.jsx)("article", {
                    className: `chat-message chat-message--${message.role}`,
                    "data-status": message.status,
                    children: renderMessage ? renderMessage(message) : /*#__PURE__*/ (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
                        children: [
                            typeof message.content === "string" && message.content.length > 0 ? /*#__PURE__*/ (0, $e9nev.jsxs)("div", {
                                className: "chat-bubble",
                                children: [
                                    /*#__PURE__*/ (0, $e9nev.jsx)($929c4e147339edc0$var$MessageContent, {
                                        markdown: message.content
                                    }),
                                    message.role === "assistant" && /*#__PURE__*/ (0, $e9nev.jsxs)("div", {
                                        className: "bubble-footer",
                                        children: [
                                            /*#__PURE__*/ (0, $e9nev.jsx)($929c4e147339edc0$var$FeedbackContainer, {
                                                messageID: message.id
                                            }),
                                            /*#__PURE__*/ (0, $e9nev.jsx)($929c4e147339edc0$var$CopyButton, {
                                                text: message.content
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $e9nev.jsx)("div", {
                                className: "chat-bubble",
                                children: "No message"
                            }),
                            message.createdAt != null && /*#__PURE__*/ (0, $e9nev.jsx)("time", {
                                className: "chat-time",
                                dateTime: new Date(message.createdAt).toISOString(),
                                children: (0, $878c53339ed7cfc8$export$35c832f048303b4a)(message.createdAt)
                            })
                        ]
                    })
                }, message.id)),
            isLoading && /*#__PURE__*/ (0, $e9nev.jsxs)("div", {
                className: "chat-typing",
                role: "status",
                "aria-busy": "true",
                children: [
                    /*#__PURE__*/ (0, $e9nev.jsxs)("span", {
                        className: "chat-typing-dots",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $e9nev.jsx)("span", {}),
                            /*#__PURE__*/ (0, $e9nev.jsx)("span", {}),
                            /*#__PURE__*/ (0, $e9nev.jsx)("span", {})
                        ]
                    }),
                    typingLabel
                ]
            }),
            /*#__PURE__*/ (0, $e9nev.jsx)("div", {
                ref: bottomRef,
                className: "chat-scroll-anchor"
            })
        ]
    });
}
function $929c4e147339edc0$export$19b903fd083c557c({ onSubmit: onSubmit, disabled: disabled, placeholder: placeholder, sendLabel: sendLabel, autoFocus: autoFocus, maxLength: maxLength, onCancel: onCancel }) {
    const [value, setValue] = (0, $eeyUA.useState)("");
    const [submitting, setSubmitting] = (0, $eeyUA.useState)(false);
    (0, $eeyUA.useEffect)(()=>{
        if (autoFocus) document.getElementById("cactai-chat-message")?.focus();
    }, [
        autoFocus
    ]);
    const cancelPrompt = ()=>{
        setValue("");
        setSubmitting(false);
        onCancel();
    };
    const handleSubmit = async (event)=>{
        event?.preventDefault();
        const trimmed = value.trim();
        if (!trimmed || disabled || submitting) return;
        setSubmitting(true);
        try {
            await onSubmit(trimmed);
            setValue("");
        } finally{
            setSubmitting(false);
        }
    };
    const handleKeyDown = (event)=>{
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            handleSubmit();
        }
    };
    return /*#__PURE__*/ (0, $e9nev.jsxs)("form", {
        className: "chat-input-form",
        onSubmit: (e)=>void handleSubmit(e),
        children: [
            /*#__PURE__*/ (0, $e9nev.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($dd2c652a409911c6$exports))),
                alt: "CactAI",
                className: "chat-avatar"
            }),
            /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$c86715117507e8e5), {
                id: "cactai-chat-message",
                label: placeholder,
                noLabel: true,
                multiline: true,
                rows: 1,
                value: value,
                onChange: (e)=>setValue(e.target.value),
                onKeyDown: handleKeyDown,
                placeholder: placeholder,
                disabled: disabled || submitting,
                maxLength: maxLength,
                "aria-label": placeholder
            }),
            /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$353f5b6fc5456de1), {
                type: submitting ? "button" : "submit",
                as: "button",
                onClick: submitting ? ()=>void cancelPrompt() : undefined,
                style: "function",
                className: "chat-send-button",
                ariaLabel: sendLabel,
                children: submitting ? /*#__PURE__*/ (0, $e9nev.jsx)((0, $421890d9d088a5ce$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $e9nev.jsx)((0, $bdfc75442d6c78bf$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
function $929c4e147339edc0$export$6ae14dc05aa6ecd6(labels) {
    return {
        ...$929c4e147339edc0$var$defaultLabels,
        ...labels
    };
}



var $eeyUA = parcelRequire("eeyUA");


var $eeyUA = parcelRequire("eeyUA");


var $eeyUA = parcelRequire("eeyUA");





/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $627b11c055ff79b0$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $627b11c055ff79b0$export$2e2bcd8739ae039 = $627b11c055ff79b0$var$murmur2;




var $eeyUA = parcelRequire("eeyUA");



var $eeyUA = parcelRequire("eeyUA");
function $f7a41f4eea21629f$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $eeyUA.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}




/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $899ab126ac4c56d7$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $f29d0996356f1173$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(a) === 'object' && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $899ab126ac4c56d7$export$2e2bcd8739ae039 = $899ab126ac4c56d7$var$isEqual;



var $eeyUA = parcelRequire("eeyUA");



// [times, realValue]
var $631880e01af2cb85$var$SPLIT = '%';
function $631880e01af2cb85$export$1d14e1d8187b9aad(keys) {
    return keys.join($631880e01af2cb85$var$SPLIT);
}
var $631880e01af2cb85$var$Entity = /*#__PURE__*/ function() {
    function Entity(instanceId) {
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, Entity);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "instanceId", void 0);
        /** @private Internal cache map. Do not access this directly */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "cache", new Map());
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "extracted", new Set());
        this.instanceId = instanceId;
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(Entity, [
        {
            key: "get",
            value: function get(keys) {
                return this.opGet($631880e01af2cb85$export$1d14e1d8187b9aad(keys));
            }
        },
        {
            key: "opGet",
            value: function opGet(keyPathStr) {
                return this.cache.get(keyPathStr) || null;
            }
        },
        {
            key: "update",
            value: function update(keys, valueFn) {
                return this.opUpdate($631880e01af2cb85$export$1d14e1d8187b9aad(keys), valueFn);
            }
        },
        {
            key: "opUpdate",
            value: function opUpdate(keyPathStr, valueFn) {
                var prevValue = this.cache.get(keyPathStr);
                var nextValue = valueFn(prevValue);
                if (nextValue === null) this.cache.delete(keyPathStr);
                else this.cache.set(keyPathStr, nextValue);
            }
        }
    ]);
    return Entity;
}();
var $631880e01af2cb85$export$2e2bcd8739ae039 = $631880e01af2cb85$var$Entity;


var $17bf098ab43a08aa$var$_excluded = [
    "children"
];
var $17bf098ab43a08aa$export$5d99297dcd5476ac = 'data-token-hash';
var $17bf098ab43a08aa$export$89ce1123b3c0bd9e = 'data-css-hash';
var $17bf098ab43a08aa$export$36f8a6c9fa24262a = 'data-cache-path';
var $17bf098ab43a08aa$export$4c16a0c02134a7dc = '__cssinjs_instance__';
function $17bf098ab43a08aa$export$cf6fa0bbcc94b912() {
    var cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== 'undefined' && document.head && document.body) {
        var styles = document.body.querySelectorAll("style[".concat($17bf098ab43a08aa$export$89ce1123b3c0bd9e, "]")) || [];
        var firstChild = document.head.firstChild;
        Array.from(styles).forEach(function(style) {
            style[$17bf098ab43a08aa$export$4c16a0c02134a7dc] = style[$17bf098ab43a08aa$export$4c16a0c02134a7dc] || cssinjsInstanceId;
            // Not force move if no head
            if (style[$17bf098ab43a08aa$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        var styleHash = {};
        Array.from(document.querySelectorAll("style[".concat($17bf098ab43a08aa$export$89ce1123b3c0bd9e, "]"))).forEach(function(style) {
            var hash = style.getAttribute($17bf098ab43a08aa$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$17bf098ab43a08aa$export$4c16a0c02134a7dc] === cssinjsInstanceId) {
                    var _style$parentNode;
                    (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
                }
            } else styleHash[hash] = true;
        });
    }
    return new (0, $631880e01af2cb85$export$2e2bcd8739ae039)(cssinjsInstanceId);
}
var $17bf098ab43a08aa$var$StyleContext = /*#__PURE__*/ $eeyUA.createContext({
    hashPriority: 'low',
    cache: $17bf098ab43a08aa$export$cf6fa0bbcc94b912(),
    defaultCache: true
});
var $17bf098ab43a08aa$export$6aedb87c7b665270 = function StyleProvider(props) {
    var children = props.children, restProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(props, $17bf098ab43a08aa$var$_excluded);
    var parentContext = $eeyUA.useContext($17bf098ab43a08aa$var$StyleContext);
    var context = (0, $f7a41f4eea21629f$export$2e2bcd8739ae039)(function() {
        var mergedContext = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, parentContext);
        Object.keys(restProps).forEach(function(key) {
            var value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        var cache = restProps.cache;
        mergedContext.cache = mergedContext.cache || $17bf098ab43a08aa$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], function(prev, next) {
        return !(0, $899ab126ac4c56d7$export$2e2bcd8739ae039)(prev[0], next[0], true) || !(0, $899ab126ac4c56d7$export$2e2bcd8739ae039)(prev[1], next[1], true);
    });
    return /*#__PURE__*/ $eeyUA.createElement($17bf098ab43a08aa$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $17bf098ab43a08aa$export$2e2bcd8739ae039 = $17bf098ab43a08aa$var$StyleContext;


















var $f7f1acd901c55364$var$AbstractCalculator = /*#__PURE__*/ (0, $055f1aac98d71283$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $827123db267e1039$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $f7f1acd901c55364$export$2e2bcd8739ae039 = $f7f1acd901c55364$var$AbstractCalculator;


var $aaa026d3d9a204e7$var$CALC_UNIT = 'CALC_UNIT';
var $aaa026d3d9a204e7$var$regexp = new RegExp($aaa026d3d9a204e7$var$CALC_UNIT, 'g');
function $aaa026d3d9a204e7$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($aaa026d3d9a204e7$var$CALC_UNIT);
    return value;
}
var $aaa026d3d9a204e7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $6a4c2bdb64108a28$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $7104bbef2c357751$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "result", '');
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "unitlessCssVar", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "lowPriority", void 0);
        var numType = (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $aaa026d3d9a204e7$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($aaa026d3d9a204e7$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($aaa026d3d9a204e7$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($aaa026d3d9a204e7$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $f7f1acd901c55364$export$2e2bcd8739ae039));









var $44a0a825f9c6754e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $6a4c2bdb64108a28$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $7104bbef2c357751$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $f7f1acd901c55364$export$2e2bcd8739ae039));


var $8eaabb9572580f1d$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $aaa026d3d9a204e7$export$2e2bcd8739ae039) : (0, $44a0a825f9c6754e$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $8eaabb9572580f1d$export$2e2bcd8739ae039 = $8eaabb9572580f1d$var$genCalc;






function $810940ffb0a2e4fa$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(var i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
var $810940ffb0a2e4fa$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeCache() {
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, ThemeCache);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "cache", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "keys", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "cacheCallTimes", void 0);
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(ThemeCache, [
        {
            key: "size",
            value: function size() {
                return this.keys.length;
            }
        },
        {
            key: "internalGet",
            value: function internalGet(derivativeOption) {
                var _cache2, _cache3;
                var updateCallTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var cache = {
                    map: this.cache
                };
                derivativeOption.forEach(function(derivative) {
                    if (!cache) cache = undefined;
                    else {
                        var _cache;
                        cache = (_cache = cache) === null || _cache === void 0 || (_cache = _cache.map) === null || _cache === void 0 ? void 0 : _cache.get(derivative);
                    }
                });
                if ((_cache2 = cache) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
                return (_cache3 = cache) === null || _cache3 === void 0 ? void 0 : _cache3.value;
            }
        },
        {
            key: "get",
            value: function get(derivativeOption) {
                var _this$internalGet;
                return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
            }
        },
        {
            key: "has",
            value: function has(derivativeOption) {
                return !!this.internalGet(derivativeOption);
            }
        },
        {
            key: "set",
            value: function set(derivativeOption, value) {
                var _this = this;
                // New cache
                if (!this.has(derivativeOption)) {
                    if (this.size() + 1 > ThemeCache.MAX_CACHE_SIZE + ThemeCache.MAX_CACHE_OFFSET) {
                        var _this$keys$reduce = this.keys.reduce(function(result, key) {
                            var _result = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(result, 2), callTimes = _result[1];
                            if (_this.internalGet(key)[1] < callTimes) return [
                                key,
                                _this.internalGet(key)[1]
                            ];
                            return result;
                        }, [
                            this.keys[0],
                            this.cacheCallTimes
                        ]), _this$keys$reduce2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_this$keys$reduce, 1), targetKey = _this$keys$reduce2[0];
                        this.delete(targetKey);
                    }
                    this.keys.push(derivativeOption);
                }
                var cache = this.cache;
                derivativeOption.forEach(function(derivative, index) {
                    if (index === derivativeOption.length - 1) cache.set(derivative, {
                        value: [
                            value,
                            _this.cacheCallTimes++
                        ]
                    });
                    else {
                        var cacheValue = cache.get(derivative);
                        if (!cacheValue) cache.set(derivative, {
                            map: new Map()
                        });
                        else if (!cacheValue.map) cacheValue.map = new Map();
                        cache = cache.get(derivative).map;
                    }
                });
            }
        },
        {
            key: "deleteByPath",
            value: function deleteByPath(currentCache, derivatives) {
                var cache = currentCache.get(derivatives[0]);
                if (derivatives.length === 1) {
                    var _cache$value;
                    if (!cache.map) currentCache.delete(derivatives[0]);
                    else currentCache.set(derivatives[0], {
                        map: cache.map
                    });
                    return (_cache$value = cache.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
                }
                var result = this.deleteByPath(cache.map, derivatives.slice(1));
                if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
                return result;
            }
        },
        {
            key: "delete",
            value: function _delete(derivativeOption) {
                // If cache exists
                if (this.has(derivativeOption)) {
                    this.keys = this.keys.filter(function(item) {
                        return !$810940ffb0a2e4fa$export$dd65e95e99ed0739(item, derivativeOption);
                    });
                    return this.deleteByPath(this.cache, derivativeOption);
                }
                return undefined;
            }
        }
    ]);
    return ThemeCache;
}();
(0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)($810940ffb0a2e4fa$export$2e2bcd8739ae039, "MAX_CACHE_SIZE", 20);
(0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)($810940ffb0a2e4fa$export$2e2bcd8739ae039, "MAX_CACHE_OFFSET", 5);






var $c53ea62aae679119$var$uuid = 0;
/**
 * Theme with algorithms to derive tokens from design tokens.
 * Use `createTheme` first which will help to manage the theme instance cache.
 */ var $c53ea62aae679119$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Theme(derivatives) {
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, Theme);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "derivatives", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "id", void 0);
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $c53ea62aae679119$var$uuid;
        if (derivatives.length === 0) (0, $f29d0996356f1173$export$491112666e282270)(derivatives.length > 0, '[Ant Design CSS-in-JS] Theme should have at least one derivative function.');
        $c53ea62aae679119$var$uuid += 1;
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(Theme, [
        {
            key: "getDerivativeToken",
            value: function getDerivativeToken(token) {
                return this.derivatives.reduce(function(result, derivative) {
                    return derivative(token, result);
                }, undefined);
            }
        }
    ]);
    return Theme;
}();


var $d38e822e786c0de9$var$cacheThemes = new (0, $810940ffb0a2e4fa$export$2e2bcd8739ae039)();
function $d38e822e786c0de9$export$2e2bcd8739ae039(derivatives) {
    var derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$d38e822e786c0de9$var$cacheThemes.has(derivativeArr)) $d38e822e786c0de9$var$cacheThemes.set(derivativeArr, new (0, $c53ea62aae679119$export$2e2bcd8739ae039)(derivativeArr));
    // Get theme from cache and return
    return $d38e822e786c0de9$var$cacheThemes.get(derivativeArr);
}






// Create a cache for memo concat
var $2c076defa05cd41b$var$resultCache = new WeakMap();
var $2c076defa05cd41b$var$RESULT_VALUE = {};
function $2c076defa05cd41b$export$6aabcc1951563d93(callback, deps) {
    var current = $2c076defa05cd41b$var$resultCache;
    for(var i = 0; i < deps.length; i += 1){
        var dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($2c076defa05cd41b$var$RESULT_VALUE)) current.set($2c076defa05cd41b$var$RESULT_VALUE, callback());
    return current.get($2c076defa05cd41b$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
var $2c076defa05cd41b$var$flattenTokenCache = new WeakMap();
function $2c076defa05cd41b$export$597374558a261efc(token) {
    var str = $2c076defa05cd41b$var$flattenTokenCache.get(token) || '';
    if (!str) {
        Object.keys(token).forEach(function(key) {
            var value = token[key];
            str += key;
            if (value instanceof (0, $c53ea62aae679119$export$2e2bcd8739ae039)) str += value.id;
            else if (value && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(value) === 'object') str += $2c076defa05cd41b$export$597374558a261efc(value);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        str = (0, $627b11c055ff79b0$export$2e2bcd8739ae039)(str);
        // Put in cache
        $2c076defa05cd41b$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $2c076defa05cd41b$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $627b11c055ff79b0$export$2e2bcd8739ae039)("".concat(salt, "_").concat($2c076defa05cd41b$export$597374558a261efc(token)));
}
var $2c076defa05cd41b$var$randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, '');
// Magic `content` for detect selector support
var $2c076defa05cd41b$var$checkContent = '_bAmBoO_';
function $2c076defa05cd41b$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)()) {
        var _getComputedStyle$con, _ele$parentNode;
        (0, $56d822aab7894329$export$4d99a2890bb989f0)(styleStr, $2c076defa05cd41b$var$randomSelectorKey);
        var _ele = document.createElement('div');
        _ele.style.position = 'fixed';
        _ele.style.left = '0';
        _ele.style.top = '0';
        handleElement === null || handleElement === void 0 || handleElement(_ele);
        document.body.appendChild(_ele);
        var support = supportCheck ? supportCheck(_ele) : (_getComputedStyle$con = getComputedStyle(_ele).content) === null || _getComputedStyle$con === void 0 ? void 0 : _getComputedStyle$con.includes($2c076defa05cd41b$var$checkContent);
        (_ele$parentNode = _ele.parentNode) === null || _ele$parentNode === void 0 || _ele$parentNode.removeChild(_ele);
        (0, $56d822aab7894329$export$2232e336aecaa80a)($2c076defa05cd41b$var$randomSelectorKey);
        return support;
    }
    return false;
}
var $2c076defa05cd41b$var$canLayer = undefined;
function $2c076defa05cd41b$export$ac8d3fd9840e20dd() {
    if ($2c076defa05cd41b$var$canLayer === undefined) $2c076defa05cd41b$var$canLayer = $2c076defa05cd41b$var$supportSelector("@layer ".concat($2c076defa05cd41b$var$randomSelectorKey, " { .").concat($2c076defa05cd41b$var$randomSelectorKey, " { content: \"").concat($2c076defa05cd41b$var$checkContent, "\"!important; } }"), function(ele) {
        ele.className = $2c076defa05cd41b$var$randomSelectorKey;
    });
    return $2c076defa05cd41b$var$canLayer;
}
var $2c076defa05cd41b$var$canWhere = undefined;
function $2c076defa05cd41b$export$f51d3b8ac4ac9ed1() {
    if ($2c076defa05cd41b$var$canWhere === undefined) $2c076defa05cd41b$var$canWhere = $2c076defa05cd41b$var$supportSelector(":where(.".concat($2c076defa05cd41b$var$randomSelectorKey, ") { content: \"").concat($2c076defa05cd41b$var$checkContent, "\"!important; }"), function(ele) {
        ele.className = $2c076defa05cd41b$var$randomSelectorKey;
    });
    return $2c076defa05cd41b$var$canWhere;
}
var $2c076defa05cd41b$var$canLogic = undefined;
function $2c076defa05cd41b$export$64a912f57d5de48e() {
    if ($2c076defa05cd41b$var$canLogic === undefined) $2c076defa05cd41b$var$canLogic = $2c076defa05cd41b$var$supportSelector(".".concat($2c076defa05cd41b$var$randomSelectorKey, " { inset-block: 93px !important; }"), function(ele) {
        ele.className = $2c076defa05cd41b$var$randomSelectorKey;
    }, function(ele) {
        return getComputedStyle(ele).bottom === '93px';
    });
    return $2c076defa05cd41b$var$canLogic;
}
var $2c076defa05cd41b$export$9542afab8c2a5f48 = (0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)();
function $2c076defa05cd41b$export$523c0b569236b342(num) {
    if (typeof num === 'number') return "".concat(num, "px");
    return num;
}
function $2c076defa05cd41b$export$71c98ec84f0481d3(style, tokenKey, styleId) {
    var customizeAttrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (plain) return style;
    var attrs = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, customizeAttrs), {}, (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, (0, $17bf098ab43a08aa$export$5d99297dcd5476ac), tokenKey), (0, $17bf098ab43a08aa$export$89ce1123b3c0bd9e), styleId));
    var attrStr = Object.keys(attrs).map(function(attr) {
        var val = attrs[attr];
        return val ? "".concat(attr, "=\"").concat(val, "\"") : null;
    }).filter(function(v) {
        return v;
    }).join(' ');
    return "<style ".concat(attrStr, ">").concat(style, "</style>");
}



var $6b85f1efbeaa7e3a$export$309b3b095f0c7662 = function token2CSSVar(token) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return "--".concat(prefix ? "".concat(prefix, "-") : '').concat(token).replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2').replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
};
var $6b85f1efbeaa7e3a$export$a27ef1ee9bbc757e = function serializeCSSVar(cssVars, hashId, options) {
    if (!Object.keys(cssVars).length) return '';
    return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : '', "{").concat(Object.entries(cssVars).map(function(_ref) {
        var _ref2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
        return "".concat(key, ":").concat(value, ";");
    }).join(''), "}");
};
var $6b85f1efbeaa7e3a$export$67858afe85bce49f = function transformToken(token, themeKey, config) {
    var cssVars = {};
    var result = {};
    Object.entries(token).forEach(function(_ref3) {
        var _config$preserve, _config$ignore;
        var _ref4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], value = _ref4[1];
        if (config !== null && config !== void 0 && (_config$preserve = config.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key]) result[key] = value;
        else if ((typeof value === 'string' || typeof value === 'number') && !(config !== null && config !== void 0 && (_config$ignore = config.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key])) {
            var _config$unitless;
            var cssVar = $6b85f1efbeaa7e3a$export$309b3b095f0c7662(key, config === null || config === void 0 ? void 0 : config.prefix);
            cssVars[cssVar] = typeof value === 'number' && !(config !== null && config !== void 0 && (_config$unitless = config.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key]) ? "".concat(value, "px") : String(value);
            result[key] = "var(".concat(cssVar, ")");
        }
    });
    return [
        result,
        $6b85f1efbeaa7e3a$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config === null || config === void 0 ? void 0 : config.scope
        })
    ];
};





var $eeyUA = parcelRequire("eeyUA");




var $eeyUA = parcelRequire("eeyUA");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $a6cbf381af41096e$var$useInternalLayoutEffect = (0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)() ? $eeyUA.useLayoutEffect : $eeyUA.useEffect;
var $a6cbf381af41096e$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $eeyUA.useRef(true);
    $a6cbf381af41096e$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $a6cbf381af41096e$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $a6cbf381af41096e$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $a6cbf381af41096e$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $a6cbf381af41096e$export$2e2bcd8739ae039 = $a6cbf381af41096e$var$useLayoutEffect;



var $eeyUA = parcelRequire("eeyUA");
// We need fully clone React function here
// to avoid webpack warning React 17 do not export `useId`
var $8bf02b5c0ee1a012$var$fullClone = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, $eeyUA);
var $8bf02b5c0ee1a012$var$useInsertionEffect = $8bf02b5c0ee1a012$var$fullClone.useInsertionEffect;
/**
 * Polyfill `useInsertionEffect` for React < 18
 * @param renderEffect will be executed in `useMemo`, and do not have callback
 * @param effect will be executed in `useLayoutEffect`
 * @param deps
 */ var $8bf02b5c0ee1a012$var$useInsertionEffectPolyfill = function useInsertionEffectPolyfill(renderEffect, effect, deps) {
    $eeyUA.useMemo(renderEffect, deps);
    (0, $a6cbf381af41096e$export$2e2bcd8739ae039)(function() {
        return effect(true);
    }, deps);
};
/**
 * Compatible `useInsertionEffect`
 * will use `useInsertionEffect` if React version >= 18,
 * otherwise use `useInsertionEffectPolyfill`.
 */ var $8bf02b5c0ee1a012$var$useCompatibleInsertionEffect = $8bf02b5c0ee1a012$var$useInsertionEffect ? function(renderEffect, effect, deps) {
    return $8bf02b5c0ee1a012$var$useInsertionEffect(function() {
        renderEffect();
        return effect();
    }, deps);
} : $8bf02b5c0ee1a012$var$useInsertionEffectPolyfill;
var $8bf02b5c0ee1a012$export$2e2bcd8739ae039 = $8bf02b5c0ee1a012$var$useCompatibleInsertionEffect;





var $eeyUA = parcelRequire("eeyUA");
var $8de610ebae3e312b$var$fullClone = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, $eeyUA);
var $8de610ebae3e312b$var$useInsertionEffect = $8de610ebae3e312b$var$fullClone.useInsertionEffect;
// DO NOT register functions in useEffect cleanup function, or functions that registered will never be called.
var $8de610ebae3e312b$var$useCleanupRegister = function useCleanupRegister(deps) {
    var effectCleanups = [];
    var cleanupFlag = false;
    function register(fn) {
        if (cleanupFlag) return;
        effectCleanups.push(fn);
    }
    $eeyUA.useEffect(function() {
        // Compatible with strict mode
        cleanupFlag = false;
        return function() {
            cleanupFlag = true;
            if (effectCleanups.length) effectCleanups.forEach(function(fn) {
                return fn();
            });
        };
    }, deps);
    return register;
};
var $8de610ebae3e312b$var$useRun = function useRun() {
    return function(fn) {
        fn();
    };
};
// Only enable register in React 18
var $8de610ebae3e312b$var$useEffectCleanupRegister = typeof $8de610ebae3e312b$var$useInsertionEffect !== 'undefined' ? $8de610ebae3e312b$var$useCleanupRegister : $8de610ebae3e312b$var$useRun;
var $8de610ebae3e312b$export$2e2bcd8739ae039 = $8de610ebae3e312b$var$useEffectCleanupRegister;


function $1724ef27b3419eff$var$useProdHMR() {
    return false;
}
var $1724ef27b3419eff$var$webpackHMR = false;
function $1724ef27b3419eff$var$useDevHMR() {
    return $1724ef27b3419eff$var$webpackHMR;
}
var $1724ef27b3419eff$export$2e2bcd8739ae039 = $1724ef27b3419eff$var$useProdHMR;
var $1724ef27b3419eff$var$win, $1724ef27b3419eff$var$originWebpackHotUpdate;


function $a87f55181aa84edc$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    var _React$useContext = $eeyUA.useContext((0, $17bf098ab43a08aa$export$2e2bcd8739ae039)), globalCache = _React$useContext.cache;
    var fullPath = [
        prefix
    ].concat((0, $3440102357566473$export$2e2bcd8739ae039)(keyPath));
    var fullPathStr = (0, $631880e01af2cb85$export$1d14e1d8187b9aad)(fullPath);
    var register = (0, $8de610ebae3e312b$export$2e2bcd8739ae039)([
        fullPathStr
    ]);
    var HMRUpdate = (0, $1724ef27b3419eff$export$2e2bcd8739ae039)();
    var buildCache = function buildCache(updater) {
        globalCache.opUpdate(fullPathStr, function(prevCache) {
            var _ref = prevCache || [
                undefined,
                undefined
            ], _ref2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref, 2), _ref2$ = _ref2[0], times = _ref2$ === void 0 ? 0 : _ref2$, cache = _ref2[1];
            // HMR should always ignore cache since developer may change it
            var tmpCache = cache;
            var mergedCache = tmpCache || cacheFn();
            var data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $eeyUA.useMemo(function() {
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    var cacheEntity = globalCache.opGet(fullPathStr);
    var cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $8bf02b5c0ee1a012$export$2e2bcd8739ae039)(function() {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
    }, function(polyfill) {
        // It's bad to call build again in effect.
        // But we have to do this since StrictMode will call effect twice
        // which will clear cache on the first time.
        buildCache(function(_ref3) {
            var _ref4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref3, 2), times = _ref4[0], cache = _ref4[1];
            if (polyfill && times === 0) onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
            return [
                times + 1,
                cache
            ];
        });
        return function() {
            globalCache.opUpdate(fullPathStr, function(prevCache) {
                var _ref5 = prevCache || [], _ref6 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref5, 2), _ref6$ = _ref6[0], times = _ref6$ === void 0 ? 0 : _ref6$, cache = _ref6[1];
                var nextCount = times - 1;
                if (nextCount === 0) {
                    // Always remove styles in useEffect callback
                    register(function() {
                        // With polyfill, registered callback will always be called synchronously
                        // But without polyfill, it will be called in effect clean up,
                        // And by that time this cache is cleaned up.
                        if (polyfill || !globalCache.opGet(fullPathStr)) onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache, false);
                    });
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}


var $d9c65b249070f8ca$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
var $d9c65b249070f8ca$var$hashPrefix = 'css';
var $d9c65b249070f8ca$var$tokenKeys = new Map();
function $d9c65b249070f8ca$var$recordCleanToken(tokenKey) {
    $d9c65b249070f8ca$var$tokenKeys.set(tokenKey, ($d9c65b249070f8ca$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $d9c65b249070f8ca$var$removeStyleTags(key, instanceId) {
    if (typeof document !== 'undefined') {
        var styles = document.querySelectorAll("style[".concat((0, $17bf098ab43a08aa$export$5d99297dcd5476ac), "=\"").concat(key, "\"]"));
        styles.forEach(function(style) {
            if (style[0, $17bf098ab43a08aa$export$4c16a0c02134a7dc] === instanceId) {
                var _style$parentNode;
                (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
            }
        });
    }
}
var $d9c65b249070f8ca$var$TOKEN_THRESHOLD = 0;
// Remove will check current keys first
function $d9c65b249070f8ca$var$cleanTokenStyle(tokenKey, instanceId) {
    $d9c65b249070f8ca$var$tokenKeys.set(tokenKey, ($d9c65b249070f8ca$var$tokenKeys.get(tokenKey) || 0) - 1);
    var cleanableKeyList = new Set();
    $d9c65b249070f8ca$var$tokenKeys.forEach(function(value, key) {
        if (value <= 0) cleanableKeyList.add(key);
    });
    // Should keep tokens under threshold for not to insert style too often
    if ($d9c65b249070f8ca$var$tokenKeys.size - cleanableKeyList.size > $d9c65b249070f8ca$var$TOKEN_THRESHOLD) cleanableKeyList.forEach(function(key) {
        $d9c65b249070f8ca$var$removeStyleTags(key, instanceId);
        $d9c65b249070f8ca$var$tokenKeys.delete(key);
    });
}
var $d9c65b249070f8ca$export$18602cb46ae80b62 = function getComputedToken(originToken, overrideToken, theme, format) {
    var derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    var mergedDerivativeToken = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, derivativeToken), overrideToken);
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
var $d9c65b249070f8ca$export$270fba097347f4fa = 'token';
function $d9c65b249070f8ca$export$2e2bcd8739ae039(theme, tokens) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _useContext = (0, $eeyUA.useContext)((0, $17bf098ab43a08aa$export$2e2bcd8739ae039)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var _option$salt = option.salt, salt = _option$salt === void 0 ? '' : _option$salt, _option$override = option.override, override = _option$override === void 0 ? $d9c65b249070f8ca$var$EMPTY_OVERRIDE : _option$override, formatToken = option.formatToken, compute = option.getComputedToken, cssVar = option.cssVar;
    // Basic - We do basic cache here
    var mergedToken = (0, $2c076defa05cd41b$export$6aabcc1951563d93)(function() {
        return Object.assign.apply(Object, [
            {}
        ].concat((0, $3440102357566473$export$2e2bcd8739ae039)(tokens)));
    }, tokens);
    var tokenStr = (0, $2c076defa05cd41b$export$597374558a261efc)(mergedToken);
    var overrideTokenStr = (0, $2c076defa05cd41b$export$597374558a261efc)(override);
    var cssVarStr = cssVar ? (0, $2c076defa05cd41b$export$597374558a261efc)(cssVar) : '';
    var cachedToken = (0, $a87f55181aa84edc$export$2e2bcd8739ae039)($d9c65b249070f8ca$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], function() {
        var _cssVar$key;
        var mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $d9c65b249070f8ca$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        // Replace token value with css variables
        var actualToken = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, mergedDerivativeToken);
        var cssVarsStr = '';
        if (!!cssVar) {
            var _transformToken = (0, $6b85f1efbeaa7e3a$export$67858afe85bce49f)(mergedDerivativeToken, cssVar.key, {
                prefix: cssVar.prefix,
                ignore: cssVar.ignore,
                unitless: cssVar.unitless,
                preserve: cssVar.preserve
            });
            var _transformToken2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_transformToken, 2);
            mergedDerivativeToken = _transformToken2[0];
            cssVarsStr = _transformToken2[1];
        }
        // Optimize for `useStyleRegister` performance
        var tokenKey = (0, $2c076defa05cd41b$export$6c82d0ebe8f2ea2c)(mergedDerivativeToken, salt);
        mergedDerivativeToken._tokenKey = tokenKey;
        actualToken._tokenKey = (0, $2c076defa05cd41b$export$6c82d0ebe8f2ea2c)(actualToken, salt);
        var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
        mergedDerivativeToken._themeKey = themeKey;
        $d9c65b249070f8ca$var$recordCleanToken(themeKey);
        var hashId = "".concat($d9c65b249070f8ca$var$hashPrefix, "-").concat((0, $627b11c055ff79b0$export$2e2bcd8739ae039)(tokenKey));
        mergedDerivativeToken._hashId = hashId; // Not used
        return [
            mergedDerivativeToken,
            hashId,
            actualToken,
            cssVarsStr,
            (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ''
        ];
    }, function(cache) {
        // Remove token will remove all related style
        $d9c65b249070f8ca$var$cleanTokenStyle(cache[0]._themeKey, instanceId);
    }, function(_ref) {
        var _ref2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref, 4), token = _ref2[0], cssVarsStr = _ref2[3];
        if (cssVar && cssVarsStr) {
            var style = (0, $56d822aab7894329$export$4d99a2890bb989f0)(cssVarsStr, (0, $627b11c055ff79b0$export$2e2bcd8739ae039)("css-variables-".concat(token._themeKey)), {
                mark: (0, $17bf098ab43a08aa$export$89ce1123b3c0bd9e),
                prepend: 'queue',
                attachTo: container,
                priority: -999
            });
            style[0, $17bf098ab43a08aa$export$4c16a0c02134a7dc] = instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $17bf098ab43a08aa$export$5d99297dcd5476ac), token._themeKey);
        }
    });
    return cachedToken;
}
var $d9c65b249070f8ca$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(cache, 5), realToken = _cache[2], styleStr = _cache[3], cssVarKey = _cache[4];
    var _ref3 = options || {}, plain = _ref3.plain;
    if (!styleStr) return null;
    var styleId = realToken._tokenKey;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    var styleText = (0, $2c076defa05cd41b$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};






var $eeyUA = parcelRequire("eeyUA");





var $7Nobb = parcelRequire("7Nobb");








var $eeyUA = parcelRequire("eeyUA");
var $03335e5feb44f925$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $03335e5feb44f925$export$2e2bcd8739ae039 = $03335e5feb44f925$var$unitlessKeys;


var $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 = "-ms-";
var $1e1e3b1b39978d8a$export$2c0f367103c8d01c = "-moz-";
var $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 = "-webkit-";
var $1e1e3b1b39978d8a$export$a29989082612d0d9 = "comm";
var $1e1e3b1b39978d8a$export$aa3a2e812ca8570d = "rule";
var $1e1e3b1b39978d8a$export$527d108ccf083c2b = "decl";
var $1e1e3b1b39978d8a$export$d3d35020fa5b54f0 = "@page";
var $1e1e3b1b39978d8a$export$500415a86c544f73 = "@media";
var $1e1e3b1b39978d8a$export$a763edbf796b780a = "@import";
var $1e1e3b1b39978d8a$export$2790aeb8b4e5c826 = "@charset";
var $1e1e3b1b39978d8a$export$1cc683e23b84b133 = "@viewport";
var $1e1e3b1b39978d8a$export$9447a5efea57e862 = "@supports";
var $1e1e3b1b39978d8a$export$ef011b4e114b1fba = "@document";
var $1e1e3b1b39978d8a$export$6aad947bda0f3f46 = "@namespace";
var $1e1e3b1b39978d8a$export$b44a8529a35fcb60 = "@keyframes";
var $1e1e3b1b39978d8a$export$2c16de31893252e6 = "@font-face";
var $1e1e3b1b39978d8a$export$3d846dd52e150c6f = "@counter-style";
var $1e1e3b1b39978d8a$export$22314bfbb57653fe = "@font-feature-values";
var $1e1e3b1b39978d8a$export$d773506282b3cfe6 = "@layer";
var $1e1e3b1b39978d8a$export$1c5a554c78c0cd12 = "@scope";
var $1e1e3b1b39978d8a$export$2335f513bbd82c6d = Math.abs;
var $1e1e3b1b39978d8a$export$6788812c4e6611e6 = String.fromCharCode;
var $1e1e3b1b39978d8a$export$e6e34fd1f2686227 = Object.assign;
function $1e1e3b1b39978d8a$export$d6af199866bfb566(e, r) {
    return $1e1e3b1b39978d8a$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $1e1e3b1b39978d8a$export$a9db5e087081082d(e, 0)) << 2 ^ $1e1e3b1b39978d8a$export$a9db5e087081082d(e, 1)) << 2 ^ $1e1e3b1b39978d8a$export$a9db5e087081082d(e, 2)) << 2 ^ $1e1e3b1b39978d8a$export$a9db5e087081082d(e, 3) : 0;
}
function $1e1e3b1b39978d8a$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $1e1e3b1b39978d8a$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $1e1e3b1b39978d8a$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $1e1e3b1b39978d8a$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $1e1e3b1b39978d8a$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $1e1e3b1b39978d8a$export$36776f635604f274(e) {
    return e.length;
}
function $1e1e3b1b39978d8a$export$f9084667e487ed46(e) {
    return e.length;
}
function $1e1e3b1b39978d8a$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $1e1e3b1b39978d8a$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $1e1e3b1b39978d8a$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$1e1e3b1b39978d8a$export$4659b591c19bdf3d(e, r);
    });
}
var $1e1e3b1b39978d8a$export$53f1d5ea8de3d7c = 1;
var $1e1e3b1b39978d8a$export$4e0c71f277ca26b3 = 1;
var $1e1e3b1b39978d8a$export$f24224f1c91d8156 = 0;
var $1e1e3b1b39978d8a$export$5880b8b5730aff45 = 0;
var $1e1e3b1b39978d8a$export$c0306caf338ac095 = 0;
var $1e1e3b1b39978d8a$export$30a86d91af8ff6e6 = "";
function $1e1e3b1b39978d8a$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $1e1e3b1b39978d8a$export$53f1d5ea8de3d7c,
        column: $1e1e3b1b39978d8a$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $1e1e3b1b39978d8a$export$784d13d8ee351f07(e, r) {
    return $1e1e3b1b39978d8a$export$e6e34fd1f2686227($1e1e3b1b39978d8a$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $1e1e3b1b39978d8a$export$590e8b2c435046d9(e) {
    while(e.root)e = $1e1e3b1b39978d8a$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $1e1e3b1b39978d8a$export$10d8903dec122b9d(e, e.siblings);
}
function $1e1e3b1b39978d8a$export$eba6f6f03b0a92e7() {
    return $1e1e3b1b39978d8a$export$c0306caf338ac095;
}
function $1e1e3b1b39978d8a$export$232faf9add678146() {
    $1e1e3b1b39978d8a$export$c0306caf338ac095 = $1e1e3b1b39978d8a$export$5880b8b5730aff45 > 0 ? $1e1e3b1b39978d8a$export$a9db5e087081082d($1e1e3b1b39978d8a$export$30a86d91af8ff6e6, --$1e1e3b1b39978d8a$export$5880b8b5730aff45) : 0;
    if ($1e1e3b1b39978d8a$export$4e0c71f277ca26b3--, $1e1e3b1b39978d8a$export$c0306caf338ac095 === 10) $1e1e3b1b39978d8a$export$4e0c71f277ca26b3 = 1, $1e1e3b1b39978d8a$export$53f1d5ea8de3d7c--;
    return $1e1e3b1b39978d8a$export$c0306caf338ac095;
}
function $1e1e3b1b39978d8a$export$48cfd1e771a65c4f() {
    $1e1e3b1b39978d8a$export$c0306caf338ac095 = $1e1e3b1b39978d8a$export$5880b8b5730aff45 < $1e1e3b1b39978d8a$export$f24224f1c91d8156 ? $1e1e3b1b39978d8a$export$a9db5e087081082d($1e1e3b1b39978d8a$export$30a86d91af8ff6e6, $1e1e3b1b39978d8a$export$5880b8b5730aff45++) : 0;
    if ($1e1e3b1b39978d8a$export$4e0c71f277ca26b3++, $1e1e3b1b39978d8a$export$c0306caf338ac095 === 10) $1e1e3b1b39978d8a$export$4e0c71f277ca26b3 = 1, $1e1e3b1b39978d8a$export$53f1d5ea8de3d7c++;
    return $1e1e3b1b39978d8a$export$c0306caf338ac095;
}
function $1e1e3b1b39978d8a$export$4d3fb11e950abb9e() {
    return $1e1e3b1b39978d8a$export$a9db5e087081082d($1e1e3b1b39978d8a$export$30a86d91af8ff6e6, $1e1e3b1b39978d8a$export$5880b8b5730aff45);
}
function $1e1e3b1b39978d8a$export$e88cb2efb12ae807() {
    return $1e1e3b1b39978d8a$export$5880b8b5730aff45;
}
function $1e1e3b1b39978d8a$export$58adb3bec8346d0f(e, r) {
    return $1e1e3b1b39978d8a$export$2f35ab04d2335697($1e1e3b1b39978d8a$export$30a86d91af8ff6e6, e, r);
}
function $1e1e3b1b39978d8a$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $1e1e3b1b39978d8a$export$2de70f21292aac9e(e) {
    return $1e1e3b1b39978d8a$export$53f1d5ea8de3d7c = $1e1e3b1b39978d8a$export$4e0c71f277ca26b3 = 1, $1e1e3b1b39978d8a$export$f24224f1c91d8156 = $1e1e3b1b39978d8a$export$36776f635604f274($1e1e3b1b39978d8a$export$30a86d91af8ff6e6 = e), $1e1e3b1b39978d8a$export$5880b8b5730aff45 = 0, [];
}
function $1e1e3b1b39978d8a$export$45918ac1574455b1(e) {
    return $1e1e3b1b39978d8a$export$30a86d91af8ff6e6 = "", e;
}
function $1e1e3b1b39978d8a$export$410ac95b9ec204b8(e) {
    return $1e1e3b1b39978d8a$export$87c2784dc9fc4ab($1e1e3b1b39978d8a$export$58adb3bec8346d0f($1e1e3b1b39978d8a$export$5880b8b5730aff45 - 1, $1e1e3b1b39978d8a$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $1e1e3b1b39978d8a$export$660b2ee2d4fb4eff(e) {
    return $1e1e3b1b39978d8a$export$45918ac1574455b1($1e1e3b1b39978d8a$export$5f8c09e3ae6f64e1($1e1e3b1b39978d8a$export$2de70f21292aac9e(e)));
}
function $1e1e3b1b39978d8a$export$7af1228ff777d175(e) {
    while($1e1e3b1b39978d8a$export$c0306caf338ac095 = $1e1e3b1b39978d8a$export$4d3fb11e950abb9e())if ($1e1e3b1b39978d8a$export$c0306caf338ac095 < 33) $1e1e3b1b39978d8a$export$48cfd1e771a65c4f();
    else break;
    return $1e1e3b1b39978d8a$export$9e1725a4cfeada27(e) > 2 || $1e1e3b1b39978d8a$export$9e1725a4cfeada27($1e1e3b1b39978d8a$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $1e1e3b1b39978d8a$export$5f8c09e3ae6f64e1(e) {
    while($1e1e3b1b39978d8a$export$48cfd1e771a65c4f())switch($1e1e3b1b39978d8a$export$9e1725a4cfeada27($1e1e3b1b39978d8a$export$c0306caf338ac095)){
        case 0:
            $1e1e3b1b39978d8a$export$10d8903dec122b9d($1e1e3b1b39978d8a$export$c2ab62c7bf24634($1e1e3b1b39978d8a$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $1e1e3b1b39978d8a$export$10d8903dec122b9d($1e1e3b1b39978d8a$export$410ac95b9ec204b8($1e1e3b1b39978d8a$export$c0306caf338ac095), e);
            break;
        default:
            $1e1e3b1b39978d8a$export$10d8903dec122b9d($1e1e3b1b39978d8a$export$6788812c4e6611e6($1e1e3b1b39978d8a$export$c0306caf338ac095), e);
    }
    return e;
}
function $1e1e3b1b39978d8a$export$955ba06d119e085e(e, r) {
    while(--r && $1e1e3b1b39978d8a$export$48cfd1e771a65c4f())if ($1e1e3b1b39978d8a$export$c0306caf338ac095 < 48 || $1e1e3b1b39978d8a$export$c0306caf338ac095 > 102 || $1e1e3b1b39978d8a$export$c0306caf338ac095 > 57 && $1e1e3b1b39978d8a$export$c0306caf338ac095 < 65 || $1e1e3b1b39978d8a$export$c0306caf338ac095 > 70 && $1e1e3b1b39978d8a$export$c0306caf338ac095 < 97) break;
    return $1e1e3b1b39978d8a$export$58adb3bec8346d0f(e, $1e1e3b1b39978d8a$export$e88cb2efb12ae807() + (r < 6 && $1e1e3b1b39978d8a$export$4d3fb11e950abb9e() == 32 && $1e1e3b1b39978d8a$export$48cfd1e771a65c4f() == 32));
}
function $1e1e3b1b39978d8a$export$c889f2fcc19dbf12(e) {
    while($1e1e3b1b39978d8a$export$48cfd1e771a65c4f())switch($1e1e3b1b39978d8a$export$c0306caf338ac095){
        case e:
            return $1e1e3b1b39978d8a$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $1e1e3b1b39978d8a$export$c889f2fcc19dbf12($1e1e3b1b39978d8a$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $1e1e3b1b39978d8a$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $1e1e3b1b39978d8a$export$48cfd1e771a65c4f();
            break;
    }
    return $1e1e3b1b39978d8a$export$5880b8b5730aff45;
}
function $1e1e3b1b39978d8a$export$4254d4e2b3745c4c(e, r) {
    while($1e1e3b1b39978d8a$export$48cfd1e771a65c4f())if (e + $1e1e3b1b39978d8a$export$c0306caf338ac095 === 57) break;
    else if (e + $1e1e3b1b39978d8a$export$c0306caf338ac095 === 84 && $1e1e3b1b39978d8a$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $1e1e3b1b39978d8a$export$58adb3bec8346d0f(r, $1e1e3b1b39978d8a$export$5880b8b5730aff45 - 1) + "*" + $1e1e3b1b39978d8a$export$6788812c4e6611e6(e === 47 ? e : $1e1e3b1b39978d8a$export$48cfd1e771a65c4f());
}
function $1e1e3b1b39978d8a$export$c2ab62c7bf24634(e) {
    while(!$1e1e3b1b39978d8a$export$9e1725a4cfeada27($1e1e3b1b39978d8a$export$4d3fb11e950abb9e()))$1e1e3b1b39978d8a$export$48cfd1e771a65c4f();
    return $1e1e3b1b39978d8a$export$58adb3bec8346d0f(e, $1e1e3b1b39978d8a$export$5880b8b5730aff45);
}
function $1e1e3b1b39978d8a$export$ef7acd7185315e22(e) {
    return $1e1e3b1b39978d8a$export$45918ac1574455b1($1e1e3b1b39978d8a$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $1e1e3b1b39978d8a$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $1e1e3b1b39978d8a$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var k = 0;
    var g = 0;
    var $ = "";
    var x = n;
    var y = s;
    var j = c;
    var z = $;
    while(w)switch(b = g, g = $1e1e3b1b39978d8a$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $1e1e3b1b39978d8a$export$a9db5e087081082d(z, l - 1) == 58) k++, z += "(";
            else z += $1e1e3b1b39978d8a$export$410ac95b9ec204b8(g);
            break;
        case 41:
            k--, z += ")";
            break;
        case 34:
        case 39:
        case 91:
            z += $1e1e3b1b39978d8a$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            if (k > 0) {
                z += $1e1e3b1b39978d8a$export$6788812c4e6611e6(g);
                break;
            }
            z += $1e1e3b1b39978d8a$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $1e1e3b1b39978d8a$export$955ba06d119e085e($1e1e3b1b39978d8a$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($1e1e3b1b39978d8a$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $1e1e3b1b39978d8a$export$10d8903dec122b9d($1e1e3b1b39978d8a$export$4a34f930e789283c($1e1e3b1b39978d8a$export$4254d4e2b3745c4c($1e1e3b1b39978d8a$export$48cfd1e771a65c4f(), $1e1e3b1b39978d8a$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($1e1e3b1b39978d8a$export$9e1725a4cfeada27(b || 1) == 5 || $1e1e3b1b39978d8a$export$9e1725a4cfeada27($1e1e3b1b39978d8a$export$4d3fb11e950abb9e() || 1) == 5) && $1e1e3b1b39978d8a$export$36776f635604f274(z) && $1e1e3b1b39978d8a$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $1e1e3b1b39978d8a$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            if (k > 0 && g) {
                z += $1e1e3b1b39978d8a$export$6788812c4e6611e6(g);
                break;
            }
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($1e1e3b1b39978d8a$export$36776f635604f274(z) - l || h === 0)) $1e1e3b1b39978d8a$export$10d8903dec122b9d(v > 32 ? $1e1e3b1b39978d8a$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $1e1e3b1b39978d8a$export$f8483753829ec8f3($1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $1e1e3b1b39978d8a$export$10d8903dec122b9d(j = $1e1e3b1b39978d8a$export$3307ffa7023ede1e(z, r, a, f, o, n, u, $, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $1e1e3b1b39978d8a$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($1e1e3b1b39978d8a$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($1e1e3b1b39978d8a$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $1e1e3b1b39978d8a$export$98e6a39c04603d36(e, j, j, c && $1e1e3b1b39978d8a$export$10d8903dec122b9d($1e1e3b1b39978d8a$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, $, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $1e1e3b1b39978d8a$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, $ = z = "", l = t;
            break;
        case 58:
            l = 1 + $1e1e3b1b39978d8a$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $1e1e3b1b39978d8a$export$232faf9add678146() == 125) continue;
            }
            switch(z += $1e1e3b1b39978d8a$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    if (k > 0) break;
                    u[f++] = ($1e1e3b1b39978d8a$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($1e1e3b1b39978d8a$export$4d3fb11e950abb9e() === 45) z += $1e1e3b1b39978d8a$export$410ac95b9ec204b8($1e1e3b1b39978d8a$export$48cfd1e771a65c4f());
                    p = $1e1e3b1b39978d8a$export$4d3fb11e950abb9e(), o = l = $1e1e3b1b39978d8a$export$36776f635604f274($ = z += $1e1e3b1b39978d8a$export$c2ab62c7bf24634($1e1e3b1b39978d8a$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $1e1e3b1b39978d8a$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $1e1e3b1b39978d8a$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $1e1e3b1b39978d8a$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, k = 0; w < c; ++w)for(var g = 0, m = $1e1e3b1b39978d8a$export$2f35ab04d2335697(e, v + 1, v = $1e1e3b1b39978d8a$export$2335f513bbd82c6d(d = u[w])), x = e; g < h; ++g)if (x = $1e1e3b1b39978d8a$export$87c2784dc9fc4ab(d > 0 ? b[g] + " " + m : $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(m, /&\f/g, b[g]))) f[k++] = x;
    return $1e1e3b1b39978d8a$export$35059013cd4a06db(e, r, a, s === 0 ? $1e1e3b1b39978d8a$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $1e1e3b1b39978d8a$export$4a34f930e789283c(e, r, a, n) {
    return $1e1e3b1b39978d8a$export$35059013cd4a06db(e, r, a, $1e1e3b1b39978d8a$export$a29989082612d0d9, $1e1e3b1b39978d8a$export$6788812c4e6611e6($1e1e3b1b39978d8a$export$eba6f6f03b0a92e7()), $1e1e3b1b39978d8a$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $1e1e3b1b39978d8a$export$f8483753829ec8f3(e, r, a, c, n) {
    return $1e1e3b1b39978d8a$export$35059013cd4a06db(e, r, a, $1e1e3b1b39978d8a$export$527d108ccf083c2b, $1e1e3b1b39978d8a$export$2f35ab04d2335697(e, 0, c), $1e1e3b1b39978d8a$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $1e1e3b1b39978d8a$export$82e9f45cca5ba907(c, n, s) {
    switch($1e1e3b1b39978d8a$export$d6af199866bfb566(c, n)){
        case 5103:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $1e1e3b1b39978d8a$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$2c0f367103c8d01c + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($1e1e3b1b39978d8a$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "box-$1$2" + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + "flex-item-" + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$1e1e3b1b39978d8a$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + "grid-row-" + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + "flex-line-pack" + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "box-" + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, "-grow", "") + $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed($1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed($1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed($1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "box-pack:$3" + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$1e1e3b1b39978d8a$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + "grid-column-align" + $1e1e3b1b39978d8a$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $1e1e3b1b39978d8a$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$1e1e3b1b39978d8a$export$f8e21b1e77979a08(c + (s = s[n].value), "span") ? c : $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$1e1e3b1b39978d8a$export$f8e21b1e77979a08(s, "span") ? $1e1e3b1b39978d8a$export$4659b591c19bdf3d(s, /\d+/) : +$1e1e3b1b39978d8a$export$4659b591c19bdf3d(s, /\d+/) - +$1e1e3b1b39978d8a$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $1e1e3b1b39978d8a$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed($1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($1e1e3b1b39978d8a$export$36776f635604f274(c) - 1 - n > 6) switch($1e1e3b1b39978d8a$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($1e1e3b1b39978d8a$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $1e1e3b1b39978d8a$export$2c0f367103c8d01c + ($1e1e3b1b39978d8a$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$1e1e3b1b39978d8a$export$f8e21b1e77979a08(c, "stretch") ? $1e1e3b1b39978d8a$export$82e9f45cca5ba907($1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($1e1e3b1b39978d8a$export$a9db5e087081082d(c, n + 6) === 121) return $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, ":", ":" + $1e1e3b1b39978d8a$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($1e1e3b1b39978d8a$export$a9db5e087081082d(c, $1e1e3b1b39978d8a$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + ($1e1e3b1b39978d8a$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, ":", ":" + $1e1e3b1b39978d8a$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $1e1e3b1b39978d8a$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $1e1e3b1b39978d8a$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $1e1e3b1b39978d8a$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $1e1e3b1b39978d8a$export$a763edbf796b780a:
        case $1e1e3b1b39978d8a$export$6aad947bda0f3f46:
        case $1e1e3b1b39978d8a$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $1e1e3b1b39978d8a$export$a29989082612d0d9:
            return "";
        case $1e1e3b1b39978d8a$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $1e1e3b1b39978d8a$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $1e1e3b1b39978d8a$export$aa3a2e812ca8570d:
            if (!$1e1e3b1b39978d8a$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $1e1e3b1b39978d8a$export$36776f635604f274(a = $1e1e3b1b39978d8a$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $1e1e3b1b39978d8a$export$5a7767152ae0305f(e) {
    var r = $1e1e3b1b39978d8a$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $1e1e3b1b39978d8a$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $1e1e3b1b39978d8a$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $1e1e3b1b39978d8a$export$527d108ccf083c2b:
                c.return = $1e1e3b1b39978d8a$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $1e1e3b1b39978d8a$export$b44a8529a35fcb60:
                return $1e1e3b1b39978d8a$export$dfdc1655ccc5b9cb([
                    $1e1e3b1b39978d8a$export$784d13d8ee351f07(c, {
                        value: $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $1e1e3b1b39978d8a$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $1e1e3b1b39978d8a$export$aa3a2e812ca8570d:
                if (c.length) return $1e1e3b1b39978d8a$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($1e1e3b1b39978d8a$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $1e1e3b1b39978d8a$export$590e8b2c435046d9($1e1e3b1b39978d8a$export$784d13d8ee351f07(c, {
                                props: [
                                    $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $1e1e3b1b39978d8a$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $1e1e3b1b39978d8a$export$590e8b2c435046d9($1e1e3b1b39978d8a$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $1e1e3b1b39978d8a$export$e6e34fd1f2686227(c, {
                                props: $1e1e3b1b39978d8a$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $1e1e3b1b39978d8a$export$590e8b2c435046d9($1e1e3b1b39978d8a$export$784d13d8ee351f07(c, {
                                props: [
                                    $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $1e1e3b1b39978d8a$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $1e1e3b1b39978d8a$export$590e8b2c435046d9($1e1e3b1b39978d8a$export$784d13d8ee351f07(c, {
                                props: [
                                    $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $1e1e3b1b39978d8a$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $1e1e3b1b39978d8a$export$590e8b2c435046d9($1e1e3b1b39978d8a$export$784d13d8ee351f07(c, {
                                props: [
                                    $1e1e3b1b39978d8a$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $1e1e3b1b39978d8a$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $1e1e3b1b39978d8a$export$590e8b2c435046d9($1e1e3b1b39978d8a$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $1e1e3b1b39978d8a$export$e6e34fd1f2686227(c, {
                                props: $1e1e3b1b39978d8a$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $1e1e3b1b39978d8a$export$76a88f7de6507443(e) {
    switch(e.type){
        case $1e1e3b1b39978d8a$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $1e1e3b1b39978d8a$export$1be1fc439b849fdf($1e1e3b1b39978d8a$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($1e1e3b1b39978d8a$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $1e1e3b1b39978d8a$export$2f35ab04d2335697(r, 1, $1e1e3b1b39978d8a$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $1e1e3b1b39978d8a$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $1e1e3b1b39978d8a$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $1e1e3b1b39978d8a$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}



function $9d5d01c7c2c83bef$export$e7b7955c4f1f8c03(message, info) {
    var path = info.path, parentSelectors = info.parentSelectors;
    (0, $f29d0996356f1173$export$2e2bcd8739ae039)(false, "[Ant Design CSS-in-JS] ".concat(path ? "Error in ".concat(path, ": ") : '').concat(message).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(' | ')) : ''));
}


var $517582dd13fccf96$var$linter = function linter(key, value, info) {
    if (key === 'content') {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        var contentValues = [
            'normal',
            'none',
            'initial',
            'inherit',
            'unset'
        ];
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $9d5d01c7c2c83bef$export$e7b7955c4f1f8c03)("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
};
var $517582dd13fccf96$export$2e2bcd8739ae039 = $517582dd13fccf96$var$linter;



var $f874c3ed9f1683e0$var$linter = function linter(key, value, info) {
    if (key === 'animation') {
        if (info.hashId && value !== 'none') (0, $9d5d01c7c2c83bef$export$e7b7955c4f1f8c03)("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
};
var $f874c3ed9f1683e0$export$2e2bcd8739ae039 = $f874c3ed9f1683e0$var$linter;



function $67aaf972fab16f6a$var$isConcatSelector(selector) {
    var _selector$match;
    var notContent = ((_selector$match = selector.match(/:not\(([^)]*)\)/)) === null || _selector$match === void 0 ? void 0 : _selector$match[1]) || '';
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    var splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter(function(str) {
        return str;
    });
    return splitCells.length > 1;
}
function $67aaf972fab16f6a$var$parsePath(info) {
    return info.parentSelectors.reduce(function(prev, cur) {
        if (!prev) return cur;
        return cur.includes('&') ? cur.replace(/&/g, prev) : "".concat(prev, " ").concat(cur);
    }, '');
}
var $67aaf972fab16f6a$var$linter = function linter(key, value, info) {
    var parentSelectorPath = $67aaf972fab16f6a$var$parsePath(info);
    var notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($67aaf972fab16f6a$var$isConcatSelector)) (0, $9d5d01c7c2c83bef$export$e7b7955c4f1f8c03)("Concat ':not' selector not support in legacy browsers.", info);
};
var $67aaf972fab16f6a$export$2e2bcd8739ae039 = $67aaf972fab16f6a$var$linter;



var $2dd98c6f33e1fa2d$var$linter = function linter(key, value, info) {
    switch(key){
        case 'marginLeft':
        case 'marginRight':
        case 'paddingLeft':
        case 'paddingRight':
        case 'left':
        case 'right':
        case 'borderLeft':
        case 'borderLeftWidth':
        case 'borderLeftStyle':
        case 'borderLeftColor':
        case 'borderRight':
        case 'borderRightWidth':
        case 'borderRightStyle':
        case 'borderRightColor':
        case 'borderTopLeftRadius':
        case 'borderTopRightRadius':
        case 'borderBottomLeftRadius':
        case 'borderBottomRightRadius':
            (0, $9d5d01c7c2c83bef$export$e7b7955c4f1f8c03)("You seem to be using non-logical property '".concat(key, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case 'margin':
        case 'padding':
        case 'borderWidth':
        case 'borderStyle':
            // case 'borderColor':
            if (typeof value === 'string') {
                var valueArr = value.split(' ').map(function(item) {
                    return item.trim();
                });
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $9d5d01c7c2c83bef$export$e7b7955c4f1f8c03)("You seem to be using '".concat(key, "' property with different left ").concat(key, " and right ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        case 'clear':
        case 'textAlign':
            if (value === 'left' || value === 'right') (0, $9d5d01c7c2c83bef$export$e7b7955c4f1f8c03)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case 'borderRadius':
            if (typeof value === 'string') {
                var radiusGroups = value.split('/').map(function(item) {
                    return item.trim();
                });
                var invalid = radiusGroups.reduce(function(result, group) {
                    if (result) return result;
                    var radiusArr = group.split(' ').map(function(item) {
                        return item.trim();
                    });
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $9d5d01c7c2c83bef$export$e7b7955c4f1f8c03)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        default:
    }
};
var $2dd98c6f33e1fa2d$export$2e2bcd8739ae039 = $2dd98c6f33e1fa2d$var$linter;



var $3bc004b59cd7593a$var$linter = function linter(key, value, info) {
    if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) (0, $9d5d01c7c2c83bef$export$e7b7955c4f1f8c03)("Unexpected 'NaN' in property '".concat(key, ": ").concat(value, "'."), info);
};
var $3bc004b59cd7593a$export$2e2bcd8739ae039 = $3bc004b59cd7593a$var$linter;



var $a45363a11a5b7c18$var$linter = function linter(key, value, info) {
    if (info.parentSelectors.some(function(selector) {
        var selectors = selector.split(',');
        return selectors.some(function(item) {
            return item.split('&').length > 2;
        });
    })) (0, $9d5d01c7c2c83bef$export$e7b7955c4f1f8c03)('Should not use more than one `&` in a selector.', info);
};
var $a45363a11a5b7c18$export$2e2bcd8739ae039 = $a45363a11a5b7c18$var$linter;









var $17bd5ebac42898ae$export$1c054aa01963e47e = 'data-ant-cssinjs-cache-path';
var $17bd5ebac42898ae$export$e0a2f8ff7fc63361 = '_FILE_STYLE__';
function $17bd5ebac42898ae$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map(function(path) {
        var hash = cachePathMap[path];
        return "".concat(path, ":").concat(hash);
    }).join(';');
}
var $17bd5ebac42898ae$var$cachePathMap;
var $17bd5ebac42898ae$var$fromCSSFile = true;
function $17bd5ebac42898ae$export$aad8462122ac592b(mockCache) {
    var fromFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $17bd5ebac42898ae$var$cachePathMap = mockCache;
    $17bd5ebac42898ae$var$fromCSSFile = fromFile;
}
function $17bd5ebac42898ae$export$18298bb220d85216() {
    if (!$17bd5ebac42898ae$var$cachePathMap) {
        $17bd5ebac42898ae$var$cachePathMap = {};
        if ((0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)()) {
            var div = document.createElement('div');
            div.className = $17bd5ebac42898ae$export$1c054aa01963e47e;
            div.style.position = 'fixed';
            div.style.visibility = 'hidden';
            div.style.top = '-9999px';
            document.body.appendChild(div);
            var content = getComputedStyle(div).content || '';
            content = content.replace(/^"/, '').replace(/"$/, '');
            // Fill data
            content.split(';').forEach(function(item) {
                var _item$split = item.split(':'), _item$split2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_item$split, 2), path = _item$split2[0], hash = _item$split2[1];
                $17bd5ebac42898ae$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            var inlineMapStyle = document.querySelector("style[".concat($17bd5ebac42898ae$export$1c054aa01963e47e, "]"));
            if (inlineMapStyle) {
                var _inlineMapStyle$paren;
                $17bd5ebac42898ae$var$fromCSSFile = false;
                (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $17bd5ebac42898ae$export$5aa0d776d676ab98(path) {
    $17bd5ebac42898ae$export$18298bb220d85216();
    return !!$17bd5ebac42898ae$var$cachePathMap[path];
}
function $17bd5ebac42898ae$export$d3851dfd3659b2ce(path) {
    var hash = $17bd5ebac42898ae$var$cachePathMap[path];
    var styleStr = null;
    if (hash && (0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)()) {
        if ($17bd5ebac42898ae$var$fromCSSFile) styleStr = $17bd5ebac42898ae$export$e0a2f8ff7fc63361;
        else {
            var _style = document.querySelector("style[".concat((0, $17bf098ab43a08aa$export$89ce1123b3c0bd9e), "=\"").concat($17bd5ebac42898ae$var$cachePathMap[path], "\"]"));
            if (_style) styleStr = _style.innerHTML;
            else // Clean up since not exist anymore
            delete $17bd5ebac42898ae$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}



var $a5989a3a1f75ed7b$var$SKIP_CHECK = '_skip_check_';
var $a5989a3a1f75ed7b$var$MULTI_VALUE = '_multi_value_';
function $a5989a3a1f75ed7b$export$8756898546458274(styleStr) {
    var serialized = (0, $1e1e3b1b39978d8a$export$dfdc1655ccc5b9cb)((0, $1e1e3b1b39978d8a$export$ef7acd7185315e22)(styleStr), (0, $1e1e3b1b39978d8a$export$fac44ee5b035f737));
    return serialized.replace(/\{%%%\:[^;];}/g, ';');
}
function $a5989a3a1f75ed7b$var$isCompoundCSSProperty(value) {
    return (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(value) === 'object' && value && ($a5989a3a1f75ed7b$var$SKIP_CHECK in value || $a5989a3a1f75ed7b$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $a5989a3a1f75ed7b$var$injectSelectorHash(key, hashId, hashPriority) {
    if (!hashId) return key;
    var hashClassName = ".".concat(hashId);
    var hashSelector = hashPriority === 'low' ? ":where(".concat(hashClassName, ")") : hashClassName;
    // 注入 hashId
    var keys = key.split(',').map(function(k) {
        var _firstPath$match;
        var fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        var firstPath = fullPath[0] || '';
        var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || '';
        firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
        return [
            firstPath
        ].concat((0, $3440102357566473$export$2e2bcd8739ae039)(fullPath.slice(1))).join(' ');
    });
    return keys.join(',');
}
var $a5989a3a1f75ed7b$export$e13dc740254f53d7 = function parseStyle(interpolation) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        root: true,
        parentSelectors: []
    }, root = _ref.root, injectHash = _ref.injectHash, parentSelectors = _ref.parentSelectors;
    var hashId = config.hashId, layer = config.layer, path = config.path, hashPriority = config.hashPriority, _config$transformers = config.transformers, transformers = _config$transformers === void 0 ? [] : _config$transformers, _config$linters = config.linters, linters = _config$linters === void 0 ? [] : _config$linters;
    var styleStr = '';
    var effectStyle = {};
    function parseKeyframes(keyframes) {
        var animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            var _parseStyle = parseStyle(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            }), _parseStyle2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_parseStyle, 1), _parsedStr = _parseStyle2[0];
            effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
        }
    }
    function flattenList(list) {
        var fullList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        list.forEach(function(item) {
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach(function(originStyle) {
        // Only root level can use raw string
        var style = typeof originStyle === 'string' && !root ? {} : originStyle;
        if (typeof style === 'string') styleStr += "".concat(style, "\n");
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            var mergedStyle = transformers.reduce(function(prev, trans) {
                var _trans$visit;
                return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev)) || prev;
            }, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach(function(key) {
                var value = mergedStyle[key];
                if ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(value) === 'object' && value && (key !== 'animationName' || !value._keyframe) && !$a5989a3a1f75ed7b$var$isCompoundCSSProperty(value)) {
                    var subInjectHash = false;
                    // 当成嵌套对象来处理
                    var mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    var nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith('@')) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else if (mergedKey === '&') // 抹掉 root selector 上的单个 &
                        mergedKey = $a5989a3a1f75ed7b$var$injectSelectorHash('', hashId, hashPriority);
                        else // 注入 hashId
                        mergedKey = $a5989a3a1f75ed7b$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === '&' || mergedKey === '')) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = '';
                        nextRoot = true;
                    }
                    var _parseStyle3 = parseStyle(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(parentSelectors), [
                            mergedKey
                        ])
                    }), _parseStyle4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_parseStyle3, 2), _parsedStr2 = _parseStyle4[0], childEffectStyle = _parseStyle4[1];
                    effectStyle = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, effectStyle), childEffectStyle);
                    styleStr += "".concat(mergedKey).concat(_parsedStr2);
                } else {
                    var _value;
                    function appendStyle(cssKey, cssValue) {
                        // 如果是样式则直接插入
                        var styleName = cssKey.replace(/[A-Z]/g, function(match) {
                            return "-".concat(match.toLowerCase());
                        });
                        // Auto suffix with px
                        var formatValue = cssValue;
                        if (!(0, $03335e5feb44f925$export$2e2bcd8739ae039)[cssKey] && typeof formatValue === 'number' && formatValue !== 0) formatValue = "".concat(formatValue, "px");
                        // handle animationName & Keyframe value
                        if (cssKey === 'animationName' && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += "".concat(styleName, ":").concat(formatValue, ";");
                    }
                    var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
                    if ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(value) === 'object' && value !== null && value !== void 0 && value[$a5989a3a1f75ed7b$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach(function(item) {
                        appendStyle(key, item);
                    });
                    else appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = "{".concat(styleStr, "}");
    else if (layer) {
        // fixme: https://github.com/thysultan/stylis/pull/339
        if (styleStr) styleStr = "@layer ".concat(layer.name, " {").concat(styleStr, "}");
        if (layer.dependencies) effectStyle["@layer ".concat(layer.name)] = layer.dependencies.map(function(deps) {
            return "@layer ".concat(deps, ", ").concat(layer.name, ";");
        }).join('\n');
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $a5989a3a1f75ed7b$export$412618713057f6ca(path, styleStr) {
    return (0, $627b11c055ff79b0$export$2e2bcd8739ae039)("".concat(path.join('%')).concat(styleStr));
}
function $a5989a3a1f75ed7b$var$Empty() {
    return null;
}
var $a5989a3a1f75ed7b$export$1e6d9f0d06c7ec14 = 'style';
function $a5989a3a1f75ed7b$export$2e2bcd8739ae039(info, styleFn) {
    var token = info.token, path = info.path, hashId = info.hashId, layer = info.layer, nonce = info.nonce, clientOnly = info.clientOnly, _info$order = info.order, order = _info$order === void 0 ? 0 : _info$order;
    var _React$useContext = $eeyUA.useContext((0, $17bf098ab43a08aa$export$2e2bcd8739ae039)), autoClear = _React$useContext.autoClear, mock = _React$useContext.mock, defaultCache = _React$useContext.defaultCache, hashPriority = _React$useContext.hashPriority, container = _React$useContext.container, ssrInline = _React$useContext.ssrInline, transformers = _React$useContext.transformers, linters = _React$useContext.linters, cache = _React$useContext.cache, enableLayer = _React$useContext.layer;
    var tokenKey = token._tokenKey;
    var fullPath = [
        tokenKey
    ];
    if (enableLayer) fullPath.push('layer');
    fullPath.push.apply(fullPath, (0, $3440102357566473$export$2e2bcd8739ae039)(path));
    // Check if need insert style
    var isMergedClientSide = (0, $2c076defa05cd41b$export$9542afab8c2a5f48);
    var _useGlobalCache = (0, $a87f55181aa84edc$export$2e2bcd8739ae039)($a5989a3a1f75ed7b$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    function() {
        var cachePath = fullPath.join('|');
        // Get style from SSR inline style directly
        if ((0, $17bd5ebac42898ae$export$5aa0d776d676ab98)(cachePath)) {
            var _getStyleAndHash = (0, $17bd5ebac42898ae$export$d3851dfd3659b2ce)(cachePath), _getStyleAndHash2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_getStyleAndHash, 2), inlineCacheStyleStr = _getStyleAndHash2[0], styleHash = _getStyleAndHash2[1];
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                tokenKey,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        var styleObj = styleFn();
        var _parseStyle5 = $a5989a3a1f75ed7b$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join('-'),
            transformers: transformers,
            linters: linters
        }), _parseStyle6 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_parseStyle5, 2), parsedStyle = _parseStyle6[0], effectStyle = _parseStyle6[1];
        var styleStr = $a5989a3a1f75ed7b$export$8756898546458274(parsedStyle);
        var styleId = $a5989a3a1f75ed7b$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            tokenKey,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    function(_ref2, fromHMR) {
        var _ref3 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref2, 3), styleId = _ref3[2];
        if ((fromHMR || autoClear) && (0, $2c076defa05cd41b$export$9542afab8c2a5f48)) (0, $56d822aab7894329$export$2232e336aecaa80a)(styleId, {
            mark: (0, $17bf098ab43a08aa$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, // Effect: Inject style here
    function(_ref4) {
        var _ref5 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref4, 4), styleStr = _ref5[0], _ = _ref5[1], styleId = _ref5[2], effectStyle = _ref5[3];
        if (isMergedClientSide && styleStr !== (0, $17bd5ebac42898ae$export$e0a2f8ff7fc63361)) {
            var mergedCSSConfig = {
                mark: (0, $17bf098ab43a08aa$export$89ce1123b3c0bd9e),
                prepend: enableLayer ? false : 'queue',
                attachTo: container,
                priority: order
            };
            var nonceStr = typeof nonce === 'function' ? nonce() : nonce;
            if (nonceStr) mergedCSSConfig.csp = {
                nonce: nonceStr
            };
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            var effectLayerKeys = [];
            var effectRestKeys = [];
            Object.keys(effectStyle).forEach(function(key) {
                if (key.startsWith('@layer')) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach(function(effectKey) {
                (0, $56d822aab7894329$export$4d99a2890bb989f0)($a5989a3a1f75ed7b$export$8756898546458274(effectStyle[effectKey]), "_layer-".concat(effectKey), (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, mergedCSSConfig), {}, {
                    prepend: true
                }));
            });
            // ==================== Inject Style ====================
            // Inject style
            var style = (0, $56d822aab7894329$export$4d99a2890bb989f0)(styleStr, styleId, mergedCSSConfig);
            style[0, $17bf098ab43a08aa$export$4c16a0c02134a7dc] = cache.instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $17bf098ab43a08aa$export$5d99297dcd5476ac), tokenKey);
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach(function(effectKey) {
                (0, $56d822aab7894329$export$4d99a2890bb989f0)($a5989a3a1f75ed7b$export$8756898546458274(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
            });
        }
    }), _useGlobalCache2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useGlobalCache, 3), cachedStyleStr = _useGlobalCache2[0], cachedTokenKey = _useGlobalCache2[1], cachedStyleId = _useGlobalCache2[2];
    return function(node) {
        var styleNode;
        if (!ssrInline || isMergedClientSide || !defaultCache) styleNode = /*#__PURE__*/ $eeyUA.createElement($a5989a3a1f75ed7b$var$Empty, null);
        else styleNode = /*#__PURE__*/ $eeyUA.createElement("style", (0, $7Nobb.default)({}, (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, (0, $17bf098ab43a08aa$export$5d99297dcd5476ac), cachedTokenKey), (0, $17bf098ab43a08aa$export$89ce1123b3c0bd9e), cachedStyleId), {
            dangerouslySetInnerHTML: {
                __html: cachedStyleStr
            }
        }));
        return /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, styleNode, node);
    };
}
var $a5989a3a1f75ed7b$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(cache, 6), styleStr = _cache[0], tokenKey = _cache[1], styleId = _cache[2], effectStyle = _cache[3], clientOnly = _cache[4], order = _cache[5];
    var _ref7 = options || {}, plain = _ref7.plain;
    // Skip client only style
    if (clientOnly) return null;
    var keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    // ====================== Style ======================
    keyStyleText = (0, $2c076defa05cd41b$export$71c98ec84f0481d3)(styleStr, tokenKey, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach(function(effectKey) {
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            var effectStyleStr = $a5989a3a1f75ed7b$export$8756898546458274(effectStyle[effectKey]);
            var effectStyleHTML = (0, $2c076defa05cd41b$export$71c98ec84f0481d3)(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
            if (effectKey.startsWith('@layer')) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};


var $3161356e0ec3b6e2$export$d96c342855c5e1fc = 'cssVar';
var $3161356e0ec3b6e2$var$useCSSVarRegister = function useCSSVarRegister(config, fn) {
    var key = config.key, prefix = config.prefix, unitless = config.unitless, ignore = config.ignore, token = config.token, _config$scope = config.scope, scope = _config$scope === void 0 ? '' : _config$scope;
    var _useContext = (0, $eeyUA.useContext)((0, $17bf098ab43a08aa$export$2e2bcd8739ae039)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var tokenKey = token._tokenKey;
    var stylePath = [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(config.path), [
        key,
        scope,
        tokenKey
    ]);
    var cache = (0, $a87f55181aa84edc$export$2e2bcd8739ae039)($3161356e0ec3b6e2$export$d96c342855c5e1fc, stylePath, function() {
        var originToken = fn();
        var _transformToken = (0, $6b85f1efbeaa7e3a$export$67858afe85bce49f)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope
        }), _transformToken2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_transformToken, 2), mergedToken = _transformToken2[0], cssVarsStr = _transformToken2[1];
        var styleId = (0, $a5989a3a1f75ed7b$export$412618713057f6ca)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, function(_ref) {
        var _ref2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref, 3), styleId = _ref2[2];
        if (0, $2c076defa05cd41b$export$9542afab8c2a5f48) (0, $56d822aab7894329$export$2232e336aecaa80a)(styleId, {
            mark: (0, $17bf098ab43a08aa$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, function(_ref3) {
        var _ref4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref3, 3), cssVarsStr = _ref4[1], styleId = _ref4[2];
        if (!cssVarsStr) return;
        var style = (0, $56d822aab7894329$export$4d99a2890bb989f0)(cssVarsStr, styleId, {
            mark: (0, $17bf098ab43a08aa$export$89ce1123b3c0bd9e),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        });
        style[0, $17bf098ab43a08aa$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $17bf098ab43a08aa$export$5d99297dcd5476ac), key);
    });
    return cache;
};
var $3161356e0ec3b6e2$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(cache, 4), styleStr = _cache[1], styleId = _cache[2], cssVarKey = _cache[3];
    var _ref5 = options || {}, plain = _ref5.plain;
    if (!styleStr) return null;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    var styleText = (0, $2c076defa05cd41b$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $3161356e0ec3b6e2$export$2e2bcd8739ae039 = $3161356e0ec3b6e2$var$useCSSVarRegister;





var $7101a1dc64488d1f$var$ExtractStyleFns = (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, (0, $a5989a3a1f75ed7b$export$1e6d9f0d06c7ec14), (0, $a5989a3a1f75ed7b$export$f9380c9a627682d3)), (0, $d9c65b249070f8ca$export$270fba097347f4fa), (0, $d9c65b249070f8ca$export$f9380c9a627682d3)), (0, $3161356e0ec3b6e2$export$d96c342855c5e1fc), (0, $3161356e0ec3b6e2$export$f9380c9a627682d3));
function $7101a1dc64488d1f$var$isNotNull(value) {
    return value !== null;
}
function $7101a1dc64488d1f$export$2e2bcd8739ae039(cache, options) {
    var _ref = typeof options === 'boolean' ? {
        plain: options
    } : options || {}, _ref$plain = _ref.plain, plain = _ref$plain === void 0 ? false : _ref$plain, _ref$types = _ref.types, types = _ref$types === void 0 ? [
        'style',
        'token',
        'cssVar'
    ] : _ref$types, _ref$once = _ref.once, once = _ref$once === void 0 ? false : _ref$once;
    var matchPrefixRegexp = new RegExp("^(".concat((typeof types === 'string' ? [
        types
    ] : types).join('|'), ")%"));
    // prefix with `style` is used for `useStyleRegister` to cache style context
    var styleKeys = Array.from(cache.cache.keys()).filter(function(key) {
        return matchPrefixRegexp.test(key);
    });
    // Common effect styles like animation
    var effectStyles = {};
    // Mapping of cachePath to style hash
    var cachePathMap = {};
    var styleText = '';
    styleKeys.map(function(key) {
        if (once && cache.extracted.has(key)) return null; // Skip if already extracted
        var cachePath = key.replace(matchPrefixRegexp, '').replace(/%/g, '|');
        var _key$split = key.split('%'), _key$split2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_key$split, 1), prefix = _key$split2[0];
        var extractFn = $7101a1dc64488d1f$var$ExtractStyleFns[prefix];
        var extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        var _extractedStyle = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(extractedStyle, 3), order = _extractedStyle[0], styleId = _extractedStyle[1], styleStr = _extractedStyle[2];
        if (key.startsWith('style')) cachePathMap[cachePath] = styleId;
        // record that this style has been extracted
        cache.extracted.add(key);
        return [
            order,
            styleStr
        ];
    }).filter($7101a1dc64488d1f$var$isNotNull).sort(function(_ref2, _ref3) {
        var _ref4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref2, 1), o1 = _ref4[0];
        var _ref5 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref3, 1), o2 = _ref5[0];
        return o1 - o2;
    }).forEach(function(_ref6) {
        var _ref7 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref6, 2), style = _ref7[1];
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $2c076defa05cd41b$export$71c98ec84f0481d3)(".".concat((0, $17bd5ebac42898ae$export$1c054aa01963e47e), "{content:\"").concat((0, $17bd5ebac42898ae$export$dfdc1655ccc5b9cb)(cachePathMap), "\";}"), undefined, undefined, (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, (0, $17bd5ebac42898ae$export$1c054aa01963e47e), (0, $17bd5ebac42898ae$export$1c054aa01963e47e)), plain);
    return styleText;
}








var $e21e866c0a33f7b1$var$Keyframe = /*#__PURE__*/ function() {
    function Keyframe(name, style) {
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, Keyframe);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "name", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "style", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "_keyframe", true);
        this.name = name;
        this.style = style;
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(Keyframe, [
        {
            key: "getName",
            value: function getName() {
                var hashId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
            }
        }
    ]);
    return Keyframe;
}();
var $e21e866c0a33f7b1$export$2e2bcd8739ae039 = $e21e866c0a33f7b1$var$Keyframe;






function $e14492f118609420$var$splitValues(value) {
    if (typeof value === 'number') return [
        [
            value
        ],
        false
    ];
    var rawStyle = String(value).trim();
    var importantCells = rawStyle.match(/(.*)(!important)/);
    var splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    var temp = [];
    var brackets = 0;
    return [
        splitStyle.reduce(function(list, item) {
            if (item.includes('(') || item.includes(')')) {
                var left = item.split('(').length - 1;
                var right = item.split(')').length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(' '));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function $e14492f118609420$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
var $e14492f118609420$var$keyMap = {
    // Inset
    inset: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    insetBlock: [
        'top',
        'bottom'
    ],
    insetBlockStart: [
        'top'
    ],
    insetBlockEnd: [
        'bottom'
    ],
    insetInline: [
        'left',
        'right'
    ],
    insetInlineStart: [
        'left'
    ],
    insetInlineEnd: [
        'right'
    ],
    // Margin
    marginBlock: [
        'marginTop',
        'marginBottom'
    ],
    marginBlockStart: [
        'marginTop'
    ],
    marginBlockEnd: [
        'marginBottom'
    ],
    marginInline: [
        'marginLeft',
        'marginRight'
    ],
    marginInlineStart: [
        'marginLeft'
    ],
    marginInlineEnd: [
        'marginRight'
    ],
    // Padding
    paddingBlock: [
        'paddingTop',
        'paddingBottom'
    ],
    paddingBlockStart: [
        'paddingTop'
    ],
    paddingBlockEnd: [
        'paddingBottom'
    ],
    paddingInline: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingInlineStart: [
        'paddingLeft'
    ],
    paddingInlineEnd: [
        'paddingRight'
    ],
    // Border
    borderBlock: $e14492f118609420$var$noSplit([
        'borderTop',
        'borderBottom'
    ]),
    borderBlockStart: $e14492f118609420$var$noSplit([
        'borderTop'
    ]),
    borderBlockEnd: $e14492f118609420$var$noSplit([
        'borderBottom'
    ]),
    borderInline: $e14492f118609420$var$noSplit([
        'borderLeft',
        'borderRight'
    ]),
    borderInlineStart: $e14492f118609420$var$noSplit([
        'borderLeft'
    ]),
    borderInlineEnd: $e14492f118609420$var$noSplit([
        'borderRight'
    ]),
    // Border width
    borderBlockWidth: [
        'borderTopWidth',
        'borderBottomWidth'
    ],
    borderBlockStartWidth: [
        'borderTopWidth'
    ],
    borderBlockEndWidth: [
        'borderBottomWidth'
    ],
    borderInlineWidth: [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    borderInlineStartWidth: [
        'borderLeftWidth'
    ],
    borderInlineEndWidth: [
        'borderRightWidth'
    ],
    // Border style
    borderBlockStyle: [
        'borderTopStyle',
        'borderBottomStyle'
    ],
    borderBlockStartStyle: [
        'borderTopStyle'
    ],
    borderBlockEndStyle: [
        'borderBottomStyle'
    ],
    borderInlineStyle: [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    borderInlineStartStyle: [
        'borderLeftStyle'
    ],
    borderInlineEndStyle: [
        'borderRightStyle'
    ],
    // Border color
    borderBlockColor: [
        'borderTopColor',
        'borderBottomColor'
    ],
    borderBlockStartColor: [
        'borderTopColor'
    ],
    borderBlockEndColor: [
        'borderBottomColor'
    ],
    borderInlineColor: [
        'borderLeftColor',
        'borderRightColor'
    ],
    borderInlineStartColor: [
        'borderLeftColor'
    ],
    borderInlineEndColor: [
        'borderRightColor'
    ],
    // Border radius
    borderStartStartRadius: [
        'borderTopLeftRadius'
    ],
    borderStartEndRadius: [
        'borderTopRightRadius'
    ],
    borderEndStartRadius: [
        'borderBottomLeftRadius'
    ],
    borderEndEndRadius: [
        'borderBottomRightRadius'
    ]
};
function $e14492f118609420$var$wrapImportantAndSkipCheck(value, important) {
    var parsedValue = value;
    if (important) parsedValue = "".concat(parsedValue, " !important");
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ var $e14492f118609420$var$transform = {
    visit: function visit(cssObj) {
        var clone = {};
        Object.keys(cssObj).forEach(function(key) {
            var value = cssObj[key];
            var matchValue = $e14492f118609420$var$keyMap[key];
            if (matchValue && (typeof value === 'number' || typeof value === 'string')) {
                var _splitValues = $e14492f118609420$var$splitValues(value), _splitValues2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_splitValues, 2), _values = _splitValues2[0], _important = _splitValues2[1];
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach(function(matchKey) {
                    clone[matchKey] = $e14492f118609420$var$wrapImportantAndSkipCheck(value, _important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $e14492f118609420$var$wrapImportantAndSkipCheck(_values[0], _important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach(function(matchKey, index) {
                    var _values$index;
                    clone[matchKey] = $e14492f118609420$var$wrapImportantAndSkipCheck((_values$index = _values[index]) !== null && _values$index !== void 0 ? _values$index : _values[0], _important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach(function(matchKey, index) {
                    var _ref, _values$index2;
                    clone[matchKey] = $e14492f118609420$var$wrapImportantAndSkipCheck((_ref = (_values$index2 = _values[index]) !== null && _values$index2 !== void 0 ? _values$index2 : _values[index - 2]) !== null && _ref !== void 0 ? _ref : _values[0], _important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $e14492f118609420$export$2e2bcd8739ae039 = $e14492f118609420$var$transform;





var $e100843fa705bc5b$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $e100843fa705bc5b$var$toFixed(number, precision) {
    var multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
var $e100843fa705bc5b$var$transform = function transform() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$rootValue = options.rootValue, rootValue = _options$rootValue === void 0 ? 16 : _options$rootValue, _options$precision = options.precision, precision = _options$precision === void 0 ? 5 : _options$precision, _options$mediaQuery = options.mediaQuery, mediaQuery = _options$mediaQuery === void 0 ? false : _options$mediaQuery;
    var pxReplace = function pxReplace(m, $1) {
        if (!$1) return m;
        var pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        var fixedVal = $e100843fa705bc5b$var$toFixed(pixels / rootValue, precision);
        return "".concat(fixedVal, "rem");
    };
    var visit = function visit(cssObj) {
        var clone = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, cssObj);
        Object.entries(cssObj).forEach(function(_ref) {
            var _ref2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
            if (typeof value === 'string' && value.includes('px')) {
                var newValue = value.replace($e100843fa705bc5b$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $03335e5feb44f925$export$2e2bcd8739ae039)[key] && typeof value === 'number' && value !== 0) clone[key] = "".concat(value, "px").replace($e100843fa705bc5b$var$pxRegex, pxReplace);
            // Media queries
            var mergedKey = key.trim();
            if (mergedKey.startsWith('@') && mergedKey.includes('px') && mediaQuery) {
                var newKey = key.replace($e100843fa705bc5b$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $e100843fa705bc5b$export$2e2bcd8739ae039 = $e100843fa705bc5b$var$transform;




var $360f78d8b8035c33$export$73abaea5066f503b = {
    supportModernCSS: function supportModernCSS() {
        return (0, $2c076defa05cd41b$export$f51d3b8ac4ac9ed1)() && (0, $2c076defa05cd41b$export$64a912f57d5de48e)();
    }
};











function $893d02686e989634$export$2e2bcd8739ae039(r) {
    return (0, $6f7c37c69e4e8741$export$2e2bcd8739ae039)(r) || (0, $cea7bea6a572eabb$export$2e2bcd8739ae039)(r) || (0, $31afbef354c99f62$export$2e2bcd8739ae039)(r) || (0, $78429f9f1196ab95$export$2e2bcd8739ae039)();
}


function $e27746190091cddd$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}


function $b0ca387bd247d427$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $893d02686e989634$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $3440102357566473$export$2e2bcd8739ae039)(entity);
    else clone = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $b0ca387bd247d427$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $b0ca387bd247d427$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $e27746190091cddd$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $b0ca387bd247d427$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $b0ca387bd247d427$var$isObject(obj) {
    return (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $b0ca387bd247d427$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $b0ca387bd247d427$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $b0ca387bd247d427$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $b0ca387bd247d427$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $e27746190091cddd$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $b0ca387bd247d427$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $e27746190091cddd$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $b0ca387bd247d427$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(originValue) !== 'object') // Init container if not exist
                    clone = $b0ca387bd247d427$export$2e2bcd8739ae039(clone, path, $b0ca387bd247d427$var$createEmpty(value));
                    $b0ca387bd247d427$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $3440102357566473$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $b0ca387bd247d427$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}



var $eeyUA = parcelRequire("eeyUA");

function $a3188745ad304597$export$8793edee2d425525() {}
let $a3188745ad304597$var$deprecatedWarnList = null;
function $a3188745ad304597$export$60eef1277fe463e4() {
    $a3188745ad304597$var$deprecatedWarnList = null;
    (0, $f29d0996356f1173$export$60eef1277fe463e4)();
}
let $a3188745ad304597$var$_warning = $a3188745ad304597$export$8793edee2d425525;
var $a3188745ad304597$var$valid, $a3188745ad304597$var$component, $a3188745ad304597$var$message;
const $a3188745ad304597$var$warning = $a3188745ad304597$var$_warning;
const $a3188745ad304597$export$11b88c75b33aa1fd = /*#__PURE__*/ $eeyUA.createContext({});
const $a3188745ad304597$export$cf977aa92c751e61 = ()=>{
    const noopWarning = ()=>{};
    noopWarning.deprecated = $a3188745ad304597$export$8793edee2d425525;
    return noopWarning;
};
var $a3188745ad304597$export$2e2bcd8739ae039 = $a3188745ad304597$var$warning;



var $eeyUA = parcelRequire("eeyUA");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
$c2615193e2fa8226$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eeyUA.createContext)(undefined);



var $eeyUA = parcelRequire("eeyUA");

var $bfd84d2568e4f30f$var$locale = {
    // Options
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
var $bfd84d2568e4f30f$export$2e2bcd8739ae039 = $bfd84d2568e4f30f$var$locale;



var $ea37f96c788b8738$export$bdd78c3fd9633c1e = {
    yearFormat: 'YYYY',
    dayFormat: 'D',
    cellMeridiemFormat: 'A',
    monthBeforeYear: true
};


var $9eb547fe840461ff$var$locale = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, (0, $ea37f96c788b8738$export$bdd78c3fd9633c1e)), {}, {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    dateFormat: 'M/D/YYYY',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
});
var $9eb547fe840461ff$export$2e2bcd8739ae039 = $9eb547fe840461ff$var$locale;


const $81fae850e0c9e31d$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $81fae850e0c9e31d$export$2e2bcd8739ae039 = $81fae850e0c9e31d$var$locale;


// Merge into a locale object
const $88946104844f0e1d$var$locale = {
    lang: Object.assign({
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ]
    }, (0, $9eb547fe840461ff$export$2e2bcd8739ae039)),
    timePickerLocale: Object.assign({}, (0, $81fae850e0c9e31d$export$2e2bcd8739ae039))
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$88946104844f0e1d$export$2e2bcd8739ae039 = $88946104844f0e1d$var$locale;


var $bc064e5ebb4c7a6e$export$2e2bcd8739ae039 = (0, $88946104844f0e1d$export$2e2bcd8739ae039);




const $535519d587587ff4$var$typeTemplate = '${label} is not a valid ${type}';
const $535519d587587ff4$var$localeValues = {
    locale: 'en',
    Pagination: $bfd84d2568e4f30f$export$2e2bcd8739ae039,
    DatePicker: $88946104844f0e1d$export$2e2bcd8739ae039,
    TimePicker: $81fae850e0c9e31d$export$2e2bcd8739ae039,
    Calendar: $bc064e5ebb4c7a6e$export$2e2bcd8739ae039,
    global: {
        placeholder: 'Please select',
        close: 'Close'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckAll: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Tour: {
        Next: 'Next',
        Previous: 'Previous',
        Finish: 'Finish'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        deselectAll: 'Deselect all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand',
        collapse: 'Collapse'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            default: 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            enum: '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $535519d587587ff4$var$typeTemplate,
                method: $535519d587587ff4$var$typeTemplate,
                array: $535519d587587ff4$var$typeTemplate,
                object: $535519d587587ff4$var$typeTemplate,
                number: $535519d587587ff4$var$typeTemplate,
                date: $535519d587587ff4$var$typeTemplate,
                boolean: $535519d587587ff4$var$typeTemplate,
                integer: $535519d587587ff4$var$typeTemplate,
                float: $535519d587587ff4$var$typeTemplate,
                regexp: $535519d587587ff4$var$typeTemplate,
                email: $535519d587587ff4$var$typeTemplate,
                url: $535519d587587ff4$var$typeTemplate,
                hex: $535519d587587ff4$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    Image: {
        preview: 'Preview'
    },
    QRCode: {
        expired: 'QR code expired',
        refresh: 'Refresh',
        scanned: 'Scanned'
    },
    ColorPicker: {
        presetEmpty: 'Empty',
        transparent: 'Transparent',
        singleColor: 'Single',
        gradientColor: 'Gradient'
    }
};
var $535519d587587ff4$export$2e2bcd8739ae039 = $535519d587587ff4$var$localeValues;


let $1519b933a5ca31be$var$runtimeLocale = Object.assign({}, (0, $535519d587587ff4$export$2e2bcd8739ae039).Modal);
let $1519b933a5ca31be$var$localeList = [];
const $1519b933a5ca31be$var$generateLocale = ()=>$1519b933a5ca31be$var$localeList.reduce((merged, locale)=>Object.assign(Object.assign({}, merged), locale), (0, $535519d587587ff4$export$2e2bcd8739ae039).Modal);
function $1519b933a5ca31be$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        const cloneLocale = Object.assign({}, newLocale);
        $1519b933a5ca31be$var$localeList.push(cloneLocale);
        $1519b933a5ca31be$var$runtimeLocale = $1519b933a5ca31be$var$generateLocale();
        return ()=>{
            $1519b933a5ca31be$var$localeList = $1519b933a5ca31be$var$localeList.filter((locale)=>locale !== cloneLocale);
            $1519b933a5ca31be$var$runtimeLocale = $1519b933a5ca31be$var$generateLocale();
        };
    }
    $1519b933a5ca31be$var$runtimeLocale = Object.assign({}, (0, $535519d587587ff4$export$2e2bcd8739ae039).Modal);
}
function $1519b933a5ca31be$export$1b6004afda18cd51() {
    return $1519b933a5ca31be$var$runtimeLocale;
}



var $eeyUA = parcelRequire("eeyUA");
const $b9b175c770d4ccec$var$LocaleContext = /*#__PURE__*/ (0, $eeyUA.createContext)(undefined);
var $b9b175c770d4ccec$export$2e2bcd8739ae039 = $b9b175c770d4ccec$var$LocaleContext;



var $eeyUA = parcelRequire("eeyUA");


const $6d3e114ae5f0e28f$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $eeyUA.useContext((0, $b9b175c770d4ccec$export$2e2bcd8739ae039));
    const getLocale = $eeyUA.useMemo(()=>{
        var _a;
        const locale = defaultLocale || (0, $535519d587587ff4$export$2e2bcd8739ae039)[componentName];
        const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return Object.assign(Object.assign({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $eeyUA.useMemo(()=>{
        const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) return (0, $535519d587587ff4$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $6d3e114ae5f0e28f$export$2e2bcd8739ae039 = $6d3e114ae5f0e28f$var$useLocale;


"use client";
const $ecc11aa0f480405f$export$b2f162cd5c15ea3e = 'internalMark';
const $ecc11aa0f480405f$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    $eeyUA.useEffect(()=>{
        const clearLocale = (0, $1519b933a5ca31be$export$9485ecb9d81a550c)(locale === null || locale === void 0 ? void 0 : locale.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $eeyUA.useMemo(()=>Object.assign(Object.assign({}, locale), {
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $eeyUA.createElement((0, $b9b175c770d4ccec$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $ecc11aa0f480405f$export$2e2bcd8739ae039 = $ecc11aa0f480405f$var$LocaleProvider;






const $57d31f3def09e8b8$export$37e27b43af4d16eb = {
    blue: '#1677FF',
    purple: '#722ED1',
    cyan: '#13C2C2',
    green: '#52C41A',
    magenta: '#EB2F96',
    /**
   * @deprecated Use magenta instead
   */ pink: '#EB2F96',
    red: '#F5222D',
    orange: '#FA8C16',
    yellow: '#FADB14',
    volcano: '#FA541C',
    geekblue: '#2F54EB',
    gold: '#FAAD14',
    lime: '#A0D911'
};
const $57d31f3def09e8b8$var$seedToken = Object.assign(Object.assign({}, $57d31f3def09e8b8$export$37e27b43af4d16eb), {
    // Color
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1677ff',
    colorLink: '',
    colorTextBase: '',
    colorBgBase: '',
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: 'solid',
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
    motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
    motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
    motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
    motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
});
var $57d31f3def09e8b8$export$2e2bcd8739ae039 = $57d31f3def09e8b8$var$seedToken;



function $e410c9b529785e2e$export$2e2bcd8739ae039(seed, { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes }) {
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)(errorColors[1]).mix(new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)(errorColors[3]), 50).toHexString();
    return Object.assign(Object.assign({}, neutralColors), {
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgFilledHover: colorErrorBgFilledHover,
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        colorBgMask: new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)('#000').setA(0.45).toRgbString(),
        colorWhite: '#fff'
    });
}


const $aed090eabd2f46fd$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $aed090eabd2f46fd$export$2e2bcd8739ae039 = $aed090eabd2f46fd$var$genRadius;


function $3c718f1bf39c502f$export$2e2bcd8739ae039(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return Object.assign({
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1
    }, (0, $aed090eabd2f46fd$export$2e2bcd8739ae039)(borderRadius));
}


const $133e76c184d72eb7$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $133e76c184d72eb7$export$2e2bcd8739ae039 = $133e76c184d72eb7$var$genControlHeight;


function $cddb9a637e42434c$export$56204a27a2958a55(fontSize) {
    return (fontSize + 8) / fontSize;
}
function $cddb9a637e42434c$export$2e2bcd8739ae039(base) {
    const fontSizes = Array.from({
        length: 10
    }).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.pow(Math.E, i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size: size,
            lineHeight: $cddb9a637e42434c$export$56204a27a2958a55(size)
        }));
}


const $7c869d773e82be36$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $cddb9a637e42434c$export$2e2bcd8739ae039)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $7c869d773e82be36$export$2e2bcd8739ae039 = $7c869d773e82be36$var$genFontMapToken;


function $7401bf12324fc778$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}




const $89cd6055f1dd2c9c$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)(baseColor).setA(alpha).toRgbString();
const $89cd6055f1dd2c9c$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)(baseColor);
    return instance.darken(brightness).toHexString();
};


const $4ec683e671fc3015$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $e53618f60b7980a8$export$2e2bcd8739ae039)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const $4ec683e671fc3015$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || '#fff';
    const colorTextBase = textBaseColor || '#000';
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 0.88),
        colorTextSecondary: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 0.15),
        colorFillSecondary: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 0.06),
        colorFillTertiary: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 0.02),
        colorBgSolid: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 1),
        colorBgSolidHover: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 0.75),
        colorBgSolidActive: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 0.95),
        colorBgLayout: (0, $89cd6055f1dd2c9c$export$7003a8a990e79359)(colorBgBase, 4),
        colorBgContainer: (0, $89cd6055f1dd2c9c$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgElevated: (0, $89cd6055f1dd2c9c$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $89cd6055f1dd2c9c$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorBgBlur: 'transparent',
        colorBorder: (0, $89cd6055f1dd2c9c$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderSecondary: (0, $89cd6055f1dd2c9c$export$7003a8a990e79359)(colorBgBase, 6)
    };
};


function $10f5fc6cde209df3$export$2e2bcd8739ae039(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    (0, $c009fb49b603f911$export$3968a3afc810b5f5).pink = (0, $c009fb49b603f911$export$3968a3afc810b5f5).magenta;
    (0, $c009fb49b603f911$export$36ad6df0f83f284d).pink = (0, $c009fb49b603f911$export$36ad6df0f83f284d).magenta;
    const colorPalettes = Object.keys((0, $57d31f3def09e8b8$export$37e27b43af4d16eb)).map((colorKey)=>{
        const colors = token[colorKey] === (0, $c009fb49b603f911$export$3968a3afc810b5f5)[colorKey] ? (0, $c009fb49b603f911$export$36ad6df0f83f284d)[colorKey] : (0, $e53618f60b7980a8$export$2e2bcd8739ae039)(token[colorKey]);
        return Array.from({
            length: 10
        }, ()=>1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), (0, $e410c9b529785e2e$export$2e2bcd8739ae039)(token, {
        generateColorPalettes: $4ec683e671fc3015$export$da275153033f4ec1,
        generateNeutralColorPalettes: $4ec683e671fc3015$export$3e0cb0c1d9c1b691
    })), (0, $7c869d773e82be36$export$2e2bcd8739ae039)(token.fontSize)), (0, $7401bf12324fc778$export$2e2bcd8739ae039)(token)), (0, $133e76c184d72eb7$export$2e2bcd8739ae039)(token)), (0, $3c718f1bf39c502f$export$2e2bcd8739ae039)(token));
}


const $d62a95af33c9b503$var$defaultTheme = (0, $d38e822e786c0de9$export$2e2bcd8739ae039)((0, $10f5fc6cde209df3$export$2e2bcd8739ae039));
var $d62a95af33c9b503$export$2e2bcd8739ae039 = $d62a95af33c9b503$var$defaultTheme;


var $eeyUA = parcelRequire("eeyUA");


const $af40d724f1881849$export$f84bd70098573c5c = {
    token: (0, $57d31f3def09e8b8$export$2e2bcd8739ae039),
    override: {
        override: (0, $57d31f3def09e8b8$export$2e2bcd8739ae039)
    },
    hashed: true
};
const $af40d724f1881849$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createContext($af40d724f1881849$export$f84bd70098573c5c);




var $eeyUA = parcelRequire("eeyUA");
const $0b79f8c0c8222aa8$export$e4ec87ea71f29b41 = 'ant';
const $0b79f8c0c8222aa8$export$eaca8ee5ed21b4e9 = 'anticon';
const $0b79f8c0c8222aa8$export$fa216ce2679a073b = [
    'outlined',
    'borderless',
    'filled',
    'underlined'
];
const $0b79f8c0c8222aa8$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `${$0b79f8c0c8222aa8$export$e4ec87ea71f29b41}-${suffixCls}` : $0b79f8c0c8222aa8$export$e4ec87ea71f29b41;
};
const $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b = /*#__PURE__*/ $eeyUA.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $0b79f8c0c8222aa8$var$defaultGetPrefixCls,
    iconPrefixCls: $0b79f8c0c8222aa8$export$eaca8ee5ed21b4e9
});
const { Consumer: $0b79f8c0c8222aa8$export$cd5442f2b8da7663 } = $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b;
const $0b79f8c0c8222aa8$var$EMPTY_OBJECT = {};
function $0b79f8c0c8222aa8$export$46f4bd6436a25a31(propName) {
    const context = $eeyUA.useContext($0b79f8c0c8222aa8$export$a92f85ab3e9ad68b);
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer } = context;
    const propValue = context[propName];
    return Object.assign(Object.assign({
        classNames: $0b79f8c0c8222aa8$var$EMPTY_OBJECT,
        styles: $0b79f8c0c8222aa8$var$EMPTY_OBJECT
    }, propValue), {
        getPrefixCls: getPrefixCls,
        direction: direction,
        getPopupContainer: getPopupContainer
    });
}







const $bedba16a99fbc67d$var$dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function $bedba16a99fbc67d$export$3d2f074408bd1b82(globalPrefixCls, theme) {
    const variables = {};
    const formatColor = (color, updater)=>{
        let clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    const fillColor = (colorVal, type)=>{
        const baseColor = new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)(colorVal);
        const colorPalettes = (0, $e53618f60b7980a8$export$2e2bcd8739ae039)(baseColor.toRgbString());
        variables[`${type}-color`] = formatColor(baseColor);
        variables[`${type}-color-disabled`] = colorPalettes[1];
        variables[`${type}-color-hover`] = colorPalettes[4];
        variables[`${type}-color-active`] = colorPalettes[6];
        variables[`${type}-color-outline`] = baseColor.clone().setA(0.2).toRgbString();
        variables[`${type}-color-deprecated-bg`] = colorPalettes[0];
        variables[`${type}-color-deprecated-border`] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, 'primary');
        const primaryColor = new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)(theme.primaryColor);
        const primaryColors = (0, $e53618f60b7980a8$export$2e2bcd8739ae039)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach((color, index)=>{
            variables[`primary-${index + 1}`] = color;
        });
        // Deprecated
        variables['primary-color-deprecated-l-35'] = formatColor(primaryColor, (c)=>c.lighten(35));
        variables['primary-color-deprecated-l-20'] = formatColor(primaryColor, (c)=>c.lighten(20));
        variables['primary-color-deprecated-t-20'] = formatColor(primaryColor, (c)=>c.tint(20));
        variables['primary-color-deprecated-t-50'] = formatColor(primaryColor, (c)=>c.tint(50));
        variables['primary-color-deprecated-f-12'] = formatColor(primaryColor, (c)=>c.setA(c.a * 0.12));
        const primaryActiveColor = new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)(primaryColors[0]);
        variables['primary-color-active-deprecated-f-30'] = formatColor(primaryActiveColor, (c)=>c.setA(c.a * 0.3));
        variables['primary-color-active-deprecated-d-02'] = formatColor(primaryActiveColor, (c)=>c.darken(2));
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, 'success');
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, 'warning');
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, 'error');
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, 'info');
    // Convert to css variables
    const cssList = Object.keys(variables).map((key)=>`--${globalPrefixCls}-${key}: ${variables[key]};`);
    return `
  :root {
    ${cssList.join('\n')}
  }
  `.trim();
}
function $bedba16a99fbc67d$export$f9c59eed5de5ff80(globalPrefixCls, theme) {
    const style = $bedba16a99fbc67d$export$3d2f074408bd1b82(globalPrefixCls, theme);
    if ((0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)()) (0, $56d822aab7894329$export$4d99a2890bb989f0)(style, `${$bedba16a99fbc67d$var$dynamicStyleMark}-dynamic-theme`);
}



var $eeyUA = parcelRequire("eeyUA");
"use client";
const $1dece405dee1b50b$var$DisabledContext = /*#__PURE__*/ $eeyUA.createContext(false);
const $1dece405dee1b50b$export$6adb5f3b918b11bb = ({ children: children, disabled: disabled })=>{
    const originDisabled = $eeyUA.useContext($1dece405dee1b50b$var$DisabledContext);
    return /*#__PURE__*/ $eeyUA.createElement($1dece405dee1b50b$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $1dece405dee1b50b$export$2e2bcd8739ae039 = $1dece405dee1b50b$var$DisabledContext;



var $eeyUA = parcelRequire("eeyUA");


var $eeyUA = parcelRequire("eeyUA");
"use client";
const $8a37775a72de6646$var$SizeContext = /*#__PURE__*/ $eeyUA.createContext(undefined);
const $8a37775a72de6646$export$dbc92d89fabc8ebe = ({ children: children, size: size })=>{
    const originSize = $eeyUA.useContext($8a37775a72de6646$var$SizeContext);
    return /*#__PURE__*/ $eeyUA.createElement($8a37775a72de6646$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $8a37775a72de6646$export$2e2bcd8739ae039 = $8a37775a72de6646$var$SizeContext;


function $6997ee34ad84aefe$var$useConfig() {
    const componentDisabled = (0, $eeyUA.useContext)((0, $1dece405dee1b50b$export$2e2bcd8739ae039));
    const componentSize = (0, $eeyUA.useContext)((0, $8a37775a72de6646$export$2e2bcd8739ae039));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $6997ee34ad84aefe$export$2e2bcd8739ae039 = $6997ee34ad84aefe$var$useConfig;







var $eeyUA = parcelRequire("eeyUA");
const $ea20fc5263ee81ac$var$fullClone = Object.assign({}, $eeyUA);
const { useId: $ea20fc5263ee81ac$var$useId } = $ea20fc5263ee81ac$var$fullClone;
const $ea20fc5263ee81ac$var$useEmptyId = ()=>'';
const $ea20fc5263ee81ac$var$useThemeKey = typeof $ea20fc5263ee81ac$var$useId === 'undefined' ? $ea20fc5263ee81ac$var$useEmptyId : $ea20fc5263ee81ac$var$useId;
var $ea20fc5263ee81ac$export$2e2bcd8739ae039 = $ea20fc5263ee81ac$var$useThemeKey;


function $9cdf28e66a843206$export$2e2bcd8739ae039(theme, parentTheme, config) {
    var _a, _b;
    const warning = (0, $a3188745ad304597$export$cf977aa92c751e61)('ConfigProvider');
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? Object.assign(Object.assign({}, (0, $af40d724f1881849$export$f84bd70098573c5c)), {
        hashed: (_a = parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.hashed) !== null && _a !== void 0 ? _a : (0, $af40d724f1881849$export$f84bd70098573c5c).hashed,
        cssVar: parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.cssVar
    }) : parentTheme;
    const themeKey = (0, $ea20fc5263ee81ac$export$2e2bcd8739ae039)();
    return (0, $f7a41f4eea21629f$export$2e2bcd8739ae039)(()=>{
        var _a, _b;
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = Object.assign({}, parentThemeConfig.components);
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
        const mergedCssVar = ((_a = themeConfig.cssVar) !== null && _a !== void 0 ? _a : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
            prefix: config === null || config === void 0 ? void 0 : config.prefixCls
        }, typeof parentThemeConfig.cssVar === 'object' ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === 'object' ? themeConfig.cssVar : {}), {
            key: typeof themeConfig.cssVar === 'object' && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || cssVarKey
        });
        // Base token
        return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
            token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
            components: mergedComponents,
            cssVar: mergedCssVar
        });
    }, [
        themeConfig,
        parentThemeConfig
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $899ab126ac4c56d7$export$2e2bcd8739ae039)(prevTheme, nextTheme, true);
        }));
}



var $eeyUA = parcelRequire("eeyUA");







var $eeyUA = parcelRequire("eeyUA");

function $66dfaa1c55a64564$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $66dfaa1c55a64564$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(node) === 'object' && $66dfaa1c55a64564$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($66dfaa1c55a64564$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $66dfaa1c55a64564$export$2e2bcd8739ae039(node) {
    var domNode = $66dfaa1c55a64564$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($6568ab17ba5c963b$exports))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($6568ab17ba5c963b$exports))), node);
    }
    return null;
}




var $eeyUA = parcelRequire("eeyUA");
var $db43fd9705486ec0$exports = {};
'use strict';

$db43fd9705486ec0$exports = (parcelRequire("aFVta"));




var $be2e892f106f6ad3$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $be2e892f106f6ad3$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $be2e892f106f6ad3$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $be2e892f106f6ad3$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(object) === 'object' && // React Element type
    (object.$$typeof === $be2e892f106f6ad3$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $be2e892f106f6ad3$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $be2e892f106f6ad3$var$REACT_FRAGMENT_TYPE);
}


var $54bedb74db46e87d$var$ReactMajorVersion = Number((0, $eeyUA.version).split('.')[0]);
var $54bedb74db46e87d$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $54bedb74db46e87d$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $54bedb74db46e87d$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $54bedb74db46e87d$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $f7a41f4eea21629f$export$2e2bcd8739ae039)(function() {
        return $54bedb74db46e87d$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $54bedb74db46e87d$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($54bedb74db46e87d$var$isReactElement(nodeOrComponent) && $54bedb74db46e87d$var$ReactMajorVersion >= 19) return true;
    var type = (0, $db43fd9705486ec0$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $db43fd9705486ec0$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $db43fd9705486ec0$exports.ForwardRef)) return false;
    return true;
};
function $54bedb74db46e87d$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $eeyUA.isValidElement)(node) && !(0, $be2e892f106f6ad3$export$2e2bcd8739ae039)(node);
}
var $54bedb74db46e87d$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $54bedb74db46e87d$var$isReactElement(node) && $54bedb74db46e87d$export$c1cec34af06bcf7(node);
};
var $54bedb74db46e87d$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $54bedb74db46e87d$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};



var $eeyUA = parcelRequire("eeyUA");


var $eeyUA = parcelRequire("eeyUA");
var $74703621beea1e35$var$_excluded = [
    "children"
];
var $74703621beea1e35$export$841858b892ce1f4c = /*#__PURE__*/ $eeyUA.createContext({});
function $74703621beea1e35$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_ref, $74703621beea1e35$var$_excluded);
    return /*#__PURE__*/ $eeyUA.createElement($74703621beea1e35$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}







var $eeyUA = parcelRequire("eeyUA");
var $065881e239f46c2a$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $6a4c2bdb64108a28$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $7104bbef2c357751$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($eeyUA.Component);
var $065881e239f46c2a$export$2e2bcd8739ae039 = $065881e239f46c2a$var$DomWrapper;






var $eeyUA = parcelRequire("eeyUA");
function $5c3680878bae3f7a$export$2e2bcd8739ae039(callback) {
    var fnRef = $eeyUA.useRef();
    fnRef.current = callback;
    var memoFn = $eeyUA.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}







var $eeyUA = parcelRequire("eeyUA");
function $7302d87e3dd17afc$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $eeyUA.useRef(false);
    var _React$useState = $eeyUA.useState(defaultValue), _React$useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $eeyUA.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $e7fff343666ddaae$var$hasValue(value) {
    return value !== undefined;
}
function $e7fff343666ddaae$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $7302d87e3dd17afc$export$2e2bcd8739ae039)(function() {
        if ($e7fff343666ddaae$var$hasValue(value)) return value;
        else if ($e7fff343666ddaae$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $5c3680878bae3f7a$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $7302d87e3dd17afc$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $a6cbf381af41096e$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $a6cbf381af41096e$export$9283e56bae2f7b0f)(function() {
        if (!$e7fff343666ddaae$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $5c3680878bae3f7a$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}











var $eeyUA = parcelRequire("eeyUA");

function $566c1c8dc342d975$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $eeyUA.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $eeyUA.useRef(defaultValue);
    var getValue = (0, $5c3680878bae3f7a$export$2e2bcd8739ae039)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $5c3680878bae3f7a$export$2e2bcd8739ae039)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}



var $eeyUA = parcelRequire("eeyUA");
var $f5d774a6f23f569e$export$de71442bbf2143da = 'none';
var $f5d774a6f23f569e$export$4fc3521687bcacd2 = 'appear';
var $f5d774a6f23f569e$export$5d6af549241fe2e8 = 'enter';
var $f5d774a6f23f569e$export$59b1c493d29f68e4 = 'leave';
var $f5d774a6f23f569e$export$40b34dd77d5522bf = 'none';
var $f5d774a6f23f569e$export$1b792916a5fac4fc = 'prepare';
var $f5d774a6f23f569e$export$9563153dd25a3ce8 = 'start';
var $f5d774a6f23f569e$export$e205886172277ec6 = 'active';
var $f5d774a6f23f569e$export$3a846c3d2fac10b8 = 'end';
var $f5d774a6f23f569e$export$98351fa4e6b4f204 = 'prepared';



var $eeyUA = parcelRequire("eeyUA");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $6a077ab486d7c484$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $6a077ab486d7c484$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $6a077ab486d7c484$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $6a077ab486d7c484$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $6a077ab486d7c484$var$vendorPrefixes = $6a077ab486d7c484$export$6e8b350b1a8958a0((0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
var $6a077ab486d7c484$var$style = {};
if ((0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)()) {
    var $6a077ab486d7c484$var$_document$createEleme = document.createElement('div');
    $6a077ab486d7c484$var$style = $6a077ab486d7c484$var$_document$createEleme.style;
}
var $6a077ab486d7c484$var$prefixedEventNames = {};
function $6a077ab486d7c484$export$a032e4f39350c1d8(eventName) {
    if ($6a077ab486d7c484$var$prefixedEventNames[eventName]) return $6a077ab486d7c484$var$prefixedEventNames[eventName];
    var prefixMap = $6a077ab486d7c484$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $6a077ab486d7c484$var$style) {
                $6a077ab486d7c484$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $6a077ab486d7c484$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $6a077ab486d7c484$var$internalAnimationEndName = $6a077ab486d7c484$export$a032e4f39350c1d8('animationend');
var $6a077ab486d7c484$var$internalTransitionEndName = $6a077ab486d7c484$export$a032e4f39350c1d8('transitionend');
var $6a077ab486d7c484$export$d28133ed3ad06c8b = !!($6a077ab486d7c484$var$internalAnimationEndName && $6a077ab486d7c484$var$internalTransitionEndName);
var $6a077ab486d7c484$export$760cc9769c51b738 = $6a077ab486d7c484$var$internalAnimationEndName || 'animationend';
var $6a077ab486d7c484$export$44baea64b8602e3c = $6a077ab486d7c484$var$internalTransitionEndName || 'transitionend';
function $6a077ab486d7c484$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $6a8b36371f95eab1$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $eeyUA.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $6a077ab486d7c484$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $6a077ab486d7c484$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $6a077ab486d7c484$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $6a077ab486d7c484$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $eeyUA.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $eeyUA = parcelRequire("eeyUA");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $d971251ccd3d9511$var$useIsomorphicLayoutEffect = (0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)() ? (0, $eeyUA.useLayoutEffect) : (0, $eeyUA.useEffect);
var $d971251ccd3d9511$export$2e2bcd8739ae039 = $d971251ccd3d9511$var$useIsomorphicLayoutEffect;





var $eeyUA = parcelRequire("eeyUA");


var $6c76e01d5e295d55$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $6c76e01d5e295d55$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $6c76e01d5e295d55$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $6c76e01d5e295d55$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $6c76e01d5e295d55$var$rafUUID = 0;
var $6c76e01d5e295d55$var$rafIds = new Map();
function $6c76e01d5e295d55$var$cleanup(id) {
    $6c76e01d5e295d55$var$rafIds.delete(id);
}
var $6c76e01d5e295d55$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $6c76e01d5e295d55$var$rafUUID += 1;
    var id = $6c76e01d5e295d55$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $6c76e01d5e295d55$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $6c76e01d5e295d55$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $6c76e01d5e295d55$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$6c76e01d5e295d55$var$wrapperRaf.cancel = function(id) {
    var realId = $6c76e01d5e295d55$var$rafIds.get(id);
    $6c76e01d5e295d55$var$cleanup(id);
    return $6c76e01d5e295d55$var$caf(realId);
};
var $6c76e01d5e295d55$export$2e2bcd8739ae039 = $6c76e01d5e295d55$var$wrapperRaf;



var $eeyUA = parcelRequire("eeyUA");
var $f38cbdcce3c8054f$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $eeyUA.useRef(null);
    function cancelNextFrame() {
        (0, $6c76e01d5e295d55$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $6c76e01d5e295d55$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $eeyUA.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $f4784a63d48fc214$var$FULL_STEP_QUEUE = [
    (0, $f5d774a6f23f569e$export$1b792916a5fac4fc),
    (0, $f5d774a6f23f569e$export$9563153dd25a3ce8),
    (0, $f5d774a6f23f569e$export$e205886172277ec6),
    (0, $f5d774a6f23f569e$export$3a846c3d2fac10b8)
];
var $f4784a63d48fc214$var$SIMPLE_STEP_QUEUE = [
    (0, $f5d774a6f23f569e$export$1b792916a5fac4fc),
    (0, $f5d774a6f23f569e$export$98351fa4e6b4f204)
];
var $f4784a63d48fc214$export$c2029bf6cfdbc28a = false;
var $f4784a63d48fc214$export$dbee1e282e8c4830 = true;
function $f4784a63d48fc214$export$39e04e72f972b885(step) {
    return step === (0, $f5d774a6f23f569e$export$e205886172277ec6) || step === (0, $f5d774a6f23f569e$export$3a846c3d2fac10b8);
}
var $f4784a63d48fc214$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $7302d87e3dd17afc$export$2e2bcd8739ae039)((0, $f5d774a6f23f569e$export$40b34dd77d5522bf)), _useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $f38cbdcce3c8054f$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $f5d774a6f23f569e$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $f4784a63d48fc214$var$SIMPLE_STEP_QUEUE : $f4784a63d48fc214$var$FULL_STEP_QUEUE;
    (0, $d971251ccd3d9511$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $f5d774a6f23f569e$export$40b34dd77d5522bf) && step !== (0, $f5d774a6f23f569e$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $f4784a63d48fc214$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $eeyUA.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $2035be2ba70085c3$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $7302d87e3dd17afc$export$2e2bcd8739ae039)(), _useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $566c1c8dc342d975$export$2e2bcd8739ae039)((0, $f5d774a6f23f569e$export$de71442bbf2143da)), _useSyncState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $7302d87e3dd17afc$export$2e2bcd8739ae039)(null), _useState4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $eeyUA.useRef)(false);
    var deadlineRef = (0, $eeyUA.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $eeyUA.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $f5d774a6f23f569e$export$de71442bbf2143da));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $5c3680878bae3f7a$export$2e2bcd8739ae039)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $f5d774a6f23f569e$export$de71442bbf2143da)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $f5d774a6f23f569e$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $f5d774a6f23f569e$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $f5d774a6f23f569e$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $6a8b36371f95eab1$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $f5d774a6f23f569e$export$4fc3521687bcacd2:
                return (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, (0, $f5d774a6f23f569e$export$1b792916a5fac4fc), onAppearPrepare), (0, $f5d774a6f23f569e$export$9563153dd25a3ce8), onAppearStart), (0, $f5d774a6f23f569e$export$e205886172277ec6), onAppearActive);
            case 0, $f5d774a6f23f569e$export$5d6af549241fe2e8:
                return (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, (0, $f5d774a6f23f569e$export$1b792916a5fac4fc), onEnterPrepare), (0, $f5d774a6f23f569e$export$9563153dd25a3ce8), onEnterStart), (0, $f5d774a6f23f569e$export$e205886172277ec6), onEnterActive);
            case 0, $f5d774a6f23f569e$export$59b1c493d29f68e4:
                return (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, (0, $f5d774a6f23f569e$export$1b792916a5fac4fc), onLeavePrepare), (0, $f5d774a6f23f569e$export$9563153dd25a3ce8), onLeaveStart), (0, $f5d774a6f23f569e$export$e205886172277ec6), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $eeyUA.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $f4784a63d48fc214$export$2e2bcd8739ae039)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $f5d774a6f23f569e$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $f5d774a6f23f569e$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $f4784a63d48fc214$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $f5d774a6f23f569e$export$e205886172277ec6) && currentStatus !== (0, $f5d774a6f23f569e$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $f5d774a6f23f569e$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $f4784a63d48fc214$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $f4784a63d48fc214$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    var visibleRef = (0, $eeyUA.useRef)(null);
    // Update with new status
    (0, $d971251ccd3d9511$export$2e2bcd8739ae039)(function() {
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $f5d774a6f23f569e$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $f5d774a6f23f569e$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $f5d774a6f23f569e$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $f5d774a6f23f569e$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $f5d774a6f23f569e$export$de71442bbf2143da));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $eeyUA.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $f5d774a6f23f569e$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $f5d774a6f23f569e$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $f5d774a6f23f569e$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $f5d774a6f23f569e$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $eeyUA.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $eeyUA.useRef(false);
    (0, $eeyUA.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $f5d774a6f23f569e$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $f5d774a6f23f569e$export$1b792916a5fac4fc] && step === (0, $f5d774a6f23f569e$export$9563153dd25a3ce8)) mergedStyle = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $5876bed62b6c4389$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $eeyUA.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $eeyUA.useContext((0, $74703621beea1e35$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $eeyUA.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $eeyUA.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $66dfaa1c55a64564$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $2035be2ba70085c3$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $eeyUA.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $eeyUA.useCallback(function(node) {
            nodeRef.current = node;
            (0, $54bedb74db46e87d$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $f5d774a6f23f569e$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $f5d774a6f23f569e$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
            else if ((0, $f4784a63d48fc214$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $f5d774a6f23f569e$export$9563153dd25a3ce8)) statusSuffix = 'start';
            var motionCls = (0, $6a077ab486d7c484$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))((0, $6a077ab486d7c484$export$27c72201b1d09951)(motionName, status), (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $eeyUA.isValidElement(motionChildren) && (0, $54bedb74db46e87d$export$c1cec34af06bcf7)(motionChildren)) {
            var originNodeRef = (0, $54bedb74db46e87d$export$7465e5c0bf44f19a)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $eeyUA.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $eeyUA.createElement((0, $065881e239f46c2a$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $5876bed62b6c4389$export$2e2bcd8739ae039 = $5876bed62b6c4389$export$e265d52a86a9f199((0, $6a077ab486d7c484$export$d28133ed3ad06c8b));



var $7Nobb = parcelRequire("7Nobb");









var $eeyUA = parcelRequire("eeyUA");



var $99b96b7c90af177b$export$3904baa009bc026e = 'add';
var $99b96b7c90af177b$export$851162f0adad2cbc = 'keep';
var $99b96b7c90af177b$export$c8b3fb08b68cfc85 = 'remove';
var $99b96b7c90af177b$export$2ac1bd1808d2e43a = 'removed';
function $99b96b7c90af177b$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $99b96b7c90af177b$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($99b96b7c90af177b$export$c47fd798e598c85c);
}
function $99b96b7c90af177b$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $99b96b7c90af177b$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $99b96b7c90af177b$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $99b96b7c90af177b$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $99b96b7c90af177b$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $99b96b7c90af177b$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $99b96b7c90af177b$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $99b96b7c90af177b$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $99b96b7c90af177b$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $4b48db06679f2b91$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $4b48db06679f2b91$var$_excluded2 = [
    "status"
];
var $4b48db06679f2b91$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $4b48db06679f2b91$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5876bed62b6c4389$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $6a4c2bdb64108a28$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $7104bbef2c357751$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $827123db267e1039$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                _this.setState(function(prevState) {
                    var nextKeyEntities = prevState.keyEntities.map(function(entity) {
                        if (entity.key !== removeKey) return entity;
                        return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, entity), {}, {
                            status: (0, $99b96b7c90af177b$export$2ac1bd1808d2e43a)
                        });
                    });
                    return {
                        keyEntities: nextKeyEntities
                    };
                }, function() {
                    var keyEntities = _this.state.keyEntities;
                    var restKeysCount = keyEntities.filter(function(_ref) {
                        var status = _ref.status;
                        return status !== (0, $99b96b7c90af177b$export$2ac1bd1808d2e43a);
                    }).length;
                    if (restKeysCount === 0 && _this.props.onAllRemoved) _this.props.onAllRemoved();
                });
            });
            return _this;
        }
        (0, $055f1aac98d71283$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_this$props, $4b48db06679f2b91$var$_excluded);
                    var Component = component || $eeyUA.Fragment;
                    var motionProps = {};
                    $4b48db06679f2b91$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $eeyUA.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_ref2, $4b48db06679f2b91$var$_excluded2);
                        var visible = status === (0, $99b96b7c90af177b$export$3904baa009bc026e) || status === (0, $99b96b7c90af177b$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $eeyUA.createElement(CSSMotion, (0, $7Nobb.default)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) _this2.removeKey(eventProps.key);
                            }
                        }), function(props, ref) {
                            return children((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $99b96b7c90af177b$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $99b96b7c90af177b$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $99b96b7c90af177b$export$2ac1bd1808d2e43a) && entity.status === (0, $99b96b7c90af177b$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($eeyUA.Component);
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $4b48db06679f2b91$export$2e2bcd8739ae039 = $4b48db06679f2b91$export$fcfc62c1d33d5e2e((0, $6a077ab486d7c484$export$d28133ed3ad06c8b));



var $31ad051c24fca029$export$2e2bcd8739ae039 = (0, $5876bed62b6c4389$export$2e2bcd8739ae039);



var $eeyUA = parcelRequire("eeyUA");

var $967f3aacd5a334b2$export$2e2bcd8739ae039 = '5.29.3';


"use client";
var $b2322773a3b0224d$export$2e2bcd8739ae039 = (0, $967f3aacd5a334b2$export$2e2bcd8739ae039);







function $699d3b1bab70fa3d$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $699d3b1bab70fa3d$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($699d3b1bab70fa3d$var$isStableColor(r) && $699d3b1bab70fa3d$var$isStableColor(g) && $699d3b1bab70fa3d$var$isStableColor(b)) return new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $699d3b1bab70fa3d$export$2e2bcd8739ae039 = $699d3b1bab70fa3d$var$getAlphaColor;


var $a85934f07b6b2b98$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $a85934f07b6b2b98$export$2e2bcd8739ae039(derivativeToken) {
    const { override: override } = derivativeToken, restToken = $a85934f07b6b2b98$var$__rest(derivativeToken, [
        "override"
    ]);
    const overrideTokens = Object.assign({}, override);
    Object.keys((0, $57d31f3def09e8b8$export$2e2bcd8739ae039)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = '0s';
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $699d3b1bab70fa3d$export$2e2bcd8739ae039)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $699d3b1bab70fa3d$export$2e2bcd8739ae039)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $699d3b1bab70fa3d$export$2e2bcd8739ae039)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 3,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $699d3b1bab70fa3d$export$2e2bcd8739ae039)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: 'none',
        linkHoverDecoration: 'none',
        linkFocusDecoration: 'none',
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        boxShadowPopoverArrow: '2px 2px 5px rgba(0, 0, 0, 0.05)',
        boxShadowCard: `
      0 1px 2px -2px ${new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.16)').toRgbString()},
      0 3px 6px 0 ${new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.12)').toRgbString()},
      0 5px 12px 4px ${new (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.09)').toRgbString()}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTabsOverflowLeft: 'inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowRight: 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowTop: 'inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowBottom: 'inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)'
    }), overrideTokens);
    return aliasToken;
}


var $77023b8a2ee37055$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $77023b8a2ee37055$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
};
const $77023b8a2ee37055$export$738b109e247a462c = {
    motionBase: true,
    motionUnit: true
};
const $77023b8a2ee37055$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
};
const $77023b8a2ee37055$export$18602cb46ae80b62 = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override } = overrideToken, components = $77023b8a2ee37055$var$__rest(overrideToken, [
        "override"
    ]);
    // Merge with override
    let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
        override: override
    });
    // Format if needed
    mergedDerivativeToken = (0, $a85934f07b6b2b98$export$2e2bcd8739ae039)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach(([key, value])=>{
        const { theme: componentTheme } = value, componentTokens = $77023b8a2ee37055$var$__rest(value, [
            "theme"
        ]);
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $77023b8a2ee37055$export$18602cb46ae80b62(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $77023b8a2ee37055$export$2e2bcd8739ae039() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: cssVar } = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useContext((0, $af40d724f1881849$export$69b0ebb9efcddb30));
    const salt = `${(0, $b2322773a3b0224d$export$2e2bcd8739ae039)}-${hashed || ''}`;
    const mergedTheme = theme || (0, $d62a95af33c9b503$export$2e2bcd8739ae039);
    const [token, hashId, realToken] = (0, $d9c65b249070f8ca$export$2e2bcd8739ae039)(mergedTheme, [
        (0, $57d31f3def09e8b8$export$2e2bcd8739ae039),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $77023b8a2ee37055$export$18602cb46ae80b62,
        formatToken: // formatToken will not be consumed after 1.15.0 with getComputedToken.
        // But token will break if @ant-design/cssinjs is under 1.15.0 without it
        $a85934f07b6b2b98$export$2e2bcd8739ae039,
        cssVar: cssVar && {
            prefix: cssVar.prefix,
            key: cssVar.key,
            unitless: $77023b8a2ee37055$export$c6b9faa6b723d31a,
            ignore: $77023b8a2ee37055$export$738b109e247a462c,
            preserve: $77023b8a2ee37055$var$preserve
        }
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : '',
        token,
        cssVar
    ];
}


"use client";
const $6febb7f436d22e66$var$MotionCacheContext = /*#__PURE__*/ $eeyUA.createContext(true);
function $6febb7f436d22e66$export$2e2bcd8739ae039(props) {
    const parentMotion = $eeyUA.useContext($6febb7f436d22e66$var$MotionCacheContext);
    const { children: children } = props;
    const [, token] = (0, $77023b8a2ee37055$export$2e2bcd8739ae039)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $eeyUA.useRef(false);
    needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion);
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $eeyUA.createElement($6febb7f436d22e66$var$MotionCacheContext.Provider, {
        value: motion
    }, /*#__PURE__*/ $eeyUA.createElement((0, $74703621beea1e35$export$2e2bcd8739ae039), {
        motion: motion
    }, children));
    return children;
}



var $eeyUA = parcelRequire("eeyUA");

"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $32d6930370d1e7c3$var$PropWarning = /*#__PURE__*/ $eeyUA.memo(({ dropdownMatchSelectWidth: dropdownMatchSelectWidth })=>{
    const warning = (0, $a3188745ad304597$export$cf977aa92c751e61)('ConfigProvider');
    warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
    return null;
});
var $32d6930370d1e7c3$export$2e2bcd8739ae039 = ()=>null;





"use client";
const $d715ae4ca001487d$export$b2b65df0d0824629 = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
};
const $d715ae4ca001487d$export$23997c3e44cc1c59 = (token, needInheritFontFamily = false)=>({
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: 'none',
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
    });
const $d715ae4ca001487d$export$171ccda7bc085e59 = ()=>({
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        fontStyle: 'normal',
        lineHeight: 0,
        textAlign: 'center',
        textTransform: 'none',
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: '-0.125em',
        textRendering: 'optimizeLegibility',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '> *': {
            lineHeight: 1
        },
        svg: {
            display: 'inline-block'
        }
    });
const $d715ae4ca001487d$export$8c467e8859fdef13 = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        '&::before': {
            display: 'table',
            content: '""'
        },
        '&::after': {
            // https://github.com/ant-design/ant-design/issues/21864
            display: 'table',
            clear: 'both',
            content: '""'
        }
    });
const $d715ae4ca001487d$export$905d771977096614 = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: 'transparent',
            // remove the gray background on active links in IE 10.
            outline: 'none',
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            '-webkit-text-decoration-skip': 'objects',
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            '&:hover': {
                color: token.colorLinkHover
            },
            '&:active': {
                color: token.colorLinkActive
            },
            '&:active, &:hover': {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            '&:focus': {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            '&[disabled]': {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    });
const $d715ae4ca001487d$export$689382c111559cd9 = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: 'border-box',
        '&::before, &::after': {
            boxSizing: 'border-box'
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: Object.assign(Object.assign(Object.assign({}, resetFontStyle), resetStyle), {
            [prefixSelector]: resetStyle
        })
    };
};
const $d715ae4ca001487d$export$6539948f0a737e39 = (token, offset)=>({
        outline: `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: offset !== null && offset !== void 0 ? offset : 1,
        transition: 'outline-offset 0s, outline 0s'
    });
const $d715ae4ca001487d$export$a44db842bcb28231 = (token, offset)=>({
        '&:focus-visible': $d715ae4ca001487d$export$6539948f0a737e39(token, offset)
    });
const $d715ae4ca001487d$export$f1a0b31dfb234e7e = (iconPrefixCls)=>({
        [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, $d715ae4ca001487d$export$171ccda7bc085e59()), {
            [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
                display: 'block'
            }
        })
    });
const $d715ae4ca001487d$export$9a16e7694a707ab4 = (token)=>Object.assign(Object.assign({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: token.linkDecoration,
        outline: 'none',
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        border: 0,
        padding: 0,
        background: 'none',
        userSelect: 'none'
    }, $d715ae4ca001487d$export$a44db842bcb28231(token)), {
        '&:hover': {
            color: token.colorLinkHover,
            textDecoration: token.linkHoverDecoration
        },
        '&:focus': {
            color: token.colorLinkHover,
            textDecoration: token.linkFocusDecoration
        },
        '&:active': {
            color: token.colorLinkActive,
            textDecoration: token.linkHoverDecoration
        }
    });



const $ec13a61cda710957$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $77023b8a2ee37055$export$2e2bcd8739ae039)();
    // Generate style for icons
    return (0, $a5989a3a1f75ed7b$export$2e2bcd8739ae039)({
        theme: theme,
        token: token,
        hashId: '',
        path: [
            'ant-design-icons',
            iconPrefixCls
        ],
        nonce: ()=>csp === null || csp === void 0 ? void 0 : csp.nonce,
        layer: {
            name: 'antd'
        }
    }, ()=>(0, $d715ae4ca001487d$export$f1a0b31dfb234e7e)(iconPrefixCls));
};
var $ec13a61cda710957$export$2e2bcd8739ae039 = $ec13a61cda710957$var$useResetIconStyle;


"use client";
var $517cf7c86b737e50$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $517cf7c86b737e50$var$existThemeConfig = false;
const $517cf7c86b737e50$export$7c4f6da0f9434a77 = /* istanbul ignore next */ null;
const $517cf7c86b737e50$export$e7f14a745e5c386a = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale'
];
// These props is used by `useContext` directly in sub component
const $517cf7c86b737e50$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'input',
    'pagination',
    'form',
    'select',
    'button'
];
let $517cf7c86b737e50$var$globalPrefixCls;
let $517cf7c86b737e50$var$globalIconPrefixCls;
let $517cf7c86b737e50$var$globalTheme;
let $517cf7c86b737e50$var$globalHolderRender;
function $517cf7c86b737e50$var$getGlobalPrefixCls() {
    return $517cf7c86b737e50$var$globalPrefixCls || (0, $0b79f8c0c8222aa8$export$e4ec87ea71f29b41);
}
function $517cf7c86b737e50$var$getGlobalIconPrefixCls() {
    return $517cf7c86b737e50$var$globalIconPrefixCls || (0, $0b79f8c0c8222aa8$export$eaca8ee5ed21b4e9);
}
function $517cf7c86b737e50$var$isLegacyTheme(theme) {
    return Object.keys(theme).some((key)=>key.endsWith('Color'));
}
const $517cf7c86b737e50$var$setGlobalConfig = (props)=>{
    const { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme, holderRender: holderRender } = props;
    if (prefixCls !== undefined) $517cf7c86b737e50$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $517cf7c86b737e50$var$globalIconPrefixCls = iconPrefixCls;
    if ('holderRender' in props) $517cf7c86b737e50$var$globalHolderRender = holderRender;
    if (theme) {
        if ($517cf7c86b737e50$var$isLegacyTheme(theme)) (0, $bedba16a99fbc67d$export$f9c59eed5de5ff80)($517cf7c86b737e50$var$getGlobalPrefixCls(), theme);
        else $517cf7c86b737e50$var$globalTheme = theme;
    }
};
const $517cf7c86b737e50$export$f9cd1e43211d8a4a = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$517cf7c86b737e50$var$getGlobalPrefixCls()}-${suffixCls}` : $517cf7c86b737e50$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $517cf7c86b737e50$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($517cf7c86b737e50$var$globalPrefixCls) return $517cf7c86b737e50$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $517cf7c86b737e50$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$517cf7c86b737e50$var$globalTheme,
        holderRender: $517cf7c86b737e50$var$globalHolderRender
    });
const $517cf7c86b737e50$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, anchor: anchor, form: form, locale: locale, componentSize: componentSize, direction: direction, space: space, splitter: splitter, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, menu: menu, pagination: pagination, input: input, textArea: textArea, empty: empty, badge: badge, radio: radio, rate: rate, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig, tour: tour, tooltip: tooltip, popover: popover, popconfirm: popconfirm, floatButton: floatButton, floatButtonGroup: floatButtonGroup, variant: variant, inputNumber: inputNumber, treeSelect: treeSelect } = props;
    // =================================== Context ===================================
    const getPrefixCls = $eeyUA.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $0b79f8c0c8222aa8$export$eaca8ee5ed21b4e9);
    const csp = customCsp || parentContext.csp;
    (0, $ec13a61cda710957$export$2e2bcd8739ae039)(iconPrefixCls, csp);
    const mergedTheme = (0, $9cdf28e66a843206$export$2e2bcd8739ae039)(theme, parentContext.theme, {
        prefixCls: getPrefixCls('')
    });
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        anchor: anchor,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        splitter: splitter,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        textArea: textArea,
        layout: layout,
        list: list,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        radio: radio,
        rate: rate,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig,
        tour: tour,
        tooltip: tooltip,
        popover: popover,
        popconfirm: popconfirm,
        floatButton: floatButton,
        floatButtonGroup: floatButtonGroup,
        variant: variant,
        inputNumber: inputNumber,
        treeSelect: treeSelect
    };
    const config = Object.assign({}, parentContext);
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $517cf7c86b737e50$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== 'undefined') // merge deprecated api
    config.button = Object.assign({
        autoInsertSpace: autoInsertSpaceInButton
    }, config.button);
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $f7a41f4eea21629f$export$2e2bcd8739ae039)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const { layer: layer } = $eeyUA.useContext((0, $17bf098ab43a08aa$export$2e2bcd8739ae039));
    const memoIconContextValue = $eeyUA.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp,
            layer: layer ? 'antd' : undefined
        }), [
        iconPrefixCls,
        csp,
        layer
    ]);
    let childNode = /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, /*#__PURE__*/ $eeyUA.createElement((0, $32d6930370d1e7c3$export$2e2bcd8739ae039), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $eeyUA.useMemo(()=>{
        var _a, _b, _c, _d;
        return (0, $b0ca387bd247d427$export$4950aa0f605343fb)(((_a = (0, $535519d587587ff4$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $eeyUA.createElement((0, $c2615193e2fa8226$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $eeyUA.createElement((0, $ecc11aa0f480405f$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $ecc11aa0f480405f$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $eeyUA.createElement((0, $f1a22bf36ab8f6bd$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $eeyUA.createElement((0, $8a37775a72de6646$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $eeyUA.createElement((0, $6febb7f436d22e66$export$2e2bcd8739ae039), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $eeyUA.useMemo(()=>{
        const _a = mergedTheme || {}, { algorithm: algorithm, token: token, components: components, cssVar: cssVar } = _a, rest = $517cf7c86b737e50$var$__rest(_a, [
            "algorithm",
            "token",
            "components",
            "cssVar"
        ]);
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $d38e822e786c0de9$export$2e2bcd8739ae039)(algorithm) : (0, $d62a95af33c9b503$export$2e2bcd8739ae039);
        const parsedComponents = {};
        Object.entries(components || {}).forEach(([componentName, componentToken])=>{
            const parsedToken = Object.assign({}, componentToken);
            if ('algorithm' in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === 'function') parsedToken.theme = (0, $d38e822e786c0de9$export$2e2bcd8739ae039)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = Object.assign(Object.assign({}, (0, $57d31f3def09e8b8$export$2e2bcd8739ae039)), token);
        return Object.assign(Object.assign({}, rest), {
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: Object.assign({
                override: mergedToken
            }, parsedComponents),
            cssVar: cssVar
        });
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $eeyUA.createElement((0, $af40d724f1881849$export$69b0ebb9efcddb30).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $eeyUA.createElement((0, $a3188745ad304597$export$11b88c75b33aa1fd).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $eeyUA.createElement((0, $1dece405dee1b50b$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $eeyUA.createElement((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
const $517cf7c86b737e50$var$ConfigProvider = (props)=>{
    const context = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const antLocale = $eeyUA.useContext((0, $b9b175c770d4ccec$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $eeyUA.createElement($517cf7c86b737e50$var$ProviderChildren, Object.assign({
        parentContext: context,
        legacyLocale: antLocale
    }, props));
};
$517cf7c86b737e50$var$ConfigProvider.ConfigContext = (0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b);
$517cf7c86b737e50$var$ConfigProvider.SizeContext = (0, $8a37775a72de6646$export$2e2bcd8739ae039);
$517cf7c86b737e50$var$ConfigProvider.config = $517cf7c86b737e50$var$setGlobalConfig;
$517cf7c86b737e50$var$ConfigProvider.useConfig = (0, $6997ee34ad84aefe$export$2e2bcd8739ae039);
Object.defineProperty($517cf7c86b737e50$var$ConfigProvider, 'SizeContext', {
    get: ()=>{
        return 0, $8a37775a72de6646$export$2e2bcd8739ae039;
    }
});
var $517cf7c86b737e50$export$2e2bcd8739ae039 = $517cf7c86b737e50$var$ConfigProvider;


parcelRequire("eeyUA");

function $6a3480bb7f46effc$export$2e2bcd8739ae039(e, d) {
    this.v = e, this.k = d;
}


function $0c853990887cf809$export$2e2bcd8739ae039(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    $0c853990887cf809$export$2e2bcd8739ae039 = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $0c853990887cf809$export$2e2bcd8739ae039(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, $0c853990887cf809$export$2e2bcd8739ae039(e, r, n, t);
}


function $248b2bbf4bc6c3ae$export$2e2bcd8739ae039() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return (0, $0c853990887cf809$export$2e2bcd8739ae039)(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ((0, $0c853990887cf809$export$2e2bcd8739ae039)(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, (0, $0c853990887cf809$export$2e2bcd8739ae039)(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, (0, $0c853990887cf809$export$2e2bcd8739ae039)(u, "constructor", GeneratorFunctionPrototype), (0, $0c853990887cf809$export$2e2bcd8739ae039)(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", (0, $0c853990887cf809$export$2e2bcd8739ae039)(GeneratorFunctionPrototype, o, "GeneratorFunction"), (0, $0c853990887cf809$export$2e2bcd8739ae039)(u), (0, $0c853990887cf809$export$2e2bcd8739ae039)(u, o, "Generator"), (0, $0c853990887cf809$export$2e2bcd8739ae039)(u, n, function() {
        return this;
    }), (0, $0c853990887cf809$export$2e2bcd8739ae039)(u, "toString", function() {
        return "[object Generator]";
    }), ($248b2bbf4bc6c3ae$export$2e2bcd8739ae039 = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}





function $96e0fbd1b333d18e$export$2e2bcd8739ae039(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof (0, $6a3480bb7f46effc$export$2e2bcd8739ae039) ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ((0, $0c853990887cf809$export$2e2bcd8739ae039)($96e0fbd1b333d18e$export$2e2bcd8739ae039.prototype), (0, $0c853990887cf809$export$2e2bcd8739ae039)($96e0fbd1b333d18e$export$2e2bcd8739ae039.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), (0, $0c853990887cf809$export$2e2bcd8739ae039)(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}


function $8c4c35445177708b$export$2e2bcd8739ae039(r, e, t, o, n) {
    return new (0, $96e0fbd1b333d18e$export$2e2bcd8739ae039)((0, $248b2bbf4bc6c3ae$export$2e2bcd8739ae039)().w(r, e, t, o), n || Promise);
}


function $1cdd58b7a60a699a$export$2e2bcd8739ae039(n, e, r, t, o) {
    var a = (0, $8c4c35445177708b$export$2e2bcd8739ae039)(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}




function $a12d0e42f8d24b3f$export$2e2bcd8739ae039(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}



function $2943464934c63eb2$export$2e2bcd8739ae039(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(e) + " is not iterable");
}


function $92ecb52394fe22cf$export$2e2bcd8739ae039() {
    "use strict";
    var r = (0, $248b2bbf4bc6c3ae$export$2e2bcd8739ae039)(), e = r.m($92ecb52394fe22cf$export$2e2bcd8739ae039), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, (0, $2943464934c63eb2$export$2e2bcd8739ae039)(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return ($92ecb52394fe22cf$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new (0, $6a3480bb7f46effc$export$2e2bcd8739ae039)(r, e);
            },
            AsyncIterator: (0, $96e0fbd1b333d18e$export$2e2bcd8739ae039),
            async: function async(r, e, t, o, u) {
                return (n(e) ? (0, $8c4c35445177708b$export$2e2bcd8739ae039) : (0, $1cdd58b7a60a699a$export$2e2bcd8739ae039))(a(r), e, t, o, u);
            },
            keys: (0, $a12d0e42f8d24b3f$export$2e2bcd8739ae039),
            values: (0, $2943464934c63eb2$export$2e2bcd8739ae039)
        };
    })();
}


function $5fc0c4295ecffc5b$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $5fc0c4295ecffc5b$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $5fc0c4295ecffc5b$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $5fc0c4295ecffc5b$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}





// Let compiler not to search module usage
var $5bb1199f7e0c735a$var$fullClone = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, $6568ab17ba5c963b$exports);
var $5bb1199f7e0c735a$var$version = $5bb1199f7e0c735a$var$fullClone.version, $5bb1199f7e0c735a$var$reactRender = $5bb1199f7e0c735a$var$fullClone.render, $5bb1199f7e0c735a$var$unmountComponentAtNode = $5bb1199f7e0c735a$var$fullClone.unmountComponentAtNode;
var $5bb1199f7e0c735a$var$createRoot;
try {
    var $5bb1199f7e0c735a$var$mainVersion = Number(($5bb1199f7e0c735a$var$version || '').split('.')[0]);
    if ($5bb1199f7e0c735a$var$mainVersion >= 18) $5bb1199f7e0c735a$var$createRoot = $5bb1199f7e0c735a$var$fullClone.createRoot;
} catch (e) {
// Do nothing;
}
function $5bb1199f7e0c735a$var$toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $5bb1199f7e0c735a$var$fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === 'object') __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
}
var $5bb1199f7e0c735a$var$MARK = '__rc_react_root__';
// ========================== Render ==========================
function $5bb1199f7e0c735a$var$modernRender(node, container) {
    $5bb1199f7e0c735a$var$toggleWarning(true);
    var root = container[$5bb1199f7e0c735a$var$MARK] || $5bb1199f7e0c735a$var$createRoot(container);
    $5bb1199f7e0c735a$var$toggleWarning(false);
    root.render(node);
    container[$5bb1199f7e0c735a$var$MARK] = root;
}
function $5bb1199f7e0c735a$var$legacyRender(node, container) {
    $5bb1199f7e0c735a$var$reactRender === null || $5bb1199f7e0c735a$var$reactRender === void 0 || $5bb1199f7e0c735a$var$reactRender(node, container);
}
function $5bb1199f7e0c735a$export$892c6608f54d7438(node, container) {}
function $5bb1199f7e0c735a$export$b3890eb0ae9dca99(node, container) {
    if ($5bb1199f7e0c735a$var$createRoot) {
        $5bb1199f7e0c735a$var$modernRender(node, container);
        return;
    }
    $5bb1199f7e0c735a$var$legacyRender(node, container);
}
// ========================= Unmount ==========================
function $5bb1199f7e0c735a$var$modernUnmount(_x) {
    return $5bb1199f7e0c735a$var$_modernUnmount.apply(this, arguments);
}
function $5bb1199f7e0c735a$var$_modernUnmount() {
    $5bb1199f7e0c735a$var$_modernUnmount = (0, $5fc0c4295ecffc5b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().mark(function _callee(container) {
        return (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[$5bb1199f7e0c735a$var$MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[$5bb1199f7e0c735a$var$MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $5bb1199f7e0c735a$var$_modernUnmount.apply(this, arguments);
}
function $5bb1199f7e0c735a$var$legacyUnmount(container) {
    $5bb1199f7e0c735a$var$unmountComponentAtNode(container);
}
function $5bb1199f7e0c735a$export$fd39fe14445b207a(container) {}
function $5bb1199f7e0c735a$export$121e2d597d222bad(_x2) {
    return $5bb1199f7e0c735a$var$_unmount.apply(this, arguments);
}
function $5bb1199f7e0c735a$var$_unmount() {
    $5bb1199f7e0c735a$var$_unmount = (0, $5fc0c4295ecffc5b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().mark(function _callee2(container) {
        return (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!($5bb1199f7e0c735a$var$createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $5bb1199f7e0c735a$var$modernUnmount(container));
                case 2:
                    $5bb1199f7e0c735a$var$legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $5bb1199f7e0c735a$var$_unmount.apply(this, arguments);
}



"use client";
const $cf87e1c636d1838d$var$defaultReactRender = (node, container)=>{
    (0, $5bb1199f7e0c735a$export$b3890eb0ae9dca99)(node, container);
    return ()=>{
        return (0, $5bb1199f7e0c735a$export$121e2d597d222bad)(container);
    };
};
let $cf87e1c636d1838d$var$unstableRender = $cf87e1c636d1838d$var$defaultReactRender;
function $cf87e1c636d1838d$export$4d4bf8843d204cca(render) {
    if (render) $cf87e1c636d1838d$var$unstableRender = render;
    return $cf87e1c636d1838d$var$unstableRender;
}



var $eeyUA = parcelRequire("eeyUA");

var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $3d32ca71c033edf9$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $3d32ca71c033edf9$export$2e2bcd8739ae039 = $3d32ca71c033edf9$var$CheckCircleFilled;



var $27c75b31e162e0b9$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $3d32ca71c033edf9$export$2e2bcd8739ae039)
    }));
};
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */ var $27c75b31e162e0b9$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($27c75b31e162e0b9$var$CheckCircleFilled);
var $27c75b31e162e0b9$export$2e2bcd8739ae039 = $27c75b31e162e0b9$var$RefIcon;



var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $020035b3ad489549$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $020035b3ad489549$export$2e2bcd8739ae039 = $020035b3ad489549$var$CloseCircleFilled;



var $bb922e54d3e229c9$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $020035b3ad489549$export$2e2bcd8739ae039)
    }));
};
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ var $bb922e54d3e229c9$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($bb922e54d3e229c9$var$CloseCircleFilled);
var $bb922e54d3e229c9$export$2e2bcd8739ae039 = $bb922e54d3e229c9$var$RefIcon;



var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $16c93b144323dd33$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $16c93b144323dd33$export$2e2bcd8739ae039 = $16c93b144323dd33$var$ExclamationCircleFilled;



var $fa20ac1ef8e6063f$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $16c93b144323dd33$export$2e2bcd8739ae039)
    }));
};
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ var $fa20ac1ef8e6063f$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($fa20ac1ef8e6063f$var$ExclamationCircleFilled);
var $fa20ac1ef8e6063f$export$2e2bcd8739ae039 = $fa20ac1ef8e6063f$var$RefIcon;



var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $3e78cdb7400a6217$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $3e78cdb7400a6217$export$2e2bcd8739ae039 = $3e78cdb7400a6217$var$InfoCircleFilled;



var $8eaa4c935d74b503$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $3e78cdb7400a6217$export$2e2bcd8739ae039)
    }));
};
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ var $8eaa4c935d74b503$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($8eaa4c935d74b503$var$InfoCircleFilled);
var $8eaa4c935d74b503$export$2e2bcd8739ae039 = $8eaa4c935d74b503$var$RefIcon;




var $eeyUA = parcelRequire("eeyUA");



var $eeyUA = parcelRequire("eeyUA");
const $2a9d851d9c220ba7$var$zIndexContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createContext(undefined);
var $2a9d851d9c220ba7$export$2e2bcd8739ae039 = $2a9d851d9c220ba7$var$zIndexContext;


// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const $d1784ce42cc285a0$var$CONTAINER_OFFSET = 100;
const $d1784ce42cc285a0$var$CONTAINER_OFFSET_MAX_COUNT = 10;
const $d1784ce42cc285a0$export$33ada7d8845f7e5 = $d1784ce42cc285a0$var$CONTAINER_OFFSET * $d1784ce42cc285a0$var$CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */ const $d1784ce42cc285a0$var$CONTAINER_MAX_OFFSET_WITH_CHILDREN = $d1784ce42cc285a0$export$33ada7d8845f7e5 + $d1784ce42cc285a0$var$CONTAINER_OFFSET;
const $d1784ce42cc285a0$export$1658852af8bb2a55 = {
    Modal: $d1784ce42cc285a0$var$CONTAINER_OFFSET,
    Drawer: $d1784ce42cc285a0$var$CONTAINER_OFFSET,
    Popover: $d1784ce42cc285a0$var$CONTAINER_OFFSET,
    Popconfirm: $d1784ce42cc285a0$var$CONTAINER_OFFSET,
    Tooltip: $d1784ce42cc285a0$var$CONTAINER_OFFSET,
    Tour: $d1784ce42cc285a0$var$CONTAINER_OFFSET,
    FloatButton: $d1784ce42cc285a0$var$CONTAINER_OFFSET
};
const $d1784ce42cc285a0$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
function $d1784ce42cc285a0$var$isContainerType(type) {
    return type in $d1784ce42cc285a0$export$1658852af8bb2a55;
}
const $d1784ce42cc285a0$export$3e7906d4075187a4 = (componentType, customZIndex)=>{
    const [, token] = (0, $77023b8a2ee37055$export$2e2bcd8739ae039)();
    const parentZIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useContext((0, $2a9d851d9c220ba7$export$2e2bcd8739ae039));
    const isContainer = $d1784ce42cc285a0$var$isContainerType(componentType);
    let result;
    if (customZIndex !== undefined) result = [
        customZIndex,
        customZIndex
    ];
    else {
        let zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;
        if (isContainer) zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $d1784ce42cc285a0$export$1658852af8bb2a55[componentType];
        else zIndex += $d1784ce42cc285a0$export$3f7a364c708f940b[componentType];
        result = [
            parentZIndex === undefined ? customZIndex : zIndex,
            zIndex
        ];
    }
    return result;
};



// ================== Collapse Motion ==================
const $5e50fdfe62d69e21$var$getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const $5e50fdfe62d69e21$var$getRealHeight = (node)=>{
    const { scrollHeight: scrollHeight } = node;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
const $5e50fdfe62d69e21$var$getCurrentHeight = (node)=>({
        height: node ? node.offsetHeight : 0
    });
const $5e50fdfe62d69e21$var$skipOpacityTransition = (_, event)=>(event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === 'height';
const $5e50fdfe62d69e21$var$initCollapseMotion = (rootCls = (0, $0b79f8c0c8222aa8$export$e4ec87ea71f29b41))=>({
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: $5e50fdfe62d69e21$var$getCollapsedHeight,
        onEnterStart: $5e50fdfe62d69e21$var$getCollapsedHeight,
        onAppearActive: $5e50fdfe62d69e21$var$getRealHeight,
        onEnterActive: $5e50fdfe62d69e21$var$getRealHeight,
        onLeaveStart: $5e50fdfe62d69e21$var$getCurrentHeight,
        onLeaveActive: $5e50fdfe62d69e21$var$getCollapsedHeight,
        onAppearEnd: $5e50fdfe62d69e21$var$skipOpacityTransition,
        onEnterEnd: $5e50fdfe62d69e21$var$skipOpacityTransition,
        onLeaveEnd: $5e50fdfe62d69e21$var$skipOpacityTransition,
        motionDeadline: 500
    });
const $5e50fdfe62d69e21$var$_SelectPlacements = [
    'bottomLeft',
    'bottomRight',
    'topLeft',
    'topRight'
];
const $5e50fdfe62d69e21$export$27c72201b1d09951 = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
var $5e50fdfe62d69e21$export$2e2bcd8739ae039 = $5e50fdfe62d69e21$var$initCollapseMotion;







var $eeyUA = parcelRequire("eeyUA");

var $eeyUA = parcelRequire("eeyUA");


var $eeyUA = parcelRequire("eeyUA");


function $26e0f2bfdd13a109$export$2e2bcd8739ae039(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}





var $eeyUA = parcelRequire("eeyUA");

var $a7747dcb15966592$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};





var $eeyUA = parcelRequire("eeyUA");
function $0e473b0b0663338c$export$9522e17588c12572(child) {
    return child && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).isValidElement(child) && child.type === (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Fragment;
}
const $0e473b0b0663338c$export$2dfe578f95754f6a = (element, replacement, props)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).isValidElement(element)) return replacement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
};
function $0e473b0b0663338c$export$e530037191fcd5d7(element, props) {
    return $0e473b0b0663338c$export$2dfe578f95754f6a(element, element, props);
}



var $eeyUA = parcelRequire("eeyUA");





var $eeyUA = parcelRequire("eeyUA");










var $8cdf2085af3ff5ee$var$AbstractCalculator = /*#__PURE__*/ (0, $055f1aac98d71283$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $827123db267e1039$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $8cdf2085af3ff5ee$export$2e2bcd8739ae039 = $8cdf2085af3ff5ee$var$AbstractCalculator;


var $a86007c29ff3cebe$var$CALC_UNIT = 'CALC_UNIT';
var $a86007c29ff3cebe$var$regexp = new RegExp($a86007c29ff3cebe$var$CALC_UNIT, 'g');
function $a86007c29ff3cebe$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($a86007c29ff3cebe$var$CALC_UNIT);
    return value;
}
var $a86007c29ff3cebe$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $6a4c2bdb64108a28$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $7104bbef2c357751$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "result", '');
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "unitlessCssVar", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "lowPriority", void 0);
        var numType = (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $a86007c29ff3cebe$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($a86007c29ff3cebe$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($a86007c29ff3cebe$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($a86007c29ff3cebe$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $8cdf2085af3ff5ee$export$2e2bcd8739ae039));









var $76cedba1804bade9$var$NumCalculator = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $6a4c2bdb64108a28$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $7104bbef2c357751$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $8cdf2085af3ff5ee$export$2e2bcd8739ae039));
var $76cedba1804bade9$export$2e2bcd8739ae039 = $76cedba1804bade9$var$NumCalculator;


var $faa77385d4fe4c1a$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $a86007c29ff3cebe$export$2e2bcd8739ae039) : (0, $76cedba1804bade9$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $faa77385d4fe4c1a$export$2e2bcd8739ae039 = $faa77385d4fe4c1a$var$genCalc;


var $ac09870f7d80063c$var$getCompVarPrefix = function getCompVarPrefix(component, prefix) {
    return "".concat([
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2')
    ].filter(Boolean).join('-'));
};
var $ac09870f7d80063c$export$2e2bcd8739ae039 = $ac09870f7d80063c$var$getCompVarPrefix;





function $43f1cb4391abeddc$var$getComponentToken(component, token, defaultToken, options) {
    var customToken = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, token[component]);
    if (options !== null && options !== void 0 && options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function(_ref) {
            var _ref2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
                var _customToken$newToken;
                (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
            }
        });
    }
    var mergedToken = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, defaultToken), customToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach(function(key) {
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
}
var $43f1cb4391abeddc$export$2e2bcd8739ae039 = $43f1cb4391abeddc$var$getComponentToken;




var $0dfcc8c9c107e242$var$enableStatistic = typeof CSSINJS_STATISTIC !== 'undefined';
var $0dfcc8c9c107e242$var$recording = true;
function $0dfcc8c9c107e242$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$0dfcc8c9c107e242$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $0dfcc8c9c107e242$var$recording = false;
    var ret = {};
    objs.forEach(function(obj) {
        if ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(obj) !== 'object') return;
        var keys = Object.keys(obj);
        keys.forEach(function(key) {
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: function get() {
                    return obj[key];
                }
            });
        });
    });
    $0dfcc8c9c107e242$var$recording = true;
    return ret;
}
var $0dfcc8c9c107e242$export$754a5e2d36c5fa7a = {};
var $0dfcc8c9c107e242$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $0dfcc8c9c107e242$var$noop() {}
/** Statistic token usage case. Should use `merge` function if you do not want spread record. */ var $0dfcc8c9c107e242$var$statisticToken = function statisticToken(token) {
    var tokenKeys;
    var proxy = token;
    var flush = $0dfcc8c9c107e242$var$noop;
    if ($0dfcc8c9c107e242$var$enableStatistic && typeof Proxy !== 'undefined') {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get: function get(obj, prop) {
                if ($0dfcc8c9c107e242$var$recording) {
                    var _tokenKeys;
                    (_tokenKeys = tokenKeys) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
                }
                return obj[prop];
            }
        });
        flush = function flush(componentName, componentToken) {
            var _statistic$componentN;
            $0dfcc8c9c107e242$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, (_statistic$componentN = $0dfcc8c9c107e242$export$754a5e2d36c5fa7a[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
};
var $0dfcc8c9c107e242$export$2e2bcd8739ae039 = $0dfcc8c9c107e242$var$statisticToken;


function $7d6305380787cd9c$var$getDefaultComponentToken(component, token, getDefaultToken) {
    if (typeof getDefaultToken === 'function') {
        var _token$component;
        return getDefaultToken((0, $0dfcc8c9c107e242$export$4950aa0f605343fb)(token, (_token$component = token[component]) !== null && _token$component !== void 0 ? _token$component : {}));
    }
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
var $7d6305380787cd9c$export$2e2bcd8739ae039 = $7d6305380787cd9c$var$getDefaultComponentToken;



function $8187bd4d18399ed8$var$genMaxMin(type) {
    if (type === 'js') return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function max() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return "max(".concat(args.map(function(value) {
                return (0, $2c076defa05cd41b$export$523c0b569236b342)(value);
            }).join(','), ")");
        },
        min: function min() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return "min(".concat(args.map(function(value) {
                return (0, $2c076defa05cd41b$export$523c0b569236b342)(value);
            }).join(','), ")");
        }
    };
}
var $8187bd4d18399ed8$export$2e2bcd8739ae039 = $8187bd4d18399ed8$var$genMaxMin;








var $eeyUA = parcelRequire("eeyUA");
var $a34734b73c302720$var$BEAT_LIMIT = 600000;
/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */ var $a34734b73c302720$var$ArrayKeyMap = /*#__PURE__*/ function() {
    function ArrayKeyMap() {
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, ArrayKeyMap);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "map", new Map());
        // Use WeakMap to avoid memory leak
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "objectIDMap", new WeakMap());
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "nextID", 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "lastAccessBeat", new Map());
        // We will clean up the cache when reach the limit
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "accessBeat", 0);
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(ArrayKeyMap, [
        {
            key: "set",
            value: function set(keys, value) {
                // New set will trigger clear
                this.clear();
                // Set logic
                var compositeKey = this.getCompositeKey(keys);
                this.map.set(compositeKey, value);
                this.lastAccessBeat.set(compositeKey, Date.now());
            }
        },
        {
            key: "get",
            value: function get(keys) {
                var compositeKey = this.getCompositeKey(keys);
                var cache = this.map.get(compositeKey);
                this.lastAccessBeat.set(compositeKey, Date.now());
                this.accessBeat += 1;
                return cache;
            }
        },
        {
            key: "getCompositeKey",
            value: function getCompositeKey(keys) {
                var _this = this;
                var ids = keys.map(function(key) {
                    if (key && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(key) === 'object') return "obj_".concat(_this.getObjectID(key));
                    return "".concat((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(key), "_").concat(key);
                });
                return ids.join('|');
            }
        },
        {
            key: "getObjectID",
            value: function getObjectID(obj) {
                if (this.objectIDMap.has(obj)) return this.objectIDMap.get(obj);
                var id = this.nextID;
                this.objectIDMap.set(obj, id);
                this.nextID += 1;
                return id;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this2 = this;
                if (this.accessBeat > 10000) {
                    var now = Date.now();
                    this.lastAccessBeat.forEach(function(beat, key) {
                        if (now - beat > $a34734b73c302720$var$BEAT_LIMIT) {
                            _this2.map.delete(key);
                            _this2.lastAccessBeat.delete(key);
                        }
                    });
                    this.accessBeat = 0;
                }
            }
        }
    ]);
    return ArrayKeyMap;
}();
var $a34734b73c302720$var$uniqueMap = new $a34734b73c302720$var$ArrayKeyMap();
/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */ function $a34734b73c302720$var$useUniqueMemo(memoFn, deps) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useMemo(function() {
        var cachedValue = $a34734b73c302720$var$uniqueMap.get(deps);
        if (cachedValue) return cachedValue;
        var newValue = memoFn();
        $a34734b73c302720$var$uniqueMap.set(deps, newValue);
        return newValue;
    }, deps);
}
var $a34734b73c302720$export$2e2bcd8739ae039 = $a34734b73c302720$var$useUniqueMemo;


/**
 * Provide a default hook since not everyone needs to config this.
 */ var $d0565f4681b87c2e$var$useDefaultCSP = function useDefaultCSP() {
    return {};
};
var $d0565f4681b87c2e$export$2e2bcd8739ae039 = $d0565f4681b87c2e$var$useDefaultCSP;


function $77d51ffdaffc536d$var$genStyleUtils(config) {
    // Dependency inversion for preparing basic config.
    var _config$useCSP = config.useCSP, useCSP = _config$useCSP === void 0 ? (0, $d0565f4681b87c2e$export$2e2bcd8739ae039) : _config$useCSP, useToken = config.useToken, usePrefix = config.usePrefix, getResetStyles = config.getResetStyles, getCommonStyle = config.getCommonStyle, getCompUnitless = config.getCompUnitless;
    function genStyleHooks(component, styleFn, getDefaultToken, options) {
        var componentName = Array.isArray(component) ? component[0] : component;
        function prefixToken(key) {
            return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
        }
        // Fill unitless
        var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
        var originCompUnitless = typeof getCompUnitless === 'function' ? getCompUnitless(component) : {};
        var compUnitless = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, originCompUnitless), {}, (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, prefixToken('zIndexPopup'), true));
        Object.keys(originUnitless).forEach(function(key) {
            compUnitless[prefixToken(key)] = originUnitless[key];
        });
        // Options
        var mergedOptions = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, options), {}, {
            unitless: compUnitless,
            prefixToken: prefixToken
        });
        // Hooks
        var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
        var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useStyle = useStyle(prefixCls, rootCls), _useStyle2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useStyle, 2), hashId = _useStyle2[1];
            var _useCSSVar = useCSSVar(rootCls), _useCSSVar2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useCSSVar, 2), wrapCSSVar = _useCSSVar2[0], cssVarCls = _useCSSVar2[1];
            return [
                wrapCSSVar,
                hashId,
                cssVarCls
            ];
        };
    }
    function genCSSVarRegister(component, getDefaultToken, options) {
        var compUnitless = options.unitless, _options$injectStyle = options.injectStyle, injectStyle = _options$injectStyle === void 0 ? true : _options$injectStyle, prefixToken = options.prefixToken, ignore = options.ignore;
        var CSSVarRegister = function CSSVarRegister(_ref) {
            var rootCls = _ref.rootCls, _ref$cssVar = _ref.cssVar, cssVar = _ref$cssVar === void 0 ? {} : _ref$cssVar;
            var _useToken = useToken(), realToken = _useToken.realToken;
            (0, $3161356e0ec3b6e2$export$2e2bcd8739ae039)({
                path: [
                    component
                ],
                prefix: cssVar.prefix,
                key: cssVar.key,
                unitless: compUnitless,
                ignore: ignore,
                token: realToken,
                scope: rootCls
            }, function() {
                var defaultToken = (0, $7d6305380787cd9c$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentToken = (0, $43f1cb4391abeddc$export$2e2bcd8739ae039)(component, realToken, defaultToken, {
                    deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
                });
                Object.keys(defaultToken).forEach(function(key) {
                    componentToken[prefixToken(key)] = componentToken[key];
                    delete componentToken[key];
                });
                return componentToken;
            });
            return null;
        };
        var useCSSVar = function useCSSVar(rootCls) {
            var _useToken2 = useToken(), cssVar = _useToken2.cssVar;
            return [
                function(node) {
                    return injectStyle && cssVar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(CSSVarRegister, {
                        rootCls: rootCls,
                        cssVar: cssVar,
                        component: component
                    }), node) : node;
                },
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.key
            ];
        };
        return useCSSVar;
    }
    function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var cells = Array.isArray(componentName) ? componentName : [
            componentName,
            componentName
        ];
        var _cells = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(cells, 1), component = _cells[0];
        var concatComponent = cells.join('-');
        var mergedLayer = config.layer || {
            name: 'antd'
        };
        // Return new style hook
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useToken3 = useToken(), theme = _useToken3.theme, realToken = _useToken3.realToken, hashId = _useToken3.hashId, token = _useToken3.token, cssVar = _useToken3.cssVar;
            var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
            var csp = useCSP();
            var type = cssVar ? 'css' : 'js';
            // Use unique memo to share the result across all instances
            var calc = (0, $a34734b73c302720$export$2e2bcd8739ae039)(function() {
                var unitlessCssVar = new Set();
                if (cssVar) Object.keys(options.unitless || {}).forEach(function(key) {
                    // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
                    // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
                    unitlessCssVar.add((0, $6b85f1efbeaa7e3a$export$309b3b095f0c7662)(key, cssVar.prefix));
                    unitlessCssVar.add((0, $6b85f1efbeaa7e3a$export$309b3b095f0c7662)(key, (0, $ac09870f7d80063c$export$2e2bcd8739ae039)(component, cssVar.prefix)));
                });
                return (0, $faa77385d4fe4c1a$export$2e2bcd8739ae039)(type, unitlessCssVar);
            }, [
                type,
                component,
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix
            ]);
            var _genMaxMin = (0, $8187bd4d18399ed8$export$2e2bcd8739ae039)(type), max = _genMaxMin.max, min = _genMaxMin.min;
            // Shared config
            var sharedConfig = {
                theme: theme,
                token: token,
                hashId: hashId,
                nonce: function nonce() {
                    return csp.nonce;
                },
                clientOnly: options.clientOnly,
                layer: mergedLayer,
                // antd is always at top of styles
                order: options.order || -999
            };
            // This if statement is safe, as it will only be used if the generator has the function. It's not dynamic.
            if (typeof getResetStyles === 'function') // Generate style for all need reset tags.
            (0, $a5989a3a1f75ed7b$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                clientOnly: false,
                path: [
                    'Shared',
                    rootPrefixCls
                ]
            }), function() {
                return getResetStyles(token, {
                    prefix: {
                        rootPrefixCls: rootPrefixCls,
                        iconPrefixCls: iconPrefixCls
                    },
                    csp: csp
                });
            });
            var wrapSSR = (0, $a5989a3a1f75ed7b$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                path: [
                    concatComponent,
                    prefixCls,
                    iconPrefixCls
                ]
            }), function() {
                if (options.injectStyle === false) return [];
                var _statisticToken = (0, $0dfcc8c9c107e242$export$2e2bcd8739ae039)(token), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
                var defaultComponentToken = (0, $7d6305380787cd9c$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentCls = ".".concat(prefixCls);
                var componentToken = (0, $43f1cb4391abeddc$export$2e2bcd8739ae039)(component, realToken, defaultComponentToken, {
                    deprecatedTokens: options.deprecatedTokens
                });
                if (cssVar && defaultComponentToken && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(defaultComponentToken) === 'object') Object.keys(defaultComponentToken).forEach(function(key) {
                    defaultComponentToken[key] = "var(".concat((0, $6b85f1efbeaa7e3a$export$309b3b095f0c7662)(key, (0, $ac09870f7d80063c$export$2e2bcd8739ae039)(component, cssVar.prefix)), ")");
                });
                var mergedToken = (0, $0dfcc8c9c107e242$export$4950aa0f605343fb)(proxyToken, {
                    componentCls: componentCls,
                    prefixCls: prefixCls,
                    iconCls: ".".concat(iconPrefixCls),
                    antCls: ".".concat(rootPrefixCls),
                    calc: calc,
                    // @ts-ignore
                    max: max,
                    // @ts-ignore
                    min: min
                }, cssVar ? defaultComponentToken : componentToken);
                var styleInterpolation = styleFn(mergedToken, {
                    hashId: hashId,
                    prefixCls: prefixCls,
                    rootPrefixCls: rootPrefixCls,
                    iconPrefixCls: iconPrefixCls
                });
                flush(component, componentToken);
                var commonStyle = typeof getCommonStyle === 'function' ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
                return [
                    options.resetStyle === false ? null : commonStyle,
                    styleInterpolation
                ];
            });
            return [
                wrapSSR,
                hashId
            ];
        };
    }
    function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
            resetStyle: false,
            // Sub Style should default after root one
            order: -998
        }, options));
        var StyledComponent = function StyledComponent(_ref2) {
            var prefixCls = _ref2.prefixCls, _ref2$rootCls = _ref2.rootCls, rootCls = _ref2$rootCls === void 0 ? prefixCls : _ref2$rootCls;
            useStyle(prefixCls, rootCls);
            return null;
        };
        return StyledComponent;
    }
    return {
        genStyleHooks: genStyleHooks,
        genSubStyleComponent: genSubStyleComponent,
        genComponentStyleHook: genComponentStyleHook
    };
}
var $77d51ffdaffc536d$export$2e2bcd8739ae039 = $77d51ffdaffc536d$var$genStyleUtils;









const { genStyleHooks: $16d63ad40d593937$export$51ec95de45185b42, genComponentStyleHook: $16d63ad40d593937$export$b8cc4ee2ee8cfbc8, genSubStyleComponent: $16d63ad40d593937$export$1537386bc155ea56 } = (0, $77d51ffdaffc536d$export$2e2bcd8739ae039)({
    usePrefix: ()=>{
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls } = (0, $eeyUA.useContext)((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
        const rootPrefixCls = getPrefixCls();
        return {
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls
        };
    },
    useToken: ()=>{
        const [theme, realToken, hashId, token, cssVar] = (0, $77023b8a2ee37055$export$2e2bcd8739ae039)();
        return {
            theme: theme,
            realToken: realToken,
            hashId: hashId,
            token: token,
            cssVar: cssVar
        };
    },
    useCSP: ()=>{
        const { csp: csp } = (0, $eeyUA.useContext)((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
        return csp !== null && csp !== void 0 ? csp : {};
    },
    getResetStyles: (token, config)=>{
        var _a;
        const linkStyle = (0, $d715ae4ca001487d$export$905d771977096614)(token);
        return [
            linkStyle,
            {
                '&': linkStyle
            },
            (0, $d715ae4ca001487d$export$f1a0b31dfb234e7e)((_a = config === null || config === void 0 ? void 0 : config.prefix.iconPrefixCls) !== null && _a !== void 0 ? _a : (0, $0b79f8c0c8222aa8$export$eaca8ee5ed21b4e9))
        ];
    },
    getCommonStyle: (0, $d715ae4ca001487d$export$689382c111559cd9),
    getCompUnitless: ()=>(0, $77023b8a2ee37055$export$c6b9faa6b723d31a)
});


const $b15384014e0b9644$var$genWaveStyle = (token)=>{
    const { componentCls: componentCls, colorPrimary: colorPrimary } = token;
    return {
        [componentCls]: {
            position: 'absolute',
            background: 'transparent',
            pointerEvents: 'none',
            boxSizing: 'border-box',
            color: `var(--wave-color, ${colorPrimary})`,
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            '&.wave-motion-appear': {
                transition: [
                    `box-shadow 0.4s ${token.motionEaseOutCirc}`,
                    `opacity 2s ${token.motionEaseOutCirc}`
                ].join(','),
                '&-active': {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                '&.wave-quick': {
                    transition: [
                        `box-shadow ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                        `opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`
                    ].join(',')
                }
            }
        }
    };
};
var $b15384014e0b9644$export$2e2bcd8739ae039 = (0, $16d63ad40d593937$export$b8cc4ee2ee8cfbc8)('Wave', $b15384014e0b9644$var$genWaveStyle);



var $eeyUA = parcelRequire("eeyUA");





const $5a4fb06e6e0070e9$export$23466a5792b7a5d3 = `${(0, $0b79f8c0c8222aa8$export$e4ec87ea71f29b41)}-wave-target`;



var $eeyUA = parcelRequire("eeyUA");






function $37ddc3f45c4cc719$export$9d61ea039e87eb91(color) {
    return color && color !== '#fff' && color !== '#ffffff' && color !== 'rgb(255, 255, 255)' && color !== 'rgba(255, 255, 255, 1)' && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
    color !== 'transparent' && color !== 'canvastext';
}
function $37ddc3f45c4cc719$export$651d8e9c80304fc8(node) {
    var _a;
    const { borderTopColor: borderTopColor, borderColor: borderColor, backgroundColor: backgroundColor } = getComputedStyle(node);
    return (_a = [
        borderTopColor,
        borderColor,
        backgroundColor
    ].find($37ddc3f45c4cc719$export$9d61ea039e87eb91)) !== null && _a !== void 0 ? _a : null;
}


"use client";
function $a97cc2a31eadd55d$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const $a97cc2a31eadd55d$var$WaveEffect = (props)=>{
    const { className: className, target: target, component: component, registerUnmount: registerUnmount } = props;
    const divRef = $eeyUA.useRef(null);
    // ====================== Refs ======================
    const unmountRef = $eeyUA.useRef(null);
    $eeyUA.useEffect(()=>{
        unmountRef.current = registerUnmount();
    }, []);
    // ===================== Effect =====================
    const [color, setWaveColor] = $eeyUA.useState(null);
    const [borderRadius, setBorderRadius] = $eeyUA.useState([]);
    const [left, setLeft] = $eeyUA.useState(0);
    const [top, setTop] = $eeyUA.useState(0);
    const [width, setWidth] = $eeyUA.useState(0);
    const [height, setHeight] = $eeyUA.useState(0);
    const [enabled, setEnabled] = $eeyUA.useState(false);
    const waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(' ')
    };
    if (color) waveStyle['--wave-color'] = color;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $37ddc3f45c4cc719$export$651d8e9c80304fc8)(target));
        const isStatic = nodeStyle.position === 'static';
        // Rect
        const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : $a97cc2a31eadd55d$var$validateNum(-Number.parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $a97cc2a31eadd55d$var$validateNum(-Number.parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius: borderTopLeftRadius, borderTopRightRadius: borderTopRightRadius, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>$a97cc2a31eadd55d$var$validateNum(Number.parseFloat(radius))));
    }
    $eeyUA.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, $6c76e01d5e295d55$export$2e2bcd8739ae039)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, $6c76e01d5e295d55$export$2e2bcd8739ae039).cancel(id);
                resizeObserver === null || resizeObserver === void 0 || resizeObserver.disconnect();
            };
        }
    }, [
        target
    ]);
    if (!enabled) return null;
    const isSmallComponent = (component === 'Checkbox' || component === 'Radio') && (target === null || target === void 0 ? void 0 : target.classList.contains((0, $5a4fb06e6e0070e9$export$23466a5792b7a5d3)));
    return /*#__PURE__*/ $eeyUA.createElement((0, $31ad051c24fca029$export$2e2bcd8739ae039), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            var _a, _b;
            if (event.deadline || event.propertyName === 'opacity') {
                const holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
                (_b = unmountRef.current) === null || _b === void 0 || _b.call(unmountRef).then(()=>{
                    holder === null || holder === void 0 || holder.remove();
                });
            }
            return false;
        }
    }, ({ className: motionClassName }, ref)=>/*#__PURE__*/ $eeyUA.createElement("div", {
            ref: (0, $54bedb74db46e87d$export$ab452c34e8e05029)(divRef, ref),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(className, motionClassName, {
                'wave-quick': isSmallComponent
            }),
            style: waveStyle
        }));
};
const $a97cc2a31eadd55d$var$showWaveEffect = (target, info)=>{
    var _a;
    const { component: component } = info;
    // Skip for unchecked checkbox
    if (component === 'Checkbox' && !((_a = target.querySelector('input')) === null || _a === void 0 ? void 0 : _a.checked)) return;
    // Create holder
    const holder = document.createElement('div');
    holder.style.position = 'absolute';
    holder.style.left = '0px';
    holder.style.top = '0px';
    target === null || target === void 0 || target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
    const reactRender = (0, $cf87e1c636d1838d$export$4d4bf8843d204cca)();
    let unmountCallback = null;
    function registerUnmount() {
        return unmountCallback;
    }
    unmountCallback = reactRender(/*#__PURE__*/ $eeyUA.createElement($a97cc2a31eadd55d$var$WaveEffect, Object.assign({}, info, {
        target: target,
        registerUnmount: registerUnmount
    })), holder);
};
var $a97cc2a31eadd55d$export$2e2bcd8739ae039 = $a97cc2a31eadd55d$var$showWaveEffect;


const $61ce23014c4a5dd0$var$useWave = (nodeRef, className, component)=>{
    const { wave: wave } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const [, token, hashId] = (0, $77023b8a2ee37055$export$2e2bcd8739ae039)();
    const showWave = (0, $5c3680878bae3f7a$export$2e2bcd8739ae039)((event)=>{
        const node = nodeRef.current;
        if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node) return;
        const targetNode = node.querySelector(`.${(0, $5a4fb06e6e0070e9$export$23466a5792b7a5d3)}`) || node;
        const { showEffect: showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, $a97cc2a31eadd55d$export$2e2bcd8739ae039))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId
        });
    });
    const rafId = $eeyUA.useRef(null);
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, $6c76e01d5e295d55$export$2e2bcd8739ae039).cancel(rafId.current);
        rafId.current = (0, $6c76e01d5e295d55$export$2e2bcd8739ae039)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
};
var $61ce23014c4a5dd0$export$2e2bcd8739ae039 = $61ce23014c4a5dd0$var$useWave;


const $cb3c6c31c4444a0a$var$Wave = (props)=>{
    const { children: children, disabled: disabled, component: component } = props;
    const { getPrefixCls: getPrefixCls } = (0, $eeyUA.useContext)((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const containerRef = (0, $eeyUA.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('wave');
    const [, hashId] = (0, $b15384014e0b9644$export$2e2bcd8739ae039)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, $61ce23014c4a5dd0$export$2e2bcd8739ae039)(containerRef, (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, hashId), component);
    // ============================== Effect ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== window.Node.ELEMENT_NODE || disabled) return;
        // Click handler
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, $a7747dcb15966592$export$2e2bcd8739ae039)(e.target) || // No need wave
            !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('disabled') && !node.className.includes('disabled:') || node.getAttribute('aria-disabled') === 'true' || node.className.includes('-leave')) return;
            showWave(e);
        };
        // Bind events
        node.addEventListener('click', onClick, true);
        return ()=>{
            node.removeEventListener('click', onClick, true);
        };
    }, [
        disabled
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).isValidElement(children)) return children !== null && children !== void 0 ? children : null;
    const ref = (0, $54bedb74db46e87d$export$c1cec34af06bcf7)(children) ? (0, $54bedb74db46e87d$export$ab452c34e8e05029)((0, $54bedb74db46e87d$export$7465e5c0bf44f19a)(children), containerRef) : containerRef;
    return (0, $0e473b0b0663338c$export$e530037191fcd5d7)(children, {
        ref: ref
    });
};
var $cb3c6c31c4444a0a$export$2e2bcd8739ae039 = $cb3c6c31c4444a0a$var$Wave;





var $eeyUA = parcelRequire("eeyUA");

const $5c741ce817a3a21f$var$useSize = (customSize)=>{
    const size = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useContext((0, $8a37775a72de6646$export$2e2bcd8739ae039));
    const mergedSize = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useMemo(()=>{
        if (!customSize) return size;
        if (typeof customSize === 'string') return customSize !== null && customSize !== void 0 ? customSize : size;
        if (typeof customSize === 'function') return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $5c741ce817a3a21f$export$2e2bcd8739ae039 = $5c741ce817a3a21f$var$useSize;



var $eeyUA = parcelRequire("eeyUA");



var $eeyUA = parcelRequire("eeyUA");
function $ad876cf685db44a4$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($ad876cf685db44a4$export$2e2bcd8739ae039(child));
        else if ((0, $be2e892f106f6ad3$export$2e2bcd8739ae039)(child) && child.props) ret = ret.concat($ad876cf685db44a4$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}





const $43d7a65f7e3a3de7$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-block': {
                display: 'flex',
                width: '100%'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
var // ============================== Export ==============================
$43d7a65f7e3a3de7$export$2e2bcd8739ae039 = (0, $16d63ad40d593937$export$51ec95de45185b42)([
    'Space',
    'Compact'
], (token)=>[
        $43d7a65f7e3a3de7$var$genSpaceCompactStyle(token)
    ], ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
var $b246d7f7ea639ac8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b246d7f7ea639ac8$export$8d1c486ac0db0a7d = /*#__PURE__*/ $eeyUA.createContext(null);
const $b246d7f7ea639ac8$export$cd8cf9d7bab8dd4 = (prefixCls, direction)=>{
    const compactItemContext = $eeyUA.useContext($b246d7f7ea639ac8$export$8d1c486ac0db0a7d);
    const compactItemClassnames = $eeyUA.useMemo(()=>{
        if (!compactItemContext) return '';
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
const $b246d7f7ea639ac8$export$5f56e610a4afb685 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ $eeyUA.createElement($b246d7f7ea639ac8$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
const $b246d7f7ea639ac8$var$CompactItem = (props)=>{
    const { children: children } = props, others = $b246d7f7ea639ac8$var$__rest(props, [
        "children"
    ]);
    return /*#__PURE__*/ $eeyUA.createElement($b246d7f7ea639ac8$export$8d1c486ac0db0a7d.Provider, {
        value: $eeyUA.useMemo(()=>others, [
            others
        ])
    }, children);
};
const $b246d7f7ea639ac8$var$Compact = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const { size: size, direction: direction, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children } = props, restProps = $b246d7f7ea639ac8$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "rootClassName",
        "children"
    ]);
    const mergedSize = (0, $5c741ce817a3a21f$export$2e2bcd8739ae039)((ctx)=>size !== null && size !== void 0 ? size : ctx);
    const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $43d7a65f7e3a3de7$export$2e2bcd8739ae039)(prefixCls);
    const clx = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: direction === 'vertical'
    }, className, rootClassName);
    const compactItemContext = $eeyUA.useContext($b246d7f7ea639ac8$export$8d1c486ac0db0a7d);
    const childNodes = (0, $ad876cf685db44a4$export$2e2bcd8739ae039)(children);
    const nodes = $eeyUA.useMemo(()=>childNodes.map((child, i)=>{
            const key = (child === null || child === void 0 ? void 0 : child.key) || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $eeyUA.createElement($b246d7f7ea639ac8$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        }), [
        childNodes,
        compactItemContext,
        direction,
        mergedSize,
        prefixCls
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return wrapCSSVar(/*#__PURE__*/ $eeyUA.createElement("div", Object.assign({
        className: clx
    }, restProps), nodes));
};
var $b246d7f7ea639ac8$export$2e2bcd8739ae039 = $b246d7f7ea639ac8$var$Compact;



var $eeyUA = parcelRequire("eeyUA");




"use client";
var $67bcb2b0d64ede53$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $67bcb2b0d64ede53$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $eeyUA.createContext(undefined);
const $67bcb2b0d64ede53$var$ButtonGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, size: size, className: className } = props, others = $67bcb2b0d64ede53$var$__rest(props, [
        "prefixCls",
        "size",
        "className"
    ]);
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const [, , hashId] = (0, $77023b8a2ee37055$export$2e2bcd8739ae039)();
    const sizeCls = $eeyUA.useMemo(()=>{
        switch(size){
            case 'large':
                return 'lg';
            case 'small':
                return 'sm';
            default:
                return '';
        }
    }, [
        size
    ]);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId);
    return /*#__PURE__*/ $eeyUA.createElement($67bcb2b0d64ede53$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $eeyUA.createElement("div", Object.assign({}, others, {
        className: classes
    })));
};
var $67bcb2b0d64ede53$export$2e2bcd8739ae039 = $67bcb2b0d64ede53$var$ButtonGroup;




var $eeyUA = parcelRequire("eeyUA");

const $ed04b53644533bfe$export$6d4fe3a00a1811ad = [
    'blue',
    'purple',
    'cyan',
    'green',
    'magenta',
    'pink',
    'red',
    'orange',
    'yellow',
    'volcano',
    'geekblue',
    'lime',
    'gold'
];


"use client";
const $eed44a28a6b1b10c$var$rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const $eed44a28a6b1b10c$export$c5dca2bf412dea0d = $eed44a28a6b1b10c$var$rxTwoCNChar.test.bind($eed44a28a6b1b10c$var$rxTwoCNChar);
function $eed44a28a6b1b10c$export$19bc9a290855952(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type: type
    };
}
function $eed44a28a6b1b10c$export$844ec244b1367d54(str) {
    return typeof str === 'string';
}
function $eed44a28a6b1b10c$export$b120bc11c0d9c214(type) {
    return type === 'text' || type === 'link';
}
function $eed44a28a6b1b10c$var$splitCNCharsBySpace(child, needInserted) {
    if (child === null || child === undefined) return;
    const SPACE = needInserted ? ' ' : '';
    if (typeof child !== 'string' && typeof child !== 'number' && $eed44a28a6b1b10c$export$844ec244b1367d54(child.type) && $eed44a28a6b1b10c$export$c5dca2bf412dea0d(child.props.children)) return (0, $0e473b0b0663338c$export$e530037191fcd5d7)(child, {
        children: child.props.children.split('').join(SPACE)
    });
    if ($eed44a28a6b1b10c$export$844ec244b1367d54(child)) return $eed44a28a6b1b10c$export$c5dca2bf412dea0d(child) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("span", null, child.split('').join(SPACE)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("span", null, child);
    if ((0, $0e473b0b0663338c$export$9522e17588c12572)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("span", null, child);
    return child;
}
function $eed44a28a6b1b10c$export$b6ee00a7e7908bc(children, needInserted) {
    let isPrevChildPure = false;
    const childList = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Children.forEach(children, (child)=>{
        const type = typeof child;
        const isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Children.map(childList, (child)=>$eed44a28a6b1b10c$var$splitCNCharsBySpace(child, needInserted));
}
const $eed44a28a6b1b10c$var$_ButtonTypes = [
    'default',
    'primary',
    'dashed',
    'link',
    'text'
];
const $eed44a28a6b1b10c$var$_ButtonShapes = [
    'default',
    'circle',
    'round'
];
const $eed44a28a6b1b10c$var$_ButtonHTMLTypes = [
    'submit',
    'button',
    'reset'
];
const $eed44a28a6b1b10c$export$9870b52452f51da5 = [
    'outlined',
    'dashed',
    'solid',
    'filled',
    'text',
    'link'
];
const $eed44a28a6b1b10c$export$760f16d96e091fc5 = [
    'default',
    'primary',
    'danger'
].concat((0, $3440102357566473$export$2e2bcd8739ae039)((0, $ed04b53644533bfe$export$6d4fe3a00a1811ad)));



var $eeyUA = parcelRequire("eeyUA");

var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $1881705c4d548ac6$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $1881705c4d548ac6$export$2e2bcd8739ae039 = $1881705c4d548ac6$var$LoadingOutlined;



var $f8dd918f064a5140$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $1881705c4d548ac6$export$2e2bcd8739ae039)
    }));
};
/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */ var $f8dd918f064a5140$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($f8dd918f064a5140$var$LoadingOutlined);
var $f8dd918f064a5140$export$2e2bcd8739ae039 = $f8dd918f064a5140$var$RefIcon;





var $eeyUA = parcelRequire("eeyUA");

"use client";
const $1ba4c1fd069f8c0f$var$IconWrapper = /*#__PURE__*/ (0, $eeyUA.forwardRef)((props, ref)=>{
    const { className: className, style: style, children: children, prefixCls: prefixCls } = props;
    const iconWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $1ba4c1fd069f8c0f$export$2e2bcd8739ae039 = $1ba4c1fd069f8c0f$var$IconWrapper;


"use client";
const $6b18331f8890bcb5$var$InnerLoadingIcon = /*#__PURE__*/ (0, $eeyUA.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, iconClassName: iconClassName } = props;
    const mergedIconCls = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $1ba4c1fd069f8c0f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $f8dd918f064a5140$export$2e2bcd8739ae039), {
        className: iconClassName
    }));
});
const $6b18331f8890bcb5$var$getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    });
const $6b18331f8890bcb5$var$getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    });
const $6b18331f8890bcb5$var$DefaultLoadingIcon = (props)=>{
    const { prefixCls: prefixCls, loading: loading, existIcon: existIcon, className: className, style: style, mount: mount } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement($6b18331f8890bcb5$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $31ad051c24fca029$export$2e2bcd8739ae039), {
        visible: visible,
        // Used for minus flex gap style only
        motionName: `${prefixCls}-loading-icon-motion`,
        motionAppear: !mount,
        motionEnter: !mount,
        motionLeave: !mount,
        removeOnLeave: true,
        onAppearStart: $6b18331f8890bcb5$var$getCollapsedWidth,
        onAppearActive: $6b18331f8890bcb5$var$getRealWidth,
        onEnterStart: $6b18331f8890bcb5$var$getCollapsedWidth,
        onEnterActive: $6b18331f8890bcb5$var$getRealWidth,
        onLeaveStart: $6b18331f8890bcb5$var$getRealWidth,
        onLeaveActive: $6b18331f8890bcb5$var$getCollapsedWidth
    }, ({ className: motionCls, style: motionStyle }, ref)=>{
        const mergedStyle = Object.assign(Object.assign({}, style), motionStyle);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement($6b18331f8890bcb5$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(className, motionCls),
            style: mergedStyle,
            ref: ref
        });
    });
};
var $6b18331f8890bcb5$export$2e2bcd8739ae039 = $6b18331f8890bcb5$var$DefaultLoadingIcon;







const $604627c373961b8f$var$genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            '&:not(:last-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            '&:not(:first-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const $604627c373961b8f$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, fontSize: fontSize, lineWidth: lineWidth, groupBorderColor: groupBorderColor, colorErrorHover: colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: 'relative',
                display: 'inline-flex',
                // Border
                [`> span, > ${componentCls}`]: {
                    '&:not(:last-child)': {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    '&:not(:first-child)': {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: 'relative',
                    zIndex: 1,
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    },
                    '&[disabled]': {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize: fontSize
                }
            },
            // Border Color
            $604627c373961b8f$var$genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            $604627c373961b8f$var$genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
var $604627c373961b8f$export$2e2bcd8739ae039 = $604627c373961b8f$var$genGroupStyle;






var $7Nobb = parcelRequire("7Nobb");



var $eeyUA = parcelRequire("eeyUA");









var $bdc73cc467115cb8$var$_excluded = [
    "b"
], $bdc73cc467115cb8$var$_excluded2 = [
    "v"
];
var $bdc73cc467115cb8$export$8d6531175688484b = function getRoundNumber(value) {
    return Math.round(Number(value || 0));
};
var $bdc73cc467115cb8$var$convertHsb2Hsv = function convertHsb2Hsv(color) {
    if (color instanceof (0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a)) return color;
    if (color && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(color) === 'object' && 'h' in color && 'b' in color) {
        var _ref = color, b = _ref.b, resets = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_ref, $bdc73cc467115cb8$var$_excluded);
        return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, resets), {}, {
            v: b
        });
    }
    if (typeof color === 'string' && /hsb/.test(color)) return color.replace(/hsb/, 'hsv');
    return color;
};
var $bdc73cc467115cb8$export$892596cec99bc70e = /*#__PURE__*/ function(_FastColor) {
    (0, $6a4c2bdb64108a28$export$2e2bcd8739ae039)(Color, _FastColor);
    var _super = (0, $7104bbef2c357751$export$2e2bcd8739ae039)(Color);
    function Color(color) {
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, Color);
        return _super.call(this, $bdc73cc467115cb8$var$convertHsb2Hsv(color));
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(Color, [
        {
            key: "toHsbString",
            value: function toHsbString() {
                var hsb = this.toHsb();
                var saturation = $bdc73cc467115cb8$export$8d6531175688484b(hsb.s * 100);
                var lightness = $bdc73cc467115cb8$export$8d6531175688484b(hsb.b * 100);
                var hue = $bdc73cc467115cb8$export$8d6531175688484b(hsb.h);
                var alpha = hsb.a;
                var hsbString = "hsb(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%)");
                var hsbaString = "hsba(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%, ").concat(alpha.toFixed(alpha === 0 ? 0 : 2), ")");
                return alpha === 1 ? hsbString : hsbaString;
            }
        },
        {
            key: "toHsb",
            value: function toHsb() {
                var _this$toHsv = this.toHsv(), v = _this$toHsv.v, resets = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_this$toHsv, $bdc73cc467115cb8$var$_excluded2);
                return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, resets), {}, {
                    b: v,
                    a: this.a
                });
            }
        }
    ]);
    return Color;
}((0, $20bbc8b28143e9d1$export$2c4f38d6c0ecc25a));


var $0d873d90ddd67a68$export$90004e2badfbdf1f = 'rc-color-picker';
var $0d873d90ddd67a68$export$c844f5d21427d1ab = function generateColor(color) {
    if (color instanceof (0, $bdc73cc467115cb8$export$892596cec99bc70e)) return color;
    return new (0, $bdc73cc467115cb8$export$892596cec99bc70e)(color);
};
var $0d873d90ddd67a68$export$f705f0fde43a55a = $0d873d90ddd67a68$export$c844f5d21427d1ab('#1677ff');
var $0d873d90ddd67a68$export$3a7095e9fd85a71d = function calculateColor(props) {
    var offset = props.offset, targetRef = props.targetRef, containerRef = props.containerRef, color = props.color, type = props.type;
    var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
    var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
    var centerOffsetX = targetWidth / 2;
    var centerOffsetY = targetHeight / 2;
    var saturation = (offset.x + centerOffsetX) / width;
    var bright = 1 - (offset.y + centerOffsetY) / height;
    var hsb = color.toHsb();
    var alphaOffset = saturation;
    var hueOffset = (offset.x + centerOffsetX) / width * 360;
    if (type) switch(type){
        case 'hue':
            return $0d873d90ddd67a68$export$c844f5d21427d1ab((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, hsb), {}, {
                h: hueOffset <= 0 ? 0 : hueOffset
            }));
        case 'alpha':
            return $0d873d90ddd67a68$export$c844f5d21427d1ab((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, hsb), {}, {
                a: alphaOffset <= 0 ? 0 : alphaOffset
            }));
    }
    return $0d873d90ddd67a68$export$c844f5d21427d1ab({
        h: hsb.h,
        s: saturation <= 0 ? 0 : saturation,
        b: bright >= 1 ? 1 : bright,
        a: hsb.a
    });
};
var $0d873d90ddd67a68$export$20165527867cbf14 = function calcOffset(color, type) {
    var hsb = color.toHsb();
    switch(type){
        case 'hue':
            return {
                x: hsb.h / 360 * 100,
                y: 50
            };
        case 'alpha':
            return {
                x: color.a * 100,
                y: 50
            };
        // Picker panel
        default:
            return {
                x: hsb.s * 100,
                y: (1 - hsb.b) * 100
            };
    }
};






var $eeyUA = parcelRequire("eeyUA");
var $cc4770487dc4d81e$var$ColorBlock = function ColorBlock(_ref) {
    var color = _ref.color, prefixCls = _ref.prefixCls, className = _ref.className, style = _ref.style, onClick = _ref.onClick;
    var colorBlockCls = "".concat(prefixCls, "-color-block");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(colorBlockCls, className),
        style: style,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: "".concat(colorBlockCls, "-inner"),
        style: {
            background: color
        }
    }));
};
var $cc4770487dc4d81e$export$2e2bcd8739ae039 = $cc4770487dc4d81e$var$ColorBlock;




var $eeyUA = parcelRequire("eeyUA");


var $eeyUA = parcelRequire("eeyUA");
function $9789355571fb4143$var$getPosition(e) {
    var obj = 'touches' in e ? e.touches[0] : e;
    var scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
    var scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    return {
        pageX: obj.pageX - scrollXOffset,
        pageY: obj.pageY - scrollYOffset
    };
}
function $9789355571fb4143$var$useColorDrag(props) {
    var targetRef = props.targetRef, containerRef = props.containerRef, direction = props.direction, onDragChange = props.onDragChange, onDragChangeComplete = props.onDragChangeComplete, calculate = props.calculate, color = props.color, disabledDrag = props.disabledDrag;
    var _useState = (0, $eeyUA.useState)({
        x: 0,
        y: 0
    }), _useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState, 2), offsetValue = _useState2[0], setOffsetValue = _useState2[1];
    var mouseMoveRef = (0, $eeyUA.useRef)(null);
    var mouseUpRef = (0, $eeyUA.useRef)(null);
    // Always get position from `color`
    (0, $eeyUA.useEffect)(function() {
        setOffsetValue(calculate());
    }, [
        color
    ]);
    (0, $eeyUA.useEffect)(function() {
        return function() {
            document.removeEventListener('mousemove', mouseMoveRef.current);
            document.removeEventListener('mouseup', mouseUpRef.current);
            document.removeEventListener('touchmove', mouseMoveRef.current);
            document.removeEventListener('touchend', mouseUpRef.current);
            mouseMoveRef.current = null;
            mouseUpRef.current = null;
        };
    }, []);
    var updateOffset = function updateOffset(e) {
        var _getPosition = $9789355571fb4143$var$getPosition(e), pageX = _getPosition.pageX, pageY = _getPosition.pageY;
        var _containerRef$current = containerRef.current.getBoundingClientRect(), rectX = _containerRef$current.x, rectY = _containerRef$current.y, width = _containerRef$current.width, height = _containerRef$current.height;
        var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
        var centerOffsetX = targetWidth / 2;
        var centerOffsetY = targetHeight / 2;
        var offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
        var offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
        var calcOffset = {
            x: offsetX,
            y: direction === 'x' ? offsetValue.y : offsetY
        };
        // Exclusion of boundary cases
        if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) return false;
        onDragChange === null || onDragChange === void 0 || onDragChange(calcOffset);
    };
    var onDragMove = function onDragMove(e) {
        e.preventDefault();
        updateOffset(e);
    };
    var onDragStop = function onDragStop(e) {
        e.preventDefault();
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        document.removeEventListener('touchmove', mouseMoveRef.current);
        document.removeEventListener('touchend', mouseUpRef.current);
        mouseMoveRef.current = null;
        mouseUpRef.current = null;
        onDragChangeComplete === null || onDragChangeComplete === void 0 || onDragChangeComplete();
    };
    var onDragStart = function onDragStart(e) {
        // https://github.com/ant-design/ant-design/issues/43529
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        if (disabledDrag) return;
        updateOffset(e);
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragStop);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragStop);
        mouseMoveRef.current = onDragMove;
        mouseUpRef.current = onDragStop;
    };
    return [
        offsetValue,
        onDragStart
    ];
}
var $9789355571fb4143$export$2e2bcd8739ae039 = $9789355571fb4143$var$useColorDrag;







var $eeyUA = parcelRequire("eeyUA");
var $a71cbddbaa1d4a35$var$Handler = function Handler(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'default' : _ref$size, color = _ref.color, prefixCls = _ref.prefixCls;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-handler"), (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-handler-sm"), size === 'small')),
        style: {
            backgroundColor: color
        }
    });
};
var $a71cbddbaa1d4a35$export$2e2bcd8739ae039 = $a71cbddbaa1d4a35$var$Handler;




var $eeyUA = parcelRequire("eeyUA");
var $94b497230f6da52a$var$Palette = function Palette(_ref) {
    var children = _ref.children, style = _ref.style, prefixCls = _ref.prefixCls;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: "".concat(prefixCls, "-palette"),
        style: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
            position: 'relative'
        }, style)
    }, children);
};
var $94b497230f6da52a$export$2e2bcd8739ae039 = $94b497230f6da52a$var$Palette;



var $eeyUA = parcelRequire("eeyUA");
var $87c82d5edc2e91ae$var$Transform = /*#__PURE__*/ (0, $eeyUA.forwardRef)(function(props, ref) {
    var children = props.children, x = props.x, y = props.y;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        ref: ref,
        style: {
            position: 'absolute',
            left: "".concat(x, "%"),
            top: "".concat(y, "%"),
            zIndex: 1,
            transform: 'translate(-50%, -50%)'
        }
    }, children);
});
var $87c82d5edc2e91ae$export$2e2bcd8739ae039 = $87c82d5edc2e91ae$var$Transform;


var $6cde060e35606b00$var$Picker = function Picker(_ref) {
    var color = _ref.color, onChange = _ref.onChange, prefixCls = _ref.prefixCls, onChangeComplete = _ref.onChangeComplete, disabled = _ref.disabled;
    var pickerRef = (0, $eeyUA.useRef)();
    var transformRef = (0, $eeyUA.useRef)();
    var colorRef = (0, $eeyUA.useRef)(color);
    var onDragChange = (0, $5c3680878bae3f7a$export$2e2bcd8739ae039)(function(offsetValue) {
        var calcColor = (0, $0d873d90ddd67a68$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: pickerRef,
            color: color
        });
        colorRef.current = calcColor;
        onChange(calcColor);
    });
    var _useColorDrag = (0, $9789355571fb4143$export$2e2bcd8739ae039)({
        color: color,
        containerRef: pickerRef,
        targetRef: transformRef,
        calculate: function calculate() {
            return (0, $0d873d90ddd67a68$export$20165527867cbf14)(color);
        },
        onDragChange: onDragChange,
        onDragChangeComplete: function onDragChangeComplete() {
            return onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(colorRef.current);
        },
        disabledDrag: disabled
    }), _useColorDrag2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useColorDrag, 2), offset = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        ref: pickerRef,
        className: "".concat(prefixCls, "-select"),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $94b497230f6da52a$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $87c82d5edc2e91ae$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $a71cbddbaa1d4a35$export$2e2bcd8739ae039), {
        color: color.toRgbString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: "".concat(prefixCls, "-saturation"),
        style: {
            backgroundColor: "hsl(".concat(color.toHsb().h, ",100%, 50%)"),
            backgroundImage: 'linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))'
        }
    })));
};
var $6cde060e35606b00$export$2e2bcd8739ae039 = $6cde060e35606b00$var$Picker;





var $eeyUA = parcelRequire("eeyUA");

var $270eb54860b6169d$var$useColorState = function useColorState(defaultValue, value) {
    var _useMergedState = (0, $e7fff343666ddaae$export$2e2bcd8739ae039)(defaultValue, {
        value: value
    }), _useMergedState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
    var color = (0, $eeyUA.useMemo)(function() {
        return (0, $0d873d90ddd67a68$export$c844f5d21427d1ab)(mergedValue);
    }, [
        mergedValue
    ]);
    return [
        color,
        setValue
    ];
};
var $270eb54860b6169d$export$2e2bcd8739ae039 = $270eb54860b6169d$var$useColorState;



var $eeyUA = parcelRequire("eeyUA");


var $eeyUA = parcelRequire("eeyUA");







var $eeyUA = parcelRequire("eeyUA");


var $4bdf6ac2e1264499$var$Gradient = function Gradient(_ref) {
    var colors = _ref.colors, children = _ref.children, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'to right' : _ref$direction, type = _ref.type, prefixCls = _ref.prefixCls;
    var gradientColors = (0, $eeyUA.useMemo)(function() {
        return colors.map(function(color, idx) {
            var result = (0, $0d873d90ddd67a68$export$c844f5d21427d1ab)(color);
            if (type === 'alpha' && idx === colors.length - 1) result = new (0, $bdc73cc467115cb8$export$892596cec99bc70e)(result.setA(1));
            return result.toRgbString();
        }).join(',');
    }, [
        colors,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: "".concat(prefixCls, "-gradient"),
        style: {
            position: 'absolute',
            inset: 0,
            background: "linear-gradient(".concat(direction, ", ").concat(gradientColors, ")")
        }
    }, children);
};
var $4bdf6ac2e1264499$export$2e2bcd8739ae039 = $4bdf6ac2e1264499$var$Gradient;




var $5d690ec2e129baa6$var$Slider = function Slider(props) {
    var prefixCls = props.prefixCls, colors = props.colors, disabled = props.disabled, onChange = props.onChange, onChangeComplete = props.onChangeComplete, color = props.color, type = props.type;
    var sliderRef = (0, $eeyUA.useRef)();
    var transformRef = (0, $eeyUA.useRef)();
    var colorRef = (0, $eeyUA.useRef)(color);
    var getValue = function getValue(c) {
        return type === 'hue' ? c.getHue() : c.a * 100;
    };
    var onDragChange = (0, $5c3680878bae3f7a$export$2e2bcd8739ae039)(function(offsetValue) {
        var calcColor = (0, $0d873d90ddd67a68$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: sliderRef,
            color: color,
            type: type
        });
        colorRef.current = calcColor;
        onChange(getValue(calcColor));
    });
    var _useColorDrag = (0, $9789355571fb4143$export$2e2bcd8739ae039)({
        color: color,
        targetRef: transformRef,
        containerRef: sliderRef,
        calculate: function calculate() {
            return (0, $0d873d90ddd67a68$export$20165527867cbf14)(color, type);
        },
        onDragChange: onDragChange,
        onDragChangeComplete: function onDragChangeComplete() {
            onChangeComplete(getValue(colorRef.current));
        },
        direction: 'x',
        disabledDrag: disabled
    }), _useColorDrag2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useColorDrag, 2), offset = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
    var handleColor = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useMemo(function() {
        if (type === 'hue') {
            var hsb = color.toHsb();
            hsb.s = 1;
            hsb.b = 1;
            hsb.a = 1;
            var lightColor = new (0, $bdc73cc467115cb8$export$892596cec99bc70e)(hsb);
            return lightColor;
        }
        return color;
    }, [
        color,
        type
    ]);
    // ========================= Gradient =========================
    var gradientList = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useMemo(function() {
        return colors.map(function(info) {
            return "".concat(info.color, " ").concat(info.percent, "%");
        });
    }, [
        colors
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        ref: sliderRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-slider"), "".concat(prefixCls, "-slider-").concat(type)),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $94b497230f6da52a$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $87c82d5edc2e91ae$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $a71cbddbaa1d4a35$export$2e2bcd8739ae039), {
        size: "small",
        color: handleColor.toHexString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $4bdf6ac2e1264499$export$2e2bcd8739ae039), {
        colors: gradientList,
        type: type,
        prefixCls: prefixCls
    })));
};
var $5d690ec2e129baa6$export$2e2bcd8739ae039 = $5d690ec2e129baa6$var$Slider;


function $9b8c73fba5b2d8cd$export$2e2bcd8739ae039(components) {
    return $eeyUA.useMemo(function() {
        var _ref = components || {}, slider = _ref.slider;
        return [
            slider || (0, $5d690ec2e129baa6$export$2e2bcd8739ae039)
        ];
    }, [
        components
    ]);
}


var $7b9b2bac84ad62f0$var$HUE_COLORS = [
    {
        color: 'rgb(255, 0, 0)',
        percent: 0
    },
    {
        color: 'rgb(255, 255, 0)',
        percent: 17
    },
    {
        color: 'rgb(0, 255, 0)',
        percent: 33
    },
    {
        color: 'rgb(0, 255, 255)',
        percent: 50
    },
    {
        color: 'rgb(0, 0, 255)',
        percent: 67
    },
    {
        color: 'rgb(255, 0, 255)',
        percent: 83
    },
    {
        color: 'rgb(255, 0, 0)',
        percent: 100
    }
];
var $7b9b2bac84ad62f0$var$ColorPicker = /*#__PURE__*/ (0, $eeyUA.forwardRef)(function(props, ref) {
    var value = props.value, defaultValue = props.defaultValue, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? (0, $0d873d90ddd67a68$export$90004e2badfbdf1f) : _props$prefixCls, onChange = props.onChange, onChangeComplete = props.onChangeComplete, className = props.className, style = props.style, panelRender = props.panelRender, _props$disabledAlpha = props.disabledAlpha, disabledAlpha = _props$disabledAlpha === void 0 ? false : _props$disabledAlpha, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, components = props.components;
    // ========================== Components ==========================
    var _useComponent = (0, $9b8c73fba5b2d8cd$export$2e2bcd8739ae039)(components), _useComponent2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useComponent, 1), Slider = _useComponent2[0];
    // ============================ Color =============================
    var _useColorState = (0, $270eb54860b6169d$export$2e2bcd8739ae039)(defaultValue || (0, $0d873d90ddd67a68$export$f705f0fde43a55a), value), _useColorState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useColorState, 2), colorValue = _useColorState2[0], setColorValue = _useColorState2[1];
    var alphaColor = (0, $eeyUA.useMemo)(function() {
        return colorValue.setA(1).toRgbString();
    }, [
        colorValue
    ]);
    // ============================ Events ============================
    var handleChange = function handleChange(data, type) {
        if (!value) setColorValue(data);
        onChange === null || onChange === void 0 || onChange(data, type);
    };
    // Convert
    var getHueColor = function getHueColor(hue) {
        return new (0, $bdc73cc467115cb8$export$892596cec99bc70e)(colorValue.setHue(hue));
    };
    var getAlphaColor = function getAlphaColor(alpha) {
        return new (0, $bdc73cc467115cb8$export$892596cec99bc70e)(colorValue.setA(alpha / 100));
    };
    // Slider change
    var onHueChange = function onHueChange(hue) {
        handleChange(getHueColor(hue), {
            type: 'hue',
            value: hue
        });
    };
    var onAlphaChange = function onAlphaChange(alpha) {
        handleChange(getAlphaColor(alpha), {
            type: 'alpha',
            value: alpha
        });
    };
    // Complete
    var onHueChangeComplete = function onHueChangeComplete(hue) {
        if (onChangeComplete) onChangeComplete(getHueColor(hue));
    };
    var onAlphaChangeComplete = function onAlphaChangeComplete(alpha) {
        if (onChangeComplete) onChangeComplete(getAlphaColor(alpha));
    };
    // ============================ Render ============================
    var mergeCls = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-panel"), className, (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-panel-disabled"), disabled));
    var sharedSliderProps = {
        prefixCls: prefixCls,
        disabled: disabled,
        color: colorValue
    };
    var defaultPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $6cde060e35606b00$export$2e2bcd8739ae039), (0, $7Nobb.default)({
        onChange: handleChange
    }, sharedSliderProps, {
        onChangeComplete: onChangeComplete
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: "".concat(prefixCls, "-slider-container")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-slider-group"), (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-slider-group-disabled-alpha"), disabledAlpha))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(Slider, (0, $7Nobb.default)({}, sharedSliderProps, {
        type: "hue",
        colors: $7b9b2bac84ad62f0$var$HUE_COLORS,
        min: 0,
        max: 359,
        value: colorValue.getHue(),
        onChange: onHueChange,
        onChangeComplete: onHueChangeComplete
    })), !disabledAlpha && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(Slider, (0, $7Nobb.default)({}, sharedSliderProps, {
        type: "alpha",
        colors: [
            {
                percent: 0,
                color: 'rgba(255, 0, 4, 0)'
            },
            {
                percent: 100,
                color: alphaColor
            }
        ],
        min: 0,
        max: 100,
        value: colorValue.a * 100,
        onChange: onAlphaChange,
        onChangeComplete: onAlphaChangeComplete
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $cc4770487dc4d81e$export$2e2bcd8739ae039), {
        color: colorValue.toRgbString(),
        prefixCls: prefixCls
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: mergeCls,
        style: style,
        ref: ref
    }, typeof panelRender === 'function' ? panelRender(defaultPanel) : defaultPanel);
});
var $7b9b2bac84ad62f0$export$2e2bcd8739ae039 = $7b9b2bac84ad62f0$var$ColorPicker;






var $fd6b2d6fb4af1718$export$2e2bcd8739ae039 = (0, $7b9b2bac84ad62f0$export$2e2bcd8739ae039);


const $ea3106541828fcc7$export$d0aa8b5e56c9af06 = (value, alpha)=>(value === null || value === void 0 ? void 0 : value.replace(/[^\w/]/g, '').slice(0, alpha ? 8 : 6)) || '';
const $ea3106541828fcc7$export$6c90ef703dcfba25 = (value, alpha)=>value ? $ea3106541828fcc7$export$d0aa8b5e56c9af06(value, alpha) : '';
let $ea3106541828fcc7$export$e8cc8a2e87e145b4 = /*#__PURE__*/ function() {
    function AggregationColor(color) {
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, AggregationColor);
        var _a;
        this.cleared = false;
        // Clone from another AggregationColor
        if (color instanceof AggregationColor) {
            this.metaColor = color.metaColor.clone();
            this.colors = (_a = color.colors) === null || _a === void 0 ? void 0 : _a.map((info)=>({
                    color: new AggregationColor(info.color),
                    percent: info.percent
                }));
            this.cleared = color.cleared;
            return;
        }
        const isArray = Array.isArray(color);
        if (isArray && color.length) {
            this.colors = color.map(({ color: c, percent: percent })=>({
                    color: new AggregationColor(c),
                    percent: percent
                }));
            this.metaColor = new (0, $bdc73cc467115cb8$export$892596cec99bc70e)(this.colors[0].color.metaColor);
        } else this.metaColor = new (0, $bdc73cc467115cb8$export$892596cec99bc70e)(isArray ? '' : color);
        if (!color || isArray && !this.colors) {
            this.metaColor = this.metaColor.setA(0);
            this.cleared = true;
        }
    }
    return (0, $055f1aac98d71283$export$2e2bcd8739ae039)(AggregationColor, [
        {
            key: "toHsb",
            value: function toHsb() {
                return this.metaColor.toHsb();
            }
        },
        {
            key: "toHsbString",
            value: function toHsbString() {
                return this.metaColor.toHsbString();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return $ea3106541828fcc7$export$6c90ef703dcfba25(this.toHexString(), this.metaColor.a < 1);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this.metaColor.toHexString();
            }
        },
        {
            key: "toRgb",
            value: function toRgb() {
                return this.metaColor.toRgb();
            }
        },
        {
            key: "toRgbString",
            value: function toRgbString() {
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "isGradient",
            value: function isGradient() {
                return !!this.colors && !this.cleared;
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return this.colors || [
                    {
                        color: this,
                        percent: 0
                    }
                ];
            }
        },
        {
            key: "toCssString",
            value: function toCssString() {
                const { colors: colors } = this;
                // CSS line-gradient
                if (colors) {
                    const colorsStr = colors.map((c)=>`${c.color.toRgbString()} ${c.percent}%`).join(', ');
                    return `linear-gradient(90deg, ${colorsStr})`;
                }
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "equals",
            value: function equals(color) {
                if (!color || this.isGradient() !== color.isGradient()) return false;
                if (!this.isGradient()) return this.toHexString() === color.toHexString();
                return this.colors.length === color.colors.length && this.colors.every((c, i)=>{
                    const target = color.colors[i];
                    return c.percent === target.percent && c.color.equals(target.color);
                });
            }
        }
    ]);
}();



var $eeyUA = parcelRequire("eeyUA");




var $eeyUA = parcelRequire("eeyUA");

var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $fa223280bc0dc591$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $fa223280bc0dc591$export$2e2bcd8739ae039 = $fa223280bc0dc591$var$RightOutlined;



var $b30e07b2937930b3$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $fa223280bc0dc591$export$2e2bcd8739ae039)
    }));
};
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ var $b30e07b2937930b3$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($b30e07b2937930b3$var$RightOutlined);
var $b30e07b2937930b3$export$2e2bcd8739ae039 = $b30e07b2937930b3$var$RefIcon;




var $7Nobb = parcelRequire("7Nobb");







var $eeyUA = parcelRequire("eeyUA");

var $7Nobb = parcelRequire("7Nobb");



var $eeyUA = parcelRequire("eeyUA");


var $7Nobb = parcelRequire("7Nobb");




/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $6d43cdfee1c37e0d$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $6d43cdfee1c37e0d$var$KeyCode.F1 && keyCode <= $6d43cdfee1c37e0d$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $6d43cdfee1c37e0d$var$KeyCode.ALT:
            case $6d43cdfee1c37e0d$var$KeyCode.CAPS_LOCK:
            case $6d43cdfee1c37e0d$var$KeyCode.CONTEXT_MENU:
            case $6d43cdfee1c37e0d$var$KeyCode.CTRL:
            case $6d43cdfee1c37e0d$var$KeyCode.DOWN:
            case $6d43cdfee1c37e0d$var$KeyCode.END:
            case $6d43cdfee1c37e0d$var$KeyCode.ESC:
            case $6d43cdfee1c37e0d$var$KeyCode.HOME:
            case $6d43cdfee1c37e0d$var$KeyCode.INSERT:
            case $6d43cdfee1c37e0d$var$KeyCode.LEFT:
            case $6d43cdfee1c37e0d$var$KeyCode.MAC_FF_META:
            case $6d43cdfee1c37e0d$var$KeyCode.META:
            case $6d43cdfee1c37e0d$var$KeyCode.NUMLOCK:
            case $6d43cdfee1c37e0d$var$KeyCode.NUM_CENTER:
            case $6d43cdfee1c37e0d$var$KeyCode.PAGE_DOWN:
            case $6d43cdfee1c37e0d$var$KeyCode.PAGE_UP:
            case $6d43cdfee1c37e0d$var$KeyCode.PAUSE:
            case $6d43cdfee1c37e0d$var$KeyCode.PRINT_SCREEN:
            case $6d43cdfee1c37e0d$var$KeyCode.RIGHT:
            case $6d43cdfee1c37e0d$var$KeyCode.SHIFT:
            case $6d43cdfee1c37e0d$var$KeyCode.UP:
            case $6d43cdfee1c37e0d$var$KeyCode.WIN_KEY:
            case $6d43cdfee1c37e0d$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $6d43cdfee1c37e0d$var$KeyCode.ZERO && keyCode <= $6d43cdfee1c37e0d$var$KeyCode.NINE) return true;
        if (keyCode >= $6d43cdfee1c37e0d$var$KeyCode.NUM_ZERO && keyCode <= $6d43cdfee1c37e0d$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $6d43cdfee1c37e0d$var$KeyCode.A && keyCode <= $6d43cdfee1c37e0d$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $6d43cdfee1c37e0d$var$KeyCode.SPACE:
            case $6d43cdfee1c37e0d$var$KeyCode.QUESTION_MARK:
            case $6d43cdfee1c37e0d$var$KeyCode.NUM_PLUS:
            case $6d43cdfee1c37e0d$var$KeyCode.NUM_MINUS:
            case $6d43cdfee1c37e0d$var$KeyCode.NUM_PERIOD:
            case $6d43cdfee1c37e0d$var$KeyCode.NUM_DIVISION:
            case $6d43cdfee1c37e0d$var$KeyCode.SEMICOLON:
            case $6d43cdfee1c37e0d$var$KeyCode.DASH:
            case $6d43cdfee1c37e0d$var$KeyCode.EQUALS:
            case $6d43cdfee1c37e0d$var$KeyCode.COMMA:
            case $6d43cdfee1c37e0d$var$KeyCode.PERIOD:
            case $6d43cdfee1c37e0d$var$KeyCode.SLASH:
            case $6d43cdfee1c37e0d$var$KeyCode.APOSTROPHE:
            case $6d43cdfee1c37e0d$var$KeyCode.SINGLE_QUOTE:
            case $6d43cdfee1c37e0d$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $6d43cdfee1c37e0d$var$KeyCode.BACKSLASH:
            case $6d43cdfee1c37e0d$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $6d43cdfee1c37e0d$export$2e2bcd8739ae039 = $6d43cdfee1c37e0d$var$KeyCode;



var $eeyUA = parcelRequire("eeyUA");




var $eeyUA = parcelRequire("eeyUA");
var $390b2364af1b9972$var$PanelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, forceRender = props.forceRender, className = props.className, style = props.style, children = props.children, isActive = props.isActive, role = props.role, customizeClassNames = props.classNames, styles = props.styles;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useState(isActive || forceRender), _React$useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState, 2), rendered = _React$useState2[0], setRendered = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useEffect(function() {
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-content"), (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-content-active"), isActive), "".concat(prefixCls, "-content-inactive"), !isActive), className),
        style: style,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-content-box"), customizeClassNames === null || customizeClassNames === void 0 ? void 0 : customizeClassNames.body),
        style: styles === null || styles === void 0 ? void 0 : styles.body
    }, children));
});
$390b2364af1b9972$var$PanelContent.displayName = 'PanelContent';
var $390b2364af1b9972$export$2e2bcd8739ae039 = $390b2364af1b9972$var$PanelContent;


var $22c45c52e4051183$var$_excluded = [
    "showArrow",
    "headerClass",
    "isActive",
    "onItemClick",
    "forceRender",
    "className",
    "classNames",
    "styles",
    "prefixCls",
    "collapsible",
    "accordion",
    "panelKey",
    "extra",
    "header",
    "expandIcon",
    "openMotion",
    "destroyInactivePanel",
    "children"
];
var $22c45c52e4051183$var$CollapsePanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).forwardRef(function(props, ref) {
    var _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, headerClass = props.headerClass, isActive = props.isActive, onItemClick = props.onItemClick, forceRender = props.forceRender, className = props.className, _props$classNames = props.classNames, customizeClassNames = _props$classNames === void 0 ? {} : _props$classNames, _props$styles = props.styles, styles = _props$styles === void 0 ? {} : _props$styles, prefixCls = props.prefixCls, collapsible = props.collapsible, accordion = props.accordion, panelKey = props.panelKey, extra = props.extra, header = props.header, expandIcon = props.expandIcon, openMotion = props.openMotion, destroyInactivePanel = props.destroyInactivePanel, children = props.children, resetProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(props, $22c45c52e4051183$var$_excluded);
    var disabled = collapsible === 'disabled';
    var ifExtraExist = extra !== null && extra !== undefined && typeof extra !== 'boolean';
    var collapsibleProps = (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({
        onClick: function onClick() {
            onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
        },
        onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter' || e.keyCode === (0, $6d43cdfee1c37e0d$export$2e2bcd8739ae039).ENTER || e.which === (0, $6d43cdfee1c37e0d$export$2e2bcd8739ae039).ENTER) onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
        },
        role: accordion ? 'tab' : 'button'
    }, 'aria-expanded', isActive), 'aria-disabled', disabled), "tabIndex", disabled ? -1 : 0);
    // ======================== Icon ========================
    var iconNodeInner = typeof expandIcon === 'function' ? expandIcon(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("i", {
        className: "arrow"
    });
    var iconNode = iconNodeInner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", (0, $7Nobb.default)({
        className: "".concat(prefixCls, "-expand-icon")
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
    var collapsePanelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-item"), (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-item-active"), isActive), "".concat(prefixCls, "-item-disabled"), disabled), className);
    var headerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(headerClass, "".concat(prefixCls, "-header"), (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-collapsible-").concat(collapsible), !!collapsible), customizeClassNames.header);
    // ======================== HeaderProps ========================
    var headerProps = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        className: headerClassName,
        style: styles.header
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? {} : collapsibleProps);
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", (0, $7Nobb.default)({}, resetProps, {
        ref: ref,
        className: collapsePanelClassNames
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("span", (0, $7Nobb.default)({
        className: "".concat(prefixCls, "-header-text")
    }, collapsible === 'header' ? collapsibleProps : {}), header), ifExtraExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: "".concat(prefixCls, "-extra")
    }, extra)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $31ad051c24fca029$export$2e2bcd8739ae039), (0, $7Nobb.default)({
        visible: isActive,
        leavedClassName: "".concat(prefixCls, "-content-hidden")
    }, openMotion, {
        forceRender: forceRender,
        removeOnLeave: destroyInactivePanel
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $390b2364af1b9972$export$2e2bcd8739ae039), {
            ref: motionRef,
            prefixCls: prefixCls,
            className: motionClassName,
            classNames: customizeClassNames,
            style: motionStyle,
            styles: styles,
            isActive: isActive,
            forceRender: forceRender,
            role: accordion ? 'tabpanel' : void 0
        }, children);
    }));
});
var $22c45c52e4051183$export$2e2bcd8739ae039 = $22c45c52e4051183$var$CollapsePanel;


var $d29a63bdccf7b031$var$_excluded = [
    "children",
    "label",
    "key",
    "collapsible",
    "onItemClick",
    "destroyInactivePanel"
];
var $d29a63bdccf7b031$var$convertItemsToNodes = function convertItemsToNodes(items, props) {
    var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
    return items.map(function(item, index) {
        var children = item.children, label = item.label, rawKey = item.key, rawCollapsible = item.collapsible, rawOnItemClick = item.onItemClick, rawDestroyInactivePanel = item.destroyInactivePanel, restProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(item, $d29a63bdccf7b031$var$_excluded);
        // You may be puzzled why you want to convert them all into strings, me too.
        // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
        var key = String(rawKey !== null && rawKey !== void 0 ? rawKey : index);
        var mergeCollapsible = rawCollapsible !== null && rawCollapsible !== void 0 ? rawCollapsible : collapsible;
        var mergeDestroyInactivePanel = rawDestroyInactivePanel !== null && rawDestroyInactivePanel !== void 0 ? rawDestroyInactivePanel : destroyInactivePanel;
        var handleItemClick = function handleItemClick(value) {
            if (mergeCollapsible === 'disabled') return;
            onItemClick(value);
            rawOnItemClick === null || rawOnItemClick === void 0 || rawOnItemClick(value);
        };
        var isActive = false;
        if (accordion) isActive = activeKey[0] === key;
        else isActive = activeKey.indexOf(key) > -1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $22c45c52e4051183$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, restProps, {
            prefixCls: prefixCls,
            key: key,
            panelKey: key,
            isActive: isActive,
            accordion: accordion,
            openMotion: openMotion,
            expandIcon: expandIcon,
            header: label,
            collapsible: mergeCollapsible,
            onItemClick: handleItemClick,
            destroyInactivePanel: mergeDestroyInactivePanel
        }), children);
    });
};
/**
 * @deprecated The next major version will be removed
 */ var $d29a63bdccf7b031$var$getNewChild = function getNewChild(child, index, props) {
    if (!child) return null;
    var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
    var key = child.key || String(index);
    var _child$props = child.props, header = _child$props.header, headerClass = _child$props.headerClass, childDestroyInactivePanel = _child$props.destroyInactivePanel, childCollapsible = _child$props.collapsible, childOnItemClick = _child$props.onItemClick;
    var isActive = false;
    if (accordion) isActive = activeKey[0] === key;
    else isActive = activeKey.indexOf(key) > -1;
    var mergeCollapsible = childCollapsible !== null && childCollapsible !== void 0 ? childCollapsible : collapsible;
    var handleItemClick = function handleItemClick(value) {
        if (mergeCollapsible === 'disabled') return;
        onItemClick(value);
        childOnItemClick === null || childOnItemClick === void 0 || childOnItemClick(value);
    };
    var childProps = {
        key: key,
        panelKey: key,
        header: header,
        headerClass: headerClass,
        isActive: isActive,
        prefixCls: prefixCls,
        destroyInactivePanel: childDestroyInactivePanel !== null && childDestroyInactivePanel !== void 0 ? childDestroyInactivePanel : destroyInactivePanel,
        openMotion: openMotion,
        accordion: accordion,
        children: child.props.children,
        onItemClick: handleItemClick,
        expandIcon: expandIcon,
        collapsible: mergeCollapsible
    };
    // https://github.com/ant-design/ant-design/issues/20479
    if (typeof child.type === 'string') return child;
    Object.keys(childProps).forEach(function(propName) {
        if (typeof childProps[propName] === 'undefined') delete childProps[propName];
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).cloneElement(child, childProps);
};
function $d29a63bdccf7b031$var$useItems(items, rawChildren, props) {
    if (Array.isArray(items)) return $d29a63bdccf7b031$var$convertItemsToNodes(items, props);
    return (0, $ad876cf685db44a4$export$2e2bcd8739ae039)(rawChildren).map(function(child, index) {
        return $d29a63bdccf7b031$var$getNewChild(child, index, props);
    });
}
var $d29a63bdccf7b031$export$2e2bcd8739ae039 = $d29a63bdccf7b031$var$useItems;




var $2b6013c7a3c0e965$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $2b6013c7a3c0e965$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $2b6013c7a3c0e965$var$propList = "".concat($2b6013c7a3c0e965$var$attributes, " ").concat($2b6013c7a3c0e965$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $2b6013c7a3c0e965$var$ariaPrefix = 'aria-';
var $2b6013c7a3c0e965$var$dataPrefix = 'data-';
function $2b6013c7a3c0e965$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $2b6013c7a3c0e965$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === 'role' || $2b6013c7a3c0e965$var$match(key, $2b6013c7a3c0e965$var$ariaPrefix)) || // Data
        mergedConfig.data && $2b6013c7a3c0e965$var$match(key, $2b6013c7a3c0e965$var$dataPrefix) || // Attr
        mergedConfig.attr && $2b6013c7a3c0e965$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}


function $0920f742ddf91b26$var$getActiveKeysArray(activeKey) {
    var currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        var activeKeyType = (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(currentActiveKey);
        currentActiveKey = activeKeyType === 'number' || activeKeyType === 'string' ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map(function(key) {
        return String(key);
    });
}
var $0920f742ddf91b26$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-collapse' : _props$prefixCls, _props$destroyInactiv = props.destroyInactivePanel, destroyInactivePanel = _props$destroyInactiv === void 0 ? false : _props$destroyInactiv, style = props.style, accordion = props.accordion, className = props.className, children = props.children, collapsible = props.collapsible, openMotion = props.openMotion, expandIcon = props.expandIcon, rawActiveKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, _onChange = props.onChange, items = props.items;
    var collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, className);
    var _useMergedState = (0, $e7fff343666ddaae$export$2e2bcd8739ae039)([], {
        value: rawActiveKey,
        onChange: function onChange(v) {
            return _onChange === null || _onChange === void 0 ? void 0 : _onChange(v);
        },
        defaultValue: defaultActiveKey,
        postState: $0920f742ddf91b26$var$getActiveKeysArray
    }), _useMergedState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useMergedState, 2), activeKey = _useMergedState2[0], setActiveKey = _useMergedState2[1];
    var onItemClick = function onItemClick(key) {
        return setActiveKey(function() {
            if (accordion) return activeKey[0] === key ? [] : [
                key
            ];
            var index = activeKey.indexOf(key);
            var isActive = index > -1;
            if (isActive) return activeKey.filter(function(item) {
                return item !== key;
            });
            return [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(activeKey), [
                key
            ]);
        });
    };
    // ======================== Children ========================
    (0, $f29d0996356f1173$export$2e2bcd8739ae039)(!children, '[rc-collapse] `children` will be removed in next major version. Please use `items` instead.');
    var mergedChildren = (0, $d29a63bdccf7b031$export$2e2bcd8739ae039)(items, children, {
        prefixCls: prefixCls,
        accordion: accordion,
        openMotion: openMotion,
        expandIcon: expandIcon,
        collapsible: collapsible,
        destroyInactivePanel: destroyInactivePanel,
        onItemClick: onItemClick,
        activeKey: activeKey
    });
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", (0, $7Nobb.default)({
        ref: ref,
        className: collapseClassName,
        style: style,
        role: accordion ? 'tablist' : undefined
    }, (0, $2b6013c7a3c0e965$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    })), mergedChildren);
});
var $0920f742ddf91b26$export$2e2bcd8739ae039 = Object.assign($0920f742ddf91b26$var$Collapse, {
    /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */ Panel: (0, $22c45c52e4051183$export$2e2bcd8739ae039)
});


var $d9bf497b41578fcf$export$2e2bcd8739ae039 = (0, $0920f742ddf91b26$export$2e2bcd8739ae039);
/**
 * @deprecated use `items` instead, will be removed in `v4.0.0`
 */ var $d9bf497b41578fcf$export$2ddb90ad54e5f587 = (0, $0920f742ddf91b26$export$2e2bcd8739ae039).Panel;










var $eeyUA = parcelRequire("eeyUA");




"use client";
const $56f0a527b1b911c4$var$CollapsePanel = /*#__PURE__*/ $eeyUA.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showArrow: showArrow = true } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const collapsePanelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))({
        [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /*#__PURE__*/ $eeyUA.createElement((0, $d9bf497b41578fcf$export$2e2bcd8739ae039).Panel, Object.assign({
        ref: ref
    }, props, {
        prefixCls: prefixCls,
        className: collapsePanelClassName
    }));
});
var $56f0a527b1b911c4$export$2e2bcd8739ae039 = $56f0a527b1b911c4$var$CollapsePanel;




const $8374ae24a6283b16$var$genCollapseMotion = (token)=>({
        [token.componentCls]: {
            // For common/openAnimation
            [`${token.antCls}-motion-collapse-legacy`]: {
                overflow: 'hidden',
                '&-active': {
                    transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
                }
            },
            [`${token.antCls}-motion-collapse`]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
            }
        }
    });
var $8374ae24a6283b16$export$2e2bcd8739ae039 = $8374ae24a6283b16$var$genCollapseMotion;



const $e4c81cb01be8f052$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, contentBg: contentBg, padding: padding, headerBg: headerBg, headerPadding: headerPadding, collapseHeaderPaddingSM: collapseHeaderPaddingSM, collapseHeaderPaddingLG: collapseHeaderPaddingLG, collapsePanelBorderRadius: collapsePanelBorderRadius, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, colorText: colorText, colorTextHeading: colorTextHeading, colorTextDisabled: colorTextDisabled, fontSizeLG: fontSizeLG, lineHeight: lineHeight, lineHeightLG: lineHeightLG, marginSM: marginSM, paddingSM: paddingSM, paddingLG: paddingLG, paddingXS: paddingXS, motionDurationSlow: motionDurationSlow, fontSizeIcon: fontSizeIcon, contentPadding: contentPadding, fontHeight: fontHeight, fontHeightLG: fontHeightLG } = token;
    const borderBase = `${(0, $2c076defa05cd41b$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $d715ae4ca001487d$export$23997c3e44cc1c59)(token)), {
            backgroundColor: headerBg,
            border: borderBase,
            borderRadius: collapsePanelBorderRadius,
            '&-rtl': {
                direction: 'rtl'
            },
            [`& > ${componentCls}-item`]: {
                borderBottom: borderBase,
                '&:first-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `${(0, $2c076defa05cd41b$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(collapsePanelBorderRadius)} 0 0`
                    }
                },
                '&:last-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `0 0 ${(0, $2c076defa05cd41b$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                    }
                },
                [`> ${componentCls}-header`]: Object.assign(Object.assign({
                    position: 'relative',
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: headerPadding,
                    color: colorTextHeading,
                    lineHeight: lineHeight,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}, visibility 0s`
                }, (0, $d715ae4ca001487d$export$a44db842bcb28231)(token)), {
                    [`> ${componentCls}-header-text`]: {
                        flex: 'auto'
                    },
                    // >>>>> Arrow
                    [`${componentCls}-expand-icon`]: {
                        height: fontHeight,
                        display: 'flex',
                        alignItems: 'center',
                        paddingInlineEnd: marginSM
                    },
                    [`${componentCls}-arrow`]: Object.assign(Object.assign({}, (0, $d715ae4ca001487d$export$171ccda7bc085e59)()), {
                        fontSize: fontSizeIcon,
                        // when `transform: rotate()` is applied to icon's root element
                        transition: `transform ${motionDurationSlow}`,
                        // when `transform: rotate()` is applied to icon's child element
                        svg: {
                            transition: `transform ${motionDurationSlow}`
                        }
                    }),
                    // >>>>> Text
                    [`${componentCls}-header-text`]: {
                        marginInlineEnd: 'auto'
                    }
                }),
                [`${componentCls}-collapsible-header`]: {
                    cursor: 'default',
                    [`${componentCls}-header-text`]: {
                        flex: 'none',
                        cursor: 'pointer'
                    },
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                },
                [`${componentCls}-collapsible-icon`]: {
                    cursor: 'unset',
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                }
            },
            [`${componentCls}-content`]: {
                color: colorText,
                backgroundColor: contentBg,
                borderTop: borderBase,
                [`& > ${componentCls}-content-box`]: {
                    padding: contentPadding
                },
                '&-hidden': {
                    display: 'none'
                }
            },
            '&-small': {
                [`> ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingSM,
                        paddingInlineStart: paddingXS,
                        [`> ${componentCls}-expand-icon`]: {
                            // Arrow offset
                            marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
                        }
                    },
                    [`> ${componentCls}-content > ${componentCls}-content-box`]: {
                        padding: paddingSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-item`]: {
                    fontSize: fontSizeLG,
                    lineHeight: lineHeightLG,
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingLG,
                        paddingInlineStart: padding,
                        [`> ${componentCls}-expand-icon`]: {
                            height: fontHeightLG,
                            // Arrow offset
                            marginInlineStart: token.calc(paddingLG).sub(padding).equal()
                        }
                    },
                    [`> ${componentCls}-content > ${componentCls}-content-box`]: {
                        padding: paddingLG
                    }
                }
            },
            [`${componentCls}-item:last-child`]: {
                borderBottom: 0,
                [`> ${componentCls}-content`]: {
                    borderRadius: `0 0 ${(0, $2c076defa05cd41b$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                }
            },
            [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
                [`
          &,
          & > .arrow
        `]: {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            // ========================== Icon Position ==========================
            [`&${componentCls}-icon-position-end`]: {
                [`& > ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        [`${componentCls}-expand-icon`]: {
                            order: 1,
                            paddingInlineEnd: 0,
                            paddingInlineStart: marginSM
                        }
                    }
                }
            }
        })
    };
};
const $e4c81cb01be8f052$var$genArrowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
    return {
        [`${componentCls}-rtl`]: {
            [fixedSelector]: {
                transform: `rotate(180deg)`
            }
        }
    };
};
const $e4c81cb01be8f052$var$genBorderlessStyle = (token)=>{
    const { componentCls: componentCls, headerBg: headerBg, borderlessContentPadding: borderlessContentPadding, borderlessContentBg: borderlessContentBg, colorBorder: colorBorder } = token;
    return {
        [`${componentCls}-borderless`]: {
            backgroundColor: headerBg,
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: `1px solid ${colorBorder}`
            },
            [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
                borderRadius: 0
            },
            [`> ${componentCls}-item:last-child`]: {
                borderBottom: 0
            },
            [`> ${componentCls}-item > ${componentCls}-content`]: {
                backgroundColor: borderlessContentBg,
                borderTop: 0
            },
            [`> ${componentCls}-item > ${componentCls}-content > ${componentCls}-content-box`]: {
                padding: borderlessContentPadding
            }
        }
    };
};
const $e4c81cb01be8f052$var$genGhostStyle = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    return {
        [`${componentCls}-ghost`]: {
            backgroundColor: 'transparent',
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: 0,
                [`> ${componentCls}-content`]: {
                    backgroundColor: 'transparent',
                    border: 0,
                    [`> ${componentCls}-content-box`]: {
                        paddingBlock: paddingSM
                    }
                }
            }
        }
    };
};
const $e4c81cb01be8f052$export$9ca1be8807fe0675 = (token)=>({
        headerPadding: `${token.paddingSM}px ${token.padding}px`,
        headerBg: token.colorFillAlter,
        contentPadding: `${token.padding}px 16px`,
        // Fixed Value
        contentBg: token.colorBgContainer,
        borderlessContentPadding: `${token.paddingXXS}px 16px ${token.padding}px`,
        borderlessContentBg: 'transparent'
    });
var $e4c81cb01be8f052$export$2e2bcd8739ae039 = (0, $16d63ad40d593937$export$51ec95de45185b42)('Collapse', (token)=>{
    const collapseToken = (0, $0dfcc8c9c107e242$export$4950aa0f605343fb)(token, {
        collapseHeaderPaddingSM: `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.paddingXS)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.paddingSM)}`,
        collapseHeaderPaddingLG: `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.padding)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.paddingLG)}`,
        collapsePanelBorderRadius: token.borderRadiusLG
    });
    return [
        $e4c81cb01be8f052$export$5ca74f7be820a85(collapseToken),
        $e4c81cb01be8f052$var$genBorderlessStyle(collapseToken),
        $e4c81cb01be8f052$var$genGhostStyle(collapseToken),
        $e4c81cb01be8f052$var$genArrowStyle(collapseToken),
        (0, $8374ae24a6283b16$export$2e2bcd8739ae039)(collapseToken)
    ];
}, $e4c81cb01be8f052$export$9ca1be8807fe0675);


"use client";
const $00268a11b443c0c0$var$Collapse = /*#__PURE__*/ $eeyUA.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, expandIcon: contextExpandIcon, className: contextClassName, style: contextStyle } = (0, $0b79f8c0c8222aa8$export$46f4bd6436a25a31)('collapse');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, bordered: bordered = true, ghost: ghost, size: customizeSize, expandIconPosition: expandIconPosition = 'start', children: children, destroyInactivePanel: destroyInactivePanel, destroyOnHidden: destroyOnHidden, expandIcon: expandIcon } = props;
    const mergedSize = (0, $5c741ce817a3a21f$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : ctx) !== null && _a !== void 0 ? _a : 'middle';
    });
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [wrapCSSVar, hashId, cssVarCls] = (0, $e4c81cb01be8f052$export$2e2bcd8739ae039)(prefixCls);
    // Align with logic position
    const mergedExpandIconPosition = $eeyUA.useMemo(()=>{
        if (expandIconPosition === 'left') return 'start';
        return expandIconPosition === 'right' ? 'end' : expandIconPosition;
    }, [
        expandIconPosition
    ]);
    const mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
    const renderExpandIcon = $eeyUA.useCallback((panelProps = {})=>{
        const icon = typeof mergedExpandIcon === 'function' ? mergedExpandIcon(panelProps) : /*#__PURE__*/ $eeyUA.createElement((0, $b30e07b2937930b3$export$2e2bcd8739ae039), {
            rotate: panelProps.isActive ? direction === 'rtl' ? -90 : 90 : undefined,
            "aria-label": panelProps.isActive ? 'expanded' : 'collapsed'
        });
        return (0, $0e473b0b0663338c$export$e530037191fcd5d7)(icon, ()=>{
            var _a;
            return {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))((_a = icon.props) === null || _a === void 0 ? void 0 : _a.className, `${prefixCls}-arrow`)
            };
        });
    }, [
        mergedExpandIcon,
        prefixCls,
        direction
    ]);
    const collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(`${prefixCls}-icon-position-${mergedExpandIconPosition}`, {
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-ghost`]: !!ghost,
        [`${prefixCls}-${mergedSize}`]: mergedSize !== 'middle'
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    const openMotion = $eeyUA.useMemo(()=>Object.assign(Object.assign({}, (0, $5e50fdfe62d69e21$export$2e2bcd8739ae039)(rootPrefixCls)), {
            motionAppear: false,
            leavedClassName: `${prefixCls}-content-hidden`
        }), [
        rootPrefixCls,
        prefixCls
    ]);
    const items = $eeyUA.useMemo(()=>{
        if (!children) return null;
        return (0, $ad876cf685db44a4$export$2e2bcd8739ae039)(children).map((child, index)=>{
            var _a, _b;
            const childProps = child.props;
            if (childProps === null || childProps === void 0 ? void 0 : childProps.disabled) {
                const key = (_a = child.key) !== null && _a !== void 0 ? _a : String(index);
                const mergedChildProps = Object.assign(Object.assign({}, (0, $26e0f2bfdd13a109$export$2e2bcd8739ae039)(child.props, [
                    'disabled'
                ])), {
                    key: key,
                    collapsible: (_b = childProps.collapsible) !== null && _b !== void 0 ? _b : 'disabled'
                });
                return (0, $0e473b0b0663338c$export$e530037191fcd5d7)(child, mergedChildProps);
            }
            return child;
        });
    }, [
        children
    ]);
    return wrapCSSVar(/*#__PURE__*/ // @ts-ignore
    $eeyUA.createElement((0, $d9bf497b41578fcf$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        openMotion: openMotion
    }, (0, $26e0f2bfdd13a109$export$2e2bcd8739ae039)(props, [
        'rootClassName'
    ]), {
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName,
        style: Object.assign(Object.assign({}, contextStyle), style),
        // TODO: In the future, destroyInactivePanel in rc-collapse needs to be upgrade to destroyOnHidden
        destroyInactivePanel: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyInactivePanel
    }), items));
});
var $00268a11b443c0c0$export$2e2bcd8739ae039 = Object.assign($00268a11b443c0c0$var$Collapse, {
    Panel: (0, $56f0a527b1b911c4$export$2e2bcd8739ae039)
});


"use client";
var $489923a58516f20d$export$2e2bcd8739ae039 = (0, $00268a11b443c0c0$export$2e2bcd8739ae039);







const $90432444c0433c9d$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $ea3106541828fcc7$export$e8cc8a2e87e145b4)) return color;
    return new (0, $ea3106541828fcc7$export$e8cc8a2e87e145b4)(color);
};
const $90432444c0433c9d$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $90432444c0433c9d$export$3c8ae3c73ab0e52a = (color)=>$90432444c0433c9d$export$8d6531175688484b(color.toHsb().a * 100);
const $90432444c0433c9d$export$f04e5f54cfbb466c = (color, alpha)=>{
    const rgba = color.toRgb();
    // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
    // So if rgb is empty, we should get from hsb
    if (!rgba.r && !rgba.g && !rgba.b) {
        const hsba = color.toHsb();
        hsba.a = alpha || 1;
        return $90432444c0433c9d$export$c844f5d21427d1ab(hsba);
    }
    rgba.a = alpha || 1;
    return $90432444c0433c9d$export$c844f5d21427d1ab(rgba);
};
const $90432444c0433c9d$export$9dd6bfe648e14e97 = (colors, percent)=>{
    const filledColors = [
        {
            percent: 0,
            color: colors[0].color
        }
    ].concat((0, $3440102357566473$export$2e2bcd8739ae039)(colors), [
        {
            percent: 100,
            color: colors[colors.length - 1].color
        }
    ]);
    for(let i = 0; i < filledColors.length - 1; i += 1){
        const startPtg = filledColors[i].percent;
        const endPtg = filledColors[i + 1].percent;
        const startColor = filledColors[i].color;
        const endColor = filledColors[i + 1].color;
        if (startPtg <= percent && percent <= endPtg) {
            const dist = endPtg - startPtg;
            if (dist === 0) return startColor;
            const ratio = (percent - startPtg) / dist * 100;
            const startRcColor = new (0, $bdc73cc467115cb8$export$892596cec99bc70e)(startColor);
            const endRcColor = new (0, $bdc73cc467115cb8$export$892596cec99bc70e)(endColor);
            return startRcColor.mix(endRcColor, ratio).toRgbString();
        }
    }
    // This will never reach
    /* istanbul ignore next */ return '';
};


"use client";
const $cd81714b3f79f0e3$var$genPresetColor = (list)=>list.map((value)=>{
        value.colors = value.colors.map((0, $90432444c0433c9d$export$c844f5d21427d1ab));
        return value;
    });
const $cd81714b3f79f0e3$export$6341b37cb79161da = (value, bgColorToken)=>{
    const { r: r, g: g, b: b, a: a } = value.toRgb();
    const hsv = new (0, $bdc73cc467115cb8$export$892596cec99bc70e)(value.toRgbString()).onBackground(bgColorToken).toHsv();
    if (a <= 0.5) // Adapted to dark mode
    return hsv.v > 0.5;
    return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const $cd81714b3f79f0e3$var$genCollapsePanelKey = (preset, index)=>{
    var _a;
    const mergedKey = (_a = preset.key) !== null && _a !== void 0 ? _a : index;
    return `panel-${mergedKey}`;
};
const $cd81714b3f79f0e3$var$ColorPresets = ({ prefixCls: prefixCls, presets: presets, value: color, onChange: onChange })=>{
    const [locale] = (0, $6d3e114ae5f0e28f$export$2e2bcd8739ae039)('ColorPicker');
    const [, token] = (0, $77023b8a2ee37055$export$2e2bcd8739ae039)();
    const [presetsValue] = (0, $e7fff343666ddaae$export$2e2bcd8739ae039)($cd81714b3f79f0e3$var$genPresetColor(presets), {
        value: $cd81714b3f79f0e3$var$genPresetColor(presets),
        postState: $cd81714b3f79f0e3$var$genPresetColor
    });
    const colorPresetsPrefixCls = `${prefixCls}-presets`;
    const activeKeys = (0, $eeyUA.useMemo)(()=>presetsValue.reduce((acc, preset, index)=>{
            const { defaultOpen: defaultOpen = true } = preset;
            if (defaultOpen) acc.push($cd81714b3f79f0e3$var$genCollapsePanelKey(preset, index));
            return acc;
        }, []), [
        presetsValue
    ]);
    const handleClick = (colorValue)=>{
        onChange === null || onChange === void 0 || onChange(colorValue);
    };
    const items = presetsValue.map((preset, index)=>{
        var _a;
        return {
            key: $cd81714b3f79f0e3$var$genCollapsePanelKey(preset, index),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
                className: `${colorPresetsPrefixCls}-label`
            }, preset === null || preset === void 0 ? void 0 : preset.label),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
                className: `${colorPresetsPrefixCls}-items`
            }, Array.isArray(preset === null || preset === void 0 ? void 0 : preset.colors) && ((_a = preset.colors) === null || _a === void 0 ? void 0 : _a.length) > 0 ? preset.colors.map((presetColor, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $cc4770487dc4d81e$export$2e2bcd8739ae039), {
                    // eslint-disable-next-line react/no-array-index-key
                    key: `preset-${index}-${presetColor.toHexString()}`,
                    color: (0, $90432444c0433c9d$export$c844f5d21427d1ab)(presetColor).toRgbString(),
                    prefixCls: prefixCls,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(`${colorPresetsPrefixCls}-color`, {
                        [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toHexString() === (color === null || color === void 0 ? void 0 : color.toHexString()),
                        [`${colorPresetsPrefixCls}-color-bright`]: $cd81714b3f79f0e3$export$6341b37cb79161da(presetColor, token.colorBgElevated)
                    }),
                    onClick: ()=>handleClick(presetColor)
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("span", {
                className: `${colorPresetsPrefixCls}-empty`
            }, locale.presetEmpty))
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: colorPresetsPrefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $489923a58516f20d$export$2e2bcd8739ae039), {
        defaultActiveKey: activeKeys,
        ghost: true,
        items: items
    }));
};
var $cd81714b3f79f0e3$export$2e2bcd8739ae039 = $cd81714b3f79f0e3$var$ColorPresets;





const $ddfc411653db0f5d$export$362fb92a8f81bbf9 = (token)=>{
    const { paddingInline: paddingInline, onlyIconSize: onlyIconSize } = token;
    const buttonToken = (0, $0dfcc8c9c107e242$export$4950aa0f605343fb)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: 0,
        buttonIconOnlyFontSize: onlyIconSize
    });
    return buttonToken;
};
const $ddfc411653db0f5d$export$9ca1be8807fe0675 = (token)=>{
    var _a, _b, _c, _d, _e, _f;
    const contentFontSize = (_a = token.contentFontSize) !== null && _a !== void 0 ? _a : token.fontSize;
    const contentFontSizeSM = (_b = token.contentFontSizeSM) !== null && _b !== void 0 ? _b : token.fontSize;
    const contentFontSizeLG = (_c = token.contentFontSizeLG) !== null && _c !== void 0 ? _c : token.fontSizeLG;
    const contentLineHeight = (_d = token.contentLineHeight) !== null && _d !== void 0 ? _d : (0, $cddb9a637e42434c$export$56204a27a2958a55)(contentFontSize);
    const contentLineHeightSM = (_e = token.contentLineHeightSM) !== null && _e !== void 0 ? _e : (0, $cddb9a637e42434c$export$56204a27a2958a55)(contentFontSizeSM);
    const contentLineHeightLG = (_f = token.contentLineHeightLG) !== null && _f !== void 0 ? _f : (0, $cddb9a637e42434c$export$56204a27a2958a55)(contentFontSizeLG);
    const solidTextColor = (0, $cd81714b3f79f0e3$export$6341b37cb79161da)(new (0, $ea3106541828fcc7$export$e8cc8a2e87e145b4)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    const shadowColorTokens = (0, $ed04b53644533bfe$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>Object.assign(Object.assign({}, prev), {
            [`${colorKey}ShadowColor`]: `0 ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.controlOutlineWidth)} 0 ${(0, $699d3b1bab70fa3d$export$2e2bcd8739ae039)(token[`${colorKey}1`], token.colorBgContainer)}`
        }), {});
    return Object.assign(Object.assign({}, shadowColorTokens), {
        fontWeight: 400,
        iconGap: token.marginXS,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorder,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: 'transparent',
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        onlyIconSize: 'inherit',
        onlyIconSizeSM: 'inherit',
        onlyIconSizeLG: 'inherit',
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: 'transparent',
        textTextColor: token.colorText,
        textTextHoverColor: token.colorText,
        textTextActiveColor: token.colorText,
        textHoverBg: token.colorFillTertiary,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        defaultHoverBg: token.colorBgContainer,
        defaultHoverColor: token.colorPrimaryHover,
        defaultHoverBorderColor: token.colorPrimaryHover,
        defaultActiveBg: token.colorBgContainer,
        defaultActiveColor: token.colorPrimaryActive,
        defaultActiveBorderColor: token.colorPrimaryActive,
        solidTextColor: solidTextColor,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG,
        contentLineHeight: contentLineHeight,
        contentLineHeightSM: contentLineHeightSM,
        contentLineHeightLG: contentLineHeightLG,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0)
    });
};


// ============================== Shared ==============================
const $eb1cf391543b1933$var$genSharedButtonStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontWeight: fontWeight, opacityLoading: opacityLoading, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, iconGap: iconGap, calc: calc } = token;
    return {
        [componentCls]: {
            outline: 'none',
            position: 'relative',
            display: 'inline-flex',
            gap: iconGap,
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: fontWeight,
            whiteSpace: 'nowrap',
            textAlign: 'center',
            backgroundImage: 'none',
            background: 'transparent',
            border: `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: 'none',
            touchAction: 'manipulation',
            color: token.colorText,
            '&:disabled > *': {
                pointerEvents: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/51380
            [`${componentCls}-icon > svg`]: (0, $d715ae4ca001487d$export$171ccda7bc085e59)(),
            '> a': {
                color: 'currentColor'
            },
            '&:not(:disabled)': (0, $d715ae4ca001487d$export$a44db842bcb28231)(token),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: '-0.34em',
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-icon-only`]: {
                paddingInline: 0,
                // make `btn-icon-only` not too narrow
                [`&${componentCls}-compact-item`]: {
                    flex: 'none'
                }
            },
            // Loading
            [`&${componentCls}-loading`]: {
                opacity: opacityLoading,
                cursor: 'default'
            },
            [`${componentCls}-loading-icon`]: {
                transition: [
                    'width',
                    'opacity',
                    'margin'
                ].map((transition)=>`${transition} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
            },
            // iconPosition
            [`&:not(${componentCls}-icon-end)`]: {
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineEnd: 0
                    },
                    '&-leave-start': {
                        marginInlineEnd: 0
                    },
                    '&-leave-active': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    }
                }
            },
            '&-icon-end': {
                flexDirection: 'row-reverse',
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineStart: 0
                    },
                    '&-leave-start': {
                        marginInlineStart: 0
                    },
                    '&-leave-active': {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    }
                }
            }
        }
    };
};
const $eb1cf391543b1933$var$genHoverActiveButtonStyle = (btnCls, hoverStyle, activeStyle)=>({
        [`&:not(:disabled):not(${btnCls}-disabled)`]: {
            '&:hover': hoverStyle,
            '&:active': activeStyle
        }
    });
// ============================== Shape ===============================
const $eb1cf391543b1933$var$genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInline: 0,
        borderRadius: '50%'
    });
const $eb1cf391543b1933$var$genDisabledStyle = (token)=>({
        cursor: 'not-allowed',
        borderColor: token.borderColorDisabled,
        color: token.colorTextDisabled,
        background: token.colorBgContainerDisabled,
        boxShadow: 'none'
    });
const $eb1cf391543b1933$var$genGhostButtonStyle = (btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle)=>({
        [`&${btnCls}-background-ghost`]: Object.assign(Object.assign({
            color: textColor || undefined,
            background: background,
            borderColor: borderColor || undefined,
            boxShadow: 'none'
        }, $eb1cf391543b1933$var$genHoverActiveButtonStyle(btnCls, Object.assign({
            background: background
        }, hoverStyle), Object.assign({
            background: background
        }, activeStyle))), {
            '&:disabled': {
                cursor: 'not-allowed',
                color: textColorDisabled || undefined,
                borderColor: borderColorDisabled || undefined
            }
        })
    });
const $eb1cf391543b1933$var$genSolidDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: Object.assign({}, $eb1cf391543b1933$var$genDisabledStyle(token))
    });
const $eb1cf391543b1933$var$genPureDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: {
            cursor: 'not-allowed',
            color: token.colorTextDisabled
        }
    });
// ============================== Variant =============================
const $eb1cf391543b1933$var$genVariantButtonStyle = (token, hoverStyle, activeStyle, variant)=>{
    const isPureDisabled = variant && [
        'link',
        'text'
    ].includes(variant);
    const genDisabledButtonStyle = isPureDisabled ? $eb1cf391543b1933$var$genPureDisabledButtonStyle : $eb1cf391543b1933$var$genSolidDisabledButtonStyle;
    return Object.assign(Object.assign({}, genDisabledButtonStyle(token)), $eb1cf391543b1933$var$genHoverActiveButtonStyle(token.componentCls, hoverStyle, activeStyle));
};
const $eb1cf391543b1933$var$genSolidButtonStyle = (token, textColor, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-solid`]: Object.assign({
            color: textColor,
            background: background
        }, $eb1cf391543b1933$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $eb1cf391543b1933$var$genOutlinedDashedButtonStyle = (token, borderColor, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-outlined, &${token.componentCls}-variant-dashed`]: Object.assign({
            borderColor: borderColor,
            background: background
        }, $eb1cf391543b1933$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $eb1cf391543b1933$var$genDashedButtonStyle = (token)=>({
        [`&${token.componentCls}-variant-dashed`]: {
            borderStyle: 'dashed'
        }
    });
const $eb1cf391543b1933$var$genFilledButtonStyle = (token, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-filled`]: Object.assign({
            boxShadow: 'none',
            background: background
        }, $eb1cf391543b1933$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $eb1cf391543b1933$var$genTextLinkButtonStyle = (token, textColor, variant, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-${variant}`]: Object.assign({
            color: textColor,
            boxShadow: 'none'
        }, $eb1cf391543b1933$var$genVariantButtonStyle(token, hoverStyle, activeStyle, variant))
    });
// =============================== Color ==============================
const $eb1cf391543b1933$var$genPresetColorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return (0, $ed04b53644533bfe$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>{
        const darkColor = token[`${colorKey}6`];
        const lightColor = token[`${colorKey}1`];
        const hoverColor = token[`${colorKey}5`];
        const lightHoverColor = token[`${colorKey}2`];
        const lightBorderColor = token[`${colorKey}3`];
        const activeColor = token[`${colorKey}7`];
        return Object.assign(Object.assign({}, prev), {
            [`&${componentCls}-color-${colorKey}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
                color: darkColor,
                boxShadow: token[`${colorKey}ShadowColor`]
            }, $eb1cf391543b1933$var$genSolidButtonStyle(token, token.colorTextLightSolid, darkColor, {
                background: hoverColor
            }, {
                background: activeColor
            })), $eb1cf391543b1933$var$genOutlinedDashedButtonStyle(token, darkColor, token.colorBgContainer, {
                color: hoverColor,
                borderColor: hoverColor,
                background: token.colorBgContainer
            }, {
                color: activeColor,
                borderColor: activeColor,
                background: token.colorBgContainer
            })), $eb1cf391543b1933$var$genDashedButtonStyle(token)), $eb1cf391543b1933$var$genFilledButtonStyle(token, lightColor, {
                color: darkColor,
                background: lightHoverColor
            }, {
                color: darkColor,
                background: lightBorderColor
            })), $eb1cf391543b1933$var$genTextLinkButtonStyle(token, darkColor, 'link', {
                color: hoverColor
            }, {
                color: activeColor
            })), $eb1cf391543b1933$var$genTextLinkButtonStyle(token, darkColor, 'text', {
                color: hoverColor,
                background: lightColor
            }, {
                color: activeColor,
                background: lightBorderColor
            }))
        });
    }, {});
};
const $eb1cf391543b1933$var$genDefaultButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.defaultColor,
        boxShadow: token.defaultShadow
    }, $eb1cf391543b1933$var$genSolidButtonStyle(token, token.solidTextColor, token.colorBgSolid, {
        color: token.solidTextColor,
        background: token.colorBgSolidHover
    }, {
        color: token.solidTextColor,
        background: token.colorBgSolidActive
    })), $eb1cf391543b1933$var$genDashedButtonStyle(token)), $eb1cf391543b1933$var$genFilledButtonStyle(token, token.colorFillTertiary, {
        color: token.defaultColor,
        background: token.colorFillSecondary
    }, {
        color: token.defaultColor,
        background: token.colorFill
    })), $eb1cf391543b1933$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.defaultGhostColor, token.defaultGhostBorderColor, token.colorTextDisabled, token.colorBorder)), $eb1cf391543b1933$var$genTextLinkButtonStyle(token, token.textTextColor, 'link', {
        color: token.colorLinkHover,
        background: token.linkHoverBg
    }, {
        color: token.colorLinkActive
    }));
const $eb1cf391543b1933$var$genPrimaryButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.colorPrimary,
        boxShadow: token.primaryShadow
    }, $eb1cf391543b1933$var$genOutlinedDashedButtonStyle(token, token.colorPrimary, token.colorBgContainer, {
        color: token.colorPrimaryTextHover,
        borderColor: token.colorPrimaryHover,
        background: token.colorBgContainer
    }, {
        color: token.colorPrimaryTextActive,
        borderColor: token.colorPrimaryActive,
        background: token.colorBgContainer
    })), $eb1cf391543b1933$var$genDashedButtonStyle(token)), $eb1cf391543b1933$var$genFilledButtonStyle(token, token.colorPrimaryBg, {
        color: token.colorPrimary,
        background: token.colorPrimaryBgHover
    }, {
        color: token.colorPrimary,
        background: token.colorPrimaryBorder
    })), $eb1cf391543b1933$var$genTextLinkButtonStyle(token, token.colorPrimaryText, 'text', {
        color: token.colorPrimaryTextHover,
        background: token.colorPrimaryBg
    }, {
        color: token.colorPrimaryTextActive,
        background: token.colorPrimaryBorder
    })), $eb1cf391543b1933$var$genTextLinkButtonStyle(token, token.colorPrimaryText, 'link', {
        color: token.colorPrimaryTextHover,
        background: token.linkHoverBg
    }, {
        color: token.colorPrimaryTextActive
    })), $eb1cf391543b1933$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorPrimary, token.colorPrimary, token.colorTextDisabled, token.colorBorder, {
        color: token.colorPrimaryHover,
        borderColor: token.colorPrimaryHover
    }, {
        color: token.colorPrimaryActive,
        borderColor: token.colorPrimaryActive
    }));
const $eb1cf391543b1933$var$genDangerousStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.colorError,
        boxShadow: token.dangerShadow
    }, $eb1cf391543b1933$var$genSolidButtonStyle(token, token.dangerColor, token.colorError, {
        background: token.colorErrorHover
    }, {
        background: token.colorErrorActive
    })), $eb1cf391543b1933$var$genOutlinedDashedButtonStyle(token, token.colorError, token.colorBgContainer, {
        color: token.colorErrorHover,
        borderColor: token.colorErrorBorderHover
    }, {
        color: token.colorErrorActive,
        borderColor: token.colorErrorActive
    })), $eb1cf391543b1933$var$genDashedButtonStyle(token)), $eb1cf391543b1933$var$genFilledButtonStyle(token, token.colorErrorBg, {
        color: token.colorError,
        background: token.colorErrorBgFilledHover
    }, {
        color: token.colorError,
        background: token.colorErrorBgActive
    })), $eb1cf391543b1933$var$genTextLinkButtonStyle(token, token.colorError, 'text', {
        color: token.colorErrorHover,
        background: token.colorErrorBg
    }, {
        color: token.colorErrorHover,
        background: token.colorErrorBgActive
    })), $eb1cf391543b1933$var$genTextLinkButtonStyle(token, token.colorError, 'link', {
        color: token.colorErrorHover
    }, {
        color: token.colorErrorActive
    })), $eb1cf391543b1933$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder, {
        color: token.colorErrorHover,
        borderColor: token.colorErrorHover
    }, {
        color: token.colorErrorActive,
        borderColor: token.colorErrorActive
    }));
const $eb1cf391543b1933$var$genLinkStyle = (token)=>Object.assign(Object.assign({}, $eb1cf391543b1933$var$genTextLinkButtonStyle(token, token.colorLink, 'link', {
        color: token.colorLinkHover
    }, {
        color: token.colorLinkActive
    })), $eb1cf391543b1933$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorInfo, token.colorInfo, token.colorTextDisabled, token.colorBorder, {
        color: token.colorInfoHover,
        borderColor: token.colorInfoHover
    }, {
        color: token.colorInfoActive,
        borderColor: token.colorInfoActive
    }));
const $eb1cf391543b1933$var$genColorButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return Object.assign({
        [`${componentCls}-color-default`]: $eb1cf391543b1933$var$genDefaultButtonStyle(token),
        [`${componentCls}-color-primary`]: $eb1cf391543b1933$var$genPrimaryButtonStyle(token),
        [`${componentCls}-color-dangerous`]: $eb1cf391543b1933$var$genDangerousStyle(token),
        [`${componentCls}-color-link`]: $eb1cf391543b1933$var$genLinkStyle(token)
    }, $eb1cf391543b1933$var$genPresetColorStyle(token));
};
// =========== Compatible with versions earlier than 5.21.0 ===========
const $eb1cf391543b1933$var$genCompatibleButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign({}, $eb1cf391543b1933$var$genOutlinedDashedButtonStyle(token, token.defaultBorderColor, token.defaultBg, {
        color: token.defaultHoverColor,
        borderColor: token.defaultHoverBorderColor,
        background: token.defaultHoverBg
    }, {
        color: token.defaultActiveColor,
        borderColor: token.defaultActiveBorderColor,
        background: token.defaultActiveBg
    })), $eb1cf391543b1933$var$genTextLinkButtonStyle(token, token.textTextColor, 'text', {
        color: token.textTextHoverColor,
        background: token.textHoverBg
    }, {
        color: token.textTextActiveColor,
        background: token.colorBgTextActive
    })), $eb1cf391543b1933$var$genSolidButtonStyle(token, token.primaryColor, token.colorPrimary, {
        background: token.colorPrimaryHover,
        color: token.primaryColor
    }, {
        background: token.colorPrimaryActive,
        color: token.primaryColor
    })), $eb1cf391543b1933$var$genTextLinkButtonStyle(token, token.colorLink, 'link', {
        color: token.colorLinkHover,
        background: token.linkHoverBg
    }, {
        color: token.colorLinkActive
    }));
// =============================== Size ===============================
const $eb1cf391543b1933$var$genButtonStyle = (token, prefixCls = '')=>{
    const { componentCls: componentCls, controlHeight: controlHeight, fontSize: fontSize, borderRadius: borderRadius, buttonPaddingHorizontal: buttonPaddingHorizontal, iconCls: iconCls, buttonPaddingVertical: buttonPaddingVertical, buttonIconOnlyFontSize: buttonIconOnlyFontSize } = token;
    return [
        {
            [prefixCls]: {
                fontSize: fontSize,
                height: controlHeight,
                padding: `${(0, $2c076defa05cd41b$export$523c0b569236b342)(buttonPaddingVertical)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(buttonPaddingHorizontal)}`,
                borderRadius: borderRadius,
                [`&${componentCls}-icon-only`]: {
                    width: controlHeight,
                    [iconCls]: {
                        fontSize: buttonIconOnlyFontSize
                    }
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${prefixCls}`]: $eb1cf391543b1933$var$genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${prefixCls}`]: {
                borderRadius: token.controlHeight,
                [`&:not(${componentCls}-icon-only)`]: {
                    paddingInline: token.buttonPaddingHorizontal
                }
            }
        }
    ];
};
const $eb1cf391543b1933$var$genSizeBaseButtonStyle = (token)=>{
    const baseToken = (0, $0dfcc8c9c107e242$export$4950aa0f605343fb)(token, {
        fontSize: token.contentFontSize
    });
    return $eb1cf391543b1933$var$genButtonStyle(baseToken, token.componentCls);
};
const $eb1cf391543b1933$var$genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, $0dfcc8c9c107e242$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $eb1cf391543b1933$var$genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const $eb1cf391543b1933$var$genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, $0dfcc8c9c107e242$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $eb1cf391543b1933$var$genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const $eb1cf391543b1933$var$genBlockButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: '100%'
            }
        }
    };
};
var // ============================== Export ==============================
$eb1cf391543b1933$export$2e2bcd8739ae039 = (0, $16d63ad40d593937$export$51ec95de45185b42)('Button', (token)=>{
    const buttonToken = (0, $ddfc411653db0f5d$export$362fb92a8f81bbf9)(token);
    return [
        // Shared
        $eb1cf391543b1933$var$genSharedButtonStyle(buttonToken),
        // Size
        $eb1cf391543b1933$var$genSizeBaseButtonStyle(buttonToken),
        $eb1cf391543b1933$var$genSizeSmallButtonStyle(buttonToken),
        $eb1cf391543b1933$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $eb1cf391543b1933$var$genBlockButtonStyle(buttonToken),
        // Color
        $eb1cf391543b1933$var$genColorButtonStyle(buttonToken),
        // https://github.com/ant-design/ant-design/issues/50969
        $eb1cf391543b1933$var$genCompatibleButtonStyle(buttonToken),
        // Button Group
        (0, $604627c373961b8f$export$2e2bcd8739ae039)(buttonToken)
    ];
}, (0, $ddfc411653db0f5d$export$9ca1be8807fe0675), {
    unitless: {
        fontWeight: true,
        contentLineHeight: true,
        contentLineHeightSM: true,
        contentLineHeightLG: true
    }
});


// handle border collapse
function $d2c902a9f91430cd$var$compactItemBorder(token, parentCls, options, prefixCls) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? '> *' : '';
    const hoverEffects = [
        'hover',
        focus ? 'focus' : null,
        'active'
    ].filter(Boolean).map((n)=>`&:${n} ${childCombinator}`).join(',');
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': Object.assign(Object.assign({
            [hoverEffects]: {
                zIndex: 3
            }
        }, focusElCls ? {
            [`&${focusElCls}`]: {
                zIndex: 3
            }
        } : {}), {
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        })
    };
}
// handle border-radius
function $d2c902a9f91430cd$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : '';
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $d2c902a9f91430cd$export$b1208b23589b4b73(token, options = {
    focus: true
}) {
    const { componentCls: componentCls } = token;
    const { componentCls: customizePrefixCls } = options;
    const mergedComponentCls = customizePrefixCls || componentCls;
    const compactCls = `${mergedComponentCls}-compact`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $d2c902a9f91430cd$var$compactItemBorder(token, compactCls, options, mergedComponentCls)), $d2c902a9f91430cd$var$compactItemBorderRadius(mergedComponentCls, compactCls, options))
    };
}


function $4971d3b06fc0558a$var$compactItemVerticalBorder(token, parentCls, prefixCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': {
            '&:hover,&:focus,&:active': {
                zIndex: 3
            },
            '&[disabled]': {
                zIndex: 0
            }
        }
    };
}
function $4971d3b06fc0558a$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function $4971d3b06fc0558a$export$4dc87cb8ebf78ac6(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $4971d3b06fc0558a$var$compactItemVerticalBorder(token, compactCls, token.componentCls)), $4971d3b06fc0558a$var$compactItemBorderVerticalRadius(token.componentCls, compactCls))
    };
}




const $17358ff6d962a94b$var$genButtonCompactStyle = (token)=>{
    const { componentCls: componentCls, colorPrimaryHover: colorPrimaryHover, lineWidth: lineWidth, calc: calc } = token;
    const insetOffset = calc(lineWidth).mul(-1).equal();
    const getCompactBorderStyle = (vertical)=>{
        const selector = `${componentCls}-compact${vertical ? '-vertical' : ''}-item${componentCls}-primary:not([disabled])`;
        return {
            [`${selector} + ${selector}::before`]: {
                position: 'absolute',
                top: vertical ? insetOffset : 0,
                insetInlineStart: vertical ? 0 : insetOffset,
                backgroundColor: colorPrimaryHover,
                content: '""',
                width: vertical ? '100%' : lineWidth,
                height: vertical ? lineWidth : '100%'
            }
        };
    };
    // Special styles for Primary Button
    return Object.assign(Object.assign({}, getCompactBorderStyle()), getCompactBorderStyle(true));
};
var // ============================== Export ==============================
$17358ff6d962a94b$export$2e2bcd8739ae039 = (0, $16d63ad40d593937$export$1537386bc155ea56)([
    'Button',
    'compact'
], (token)=>{
    const buttonToken = (0, $ddfc411653db0f5d$export$362fb92a8f81bbf9)(token);
    return [
        // Space Compact
        (0, $d2c902a9f91430cd$export$b1208b23589b4b73)(buttonToken),
        (0, $4971d3b06fc0558a$export$4dc87cb8ebf78ac6)(buttonToken),
        $17358ff6d962a94b$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $ddfc411653db0f5d$export$9ca1be8807fe0675));


"use client";
var $b9b473c26162a316$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $b9b473c26162a316$var$getLoadingConfig(loading) {
    if (typeof loading === 'object' && loading) {
        let delay = loading === null || loading === void 0 ? void 0 : loading.delay;
        delay = !Number.isNaN(delay) && typeof delay === 'number' ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const $b9b473c26162a316$var$ButtonTypeMap = {
    default: [
        'default',
        'outlined'
    ],
    primary: [
        'primary',
        'solid'
    ],
    dashed: [
        'default',
        'dashed'
    ],
    // `link` is not a real color but we should compatible with it
    link: [
        'link',
        'link'
    ],
    text: [
        'default',
        'text'
    ]
};
const $b9b473c26162a316$var$InternalCompoundedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).forwardRef((props, ref)=>{
    var _a, _b;
    const { loading: loading = false, prefixCls: customizePrefixCls, color: color, variant: variant, type: type, danger: danger = false, shape: customizeShape, size: customizeSize, styles: styles, disabled: customDisabled, className: className, rootClassName: rootClassName, children: children, icon: icon, iconPosition: iconPosition = 'start', ghost: ghost = false, block: block = false, htmlType: // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = 'button', classNames: customClassNames, style: customStyle = {}, autoInsertSpace: autoInsertSpace, autoFocus: autoFocus } = props, rest = $b9b473c26162a316$var$__rest(props, [
        "loading",
        "prefixCls",
        "color",
        "variant",
        "type",
        "danger",
        "shape",
        "size",
        "styles",
        "disabled",
        "className",
        "rootClassName",
        "children",
        "icon",
        "iconPosition",
        "ghost",
        "block",
        "htmlType",
        "classNames",
        "style",
        "autoInsertSpace",
        "autoFocus"
    ]);
    // https://github.com/ant-design/ant-design/issues/47605
    // Compatible with original `type` behavior
    const mergedType = type || 'default';
    const { button: button } = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const shape = customizeShape || (button === null || button === void 0 ? void 0 : button.shape) || 'default';
    const [mergedColor, mergedVariant] = (0, $eeyUA.useMemo)(()=>{
        // >>>>> Local
        // Color & Variant
        if (color && variant) return [
            color,
            variant
        ];
        // Sugar syntax
        if (type || danger) {
            const colorVariantPair = $b9b473c26162a316$var$ButtonTypeMap[mergedType] || [];
            if (danger) return [
                'danger',
                colorVariantPair[1]
            ];
            return colorVariantPair;
        }
        // >>> Context fallback
        if ((button === null || button === void 0 ? void 0 : button.color) && (button === null || button === void 0 ? void 0 : button.variant)) return [
            button.color,
            button.variant
        ];
        return [
            'default',
            'outlined'
        ];
    }, [
        color,
        variant,
        type,
        danger,
        button === null || button === void 0 ? void 0 : button.color,
        button === null || button === void 0 ? void 0 : button.variant,
        mergedType
    ]);
    const isDanger = mergedColor === 'danger';
    const mergedColorText = isDanger ? 'dangerous' : mergedColor;
    const { getPrefixCls: getPrefixCls, direction: direction, autoInsertSpace: contextAutoInsertSpace, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $0b79f8c0c8222aa8$export$46f4bd6436a25a31)('button');
    const mergedInsertSpace = (_a = autoInsertSpace !== null && autoInsertSpace !== void 0 ? autoInsertSpace : contextAutoInsertSpace) !== null && _a !== void 0 ? _a : true;
    const prefixCls = getPrefixCls('btn', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $eb1cf391543b1933$export$2e2bcd8739ae039)(prefixCls);
    const disabled = (0, $eeyUA.useContext)((0, $1dece405dee1b50b$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const groupSize = (0, $eeyUA.useContext)((0, $67bcb2b0d64ede53$export$ed0cc8bd1f617d6d));
    const loadingOrDelay = (0, $eeyUA.useMemo)(()=>$b9b473c26162a316$var$getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setLoading] = (0, $eeyUA.useState)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, $eeyUA.useState)(false);
    const buttonRef = (0, $eeyUA.useRef)(null);
    const mergedRef = (0, $54bedb74db46e87d$export$1d1c999670a1285d)(ref, buttonRef);
    const needInserted = (0, $eeyUA.Children).count(children) === 1 && !icon && !(0, $eed44a28a6b1b10c$export$b120bc11c0d9c214)(mergedVariant);
    // ========================= Mount ==========================
    // Record for mount status.
    // This will help to no to show the animation of loading on the first mount.
    const isMountRef = (0, $eeyUA.useRef)(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useEffect(()=>{
        isMountRef.current = false;
        return ()=>{
            isMountRef.current = true;
        };
    }, []);
    // ========================= Effect =========================
    // Loading. Should use `useLayoutEffect` to avoid low perf multiple click issue.
    // https://github.com/ant-design/ant-design/issues/51325
    (0, $a6cbf381af41096e$export$2e2bcd8739ae039)(()=>{
        let delayTimer = null;
        if (loadingOrDelay.delay > 0) delayTimer = setTimeout(()=>{
            delayTimer = null;
            setLoading(true);
        }, loadingOrDelay.delay);
        else setLoading(loadingOrDelay.loading);
        function cleanupTimer() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        return cleanupTimer;
    }, [
        loadingOrDelay.delay,
        loadingOrDelay.loading
    ]);
    // Two chinese characters check
    (0, $eeyUA.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef.current || !mergedInsertSpace) return;
        const buttonText = buttonRef.current.textContent || '';
        if (needInserted && (0, $eed44a28a6b1b10c$export$c5dca2bf412dea0d)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    });
    // Auto focus
    (0, $eeyUA.useEffect)(()=>{
        if (autoFocus && buttonRef.current) buttonRef.current.focus();
    }, []);
    // ========================= Events =========================
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useCallback((e)=>{
        var _a;
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        (_a = props.onClick) === null || _a === void 0 || _a.call(props, 'href' in props ? e : e);
    }, [
        props.onClick,
        innerLoading,
        mergedDisabled
    ]);
    // ========================== Size ==========================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $b246d7f7ea639ac8$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const sizeClassNameMap = {
        large: 'lg',
        small: 'sm',
        middle: undefined
    };
    const sizeFullName = (0, $5c741ce817a3a21f$export$2e2bcd8739ae039)((ctxSize)=>{
        var _a, _b;
        return (_b = (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : groupSize) !== null && _b !== void 0 ? _b : ctxSize;
    });
    const sizeCls = sizeFullName ? (_b = sizeClassNameMap[sizeFullName]) !== null && _b !== void 0 ? _b : '' : '';
    const iconType = innerLoading ? 'loading' : icon;
    const linkButtonRestProps = (0, $26e0f2bfdd13a109$export$2e2bcd8739ae039)(rest, [
        'navigate'
    ]);
    // ========================= Render =========================
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, hashId, cssVarCls, {
        [`${prefixCls}-${shape}`]: shape !== 'default' && shape,
        // Compatible with versions earlier than 5.21.0
        [`${prefixCls}-${mergedType}`]: mergedType,
        [`${prefixCls}-dangerous`]: danger,
        [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
        [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, $eed44a28a6b1b10c$export$b120bc11c0d9c214)(mergedVariant),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-icon-end`]: iconPosition === 'end'
    }, compactItemClassnames, className, rootClassName, contextClassName);
    const fullStyle = Object.assign(Object.assign({}, contextStyle), customStyle);
    const iconClasses = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, contextClassNames.icon);
    const iconStyle = Object.assign(Object.assign({}, (styles === null || styles === void 0 ? void 0 : styles.icon) || {}), contextStyles.icon || {});
    /**
   * Extract icon node
   * If there is a custom icon and not in loading state: show custom icon
   */ const iconWrapperElement = (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $1ba4c1fd069f8c0f$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            className: iconClasses,
            style: iconStyle
        }, child);
    const defaultLoadingIconElement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $6b18331f8890bcb5$export$2e2bcd8739ae039), {
            existIcon: !!icon,
            prefixCls: prefixCls,
            loading: innerLoading,
            mount: isMountRef.current
        });
    /**
   * Using if-else statements can improve code readability without affecting future expansion.
   */ let iconNode;
    if (icon && !innerLoading) iconNode = iconWrapperElement(icon);
    else if (loading && typeof loading === 'object' && loading.icon) iconNode = iconWrapperElement(loading.icon);
    else iconNode = defaultLoadingIconElement();
    const kids = children || children === 0 ? (0, $eed44a28a6b1b10c$export$b6ee00a7e7908bc)(children, needInserted && mergedInsertSpace) : null;
    if (linkButtonRestProps.href !== undefined) return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("a", Object.assign({}, linkButtonRestProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: mergedRef,
        tabIndex: mergedDisabled ? -1 : 0,
        "aria-disabled": mergedDisabled
    }), iconNode, kids));
    let buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("button", Object.assign({}, rest, {
        type: htmlType,
        className: classes,
        style: fullStyle,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: mergedRef
    }), iconNode, kids, compactItemClassnames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $17358ff6d962a94b$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
    if (!(0, $eed44a28a6b1b10c$export$b120bc11c0d9c214)(mergedVariant)) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $cb3c6c31c4444a0a$export$2e2bcd8739ae039), {
        component: "Button",
        disabled: innerLoading
    }, buttonNode);
    return wrapCSSVar(buttonNode);
});
const $b9b473c26162a316$var$Button = $b9b473c26162a316$var$InternalCompoundedButton;
$b9b473c26162a316$var$Button.Group = (0, $67bcb2b0d64ede53$export$2e2bcd8739ae039);
$b9b473c26162a316$var$Button.__ANT_BUTTON = true;
var $b9b473c26162a316$export$2e2bcd8739ae039 = $b9b473c26162a316$var$Button;



"use client";
var $9c54331fbf1bdfe2$export$2e2bcd8739ae039 = (0, $b9b473c26162a316$export$2e2bcd8739ae039);



"use client";
const $ca4a8370e0a22d16$var$isThenable = (thing)=>{
    return typeof (thing === null || thing === void 0 ? void 0 : thing.then) === 'function';
};
const $ca4a8370e0a22d16$var$ActionButton = (props)=>{
    const { type: type, children: children, prefixCls: prefixCls, buttonProps: buttonProps, close: close, autoFocus: autoFocus, emitEvent: emitEvent, isSilent: isSilent, quitOnNullishReturnValue: quitOnNullishReturnValue, actionFn: actionFn } = props;
    const clickedRef = $eeyUA.useRef(false);
    const buttonRef = $eeyUA.useRef(null);
    const [loading, setLoading] = (0, $7302d87e3dd17afc$export$2e2bcd8739ae039)(false);
    const onInternalClose = (...args)=>{
        close === null || close === void 0 || close.apply(void 0, args);
    };
    $eeyUA.useEffect(()=>{
        let timeoutId = null;
        if (autoFocus) timeoutId = setTimeout(()=>{
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 || _a.focus({
                preventScroll: true
            });
        });
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        autoFocus
    ]);
    const handlePromiseOnOk = (returnValueOfOnOk)=>{
        if (!$ca4a8370e0a22d16$var$isThenable(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then((...args)=>{
            setLoading(false, true);
            onInternalClose.apply(void 0, args);
            clickedRef.current = false;
        }, (e)=>{
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent === null || isSilent === void 0 ? void 0 : isSilent()) return;
            return Promise.reject(e);
        });
    };
    const onClick = (e)=>{
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        let returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !$ca4a8370e0a22d16$var$isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!$ca4a8370e0a22d16$var$isThenable(returnValueOfOnOk)) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return /*#__PURE__*/ $eeyUA.createElement((0, $9c54331fbf1bdfe2$export$2e2bcd8739ae039), Object.assign({}, (0, $eed44a28a6b1b10c$export$19bc9a290855952)(type), {
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls
    }, buttonProps, {
        ref: buttonRef
    }), children);
};
var $ca4a8370e0a22d16$export$2e2bcd8739ae039 = $ca4a8370e0a22d16$var$ActionButton;



var $eeyUA = parcelRequire("eeyUA");
const $a1cd72ffec1dc6d7$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createContext({});
const { Provider: $a1cd72ffec1dc6d7$export$7c9538f5f3c365e9 } = $a1cd72ffec1dc6d7$export$ab57792b9b6974a6;


"use client";
const $a54c63ab3eac8979$var$ConfirmCancelBtn = ()=>{
    const { autoFocusButton: autoFocusButton, cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, isSilent: isSilent, mergedOkCancel: mergedOkCancel, rootPrefixCls: rootPrefixCls, close: close, onCancel: onCancel, onConfirm: onConfirm } = (0, $eeyUA.useContext)((0, $a1cd72ffec1dc6d7$export$ab57792b9b6974a6));
    return mergedOkCancel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $ca4a8370e0a22d16$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        actionFn: onCancel,
        close: (...args)=>{
            close === null || close === void 0 || close.apply(void 0, args);
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        autoFocus: autoFocusButton === 'cancel',
        buttonProps: cancelButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, cancelTextLocale) : null;
};
var $a54c63ab3eac8979$export$2e2bcd8739ae039 = $a54c63ab3eac8979$var$ConfirmCancelBtn;



var $eeyUA = parcelRequire("eeyUA");


"use client";
const $e222f17e4922fd62$var$ConfirmOkBtn = ()=>{
    const { autoFocusButton: autoFocusButton, close: close, isSilent: isSilent, okButtonProps: okButtonProps, rootPrefixCls: rootPrefixCls, okTextLocale: okTextLocale, okType: okType, onConfirm: onConfirm, onOk: onOk } = (0, $eeyUA.useContext)((0, $a1cd72ffec1dc6d7$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $ca4a8370e0a22d16$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        type: okType || 'primary',
        actionFn: onOk,
        close: (...args)=>{
            close === null || close === void 0 || close.apply(void 0, args);
            onConfirm === null || onConfirm === void 0 || onConfirm(true);
        },
        autoFocus: autoFocusButton === 'ok',
        buttonProps: okButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, okTextLocale);
};
var $e222f17e4922fd62$export$2e2bcd8739ae039 = $e222f17e4922fd62$var$ConfirmOkBtn;




var $eeyUA = parcelRequire("eeyUA");

var $7Nobb = parcelRequire("7Nobb");

var $eeyUA = parcelRequire("eeyUA");
// This icon file is generated automatically.
var $39b763163bd33783$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $39b763163bd33783$export$2e2bcd8739ae039 = $39b763163bd33783$var$CloseOutlined;



var $e2f667acd0c5267b$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $eeyUA.createElement((0, $4ca0d5594d977ef2$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        ref: ref,
        icon: (0, $39b763163bd33783$export$2e2bcd8739ae039)
    }));
};
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ var $e2f667acd0c5267b$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($e2f667acd0c5267b$var$CloseOutlined);
var $e2f667acd0c5267b$export$2e2bcd8739ae039 = $e2f667acd0c5267b$var$RefIcon;




var $7Nobb = parcelRequire("7Nobb");



var $eeyUA = parcelRequire("eeyUA");





var $eeyUA = parcelRequire("eeyUA");
var $ec8f93c5780bd7f2$var$OrderContext = /*#__PURE__*/ $eeyUA.createContext(null);
var $ec8f93c5780bd7f2$export$2e2bcd8739ae039 = $ec8f93c5780bd7f2$var$OrderContext;





var $eeyUA = parcelRequire("eeyUA");



var $84be728b30fbf368$var$EMPTY_LIST = [];
function $84be728b30fbf368$export$2e2bcd8739ae039(render, debug) {
    var _React$useState = $eeyUA.useState(function() {
        if (!(0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)()) return null;
        var defaultEle = document.createElement('div');
        return defaultEle;
    }), _React$useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState, 1), ele = _React$useState2[0];
    // ========================== Order ==========================
    var appendedRef = $eeyUA.useRef(false);
    var queueCreate = $eeyUA.useContext((0, $ec8f93c5780bd7f2$export$2e2bcd8739ae039));
    var _React$useState3 = $eeyUA.useState($84be728b30fbf368$var$EMPTY_LIST), _React$useState4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
    var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function(appendFn) {
        setQueue(function(origin) {
            var newQueue = [
                appendFn
            ].concat((0, $3440102357566473$export$2e2bcd8739ae039)(origin));
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        var _ele$parentElement;
        (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || _ele$parentElement.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $a6cbf381af41096e$export$2e2bcd8739ae039)(function() {
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $a6cbf381af41096e$export$2e2bcd8739ae039)(function() {
        if (queue.length) {
            queue.forEach(function(appendFn) {
                return appendFn();
            });
            setQueue($84be728b30fbf368$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}




var $eeyUA = parcelRequire("eeyUA");


/* eslint-disable no-param-reassign */ 
var $8625db7bfa8eaa5c$var$cached;
function $8625db7bfa8eaa5c$var$measureScrollbarSize(ele) {
    var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
    var measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    var measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    var fallbackWidth;
    var fallbackHeight;
    if (ele) {
        var targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        var webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        var width = parseInt(webkitScrollbarStyle.width, 10);
        var height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : '';
            var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : '';
            (0, $56d822aab7894329$export$4d99a2890bb989f0)("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $56d822aab7894329$export$2232e336aecaa80a)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $8625db7bfa8eaa5c$export$2e2bcd8739ae039(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || $8625db7bfa8eaa5c$var$cached === undefined) $8625db7bfa8eaa5c$var$cached = $8625db7bfa8eaa5c$var$measureScrollbarSize();
    return $8625db7bfa8eaa5c$var$cached.width;
}
function $8625db7bfa8eaa5c$export$4f3ef2310365b56a(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $8625db7bfa8eaa5c$var$measureScrollbarSize(target);
}


/**
 * Test usage export. Do not use in your production
 */ function $1d057cb3e851bef1$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


var $5a4e878944709eaf$var$UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var $5a4e878944709eaf$var$uuid = 0;
function $5a4e878944709eaf$export$2e2bcd8739ae039(lock) {
    var mergedLock = !!lock;
    var _React$useState = $eeyUA.useState(function() {
        $5a4e878944709eaf$var$uuid += 1;
        return "".concat($5a4e878944709eaf$var$UNIQUE_ID, "_").concat($5a4e878944709eaf$var$uuid);
    }), _React$useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState, 1), id = _React$useState2[0];
    (0, $a6cbf381af41096e$export$2e2bcd8739ae039)(function() {
        if (mergedLock) {
            var scrollbarSize = (0, $8625db7bfa8eaa5c$export$4f3ef2310365b56a)(document.body).width;
            var isOverflow = (0, $1d057cb3e851bef1$export$31b5c8f1131a3a52)();
            (0, $56d822aab7894329$export$4d99a2890bb989f0)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : '', "\n}"), id);
        } else (0, $56d822aab7894329$export$2232e336aecaa80a)(id);
        return function() {
            (0, $56d822aab7894329$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}


var $59dba86b1bf45178$export$18c8ad048e32c7d5 = false;
function $59dba86b1bf45178$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === 'boolean') $59dba86b1bf45178$export$18c8ad048e32c7d5 = nextInline;
    return $59dba86b1bf45178$export$18c8ad048e32c7d5;
}


var $c03c36aa71e3d8c9$var$getPortalContainer = function getPortalContainer(getContainer) {
    if (getContainer === false) return false;
    if (!(0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)() || !getContainer) return null;
    if (typeof getContainer === 'string') return document.querySelector(getContainer);
    if (typeof getContainer === 'function') return getContainer();
    return getContainer;
};
var $c03c36aa71e3d8c9$var$Portal = /*#__PURE__*/ $eeyUA.forwardRef(function(props, ref) {
    var open = props.open, autoLock = props.autoLock, getContainer = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
    var _React$useState = $eeyUA.useState(open), _React$useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
    var mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $eeyUA.useEffect(function() {
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    var _React$useState3 = $eeyUA.useState(function() {
        return $c03c36aa71e3d8c9$var$getPortalContainer(getContainer);
    }), _React$useState4 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
    $eeyUA.useEffect(function() {
        var customizeContainer = $c03c36aa71e3d8c9$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
    });
    var _useDom = (0, $84be728b30fbf368$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug), _useDom2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
    var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;
    // ========================= Locker ==========================
    (0, $5a4e878944709eaf$export$2e2bcd8739ae039)(autoLock && open && (0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    var childRef = null;
    if (children && (0, $54bedb74db46e87d$export$c1cec34af06bcf7)(children) && ref) {
        var _ref = children;
        childRef = _ref.ref;
    }
    var mergedRef = (0, $54bedb74db46e87d$export$1d1c999670a1285d)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)() || innerContainer === undefined) return null;
    // Render inline
    var renderInline = mergedContainer === false || (0, $59dba86b1bf45178$export$121d9fd0ca615463)();
    var reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $eeyUA.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $eeyUA.createElement((0, $ec8f93c5780bd7f2$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $6568ab17ba5c963b$exports.createPortal)(reffedChildren, mergedContainer));
});
var $c03c36aa71e3d8c9$export$2e2bcd8739ae039 = $c03c36aa71e3d8c9$var$Portal;



var $c8fdfb4d9cbfc8fc$export$2e2bcd8739ae039 = (0, $c03c36aa71e3d8c9$export$2e2bcd8739ae039);



var $eeyUA = parcelRequire("eeyUA");

var $eeyUA = parcelRequire("eeyUA");
var $a6cfacf295792ecf$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $eeyUA.createContext({});



var $7Nobb = parcelRequire("7Nobb");







var $eeyUA = parcelRequire("eeyUA");
function $5f0a24e712fa207c$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, $eeyUA);
    return fullClone.useId;
}
var $5f0a24e712fa207c$var$uuid = 0;
function $5f0a24e712fa207c$export$2f0435a662835942() {}
var $5f0a24e712fa207c$var$useOriginId = $5f0a24e712fa207c$var$getUseId();
var $5f0a24e712fa207c$export$2e2bcd8739ae039 = $5f0a24e712fa207c$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $5f0a24e712fa207c$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $eeyUA.useState('ssr-id'), _React$useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $eeyUA.useEffect(function() {
        var nextId = $5f0a24e712fa207c$var$uuid;
        $5f0a24e712fa207c$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};





var $eeyUA = parcelRequire("eeyUA");
// =============================== Motion ===============================
function $bb94b7290e7f3433$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    var motionName = transitionName;
    if (!motionName && animationName) motionName = "".concat(prefixCls, "-").concat(animationName);
    return motionName;
}
// =============================== Offset ===============================
function $bb94b7290e7f3433$var$getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') ret = d.body[method];
    }
    return ret;
}
function $bb94b7290e7f3433$export$cc800923e997bb8(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $bb94b7290e7f3433$var$getScroll(w);
    pos.top += $bb94b7290e7f3433$var$getScroll(w, true);
    return pos;
}



var $7Nobb = parcelRequire("7Nobb");



var $eeyUA = parcelRequire("eeyUA");




var $7Nobb = parcelRequire("7Nobb");





var $eeyUA = parcelRequire("eeyUA");


var $eeyUA = parcelRequire("eeyUA");
var $adfcbf7c67e31444$export$2e2bcd8739ae039 = /*#__PURE__*/ $eeyUA.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, _ref2) {
    var shouldUpdate = _ref2.shouldUpdate;
    return !shouldUpdate;
});



var $15478a04d85e8e5c$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: 'hidden',
    outline: 'none'
};
var $15478a04d85e8e5c$var$entityStyle = {
    outline: 'none'
};
var $15478a04d85e8e5c$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, title = props.title, ariaId = props.ariaId, footer = props.footer, closable = props.closable, closeIcon = props.closeIcon, onClose = props.onClose, children = props.children, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, modalRender = props.modalRender, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, holderRef = props.holderRef, visible = props.visible, forceRender = props.forceRender, width = props.width, height = props.height, modalClassNames = props.classNames, modalStyles = props.styles;
    // ================================= Refs =================================
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useContext((0, $a6cfacf295792ecf$export$ee4e38b469b6f5d1)), panelRef = _React$useContext.panel;
    var mergedRef = (0, $54bedb74db46e87d$export$1d1c999670a1285d)(holderRef, panelRef);
    var sentinelStartRef = (0, $eeyUA.useRef)();
    var sentinelEndRef = (0, $eeyUA.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                var _sentinelStartRef$cur;
                (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
                    preventScroll: true
                });
            },
            changeActive: function changeActive(next) {
                var _document = document, activeElement = _document.activeElement;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus({
                    preventScroll: true
                });
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus({
                    preventScroll: true
                });
            }
        };
    });
    // ================================ Style =================================
    var contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    var footerNode = footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-footer"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.footer),
        style: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.footer)
    }, footer) : null;
    var headerNode = title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-header"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.header),
        style: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.header)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: "".concat(prefixCls, "-title"),
        id: ariaId
    }, title)) : null;
    var closableObj = (0, $eeyUA.useMemo)(function() {
        if ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(closable) === 'object' && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("span", {
                className: "".concat(prefixCls, "-close-x")
            })
        };
        return {};
    }, [
        closable,
        closeIcon,
        prefixCls
    ]);
    var ariaProps = (0, $2b6013c7a3c0e965$export$2e2bcd8739ae039)(closableObj, true);
    var closeBtnIsDisabled = (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(closable) === 'object' && closable.disabled;
    var closerNode = closable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("button", (0, $7Nobb.default)({
        type: "button",
        onClick: onClose,
        "aria-label": "Close"
    }, ariaProps, {
        className: "".concat(prefixCls, "-close"),
        disabled: closeBtnIsDisabled
    }), closableObj.closeIcon) : null;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-content"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.content),
        style: modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.content
    }, closerNode, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", (0, $7Nobb.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-body"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.body),
        style: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, bodyStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.body)
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: mergedRef,
        style: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, style), contentStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        ref: sentinelStartRef,
        tabIndex: 0,
        style: $15478a04d85e8e5c$var$entityStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $adfcbf7c67e31444$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $15478a04d85e8e5c$var$sentinelStyle
    }));
});
var $15478a04d85e8e5c$export$2e2bcd8739ae039 = $15478a04d85e8e5c$var$Panel;


var $d4a8fa723e995527$var$Content = /*#__PURE__*/ $eeyUA.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, title = props.title, style = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, destroyOnClose = props.destroyOnClose, motionName = props.motionName, ariaId = props.ariaId, onVisibleChanged = props.onVisibleChanged, mousePosition = props.mousePosition;
    var dialogRef = (0, $eeyUA.useRef)();
    // ============================= Style ==============================
    var _React$useState = $eeyUA.useState(), _React$useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
    var contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        var elementOffset = (0, $bb94b7290e7f3433$export$cc800923e997bb8)(dialogRef.current);
        setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : '');
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $eeyUA.createElement((0, $31ad051c24fca029$export$2e2bcd8739ae039), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnClose,
        ref: dialogRef
    }, function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $eeyUA.createElement((0, $15478a04d85e8e5c$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
            ref: ref,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, motionStyle), style), contentStyle),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(className, motionClassName)
        }));
    });
});
$d4a8fa723e995527$var$Content.displayName = 'Content';
var $d4a8fa723e995527$export$2e2bcd8739ae039 = $d4a8fa723e995527$var$Content;



var $7Nobb = parcelRequire("7Nobb");


var $eeyUA = parcelRequire("eeyUA");


var $e89ab55aabf30667$var$Mask = function Mask(props) {
    var prefixCls = props.prefixCls, style = props.style, visible = props.visible, maskProps = props.maskProps, motionName = props.motionName, className = props.className;
    return /*#__PURE__*/ $eeyUA.createElement((0, $31ad051c24fca029$export$2e2bcd8739ae039), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: "".concat(prefixCls, "-mask-hidden")
    }, function(_ref, ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $eeyUA.createElement("div", (0, $7Nobb.default)({
            ref: ref,
            style: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, motionStyle), style),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-mask"), motionClassName, className)
        }, maskProps));
    });
};
var $e89ab55aabf30667$export$2e2bcd8739ae039 = $e89ab55aabf30667$var$Mask;



var $997a31eed20a95f5$var$Dialog = function Dialog(props) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-dialog' : _props$prefixCls, zIndex = props.zIndex, _props$visible = props.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, wrapStyle = props.wrapStyle, wrapClassName = props.wrapClassName, wrapProps = props.wrapProps, onClose = props.onClose, afterOpenChange = props.afterOpenChange, afterClose = props.afterClose, transitionName = props.transitionName, animation = props.animation, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props.maskStyle, maskProps = props.maskProps, rootClassName = props.rootClassName, modalClassNames = props.classNames, modalStyles = props.styles;
    var lastOutSideActiveElementRef = (0, $eeyUA.useRef)();
    var wrapperRef = (0, $eeyUA.useRef)();
    var contentRef = (0, $eeyUA.useRef)();
    var _React$useState = $eeyUA.useState(visible), _React$useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    // ========================== Init ==========================
    var ariaId = (0, $5f0a24e712fa207c$export$2e2bcd8739ae039)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $9aac4e6cc0b0cad1$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $9aac4e6cc0b0cad1$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) {
            var _contentRef$current;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
        }
    }
    // ========================= Events =========================
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else {
            // Clean up scroll bar & focus back
            setAnimatedVisible(false);
            if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
                try {
                    lastOutSideActiveElementRef.current.focus({
                        preventScroll: true
                    });
                } catch (e) {
                // Do nothing
                }
                lastOutSideActiveElementRef.current = null;
            }
            // Trigger afterClose only when change visible from true to false
            if (animatedVisible) afterClose === null || afterClose === void 0 || afterClose();
        }
        afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(newVisible);
    }
    function onInternalClose(e) {
        onClose === null || onClose === void 0 || onClose(e);
    }
    // >>> Content
    var contentClickRef = (0, $eeyUA.useRef)(false);
    var contentTimeoutRef = (0, $eeyUA.useRef)();
    // We need record content click incase content popup out of dialog
    var onContentMouseDown = function onContentMouseDown() {
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    var onContentMouseUp = function onContentMouseUp() {
        contentTimeoutRef.current = setTimeout(function() {
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    var onWrapperClick = null;
    if (maskClosable) onWrapperClick = function onWrapperClick(e) {
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, $6d43cdfee1c37e0d$export$2e2bcd8739ae039).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible && e.keyCode === (0, $6d43cdfee1c37e0d$export$2e2bcd8739ae039).TAB) contentRef.current.changeActive(!e.shiftKey);
    }
    // ========================= Effect =========================
    (0, $eeyUA.useEffect)(function() {
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        }
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, $eeyUA.useEffect)(function() {
        return function() {
            clearTimeout(contentTimeoutRef.current);
        };
    }, []);
    var mergedStyle = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
        zIndex: zIndex
    }, wrapStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapper), {}, {
        display: !animatedVisible ? 'none' : null
    });
    // ========================= Render =========================
    return /*#__PURE__*/ $eeyUA.createElement("div", (0, $7Nobb.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-root"), rootClassName)
    }, (0, $2b6013c7a3c0e965$export$2e2bcd8739ae039)(props, {
        data: true
    })), /*#__PURE__*/ $eeyUA.createElement((0, $e89ab55aabf30667$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $bb94b7290e7f3433$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
            zIndex: zIndex
        }, maskStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.mask),
        maskProps: maskProps,
        className: modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.mask
    }), /*#__PURE__*/ $eeyUA.createElement("div", (0, $7Nobb.default)({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))("".concat(prefixCls, "-wrap"), wrapClassName, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: mergedStyle
    }, wrapProps), /*#__PURE__*/ $eeyUA.createElement((0, $d4a8fa723e995527$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $bb94b7290e7f3433$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
};
var $997a31eed20a95f5$export$2e2bcd8739ae039 = $997a31eed20a95f5$var$Dialog;


// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ var $6ce45b1d4c35f29a$var$DialogWrap = function DialogWrap(props) {
    var visible = props.visible, getContainer = props.getContainer, forceRender = props.forceRender, _props$destroyOnClose = props.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props.afterClose, panelRef = props.panelRef;
    var _React$useState = $eeyUA.useState(visible), _React$useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    var refContext = $eeyUA.useMemo(function() {
        return {
            panel: panelRef
        };
    }, [
        panelRef
    ]);
    $eeyUA.useEffect(function() {
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnClose && !animatedVisible) return null;
    return /*#__PURE__*/ $eeyUA.createElement((0, $a6cfacf295792ecf$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $eeyUA.createElement((0, $c8fdfb4d9cbfc8fc$export$2e2bcd8739ae039), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ $eeyUA.createElement((0, $997a31eed20a95f5$export$2e2bcd8739ae039), (0, $7Nobb.default)({}, props, {
        destroyOnClose: destroyOnClose,
        afterClose: function afterClose() {
            _afterClose === null || _afterClose === void 0 || _afterClose();
            setAnimatedVisible(false);
        }
    }))));
};
$6ce45b1d4c35f29a$var$DialogWrap.displayName = 'Dialog';
var $6ce45b1d4c35f29a$export$2e2bcd8739ae039 = $6ce45b1d4c35f29a$var$DialogWrap;



var $9f9c254f72248144$export$2e2bcd8739ae039 = (0, $6ce45b1d4c35f29a$export$2e2bcd8739ae039);




var $eeyUA = parcelRequire("eeyUA");

var $eeyUA = parcelRequire("eeyUA");

var $eeyUA = parcelRequire("eeyUA");

var $7Nobb = parcelRequire("7Nobb");















var $eeyUA = parcelRequire("eeyUA");


var $eeyUA = parcelRequire("eeyUA");
var $176a86e7f5cc56f5$export$24829b7c0e49e9f7 = 'RC_FORM_INTERNAL_HOOKS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $176a86e7f5cc56f5$var$warningFunc = function warningFunc() {
    (0, $f29d0996356f1173$export$2e2bcd8739ae039)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
var $176a86e7f5cc56f5$var$Context = /*#__PURE__*/ $eeyUA.createContext({
    getFieldValue: $176a86e7f5cc56f5$var$warningFunc,
    getFieldsValue: $176a86e7f5cc56f5$var$warningFunc,
    getFieldError: $176a86e7f5cc56f5$var$warningFunc,
    getFieldWarning: $176a86e7f5cc56f5$var$warningFunc,
    getFieldsError: $176a86e7f5cc56f5$var$warningFunc,
    isFieldsTouched: $176a86e7f5cc56f5$var$warningFunc,
    isFieldTouched: $176a86e7f5cc56f5$var$warningFunc,
    isFieldValidating: $176a86e7f5cc56f5$var$warningFunc,
    isFieldsValidating: $176a86e7f5cc56f5$var$warningFunc,
    resetFields: $176a86e7f5cc56f5$var$warningFunc,
    setFields: $176a86e7f5cc56f5$var$warningFunc,
    setFieldValue: $176a86e7f5cc56f5$var$warningFunc,
    setFieldsValue: $176a86e7f5cc56f5$var$warningFunc,
    validateFields: $176a86e7f5cc56f5$var$warningFunc,
    submit: $176a86e7f5cc56f5$var$warningFunc,
    getInternalHooks: function getInternalHooks() {
        $176a86e7f5cc56f5$var$warningFunc();
        return {
            dispatch: $176a86e7f5cc56f5$var$warningFunc,
            initEntityValue: $176a86e7f5cc56f5$var$warningFunc,
            registerField: $176a86e7f5cc56f5$var$warningFunc,
            useSubscribe: $176a86e7f5cc56f5$var$warningFunc,
            setInitialValues: $176a86e7f5cc56f5$var$warningFunc,
            destroyForm: $176a86e7f5cc56f5$var$warningFunc,
            setCallbacks: $176a86e7f5cc56f5$var$warningFunc,
            registerWatch: $176a86e7f5cc56f5$var$warningFunc,
            getFields: $176a86e7f5cc56f5$var$warningFunc,
            setValidateMessages: $176a86e7f5cc56f5$var$warningFunc,
            setPreserve: $176a86e7f5cc56f5$var$warningFunc,
            getInitialValue: $176a86e7f5cc56f5$var$warningFunc
        };
    }
});
var $176a86e7f5cc56f5$export$2e2bcd8739ae039 = $176a86e7f5cc56f5$var$Context;



var $eeyUA = parcelRequire("eeyUA");
var $21aa92066fb7255e$var$ListContext = /*#__PURE__*/ $eeyUA.createContext(null);
var $21aa92066fb7255e$export$2e2bcd8739ae039 = $21aa92066fb7255e$var$ListContext;


function $0ac46302870a674a$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $0ac46302870a674a$export$717b316e73068e8d(form) {
    return form && !!form._init;
}













function $8a59a3ad227ca33a$export$f77fd0c3b25d8534() {
    return {
        default: 'Validation error on field %s',
        required: '%s is required',
        enum: '%s must be one of %s',
        whitespace: '%s cannot be empty',
        date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
        },
        types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            boolean: '%s is not a %s',
            integer: '%s is not an %s',
            float: '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            tel: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
        },
        string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
        },
        number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
        },
        array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
        },
        pattern: {
            mismatch: '%s value %s does not match pattern %s'
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $8a59a3ad227ca33a$export$defe85febe8b728c = $8a59a3ad227ca33a$export$f77fd0c3b25d8534();











function $f167335a217b4a28$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}




function $38d783c1c68562f1$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $e6710e827d4afd27$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $f165bc1d5e47b973$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $23b85aadd92c8fd4$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $23b85aadd92c8fd4$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $f167335a217b4a28$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $38d783c1c68562f1$export$2e2bcd8739ae039)(t, arguments, (0, $e20481fbceebf07e$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $f165bc1d5e47b973$export$2e2bcd8739ae039)(Wrapper, t);
    }, $23b85aadd92c8fd4$export$2e2bcd8739ae039(t);
}




/* eslint no-console:0 */ var $57f00528ffbcbb9d$var$formatRegExp = /%[sdj%]/g;
var $57f00528ffbcbb9d$export$491112666e282270 = function warning() {};
function $57f00528ffbcbb9d$export$e85887f5ceeacced(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $57f00528ffbcbb9d$export$d9468344d3651243(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === 'function') // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
    if (typeof template === 'string') {
        var str = template.replace($57f00528ffbcbb9d$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $57f00528ffbcbb9d$var$isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern' || type === 'tel';
}
function $57f00528ffbcbb9d$export$141eca273a04dc3e(value, type) {
    if (value === undefined || value === null) return true;
    if (type === 'array' && Array.isArray(value) && !value.length) return true;
    if ($57f00528ffbcbb9d$var$isNativeStringType(type) && typeof value === 'string' && !value) return true;
    return false;
}
function $57f00528ffbcbb9d$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $57f00528ffbcbb9d$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, (0, $3440102357566473$export$2e2bcd8739ae039)(errors || []));
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $57f00528ffbcbb9d$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $57f00528ffbcbb9d$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, (0, $3440102357566473$export$2e2bcd8739ae039)(objArr[k] || []));
    });
    return ret;
}
var $57f00528ffbcbb9d$export$188f48b73534b6f0 = /*#__PURE__*/ function(_Error) {
    (0, $6a4c2bdb64108a28$export$2e2bcd8739ae039)(AsyncValidationError, _Error);
    var _super = (0, $7104bbef2c357751$export$2e2bcd8739ae039)(AsyncValidationError);
    function AsyncValidationError(errors, fields) {
        var _this;
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, AsyncValidationError);
        _this = _super.call(this, 'Async Validation Error');
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "errors", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "fields", void 0);
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return (0, $055f1aac98d71283$export$2e2bcd8739ae039)(AsyncValidationError);
}(/*#__PURE__*/ (0, $23b85aadd92c8fd4$export$2e2bcd8739ae039)(Error));
function $57f00528ffbcbb9d$export$707ee4c4c95d39e3(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $57f00528ffbcbb9d$export$188f48b73534b6f0(errors, $57f00528ffbcbb9d$export$e85887f5ceeacced(errors))) : resolve(source);
            };
            var flattenArr = $57f00528ffbcbb9d$var$flattenObjArr(objArr);
            $57f00528ffbcbb9d$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending.catch(function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            // eslint-disable-next-line prefer-spread
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $57f00528ffbcbb9d$export$188f48b73534b6f0(results, $57f00528ffbcbb9d$export$e85887f5ceeacced(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $57f00528ffbcbb9d$var$asyncSerialArray(arr, func, next);
            else $57f00528ffbcbb9d$var$asyncParallelArray(arr, func, next);
        });
    });
    pending.catch(function(e) {
        return e;
    });
    return pending;
}
function $57f00528ffbcbb9d$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $57f00528ffbcbb9d$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $57f00528ffbcbb9d$export$34d5fe50d2616cee(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $57f00528ffbcbb9d$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($57f00528ffbcbb9d$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === 'function' ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $57f00528ffbcbb9d$export$6969335ea1e4e77c(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(value) === 'object' && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(target[s]) === 'object') target[s] = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, target[s]), value);
            else target[s] = value;
        }
    }
    return target;
}



var $1f421581c22416c1$var$ENUM = 'enum';
var $1f421581c22416c1$var$enumerable = function enumerable(rule, value, source, errors, options) {
    rule[$1f421581c22416c1$var$ENUM] = Array.isArray(rule[$1f421581c22416c1$var$ENUM]) ? rule[$1f421581c22416c1$var$ENUM] : [];
    if (rule[$1f421581c22416c1$var$ENUM].indexOf(value) === -1) errors.push((0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages[$1f421581c22416c1$var$ENUM], rule.fullField, rule[$1f421581c22416c1$var$ENUM].join(', ')));
};
var $1f421581c22416c1$export$2e2bcd8739ae039 = $1f421581c22416c1$var$enumerable;



var $73db8946fbfe46eb$var$pattern = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push((0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === 'string') {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push((0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $73db8946fbfe46eb$export$2e2bcd8739ae039 = $73db8946fbfe46eb$var$pattern;



var $12c75923b3dfddef$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === 'number';
    var min = typeof rule.min === 'number';
    var max = typeof rule.max === 'number';
    // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === 'number';
    var str = typeof value === 'string';
    var arr = Array.isArray(value);
    if (num) key = 'number';
    else if (str) key = 'string';
    else if (arr) key = 'array';
    // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, '_').length;
    if (len) {
        if (val !== rule.len) errors.push((0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push((0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push((0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push((0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $12c75923b3dfddef$export$2e2bcd8739ae039 = $12c75923b3dfddef$var$range;



var $7dd0d38dc9489dab$var$required = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || (0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value, type || rule.type))) errors.push((0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages.required, rule.fullField));
};
var $7dd0d38dc9489dab$export$2e2bcd8739ae039 = $7dd0d38dc9489dab$var$required;





// https://github.com/kevva/url-regex/blob/master/index.js
var $e89cf75323f14871$var$urlReg;
var $e89cf75323f14871$export$2e2bcd8739ae039 = function() {
    if ($e89cf75323f14871$var$urlReg) return $e89cf75323f14871$var$urlReg;
    var word = '[a-fA-F\\d:]';
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : '';
    };
    var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
    var v6seg = '[a-fA-F\\d]{1,4}';
    var v6List = [
        "(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
        "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
        "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
        "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
        "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
        "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))") // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
    ];
    var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?"; // %eth0            %1
    var v6 = "(?:".concat(v6List.join('|'), ")").concat(v6Eth0);
    // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
    var v4exact = new RegExp("^".concat(v4, "$"));
    var v6exact = new RegExp("^".concat(v6, "$"));
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), 'g');
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), 'g');
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), 'g');
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = '(?:\\S+(?::\\S*)?@)?';
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = '(?::\\d{2,5})?';
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:".concat(protocol, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain).concat(tld, ")").concat(port).concat(path);
    $e89cf75323f14871$var$urlReg = new RegExp("(?:^".concat(regex, "$)"), 'i');
    return $e89cf75323f14871$var$urlReg;
};


/* eslint max-len:0 */ var $8e34dd03954f39e9$var$pattern = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    /**
   * Phone number regex, support country code, brackets, spaces, and dashes (or non-breaking hyphen \u2011).
   * @see https://regexr.com/3c53v
   * @see https://ihateregex.io/expr/phone/
   * @see https://developers.google.com/style/phone-numbers using non-breaking hyphen \u2011
   */ tel: /^(\+[0-9]{1,3}[-\s\u2011]?)?(\([0-9]{1,4}\)[-\s\u2011]?)?([0-9]+[-\s\u2011]?)*[0-9]+$/,
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $8e34dd03954f39e9$var$types = {
    integer: function integer(value) {
        return $8e34dd03954f39e9$var$types.number(value) && parseInt(value, 10) === value;
    },
    float: function float(value) {
        return $8e34dd03954f39e9$var$types.number(value) && !$8e34dd03954f39e9$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === 'number';
    },
    object: function object(value) {
        return (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(value) === 'object' && !$8e34dd03954f39e9$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === 'function';
    },
    email: function email(value) {
        return typeof value === 'string' && value.length <= 320 && !!value.match($8e34dd03954f39e9$var$pattern.email);
    },
    tel: function tel(value) {
        return typeof value === 'string' && value.length <= 32 && !!value.match($8e34dd03954f39e9$var$pattern.tel);
    },
    url: function url(value) {
        return typeof value === 'string' && value.length <= 2048 && !!value.match((0, $e89cf75323f14871$export$2e2bcd8739ae039)());
    },
    hex: function hex(value) {
        return typeof value === 'string' && !!value.match($8e34dd03954f39e9$var$pattern.hex);
    }
};
var $8e34dd03954f39e9$var$type = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        (0, $7dd0d38dc9489dab$export$2e2bcd8739ae039)(rule, value, source, errors, options);
        return;
    }
    var custom = [
        'integer',
        'float',
        'array',
        'regexp',
        'object',
        'method',
        'email',
        'tel',
        'number',
        'date',
        'url',
        'hex'
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$8e34dd03954f39e9$var$types[ruleType](value)) errors.push((0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
    } else if (ruleType && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(value) !== rule.type) errors.push((0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $8e34dd03954f39e9$export$2e2bcd8739ae039 = $8e34dd03954f39e9$var$type;



/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $a860829e5f60c4df$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === '') errors.push((0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages.whitespace, rule.fullField));
};
var $a860829e5f60c4df$export$2e2bcd8739ae039 = $a860829e5f60c4df$var$whitespace;


var $3702ea12d7c3271b$export$2e2bcd8739ae039 = {
    required: (0, $7dd0d38dc9489dab$export$2e2bcd8739ae039),
    whitespace: (0, $a860829e5f60c4df$export$2e2bcd8739ae039),
    type: (0, $8e34dd03954f39e9$export$2e2bcd8739ae039),
    range: (0, $12c75923b3dfddef$export$2e2bcd8739ae039),
    enum: (0, $1f421581c22416c1$export$2e2bcd8739ae039),
    pattern: (0, $73db8946fbfe46eb$export$2e2bcd8739ae039)
};



var $bcb122469eb4ed29$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $bcb122469eb4ed29$export$2e2bcd8739ae039 = $bcb122469eb4ed29$var$any;



var $7d36eaf586045d42$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'array');
        if (value !== undefined && value !== null) {
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $7d36eaf586045d42$export$2e2bcd8739ae039 = $7d36eaf586045d42$var$array;




var $7419ab7439a42a49$var$boolean = function boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $7419ab7439a42a49$export$2e2bcd8739ae039 = $7419ab7439a42a49$var$boolean;




var $ac9d3ef93ddd5125$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    // console.log('validate on %s value', value);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value, 'date') && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value, 'date')) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).type(rule, dateObject, source, errors, options);
            if (dateObject) (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $ac9d3ef93ddd5125$export$2e2bcd8739ae039 = $ac9d3ef93ddd5125$var$date;




var $36822b1a38a26cf6$var$ENUM = 'enum';
var $36822b1a38a26cf6$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $3702ea12d7c3271b$export$2e2bcd8739ae039)[$36822b1a38a26cf6$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $36822b1a38a26cf6$export$2e2bcd8739ae039 = $36822b1a38a26cf6$var$enumerable;




var $f9a3972b623e0044$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $f9a3972b623e0044$export$2e2bcd8739ae039 = $f9a3972b623e0044$var$floatFn;




var $33c461465e81b978$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $33c461465e81b978$export$2e2bcd8739ae039 = $33c461465e81b978$var$integer;




var $1f85bdb54991dbb6$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $1f85bdb54991dbb6$export$2e2bcd8739ae039 = $1f85bdb54991dbb6$var$method;




var $7845b54d10a3d54e$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === '') // eslint-disable-next-line no-param-reassign
        value = undefined;
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $7845b54d10a3d54e$export$2e2bcd8739ae039 = $7845b54d10a3d54e$var$number;




var $8606c9a982d4f00d$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $8606c9a982d4f00d$export$2e2bcd8739ae039 = $8606c9a982d4f00d$var$object;




var $88a98de1634fc31e$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value, 'string')) (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $88a98de1634fc31e$export$2e2bcd8739ae039 = $88a98de1634fc31e$var$pattern;




var $e773f96d8ec72a3a$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value)) (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $e773f96d8ec72a3a$export$2e2bcd8739ae039 = $e773f96d8ec72a3a$var$regexp;




var $8752bf2989fd723c$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? 'array' : (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(value);
    (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options, type);
    callback(errors);
};
var $8752bf2989fd723c$export$2e2bcd8739ae039 = $8752bf2989fd723c$var$required;




var $682e055d3ad3c943$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'string');
        if (!(0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value, 'string')) {
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
            (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $682e055d3ad3c943$export$2e2bcd8739ae039 = $682e055d3ad3c943$var$string;




var $4587d46a56e794ec$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value, ruleType) && !rule.required) return callback();
        (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).required(rule, value, source, errors, options, ruleType);
        if (!(0, $57f00528ffbcbb9d$export$141eca273a04dc3e)(value, ruleType)) (0, $3702ea12d7c3271b$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $4587d46a56e794ec$export$2e2bcd8739ae039 = $4587d46a56e794ec$var$type;


var $89305579bea3fa8c$export$2e2bcd8739ae039 = {
    string: (0, $682e055d3ad3c943$export$2e2bcd8739ae039),
    method: (0, $1f85bdb54991dbb6$export$2e2bcd8739ae039),
    number: (0, $7845b54d10a3d54e$export$2e2bcd8739ae039),
    boolean: (0, $7419ab7439a42a49$export$2e2bcd8739ae039),
    regexp: (0, $e773f96d8ec72a3a$export$2e2bcd8739ae039),
    integer: (0, $33c461465e81b978$export$2e2bcd8739ae039),
    float: (0, $f9a3972b623e0044$export$2e2bcd8739ae039),
    array: (0, $7d36eaf586045d42$export$2e2bcd8739ae039),
    object: (0, $8606c9a982d4f00d$export$2e2bcd8739ae039),
    enum: (0, $36822b1a38a26cf6$export$2e2bcd8739ae039),
    pattern: (0, $88a98de1634fc31e$export$2e2bcd8739ae039),
    date: (0, $ac9d3ef93ddd5125$export$2e2bcd8739ae039),
    url: (0, $4587d46a56e794ec$export$2e2bcd8739ae039),
    hex: (0, $4587d46a56e794ec$export$2e2bcd8739ae039),
    email: (0, $4587d46a56e794ec$export$2e2bcd8739ae039),
    tel: (0, $4587d46a56e794ec$export$2e2bcd8739ae039),
    required: (0, $8752bf2989fd723c$export$2e2bcd8739ae039),
    any: (0, $bcb122469eb4ed29$export$2e2bcd8739ae039)
};




/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $93d866b807eda78d$var$Schema = /*#__PURE__*/ function() {
    function Schema(descriptor) {
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, Schema);
        // ======================== Instance ========================
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "rules", null);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "_messages", (0, $8a59a3ad227ca33a$export$defe85febe8b728c));
        this.define(descriptor);
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(Schema, [
        {
            key: "define",
            value: function define(rules) {
                var _this = this;
                if (!rules) throw new Error('Cannot configure a schema with no rules');
                if ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(rules) !== 'object' || Array.isArray(rules)) throw new Error('Rules must be an object');
                this.rules = {};
                Object.keys(rules).forEach(function(name) {
                    var item = rules[name];
                    _this.rules[name] = Array.isArray(item) ? item : [
                        item
                    ];
                });
            }
        },
        {
            key: "messages",
            value: function messages(_messages) {
                if (_messages) this._messages = (0, $57f00528ffbcbb9d$export$6969335ea1e4e77c)((0, $8a59a3ad227ca33a$export$f77fd0c3b25d8534)(), _messages);
                return this._messages;
            }
        },
        {
            key: "validate",
            value: function validate(source_) {
                var _this2 = this;
                var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {};
                var source = source_;
                var options = o;
                var callback = oc;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!this.rules || Object.keys(this.rules).length === 0) {
                    if (callback) callback(null, source);
                    return Promise.resolve(source);
                }
                function complete(results) {
                    var errors = [];
                    var fields = {};
                    function add(e) {
                        if (Array.isArray(e)) {
                            var _errors;
                            errors = (_errors = errors).concat.apply(_errors, (0, $3440102357566473$export$2e2bcd8739ae039)(e));
                        } else errors.push(e);
                    }
                    for(var i = 0; i < results.length; i++)add(results[i]);
                    if (!errors.length) callback(null, source);
                    else {
                        fields = (0, $57f00528ffbcbb9d$export$e85887f5ceeacced)(errors);
                        callback(errors, fields);
                    }
                }
                if (options.messages) {
                    var messages = this.messages();
                    if (messages === (0, $8a59a3ad227ca33a$export$defe85febe8b728c)) messages = (0, $8a59a3ad227ca33a$export$f77fd0c3b25d8534)();
                    (0, $57f00528ffbcbb9d$export$6969335ea1e4e77c)(messages, options.messages);
                    options.messages = messages;
                } else options.messages = this.messages();
                var series = {};
                var keys = options.keys || Object.keys(this.rules);
                keys.forEach(function(z) {
                    var arr = _this2.rules[z];
                    var value = source[z];
                    arr.forEach(function(r) {
                        var rule = r;
                        if (typeof rule.transform === 'function') {
                            if (source === source_) source = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, source);
                            value = source[z] = rule.transform(value);
                            if (value !== undefined && value !== null) rule.type = rule.type || (Array.isArray(value) ? 'array' : (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(value));
                        }
                        if (typeof rule === 'function') rule = {
                            validator: rule
                        };
                        else rule = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, rule);
                        // Fill validator. Skip if nothing need to validate
                        rule.validator = _this2.getValidationMethod(rule);
                        if (!rule.validator) return;
                        rule.field = z;
                        rule.fullField = rule.fullField || z;
                        rule.type = _this2.getType(rule);
                        series[z] = series[z] || [];
                        series[z].push({
                            rule: rule,
                            value: value,
                            source: source,
                            field: z
                        });
                    });
                });
                var errorFields = {};
                return (0, $57f00528ffbcbb9d$export$707ee4c4c95d39e3)(series, options, function(data, doIt) {
                    var rule = data.rule;
                    var deep = (rule.type === 'object' || rule.type === 'array') && ((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(rule.fields) === 'object' || (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(rule.defaultField) === 'object');
                    deep = deep && (rule.required || !rule.required && data.value);
                    rule.field = data.field;
                    function addFullField(key, schema) {
                        return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, schema), {}, {
                            fullField: "".concat(rule.fullField, ".").concat(key),
                            fullFields: rule.fullFields ? [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(rule.fullFields), [
                                key
                            ]) : [
                                key
                            ]
                        });
                    }
                    function cb() {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var errorList = Array.isArray(e) ? e : [
                            e
                        ];
                        if (!options.suppressWarning && errorList.length) Schema.warning('async-validator:', errorList);
                        if (errorList.length && rule.message !== undefined && rule.message !== null) errorList = [].concat(rule.message);
                        // Fill error info
                        var filledErrors = errorList.map((0, $57f00528ffbcbb9d$export$34d5fe50d2616cee)(rule, source));
                        if (options.first && filledErrors.length) {
                            errorFields[rule.field] = 1;
                            return doIt(filledErrors);
                        }
                        if (!deep) doIt(filledErrors);
                        else {
                            // if rule is required but the target object
                            // does not exist fail at the rule level and don't
                            // go deeper
                            if (rule.required && !data.value) {
                                if (rule.message !== undefined) filledErrors = [].concat(rule.message).map((0, $57f00528ffbcbb9d$export$34d5fe50d2616cee)(rule, source));
                                else if (options.error) filledErrors = [
                                    options.error(rule, (0, $57f00528ffbcbb9d$export$d9468344d3651243)(options.messages.required, rule.field))
                                ];
                                return doIt(filledErrors);
                            }
                            var fieldsSchema = {};
                            if (rule.defaultField) Object.keys(data.value).map(function(key) {
                                fieldsSchema[key] = rule.defaultField;
                            });
                            fieldsSchema = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, fieldsSchema), data.rule.fields);
                            var paredFieldsSchema = {};
                            Object.keys(fieldsSchema).forEach(function(field) {
                                var fieldSchema = fieldsSchema[field];
                                var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                                    fieldSchema
                                ];
                                paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                            });
                            var schema = new Schema(paredFieldsSchema);
                            schema.messages(options.messages);
                            if (data.rule.options) {
                                data.rule.options.messages = options.messages;
                                data.rule.options.error = options.error;
                            }
                            schema.validate(data.value, data.rule.options || options, function(errs) {
                                var finalErrors = [];
                                if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, (0, $3440102357566473$export$2e2bcd8739ae039)(filledErrors));
                                if (errs && errs.length) finalErrors.push.apply(finalErrors, (0, $3440102357566473$export$2e2bcd8739ae039)(errs));
                                doIt(finalErrors.length ? finalErrors : null);
                            });
                        }
                    }
                    var res;
                    if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
                    else if (rule.validator) {
                        try {
                            res = rule.validator(rule, data.value, cb, data.source, options);
                        } catch (error) {
                            var _console$error, _console;
                            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error);
                            // rethrow to report error
                            if (!options.suppressValidatorError) setTimeout(function() {
                                throw error;
                            }, 0);
                            cb(error.message);
                        }
                        if (res === true) cb();
                        else if (res === false) cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
                        else if (res instanceof Array) cb(res);
                        else if (res instanceof Error) cb(res.message);
                    }
                    if (res && res.then) res.then(function() {
                        return cb();
                    }, function(e) {
                        return cb(e);
                    });
                }, function(results) {
                    complete(results);
                }, source);
            }
        },
        {
            key: "getType",
            value: function getType(rule) {
                if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = 'pattern';
                if (typeof rule.validator !== 'function' && rule.type && !(0, $89305579bea3fa8c$export$2e2bcd8739ae039).hasOwnProperty(rule.type)) throw new Error((0, $57f00528ffbcbb9d$export$d9468344d3651243)('Unknown rule type %s', rule.type));
                return rule.type || 'string';
            }
        },
        {
            key: "getValidationMethod",
            value: function getValidationMethod(rule) {
                if (typeof rule.validator === 'function') return rule.validator;
                var keys = Object.keys(rule);
                var messageIndex = keys.indexOf('message');
                if (messageIndex !== -1) keys.splice(messageIndex, 1);
                if (keys.length === 1 && keys[0] === 'required') return (0, $89305579bea3fa8c$export$2e2bcd8739ae039).required;
                return (0, $89305579bea3fa8c$export$2e2bcd8739ae039)[this.getType(rule)] || undefined;
            }
        }
    ]);
    return Schema;
}();
// ========================= Static =========================
(0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)($93d866b807eda78d$var$Schema, "register", function register(type, validator) {
    if (typeof validator !== 'function') throw new Error('Cannot register a validator by type, validator is not a function');
    (0, $89305579bea3fa8c$export$2e2bcd8739ae039)[type] = validator;
});
(0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)($93d866b807eda78d$var$Schema, "warning", (0, $57f00528ffbcbb9d$export$491112666e282270));
(0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)($93d866b807eda78d$var$Schema, "messages", (0, $8a59a3ad227ca33a$export$defe85febe8b728c));
(0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)($93d866b807eda78d$var$Schema, "validators", (0, $89305579bea3fa8c$export$2e2bcd8739ae039));
var $93d866b807eda78d$export$2e2bcd8739ae039 = $93d866b807eda78d$var$Schema;



var $eeyUA = parcelRequire("eeyUA");

var $e49d64a5cd2ea570$var$typeTemplate = "'${name}' is not a valid ${type}";
var $e49d64a5cd2ea570$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $e49d64a5cd2ea570$var$typeTemplate,
        method: $e49d64a5cd2ea570$var$typeTemplate,
        array: $e49d64a5cd2ea570$var$typeTemplate,
        object: $e49d64a5cd2ea570$var$typeTemplate,
        number: $e49d64a5cd2ea570$var$typeTemplate,
        date: $e49d64a5cd2ea570$var$typeTemplate,
        boolean: $e49d64a5cd2ea570$var$typeTemplate,
        integer: $e49d64a5cd2ea570$var$typeTemplate,
        float: $e49d64a5cd2ea570$var$typeTemplate,
        regexp: $e49d64a5cd2ea570$var$typeTemplate,
        email: $e49d64a5cd2ea570$var$typeTemplate,
        url: $e49d64a5cd2ea570$var$typeTemplate,
        hex: $e49d64a5cd2ea570$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};



// Remove incorrect original ts define
var $5f5d1a9286f59eae$var$AsyncValidator = (0, $93d866b807eda78d$export$2e2bcd8739ae039);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $5f5d1a9286f59eae$var$replaceMessage(template, kv) {
    return template.replace(/\\?\$\{\w+\}/g, function(str) {
        if (str.startsWith('\\')) return str.slice(1);
        var key = str.slice(2, -1);
        return kv[key];
    });
}
var $5f5d1a9286f59eae$var$CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
function $5f5d1a9286f59eae$var$validateRule(_x, _x2, _x3, _x4, _x5) {
    return $5f5d1a9286f59eae$var$_validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */ function $5f5d1a9286f59eae$var$_validateRule() {
    $5f5d1a9286f59eae$var$_validateRule = (0, $5fc0c4295ecffc5b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().mark(function _callee2(name, value, rule, options, messageVariables) {
        var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
        return (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    cloneRule = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, rule); // Bug of `async-validator`
                    // https://github.com/react-component/field-form/issues/316
                    // https://github.com/react-component/field-form/issues/313
                    delete cloneRule.ruleIndex;
                    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
                    $5f5d1a9286f59eae$var$AsyncValidator.warning = function() {
                        return void 0;
                    };
                    if (cloneRule.validator) {
                        originValidator = cloneRule.validator;
                        cloneRule.validator = function() {
                            try {
                                return originValidator.apply(void 0, arguments);
                            } catch (error) {
                                console.error(error);
                                return Promise.reject($5f5d1a9286f59eae$var$CODE_LOGIC_ERROR);
                            }
                        };
                    }
                    // We should special handle array validate
                    subRuleField = null;
                    if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
                        subRuleField = cloneRule.defaultField;
                        delete cloneRule.defaultField;
                    }
                    validator = new $5f5d1a9286f59eae$var$AsyncValidator((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, name, [
                        cloneRule
                    ]));
                    messages = (0, $b0ca387bd247d427$export$4950aa0f605343fb)((0, $e49d64a5cd2ea570$export$c86b939816b8fbf8), options.validateMessages);
                    validator.messages(messages);
                    result = [];
                    _context2.prev = 10;
                    _context2.next = 13;
                    return Promise.resolve(validator.validate((0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, name, value), (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, options)));
                case 13:
                    _context2.next = 18;
                    break;
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](10);
                    if (_context2.t0.errors) result = _context2.t0.errors.map(function(_ref4, index) {
                        var message = _ref4.message;
                        var mergedMessage = message === $5f5d1a9286f59eae$var$CODE_LOGIC_ERROR ? messages.default : message;
                        return /*#__PURE__*/ $eeyUA.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
                        $eeyUA.cloneElement(mergedMessage, {
                            key: "error_".concat(index)
                        }) : mergedMessage;
                    });
                case 18:
                    if (!(!result.length && subRuleField && Array.isArray(value) && value.length > 0)) {
                        _context2.next = 23;
                        break;
                    }
                    _context2.next = 21;
                    return Promise.all(value.map(function(subValue, i) {
                        return $5f5d1a9286f59eae$var$validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
                    }));
                case 21:
                    subResults = _context2.sent;
                    return _context2.abrupt("return", subResults.reduce(function(prev, errors) {
                        return [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(prev), (0, $3440102357566473$export$2e2bcd8739ae039)(errors));
                    }, []));
                case 23:
                    // Replace message with variables
                    kv = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, rule), {}, {
                        name: name,
                        enum: (rule.enum || []).join(', ')
                    }, messageVariables);
                    fillVariableResult = result.map(function(error) {
                        if (typeof error === 'string') return $5f5d1a9286f59eae$var$replaceMessage(error, kv);
                        return error;
                    });
                    return _context2.abrupt("return", fillVariableResult);
                case 26:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                10,
                15
            ]
        ]);
    }));
    return $5f5d1a9286f59eae$var$_validateRule.apply(this, arguments);
}
function $5f5d1a9286f59eae$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    var name = namePath.join('.');
    // Fill rule with context
    var filledRules = rules.map(function(currentRule, ruleIndex) {
        var originValidatorFunc = currentRule.validator;
        var cloneRule = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, currentRule), {}, {
            ruleIndex: ruleIndex
        });
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = function(rule, val, callback) {
            var hasPromise = false;
            // Wrap callback only accept when promise not provided
            var wrappedCallback = function wrappedCallback() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(function() {
                    (0, $f29d0996356f1173$export$2e2bcd8739ae039)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
                    if (!hasPromise) callback.apply(void 0, args);
                });
            };
            // Get promise
            var promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $f29d0996356f1173$export$2e2bcd8739ae039)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
            if (hasPromise) promise.then(function() {
                callback();
            }).catch(function(err) {
                callback(err || ' ');
            });
        };
        return cloneRule;
    }).sort(function(_ref, _ref2) {
        var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
        var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    var summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(/*#__PURE__*/ function() {
        var _ref3 = (0, $5fc0c4295ecffc5b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().mark(function _callee(resolve, reject) {
            var i, rule, errors;
            return (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        i = 0;
                    case 1:
                        if (!(i < filledRules.length)) {
                            _context.next = 12;
                            break;
                        }
                        rule = filledRules[i];
                        _context.next = 5;
                        return $5f5d1a9286f59eae$var$validateRule(name, value, rule, options, messageVariables);
                    case 5:
                        errors = _context.sent;
                        if (!errors.length) {
                            _context.next = 9;
                            break;
                        }
                        reject([
                            {
                                errors: errors,
                                rule: rule
                            }
                        ]);
                        return _context.abrupt("return");
                    case 9:
                        i += 1;
                        _context.next = 1;
                        break;
                    case 12:
                        /* eslint-enable */ resolve([]);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }());
    else {
        // >>>>> Validate by parallel
        var rulePromises = filledRules.map(function(rule) {
            return $5f5d1a9286f59eae$var$validateRule(name, value, rule, options, messageVariables).then(function(errors) {
                return {
                    errors: errors,
                    rule: rule
                };
            });
        });
        summaryPromise = (validateFirst ? $5f5d1a9286f59eae$var$finishOnFirstFailed(rulePromises) : $5f5d1a9286f59eae$var$finishOnAllFailed(rulePromises)).then(function(errors) {
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch(function(e) {
        return e;
    });
    return summaryPromise;
}
function $5f5d1a9286f59eae$var$finishOnAllFailed(_x8) {
    return $5f5d1a9286f59eae$var$_finishOnAllFailed.apply(this, arguments);
}
function $5f5d1a9286f59eae$var$_finishOnAllFailed() {
    $5f5d1a9286f59eae$var$_finishOnAllFailed = (0, $5fc0c4295ecffc5b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().mark(function _callee3(rulePromises) {
        return (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
                        var _ref5;
                        var errors = (_ref5 = []).concat.apply(_ref5, (0, $3440102357566473$export$2e2bcd8739ae039)(errorsList));
                        return errors;
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $5f5d1a9286f59eae$var$_finishOnAllFailed.apply(this, arguments);
}
function $5f5d1a9286f59eae$var$finishOnFirstFailed(_x9) {
    return $5f5d1a9286f59eae$var$_finishOnFirstFailed.apply(this, arguments);
}
function $5f5d1a9286f59eae$var$_finishOnFirstFailed() {
    $5f5d1a9286f59eae$var$_finishOnFirstFailed = (0, $5fc0c4295ecffc5b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().mark(function _callee4(rulePromises) {
        var count;
        return (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    count = 0;
                    return _context4.abrupt("return", new Promise(function(resolve) {
                        rulePromises.forEach(function(promise) {
                            promise.then(function(ruleError) {
                                if (ruleError.errors.length) resolve([
                                    ruleError
                                ]);
                                count += 1;
                                if (count === rulePromises.length) resolve([]);
                            });
                        });
                    }));
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $5f5d1a9286f59eae$var$_finishOnFirstFailed.apply(this, arguments);
}







function $b84aa89359563276$export$f877b3cb4cb4ccf9(path) {
    return (0, $0ac46302870a674a$export$45b10814cc054894)(path);
}
function $b84aa89359563276$export$f5be6dfb30403c59(store, namePathList) {
    var newStore = {};
    namePathList.forEach(function(namePath) {
        var value = (0, $e27746190091cddd$export$2e2bcd8739ae039)(store, namePath);
        newStore = (0, $b0ca387bd247d427$export$2e2bcd8739ae039)(newStore, namePath, value);
    });
    return newStore;
}
function $b84aa89359563276$export$646d5504364ae55b(namePathList, namePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return namePathList && namePathList.some(function(path) {
        return $b84aa89359563276$export$325a4bd0e71bdc3a(namePath, path, partialMatch);
    });
}
function $b84aa89359563276$export$325a4bd0e71bdc3a(namePath, subNamePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every(function(nameUnit, i) {
        return namePath[i] === nameUnit;
    });
}
function $b84aa89359563276$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(source) !== 'object' || (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(target) !== 'object') return false;
    var sourceKeys = Object.keys(source);
    var targetKeys = Object.keys(target);
    var keys = new Set([].concat(sourceKeys, targetKeys));
    return (0, $3440102357566473$export$2e2bcd8739ae039)(keys).every(function(key) {
        var sourceValue = source[key];
        var targetValue = target[key];
        if (typeof sourceValue === 'function' && typeof targetValue === 'function') return true;
        return sourceValue === targetValue;
    });
}
function $b84aa89359563276$export$6eeac3c5b406fb30(valuePropName) {
    var event = arguments.length <= 1 ? undefined : arguments[1];
    if (event && event.target && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(event.target) === 'object' && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $b84aa89359563276$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    var length = array.length;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    var item = array[moveIndex];
    var diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(array.slice(0, toIndex)), [
        item
    ], (0, $3440102357566473$export$2e2bcd8739ae039)(array.slice(toIndex, moveIndex)), (0, $3440102357566473$export$2e2bcd8739ae039)(array.slice(moveIndex + 1, length)));
    if (diff < 0) // move right
    return [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(array.slice(0, moveIndex)), (0, $3440102357566473$export$2e2bcd8739ae039)(array.slice(moveIndex + 1, toIndex + 1)), [
        item
    ], (0, $3440102357566473$export$2e2bcd8739ae039)(array.slice(toIndex + 1, length)));
    return array;
}


var $1048db12e21a7df2$var$_excluded = [
    "name"
];
var $1048db12e21a7df2$var$EMPTY_ERRORS = [];
function $1048db12e21a7df2$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === 'function') return shouldUpdate(prev, next, 'source' in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
var $1048db12e21a7df2$var$Field = /*#__PURE__*/ function(_React$Component) {
    (0, $6a4c2bdb64108a28$export$2e2bcd8739ae039)(Field, _React$Component);
    var _super = (0, $7104bbef2c357751$export$2e2bcd8739ae039)(Field);
    // ============================== Subscriptions ==============================
    function Field(props) {
        var _this;
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, Field);
        _this = _super.call(this, props);
        // Register on init
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "state", {
            resetCount: 0
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "cancelRegisterFunc", null);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "mounted", false);
        /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "touched", false);
        /**
     * Mark when touched & validated. Currently only used for `dependencies`.
     * Note that we do not think field with `initialValue` is dirty
     * but this will be by `isFieldDirty` func.
     */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "dirty", false);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "validatePromise", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "prevValidating", void 0);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "errors", $1048db12e21a7df2$var$EMPTY_ERRORS);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "warnings", $1048db12e21a7df2$var$EMPTY_ERRORS);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "cancelRegister", function() {
            var _this$props = _this.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
            if (_this.cancelRegisterFunc) _this.cancelRegisterFunc(isListField, preserve, (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(name));
            _this.cancelRegisterFunc = null;
        });
        // ================================== Utils ==================================
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "getNamePath", function() {
            var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
            var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
            return name !== undefined ? [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(prefixName), (0, $3440102357566473$export$2e2bcd8739ae039)(name)) : [];
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "getRules", function() {
            var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
            return rules.map(function(rule) {
                if (typeof rule === 'function') return rule(fieldContext);
                return rule;
            });
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "refresh", function() {
            if (!_this.mounted) return;
            /**
       * Clean up current node.
       */ _this.setState(function(_ref) {
                var resetCount = _ref.resetCount;
                return {
                    resetCount: resetCount + 1
                };
            });
        });
        // Event should only trigger when meta changed
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "metaCache", null);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "triggerMetaEvent", function(destroy) {
            var onMetaChange = _this.props.onMetaChange;
            if (onMetaChange) {
                var _meta = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, _this.getMeta()), {}, {
                    destroy: destroy
                });
                if (!(0, $899ab126ac4c56d7$export$2e2bcd8739ae039)(_this.metaCache, _meta)) onMetaChange(_meta);
                _this.metaCache = _meta;
            } else _this.metaCache = null;
        });
        // ========================= Field Entity Interfaces =========================
        // Trigger by store update. Check if need update the component
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "onStoreChange", function(prevStore, namePathList, info) {
            var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
            var store = info.store;
            var namePath = _this.getNamePath();
            var prevValue = _this.getValue(prevStore);
            var curValue = _this.getValue(store);
            var namePathMatch = namePathList && (0, $b84aa89359563276$export$646d5504364ae55b)(namePathList, namePath);
            // `setFieldsValue` is a quick access to update related status
            if (info.type === 'valueUpdate' && info.source === 'external' && !(0, $899ab126ac4c56d7$export$2e2bcd8739ae039)(prevValue, curValue)) {
                _this.touched = true;
                _this.dirty = true;
                _this.validatePromise = null;
                _this.errors = $1048db12e21a7df2$var$EMPTY_ERRORS;
                _this.warnings = $1048db12e21a7df2$var$EMPTY_ERRORS;
                _this.triggerMetaEvent();
            }
            switch(info.type){
                case 'reset':
                    if (!namePathList || namePathMatch) {
                        // Clean up state
                        _this.touched = false;
                        _this.dirty = false;
                        _this.validatePromise = undefined;
                        _this.errors = $1048db12e21a7df2$var$EMPTY_ERRORS;
                        _this.warnings = $1048db12e21a7df2$var$EMPTY_ERRORS;
                        _this.triggerMetaEvent();
                        onReset === null || onReset === void 0 || onReset();
                        _this.refresh();
                        return;
                    }
                    break;
                /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */ case 'remove':
                    if (shouldUpdate && $1048db12e21a7df2$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'setField':
                    var data = info.data;
                    if (namePathMatch) {
                        if ('touched' in data) _this.touched = data.touched;
                        if ('validating' in data && !('originRCField' in data)) _this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ('errors' in data) _this.errors = data.errors || $1048db12e21a7df2$var$EMPTY_ERRORS;
                        if ('warnings' in data) _this.warnings = data.warnings || $1048db12e21a7df2$var$EMPTY_ERRORS;
                        _this.dirty = true;
                        _this.triggerMetaEvent();
                        _this.reRender();
                        return;
                    } else if ('value' in data && (0, $b84aa89359563276$export$646d5504364ae55b)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        _this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $1048db12e21a7df2$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'dependenciesUpdate':
                    /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */ var dependencyList = dependencies.map((0, $b84aa89359563276$export$f877b3cb4cb4ccf9));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some(function(dependency) {
                        return (0, $b84aa89359563276$export$646d5504364ae55b)(info.relatedFields, dependency);
                    })) {
                        _this.reRender();
                        return;
                    }
                    break;
                default:
                    // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                    //      For example <List name="list"><Field name={['list', 0]}></List>
                    //      If `namePathList` is [['list']] (List value update), Field should be updated
                    //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                    // 2.
                    //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                    //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                    //       is not provided
                    //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                    //       else to check if value changed
                    if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $1048db12e21a7df2$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
            }
            if (shouldUpdate === true) _this.reRender();
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "validateRules", function(options) {
            // We should fixed namePath & value to avoid developer change then by form function
            var namePath = _this.getNamePath();
            var currentValue = _this.getValue();
            var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
            // Force change to async to avoid rule OOD under renderProps field
            var rootPromise = Promise.resolve().then(/*#__PURE__*/ (0, $5fc0c4295ecffc5b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().mark(function _callee() {
                var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
                return (0, $92ecb52394fe22cf$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (_this.mounted) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 2:
                            _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce; // Start validate
                            filteredRules = _this.getRules();
                            if (triggerName) filteredRules = filteredRules.filter(function(rule) {
                                return rule;
                            }).filter(function(rule) {
                                var validateTrigger = rule.validateTrigger;
                                if (!validateTrigger) return true;
                                var triggerList = (0, $0ac46302870a674a$export$45b10814cc054894)(validateTrigger);
                                return triggerList.includes(triggerName);
                            });
                            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
                            if (!(validateDebounce && triggerName)) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 8;
                            return new Promise(function(resolve) {
                                setTimeout(resolve, validateDebounce);
                            });
                        case 8:
                            if (!(_this.validatePromise !== rootPromise)) {
                                _context.next = 10;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 10:
                            promise = (0, $5f5d1a9286f59eae$export$e1fc4b442d0297dd)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
                            promise.catch(function(e) {
                                return e;
                            }).then(function() {
                                var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $1048db12e21a7df2$var$EMPTY_ERRORS;
                                if (_this.validatePromise === rootPromise) {
                                    var _ruleErrors$forEach;
                                    _this.validatePromise = null;
                                    // Get errors & warnings
                                    var nextErrors = [];
                                    var nextWarnings = [];
                                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                                        var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? $1048db12e21a7df2$var$EMPTY_ERRORS : _ref4$errors;
                                        if (warningOnly) nextWarnings.push.apply(nextWarnings, (0, $3440102357566473$export$2e2bcd8739ae039)(errors));
                                        else nextErrors.push.apply(nextErrors, (0, $3440102357566473$export$2e2bcd8739ae039)(errors));
                                    });
                                    _this.errors = nextErrors;
                                    _this.warnings = nextWarnings;
                                    _this.triggerMetaEvent();
                                    _this.reRender();
                                }
                            });
                            return _context.abrupt("return", promise);
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            if (validateOnly) return rootPromise;
            _this.validatePromise = rootPromise;
            _this.dirty = true;
            _this.errors = $1048db12e21a7df2$var$EMPTY_ERRORS;
            _this.warnings = $1048db12e21a7df2$var$EMPTY_ERRORS;
            _this.triggerMetaEvent();
            // Force trigger re-render since we need sync renderProps with new meta
            _this.reRender();
            return rootPromise;
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "isFieldValidating", function() {
            return !!_this.validatePromise;
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "isFieldTouched", function() {
            return _this.touched;
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "isFieldDirty", function() {
            // Touched or validate or has initialValue
            if (_this.dirty || _this.props.initialValue !== undefined) return true;
            // Form set initialValue
            var fieldContext = _this.props.fieldContext;
            var _fieldContext$getInte = fieldContext.getInternalHooks((0, $176a86e7f5cc56f5$export$24829b7c0e49e9f7)), getInitialValue = _fieldContext$getInte.getInitialValue;
            if (getInitialValue(_this.getNamePath()) !== undefined) return true;
            return false;
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "getErrors", function() {
            return _this.errors;
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "getWarnings", function() {
            return _this.warnings;
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "isListField", function() {
            return _this.props.isListField;
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "isList", function() {
            return _this.props.isList;
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "isPreserve", function() {
            return _this.props.preserve;
        });
        // ============================= Child Component =============================
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "getMeta", function() {
            // Make error & validating in cache to save perf
            _this.prevValidating = _this.isFieldValidating();
            var meta = {
                touched: _this.isFieldTouched(),
                validating: _this.prevValidating,
                errors: _this.errors,
                warnings: _this.warnings,
                name: _this.getNamePath(),
                validated: _this.validatePromise === null
            };
            return meta;
        });
        // Only return validate child node. If invalidate, will do nothing about field.
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "getOnlyChild", function(children) {
            // Support render props
            if (typeof children === 'function') {
                var _meta2 = _this.getMeta();
                return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
                    isFunction: true
                });
            }
            // Filed element only
            var childList = (0, $ad876cf685db44a4$export$2e2bcd8739ae039)(children);
            if (childList.length !== 1 || !/*#__PURE__*/ $eeyUA.isValidElement(childList[0])) return {
                child: childList,
                isFunction: false
            };
            return {
                child: childList[0],
                isFunction: false
            };
        });
        // ============================== Field Control ==============================
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "getValue", function(store) {
            var getFieldsValue = _this.props.fieldContext.getFieldsValue;
            var namePath = _this.getNamePath();
            return (0, $e27746190091cddd$export$2e2bcd8739ae039)(store || getFieldsValue(true), namePath);
        });
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this), "getControlled", function() {
            var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props6 = _this.props, name = _this$props6.name, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
            var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
            var namePath = _this.getNamePath();
            var getInternalHooks = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
            var _getInternalHooks = getInternalHooks((0, $176a86e7f5cc56f5$export$24829b7c0e49e9f7)), dispatch = _getInternalHooks.dispatch;
            var value = _this.getValue();
            var mergedGetValueProps = getValueProps || function(val) {
                return (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, valuePropName, val);
            };
            var originTriggerFunc = childProps[trigger];
            var valueProps = name !== undefined ? mergedGetValueProps(value) : {};
            var control = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, childProps), valueProps);
            // Add trigger
            control[trigger] = function() {
                // Mark as touched
                _this.touched = true;
                _this.dirty = true;
                _this.triggerMetaEvent();
                var newValue;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (getValueFromEvent) newValue = getValueFromEvent.apply(void 0, args);
                else newValue = (0, $b84aa89359563276$export$6eeac3c5b406fb30).apply(void 0, [
                    valuePropName
                ].concat(args));
                if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
                if (newValue !== value) dispatch({
                    type: 'updateValue',
                    namePath: namePath,
                    value: newValue
                });
                if (originTriggerFunc) originTriggerFunc.apply(void 0, args);
            };
            // Add validateTrigger
            var validateTriggerList = (0, $0ac46302870a674a$export$45b10814cc054894)(mergedValidateTrigger || []);
            validateTriggerList.forEach(function(triggerName) {
                // Wrap additional function of component, so that we can get latest value from store
                var originTrigger = control[triggerName];
                control[triggerName] = function() {
                    if (originTrigger) originTrigger.apply(void 0, arguments);
                    // Always use latest rules
                    var rules = _this.props.rules;
                    if (rules && rules.length) // We dispatch validate to root,
                    // since it will update related data with other field with same name
                    dispatch({
                        type: 'validateField',
                        namePath: namePath,
                        triggerName: triggerName
                    });
                };
            });
            return control;
        });
        if (props.fieldContext) {
            var getInternalHooks = props.fieldContext.getInternalHooks;
            var _getInternalHooks2 = getInternalHooks((0, $176a86e7f5cc56f5$export$24829b7c0e49e9f7)), initEntityValue = _getInternalHooks2.initEntityValue;
            initEntityValue((0, $7e5561df6a152bb7$export$2e2bcd8739ae039)(_this));
        }
        return _this;
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(Field, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
                this.mounted = true;
                // Register on init
                if (fieldContext) {
                    var getInternalHooks = fieldContext.getInternalHooks;
                    var _getInternalHooks3 = getInternalHooks((0, $176a86e7f5cc56f5$export$24829b7c0e49e9f7)), registerField = _getInternalHooks3.registerField;
                    this.cancelRegisterFunc = registerField(this);
                }
                // One more render for component in case fields not ready
                if (shouldUpdate === true) this.reRender();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRegister();
                this.triggerMetaEvent(true);
                this.mounted = false;
            }
        },
        {
            key: "reRender",
            value: function reRender() {
                if (!this.mounted) return;
                this.forceUpdate();
            }
        },
        {
            key: "render",
            value: function render() {
                var resetCount = this.state.resetCount;
                var children = this.props.children;
                var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction = _this$getOnlyChild.isFunction;
                // Not need to `cloneElement` since user can handle this in render function self
                var returnChildNode;
                if (isFunction) returnChildNode = child;
                else if (/*#__PURE__*/ $eeyUA.isValidElement(child)) returnChildNode = /*#__PURE__*/ $eeyUA.cloneElement(child, this.getControlled(child.props));
                else {
                    (0, $f29d0996356f1173$export$2e2bcd8739ae039)(!child, '`children` of Field is not validate ReactElement.');
                    returnChildNode = child;
                }
                return /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, {
                    key: resetCount
                }, returnChildNode);
            }
        }
    ]);
    return Field;
}($eeyUA.Component);
(0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)($1048db12e21a7df2$var$Field, "contextType", (0, $176a86e7f5cc56f5$export$2e2bcd8739ae039));
(0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)($1048db12e21a7df2$var$Field, "defaultProps", {
    trigger: 'onChange',
    valuePropName: 'value'
});
function $1048db12e21a7df2$var$WrapperField(_ref6) {
    var _restProps$isListFiel;
    var name = _ref6.name, restProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_ref6, $1048db12e21a7df2$var$_excluded);
    var fieldContext = $eeyUA.useContext((0, $176a86e7f5cc56f5$export$2e2bcd8739ae039));
    var listContext = $eeyUA.useContext((0, $21aa92066fb7255e$export$2e2bcd8739ae039));
    var namePath = name !== undefined ? (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(name) : undefined;
    var isMergedListField = (_restProps$isListFiel = restProps.isListField) !== null && _restProps$isListFiel !== void 0 ? _restProps$isListFiel : !!listContext;
    var key = 'keep';
    if (!isMergedListField) key = "_".concat((namePath || []).join('_'));
    return /*#__PURE__*/ $eeyUA.createElement($1048db12e21a7df2$var$Field, (0, $7Nobb.default)({
        key: key,
        name: namePath,
        isListField: isMergedListField
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $1048db12e21a7df2$export$2e2bcd8739ae039 = $1048db12e21a7df2$var$WrapperField;





var $eeyUA = parcelRequire("eeyUA");





function $33028f92388f9fed$var$List(_ref) {
    var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
    var context = $eeyUA.useContext((0, $176a86e7f5cc56f5$export$2e2bcd8739ae039));
    var wrapperListContext = $eeyUA.useContext((0, $21aa92066fb7255e$export$2e2bcd8739ae039));
    var keyRef = $eeyUA.useRef({
        keys: [],
        id: 0
    });
    var keyManager = keyRef.current;
    var prefixName = $eeyUA.useMemo(function() {
        var parentPrefixName = (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(context.prefixName) || [];
        return [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(parentPrefixName), (0, $3440102357566473$export$2e2bcd8739ae039)((0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(name)));
    }, [
        context.prefixName,
        name
    ]);
    var fieldContext = $eeyUA.useMemo(function() {
        return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, context), {}, {
            prefixName: prefixName
        });
    }, [
        context,
        prefixName
    ]);
    // List context
    var listContext = $eeyUA.useMemo(function() {
        return {
            getKey: function getKey(namePath) {
                var len = prefixName.length;
                var pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        };
    }, [
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== 'function') {
        (0, $f29d0996356f1173$export$2e2bcd8739ae039)(false, 'Form.List only accepts function as children.');
        return null;
    }
    var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
        var source = _ref2.source;
        if (source === 'internal') return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $eeyUA.createElement((0, $21aa92066fb7255e$export$2e2bcd8739ae039).Provider, {
        value: listContext
    }, /*#__PURE__*/ $eeyUA.createElement((0, $176a86e7f5cc56f5$export$2e2bcd8739ae039).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $eeyUA.createElement((0, $1048db12e21a7df2$export$2e2bcd8739ae039), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
    }, function(_ref3, meta) {
        var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
        var getFieldValue = context.getFieldValue;
        var getNewValue = function getNewValue() {
            var values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ var operations = {
            add: function add(defaultValue, index) {
                // Mapping keys
                var newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(keyManager.keys.slice(0, index)), [
                        keyManager.id
                    ], (0, $3440102357566473$export$2e2bcd8739ae039)(keyManager.keys.slice(index)));
                    onChange([].concat((0, $3440102357566473$export$2e2bcd8739ae039)(newValue.slice(0, index)), [
                        defaultValue
                    ], (0, $3440102357566473$export$2e2bcd8739ae039)(newValue.slice(index))));
                } else {
                    keyManager.keys = [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(keyManager.keys), [
                        keyManager.id
                    ]);
                    onChange([].concat((0, $3440102357566473$export$2e2bcd8739ae039)(newValue), [
                        defaultValue
                    ]));
                }
                keyManager.id += 1;
            },
            remove: function remove(index) {
                var newValue = getNewValue();
                var indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
                    return !indexSet.has(keysIndex);
                });
                // Trigger store change
                onChange(newValue.filter(function(_, valueIndex) {
                    return !indexSet.has(valueIndex);
                }));
            },
            move: function move(from, to) {
                if (from === to) return;
                var newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $b84aa89359563276$export$d947e5f4f4c48d48)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $b84aa89359563276$export$d947e5f4f4c48d48)(newValue, from, to));
            }
        };
        var listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map(function(__, index) {
            var key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $33028f92388f9fed$export$2e2bcd8739ae039 = $33028f92388f9fed$var$List;













var $eeyUA = parcelRequire("eeyUA");

function $dcf83d968d8b8278$export$6152adfdcc6be2b5(promiseList) {
    var hasError = false;
    var count = promiseList.length;
    var results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise(function(resolve, reject) {
        promiseList.forEach(function(promise, index) {
            promise.catch(function(e) {
                hasError = true;
                return e;
            }).then(function(result) {
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}









var $88784a3307e49005$var$SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $88784a3307e49005$var$normalize(namePath) {
    return namePath.map(function(cell) {
        return "".concat((0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(cell), ":").concat(cell);
    })// Magic split
    .join($88784a3307e49005$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ var $88784a3307e49005$var$NameMap = /*#__PURE__*/ function() {
    function NameMap() {
        (0, $827123db267e1039$export$2e2bcd8739ae039)(this, NameMap);
        (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "kvs", new Map());
    }
    (0, $055f1aac98d71283$export$2e2bcd8739ae039)(NameMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.kvs.set($88784a3307e49005$var$normalize(key), value);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.kvs.get($88784a3307e49005$var$normalize(key));
            }
        },
        {
            key: "update",
            value: function update(key, updater) {
                var origin = this.get(key);
                var next = updater(origin);
                if (!next) this.delete(key);
                else this.set(key, next);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this.kvs.delete($88784a3307e49005$var$normalize(key));
            }
        },
        {
            key: "map",
            value: function map(callback) {
                return (0, $3440102357566473$export$2e2bcd8739ae039)(this.kvs.entries()).map(function(_ref) {
                    var _ref2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
                    var cells = key.split($88784a3307e49005$var$SPLIT);
                    return callback({
                        key: cells.map(function(cell) {
                            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_cell$match, 3), type = _cell$match2[1], unit = _cell$match2[2];
                            return type === 'number' ? Number(unit) : unit;
                        }),
                        value: value
                    });
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                this.map(function(_ref3) {
                    var key = _ref3.key, value = _ref3.value;
                    json[key.join('.')] = value;
                    return null;
                });
                return json;
            }
        }
    ]);
    return NameMap;
}();
var $88784a3307e49005$export$2e2bcd8739ae039 = $88784a3307e49005$var$NameMap;



var $5e50076ee2f6a09b$var$_excluded = [
    "name"
];
var $5e50076ee2f6a09b$export$75ff1ab1187e691 = /*#__PURE__*/ (0, $055f1aac98d71283$export$2e2bcd8739ae039)(function FormStore(forceRootUpdate) {
    var _this = this;
    (0, $827123db267e1039$export$2e2bcd8739ae039)(this, FormStore);
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "formHooked", false);
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "forceRootUpdate", void 0);
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "subscribable", true);
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "store", {});
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "fieldEntities", []);
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "initialValues", {});
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "callbacks", {});
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "validateMessages", null);
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "preserve", null);
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "lastValidatePromise", null);
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getForm", function() {
        return {
            getFieldValue: _this.getFieldValue,
            getFieldsValue: _this.getFieldsValue,
            getFieldError: _this.getFieldError,
            getFieldWarning: _this.getFieldWarning,
            getFieldsError: _this.getFieldsError,
            isFieldsTouched: _this.isFieldsTouched,
            isFieldTouched: _this.isFieldTouched,
            isFieldValidating: _this.isFieldValidating,
            isFieldsValidating: _this.isFieldsValidating,
            resetFields: _this.resetFields,
            setFields: _this.setFields,
            setFieldValue: _this.setFieldValue,
            setFieldsValue: _this.setFieldsValue,
            validateFields: _this.validateFields,
            submit: _this.submit,
            _init: true,
            getInternalHooks: _this.getInternalHooks
        };
    });
    // ======================== Internal Hooks ========================
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getInternalHooks", function(key) {
        if (key === (0, $176a86e7f5cc56f5$export$24829b7c0e49e9f7)) {
            _this.formHooked = true;
            return {
                dispatch: _this.dispatch,
                initEntityValue: _this.initEntityValue,
                registerField: _this.registerField,
                useSubscribe: _this.useSubscribe,
                setInitialValues: _this.setInitialValues,
                destroyForm: _this.destroyForm,
                setCallbacks: _this.setCallbacks,
                setValidateMessages: _this.setValidateMessages,
                getFields: _this.getFields,
                setPreserve: _this.setPreserve,
                getInitialValue: _this.getInitialValue,
                registerWatch: _this.registerWatch
            };
        }
        (0, $f29d0996356f1173$export$2e2bcd8739ae039)(false, '`getInternalHooks` is internal usage. Should not call directly.');
        return null;
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "useSubscribe", function(subscribable) {
        _this.subscribable = subscribable;
    });
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "prevWithoutPreserves", null);
    /**
   * First time `setInitialValues` should update store with initial value
   */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "setInitialValues", function(initialValues, init) {
        _this.initialValues = initialValues || {};
        if (init) {
            var _this$prevWithoutPres;
            var nextStore = (0, $b0ca387bd247d427$export$4950aa0f605343fb)(initialValues, _this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
                var namePath = _ref.key;
                nextStore = (0, $b0ca387bd247d427$export$2e2bcd8739ae039)(nextStore, namePath, (0, $e27746190091cddd$export$2e2bcd8739ae039)(initialValues, namePath));
            });
            _this.prevWithoutPreserves = null;
            _this.updateStore(nextStore);
        }
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "destroyForm", function(clearOnDestroy) {
        if (clearOnDestroy) // destroy form reset store
        _this.updateStore({});
        else {
            // Fill preserve fields
            var prevWithoutPreserves = new (0, $88784a3307e49005$export$2e2bcd8739ae039)();
            _this.getFieldEntities(true).forEach(function(entity) {
                if (!_this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
            });
            _this.prevWithoutPreserves = prevWithoutPreserves;
        }
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getInitialValue", function(namePath) {
        var initValue = (0, $e27746190091cddd$export$2e2bcd8739ae039)(_this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $b0ca387bd247d427$export$4950aa0f605343fb)(initValue) : initValue;
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "setCallbacks", function(callbacks) {
        _this.callbacks = callbacks;
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "setValidateMessages", function(validateMessages) {
        _this.validateMessages = validateMessages;
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "setPreserve", function(preserve) {
        _this.preserve = preserve;
    });
    // ============================= Watch ============================
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "watchList", []);
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "registerWatch", function(callback) {
        _this.watchList.push(callback);
        return function() {
            _this.watchList = _this.watchList.filter(function(fn) {
                return fn !== callback;
            });
        };
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "notifyWatch", function() {
        var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // No need to cost perf when nothing need to watch
        if (_this.watchList.length) {
            var values = _this.getFieldsValue();
            var allValues = _this.getFieldsValue(true);
            _this.watchList.forEach(function(callback) {
                callback(values, allValues, namePath);
            });
        }
    });
    // ========================== Dev Warning =========================
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "timeoutId", null);
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "warningUnhooked", function() {});
    // ============================ Store =============================
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "updateStore", function(nextStore) {
        _this.store = nextStore;
    });
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getFieldEntities", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!pure) return _this.fieldEntities;
        return _this.fieldEntities.filter(function(field) {
            return field.getNamePath().length;
        });
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getFieldsMap", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var cache = new (0, $88784a3307e49005$export$2e2bcd8739ae039)();
        _this.getFieldEntities(pure).forEach(function(field) {
            var namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getFieldEntitiesForNamePathList", function(nameList) {
        if (!nameList) return _this.getFieldEntities(true);
        var cache = _this.getFieldsMap(true);
        return nameList.map(function(name) {
            var namePath = (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(name)
            };
        });
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getFieldsValue", function(nameList, filterFunc) {
        _this.warningUnhooked();
        // Fill args
        var mergedNameList;
        var mergedFilterFunc;
        var mergedStrict;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && (0, $0e73c95013f1ef2d$export$2e2bcd8739ae039)(nameList) === 'object') {
            mergedStrict = nameList.strict;
            mergedFilterFunc = nameList.filter;
        }
        if (mergedNameList === true && !mergedFilterFunc) return _this.store;
        var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        var filteredNameList = [];
        fieldEntities.forEach(function(entity) {
            var _isListField, _ref3;
            var namePath = 'INVALIDATE_NAME_PATH' in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (mergedStrict) {
                var _isList, _ref2;
                if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) return;
            } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) return;
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                var meta = 'getMeta' in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        return (0, $b84aa89359563276$export$f5be6dfb30403c59)(_this.store, filteredNameList.map((0, $b84aa89359563276$export$f877b3cb4cb4ccf9)));
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getFieldValue", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(name);
        return (0, $e27746190091cddd$export$2e2bcd8739ae039)(_this.store, namePath);
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getFieldsError", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map(function(entity, index) {
            if (entity && !('INVALIDATE_NAME_PATH' in entity)) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getFieldError", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getFieldWarning", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "isFieldsTouched", function() {
        _this.warningUnhooked();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var arg0 = args[0], arg1 = args[1];
        var namePathList;
        var isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $b84aa89359563276$export$f877b3cb4cb4ccf9));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $b84aa89359563276$export$f877b3cb4cb4ccf9));
            isAllFieldsTouched = arg1;
        }
        var fieldEntities = _this.getFieldEntities(true);
        var isFieldTouched = function isFieldTouched(field) {
            return field.isFieldTouched();
        };
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every(function(entity) {
            return isFieldTouched(entity) || entity.isList();
        }) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        var map = new (0, $88784a3307e49005$export$2e2bcd8739ae039)();
        namePathList.forEach(function(shortNamePath) {
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach(function(field) {
            var fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach(function(shortNamePath) {
                if (shortNamePath.every(function(nameUnit, i) {
                    return fieldNamePath[i] === nameUnit;
                })) map.update(shortNamePath, function(list) {
                    return [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(list), [
                        field
                    ]);
                });
            });
        });
        // Check if NameMap value is touched
        var isNamePathListTouched = function isNamePathListTouched(entities) {
            return entities.some(isFieldTouched);
        };
        var namePathListEntities = map.map(function(_ref4) {
            var value = _ref4.value;
            return value;
        });
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "isFieldTouched", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsTouched([
            name
        ]);
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "isFieldsValidating", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntities();
        if (!nameList) return fieldEntities.some(function(testField) {
            return testField.isFieldValidating();
        });
        var namePathList = nameList.map((0, $b84aa89359563276$export$f877b3cb4cb4ccf9));
        return fieldEntities.some(function(testField) {
            var fieldNamePath = testField.getNamePath();
            return (0, $b84aa89359563276$export$646d5504364ae55b)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "isFieldValidating", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsValidating([
            name
        ]);
    });
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "resetWithFieldInitialValue", function() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Create cache
        var cache = new (0, $88784a3307e49005$export$2e2bcd8739ae039)();
        var fieldEntities = _this.getFieldEntities(true);
        fieldEntities.forEach(function(field) {
            var initialValue = field.props.initialValue;
            var namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                var records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        var resetWithFields = function resetWithFields(entities) {
            entities.forEach(function(field) {
                var initialValue = field.props.initialValue;
                if (initialValue !== undefined) {
                    var namePath = field.getNamePath();
                    var formInitialValue = _this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $f29d0996356f1173$export$2e2bcd8739ae039)(false, "Form already set 'initialValues' with path '".concat(namePath.join('.'), "'. Field can not overwrite it."));
                    else {
                        var records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $f29d0996356f1173$export$2e2bcd8739ae039)(false, "Multiple Field with path '".concat(namePath.join('.'), "' set 'initialValue'. Can not decide which one to pick."));
                        else if (records) {
                            var originValue = _this.getFieldValue(namePath);
                            var isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) _this.updateStore((0, $b0ca387bd247d427$export$2e2bcd8739ae039)(_this.store, namePath, (0, $3440102357566473$export$2e2bcd8739ae039)(records)[0].value));
                        }
                    }
                }
            });
        };
        var requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach(function(namePath) {
                var records = cache.get(namePath);
                if (records) {
                    var _requiredFieldEntitie;
                    (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, (0, $3440102357566473$export$2e2bcd8739ae039)((0, $3440102357566473$export$2e2bcd8739ae039)(records).map(function(r) {
                        return r.entity;
                    })));
                }
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "resetFields", function(nameList) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (!nameList) {
            _this.updateStore((0, $b0ca387bd247d427$export$4950aa0f605343fb)(_this.initialValues));
            _this.resetWithFieldInitialValue();
            _this.notifyObservers(prevStore, null, {
                type: 'reset'
            });
            _this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        var namePathList = nameList.map((0, $b84aa89359563276$export$f877b3cb4cb4ccf9));
        namePathList.forEach(function(namePath) {
            var initialValue = _this.getInitialValue(namePath);
            _this.updateStore((0, $b0ca387bd247d427$export$2e2bcd8739ae039)(_this.store, namePath, initialValue));
        });
        _this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        _this.notifyObservers(prevStore, namePathList, {
            type: 'reset'
        });
        _this.notifyWatch(namePathList);
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "setFields", function(fields) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        var namePathList = [];
        fields.forEach(function(fieldData) {
            var name = fieldData.name, data = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(fieldData, $5e50076ee2f6a09b$var$_excluded);
            var namePath = (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(name);
            namePathList.push(namePath);
            // Value
            if ('value' in data) _this.updateStore((0, $b0ca387bd247d427$export$2e2bcd8739ae039)(_this.store, namePath, data.value));
            _this.notifyObservers(prevStore, [
                namePath
            ], {
                type: 'setField',
                data: fieldData
            });
        });
        _this.notifyWatch(namePathList);
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getFields", function() {
        var entities = _this.getFieldEntities(true);
        var fields = entities.map(function(field) {
            var namePath = field.getNamePath();
            var meta = field.getMeta();
            var fieldData = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, meta), {}, {
                name: namePath,
                value: _this.getFieldValue(namePath)
            });
            Object.defineProperty(fieldData, 'originRCField', {
                value: true
            });
            return fieldData;
        });
        return fields;
    });
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "initEntityValue", function(entity) {
        var initialValue = entity.props.initialValue;
        if (initialValue !== undefined) {
            var namePath = entity.getNamePath();
            var prevValue = (0, $e27746190091cddd$export$2e2bcd8739ae039)(_this.store, namePath);
            if (prevValue === undefined) _this.updateStore((0, $b0ca387bd247d427$export$2e2bcd8739ae039)(_this.store, namePath, initialValue));
        }
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "isMergedPreserve", function(fieldPreserve) {
        var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
        return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "registerField", function(entity) {
        _this.fieldEntities.push(entity);
        var namePath = entity.getNamePath();
        _this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            var prevStore = _this.store;
            _this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            _this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: 'valueUpdate',
                source: 'internal'
            });
        }
        // un-register field callback
        return function(isListField, preserve) {
            var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _this.fieldEntities = _this.fieldEntities.filter(function(item) {
                return item !== entity;
            });
            // Clean up store value if not preserve
            if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);
                if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
                    return(// Only reset when no namePath exist
                    !(0, $b84aa89359563276$export$325a4bd0e71bdc3a)(field.getNamePath(), namePath));
                })) {
                    var _prevStore = _this.store;
                    _this.updateStore((0, $b0ca387bd247d427$export$2e2bcd8739ae039)(_prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    _this.notifyObservers(_prevStore, [
                        namePath
                    ], {
                        type: 'remove'
                    });
                    // Dependencies update
                    _this.triggerDependenciesUpdate(_prevStore, namePath);
                }
            }
            _this.notifyWatch([
                namePath
            ]);
        };
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "dispatch", function(action) {
        switch(action.type){
            case 'updateValue':
                var namePath = action.namePath, value = action.value;
                _this.updateValue(namePath, value);
                break;
            case 'validateField':
                var _namePath = action.namePath, triggerName = action.triggerName;
                _this.validateFields([
                    _namePath
                ], {
                    triggerName: triggerName
                });
                break;
            default:
        }
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "notifyObservers", function(prevStore, namePathList, info) {
        if (_this.subscribable) {
            var mergedInfo = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, info), {}, {
                store: _this.getFieldsValue(true)
            });
            _this.getFieldEntities().forEach(function(_ref5) {
                var onStoreChange = _ref5.onStoreChange;
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else _this.forceRootUpdate();
    });
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
        var childrenFields = _this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) _this.validateFields(childrenFields);
        _this.notifyObservers(prevStore, childrenFields, {
            type: 'dependenciesUpdate',
            relatedFields: [
                namePath
            ].concat((0, $3440102357566473$export$2e2bcd8739ae039)(childrenFields))
        });
        return childrenFields;
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "updateValue", function(name, value) {
        var namePath = (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(name);
        var prevStore = _this.store;
        _this.updateStore((0, $b0ca387bd247d427$export$2e2bcd8739ae039)(_this.store, namePath, value));
        _this.notifyObservers(prevStore, [
            namePath
        ], {
            type: 'valueUpdate',
            source: 'internal'
        });
        _this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        var onValuesChange = _this.callbacks.onValuesChange;
        if (onValuesChange) {
            var changedValues = (0, $b84aa89359563276$export$f5be6dfb30403c59)(_this.store, [
                namePath
            ]);
            onValuesChange(changedValues, _this.getFieldsValue());
        }
        _this.triggerOnFieldsChange([
            namePath
        ].concat((0, $3440102357566473$export$2e2bcd8739ae039)(childrenFields)));
    });
    // Let all child Field get update.
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "setFieldsValue", function(store) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (store) {
            var nextStore = (0, $b0ca387bd247d427$export$4950aa0f605343fb)(_this.store, store);
            _this.updateStore(nextStore);
        }
        _this.notifyObservers(prevStore, null, {
            type: 'valueUpdate',
            source: 'external'
        });
        _this.notifyWatch();
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "setFieldValue", function(name, value) {
        _this.setFields([
            {
                name: name,
                value: value,
                errors: [],
                warnings: []
            }
        ]);
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "getDependencyChildrenFields", function(rootNamePath) {
        var children = new Set();
        var childrenFields = [];
        var dependencies2fields = new (0, $88784a3307e49005$export$2e2bcd8739ae039)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ _this.getFieldEntities().forEach(function(field) {
            var dependencies = field.props.dependencies;
            (dependencies || []).forEach(function(dependency) {
                var dependencyNamePath = (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(dependency);
                dependencies2fields.update(dependencyNamePath, function() {
                    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
                    fields.add(field);
                    return fields;
                });
            });
        });
        var fillChildren = function fillChildren(namePath) {
            var fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach(function(field) {
                if (!children.has(field)) {
                    children.add(field);
                    var fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    });
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
        var onFieldsChange = _this.callbacks.onFieldsChange;
        if (onFieldsChange) {
            var fields = _this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                var cache = new (0, $88784a3307e49005$export$2e2bcd8739ae039)();
                filedErrors.forEach(function(_ref6) {
                    var name = _ref6.name, errors = _ref6.errors;
                    cache.set(name, errors);
                });
                fields.forEach(function(field) {
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            var changedFields = fields.filter(function(_ref7) {
                var fieldName = _ref7.name;
                return (0, $b84aa89359563276$export$646d5504364ae55b)(namePathList, fieldName);
            });
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    });
    // =========================== Validate ===========================
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "validateFields", function(arg1, arg2) {
        _this.warningUnhooked();
        var nameList;
        var options;
        if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        var provideNameList = !!nameList;
        var namePathList = provideNameList ? nameList.map((0, $b84aa89359563276$export$f877b3cb4cb4ccf9)) : [];
        // Collect result in promise list
        var promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        var TMP_SPLIT = String(Date.now());
        var validateNamePathList = new Set();
        var _ref8 = options || {}, recursive = _ref8.recursive, dirty = _ref8.dirty;
        _this.getFieldEntities(true).forEach(function(field) {
            // Add field if not provide `nameList`
            if (!provideNameList) namePathList.push(field.getNamePath());
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            var fieldNamePath = field.getNamePath();
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $b84aa89359563276$export$646d5504364ae55b)(namePathList, fieldNamePath, recursive)) {
                var promise = field.validateRules((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({
                    validateMessages: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, (0, $e49d64a5cd2ea570$export$c86b939816b8fbf8)), _this.validateMessages)
                }, options));
                // Wrap promise with field
                promiseList.push(promise.then(function() {
                    return {
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    };
                }).catch(function(ruleErrors) {
                    var _ruleErrors$forEach;
                    var mergedErrors = [];
                    var mergedWarnings = [];
                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref9) {
                        var warningOnly = _ref9.rule.warningOnly, errors = _ref9.errors;
                        if (warningOnly) mergedWarnings.push.apply(mergedWarnings, (0, $3440102357566473$export$2e2bcd8739ae039)(errors));
                        else mergedErrors.push.apply(mergedErrors, (0, $3440102357566473$export$2e2bcd8739ae039)(errors));
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        var summaryPromise = (0, $dcf83d968d8b8278$export$6152adfdcc6be2b5)(promiseList);
        _this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch(function(results) {
            return results;
        }).then(function(results) {
            var resultNamePathList = results.map(function(_ref10) {
                var name = _ref10.name;
                return name;
            });
            _this.notifyObservers(_this.store, resultNamePathList, {
                type: 'validateFinish'
            });
            _this.triggerOnFieldsChange(resultNamePathList, results);
        });
        var returnPromise = summaryPromise.then(function() {
            if (_this.lastValidatePromise === summaryPromise) return Promise.resolve(_this.getFieldsValue(namePathList));
            return Promise.reject([]);
        }).catch(function(results) {
            var errorList = results.filter(function(result) {
                return result && result.errors.length;
            });
            return Promise.reject({
                values: _this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: _this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch(function(e) {
            return e;
        });
        // `validating` changed. Trigger `onFieldsChange`
        var triggerNamePathList = namePathList.filter(function(namePath) {
            return validateNamePathList.has(namePath.join(TMP_SPLIT));
        });
        _this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    });
    // ============================ Submit ============================
    (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)(this, "submit", function() {
        _this.warningUnhooked();
        _this.validateFields().then(function(values) {
            var onFinish = _this.callbacks.onFinish;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch(function(e) {
            var onFinishFailed = _this.callbacks.onFinishFailed;
            if (onFinishFailed) onFinishFailed(e);
        });
    });
    this.forceRootUpdate = forceRootUpdate;
});
function $5e50076ee2f6a09b$var$useForm(form) {
    var formRef = $eeyUA.useRef();
    var _React$useState = $eeyUA.useState({}), _React$useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_React$useState, 2), forceUpdate = _React$useState2[1];
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            var forceReRender = function forceReRender() {
                forceUpdate({});
            };
            var formStore = new $5e50076ee2f6a09b$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $5e50076ee2f6a09b$export$2e2bcd8739ae039 = $5e50076ee2f6a09b$var$useForm;



var $7Nobb = parcelRequire("7Nobb");




var $eeyUA = parcelRequire("eeyUA");





var $eeyUA = parcelRequire("eeyUA");
var $f7738c2983cc7006$var$FormContext = /*#__PURE__*/ $eeyUA.createContext({
    triggerFormChange: function triggerFormChange() {},
    triggerFormFinish: function triggerFormFinish() {},
    registerForm: function registerForm() {},
    unregisterForm: function unregisterForm() {}
});
var $f7738c2983cc7006$export$8ce1ff4f94d08846 = function FormProvider(_ref) {
    var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
    var formContext = $eeyUA.useContext($f7738c2983cc7006$var$FormContext);
    var formsRef = $eeyUA.useRef({});
    return /*#__PURE__*/ $eeyUA.createElement($f7738c2983cc7006$var$FormContext.Provider, {
        value: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, formContext), {}, {
            validateMessages: (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, formContext.validateMessages), validateMessages),
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: function triggerFormChange(name, changedFields) {
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: function triggerFormFinish(name, values) {
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: function registerForm(name, form) {
                if (name) formsRef.current = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, formsRef.current), {}, (0, $8ac9efdfad2454a3$export$2e2bcd8739ae039)({}, name, form));
                formContext.registerForm(name, form);
            },
            unregisterForm: function unregisterForm(name) {
                var newForms = (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, formsRef.current);
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        })
    }, children);
};
var $f7738c2983cc7006$export$2e2bcd8739ae039 = $f7738c2983cc7006$var$FormContext;




var $91ee0e8c69ee6369$var$_excluded = [
    "name",
    "initialValues",
    "fields",
    "form",
    "preserve",
    "children",
    "component",
    "validateMessages",
    "validateTrigger",
    "onValuesChange",
    "onFieldsChange",
    "onFinish",
    "onFinishFailed",
    "clearOnDestroy"
];
var $91ee0e8c69ee6369$var$Form = function Form(_ref, ref) {
    var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component = _ref$component === void 0 ? 'form' : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? 'onChange' : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, clearOnDestroy = _ref.clearOnDestroy, restProps = (0, $5a329839a83d6c12$export$2e2bcd8739ae039)(_ref, $91ee0e8c69ee6369$var$_excluded);
    var nativeElementRef = $eeyUA.useRef(null);
    var formContext = $eeyUA.useContext((0, $f7738c2983cc7006$export$2e2bcd8739ae039));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    var _useForm = (0, $5e50076ee2f6a09b$export$2e2bcd8739ae039)(form), _useForm2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useForm, 1), formInstance = _useForm2[0];
    var _getInternalHooks = formInstance.getInternalHooks((0, $176a86e7f5cc56f5$export$24829b7c0e49e9f7)), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
    // Pass ref with form instance
    $eeyUA.useImperativeHandle(ref, function() {
        return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, formInstance), {}, {
            nativeElement: nativeElementRef.current
        });
    });
    // Register form into Context
    $eeyUA.useEffect(function() {
        formContext.registerForm(name, formInstance);
        return function() {
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, formContext.validateMessages), validateMessages));
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: function onFieldsChange(changedFields) {
            formContext.triggerFormChange(name, changedFields);
            if (_onFieldsChange) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
                _onFieldsChange.apply(void 0, [
                    changedFields
                ].concat(rest));
            }
        },
        onFinish: function onFinish(values) {
            formContext.triggerFormFinish(name, values);
            if (_onFinish) _onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    var mountRef = $eeyUA.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    $eeyUA.useEffect(function() {
        return function() {
            return destroyForm(clearOnDestroy);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    var childrenNode;
    var childrenRenderProps = typeof children === 'function';
    if (childrenRenderProps) {
        var _values = formInstance.getFieldsValue(true);
        childrenNode = children(_values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    var prevFieldsRef = $eeyUA.useRef();
    $eeyUA.useEffect(function() {
        if (!(0, $b84aa89359563276$export$dfcec05bb7372a54)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    var formContextValue = $eeyUA.useMemo(function() {
        return (0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)((0, $9d79fabd39cd20fa$export$2e2bcd8739ae039)({}, formInstance), {}, {
            validateTrigger: validateTrigger
        });
    }, [
        formInstance,
        validateTrigger
    ]);
    var wrapperNode = /*#__PURE__*/ $eeyUA.createElement((0, $21aa92066fb7255e$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $eeyUA.createElement((0, $176a86e7f5cc56f5$export$2e2bcd8739ae039).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $eeyUA.createElement(Component, (0, $7Nobb.default)({}, restProps, {
        ref: nativeElementRef,
        onSubmit: function onSubmit(event) {
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: function onReset(event) {
            var _restProps$onReset;
            event.preventDefault();
            formInstance.resetFields();
            (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
        }
    }), wrapperNode);
};
var $91ee0e8c69ee6369$export$2e2bcd8739ae039 = $91ee0e8c69ee6369$var$Form;








var $eeyUA = parcelRequire("eeyUA");



function $c50955d586179d38$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch (err) {
        return Math.random();
    }
}
var $c50955d586179d38$var$useWatchWarning = function() {};
// ------- selector type -------
// ------- selector type end -------
function $c50955d586179d38$var$useWatch() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var dependencies = args[0], _args$ = args[1], _form = _args$ === void 0 ? {} : _args$;
    var options = (0, $0ac46302870a674a$export$717b316e73068e8d)(_form) ? {
        form: _form
    } : _form;
    var form = options.form;
    var _useState = (0, $eeyUA.useState)(), _useState2 = (0, $99519ca24d40826a$export$2e2bcd8739ae039)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueStr = (0, $eeyUA.useMemo)(function() {
        return $c50955d586179d38$export$fac44ee5b035f737(value);
    }, [
        value
    ]);
    var valueStrRef = (0, $eeyUA.useRef)(valueStr);
    valueStrRef.current = valueStr;
    var fieldContext = (0, $eeyUA.useContext)((0, $176a86e7f5cc56f5$export$2e2bcd8739ae039));
    var formInstance = form || fieldContext;
    var isValidForm = formInstance && formInstance._init;
    var namePath = (0, $b84aa89359563276$export$f877b3cb4cb4ccf9)(dependencies);
    var namePathRef = (0, $eeyUA.useRef)(namePath);
    namePathRef.current = namePath;
    $c50955d586179d38$var$useWatchWarning(namePath);
    (0, $eeyUA.useEffect)(function() {
        // Skip if not exist form instance
        if (!isValidForm) return;
        var getFieldsValue = formInstance.getFieldsValue, getInternalHooks = formInstance.getInternalHooks;
        var _getInternalHooks = getInternalHooks((0, $176a86e7f5cc56f5$export$24829b7c0e49e9f7)), registerWatch = _getInternalHooks.registerWatch;
        var getWatchValue = function getWatchValue(values, allValues) {
            var watchValue = options.preserve ? allValues : values;
            return typeof dependencies === 'function' ? dependencies(watchValue) : (0, $e27746190091cddd$export$2e2bcd8739ae039)(watchValue, namePathRef.current);
        };
        var cancelRegister = registerWatch(function(values, allValues) {
            var newValue = getWatchValue(values, allValues);
            var nextValueStr = $c50955d586179d38$export$fac44ee5b035f737(newValue);
            // Compare stringify in case it's nest object
            if (valueStrRef.current !== nextValueStr) {
                valueStrRef.current = nextValueStr;
                setValue(newValue);
            }
        });
        // TODO: We can improve this perf in future
        var initialValue = getWatchValue(getFieldsValue(), getFieldsValue(true));
        // React 18 has the bug that will queue update twice even the value is not changed
        // ref: https://github.com/facebook/react/issues/27213
        if (value !== initialValue) setValue(initialValue);
        return cancelRegister;
    }, // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isValidForm
    ]);
    return value;
}
var $c50955d586179d38$export$2e2bcd8739ae039 = $c50955d586179d38$var$useWatch;


var $bcc35db49b2b6c53$var$InternalForm = /*#__PURE__*/ $eeyUA.forwardRef((0, $91ee0e8c69ee6369$export$2e2bcd8739ae039));
var $bcc35db49b2b6c53$var$RefForm = $bcc35db49b2b6c53$var$InternalForm;
$bcc35db49b2b6c53$var$RefForm.FormProvider = (0, $f7738c2983cc7006$export$8ce1ff4f94d08846);
$bcc35db49b2b6c53$var$RefForm.Field = (0, $1048db12e21a7df2$export$2e2bcd8739ae039);
$bcc35db49b2b6c53$var$RefForm.List = (0, $33028f92388f9fed$export$2e2bcd8739ae039);
$bcc35db49b2b6c53$var$RefForm.useForm = (0, $5e50076ee2f6a09b$export$2e2bcd8739ae039);
$bcc35db49b2b6c53$var$RefForm.useWatch = (0, $c50955d586179d38$export$2e2bcd8739ae039);
var $bcc35db49b2b6c53$export$2e2bcd8739ae039 = $bcc35db49b2b6c53$var$RefForm;



"use client";
const $4e91742d0358bed4$export$c24727297075ec6a = /*#__PURE__*/ $eeyUA.createContext({
    labelAlign: 'right',
    layout: 'horizontal',
    itemRef: ()=>{}
});
const $4e91742d0358bed4$export$d718247e9f9b0b9e = /*#__PURE__*/ $eeyUA.createContext(null);
const $4e91742d0358bed4$export$8ce1ff4f94d08846 = (props)=>{
    const providerProps = (0, $26e0f2bfdd13a109$export$2e2bcd8739ae039)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $eeyUA.createElement((0, $f7738c2983cc7006$export$8ce1ff4f94d08846), Object.assign({}, providerProps));
};
const $4e91742d0358bed4$export$fb6582d3042cc879 = /*#__PURE__*/ $eeyUA.createContext({
    prefixCls: ''
});
const $4e91742d0358bed4$export$bbb5553c6c7a14ed = /*#__PURE__*/ $eeyUA.createContext({});
const $4e91742d0358bed4$export$80e4c53cb85dcab1 = ({ children: children, status: status, override: override })=>{
    const formItemInputContext = $eeyUA.useContext($4e91742d0358bed4$export$bbb5553c6c7a14ed);
    const newFormItemInputContext = $eeyUA.useMemo(()=>{
        const newContext = Object.assign({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $eeyUA.createElement($4e91742d0358bed4$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};
const $4e91742d0358bed4$export$6f0555dad42725fb = /*#__PURE__*/ $eeyUA.createContext(undefined);



"use client";
const $54aba063db3ce030$var$ContextIsolator = (props)=>{
    const { space: space, form: form, children: children } = props;
    if (children === undefined || children === null) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $4e91742d0358bed4$export$80e4c53cb85dcab1), {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $b246d7f7ea639ac8$export$5f56e610a4afb685), null, result);
    return result;
};
var $54aba063db3ce030$export$2e2bcd8739ae039 = $54aba063db3ce030$var$ContextIsolator;



var $eeyUA = parcelRequire("eeyUA");




function $c8b3dff41e99083e$var$mergeProps(...items) {
    const ret = {};
    items.forEach((item)=>{
        if (item) Object.keys(item).forEach((key)=>{
            if (item[key] !== undefined) ret[key] = item[key];
        });
    });
    return ret;
}
var $c8b3dff41e99083e$export$2e2bcd8739ae039 = $c8b3dff41e99083e$var$mergeProps;


"use client";
function $3d28c4e84016e3c1$export$51ad9c30389f050b(context) {
    if (!context) return undefined;
    const { closable: closable, closeIcon: closeIcon } = context;
    return {
        closable: closable,
        closeIcon: closeIcon
    };
}
/** Convert `closable` and `closeIcon` to config object */ function $3d28c4e84016e3c1$var$useClosableConfig(closableCollection) {
    const { closable: closable, closeIcon: closeIcon } = closableCollection || {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useMemo(()=>{
        if (// If `closable`, whatever rest be should be true
        !closable && (closable === false || closeIcon === false || closeIcon === null)) return false;
        if (closable === undefined && closeIcon === undefined) return null;
        let closableConfig = {
            closeIcon: typeof closeIcon !== 'boolean' && closeIcon !== null ? closeIcon : undefined
        };
        if (closable && typeof closable === 'object') closableConfig = Object.assign(Object.assign({}, closableConfig), closable);
        return closableConfig;
    }, [
        closable,
        closeIcon
    ]);
}
/** Use same object to support `useMemo` optimization */ const $3d28c4e84016e3c1$var$EmptyFallbackCloseCollection = {};
const $3d28c4e84016e3c1$export$aa101db403ccf5f3 = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = $3d28c4e84016e3c1$var$EmptyFallbackCloseCollection)=>{
    // Align the `props`, `context` `fallback` to config object first
    const propCloseConfig = $3d28c4e84016e3c1$var$useClosableConfig(propCloseCollection);
    const contextCloseConfig = $3d28c4e84016e3c1$var$useClosableConfig(contextCloseCollection);
    const [contextLocale] = (0, $6d3e114ae5f0e28f$export$2e2bcd8739ae039)('global', (0, $535519d587587ff4$export$2e2bcd8739ae039).global);
    const closeBtnIsDisabled = typeof propCloseConfig !== 'boolean' ? !!(propCloseConfig === null || propCloseConfig === void 0 ? void 0 : propCloseConfig.disabled) : false;
    const mergedFallbackCloseCollection = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useMemo(()=>Object.assign({
            closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $e2f667acd0c5267b$export$2e2bcd8739ae039), null)
        }, fallbackCloseCollection), [
        fallbackCloseCollection
    ]);
    // Use fallback logic to fill the config
    const mergedClosableConfig = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useMemo(()=>{
        // ================ Props First ================
        // Skip if prop is disabled
        if (propCloseConfig === false) return false;
        if (propCloseConfig) return (0, $c8b3dff41e99083e$export$2e2bcd8739ae039)(mergedFallbackCloseCollection, contextCloseConfig, propCloseConfig);
        // =============== Context Second ==============
        // Skip if context is disabled
        if (contextCloseConfig === false) return false;
        if (contextCloseConfig) return (0, $c8b3dff41e99083e$export$2e2bcd8739ae039)(mergedFallbackCloseCollection, contextCloseConfig);
        // ============= Fallback Default ==============
        return !mergedFallbackCloseCollection.closable ? false : mergedFallbackCloseCollection;
    }, [
        propCloseConfig,
        contextCloseConfig,
        mergedFallbackCloseCollection
    ]);
    // Calculate the final closeIcon
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useMemo(()=>{
        var _a, _b;
        if (mergedClosableConfig === false) return [
            false,
            null,
            closeBtnIsDisabled,
            {}
        ];
        const { closeIconRender: closeIconRender } = mergedFallbackCloseCollection;
        const { closeIcon: closeIcon } = mergedClosableConfig;
        let mergedCloseIcon = closeIcon;
        // Wrap the closeIcon with aria props
        const ariaOrDataProps = (0, $2b6013c7a3c0e965$export$2e2bcd8739ae039)(mergedClosableConfig, true);
        if (mergedCloseIcon !== null && mergedCloseIcon !== undefined) {
            // Wrap the closeIcon if needed
            if (closeIconRender) mergedCloseIcon = closeIconRender(closeIcon);
            mergedCloseIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).isValidElement(mergedCloseIcon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).cloneElement(mergedCloseIcon, Object.assign(Object.assign(Object.assign({}, mergedCloseIcon.props), {
                'aria-label': (_b = (_a = mergedCloseIcon.props) === null || _a === void 0 ? void 0 : _a['aria-label']) !== null && _b !== void 0 ? _b : contextLocale.close
            }), ariaOrDataProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("span", Object.assign({
                "aria-label": contextLocale.close
            }, ariaOrDataProps), mergedCloseIcon);
        }
        return [
            true,
            mergedCloseIcon,
            closeBtnIsDisabled,
            ariaOrDataProps
        ];
    }, [
        closeBtnIsDisabled,
        contextLocale.close,
        mergedClosableConfig,
        mergedFallbackCloseCollection
    ]);
};





var $2a384556ac0c94fa$var$isStyleNameSupport = function isStyleNameSupport(styleName) {
    if ((0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)() && window.document.documentElement) {
        var styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        var documentElement = window.document.documentElement;
        return styleNameList.some(function(name) {
            return name in documentElement.style;
        });
    }
    return false;
};
var $2a384556ac0c94fa$var$isStyleValueSupport = function isStyleValueSupport(styleName, value) {
    if (!$2a384556ac0c94fa$var$isStyleNameSupport(styleName)) return false;
    var ele = document.createElement('div');
    var origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $2a384556ac0c94fa$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $2a384556ac0c94fa$var$isStyleValueSupport(styleName, styleValue);
    return $2a384556ac0c94fa$var$isStyleNameSupport(styleName);
}


const $93e9c4f5e5301ab9$export$7dbdadf5e9653129 = ()=>(0, $cfc14895ce0a1d11$export$2e2bcd8739ae039)() && window.document.documentElement;






/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ const $600dec3f5c51945c$var$useCSSVarCls = (prefixCls)=>{
    const [, , , , cssVar] = (0, $77023b8a2ee37055$export$2e2bcd8739ae039)();
    return cssVar ? `${prefixCls}-css-var` : '';
};
var $600dec3f5c51945c$export$2e2bcd8739ae039 = $600dec3f5c51945c$var$useCSSVarCls;



var $eeyUA = parcelRequire("eeyUA");



var $eeyUA = parcelRequire("eeyUA");




var $eeyUA = parcelRequire("eeyUA");

"use client";
const $1b14882805b99266$var$Element = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, size: size, shape: shape } = props;
    const sizeCls = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))({
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-sm`]: size === 'small'
    });
    const shapeCls = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))({
        [`${prefixCls}-circle`]: shape === 'circle',
        [`${prefixCls}-square`]: shape === 'square',
        [`${prefixCls}-round`]: shape === 'round'
    });
    const sizeStyle = $eeyUA.useMemo(()=>typeof size === 'number' ? {
            width: size,
            height: size,
            lineHeight: `${size}px`
        } : {}, [
        size
    ]);
    return /*#__PURE__*/ $eeyUA.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, sizeCls, shapeCls, className),
        style: Object.assign(Object.assign({}, sizeStyle), style)
    });
};
var $1b14882805b99266$export$2e2bcd8739ae039 = $1b14882805b99266$var$Element;




const $242770e8fa8c9803$var$skeletonClsLoading = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)(`ant-skeleton-loading`, {
    '0%': {
        backgroundPosition: '100% 50%'
    },
    '100%': {
        backgroundPosition: '0 50%'
    }
});
const $242770e8fa8c9803$var$genSkeletonElementCommonSize = (size)=>({
        height: size,
        lineHeight: (0, $2c076defa05cd41b$export$523c0b569236b342)(size)
    });
const $242770e8fa8c9803$var$genSkeletonElementAvatarSize = (size)=>Object.assign({
        width: size
    }, $242770e8fa8c9803$var$genSkeletonElementCommonSize(size));
const $242770e8fa8c9803$var$genSkeletonColor = (token)=>({
        background: token.skeletonLoadingBackground,
        backgroundSize: '400% 100%',
        animationName: $242770e8fa8c9803$var$skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: 'ease',
        animationIterationCount: 'infinite'
    });
const $242770e8fa8c9803$var$genSkeletonElementInputSize = (size, calc)=>Object.assign({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal()
    }, $242770e8fa8c9803$var$genSkeletonElementCommonSize(size));
const $242770e8fa8c9803$var$genSkeletonElementAvatar = (token)=>{
    const { skeletonAvatarCls: skeletonAvatarCls, gradientFromColor: gradientFromColor, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM } = token;
    return {
        [skeletonAvatarCls]: Object.assign({
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor
        }, $242770e8fa8c9803$var$genSkeletonElementAvatarSize(controlHeight)),
        [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
            borderRadius: '50%'
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: Object.assign({}, $242770e8fa8c9803$var$genSkeletonElementAvatarSize(controlHeightLG)),
        [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: Object.assign({}, $242770e8fa8c9803$var$genSkeletonElementAvatarSize(controlHeightSM))
    };
};
const $242770e8fa8c9803$var$genSkeletonElementInput = (token)=>{
    const { controlHeight: controlHeight, borderRadiusSM: borderRadiusSM, skeletonInputCls: skeletonInputCls, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonInputCls]: Object.assign({
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM
        }, $242770e8fa8c9803$var$genSkeletonElementInputSize(controlHeight, calc)),
        [`${skeletonInputCls}-lg`]: Object.assign({}, $242770e8fa8c9803$var$genSkeletonElementInputSize(controlHeightLG, calc)),
        [`${skeletonInputCls}-sm`]: Object.assign({}, $242770e8fa8c9803$var$genSkeletonElementInputSize(controlHeightSM, calc))
    };
};
const $242770e8fa8c9803$var$genSkeletonElementImageSize = (size)=>Object.assign({
        width: size
    }, $242770e8fa8c9803$var$genSkeletonElementCommonSize(size));
const $242770e8fa8c9803$var$genSkeletonElementImage = (token)=>{
    const { skeletonImageCls: skeletonImageCls, imageSizeBase: imageSizeBase, gradientFromColor: gradientFromColor, borderRadiusSM: borderRadiusSM, calc: calc } = token;
    return {
        [skeletonImageCls]: Object.assign(Object.assign({
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            verticalAlign: 'middle',
            background: gradientFromColor,
            borderRadius: borderRadiusSM
        }, $242770e8fa8c9803$var$genSkeletonElementImageSize(calc(imageSizeBase).mul(2).equal())), {
            [`${skeletonImageCls}-path`]: {
                fill: '#bfbfbf'
            },
            [`${skeletonImageCls}-svg`]: Object.assign(Object.assign({}, $242770e8fa8c9803$var$genSkeletonElementImageSize(imageSizeBase)), {
                maxWidth: calc(imageSizeBase).mul(4).equal(),
                maxHeight: calc(imageSizeBase).mul(4).equal()
            }),
            [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
                borderRadius: '50%'
            }
        }),
        [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
            borderRadius: '50%'
        }
    };
};
const $242770e8fa8c9803$var$genSkeletonElementButtonShape = (token, size, buttonCls)=>{
    const { skeletonButtonCls: skeletonButtonCls } = token;
    return {
        [`${buttonCls}${skeletonButtonCls}-circle`]: {
            width: size,
            minWidth: size,
            borderRadius: '50%'
        },
        [`${buttonCls}${skeletonButtonCls}-round`]: {
            borderRadius: size
        }
    };
};
const $242770e8fa8c9803$var$genSkeletonElementButtonSize = (size, calc)=>Object.assign({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal()
    }, $242770e8fa8c9803$var$genSkeletonElementCommonSize(size));
const $242770e8fa8c9803$var$genSkeletonElementButton = (token)=>{
    const { borderRadiusSM: borderRadiusSM, skeletonButtonCls: skeletonButtonCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        [skeletonButtonCls]: Object.assign({
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            width: calc(controlHeight).mul(2).equal(),
            minWidth: calc(controlHeight).mul(2).equal()
        }, $242770e8fa8c9803$var$genSkeletonElementButtonSize(controlHeight, calc))
    }, $242770e8fa8c9803$var$genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls)), {
        [`${skeletonButtonCls}-lg`]: Object.assign({}, $242770e8fa8c9803$var$genSkeletonElementButtonSize(controlHeightLG, calc))
    }), $242770e8fa8c9803$var$genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`)), {
        [`${skeletonButtonCls}-sm`]: Object.assign({}, $242770e8fa8c9803$var$genSkeletonElementButtonSize(controlHeightSM, calc))
    }), $242770e8fa8c9803$var$genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`));
};
// =============================== Base ===============================
const $242770e8fa8c9803$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, skeletonAvatarCls: skeletonAvatarCls, skeletonTitleCls: skeletonTitleCls, skeletonParagraphCls: skeletonParagraphCls, skeletonButtonCls: skeletonButtonCls, skeletonInputCls: skeletonInputCls, skeletonImageCls: skeletonImageCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, padding: padding, marginSM: marginSM, borderRadius: borderRadius, titleHeight: titleHeight, blockRadius: blockRadius, paragraphLiHeight: paragraphLiHeight, controlHeightXS: controlHeightXS, paragraphMarginTop: paragraphMarginTop } = token;
    return {
        [componentCls]: {
            display: 'table',
            width: '100%',
            [`${componentCls}-header`]: {
                display: 'table-cell',
                paddingInlineEnd: padding,
                verticalAlign: 'top',
                // Avatar
                [skeletonAvatarCls]: Object.assign({
                    display: 'inline-block',
                    verticalAlign: 'top',
                    background: gradientFromColor
                }, $242770e8fa8c9803$var$genSkeletonElementAvatarSize(controlHeight)),
                [`${skeletonAvatarCls}-circle`]: {
                    borderRadius: '50%'
                },
                [`${skeletonAvatarCls}-lg`]: Object.assign({}, $242770e8fa8c9803$var$genSkeletonElementAvatarSize(controlHeightLG)),
                [`${skeletonAvatarCls}-sm`]: Object.assign({}, $242770e8fa8c9803$var$genSkeletonElementAvatarSize(controlHeightSM))
            },
            [`${componentCls}-content`]: {
                display: 'table-cell',
                width: '100%',
                verticalAlign: 'top',
                // Title
                [skeletonTitleCls]: {
                    width: '100%',
                    height: titleHeight,
                    background: gradientFromColor,
                    borderRadius: blockRadius,
                    [`+ ${skeletonParagraphCls}`]: {
                        marginBlockStart: controlHeightSM
                    }
                },
                // paragraph
                [skeletonParagraphCls]: {
                    padding: 0,
                    '> li': {
                        width: '100%',
                        height: paragraphLiHeight,
                        listStyle: 'none',
                        background: gradientFromColor,
                        borderRadius: blockRadius,
                        '+ li': {
                            marginBlockStart: controlHeightXS
                        }
                    }
                },
                [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
                    width: '61%'
                }
            },
            [`&-round ${componentCls}-content`]: {
                [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
                    borderRadius: borderRadius
                }
            }
        },
        [`${componentCls}-with-avatar ${componentCls}-content`]: {
            // Title
            [skeletonTitleCls]: {
                marginBlockStart: marginSM,
                [`+ ${skeletonParagraphCls}`]: {
                    marginBlockStart: paragraphMarginTop
                }
            }
        },
        // Skeleton element
        [`${componentCls}${componentCls}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
            display: 'inline-block',
            width: 'auto'
        }, $242770e8fa8c9803$var$genSkeletonElementButton(token)), $242770e8fa8c9803$var$genSkeletonElementAvatar(token)), $242770e8fa8c9803$var$genSkeletonElementInput(token)), $242770e8fa8c9803$var$genSkeletonElementImage(token)),
        // Skeleton Block Button, Input
        [`${componentCls}${componentCls}-block`]: {
            width: '100%',
            [skeletonButtonCls]: {
                width: '100%'
            },
            [skeletonInputCls]: {
                width: '100%'
            }
        },
        // With active animation
        [`${componentCls}${componentCls}-active`]: {
            [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonImageCls}
      `]: Object.assign({}, $242770e8fa8c9803$var$genSkeletonColor(token))
        }
    };
};
const $242770e8fa8c9803$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillContent: colorFillContent, colorFill: colorFill } = token;
    const gradientFromColor = colorFillContent;
    const gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor: gradientFromColor,
        gradientToColor: gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
var $242770e8fa8c9803$export$2e2bcd8739ae039 = (0, $16d63ad40d593937$export$51ec95de45185b42)('Skeleton', (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    const skeletonToken = (0, $0dfcc8c9c107e242$export$4950aa0f605343fb)(token, {
        skeletonAvatarCls: `${componentCls}-avatar`,
        skeletonTitleCls: `${componentCls}-title`,
        skeletonParagraphCls: `${componentCls}-paragraph`,
        skeletonButtonCls: `${componentCls}-button`,
        skeletonInputCls: `${componentCls}-input`,
        skeletonImageCls: `${componentCls}-image`,
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
        skeletonLoadingMotionDuration: '1.4s'
    });
    return $242770e8fa8c9803$var$genBaseStyle(skeletonToken);
}, $242770e8fa8c9803$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            'color',
            'gradientFromColor'
        ],
        [
            'colorGradientEnd',
            'gradientToColor'
        ]
    ]
});


"use client";
const $09a9997b7ade1d46$var$SkeletonAvatar = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, shape: shape = 'circle', size: size = 'default' } = props;
    const { getPrefixCls: getPrefixCls } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $242770e8fa8c9803$export$2e2bcd8739ae039)(prefixCls);
    const otherProps = (0, $26e0f2bfdd13a109$export$2e2bcd8739ae039)(props, [
        'prefixCls',
        'className'
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $eeyUA.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $eeyUA.createElement((0, $1b14882805b99266$export$2e2bcd8739ae039), Object.assign({
        prefixCls: `${prefixCls}-avatar`,
        shape: shape,
        size: size
    }, otherProps))));
};
var $09a9997b7ade1d46$export$2e2bcd8739ae039 = $09a9997b7ade1d46$var$SkeletonAvatar;



var $eeyUA = parcelRequire("eeyUA");





"use client";
const $be74c75078f31193$var$SkeletonButton = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, block: block = false, size: size = 'default' } = props;
    const { getPrefixCls: getPrefixCls } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $242770e8fa8c9803$export$2e2bcd8739ae039)(prefixCls);
    const otherProps = (0, $26e0f2bfdd13a109$export$2e2bcd8739ae039)(props, [
        'prefixCls'
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $eeyUA.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $eeyUA.createElement((0, $1b14882805b99266$export$2e2bcd8739ae039), Object.assign({
        prefixCls: `${prefixCls}-button`,
        size: size
    }, otherProps))));
};
var $be74c75078f31193$export$2e2bcd8739ae039 = $be74c75078f31193$var$SkeletonButton;




var $eeyUA = parcelRequire("eeyUA");



"use client";
const $c2d329ded8b6e346$var$path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';
const $c2d329ded8b6e346$var$SkeletonImage = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, active: active } = props;
    const { getPrefixCls: getPrefixCls } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $242770e8fa8c9803$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $eeyUA.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $eeyUA.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(`${prefixCls}-image`, className),
        style: style
    }, /*#__PURE__*/ $eeyUA.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${prefixCls}-image-svg`
    }, /*#__PURE__*/ $eeyUA.createElement("title", null, "Image placeholder"), /*#__PURE__*/ $eeyUA.createElement("path", {
        d: $c2d329ded8b6e346$var$path,
        className: `${prefixCls}-image-path`
    })))));
};
var $c2d329ded8b6e346$export$2e2bcd8739ae039 = $c2d329ded8b6e346$var$SkeletonImage;



var $eeyUA = parcelRequire("eeyUA");





"use client";
const $99b2cbf75e812f33$var$SkeletonInput = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, block: block, size: size = 'default' } = props;
    const { getPrefixCls: getPrefixCls } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $242770e8fa8c9803$export$2e2bcd8739ae039)(prefixCls);
    const otherProps = (0, $26e0f2bfdd13a109$export$2e2bcd8739ae039)(props, [
        'prefixCls'
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $eeyUA.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $eeyUA.createElement((0, $1b14882805b99266$export$2e2bcd8739ae039), Object.assign({
        prefixCls: `${prefixCls}-input`,
        size: size
    }, otherProps))));
};
var $99b2cbf75e812f33$export$2e2bcd8739ae039 = $99b2cbf75e812f33$var$SkeletonInput;



var $eeyUA = parcelRequire("eeyUA");



"use client";
const $582f01d5fbc72e04$var$SkeletonNode = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, active: active, children: children } = props;
    const { getPrefixCls: getPrefixCls } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $242770e8fa8c9803$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, hashId, className, rootClassName, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $eeyUA.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $eeyUA.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(`${prefixCls}-image`, className),
        style: style
    }, children)));
};
var $582f01d5fbc72e04$export$2e2bcd8739ae039 = $582f01d5fbc72e04$var$SkeletonNode;



var $eeyUA = parcelRequire("eeyUA");

"use client";
const $bf35e6eaddae3633$var$getWidth = (index, props)=>{
    const { width: width, rows: rows = 2 } = props;
    if (Array.isArray(width)) return width[index];
    // last paragraph
    if (rows - 1 === index) return width;
    return undefined;
};
const $bf35e6eaddae3633$var$Paragraph = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, rows: rows = 0 } = props;
    const rowList = Array.from({
        length: rows
    }).map((_, index)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $eeyUA.createElement("li", {
            key: index,
            style: {
                width: $bf35e6eaddae3633$var$getWidth(index, props)
            }
        }));
    return /*#__PURE__*/ $eeyUA.createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, className),
        style: style
    }, rowList);
};
var $bf35e6eaddae3633$export$2e2bcd8739ae039 = $bf35e6eaddae3633$var$Paragraph;




var $eeyUA = parcelRequire("eeyUA");

"use client";
const $7b1eacc48197405e$var$Title = ({ prefixCls: prefixCls, className: className, width: width, style: style })=>/*#__PURE__*/ // biome-ignore lint/a11y/useHeadingContent: HOC here
    $eeyUA.createElement("h3", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, className),
        style: Object.assign({
            width: width
        }, style)
    });
var $7b1eacc48197405e$export$2e2bcd8739ae039 = $7b1eacc48197405e$var$Title;


"use client";
function $e9390a0bc86412cb$var$getComponentProps(prop) {
    if (prop && typeof prop === 'object') return prop;
    return {};
}
function $e9390a0bc86412cb$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: 'large',
        shape: 'square'
    };
    return {
        size: 'large',
        shape: 'circle'
    };
}
function $e9390a0bc86412cb$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: '38%'
    };
    if (hasAvatar && hasParagraph) return {
        width: '50%'
    };
    return {};
}
function $e9390a0bc86412cb$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = '61%';
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
const $e9390a0bc86412cb$var$Skeleton = (props)=>{
    const { prefixCls: customizePrefixCls, loading: loading, className: className, rootClassName: rootClassName, style: style, children: children, avatar: avatar = false, title: title = true, paragraph: paragraph = true, active: active, round: round } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle } = (0, $0b79f8c0c8222aa8$export$46f4bd6436a25a31)('skeleton');
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $242770e8fa8c9803$export$2e2bcd8739ae039)(prefixCls);
    if (loading || !('loading' in props)) {
        const hasAvatar = !!avatar;
        const hasTitle = !!title;
        const hasParagraph = !!paragraph;
        // Avatar
        let avatarNode;
        if (hasAvatar) {
            const avatarProps = Object.assign(Object.assign({
                prefixCls: `${prefixCls}-avatar`
            }, $e9390a0bc86412cb$var$getAvatarBasicProps(hasTitle, hasParagraph)), $e9390a0bc86412cb$var$getComponentProps(avatar));
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ $eeyUA.createElement("div", {
                className: `${prefixCls}-header`
            }, /*#__PURE__*/ $eeyUA.createElement((0, $1b14882805b99266$export$2e2bcd8739ae039), Object.assign({}, avatarProps)));
        }
        let contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            let $title;
            if (hasTitle) {
                const titleProps = Object.assign(Object.assign({
                    prefixCls: `${prefixCls}-title`
                }, $e9390a0bc86412cb$var$getTitleBasicProps(hasAvatar, hasParagraph)), $e9390a0bc86412cb$var$getComponentProps(title));
                $title = /*#__PURE__*/ $eeyUA.createElement((0, $7b1eacc48197405e$export$2e2bcd8739ae039), Object.assign({}, titleProps));
            }
            // Paragraph
            let paragraphNode;
            if (hasParagraph) {
                const paragraphProps = Object.assign(Object.assign({
                    prefixCls: `${prefixCls}-paragraph`
                }, $e9390a0bc86412cb$var$getParagraphBasicProps(hasAvatar, hasTitle)), $e9390a0bc86412cb$var$getComponentProps(paragraph));
                paragraphNode = /*#__PURE__*/ $eeyUA.createElement((0, $bf35e6eaddae3633$export$2e2bcd8739ae039), Object.assign({}, paragraphProps));
            }
            contentNode = /*#__PURE__*/ $eeyUA.createElement("div", {
                className: `${prefixCls}-content`
            }, $title, paragraphNode);
        }
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(prefixCls, {
            [`${prefixCls}-with-avatar`]: hasAvatar,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-round`]: round
        }, contextClassName, className, rootClassName, hashId, cssVarCls);
        return wrapCSSVar(/*#__PURE__*/ $eeyUA.createElement("div", {
            className: cls,
            style: Object.assign(Object.assign({}, contextStyle), style)
        }, avatarNode, contentNode));
    }
    return children !== null && children !== void 0 ? children : null;
};
$e9390a0bc86412cb$var$Skeleton.Button = (0, $be74c75078f31193$export$2e2bcd8739ae039);
$e9390a0bc86412cb$var$Skeleton.Avatar = (0, $09a9997b7ade1d46$export$2e2bcd8739ae039);
$e9390a0bc86412cb$var$Skeleton.Input = (0, $99b2cbf75e812f33$export$2e2bcd8739ae039);
$e9390a0bc86412cb$var$Skeleton.Image = (0, $c2d329ded8b6e346$export$2e2bcd8739ae039);
$e9390a0bc86412cb$var$Skeleton.Node = (0, $582f01d5fbc72e04$export$2e2bcd8739ae039);
var $e9390a0bc86412cb$export$2e2bcd8739ae039 = $e9390a0bc86412cb$var$Skeleton;


"use client";
var $ffd6e5be065132e3$export$2e2bcd8739ae039 = (0, $e9390a0bc86412cb$export$2e2bcd8739ae039);



var $eeyUA = parcelRequire("eeyUA");

function $92b7eb127f220a4a$var$voidFunc() {}
const $92b7eb127f220a4a$var$WatermarkContext = /*#__PURE__*/ $eeyUA.createContext({
    add: $92b7eb127f220a4a$var$voidFunc,
    remove: $92b7eb127f220a4a$var$voidFunc
});
function $92b7eb127f220a4a$export$94ab53417567be34(panelSelector) {
    const watermark = $eeyUA.useContext($92b7eb127f220a4a$var$WatermarkContext);
    const panelEleRef = $eeyUA.useRef(null);
    const panelRef = (0, $5c3680878bae3f7a$export$2e2bcd8739ae039)((ele)=>{
        if (ele) {
            const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            if (innerContentEle) {
                watermark.add(innerContentEle);
                panelEleRef.current = innerContentEle;
            }
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
var $92b7eb127f220a4a$export$2e2bcd8739ae039 = $92b7eb127f220a4a$var$WatermarkContext;



var $eeyUA = parcelRequire("eeyUA");




var $eeyUA = parcelRequire("eeyUA");


"use client";
const $529518ce568d7c55$var$NormalCancelBtn = ()=>{
    const { cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, onCancel: onCancel } = (0, $eeyUA.useContext)((0, $a1cd72ffec1dc6d7$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $9c54331fbf1bdfe2$export$2e2bcd8739ae039), Object.assign({
        onClick: onCancel
    }, cancelButtonProps), cancelTextLocale);
};
var $529518ce568d7c55$export$2e2bcd8739ae039 = $529518ce568d7c55$var$NormalCancelBtn;



var $eeyUA = parcelRequire("eeyUA");



"use client";
const $59d9b7ff7c3a5d5b$var$NormalOkBtn = ()=>{
    const { confirmLoading: confirmLoading, okButtonProps: okButtonProps, okType: okType, okTextLocale: okTextLocale, onOk: onOk } = (0, $eeyUA.useContext)((0, $a1cd72ffec1dc6d7$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $9c54331fbf1bdfe2$export$2e2bcd8739ae039), Object.assign({}, (0, $eed44a28a6b1b10c$export$19bc9a290855952)(okType), {
        loading: confirmLoading,
        onClick: onOk
    }, okButtonProps), okTextLocale);
};
var $59d9b7ff7c3a5d5b$export$2e2bcd8739ae039 = $59d9b7ff7c3a5d5b$var$NormalOkBtn;




"use client";
function $2c02b2bad38f1bbf$export$97c34646962d356e(prefixCls, closeIcon) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement("span", {
        className: `${prefixCls}-close-x`
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $e2f667acd0c5267b$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    }));
}
const $2c02b2bad38f1bbf$export$a06f1c675e846f6f = (props)=>{
    const { okText: okText, okType: okType = 'primary', cancelText: cancelText, confirmLoading: confirmLoading, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, footer: footer } = props;
    const [locale] = (0, $6d3e114ae5f0e28f$export$2e2bcd8739ae039)('Modal', (0, $1519b933a5ca31be$export$1b6004afda18cd51)());
    // ================== Locale Text ==================
    const okTextLocale = okText || (locale === null || locale === void 0 ? void 0 : locale.okText);
    const cancelTextLocale = cancelText || (locale === null || locale === void 0 ? void 0 : locale.cancelText);
    const memoizedValue = (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).useMemo(()=>{
        return {
            confirmLoading: confirmLoading,
            okButtonProps: okButtonProps,
            cancelButtonProps: cancelButtonProps,
            okTextLocale: okTextLocale,
            cancelTextLocale: cancelTextLocale,
            okType: okType,
            onOk: onOk,
            onCancel: onCancel
        };
    }, [
        confirmLoading,
        okButtonProps,
        cancelButtonProps,
        okTextLocale,
        cancelTextLocale,
        okType,
        onOk,
        onCancel
    ]);
    let footerNode;
    if (typeof footer === 'function' || typeof footer === 'undefined') {
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $529518ce568d7c55$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $59d9b7ff7c3a5d5b$export$2e2bcd8739ae039), null));
        if (typeof footer === 'function') footerNode = footer(footerNode, {
            OkBtn: (0, $59d9b7ff7c3a5d5b$export$2e2bcd8739ae039),
            CancelBtn: (0, $529518ce568d7c55$export$2e2bcd8739ae039)
        });
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $a1cd72ffec1dc6d7$export$7c9538f5f3c365e9), {
            value: memoizedValue
        }, footerNode);
    } else footerNode = footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $1dece405dee1b50b$export$6adb5f3b918b11bb), {
        disabled: false
    }, footerNode);
};






// ============================== Row-Shared ==============================
const $620fcbd40b6742a0$var$genGridRowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            display: 'flex',
            flexFlow: 'row wrap',
            minWidth: 0,
            '&::before, &::after': {
                display: 'flex'
            },
            '&-no-wrap': {
                flexWrap: 'nowrap'
            },
            // The origin of the X-axis
            '&-start': {
                justifyContent: 'flex-start'
            },
            // The center of the X-axis
            '&-center': {
                justifyContent: 'center'
            },
            // The opposite of the X-axis
            '&-end': {
                justifyContent: 'flex-end'
            },
            '&-space-between': {
                justifyContent: 'space-between'
            },
            '&-space-around': {
                justifyContent: 'space-around'
            },
            '&-space-evenly': {
                justifyContent: 'space-evenly'
            },
            // Align at the top
            '&-top': {
                alignItems: 'flex-start'
            },
            // Align at the center
            '&-middle': {
                alignItems: 'center'
            },
            '&-bottom': {
                alignItems: 'flex-end'
            }
        }
    };
};
// ============================== Col-Shared ==============================
const $620fcbd40b6742a0$var$genGridColStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            position: 'relative',
            maxWidth: '100%',
            // Prevent columns from collapsing when empty
            minHeight: 1
        }
    };
};
const $620fcbd40b6742a0$var$genLoopGridColumnsStyle = (token, sizeCls)=>{
    const { prefixCls: prefixCls, componentCls: componentCls, gridColumns: gridColumns } = token;
    const gridColumnsStyle = {};
    for(let i = gridColumns; i >= 0; i--)if (i === 0) {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
            display: 'none'
        };
        gridColumnsStyle[`${componentCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: 0
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: 0
        };
    } else {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
            // https://github.com/ant-design/ant-design/issues/44456
            // Form set `display: flex` on Col which will override `display: block`.
            // Let's get it from css variable to support override.
            {
                ['--ant-display']: 'block',
                // Fallback to display if variable not support
                display: 'block'
            },
            {
                display: 'var(--ant-display)',
                flex: `0 0 ${i / gridColumns * 100}%`,
                maxWidth: `${i / gridColumns * 100}%`
            }
        ];
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: i
        };
    }
    // Flex CSS Var
    gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
        flex: `var(--${prefixCls}${sizeCls}-flex)`
    };
    return gridColumnsStyle;
};
const $620fcbd40b6742a0$var$genGridStyle = (token, sizeCls)=>$620fcbd40b6742a0$var$genLoopGridColumnsStyle(token, sizeCls);
const $620fcbd40b6742a0$var$genGridMediaStyle = (token, screenSize, sizeCls)=>({
        [`@media (min-width: ${(0, $2c076defa05cd41b$export$523c0b569236b342)(screenSize)})`]: Object.assign({}, $620fcbd40b6742a0$var$genGridStyle(token, sizeCls))
    });
const $620fcbd40b6742a0$export$519f4f378a4f8e85 = ()=>({});
const $620fcbd40b6742a0$export$5504d86ab3175593 = ()=>({});
const $620fcbd40b6742a0$export$b0d9c6b8be4e14cd = (0, $16d63ad40d593937$export$51ec95de45185b42)('Grid', $620fcbd40b6742a0$var$genGridRowStyle, $620fcbd40b6742a0$export$519f4f378a4f8e85);
const $620fcbd40b6742a0$export$6353f655434817c5 = (token)=>{
    const mediaSizesMap = {
        xs: token.screenXSMin,
        sm: token.screenSMMin,
        md: token.screenMDMin,
        lg: token.screenLGMin,
        xl: token.screenXLMin,
        xxl: token.screenXXLMin
    };
    return mediaSizesMap;
};
const $620fcbd40b6742a0$export$4d3e83959861592f = (0, $16d63ad40d593937$export$51ec95de45185b42)('Grid', (token)=>{
    const gridToken = (0, $0dfcc8c9c107e242$export$4950aa0f605343fb)(token, {
        gridColumns: 24 // Row is divided into 24 parts in Grid
    });
    const gridMediaSizesMap = $620fcbd40b6742a0$export$6353f655434817c5(gridToken);
    delete gridMediaSizesMap.xs;
    return [
        $620fcbd40b6742a0$var$genGridColStyle(gridToken),
        $620fcbd40b6742a0$var$genGridStyle(gridToken, ''),
        $620fcbd40b6742a0$var$genGridStyle(gridToken, '-xs'),
        Object.keys(gridMediaSizesMap).map((key)=>$620fcbd40b6742a0$var$genGridMediaStyle(gridToken, gridMediaSizesMap[key], `-${key}`)).reduce((pre, cur)=>Object.assign(Object.assign({}, pre), cur), {})
    ];
}, $620fcbd40b6742a0$export$5504d86ab3175593);




const $a2748644b54a3cfa$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const $a2748644b54a3cfa$var$initMotionCommonLeave = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
const $a2748644b54a3cfa$export$83e1da9e09ec9112 = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false)=>{
    const sameLevelPrefix = sameLevel ? '&' : '';
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, $a2748644b54a3cfa$var$initMotionCommon(duration)), {
            animationPlayState: 'paused'
        }),
        [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, $a2748644b54a3cfa$var$initMotionCommonLeave(duration)), {
            animationPlayState: 'paused'
        }),
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: 'running'
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: 'running',
            pointerEvents: 'none'
        }
    };
};


const $7449fed82903af24$export$82e6205b15e6c637 = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antFadeIn', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
const $7449fed82903af24$export$c091916f1530334c = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antFadeOut', {
    '0%': {
        opacity: 1
    },
    '100%': {
        opacity: 0
    }
});
const $7449fed82903af24$export$2909268c8354a12 = (token, sameLevel = false)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? '&' : '';
    return [
        (0, $a2748644b54a3cfa$export$83e1da9e09ec9112)(motionCls, $7449fed82903af24$export$82e6205b15e6c637, $7449fed82903af24$export$c091916f1530334c, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: 'linear'
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: 'linear'
            }
        }
    ];
};



const $55346cd5d8fa18e5$export$3b71758b3ed5255f = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomIn', {
    '0%': {
        transform: 'scale(0.2)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $55346cd5d8fa18e5$export$9fdb0a49c6b4b521 = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.2)',
        opacity: 0
    }
});
const $55346cd5d8fa18e5$export$be061d573c42e33a = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomBigIn', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $55346cd5d8fa18e5$export$582d93d613303da3 = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomBigOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.8)',
        opacity: 0
    }
});
const $55346cd5d8fa18e5$export$45eddd18c599b827 = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomUpIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    }
});
const $55346cd5d8fa18e5$export$a85c97750adaa37a = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomUpOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    }
});
const $55346cd5d8fa18e5$export$bd2378f7814f5f1a = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomLeftIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    }
});
const $55346cd5d8fa18e5$export$e58f88c751c4f04e = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomLeftOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    }
});
const $55346cd5d8fa18e5$export$fee1456954aef331 = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomRightIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    }
});
const $55346cd5d8fa18e5$export$811ba6d3e2adb730 = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomRightOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    }
});
const $55346cd5d8fa18e5$export$633a68aa72dec21c = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomDownIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    }
});
const $55346cd5d8fa18e5$export$1cf46a906e8dede4 = new (0, $e21e866c0a33f7b1$export$2e2bcd8739ae039)('antZoomDownOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    }
});
const $55346cd5d8fa18e5$var$zoomMotion = {
    zoom: {
        inKeyframes: $55346cd5d8fa18e5$export$3b71758b3ed5255f,
        outKeyframes: $55346cd5d8fa18e5$export$9fdb0a49c6b4b521
    },
    'zoom-big': {
        inKeyframes: $55346cd5d8fa18e5$export$be061d573c42e33a,
        outKeyframes: $55346cd5d8fa18e5$export$582d93d613303da3
    },
    'zoom-big-fast': {
        inKeyframes: $55346cd5d8fa18e5$export$be061d573c42e33a,
        outKeyframes: $55346cd5d8fa18e5$export$582d93d613303da3
    },
    'zoom-left': {
        inKeyframes: $55346cd5d8fa18e5$export$bd2378f7814f5f1a,
        outKeyframes: $55346cd5d8fa18e5$export$e58f88c751c4f04e
    },
    'zoom-right': {
        inKeyframes: $55346cd5d8fa18e5$export$fee1456954aef331,
        outKeyframes: $55346cd5d8fa18e5$export$811ba6d3e2adb730
    },
    'zoom-up': {
        inKeyframes: $55346cd5d8fa18e5$export$45eddd18c599b827,
        outKeyframes: $55346cd5d8fa18e5$export$a85c97750adaa37a
    },
    'zoom-down': {
        inKeyframes: $55346cd5d8fa18e5$export$633a68aa72dec21c,
        outKeyframes: $55346cd5d8fa18e5$export$1cf46a906e8dede4
    }
};
const $55346cd5d8fa18e5$export$f5d123412490d9dc = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $55346cd5d8fa18e5$var$zoomMotion[motionName];
    return [
        (0, $a2748644b54a3cfa$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: 'scale(0)',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                '&-prepare': {
                    transform: 'none'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};



function $0c4723a771151f77$var$box(position) {
    return {
        position: position,
        inset: 0
    };
}
const $0c4723a771151f77$export$8bb6dada04673ddd = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return [
        {
            [`${componentCls}-root`]: {
                [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
                    // reset scale avoid mousePosition bug
                    transform: 'none',
                    opacity: 0,
                    animationDuration: token.motionDurationSlow,
                    // https://github.com/ant-design/ant-design/issues/11777
                    userSelect: 'none'
                },
                // https://github.com/ant-design/ant-design/issues/37329
                // https://github.com/ant-design/ant-design/issues/40272
                [`${componentCls}${antCls}-zoom-leave ${componentCls}-content`]: {
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask`]: Object.assign(Object.assign({}, $0c4723a771151f77$var$box('fixed')), {
                    zIndex: token.zIndexPopupBase,
                    height: '100%',
                    backgroundColor: token.colorBgMask,
                    pointerEvents: 'none',
                    [`${componentCls}-hidden`]: {
                        display: 'none'
                    }
                }),
                [`${componentCls}-wrap`]: Object.assign(Object.assign({}, $0c4723a771151f77$var$box('fixed')), {
                    zIndex: token.zIndexPopupBase,
                    overflow: 'auto',
                    outline: 0,
                    WebkitOverflowScrolling: 'touch'
                })
            }
        },
        {
            [`${componentCls}-root`]: (0, $7449fed82903af24$export$2909268c8354a12)(token)
        }
    ];
};
const $0c4723a771151f77$var$genModalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        // ======================== Root =========================
        {
            [`${componentCls}-root`]: {
                [`${componentCls}-wrap-rtl`]: {
                    direction: 'rtl'
                },
                [`${componentCls}-centered`]: {
                    textAlign: 'center',
                    '&::before': {
                        display: 'inline-block',
                        width: 0,
                        height: '100%',
                        verticalAlign: 'middle',
                        content: '""'
                    },
                    [componentCls]: {
                        top: 0,
                        display: 'inline-block',
                        paddingBottom: 0,
                        textAlign: 'start',
                        verticalAlign: 'middle'
                    }
                },
                [`@media (max-width: ${token.screenSMMax}px)`]: {
                    [componentCls]: {
                        maxWidth: 'calc(100vw - 16px)',
                        margin: `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.marginXS)} auto`
                    },
                    [`${componentCls}-centered`]: {
                        [componentCls]: {
                            flex: 1
                        }
                    }
                }
            }
        },
        // ======================== Modal ========================
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $d715ae4ca001487d$export$23997c3e44cc1c59)(token)), {
                pointerEvents: 'none',
                position: 'relative',
                top: 100,
                width: 'auto',
                maxWidth: `calc(100vw - ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.calc(token.margin).mul(2).equal())})`,
                margin: '0 auto',
                paddingBottom: token.paddingLG,
                [`${componentCls}-title`]: {
                    margin: 0,
                    color: token.titleColor,
                    fontWeight: token.fontWeightStrong,
                    fontSize: token.titleFontSize,
                    lineHeight: token.titleLineHeight,
                    wordWrap: 'break-word'
                },
                [`${componentCls}-content`]: {
                    position: 'relative',
                    backgroundColor: token.contentBg,
                    backgroundClip: 'padding-box',
                    border: 0,
                    borderRadius: token.borderRadiusLG,
                    boxShadow: token.boxShadow,
                    pointerEvents: 'auto',
                    padding: token.contentPadding
                },
                [`${componentCls}-close`]: Object.assign({
                    position: 'absolute',
                    top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
                    padding: 0,
                    color: token.modalCloseIconColor,
                    fontWeight: token.fontWeightStrong,
                    lineHeight: 1,
                    textDecoration: 'none',
                    background: 'transparent',
                    borderRadius: token.borderRadiusSM,
                    width: token.modalCloseBtnSize,
                    height: token.modalCloseBtnSize,
                    border: 0,
                    outline: 0,
                    cursor: 'pointer',
                    transition: `color ${token.motionDurationMid}, background-color ${token.motionDurationMid}`,
                    '&-x': {
                        display: 'flex',
                        fontSize: token.fontSizeLG,
                        fontStyle: 'normal',
                        lineHeight: (0, $2c076defa05cd41b$export$523c0b569236b342)(token.modalCloseBtnSize),
                        justifyContent: 'center',
                        textTransform: 'none',
                        textRendering: 'auto'
                    },
                    '&:disabled': {
                        pointerEvents: 'none'
                    },
                    '&:hover': {
                        color: token.modalCloseIconHoverColor,
                        backgroundColor: token.colorBgTextHover,
                        textDecoration: 'none'
                    },
                    '&:active': {
                        backgroundColor: token.colorBgTextActive
                    }
                }, (0, $d715ae4ca001487d$export$a44db842bcb28231)(token)),
                [`${componentCls}-header`]: {
                    color: token.colorText,
                    background: token.headerBg,
                    borderRadius: `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
                    marginBottom: token.headerMarginBottom,
                    padding: token.headerPadding,
                    borderBottom: token.headerBorderBottom
                },
                [`${componentCls}-body`]: {
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    wordWrap: 'break-word',
                    padding: token.bodyPadding,
                    [`${componentCls}-body-skeleton`]: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.margin)} auto`
                    }
                },
                [`${componentCls}-footer`]: {
                    textAlign: 'end',
                    background: token.footerBg,
                    marginTop: token.footerMarginTop,
                    padding: token.footerPadding,
                    borderTop: token.footerBorderTop,
                    borderRadius: token.footerBorderRadius,
                    [`> ${token.antCls}-btn + ${token.antCls}-btn`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                [`${componentCls}-open`]: {
                    overflow: 'hidden'
                }
            })
        },
        // ======================== Pure =========================
        {
            [`${componentCls}-pure-panel`]: {
                top: 'auto',
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                [`${componentCls}-content,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 'auto'
                },
                [`${componentCls}-confirm-body`]: {
                    marginBottom: 'auto'
                }
            }
        }
    ];
};
const $0c4723a771151f77$var$genRTLStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-root`]: {
            [`${componentCls}-wrap-rtl`]: {
                direction: 'rtl',
                [`${componentCls}-confirm-body`]: {
                    direction: 'rtl'
                }
            }
        }
    };
};
const $0c4723a771151f77$var$genResponsiveWidthStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const oriGridMediaSizesMap = (0, $620fcbd40b6742a0$export$6353f655434817c5)(token);
    const gridMediaSizesMap = Object.assign({}, oriGridMediaSizesMap);
    delete gridMediaSizesMap.xs;
    const cssVarPrefix = `--${componentCls.replace('.', '')}-`;
    const responsiveStyles = Object.keys(gridMediaSizesMap).map((key)=>({
            [`@media (min-width: ${(0, $2c076defa05cd41b$export$523c0b569236b342)(gridMediaSizesMap[key])})`]: {
                width: `var(${cssVarPrefix}${key}-width)`
            }
        }));
    return {
        [`${componentCls}-root`]: {
            [componentCls]: [].concat((0, $3440102357566473$export$2e2bcd8739ae039)(Object.keys(oriGridMediaSizesMap).map((currentKey, index)=>{
                const previousKey = Object.keys(oriGridMediaSizesMap)[index - 1];
                return previousKey ? {
                    [`${cssVarPrefix}${currentKey}-width`]: `var(${cssVarPrefix}${previousKey}-width)`
                } : null;
            })), [
                {
                    width: `var(${cssVarPrefix}xs-width)`
                }
            ], (0, $3440102357566473$export$2e2bcd8739ae039)(responsiveStyles))
        }
    };
};
const $0c4723a771151f77$export$362fb92a8f81bbf9 = (token)=>{
    const headerPaddingVertical = token.padding;
    const headerFontSize = token.fontSizeHeading5;
    const headerLineHeight = token.lineHeightHeading5;
    const modalToken = (0, $0dfcc8c9c107e242$export$4950aa0f605343fb)(token, {
        modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
        modalFooterBorderColorSplit: token.colorSplit,
        modalFooterBorderStyle: token.lineType,
        modalFooterBorderWidth: token.lineWidth,
        modalCloseIconColor: token.colorIcon,
        modalCloseIconHoverColor: token.colorIconHover,
        modalCloseBtnSize: token.controlHeight,
        modalConfirmIconSize: token.fontHeight,
        modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
    });
    return modalToken;
};
const $0c4723a771151f77$export$9ca1be8807fe0675 = (token)=>({
        footerBg: 'transparent',
        headerBg: token.colorBgElevated,
        titleLineHeight: token.lineHeightHeading5,
        titleFontSize: token.fontSizeHeading5,
        contentBg: token.colorBgElevated,
        titleColor: token.colorTextHeading,
        // internal
        contentPadding: token.wireframe ? 0 : `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.paddingMD)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.paddingContentHorizontalLG)}`,
        headerPadding: token.wireframe ? `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.padding)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.paddingLG)}` : 0,
        headerBorderBottom: token.wireframe ? `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        headerMarginBottom: token.wireframe ? 0 : token.marginXS,
        bodyPadding: token.wireframe ? token.paddingLG : 0,
        footerPadding: token.wireframe ? `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.paddingXS)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.padding)}` : 0,
        footerBorderTop: token.wireframe ? `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        footerBorderRadius: token.wireframe ? `0 0 ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.borderRadiusLG)}` : 0,
        footerMarginTop: token.wireframe ? 0 : token.marginSM,
        confirmBodyPadding: token.wireframe ? `${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.padding * 2)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.padding * 2)} ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.paddingLG)}` : 0,
        confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
        confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM
    });
var $0c4723a771151f77$export$2e2bcd8739ae039 = (0, $16d63ad40d593937$export$51ec95de45185b42)('Modal', (token)=>{
    const modalToken = $0c4723a771151f77$export$362fb92a8f81bbf9(token);
    return [
        $0c4723a771151f77$var$genModalStyle(modalToken),
        $0c4723a771151f77$var$genRTLStyle(modalToken),
        $0c4723a771151f77$export$8bb6dada04673ddd(modalToken),
        (0, $55346cd5d8fa18e5$export$f5d123412490d9dc)(modalToken, 'zoom'),
        $0c4723a771151f77$var$genResponsiveWidthStyle(modalToken)
    ];
}, $0c4723a771151f77$export$9ca1be8807fe0675, {
    unitless: {
        titleLineHeight: true
    }
});


"use client";
var $1356cc7fb9069279$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $1356cc7fb9069279$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const $1356cc7fb9069279$var$getClickPosition = (e)=>{
    $1356cc7fb9069279$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(()=>{
        $1356cc7fb9069279$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $93e9c4f5e5301ab9$export$7dbdadf5e9653129)()) document.documentElement.addEventListener('click', $1356cc7fb9069279$var$getClickPosition, true);
const $1356cc7fb9069279$var$Modal = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, open: open, wrapClassName: wrapClassName, centered: centered, getContainer: getContainer, focusTriggerAfterClose: focusTriggerAfterClose = true, style: style, visible: // Deprecated
    visible, width: width = 520, footer: footer, classNames: modalClassNames, styles: modalStyles, children: children, loading: loading, confirmLoading: confirmLoading, zIndex: customizeZIndex, mousePosition: customizeMousePosition, onOk: onOk, onCancel: onCancel, destroyOnHidden: destroyOnHidden, destroyOnClose: destroyOnClose, panelRef: panelRef = null, modalRender: modalRender } = props, restProps = $1356cc7fb9069279$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "open",
        "wrapClassName",
        "centered",
        "getContainer",
        "focusTriggerAfterClose",
        "style",
        "visible",
        "width",
        "footer",
        "classNames",
        "styles",
        "children",
        "loading",
        "confirmLoading",
        "zIndex",
        "mousePosition",
        "onOk",
        "onCancel",
        "destroyOnHidden",
        "destroyOnClose",
        "panelRef",
        "modalRender"
    ]);
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, modal: modalContext } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const handleCancel = (e)=>{
        if (confirmLoading) return;
        onCancel === null || onCancel === void 0 || onCancel(e);
    };
    const handleOk = (e)=>{
        onOk === null || onOk === void 0 || onOk(e);
    };
    var deprecatedName, newName;
    const prefixCls = getPrefixCls('modal', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    // Style
    const rootCls = (0, $600dec3f5c51945c$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $0c4723a771151f77$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const wrapClassNameExtended = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(wrapClassName, {
        [`${prefixCls}-centered`]: centered !== null && centered !== void 0 ? centered : modalContext === null || modalContext === void 0 ? void 0 : modalContext.centered,
        [`${prefixCls}-wrap-rtl`]: direction === 'rtl'
    });
    const dialogFooter = footer !== null && !loading ? /*#__PURE__*/ $eeyUA.createElement((0, $2c02b2bad38f1bbf$export$a06f1c675e846f6f), Object.assign({}, props, {
        onOk: handleOk,
        onCancel: handleCancel
    })) : null;
    const [mergedClosable, mergedCloseIcon, closeBtnIsDisabled, ariaProps] = (0, $3d28c4e84016e3c1$export$aa101db403ccf5f3)((0, $3d28c4e84016e3c1$export$51ad9c30389f050b)(props), (0, $3d28c4e84016e3c1$export$51ad9c30389f050b)(modalContext), {
        closable: true,
        closeIcon: /*#__PURE__*/ $eeyUA.createElement((0, $e2f667acd0c5267b$export$2e2bcd8739ae039), {
            className: `${prefixCls}-close-icon`
        }),
        closeIconRender: (icon)=>(0, $2c02b2bad38f1bbf$export$97c34646962d356e)(prefixCls, icon)
    });
    // ============================ modalRender ============================
    const mergedModalRender = modalRender ? (node)=>/*#__PURE__*/ $eeyUA.createElement("div", {
            className: `${prefixCls}-render`
        }, modalRender(node)) : undefined;
    // ============================ Refs ============================
    // Select `ant-modal-content` by `panelRef`
    const panelClassName = `.${prefixCls}-${modalRender ? 'render' : 'content'}`;
    const innerPanelRef = (0, $92b7eb127f220a4a$export$94ab53417567be34)(panelClassName);
    const mergedPanelRef = (0, $54bedb74db46e87d$export$ab452c34e8e05029)(panelRef, innerPanelRef);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $d1784ce42cc285a0$export$3e7906d4075187a4)('Modal', customizeZIndex);
    // =========================== Width ============================
    const [numWidth, responsiveWidth] = $eeyUA.useMemo(()=>{
        if (width && typeof width === 'object') return [
            undefined,
            width
        ];
        return [
            width,
            undefined
        ];
    }, [
        width
    ]);
    const responsiveWidthVars = $eeyUA.useMemo(()=>{
        const vars = {};
        if (responsiveWidth) Object.keys(responsiveWidth).forEach((breakpoint)=>{
            const breakpointWidth = responsiveWidth[breakpoint];
            if (breakpointWidth !== undefined) vars[`--${prefixCls}-${breakpoint}-width`] = typeof breakpointWidth === 'number' ? `${breakpointWidth}px` : breakpointWidth;
        });
        return vars;
    }, [
        prefixCls,
        responsiveWidth
    ]);
    // =========================== Render ===========================
    return wrapCSSVar(/*#__PURE__*/ $eeyUA.createElement((0, $54aba063db3ce030$export$2e2bcd8739ae039), {
        form: true,
        space: true
    }, /*#__PURE__*/ $eeyUA.createElement((0, $2a9d851d9c220ba7$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $eeyUA.createElement((0, $9f9c254f72248144$export$2e2bcd8739ae039), Object.assign({
        width: numWidth
    }, restProps, {
        zIndex: zIndex,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(hashId, rootClassName, cssVarCls, rootCls),
        footer: dialogFooter,
        visible: open !== null && open !== void 0 ? open : visible,
        mousePosition: customizeMousePosition !== null && customizeMousePosition !== void 0 ? customizeMousePosition : $1356cc7fb9069279$var$mousePosition,
        onClose: handleCancel,
        closable: mergedClosable ? Object.assign({
            disabled: closeBtnIsDisabled,
            closeIcon: mergedCloseIcon
        }, ariaProps) : mergedClosable,
        closeIcon: mergedCloseIcon,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: (0, $5e50fdfe62d69e21$export$27c72201b1d09951)(rootPrefixCls, 'zoom', props.transitionName),
        maskTransitionName: (0, $5e50fdfe62d69e21$export$27c72201b1d09951)(rootPrefixCls, 'fade', props.maskTransitionName),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(hashId, className, modalContext === null || modalContext === void 0 ? void 0 : modalContext.className),
        style: Object.assign(Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.style), style), responsiveWidthVars),
        classNames: Object.assign(Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.classNames), modalClassNames), {
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(wrapClassNameExtended, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper)
        }),
        styles: Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.styles), modalStyles),
        panelRef: mergedPanelRef,
        // TODO: In the future, destroyOnClose in rc-dialog needs to be upgrade to destroyOnHidden
        destroyOnClose: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyOnClose,
        modalRender: mergedModalRender
    }), loading ? /*#__PURE__*/ $eeyUA.createElement((0, $ffd6e5be065132e3$export$2e2bcd8739ae039), {
        active: true,
        title: false,
        paragraph: {
            rows: 4
        },
        className: `${prefixCls}-body-skeleton`
    }) : children))));
};
var $1356cc7fb9069279$export$2e2bcd8739ae039 = $1356cc7fb9069279$var$Modal;


// Style as confirm component




// ============================= Confirm ==============================
const $82caf49bab2b7d3b$var$genModalConfirmStyle = (token)=>{
    const { componentCls: componentCls, titleFontSize: titleFontSize, titleLineHeight: titleLineHeight, modalConfirmIconSize: modalConfirmIconSize, fontSize: fontSize, lineHeight: lineHeight, modalTitleHeight: modalTitleHeight, fontHeight: fontHeight, confirmBodyPadding: confirmBodyPadding } = token;
    const confirmComponentCls = `${componentCls}-confirm`;
    return {
        [confirmComponentCls]: {
            '&-rtl': {
                direction: 'rtl'
            },
            [`${token.antCls}-modal-header`]: {
                display: 'none'
            },
            [`${confirmComponentCls}-body-wrapper`]: Object.assign({}, (0, $d715ae4ca001487d$export$8c467e8859fdef13)()),
            [`&${componentCls} ${componentCls}-body`]: {
                padding: confirmBodyPadding
            },
            // ====================== Body ======================
            [`${confirmComponentCls}-body`]: {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'start',
                [`> ${token.iconCls}`]: {
                    flex: 'none',
                    fontSize: modalConfirmIconSize,
                    marginInlineEnd: token.confirmIconMarginInlineEnd,
                    marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                },
                [`&-has-title > ${token.iconCls}`]: {
                    marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                }
            },
            [`${confirmComponentCls}-paragraph`]: {
                display: 'flex',
                flexDirection: 'column',
                flex: 'auto',
                rowGap: token.marginXS,
                // https://github.com/ant-design/ant-design/issues/51912
                maxWidth: `calc(100% - ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.marginSM)})`
            },
            // https://github.com/ant-design/ant-design/issues/48159
            [`${token.iconCls} + ${confirmComponentCls}-paragraph`]: {
                maxWidth: `calc(100% - ${(0, $2c076defa05cd41b$export$523c0b569236b342)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
            },
            [`${confirmComponentCls}-title`]: {
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                fontSize: titleFontSize,
                lineHeight: titleLineHeight
            },
            [`${confirmComponentCls}-content`]: {
                color: token.colorText,
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            // ===================== Footer =====================
            [`${confirmComponentCls}-btns`]: {
                textAlign: 'end',
                marginTop: token.confirmBtnsMarginTop,
                [`${token.antCls}-btn + ${token.antCls}-btn`]: {
                    marginBottom: 0,
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorError
        },
        [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorWarning
        },
        [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorInfo
        },
        [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorSuccess
        }
    };
};
var // ============================== Export ==============================
$82caf49bab2b7d3b$export$2e2bcd8739ae039 = (0, $16d63ad40d593937$export$1537386bc155ea56)([
    'Modal',
    'confirm'
], (token)=>{
    const modalToken = (0, $0c4723a771151f77$export$362fb92a8f81bbf9)(token);
    return $82caf49bab2b7d3b$var$genModalConfirmStyle(modalToken);
}, (0, $0c4723a771151f77$export$9ca1be8807fe0675), {
    // confirm is weak than modal since no conflict here
    order: -1000
});


"use client";
var $2af487ce1ab90947$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $2af487ce1ab90947$export$78cf841dc2c9f0b5 = (props)=>{
    const { prefixCls: prefixCls, icon: icon, okText: okText, cancelText: cancelText, confirmPrefixCls: confirmPrefixCls, type: type, okCancel: okCancel, footer: footer, // Legacy for static function usage
    locale: staticLocale } = props, resetProps = $2af487ce1ab90947$var$__rest(props, [
        "prefixCls",
        "icon",
        "okText",
        "cancelText",
        "confirmPrefixCls",
        "type",
        "okCancel",
        "footer",
        "locale"
    ]);
    // Icon
    let mergedIcon = icon;
    // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
    if (!icon && icon !== null) switch(type){
        case 'info':
            mergedIcon = /*#__PURE__*/ $eeyUA.createElement((0, $8eaa4c935d74b503$export$2e2bcd8739ae039), null);
            break;
        case 'success':
            mergedIcon = /*#__PURE__*/ $eeyUA.createElement((0, $27c75b31e162e0b9$export$2e2bcd8739ae039), null);
            break;
        case 'error':
            mergedIcon = /*#__PURE__*/ $eeyUA.createElement((0, $bb922e54d3e229c9$export$2e2bcd8739ae039), null);
            break;
        default:
            mergedIcon = /*#__PURE__*/ $eeyUA.createElement((0, $fa20ac1ef8e6063f$export$2e2bcd8739ae039), null);
    }
    // 默认为 true，保持向下兼容
    const mergedOkCancel = okCancel !== null && okCancel !== void 0 ? okCancel : type === 'confirm';
    const autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
    const [locale] = (0, $6d3e114ae5f0e28f$export$2e2bcd8739ae039)('Modal');
    const mergedLocale = staticLocale || locale;
    // ================== Locale Text ==================
    const okTextLocale = okText || (mergedOkCancel ? mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.okText : mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.justOkText);
    const cancelTextLocale = cancelText || (mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.cancelText);
    const memoizedValue = $eeyUA.useMemo(()=>{
        return Object.assign({
            autoFocusButton: autoFocusButton,
            cancelTextLocale: cancelTextLocale,
            okTextLocale: okTextLocale,
            mergedOkCancel: mergedOkCancel
        }, resetProps);
    }, [
        autoFocusButton,
        cancelTextLocale,
        okTextLocale,
        mergedOkCancel,
        resetProps
    ]);
    // ====================== Footer Origin Node ======================
    const footerOriginNode = /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, /*#__PURE__*/ $eeyUA.createElement((0, $a54c63ab3eac8979$export$2e2bcd8739ae039), null), /*#__PURE__*/ $eeyUA.createElement((0, $e222f17e4922fd62$export$2e2bcd8739ae039), null));
    const hasTitle = props.title !== undefined && props.title !== null;
    const bodyCls = `${confirmPrefixCls}-body`;
    return /*#__PURE__*/ $eeyUA.createElement("div", {
        className: `${confirmPrefixCls}-body-wrapper`
    }, /*#__PURE__*/ $eeyUA.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(bodyCls, {
            [`${bodyCls}-has-title`]: hasTitle
        })
    }, mergedIcon, /*#__PURE__*/ $eeyUA.createElement("div", {
        className: `${confirmPrefixCls}-paragraph`
    }, hasTitle && /*#__PURE__*/ $eeyUA.createElement("span", {
        className: `${confirmPrefixCls}-title`
    }, props.title), /*#__PURE__*/ $eeyUA.createElement("div", {
        className: `${confirmPrefixCls}-content`
    }, props.content))), footer === undefined || typeof footer === 'function' ? /*#__PURE__*/ $eeyUA.createElement((0, $a1cd72ffec1dc6d7$export$7c9538f5f3c365e9), {
        value: memoizedValue
    }, /*#__PURE__*/ $eeyUA.createElement("div", {
        className: `${confirmPrefixCls}-btns`
    }, typeof footer === 'function' ? footer(footerOriginNode, {
        OkBtn: $e222f17e4922fd62$export$2e2bcd8739ae039,
        CancelBtn: $a54c63ab3eac8979$export$2e2bcd8739ae039
    }) : footerOriginNode)) : footer, /*#__PURE__*/ $eeyUA.createElement((0, $82caf49bab2b7d3b$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
const $2af487ce1ab90947$var$ConfirmDialog = (props)=>{
    const { close: close, zIndex: zIndex, maskStyle: maskStyle, direction: direction, prefixCls: prefixCls, wrapClassName: wrapClassName, rootPrefixCls: rootPrefixCls, bodyStyle: bodyStyle, closable: closable = false, onConfirm: onConfirm, styles: styles, title: title } = props;
    var deprecatedName, newName;
    const confirmPrefixCls = `${prefixCls}-confirm`;
    const width = props.width || 416;
    const style = props.style || {};
    const mask = props.mask === undefined ? true : props.mask;
    // 默认为 false，保持旧版默认行为
    const maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
        [`${confirmPrefixCls}-rtl`]: direction === 'rtl'
    }, props.className);
    // ========================= zIndex =========================
    const [, token] = (0, $77023b8a2ee37055$export$2e2bcd8739ae039)();
    const mergedZIndex = $eeyUA.useMemo(()=>{
        if (zIndex !== undefined) return zIndex;
        // Static always use max zIndex
        return token.zIndexPopupBase + (0, $d1784ce42cc285a0$export$33ada7d8845f7e5);
    }, [
        zIndex,
        token
    ]);
    // ========================= Render =========================
    return /*#__PURE__*/ $eeyUA.createElement((0, $1356cc7fb9069279$export$2e2bcd8739ae039), Object.assign({}, props, {
        className: classString,
        wrapClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))({
            [`${confirmPrefixCls}-centered`]: !!props.centered
        }, wrapClassName),
        onCancel: ()=>{
            close === null || close === void 0 || close({
                triggerCancel: true
            });
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        title: title,
        footer: null,
        transitionName: (0, $5e50fdfe62d69e21$export$27c72201b1d09951)(rootPrefixCls || '', 'zoom', props.transitionName),
        maskTransitionName: (0, $5e50fdfe62d69e21$export$27c72201b1d09951)(rootPrefixCls || '', 'fade', props.maskTransitionName),
        mask: mask,
        maskClosable: maskClosable,
        style: style,
        styles: Object.assign({
            body: bodyStyle,
            mask: maskStyle
        }, styles),
        width: width,
        zIndex: mergedZIndex,
        closable: closable
    }), /*#__PURE__*/ $eeyUA.createElement($2af487ce1ab90947$export$78cf841dc2c9f0b5, Object.assign({}, props, {
        confirmPrefixCls: confirmPrefixCls
    })));
};
const $2af487ce1ab90947$var$ConfirmDialogWrapper = (props)=>{
    const { rootPrefixCls: rootPrefixCls, iconPrefixCls: iconPrefixCls, direction: direction, theme: theme } = props;
    return /*#__PURE__*/ $eeyUA.createElement((0, $517cf7c86b737e50$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction,
        theme: theme
    }, /*#__PURE__*/ $eeyUA.createElement($2af487ce1ab90947$var$ConfirmDialog, Object.assign({}, props)));
};
var $2af487ce1ab90947$export$2e2bcd8739ae039 = $2af487ce1ab90947$var$ConfirmDialogWrapper;


const $47a9c16b08d95a49$var$destroyFns = [];
var $47a9c16b08d95a49$export$2e2bcd8739ae039 = $47a9c16b08d95a49$var$destroyFns;



"use client";
let $3006151e73f79c05$var$defaultRootPrefixCls = '';
function $3006151e73f79c05$var$getRootPrefixCls() {
    return $3006151e73f79c05$var$defaultRootPrefixCls;
}
const $3006151e73f79c05$var$ConfirmDialogWrapper = (props)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, getContainer: getContainer, direction: direction } = props;
    const runtimeLocale = (0, $1519b933a5ca31be$export$1b6004afda18cd51)();
    const config = (0, $eeyUA.useContext)((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const rootPrefixCls = $3006151e73f79c05$var$getRootPrefixCls() || config.getPrefixCls();
    // because Modal.config set rootPrefixCls, which is different from other components
    const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
    let mergedGetContainer = getContainer;
    if (mergedGetContainer === false) mergedGetContainer = undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $2af487ce1ab90947$export$2e2bcd8739ae039), Object.assign({}, props, {
        rootPrefixCls: rootPrefixCls,
        prefixCls: prefixCls,
        iconPrefixCls: config.iconPrefixCls,
        theme: config.theme,
        direction: direction !== null && direction !== void 0 ? direction : config.direction,
        locale: (_b = (_a = config.locale) === null || _a === void 0 ? void 0 : _a.Modal) !== null && _b !== void 0 ? _b : runtimeLocale,
        getContainer: mergedGetContainer
    }));
};
function $3006151e73f79c05$export$2e2bcd8739ae039(config) {
    const global = (0, $517cf7c86b737e50$export$f9cd1e43211d8a4a)();
    const container = document.createDocumentFragment();
    let currentConfig = Object.assign(Object.assign({}, config), {
        close: close,
        open: true
    });
    let timeoutId;
    let reactUnmount;
    function destroy(...args) {
        var _a;
        const triggerCancel = args.some((param)=>param === null || param === void 0 ? void 0 : param.triggerCancel);
        if (triggerCancel) {
            var _a2;
            (_a = config.onCancel) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                config,
                ()=>{}
            ].concat((0, $3440102357566473$export$2e2bcd8739ae039)(args.slice(1))));
        }
        for(let i = 0; i < (0, $47a9c16b08d95a49$export$2e2bcd8739ae039).length; i++){
            const fn = (0, $47a9c16b08d95a49$export$2e2bcd8739ae039)[i];
            if (fn === close) {
                (0, $47a9c16b08d95a49$export$2e2bcd8739ae039).splice(i, 1);
                break;
            }
        }
        reactUnmount();
    }
    const scheduleRender = (props)=>{
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(()=>{
            const rootPrefixCls = global.getPrefixCls(undefined, $3006151e73f79c05$var$getRootPrefixCls());
            const iconPrefixCls = global.getIconPrefixCls();
            const theme = global.getTheme();
            const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement($3006151e73f79c05$var$ConfirmDialogWrapper, Object.assign({}, props));
            const reactRender = (0, $cf87e1c636d1838d$export$4d4bf8843d204cca)();
            reactUnmount = reactRender(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $517cf7c86b737e50$export$2e2bcd8739ae039), {
                prefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                theme: theme
            }, typeof global.holderRender === 'function' ? global.holderRender(dom) : dom), container);
        });
    };
    function close(...args) {
        currentConfig = Object.assign(Object.assign({}, currentConfig), {
            open: false,
            afterClose: ()=>{
                if (typeof config.afterClose === 'function') config.afterClose();
                // @ts-ignore
                destroy.apply(this, args);
            }
        });
        // Legacy support
        if (currentConfig.visible) delete currentConfig.visible;
        scheduleRender(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') currentConfig = configUpdate(currentConfig);
        else currentConfig = Object.assign(Object.assign({}, currentConfig), configUpdate);
        scheduleRender(currentConfig);
    }
    scheduleRender(currentConfig);
    (0, $47a9c16b08d95a49$export$2e2bcd8739ae039).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $3006151e73f79c05$export$503fa8fed137d104(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'warning'
    });
}
function $3006151e73f79c05$export$2f728eab0dacbb2e(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'info'
    });
}
function $3006151e73f79c05$export$2b5f8d7f29c805d4(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'success'
    });
}
function $3006151e73f79c05$export$60e9e0884ce12b55(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'error'
    });
}
function $3006151e73f79c05$export$665b64399d4af99c(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'confirm'
    });
}
function $3006151e73f79c05$export$ff0b30c638ae2396({ rootPrefixCls: rootPrefixCls }) {
    $3006151e73f79c05$var$defaultRootPrefixCls = rootPrefixCls;
}





var $eeyUA = parcelRequire("eeyUA");



var $eeyUA = parcelRequire("eeyUA");


"use client";
function $3d72b0b2fee24bc3$export$29e2a8c3cdb34b03(Component) {
    return (props)=>/*#__PURE__*/ $eeyUA.createElement((0, $517cf7c86b737e50$export$2e2bcd8739ae039), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $eeyUA.createElement(Component, Object.assign({}, props)));
}
/* istanbul ignore next */ const $3d72b0b2fee24bc3$var$genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style: style } = props;
        const holderRef = $eeyUA.useRef(null);
        const [popupHeight, setPopupHeight] = $eeyUA.useState(0);
        const [popupWidth, setPopupWidth] = $eeyUA.useState(0);
        const [open, setOpen] = (0, $e7fff343666ddaae$export$2e2bcd8739ae039)(false, {
            value: props.open
        });
        const { getPrefixCls: getPrefixCls } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
        const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
        $eeyUA.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== 'undefined') {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    var _a;
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, [
            prefixCls
        ]);
        let mergedProps = Object.assign(Object.assign({}, props), {
            style: Object.assign(Object.assign({}, style), {
                margin: 0
            }),
            open: open,
            visible: open,
            getPopupContainer: ()=>holderRef.current
        });
        if (postProps) mergedProps = postProps(mergedProps);
        if (alignPropName) Object.assign(mergedProps, {
            [alignPropName]: {
                overflow: {
                    adjustX: false,
                    adjustY: false
                }
            }
        });
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: 'relative',
            minWidth: popupWidth
        };
        return /*#__PURE__*/ $eeyUA.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ $eeyUA.createElement(Component, Object.assign({}, mergedProps)));
    };
    return $3d72b0b2fee24bc3$export$29e2a8c3cdb34b03(PurePanel);
};
var $3d72b0b2fee24bc3$export$2e2bcd8739ae039 = $3d72b0b2fee24bc3$var$genPurePanel;







"use client";
var $1ea68aee3ab1255c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $1ea68aee3ab1255c$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, closeIcon: closeIcon, closable: closable, type: type, title: title, children: children, footer: footer } = props, restProps = $1ea68aee3ab1255c$var$__rest(props, [
        "prefixCls",
        "className",
        "closeIcon",
        "closable",
        "type",
        "title",
        "children",
        "footer"
    ]);
    const { getPrefixCls: getPrefixCls } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const prefixCls = customizePrefixCls || getPrefixCls('modal');
    const rootCls = (0, $600dec3f5c51945c$export$2e2bcd8739ae039)(rootPrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $0c4723a771151f77$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const confirmPrefixCls = `${prefixCls}-confirm`;
    // Choose target props by confirm mark
    let additionalProps = {};
    if (type) additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : false,
        title: '',
        footer: '',
        children: /*#__PURE__*/ $eeyUA.createElement((0, $2af487ce1ab90947$export$78cf841dc2c9f0b5), Object.assign({}, props, {
            prefixCls: prefixCls,
            confirmPrefixCls: confirmPrefixCls,
            rootPrefixCls: rootPrefixCls,
            content: children
        }))
    };
    else additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : true,
        title: title,
        footer: footer !== null && /*#__PURE__*/ $eeyUA.createElement((0, $2c02b2bad38f1bbf$export$a06f1c675e846f6f), Object.assign({}, props)),
        children: children
    };
    return wrapCSSVar(/*#__PURE__*/ $eeyUA.createElement((0, $15478a04d85e8e5c$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4f652a989dd07e$exports)))(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, cssVarCls, rootCls)
    }, restProps, {
        closeIcon: (0, $2c02b2bad38f1bbf$export$97c34646962d356e)(prefixCls, closeIcon),
        closable: closable
    }, additionalProps)));
};
var $1ea68aee3ab1255c$export$2e2bcd8739ae039 = (0, $3d72b0b2fee24bc3$export$29e2a8c3cdb34b03)($1ea68aee3ab1255c$var$PurePanel);




var $eeyUA = parcelRequire("eeyUA");


var $eeyUA = parcelRequire("eeyUA");
const $63982f5ffec02544$export$26425c9dd59b4436 = ()=>{
    const [elements, setElements] = $eeyUA.useState([]);
    const patchElement = $eeyUA.useCallback((element)=>{
        // append a new element to elements (and create a new ref)
        setElements((originElements)=>[].concat((0, $3440102357566473$export$2e2bcd8739ae039)(originElements), [
                element
            ]));
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return ()=>{
            setElements((originElements)=>originElements.filter((ele)=>ele !== element));
        };
    }, []);
    return [
        elements,
        patchElement
    ];
};






var $eeyUA = parcelRequire("eeyUA");




"use client";
var $027d84bd6f60638b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $027d84bd6f60638b$var$HookModal = (_a, ref)=>{
    var _b;
    var { afterClose: hookAfterClose, config: config } = _a, restProps = $027d84bd6f60638b$var$__rest(_a, [
        "afterClose",
        "config"
    ]);
    const [open, setOpen] = $eeyUA.useState(true);
    const [innerConfig, setInnerConfig] = $eeyUA.useState(config);
    const { direction: direction, getPrefixCls: getPrefixCls } = $eeyUA.useContext((0, $0b79f8c0c8222aa8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('modal');
    const rootPrefixCls = getPrefixCls();
    const afterClose = ()=>{
        var _a;
        hookAfterClose();
        (_a = innerConfig.afterClose) === null || _a === void 0 || _a.call(innerConfig);
    };
    const close = (...args)=>{
        var _a;
        setOpen(false);
        const triggerCancel = args.some((param)=>param === null || param === void 0 ? void 0 : param.triggerCancel);
        if (triggerCancel) {
            var _a2;
            (_a = innerConfig.onCancel) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                innerConfig,
                ()=>{}
            ].concat((0, $3440102357566473$export$2e2bcd8739ae039)(args.slice(1))));
        }
    };
    $eeyUA.useImperativeHandle(ref, ()=>({
            destroy: close,
            update: (newConfig)=>{
                setInnerConfig((originConfig)=>{
                    const nextConfig = typeof newConfig === 'function' ? newConfig(originConfig) : newConfig;
                    return Object.assign(Object.assign({}, originConfig), nextConfig);
                });
            }
        }));
    const mergedOkCancel = (_b = innerConfig.okCancel) !== null && _b !== void 0 ? _b : innerConfig.type === 'confirm';
    const [contextLocale] = (0, $6d3e114ae5f0e28f$export$2e2bcd8739ae039)('Modal', (0, $535519d587587ff4$export$2e2bcd8739ae039).Modal);
    return /*#__PURE__*/ $eeyUA.createElement((0, $2af487ce1ab90947$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls
    }, innerConfig, {
        close: close,
        open: open,
        afterClose: afterClose,
        okText: innerConfig.okText || (mergedOkCancel ? contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.okText : contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.justOkText),
        direction: innerConfig.direction || direction,
        cancelText: innerConfig.cancelText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.cancelText)
    }, restProps));
};
var $027d84bd6f60638b$export$2e2bcd8739ae039 = /*#__PURE__*/ $eeyUA.forwardRef($027d84bd6f60638b$var$HookModal);


"use client";
let $0deecc2bd594064a$var$uuid = 0;
const $0deecc2bd594064a$var$ElementsHolder = /*#__PURE__*/ $eeyUA.memo(/*#__PURE__*/ $eeyUA.forwardRef((_props, ref)=>{
    const [elements, patchElement] = (0, $63982f5ffec02544$export$26425c9dd59b4436)();
    $eeyUA.useImperativeHandle(ref, ()=>({
            patchElement: patchElement
        }), [
        patchElement
    ]);
    return /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, elements);
}));
function $0deecc2bd594064a$var$useModal() {
    const holderRef = $eeyUA.useRef(null);
    // ========================== Effect ==========================
    const [actionQueue, setActionQueue] = $eeyUA.useState([]);
    $eeyUA.useEffect(()=>{
        if (actionQueue.length) {
            const cloneQueue = (0, $3440102357566473$export$2e2bcd8739ae039)(actionQueue);
            cloneQueue.forEach((action)=>{
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    const getConfirmFunc = $eeyUA.useCallback((withFunc)=>function hookConfirm(config) {
            var _a;
            $0deecc2bd594064a$var$uuid += 1;
            const modalRef = /*#__PURE__*/ $eeyUA.createRef();
            // Proxy to promise with `onClose`
            let resolvePromise;
            const promise = new Promise((resolve)=>{
                resolvePromise = resolve;
            });
            let silent = false;
            let closeFunc;
            const modal = /*#__PURE__*/ $eeyUA.createElement((0, $027d84bd6f60638b$export$2e2bcd8739ae039), {
                key: `modal-${$0deecc2bd594064a$var$uuid}`,
                config: withFunc(config),
                ref: modalRef,
                afterClose: ()=>{
                    closeFunc === null || closeFunc === void 0 || closeFunc();
                },
                isSilent: ()=>silent,
                onConfirm: (confirmed)=>{
                    resolvePromise(confirmed);
                }
            });
            closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
            if (closeFunc) (0, $47a9c16b08d95a49$export$2e2bcd8739ae039).push(closeFunc);
            const instance = {
                destroy: ()=>{
                    function destroyAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue((prev)=>[].concat((0, $3440102357566473$export$2e2bcd8739ae039)(prev), [
                            destroyAction
                        ]));
                },
                update: (newConfig)=>{
                    function updateAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue((prev)=>[].concat((0, $3440102357566473$export$2e2bcd8739ae039)(prev), [
                            updateAction
                        ]));
                },
                then: (resolve)=>{
                    silent = true;
                    return promise.then(resolve);
                }
            };
            return instance;
        }, []);
    const fns = $eeyUA.useMemo(()=>({
            info: getConfirmFunc((0, $3006151e73f79c05$export$2f728eab0dacbb2e)),
            success: getConfirmFunc((0, $3006151e73f79c05$export$2b5f8d7f29c805d4)),
            error: getConfirmFunc((0, $3006151e73f79c05$export$60e9e0884ce12b55)),
            warning: getConfirmFunc((0, $3006151e73f79c05$export$503fa8fed137d104)),
            confirm: getConfirmFunc((0, $3006151e73f79c05$export$665b64399d4af99c))
        }), [
        getConfirmFunc
    ]);
    return [
        fns,
        /*#__PURE__*/ $eeyUA.createElement($0deecc2bd594064a$var$ElementsHolder, {
            key: "modal-holder",
            ref: holderRef
        })
    ];
}
var $0deecc2bd594064a$export$2e2bcd8739ae039 = $0deecc2bd594064a$var$useModal;


"use client";
function $cd9238af9d931c2f$var$modalWarn(props) {
    return (0, $3006151e73f79c05$export$2e2bcd8739ae039)((0, $3006151e73f79c05$export$503fa8fed137d104)(props));
}
const $cd9238af9d931c2f$var$Modal = (0, $1356cc7fb9069279$export$2e2bcd8739ae039);
$cd9238af9d931c2f$var$Modal.useModal = (0, $0deecc2bd594064a$export$2e2bcd8739ae039);
$cd9238af9d931c2f$var$Modal.info = function infoFn(props) {
    return (0, $3006151e73f79c05$export$2e2bcd8739ae039)((0, $3006151e73f79c05$export$2f728eab0dacbb2e)(props));
};
$cd9238af9d931c2f$var$Modal.success = function successFn(props) {
    return (0, $3006151e73f79c05$export$2e2bcd8739ae039)((0, $3006151e73f79c05$export$2b5f8d7f29c805d4)(props));
};
$cd9238af9d931c2f$var$Modal.error = function errorFn(props) {
    return (0, $3006151e73f79c05$export$2e2bcd8739ae039)((0, $3006151e73f79c05$export$60e9e0884ce12b55)(props));
};
$cd9238af9d931c2f$var$Modal.warning = $cd9238af9d931c2f$var$modalWarn;
$cd9238af9d931c2f$var$Modal.warn = $cd9238af9d931c2f$var$modalWarn;
$cd9238af9d931c2f$var$Modal.confirm = function confirmFn(props) {
    return (0, $3006151e73f79c05$export$2e2bcd8739ae039)((0, $3006151e73f79c05$export$665b64399d4af99c)(props));
};
$cd9238af9d931c2f$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $47a9c16b08d95a49$export$2e2bcd8739ae039).length){
        const close = (0, $47a9c16b08d95a49$export$2e2bcd8739ae039).pop();
        if (close) close();
    }
};
$cd9238af9d931c2f$var$Modal.config = (0, $3006151e73f79c05$export$ff0b30c638ae2396);
$cd9238af9d931c2f$var$Modal._InternalPanelDoNotUseOrYouWillBeFired = (0, $1ea68aee3ab1255c$export$2e2bcd8739ae039);
var $cd9238af9d931c2f$export$2e2bcd8739ae039 = $cd9238af9d931c2f$var$Modal;



var $eeyUA = parcelRequire("eeyUA");
var $8b4b510a8206fdfa$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($8b4b510a8206fdfa$exports, "__esModule", {
    value: true
});
var $8b4b510a8206fdfa$var$FullscreenExitOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 000 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 00391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 00-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z"
                }
            }
        ]
    },
    "name": "fullscreen-exit",
    "theme": "outlined"
};
$8b4b510a8206fdfa$exports.default = $8b4b510a8206fdfa$var$FullscreenExitOutlined;



function $94eb52b6522df020$var$_extends() {
    $94eb52b6522df020$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $94eb52b6522df020$var$_extends.apply(this, arguments);
}
const $94eb52b6522df020$var$FullscreenExitOutlined = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $94eb52b6522df020$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8b4b510a8206fdfa$exports)))
    }));
/**![fullscreen-exit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM5MSAyNDAuOWMtLjgtNi42LTguOS05LjQtMTMuNi00LjdsLTQzLjcgNDMuN0wyMDAgMTQ2LjNhOC4wMyA4LjAzIDAgMDAtMTEuMyAwbC00Mi40IDQyLjNhOC4wMyA4LjAzIDAgMDAwIDExLjNMMjgwIDMzMy42bC00My45IDQzLjlhOC4wMSA4LjAxIDAgMDA0LjcgMTMuNkw0MDEgNDEwYzUuMS42IDkuNS0zLjcgOC45LTguOUwzOTEgMjQwLjl6bTEwLjEgMzczLjJMMjQwLjggNjMzYy02LjYuOC05LjQgOC45LTQuNyAxMy42bDQzLjkgNDMuOUwxNDYuMyA4MjRhOC4wMyA4LjAzIDAgMDAwIDExLjNsNDIuNCA0Mi4zYzMuMSAzLjEgOC4yIDMuMSAxMS4zIDBMMzMzLjcgNzQ0bDQzLjcgNDMuN0E4LjAxIDguMDEgMCAwMDM5MSA3ODNsMTguOS0xNjAuMWMuNi01LjEtMy43LTkuNC04LjgtOC44em0yMjEuOC0yMDQuMkw3ODMuMiAzOTFjNi42LS44IDkuNC04LjkgNC43LTEzLjZMNzQ0IDMzMy42IDg3Ny43IDIwMGMzLjEtMy4xIDMuMS04LjIgMC0xMS4zbC00Mi40LTQyLjNhOC4wMyA4LjAzIDAgMDAtMTEuMyAwTDY5MC4zIDI3OS45bC00My43LTQzLjdhOC4wMSA4LjAxIDAgMDAtMTMuNiA0LjdMNjE0LjEgNDAxYy0uNiA1LjIgMy43IDkuNSA4LjggOC45ek03NDQgNjkwLjRsNDMuOS00My45YTguMDEgOC4wMSAwIDAwLTQuNy0xMy42TDYyMyA2MTRjLTUuMS0uNi05LjUgMy43LTguOSA4LjlMNjMzIDc4My4xYy44IDYuNiA4LjkgOS40IDEzLjYgNC43bDQzLjctNDMuN0w4MjQgODc3LjdjMy4xIDMuMSA4LjIgMy4xIDExLjMgMGw0Mi40LTQyLjNjMy4xLTMuMSAzLjEtOC4yIDAtMTEuM0w3NDQgNjkwLjR6IiAvPjwvc3ZnPg==) */ const $94eb52b6522df020$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($94eb52b6522df020$var$FullscreenExitOutlined);
var $94eb52b6522df020$export$2e2bcd8739ae039 = $94eb52b6522df020$var$RefIcon;


var $eeyUA = parcelRequire("eeyUA");
var $9bc35af8ed2a15b3$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($9bc35af8ed2a15b3$exports, "__esModule", {
    value: true
});
var $9bc35af8ed2a15b3$var$FullscreenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M290 236.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0013.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 000 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 00-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z"
                }
            }
        ]
    },
    "name": "fullscreen",
    "theme": "outlined"
};
$9bc35af8ed2a15b3$exports.default = $9bc35af8ed2a15b3$var$FullscreenOutlined;



function $c94787c84aa11990$var$_extends() {
    $c94787c84aa11990$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c94787c84aa11990$var$_extends.apply(this, arguments);
}
const $c94787c84aa11990$var$FullscreenOutlined = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $c94787c84aa11990$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9bc35af8ed2a15b3$exports)))
    }));
/**![fullscreen](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5MCAyMzYuNGw0My45LTQzLjlhOC4wMSA4LjAxIDAgMDAtNC43LTEzLjZMMTY5IDE2MGMtNS4xLS42LTkuNSAzLjctOC45IDguOUwxNzkgMzI5LjFjLjggNi42IDguOSA5LjQgMTMuNiA0LjdsNDMuNy00My43TDM3MCA0MjMuN2MzLjEgMy4xIDguMiAzLjEgMTEuMyAwbDQyLjQtNDIuM2MzLjEtMy4xIDMuMS04LjIgMC0xMS4zTDI5MCAyMzYuNHptMzUyLjcgMTg3LjNjMy4xIDMuMSA4LjIgMy4xIDExLjMgMGwxMzMuNy0xMzMuNiA0My43IDQzLjdhOC4wMSA4LjAxIDAgMDAxMy42LTQuN0w4NjMuOSAxNjljLjYtNS4xLTMuNy05LjUtOC45LTguOUw2OTQuOCAxNzljLTYuNi44LTkuNCA4LjktNC43IDEzLjZsNDMuOSA0My45TDYwMC4zIDM3MGE4LjAzIDguMDMgMCAwMDAgMTEuM2w0Mi40IDQyLjR6TTg0NSA2OTQuOWMtLjgtNi42LTguOS05LjQtMTMuNi00LjdsLTQzLjcgNDMuN0w2NTQgNjAwLjNhOC4wMyA4LjAzIDAgMDAtMTEuMyAwbC00Mi40IDQyLjNhOC4wMyA4LjAzIDAgMDAwIDExLjNMNzM0IDc4Ny42bC00My45IDQzLjlhOC4wMSA4LjAxIDAgMDA0LjcgMTMuNkw4NTUgODY0YzUuMS42IDkuNS0zLjcgOC45LTguOUw4NDUgNjk0Ljl6bS00NjMuNy05NC42YTguMDMgOC4wMyAwIDAwLTExLjMgMEwyMzYuMyA3MzMuOWwtNDMuNy00My43YTguMDEgOC4wMSAwIDAwLTEzLjYgNC43TDE2MC4xIDg1NWMtLjYgNS4xIDMuNyA5LjUgOC45IDguOUwzMjkuMiA4NDVjNi42LS44IDkuNC04LjkgNC43LTEzLjZMMjkwIDc4Ny42IDQyMy43IDY1NGMzLjEtMy4xIDMuMS04LjIgMC0xMS4zbC00Mi40LTQyLjR6IiAvPjwvc3ZnPg==) */ const $c94787c84aa11990$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($c94787c84aa11990$var$FullscreenOutlined);
var $c94787c84aa11990$export$2e2bcd8739ae039 = $c94787c84aa11990$var$RefIcon;


var $eeyUA = parcelRequire("eeyUA");
var $aeaf8786b3b48822$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($aeaf8786b3b48822$exports, "__esModule", {
    value: true
});
var $aeaf8786b3b48822$var$MinusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "minus-square",
    "theme": "outlined"
};
$aeaf8786b3b48822$exports.default = $aeaf8786b3b48822$var$MinusSquareOutlined;



function $55e41a7874da62c7$var$_extends() {
    $55e41a7874da62c7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55e41a7874da62c7$var$_extends.apply(this, arguments);
}
const $55e41a7874da62c7$var$MinusSquareOutlined = (props, ref)=>/*#__PURE__*/ $eeyUA.createElement((0, $1df11896f514c369$export$2e2bcd8739ae039), $55e41a7874da62c7$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aeaf8786b3b48822$exports)))
    }));
/**![minus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMzY4YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04SDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $55e41a7874da62c7$var$RefIcon = /*#__PURE__*/ $eeyUA.forwardRef($55e41a7874da62c7$var$MinusSquareOutlined);
var $55e41a7874da62c7$export$2e2bcd8739ae039 = $55e41a7874da62c7$var$RefIcon;





class $e16fc262c883ea08$var$CancelledError extends Error {
}
const $e16fc262c883ea08$var$WS_URL = "wss://r6w6gioyeg.execute-api.us-east-2.amazonaws.com/uat" ?? "";
let $e16fc262c883ea08$var$socket = null;
let $e16fc262c883ea08$var$connecting = null;
let $e16fc262c883ea08$var$generation = 0;
let $e16fc262c883ea08$var$cancelActive = null;
function $e16fc262c883ea08$export$dde3008c9b80e3() {
    return $e16fc262c883ea08$var$generation;
}
function $e16fc262c883ea08$var$createAuthorizedWebSocket(url, token) {
    // const WS = WebSocket as unknown as WSWithHeaders;
    // return new WS(url, [], {
    //   headers: { Authorization: `Bearer ${token}` },
    // });
    const urlObj = new URL(url);
    urlObj.searchParams.set("Authorization", `Bearer ${token}`);
    return new WebSocket(urlObj.toString());
}
async function $e16fc262c883ea08$export$64605811ab45167f() {
    if ($e16fc262c883ea08$var$socket?.readyState === WebSocket.OPEN) return $e16fc262c883ea08$var$socket;
    if ($e16fc262c883ea08$var$connecting) return $e16fc262c883ea08$var$connecting;
    const connectGeneration = $e16fc262c883ea08$var$generation;
    $e16fc262c883ea08$var$connecting = (async ()=>{
        if (!$e16fc262c883ea08$var$WS_URL) throw new Error("CACTAI_URL is not configured");
        const token = await (0, $f8e271a6a8b7dd21$export$84773cc9bf7dbe87)();
        if (!token) throw new Error("No access token for upgrade");
        const url = new URL($e16fc262c883ea08$var$WS_URL);
        if (url.protocol !== "wss:" && url.protocol !== "ws:") throw new Error(`CACTAI_URL must be wss:// (got ${url.protocol})`);
        console.log("[CactAI WS] upgrading", url.toString());
        const ws = $e16fc262c883ea08$var$createAuthorizedWebSocket(url.toString(), token);
        await new Promise((resolve, reject)=>{
            const onOpen = ()=>{
                cleanup();
                console.log("[CactAI WS] upgrade complete ($connect ok)");
                resolve();
            };
            const onError = ()=>{
                cleanup();
                reject(new Error("WebSocket upgrade failed"));
            };
            const onClose = (event)=>{
                console.log("[CactAI WS] upgrade closed", {
                    code: event.code,
                    reason: event.reason,
                    wasClean: event.wasClean
                });
                cleanup();
                reject(new Error(event.reason || `WebSocket upgrade closed (${event.code})`));
            };
            const onMessage = (event)=>{
                console.log("[CactAI WS] message", event.data);
            };
            const cleanup = ()=>{
                ws.removeEventListener("open", onOpen);
                ws.removeEventListener("error", onError);
                ws.removeEventListener("close", onClose);
                ws.removeEventListener("message", onMessage);
            };
            ws.addEventListener("message", onMessage);
            ws.addEventListener("open", onOpen);
            ws.addEventListener("error", onError);
            ws.addEventListener("close", onClose);
        });
        if (connectGeneration !== $e16fc262c883ea08$var$generation) {
            ws.close(1000, "cancelled during connect");
            throw new $e16fc262c883ea08$var$CancelledError();
        }
        ws.addEventListener("close", (event)=>{
            console.warn("[CactAI WS] closed", {
                code: event.code,
                reason: event.reason,
                wasClean: event.wasClean
            });
            if ($e16fc262c883ea08$var$socket === ws) $e16fc262c883ea08$var$socket = null;
        });
        $e16fc262c883ea08$var$socket = ws;
        return ws;
    })();
    try {
        return await $e16fc262c883ea08$var$connecting;
    } catch (err) {
        $e16fc262c883ea08$var$socket = null;
        throw err;
    } finally{
        $e16fc262c883ea08$var$connecting = null;
    }
}
function $e16fc262c883ea08$export$37dfea93db2e14ed() {
    const ws = $e16fc262c883ea08$var$socket;
    $e16fc262c883ea08$var$socket = null;
    $e16fc262c883ea08$var$connecting = null;
    if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) ws.close(1000, "client disconnect");
}
async function $e16fc262c883ea08$export$465cb47180de50f0(prompt, startedAt = $e16fc262c883ea08$var$generation) {
    try {
        if (!prompt.trim()) return {
            response: "prompt must not be empty"
        };
        if (startedAt !== $e16fc262c883ea08$var$generation) throw new $e16fc262c883ea08$var$CancelledError();
        const ws = await $e16fc262c883ea08$export$64605811ab45167f();
        if (startedAt !== $e16fc262c883ea08$var$generation) throw new $e16fc262c883ea08$var$CancelledError();
        return await new Promise((resolve, reject)=>{
            let buffer = "";
            let messageID;
            let settled = false;
            const fail = (error)=>{
                if (settled) return;
                settled = true;
                cleanup();
                reject(error);
            };
            const succeed = (response)=>{
                if (settled) return;
                settled = true;
                cleanup();
                resolve({
                    response: response,
                    messageID: messageID
                });
            };
            const onMessage = (event)=>{
                try {
                    const data = JSON.parse(String(event.data));
                    if (typeof data.messageID === "string" && data.messageID.length > 0) messageID = data.messageID;
                    if (typeof data.token === "string" && data.token.length > 0) buffer += data.token;
                    if (data.isComplete) succeed(buffer);
                } catch  {
                    fail(new Error("Invalid message from WebSocket"));
                }
            };
            const onError = ()=>fail(new Error("WebSocket error during stream"));
            const onClose = (event)=>{
                fail(new Error(event.reason || `WebSocket closed during stream (${event.code})`));
            };
            const cleanup = ()=>{
                ws.removeEventListener("message", onMessage);
                ws.removeEventListener("error", onError);
                ws.removeEventListener("close", onClose);
                if ($e16fc262c883ea08$var$cancelActive === abort) $e16fc262c883ea08$var$cancelActive = null;
            };
            const abort = ()=>fail(new $e16fc262c883ea08$var$CancelledError());
            $e16fc262c883ea08$var$cancelActive = abort;
            ws.addEventListener("message", onMessage);
            ws.addEventListener("error", onError);
            ws.addEventListener("close", onClose);
            try {
                ws.send(JSON.stringify({
                    action: "stream",
                    prompt: prompt
                }));
            } catch (err) {
                fail(err instanceof Error ? err : new Error("Failed to send stream message"));
            }
        });
    } catch (error) {
        if (error instanceof $e16fc262c883ea08$var$CancelledError) return {
            response: "",
            cancelled: true
        };
        const message = error instanceof Error ? error.message : "An unknown error occurred";
        console.log("[CactAI WS] sendMessage failed:", message);
        return {
            response: message
        };
    }
}
function $e16fc262c883ea08$export$4f51118d1b255345() {
    $e16fc262c883ea08$var$generation += 1;
    $e16fc262c883ea08$var$cancelActive?.();
    const ws = $e16fc262c883ea08$var$socket;
    if (ws?.readyState === WebSocket.OPEN) try {
        ws.send(JSON.stringify({
            action: "cancel"
        }));
    } catch (error) {
        console.log("[CactAI WS] cancelMessage send failed:", error);
    }
    $e16fc262c883ea08$export$37dfea93db2e14ed();
}


const $696c8e7da4f790b8$var$NAV_BAR_HEIGHT = 72;
const $696c8e7da4f790b8$var$RESIZE_DEBOUNCE_MS = 200;
function $696c8e7da4f790b8$var$dimensionsForWindow(minimized) {
    return {
        width: minimized ? window.innerWidth / 2 : window.innerWidth,
        height: minimized ? window.innerHeight * 0.8 : window.innerHeight - $696c8e7da4f790b8$var$NAV_BAR_HEIGHT - 5
    };
}
/** Batch dimension updates to the next frame (reduces ResizeObserver churn). */ function $696c8e7da4f790b8$var$scheduleDimensionUpdate(apply, minimized) {
    requestAnimationFrame(()=>apply(minimized));
}
function $696c8e7da4f790b8$export$6fa16436f8ccc529({ messages: messages, onSendMessage: onSendMessage, isLoading: isLoading = false, disabled: disabled = false, className: className, labels: labels, renderMessage: renderMessage, autoFocusInput: autoFocusInput = true, maxInputLength: maxInputLength, setIsLoading: setIsLoading, isStandalone: isStandalone = false }) {
    const merged = (0, $929c4e147339edc0$export$6ae14dc05aa6ecd6)(labels);
    const rootClass = [
        "cactai-chat",
        className
    ].filter(Boolean).join(" ");
    const [open, setOpen] = (0, $eeyUA.useState)(false);
    const [width, setWidth] = (0, $eeyUA.useState)(window.innerWidth);
    const [minimized, setMinimized] = (0, $eeyUA.useState)(true);
    const [height, setHeight] = (0, $eeyUA.useState)(window.innerHeight);
    const minimizedRef = (0, $eeyUA.useRef)(minimized);
    minimizedRef.current = minimized;
    const cancelPrompt = ()=>{
        (0, $e16fc262c883ea08$export$4f51118d1b255345)();
        setIsLoading?.(false);
    };
    const [scrollPosition, setScrollPosition] = (0, $eeyUA.useState)(0);
    const applyDimensions = (0, $eeyUA.useCallback)((isMinimized)=>{
        const { width: w, height: h } = $696c8e7da4f790b8$var$dimensionsForWindow(isMinimized);
        setWidth(w);
        setHeight(h);
        setMinimized(window.innerWidth > 430);
    }, []);
    (0, $eeyUA.useEffect)(()=>{
        let timeoutId;
        const onResize = ()=>{
            clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>{
                $696c8e7da4f790b8$var$scheduleDimensionUpdate(applyDimensions, minimizedRef.current);
            }, $696c8e7da4f790b8$var$RESIZE_DEBOUNCE_MS);
        };
        window.addEventListener("resize", onResize);
        return ()=>{
            clearTimeout(timeoutId);
            window.removeEventListener("resize", onResize);
        };
    }, [
        applyDimensions
    ]);
    const showModal = ()=>{
        $696c8e7da4f790b8$var$scheduleDimensionUpdate(applyDimensions, minimizedRef.current);
        setOpen(true);
        document.documentElement.style.setProperty('overflow-y', 'auto', 'important');
        document.body.style.setProperty('overflow-y', 'auto', 'important');
    };
    const maximize = ()=>{
        setMinimized(false);
        requestAnimationFrame(()=>{
            setWidth(window.innerWidth);
            setHeight(window.innerHeight - $696c8e7da4f790b8$var$NAV_BAR_HEIGHT - 5);
        });
    };
    const minimize = ()=>{
        setMinimized(true);
        $696c8e7da4f790b8$var$scheduleDimensionUpdate(applyDimensions, true);
    };
    return /*#__PURE__*/ (0, $e9nev.jsx)((0, $e9nev.Fragment), {
        children: isStandalone ? /*#__PURE__*/ (0, $e9nev.jsxs)("div", {
            className: "chat-standalone-shell",
            children: [
                /*#__PURE__*/ (0, $e9nev.jsx)("div", {
                    className: "chat-header-standalone",
                    children: "CACTAI Chat"
                }),
                /*#__PURE__*/ (0, $e9nev.jsx)("div", {
                    className: "chat-body-standalone",
                    children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $929c4e147339edc0$export$89085c7857c3f940), {
                        messages: messages,
                        emptyLabel: merged.emptyState,
                        renderMessage: renderMessage,
                        isLoading: isLoading
                    })
                }),
                /*#__PURE__*/ (0, $e9nev.jsx)("div", {
                    className: "chat-footer-standalone",
                    children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $929c4e147339edc0$export$19b903fd083c557c), {
                        onSubmit: onSendMessage,
                        disabled: disabled || isLoading,
                        placeholder: merged.inputPlaceholder,
                        sendLabel: merged.sendButton,
                        autoFocus: autoFocusInput,
                        maxLength: maxInputLength,
                        onCancel: cancelPrompt
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $e9nev.jsxs)("div", {
            className: "chat-interface-container",
            children: [
                /*#__PURE__*/ (0, $e9nev.jsx)((0, $cd9238af9d931c2f$export$2e2bcd8739ae039), {
                    style: minimized ? {
                        position: 'absolute',
                        bottom: '0px',
                        right: '0px'
                    } : {},
                    className: "cactai-chat-modal",
                    title: /*#__PURE__*/ (0, $e9nev.jsxs)("div", {
                        className: "chat-header",
                        onFocus: ()=>{},
                        onBlur: ()=>{},
                        children: [
                            "CactAI Chat",
                            /*#__PURE__*/ (0, $e9nev.jsxs)("div", {
                                className: "button-container",
                                children: [
                                    minimized ? /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$28c660c63b792dea), {
                                        content: "Maximize",
                                        id: "maximize",
                                        children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $c94787c84aa11990$export$2e2bcd8739ae039), {
                                            className: "chat-header-maximize",
                                            onClick: maximize
                                        })
                                    }) : /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$28c660c63b792dea), {
                                        content: "Minimize",
                                        id: "minimize",
                                        children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $94eb52b6522df020$export$2e2bcd8739ae039), {
                                            className: "chat-header-minimize",
                                            onClick: minimize
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$28c660c63b792dea), {
                                        content: "Close",
                                        id: "close",
                                        children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $55e41a7874da62c7$export$2e2bcd8739ae039), {
                                            className: "chat-header-close",
                                            onClick: ()=>setOpen(false)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    open: open,
                    width: width,
                    centered: false,
                    closable: false,
                    footer: null,
                    mask: false,
                    onCancel: ()=>setOpen(false),
                    zIndex: 9999,
                    styles: {
                        wrapper: {
                            pointerEvents: "none"
                        },
                        content: {
                            height: `${height}px`,
                            maxHeight: `${height}px`,
                            pointerEvents: "auto"
                        }
                    },
                    modalRender: (modal)=>/*#__PURE__*/ (0, $e9nev.jsx)("div", {
                            className: "cactai-chat-modal-shell",
                            children: modal
                        }),
                    children: /*#__PURE__*/ (0, $e9nev.jsxs)("section", {
                        className: rootClass,
                        "aria-label": "Chat",
                        children: [
                            /*#__PURE__*/ (0, $e9nev.jsx)("div", {
                                className: "chat-body",
                                children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $929c4e147339edc0$export$89085c7857c3f940), {
                                    messages: messages,
                                    emptyLabel: merged.emptyState,
                                    renderMessage: renderMessage,
                                    isLoading: isLoading
                                })
                            }),
                            /*#__PURE__*/ (0, $e9nev.jsx)("footer", {
                                className: "chat-footer",
                                children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $929c4e147339edc0$export$19b903fd083c557c), {
                                    onSubmit: onSendMessage,
                                    disabled: disabled || isLoading,
                                    placeholder: merged.inputPlaceholder,
                                    sendLabel: merged.sendButton,
                                    autoFocus: autoFocusInput,
                                    maxLength: maxInputLength,
                                    onCancel: cancelPrompt
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e9nev.jsx)("div", {
                    className: "chat-avatar-button-container",
                    onClick: ()=>open ? setOpen(false) : showModal(),
                    children: /*#__PURE__*/ (0, $e9nev.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dd2c652a409911c6$exports))),
                        alt: "CactAI",
                        className: "chat-avatar-button-image"
                    })
                })
            ]
        })
    });
}




const $5441cd050a2a0ab6$var$MAX_MESSAGES = 10;
const $5441cd050a2a0ab6$var$getMessages = ()=>{
    const messages = JSON.parse(localStorage.getItem('messages') || '[]');
    return messages.sort((a, b)=>new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()).slice(messages.length - $5441cd050a2a0ab6$var$MAX_MESSAGES, messages.length);
};
function $5441cd050a2a0ab6$export$42499dcdbb97379f({ title: title = "CactAI Chat", className: className = "cactai-chat", standalone: standalone = false }) {
    const [messages, setMessages] = (0, $eeyUA.useState)($5441cd050a2a0ab6$var$getMessages());
    const [isLoading, setIsLoading] = (0, $eeyUA.useState)(false);
    (0, $eeyUA.useEffect)(()=>{
        const newMessages = Array.from(new Map([
            ...messages,
            ...JSON.parse(localStorage.getItem('messages') || '[]')
        ].map((item)=>[
                item.id,
                item
            ])).values());
        localStorage.setItem('messages', JSON.stringify(newMessages));
    }, [
        messages
    ]);
    const onSendMessage = async (content)=>{
        const startedAt = (0, $e16fc262c883ea08$export$dde3008c9b80e3)();
        setMessages((prev)=>[
                ...prev,
                (0, $878c53339ed7cfc8$export$fca7975d61bd3fc6)(content)
            ]);
        setIsLoading(true);
        const { response: reply, messageID: messageID, cancelled: cancelled } = await (0, $e16fc262c883ea08$export$465cb47180de50f0)(content, startedAt);
        if (cancelled) return;
        const assistantMessage = (0, $878c53339ed7cfc8$export$ed9cacc6cac33058)(reply, messageID ? {
            id: messageID,
            messageID: messageID
        } : undefined);
        setMessages((prev)=>prev.some((m)=>m.id === assistantMessage.id) ? prev : [
                ...prev,
                assistantMessage
            ]);
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $e9nev.jsx)("div", {
        className: `cactai-chat-container ${className}`.trim(),
        children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $696c8e7da4f790b8$export$6fa16436f8ccc529), {
            messages: messages,
            onSendMessage: onSendMessage,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            labels: {
                inputPlaceholder: "Send a message to CactAI...",
                emptyState: "Start the conversation"
            },
            header: /*#__PURE__*/ (0, $e9nev.jsx)("div", {
                className: "demo-chat__header",
                children: title
            }),
            isStandalone: standalone
        })
    });
}



var $e9nev = parcelRequire("e9nev");

var $eeyUA = parcelRequire("eeyUA");
/*! @azure/msal-react v5.5.1 2026-06-30 */ /*! @azure/msal-react v5.5.1 2026-06-30 */ 
var $eeyUA = parcelRequire("eeyUA");
/*! @azure/msal-browser v5.16.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $cba2c9a1ab55d4d9$export$29650b96fd06034a = {
    initialize: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    acquireTokenPopup: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    acquireTokenRedirect: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    acquireTokenSilent: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    acquireTokenByCode: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    getAllAccounts: ()=>{
        return [];
    },
    getAccount: ()=>{
        return null;
    },
    handleRedirectPromise: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    loginPopup: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    loginRedirect: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    logoutRedirect: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    logoutPopup: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    ssoSilent: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    addEventCallback: ()=>{
        return null;
    },
    removeEventCallback: ()=>{
        return;
    },
    addPerformanceCallback: ()=>{
        return "";
    },
    removePerformanceCallback: ()=>{
        return false;
    },
    getLogger: ()=>{
        throw (0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), "");
    },
    setLogger: ()=>{
        return;
    },
    setActiveAccount: ()=>{
        return;
    },
    getActiveAccount: ()=>{
        return null;
    },
    initializeWrapperLibrary: ()=>{
        return;
    },
    setNavigationClient: ()=>{
        return;
    },
    getConfiguration: ()=>{
        throw (0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), "");
    },
    hydrateCache: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    },
    clearCache: ()=>{
        return Promise.reject((0, $179ed9ff4e1d3922$export$176bd5050947ba0c)((0, $3c757ef3817bc34f$export$1377ea690fa0b6d8), ""));
    }
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*
 * Stubbed context implementation
 * Only used when there is no provider, which is an unsupported scenario
 */ const $60e70e8a95b8192f$var$defaultMsalContext = {
    instance: (0, $cba2c9a1ab55d4d9$export$29650b96fd06034a),
    inProgress: (0, $7101cc4ee26a17a4$export$bec20eda0179362b).None,
    accounts: [],
    logger: new (0, $0fd93c953107c2f4$export$efa9a398d6368992)({})
};
const $60e70e8a95b8192f$export$66324aeea97dd1e5 = $eeyUA.createContext($60e70e8a95b8192f$var$defaultMsalContext);
const $60e70e8a95b8192f$export$b74154d0810e24c1 = $60e70e8a95b8192f$export$66324aeea97dd1e5.Consumer;


/*! @azure/msal-react v5.5.1 2026-06-30 */ 
var $eeyUA = parcelRequire("eeyUA");
/*! @azure/msal-browser v5.16.0 2026-06-30 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $6d88dc1f620bb7db$export$ba9166e03da6599c {
    /**
     * Gets interaction status from event message
     * @param message
     * @param currentStatus
     */ static getInteractionStatusFromEvent(message, currentStatus) {
        switch(message.eventType){
            case (0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_START:
                if (message.interactionType === (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup) return (0, $7101cc4ee26a17a4$export$bec20eda0179362b).AcquireToken;
                break;
            case (0, $2f7b58c8e76d4457$export$3d7865934588d77e).HANDLE_REDIRECT_START:
                return (0, $7101cc4ee26a17a4$export$bec20eda0179362b).HandleRedirect;
            case (0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_START:
                return (0, $7101cc4ee26a17a4$export$bec20eda0179362b).Logout;
            case (0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGOUT_END:
                if (currentStatus && currentStatus !== (0, $7101cc4ee26a17a4$export$bec20eda0179362b).Logout) break;
                return (0, $7101cc4ee26a17a4$export$bec20eda0179362b).None;
            case (0, $2f7b58c8e76d4457$export$3d7865934588d77e).HANDLE_REDIRECT_END:
                if (currentStatus && currentStatus !== (0, $7101cc4ee26a17a4$export$bec20eda0179362b).HandleRedirect) break;
                return (0, $7101cc4ee26a17a4$export$bec20eda0179362b).None;
            case (0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS:
            case (0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE:
            case (0, $2f7b58c8e76d4457$export$3d7865934588d77e).RESTORE_FROM_BFCACHE:
                if (message.interactionType === (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup) {
                    if (currentStatus && currentStatus !== (0, $7101cc4ee26a17a4$export$bec20eda0179362b).AcquireToken) break;
                    return (0, $7101cc4ee26a17a4$export$bec20eda0179362b).None;
                }
                break;
        }
        return null;
    }
}



/*! @azure/msal-react v5.5.1 2026-06-30 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $b871115412455e33$export$7a39d5906c5d6010(children, args) {
    if (typeof children === "function") return children(args);
    return children;
}
/**
 * Helper function to determine whether 2 arrays are equal
 * Used to avoid unnecessary state updates
 * @param arrayA
 * @param arrayB
 */ function $b871115412455e33$export$601fd69958c01c8c(arrayA, arrayB) {
    if (arrayA.length !== arrayB.length) return false;
    const comparisonArray = [
        ...arrayB
    ];
    return arrayA.every((elementA)=>{
        const elementB = comparisonArray.shift();
        if (!elementA || !elementB) return false;
        return elementA.homeAccountId === elementB.homeAccountId && elementA.localAccountId === elementB.localAccountId && elementA.username === elementB.username;
    });
}
function $b871115412455e33$export$fa581286d49c51db(allAccounts, accountIdentifiers) {
    if (allAccounts.length > 0 && (accountIdentifiers.homeAccountId || accountIdentifiers.localAccountId || accountIdentifiers.username)) {
        const matchedAccounts = allAccounts.filter((accountObj)=>{
            if (accountIdentifiers.username && accountIdentifiers.username.toLowerCase() !== accountObj.username.toLowerCase()) return false;
            if (accountIdentifiers.homeAccountId && accountIdentifiers.homeAccountId.toLowerCase() !== accountObj.homeAccountId.toLowerCase()) return false;
            if (accountIdentifiers.localAccountId && accountIdentifiers.localAccountId.toLowerCase() !== accountObj.localAccountId.toLowerCase()) return false;
            return true;
        });
        return matchedAccounts[0] || null;
    } else return null;
}


/*! @azure/msal-react v5.5.1 2026-06-30 */ 'use strict';
/* eslint-disable header/header */ const $de57b30822b9b332$export$a8ff84c12d48cfa6 = "@azure/msal-react";
const $de57b30822b9b332$export$83d89fbfd8236492 = "5.5.1";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $710839bca839223b$var$MsalProviderActionType = {
    UNBLOCK_INPROGRESS: "UNBLOCK_INPROGRESS",
    EVENT: "EVENT"
};
/**
 * Returns the next inProgress and accounts state based on event message
 * @param previousState
 * @param action
 */ const $710839bca839223b$var$reducer = (previousState, action)=>{
    const { type: type, payload: payload } = action;
    let newInProgress = previousState.inProgress;
    switch(type){
        case $710839bca839223b$var$MsalProviderActionType.UNBLOCK_INPROGRESS:
            if (previousState.inProgress === (0, $7101cc4ee26a17a4$export$bec20eda0179362b).Startup) {
                newInProgress = (0, $7101cc4ee26a17a4$export$bec20eda0179362b).None;
                payload.logger.info("MsalProvider - handleRedirectPromise resolved, setting inProgress to 'none'", "");
            }
            break;
        case $710839bca839223b$var$MsalProviderActionType.EVENT:
            const message = payload.message;
            const status = (0, $6d88dc1f620bb7db$export$ba9166e03da6599c).getInteractionStatusFromEvent(message, previousState.inProgress);
            if (status) {
                payload.logger.info(`MsalProvider - '${message.eventType}' results in setting inProgress from '${previousState.inProgress}' to '${status}'`, "");
                newInProgress = status;
            }
            break;
        default:
            throw new Error(`Unknown action type: ${type}`);
    }
    if (newInProgress === (0, $7101cc4ee26a17a4$export$bec20eda0179362b).Startup) // Can't start checking accounts until initialization is complete
    return previousState;
    const currentAccounts = payload.instance.getAllAccounts();
    if (newInProgress !== previousState.inProgress && !(0, $b871115412455e33$export$601fd69958c01c8c)(currentAccounts, previousState.accounts)) // Both inProgress and accounts changed
    return {
        ...previousState,
        inProgress: newInProgress,
        accounts: currentAccounts
    };
    else if (newInProgress !== previousState.inProgress) // Only only inProgress changed
    return {
        ...previousState,
        inProgress: newInProgress
    };
    else if (!(0, $b871115412455e33$export$601fd69958c01c8c)(currentAccounts, previousState.accounts)) // Only accounts changed
    return {
        ...previousState,
        accounts: currentAccounts
    };
    else // Nothing changed
    return previousState;
};
/**
 * MSAL context provider component. This must be rendered above any other components that use MSAL.
 */ function $710839bca839223b$export$25bac41dc3d78d47({ instance: instance, children: children }) {
    (0, $eeyUA.useEffect)(()=>{
        instance.initializeWrapperLibrary((0, $7101cc4ee26a17a4$export$8abb9de997bb4e44).React, (0, $de57b30822b9b332$export$83d89fbfd8236492));
    }, [
        instance
    ]);
    // Create a logger instance for msal-react with the same options as PublicClientApplication
    const logger = (0, $eeyUA.useMemo)(()=>{
        return instance.getLogger().clone((0, $de57b30822b9b332$export$a8ff84c12d48cfa6), (0, $de57b30822b9b332$export$83d89fbfd8236492));
    }, [
        instance
    ]);
    const [state, updateState] = (0, $eeyUA.useReducer)($710839bca839223b$var$reducer, undefined, ()=>{
        // Lazy initialization of the initial state
        return {
            inProgress: (0, $7101cc4ee26a17a4$export$bec20eda0179362b).Startup,
            accounts: []
        };
    });
    (0, $eeyUA.useEffect)(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            updateState({
                payload: {
                    instance: instance,
                    logger: logger,
                    message: message
                },
                type: $710839bca839223b$var$MsalProviderActionType.EVENT
            });
        });
        logger.verbose(`MsalProvider - Registered event callback with id: '${callbackId}'`, "");
        instance.initialize().then(()=>{
            instance.handleRedirectPromise().catch(()=>{
                // Errors should be handled by listening to the LOGIN_FAILURE event
                return;
            }).finally(()=>{
                /*
                 * If handleRedirectPromise returns a cached promise the necessary events may not be fired
                 * This is a fallback to prevent inProgress from getting stuck in 'startup'
                 */ updateState({
                    payload: {
                        instance: instance,
                        logger: logger
                    },
                    type: $710839bca839223b$var$MsalProviderActionType.UNBLOCK_INPROGRESS
                });
            });
        }).catch(()=>{
            // Errors should be handled by listening to the LOGIN_FAILURE event
            return;
        });
        return ()=>{
            // Remove callback when component unmounts or accounts change
            if (callbackId) {
                logger.verbose(`MsalProvider - Removing event callback '${callbackId}'`, "");
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    const contextValue = {
        instance: instance,
        inProgress: state.inProgress,
        accounts: state.accounts,
        logger: logger
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, $60e70e8a95b8192f$export$66324aeea97dd1e5).Provider, {
        value: contextValue
    }, children);
}


/*! @azure/msal-react v5.5.1 2026-06-30 */ 
var $eeyUA = parcelRequire("eeyUA");

/*! @azure/msal-react v5.5.1 2026-06-30 */ 
var $eeyUA = parcelRequire("eeyUA");

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns Msal Context values
 */ const $53d03c4325cd69bf$export$f41558044a1dd55 = ()=>(0, $eeyUA.useContext)((0, $60e70e8a95b8192f$export$66324aeea97dd1e5));


/*! @azure/msal-react v5.5.1 2026-06-30 */ 
var $eeyUA = parcelRequire("eeyUA");



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $b456e1137d3c2117$var$isAuthenticated(allAccounts, matchAccount) {
    if (matchAccount && (matchAccount.username || matchAccount.homeAccountId || matchAccount.localAccountId)) return !!(0, $b871115412455e33$export$fa581286d49c51db)(allAccounts, matchAccount);
    return allAccounts.length > 0;
}
/**
 * Returns whether or not a user is currently signed-in. Optionally provide 1 or more accountIdentifiers to determine if a specific user is signed-in
 * @param matchAccount
 */ function $b456e1137d3c2117$export$7e9c60d6d1836c84(matchAccount) {
    const { accounts: allAccounts, inProgress: inProgress } = (0, $53d03c4325cd69bf$export$f41558044a1dd55)();
    const isUserAuthenticated = (0, $eeyUA.useMemo)(()=>{
        if (inProgress === (0, $7101cc4ee26a17a4$export$bec20eda0179362b).Startup) return false;
        return $b456e1137d3c2117$var$isAuthenticated(allAccounts, matchAccount);
    }, [
        allAccounts,
        inProgress,
        matchAccount
    ]);
    return isUserAuthenticated;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is authenticated
 * @param props
 */ function $4da6df91f44339a6$export$3f7734c901feade6({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = (0, $53d03c4325cd69bf$export$f41558044a1dd55)();
    const accountIdentifier = (0, $eeyUA.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = (0, $b456e1137d3c2117$export$7e9c60d6d1836c84)(accountIdentifier);
    if (isAuthenticated && context.inProgress !== (0, $7101cc4ee26a17a4$export$bec20eda0179362b).Startup) return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Fragment, null, (0, $b871115412455e33$export$7a39d5906c5d6010)(children, context));
    return null;
}


/*! @azure/msal-react v5.5.1 2026-06-30 */ 
var $eeyUA = parcelRequire("eeyUA");




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is unauthenticated
 * @param props
 */ function $b920ddc4f9db74d0$export$8285a35799c5812b({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = (0, $53d03c4325cd69bf$export$f41558044a1dd55)();
    const accountIdentifier = (0, $eeyUA.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = (0, $b456e1137d3c2117$export$7e9c60d6d1836c84)(accountIdentifier);
    if (!isAuthenticated && context.inProgress !== (0, $7101cc4ee26a17a4$export$bec20eda0179362b).Startup && context.inProgress !== (0, $7101cc4ee26a17a4$export$bec20eda0179362b).HandleRedirect) return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Fragment, null, (0, $b871115412455e33$export$7a39d5906c5d6010)(children, context));
    return null;
}


/*! @azure/msal-react v5.5.1 2026-06-30 */ 
var $eeyUA = parcelRequire("eeyUA");


/*! @azure/msal-react v5.5.1 2026-06-30 */ 
var $eeyUA = parcelRequire("eeyUA");
/*! @azure/msal-browser v5.16.0 2026-06-30 */ 























'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @packageDocumentation
 * @module @azure/msal-browser
 */ // Common constants
const $8fc27be6da700095$export$901491a717da2ba5 = (0, $8994aeee5e01080d$exports).AuthenticationScheme;
const $8fc27be6da700095$export$f990a5bae1260b8c = (0, $8994aeee5e01080d$exports).ResponseMode;
const $8fc27be6da700095$export$49a06cbda5acaa5 = (0, $8994aeee5e01080d$exports).PromptValue;
const $8fc27be6da700095$export$fe5c42ed17efe603 = (0, $8994aeee5e01080d$exports).JsonWebTokenTypes;
const $8fc27be6da700095$export$893b1b5b686d84ef = (0, $8994aeee5e01080d$exports).OIDC_DEFAULT_SCOPES;




/*! @azure/msal-react v5.5.1 2026-06-30 */ 
var $eeyUA = parcelRequire("eeyUA");



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $d8cf178bb968284a$var$getAccount(instance, accountIdentifiers) {
    if (!accountIdentifiers || !accountIdentifiers.homeAccountId && !accountIdentifiers.localAccountId && !accountIdentifiers.username) // If no account identifiers are provided, return active account
    return instance.getActiveAccount();
    return (0, $b871115412455e33$export$fa581286d49c51db)(instance.getAllAccounts(), accountIdentifiers);
}
/**
 * Helper function to determine whether 2 accountInfo objects represent the same account
 * @param accountA
 * @param accountB
 */ function $d8cf178bb968284a$export$e7484df505e59f1(accountA, accountB) {
    if (!accountA || !accountB) return false;
    const accountAClaims = accountA.idTokenClaims || {};
    const accountBClaims = accountB.idTokenClaims || {};
    // issued at timestamp and nonce are expected to change each time a new id token is acquired
    const claimsMatch = accountAClaims.iat === accountBClaims.iat && accountAClaims.nonce === accountBClaims.nonce;
    return accountA.homeAccountId === accountB.homeAccountId && accountA.localAccountId === accountB.localAccountId && accountA.username === accountB.username && accountA.tenantId === accountB.tenantId && accountA.environment === accountB.environment && accountA.nativeAccountId === accountB.nativeAccountId && claimsMatch;
}
/**
 * Given 1 or more accountIdentifiers, returns the Account object if the user is signed-in
 * @param accountIdentifiers
 */ function $d8cf178bb968284a$export$83a8e409853da004(accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = (0, $53d03c4325cd69bf$export$f41558044a1dd55)();
    const [account, setAccount] = (0, $eeyUA.useState)(()=>{
        if (inProgress === (0, $7101cc4ee26a17a4$export$bec20eda0179362b).Startup) return null;
        else return $d8cf178bb968284a$var$getAccount(instance, accountIdentifiers);
    });
    const updateAccount = (0, $eeyUA.useCallback)(()=>{
        const nextAccount = $d8cf178bb968284a$var$getAccount(instance, accountIdentifiers);
        setAccount((currentAccount)=>{
            if (!$d8cf178bb968284a$export$e7484df505e59f1(currentAccount, nextAccount)) {
                logger.info("useAccount - Updating account", "");
                return nextAccount;
            }
            return currentAccount;
        });
    }, [
        accountIdentifiers,
        instance,
        logger
    ]);
    (0, $eeyUA.useEffect)(()=>{
        if (inProgress !== (0, $7101cc4ee26a17a4$export$bec20eda0179362b).Startup) updateAccount();
        const callbackId = instance.addEventCallback((message)=>{
            if (message.eventType === (0, $2f7b58c8e76d4457$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED || message.eventType === (0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGIN_SUCCESS && message.interactionType === (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent) updateAccount();
        });
        return ()=>{
            if (callbackId) instance.removeEventCallback(callbackId);
        };
    }, [
        updateAccount,
        inProgress,
        instance
    ]);
    return account;
}


/*! @azure/msal-react v5.5.1 2026-06-30 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $dca4f51e43a98eb0$export$a77ea62d722c2a73 = {
    invalidInteractionType: {
        code: "invalid_interaction_type",
        desc: "The provided interaction type is invalid."
    },
    unableToFallbackToInteraction: {
        code: "unable_to_fallback_to_interaction",
        desc: "Interaction is required but another interaction is already in progress. Please try again when the current interaction is complete."
    }
};
class $dca4f51e43a98eb0$export$2aa0f0a55de712e6 extends (0, $8d1fc9917b2c0dac$export$145273558d58e0ac) {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        Object.setPrototypeOf(this, $dca4f51e43a98eb0$export$2aa0f0a55de712e6.prototype);
        this.name = "ReactAuthError";
    }
    static createInvalidInteractionTypeError(correlationId) {
        return new $dca4f51e43a98eb0$export$2aa0f0a55de712e6($dca4f51e43a98eb0$export$a77ea62d722c2a73.invalidInteractionType.code, correlationId || "", $dca4f51e43a98eb0$export$a77ea62d722c2a73.invalidInteractionType.desc);
    }
    static createUnableToFallbackToInteractionError(correlationId) {
        return new $dca4f51e43a98eb0$export$2aa0f0a55de712e6($dca4f51e43a98eb0$export$a77ea62d722c2a73.unableToFallbackToInteraction.code, correlationId || "", $dca4f51e43a98eb0$export$a77ea62d722c2a73.unableToFallbackToInteraction.desc);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * If a user is not currently signed in this hook invokes a login. Failed logins can be retried using the login callback returned.
 * If a user is currently signed in this hook attempts to acquire a token. Subsequent token requests can use the acquireToken callback returned.
 * Optionally provide a request object to be used in the login/acquireToken call.
 * Optionally provide a specific user that should be logged in.
 * @param interactionType
 * @param authenticationRequest
 * @param accountIdentifiers
 */ function $134a550bcae7842f$export$d130d543558e611f(interactionType, authenticationRequest, accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = (0, $53d03c4325cd69bf$export$f41558044a1dd55)();
    const isAuthenticated = (0, $b456e1137d3c2117$export$7e9c60d6d1836c84)(accountIdentifiers);
    const account = (0, $d8cf178bb968284a$export$83a8e409853da004)(accountIdentifiers);
    const [[result, error], setResponse] = (0, $eeyUA.useState)([
        null,
        null
    ]);
    // Used to prevent state updates after unmount
    const mounted = (0, $eeyUA.useRef)(true);
    (0, $eeyUA.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    // Boolean used to check if interaction is in progress in acquireTokenSilent fallback. Use Ref instead of state to prevent acquireToken function from being regenerated on each change to interactionInProgress value
    const interactionInProgress = (0, $eeyUA.useRef)(inProgress !== (0, $7101cc4ee26a17a4$export$bec20eda0179362b).None);
    (0, $eeyUA.useEffect)(()=>{
        interactionInProgress.current = inProgress !== (0, $7101cc4ee26a17a4$export$bec20eda0179362b).None;
    }, [
        inProgress
    ]);
    // Flag used to control when the hook calls login/acquireToken
    const shouldAcquireToken = (0, $eeyUA.useRef)(true);
    (0, $eeyUA.useEffect)(()=>{
        if (!!error) {
            // Errors should be handled by consuming component
            shouldAcquireToken.current = false;
            return;
        }
        if (!!result) {
            // Token has already been acquired, consuming component/application is responsible for renewing
            shouldAcquireToken.current = false;
            return;
        }
    }, [
        error,
        result
    ]);
    const login = (0, $eeyUA.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const loginType = callbackInteractionType || interactionType;
        const loginRequest = callbackRequest || authenticationRequest;
        const getToken = async ()=>{
            logger.verbose("useMsalAuthentication - Calling getToken", callbackRequest?.correlationId || "");
            switch(loginType){
                case (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Popup:
                    logger.verbose("useMsalAuthentication - Calling loginPopup", callbackRequest?.correlationId || "");
                    return instance.loginPopup(loginRequest);
                case (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect:
                    // This promise is not expected to resolve due to full frame redirect
                    logger.verbose("useMsalAuthentication - Calling loginRedirect", callbackRequest?.correlationId || "");
                    await instance.handleRedirectPromise();
                    return instance.loginRedirect(loginRequest).then(()=>null);
                case (0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Silent:
                    logger.verbose("useMsalAuthentication - Calling ssoSilent", callbackRequest?.correlationId || "");
                    return instance.ssoSilent(!!loginRequest ? loginRequest : {});
                default:
                    const invalidTypeError = (0, $dca4f51e43a98eb0$export$2aa0f0a55de712e6).createInvalidInteractionTypeError(loginRequest?.correlationId);
                    if (mounted.current) setResponse([
                        null,
                        invalidTypeError
                    ]);
                    throw invalidTypeError;
            }
        };
        return getToken().then((response)=>{
            if (response && mounted.current) setResponse([
                response,
                null
            ]);
            return response;
        }).catch((e)=>{
            if (mounted.current) setResponse([
                null,
                e
            ]);
            throw e;
        });
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger
    ]);
    const acquireToken = (0, $eeyUA.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const fallbackInteractionType = callbackInteractionType || interactionType;
        let tokenRequest;
        if (callbackRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the callback", callbackRequest.correlationId || "");
            tokenRequest = {
                ...callbackRequest
            };
        } else if (authenticationRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the hook", authenticationRequest.correlationId || "");
            tokenRequest = {
                ...authenticationRequest,
                scopes: authenticationRequest.scopes || (0, $8fc27be6da700095$export$893b1b5b686d84ef)
            };
        } else {
            logger.trace("useMsalAuthentication - acquireToken - No request object provided, using default request.", "");
            tokenRequest = {
                scopes: (0, $8fc27be6da700095$export$893b1b5b686d84ef)
            };
        }
        const correlationId = tokenRequest.correlationId || (0, $8e677587a7c978db$exports).createGuid();
        tokenRequest.correlationId = correlationId;
        if (!tokenRequest.account && account) {
            logger.trace("useMsalAuthentication - acquireToken - Attaching account to request", correlationId);
            tokenRequest.account = account;
        }
        return instance.acquireTokenSilent(tokenRequest).then((response)=>{
            if (mounted.current) setResponse([
                response,
                null
            ]);
            return response;
        }).catch(async (e)=>{
            if (e instanceof (0, $e9bbb17645bd3149$export$6ba3e818c6bc76ba)) {
                if (!interactionInProgress.current) {
                    logger.error("useMsalAuthentication - Interaction required, falling back to interaction", correlationId);
                    return login(fallbackInteractionType, tokenRequest);
                } else {
                    const fallbackError = (0, $dca4f51e43a98eb0$export$2aa0f0a55de712e6).createUnableToFallbackToInteractionError(correlationId);
                    logger.error("useMsalAuthentication - Interaction required but is already in progress. Please try again, if needed, after interaction completes.", correlationId);
                    if (mounted.current) setResponse([
                        null,
                        fallbackError
                    ]);
                    throw fallbackError;
                }
            }
            // Handle other errors
            if (mounted.current) setResponse([
                null,
                e
            ]);
            throw e;
        });
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger,
        account,
        login
    ]);
    (0, $eeyUA.useEffect)(()=>{
        if (shouldAcquireToken.current && inProgress === (0, $7101cc4ee26a17a4$export$bec20eda0179362b).None) {
            if (!isAuthenticated) {
                shouldAcquireToken.current = false;
                logger.info("useMsalAuthentication - No user is authenticated, attempting to login", "");
                login().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            } else if (account) {
                shouldAcquireToken.current = false;
                logger.info("useMsalAuthentication - User is authenticated, attempting to acquire token", "");
                acquireToken().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            }
        // If logging out, set the state to null so the component doesn't display authenticated content for a user that is logged out
        } else if (!account && result) setResponse([
            null,
            null
        ]);
    }, [
        isAuthenticated,
        account,
        inProgress,
        login,
        acquireToken,
        logger
    ]);
    return {
        login: login,
        acquireToken: acquireToken,
        result: result,
        error: error
    };
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Attempts to authenticate user if not already authenticated, then renders child components
 * @param props
 */ function $2aab632b47f97def$export$c9cd7a02d4bd7707({ interactionType: interactionType, username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, authenticationRequest: authenticationRequest, loadingComponent: LoadingComponent, errorComponent: ErrorComponent, children: children }) {
    const accountIdentifier = (0, $eeyUA.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const context = (0, $53d03c4325cd69bf$export$f41558044a1dd55)();
    const msalAuthResult = (0, $134a550bcae7842f$export$d130d543558e611f)(interactionType, authenticationRequest, accountIdentifier);
    const isAuthenticated = (0, $b456e1137d3c2117$export$7e9c60d6d1836c84)(accountIdentifier);
    if (msalAuthResult.error && context.inProgress === (0, $7101cc4ee26a17a4$export$bec20eda0179362b).None) {
        if (!!ErrorComponent) return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(ErrorComponent, {
            ...msalAuthResult
        });
        throw msalAuthResult.error;
    }
    if (isAuthenticated) return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).Fragment, null, (0, $b871115412455e33$export$7a39d5906c5d6010)(children, msalAuthResult));
    if (!!LoadingComponent && context.inProgress !== (0, $7101cc4ee26a17a4$export$bec20eda0179362b).None) return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(LoadingComponent, {
        ...context
    });
    return null;
}


/*! @azure/msal-react v5.5.1 2026-06-30 */ 
var $eeyUA = parcelRequire("eeyUA");

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Higher order component wraps provided component with msal by injecting msal context values into the component's props
 * @param Component
 */ const $83c5852d0c746ade$export$8dea26c30ebc61cd = (Component)=>{
    const ComponentWithMsal = (props)=>{
        const msal = (0, $53d03c4325cd69bf$export$f41558044a1dd55)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeyUA))).createElement(Component, {
            ...props,
            msalContext: msal
        });
    };
    const componentName = Component.displayName || Component.name || "Component";
    ComponentWithMsal.displayName = `withMsal(${componentName})`;
    return ComponentWithMsal;
};







'use strict';




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */ const $d9ec22feede57c3d$var$TENANT_ID = "740e0ba1-e4ed-4c5d-9a56-2559c8fb94a6";
const $d9ec22feede57c3d$var$CLIENT_ID = "da42c2c9-fec6-47df-8caa-24eaeddc4082";
const $d9ec22feede57c3d$var$redirectUri = `${window.location.origin}`;
const $d9ec22feede57c3d$export$f6d610d2730cbf1a = {
    auth: {
        clientId: `${$d9ec22feede57c3d$var$CLIENT_ID}`,
        authority: `https://login.microsoftonline.com/${$d9ec22feede57c3d$var$TENANT_ID}`,
        redirectUri: $d9ec22feede57c3d$var$redirectUri,
        postLogoutRedirectUri: $d9ec22feede57c3d$var$redirectUri
    },
    cache: {
        cacheLocation: "sessionStorage"
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii)=>{
                if (containsPii) return;
                switch(level){
                    case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Error:
                        break;
                    case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Info:
                        break;
                    case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Verbose:
                        break;
                    case (0, $0fd93c953107c2f4$export$243e62d78d3b544d).Warning:
                        break;
                }
            }
        }
    }
};
const $d9ec22feede57c3d$export$be6c432b2463c5eb = {
    scopes: [
        "User.Read"
    ]
};
const $d9ec22feede57c3d$export$4965d3e40bbf5ccb = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};


const $9047bffd7d73a6ba$var$isSingleSpa = false;
const $9047bffd7d73a6ba$var$CLIENT_ID = $9047bffd7d73a6ba$var$isSingleSpa ? "" : "da42c2c9-fec6-47df-8caa-24eaeddc4082";
const $9047bffd7d73a6ba$export$ca9e2d319cf1d00d = {
    scopes: [
        `${$9047bffd7d73a6ba$var$CLIENT_ID}/.default`
    ]
};
const $9047bffd7d73a6ba$export$a59c2286a7150b12 = new (0, $d4ca65a93729f924$export$89f4855ef88b7920)((0, $d9ec22feede57c3d$export$f6d610d2730cbf1a));
const $9047bffd7d73a6ba$export$84773cc9bf7dbe87 = async ()=>{
    await $9047bffd7d73a6ba$export$a59c2286a7150b12.initialize();
    const accounts = $9047bffd7d73a6ba$export$a59c2286a7150b12.getAllAccounts();
    if (accounts.length > 0) try {
        const request = {
            ...$9047bffd7d73a6ba$export$ca9e2d319cf1d00d,
            account: accounts[0],
            forceRefresh: false
        };
        const response = await $9047bffd7d73a6ba$export$a59c2286a7150b12.acquireTokenSilent(request);
        return response.accessToken;
    } catch (error) {
        console.error("Silent token acquisition failed:", error);
        // If silent token acquisition fails, we might need to refresh
        // but we shouldn't do interactive auth here since it should be handled by the provider
        try {
            // Try one more time with forceRefresh
            const refreshRequest = {
                ...$9047bffd7d73a6ba$export$ca9e2d319cf1d00d,
                account: accounts[0],
                forceRefresh: true
            };
            const refreshResponse = await $9047bffd7d73a6ba$export$a59c2286a7150b12.acquireTokenSilent(refreshRequest);
            return refreshResponse.accessToken;
        } catch (refreshError) {
            console.error("Token refresh failed:", refreshError);
            return null;
        }
    }
    return null;
};
// Account selection logic is app dependent. Adjust as needed for different use cases.
$9047bffd7d73a6ba$export$a59c2286a7150b12.addEventCallback((event)=>{
    if (event.eventType === (0, $2f7b58c8e76d4457$export$3d7865934588d77e).LOGIN_SUCCESS) {
        // @ts-expect-error: see above
        const account = event.payload.account;
        $9047bffd7d73a6ba$export$a59c2286a7150b12.setActiveAccount(account);
    }
});



var $e9nev = parcelRequire("e9nev");
parcelRequire("eeyUA");
var $82dc196bc2e14086$export$34e0f9847d4c02dd;
var $82dc196bc2e14086$export$eaceaf7f88807f33;
var $82dc196bc2e14086$export$7f951d8d5ede654f;
var $82dc196bc2e14086$export$a80b3bd66acc52ff;
var $82dc196bc2e14086$export$db3c28d99448dcff;
$82dc196bc2e14086$export$34e0f9847d4c02dd = `B9_LqW_container`;
$82dc196bc2e14086$export$eaceaf7f88807f33 = `B9_LqW_error-container`;
$82dc196bc2e14086$export$7f951d8d5ede654f = `B9_LqW_img-container`;
$82dc196bc2e14086$export$a80b3bd66acc52ff = `B9_LqW_info`;
$82dc196bc2e14086$export$db3c28d99448dcff = `B9_LqW_logo`;



const $230fb2dc9c8c870f$var$isHomePageOrNoUserRole = ()=>{
    return window.location.pathname === "/" || !localStorage.getItem("userRole");
};
const $230fb2dc9c8c870f$var$LoadingScreen = ({ error: error })=>{
    if ($230fb2dc9c8c870f$var$isHomePageOrNoUserRole()) return /*#__PURE__*/ (0, $e9nev.jsx)((0, $e9nev.Fragment), {
        children: /*#__PURE__*/ (0, $e9nev.jsxs)("div", {
            className: "loader-container",
            children: [
                /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$fac4de5e29191aa5), {
                    size: "lg"
                }),
                error && /*#__PURE__*/ (0, $e9nev.jsx)("div", {
                    className: "error-container",
                    children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $0eb8c2f4491c20a6$export$caec2af78bcc877f), {
                        type: (0, $0eb8c2f4491c20a6$export$5b4a8869eb24d061).Error,
                        id: "signup-error",
                        children: error
                    })
                })
            ]
        })
    });
    // Return null or other fallback for non-home pages
    return null;
};
var $230fb2dc9c8c870f$export$2e2bcd8739ae039 = $230fb2dc9c8c870f$var$LoadingScreen;


var $25746eb61037a613$export$46919bad18fb2f76 = /*#__PURE__*/ function(Role) {
    Role["ACCOUNT_MANAGER"] = "ACCOUNT_MANAGER";
    Role["RECRUITER"] = "RECRUITER";
    Role["NON_PRODUCER"] = "NON_PRODUCER";
    Role["NA"] = "N/A";
    return Role;
}({});




const $d59547663c27188e$var$ENV = "uat";
const $d59547663c27188e$var$BASE_URLS = {
    local: "http://localhost:8080/local",
    dev: "https://yox5u6qgd9.execute-api.us-east-1.amazonaws.com/dev",
    qa: "https://7e102o8ue9.execute-api.us-east-1.amazonaws.com/qa",
    uat: "https://wlp4d35ldh.execute-api.us-east-1.amazonaws.com/uat/",
    prod: "https://skyh3buu7a.execute-api.us-east-1.amazonaws.com/prod/"
};
const $d59547663c27188e$var$api = (0, $9b1678a8d2ae1e0f$export$2e2bcd8739ae039).create({
    baseURL: $d59547663c27188e$var$BASE_URLS[$d59547663c27188e$var$ENV] || $d59547663c27188e$var$BASE_URLS.prod,
    headers: {
        "Content-Type": "application/json"
    }
});
const $d59547663c27188e$export$7cbf767827cd68ba = async (oid)=>{
    try {
        const token = await (0, $9047bffd7d73a6ba$export$84773cc9bf7dbe87)();
        const response = await $d59547663c27188e$var$api.post(`/cactus-${$d59547663c27188e$var$ENV}-user-getUserData`, {
            oid: oid
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data.user;
    } catch (error) {
        if ((0, $9b1678a8d2ae1e0f$export$2e2bcd8739ae039).isAxiosError(error)) console.log("Axios error:", error.response?.data);
        else console.log("General error:", error);
        throw error;
    }
};


/**
 * React Router DOM v6.7.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eeyUA = parcelRequire("eeyUA");
/**
 * @remix-run/router v1.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $d77aa7b81189e5d8$var$_extends() {
    $d77aa7b81189e5d8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d77aa7b81189e5d8$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $d77aa7b81189e5d8$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d77aa7b81189e5d8$export$e19cd5f9376f8cee || ($d77aa7b81189e5d8$export$e19cd5f9376f8cee = {}));
const $d77aa7b81189e5d8$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $d77aa7b81189e5d8$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $d77aa7b81189e5d8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $d77aa7b81189e5d8$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d77aa7b81189e5d8$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d77aa7b81189e5d8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d77aa7b81189e5d8$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $d77aa7b81189e5d8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $d77aa7b81189e5d8$export$fe53371bee54353d(to);
    }
    return $d77aa7b81189e5d8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d77aa7b81189e5d8$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d77aa7b81189e5d8$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $d77aa7b81189e5d8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d77aa7b81189e5d8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d77aa7b81189e5d8$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $d77aa7b81189e5d8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d77aa7b81189e5d8$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d77aa7b81189e5d8$var$warning$1(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $d77aa7b81189e5d8$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $d77aa7b81189e5d8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $d77aa7b81189e5d8$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $d77aa7b81189e5d8$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $d77aa7b81189e5d8$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d77aa7b81189e5d8$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $d77aa7b81189e5d8$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $d77aa7b81189e5d8$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d77aa7b81189e5d8$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($d77aa7b81189e5d8$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        let nextAction = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        if (nextIndex != null) {
            let delta = nextIndex - index;
            action = nextAction;
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: history.location,
                delta: delta
            });
        } else $d77aa7b81189e5d8$var$warning$1(false, // and link to it here so people can understand better what is going on
        // and how to avoid it.
        "You are trying to block a POP navigation to a location that was not created by @remix-run/router. The block will fail silently in production, but in general you should do all navigation with the router (instead of using window.history.pushState directly) to avoid this situation.");
    }
    function push(to, state) {
        action = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Push;
        let location = $d77aa7b81189e5d8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d77aa7b81189e5d8$var$getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Replace;
        let location = $d77aa7b81189e5d8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d77aa7b81189e5d8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $d77aa7b81189e5d8$export$fe53371bee54353d(to);
        $d77aa7b81189e5d8$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($d77aa7b81189e5d8$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($d77aa7b81189e5d8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $d77aa7b81189e5d8$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($d77aa7b81189e5d8$var$ResultType || ($d77aa7b81189e5d8$var$ResultType = {}));
function $d77aa7b81189e5d8$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $d77aa7b81189e5d8$export$4a6d22b32134ea5d(routes, parentPath, allIds) {
    if (parentPath === void 0) parentPath = [];
    if (allIds === void 0) allIds = new Set();
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d77aa7b81189e5d8$export$f5708dca728d7177(route.index !== true || !route.children, "Cannot specify children on an index route");
        $d77aa7b81189e5d8$export$f5708dca728d7177(!allIds.has(id), "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        allIds.add(id);
        if ($d77aa7b81189e5d8$var$isIndexRoute(route)) {
            let indexRoute = $d77aa7b81189e5d8$var$_extends({}, route, {
                id: id
            });
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $d77aa7b81189e5d8$var$_extends({}, route, {
                id: id,
                children: route.children ? $d77aa7b81189e5d8$export$4a6d22b32134ea5d(route.children, treePath, allIds) : undefined
            });
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $d77aa7b81189e5d8$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $d77aa7b81189e5d8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d77aa7b81189e5d8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $d77aa7b81189e5d8$var$flattenRoutes(routes);
    $d77aa7b81189e5d8$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $d77aa7b81189e5d8$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $d77aa7b81189e5d8$var$safelyDecodeURI(pathname));
    return matches;
}
function $d77aa7b81189e5d8$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $d77aa7b81189e5d8$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d77aa7b81189e5d8$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $d77aa7b81189e5d8$export$f5708dca728d7177(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $d77aa7b81189e5d8$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d77aa7b81189e5d8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $d77aa7b81189e5d8$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $d77aa7b81189e5d8$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d77aa7b81189e5d8$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d77aa7b81189e5d8$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $d77aa7b81189e5d8$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $d77aa7b81189e5d8$var$paramRe = /^:\w+$/;
const $d77aa7b81189e5d8$var$dynamicSegmentValue = 3;
const $d77aa7b81189e5d8$var$indexRouteValue = 2;
const $d77aa7b81189e5d8$var$emptySegmentValue = 1;
const $d77aa7b81189e5d8$var$staticSegmentValue = 10;
const $d77aa7b81189e5d8$var$splatPenalty = -2;
const $d77aa7b81189e5d8$var$isSplat = (s)=>s === "*";
function $d77aa7b81189e5d8$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d77aa7b81189e5d8$var$isSplat)) initialScore += $d77aa7b81189e5d8$var$splatPenalty;
    if (index) initialScore += $d77aa7b81189e5d8$var$indexRouteValue;
    return segments.filter((s)=>!$d77aa7b81189e5d8$var$isSplat(s)).reduce((score, segment)=>score + ($d77aa7b81189e5d8$var$paramRe.test(segment) ? $d77aa7b81189e5d8$var$dynamicSegmentValue : segment === "" ? $d77aa7b81189e5d8$var$emptySegmentValue : $d77aa7b81189e5d8$var$staticSegmentValue), initialScore);
}
function $d77aa7b81189e5d8$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $d77aa7b81189e5d8$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d77aa7b81189e5d8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d77aa7b81189e5d8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d77aa7b81189e5d8$export$a5c6d149b50c1d86($d77aa7b81189e5d8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d77aa7b81189e5d8$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $d77aa7b81189e5d8$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d77aa7b81189e5d8$export$491112666e282270(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    return path.replace(/^:(\w+)(\??)/g, (_, key, optional)=>{
        let param = params[key];
        if (optional === "?") return param == null ? "" : param;
        if (param == null) $d77aa7b81189e5d8$export$f5708dca728d7177(false, "Missing \":" + key + "\" param");
        return param;
    }).replace(/\/:(\w+)(\??)/g, (_, key, optional)=>{
        let param = params[key];
        if (optional === "?") return param == null ? "" : "/" + param;
        if (param == null) $d77aa7b81189e5d8$export$f5708dca728d7177(false, "Missing \":" + key + "\" param");
        return "/" + param;
    }) // Remove any optional markers from optional static segments
    .replace(/\?/g, "").replace(/(\/?)\*/, (_, prefix, __, str)=>{
        const star = "*";
        if (params[star] == null) // If no splat was provided, trim the trailing slash _unless_ it's
        // the entire path
        return str === "/*" ? "/" : "";
         // Apply the splat
        return "" + prefix + params[star];
    });
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $d77aa7b81189e5d8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $d77aa7b81189e5d8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $d77aa7b81189e5d8$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d77aa7b81189e5d8$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $d77aa7b81189e5d8$export$491112666e282270(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $d77aa7b81189e5d8$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $d77aa7b81189e5d8$export$491112666e282270(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $d77aa7b81189e5d8$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $d77aa7b81189e5d8$export$491112666e282270(false, "The value for the URL param \"" + paramName + "\" will not be decoded because" + (" the string \"" + value + "\" is a malformed URL segment. This is probably") + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $d77aa7b81189e5d8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * @private
 */ function $d77aa7b81189e5d8$export$491112666e282270(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging @remix-run/router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $d77aa7b81189e5d8$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d77aa7b81189e5d8$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $d77aa7b81189e5d8$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $d77aa7b81189e5d8$var$normalizeSearch(search),
        hash: $d77aa7b81189e5d8$var$normalizeHash(hash)
    };
}
function $d77aa7b81189e5d8$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d77aa7b81189e5d8$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $d77aa7b81189e5d8$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $d77aa7b81189e5d8$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $d77aa7b81189e5d8$export$8ccf933b0513f8d0(toArg);
    else {
        to = $d77aa7b81189e5d8$var$_extends({}, toArg);
        $d77aa7b81189e5d8$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $d77aa7b81189e5d8$var$getInvalidPathError("?", "pathname", "search", to));
        $d77aa7b81189e5d8$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $d77aa7b81189e5d8$var$getInvalidPathError("#", "pathname", "hash", to));
        $d77aa7b81189e5d8$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $d77aa7b81189e5d8$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d77aa7b81189e5d8$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $d77aa7b81189e5d8$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $d77aa7b81189e5d8$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $d77aa7b81189e5d8$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $d77aa7b81189e5d8$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $d77aa7b81189e5d8$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $d77aa7b81189e5d8$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $d77aa7b81189e5d8$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $d77aa7b81189e5d8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $d77aa7b81189e5d8$export$42a99a7a4bc0e76a extends Error {
}
class $d77aa7b81189e5d8$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $d77aa7b81189e5d8$export$f5708dca728d7177(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $d77aa7b81189e5d8$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $d77aa7b81189e5d8$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $d77aa7b81189e5d8$export$f5708dca728d7177(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $d77aa7b81189e5d8$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $d77aa7b81189e5d8$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $d77aa7b81189e5d8$var$unwrapTrackedPromise(value) {
    if (!$d77aa7b81189e5d8$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $d77aa7b81189e5d8$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $d77aa7b81189e5d8$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d77aa7b81189e5d8$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $d77aa7b81189e5d8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $d77aa7b81189e5d8$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response throw from an action/loader
 */ function $d77aa7b81189e5d8$export$972111febbeef05b(e) {
    return e instanceof $d77aa7b81189e5d8$export$acf1a680051f5031;
}
const $d77aa7b81189e5d8$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $d77aa7b81189e5d8$var$validMutationMethods = new Set($d77aa7b81189e5d8$var$validMutationMethodsArr);
const $d77aa7b81189e5d8$var$validRequestMethodsArr = [
    "get",
    ...$d77aa7b81189e5d8$var$validMutationMethodsArr
];
const $d77aa7b81189e5d8$var$validRequestMethods = new Set($d77aa7b81189e5d8$var$validRequestMethodsArr);
const $d77aa7b81189e5d8$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $d77aa7b81189e5d8$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $d77aa7b81189e5d8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $d77aa7b81189e5d8$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $d77aa7b81189e5d8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $d77aa7b81189e5d8$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $d77aa7b81189e5d8$var$isServer = !$d77aa7b81189e5d8$var$isBrowser; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $d77aa7b81189e5d8$export$baddd0131ee8c05b(init) {
    $d77aa7b81189e5d8$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let dataRoutes = $d77aa7b81189e5d8$export$4a6d22b32134ea5d(init.routes); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d77aa7b81189e5d8$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $d77aa7b81189e5d8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d77aa7b81189e5d8$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = !initialMatches.some((m)=>m.route.loader) || init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $d77aa7b81189e5d8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // We ony support a single active blocker at the moment since we don't have
    // any compelling use cases for multi-blocker yet
    let activeBlocker = null; // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        if (!state.initialized) startNavigation($d77aa7b81189e5d8$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $d77aa7b81189e5d8$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d77aa7b81189e5d8$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $d77aa7b81189e5d8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d77aa7b81189e5d8$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        updateState($d77aa7b81189e5d8$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $d77aa7b81189e5d8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path: path, submission: submission, error: error } = $d77aa7b81189e5d8$var$normalizeNavigateOptions(to, opts);
        let currentLocation = state.location;
        let nextLocation = $d77aa7b81189e5d8$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $d77aa7b81189e5d8$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $d77aa7b81189e5d8$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $d77aa7b81189e5d8$export$2708184779ceb39d(dataRoutes, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $d77aa7b81189e5d8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d77aa7b81189e5d8$var$getShortCircuitMatches(dataRoutes); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change
        if ($d77aa7b81189e5d8$var$isHashChangeOnly(state.location, location)) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $d77aa7b81189e5d8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$d77aa7b81189e5d8$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $d77aa7b81189e5d8$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $d77aa7b81189e5d8$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $d77aa7b81189e5d8$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $d77aa7b81189e5d8$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $d77aa7b81189e5d8$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action) result = {
            type: $d77aa7b81189e5d8$var$ResultType.error,
            error: $d77aa7b81189e5d8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $d77aa7b81189e5d8$var$callLoaderOrAction("action", request, actionMatch, matches, router.basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d77aa7b81189e5d8$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($d77aa7b81189e5d8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d77aa7b81189e5d8$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($d77aa7b81189e5d8$var$isDeferredResult(result)) throw $d77aa7b81189e5d8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $d77aa7b81189e5d8$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission ? submission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let [matchesToLoad, revalidatingFetchers] = $d77aa7b81189e5d8$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, $d77aa7b81189e5d8$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((_ref2)=>{
                let [key] = _ref2;
                let fetcher = state.fetchers.get(key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($d77aa7b81189e5d8$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((_ref3)=>{
            let [key] = _ref3;
            return fetchControllers.set(key, pendingNavigationController);
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((_ref4)=>{
            let [key] = _ref4;
            return fetchControllers.delete(key);
        }); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $d77aa7b81189e5d8$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d77aa7b81189e5d8$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return $d77aa7b81189e5d8$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $d77aa7b81189e5d8$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($d77aa7b81189e5d8$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let matches = $d77aa7b81189e5d8$export$2708184779ceb39d(dataRoutes, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, $d77aa7b81189e5d8$var$getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        let { path: path, submission: submission } = $d77aa7b81189e5d8$var$normalizeNavigateOptions(href, opts, true);
        let match = $d77aa7b81189e5d8$var$getTargetMatch(matches, path);
        if (submission && $d77aa7b81189e5d8$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, [
            path,
            match,
            matches
        ]);
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action) {
            let error = $d77aa7b81189e5d8$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $d77aa7b81189e5d8$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $d77aa7b81189e5d8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $d77aa7b81189e5d8$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, router.basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($d77aa7b81189e5d8$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $d77aa7b81189e5d8$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($d77aa7b81189e5d8$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($d77aa7b81189e5d8$var$isDeferredResult(actionResult)) throw $d77aa7b81189e5d8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d77aa7b81189e5d8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? $d77aa7b81189e5d8$export$2708184779ceb39d(dataRoutes, state.navigation.location, init.basename) : state.matches;
        $d77aa7b81189e5d8$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $d77aa7b81189e5d8$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $d77aa7b81189e5d8$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, {
            [match.route.id]: actionResult.data
        }, undefined, fetchLoadMatches); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((_ref5)=>{
            let [staleKey] = _ref5;
            return staleKey !== key;
        }).forEach((_ref6)=>{
            let [staleKey] = _ref6;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((_ref7)=>{
            let [staleKey] = _ref7;
            return fetchControllers.delete(staleKey);
        });
        let redirect = $d77aa7b81189e5d8$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d77aa7b81189e5d8$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d77aa7b81189e5d8$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($d77aa7b81189e5d8$var$_extends({
                errors: errors,
                loaderData: $d77aa7b81189e5d8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $d77aa7b81189e5d8$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $d77aa7b81189e5d8$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $d77aa7b81189e5d8$var$callLoaderOrAction("loader", fetchRequest, match, matches, router.basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($d77aa7b81189e5d8$var$isDeferredResult(result)) result = await $d77aa7b81189e5d8$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($d77aa7b81189e5d8$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($d77aa7b81189e5d8$var$isErrorResult(result)) {
            let boundaryMatch = $d77aa7b81189e5d8$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $d77aa7b81189e5d8$export$f5708dca728d7177(!$d77aa7b81189e5d8$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $d77aa7b81189e5d8$var$createLocation(state.location, redirect.location, $d77aa7b81189e5d8$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $d77aa7b81189e5d8$export$f5708dca728d7177(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an external redirect that goes to a new origin
        if ($d77aa7b81189e5d8$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let newOrigin = init.history.createURL(redirect.location).origin;
            if (window.location.origin !== newOrigin) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Replace : $d77aa7b81189e5d8$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($d77aa7b81189e5d8$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $d77aa7b81189e5d8$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $d77aa7b81189e5d8$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d77aa7b81189e5d8$var$callLoaderOrAction("loader", request, match, matches, router.basename)),
            ...fetchersToLoad.map((_ref8)=>{
                let [, href, match, fetchMatches] = _ref8;
                return $d77aa7b81189e5d8$var$callLoaderOrAction("loader", $d77aa7b81189e5d8$var$createClientSideRequest(init.history, href, request.signal), match, fetchMatches, router.basename);
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $d77aa7b81189e5d8$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            $d77aa7b81189e5d8$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((_ref9)=>{
                let [, , match] = _ref9;
                return match;
            }), fetcherResults, request.signal, true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $d77aa7b81189e5d8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $d77aa7b81189e5d8$export$f5708dca728d7177(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $d77aa7b81189e5d8$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $d77aa7b81189e5d8$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d77aa7b81189e5d8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) {
            blockerFunctions.set(key, fn);
            if (activeBlocker == null) // This is now the active blocker
            activeBlocker = key;
            else if (key !== activeBlocker) $d77aa7b81189e5d8$export$491112666e282270(false, "A router only supports one blocker at a time");
        }
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
        if (activeBlocker === key) activeBlocker = null;
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d77aa7b81189e5d8$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $d77aa7b81189e5d8$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref10) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref10;
        if (activeBlocker == null) return;
         // We only allow a single blocker at the moment.  This will need to be
        // updated if we enhance to support multiple blockers in the future
        let blockerFunction = blockerFunctions.get(activeBlocker);
        $d77aa7b81189e5d8$export$f5708dca728d7177(blockerFunction, "Could not find a function for the active blocker");
        let blocker = state.blockers.get(activeBlocker);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return activeBlocker;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $d77aa7b81189e5d8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$d77aa7b81189e5d8$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$d77aa7b81189e5d8$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $d77aa7b81189e5d8$export$4d0306f8f6a4585b = Symbol("deferred");
function $d77aa7b81189e5d8$export$3336b097a6fbc59a(routes, opts) {
    $d77aa7b81189e5d8$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let dataRoutes = $d77aa7b81189e5d8$export$4a6d22b32134ea5d(routes);
    let basename = (opts ? opts.basename : null) || "/";
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $d77aa7b81189e5d8$var$createLocation("", $d77aa7b81189e5d8$export$fe53371bee54353d(url), null, "default");
        let matches = $d77aa7b81189e5d8$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$d77aa7b81189e5d8$var$isValidMethod(method) && method !== "head") {
            let error = $d77aa7b81189e5d8$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d77aa7b81189e5d8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $d77aa7b81189e5d8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d77aa7b81189e5d8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($d77aa7b81189e5d8$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $d77aa7b81189e5d8$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $d77aa7b81189e5d8$var$createLocation("", $d77aa7b81189e5d8$export$fe53371bee54353d(url), null, "default");
        let matches = $d77aa7b81189e5d8$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$d77aa7b81189e5d8$var$isValidMethod(method) && method !== "head" && method !== "options") throw $d77aa7b81189e5d8$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d77aa7b81189e5d8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d77aa7b81189e5d8$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d77aa7b81189e5d8$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $d77aa7b81189e5d8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($d77aa7b81189e5d8$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$d77aa7b81189e5d8$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $d77aa7b81189e5d8$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d77aa7b81189e5d8$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $d77aa7b81189e5d8$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $d77aa7b81189e5d8$var$isResponse(result) ? result : $d77aa7b81189e5d8$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($d77aa7b81189e5d8$var$isQueryRouteResponse(e)) {
                if (e.type === $d77aa7b81189e5d8$var$ResultType.error && !$d77aa7b81189e5d8$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($d77aa7b81189e5d8$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action) {
            let error = $d77aa7b81189e5d8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d77aa7b81189e5d8$var$ResultType.error,
                error: error
            };
        } else {
            result = await $d77aa7b81189e5d8$var$callLoaderOrAction("action", request, actionMatch, matches, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($d77aa7b81189e5d8$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($d77aa7b81189e5d8$var$isDeferredResult(result)) {
            let error = $d77aa7b81189e5d8$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d77aa7b81189e5d8$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($d77aa7b81189e5d8$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($d77aa7b81189e5d8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d77aa7b81189e5d8$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $d77aa7b81189e5d8$var$_extends({}, context, {
                statusCode: $d77aa7b81189e5d8$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $d77aa7b81189e5d8$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $d77aa7b81189e5d8$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $d77aa7b81189e5d8$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader)) throw $d77aa7b81189e5d8$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $d77aa7b81189e5d8$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d77aa7b81189e5d8$var$callLoaderOrAction("loader", request, match, matches, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $d77aa7b81189e5d8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $d77aa7b81189e5d8$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $d77aa7b81189e5d8$export$fec11da027c70692(routes, context, error) {
    let newContext = $d77aa7b81189e5d8$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $d77aa7b81189e5d8$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $d77aa7b81189e5d8$var$normalizeNavigateOptions(to, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : $d77aa7b81189e5d8$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !$d77aa7b81189e5d8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d77aa7b81189e5d8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d77aa7b81189e5d8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        submission = {
            formMethod: opts.formMethod || "get",
            formAction: $d77aa7b81189e5d8$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($d77aa7b81189e5d8$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $d77aa7b81189e5d8$export$8ccf933b0513f8d0(path);
    try {
        let searchParams = $d77aa7b81189e5d8$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
        // navigation GET submissions which run all loaders), we need to preserve
        // any incoming ?index params
        if (isFetcher && parsedPath.search && $d77aa7b81189e5d8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
        parsedPath.search = "?" + searchParams;
    } catch (e) {
        return {
            path: path,
            error: $d77aa7b81189e5d8$var$getInternalRouterError(400)
        };
    }
    return {
        path: $d77aa7b81189e5d8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $d77aa7b81189e5d8$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $d77aa7b81189e5d8$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $d77aa7b81189e5d8$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>match.route.loader != null && ($d77aa7b81189e5d8$var$isNewLoader(state.loaderData, state.matches[index], match) || // If this route had a pending deferred cancelled it must be revalidated
        cancelledDeferredRoutes.some((id)=>id === match.route.id) || $d77aa7b81189e5d8$var$shouldRevalidateLoader(history, state.location, state.matches[index], submission, location, match, isRevalidationRequired, actionResult))); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches && fetchLoadMatches.forEach((_ref11, key)=>{
        let [href, match, fetchMatches] = _ref11;
        // This fetcher was cancelled from a prior action submission - force reload
        if (cancelledFetcherLoads.includes(key)) revalidatingFetchers.push([
            key,
            href,
            match,
            fetchMatches
        ]);
        else if (isRevalidationRequired) {
            let shouldRevalidate = $d77aa7b81189e5d8$var$shouldRevalidateLoader(history, href, match, submission, href, match, isRevalidationRequired, actionResult);
            if (shouldRevalidate) revalidatingFetchers.push([
                key,
                href,
                match,
                fetchMatches
            ]);
        }
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $d77aa7b81189e5d8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $d77aa7b81189e5d8$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $d77aa7b81189e5d8$var$shouldRevalidateLoader(history, currentLocation, currentMatch, submission, location, match, isRevalidationRequired, actionResult) {
    let currentUrl = history.createURL(currentLocation);
    let currentParams = currentMatch.params;
    let nextUrl = history.createURL(location);
    let nextParams = match.params; // This is the default implementation as to when we revalidate.  If the route
    // provides it's own implementation, then we give them full control but
    // provide this value so they can leverage it if needed after they check
    // their own specific use cases
    // Note that fetchers always provide the same current/next locations so the
    // URL-based checks here don't apply to fetcher shouldRevalidate calls
    let defaultShouldRevalidate = $d77aa7b81189e5d8$var$isNewRouteInstance(currentMatch, match) || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search || // Forced revalidation due to submission, useRevalidate, or X-Remix-Revalidate
    isRevalidationRequired;
    if (match.route.shouldRevalidate) {
        let routeChoice = match.route.shouldRevalidate($d77aa7b81189e5d8$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentParams,
            nextUrl: nextUrl,
            nextParams: nextParams
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate
        }));
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return defaultShouldRevalidate;
}
async function $d77aa7b81189e5d8$var$callLoaderOrAction(type, request, match, matches, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (basename === void 0) basename = "/";
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result; // Setup a promise we can race against so that abort signals short circuit
    let reject;
    let abortPromise = new Promise((_, r)=>reject = r);
    let onReject = ()=>reject();
    request.signal.addEventListener("abort", onReject);
    try {
        let handler = match.route[type];
        $d77aa7b81189e5d8$export$f5708dca728d7177(handler, "Could not find the " + type + " to run on the \"" + match.route.id + "\" route");
        result = await Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
        $d77aa7b81189e5d8$export$f5708dca728d7177(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $d77aa7b81189e5d8$var$ResultType.error;
        result = e;
    } finally{
        request.signal.removeEventListener("abort", onReject);
    }
    if ($d77aa7b81189e5d8$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($d77aa7b81189e5d8$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $d77aa7b81189e5d8$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            let isAbsolute = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(location); // Support relative routing in internal redirects
            if (!isAbsolute) {
                let activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                let routePathnames = $d77aa7b81189e5d8$export$90ba53ce1c7fdff2(activeMatches).map((match)=>match.pathnameBase);
                let resolvedLocation = $d77aa7b81189e5d8$export$cae722b0cc860f13(location, routePathnames, new URL(request.url).pathname);
                $d77aa7b81189e5d8$export$f5708dca728d7177($d77aa7b81189e5d8$export$fe53371bee54353d(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                if (basename) {
                    let path = resolvedLocation.pathname;
                    resolvedLocation.pathname = path === "/" ? basename : $d77aa7b81189e5d8$export$86d9a7913e44197e([
                        basename,
                        path
                    ]);
                }
                location = $d77aa7b81189e5d8$export$fe53371bee54353d(resolvedLocation);
            } else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin absolute redirects.
                // If this is a static reques, we can let it go back to the browser
                // as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                if (url.origin === currentUrl.origin) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $d77aa7b81189e5d8$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $d77aa7b81189e5d8$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $d77aa7b81189e5d8$var$ResultType.error) return {
            type: resultType,
            error: new $d77aa7b81189e5d8$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $d77aa7b81189e5d8$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $d77aa7b81189e5d8$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if (result instanceof $d77aa7b81189e5d8$export$61d759255b4eec65) return {
        type: $d77aa7b81189e5d8$var$ResultType.deferred,
        deferredData: result
    };
    return {
        type: $d77aa7b81189e5d8$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $d77aa7b81189e5d8$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d77aa7b81189e5d8$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d77aa7b81189e5d8$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission;
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $d77aa7b81189e5d8$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $d77aa7b81189e5d8$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries()){
        $d77aa7b81189e5d8$export$f5708dca728d7177(typeof value === "string", 'File inputs are not supported with encType "application/x-www-form-urlencoded", please use "multipart/form-data" instead.');
        searchParams.append(key, value);
    }
    return searchParams;
}
function $d77aa7b81189e5d8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $d77aa7b81189e5d8$export$f5708dca728d7177(!$d77aa7b81189e5d8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d77aa7b81189e5d8$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $d77aa7b81189e5d8$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $d77aa7b81189e5d8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($d77aa7b81189e5d8$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d77aa7b81189e5d8$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $d77aa7b81189e5d8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let [key, , match] = revalidatingFetchers[index];
        $d77aa7b81189e5d8$export$f5708dca728d7177(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($d77aa7b81189e5d8$var$isErrorResult(result)) {
            let boundaryMatch = $d77aa7b81189e5d8$var$findNearestBoundary(state.matches, match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $d77aa7b81189e5d8$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($d77aa7b81189e5d8$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $d77aa7b81189e5d8$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else if ($d77aa7b81189e5d8$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $d77aa7b81189e5d8$export$f5708dca728d7177(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d77aa7b81189e5d8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $d77aa7b81189e5d8$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $d77aa7b81189e5d8$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d77aa7b81189e5d8$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d77aa7b81189e5d8$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else errorMessage = "Cannot submit binary form data using GET";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $d77aa7b81189e5d8$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $d77aa7b81189e5d8$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($d77aa7b81189e5d8$var$isRedirectResult(result)) return result;
    }
}
function $d77aa7b81189e5d8$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d77aa7b81189e5d8$export$8ccf933b0513f8d0(path) : path;
    return $d77aa7b81189e5d8$export$fe53371bee54353d($d77aa7b81189e5d8$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $d77aa7b81189e5d8$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $d77aa7b81189e5d8$var$isDeferredResult(result) {
    return result.type === $d77aa7b81189e5d8$var$ResultType.deferred;
}
function $d77aa7b81189e5d8$var$isErrorResult(result) {
    return result.type === $d77aa7b81189e5d8$var$ResultType.error;
}
function $d77aa7b81189e5d8$var$isRedirectResult(result) {
    return (result && result.type) === $d77aa7b81189e5d8$var$ResultType.redirect;
}
function $d77aa7b81189e5d8$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d77aa7b81189e5d8$var$isRedirectResponse(result) {
    if (!$d77aa7b81189e5d8$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $d77aa7b81189e5d8$var$isQueryRouteResponse(obj) {
    return obj && $d77aa7b81189e5d8$var$isResponse(obj.response) && (obj.type === $d77aa7b81189e5d8$var$ResultType.data || $d77aa7b81189e5d8$var$ResultType.error);
}
function $d77aa7b81189e5d8$var$isValidMethod(method) {
    return $d77aa7b81189e5d8$var$validRequestMethods.has(method);
}
function $d77aa7b81189e5d8$var$isMutationMethod(method) {
    return $d77aa7b81189e5d8$var$validMutationMethods.has(method);
}
async function $d77aa7b81189e5d8$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$d77aa7b81189e5d8$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($d77aa7b81189e5d8$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $d77aa7b81189e5d8$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function $d77aa7b81189e5d8$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $d77aa7b81189e5d8$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $d77aa7b81189e5d8$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $d77aa7b81189e5d8$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $d77aa7b81189e5d8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $d77aa7b81189e5d8$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $d77aa7b81189e5d8$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d77aa7b81189e5d8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d77aa7b81189e5d8$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $d77aa7b81189e5d8$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

/**
 * React Router v6.7.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $eeyUA = parcelRequire("eeyUA");
function $eb35eadc52e606cf$var$_extends() {
    $eb35eadc52e606cf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eb35eadc52e606cf$var$_extends.apply(this, arguments);
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $eb35eadc52e606cf$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const $eb35eadc52e606cf$var$is = typeof Object.is === "function" ? Object.is : $eb35eadc52e606cf$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState: $eb35eadc52e606cf$var$useState, useEffect: $eb35eadc52e606cf$var$useEffect, useLayoutEffect: $eb35eadc52e606cf$var$useLayoutEffect, useDebugValue: $eb35eadc52e606cf$var$useDebugValue } = $eeyUA;
let $eb35eadc52e606cf$var$didWarnOld18Alpha = false;
let $eb35eadc52e606cf$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $eb35eadc52e606cf$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $eb35eadc52e606cf$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $eb35eadc52e606cf$var$useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($eb35eadc52e606cf$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $eb35eadc52e606cf$var$useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($eb35eadc52e606cf$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($eb35eadc52e606cf$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $eb35eadc52e606cf$var$useDebugValue(value);
    return value;
}
function $eb35eadc52e606cf$var$checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !$eb35eadc52e606cf$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $eb35eadc52e606cf$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const $eb35eadc52e606cf$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $eb35eadc52e606cf$var$isServerEnvironment = !$eb35eadc52e606cf$var$canUseDOM;
const $eb35eadc52e606cf$var$shim = $eb35eadc52e606cf$var$isServerEnvironment ? $eb35eadc52e606cf$var$useSyncExternalStore$1 : $eb35eadc52e606cf$var$useSyncExternalStore$2;
const $eb35eadc52e606cf$var$useSyncExternalStore = "useSyncExternalStore" in $eeyUA ? ((module)=>module.useSyncExternalStore)($eeyUA) : $eb35eadc52e606cf$var$shim;
const $eb35eadc52e606cf$export$3add0d5dce533e2e = /*#__PURE__*/ $eeyUA.createContext(null);
const $eb35eadc52e606cf$export$145dfa71566a64dc = /*#__PURE__*/ $eeyUA.createContext(null);
const $eb35eadc52e606cf$var$AwaitContext = /*#__PURE__*/ $eeyUA.createContext(null);
const $eb35eadc52e606cf$export$26749e8557646306 = /*#__PURE__*/ $eeyUA.createContext(null);
const $eb35eadc52e606cf$export$c7914228fb69b0f5 = /*#__PURE__*/ $eeyUA.createContext(null);
const $eb35eadc52e606cf$export$9072aa6dd1f93057 = /*#__PURE__*/ $eeyUA.createContext({
    outlet: null,
    matches: []
});
const $eb35eadc52e606cf$var$RouteErrorContext = /*#__PURE__*/ $eeyUA.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $eb35eadc52e606cf$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$eb35eadc52e606cf$export$9c954a9d03d32f4a() && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $eeyUA.useContext($eb35eadc52e606cf$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $eb35eadc52e606cf$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $d77aa7b81189e5d8$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $eb35eadc52e606cf$export$9c954a9d03d32f4a() {
    return $eeyUA.useContext($eb35eadc52e606cf$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $eb35eadc52e606cf$export$45d76561a5302f2b() {
    !$eb35eadc52e606cf$export$9c954a9d03d32f4a() && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    return $eeyUA.useContext($eb35eadc52e606cf$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $eb35eadc52e606cf$export$1b3f31771c5d07c() {
    return $eeyUA.useContext($eb35eadc52e606cf$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $eb35eadc52e606cf$export$6c330e8992e8a295(pattern) {
    !$eb35eadc52e606cf$export$9c954a9d03d32f4a() && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    let { pathname: pathname } = $eb35eadc52e606cf$export$45d76561a5302f2b();
    return $eeyUA.useMemo(()=>(0, $d77aa7b81189e5d8$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $eb35eadc52e606cf$export$9770f232ac06a008() {
    !$eb35eadc52e606cf$export$9c954a9d03d32f4a() && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $eeyUA.useContext($eb35eadc52e606cf$export$26749e8557646306);
    let { matches: matches } = $eeyUA.useContext($eb35eadc52e606cf$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $eb35eadc52e606cf$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d77aa7b81189e5d8$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $eeyUA.useRef(false);
    $eeyUA.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eeyUA.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $d77aa7b81189e5d8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d77aa7b81189e5d8$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $eb35eadc52e606cf$var$OutletContext = /*#__PURE__*/ $eeyUA.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $eb35eadc52e606cf$export$4138103a3ae699cc() {
    return $eeyUA.useContext($eb35eadc52e606cf$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $eb35eadc52e606cf$export$a3be3530d8e40d0b(context) {
    let outlet = $eeyUA.useContext($eb35eadc52e606cf$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $eb35eadc52e606cf$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eeyUA.useContext($eb35eadc52e606cf$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $eb35eadc52e606cf$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $eeyUA.useContext($eb35eadc52e606cf$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $eb35eadc52e606cf$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d77aa7b81189e5d8$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $eeyUA.useMemo(()=>(0, $d77aa7b81189e5d8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $eb35eadc52e606cf$export$5d3fca4a98652595(routes, locationArg) {
    !$eb35eadc52e606cf$export$9c954a9d03d32f4a() && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    let { navigator: navigator } = $eeyUA.useContext($eb35eadc52e606cf$export$26749e8557646306);
    let dataRouterStateContext = $eeyUA.useContext($eb35eadc52e606cf$export$145dfa71566a64dc);
    let { matches: parentMatches } = $eeyUA.useContext($eb35eadc52e606cf$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $eb35eadc52e606cf$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $d77aa7b81189e5d8$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $d77aa7b81189e5d8$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $eb35eadc52e606cf$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $d77aa7b81189e5d8$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $d77aa7b81189e5d8$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $eb35eadc52e606cf$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $d77aa7b81189e5d8$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $eb35eadc52e606cf$var$DefaultErrorElement() {
    let error = $eb35eadc52e606cf$export$ed527bf60f6e05f2();
    let message = (0, $d77aa7b81189e5d8$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    return /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, /*#__PURE__*/ $eeyUA.createElement("h2", null, "Unhandled Thrown Error!"), /*#__PURE__*/ $eeyUA.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eeyUA.createElement("pre", {
        style: preStyles
    }, stack) : null, /*#__PURE__*/ $eeyUA.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $eeyUA.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own\xA0", /*#__PURE__*/ $eeyUA.createElement("code", {
        style: codeStyles
    }, "errorElement"), " props on\xA0", /*#__PURE__*/ $eeyUA.createElement("code", {
        style: codeStyles
    }, "<Route>")));
}
class $eb35eadc52e606cf$var$RenderErrorBoundary extends $eeyUA.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $eb35eadc52e606cf$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eeyUA.useContext($eb35eadc52e606cf$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && match.route.errorElement) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $eb35eadc52e606cf$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = dataRouterState ? match.route.errorElement || /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$var$DefaultErrorElement, null) : null;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>/*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches
                }
            }, error ? errorElement : match.route.element !== undefined ? match.route.element : outlet); // Only wrap in an error boundary within data router usages when we have an
        // errorElement on this route.  Otherwise let it bubble up to an ancestor
        // errorElement
        return dataRouterState && (match.route.errorElement || index === 0) ? /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches
            }
        }) : getChildren();
    }, null);
}
var $eb35eadc52e606cf$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($eb35eadc52e606cf$var$DataRouterHook || ($eb35eadc52e606cf$var$DataRouterHook = {}));
var $eb35eadc52e606cf$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})($eb35eadc52e606cf$var$DataRouterStateHook || ($eb35eadc52e606cf$var$DataRouterStateHook = {}));
function $eb35eadc52e606cf$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $eb35eadc52e606cf$var$useDataRouterContext(hookName) {
    let ctx = $eeyUA.useContext($eb35eadc52e606cf$export$3add0d5dce533e2e);
    !ctx && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    return ctx;
}
function $eb35eadc52e606cf$var$useDataRouterState(hookName) {
    let state = $eeyUA.useContext($eb35eadc52e606cf$export$145dfa71566a64dc);
    !state && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    return state;
}
function $eb35eadc52e606cf$var$useRouteContext(hookName) {
    let route = $eeyUA.useContext($eb35eadc52e606cf$export$9072aa6dd1f93057);
    !route && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    return route;
}
function $eb35eadc52e606cf$var$useCurrentRouteId(hookName) {
    let route = $eb35eadc52e606cf$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    return thisRoute.route.id;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $eb35eadc52e606cf$export$d0fd4b7106de2769() {
    let state = $eb35eadc52e606cf$var$useDataRouterState($eb35eadc52e606cf$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $eb35eadc52e606cf$export$600dc272ed516c15() {
    let dataRouterContext = $eb35eadc52e606cf$var$useDataRouterContext($eb35eadc52e606cf$var$DataRouterHook.UseRevalidator);
    let state = $eb35eadc52e606cf$var$useDataRouterState($eb35eadc52e606cf$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $eb35eadc52e606cf$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $eb35eadc52e606cf$var$useDataRouterState($eb35eadc52e606cf$var$DataRouterStateHook.UseMatches);
    return $eeyUA.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $eb35eadc52e606cf$export$1448a5050d252c4d() {
    let state = $eb35eadc52e606cf$var$useDataRouterState($eb35eadc52e606cf$var$DataRouterStateHook.UseLoaderData);
    let routeId = $eb35eadc52e606cf$var$useCurrentRouteId($eb35eadc52e606cf$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $eb35eadc52e606cf$export$fd5d37484eab868d(routeId) {
    let state = $eb35eadc52e606cf$var$useDataRouterState($eb35eadc52e606cf$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $eb35eadc52e606cf$export$fdc00f3f26066d5e() {
    let state = $eb35eadc52e606cf$var$useDataRouterState($eb35eadc52e606cf$var$DataRouterStateHook.UseActionData);
    let route = $eeyUA.useContext($eb35eadc52e606cf$export$9072aa6dd1f93057);
    !route && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * errorElement to display a proper error message.
 */ function $eb35eadc52e606cf$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eeyUA.useContext($eb35eadc52e606cf$var$RouteErrorContext);
    let state = $eb35eadc52e606cf$var$useDataRouterState($eb35eadc52e606cf$var$DataRouterStateHook.UseRouteError);
    let routeId = $eb35eadc52e606cf$var$useCurrentRouteId($eb35eadc52e606cf$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $eb35eadc52e606cf$export$78a72ddb39bdd145() {
    let value = $eeyUA.useContext($eb35eadc52e606cf$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $eb35eadc52e606cf$export$17f53340677d5831() {
    let value = $eeyUA.useContext($eb35eadc52e606cf$var$AwaitContext);
    return value == null ? void 0 : value._error;
} // useBlocker() is a singleton for now since we don't have any compelling use
// cases for multi-blocker yet
let $eb35eadc52e606cf$var$blockerKey = "blocker-singleton";
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $eb35eadc52e606cf$export$2af03a1de5c0910(shouldBlock) {
    let { router: router } = $eb35eadc52e606cf$var$useDataRouterContext($eb35eadc52e606cf$var$DataRouterHook.UseBlocker);
    let blockerFunction = $eeyUA.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker($eb35eadc52e606cf$var$blockerKey, blockerFunction); // Cleanup on unmount
    $eeyUA.useEffect(()=>()=>router.deleteBlocker($eb35eadc52e606cf$var$blockerKey), [
        router
    ]);
    return blocker;
}
const $eb35eadc52e606cf$var$alreadyWarned = {};
function $eb35eadc52e606cf$var$warningOnce(key, cond, message) {
    if (!cond && !$eb35eadc52e606cf$var$alreadyWarned[key]) $eb35eadc52e606cf$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $eb35eadc52e606cf$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    // Sync router state to our component state to force re-renders
    let state = $eb35eadc52e606cf$var$useSyncExternalStore(router.subscribe, ()=>router.state, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    ()=>router.state);
    let navigator = $eeyUA.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/"; // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$export$3add0d5dce533e2e.Provider, {
        value: {
            router: router,
            navigator: navigator,
            static: false,
            basename: // Do we need this?
            basename
        }
    }, /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$export$3565eb3d00ca5a74, null) : fallbackElement))), null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $eb35eadc52e606cf$export$ae46f04cfaffe093(_ref2) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref2;
    let historyRef = $eeyUA.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d77aa7b81189e5d8$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $eeyUA.useState({
        action: history.action,
        location: history.location
    });
    $eeyUA.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $eb35eadc52e606cf$export$444b3ab0cb9aec40(_ref3) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref3;
    !$eb35eadc52e606cf$export$9c954a9d03d32f4a() && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    let dataRouterState = $eeyUA.useContext($eb35eadc52e606cf$export$145dfa71566a64dc);
    let navigate = $eb35eadc52e606cf$export$9770f232ac06a008();
    $eeyUA.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $eb35eadc52e606cf$export$910ae8079b2c2852(props) {
    return $eb35eadc52e606cf$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $eb35eadc52e606cf$export$e7b0ac011bb776c6(_props) {
    (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $eb35eadc52e606cf$export$55185c17a0fcbe46(_ref4) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $d77aa7b81189e5d8$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref4;
    !!$eb35eadc52e606cf$export$9c954a9d03d32f4a() && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eeyUA.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $d77aa7b81189e5d8$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = $eeyUA.useMemo(()=>{
        let trailingPathname = (0, $d77aa7b81189e5d8$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $eb35eadc52e606cf$export$3565eb3d00ca5a74(_ref5) {
    let { children: children, location: location } = _ref5;
    let dataRouterContext = $eeyUA.useContext($eb35eadc52e606cf$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : $eb35eadc52e606cf$export$16da398f5434bdec(children);
    return $eb35eadc52e606cf$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $eb35eadc52e606cf$export$6ddabde395c8c576(_ref6) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref6;
    return /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$var$ResolveAwait, null, children));
}
var $eb35eadc52e606cf$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($eb35eadc52e606cf$var$AwaitRenderStatus || ($eb35eadc52e606cf$var$AwaitRenderStatus = {}));
const $eb35eadc52e606cf$var$neverSettledPromise = new Promise(()=>{});
class $eb35eadc52e606cf$var$AwaitErrorBoundary extends $eeyUA.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $eb35eadc52e606cf$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $eb35eadc52e606cf$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $eb35eadc52e606cf$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $eb35eadc52e606cf$var$AwaitRenderStatus.error : promise._data !== undefined ? $eb35eadc52e606cf$var$AwaitRenderStatus.success : $eb35eadc52e606cf$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $eb35eadc52e606cf$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $eb35eadc52e606cf$var$AwaitRenderStatus.error && promise._error instanceof (0, $d77aa7b81189e5d8$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $eb35eadc52e606cf$var$neverSettledPromise;
        if (status === $eb35eadc52e606cf$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $eb35eadc52e606cf$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $eb35eadc52e606cf$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eeyUA.createElement($eb35eadc52e606cf$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $eb35eadc52e606cf$var$ResolveAwait(_ref7) {
    let { children: children } = _ref7;
    let data = $eb35eadc52e606cf$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eeyUA.createElement($eeyUA.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $eb35eadc52e606cf$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eeyUA.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eeyUA.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === $eeyUA.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $eb35eadc52e606cf$export$16da398f5434bdec(element.props.children, parentPath));
            return;
        }
        !(element.type === $eb35eadc52e606cf$export$e7b0ac011bb776c6) && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
        !(!element.props.index || !element.props.children) && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
        let treePath = [
            ...parentPath,
            index
        ];
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            hasErrorBoundary: element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle
        };
        if (element.props.children) route.children = $eb35eadc52e606cf$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $eb35eadc52e606cf$export$daf73786167a7f72(matches) {
    return $eb35eadc52e606cf$var$_renderMatches(matches);
}
/**
 * @private
 * Walk the route tree and add hasErrorBoundary if it's not provided, so that
 * users providing manual route arrays can just specify errorElement
 */ function $eb35eadc52e606cf$export$c7b301c52f838c5f(routes) {
    return routes.map((route)=>{
        let routeClone = $eb35eadc52e606cf$var$_extends({}, route);
        if (routeClone.hasErrorBoundary == null) routeClone.hasErrorBoundary = routeClone.errorElement != null;
        if (routeClone.children) routeClone.children = $eb35eadc52e606cf$export$c7b301c52f838c5f(routeClone.children);
        return routeClone;
    });
}
function $eb35eadc52e606cf$export$f30f7e456d254e83(routes, opts) {
    return (0, $d77aa7b81189e5d8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $d77aa7b81189e5d8$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: $eb35eadc52e606cf$export$c7b301c52f838c5f(routes)
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



function $9b6aaeb0c2a25675$var$_extends() {
    $9b6aaeb0c2a25675$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9b6aaeb0c2a25675$var$_extends.apply(this, arguments);
}
function $9b6aaeb0c2a25675$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $9b6aaeb0c2a25675$var$defaultMethod = "get";
const $9b6aaeb0c2a25675$var$defaultEncType = "application/x-www-form-urlencoded";
function $9b6aaeb0c2a25675$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $9b6aaeb0c2a25675$var$isButtonElement(object) {
    return $9b6aaeb0c2a25675$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $9b6aaeb0c2a25675$var$isFormElement(object) {
    return $9b6aaeb0c2a25675$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $9b6aaeb0c2a25675$var$isInputElement(object) {
    return $9b6aaeb0c2a25675$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $9b6aaeb0c2a25675$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $9b6aaeb0c2a25675$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$9b6aaeb0c2a25675$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $9b6aaeb0c2a25675$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $9b6aaeb0c2a25675$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $9b6aaeb0c2a25675$export$a2e4e2dcc7b1f22f(locationSearch);
    for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
        searchParams.append(key, value);
    });
    return searchParams;
}
function $9b6aaeb0c2a25675$var$getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if ($9b6aaeb0c2a25675$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $9b6aaeb0c2a25675$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $9b6aaeb0c2a25675$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($9b6aaeb0c2a25675$var$isButtonElement(target) || $9b6aaeb0c2a25675$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $9b6aaeb0c2a25675$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $9b6aaeb0c2a25675$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($9b6aaeb0c2a25675$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $9b6aaeb0c2a25675$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $9b6aaeb0c2a25675$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol: protocol, host: host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $9b6aaeb0c2a25675$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $9b6aaeb0c2a25675$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $9b6aaeb0c2a25675$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
//#region Routers
////////////////////////////////////////////////////////////////////////////////
function $9b6aaeb0c2a25675$export$1f3f55432a00e06d(routes, opts) {
    return (0, $d77aa7b81189e5d8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $d77aa7b81189e5d8$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $9b6aaeb0c2a25675$var$parseHydrationData(),
        routes: (0, $eb35eadc52e606cf$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $9b6aaeb0c2a25675$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $d77aa7b81189e5d8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $d77aa7b81189e5d8$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $9b6aaeb0c2a25675$var$parseHydrationData(),
        routes: (0, $eb35eadc52e606cf$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $9b6aaeb0c2a25675$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $9b6aaeb0c2a25675$var$_extends({}, state, {
        errors: $9b6aaeb0c2a25675$var$deserializeErrors(state.errors)
    });
    return state;
}
function $9b6aaeb0c2a25675$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $d77aa7b81189e5d8$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $9b6aaeb0c2a25675$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $eeyUA.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d77aa7b81189e5d8$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $eeyUA.useState({
        action: history.action,
        location: history.location
    });
    $eeyUA.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $eeyUA.createElement((0, $eb35eadc52e606cf$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $9b6aaeb0c2a25675$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $eeyUA.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d77aa7b81189e5d8$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $eeyUA.useState({
        action: history.action,
        location: history.location
    });
    $eeyUA.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $eeyUA.createElement((0, $eb35eadc52e606cf$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $9b6aaeb0c2a25675$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $eeyUA.useState({
        action: history.action,
        location: history.location
    });
    $eeyUA.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $eeyUA.createElement((0, $eb35eadc52e606cf$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $9b6aaeb0c2a25675$export$a6c7ac8248d6e38a = /*#__PURE__*/ $eeyUA.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $9b6aaeb0c2a25675$var$_objectWithoutPropertiesLoose(_ref4, $9b6aaeb0c2a25675$var$_excluded);
    let href = (0, $eb35eadc52e606cf$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $9b6aaeb0c2a25675$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $eeyUA.createElement("a", $9b6aaeb0c2a25675$var$_extends({}, rest, {
        href: href,
        onClick: reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $9b6aaeb0c2a25675$export$b0d92dbee9b5b60d = /*#__PURE__*/ $eeyUA.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $9b6aaeb0c2a25675$var$_objectWithoutPropertiesLoose(_ref5, $9b6aaeb0c2a25675$var$_excluded2);
    let path = (0, $eb35eadc52e606cf$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $eb35eadc52e606cf$export$45d76561a5302f2b)();
    let routerState = $eeyUA.useContext((0, $eb35eadc52e606cf$export$145dfa71566a64dc));
    let { navigator: navigator } = $eeyUA.useContext((0, $eb35eadc52e606cf$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $eeyUA.createElement($9b6aaeb0c2a25675$export$a6c7ac8248d6e38a, $9b6aaeb0c2a25675$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $9b6aaeb0c2a25675$export$a7fed597f4b8afd8 = /*#__PURE__*/ $eeyUA.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $eeyUA.createElement($9b6aaeb0c2a25675$var$FormImpl, $9b6aaeb0c2a25675$var$_extends({}, props, {
        ref: ref
    }));
});
const $9b6aaeb0c2a25675$var$FormImpl = /*#__PURE__*/ $eeyUA.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $9b6aaeb0c2a25675$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $9b6aaeb0c2a25675$var$_objectWithoutPropertiesLoose(_ref6, $9b6aaeb0c2a25675$var$_excluded3);
    let submit = $9b6aaeb0c2a25675$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $9b6aaeb0c2a25675$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $eeyUA.createElement("form", $9b6aaeb0c2a25675$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $9b6aaeb0c2a25675$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $9b6aaeb0c2a25675$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $9b6aaeb0c2a25675$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($9b6aaeb0c2a25675$var$DataRouterHook || ($9b6aaeb0c2a25675$var$DataRouterHook = {}));
var $9b6aaeb0c2a25675$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($9b6aaeb0c2a25675$var$DataRouterStateHook || ($9b6aaeb0c2a25675$var$DataRouterStateHook = {}));
function $9b6aaeb0c2a25675$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $9b6aaeb0c2a25675$var$useDataRouterContext(hookName) {
    let ctx = $eeyUA.useContext((0, $eb35eadc52e606cf$export$3add0d5dce533e2e));
    !ctx && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    return ctx;
}
function $9b6aaeb0c2a25675$var$useDataRouterState(hookName) {
    let state = $eeyUA.useContext((0, $eb35eadc52e606cf$export$145dfa71566a64dc));
    !state && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $9b6aaeb0c2a25675$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $eb35eadc52e606cf$export$9770f232ac06a008)();
    let location = (0, $eb35eadc52e606cf$export$45d76561a5302f2b)();
    let path = (0, $eb35eadc52e606cf$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $eeyUA.useCallback((event)=>{
        if ($9b6aaeb0c2a25675$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $d77aa7b81189e5d8$export$fe53371bee54353d)(location) === (0, $d77aa7b81189e5d8$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $9b6aaeb0c2a25675$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $eeyUA.useRef($9b6aaeb0c2a25675$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $eb35eadc52e606cf$export$45d76561a5302f2b)();
    let searchParams = $eeyUA.useMemo(()=>$9b6aaeb0c2a25675$var$getSearchParamsForLocation(location.search, defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $eb35eadc52e606cf$export$9770f232ac06a008)();
    let setSearchParams = $eeyUA.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $9b6aaeb0c2a25675$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $9b6aaeb0c2a25675$export$47c85c6e3a081d3() {
    return $9b6aaeb0c2a25675$var$useSubmitImpl();
}
function $9b6aaeb0c2a25675$var$useSubmitImpl(fetcherKey, routeId) {
    let { router: router } = $9b6aaeb0c2a25675$var$useDataRouterContext($9b6aaeb0c2a25675$var$DataRouterHook.UseSubmitImpl);
    let defaultAction = $9b6aaeb0c2a25675$export$89a6bd6db0d97c56();
    return $eeyUA.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method: method, encType: encType, formData: formData, url: url } = $9b6aaeb0c2a25675$var$getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $9b6aaeb0c2a25675$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $eeyUA.useContext((0, $eb35eadc52e606cf$export$26749e8557646306));
    let routeContext = $eeyUA.useContext((0, $eb35eadc52e606cf$export$9072aa6dd1f93057));
    !routeContext && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $9b6aaeb0c2a25675$var$_extends({}, (0, $eb35eadc52e606cf$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $eb35eadc52e606cf$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d77aa7b81189e5d8$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $d77aa7b81189e5d8$export$fe53371bee54353d)(path);
}
function $9b6aaeb0c2a25675$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $eeyUA.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $eeyUA.createElement($9b6aaeb0c2a25675$var$FormImpl, $9b6aaeb0c2a25675$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $9b6aaeb0c2a25675$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $9b6aaeb0c2a25675$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $9b6aaeb0c2a25675$var$useDataRouterContext($9b6aaeb0c2a25675$var$DataRouterHook.UseFetcher);
    let route = $eeyUA.useContext((0, $eb35eadc52e606cf$export$9072aa6dd1f93057));
    !route && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
    let [fetcherKey] = $eeyUA.useState(()=>String(++$9b6aaeb0c2a25675$var$fetcherId));
    let [Form] = $eeyUA.useState(()=>{
        !routeId && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
        return $9b6aaeb0c2a25675$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $eeyUA.useState(()=>(href)=>{
            !router && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
            !routeId && (0, $d77aa7b81189e5d8$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $9b6aaeb0c2a25675$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $eeyUA.useMemo(()=>$9b6aaeb0c2a25675$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $eeyUA.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $9b6aaeb0c2a25675$export$fa996778a3a31087() {
    let state = $9b6aaeb0c2a25675$var$useDataRouterState($9b6aaeb0c2a25675$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $9b6aaeb0c2a25675$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $9b6aaeb0c2a25675$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $9b6aaeb0c2a25675$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $9b6aaeb0c2a25675$var$useDataRouterContext($9b6aaeb0c2a25675$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $9b6aaeb0c2a25675$var$useDataRouterState($9b6aaeb0c2a25675$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $eb35eadc52e606cf$export$45d76561a5302f2b)();
    let matches = (0, $eb35eadc52e606cf$export$2378eb7f5ff86053)();
    let navigation = (0, $eb35eadc52e606cf$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $eeyUA.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on unload
    $9b6aaeb0c2a25675$export$c0a586b329cae57d($eeyUA.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $9b6aaeb0c2a25675$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $9b6aaeb0c2a25675$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($9b6aaeb0c2a25675$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeyUA.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $9b6aaeb0c2a25675$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $9b6aaeb0c2a25675$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeyUA.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($9b6aaeb0c2a25675$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeyUA.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $9b6aaeb0c2a25675$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $eeyUA.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $9b6aaeb0c2a25675$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $eb35eadc52e606cf$export$2af03a1de5c0910)(when);
    $eeyUA.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $eeyUA.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}
////////////////////////////////////////////////////////////////////////////////
//#region Utils
////////////////////////////////////////////////////////////////////////////////
function $9b6aaeb0c2a25675$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} //#endregion


const $24f5134d35785b68$export$b2e89522f7555cb1 = "userData";
const $24f5134d35785b68$export$4bb56266bb9366a = "userRole";


const $e030f932b827786a$export$ca5692b7e00ec0c = (a, b)=>{
    try {
        const aCopy = new URL(a);
        const bCopy = new URL(b);
        aCopy.searchParams.sort();
        bCopy.searchParams.sort();
        return aCopy.toString() === bCopy.toString();
    } catch  {
        return false;
    }
};




const $bd2f709a7c65979e$var$isEmpty = (obj)=>[
        Object,
        Array
    ].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
const $bd2f709a7c65979e$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, $eeyUA.createContext)({
    first_name: "",
    last_name: "",
    user: null
});
function $bd2f709a7c65979e$export$87091915187a1a85({ children: children }) {
    const [dbUser, setDbUser] = (0, $eeyUA.useState)(null);
    const [loading, setLoading] = (0, $eeyUA.useState)(false);
    const [error, setError] = (0, $eeyUA.useState)("");
    const { accounts: accounts } = (0, $53d03c4325cd69bf$export$f41558044a1dd55)();
    const isAuthenticated = (0, $b456e1137d3c2117$export$7e9c60d6d1836c84)(accounts[0]);
    const getUserRole = localStorage.getItem((0, $24f5134d35785b68$export$4bb56266bb9366a));
    const validTokenGetCurrentUser = (0, $eeyUA.useCallback)(async ()=>{
        if (isAuthenticated) await (0, $9047bffd7d73a6ba$export$84773cc9bf7dbe87)();
    }, [
        isAuthenticated
    ]);
    const names = accounts[0]?.name?.split(" ") || [
        "",
        ""
    ];
    const user = {
        first_name: names ? names[0] : "",
        last_name: names && names.length > 1 ? names[names.length - 1] : "",
        user: dbUser
    };
    const currentLocationUrl = new URL(window.location.href);
    const navigate = (0, $eb35eadc52e606cf$export$9770f232ac06a008)();
    (0, $eeyUA.useEffect)(()=>{
        const userRole = localStorage.getItem((0, $24f5134d35785b68$export$4bb56266bb9366a));
        if (isAuthenticated && userRole) {
            const storedRedirect = sessionStorage.getItem("postLoginRedirect");
            if (!storedRedirect) return;
            const storedRedirectUrl = new URL(storedRedirect, window.location.origin);
            if (!(0, $e030f932b827786a$export$ca5692b7e00ec0c)(currentLocationUrl, storedRedirectUrl)) {
                const pathAndSearch = `${storedRedirectUrl.pathname}${storedRedirectUrl.search}`;
                navigate(pathAndSearch, {
                    replace: true
                });
            }
            sessionStorage.removeItem("postLoginRedirect");
        }
    }, [
        isAuthenticated,
        currentLocationUrl,
        navigate
    ]);
    // Fetch user data with retry mechanism
    const fetchUserData = (0, $eeyUA.useCallback)(async ()=>{
        if (isAuthenticated && accounts.length > 0) {
            const existingUserRole = localStorage.getItem((0, $24f5134d35785b68$export$4bb56266bb9366a));
            const isNonProducerCached = localStorage.getItem("isNonProducer");
            // If role and NON_PRODUCER info are already cached, skip the API call
            if (existingUserRole && isNonProducerCached !== null) return;
            let attempt = 0;
            const maxRetries = 2;
            const delay = 2000; // 2 seconds
            // Retry function to handle the getUser call with delay
            const retryFetch = async ()=>{
                while(attempt < maxRetries)try {
                    setError(""); // Reset error before each attempt
                    const oid = accounts[0].idTokenClaims?.oid;
                    const response = await (0, $d59547663c27188e$export$7cbf767827cd68ba)(oid);
                    if (!response?.bullhorn || $bd2f709a7c65979e$var$isEmpty(response?.bullhorn)) throw Error("No Bullhorn User Found");
                    setDbUser(response);
                    if (response) localStorage.setItem((0, $24f5134d35785b68$export$b2e89522f7555cb1), JSON.stringify(response));
                    const userRole = response?.role?.name === (0, $25746eb61037a613$export$46919bad18fb2f76).NON_PRODUCER ? (0, $25746eb61037a613$export$46919bad18fb2f76).ACCOUNT_MANAGER // Default to ACCOUNT_MANAGER for NON_PRODUCERS
                     : response?.role?.name || "";
                    if (userRole) localStorage.setItem((0, $24f5134d35785b68$export$4bb56266bb9366a), userRole);
                    const isNonProducer = response.role.name === (0, $25746eb61037a613$export$46919bad18fb2f76).NON_PRODUCER;
                    localStorage.setItem("isNonProducer", JSON.stringify(isNonProducer));
                    return;
                } catch (error) {
                    console.error("Attempt failed:", error);
                    if (attempt >= maxRetries - 1) {
                        if (error.message === "No Bullhorn User Found") setError("No Bullhorn User Found. Please reach out to sos@alku.com");
                        else setError("Failed to fetch user data");
                        break;
                    } else {
                        attempt++;
                        console.log(`Retrying... Attempt ${attempt + 1} of ${maxRetries}`);
                        await new Promise((resolve)=>setTimeout(resolve, delay)); // Wait for 2 seconds before retrying
                    }
                }
            };
            // Call the retry function
            await retryFetch();
        }
    }, [
        isAuthenticated,
        accounts,
        getUserRole
    ]);
    // Fetch the current user bullhornid on initial load
    (0, $eeyUA.useEffect)(()=>{
        const initializeAuth = async ()=>{
            setLoading(true);
            await validTokenGetCurrentUser();
            await fetchUserData();
            setLoading(false);
        };
        initializeAuth();
    }, [
        validTokenGetCurrentUser,
        fetchUserData
    ]);
    // We only want to render the underlying app after we
    // assert for the presence of a current user.
    return /*#__PURE__*/ (0, $e9nev.jsxs)((0, $e9nev.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9nev.jsx)($bd2f709a7c65979e$var$AppAuth, {}),
            loading || error ? /*#__PURE__*/ (0, $e9nev.jsx)((0, $230fb2dc9c8c870f$export$2e2bcd8739ae039), {
                error: error || ""
            }) : isAuthenticated && getUserRole && /*#__PURE__*/ (0, $e9nev.jsx)((0, $4da6df91f44339a6$export$3f7734c901feade6), {
                children: /*#__PURE__*/ (0, $e9nev.jsx)($bd2f709a7c65979e$export$a0fd8390cfe8ae69.Provider, {
                    value: user,
                    children: children
                })
            }),
            !isAuthenticated || getUserRole === null && /*#__PURE__*/ (0, $e9nev.jsx)((0, $b920ddc4f9db74d0$export$8285a35799c5812b), {
                children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $230fb2dc9c8c870f$export$2e2bcd8739ae039), {
                    error: error || ""
                })
            })
        ]
    });
}
const $bd2f709a7c65979e$var$AppAuth = ()=>{
    const { accounts: accounts } = (0, $53d03c4325cd69bf$export$f41558044a1dd55)();
    if (accounts.length === 0 && sessionStorage.getItem("logoutIntent") !== "true") {
        console.log(accounts.length);
        // Save the current path before redirecting
        sessionStorage.setItem("postLoginRedirect", window.location.pathname + window.location.search);
        (0, $134a550bcae7842f$export$d130d543558e611f)((0, $7101cc4ee26a17a4$export$4ec29255e7e7f68f).Redirect);
    }
    return /*#__PURE__*/ (0, $e9nev.jsx)((0, $e9nev.Fragment), {});
};
const $bd2f709a7c65979e$export$1d39dc5b47e56ff0 = ()=>{
    return (0, $eeyUA.useContext)($bd2f709a7c65979e$export$a0fd8390cfe8ae69);
};






const $3c1564adb4c3200f$var$msalInstance = new (0, $d4ca65a93729f924$export$89f4855ef88b7920)((0, $d9ec22feede57c3d$export$f6d610d2730cbf1a));
var $3c1564adb4c3200f$export$2e2bcd8739ae039 = $3c1564adb4c3200f$var$msalInstance;



function $cd93687958c8007e$export$86fbec116b87613f() {
    const [user, setUser] = (0, $eeyUA.useState)(JSON.parse(localStorage.getItem("userData") || "{}"));
    const [isCactAIWhitelisted, setIsCactAIWhitelisted] = (0, $eeyUA.useState)(false);
    (0, $eeyUA.useEffect)(()=>{
        setIsCactAIWhitelisted(user?.features?.cactAI === true);
    }, [
        user
    ]);
    (0, $eeyUA.useEffect)(()=>{
        window.msalInstance = (0, $3c1564adb4c3200f$export$2e2bcd8739ae039);
    }, []);
    (0, $eeyUA.useEffect)(()=>{
        if (!user?.features?.cactAI) new Promise((resolve)=>setTimeout(resolve, 1000)).then(()=>{
            setUser(JSON.parse(localStorage.getItem("userData") || "{}"));
        });
    }, [
        user
    ]);
    return /*#__PURE__*/ (0, $e9nev.jsx)((0, $9b6aaeb0c2a25675$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $710839bca839223b$export$25bac41dc3d78d47), {
            instance: (0, $3c1564adb4c3200f$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $bd2f709a7c65979e$export$87091915187a1a85), {
                children: isCactAIWhitelisted ? /*#__PURE__*/ (0, $e9nev.jsx)((0, $5441cd050a2a0ab6$export$42499dcdbb97379f), {
                    standalone: true
                }) : /*#__PURE__*/ (0, $e9nev.jsx)("div", {
                    className: "unauthorized-container",
                    children: /*#__PURE__*/ (0, $e9nev.jsx)("h1", {
                        children: "You are not authorized to use CactAI. Please contact the Product and Engineering team to get access."
                    })
                })
            })
        })
    });
}


const $a88ea9323d3a23c8$var$rootEl = document.getElementById("root");
if ($a88ea9323d3a23c8$var$rootEl == null) throw new Error("Root element #root not found");
(0, $4d1551fcd46eb2de$export$882461b6382ed46c)($a88ea9323d3a23c8$var$rootEl).render(/*#__PURE__*/ (0, $e9nev.jsx)((0, $eeyUA.StrictMode), {
    children: /*#__PURE__*/ (0, $e9nev.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=standalone.f7b70676.js.map
